var skin_autumn_frame_new =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpskin_autumn_frame_new"];
/******/ 	window["webpackJsonpskin_autumn_frame_new"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		4: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "chunks/ch." + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/mcst/dist/skin_autumn_frame_new/a1f29860b0ff80d2d35b/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 80);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(380);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(117);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	if (typeof execScript === "function")
		execScript(src);
	else
		eval.call(null, src);
}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(379);
var dir = previousRequest.replace("sprite-small-preloader-white.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "sprite-small-preloader-white.png",
	name: "sprite-small-preloader-white",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/scene_preload.gif", __webpack_require__.p + "_/_/_/root/images/scene_preload.gif");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/logotype.png", __webpack_require__.p + "_/_/_/root/images/logotype.png");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Core 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(4) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

// $.ui might exist from components with no dependencies, e.g., $.ui.position
$.ui = $.ui || {};

$.extend( $.ui, {
	version: "1.11.4",

	keyCode: {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	}
});

// plugins
$.fn.extend({
	scrollParent: function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
			}).eq( 0 );

		return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
	},

	uniqueId: (function() {
		var uuid = 0;

		return function() {
			return this.each(function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			});
		};
	})(),

	removeUniqueId: function() {
		return this.each(function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		});
	}
});

// selectors
function focusable( element, isTabIndexNotNaN ) {
	var map, mapName, img,
		nodeName = element.nodeName.toLowerCase();
	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
		return !!img && visible( img );
	}
	return ( /^(input|select|textarea|button|object)$/.test( nodeName ) ?
		!element.disabled :
		"a" === nodeName ?
			element.href || isTabIndexNotNaN :
			isTabIndexNotNaN) &&
		// the element and all of its ancestors must be visible
		visible( element );
}

function visible( element ) {
	return $.expr.filters.visible( element ) &&
		!$( element ).parents().addBack().filter(function() {
			return $.css( this, "visibility" ) === "hidden";
		}).length;
}

$.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo(function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		}) :
		// support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		},

	focusable: function( element ) {
		return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
	},

	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			isTabIndexNaN = isNaN( tabIndex );
		return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
	}
});

// support: jQuery <1.8
if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			});
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each(function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			});
		};

		$.fn[ "outer" + name] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each(function() {
				$( this).css( type, reduce( this, size, true, margin ) + "px" );
			});
		};
	});
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
	$.fn.removeData = (function( removeData ) {
		return function( key ) {
			if ( arguments.length ) {
				return removeData.call( this, $.camelCase( key ) );
			} else {
				return removeData.call( this );
			}
		};
	})( $.fn.removeData );
}

// deprecated
$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

$.fn.extend({
	focus: (function( orig ) {
		return function( delay, fn ) {
			return typeof delay === "number" ?
				this.each(function() {
					var elem = this;
					setTimeout(function() {
						$( elem ).focus();
						if ( fn ) {
							fn.call( elem );
						}
					}, delay );
				}) :
				orig.apply( this, arguments );
		};
	})( $.fn.focus ),

	disableSelection: (function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.bind( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			});
		};
	})(),

	enableSelection: function() {
		return this.unbind( ".ui-disableSelection" );
	},

	zIndex: function( zIndex ) {
		if ( zIndex !== undefined ) {
			return this.css( "zIndex", zIndex );
		}

		if ( this.length ) {
			var elem = $( this[ 0 ] ), position, value;
			while ( elem.length && elem[ 0 ] !== document ) {
				// Ignore z-index if position is set to a value where z-index is ignored by the browser
				// This makes behavior of this function consistent across browsers
				// WebKit always returns auto if the element is positioned
				position = elem.css( "position" );
				if ( position === "absolute" || position === "relative" || position === "fixed" ) {
					// IE returns 0 when zIndex is not specified
					// other browsers return a string
					// we ignore the case of nested elements with an explicit value of 0
					// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
					value = parseInt( elem.css( "zIndex" ), 10 );
					if ( !isNaN( value ) && value !== 0 ) {
						return value;
					}
				}
				elem = elem.parent();
			}
		}

		return 0;
	}
});

// $.ui.plugin is deprecated. Use $.widget() extensions instead.
$.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};

}));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Widget 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(4) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var widget_uuid = 0,
	widget_slice = Array.prototype.slice;

$.cleanData = (function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; (elem = elems[i]) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
})( $.cleanData );

$.widget = function( name, base, prototype ) {
	var fullName, existingConstructor, constructor, basePrototype,
		// proxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		proxiedPrototype = {},
		namespace = name.split( "." )[ 0 ];

	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};
	// extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,
		// copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),
		// track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	});

	basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = (function() {
			var _super = function() {
					return base.prototype[ prop ].apply( this, arguments );
				},
				_superApply = function( args ) {
					return base.prototype[ prop ].apply( this, args );
				};
			return function() {
				var __super = this._super,
					__superApply = this._superApply,
					returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		})();
	});
	constructor.prototype = $.widget.extend( basePrototype, {
		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	});

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
		});
		// remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widget_slice.call( arguments, 1 ),
		inputIndex = 0,
		inputLength = input.length,
		key,
		value;
	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :
						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );
				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = widget_slice.call( arguments, 1 ),
			returnValue = this;

		if ( isMethodCall ) {
			this.each(function() {
				var methodValue,
					instance = $.data( this, fullName );
				if ( options === "instance" ) {
					returnValue = instance;
					return false;
				}
				if ( !instance ) {
					return $.error( "cannot call methods on " + name + " prior to initialization; " +
						"attempted to call method '" + options + "'" );
				}
				if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
					return $.error( "no such method '" + options + "' for " + name + " widget instance" );
				}
				methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue && methodValue.jquery ?
						returnValue.pushStack( methodValue.get() ) :
						methodValue;
					return false;
				}
			});
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat(args) );
			}

			this.each(function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",
	options: {
		disabled: false,

		// callbacks
		create: null
	},
	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widget_uuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			});
			this.document = $( element.style ?
				// element within the document
				element.ownerDocument :
				// element is window or document
				element.document || element );
			this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();
		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},
	_getCreateOptions: $.noop,
	_getCreateEventData: $.noop,
	_create: $.noop,
	_init: $.noop,

	destroy: function() {
		this._destroy();
		// we can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.unbind( this.eventNamespace )
			.removeData( this.widgetFullName )
			// support: jquery <1.6.3
			// http://bugs.jquery.com/ticket/9413
			.removeData( $.camelCase( this.widgetFullName ) );
		this.widget()
			.unbind( this.eventNamespace )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetFullName + "-disabled " +
				"ui-state-disabled" );

		// clean up events and states
		this.bindings.unbind( this.eventNamespace );
		this.hoverable.removeClass( "ui-state-hover" );
		this.focusable.removeClass( "ui-state-focus" );
	},
	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key,
			parts,
			curOption,
			i;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {
			// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				.toggleClass( this.widgetFullName + "-disabled", !!value );

			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this.hoverable.removeClass( "ui-state-hover" );
				this.focusable.removeClass( "ui-state-focus" );
			}
		}

		return this;
	},

	enable: function() {
		return this._setOptions({ disabled: false });
	},
	disable: function() {
		return this._setOptions({ disabled: true });
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement,
			instance = this;

		// no suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// no element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {
				// allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
				eventName = match[1] + instance.eventNamespace,
				selector = match[2];
			if ( selector ) {
				delegateElement.delegate( selector, eventName, handlerProxy );
			} else {
				element.bind( eventName, handlerProxy );
			}
		});
	},

	_off: function( element, eventName ) {
		eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.unbind( eventName ).undelegate( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-hover" );
			},
			mouseleave: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-hover" );
			}
		});
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-focus" );
			},
			focusout: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-focus" );
			}
		});
	},

	_trigger: function( type, event, data ) {
		var prop, orig,
			callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		// the original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}
		var hasOptions,
			effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}
		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;
		if ( options.delay ) {
			element.delay( options.delay );
		}
		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue(function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			});
		}
	};
});

return $.widget;

}));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/empty_avatar_unknown.png", __webpack_require__.p + "_/_/_/root/images/empty_avatar_unknown.png");

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inited = false;
var getMember = function getMember() {
	return false;
};

module.exports = function (rule, cb) {
	getMember = cb;

	if (!inited) {
		rule.pm.handleEvent('@parent ~.Widget', 'inited', function (params, widget) {
			if (!('templateEnv' in widget.options)) {
				widget.options.templateEnv = {};
			}

			if (!('member' in widget.options.templateEnv)) {
				Object.defineProperty(widget.options.templateEnv, 'member', {
					enumerable: true,
					get: function get() {
						return getMember();
					}
				});
			}
		}, {
			prefix: 'rule_template_env_member',
			sync: true
		});

		inited = true;
	}
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inited = false;
var logged = void 0;

module.exports = function (rule) {
	var _logged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	logged = _logged;

	if (!inited) {
		rule.pm.handleEvent('~.Pager_Simple', 'inited', function (params, widget) {
			var guestTplName = widget.getOption('tpl.container');
			var guestPagesCount = widget.getOption('pagesCount');

			if (widget.getOption('logged.tpl.container')) {
				widget.removeOption('tpl.container');

				Object.defineProperty(widget.options.tpl, 'container', {
					enumerable: true,
					get: function get() {
						return logged ? widget.getOption('logged.tpl.container') : guestTplName;
					}
				});

				widget.addHook(function () {
					return delete widget.row;
				}, 'onStartRendering');
			}

			if (widget.getOption('logged.pagesCount')) {
				widget.removeOption('pagesCount');

				Object.defineProperty(widget.options, 'pagesCount', {
					enumerable: true,
					get: function get() {
						return logged ? widget.getOption('logged.pagesCount') : guestPagesCount;
					}
				});
			}
		}, {
			prefix: 'rule_pagersimple_template',
			sync: true
		});

		inited = true;
	}
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check

//@ts-ignore
var _require = __webpack_require__(16)(fox),
    delay = _require.delay;

var _require2 = __webpack_require__(17),
    ENV_VAR_NAME_TOS = _require2.ENV_VAR_NAME_TOS;

var ENV_VAR_NAME = ENV_VAR_NAME_TOS;

/**
 * 
 * @param {Fox} fox
 */
module.exports = function (fox) {
	var site = fox.wom.getRoot();
	var gdprPopup = site.rwom1('#gdprMainPopup');

	var promise = fox.Promise.resolve();
	var shouldShow = fox.getEnv(ENV_VAR_NAME);
	var deniedGap = null;

	if (!site.rwom1('#permissionManager').hasAccess('guestActual')) {
		if (location.pathname === '/terms') {
			deniedGap = new fox.Promise(function (resolve) {
				var handler = site.handleEvent('.Site_Layout', 'switchedEmbeddedWidget', function (page) {
					if (page !== 'terms') {
						handler.drop();

						return resolve(true);
					}
				});
			});
		}
	}

	if (shouldShow) {
		if (!fox.ready) {
			promise = promise.then(function () {
				return site.wait('fox_ready');
			});
		} else {
			promise = promise.then(function () {
				return delay(2000);
			});
		}

		if (deniedGap) {
			promise = promise.then(function () {
				return deniedGap;
			});
		}

		return promise.then(function () {
			return gdprPopup.showForMember().then(function (result) {
				if (result) {
					fox.setEnv(ENV_VAR_NAME, false);
				}
			});
		});
	}
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	return fox.extend(function (pm /* permissionManager */, params /* ruleParams */) {
		this.__constructor.apply(this, arguments);
	}, {
		__constructor: function __constructor(pm, params) {
			var _this2 = this;

			this.pm = pm;
			this.params = {};
			this.wasChanged = false;

			var _this = this;

			this.setParams = function (key, value) {
				if (fox.isObject(key)) {
					return fox.getObjectKeys(key).forEach(function (prop) {
						return _this2.setParams(prop, key[prop]);
					});
				}

				if (!(key in params)) {
					params[key] = value;
				}

				if (!(key in _this2.params)) {
					return Object.defineProperty(_this2.params, key, {
						get: function get() {
							return params[key];
						},
						set: function set(value) {
							_this.wasChanged = true;
							params[key] = value;
						}
					});
				}

				_this2.params[key] = value;
			};

			this.setParams(params);
		},

		super: function _super() {
			var args = fox.clone(arguments);

			return fox.callSuperMethod.apply(this, args.concat('super'));
		},

		execute: function execute() {
			if (this.hasAccess() && fox.isFunction(this.granted)) {
				return this.granted.apply(this, arguments);
			}

			if (!this.hasAccess() && fox.isFunction(this.denied)) {
				return this.denied.apply(this, arguments);
			}
		},

		getParams: function getParams(prop) {
			if (prop) return fox.objectGet(this.params, prop);

			return this.params;
		},

		addRouteHook: function addRouteHook() {
			var params = {};

			params.performer = this.pm;
			params.prefix = [this.pm.getHash(), this._className].join('_').toLowerCase();

			this.pm.getEm().handleHook('@root #router', 'onStartSetActiveRoute', this.onRoute.bind(this), params);
		},

		onRoute: function onRoute() {},

		hasAccess: function hasAccess() {
			var result = [];

			if (fox.isObject(this.params)) {
				switch (true) {
					case 'enabled' in this.params:
						result.push(this.params.enabled);
						break;
				}
			}

			return result.length > 0 && result.every(function (value) {
				return value === true;
			});
		}
	}, null, 'Rule_Base');
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function (fox) {
	var socketsReconnectMixin = __webpack_require__(39)(fox);

	var generateToken = function generateToken() {
		var salt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'random';

		var ua = navigator.userAgent;
		var now = new Date().getTime();
		var random = Math.random().toString().slice(2);

		return fox.getStringSimpleHash(fox.shuffle([ua, now, salt]).join(random), 16);
	};

	var AutoLoginService = function () {
		function AutoLoginService(context /* Controller */) {
			_classCallCheck(this, AutoLoginService);

			this.context = context;
			this.tokens = [];
		}

		_createClass(AutoLoginService, [{
			key: 'injectToken',
			value: function injectToken(injectTo, salt) {
				var token = generateToken(salt);

				this.tokens.push(token);

				return _extends({}, injectTo, {
					token: token
				});
			}
		}, {
			key: 'matchToken',
			value: function matchToken(token) {
				return fox.inArray(this.tokens, token);
			}
		}, {
			key: 'shouldAuthorize',
			value: function shouldAuthorize(token) {
				var _this = this;

				var api = this.context.getApi('__clientAuthorizer', { method: 'site.authorizer.authByToken' });
				var root = fox.wom.getRoot();
				var pm = root.wom1('#permissionManager');

				if (!this.matchToken(token)) return fox.Promise.resolve(false);

				return api.psend({ token: token }).then(function (resp) {
					if (pm) {
						fox.setEnv('member', fox.objectGet(resp, 'params.answer.response'));

						var isPremium = pm.getMemberInfo('isPremium');
						var rules = {
							guest: {
								enabled: true
							}
						};

						if (!fox.isEmpty(isPremium)) {
							rules.guest.enabled = false;
							rules.member = {
								enabled: true
							};
						}

						var promise = pm.wait('@this', 'permissions_update', {
							prefix: 'listener_for_' + token
						}).then(function () {
							return _this.reconnectSockets();
						});

						pm.updatePermissions(rules);

						return promise;
					}

					return false;
				}).catch(function (e) {
					return false;
				});
			}
		}]);

		return AutoLoginService;
	}();

	fox.mixin(AutoLoginService.prototype, socketsReconnectMixin);

	return AutoLoginService;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	return {
		delay: function delay() {
			var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;

			return new fox.Promise(function (resolve) {
				setTimeout(resolve, delay);
			});
		}
	};
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check

exports.ENV_VAR_NAME_COOKIE = 'cookiesConsents';

exports.SESSION_VAR_NAME_COOKIE = '_scpb_';

exports.ENV_VAR_NAME_TOS = 'getConsents';

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//@ts-check

var inited = false;
var callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb 
 */
module.exports = function (rule, cb) {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.Giftbox', 'inited', function (p, widget) {
			var master_sendGifts = widget.sendGifts;

			widget.sendGifts = function (data) {
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}

				return callback().then(function (_ref) {
					var result = _ref.result,
					    params = _ref.params;

					if (result === true) {
						return master_sendGifts.apply(widget, [_extends({}, data, params)].concat(args));
					}
				});
			};
		}, {
			sync: true,
			prefix: 'user_access_patch_giftbox'
		});
	}
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check

var inited = false;
var callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb 
 */
module.exports = function (rule, cb) {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.Join_Form', 'inited', function (p, widget) {
			var master_onSubmit = widget.onSubmit;

			widget.onSubmit = function (data) {
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}

				return callback().then(function (_ref) {
					var result = _ref.result,
					    params = _ref.params;

					if (result === true) {
						return master_onSubmit.apply(widget, [data, params].concat(args));
					}
				});
			};
		}, {
			sync: true,
			prefix: 'user_access_patch_join_form'
		});
	}
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//@ts-check

var inited = false;
var callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb 
 */
module.exports = function (rule, cb) {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.ClientLSTranslator', 'inited', function (p, widget) {
			var master_sendPaidShowRequest = widget.sendPaidShowRequest;

			widget.sendPaidShowRequest = function (data) {
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}

				return callback().then(function (_ref) {
					var result = _ref.result,
					    params = _ref.params;

					if (result === true) {
						return master_sendPaidShowRequest.apply(widget, [_extends({}, data, params)].concat(args));
					}

					return [];
				});
			};
		}, {
			sync: true,
			prefix: 'user_access_patch_liveshow_translator'
		});
	}
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// EMPTY AT THE MOMENT

//@ts-check

var inited = false;
var callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb 
 */
module.exports = function (rule, cb) {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.NewsLetterSubscriber', 'inited', function (p, widget) {
			var master_submitForm = widget.submitForm;

			widget.submitForm = function (data) {
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}

				return callback().then(function (_ref) {
					var result = _ref.result,
					    params = _ref.params;

					if (result === true) {
						return master_submitForm.apply(widget, [_extends({}, data, params)].concat(args));
					}
				});
			};
		}, {
			sync: true,
			prefix: 'user_access_patch_newsletter_subscriber'
		});
	}
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//@ts-check

var inited = false;
var callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb
 * @param {PromiseConstructor} Promise
 */
module.exports = function (rule, cb, Promise) {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.Store_Content', 'inited', function (p, widget) {
			var master_showCbPopup = widget.showCbPopup;
			var master_buyNow = widget.buyNow;

			var promise = new Promise(function (resolve) {
				widget.buyNow = function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					return callback(widget, resolve).then(function (_ref) {
						var result = _ref.result,
						    params = _ref.params;
						var arg1 = args[0],
						    data = args[1],
						    restArgs = args.slice(2);

						if (data) {
							if (result === true) {
								return master_buyNow.apply(widget, [arg1, _extends({}, data, params)].concat(_toConsumableArray(restArgs)));
							}

							return Promise.resolve(result);
						}

						return Promise.resolve(master_buyNow.apply(widget, args));
					});
				};
			});

			widget.showCbPopup = function () {
				for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
					args[_key2] = arguments[_key2];
				}

				return promise.then(function (result) {
					if (result === true) {
						return master_showCbPopup.apply(widget, args);
					}
				});
			};
		}, {
			sync: true,
			prefix: 'user_access_patch_store_content'
		});
	}
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//@ts-check

var inited = false;
var callback = null;

/**
 * 
 * @param {PMRule} rule
 * @param {() => Promise} cb 
 */
module.exports = function (rule, cb) {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.Tips_Form', 'inited', function (p, widget) {
			var master_onSubmit = widget.getClass() !== 'Content_Tipme' ? widget.onSubmit : null;
			var master_submit = widget.getClass() === 'Content_Tipme' ? widget.submit : null;

			if (master_onSubmit) {
				widget.onSubmit = function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					return widget._isValid && callback().then(function (_ref) {
						var result = _ref.result,
						    params = _ref.params;

						if (result === true) {
							if (params) {
								widget.setOption('preparedTransactionParams', _extends({}, widget.getOption('preparedTransactionParams'), params));
							}

							return master_onSubmit.apply(widget, args);
						}
					});
				};
			}

			if (master_submit) {
				widget.submit = function () {
					for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
						args[_key2] = arguments[_key2];
					}

					widget.validateData();

					if (widget._isValid) {
						return callback().then(function (_ref2) {
							var result = _ref2.result,
							    params = _ref2.params;

							if (result === true) {
								if (params) {
									widget.setOption('preparedTransactionParams', _extends({}, widget.getOption('preparedTransactionParams'), params));
								}

								return master_submit.apply(widget, args);
							}
						});
					}

					return master_submit.apply(widget, args);
				};
			}
		}, {
			sync: true,
			prefix: 'user_access_patch_tipsform'
		});
	}
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inited = false;

module.exports = function (rule) {
	if (!inited) {
		rule.pm.handleEvent('@parent ~.Join_Form #prepareTransactionApi', 'inited', function (p, widget) {
			rule.guestMethod = widget.getOption('method');

			if (!rule.transactioApiMethod) {
				rule.transactioApiMethod = rule.guestMethod;
			}

			widget.removeOption('method');

			Object.defineProperty(widget.options, 'method', {
				enumerable: true,
				get: function get() {
					return rule.transactioApiMethod;
				}
			});
		}, {
			prefix: 'rule_transaction_api_method',
			sync: true
		});

		inited = true;
	}
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inited = false;

module.exports = function (rule, Promise) {
	if (!inited) {
		var promise = new Promise(function (resolve) {
			rule.pm.handleEvent('@this', 'permissions_update', function (ruleKeys) {
				if (ruleKeys.some(function (key) {
					return ['member'].indexOf(key) !== -1 && rule.pm.hasAccess(key);
				})) {
					setTimeout(function () {
						return resolve(true);
					}, 1000);
				}
			}, {
				prefix: 'rule_joinform_upgrade_oneclick'
			});
		});

		rule.pm.handleEvent('@parent ~.SitePage_Join', 'inited', function (p, widget) {
			var master_onPrepareTransaction = widget.onPrepareTransaction;

			widget.onPrepareTransaction = function (data) {
				if (rule.pm.member) {
					if (data === true) {
						promise.then(function () {
							widget.dispatchEvent('user_upgrage_oneclick');
						});

						return false;
					}
				}

				return master_onPrepareTransaction.apply(this, arguments);
			};
		}, {
			sync: true,
			prefix: 'rule_joinform_upgrade_oneclick'
		});

		inited = true;
	}
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    'use strict';

    return function () {
        var joinOptions = fox.getEnv('siteProps.ubs.joinOptions.options') || [];

        return joinOptions.reduce(function (acc, option) {
            var discount = fox.objectGet(option, 'discountParams.discount');

            return acc = parseFloat(discount && discount > acc ? discount : acc);
        }, 0);
    };
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	return {
		hoverPreviewVideo: function hoverPreviewVideo(elt, w) {
			var elt = jQuery(elt).parent();
			elt.addClass('loaderhover');
			if (fox.utils.isTouchDevice()) {
				this.mobileClearItems(elt);
			}
			if (w.imgInt) {
				clearInterval(w.imgInt);
			}
			var video = jQuery(elt).find('video')[0];
			elt.addClass('previewVideo');
			var primaryImg = jQuery(elt).find('.lazyloaded');
			if (video) {
				video.setAttribute('src', video.getAttribute('data-src'));
				video.muted = "muted";
				if (video.getAttribute('src')) {
					video.oncanplay = function () {
						if (elt.hasClass('previewVideo')) {
							$(primaryImg).addClass('_hidden');
						}
					};
				}
				video.play;
			} else {
				var arr = jQuery(elt).find('.loadImg');
				var i = 0;
				var l = arr.length;
				w.imgInt = setInterval(function () {

					var elemCurrent = arr[i];
					var prevImg = i == 0 ? arr[l - 1] : arr[i - 1];
					if (!elemCurrent.getAttribute('src')) {
						elemCurrent.setAttribute('src', elemCurrent.getAttribute('data-img'));
						elemCurrent.onload = function () {
							$(primaryImg).addClass('_hidden');
							jQuery(prevImg).addClass('_hidden');
							elemCurrent.classList.remove('_hidden');
						};
					} else {
						$(primaryImg).addClass('_hidden');
						jQuery(prevImg).addClass('_hidden');
						elemCurrent.classList.remove('_hidden');
					}
					i++;
					if (i == l) i = 0;
				}, 1000);
			}
			setTimeout(function () {
				elt.removeClass('loaderhover');
			}, 1500);
		},
		stopHoverPreviewVideo: function stopHoverPreviewVideo(el, w) {
			var parent = jQuery(el).parent();
			var p = jQuery(parent);
			p.find('.lazyloaded').removeClass('_hidden');
			p.removeClass('previewVideo');
			p.removeClass('loaderhover');
			var video = parent.find('video')[0];
			if (video) {
				video.pause();
				video.removeAttribute('src');
			} else {
				var arr = parent.find('.loadImg');
				arr.map(function (i, elm) {
					jQuery(elm).addClass('_hidden');
				});
				clearInterval(w.imgInt);
			}
		},
		followingLink: function followingLink(elm) {
			var elt = jQuery(elm).parent();
			var path = jQuery(elt).find('>a').attr('href');
			path = path.substr(1);
			fox.site.gotoPage(path);
		},
		handleTouch: function handleTouch(el, w) {
			var _this = this;

			var isMoving = false;
			var self = this;
			el.map(function (elm) {
				fox.jQuery(elm).on('touchstart', function (e) {
					var swipe = e.originalEvent.touches,
					    start = swipe[0].pageX;

					//e.preventDefault();
					e.stopPropagation();
					$(elm).on('touchmove', function (e) {
						//e.preventDefault();
						e.stopPropagation();

						var contact = e.originalEvent.touches,
						    end = contact[0].pageX,
						    distance = end - start;

						if (distance > 30 || distance < -30) {
							console.log('right');
							self.hoverPreviewVideo(elm, w);
							isMoving = true;
						}
					}.bind(this)).one('touchend', function () {
						if (!isMoving) {
							return;
						}
						isMoving = false;
						$(elm).off('touchmove touchend');
					}.bind(this));
				}.bind(_this));
			});
		},
		mobileClearItems: function mobileClearItems(elt) {
			if (elt.hasClass('previewVideo')) {
				elt.removeClass('previewVideo');
			}

			var allprimaryImg = fox.dom.select('.lazyloaded');
			var allVideo = fox.dom.select('.hov-video');
			var allHoverImg = fox.dom.select('.loadImg');
			allHoverImg.map(function (item) {
				item.classList.add('_hidden');
			});
			allprimaryImg.map(function (item) {
				item.classList.remove('_hidden');
			});
			allVideo.map(function (item) {
				jQuery(item.parentElement.parentElement).removeClass('previewVideo');
				item.pause();
				item.removeAttribute('src');
			});
		}
	};
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gallery-sprite.png", __webpack_require__.p + "_/_/_/root/images/gallery-sprite.png");

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/player_banner.png", __webpack_require__.p + "_/_/_/root/images/player_banner.png");

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(472);
var dir = previousRequest.replace("aboutPhotoEmpty.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "aboutPhotoEmpty.png",
	name: "aboutPhotoEmpty",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Mouse 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/mouse/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(4),
			__webpack_require__(9)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var mouseHandled = false;
$( document ).mouseup( function() {
	mouseHandled = false;
});

return $.widget("ui.mouse", {
	version: "1.11.4",
	options: {
		cancel: "input,textarea,button,select,option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.bind("mousedown." + this.widgetName, function(event) {
				return that._mouseDown(event);
			})
			.bind("click." + this.widgetName, function(event) {
				if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
					$.removeData(event.target, that.widgetName + ".preventClickEvent");
					event.stopImmediatePropagation();
					return false;
				}
			});

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.unbind("." + this.widgetName);
		if ( this._mouseMoveDelegate ) {
			this.document
				.unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
				.unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
		}
	},

	_mouseDown: function(event) {
		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// we may have missed mouseup (out of window)
		(this._mouseStarted && this._mouseUp(event));

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = (event.which === 1),
			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
		if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if (!this.mouseDelayMet) {
			this._mouseDelayTimer = setTimeout(function() {
				that.mouseDelayMet = true;
			}, this.options.delay);
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted = (this._mouseStart(event) !== false);
			if (!this._mouseStarted) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
			$.removeData(event.target, this.widgetName + ".preventClickEvent");
		}

		// these delegates are required to keep context
		this._mouseMoveDelegate = function(event) {
			return that._mouseMove(event);
		};
		this._mouseUpDelegate = function(event) {
			return that._mouseUp(event);
		};

		this.document
			.bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.bind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function(event) {
		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {
			// IE mouseup check - mouseup happened when mouse was out of window
			if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
				return this._mouseUp(event);

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {
				return this._mouseUp( event );
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if (this._mouseStarted) {
			this._mouseDrag(event);
			return event.preventDefault();
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted =
				(this._mouseStart(this._mouseDownEvent, event) !== false);
			(this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
		}

		return !this._mouseStarted;
	},

	_mouseUp: function(event) {
		this.document
			.unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if (this._mouseStarted) {
			this._mouseStarted = false;

			if (event.target === this._mouseDownEvent.target) {
				$.data(event.target, this.widgetName + ".preventClickEvent", true);
			}

			this._mouseStop(event);
		}

		mouseHandled = false;
		return false;
	},

	_mouseDistanceMet: function(event) {
		return (Math.max(
				Math.abs(this._mouseDownEvent.pageX - event.pageX),
				Math.abs(this._mouseDownEvent.pageY - event.pageY)
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function(/* event */) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function(/* event */) {},
	_mouseDrag: function(/* event */) {},
	_mouseStop: function(/* event */) {},
	_mouseCapture: function(/* event */) { return true; }
});

}));


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/* Html5Player Banner */
(function (fox, $) {
	"use strict";

	fox.registerWidget('Html5Player_Banner', {
		configure: function (options) {
			this.registerOptions('', {
				manualRender: true
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.setBanner();

			this.callParent('running', arguments);
		},

		activate: function() {
			this.setBanner();

			this.callParent('activate', arguments);
		},

		setBanner: function() {}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function () {
	return /^\d+(\.|-)\d+(\.|-)preview\.\S+$/.test(window.location.host);
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//@ts-check
/** @param {Fox} fox */
module.exports = function (fox) {
	//@ts-ignore
	var RuleBase = __webpack_require__(14)(fox);
	//@ts-ignore
	var showGDPRForMember = __webpack_require__(13);

	var _require = __webpack_require__(17),
	    SESSION_VAR_NAME_COOKIE = _require.SESSION_VAR_NAME_COOKIE;

	return fox.extend({
		/** @param {Controller} pm */
		__constructor: function __constructor(pm, fakeParams) {
			var _this = this;

			var params = {};

			Object.defineProperty(params, 'enabled', {
				get: function get() {
					return !fox.isEmpty(pm.member) && pm.hasAccess('guest');
				},
				enumerable: true
			});

			pm.handleEvent(pm, 'permissions_update',
			/** @param {Array} keys */
			function (keys) {
				if (keys.indexOf('guest') !== -1) {
					_this.execute();
				}
			}, {
				prefix: 'free_rule_handler',
				sync: true
			});

			for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
				args[_key - 2] = arguments[_key];
			}

			this.super('__constructor', [pm, params].concat(_toConsumableArray(args)));
		},
		granted: function granted() {
			try {
				sessionStorage.removeItem(SESSION_VAR_NAME_COOKIE);
			} catch (e) {} finally {
				showGDPRForMember(fox);
			}
		}
	}, RuleBase, null, 'Rule_Free');
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/**
 * 
 * @param {Fox} fox 
 */
module.exports = function (fox) {
	//@ts-ignore
	var RuleBase = __webpack_require__(14)(fox);
	//@ts-ignore
	var registerMemberTplEnv = __webpack_require__(11);
	//@ts-ignore
	var registerJoinformPrepareApi = __webpack_require__(24);
	//@ts-ignore
	var registerPagerSimpleLogged = __webpack_require__(12);
	//@ts-ignore
	var registerJoinformUpgradeOneclick = __webpack_require__(25);

	return fox.extend({
		__constructor: function __constructor() {
			this.super('__constructor', arguments);

			this.freeUserMethod = 'user.upgrade';

			this.originalMap = fox.clone(this.pm.rwom1('@root').getOption('map'), true);
		},

		execute: function execute() {
			registerJoinformPrepareApi(this);
			registerJoinformUpgradeOneclick(this, fox.Promise);

			return this.super('execute', [this.pm._wom.getRoot()]);
		},

		granted: function granted(site) {
			var _map = {};

			if (this.pm.member) {
				var memberDl = fox.hydrateDl(this.pm.member);

				registerMemberTplEnv(this, function () {
					return memberDl;
				});
				registerPagerSimpleLogged(this, true);

				if (!this.wasChanged) {
					this.pm.wait('@parent .Layout_Home', 'inited', {
						prefix: 'rule_layout_home_banner',
						sync: true
					}).then(function (resp) {
						resp.performer.embedWidget('upgradeBanner', 'UserAccess_UpgradeBanner', {});
					});
				} else {
					site.wom('~.Widget').forEach(function (widget) {
						widget._templaters = {};
					});

					var home = site.rwom1('.Layout_Home');

					if (home.isActive()) {
						home.embedWidget('upgradeBanner', 'UserAccess_UpgradeBanner', {}).run();
					} else {
						home.wait('addedToDom').then(function (_) {
							home.embedWidget('upgradeBanner', 'UserAccess_UpgradeBanner', {}).run();
						});
					}
				}

				this.transactioApiMethod = this.freeUserMethod;

				fox.mergeRecursive(_map, fox.clone(this.originalMap, true), this.getParams('map.free'));
			} else {
				registerMemberTplEnv(this, function () {
					return false;
				});
				registerPagerSimpleLogged(this);

				if (this.wasChanged) {
					site.wom('~.Widget').forEach(function (widget) {
						widget._templaters = {};
					});

					this._destroyBanner(site);
				}

				this.transactioApiMethod = this.guestMethod;

				fox.mergeRecursive(_map, fox.clone(this.originalMap, true), this.getParams('map.guest'));
			}

			site.setOption('map', _map);
		},

		denied: function denied(site) {
			if (this.wasChanged) {
				this._destroyBanner(site);
			}
		},

		_destroyBanner: function _destroyBanner(site) {
			var updateBanner = site.wom1('.Layout_Home #upgradeBanner');

			if (updateBanner) {
				updateBanner.destroy();
				return true;
			}

			return false;
		}
	}, RuleBase, null, 'Rule_Guest');
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//@ts-check
/**
 * 
 * @param {Fox} fox 
 */
module.exports = function (fox) {
	//@ts-ignore
	var RuleBase = __webpack_require__(14)(fox);
	//@ts-ignore
	var patchTipsForm = __webpack_require__(23);
	//@ts-ignore
	var patchStoreContent = __webpack_require__(22);
	//@ts-ignore
	var patchJoinForm = __webpack_require__(19);
	//@ts-ignore
	var patchGiftbox = __webpack_require__(18);
	//@ts-ignore
	var patchLiveshowTranslator = __webpack_require__(20);
	//@ts-ignore
	var patchNewsletterSubscribe = __webpack_require__(21);

	return fox.extend({
		__constructor: function __constructor(pm, fakeParams) {
			var _this = this;

			var params = {};

			Object.defineProperty(params, 'enabled', {
				get: function get() {
					return pm.hasAccess('guest') && fox.isEmpty(pm.member);
				},
				enumerable: true
			});

			pm.handleEvent(pm, 'permissions_update',
			/** @param {Array} keys */
			function (keys) {
				if (keys.indexOf('guest') !== -1) {
					_this.execute();
				}
			}, {
				prefix: 'guest_actual_rule_handler',
				sync: true
			});

			for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
				args[_key - 2] = arguments[_key];
			}

			this.super('__constructor', [pm, params].concat(_toConsumableArray(args)));
		},
		prepareParams: function prepareParams(values) {
			if (fox.isBoolean(values)) {
				return {
					result: values,
					params: null
				};
			}

			return {
				result: true,
				params: Object.keys(values).reduce(function (obj, key) {
					obj['transitParams[' + key + ']'] = values[key];

					return obj;
				}, {})
			};
		},
		granted: function granted() {
			var _this2 = this;

			var gdprPopup = this.pm.rwom1('@root #gdprMainPopup');

			patchTipsForm(this, function () {
				return gdprPopup.show().then(_this2.prepareParams);
			});
			patchStoreContent(this, function (widget, resolver) {
				return widget.guestForm.submit().then(function (values) {
					if (values !== false) {
						return gdprPopup.show().then(_this2.prepareParams).then(function (result) {
							if (result.result === true) {
								resolver(result.result);
							}

							return result;
						});
					}
				});
			}, fox.Promise);
			patchJoinForm(this, function () {
				return gdprPopup.show().then(_this2.prepareParams);
			});
			patchGiftbox(this, function () {
				return gdprPopup.show().then(_this2.prepareParams);
			});
			patchLiveshowTranslator(this, function () {
				return gdprPopup.show().then(_this2.prepareParams);
			});
		},
		denied: function denied() {
			var _this3 = this;

			patchTipsForm(this, function () {
				return fox.Promise.resolve(_this3.prepareParams({}));
			});
			patchStoreContent(this, function (widget, resolver) {
				resolver(true);
				return fox.Promise.resolve(_this3.prepareParams({}));
			});
			patchJoinForm(this, function () {
				return fox.Promise.resolve(_this3.prepareParams({}));
			});
			patchGiftbox(this, function () {
				return fox.Promise.resolve(_this3.prepareParams({}));
			});
			patchLiveshowTranslator(this, function () {
				return fox.Promise.resolve(_this3.prepareParams({}));
			});
		}
	}, RuleBase, null, 'Rule_GuestActual');
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/** @param {Fox} fox */
module.exports = function (fox) {
	//@ts-ignore
	var RuleBase = __webpack_require__(14)(fox);
	//@ts-ignore
	var registerMemberTplEnv = __webpack_require__(11);
	//@ts-ignore
	var registerPagerSimpleLogged = __webpack_require__(12);
	//@ts-ignore
	var showGDPRForMember = __webpack_require__(13);

	var _require = __webpack_require__(17),
	    SESSION_VAR_NAME_COOKIE = _require.SESSION_VAR_NAME_COOKIE;

	return fox.extend({
		__constructor: function __constructor() {
			this.super('__constructor', arguments);

			this.originalMap = fox.clone(this.pm.rwom1('@root').getOption('map'), true);
		},

		execute: function execute() {
			var site = this.pm.rwom1('@root');
			var memberDl = fox.hydrateDl(this.pm.member);

			return this.super('execute', [site, memberDl]);
		},

		granted: function granted(site, memberDl) {
			var _map = {};

			registerMemberTplEnv(this, function () {
				return site.member;
			});
			registerPagerSimpleLogged(this, true);

			if (this.wasChanged) {
				site.wom('~.Widget').forEach(function (widget) {
					widget._templaters = {};
				});
			}

			site.member = memberDl;

			fox.mergeRecursive(_map, fox.clone(this.originalMap, true), this.getParams('map'));

			site.setOption('map', _map);

			try {
				sessionStorage.removeItem(SESSION_VAR_NAME_COOKIE);
			} catch (e) {} finally {
				showGDPRForMember(fox);
			}
		},

		denied: function denied(site, memberDl) {
			if (this.wasChanged) {
				delete site.member;

				site.setOption('map', fox.clone(this.originalMap, true));
			}
		}
	}, RuleBase, null, 'Rule_Member');
};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function (fox) {
	'use strict';
	
	return function (contentRow) {
		var obj;
		var $ = fox.jQuery;
		var wide = $(window).width() > 600;
		
		var leftCol = document.createElement('div');
		var rightCol = document.createElement('div');

		this.fragment = this.createFragment();

		this.dl.resetIterator('mix');

		while ((obj = this.dl.iterateObject('mix'))) {
			var tplRow = this.getOption('tpl.' + (
				fox.isObject(contentRow) ? contentRow[obj.get('type')] : 'row'
			));

			var row = this.getTemplater(tplRow).setData([obj]).compile();

			if (wide) {
				var res = obj._pointer % 2 === 0 ? leftCol.appendChild(row) : rightCol.appendChild(row);
			} else {
				this.fragment.appendChild(row);
			}
		}

		if (wide) {
			this.fragment.appendChild(leftCol);
			this.fragment.appendChild(rightCol);

			return true;
		}

		return true;
	};
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reconnectDelay = 400;
var maxReconnectTimeout = 1000;

var getMaxReconnectTimerId = function getMaxReconnectTimerId(resolve) {
	return setTimeout(function () {
		return resolve(false);
	}, maxReconnectTimeout);
};

module.exports = function (fox) {
	return {
		reconnectSockets: function reconnectSockets() {
			var root = fox.wom.getRoot();
			var socket = root.wom1('#socket');
			var chatsocket = root.wom1('#uchatctrl');
			var promises = [];

			if (socket) {
				promises.push(new fox.Promise(function (resolve) {
					return setTimeout(function () {
						var timerId = getMaxReconnectTimerId(resolve);

						root.wait(socket, 'socketReady', {
							prefix: 'reconnect_socket_mixin'
						}).then(function () {
							clearTimeout(timerId);

							return resolve(true);
						});

						socket.socket.disconnect();
					}, reconnectDelay);
				}));
			}

			if (chatsocket) {
				promises.push(new fox.Promise(function (resolve) {
					return setTimeout(function () {
						var timerId = getMaxReconnectTimerId(resolve);

						chatsocket.reconnect().then(function () {
							clearTimeout(timerId);

							return resolve(true);
						});
					}, reconnectDelay);
				}));
			}

			return promises.length && fox.Promise.all(promises).then(function (results) {
				return true /* results.every(result => result) waiting for socket fix */;
			}) || fox.Promise.resolve(false);
		}
	};
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
	function LiveshowChatTokens() {
		_classCallCheck(this, LiveshowChatTokens);
	}

	_createClass(LiveshowChatTokens, null, [{
		key: 'muteUser',
		get: function get() {
			return '@mute_user@';
		}
	}, {
		key: 'unmuteUser',
		get: function get() {
			return '@unmute_user@';
		}
	}, {
		key: 'blockUser',
		get: function get() {
			return '@block_user@';
		}
	}, {
		key: 'unblockUser',
		get: function get() {
			return '@unblock_user@';
		}
	}, {
		key: 'publisherDisconnect',
		get: function get() {
			return '@publisher_disconnected@';
		}
	}, {
		key: 'paidShowRequest',
		get: function get() {
			return '@paidshow_request@';
		}
	}, {
		key: 'leavePrivate',
		get: function get() {
			return '@leaveprivate@';
		}
	}, {
		key: 'prepareWebrtcTranslation',
		get: function get() {
			return '@prepare_webrtc_translation@';
		}
	}]);

	return LiveshowChatTokens;
}();

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("css/slick/fonts/slick.eot", __webpack_require__.p + "_/_/_/main/css/slick/fonts/1hzQMgk.eot");

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-italic-webfont.eot", __webpack_require__.p + "_/_/_/root/fonts/9rFwkzF.eot");

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-regular-webfont.eot", __webpack_require__.p + "_/_/_/root/fonts/3KD6F5O.eot");

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/simplifica.woff", __webpack_require__.p + "fonts/1Vq6EH3.woff");

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/simplifica.ttf", __webpack_require__.p + "fonts/qrc--6E.ttf");

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/simplifica.svg", __webpack_require__.p + "fonts/simplifica.svg");

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/icons-lib/icons-lib.eot?n7cb91", __webpack_require__.p + "_/_/_/root/fonts/icons-lib/1SwRDx3.eot");

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/activity.eot", __webpack_require__.p + "_/_/_/root/fonts/1fjZ15u.eot");

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/throughChat.eot?exnqbq", __webpack_require__.p + "_/_/_/root/fonts/jG_130I.eot");

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/cbCpWhite.png", __webpack_require__.p + "_/_/_/root/images/cbCpWhite.png");

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	return {
		isAllowed: function isAllowed() {
			var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.settings.allowedGroups;

			var pm = this.rwom1('@root #permissionManager');

			return source.some(function (group) {
				switch (group) {
					case 'guest':
						return pm.hasAccess('guestActual');
					case 'premium':
						return pm.hasAccess('member');
					default:
						return pm.hasAccess(group);
				};
			});
		}
	};
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/common/images/discount-sticker.png", __webpack_require__.p + "_/_/_/root/components/common/images/discount-sticker.png");

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (fox) {
	return {
		formInvalidate: function formInvalidate(infos, form) {
			return infos.forEach(function (info) {
				var result = info.result,
				    field = info.field,
				    message = info.message;

				var element = form.getElement(field);

				var _element$nodes = _slicedToArray(element.nodes, 1),
				    node = _element$nodes[0];

				var container = node.parentNode;
				var error = container.nextSibling;
				var removeError = function removeError() {
					fox.dom.removeClass('error', container);

					if (error) {
						error.innerText = '';
						error.style.display = 'none';
					}
				};

				if (!result) {
					fox.dom.addClass('error', container);

					if (error) {
						error.innerText = message || 'Cannot be empty';
						error.style.display = 'inherit';
					}

					var handler = function handler() {
						fox.dom.off('focus', node, handler);

						removeError();
					};

					fox.dom.on('focus', node, handler);
				} else {
					removeError();
				}
			});
		}
	};
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';
	__webpack_require__(55)(fox);
	__webpack_require__(592)(fox);
	__webpack_require__(56);

};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("ex_premium_user", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title","data-fox-alias":"1"},[["textNode",{"text":"Attention!"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["div",{"class":"text-content","data-fox-alias":"2"},[["textNode",{"text":" Your membership on "}],["span",{},[],[["siteName","__text",true]]],["textNode",{"text":" has expired. You are still able to access your account but you won't be able to view any premium content."}]]],["div",{"class":"text-content","data-fox-alias":"3"},[["textNode",{"text":"Be sure to upgrade to premium membership to gain access to all the VIP features of "}],["span",{},[],[["siteName","__text",true]]],["textNode",{"text":"."}]]]]],["div",{"class":"popup-footer-wrapper"},[["a",{"href":"/upgrade","id":"userUpgrade","class":"mc-common-button close"},[["span",{"data-fox-alias":"4"},[["textNode",{"text":"Upgrade"}]]]]],["textNode",{"text":" "}],["button",{"class":"mc-common-button simple close","data-fox-alias":"5"},[["textNode",{"text":"Ok"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(593);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!./_gui-elem.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!./_gui-elem.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/flowplayer.commercial-3.2.16.swf", __webpack_require__.p + "_/_/_/root/flash/flowplayer.commercial-3.2.16.swf");

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/valentines-gifts-popup/fonts/arvo-bold-webfont.eot", __webpack_require__.p + "_/_/_/root/components/valentines-gifts-popup/fonts/15QGe_N.eot");

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(688);
var dir = previousRequest.replace("sprite-small-preloader-blue.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "sprite-small-preloader-blue.png",
	name: "sprite-small-preloader-blue",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_actions_related_icon", [["i",{"class":"action-icon icon-au_related"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_report", [["a",{"class":"content-report-link"},[["i",{"class":"icon-au_report"}],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"REPORT"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("footer_2257", [["p",{"class":"f-2257"},[["textNode",{"text":" All models appearing on this website are 18 years or older. "}],["a",{"href":"/2257","class":"text-color-4","target":"_blank"},[["textNode",{"text":"Click here"}]]],["textNode",{"text":" for "}],["a",{"href":"/2257","class":"text-color-4","target":"_blank"},[["textNode",{"text":"18 U.S.C. 2257 Record Keeping Requirements Compliance Statement"}]]],["textNode",{"text":". "}]]]]);
fox.registerTemplate("footer_editable", [["div",{"class":"f-text"},[["p",{"data-fox-alias":"footerText"},[["textNode",{"text":" By entering this site, you swear that you are of legal age in your area to view adult material and that you wish to view such material. "}]]]]]]);
fox.registerTemplate("footer_billing", [["if",{"notempty":""},[["p",{"class":"bill-cb"}]],[["siteProps.ubs.joinOptions.type","notempty",true,[{"name":"eq","params":["centrobill"]}],"env"]]]]);
fox.registerTemplate("footer_copyright", [["div",{"class":"bottom border-color-2-trans-5"},[["p",{"class":"links"},[["if",{"notempty":""},[["a",{"class":"text-color-4","href":"/account","rel":"nofollow"},[["textNode",{"text":"Account Management"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"&nbsp;|&nbsp;"}]]]],[["siteProps.ubs.joinOptions.type","notempty",true,[{"name":"eq","params":["centrobill"]}],"env"]]],["a",{"id":"_reportProblem","title":"Customer Support","class":"text-color-4"},[["textNode",{"text":"Technical Support"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"&nbsp;|&nbsp;"}]]],["textNode",{"text":" "}],["a",{"href":"/terms","title":"Terms of Use","class":"text-color-4","target":"_blank"},[["textNode",{"text":"Terms of Use"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"&nbsp;|&nbsp;"}]]],["textNode",{"text":" "}],["a",{"href":"/california-privacy-rights","title":"California Privacy Rights","class":"text-color-4","target":"_blank"},[["textNode",{"text":"California Privacy Rights"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"&nbsp;|&nbsp;"}]]],["textNode",{"text":" "}],["a",{"href":"/privacy-policy","title":"Privacy Policy","class":"text-color-4","target":"_blank"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"&nbsp;|&nbsp;"}]]],["textNode",{"text":" "}],["a",{"href":"/cookie-policy","title":"Cookie Policy","class":"text-color-4","target":"_blank"},[["textNode",{"text":"Cookie Policy"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"&nbsp;|&nbsp;"}]]],["textNode",{"text":" "}],["a",{"id":"_sesta","title":"Report Site","class":"text-color-4"},[["textNode",{"text":"Report"}]]],["textNode",{"text":" "}],["a",{"href":"/cookie-table","title":"Cookie Table","class":"text-color-4","target":"_blank"},[["textNode",{"text":"Cookie Table"}]]],["if",{"notempty":""},[["span",{},[["textNode",{"text":"&nbsp;|&nbsp;"}]]],["textNode",{"text":" "}],["a",{"target":"_blank","rel":"nofollow","class":"text-color-4","href":"https://centroprofits.com","title":"Affiliates"},[["textNode",{"text":"Affiliates"}]]]],[["isMcpClient","notempty",true,[],"env"]]]]],["h5",{"class":"copyright"},[["textNode",{"text":" Copyright "}],["i",{"class":"icon-copyright"}],["textNode",{"text":" "}],["span",{"class":"cp-container"},[["textNode",{"text":"2022"}]]],["textNode",{"text":"&nbsp;"}],["span",{},[],[["name","__text",true,[],"client"]]],["textNode",{"text":" all rights reserved. "}]]]]]]);
fox.registerTemplate("footer_powered", [["div",{"class":"footer-bottom-wrapper"},[["div",{"class":"powered_wrapper"},[["p",{"class":"powered"},[["a",{"class":"text-color-1","href":"https://modelcentro.com/?acode=&&0&&","rel":"nofollow","target":"_blank"},[["i",{"class":"icon-au_poweredByMC"}]],[["client.acode","href",false,[],"env"]]]]],["div",{"class":"feedback_cb"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("newsletterblock", [["div",{"class":"nsl-wrapper pad-lr pad-b"},[["div",{"class":"nsl-content bg-color-3 text-color-1"},[["div",{"class":"nsl-editable"},[["p",{"data-fox-alias":"nsl-editable-1"},[["textNode",{"text":"Let's stay in touch!"}]]]]],["div",{"class":"nsl-form"},[["div",{"class":"nsl-editable-2"},[["p",{"data-fox-alias":"nsl-editable-2"},[["textNode",{"text":"Members of my mailing list get hot updates straight to their email! Subscribe now to get it all!"}]]]]],["div",{"class":"common-input size-1 name"},[["input",{"name":"name","type":"text","placeholder":"Enter your name","class":"text-color-1"}],["textNode",{"text":" "}],["span",{"class":"inp-error"}]]],["div",{"class":"common-input size-1 email"},[["input",{"name":"email","type":"text","placeholder":"Enter your email","class":"text-color-1"}],["textNode",{"text":" "}],["span",{"class":"inp-error"}]]],["div",{"class":"common-btn size-1 border-color-3 bg-color-2 text-color-1","id":"subscribe-to-site"},[["textNode",{"text":" subscribe "}]]],["p",{"class":"consent-text"},[["textNode",{"text":"By subscribing you agree to receive communication and promotional emails from me"}]]]]]]]]]]);
fox.registerTemplate("subscriptionconfirm", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title","id":"popup-widget-title"},[["textNode",{"text":"One more step!"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":" In order to ensure that you are the owner of the e-mail address: username@gmail.com, and also for your protection, I have e-mailed you a link to confirm you want to get my hot emails. "}],["br"],["br"],["textNode",{"text":" Unless you respond to the automated e-mail just sent, your address will not be added to my mailing list! "}],["br"],["br"],["textNode",{"text":" So make sure to confirm your email right now because otherwise you will not get any of the good emails. While you are at it, try to whitelist the email so my messages don't end up in your spam mailbox. "}],["br"],["br"],["textNode",{"text":" If you experience any difficulties, please contact customer support for assistance. "}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("notification_row", [["div",{"class":"notify bg-color-1 txt-c"},[["input",{"type":"hidden","class":"notif_id","value":""},[],[["id","value",true]]],["textNode",{"text":" "}],["a",{"class":"delete link-c"},[["textNode",{"text":"+"}]]],["div",{"class":"info"},[["div",{"class":"td"},[["div",{"class":"foto bdr-c"},[["if",{"notempty":""},[["img",{"src":"","alt":"avatar"},[],[["socialImage","src",true,[],"env"]]],["else",{},[["img",{"src":"" + __webpack_require__(10) + "","alt":"avatar"}]]]],[["socialImage","notempty",true,[],"env"]]]]]]],["div",{"class":"td txt"},[["p",{"class":"message txt-c"},[["span",{},[],[["message","__text",true,[{"name":"html","params":[]}]]]]]]]]]]]]]);
fox.registerTemplate("notificationblock", [["div",{"id":"notifications"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("fake_player_button", [["span",{"class":"play bg-color-2-trans-70 text-color-1"},[["i",{"class":"icon-au_play"}],["textNode",{"text":" "}],["span",{"class":"txt"},[["textNode",{"text":"play welcome video"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';

	var RuleBase = __webpack_require__(14)(fox);

	return fox.extend({
		execute: function () {
			if (!this.getParams('enabled')) {
				this.addRouteHook();
			}
		},

		onRoute: function (route) {
			if (route.path === 'liveshow' && !this.getParams('enabled')) {
				route.action = '#home #404';
				route.path = '404';
			}

			return true;
		}
	}, RuleBase, null, 'Rule_Liveshow');
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/simplifica.eot", __webpack_require__.p + "fonts/7mXg5rJ.eot");

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(927);
var dir = previousRequest.replace("data-fox-editor-type-image.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "data-fox-editor-type-image.png",
	name: "data-fox-editor-type-image",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(929);
var dir = previousRequest.replace("banner-cam.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "banner-cam.png",
	name: "banner-cam",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(930);
var dir = previousRequest.replace("header.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "header.png",
	name: "header",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(931);
var dir = previousRequest.replace("slide-image-2.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "slide-image-2.jpg",
	name: "slide-image-2",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(932);
var dir = previousRequest.replace("slide-image-3.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "slide-image-3.jpg",
	name: "slide-image-3",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(933);
var dir = previousRequest.replace("slide-image-4.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "slide-image-4.jpg",
	name: "slide-image-4",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/iconfont.eot?ldnvmv", __webpack_require__.p + "fonts/3NVCGBe.eot");

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./_banner-cam.png": 946,
	"./_tips-img.jpg": 948,
	"./aboutPhotoEmpty.png": 30,
	"./ad-favorites.png": 950,
	"./ad-favorites_hover.png": 952,
	"./ad_next.png": 954,
	"./ad_prev.png": 956,
	"./ad_scroll_back.png": 958,
	"./ad_scroll_forward.png": 960,
	"./address_info_000000.png": 962,
	"./ajax-loader.gif": 964,
	"./avatar.gif": 965,
	"./avatar.jpg": 966,
	"./background/join-left.jpg": 968,
	"./background/join-right.jpg": 970,
	"./banner-cam-shadow.png": 972,
	"./banner-cam.png": 69,
	"./bg-img-2.jpg": 974,
	"./bg/arrow_view.png": 976,
	"./bg/bg_body.jpg": 978,
	"./bg/bg_body_1024.jpg": 980,
	"./bg/bg_enter_no.png": 982,
	"./bg/bg_menu.jpg": 984,
	"./bg/bg_menu.png": 986,
	"./bg/bg_title_block.png": 988,
	"./bg/bi-join-banner.jpg": 990,
	"./bg/btn_blue.gif": 992,
	"./bg/btn_blue.png": 993,
	"./bg/btn_pink.gif": 995,
	"./bg/btn_yellow.png": 996,
	"./bg/head_text_bg.png": 998,
	"./bg/play.png": 1000,
	"./bg/style_list_menu.png": 1002,
	"./bg_player.gif": 1004,
	"./bg_player.png": 1005,
	"./blank.gif": 1007,
	"./btn_continue.png": 1008,
	"./btn_continue_wb.png": 1010,
	"./btn_join.png": 1012,
	"./btn_join_wb.png": 1014,
	"./captcha.png": 1016,
	"./clean-thumb-tall.gif": 1018,
	"./clean-thumb-wide.gif": 1019,
	"./close.png": 1020,
	"./comments.gif": 1022,
	"./data-fox-editor-type-image.png": 68,
	"./dislike.png": 1023,
	"./download.gif": 1025,
	"./fancybox.png": 1026,
	"./favorite.gif": 1028,
	"./favorites-hover.png": 1029,
	"./favorites.png": 1031,
	"./fs_off.gif": 1033,
	"./fs_on.gif": 1034,
	"./fullscr.png": 1035,
	"./h1360i.jpg": 1037,
	"./hd.png": 1039,
	"./header-placeholder.png": 76,
	"./header.png": 70,
	"./home-hover.png": 1042,
	"./home.png": 1044,
	"./ico-bl.png": 1046,
	"./join/chbox.png": 1048,
	"./join/li_style.png": 1050,
	"./join/promotion_bg.png": 1052,
	"./join/radio.png": 1054,
	"./like.gif": 1056,
	"./like.png": 1057,
	"./loader.gif": 77,
	"./lock.png": 1059,
	"./logo.png": 1061,
	"./logout-hover.png": 1063,
	"./logout.png": 1065,
	"./messages-hover.png": 1067,
	"./messages.png": 1069,
	"./mobile.png": 1071,
	"./opa75.png": 1073,
	"./pc.png": 1075,
	"./pictures.gif": 1077,
	"./preloader.gif": 1078,
	"./preloader.png": 1079,
	"./refresh_icon.png": 1081,
	"./relate_bad.gif": 1083,
	"./relate_good.gif": 1084,
	"./sd.png": 1085,
	"./search-hover.png": 1087,
	"./search.png": 1089,
	"./settings-hover.png": 1091,
	"./settings.png": 1093,
	"./slide-image-2.jpg": 71,
	"./slide-image-3.jpg": 72,
	"./slide-image-4.jpg": 73,
	"./slider_open.png": 1095,
	"./slideshow_blue.png": 1097,
	"./slideshow_gray.png": 1099,
	"./slideshow_start.png": 1101,
	"./slideshow_stop.png": 1103,
	"./small-logo.png": 1105,
	"./social1.png": 1107,
	"./social2.png": 1109,
	"./social3.png": 1111,
	"./sprite-2.png": 1113,
	"./sprite-small-preloader-blue.png": 59,
	"./sprite-small-preloader-white.png": 5,
	"./sprite.png": 1115,
	"./tips-img.jpg": 78,
	"./trans.gif": 1118,
	"./twistys.png": 1119,
	"./unlike.gif": 1121,
	"./views_eye.gif": 1122,
	"./welcome-img.jpg": 1123,
	"./welcome.png": 1125
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1041);
var dir = previousRequest.replace("header-placeholder.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "header-placeholder.png",
	name: "header-placeholder",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/loader.gif", __webpack_require__.p + "images/loader.gif");

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1117);
var dir = previousRequest.replace("tips-img.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "tips-img.jpg",
	name: "tips-img",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (componentName) {
	'use strict';

	if (true) {
		return __webpack_require__(463)("./" + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_base2_frame') {
		return require('../skin/base2/frame/components/' + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_infinity_frame') {
		return require('../skin/infinity/frame/components/' + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_passion_frame') {
		return require('../skin/passion/frame/components/' + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_princess_frame') {
		return require('../skin/princess/frame/components/' + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_liberty_frame') {
		return require('../skin/liberty/frame/components/' + componentName + '/index');
	}
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function () {
	return __webpack_require__(81).apply(this, arguments);
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, staticUrl) {
	'use strict';

	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/.*\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}

	__webpack_require__(82)(fox);

	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	__webpack_require__(924);

	var contexts = [];
	contexts.push(__webpack_require__(937));
	contexts.push(__webpack_require__(941));
	contexts.push(__webpack_require__(1150));
	contexts.push(__webpack_require__(1251));
	contexts.forEach(getDeps);
	
	var switchColorScheme = fox.switchColorScheme = __webpack_require__(1272)(function (value) {
		return __webpack_require__(1273)("./_" + value + '.styl');
	});

	var colorscheme = fox.getEnv('c11n.invoker.colorscheme.value');

	return switchColorScheme(colorscheme || 'default');
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function () {
	return __webpack_require__(83).apply(this, arguments);
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}

	__webpack_require__(84)(fox);
	__webpack_require__(145)(fox);

	function getDeps(context) {
		context.keys().forEach(function (m) {
			var module = context(m);

			if (typeof module === 'function') module(fox);
		});
	}

	__webpack_require__(180);

	var contexts = [];
	contexts.push(__webpack_require__(381));
	contexts.push(__webpack_require__(429));
	contexts.push(__webpack_require__(628));
	contexts.push(__webpack_require__(639));
	contexts.push(__webpack_require__(704));
	contexts.push(__webpack_require__(780));
	contexts.forEach(getDeps);

	fox.RSVP.on('error', function (error) {
		return console.error && console.error('[Uncaught error in promise]: -> ', error);
	});
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}

	__webpack_require__(85)(fox);
	__webpack_require__(89)(fox);
	__webpack_require__(105)(fox);

	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(__webpack_require__(110));

	contexts.push(__webpack_require__(120));


	contexts.forEach(getDeps);
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}


	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(__webpack_require__(86));


	contexts.forEach(getDeps);
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./conversation/counterPeriodicalUpdater.js": 87,
	"./conversation/newMessageCountService.js": 88
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Counter_PeriodicallUpdater', {

		configure: function(options) {
			this.registerOptions('', {
				updateTime: 15000,				
				handleWom: {
					'navigator': {
						'event': 'modified_0',
						widget: fox.Navigator,
						callback: '@this:touchUpdate',
					}
				}
			});
			this.callParent('configure', arguments);
		},

		running: function() {
			this.touchUpdate();
			this.callParent('running', arguments);
		},

		touchUpdate: function() {
			if (fox.site.member && !this.isStarted()) {
				this.startUpdate();
			}
		}

	}, 'PeriodicalUpdater');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {

	var _ = {
		inbox: function (response) {
			var chatId;

			if (!fox.isEmpty(response.answer) && response.answer.conversationId) {
				chatId = response.answer.conversationId;

				this.total++;

				if (!this.fromUser[chatId]) {
					this.fromUser[chatId] = 1;
				} else {
					this.fromUser[chatId]++;
				}

				_.transferAmount.call(this);

				this.dispatchEvent('newInboxMessage', {
					data: response.answer,
					message: response.answer.content,
					conversationId: chatId
				});
			}
		},

		apiResponse: function (response) {
			var data;

			if (response.answer.status === true) {
				response = response.answer.response.success;

				this.total = Number(response.totalCount);
				
				fox.each(response.count, function (c, chId) {
					this.fromUser[chId] = Number(c);
				}, this);

				if (response.conversationId !== undefined) {
					fox.setEnv('site.conversationId', response.conversationId);
				}

				_.transferAmount.call(this);
			}
		},

		subMessageCount: function (chatId) {
			if (chatId !== undefined) {
				if (this.fromUser[chatId]) {
					this.total -= this.fromUser[chatId];
					this.fromUser[chatId] = 0;
					
					_.transferAmount.call(this);
					_.markMessagesAsRead.call(this, chatId);
				}
			}
		},

		transferAmount: function () {
			this.dispatchEvent('cameNewMessages', {total: this.total, fromUser: this.fromUser});
		},

		markMessagesAsRead: function (chatId) {
			return this.rwom1('#markMessagesAsReadApi').send({conversationId: chatId});
		}
	};

	fox.registerWidget('newMessageCountService', {

		configure: function () {
			this.fromUser = {};
			this.total = 0;

			this.registerOptions('', {
				subMessageCountEvent: 'readNewMessage',
				'widgets.newMessagesCountApi': {
					widget: 'Api',
					method: 'conversation.getNewMsgCount',
					useSocket: true,
					inboxSocketEvent: 'inboxSocketEventChat',
					inboxSocketCallback: fox.bind(_.inbox, this)
				},
				'widgets.markMessagesAsReadApi': {
					widget: 'Api',
					method: 'conversation.markMessagesAsRead'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			var e = this.getOption('subMessageCountEvent');

			this.handleEvent('@root', e, fox.bind(_.subMessageCount, this));

			this.callParent('init', arguments);
		},

		running: function () {
			this.wait('@root .Site_Layout', 'addedToDom')
				.then(this.fetchAmount.bind(this));
			
			this.callParent('running', arguments);
		},

		fetchAmount: function () {
			var api = this.rwom1('#newMessagesCountApi');

			return api.psend({}).then(function (resp) {
				return _.apiResponse.call(this, resp.params);
			}.bind(this));
		},

		transferAmount: function (data) {
			this.fromUser = data;

			_.transferAmount.call(this);
		}

	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}


	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(__webpack_require__(90));

	contexts.push(__webpack_require__(93));

	contexts.push(__webpack_require__(96));

	contexts.push(__webpack_require__(98));


	contexts.forEach(getDeps);
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./index.es.js": 91
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    __webpack_require__(92)(fox);
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    var Constructor = function Constructor(options) {
        this._objClass = 'LocalStorageObjectService';
        this.__constructor.call(this, options || {});

        return this;
    };

    var LocalStorageObjectService = fox.extend({
        __constructor: function __constructor(options) {
            this._lsLabel = options.lsLabel || ['label', fox.uniqid()].join('_');
            this._cleanCheckInterval = fox.isUndefined(options.cleanCheckInterval) && 1000 * 60 * 60 * 24 * 2 || options.cleanCheckInterval;

            this.ls = fox.utils.localStorage;

            if (this._cleanCheckInterval) this.cleanOldLSData();
        },

        cleanOldLSData: function cleanOldLSData() {
            var data, now;

            data = this.getLSData();
            now = new Date().getTime();

            if (fox.isObject(data)) {
                fox.each(data, function (val, key) {
                    if (val.hasOwnProperty('timestamp') && now - val.timestamp > this._cleanCheckInterval) {
                        this.removeItem(key);
                    }
                }, this);
            }
        },

        getLSData: function getLSData() {
            var data;

            try {
                data = JSON.parse(this.ls('getItem', this._lsLabel));
            } catch (e) {
                console.log(e);
            }

            return data;
        },

        setLSData: function setLSData(data) {
            return this.ls('setItem', this._lsLabel, JSON.stringify(data || {}));
        },

        setItem: function setItem(id, value) {
            var data,
                time = new Date().getTime();

            data = this.getLSData();

            if (fox.isString(value)) {
                value = {
                    value: value,
                    timestamp: time
                };
            }

            if (fox.isObject(value)) {
                value.timestamp = time;
            }

            if (fox.isEmpty(data) || !fox.isObject(data)) data = {};

            data[id] = value;

            this.setLSData(data);
        },

        getItem: function getItem(id) {
            var data = (this.getLSData() || {})[id];

            if (fox.isObject(data) && 'timestamp' in data) delete data.timestamp;

            return data;
        },

        removeItem: function removeItem(id) {
            var data;

            data = this.getLSData();

            fox.each(data, function (val, key) {
                if (key === id) {
                    delete data[key];
                }
            });

            this.setLSData(data);
        }

    }, fox.BaseObject, Constructor, 'LocalStorageObjectService');

    fox.registerService('LocalStorageObjectService', LocalStorageObjectService);
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./broadcaster_restyle.swf": 94,
	"./viewer_restyle.swf": 95
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/broadcaster_restyle.swf", __webpack_require__.p + "_/_/_/_/common/liveshow/flash/broadcaster_restyle.swf");

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/viewer_restyle.swf", __webpack_require__.p + "_/_/_/_/common/liveshow/flash/viewer_restyle.swf");

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./userChatController.js": 97
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.uchatctrl.widget":[{"value":"UserChatController","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Chat.js": 99,
	"./Fans.es.js": 100,
	"./Giftbox.es.js": 101,
	"./LSTranslator.es.js": 102,
	"./UserChatController.es.js": 103
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {

	fox.registerWidget('LSChatList', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				widgets: {
					chatList: {
						widget: 'AdvancedList',
						autoRender: true
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			var scrollContainer = this.requireOption('scrollContainer');

			this.registerOptions('#chatList', {
				'hooks.onStopAddedToDom': function () {
					$(this.element[0]).parents(scrollContainer).mCustomScrollbar({
						theme: this.getOption('scrollTheme') || 'minimal-dark'
					});

					this.getParent().scrollToBottom();
				}
			});

			this.callParent('init', arguments);
		},

		running: function () {
			this.cl = this.rwom1('#chatList');

			this.callParent('running', arguments);
		},

		scrollToBottom: function () {
			var scrollContainer = this.requireOption('scrollContainer');

			try {
				$(this.dom1(scrollContainer)).mCustomScrollbar('scrollTo', 'bottom', {scrollInertia: 200});
			} catch (e) {}
		},

		addMessage: function (m) {
			if (!this.cl) return;

			var active = this.isActive();

			if (this.cl._rendered === true) {
				return this.cl.wait('@this', 'addedToDom', {
					prefix: (Math.random() * Math.pow(10, 10)).toFixed()
				}).then(this.addMessage.bind(this, m));
			}

			return this.cl.appendItem(m, !active);
		},

		sendMessage: function (data) {
			console.log('LSChat -> sendMessage called');
		},

		reset: function () {
			this.cl.resetCollection();
		},

		updateScrollbar: function () {
			if (this.isEmbedded()) {
				this.getListScrollWrapperElement().mCustomScrollbar('update');
			}
		},

		getListScrollWrapperElement: function () {
			if (this.isEmbedded()) {
				return $(this.element[0]).parents(this.requireOption('scrollContainer'));
			}

			return false;
		},

		prepareList: function (list, mId) {
			return list.map(function (v) {
				if (v.uid === mId) {
					v.isBroadcaster = true;
				}

				if (!fox.isEmpty(v.dataset)) {
					try {
						v = fox.merge(v, JSON.parse(v.dataset));
					} catch (e) {}
				}

				return v;
			});
		}
	});

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function (fox, $, undefined) {

	fox.registerWidget('LSFans', {
		configure: function configure() {
			this.urefs = {};

			this.registerOptions('', {
				autoRender: true,
				widgets: {
					fanList: {
						widget: 'AdvancedList',
						autoRender: true,
						'hooks.onStopAddedToDom': function hooksOnStopAddedToDom() {
							$(this.element[0]).parents('.fan-list-scroll-wrapper').mCustomScrollbar({
								theme: 'minimal-dark'
							});
						},
						handleDom: {
							sendToUser: {
								event: 'click',
								target: '#send-to-user',
								callback: '@parent:sendToUser'
							}
						}
					}
				},
				handleWom: {
					onRoomJoin: {
						event: 'room_join',
						widget: '@root #uchatctrl',
						'params.alwaysActive': true,
						callback: function callback(msg, uchatctrl) {
							var _this = this;

							var member = uchatctrl.prepareUserObject(msg.member);

							if (msg.room === this.currentRoom && uchatctrl.userId != member.uid) {
								return this.prepareUserData([member]).then(function (prepared) {
									_this.dispatchEvent('roomJoin', prepared[0]);
								}).catch(function () {
									_this.dispatchEvent('roomJoin', member);
								});
							}
						}
					},
					onRoomLeave: {
						event: 'room_leave',
						widget: '@root #uchatctrl',
						'params.alwaysActive': true,
						callback: function callback(msg, uchatctrl) {
							var member = uchatctrl.prepareUserObject(msg.member);

							if (msg.room == this.currentRoom && uchatctrl.userId != member.uid) {
								var userData = this.removeUser(member.uid);

								return this.dispatchEvent('roomLeave', userData || member);
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		activate: function activate() {
			this.callParent('activate', arguments);

			if (this.getUsersAmount() === 0) {
				this.getUsers();
			}
		},

		getUsers: function getUsers() {
			var uchatctrl = this.rwom1('@root #uchatctrl');

			uchatctrl.getRoomUsers(this.currentRoom).then(function (users) {
				this.prepareUserData(users.filter(function (u) {
					return u.uid != uchatctrl.userId;
				}));
			}.bind(this));
		},

		getfl: function getfl() {
			return this.rwom1('#fanList');
		},

		prepareUserData: function prepareUserData(users) {
			var _this2 = this;

			if (fox.isEmpty(users)) return false;

			if (!fox.isArray(users) && fox.isObject(users)) users = fox.toArray(users);

			var api = this.getApi('userInfo', { method: 'liveshow.getUsers', sendTimezone: true });

			var undefinedUsers = users.filter(function (_ref) {
				var uid = _ref.uid;
				return uid.match(/^guest_/) !== null;
			}).map(function (user) {
				return _extends({}, user, { name: user.uid.replace(/^guest_/, 'Guest '), isGuest: true });
			});
			var userIds = users.filter(function (_ref2) {
				var uid = _ref2.uid;
				return uid.match(/^guest_/) === null;
			}).map(function (_ref3) {
				var uid = _ref3.uid;
				return uid;
			});

			var prepare = function prepare(_p) {
				return _p.map(function (p) {
					return _extends({}, p, {
						uid: p.id
					});
				});
			};

			var promises = [];
			if (userIds.length) promises.push(api.psend({ userIds: userIds }).then(function (resp) {
				return prepare(resp.params.answer.response);
			}));

			if (undefinedUsers.length) promises.push(fox.Promise.resolve(undefinedUsers));

			this.__addUsersProgress = promises.reduce(function (prev, next) {
				return prev.then(function (_users) {
					return next.then(function (__users) {
						return _users.concat(__users);
					});
				});
			}, fox.Promise.resolve([])).then(function (_users) {
				_this2.addUsers(_users);

				_this2.__addUsersProgress = null;
				return _users;
			}).catch(function (res) {
				_this2.addUsers(users);
				_this2.__addUsersProgress = null;
			});

			return this.__addUsersProgress;
		},

		addUsers: function addUsers(users) {
			if (!fox.isArray(users) && fox.isObject(users)) {
				users = fox.toArray(users);
			}

			var active = this.isActive();

			fox.each(users, function (user, indx) {
				return this.addUser(user, indx === users.length && active);
			}, this);

			return this;
		},

		addUser: function addUser(user, render) {
			if (!this.urefs.hasOwnProperty(user.uid)) {
				if (this.getfl()._rendered === true) {
					return this.getfl().wait('@this', 'addedToDom', {
						prefix: (Math.random() * Math.pow(10, 10)).toFixed()
					}).then(fox.bind(function () {
						this.addUser(user, render);
					}, this));
				}

				var id = this.getfl().appendItem(user, render !== undefined ? render : !this.isActive()).pop();

				this.urefs[user.uid] = id;
				this.dispatchEvent('fansAmountChanged');
			}

			return this;
		},

		removeUser: function removeUser(uid) {
			var user;

			if (uid in this.urefs) {
				user = this.getfl().getDataById(this.urefs[uid]);

				if (user !== false) {
					this.getfl().remove(user.indx);
					delete this.urefs[uid];
					this.dispatchEvent('fansAmountChanged');

					user = user.data;
				}
			}

			return user;
		},

		getUsersAmount: function getUsersAmount() {
			return this.getfl().getLength();
		},

		reset: function reset() {
			this.urefs = {};
			this.getfl().resetCollection();
			this.dispatchEvent('fansAmountChanged');
		},

		sendToUser: function sendToUser(el) {
			var uid = $(el).parents('.user-actions').data('user-id');
			var user = this.getfl().filter('uid', uid).pop();

			if (!fox.isEmpty(user)) {
				this.dispatchEvent('sendToUser', user.value);
			}
		},

		getModelId: function getModelId() {
			if (!this.modelId) {
				var buff = this.getfl().filter('isBroadcaster', true).pop();

				if (fox.objectGet(buff, 'value.uid')) {
					this.modelId = fox.objectGet(buff, 'value.uid');
				}
			}

			return this.modelId;
		},

		setCurrentRoom: function setCurrentRoom(roomId) {
			this.currentRoom = roomId;

			return this;
		},

		getUserInfoFromList: function getUserInfoFromList(uid) {
			var _this3 = this;

			if (this.__addUsersProgress) return this.__addUsersProgress.then(function () {
				return _this3.getfl().getDataById(_this3.urefs[uid]);
			});

			return fox.Promise.resolve(this.getfl().getDataById(this.urefs[uid]));
		}
	});
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function (fox, $, undefined) {
	'use strict';

	var AutoLoginService = __webpack_require__(15)(fox);

	var _ = {
		ALIAS_GIFT_PREFIX: 'gift-',

		EVENT_GIFTSENDED: 'giftSended',
		EVENT_GIFTPAID: 'giftPaid',
		EVENT_GIFTSAVAILABLE: 'giftsAvailable'
	};

	fox.registerWidget('Giftbox', {
		configure: function configure() {
			this.checkedGifts = [];
			this.pendingPayment = [];

			this.registerOptions('', {
				autoRender: true,
				template: 'ls_viewer_sidebar_giftbox',
				widgets: {
					giftboxList: {
						widget: 'AdvancedList',
						'embed.container': '#gift-list-container',
						'tpl.row': 'ls_viewer_sidebar_giftbox_list_row',
						autoRender: true,
						collection: [{ loader: true }]
					},
					cbPaymentPopup: {
						widget: 'CBPaymentPopup'
					}
				},
				handleDom: {
					sendGifts: {
						event: 'click',
						target: '#send-gift',
						callback: 'sendGiftConfirmed'
					},
					checkGift: {
						event: 'click',
						target: '.gift-item',
						targetWidget: '#giftboxList',
						callback: 'checkGiftSingle'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			var _this = this;

			this.callParent('init', arguments);
			var pm = fox.site.wom1('.PermissionManager');
			if (pm.hasAccess('guest')) {
				this.autoLoginService = new AutoLoginService(this);
				this.registerOptions('#cbPaymentPopup', {
					matchTokenFunction: function matchTokenFunction(token) {
						return _this.autoLoginService.matchToken(token);
					}
				});
			}
			this.ga = fox.wom.selectFirst('@root #googleAnalytics');
			this.typeAlias = this.requireOption('giftType');
			this.gifts = null;

			this.handleEvent('@root #socket', this.requireOption('giftPaymentSuccess'), 'giftPaymentSuccess', {
				alwaysActive: true
			});
		},

		running: function running() {
			this.fetchGifts().then(function (gifts) {
				this.rwom1('#giftboxList').resetCollection(gifts);
				this.dispatchEvent(_.EVENT_GIFTSAVAILABLE);
			}.bind(this));

			this.callParent('running', arguments);
		},

		fetchGifts: function fetchGifts() {
			var api = this.getApi('getGifts', { method: 'gift.get', cacheChannel: 'site' });

			return api.psend({
				typeAlias: this.typeAlias
			}).then(function (res) {
				res = res.params.answer.response;

				var gifts = [];

				fox.each(res, function (item) {
					var amount = parseFloat(item.amount);
					var price = (amount ^ 0) === amount ? parseInt(amount) : amount.toFixed(2);
					gifts.push({
						id: item.giftId,
						alias: _.ALIAS_GIFT_PREFIX + item.giftId,
						price: price
					});
				});

				this.gifts = gifts;

				return fox.clone(gifts);
			}.bind(this));
		},

		getGifts: function getGifts() {
			return this.gifts;
		},

		_getGift: function _getGift(id) {
			var gifts = this.getGifts();

			for (var i = 0; i < gifts.length; i++) {
				if (gifts[i].id === id) {
					return gifts[i];
				}
			}

			return false;
		},

		prepareParams: function prepareParams() {},

		sendGiftConfirmed: function sendGiftConfirmed(el, alias, performer, event) {
			var _this2 = this;

			event.preventDefault();
			event.stopPropagation();
			if (fox.isEmpty(this.checkedGifts)) {
				if (!!this.getOption('showUnchecked')) {
					var showUnchecked = this.getOption('showUnchecked');
					showUnchecked();
				}
				return false;
			}
			var pm = fox.site.wom1('.PermissionManager');
			var isGuestUser = pm.hasAccess('guest') && fox.isEmpty(pm.getMemberInfo());
			var prepareUserPromise = fox.Promise.resolve([true]);

			if (isGuestUser) {
				var showRegForm = this.getOption('userRegistration');
				this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: 'RevenueGuest', eventAction: 'FirstSendClick' });
				prepareUserPromise = showRegForm();
			} else {
				if (this.getParent().alias === "valentinesGiftsPopup") this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: 'RevenueMember', eventAction: 'SendClick' });
			}

			return prepareUserPromise.then(function (result) {
				if (!result) return [false];else return _this2.sendGifts(_extends({}, result), el);
			});
		},


		sendGifts: function sendGifts(data, btn) {
			var _this3 = this;

			var payGift = function payGift(id) {
				var getTargetId = _this3.requireOption('targetIdCb');
				var api = _this3.getApi('payGift', { method: 'gift.pay' });

				var giftParams = {
					giftId: id,
					targetId: getTargetId(),
					typeAlias: _this3.typeAlias
				};

				if (!fox.isEmpty(data)) giftParams = fox.merge(giftParams, data);

				var linkerParam = fox.wom.selectFirst('@root #googleAnalytics').getLinkerParam();

				if (linkerParam) {
					giftParams['transitParams[_ga]'] = linkerParam;
				}

				_this3.pendingPayment.push(id);

				var cbPaymentPopup = _this3.rwom1('#cbPaymentPopup');

				_this3.hookWrapper('prepareParams', giftParams);

				_this3.__prepareTransactionProgress = api.psend(giftParams, undefined, { prefix: 'waitForPay_' + id }).then(fox.bind(function (res) {
					delete this.__prepareTransactionProgress;

					res = res.params.answer.response;

					this.dispatchEvent(_.EVENT_GIFTSENDED);

					if (res.submit_url !== undefined) {
						return res;
					}
				}, _this3)).catch(fox.bind(function () {
					delete this.__prepareTransactionProgress;

					cbPaymentPopup.hide();
					this.pendingPayment.splice(this.pendingPayment.indexOf(id), 1);

					this.dispatchEvent(_.EVENT_GIFTSENDED);
				}, _this3));

				return _this3.__prepareTransactionProgress;
			};

			var _checkedGifts = _slicedToArray(this.checkedGifts, 1),
			    checkedId = _checkedGifts[0];

			this.showCbWindow(payGift(checkedId)).then(function () {
				_this3.resetCheckedGifts();
			}, function () {
				_this3.resetCheckedGifts();
			});
		},

		giftPaymentSuccess: function giftPaymentSuccess(res) {
			var _this4 = this;

			var args = Array.prototype.slice.call(arguments);
			var cbPaymentPopup = this.rwom1('#cbPaymentPopup');

			if (this.__prepareTransactionProgress) {
				return this.__prepareTransactionProgress.then(function () {
					return _this4.giftPaymentSuccess.apply(_this4, args);
				});
			}

			if (cbPaymentPopup.isOpen()) cbPaymentPopup.hide();

			res = parseInt(res.answer);
			var indx = this.pendingPayment.indexOf(res);

			if (indx !== -1) {
				this.pendingPayment.splice(indx, 1);

				var gift = this._getGift(res);

				if (gift !== false) {
					this.dispatchEvent(_.EVENT_GIFTPAID, [[gift.alias, gift.price].join(':')]);
				}
			}
		},

		showCbWindow: function showCbWindow(promise) {
			var cbPaymentPopup = this.rwom1('#cbPaymentPopup');

			return cbPaymentPopup.show(promise.then(function (params) {
				var url = params.submit_url + '?' + fox.toQueryString(params.added_fields);

				return { url: url };
			}));
		},

		checkGiftSingle: function checkGiftSingle(el, alias, performer) {
			var $el = $(el);

			if (!$el.hasClass('gift-item')) {
				$el = $el.parents('.gift-item');
			}

			var gid = $el.data('gid');
			var gift = this._getGift(gid);
			var indx;
			var checked;
			var $old;

			if (gift !== false) {
				indx = this.checkedGifts.indexOf(gid);

				if (indx === -1) {
					checked = this.checkedGifts.pop();

					if (checked !== undefined) {
						$old = $(performer.dom1('[data-gid="' + checked + '"]'));
						$old.removeClass('active');
					}

					this.checkedGifts.push(gid);
					$el.addClass('active');
				} else {
					this.checkedGifts.splice(indx, 1);
					$el.removeClass('active');
				}
			}
		},

		checkGiftMultiple: function checkGiftMultiple(el) {
			var $el = $(el),
			    gid = $el.data('gid'),
			    gift = this._getGift(gid),
			    indx;

			if (gift !== false) {
				indx = this.checkedGifts.indexOf(gid);

				if (indx === -1) {
					this.checkedGifts.push(gid);
					$el.addClass('active');
				} else {
					this.checkedGifts.splice(indx, 1);
					$el.removeClass('active');
				}
			}
		},

		showSuccessPopup: function showSuccessPopup() {
			this.dispatchEvent('giftPaid');
		},

		resetCheckedGifts: function resetCheckedGifts() {
			this.checkedGifts = [];

			this.wom1('#giftboxList').dom('[data-gid]').forEach(function (elm) {
				$(elm).removeClass('active');
			});
		}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LiveshowChatTokens = __webpack_require__(40);

module.exports = function (fox) {
  var _ = {
    WOWZA_SERVER_HOST: ['live1.modelcentro.com', 'live2.modelcentro.com'],

    LSLABEL_WOWZA_SERVER: '_lswzs_',
    EVENT_FULLSCREEN: 'fullscreen',
    EVENT_NORMALSCREEN: 'normalscreen',

    TIMEOUT_MAXCONNECT_TIMELENGTH: 1000 * 25,

    ERROR_INTERRUPTED: 'connection.closed',
    ERROR_BAD_CONNECTION: 'connection.server.notrespond'
  };

  var ROOM_ALIAS_LABEL = '_ralsl_';
  var timerId = 0;

  fox.registerWidget('LSTranslator', {
    createController: function createController() {
      var createClient = fox._liveshowController.controllerFactory(fox);
      return createClient.apply(undefined, arguments);
    },

    configure: function configure() {
      this.connectParams = {};

      this.fullscreen = false;

      this.registerOptions('', {
        autoRender: true
      });

      this.callParent('configure', arguments);
    },

    init: function init() {
      this._assignCallbacks();
      this.callParent('init', arguments);
    },

    _assignCallbacks: function _assignCallbacks() {
      var events = ['app_initialized', 'stream_connection_success', 'stream_connection_closed'];

      var mixEvents = this._getEventCallbacks();

      if (fox.isArray(mixEvents)) {
        events = events.concat(mixEvents);
      }

      fox.each(events, function (e) {
        var cb = this[e];

        if (fox.isFunction(cb)) {
          this.handleEvent('@this', e, cb.bind(this));
        }
      }, this);
    },

    onError: function onError(args) {
      if (fox._isNewfe) {
        /* if (__DEV__) */
        console.log('[' + this.getClass() + ']: -> liveshow.error', args);
      }

      return this.treatError(args.code, args);
    },

    _onEvent: function _onEvent(args) {
      var event = [args.module, args.type];
      var isActivityEvent = event.indexOf('activity') !== -1;

      if (!isActivityEvent && fox._isNewfe) {
        /* if (__DEV__) */
        console.log('[' + this.getClass() + ']: -> liveshow.event', args);
      }

      if (args.subType) {
        event = event.concat(args.subType.split('.'));
      }

      event = event.join('_');

      if (!isActivityEvent) {
        this.log(event.replace(/_/g, '.'), args);
      }

      this.dispatchEvent(event, args);
    },

    getDisconnectToken: function getDisconnectToken() {
      return LiveshowChatTokens.publisherDisconnect;
    },

    getUserBlockToken: function getUserBlockToken() {
      return LiveshowChatTokens.blockUser;
    },

    getUserUnblockToken: function getUserUnblockToken() {
      return LiveshowChatTokens.unblockUser;
    },

    getPaidShowRequestToken: function getPaidShowRequestToken() {
      return LiveshowChatTokens.paidShowRequest;
    },

    getLeavePrivateToken: function getLeavePrivateToken() {
      return LiveshowChatTokens.leavePrivate;
    },

    getPrepareWebrtcTranslationToken: function getPrepareWebrtcTranslationToken() {
      return LiveshowChatTokens.prepareWebrtcTranslation;
    },

    getInterruptError: function getInterruptError() {
      return _.ERROR_INTERRUPTED;
    },
    getBadConnectionError: function getBadConnectionError() {
      return _.ERROR_BAD_CONNECTION;
    },
    getWowzaServer: function getWowzaServer() {
      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var server = this.connectParams.server || _.WOWZA_SERVER_HOST[idx];

      return fox.utils.localStorage('getItem', _.LSLABEL_WOWZA_SERVER) || server;
    },


    connectSuccess: function connectSuccess() {
      clearTimeout(this.connectInProgress);

      return this;
    },

    setConnectParams: function setConnectParams(_ref) {
      var id = _ref.id,
          sign = _ref.sign;

      var sessionId = Number(id);

      if (this.connectParams.sessionId !== sessionId && this.connectParams.sign !== sign) this.connectParams.sessionId = sessionId;

      if (this.connectParams.sign !== sign) this.connectParams.sign = sign;

      return this;
    },

    addedToDom: function addedToDom() {
      var _this = this;

      /* avoid double call on activate */
      clearTimeout(timerId);
      timerId = setTimeout(function () {
        return _this.initApp();
      }, 100);
    },

    getConnectParams: function getConnectParams() {
      return {
        sessionId: this.connectParams.sessionId,
        hash: this.connectParams.sign,
        url: this.getWowzaServer(1),
        streamName: this.connectParams.streamName,
        stunServer: this.connectParams.stunServer
      };
    },

    initApp: function initApp(targetNode) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.inst) return false;

      var params = fox.merge({
        width: this.getOption('flashWidth') || 475,
        height: this.getOption('flashHeight') || 355
      }, args, this.getOption('flashParams') || {});

      this.inst = this.controller.init(targetNode || this.dom1(this.getOption('flashContainer')), params, this.getConnectParams());

      return true;
    },

    deactivate: function deactivate() {
      this.inst.release();
      delete this.inst;

      this.callParent('deactivate', arguments);
    },

    setFullscreen: function setFullscreen() {
      this.fullscreen = true;
      this.dispatchEvent(_.EVENT_FULLSCREEN);
    },

    exitFullscreen: function exitFullscreen() {
      this.fullscreen = false;
      this.dispatchEvent(_.EVENT_NORMALSCREEN);
    },

    setFlashSize: function setFlashSize(res) {
      var ar = parseFloat((res.w / res.h).toFixed(2).slice(0, -1));
      var sw = fox.jQuery('body').width();
      var sh = fox.jQuery('body').height();
      var _ = this.getFullscreenMargins();
      var nw = void 0;
      var nh = void 0;

      if (this.fullscreen === true) {
        nw = sw - _.MARGIN_PLAYER_W;
        nh = nw / ar;

        if (nh > sh - _.MARGIN_PLAYER_H) {
          nh = sh - _.MARGIN_PLAYER_H;
          nw = nh * ar;
        }
      } else {
        nw = this.getOption('flashWidth');

        nh = nw / ar;

        if (nh > this.getOption('flashHeight')) {
          nh = this.getOption('flashHeight');
          nw = nh * ar;
        }
      }

      this.inst.setSize(nw, nh, true);
    },

    treatError: function treatError(error, args) {
      var errorCode = 505;
      var errorRegexp = /^[A-E]?\d+$/;

      if (this.connectInProgress) {
        clearTimeout(this.connectInProgress);
      }

      if (fox.isObject(error) && error.id) {
        errorCode = error.id;
      } else if (errorRegexp.test(error)) {
        errorCode = error;
      } else if (error.split('.').length) {
        errorCode = error;
      }

      this.log(errorCode, args);

      return errorCode;
    },

    log: function log(errorCode, args) {
      if (fox.cookie.get('debug')) {
        return false;
      }

      var api = this.getApi(fox.uniqid('liveshowLog_'), {
        method: 'liveshow.log',
        sendTimezone: true,
        httpMethod: 'post'
      });

      var params = {
        liveshowId: this.connectParams.sessionId,
        code: errorCode,
        userTimestamp: new Date().getTime(),
        userAgent: window.encodeURIComponent(navigator.userAgent)
      };

      if (fox.isObject(args)) {
        params.args = window.encodeURIComponent(JSON.stringify(args));
      }

      api.send(params);
    },

    getRoomAlias: function getRoomAlias() {
      var sessionId = this.connectParams.sessionId;
      var tmpSessionId = localStorage.getItem(ROOM_ALIAS_LABEL);

      if (tmpSessionId) sessionId = tmpSessionId;

      return ['liveshow', 'room', sessionId].join('_');
    },
    changeWowzaServer: function changeWowzaServer(server) {
      fox.utils.localStorage('setItem', _.LSLABEL_WOWZA_SERVER, server);

      delete this.inst;
      this.render();
    },
    resetWowzaServer: function resetWowzaServer() {
      fox.utils.localStorage('removeItem', _.LSLABEL_WOWZA_SERVER);

      delete this.inst;
      this.render();
    }
  }, 'Widget');
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WebsocketTransport = __webpack_require__(104);

module.exports = function (fox) {
	var _ = {
		EVENT_INBOX_PRIVATE: 'inbox_private',
		EVENT_INBOX_PUBLIC: 'inbox_public',
		EVENT_INBOX_SERVICE: 'inbox_service'
	};

	fox.registerWidget('UserChatController', {
		_send: function _send(params) {
			this._transport.send(params);

			return this;
		},

		configure: function configure() {
			var _this = this;

			this.lastRequest = null;

			this.registerOptions('', {
				serverhost: 'chat.modelcentro.com',
				handleWom: {
					fingerprintRecieved: {
						widget: '@root',
						event: 'exodentity_fingerprint_recieved',
						callback: function callback(_ref) {
							var fingerprint = _ref.fingerprint;

							var pm = _this.wom1('@root #permissionManager');

							if (pm && pm.hasAccess('guestActual')) {
								var id = 'guest_' + fox.getStringSimpleHash(fingerprint, 36);

								if (id !== _this.userId) {
									return _this.reconnect();
								}
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			var _this2 = this;

			var pm = this.wom1('@root #permissionManager');
			var _getId = function _getId() {
				var id = void 0;

				if (pm && !fox.isEmpty(pm.getMemberInfo())) {
					id = '' + pm.getMemberInfo('id');
				} else if (fox.site.member) {
					id = '' + fox.site.member.getObjectValue('id');
				} else {
					var exoUid = fox.exodentity && fox.exodentity.getSavedUid();

					id = 'guest_' + (exoUid ? fox.getStringSimpleHash(exoUid, 36) : fox.random(1000, 100000));
				}

				return id;
			};

			this.userId = _getId();

			this._transport = new WebsocketTransport({
				host: this.getOption('serverhost'),
				transport: window.io,
				getId: function getId() {
					var id = _getId();

					if (_this2.userId !== id) _this2.userId = id;

					return id;
				},
				onMessage: function onMessage(message) {
					return _this2._inbox(message);
				}
			});

			this._transport.connect();

			this.callParent('init', arguments);
		},

		_inbox: function _inbox(msg) {
			if (!msg.hasOwnProperty('mtype')) {
				if (~msg.to.indexOf('@')) {
					this.dispatchEvent(_.EVENT_INBOX_PRIVATE, msg);
				} else {
					this.dispatchEvent(_.EVENT_INBOX_PUBLIC, msg);
				}
			} else if (msg.mtype === 'service') {
				this.proxyServiceMessages(msg);
			}
		},

		reconnect: function reconnect() {
			var reconnectPromise = this.wait('chat_join');
			this._transport.disconnect();
			return reconnectPromise;
		},
		createRoom: function createRoom(id, history) {
			if (id === undefined) {
				id = '_default';
			}

			var params = {
				method: 'room',
				action: 'create',
				alias: id
			};

			if (history) {
				params.plugins = { history: {} };
			}

			return this._send(params);
		},
		joinRoom: function joinRoom(id) {
			var joinPromise = this._withDelayedResolve(this.wait('room_join'));

			this._send({
				method: 'room',
				action: 'join',
				alias: id
			});

			return joinPromise;
		},
		leaveRoom: function leaveRoom(id) {
			var leavePromise = this._withDelayedResolve(this.wait('room_leave'));

			this._send({
				method: 'room',
				action: 'leave',
				alias: id
			});

			return leavePromise;
		},
		prepareUserObject: function prepareUserObject(id) {
			var parts = id.split('@');

			return {
				uid: parts[0],
				entry: parts[1]
			};
		},
		getRoomUsers: function getRoomUsers(id) {
			var roomUsersPromise = this.wait('room_members');

			this._send({
				method: 'room',
				action: 'getMembersList',
				alias: id
			});

			return roomUsersPromise.then(function (resp) {
				var members = resp.params.members.map(this.prepareUserObject);

				return fox.Promise.resolve(members);
			}.bind(this));
		},
		getRoomHistory: function getRoomHistory(id) {
			var roomHistoryPromise = this.wait('room_history');

			this._send({
				method: 'room',
				action: 'history',
				alias: id
			});

			return roomHistoryPromise.then(function (resp) {
				return resp.params.messages;
			}.bind(this));
		},
		sendMessage: function sendMessage(msg, to) {
			var params = fox.mixin({
				method: 'message',
				to: to.toString()
			}, msg);

			this._send(params);
		},
		proxyServiceMessages: function proxyServiceMessages(msg) {
			return this.dispatchEvent(msg.alias, msg);
		},
		_withDelayedResolve: function _withDelayedResolve(promise) {
			var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;

			return new fox.Promise(function (resolve) {
				var timeout = setTimeout(resolve, delay);

				return promise.then(function (resp) {
					clearTimeout(timeout);

					return resolve(resp);
				});
			});
		}
	}, 'Controller');
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
	function WebsocketTransport(_ref) {
		var host = _ref.host,
		    onMessage = _ref.onMessage,
		    getId = _ref.getId,
		    transport = _ref.transport;

		_classCallCheck(this, WebsocketTransport);

		this._host = host;
		this._transport = transport;
		this._connection = null;

		this._onMessage = onMessage;
		this._getId = getId;
	}

	_createClass(WebsocketTransport, [{
		key: 'connect',
		value: function connect() {
			var _this = this;

			if (this._connection) return this._connection.connect();

			this._connection = this._transport.connect((location.protocol === 'https:' ? 'wss://' : 'ws://') + this._host, { transports: ['websocket'] });

			this._connection.on('connect', function () {
				return _this._authorize.apply(_this, arguments);
			});
			this._connection.on('message', function () {
				return _this._inbox.apply(_this, arguments);
			});
			this._connection.on('disconnect', function () {
				return _this.connect();
			});

			return this._connection;
		}
	}, {
		key: 'disconnect',
		value: function disconnect() {
			this._connection.disconnect();
		}
	}, {
		key: 'send',
		value: function send(map) {
			this._connection.send(this._toJson(map));
		}
	}, {
		key: '_log',
		value: function _log() {
			var _console;

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return false && (_console = console).log.apply(_console, ['[WebsocketTransport]: ->'].concat(args));
		}
	}, {
		key: '_toJson',
		value: function _toJson(map) {
			return JSON.stringify((typeof map === 'undefined' ? 'undefined' : _typeof(map)) === 'object' ? map : {});
		}
	}, {
		key: '_authorize',
		value: function _authorize() {
			this.send({
				method: 'auth',
				login: this._getId()
			});
		}
	}, {
		key: '_inbox',
		value: function _inbox(message) {
			try {
				message = JSON.parse(message);

				this._log('incomming message', message);
				this._onMessage(message);
			} catch (e) {
				this._log('message parse error', e);
			}
		}
	}]);

	return WebsocketTransport;
}();

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}


	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(__webpack_require__(106));

	contexts.push(__webpack_require__(108));


	contexts.forEach(getDeps);
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ga.js": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.googleAnalytics.widget":[{"value":"mcGoogleAnalytics","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.widget":[{"value":"#logoutApi","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101024},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.event":[{"value":"success","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101025},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.callback":[{"value":function() {
var ga = fox.wom.selectFirst('@root #googleAnalytics');
ga.trackEvent({'eventCategory': 'User', 'eventAction': 'logout'});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101029},"path":"@root","_fox_":1}]},"@root #router":{"hooks.onStopExecute":[{"value":function() {
var counterCalls = 0;
var currentPage = this._passedRoute.path;
var self = this;
var callback = function callback () {
counterCalls++;
var loaded = typeof _gaScriptLoaded !== 'undefined' ?
_gaScriptLoaded :
false
if (!loaded && counterCalls < 5) {
return setTimeout(callback, 2000);
}
self.rwom1('@root #googleAnalytics').trackPageview(currentPage, false);
}();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101020},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./mcgoogleanalytics.js": 109
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	
	fox.registerWidget('mcGoogleAnalytics', {
		/**
		 * Track pageview.
		 * @param {string} page Name of tracked page
		 * @param {boolean} logPage If true, send navigator information to api logger.log
		 * @return {void}
		 */
		trackPageview: function(page, logPage) {
			this.callParent('trackPageview', [page]);

			if (fox.isEmpty(fox.site.member) && (fox.getEnv('affiliateArea') || fox.getEnv('globalSubscription'))) {
				var api = this.getApi('affTrack', {method: 'affiliate.track'});
				var data = {
					page: page
				};

				var foxref = null;

				if (foxref = fox.cookie.get('foxref')) {
					data.refCode = foxref;
				}

				api.send(data, false);
			}

			var permissionManager = fox.wom.selectFirst('~.PermissionManager');

			var isMember = permissionManager
				? !fox.isEmpty(permissionManager.getMemberInfo())
				: !fox.isEmpty(fox.site.member)
			;

			if (isMember && logPage) {
				var page = fox.Navigator.getAll()[0];

				if (!fox.inArray(['scene', 'gallery', 'product'], page)) {
					return;
				}

				var api = this.getApi('loggerLog', {method: 'logger.log'});

				api.send({
					index: 'McUserActivity',
					path: fox.Navigator.getAll()
				}, false);	
			}
		},

		/**
		 * Set default google dimensions for tracker with name "trackerName"
		 * @param {string} trackerName
		 * return {void}
		 */
		_setTrackerDimensions: function(trackerName) {
			this.callParent('_setTrackerDimensions', arguments);

			var foxref = fox.cookie.get('foxref');
			var acode = fox.cookie.get('acode');
			var parsedUrl, getParams;

			if (!acode) {
				parsedUrl = fox.Navigator.parseUrl(document.location);

				if (parsedUrl.search) {
					getParams = fox.Navigator.parseSearch(parsedUrl.search);

					if (getParams['acode']) {
						acode = getParams['acode'];
					}
				}
			}

			ga(trackerName + '.set', 'dimension2', fox.isEmpty(foxref) ? "" : foxref);
			ga(trackerName + '.set', 'dimension3', fox.isEmpty(acode) ? "" : acode);
		}

	}, 'googleAnalytics');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./slick/slick-theme.css": 111,
	"./slick/slick.css": 118
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(112);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize!./slick-theme.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize!./slick-theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".slick-loading .slick-list{background:#fff url(" + __webpack_require__(113) + ") 50% no-repeat}@font-face{font-family:slick;font-weight:400;font-style:normal;src:url(" + __webpack_require__(41) + ");src:url(" + __webpack_require__(41) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(114) + ") format(\"woff\"),url(" + __webpack_require__(115) + ") format(\"truetype\"),url(" + __webpack_require__(116) + "#slick) format(\"svg\")}.slick-next,.slick-prev{font-size:0;line-height:0;position:absolute;top:50%;display:block;width:20px;height:20px;padding:0;transform:translateY(-50%);cursor:pointer;border:none}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:none;background:transparent}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-family:slick;font-size:20px;line-height:1;opacity:.75;color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:\"\\2190\"}[dir=rtl] .slick-prev:before{content:\"\\2192\"}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}.slick-next:before{content:\"\\2192\"}[dir=rtl] .slick-next:before{content:\"\\2190\"}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{position:absolute;bottom:-25px;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li,.slick-dots li button{width:20px;height:20px;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;padding:5px;color:transparent;border:0;outline:none;background:transparent}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-family:slick;font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:\"\\2022\";text-align:center;opacity:.25;color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-dots li.slick-active button:before{opacity:.75;color:#000}", ""]);

// exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("css/slick/ajax-loader.gif", __webpack_require__.p + "_/_/_/main/css/slick/ajax-loader.gif");

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("css/slick/fonts/slick.woff", __webpack_require__.p + "_/_/_/main/css/slick/fonts/hqgf7TV.woff");

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("css/slick/fonts/slick.ttf", __webpack_require__.p + "_/_/_/main/css/slick/fonts/3Hy7EDt.ttf");

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("css/slick/fonts/slick.svg", __webpack_require__.p + "_/_/_/main/css/slick/fonts/slick.svg");

/***/ }),
/* 117 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(119);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize!./slick.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize!./slick.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list,.slick-slider{position:relative;display:block}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:none}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{transform:translateZ(0)}.slick-track{position:relative;top:0;left:0;display:block}.slick-track:after,.slick-track:before{display:table;content:\"\"}.slick-track:after{clear:both}.slick-loading .slick-track{visibility:hidden}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-loading .slick-slide{visibility:hidden}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}", ""]);

// exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./layout/404.js": 121,
	"./layout/home.js": 122,
	"./layout/join.js": 123,
	"./member.js": 124,
	"./offer/UserOffer.js": 125,
	"./offer/controllers/UserOfferAcp.js": 126,
	"./offer/controllers/UserOfferBase.js": 127,
	"./offer/controllers/UserOfferModelRelated.js": 128,
	"./offer/controllers/UserOfferModelRelated/list.js": 129,
	"./sitepage/2257.js": 130,
	"./sitepage/404.js": 131,
	"./sitepage/about.js": 132,
	"./sitepage/join.js": 133,
	"./sitepage/liveshow.js": 134,
	"./sitepage/login.js": 135,
	"./sitepage/privacy.js": 136,
	"./sitepage/splash.js": 137,
	"./sitepage/tips.js": 138,
	"./user/favoriteamc.js": 139,
	"./user/forgotpassword.js": 140,
	"./user/passwordRecovery/base.js": 141,
	"./user/passwordRecovery/confirmation.js": 142,
	"./user/passwordRecovery/email.js": 143,
	"./user/passwordrecovery.js": 144
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Home */

(function(fox) {
	fox.registerWidget('Layout_404', {

		configure: function(options) {
			options.pageContainer = '.page-404';
			this.callParent('configure', arguments);
		}

	}, 'Site_Layout');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Home  */
(function(fox) {

	fox.registerWidget('Layout_Home', {
		//Widget config
		configure: function(options) {
			this.registerOptions('', {
				pageContainer: '#container',
				widgets: {
					notification: {
						widget: 'NotificationViewer',
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			if (!fox.isEmpty(fox.getEnv('design.url'))) {
				fox.site.designUrl = fox.getEnv('design.url');
			} else {
				fox.site.designUrl = "http://" + document.location.host;
			}

			this.embedWidget('member', 'Member', {
				container: '#welcome_user',
				zenTemplate: fox.getTemplate('layout_home_member'),
				autoRender: true
			});

			/*this.embedWidget('currentConversationReload', 'Conversation_PeriodicalUpdater', {
				startUpdateEvent: {
					target: fox.Navigator,
					event: 'modified_0',
				}
			});*/

			this.createImg();

			return this.callParent('init', arguments);
		},

		running: function() {
			// this.currentConversationReload = this.requireEmbeddedWidget('currentConversationReload');
			//this.handleEvent(this.requireEmbeddedWidget('topMenu'), 'addedToDom', fox.bind(this.menuState, this));
			// this.handleEvent(fox.Navigator, 'modified_0', fox.bind(this.currentConversationReload.reloadUpdate, this));
		},

		// menuState: function() {
		// 	if (!fox.isEmpty(fox.site.member)) {
		// 		$('.dlmenu').addClass('member');
		// 	} else {
		// 		$('.dlmenu').removeClass('member');
		// 	}

		// },

		// setMenuActive: function(elt) {
		// 	$('.menu_link').each(function(id, menuElt) {
		// 		$(menuElt).removeClass('active');
		// 		}
		// 	);
		// 	$(elt).addClass('active');

		// },

		// logout: function() {
		// 	fox.site.logout();
		// },

		//large background fixing
		insertBg: function (path) {
			document.body.style.backgroundImage = 'url(' + path + ')';
			document.body.parentNode.style.backgroundImage = 'url(' + path + ')';
		},

		createImg: function (callback) {
			// var _this = this,
			// 	img = document.createElement('img');
			// 	img.src = fox.getEnv('design.url') + '/images/bg/bg_body.jpg';


			//img.onload = function () {
			//	_this.insertBg(img.src);
			//}
		}

	}, 'Site_Layout');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Home */

(function(fox) {
	fox.registerWidget('Layout_Join', {

		//Widget config
		configure: function(options) {
			this.callParent('configure', arguments);
			this.sitePageContainer = '#main';
		},

		//Widget run
		run: function() {
			if (!this.callParent('run', arguments)) return;
			delete this.sitePageFragment;
			this.renderState = 0;
			this.fragment = fox.createFragmentFromHtml(this.options.dataLayer.getObject().get('template'));

			this.render();
			return this;
		},

		sitePageReady: function(sitePageFragment) {
			if (this.renderState == 1) {
				this.renderSitePage(document.body, sitePageFragment);
			}
			this.sitePageFragment = sitePageFragment;
		},

		render: function() {
			if (this.sitePageFragment) {
				this.renderSitePage(this.fragment, this.sitePageFragment);
			}
			document.body.innerHTML = '';
			document.body.appendChild(this.fragment);
			this.renderState = 1;
		},

		renderSitePage: function(container, fragment) {
			var sitePageContainer = fox.dom.select(this.sitePageContainer, container)[0];
			sitePageContainer.innerHTML = '';
			sitePageContainer.appendChild(fragment);
		}
	}, fox.Layout);

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Member', {
		rendering: function() {
			var pm = this.wom1('@root .PermissionManager');

			if (pm) {
				if (pm.member) return this.callParent('rendering', arguments);

				return this.createFragment();
			}

			if (fox.isEmpty(fox.site.member)) {
				return this.createFragment();
			}

			return this.callParent('rendering', arguments);
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";

	fox.registerWidget('UserOffer', {
		offersWidgets: {},
		// _loaded: false,
		_actionsHistory: [],
		_actions: [],

		configure: function () {
			this.registerOptions('', {
				widgets: {
					// offerApi: {
					// 	widget: 'UserOfferApi'
					// }
					loadOffersDl: {
						widget: 'Datalayer',
						method: 'offer.loadOffers',
						fields: [
							'id', 'type', 'state', 'settings()', 'expireDate', 'siteId',
							'offerId.id', 'offerId.type',
							'userOffer.id', 'userOffer.state', 'userOffer.context', 'userOffer.expireDate', 'userOffer.userId'
						]
					},
					sendOfferActionApi: {
						widget: 'Api',
						method: 'offer.checkAction'
					},
					reloadOfferApi: {
						widget: 'Api',
						method: 'offer.getUserOffer'
					},
					updateOfferApi: {
						widget: 'Api',
						method: 'offer.update'
					}
				},
				handleWom: {
					loadOffers: {
						widget: '#loadOffersDl',
						event: ['loaded'],
						callback: 'prepareOffers'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			fox.UserOffer || Object.defineProperty(fox, 'UserOffer', {
				get: function() {return fox.site.rwom1('.UserOffer');}
			});

			this.callParent('init', arguments);
		},

		loadOffers: function () {
			this.loadOffersDl.load();
		},

		running: function () {
			this.loadOffersDl = this.rwom1('#loadOffersDl');
			this.reloadOfferApi = this.rwom1('#reloadOfferApi');
			this.sendOfferActionApi = this.rwom1('#sendOfferActionApi');
			this.updateOfferApi = this.rwom1('#updateOfferApi');

			if (fox.site.member) {
				this.loadOffers();
			}

			this.callParent('running', arguments);
		},

		prepareOffers: function (obj, offersDl) {
			if (!offersDl.isLoaded()) {
				return false;
			}

			var offer, actions;
			while (offer = offersDl.iterateObject('offers')) {
				var offerAlias = offer.get('offerId.alias');
				var offerSettings = offer.get('settings()');
				var offerWidget = this.embedWidget(offerAlias, offerSettings.widget.name, {offerSettings: offerSettings});

				if (offerWidget) {
					offerWidget.prepare(this, offer);
					this.offersWidgets[offerAlias] = offerWidget;

					if (actions = offerWidget.getActions()) {
						// this._actions = fox._.union(this._actions, offerSettings.actions);
						this._actions = fox.merge(this._actions, actions);
					}
				} else {
					this.log('UserOffer embeding offer failed: ' + offerSettings.widget.name, {
						section: 'UserOffer',
						action: 'prepareOffers',
						widgetName: offerSettings.widget.name,
						userId: fox.site.member.getObjectValue('id'),
						offerAlias: offerAlias,
						offerId: offer.get('offerId.id'),
						offerSiteId: offer.get('id')
					});
				}
			}

			this.checkAction('offersPrepared');

			this.callActionsFromHistory();
		},

		callActionsFromHistory: function () {
			if (this._actionsHistory.length > 0) {
				for (var i = 0; i < this._actionsHistory.length; i++) {
					var history = this._actionsHistory[i];
					delete this._actionsHistory[i];
					this.checkAction(history.action, history.options);
				}
			}
		},

		checkAction: function (action, options) {
			if (!this.loadOffersDl.isLoaded()) {
				this._actionsHistory.push({action: action, options: options});
				return true;
			}

			if (this._actions.indexOf(action) === -1) {
				return false;
			}

			this.log('UserOffer dispatch event: ' + action, {
				section: 'UserOffer',
				action: 'checkAction',
				actionName: action,
				userId: fox.site.member.getObjectValue('id')
			});
			this.dispatchEvent(action, options);

			return true;
		},

		sendOfferAction: function (action, offerAlias, params, callback) {
			this.sendOfferActionApi.send({
				action: action,
				offerAlias: offerAlias,
				params: params
			});

			if (callback) {
				this.waitEvent(this.sendOfferActionApi, ['failure', 'ready'], callback, {});
			}
		},

		getOfferAction: function (action, offerAlias) {
			return this.sendOfferActionApi.prepareAddressAndParams({
				action: action,
				alias: offerAlias
			});
		},

		updateOffer: function (action, offerAlias, values, withoutSave) {
			if (!withoutSave) {
				this.updateOfferApi.send({
					action: action,
					alias: offerAlias,
					values: values
				});
			}
		},

		reloadOffer: function (offerAlias, callback) {
			this.reloadOfferApi.send({
				alias: offerAlias
			});

			if (callback) {
				this.waitEvent(this.reloadOfferApi, ['failure', 'ready'], callback, {});
			}
		},

		log: function (text, tags) {
			fox.callApi('offer.logger', {
				text: text,
				tags: tags
			});
		}
	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, jQuery) {
	"use strict";

	fox.registerWidget('UserOfferAcp', {
		_acpAuthUrl: '/api.php?_method=Offer_Acp.RedirectAuth&redirect=1&alias=',
		_menuItemTemplate: 'main_menu_item_freeAcpAuth',

		configure: function (options) {
			this._acpAuthUrl += this.alias;
			this.menuPattern = {
				title: 'Bonus videos',
				url: this._acpAuthUrl,
				target: '_blank',
				position: 4.5 // add item after tab "Videos",
			};
			if (fox.checkTemplate(this._menuItemTemplate)) {
				this.menuPattern.template = this._menuItemTemplate;
			}

			this.registerOptions('', {
				widgets: {
					preCancelOverlay: {
						widget: 'Widget',
						autoRender: false,
						embed: {
							widget: '@root',
							location: 'lastChild',
							container: 'body'
						},
						template: options.offerSettings.widget.template || 'offer_overlay_freeacp_precancel',
						templateOptions: options.offerSettings.widget.templateOptions || {},

						handleDom: {
							confirmPreCancelOffer: {
								target: '.submit-btn',
								event: 'click',
								callback: fox.bind(this.confirmPreCancelOffer, this)
							},
							declinePreCancelOffer: {
								target: '.cancellation-exit',
								event: 'click',
								callback: fox.bind(this.declinePreCancelOffer, this)
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		prepare: function () {
			this.callParent('prepare', arguments);
			this.preCancelOverlay = this.rwom1('#preCancelOverlay');

			var apiAddress = this.getAction('confirmPreCancel');
			this.preCancelOverlay.setTemplateOptions('confirmApiAddress', apiAddress.address);
			this.preCancelOverlay.render();
		},

		actionPreCancel: function () {
			if (fox.site.member.getObjectValue('manual')) {
				// don't show offer to manual user
				return false;
			}

			var offerState = this._offer.get('userOffer.state');
			if (offerState === this.const.STATE_ACTIVE) {
				//TODO: we have no design for this
				return false;//this.showCancelAlert();
			}

			if (offerState === false || offerState !== this.const.STATE_ACTIVE) {
				this.updateState('new');
				this.log('UserOfferAcp shows offer popup', {
					section: 'UserOfferAcp',
					action: 'actionPreCancel'
				});
				this.showOverlay();
			}
		},

		actionUserCanceled: function () {
			this.updateState('suspended');
			this.removeAuthLink();
		},

		actionUserRenewed: function () {
			this.reload(fox.bind(function (data, w, e) {
				if (e === 'ready' && this._offer.get('userOffer.state') === this.const.STATE_ACTIVE) {
					this.addAuthLink();
				}
			}, this));
		},

		actionTrialToFull: function () {//TODO
			if (this._offer.get('userOffer.state') === this.const.STATE_ACTIVE) {
				// do not show offer if it's already active
				return false;
			}
			// check if user is trial then show popup or add menu
		},

		actionOffersPrepared: function () {
			if (this._offer.get('userOffer.state') === this.const.STATE_ACTIVE) {
				this.addAuthLink();

				return true;
			}

			// if (this._offer.get('userOffer.context.trialDeclined')) {//TODO: if offer was declined then add menu item without popup. did not checked!
			// 	this.addOfferToMenu();
			// 	return true;
			// }
		},

		showCancelAlert: function () {//TODO
			// if offer is active show alert message, else offer will be prompted
			// this.rwom1('#cancelWarningPopup').show();
		},

		confirmPreCancelOffer: function () {
			this.updateState('confirmed', true);
			this.updateState('active', true);
			this.hideOverlay();

			this.addAuthLink();

			fox.site.gotoPage('home');

			return true;
			/*this.sendAction('confirmPreCancel', {}, fox.bind(function (data, w, e) {
				document.location.href = this._acpAuthUrl;
				return true;
				if (e === 'failure') {//TODO
					console.log('UserOfferAcp: something wrong', data);
				}

				this.updateState('active', false);
				this.hideOverlay();

				this.addAuthLink();

				fox.site.gotoPage('home');
				this.openAuthLink();
			}, this));*/
		},

		declinePreCancelOffer: function () {
			// this.updateState('declined'); // we don't need to decline offer for this type, 'cause we will ask user each time when he wants make cancel
			this.log('UserOfferAcp offer declined by user', {
				section: 'UserOfferAcp',
				action: 'declinePreCancelOffer'
			});
			this.hideOverlay();
		},

		declineTrialOffer: function () {//TODO
			this.updateContext({trialDeclined: true});//or something like that

			this.addOfferToMenu();
		},

		declineExistsOffer: function () {//TODO
			// update offer if need
			this.rwom1('#cancelWarningPopup').hide();
		},

		saveExistsOffer: function () {//TODO
			this.rwom1('#cancelWarningPopup').hide();
			fox.site.gotoPage('home');
		},

		openAuthLink: function () {
			// window.open(this._acpAuthUrl, '_blank');
		},

		addAuthLink: function() {
			fox.setEnv('offer.freeAcpAuth.url', this._acpAuthUrl);
			var menuControllers = fox.wom.select('~.Menu_Main');//there is 2 menu controllers. 1st for desktop, 2nd for mobile
			fox.each(menuControllers, function (menuCtrl) {
				menuCtrl.addMenuItem('freeAcpAuth', this.menuPattern);
				// add on click action!
				// icon added as class: <i class="ico icon-au_m_$[alias]"></i>
			}, this);
		},

		removeAuthLink: function() {
			var menuControllers = fox.wom.select('~.Menu_Main');//there is 2 menu controllers. 1st for desktop, 2nd for mobile
			fox.each(menuControllers, function (menuCtrl) {
				menuCtrl.dropMenuItem('freeAcpAuth');
			}, this);
		},

		addOfferToMenu: function() {
			console.log('UserOfferAcp: add offer to menu');
		},

		showOverlay: function() {
			if (!this.preCancelOverlay.element) {
				this.handleEvent(this.preCancelOverlay, 'addedToDom', fox.bind(this.showOverlay, this));
				return false;
			}
			jQuery(this.preCancelOverlay.element).show();
			jQuery('html').css('overflow', 'hidden');
		},

		hideOverlay: function() {
			jQuery(this.preCancelOverlay.element).hide();
			jQuery('html').css('overflow', '');
		}
	}, 'UserOfferBase');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";
	fox.registerWidget('UserOfferBase', {
		const: {// don't forget about object Offer when change states
			STATE_NEW: 1,
			STATE_CONFIRMED: 2,
			STATE_ACTIVE: 3,
			STATE_DECLINED: 4,
			STATE_EXPIRED: 5,
			STATE_SUSPENDED: 6
		},
		_offer: {}, /* DataObject Offer_Site */
		_actions: [],
		_controller: false,

		prepare: function (controller, offer) {
			this._controller = controller;
			this.setOffer(offer);

			this.handleActions();
			this.run();
		},

		handleActions: function () {
			var offerSettings = this._offer.get('settings()');
			if (fox.isSet(offerSettings.actions)) {
				fox.each(offerSettings.actions, function (action) {
					this.addHandler(action);
				}, this);
			}

			this.addHandler('offersPrepared');
		},

		addHandler: function (action) {
			this._actions.push(action);
			this.handleEvent('@parent', action, 'callAction', {
				listenHistory: true
			});
		},

		callAction: function (options, w, e) {
			var method = 'action' + fox.ucfirst(e);
			if (typeof this[method] === 'function') {
				this[method](options);
			} else {
				throw 'Handled action: ' + method + ' does not exists in offer: ' + this.alias;
			}
		},

		getActions: function () {
			return this._actions;
		},

		setOffer: function(offer) {
			this._offer = offer;
		},

		getUserOffer: function () {
			return this._offer.getRelatedObject('userOffer');
		},

		_createUserOffer: function () {
			var userOfferDl = this._offer.relation('userOffer');
			userOfferDl.addObject({
				state: this.const.STATE_NEW,
				userId: fox.site.member.getObjectValue('id'),
				offerSiteId: this._offer.get('id')
			});

			return userOfferDl.getObject();
		},

		reload: function (callback) {
			this._controller.reloadOffer(this.alias, fox.bind(function (data, w, e) {
				if (e === 'ready') {
					var userOffer = this.getUserOffer();
					fox.each(data, function (v, k) {
						userOffer.set(k, v);
					}, this);
				}

				callback(data, w, e);
			}, this));
		},

		update: function (action, values, withoutSave) {// create different methods to update state if needed, i.e declineOffer, approveOffer etc.
			if (!values) {
				values = {};
			}

			var userOffer = this.getUserOffer();

			if (!userOffer) {
				userOffer = this._createUserOffer();
			}

			if (!fox.isEmpty(values)) {
				fox.each(values, function (v, k) {
					userOffer.set(k, v);
				}, this);
			}

			this._controller.updateOffer(action, this.alias, values, withoutSave);
		},

		updateState: function (state, withoutSave) {
			switch (state) {
				case 'new':
					this.update('new', {}, withoutSave);
				break;
				case 'confirmed':
					this.update('state', {state: this.const.STATE_CONFIRMED}, withoutSave);
				break;
				case 'active':
					this.update('state', {state: this.const.STATE_ACTIVE}, withoutSave);
				break;
				case 'suspended':
					this.update('state', {state: this.const.STATE_SUSPENDED}, withoutSave);
				break;
			}
		},

		updateContext: function (values) {
			this.update('context', {
				context: values
			});
		},

		sendAction: function (action, params, callback) {
			this._controller.sendOfferAction(action, this.alias, params, callback);
		},

		getAction: function (action) {
			return this._controller.getOfferAction(action, this.alias);
		},

		actionOffersPrepared: function () {
			//abstract
		},

		log: function (text, tags) {
			var userOffer = this.getUserOffer();
			tags = fox.merge({
				siteId: this._offer.get('siteId') || fox.site.dl.getObjectValue('id'),
				userId: userOffer.get('userId') || fox.site.member.getObjectValue('id'),
				offerId: this._offer.get('offerId.id'),
				offerSiteId: this._offer.get('id')
			}, tags);

			if (userOffer.get('id')) {
				tags.offerUserId = userOffer.get('id');
			}

			this._controller.log(text, tags);
		}

	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";
	fox.registerWidget('UserOfferModelRelated', {
		_offerListAlias: 'offerModelRelated',

		configure: function (options) {
			this.registerOptions('', {
				widgets: {
					purchaseApi: {
						widget: 'Api',
						method: 'Offer_ModelRelated.purchaseOffer'
					},
					infoPopup: {
						widget: 'Popup_Common',
						'dialog.width': '94%',
						additionalClasses: 'offermodel-popup',
						'widgets.content.template': 'offer_modelrelated_success_popup'
					},
					newLoginPopup: {
						widget: 'Popup_Common',
						'dialog.width': '94%',
						additionalClasses: 'offermodel-popup',
						widgets: {
							content: {
								widget: 'UserOfferNewLogin',
								template: 'offer_modelrelated_newlogin_popup'
							}
						}
					}
				},
				handleWom: {
					purchaseSuccess: {
						widget: '#purchaseApi',
						event: 'ready',
						callback: fox.bind(this.offerPurchased, this)
					},
					purchaseError: {
						widget: '#purchaseApi',
						event: 'failure',
						callback: fox.bind(this.offerError, this)
					}
				}
			});
			this.callParent('configure', arguments);
		},

		_getAccountPage: function () {
			var accountWidget = fox.wom.selectFirst('#home #account');
			if (!accountWidget) {
				this.log('UserOfferModelRelated: account page does not exists', {
					section: 'UserOfferModelRelated',
					action: 'addOfferToUserSettings'
				});
				return false;
			}

			return accountWidget;
		},

		actionAfterCancel: function (params) {
			if (fox.getEnv('user.canceled') !== 1) {// User_Cancel::STATUS_SUCCESS
				return true;
			}

			this.updateState('new');

			this.addOfferToUserSettings();
			this.dispatchUpdated();

			fox.Router.addRoute('after-cancel', '#home #afterCancel');
			fox.site.gotoPage('after-cancel');
		},

		actionUserRenewed: function () {
			var accountWidget = this._getAccountPage();
			var list = accountWidget.wom1('#' + this._offerListAlias);
			if (list) {
				list.removeSelf();
			}
		},

		actionOffersPrepared: function () {
			if (fox.getEnv('user.canceled') !== 1) {// User_Cancel::STATUS_SUCCESS
				return true;
			}

			var offerState = this._offer.get('userOffer.state');
			if (offerState === false || offerState === this.const.STATE_NEW || offerState === this.const.STATE_ACTIVE) {
				this.addOfferToUserSettings();
				this.dispatchUpdated();
				return true;
			}
		},

		addOfferToUserSettings: function () {
			var accountWidget = this._getAccountPage();

			if (!accountWidget.wom1('#' + this._offerListAlias)) {
				var listWidget = accountWidget.embedWidget(this._offerListAlias, 'UserOfferModelRelated_List');
				if (listWidget && accountWidget.isActive()) {
					listWidget.run();
				}
			}
		},

		dispatchUpdated: function () {
			this._controller.dispatchEvent('modelRelatedUpdated', this.alias);
		},

		actionPurchaseOffer: function (params) {
			var apiArgs = {
				offerAlias: this.alias,
				clientId: params.clientId
			};

			if (fox.isSet(params.login)) {
				apiArgs.login = params.login;
			}

			var api = this.rwom1('#purchaseApi');
			api.send(apiArgs);
		},

		offerPurchased: function (data) {
			this._controller.dispatchEvent('purchaseEventDone');
			
			if (data === true) {
				return true; //show successful popup or anything else
			}

			if (typeof data === 'string') {
				this.log('UserOfferModelRelated: redirect to: ' + data, {
					section: 'UserOfferModelRelated',
					action: 'offerPurchased'
				});
				window.location.href = data;
				return true;
			}
		},

		offerError: function (response) {
			var data = response.answer.data;
			this._controller.dispatchEvent('purchaseEventDone');

			if (data && data.checkingStatus === false) {
				if (data.email && data.email === false) {
					this.showInfoPopup({
						title: 'An account with this email already exists',
						text: 'If you forgot your password please <a href="http://' + data.domain + '/password-recovery">click here</a>'
					});
					return false;
				} else if (data.login === false) {
					this.wom1('#newLoginPopup #content').setOption('clientId', data.clientId);
					this.wom1('#newLoginPopup').show();
					return false;
				}
			}

			this.showInfoPopup(response.answer.reason);
			return false;
		},

		showInfoPopup: function(data) {
			if (!data) {
				return;
			}

			if (fox.isString(data)) {
				data = {
					title: 'Information',
					text: data
				};
			}

			var
				popup = this.wom1('#infoPopup'),
				content = popup.wom1('#content');

			content.setTemplateOptions({
				title: data.title || 'undefined',
				text: data.text || 'undefined'
			});

			content.render();
			popup.show();
		}
	}, 'UserOfferBase');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	"use strict";

	fox.registerWidget('UserOfferModelRelated_List', {
		offerAlias:'',

		configure: function (options) {
			this.registerOptions('', {
				autoRender: true,
				template: 'relatedModelsOffer',
				'embed.container': '#related-models-offer',
				containerOffers: '#list-items',
				widgets: {
					modelsDl: {
						widget: 'Datalayer',
						method: 'Offer_ModelRelated.list'
					},
					list: {
						widget: 'Grid_List',
						container: '#list-items',
						tpl: {
							row: 'relatedModelsOffer_item',
							emptyRow: 'relatedModelsOffer_item_empty'
						},
						externalLoad: true,
						dataLayer: '@parent #modelsDl',
						'hooks.onAddedToDom': fox.bind(this.createGalleries, this)
					}
				},
				handleWom: {
					modelRelatedUpdated: {
						widget: fox.UserOffer,
						event: 'modelRelatedUpdated',
						params: {
							listenHistory: true
						},
						callback: fox.bind(this.updateList, this)
					},
					purchaseEventDone: {
						widget: fox.UserOffer,
						event: 'purchaseEventDone',
						params: {
							listenHistory: true
						},
						callback: fox.bind(function() {
							this.waitPurchaseEvent = false;
							var but = this.dom('#list-items .btn-join.spin');
							fox.dom.removeClass('spin', but);
						}, this)
					},
					modelsDlLoaded: {
						widget: '#modelsDl',
						event: 'loaded',
						callback: 'setMinDiscount'
					}
				},
				handleDom: {
					purchase: {
						targetWidget: '#list',
						target: '.btn-join',
						event: 'click',
						eventChecker: fox.bind(function (event) {
							return !fox.dom.hasClass('disabled', event.currentTarget) && !this.waitPurchaseEvent;
						}, this),
						callback: fox.bind(this.purchaseEvent, this)
					},
					imgErrorLoad: {
						targetWidget: '#list',
						event: 'error',
						target: '.avatar',
						callback: function(elem) {
							$(elem).remove();
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		// when subscription renewed and you move to other page and back to account, offer should be blocked
		activate: function() {
			this.wait('addedToDom').then(function() {
				this.renderMinDiscount();
			}.bind(this));
			
			this.callParent('activate', arguments);
		},

		deactivate: function () {
			if (this.container.hasClass('slick-initialized')) {
				this.container.slick('unslick');
			}

			this.callParent('deactivate', arguments);
		},

		running: function () {
			this.callParent('running', arguments);
			this.list = this.wom1('#list');
			this.dl = this.rwom1('#modelsDl');
		},

		updateList: function (data) {
			this.dl.setTransitParameter('offerAlias', data);
			this.dl.load();
		},

		purchaseEvent: function (el) {
			fox.UserOffer.checkAction('purchaseOffer', {clientId: el.getAttribute('data-id')});
			this.waitPurchaseEvent = true;
			fox.dom.addClass('spin', el);
		},

		createGalleries: function() {
			this.container = $(this.element).find(this.getOption('containerOffers'));
			var containerAlias = this.getOption('embed.container');

			var initSlick = function() {
				this.container.slick({
					infinite: false,
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: false,
					centerPadding:0,
					dots: false,
					prevArrow: containerAlias + ' .arrow-prev',
					nextArrow: containerAlias + ' .arrow-next',
					responsive: [
						{
							breakpoint: 960,
							settings: {
								slidesToShow: 3
							}
						},
						{
							breakpoint: 860,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 640,
							settings: {
								slidesToShow: 1
							}
						}
					]
				});

				this.container.slick('setPosition', 0);
			};

			if (this.container.hasClass('slick-initialized') && /* fix double addedToDom issue */
				!this.container.find('.slick-list').length) {
				this.container.removeClass('slick-initialized slick-slider');
			}

			initSlick.call(this);
		},

		renderMinDiscount: function() {
			this.dom1('#discount').innerHTML = (this.minDiscount || '20') + '%';
		},

		setMinDiscount: function(obj, dl) {
			this.minDiscount = dl.getMetaValue('minDiscount');
			this.renderMinDiscount();

		}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_2257', { 

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) {
	fox.registerWidget('SitePage_404', {

		// running: function() {
		// 	// this.handleEvent(, 'addedToDom', fox.bind(function() {
		// 		$('p.p3').text('The requested URL ' + location.hash + ' was not found on this server.');	
		// 	// }, this));
		// }
	
	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('SitePage_About', {

		init: function() {

			this.embedWidget('twitter', 'Twitter', {
				container: '#twits',
				rpp: 3,
				tpl: {
					row: 'li{if $[_last]}.last{/if}>((span.name>a[href="http://twitter.com/$[authorScreenName]" target="_blank" rel="nofollow"]{$[authorName]: })+span{$[postText]})',
					rowBottom: 'a.view[href="http://twitter.com/$[authorScreenName]" target="_blank" rel="nofollow"]{view more}'
				}
			});

			return this.callParent('init', arguments);
		},

		running: function() {
			this.twitter = this.requireEmbeddedWidget('twitter');
			this.twitter.dl.load();

			this.callParent('running', arguments);
		},


	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Dvd1 SitePage Search */

(function(fox) {
	fox.registerWidget('SitePage_Join', {
		
	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('SitePage_Liveshow', {}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('SitePage_Login', {}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_Privacy', {

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Dvd1 SitePage Search */

(function(fox) {
	fox.registerWidget('SitePage_Splash', {
		
		configure: function(options) {
			this.registerOptions('', {
				'handleDom.enterSite': {
					event: 'click',
					target: '.enter',
					callback: this.enterSite
				}
			});

			this.callParent('configure', arguments);
		},

		enterSite: function(){
			var retUrl = fox.Navigator.get(0);
			fox.cookie.set('splash', 1);
			fox.site.showSplash = false;
			fox.site.runPage(retUrl !== 'splash' ? retUrl : 'home', {skipEvent: true});
		}

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {

	fox.registerWidget('SitePage_Tips', {

		configure: function (options) {
			this.registerOptions('', {
				widgets: {
					tips: {
						widget: 'Tips_Form',
						autoApply: true,
						container: '.tips-block',
						template: 'sitepage_tips_form',
						widgets: {
							form: {
								formContainer: '.tips-block',
								submit: {
									target: '#tipsSubmit',
									event: 'click'
								}
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'Site_Page')

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	
	fox.registerWidget('User_FavoriteAmc', {
		redrawFavorites: function(data)
		{
			this.isFavorite = data.response.success.isFavorite;

			if (this.isFavorite == 1) {
				fox.dom.selectFirst(this.options.showTarget, this.element).classList.add(this.options.showActive);
			} else {
				fox.dom.selectFirst(this.options.showTarget, this.element).classList.remove(this.options.showActive);
			}
		}
		
	}, 'User_Favorite');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	
	fox.registerWidget('User_ForgotPassword', {

		configure: function(options) {
			options.formElement = '#forgot_form';
			options.dataLayer || (options.dataLayer = {});
			options.dlClass = 'User_ForgotPassword';
			this.callParent('configure', arguments);
		},

		rendering: function() {
			this.addHandler('formSubmit', this.options.formElement, 'submit', fox.bind(this.submit, this));
		},

		submit: function(){
			
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('User_PasswordRecovery_Base', {

		configure: function(options) {

			this.registerOptions('', {
				errorContainer: '#recovery-message',
				handleWom: {
					submit: {
						widget: '#form',
						event: 'submit',
						callback: 'submit'
					}
				},
				handleDom: {
					focus: {
						event: 'focus',
						target: 'input',
						callback: function(elm) {
							this.toggleInputErrorState(false, elm.name);
						}.bind(this)
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.callParent('running', arguments);

			this._inProgress = false;
		},

		formInvalidate: function(infos, form, ev) {
			infos.forEach(function(err) {
				this.toggleInputErrorState((err.result === false), err.field, err.message);
			}.bind(this));
		},

		toggleInputErrorState: function(state, field, msg) {
			var inp = this.dom1('[name="' + field + '"]');

			fox.dom[(state === true ? 'addClass' : 'removeClass')]('error', inp.parentNode);
			this.toggleErrorBlock(state, msg, inp);
		},

		toggleErrorBlock: function(state, msg, inp) {
			var elm = !!inp ? inp.parentNode.nextElementSibling : this.dom1(this.getOption('errorContainer'));
			if (state === false) {
				elm.innerHTML = '';

				return;
			}

			elm.innerHTML = msg;
		},

		toggleLoader: function(state) {
			var button = this.dom1('#submit-btn');
			var loader = this.dom1('#submit-btn .small-loader');

			if (!button || !loader) {
				return;
			}

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', button);
			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', loader);
		},

		handleError: function(resp) {
			this._inProgress = false;

			this.toggleErrorBlock(true, resp.params.answer.reason);
			this.toggleLoader(false);
		},

		handleResponse: function(resp) {
			this._inProgress = false;

			this.toggleErrorBlock(false);
			this.toggleLoader(false);
		},

		submit: function(data) {
			if (this._inProgress === true) {
				return false;
			}

			return true;
		}


	}, 'Widget');
})(fox);


 /* fox-dynamic-injection */ 
};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	var _ = {
		baseValidator: [
			{ validator: 'length', options: { min: 6 }, message: 'Password must contain at least six characters.' },
			{ validator: 'regexp', options: { regexp: /^[^\s].+/ }, message: 'The password can not contain spaces.' }
		]
	};

	fox.registerWidget('User_PasswordRecovery_Confirmation', {
		configure: function(options) {
			this.registerOptions('', {
				template: 'user_passwordrecovery_confirmation',
				manualRender: true,
				successfulAction: false,
				widgets: {
					confirmApi: {
						widget: 'Api',
						method: 'passwordRecovery.changePassword'
					},
					checkHashApi: {
						widget: 'Api',
						method: 'passwordRecovery.validateHash'
					},
					successPopup: {
						widget: 'Popup_Common',
						'widgets.content': {
							template: 'popup_user_passwordChangeSuccess',
							handleDom: {
								close: {
									target: '.close',
									event: 'click',
									callback: function () {
										fox.Navigator.update({ 0: 'home' }, true);
										window.location.reload();
									}
								}
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		activate: function() {
			this.checkHash();
			this.callParent('activate', arguments);
		},

		checkHash: function() {
			var hash = fox.Navigator.get(1);

			this.wom1('#checkHashApi')
				.psend({hash: hash})
				.then(function(resp) {
					var success = fox.objectGet(resp, 'params.answer.response.success');

					if (!success) {
						this.switchState('error');
						return;
					}
					this.hash = hash;
					this.switchState('form');
				}.bind(this))
				.catch(function(resp) {
					this.switchState('error');
				}.bind(this));
		},

		submit: function() {
			if (!this.callParent('submit', arguments)) {
				return false;
			}

			this._inProgress = true;
			this.toggleLoader(true);

			this.wom1('#confirmApi')
				.psend(fox.merge(this.wom1('#form').getValues(), {hash: this.hash}))
				.then(this.handleResponse.bind(this))
				.catch(this.handleError.bind(this));
		},

		compareValues: function(val) {
			var pass = this.dom1('[name="password"]').value;

			return {
				result: pass === val,
				field: 'confirm',
				message: 'The password do not match.'
			};
		},

		handleResponse: function(resp) {
			this.callParent('handleResponse', arguments);

			if (!this.getOption('successfulAction')) {
				this.rwom1('#successPopup').show();
			} else {
				var successPage = this.getOption('successfulAction');
				successPage(this);
			}
		},

		switchState: function(alias) {
			this.setTemplateOptions('isError', (alias === 'error'));

			if (alias === 'form') {
				this.embedWidget('form', 'DomForm', {
					widget: 'DomForm',
					formSelector: '#confirmation-form',
					elements: {
						password: {
							validators: _.baseValidator
						},
						confirm: {
							validators: _.baseValidator.concat(this.compareValues.bind(this))
						}
					},
					'handleWom.formValid': {
						widget: '@this',
						event: ['form_valid', 'form_not_valid'],
						callback: '@parent:formInvalidate'
					},
					'handleDom.submit': {
						event: 'submit',
						target: '#confirmation-form'
					}
				}).run();
			}

			this.render();

		}


	}, 'User_PasswordRecovery_Base');
})(fox);


 /* fox-dynamic-injection */ 
};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('User_PasswordRecovery_Email', {

		configure: function(options) {

			this.registerOptions('', {
				errorContainer: '#recovery-message',
				template: 'user_passwordrecovery_email',
				successfulAction: false,
				widgets: {
					recoveryApi: {
						widget: 'Api',
						method: 'passwordRecovery.sendRecoveryMail'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#email-form',
						elements: {
							email: {
								validators: [
									{ validator: 'regexp', options: { type: 'email' }, message: 'Email address is invalid' }
								]
							}
						},
						'handleDom.submit': {
							event: 'submit',
							target: '#email-form'
						},
						'handleWom.formValid': {
							widget: '@this',
							event: ['form_valid', 'form_not_valid'],
							callback: '@parent:formInvalidate'
						}
					},
					successPopup: {
						widget: 'Popup_Common',
						'widgets.content.template': 'popup_user_passwordRecoverySuccess'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		submit: function(data) {

			if (!this.callParent('submit', arguments)) {
				return false;
			}

			this._inProgress = true;
			
			this.toggleLoader(true);
			this.recover(data);
		},

		handleResponse: function(resp) {
			this.callParent('handleResponse', arguments);

			if (!this.getOption('successfulAction')){
				this.rwom1('#successPopup').show();
			} else {
				var successPage = this.getOption('successfulAction');
				successPage(this);
			}
			
		},

		recover: function(data) {
			this.wom1('#recoveryApi')
				.psend(data)
				.then(this.handleResponse.bind(this))
				.catch(this.handleError.bind(this));
		}

	}, 'User_PasswordRecovery_Base');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('User_PasswordRecovery', {

		configure: function(options) {

			this.registerOptions('', {
				widgets: {
					emailForm: {
						widget: 'User_PasswordRecovery_Email',
						errorContainer: '.errors-block',
						autoRender: true,
						container: '#password-recovery-form',
						active: false,
						group: 'form'
					},
					confirmationForm: {
						widget: 'User_PasswordRecovery_Confirmation',
						errorContainer: '.errors-block',
						autoRender: true,
						container: '#password-recovery-form',
						active: false,
						group: 'form'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.callParent('running', arguments);

			this.start();
		},

		deactivate: function(argument) {
			this.callParent('deactivate', arguments);

			this._reactivationPool = [];
		},

		activate: function(argument) {
			this.callParent('activate', arguments);

			this.start();
		},

		start: function() {
			var hash = fox.Navigator.get(1);

			if (!hash) {
				this.switchEmbeddedWidget('emailForm');

				return;
			}

			this.switchEmbeddedWidget('confirmationForm');
		}


	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}


	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(__webpack_require__(146));

	contexts.push(__webpack_require__(171));

	contexts.push(__webpack_require__(177));


	contexts.forEach(getDeps);
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./aff-colors.css": 147,
	"./affiliates.css": 149
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(148);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./aff-colors.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./aff-colors.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".aff-text-color-1{color:#8088d1}.aff-text-color-2{color:#feffff}.aff-text-color-3{color:#566a76}.aff-text-color-4{color:#822f35}.aff-back-color-1{background-color:#1e2127}.aff-back-color-2{background-color:#323c42}.aff-back-color-3{background-color:#1c1f24}.aff-back-color-4{background-color:#8088d1}.aff-back-color-5{background-color:#fff}.aff-back-color-6{background-color:#323c42}.aff-form-field::-webkit-input-placeholder{color:#566a76}.aff-form-field:-moz-placeholder,.aff-form-field::-moz-placeholder{color:#566a76}.aff-form-field:-ms-input-placeholder{color:#566a76}.aff-border-color-1{border:#8088d1!important}.aff-border-color-2{border:#323c42!important}", ""]);

// exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(150);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./affiliates.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./affiliates.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:Ostrich Sans;src:url(" + __webpack_require__(151) + ");src:local(\"\\263A\"),url(" + __webpack_require__(152) + ") format(\"woff\"),url(" + __webpack_require__(153) + ") format(\"truetype\"),url(" + __webpack_require__(154) + ") format(\"svg\");font-weight:900;font-style:normal}@font-face{font-family:Ostrich Sans;src:url(" + __webpack_require__(155) + ");src:local(\"\\263A\"),url(" + __webpack_require__(156) + ") format(\"woff\"),url(" + __webpack_require__(157) + ") format(\"truetype\"),url(" + __webpack_require__(158) + ") format(\"svg\");font-weight:700;font-style:normal}@font-face{font-family:roboto_condenseditalic;src:url(" + __webpack_require__(42) + ");src:url(" + __webpack_require__(42) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(159) + ") format(\"woff2\"),url(" + __webpack_require__(160) + ") format(\"woff\"),url(" + __webpack_require__(161) + ") format(\"truetype\"),url(" + __webpack_require__(162) + "#roboto_condenseditalic) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:roboto_condensedregular;src:url(" + __webpack_require__(43) + ");src:url(" + __webpack_require__(43) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(163) + ") format(\"woff2\"),url(" + __webpack_require__(164) + ") format(\"woff\"),url(" + __webpack_require__(165) + ") format(\"truetype\"),url(" + __webpack_require__(166) + "#roboto_condensedregular) format(\"svg\");font-weight:400;font-style:normal}button,input{outline:none}.clearfix:after{content:\"\";display:table;height:0;visibility:hidden;clear:both}.clearfix{position:relative}.fl{float:left}.fr{float:right}.uppercase{text-transform:uppercase}.no-margin{margin:0!important}.text-center{text-align:center}.text-right{text-align:right}.v-padd-20{padding:20px 0}.inlb{display:inline-block!important;vertical-align:top}.dbl{display:block!important}.wrapper[data-widget-class=Layout_Affiliate]{width:100%;background-color:#0c080c;font-family:roboto_condensedregular,sans-serif;line-height:normal;font-size:14px}.wrapper[data-widget-class=Layout_Affiliate],.wrapper[data-widget-class=Layout_Affiliate] *{box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;-ms-box-sizing:border-box}.wrapper[data-widget-class=Layout_Affiliate] .aff-wrap{position:relative;z-index:3;max-width:960px;margin:0 auto;box-shadow:0 -4px 30px 3px rgba(128,136,209,.26);-webkit-box-shadow:0 -4px 30px 3px rgba(128,136,209,.26);-moz-box-shadow:0 -4px 30px 3px rgba(128,136,209,.26);-ms-box-shadow:0 -4px 30px 3px rgba(128,136,209,.26)}.wrapper[data-widget-class=Layout_Affiliate] .aff-wrap .page-width{margin:0 4%;display:block!important}.wrapper[data-widget-class=Layout_Affiliate] a{text-decoration:none;cursor:pointer}.aff-form-field{display:inline-block;vertical-align:top;height:33px;padding:7px 12px;border-radius:1px;box-shadow:inset 0 1px 2px rgba(0,0,0,.5);border:1px solid #323c42;width:100%}.aff-form-btn,.aff-form-field{position:relative;font-size:12px;font-family:roboto_condensedregular,sans-serif}.aff-form-btn{height:31px;border-width:1px;border-style:solid;box-shadow:0 2px 1px rgba(0,0,0,.5);border-color:#959ce2 #8088d1 #8088d1;cursor:pointer;padding:0 16px}.aff-form-btn.big{font-size:18px;padding:8px 34px;height:auto}#aff-header .page-width{padding:40px 0 20px;display:block}#aff-header .login-form .form{margin-bottom:6px;overflow:hidden}#aff-header .login-form input{height:27px;line-height:12px}#aff-header .login-form .inlb.error label{display:block}#aff-header .login-form .inlb{margin-right:8px}#aff-header .login-form input[type=password],#aff-header .login-form input[type=text]{width:116px}#aff-header .login-form .forgot{float:right;font-size:11px;text-decoration:none}.logo-block{float:left;max-width:80%;display:flex}.logo-block .main-text{font-family:Ostrich Sans,Arial;font-size:59px;display:inline-block}.logo-block .right-text{display:inline-block;font-family:roboto_condenseditalic,sans-serif;line-height:21px;vertical-align:top;margin-left:20px}.logo-block .right-text span{display:block}.logo-block .right-text span:first-child{font-size:21px}.logo-block .right-text span:last-child{font-size:12px;border-bottom:2px solid}.aff-section-title{font-size:25px;display:inline-block;vertical-align:middle;margin-bottom:10px}.aff-section-title.middle{font-size:24px}.aff-section-title.small{font-size:18px;margin-bottom:5px}.aff-ref-prog{font-size:16px;padding-bottom:30px;margin-bottom:30px;border-bottom:2px solid}ul .dot{display:inline-block;vertical-align:middle;width:5px;height:5px;border-radius:50%;margin-right:10px}.aff-ref-prog li{line-height:30px}.section{position:relative;padding:40px 0}#aff-reg-block .section{display:-ms-flexbox;display:flex}#aff-reg-block .section .page-width{flex:1 0}#register{top:-5px}.aff-text{line-height:26px;font-size:16px;margin-bottom:30px}.aff-program-desc{width:80%;margin-left:18px}.aff-program-desc li>div{width:95%}.aff-program-desc .aff-text{margin-bottom:20px}#aff-footer{margin-top:40px}#aff-footer .page-width{border-top:2px solid;padding-bottom:40px}.aff-info-column{display:inline-block;vertical-align:top;width:100%}.aff-info-column .inlb{margin-right:10px;margin-bottom:10px;width:95%}#aff-bann{background-image:url(" + __webpack_require__(167) + ");background-repeat:no-repeat;background-size:cover;min-height:350px}.aff-bann-img{position:absolute;bottom:-4px;right:38px;z-index:3;max-height:260px;overflow:hidden;max-width:370px}#aff-fake-login{display:none}.bann-title{width:75%}.aff-select-wrapp{position:relative}.aff-select-wrapp .arrow{width:33px;height:100%;position:absolute;right:0;top:0;bottom:0;text-align:center}.aff-select-wrapp .arrow:after{content:\">\";font-size:20px;color:#fff;transform:rotate(90deg)}.aff-form-select,.aff-select-wrapp .arrow:after{position:absolute;width:100%;height:100%;top:0;left:0}.aff-form-select{-webkit-appearance:none;appearance:none;-moz-appearance:none;padding-right:10px;text-indent:.01px;text-overflow:\"\";border:none;right:0;bottom:0;padding:0 7px;font-size:12px;font-family:roboto_condensedregular,sans-serif;opacity:0;z-index:2}#aff-login-popup{width:244px;position:fixed;top:20%;left:50%;margin-left:-122px;z-index:30;padding:20px;display:none}#aff-login-popup .inlb{width:100%;margin-bottom:10px}.aff-overlay{background:rgba(30,33,39,.95);position:fixed;top:0;right:0;bottom:0;left:0;width:100%;height:100%;z-index:29;display:none}.aff-popup-bottom{padding:15px 0}.aff-popup-bottom a{line-height:28px}.visible{display:block!important}#aff-login-popup .icon-bold-close{position:absolute;right:10px;top:10px;cursor:pointer}#aff-methods-container .aff-form-field{width:95%}#aff-fake-scroll-to-login{display:none}.inlb.error .aff-form-field{background-color:rgba(130,47,53,.2);border-color:#822f35}.inlb label{display:none}.inlb.error label{display:inline;color:#822f35;font-size:12px}.aff-reg-ok-text p{width:40%;margin:0 auto}.aff-left-bg,.aff-right-bg{height:100%;width:60%;position:absolute;top:0;z-index:1}.aff-right-bg{background:url(" + __webpack_require__(168) + ") no-repeat 80px -15%;left:50%;width:50%}.aff-left-bg{background:url(" + __webpack_require__(169) + ") no-repeat 100% -15%;right:50%;margin-right:-47px}.checkbox-block{padding-bottom:20px}#aff-reg-block .inlb label{position:relative;display:block}#aff-reg-block .checkbox-agree{position:relative;display:inline-block;font-family:inherit;font-size:inherit;padding-left:35px;line-height:25px;text-align:left}#aff-reg-block .checkbox-agree input{position:absolute;left:-9999px}#aff-reg-block .checkbox-agree input+i{position:absolute;top:0;left:0;display:block;width:23px;height:23px;outline:0;border:1px solid transparent;background:#fff;border-radius:3px}#aff-reg-block .checkbox-agree input+i:after{content:\"\";position:absolute;top:-3px;left:2px;display:block;background-image:url(" + __webpack_require__(170) + ");width:26px;height:18px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:opacity .3s}#aff-reg-block .checkbox-agree input:checked+i:after{-ms-filter:none;filter:none;opacity:1}#aff-reg-block .checkbox-agree .error-icon{right:auto;left:5px;margin-top:-15px;background-color:transparent}#aff-reg-block .error-icon{top:50%;right:40px;position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;margin-top:0;transition:opacity .2s}#aff-reg-block .error-icon .error-container{position:absolute;width:135px;background-color:red;color:#fff;font-size:14px;line-height:14px;padding:6px 10px;bottom:100%;margin-bottom:12px;left:50%;margin-left:-68px;transition:transform .3s .1s;transform:scale(.9) translateY(20px);border-radius:2px}#aff-reg-block .error-icon .error-container:after{content:\"\";display:block;position:absolute;top:100%;width:0;height:0;border-style:solid;border-width:7px 5px 0;border-color:red transparent transparent;left:50%;margin-left:-5px}#aff-reg-block .error .error-icon,.checkbox.error .error-icon{-ms-filter:none;filter:none;opacity:1}#aff-reg-block .checkbox.error .error-icon .error-container,#aff-reg-block .input.error .error-icon .error-container{transform:scale(1) translateY(0)}@media only screen and (max-width:800px){.aff-bann-img{right:0}}@media only screen and (max-width:768px){.logo-block .main-text{font-size:30px}.login-form{display:none}#aff-fake-login{display:inline-block}.bann-title{width:65%}.aff-bann-img{width:40%;bottom:65px}.aff-info-column .inlb{width:95%}#aff-scroll-to-login{display:none}#aff-fake-scroll-to-login{display:inline}}@media only screen and (max-width:710px){.aff-bann-img{display:none}#aff-scroll-to-register{padding:5px 25px}}@media only screen and (max-width:640px){#aff-reg-block .section{flex-direction:column}}@media only screen and (max-width:500px){.bann-title{width:100%}#aff-scroll-to-register{float:none!important;margin:20px 0}.logo-block .right-text{margin-left:0;display:block}.logo-block .right-text span{width:20%}}@media only screen and (max-width:400px){#aff-fake-login{margin-top:-35px;margin-right:15px}.aff-info-column{display:block;width:100%}}.animated{animation-duration:1s;animation-fill-mode:both}.animated.hinge{animation-duration:2s}@keyframes bounce{0%,20%,50%,80%,to{transform:translateY(0)}40%{transform:translateY(-30px)}60%{transform:translateY(-15px)}}@keyframes bounceInDown{0%{opacity:0;transform:translateY(-2000px)}60%{opacity:1;transform:translateY(30px)}80%{transform:translateY(-10px)}to{transform:translateY(0)}}.bounceInDown{animation-name:bounceInDown}@keyframes bounceOutUp{0%{transform:translateY(0)}20%{opacity:1;transform:translateY(20px)}to{opacity:0;transform:translateY(-2000px)}}.bounceOutUp{animation-name:bounceOutUp}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}[data-scroll-to=\"#aff-reg-section\"]{cursor:pointer}.apa-title{width:100%;font-family:roboto_condensedregular;line-height:normal;font-size:14px;font-style:normal;text-align:left;color:#fff;text-transform:none;padding-left:20px;letter-spacing:inherit;font-weight:400}", ""]);

// exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/ostrich-sans-black.eot", __webpack_require__.p + "_/_/_/root/fonts/3EiCKp0.eot");

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/ostrich-sans-black.woff", __webpack_require__.p + "_/_/_/root/fonts/27jba7p.woff");

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/ostrich-sans-black.ttf", __webpack_require__.p + "_/_/_/root/fonts/3g5NlmQ.ttf");

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/ostrich-sans-black.svg", __webpack_require__.p + "_/_/_/root/fonts/ostrich-sans-black.svg");

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/ostrich-sans-bold.eot", __webpack_require__.p + "_/_/_/root/fonts/cKQa2rL.eot");

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/ostrich-sans-bold.woff", __webpack_require__.p + "_/_/_/root/fonts/1fNPEut.woff");

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/ostrich-sans-bold.ttf", __webpack_require__.p + "_/_/_/root/fonts/1S3bm0E.ttf");

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/ostrich-sans-bold.svg", __webpack_require__.p + "_/_/_/root/fonts/ostrich-sans-bold.svg");

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-italic-webfont.woff2", __webpack_require__.p + "_/_/_/root/fonts/3KWVfPf.woff2");

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-italic-webfont.woff", __webpack_require__.p + "_/_/_/root/fonts/3OTg3kp.woff");

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-italic-webfont.ttf", __webpack_require__.p + "_/_/_/root/fonts/knK-emu.ttf");

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-italic-webfont.svg", __webpack_require__.p + "_/_/_/root/fonts/robotocondensed-italic-webfont.svg");

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-regular-webfont.woff2", __webpack_require__.p + "_/_/_/root/fonts/35EcagY.woff2");

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-regular-webfont.woff", __webpack_require__.p + "_/_/_/root/fonts/3HyMK4N.woff");

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-regular-webfont.ttf", __webpack_require__.p + "_/_/_/root/fonts/YmeR37a.ttf");

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/robotocondensed-regular-webfont.svg", __webpack_require__.p + "_/_/_/root/fonts/robotocondensed-regular-webfont.svg");

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/layer.png", __webpack_require__.p + "_/_/_/affiliate/images/layer.png");

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/right.jpg", __webpack_require__.p + "_/_/_/affiliate/images/right.jpg");

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/left.jpg", __webpack_require__.p + "_/_/_/affiliate/images/left.jpg");

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/check_mark.png", __webpack_require__.p + "_/_/_/affiliate/images/check_mark.png");

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./layout/affiliate.tpl": 172,
	"./sitepage/affiliates.tpl": 173,
	"./sitepage/affiliates/templates.tpl": 175,
	"./sitepage/agreement.tpl": 176
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_affiliate", [["div",{"class":"aff-left-bg"}],["div",{"class":"aff-right-bg"}],["div",{"class":"aff-wrap aff-back-color-1"},[["div",{"id":"aff-header"},[["div",{"class":"page-width clearfix"},[["div",{"class":"logo-block"},[["div",{"data-fox-alias":"affHeaderLogo","class":"main-text aff-text-color-1"},[["textNode",{"text":" "}],["span",{},[],[["screenName","__text",true]]],["textNode",{"text":" "}]]],["div",{"class":"right-text"},[["span",{"class":"aff-text-color-2"},[["textNode",{"text":"Affiliate"}]]],["textNode",{"text":" "}],["span",{"class":"aff-text-color-1 aff-border-color-1"},[["textNode",{"text":"Program"}]]]]]]],["div",{"class":"login-form fr"},[["div",{"class":"form"},[["form",{"id":"login-form"},[["div",{"class":"inlb"},[["input",{"type":"text","name":"email1","class":"aff-form-field aff-text-color-3 aff-back-color-3 login-data","placeholder":"E-mail"}],["textNode",{"text":" "}],["label",{},[["textNode",{"text":"This field is required"}]]]]],["div",{"class":"inlb"},[["input",{"type":"password","name":"passwd1","class":"aff-form-field aff-text-color-3 aff-back-color-3 login-data","placeholder":"Password"}],["textNode",{"text":" "}],["label",{},[["textNode",{"text":"This field is required"}]]]]],["input",{"value":"Login","id":"aff-login","type":"submit","class":"aff-form-btn aff-text-color-2 aff-back-color-4"}]]]]],["a",{"class":"forgot aff-text-color-1"},[["textNode",{"text":"Forgot your password?"}]]]]],["button",{"id":"aff-fake-login","class":"fr aff-form-btn aff-text-color-2 aff-back-color-4"},[["textNode",{"text":"Login"}]]]]]]],["div",{"id":"aff-container"}],["div",{"id":"aff-footer"},[["div",{"class":"page-width clearfix v-padd-20 aff-border-color-2"},[["div",{"class":"fl"},[["div",{"data-fox-alias":"affFooter"},[["div",{"class":"aff-text-color-3"},[["textNode",{"text":" &copy;Copyright "}],["span",{},[],[["emptyVar","__text",true,[{"name":"formatCurrentDate","params":["%Y"]}]]]],["textNode",{"text":", all rights reserved "}]]],["div",{},[["a",{"target":"_blank","rel":"nofollow","href":"https://&&0&&","class":"aff-text-color-1"},[["span",{},[],[["site","__text",true]]]],[["site","href"]]]]]]]]],["div",{"class":"fr text-right"},[["div",{},[["a",{"class":"aff-text-color-1","href":"mailto:support@modelcentro.com"},[["textNode",{"text":"Technical Support"}]]]]],["div",{},[["span",{"class":"aff-text-color-3"},[["textNode",{"text":"Powered by"}]]],["textNode",{"text":" "}],["a",{"href":"https://modelcentro.com/","class":"aff-text-color-1"},[["textNode",{"text":"ModelCentro"}]]]]]]]]]]]]],["div",{"id":"aff-login-popup","class":"aff-back-color-2"},[["i",{"id":"aff-close-login-popup","class":"icon-bold-close aff-text-color-2"}],["div",{"id":"aff-popup-container"}]]],["div",{"class":"aff-overlay"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_affiliates", [["div",{"class":"aff-content"},[["div",{"id":"aff-bann","class":"aff-back-color-2 section"},[["div",{"class":"page-width clearfix"},[["div",{"data-fox-alias":"affHeaderTitle","class":"aff-section-title uppercase bann-title"},[["span",{"class":"aff-text-color-1","data-scroll-to":"#aff-reg-section","id":"aff-scroll-to-register_join"},[["textNode",{"text":" Join my "}]]],["textNode",{"text":" "}],["span",{"class":"aff-text-color-2"},[["textNode",{"text":" Official Affiliate Program Today! "}]]]]],["button",{"data-scroll-to":"#aff-reg-section","id":"aff-scroll-to-register","class":"fr big aff-back-color-4 aff-form-btn aff-text-color-2"},[["textNode",{"text":"Registration"}]]],["ul",{"class":"aff-ref-prog aff-border-color-1 aff-text-color-2"},[["li",{},[["span",{"class":"dot aff-back-color-4"}],["p",{"class":"inlb","data-fox-alias":"affHeaderProgrammProps1"},[["textNode",{"text":" Flexible programs - earn up to "}],["span",{},[],[["joinAmount","__text",true]]],["textNode",{"text":"% Lifetime Revenue Share! "}]]]]],["li",{},[["span",{"class":"dot aff-back-color-4"}],["p",{"class":"inlb","data-fox-alias":"affHeaderProgrammProps3"},[["textNode",{"text":" Flexible payout methods "}]]]]],["li",{},[["span",{"class":"dot aff-back-color-4"}],["p",{"class":"inlb","data-fox-alias":"affHeaderProgrammProps4"},[["textNode",{"text":" Exclusive Content and The Latest Promotional Tools "}]]]]]]],["div",{"data-fox-alias":"affHeaderBottomTitle","class":"no-margin aff-text-color-1 uppercase aff-section-title small"},[["textNode",{"text":"The hottest new site on the web!"}]]]]],["div",{"class":"aff-bann-img"},[["div",{"data-fox-alias":"affHeadImgSitePrev"},[["img",{"src":"" + __webpack_require__(174) + "","alt":""}]]]]]]],["div",{"class":"section"},[["div",{"class":"page-width"},[["div",{"data-fox-alias":"affAboutTitle","class":"aff-section-title uppercase"},[["span",{"class":"aff-text-color-2"},[["textNode",{"text":" About "}]]],["textNode",{"text":" "}],["span",{"class":"aff-text-color-1"},[["textNode",{"text":" "}],["span",{},[],[["screenName","__text",true]]],["textNode",{"text":" "}]]],["textNode",{"text":" "}],["span",{"class":"aff-text-color-2"},[["textNode",{"text":" Affiliate Program "}]]]]],["p",{"data-fox-alias":"affAboutText","class":"aff-text-color-3 aff-text"},[["textNode",{"text":" Welcome to the "}],["span",{},[],[["screenName","__text",true]]],["textNode",{"text":" Affiliate Program. Built exclusively for my solo site promotion, "}],["span",{},[],[["screenName","__text",true]]],["textNode",{"text":" Affiliate Program will allow you to easily monetize your niche and mainstream traffic and make more money online than any other adult affiliate programs. "}],["span",{},[],[["screenName","__text",true]]],["textNode",{"text":" Affiliate Program was developed and is supported by ModelCentro.com and thus you can be confident in security of your income. "}]]],["div",{"data-fox-alias":"affMyProgrammTitle","class":"aff-section-title uppercase"},[["span",{"class":"aff-text-color-2"},[["textNode",{"text":" My program "}]]]]],["p",{"data-fox-alias":"affMyProgrammText","class":"aff-text-color-3 aff-text"},[["textNode",{"text":" Why should you promote "}],["span",{},[],[["screenName","__text",true]]],["textNode",{"text":" instead of the thousands of other adult webmaster programs out there? It's very simple. My website contains thousands of photosets and videos exclusively produced for my members, frequent live shows, intimate blog, private messaging and is a spicy mix of amateur and professional content so many of my fans are eager about. "}]]],["ul",{"class":"aff-program-desc aff-text-color-2"},[["li",{},[["span",{"class":"dot aff-back-color-5"}],["div",{"data-fox-alias":"affProgramList1","class":"inlb"},[["div",{"class":"aff-section-title small"},[["textNode",{"text":" "}],["span",{},[],[["joinAmount","__text",true]]],["textNode",{"text":"% Lifetime RevShare "}]]],["p",{"class":"aff-text-color-3 aff-text"},[["textNode",{"text":" Get "}],["span",{},[],[["joinAmount","__text",true]]],["textNode",{"text":" of all initial sales and "}],["span",{},[],[["rebillAmount","__text",true]]],["textNode",{"text":" of all recurring billing for the lifetime of each membership you refer. Every time the customer rebills, you get "}],["span",{},[],[["rebillAmount","__text",true]]],["textNode",{"text":" of the sale! "}]]]]]]],["li",{},[["span",{"class":"dot aff-back-color-5"}],["div",{"data-fox-alias":"affProgramList2","class":"inlb"},[["div",{"class":"aff-section-title small"},[["textNode",{"text":" Exclusive Content and Marketing Tools "}]]],["p",{"class":"aff-text-color-3 aff-text"},[["textNode",{"text":" "}],["span",{},[],[["screenName","__text",true]]],["textNode",{"text":" affiliates get access to my unique marketing tools that convert surfers to paying customers. "}]]]]]]],["li",{},[["span",{"class":"dot aff-back-color-5"}],["div",{"data-fox-alias":"affProgramList3","class":"inlb"},[["div",{"class":"aff-section-title small"},[["textNode",{"text":" Personality + Interaction = Retention "}]]],["p",{"class":"aff-text-color-3 aff-text"},[["textNode",{"text":" "}],["span",{},[],[["screenName","__text",true]]],["textNode",{"text":" members love the direct interaction and naughty fun of weekly live shows, as well as chatting with via private messages, public comments, daily blogs, Twitter and various networking sites. "}]]]]]]],["li",{},[["span",{"class":"dot aff-back-color-5"}],["div",{"data-fox-alias":"affProgramList4","class":"inlb"},[["div",{"class":"aff-section-title small"},[["textNode",{"text":" In-time Payments and Tracking "}]]],["p",{"class":"aff-text-color-3 aff-text"},[["textNode",{"text":" Enjoy peace of mind knowing that all of your affiliate statistics and commissions are tracked and paid directly by ModelCentro, a trusted leader in adult industry since 1998. "}]]]]]]]]]]]]],["div",{"id":"aff-reg-section","class":"v-padd-20 aff-back-color-2 text-center"},[["div",{"class":"aff-section-title uppercase aff-text-color-2"},[["textNode",{"text":"Registration"}]]],["p",{"class":"aff-text-color-2"},[["textNode",{"text":" Already have a ModelCentro.com account? Don't need to register, simply "}],["a",{"data-scroll-to":".aff-wrap","id":"aff-scroll-to-login","class":"aff-text-color-1"},[["textNode",{"text":"login here."}]]],["textNode",{"text":" "}],["a",{"id":"aff-fake-scroll-to-login","class":"aff-text-color-1"},[["textNode",{"text":"login here."}]]]]]]],["div",{"id":"aff-reg-block"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bann-1.jpg", __webpack_require__.p + "_/_/_/affiliate/images/bann-1.jpg");

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_affiliates_check_method", [["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Select Minimum Payout ($)"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Payable to"}]]);
fox.registerTemplate("sitepage_affiliates_paxum_method", [["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Select Minimum Payout ($)"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Account Email"}]]);
fox.registerTemplate("sitepage_affiliates_payoneer_method", [["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Select Minimum Payout ($)"}]]);
fox.registerTemplate("sitepage_affiliates_wire_method", [["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Select Minimum Payout ($)"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Beneficiary"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"SWIFT/ABA"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Account Number"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"IBAN"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Beneficiary Address"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Bank Name"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Bank Address"}],["textNode",{"text":" "}],["input",{"type":"text","name":"ln","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Currency"}]]);
fox.registerTemplate("sitepage_affiliates_reg_form_block", [["div",{"class":"section"},[["div",{"class":"page-width"},[["div",{"class":"aff-info-column"},[["div",{"class":" aff-text-color-2 aff-section-title uppercase"},[["textNode",{"text":" Account Information "}]]],["div",{"class":"inlb"},[["label",{},[["input",{"type":"text","name":"screenName","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Usename"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"inlb"},[["label",{},[["input",{"type":"text","name":"company","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Company"}]]]]],["div",{"class":"inlb"},[["label",{},[["input",{"type":"text","name":"domain","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"URL"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]]]],["div",{"class":"aff-info-column"},[["div",{"class":" aff-text-color-2 aff-section-title uppercase"},[["textNode",{"text":" Contact Information "}]]],["div",{"class":"inlb"},[["label",{},[["input",{"type":"text","name":"email","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"E-mail"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"inlb"},[["label",{},[["input",{"type":"text","name":"phone","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Phone"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"inlb"},[["div",{"class":"aff-back-color-3 aff-select-wrapp aff-form-field"},[["span",{"class":"selected-text aff-text-color-3"},[["textNode",{"text":"Test"}]]],["textNode",{"text":" "}],["span",{"class":"aff-back-color-6 arrow"}],["textNode",{"text":" "}],["select",{"class":"aff-text-color-3 aff-form-select aff-back-color-3","name":"socialAcount"},[["option",{"selected":"","value":"twitter"},[["textNode",{"text":"Twitter"}]]],["option",{"value":"skype"},[["textNode",{"text":"Skype"}]]],["option",{"value":"icq"},[["textNode",{"text":"ICQ"}]]]]]]]]],["div",{"class":"inlb"},[["input",{"type":"text","name":"socialIdentity","class":"aff-form-field aff-text-color-3 aff-back-color-3"}]]]]]]],["div",{"class":"page-width"},[["div",{"class":"aff-info-column"},[["div",{"class":"dbl aff-text-color-2 aff-section-title uppercase"},[["textNode",{"text":" Mailing Address "}]]],["div",{"class":"inlb"},[["label",{},[["input",{"type":"text","name":"firstName","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"First Name"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"inlb"},[["label",{},[["input",{"type":"text","name":"lastName","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Last Name"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"inlb"},[["input",{"type":"text","name":"address","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Address"}]]],["div",{"class":"inlb"},[["input",{"type":"text","name":"addressCont","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Address (cont)"}]]],["div",{"class":"inlb"},[["input",{"type":"text","name":"city","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"City"}]]],["div",{"class":"inlb"},[["input",{"type":"text","name":"state","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"State"}]]],["div",{"class":"inlb"},[["input",{"type":"text","name":"zip","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Zip Code"}]]],["div",{"class":"inlb"},[["input",{"type":"text","name":"country","class":"aff-form-field aff-text-color-3 aff-back-color-3","placeholder":"Country"}]]]]]]]]],["div",{"class":"aff-text-color-2 checkbox-block _p-a-20 aff-back-color-2 "},[["label",{"class":"checkbox-agree"},[["input",{"type":"checkbox","name":"consent_tos"}],["textNode",{"text":" "}],["i"],["textNode",{"text":" By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}],["span",{"onclick":"event.stopPropagation();"},[["a",{"href":"/affiliate-agreement","class":"aff-text-color-1","target":"_blank","rel":"nofollow","draggable":"true"},[["textNode",{"text":" Affiliate Agreement"}]]]]],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]],["textNode",{"text":" "}],["label",{"class":"checkbox-agree _m-t-10"},[["input",{"type":"checkbox","name":"consent_marketing","id":"checkbox2"}],["textNode",{"text":" "}],["i"],["textNode",{"text":" I agree to receive e-mails with special offers, news and updates from ModelCentro family of products "}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"v-padd-20 aff-back-color-2 text-center"},[["button",{"id":"signup","class":"big aff-back-color-4 aff-form-btn aff-text-color-2 text-center"},[["textNode",{"text":"Submit Signup"}]]]]]]);
fox.registerTemplate("sitepage_affiliates_signup_success_message", [["div",{"class":"section aff-reg-ok-text"},[["div",{"class":"page-width text-center"},[["div",{"class":"uppercase aff-section-title middle aff-text-color-2"},[["textNode",{"text":" Thank you for your interest in joining my team! "}]]],["p",{"class":"aff-text-color-3 uppercase"},[["textNode",{"text":" I will review your request and notify you by email when your account has been activated. "}]]]]]]]]);
fox.registerTemplate("sitepage_affiliates_popup_login_form", [["div",{"class":"aff-text-color-2 aff-section-title uppercase"},[["textNode",{"text":"Login"}]]],["div",{"class":"inlb"},[["input",{"type":"text","name":"email2","class":"aff-form-field aff-text-color-3 aff-back-color-3 login-data","placeholder":"E-mail"}],["textNode",{"text":" "}],["label",{},[["textNode",{"text":"This field is required"}]]]]],["div",{"class":"inlb"},[["input",{"type":"password","name":"passwd2","class":"aff-form-field aff-text-color-3 aff-back-color-3 login-data","placeholder":"Password"}],["textNode",{"text":" "}],["label",{},[["textNode",{"text":"This field is required"}]]]]],["div",{"class":"clearfix aff-popup-bottom"},[["a",{"class":"forgot aff-text-color-1"},[["textNode",{"text":"Forgot your password?"}]]],["textNode",{"text":" "}],["input",{"id":"aff-login-on-popup","value":"Login","type":"submit","class":"aff-form-btn aff-text-color-2 aff-back-color-4 fr"}]]]]);
fox.registerTemplate("sitepage_affiliates_popup_login_error", [["div",{"class":"small text-center aff-text-color-4 aff-section-title uppercase"},[["textNode",{"text":"Login or password incorrect"}]]],["div",{"class":"text-center"},[["button",{"id":"aff-login-try-again","class":"aff-form-btn aff-text-color-2 aff-back-color-4"},[["textNode",{"text":" Try again "}]]]]]]);
fox.registerTemplate("sitepage_affiliates_popup_pass_recovery", [["div",{"class":"small aff-text-color-2 aff-section-title uppercase"},[["textNode",{"text":"Password recovery"}]]],["div",{"class":"inlb"},[["input",{"type":"text","name":"recpassemail","class":"aff-form-field aff-text-color-3 aff-back-color-3 login-data","placeholder":"E-mail"}],["textNode",{"text":" "}],["label",{},[["textNode",{"text":"This field is required"}]]]]],["div",{"class":"text-center"},[["button",{"id":"aff-pass-request","class":"aff-form-btn aff-text-color-2 aff-back-color-4"},[["textNode",{"text":" Request "}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("affiliateagreement", [["div",{"class":"layout-width page-width single-page aff-text-color-2"},[["h1",{"class":"apa-title padd-left"},[["span",{},[["textNode",{"text":"ModelCentro"}],["sup",{},[["textNode",{"text":"TM"}]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Affiliate Agreement"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Updated: November 26, 2020"}]]]]],["div",{"class":"sp-main"},[["div",{"class":"sp-col sp-left"},[["div",{"class":"sp-part","id":"part-warning","style":"border: 1px solid #000; margin: 40px 20px 0 40px; padding: 10px 30px 0 0;"},[["p",{"style":"color:#f00"},[["strong",{},[["textNode",{"text":"This agreement contains disclaimers of warranties, limitations on liability, releases, a class-action waiver, and the requirement to mediate and arbitrate all claims that may arise under this agreement. These provisions are an essential basis of this agreement."}]]]]],["p",{},[["strong",{},[["textNode",{"text":"This is a legally binding agreement between you and the owner and operator of ModelCentro.com; FanCentro.com, including any successor or affiliated company or entity. You must be at least 18-years old and have reached the age of majority and legal consent in the jurisdiction in which you live or reside to agree to this agreement. By clicking on the words “I agree,” “Submit,” or similar syntax, you are electronically signing this agreement, and therefore agree to be bound by and acknowledge your complete acceptance of all the express and incorporated terms of this agreement. If you do not agree to this agreement or do not meet the age requirements, you must not register."}]]]]],["p",{},[["strong",{"style":"color:#f00"},[["textNode",{"text":"No Prostitution or Sex Trafficking."}]]],["textNode",{"text":" The promotion of prostitution, escort services, personal companions, etc. are contrary to the purposes of ModelCentro.com; FanCentro.com and will not be tolerated in any fashion. Promoting or offering prostitution or escort services on the ModelCentro.com website is strictly prohibited. Sites or profiles that are used for the promotion of prostitution or escort services in any way will be immediately disabled. This includes the use of hyperlinks to external websites promoting prostitution, URLs promoting prostitution, and any other activity that ModelCentro.com considers as promotions or offers."}]]]]],["div",{"class":"sp-part","id":"part-start"},[["p",{},[["textNode",{"text":"This affiliate marketing agreement is between "}],["strong",{},[["textNode",{"text":"Centro Publisher Limited"}]]],["textNode",{"text":", a Marshal Islands company (the "}],["strong",{},[["textNode",{"text":"“Company”"}]]],["textNode",{"text":"), and you, the individual or entity signing up to become an affiliate (the "}],["strong",{},[["textNode",{"text":"“Affiliate”"}]]],["textNode",{"text":")."}]]],["p",{},[["textNode",{"text":"The Company has developed the ModelCentro affiliate program (the "}],["strong",{},[["textNode",{"text":"“Program”"}]]],["textNode",{"text":") that allows participating affiliates to earn commissions in connection with their referral of end-user consumers (the "}],["strong",{},[["textNode",{"text":"“Consumers”"}]]],["textNode",{"text":") interested in purchasing products, services, VIP access, memberships, and other material (collectively, the "}],["strong",{},[["textNode",{"text":"“Model Offerings”"}]]],["textNode",{"text":") for a fee from one or more models (the "}],["strong",{},[["textNode",{"text":"“Models”"}]]],["textNode",{"text":") that operator websites or stores using ModelCentro’s or/and FanCentro’s proprietary platforms and were made available to the Affiliate through the Program(collectively, the "}],["strong",{},[["textNode",{"text":"“Model Sites”"}]]],["textNode",{"text":")."}]]],["p",{},[["textNode",{"text":"The Affiliate wants to participate in the Program through one or more affiliate sites (collectively, the "}],["strong",{},[["textNode",{"text":"“Affiliate Sites”"}]]],["textNode",{"text":")."}]]],["p",{},[["textNode",{"text":"The parties therefore agree as follows:"}]]]]],["div",{"class":"sp-part","id":"part-1"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"1."}]]],["textNode",{"text":" Enrollment in the Program "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"1.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Eligibility."}]]],["textNode",{"text":"The Affiliate must be at least 18-years old and the age of majority (the age at which the Affiliate can legally consent and enter into contracts) in the Affiliate’s place of residence to enroll in the Program. If the Affiliate is an entity, all individuals involved in the entity must be at least 18-years old and the age of majority in their place of residence."}]]],["span",{"class":"num"},[["textNode",{"text":"1.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Registration."}]]],["textNode",{"text":" To begin the enrollment process, the Affiliate must submit a completed Program application available online at "}],["a",{"href":"https://centroprofits.com","target":"_blank","rel":"nofollow","class":"aff-text-color-1"},[["textNode",{"text":"affiliates.modelcentro.com."}]]]]],["span",{"class":"num"},[["textNode",{"text":"1.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Evaluation of Application."}]]],["textNode",{"text":" The Company will evaluate the Affiliate’s application and will notify the Affiliate of its acceptance or rejection. Among other reasons for rejection, the Company may reject the Affiliate’s application if it determines, in its sole discretion, that one or more affiliate sites are unsuitable for the Program. Unsuitable affiliate sites include those that:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"promote or facilitate the prostitution of another person or otherwise promote escort services;"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"promote child pornography;"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"promote obscene materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"promote violence;"}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":"promote discrimination based on race, sex, religion, nationality, disability, sexual orientation, or age;"}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":"promote illegal activities; or"}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":"violate or infringe intellectual-property rights."}]]]]],["span",{"class":"num"},[["textNode",{"text":"1.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Reapplication."}]]],["textNode",{"text":" If the Company rejects the Affiliate’s application, the Affiliate may reapply to the Program at any time."}]]]]]]],["div",{"class":"sp-part","id":"part-2"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"2."}]]],["textNode",{"text":" License "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"2.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Grant."}]]],["textNode",{"text":" The Company hereby grants the Affiliate a revocable, nonexclusive, nontransferable, nonsublicensable, worldwide license to use, reproduce, transmit, publicly display, and publicly perform the materials provided by the Company or one or more Models to the Affiliate (collectively, the "}],["strong",{},[["textNode",{"text":"“Licensed Materials”"}]]],["textNode",{"text":") on one or more Affiliate Sites to market, advertise, and promote the Models’ online services and content solely in connection with the Program. This license includes the right to use the Company’s or the Models’ service marks, trademarks, logos, the video content provided by the Company and its partners, and any other Licensed Materials provided by the Company or one or more Models for the Affiliate’s use."}]]],["span",{"class":"num"},[["textNode",{"text":"2.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Limitations."}]]],["textNode",{"text":" The following limitations apply to the Affiliate’s use of the Licensed Materials:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Use Restrictions."}]]],["textNode",{"text":" All unauthorized access or duplication of the Licensed Materials is a material breach of this agreement and an infringement of the Company’s, one or more Models’, and potentially others’ trademarks, copyrights, or other rights, including privacy and publicity rights."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Other Prohibited Actions. "}]]],["textNode",{"text":"Unless the Company expressly authorizes in writing, the Affiliate will not:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"Modify, translate, reverse engineer, decompile, or disassemble the Licensed Materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":"Create derivative works based on the Licensed Materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":"Rent, lease, or transfer any rights in the Licensed Materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":"Remove any proprietary notices or labels on the Licensed Materials; or"}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":"Make any other unauthorized use of the Licensed Materials."}]]]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Ownership of Licensed Materials and Intellectual Property."}]]],["textNode",{"text":" Except for material in the public domain or licensed to the Company, the Company owns the Licensed Materials. Marshal Islands law, international treaties, and other laws and regulations protect the Licensed Materials. The Company retains all rights in the Licensed Materials."}]]]]],["span",{"class":"num"},[["textNode",{"text":"2.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"No License for Other Material."}]]],["textNode",{"text":" The Company does not grant a license for any other material published on the Model Sites or any other website unless the Company or the applicable Model makes that material available to the Affiliate through the Program and the Company or the applicable Model designates it as Licensed Materials."}]]],["span",{"class":"num"},[["textNode",{"text":"2.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Reservation of Rights."}]]],["textNode",{"text":" Except as expressly granted in this agreement, the Company does not grant any other rights to the Affiliate. The Company reserves all rights to select, alter, add, or remove all Licensed Materials used for the Program."}]]],["span",{"class":"num"},[["textNode",{"text":"2.5"}]]],["p",{},[["strong",{},[["textNode",{"text":"Termination or Withdrawal."}]]],["textNode",{"text":" On termination of this agreement or the Affiliate’s withdrawal from the Program, the Affiliate’s license to download and use the Licensed Materials automatically terminates and all rights automatically revert to the Company. At that time, the Affiliate will promptly delete all copies of the Licensed Materials that might reside on any computer system, storage device, server, or website owned by the Affiliate or under its control."}]]]]]]],["div",{"class":"sp-part","id":"part-3"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"3."}]]],["textNode",{"text":" Promotional Links. "}]]],["p",{},[["textNode",{"text":"The Affiliate may receive—or the Company may make available to the Affiliate—banner, button, or text links one or more Model Sites (the "}],["strong",{},[["textNode",{"text":"“Promotional Links”"}]]],["textNode",{"text":"). The Promotional Links may contain logos or identifying marks. The Affiliate’s use of the Promotional Links will at all times be subject to this agreement. The Affiliate may display the Promotional Links in accordance with its own site design, on condition that the Affiliate does not alter, modify, or expand the Promotional Links in any way without the Company’s advance written consent."}]]]]],["div",{"class":"sp-part","id":"part-4"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"4."}]]],["textNode",{"text":" Program Requirements. "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"4.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Compliance with Law."}]]],["textNode",{"text":" The Affiliate will comply with all applicable laws and regulations."}]]],["span",{"class":"num"},[["textNode",{"text":"4.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Prohibited Conduct."}]]],["textNode",{"text":" The Affiliate is responsible for all content posted on the Affiliate Sites. The Affiliate will not engage in the following prohibited conduct:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Depictions of Minors."}]]],["textNode",{"text":" The Affiliate will not disseminate, post on the Affiliate Sites, or provide links to any material that involves depictions of nudity or sexuality by an age inappropriate-appearing model (that is, a model who looks younger than 18-years old) or by a model who is portrayed or made to appear as a person under 18-years old by virtue of the script, make-up, costuming, demeanor, setting, etc."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Illegal or Objectionable Content. "}]]],["textNode",{"text":"The Affiliate will not disseminate, post on the Affiliate Sites, or provide links to any obscene material, including any material depicting child pornography, incest, scat, defecation, feces, urination, menstruation, genital mutilation, necrophilia, bestiality, sadomasochistic abuse or bondage, actual or simulated rape, sexual violence, actual violence inflicted on individuals by themselves or others, torture, or death. Nor will the Affiliate disseminate, post on the Affiliate Sites, or provide links to any content or materials of the following nature: warez, distribution of pirated content, prostitution or escort services, human trafficking, gambling, or controlled substances (including related paraphernalia)."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Spam."}]]],["textNode",{"text":" The Affiliate will not disseminate spam in connection with the Program. The Company imposes a strict, no-spam policy for participants in the Program. What is spamming will evolve over time as new technologies and methodologies emerge for spammers to find new ways to abuse the Program. Some of the facts that the Company takes into account when determining what is spamming include the following: "}],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has violated a U.S. federal or state anti-spamming law, including any part of the CAN-SPAM Act of 2003 ("}],["a",{"href":"https://www.law.cornell.edu/uscode/text/15/chapter-103","rel":"nofollow","target":"_blank","class":"aff-text-color-1"},[["textNode",{"text":"15 U.S.C. §§ 7701–7713"}]]],["textNode",{"text":") or any of the federal regulations promulgated under the CAN-SPAM Act ("}],["a",{"href":"https://www.law.cornell.edu/cfr/text/16/part-316","target":"_blank","rel":"nofollow","class":"aff-text-color-1"},[["textNode",{"text":"16 C.F.R. Part 316"}]]],["textNode",{"text":");"}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has violated another country’s anti-spamming law;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has violated any third-party anti-spamming policy;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has sent unsolicited bulk messages to nonconsenting recipients;"}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has misleading or false information contained in its messages, subject line, or message headers;"}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":"If the Affiliate uses automated means to collect, transmit, or sell email addresses of others;"}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":"If the Affiliate uses a third-party website or program to automatically generate and send messages or content;"}]]],["span",{"class":"num"},[["textNode",{"text":"(viii)"}]]],["p",{},[["textNode",{"text":"If the primary purpose of the Affiliate’s message is commercial in nature; and"}]]],["span",{"class":"num"},[["textNode",{"text":"(ix)"}]]],["p",{},[["textNode",{"text":"The number of spam or abuse complaints that have been lodged against the Affiliate."}]]]]]]],["p",{},[["textNode",{"text":"No one factor is controlling, and the Company will look to the particular circumstances of each case to determine what is spamming. When in doubt, don’t do it—you spam, you’re out."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Fraudulent and Deceptive Trade Practices."}]]],["textNode",{"text":" The Affiliate will not engage in any fraudulent, deceptive, or unfair transactions or trade practices. The Affiliate will comply with the Federal Trade Commission (FTC) statutes and regulations and all related rules, policies, and advisory opinions in advertising, marketing, and promoting the Program and the Program Site, including the Restore Online Shoppers’ Confidence Act ("}],["a",{"href":"https://www.law.cornell.edu/uscode/text/15/chapter-110","target":"blank","rel":"nofollow","class":"aff-text-color-1"},[["textNode",{"text":"15 U.S.C. §§ 8401–8405"}]]],["textNode",{"text":"); Guides Against Deceptive Pricing ("}],["a",{"href":"https://www.law.cornell.edu/cfr/text/16/part-233","target":"blank","rel":"nofollow","class":"aff-text-color-1"},[["textNode",{"text":" 16 C.F.R. Part 233"}]]],["textNode",{"text":"); Guides Against Bait Advertising ("}],["a",{"class":"aff-text-color-1","target":"blank","rel":"nofollow","href":"https://www.law.cornell.edu/cfr/text/16/part-238"},[["textNode",{"text":" 16 C.F.R. Part 238"}]]],["textNode",{"text":"); Guides Concerning Use of the Word “Free” and Similar Representations ("}],["a",{"target":"blank","rel":"nofollow","href":"https://www.law.cornell.edu/cfr/text/16/part-251","class":"aff-text-color-1"},[["textNode",{"text":" 16 C.F.R. Part 251"}]]],["textNode",{"text":"); Guides Concerning Use of Endorsements and Testimonials in Advertising ("}],["a",{"class":"aff-text-color-1","target":"blank","rel":"nofollow","href":"https://www.law.cornell.edu/cfr/text/16/part-255"},[["textNode",{"text":" 16 C.F.R. Part 255"}]]],["textNode",{"text":"); Use of Pre-Notification Negative Option Plans ("}],["a",{"target":"blank","rel":"nofollow","href":"https://www.law.cornell.edu/cfr/text/16/part-425","class":"aff-text-color-1"},[["textNode",{"text":" 16 C.F.R. Part 425"}]]],["textNode",{"text":"); "}],["a",{"target":"blank","class":"aff-text-color-1","rel":"nofollow","href":"https://www.ftc.gov/bcp/policystmt/ad-decept.htm"}],["textNode",{"text":" FTC Policy Statement on Deception; "}],["a",{"target":"blank","rel":"nofollow","href":"https://www.ftc.gov/bcp/guides/ad3subst.htm","class":"aff-text-color-1"}],["textNode",{"text":"FTC Policy Statement on Advertising Substantiation; "}],["a",{"target":"blank","class":"aff-text-color-1","rel":"nofollow","href":"https://www.ftc.gov/bcp/policystmt/ad-unfair.htm"},[["textNode",{"text":"FTC Policy Statement on Unfairness"}]]],["textNode",{"text":"; and "}],["a",{"target":"blank","class":"aff-text-color-1","rel":"nofollow","href":"https://www.ftc.gov/tips-advice/business-center/guidance/com-disclosures-how-make-effective-disclosures-digital"},[["textNode",{"text":"FTC .com Disclosures: How to Make Effective Disclosures in Digital Advertising."}]]]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Defamation and Related Conduct."}]]],["textNode",{"text":" The Affiliate will not publish content on the Affiliate Sites that is defamatory, libelous, threatening, abusive, hateful, derogatory, disparaging, or otherwise injurious to any person or the reputation of anyone."}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["strong",{},[["textNode",{"text":"United States Federal Record Keeping and Labeling Requirements."}]]],["textNode",{"text":" The Affiliate and the Affiliate Sites will comply with the federal record keeping and labeling requirements codified at 18 U.S.C. §§ "}],["a",{"href":"https://www.law.cornell.edu/uscode/text/18/2257","class":"aff-text-color-1","target":"_blank","rel":"nofollow"},[["textNode",{"text":"2257"}]]],["textNode",{"text":"– "}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/uscode/text/18/2257a","target":"_blank","rel":"nofollow"},[["textNode",{"text":"2257A"}]]],["textNode",{"text":" and the implementing regulations codified at "}],["a",{"href":"https://www.law.cornell.edu/cfr/text/28/part-75","target":"_blank","rel":"nofollow","class":"aff-text-color-1"},[["textNode",{"text":"28 C.F.R. Part 75"}]]],["textNode",{"text":" (collectively, the "}],["strong",{},[["textNode",{"text":"“§ 2257 Requirements”"}]]],["textNode",{"text":"). The Affiliate will act as the required “Custodian of Records” under the § 2257 Requirements for all content depicting actual sexually explicit conduct of an actual human being that may be used to promote or market the Program Site regardless of who produced the content. The Affiliate will post a 2257 statement on the Affiliate Sites in the manner and locations required by the § 2257 Requirements."}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Intellectual Property Rights."}]]],["textNode",{"text":" The Affiliate will not publish content on the Affiliate Sites that infringes the intellectual-property rights or other legal rights of any person, including copyright, patent, trademark, service mark, trade secret, trade dress, right of privacy, right of publicity, moral right, and any other proprietary right."}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Cybersquatting or Typosquatting."}]]],["textNode",{"text":" The Affiliate will not use or register or try to use or register any domain name (including second-level, third-level, fourth-level, fifth-level, and so on), subdomain name, or directory that is identical or confusingly similar to a trademark or service mark in which the Company, one or more Models, or another person has intellectual property or other legal rights, including MODELCENTRO and FANCENTRO."}]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Paid Search Advertising Schemes."}]]],["textNode",{"text":" The Affiliate will not bid on or purchase any online paid advertising schemes that incorporate or are confusingly similar to the Company’s or one or more Models’ trademarks, service marks, domain names, or URLs, including MODELCENTRO and FANCENTRO.The prohibited advertising schemes include pay-per-click models, sponsored links, search engine keywords, AdWords, or similar advertising schemes."}]]],["span",{"class":"num"},[["textNode",{"text":"(j)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Metatags."}]]],["textNode",{"text":" The Affiliate will not use any false, misleading, or infringing metatags tied to the Affiliate Sites. In addition, the Affiliate will not use any metatags that would imply or suggest that underage or illegal content may be found on the Affiliate Sites or one or more Model Sites."}]]],["span",{"class":"num"},[["textNode",{"text":"(k)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Unethical Marketing Practices."}]]],["textNode",{"text":" The Affiliate will not try to intercept, direct, redirect, divert, or usurp traffic (including through user-installed software) from, or divert fees from, any other participant in the Program. The Affiliate will not directly or indirectly offer any person any consideration or incentive (including payment of money or granting of any discounts or other benefits) to go to one or more Model Sites using the Promotional Links on the Affiliate Sites; nor will the Affiliate require any person to join or buy products from one or more Model Sites as a prerequisite to accessing other products or services. The Affiliate will not try to directly or indirectly obtain usernames or passwords from Consumers, including Consumers whom the Affiliate referred to one or more Model Sites."}]]],["span",{"class":"num"},[["textNode",{"text":"(l)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Misrepresentation of Relationship."}]]],["textNode",{"text":" The Affiliate will not misrepresent the Affiliate’s contractual relationship with the Company or one or more Models or imply that any relationship exists with the Company or one or more Models except as expressly provided in this agreement. For example, the Affiliate will not publish any statement indicating that the Company or one or more Models supports, endorses, or contributes to the Affiliate Sites except as expressly provided in this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"(m)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Unauthorized Access."}]]],["textNode",{"text":" The Affiliate’s unauthorized access or duplication of any content that the Affiliate obtains directly or indirectly through its participation in the Program is a material breach of this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"(n)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Malicious Code, Viruses, Etc."}]]],["textNode",{"text":" The Affiliate will not use or offer for download any material that contains a virus malware, or malicious code, for example, a trojan horse, that has the potential of causing disruption or damage to any computer system, network, or server. The Affiliate will be liable to the Company for all damage caused by any program of this nature."}]]],["span",{"class":"num"},[["textNode",{"text":"(o)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Links to and Content of Others."}]]],["textNode",{"text":" The Affiliate will not use the Licensed Materials, the Company marks, or any other of the Company’s intellectual property to promote or link to any other website. No links to other sites are permitted on pages where the licensed content is used."}]]],["span",{"class":"num"},[["textNode",{"text":"(p)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Use of Unapproved Promotional Materials."}]]],["textNode",{"text":" The Affiliate will only use the Licensed Materials provided by the Company or one or more Models unless the Company or the applicable Model states otherwise in writing. The Affiliate will not use any other material, whether created by the Affiliate or others, to promote the Program or one or more Model Sites unless the Company or the applicable Model states otherwise in writing."}]]],["span",{"class":"num"},[["textNode",{"text":"(q)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Abuse of Promotional Links. "}]]],["textNode",{"text":"The Affiliate will not abuse the Promotional Links, including by using the Promotional Links to purchase memberships or products on one or more Model Sites; sharing, posting, or spamming the Promotional Links in any area of the Model Sites; and recruiting existing Customers to create a new user account via the Promotional Links."}]]]]],["span",{"class":"num"},[["textNode",{"text":"4.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Breach of Program Requirements."}]]],["textNode",{"text":" The Company may withhold payments or terminate this agreement if the Affiliate breaches or otherwise violates this section 4."}]]]]]]],["div",{"class":"sp-part","id":"part-5"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"5."}]]],["textNode",{"text":" Affiliate’s Duty to Notify."}]]],["p",{},[["textNode",{"text":"The Affiliate will promptly notify the Company (a) of all URLs where the Affiliate will use the Licensed Materials or otherwise promote one or more Model Sites; (b) whenever there are inquiries or concerns by any person regarding any questionable activities; or (c) if the Affiliate receives any inquiries or requests for information regarding any of the following: (i) prostitution; (ii) obscenity; (iii) child pornography or depictions of nudity or sexuality by minors; (iv) spam complaints; (v) infringement of intellectual-property rights; (vi) deceptive trade or unfair business practices; (vii) misleading search terms; (viii) invasion of publicity or privacy issues; (ix) fraudulent activities, including credit card fraud; and (x) any civil or criminal investigation or subpoena that pertains to the Affiliate unless applicable law prohibits the Affiliate from notifying the Company. The Affiliate’s failure to comply with section 5 will constitute a material breach of this agreement. The Affiliate will be responsible for any damages the Company incurs based on the Affiliate’s failure to notify the Company as required by this section 5."}]]]]],["div",{"class":"sp-part","id":"part-6"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"6."}]]],["textNode",{"text":" Compensation. "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"6.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Commissions."}]]],["textNode",{"text":" The Company will pay the Affiliate commissions according to the specific payout terms made available to the Affiliate by the Company when the Affiliate registers for participation in the Program. The Commissions will be based on a percentage of the revenue derived from the following:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"fees that are paid by referred Consumers for membership to the applicable Model Site; plus"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"purchase price paid by referred Consumers for Model products purchased through the applicable Model Site (collectively, the "}],["strong",{},[["textNode",{"text":"“Model Site Revenues”"}]]],["textNode",{"text":"); less"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"a transaction fee that is deducted before the calculation of the Model Site Revenue."}]]]]],["p",{},[["textNode",{"text":"The Affiliate may track commissions through the affiliate portal located at "}],["a",{"target":"blank","rel":"nofollow","class":"aff-text-color-1","href":"https://centroprofits.com"},[["textNode",{"text":"centroprofits.com"}]]],["textNode",{"text":"."}]]],["span",{"class":"num"},[["textNode",{"text":"6.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Payout Requirements"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Minimum Payout Requirement."}]]],["textNode",{"text":" The information about minimum payouts is made available through the Program."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Payout Periods."}]]],["textNode",{"text":" Subject to the minimum payout requirement for the payment method selected, the Company will disburse payouts in accordance with the schedule stated in the affiliate portal. The Company will debit payouts for cancelled subscriptions. The Company may change the payout pay periods from time to time."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Processing Fees."}]]],["textNode",{"text":" The Company is not responsible for any third-party fees charged by banks or financial institutions used to receive commissions. The Company may deduct a processing fee if the payment method selected carries a processing fee."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Commission Forfeiture."}]]],["textNode",{"text":" If the Company is unable to pay the Affiliate for 180-consecutive days and the Company cannot otherwise contact the Affiliate during this period, the Company will consider all unpaid accrued commissions forfeited to the Company without further notice."}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Taxes."}]]],["textNode",{"text":" The Affiliate will pay all taxes attributable to commissions earned under this agreement. From time to time, the Company may request the Affiliate to provide tax information depending on the jurisdiction in which the Affiliate resides or is organized. The Affiliate will promptly comply with any request by the Company for tax information. If the Company requests tax information from the Affiliate and the Affiliate fails to provide it to the Company, the Company may withhold payment from the Affiliate until the Affiliate provides this information or otherwise satisfies the Company that the Affiliate is not a person from whom the Company is required to obtain tax information."}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Disputes."}]]],["textNode",{"text":" If the Affiliate disputes a payment or the calculation of a commission, the Affiliate will notify the Company in writing of the dispute or discrepancy no later than 30 days after the end of the pay period in which the disputed payment occurred. The Affiliate will include in its written notice a detailed statement describing the nature and amount of the dispute and all supporting evidence. The Affiliate will cooperate fully and in good faith with the Company to promptly address and try to resolve the dispute. If the Affiliate fails to timely notify the Company in writing, the parties will consider the Company’s determination correct and binding on the Affiliate, and the Affiliate will not dispute the Company’s determination."}]]]]],["span",{"class":"num"},[["textNode",{"text":"6.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Payout Limitations"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"The Company will pay the Affiliate for qualified purchases only, that is the Company will only pay the Affiliate commissions if its system can track a Consumer to the applicable Model Site from the time the Consumer clicks on a Promotional Link to the time of sale."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"The Company will not pay the Affiliate a commission if (i) its system cannot process the Promotional Link; (ii) the referred Consumer does not pay in full; (iii) the referred Consumer previously registered for the applicable Model Site; or (iv) if a Promotional Link directs a Consumer to a Model Site, but that Consumer leaves that Model Site and returns to that Model Site over 24 hours later to buy a Model Offering without going through the Promotional Link again."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"The Company will not pay the Affiliate for any activity that the Company considers fraudulent, including (i) credit card numbers in a negative bin number database, (ii) multiple subscriptions/purchases from a single email address, (iii) multiple subscriptions/purchases with the same credit card number, (iv) subscriptions with past memberships to the applicable Model Site, (v) sequential names or patterns of names, (vi) many subscriptions/purchases from a specific Model Site in a short time span, and (vii) multiple attempts to subscribe/purchase from the same credit card. The Company reserves sole judgment in determining fraud and all determinations bind the Affiliate. The Company may also deny or withhold commissions for any purchases coming from any practices that breach this agreement. If the Company determines that the Affiliate is engaging in practices that breach this agreement, the Affiliate will not receive any credit or payment and will forfeit all credits or payments earned."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"The Company may deny or withhold any payment to the Affiliate or terminate the Affiliate’s participation in the Program if there has been an abnormal number of chargebacks, refunds, or cancellations of memberships from Consumers referred to the Company through the Affiliate’s Promotional Links. The Company will determine what is an abnormal number of chargebacks, refunds, or cancellations based on its review of the situation and its experience with other affiliates. In addition, the Company may also deny or withhold payment to the Affiliate or terminate the Affiliate’s participation in the Program due to any other suspicious behavior, including unusual conversion ratios, lack of or low quantity of referred Consumer logins, or low referred Consumer usage."}]]]]]]]]],["div",{"class":"sp-part","id":"part-7"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"7."}]]],["textNode",{"text":"Affiliate’s Actions and Responsibilities."}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"The Affiliate will be solely responsible for developing, operating, and maintaining the Affiliate Sites and for all materials that appear on the Affiliate Sites. The Affiliate’s responsibilities include:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"7.1"}]]],["p",{},[["textNode",{"text":"The technical operation of the Affiliate Sites and all related equipment;"}]]],["span",{"class":"num"},[["textNode",{"text":"7.2"}]]],["p",{},[["textNode",{"text":"Displaying the Promotional Links and Licensed Materials on the Affiliate Sites in compliance with this agreement;"}]]],["span",{"class":"num"},[["textNode",{"text":"7.3"}]]],["p",{},[["textNode",{"text":"Creating, posting, and ensuring the accuracy of materials posted on the Affiliate Sites, including all materials related to the Model Sites and the Model Offerings;"}]]],["span",{"class":"num"},[["textNode",{"text":"7.4"}]]],["p",{},[["textNode",{"text":"Using the Licensed Materials, the Affiliate Sites, and the materials on the Affiliate Sites in a way that does not infringe any of the Company’s or a Model’s rights or those of any other person (including copyrights, trademarks, privacy, publicity, or other intellectual property or proprietary rights);"}]]],["span",{"class":"num"},[["textNode",{"text":"7.5"}]]],["p",{},[["textNode",{"text":"Disclosing on the Affiliate Sites accurately and adequately, either through a privacy policy or otherwise, how the Affiliate collects, uses, stores, and discloses data collected from Affiliate Site visitors, including, where applicable, that third parties (including the Company and other advertisers) may serve content and advertisements, collect information directly from Affiliate Site visitors, and place or recognize cookies on Affiliate Site visitors’ browsers; and"}]]],["span",{"class":"num"},[["textNode",{"text":"7.6"}]]],["p",{},[["textNode",{"text":"Making sure that any use that the Affiliate makes of the Licensed Materials complies with this agreement."}]]]]],["p",{},[["textNode",{"text":"The Company may monitor referrals through the Affiliate Sites to evaluate the Affiliate’s compliance with this agreement. If the Company determines that the Company is not in compliance, the Company may terminate the Affiliate from the Program. The Company will not be liable to the Affiliate or any other person for the Affiliate’s acts or omissions under this section 7."}]]]]]]],["div",{"class":"sp-part","id":"part-8"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"8."}]]],["textNode",{"text":" Processing; Statistics and Reporting."}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"8.1"}]]],["p",{},[["textNode",{"text":"The Company will process all spurchases from Consumers who follow the Promotional Links on the Affiliate Sites to one or more Model Sites. The Company may reject purchases that do not comply with the applicable Model Site’s requirements, which may change from time to time."}]]],["span",{"class":"num"},[["textNode",{"text":"8.2"}]]],["p",{},[["textNode",{"text":"The Company will track qualified purchases for reporting and commission accrual purposes. The Company will use reasonable efforts to provide the Affiliate with access to real-time traffic reporting, qualified purchaes, and revenue statistics. The Affiliate acknowledges that in calculating the Affiliate’s earnings, the Company’s good faith determination of any amount owed will be the final and binding determination, subject to section 6.2(g). The Affiliate will not try to artificially inflate its traffic reporting, qualified purchases, and revenue statistics by misleading or abusive practices."}]]]]]]],["div",{"class":"sp-part","id":"part-9"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"9."}]]],["textNode",{"text":" Consumer Policies and Pricing."}]]],["p",{},[["textNode",{"text":"Consumers referred through the Promotional Links are the Consumers of the applicable Model with respect to all activities they undertake on the applicable Model Site. Thus, as between the Affiliate and the applicable Model, all pricing, terms, rules, policies, and operating procedures concerning Consumer purchases and customer service stated on the applicable Model Site will apply to those Consumers, and the applicable Model may change them at any time without notifying the Affiliate."}]]]]],["div",{"class":"sp-part","id":"part-10"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"10."}]]],["textNode",{"text":"Data Ownership."}]]],["p",{},[["textNode",{"text":" The Company will have sole ownership of and full right to use all Consumer information generated by the Affiliate in connection with this agreement. The Affiliate will not have any rights in and to any Consumer information or data behind that Consumer information. The Affiliate will not (a) transfer, export, display, forward, or otherwise share any Consumer information or data contained in it to or with any third party; or (b) use any Consunmer information or data contained in it on the Affiliate’s own behalf in any way not expressly authorized by the Company in writing."}]]]]],["div",{"class":"sp-part","id":"part-11"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"11."}]]],["textNode",{"text":"Affiliate Site Privacy Requirements."}]]],["p",{},[["textNode",{"text":" The Affiliate will conspicuously post a privacy notice on the Affiliate Sites. The Affiliate’s privacy notice must fully, accurately, and concisely describe (1) what peronal data the Affiliate collects; (2) the purpose of collection; (3) how the Affiliate uses and shares that personal data; and (4) that other parties (i.e., ModelCentro, ad networks, analytics providers, etc.) may collect personal data about an individual consumer’s online activities over time and across different websites when the individual uses the Affiliate Sites or services. The Affiliate’s privacy notice must comply with the EU General Data Protection Regulation (GDPR) if the Affiliate solicits Consumers from the European Economic Area (EEA). The Affiliate’s privacy and data security practices must make sure that email, telephone, and other marketing practices, and applicable opt in and opt out policies and procedures, comply with all applicable laws."}]]]]],["div",{"class":"sp-part","id":"part-12"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"12."}]]],["textNode",{"text":"Electronic Consent."}]]],["p",{},[["textNode",{"text":" The Affiliate will conspicuously post an electronic consent policy to the Affiliate Sites. The Affiliate will obtain consent to provide required disclosures, documents, and information to the Affiliate’s end users electronically."}]]]]],["div",{"class":"sp-part","id":"part-13"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"13."}]]],["textNode",{"text":" Statements of Fact "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"13.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"By the Affiliate."}]]],["textNode",{"text":" The Affiliate states that the following facts are accurate and will continue to be accurate during this agreement:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"If the Affiliate is an individual, the Affiliate is at least 18-years old and has the legal capacity to enter into this agreement. If the Affiliate is an entity, it is duly organized, validly existing, and in good standing as a legal entity under the laws of its jurisdiction of incorporation, organization, or chartering."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"The Affiliate has the power to enter into this agreement and to perform its obligations under this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"The Affiliate owns or has the right to operate each Affiliate Site."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"The Affiliate owns or has a license for all content found on each Affiliate Site, including all text, audio, images, and videos displayed on each Affiliate Site."}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":"The Affiliate has independently evaluated the desirability of participating in the Program."}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":"The revenue the Affiliate earns through the Program is and will be directed solely to the Affiliate, and the Affiliate is not authorized to transfer the Affiliate’s checks to or deposit the Affiliate’s checks with any third parties other than bona fide financial institutions."}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":"The Affiliate is not an individual, organization, or entity listed on The Office of Foreign Assets Control Specially Designated Nationals or Blocked Persons list, as published and updated by the United States Department of Treasury."}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["textNode",{"text":"Each Affiliate Site and the content on each Affiliate Site"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"does not infringe the Company’s or any other person’s intellectual property rights;"}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":"does not violate third-party publicity or privacy rights;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":"does not promote violence, racial intolerance, or illegal activities;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":"does not promote or facilitate the prostitution of another person or otherwise promote escort services;"}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":"does not depict bestiality, necrophilia, genital mutilation, sadomasochistic abuse or bondage, defecation, urination, bleeding, enema play, menstruation, rape, extreme violence, torture, incest, or any other obscene material;"}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":"does not depict minors in adult or sexual situations or otherwise target persons under 18-years old or the age of majority, whichever is greater;"}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":"does not violate any law governing false or deceptive advertising, sweepstakes, gambling, comparative advertising, or trade disparagement;"}]]],["span",{"class":"num"},[["textNode",{"text":"(viii)"}]]],["p",{},[["textNode",{"text":"is free of any “worm,” “virus,” malware, or other device or code that could impair or injure any person or any person’s property;"}]]],["span",{"class":"num"},[["textNode",{"text":"(ix)"}]]],["p",{},[["textNode",{"text":"is not otherwise defamatory, vulgar, or obscene; and"}]]],["span",{"class":"num"},[["textNode",{"text":"(x)"}]]],["p",{},[["textNode",{"text":"complies with the program requirements set out in section 4."}]]]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"The Affiliate is generally familiar with the nature of the Internet and complies with all laws and industry standards."}]]],["span",{"class":"num"},[["textNode",{"text":"(j)"}]]],["p",{},[["textNode",{"text":"The Affiliate’s performance under this agreement does not breach any agreement or obligation between the Affiliate and a third party or violate any applicable law."}]]],["span",{"class":"num"},[["textNode",{"text":"(k)"}]]],["p",{},[["textNode",{"text":"The Affiliate’s collection and use of personal data does not violate the Affiliate Sites’ privacy policy or violate any law that governs the Affiliate’s collection and use of personal data, including the GDPR."}]]],["span",{"class":"num"},[["textNode",{"text":"(l)"}]]],["p",{},[["textNode",{"text":"The Affiliate has obtained opt-in consent from any individual whose information the Affiliate transfers to the Company for that individual to be contacted by and marketed to by the Affiliate and third parties."}]]],["span",{"class":"num"},[["textNode",{"text":"(m)"}]]],["p",{},[["textNode",{"text":"The Affiliate and each Affiliate Site complies with 18 U.S.C. §§ 2257–2257A and the implementing regulations codified at 28 C.F.R. Part 75."}]]]]],["span",{"class":"num"},[["textNode",{"text":"13.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"By the Company."}]]],["textNode",{"text":"The Company states that the following facts are accurate:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"It is duly organized, validly existing, and in good standing as a corporation under the laws of the Marshal Islands."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"It has the power to enter into this agreement and to perform its obligations under this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"It owns or has the right to operate the Program."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"It owns or has the right to license the Licensed Materials."}]]]]]]]]],["div",{"class":"sp-part","id":"part-14"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"14."}]]],["textNode",{"text":" Confidentiality "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"14.1"}]]],["p",{},[["textNode",{"text":"Neither party will use or disclose to any third party the other party’s Confidential Information except as necessary for the performance of this agreement or to enforce this agreement. The confidentiality obligations will not restrict either party from disclosing Confidential Information of the other party in accordance with a court order from a court of competent jurisdiction, on condition that the party required to make the disclosure gives reasonable advance written notice to the other party so that it may contest the order and if that disclosure is required, only discloses the part of the Confidential Information that its legal counsel advises is legally required."}]]],["span",{"class":"num"},[["textNode",{"text":"14.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"“Confidential Information”"}]]],["textNode",{"text":" consists of (a) any technical information or plans concerning the Program or any software or other technology of the Company; (b) any financial information of the other party; (c) other information disclosed by one party to the other party that is marked as confidential or should reasonably be assumed to be confidential under the circumstances; and (d) the content of this agreement. Confidential Information does not include information that: (i) is or becomes generally known to the public through no fault of or breach of the receiving party; (ii) is rightfully known by the receiving party at the time of disclosure without an obligation of confidentiality; (iii) is independently developed by the receiving party without use of the disclosing party’s Confidential Information; or (iv) is obtained by the receiving party rightfully from a third party who has no duty of confidentiality to the disclosing party."}]]]]]]],["div",{"class":"sp-part","id":"part-15"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"15."}]]],["textNode",{"text":"Publicity. "}]]],["p",{},[["textNode",{"text":"The Company may use the Affiliate’s trade names, trademarks, service marks, or logos in presentations, marketing materials, affiliate lists, financial reports, website listings of affiliates, or advertisements without advance written approval. The Affiliate may use the Company’s or the applicable Model’s trade names, trademarks, service marks, logos, domain names, and other distinctive brand features solely in connection with performing under this agreement so long as the Affiliate complies with this agreement."}]]]]],["div",{"class":"sp-part","id":"part-16"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"16."}]]],["textNode",{"text":"Privacy. "}]]],["p",{},[["textNode",{"text":"For information about how the Company collects, uses, and shares the Affiliate’s information, please review the "}],["a",{"href":"https://modelcentro.com/privacyPolicy","class":"aff-text-color-1","target":"_blank"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":". The Affiliate acknowledges that by participating in the Program, the Affiliate consents to the Company’s collection, use, and sharing of this information (including the transfer of this information to the United States or other countries for the Company’s storage, processing, and use)."}]]]]],["div",{"class":"sp-part","id":"part-17"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"17."}]]],["textNode",{"text":" Nondisparagement. "}]]],["p",{},[["textNode",{"text":" During this agreement and for two years after its termination, the Affiliate will not take any action that is intended, or would reasonably be expected, to harm the Company, the Models, or their reputation or that would reasonably be expected to lead to unwanted or unfavorable publicity to the Company or the Models. But nothing will prevent the Affiliate from making any truthful statement in connection with any legal proceeding or investigation by the Company or any government body."}]]]]],["div",{"class":"sp-part","id":"part-18"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"18."}]]],["textNode",{"text":" Term and Termination; Survival "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"18.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Term."}]]],["textNode",{"text":" This agreement begins on the Affiliate’s signup and ends when terminated by either party."}]]],["span",{"class":"num"},[["textNode",{"text":"18.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Termination."}]]],["textNode",{"text":" Either party may terminate this agreement for any reason by giving the other party a written notice of termination. The Affiliate’s breach of this agreement may result in the Affiliate’s immediate dismissal from the Program, with no obligation to the Company except to pay for earned commissions up to the point of termination unless this agreement provides otherwise. The Affiliate will forfeit all commissions due if the Company terminates the Affiliate from the Program because of the Affiliate’s fraudulent activity or for any breach of the program requirements set out in section 4."}]]],["span",{"class":"num"},[["textNode",{"text":"18.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Survival."}]]],["textNode",{"text":" Any part of this agreement that imposes an obligation after termination will survive the termination, including all disclaimers and limitations of liability."}]]]]]]],["div",{"class":"sp-part","id":"part-19"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"19."}]]],["textNode",{"text":" Warranty Disclaimers "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"19.1"}]]],["p",{},[["textNode",{"text":"The Company is not making any guarantee of profitability or about the amount of money the Affiliate will earn through the Program. The Affiliate acknowledges that past affiliate earnings do not guarantee or suggest similar future earnings."}]]],["span",{"class":"num"},[["textNode",{"text":"19.2"}]]],["p",{},[["textNode",{"text":"The Company is not making any warranty—express, implied, oral, or otherwise—that"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"the Program, the Model Sites, the Model Offerings, or the Licensed Materials will be timely, uninterrupted, or error-free (whether as a result of technical failure, acts or omissions of third parties, or other causes) or will operate in combination with any other hardware, software, system, or data;"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"the Program, the Model Sites, the Model Offerings, or the Licensed Materials will be suitable or otherwise meet the Affiliate’s requirements or expectations;"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"the Program, the Model Sites, the Model Offerings, or the Licensed Materials will be accurate or reliable;"}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"errors or defects in the Program, the Model Sites, the Model Offerings, or the Licensed Materials will be corrected; or"}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":"the servers that make the Program, the Model Sites, the Model Offerings, and the Licensed Materials available are free of viruses and other harmful components."}]]]]],["span",{"class":"num"},[["textNode",{"text":"19.3"}]]],["p",{},[["textNode",{"text":"The Company offers the Program, the Model Sites, the Model Offerings, and the Licensed Materials “as is.” The Company is not making any warranty, either express or implied, including the implied warranty of merchantability, fitness for a particular purpose, and noninfringement for the Program, the Model Sites, the Model Offerings, and the Licensed Materials. No advice or information, whether oral or written, obtained from the Company or elsewhere will create any warranty not expressly stated in this agreement."}]]]]]]],["div",{"class":"sp-part","id":"part-20"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"20."}]]],["textNode",{"text":"Limit of Liability "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"20.1"}]]],["p",{},[["textNode",{"text":"The Program, the Model Sites, the Model Offerings, and the Licensed Materials may be subject to limitations, delays, and other problems inherent in the use of the Internet and electronic communications. The Company is not liable for any delays, delivery failures, or other damage resulting from those problems."}]]],["span",{"class":"num"},[["textNode",{"text":"20.2"}]]],["p",{},[["textNode",{"text":"The Company will not be liable to the Affiliate for any of the following:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" Errors, mistakes, or inaccuracies in the Program, the Model Sites, the Model Offerings, or the Licensed Materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Content or conduct that is infringing, inaccurate, obscene, indecent, offensive, threatening, harassing, defamatory, libelous, abusive, invasive of privacy, or illegal;"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Unauthorized access to or use of the Company’s servers and any personal or financial information stored in them, including unauthorized access or changes to the Affiliate’s account, transmissions, or data;"}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" Interruption or cessation of transmission to or from the Program or the Model Sites;"}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":" Denial-of-service attack (DoS) or distributed denial-of-service attack (DDoS);"}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":" Bugs, viruses, trojan horses, malware, ransomware, or other disabling code that may be transmitted to or through the Program, the Model Sites, the Model Offerings, or the Licensed Materials by any person or that might infect the Affiliate’s computer or affect the Affiliate’s access to or use of the Program, the Model Sites, the Model Offerings, the Licensed Materials, or the Affiliate’s other services, hardware, or software;"}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":" Incompatibility between the Program, the Model Sites, the Model Offerings, or the Licensed Materials and the Affiliate’s other services, hardware, or software;"}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["textNode",{"text":" Delays or failures the Affiliate might experience in starting, conducting, or completing any transmissions to or transactions through or with the Program, the Model Sites, or the Licensed Materials; or"}]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" Loss or damage incurred because of the use of any content posted, emailed, sent, or otherwise made available through the Program or the Model Sites."}]]]]],["span",{"class":"num"},[["textNode",{"text":"20.3"}]]],["p",{},[["textNode",{"text":"The Company will not be liable to the Affiliate for breach-of-contract damages that the Company could not reasonably have foreseen on entry into this agreement. The Company also will not be liable to the Affiliate—regardless of theory of liability and even if the Affiliate advised the Company of the possibility of these damages—for any damages for: (a) loss of use; (b) loss of services; (c) loss of profits; (d) loss of revenue; (e) loss of goodwill; (f) loss of contracts; (g) loss of data; (h) loss of privacy; (i) loss of business or opportunity; or (j) cost of obtaining substitute services related to the Program, the Model Sites, the Model Offerings, or the Licensed Materials."}]]],["span",{"class":"num"},[["textNode",{"text":"20.4"}]]],["p",{},[["textNode",{"text":"Except as stated in this agreement, neither party will be liable to the other party for indirect, incidental, special, statutory, exemplary, or punitive damages arising from or relating to this agreement, regardless of theory of liability and even if that party knew or should have known of the possibility of these damages, including loss of revenue or anticipated profits or lost business."}]]],["span",{"class":"num"},[["textNode",{"text":"20.5"}]]],["p",{},[["textNode",{"text":" The Company’s total cumulative liability to the Affiliate for any breach of this agreement will not exceed the greater of the total amount owed to the Affiliate under this agreement and $500 USD. "}]]]]]]],["div",{"class":"sp-part","id":"part-22"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"21."}]]],["textNode",{"text":" Scope of Disclaimers and Limitations. "}]]],["p",{},[["textNode",{"text":" The disclaimers and limits stated in sections 19 and 20 apply to the greatest extent allowed by law, but no more. The Company does not intend to deprive the Affiliate of any mandatory protections provided to the Affiliate by law. Because some jurisdictions may prohibit the disclaimer of some warranties, the limitation of some damages or other matters, one or more of the disclaimers or limitations might not apply to the Affiliate."}]]]]],["div",{"class":"sp-part","id":"part-22"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"22."}]]],["textNode",{"text":" Indemnification "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"22.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"In General."}]]],["textNode",{"text":" The Affiliate will pay the Company for any loss of the Company’s that is caused by the Affiliate’s (a) use of the Program, the Model Sites, the Model Offerings, or the Licensed Materials; (b) failure to pay taxes in connection with revenues earned under this agreement; (c) dispute with any affiliate, model, consumer, or any other person; (d) breach of this agreement, including any statement of fact in section 13.1; (e) infringement of any person’s intellectual-property rights; (f) violation of any applicable law; (g) fraudulent or deceptive conduct or trade practices; or (h) tortious or criminal acts or omissions. But the Affiliate is not required to pay if the loss was caused by the Company’s intentional misconduct."}]]],["span",{"class":"num"},[["textNode",{"text":"22.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Definitions"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"“Loss”"}]]],["textNode",{"text":" means an amount that the Company is legally responsible for or pays in any form. Amounts include, for example, a judgment, a settlement, a fine, damages, injunctive relief, staff compensation, a decrease in property value, and expenses for defending against a claim for a loss (including fees for legal counsel, expert witnesses, and other advisers). A loss can be tangible or intangible; can arise from bodily injury, property damage, or other causes; can be based on tort, breach of contract, or any other theory of recovery; and includes incidental, direct, and consequential damages."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"A loss is "}],["strong",{},[["textNode",{"text":"“caused by”"}]]],["textNode",{"text":" an event if the loss would not have occurred without the event, even if the event is not a proximate cause of the loss."}]]]]],["span",{"class":"num"},[["textNode",{"text":"22.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Company’s Duty to Notify."}]]],["textNode",{"text":" The Company will notify the Affiliate before the 15th business day after the Company knows or should reasonably have known of a claim for a loss that the Affiliate might be obligated to pay. The Company’s failure to give the Affiliate timely notice does not terminate the Affiliate’s obligation, except to the extent that the failure prejudices the Affiliate’s ability to defend the claim or mitigate losses."}]]],["span",{"class":"num"},[["textNode",{"text":"22.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Legal Defense of a Claim"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":" Company’s Control. "}]]],["textNode",{"text":" The Company has control over defending a claim for a loss (including settling it) unless the Company directs the Affiliate to control the defense."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":" Direction to Control."}]]],["textNode",{"text":" If the Company directs the Affiliate to control the defense, each of the following applies:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"The Affiliate may choose and retain legal counsel."}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":"The Company may retain its own legal counsel at its expense."}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":"The Affiliate will not settle any litigation without the Company’s written consent if the settlement (1) imposes a penalty or limitation on the Company, (2) admits the Company’s fault, or (3) does not fully release the Company from liability."}]]]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Good Faith."}]]],["textNode",{"text":" The Company and the Affiliate will cooperate with each other in good faith on a claim."}]]]]],["span",{"class":"num"},[["textNode",{"text":"22.5"}]]],["p",{},[["strong",{},[["textNode",{"text":"No Exclusivity."}]]],["textNode",{"text":" The Company’s rights under this section 22 do not affect other rights that the Company might have."}]]]]]]],["div",{"class":"sp-part","id":"part-23"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"23."}]]],["textNode",{"text":" Dispute Resolution"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"23.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Litigation Election."}]]],["textNode",{"text":" Either party may elect to litigate the following type of case or controversy: (a) an action seeking injunctive relief; (b) an action seeking to enforce or protect intellectual-property rights; (c) a dispute related to claims subject to indemnification under section 22; or (d) a suit to compel compliance with this dispute resolution provision."}]]],["span",{"class":"num"},[["textNode",{"text":"23.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Negotiation."}]]],["textNode",{"text":" Each party will give the other a reasonable opportunity to comply before it claims that the other has not met its obligations under this agreement. The parties will first meet and negotiate with each other in good faith to try to resolve all disputes between the parties relating to this agreement. The party raising a dispute will submit to the other party a written notice and supporting material describing all issues and circumstances related to the dispute (a "}],["strong",{},[["textNode",{"text":"“Dispute Notice”"}]]],["textNode",{"text":"). A primary representative designated by each party will try to resolve the dispute."}]]],["span",{"class":"num"},[["textNode",{"text":"23.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Mediation."}]]],["textNode",{"text":" If the parties’ primary representatives are unable to resolve the dispute within 30 days after receiving a Dispute Notice, either party may, by notice to the other party and the Marshal Islands International Arbitration Centre, demand mediation under the mediation rules of the Marshal Islands International Arbitration Centre. Mediation will take place in Marshal Islands. The mediation will be conducted in the English language. Each party will bear its own costs in mediation, and the parties will share equally between them all third-party mediation costs unless the parties agree differently in writing. Each party will participate actively and constructively in mediation proceedings once started and will attend at least one joint meeting between the mediator and the parties. Any party may terminate mediation at any time after an initial meeting between the mediator and the parties."}]]],["span",{"class":"num"},[["textNode",{"text":"23.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Arbitration"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" If the parties cannot settle a dispute through mediation, the parties will settle any unresolved dispute arising out of or relating to this agreement, or the breach of it, by arbitration administered by the Marshal Islands International Arbitration Centre in accordance with the Marshal Islands Arbitration Act of 2013 and any rules promulgated under it. The arbitrator, and not any court or agency, will have exclusive authority to resolve any dispute arising under or relating to the interpretation, applicability, enforceability, or formation of this agreement, including any claim that any part of this agreement is void or voidable."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" A single arbitrator will preside over the arbitration. The arbitrator may grant whatever relief would be available in a court under law or in equity, except that the arbitrator will not award punitive or exemplary damages, or damages otherwise limited or excluded in this agreement. The arbitrator will issue a final award on all issues submitted to the arbitrator, which award must set out findings of fact and conclusions of law. The arbitrator’s award will bind the parties and may be entered as a judgment in any court of competent jurisdiction."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Arbitration will take place in Marshal Islands, and the language of the arbitration will be English. The parties will bear equally the costs of arbitration, including the fees and expenses of the arbitrator, and each party will bear the costs associated with its case, except the arbitrator will award costs and fees to the Prevailing Party in accordance with section 23.7."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"Unless required by law, neither a party nor an arbitrator will disclose the existence, content, or results of any arbitration under this agreement without the advance written consent of both parties."}]]]]],["span",{"class":"num"},[["textNode",{"text":"23.5"}]]],["p",{},[["strong",{},[["textNode",{"text":"Injunctive Relief."}]]],["textNode",{"text":" The Affiliate acknowledges that breach by it of its obligations under this agreement could cause irreparable harm for which damages would be an inadequate remedy. If any breach occurs or is threatened, the Company may seek an injunction or a restraining order, in each case without posting a bond or other security."}]]],["span",{"class":"num"},[["textNode",{"text":"23.6"}]]],["p",{},[["strong",{},[["textNode",{"text":"Jurisdiction and Venue"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"If a party brings any proceeding authorized under section 23.1, that party will bring that proceeding only in the courts located in Marshal Islands, and each party hereby submits to the exclusive jurisdiction and venue of those courts for purposes of any proceeding."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"Each party hereby waives any claim that any proceeding brought in accordance with section 23.6(a) has been brought in an inconvenient forum or that the venue of that proceeding is improper."}]]]]],["span",{"class":"num"},[["textNode",{"text":"23.7"}]]],["p",{},[["strong",{},[["textNode",{"text":"Recovery of Expenses."}]]],["textNode",{"text":" In any proceedings between the parties arising out of this agreement or relating to the subject matter of this agreement, the Prevailing Party will be entitled to recover from the other party, in addition to any other relief awarded, all expenses that the Prevailing Party incurs in those proceedings, including legal fees and expenses. For purposes of this section 23.7, "}],["strong",{},[["textNode",{"text":"“Prevailing Party”"}]]],["textNode",{"text":" means, for any proceedings, the party in whose favor an award is rendered, except that if in those proceedings the award finds in favor of one party on one or more claims or counterclaims and in favor of the other party on one or more other claims or counterclaims, neither party will be the Prevailing Party. If any proceedings are voluntarily dismissed or are dismissed as part of settlement of that dispute, neither party will be the Prevailing Party in those proceedings."}]]],["span",{"class":"num"},[["textNode",{"text":"23.8"}]]],["p",{},[["strong",{},[["textNode",{"text":"Jury Trial Waiver."}]]],["textNode",{"text":" Each party hereby waives its right to a trial by jury in any proceedings arising out of or related to the subject matter of this agreement. Either party may enforce this waiver up to and including the first day of trial."}]]],["span",{"class":"num"},[["textNode",{"text":"23.9"}]]],["p",{},[["strong",{},[["textNode",{"text":"Class Action Waiver."}]]],["textNode",{"text":" The parties will conduct all proceedings to resolve a dispute in any forum on an individual basis only. Neither the Affiliate nor the Company will seek to have any dispute heard as a class action or participate in any other proceeding in which either party acts or proposes to act in a representative capacity. The parties will not combine any proceeding with another without the advanced written consent of all parties to all affected proceedings."}]]],["span",{"class":"num"},[["textNode",{"text":"23.10"}]]],["p",{},[["strong",{},[["textNode",{"text":"Limited Time to Bring Claims."}]]],["textNode",{"text":" A party will not bring a claim arising out of, or related to the subject matter of, this agreement more than one year after the cause of action first arose. Any claim brought after one year is barred."}]]]]],["div",{"class":"sp-part","id":"part-24"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"24."}]]],["textNode",{"text":" General "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"24.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Entire Agreement."}]]],["textNode",{"text":" This agreement and the "}],["a",{"href":"https://modelcentro.com/terms-of-use","class":"aff-text-color-1","rel":"nofollow","target":"_blank"},[["textNode",{"text":"Terms-of-Use Agreement"}]]],["textNode",{"text":"Terms-of-Use Agreement constitutes the entire agreement of the parties concerning the subject matter and supersedes all earlier written or oral discussions, negotiations, proposals, undertakings, understandings, and agreements between the parties concerning the subject matter. If any conflict or inconsistent exists between this agreement and the "}],["a",{"href":"https://modelcentro.com/terms-of-use","class":"aff-text-color-1","rel":"nofollow","target":"_blank"},[["textNode",{"text":"Terms-of-Use Agreement"}]]],["textNode",{"text":", this agreement will govern. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Amendment."}]]],["textNode",{"text":" The Company may change this agreement on one or more occasions, except that changes will not apply to ongoing disputes or to disputes arising out of events occurring before the posted changes. The Company will notify the Affiliate through the affiliate portal of any changes to this agreement. Changes will become effective when posted in the affiliate portal. It is the Affiliate’s responsibility to check the affiliate portal periodically for changes to this agreement. If the Affiliate continues to participate in the Program after any change, the Company will consider the Affiliate’s continued participation as acceptance of the change unless the Affiliate notifies the Company in writing of the Affiliate’s disagreement and the reasons for the Affiliate’s disagreement no later than 15 days after the change. The Company will contact the Affiliate no later than 15 days after receiving the Affiliate’s written notice to try to reach a mutually amicable resolution. If the Company is unable to resolve the Affiliate’s disagreement with the changes, the Affiliate’s sole remedy is to terminate this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"24.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Assignment and Delegation."}]]],["textNode",{"text":" The Affiliate will not assign any of its rights or delegate any performance under this agreement, except with the Company’s advance written consent. The Company may assign its rights or delegate its performances under this agreement without the Affiliate’s consent. Any purported assignment of rights or delegation of performance in breach of this section 24.3 is void."}]]],["span",{"class":"num"},[["textNode",{"text":"24.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Waivers."}]]],["textNode",{"text":" The parties may waive any provision in this agreement only by a writing signed by the party or parties against whom the waiver is sought to be enforced. No failure or delay in exercising any right or remedy, or in requiring the satisfaction of any condition, under this agreement, and no act, omission, or course of dealing between the parties, operate as a waiver or estoppel of any right, remedy, or condition. A waiver made in writing on one occasion is effective only in that instance and only for the purpose stated. A waiver once given is not to be construed as a waiver on any future occasion or against any other person."}]]],["span",{"class":"num"},[["textNode",{"text":"24.5"}]]],["p",{},[["strong",{},[["textNode",{"text":"Severability."}]]],["textNode",{"text":" The parties intend as follows:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"that if any provision of this agreement is held to be unenforceable, then that provision will be modified to the minimum extent necessary to make it enforceable, unless that modification is not permitted by law, in which case that provision will be disregarded;"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"that if modifying or disregarding the unenforceable provision would result in failure of an essential purpose of this agreement, the entire agreement will be held unenforceable;"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"that if an unenforceable provision is modified or disregarded in accordance with this section 24.5, then the rest of the agreement will remain in effect as written; and"}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"that any unenforceable provision will remain as written inany circumstances other than those in which the provision is held to be unenforceable."}]]]]],["span",{"class":"num"},[["textNode",{"text":"24.6"}]]],["p",{},[["strong",{},[["textNode",{"text":"Notices."}]]],["textNode",{"text":" All notices and other communications between the parties will be in writing. The Affiliate may send notice to the Company by email at sales@modelcentro.com. The Company may notify the Affiliate by email using email address identified in the Affiliate’s account. The Company will consider an email notice received by it only when the Company’s server sends a return message to the Affiliate acknowledging receipt. The Company will consider notices sent to the Affiliate by email received when the Company’s email service shows transmission to the Affiliate’s email address. All other notices will be effective on receipt by the party to which notice is given, or on the fifth day after mailing, whichever occurs first."}]]],["span",{"class":"num"},[["textNode",{"text":"24.7"}]]],["p",{},[["strong",{},[["textNode",{"text":"Governing Law."}]]],["textNode",{"text":" Marshal Islands law, without giving effect to its conflicts of law principles, governs all matters arising out of or relating to this agreement, including its validity, interpretation, construction, performance, and enforcement."}]]],["span",{"class":"num"},[["textNode",{"text":"24.8"}]]],["p",{},[["strong",{},[["textNode",{"text":"Force Majeure"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"If a Force Majeure Event prevents a party from complying with any one or more obligations under this agreement, that inability will not constitute a breach if (1) that party uses reasonable efforts to perform those obligations, (2) that party’s inability to perform those obligations is not due to its failure to (A) take reasonable measures to protect itself against events or circumstances of the same type as that Force Majeure Event or (B) develop and keep a reasonable contingency plan to respond to events or circumstances of the same type as that Force Majeure Event, and (3) that party complies with its obligations under section 24.8(c)."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"For purposes of this agreement, "}],["strong",{},[["textNode",{"text":"“Force Majeure Event”"}]]],["textNode",{"text":" means, for any party, any event or circumstance, whether or not foreseeable, that was not caused by that party (other than a strike or other labor unrest that affects only that party, an increase in prices or other change in general economic conditions, a change in law, or an event or circumstances that results in that party’s not having sufficient funds to comply with an obligation to pay money) and any consequences of that event or circumstance."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"If a Force Majeure Event occurs, the noncomplying party will promptly notify the other party of occurrence of that Force Majeure Event, its effect on performance, and how long the noncomplying party expects it to last. From then on, the noncomplying party will update that information as reasonably necessary. During a Force Majeure Event, the noncomplying party will use reasonable efforts to limit damages to the other party and to resume its performance under this agreement."}]]]]],["span",{"class":"num"},[["textNode",{"text":"24.9"}]]],["p",{},[["strong",{},[["textNode",{"text":"No Third-Party Beneficiaries. "}]]],["textNode",{"text":"This agreement does not, and the parties do not intend it to, confer any rights or remedies on any person other than the parties to this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"24.10"}]]],["p",{},[["strong",{},[["textNode",{"text":"Relationship of the Parties. "}]]],["textNode",{"text":"The parties intend that their relationship will be that of independent contractors and not business partners. This agreement does not, and the parties do not intend it to, create a partnership, joint venture, agency, franchise, or employment relationship between the parties and the parties expressly disclaim the existence of any of these relationships between them. Neither of the parties is the agent for the other, and neither party has the right to bind the other on any agreement with a third party. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.11"}]]],["p",{},[["strong",{},[["textNode",{"text":"Successors and Assigns."}]]],["textNode",{"text":" This agreement binds and inures to the benefit of the parties and their respective successors and assigns. This section 24.11 does not address, directly or indirectly, whether a party may assign its rights or delegate its obligations under this agreement. Section 24.3 addresses these matters. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.12"}]]],["p",{},[["strong",{},[["textNode",{"text":"Electronic Signatures."}]]],["textNode",{"text":" The Affiliate acknowledges that any affirmation, assent, or agreement the Affiliate sends through the affiliate portal in response to a prompt binds the Affiliate. The Affiliate further acknowledges that when the Affiliate clicks on an “I agree,” “I consent,” or other similarly worded “button” or entry field using a finger (for touch enabled devices), mouse, keystroke, or other device, this action is the legal equivalent of the Affiliate’s handwritten signature and binds the Affiliate in the same way. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.13"}]]],["p",{},[["strong",{},[["textNode",{"text":"Voluntary Agreement."}]]],["textNode",{"text":" The Affiliate has entered this agreement voluntarily and for valid reasons. The Affiliate acknowledges that the Affiliate (i) has carefully read this agreement, (ii) discussed it with the Affiliate’s attorneys or other advisors, (iii) understood all the terms, and (iv) will comply with it. The Affiliate has relied on the advice of the Affiliate’s attorneys or other advisors about the terms of this agreement and waives any claim that the terms should be construed against the drafter. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.14"}]]],["p",{},[["strong",{},[["textNode",{"text":"No Reliance."}]]],["textNode",{"text":" The Affiliate acknowledges that in electronically signing this agreement, that the Affiliate does not rely and has not relied on any statement by the Company or its agents, except those statements contained in this agreement. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.15"}]]],["p",{},[["strong",{},[["textNode",{"text":"Permission to Send Emails to the Affiliate."}]]],["textNode",{"text":" The Affiliate grants the Company permission to email the Affiliate notices, advertisements, and other communications, including emails, advertisements, notices, and other communications containing adult-oriented material, sexual content and language, and images of nudity unsuitable for minors. The Affiliate’s permission will continue until the Affiliate asks the Company to remove the Affiliate from the Company’s email list. For more information, please see the "}],["a",{"href":"https://modelcentro.com/privacyPolicy","target":"_blank","rel":"nofollow","class":"aff-text-color-1"},[["textNode",{"text":"Privacy Policy."}]]]]],["span",{"class":"num"},[["textNode",{"text":"24.16"}]]],["p",{},[["strong",{},[["textNode",{"text":"Feedback."}]]],["textNode",{"text":" The Company encourages the Affiliate to give feedback about the Company, the Program, the Model Sites, the Model Offerings, or the Licensed Materials. But the Company will not treat as confidential any suggestion or idea the Affiliate gives, and nothing in this agreement will restrict the Company’s right to use, profit from, disclose, publish, or otherwise exploit any feedback, without payment to the Affiliate. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.17"}]]],["p",{},[["strong",{},[["textNode",{"text":"English Language."}]]],["textNode",{"text":" The Company has drafted this agreement in the English language, and no translation into any other language will be used to interpret or construe this agreement. The Company will provide all services, support, notices, designations, specifications, and communications in the English language. "}]]]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./layout/affiliate.js": 178,
	"./sitepage/affiliates.js": 179
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Affiliate  */
(function(fox, $) {
	'use strict';

	fox.registerWidget('Layout_Affiliate', {
		configure: function(options) {
			this.registerOptions('', {
				pageContainer: '#aff-container',
				widgets: {
					loginApi: {
						widget: 'Api',
						address: '/affiliates/api.php',
						method: 'affiliate.authorizer.auth'
					},
					recoveryPassApi: {
						widget: 'Api',
						address: '/affiliates/api.php',
						method: 'passwordRecovery.sendRecoveryMail',
						handleWom: {
							recoveryApiResponse: {
								event: ['success', 'error', 'failure'],
								widget: '@this',
								callback: '@parent:recoveryApiResponse'
							}
						}
					},
					clientDataApi: {
						widget: 'Api',
						address: '/affiliates/api.php',
						method: 'affiliate.getModelFrontData',
						'handleWom.cdaApiSuccess': {
							event: 'success',
							widget: '@this',
							callback: '@parent:cdaApiSuccess'
						}
					},
					recoveryPass: {
						widget: 'Widget',
						active: false,
						group: 'popup',
						autoRender: true,
						'embed.container': '#aff-popup-container',
						template: 'sitepage_affiliates_popup_pass_recovery',
						'widgets.recoveryForm': {
							widget: 'Form',
							loadValuesOnRun: false,
							autoApply: true,
							formElements: {
								email: {element: '[name=recpassemail]'}
							},
							submit: {
								event: 'click',
								target: '#aff-pass-request'
							},
							'hooks.onSubmit': '@parent @parent:onPassRecovery',
							'widgets.validator': {
								widget: 'Easy_Form_Validator',
								hangClassLocation: 'parentNode',
								requiredFields: ['email'],
								formWidget: '@parent',
								defaultValidator: [{
									validator: 'length',
									options: {min: 1},
									message: 'This field is required'
								}]
							}
						}
					},
					loginForm1: {
						widget: 'Form',
						loadValuesOnRun: false,
						autoApply: true,
						formElements: {
							email1: {element: '[name=email1]'},
							passwd1: {element: '[name=passwd1]'}
						},
						submit: {
							event: 'click',
							target: '#aff-login'
						},
						'hooks.onSubmit': '@parent:onLogin',
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							hangClassLocation: 'parentNode',
							requiredFields: ['email1', 'passwd1'],
							formWidget: '@parent',
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'This field is required'
							}]
						}
					},
					loginError: {
						widget: 'Widget',
						autoRender: true,
						active: false,
						group: 'popup',
						'embed.container': '#aff-popup-container',
						template: 'sitepage_affiliates_popup_login_error'
					},
					popupLogin: {
						widget: 'Widget',
						autoRender: true,
						active: true,
						group: 'popup',
						'embed.container': '#aff-popup-container',
						template: 'sitepage_affiliates_popup_login_form',
						'widgets.loginForm2': {
							widget: 'Form',
							loadValuesOnRun: false,
							autoApply: true,
							formElements: {
								email2: {element: '[name=email2]'},
								passwd2: {element: '[name=passwd2]'}
							},
							submit: {
								event: 'click',
								target: '#aff-login-on-popup'
							},
							'hooks.onSubmit': '@parent @parent:onLogin',
							'widgets.validator': {
								widget: 'Easy_Form_Validator',
								hangClassLocation: 'parentNode',
								requiredFields: ['email2', 'passwd2'],
								formWidget: '@parent',
								defaultValidator: [{
									validator: 'length',
									options: {min: 1},
									message: 'This field is required'
								}]
							}
						}
					}
				},
				handleWom: {
					loginApiResponse: {
						widget: '#loginApi',
						event: ['success', 'failure'],
						callback: '_loginApiResponse'
					}
				},
				handleDom: {
					showLoginForm: {
						event: 'click',
						target: ['#aff-fake-login', '#aff-close-login-popup'],
						callback: 'showHideLoginForm'
					},
					tryLoginAgain: {
						event: 'click',
						target: '#aff-login-try-again',
						targetWidget: '#loginError',
						callback: 'tryLoginAgain'
					},
					clickOnDesktop: {
						event: 'click',
						target: '#aff-login',
						callback: function () {
							this.clickOnDesktop = true;
						}
					},
					passRecovery: {
						event: 'click',
						target: '.forgot',
						callback: 'passRecovery'
					},
					passRecovery2: {
						event: 'click',
						target: '.forgot',
						targetWidget: '#popupLogin',
						callback: 'passRecovery'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.clickOnDesktop = false;	
		
			this.callParent('init', arguments);
		},

		onLogin: function (formData) {
			var data = {};

			fox.each(formData, function (val, alias) {
				var a = alias.slice(0, -1);

				data[a] = fox.trim(val);
			});

			this.rwom1('#loginApi').send(data, false);
		},

		_loginApiResponse: function (data) {
			var response = data.answer.response;

			if (!data.answer.status) {
				this.showLoginError();

				return;
			}

			if (response && !response.member) {
				return;
			}

			document.location.href = 'https://centroprofits.com';
		},

		showHideLoginForm: function (el) {
			var popup, overlay;
			
			if (el && el.getAttribute('id') === 'aff-fake-login' &&
				!this.rwom1('#popupLogin').isActive()) {
				this.switchEmbeddedWidget('popupLogin');
			}

			popup = this.dom1('#aff-login-popup');
			overlay = this.dom1('.aff-overlay');

			if ($(popup).is(':visible') && $(overlay).is(':visible')) {
				$(popup).removeClass('bounceInDown').addClass('bounceOutUp');
				$(overlay).removeClass('fadeIn').addClass('fadeOut');

				setTimeout(function () {
					$(popup).removeClass('visible animated bounceOutUp');
					$(overlay).removeClass('visible animated fadeOut');
				}, 1000);
			} else {
				$(popup).addClass('visible animated bounceInDown');
				$(overlay).addClass('visible animated fadeIn');
			}
		},

		showLoginError: function () {
			var popup;

			popup = this.dom1('#aff-login-popup');

			if (!this.rwom1('#loginError').isActive()) {
				this.switchEmbeddedWidget('loginError');
			}

			if (!$(popup).is(':visible')) {
				this.showHideLoginForm();
			}
		},

		tryLoginAgain: function () {
			if (this.clickOnDesktop === true) {
				this.showHideLoginForm();
				this.clickOnDesktop = false;

				return;
			}

			if (this.rwom1('#loginError').isActive()) {
				this.switchEmbeddedWidget('popupLogin');
			}
		},

		passRecovery: function () {
			var popup;

			popup = this.dom1('#aff-login-popup');

			this.switchEmbeddedWidget('recoveryPass');

			if (!$(popup).is(':visible')) {
				this.showHideLoginForm();
			}
		},

		onPassRecovery: function (formData) {
			formData.domainProd = 1;
			this.rwom1('#recoveryPassApi').send(formData);
		},

		recoveryApiResponse: function (res) {
			var label;

			res = res.answer.response;
			
			if (res.success === false) {
				label = this.rwom1('#recoveryPass').dom1('label');
				label.innerText = res.text;
				fox.dom.addClass('error', label.parentNode);
			} else {
				this.showHideLoginForm();
			}
		},

		render: function () {
			if (!this.clientData) {
				this.getClientData();
			} else {
				this.setTemplateOptions(this.clientData);
				this.callParent('render', arguments);
				this.rwom1('.Site_Page').render();
			}
		},

		getClientData: function () {
			//this.rwom1('#clientDataApi').send(); fix for AMC-17575

			return this;
		},

		cdaApiSuccess: function (res) {
			this.clientData = res.answer.response;

			this.render();
		}

	}, 'Site_Layout');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('SitePage_Affiliates', {
		configure: function () {
			this._defPayMethods = {
				widget: 'Widget',
				group: 'payoutMethods',
				active: false,
				autoRender: true,
				'embed.container': '#aff-methods-container'
			};

			this.registerOptions('', {
				autoRender: true,
				widgets: {
					checkMethod: fox.merge({
						template: 'sitepage_affiliates_check_method'
					}, this._defPayMethods),
					paxumMethod: fox.merge({
						template: 'sitepage_affiliates_paxum_method'
					}, this._defPayMethods),
					payoneerMethod: fox.merge({
						template: 'sitepage_affiliates_payoneer_method'
					}, this._defPayMethods),
					wireMethod: fox.merge({
						template: 'sitepage_affiliates_wire_method'
					}, this._defPayMethods),
					signupApi: {
						widget: 'Api',
						method: 'affiliate.register',
						address: '/affiliates/api.php'
					},
					signUpSuccessMessage: {
						widget: 'Widget',
						template: 'sitepage_affiliates_signup_success_message',
						'embed.container': '#aff-reg-block',
						active: false,
						group: 'regForm',
						autoRender: true
					},
					regFormBlock: {
						widget: 'Widget',
						autoRender: true,
						active: true,
						group: 'regForm',
						template: 'sitepage_affiliates_reg_form_block',
						'embed.container': '#aff-reg-block',
						'widgets.mainForm': {
							widget: 'Form',
							loadValuesOnRun: false,
							autoApply: true,
							formElements: {
								screenName: {element: '[name=screenName]'},
								domain: {
									element: '[name=domain]',
									validate: [{validator: 'regexp', options: {regexp: fox.regexp.url}, message: 'Wrong domain name format'}]
								},
								company: {element: '[name=company]'},
								email: {
									element: '[name=email]',
									validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}]
								},
								phone: {element: '[name=phone]'},
								socialAcount: {element: '[name=socialAcount]'},
								socialIdentity: {element: '[name=socialIdentity]'},
								firstName: {element: '[name=firstName]'},
								lastName: {element: '[name=lastName]'},
								address: {element: '[name=address]'},
								addressCont: {element: '[name=addressCont]'},
								city: {element: '[name=city]'},
								state: {element: '[name=state]'},
								zip: {element: '[name=zip]'},
								country: {element: '[name=country]'},
								'consent_tos': {element:'[name=consent_tos]'},
								'consent_marketing': {element: '[name=consent_marketing]'}
							},
							submit: {
								target: '#signup',
								event: 'click'
							},
							'hooks.onSubmit': '@parent @parent:submitSignUp',
							'widgets.validator': {
								widget: 'Easy_Form_Validator',
								hangClassLocation: 'parentNode',
								requiredFields: ['screenName', 'domain', 'phone', 'email', 'lastName', 'firstName', 'consent_tos'],
								formWidget: '@parent',
								defaultValidator: [{
									validator: 'length',
									options: {min: 1},
									message: 'This field is required'
								}]
							}
						},
						handleDom:{
							focus: {
								target: 'input[name]',
								event: 'focus',
								callback: '@parent:_handleFocus'
							}
						}
					}
				},
				handleWom: {
					formError: {
						event: 'formNotValid',
						widget: '#regFormBlock #mainForm #validator',
						callback: 'mainFormNotValid'
					},
					signupApiResponse: {
						event: ['success', 'error', 'failure'],
						widget: '#signupApi',
						callback: 'signupApiResponse'
					},
					elementsUpdated: {
						widget: '#regFormBlock #mainForm',
						event: 'elementsUpdated',
						callback: 'checkMarketingConsent'
					}
				},
				handleDom: {
					customizeSelect: {
						event: 'change',
						target: 'select',
						targetWidget: '#regFormBlock',
						callback: 'handleChange'
					},
					selectMethod: {
						event: 'change',
						target: '[name=payoutMethods]',
						targetWidget: '#regFormBlock',
						callback: 'selectMethod'
					},
					scrollTo: {
						event: 'click',
						target: ['#aff-scroll-to-register', '#aff-scroll-to-login', '#aff-scroll-to-register_join'],
						callback: 'scrollTo'
					},
					showLogin: {
						event: 'click',
						target: '#aff-fake-scroll-to-login',
						callback: '@parent:showHideLoginForm'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		running: function () {
			if (!fox.site.getOption('hasAffiliate')) {
				fox.site._gotoPage('404');
				return;
			}
			this.mf = this.rwom1('#regFormBlock #mainForm');

			this.handleEvent('#regFormBlock', 'addedToDom', 'customizeOnAdd');	
		
			this.callParent('running', arguments);
		},

		handleChange: function (el) {
			this._customizeSelect(el);
		},

		_customizeSelect: function (el) {
			var curValue;

			if ((curValue = $(el).parent().find('.selected-text'))) {
				curValue.text($(el).find('option:selected').text());
			}
		},

		customizeOnAdd: function (o, p) {
			fox.each(p.dom('select'), this._customizeSelect);
		},

		selectMethod: function (el) {
			try {
				this.switchEmbeddedWidget(el.value);
			} catch (e) {
				
			}
		},

		scrollTo: function (el) {
			$('body, html').animate({
				scrollTop: $($(el).data('scroll-to')).offset().top
			}, 500);
		},

		submitSignUp: function () {
			var api, formData;

			api =  this.rwom1('#signupApi');
			formData = this.mf.collectData();

			api.send(formData);

		},

		_handleFocus: function (el) {
			$(el).parent().removeClass('error').find('.error-container').text('');
		},

		mainFormNotValid: function (data) {
			fox.each(data.errorStack, function (val, alias) {
				var err = val[0];

				$(this.dom1('[name="' + alias + '"]'))
					.parent()
					.find('.error-container')
					.text(err.message);
			}, this);
		},

		signupApiResponse: function (res) {
			if (res.answer.response) {
				this.switchEmbeddedWidget('signUpSuccessMessage');
			}
			// temporary
			if (!res.answer.status) {
				var field;

				field = this.rwom1('#regFormBlock').dom1('[name=email]');

				fox.dom.addClass('error', field.parentNode);

				$(field).next().find('.error-container').text(res.answer.reason);
			}
		},

		rendering: function () {
			this.setTemplateOptions(this.getParent().clientData);

			this.callParent('rendering', arguments);
		},

		checkMarketingConsent: function() {
			if (fox.getEnv('defaultMarketingConsentValue') === 'true') {
				this.wom1('#regFormBlock #mainForm #consent_marketing').setValue(true);
			}
		}

	}, 'Site_Page');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(181);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_root-index.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_root-index.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".mc-common-button{display:inline-block;border-radius:2px;line-height:32px;height:32px;border:1px solid transparent;background-color:rgba(0,0,0,.3);color:#fff;padding:0 10px;text-align:center;min-width:100px;font-size:inherit;text-transform:uppercase;position:relative;text-decoration:none;cursor:pointer}.mc-common-button *,.mc-common-button :after,.mc-common-button :before{box-sizing:border-box}.mc-common-button:hover{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}.mc-common-button:hover.no-hover{-ms-filter:none;filter:none;opacity:1}.mc-common-button:disabled,.mc-common-button:disabled:hover{cursor:auto;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.mc-common-button.simple{background-color:transparent;border-color:rgba(0,0,0,.3)}.mc-common-button:before{content:\"\";top:50%;margin-top:-10px;display:block;width:19px;height:19px;position:absolute;background-repeat:no-repeat;background-position:0 0;left:10px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.mc-common-button.spin{padding-left:40px}.mc-common-button.spin:before{animation:play 1s steps(28) infinite;-ms-filter:none;filter:none;opacity:1}.mc-common-button input[type=submit]{width:100%;position:absolute;left:0;top:0;right:0;bottom:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;z-index:1;cursor:pointer}.mc-common-input{border:1px solid rgba(0,0,0,.3);border-radius:2px}.mc-common-input *,.mc-common-input :after,.mc-common-input :before{box-sizing:border-box}.mc-common-input input[type=password],.mc-common-input input[type=text],.mc-common-input textarea{border-color:rgba(0,0,0,.3);background-color:transparent;display:block;width:100%;height:100%;padding-left:10px;padding-right:10px;color:inherit;border-width:0}.mc-common-input input[type=password],.mc-common-input input[type=text]{height:30px;line-height:30px;border-radius:2px}.mc-common-input textarea{min-height:60px;padding-top:10px;padding-bottom:10px;line-height:normal;border-radius:2px}.mc-common-input input:-webkit-autofill,.mc-common-input select:-webkit-autofill,.mc-common-input textarea:-webkit-autofill{border-color:rgba(0,0,0,.3);background-color:transparent}.select-wrapper{height:32px;line-height:32px;position:relative;border-radius:2px;text-align:left;background-color:rgba(0,0,0,.3);color:#fff;border:1px solid transparent}.select-wrapper select{display:block;width:100%;height:30px;position:absolute;left:0;top:0;z-index:2;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.select-wrapper .selected{padding:0 25px 0 12px}.select-wrapper .arr{position:absolute;right:12px;font-size:8px;top:12px;transform:rotate(90deg);z-index:1}.select-wrapper.error{border-color:rgba(255,0,0,.3)}.nsl-wrapper{position:relative;transition:opacity .5s,height .4s,transform .4s}.nsl-wrapper.removed{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;height:0;transform:rotateX(-90deg)}.nsl-content{border-radius:2px;padding:30px 0}.nsl-content .nsl-editable{margin-right:3%}.nsl-content .nsl-form{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.nsl-content .nsl-form .common-btn,.nsl-content .nsl-form .common-input{-moz-flex:1 auto;-ms-flex:1 auto;flex:1 auto}.nsl-content .nsl-form .common-input:nth-child(3){margin:0 10px}.nsl-content .nsl-editable-2{margin-top:25px;text-align:center;font-style:italic;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}@media screen and (max-width:540px){.nsl-content,.nsl-content .nsl-form{-ms-flex-flow:column nowrap;flex-flow:column nowrap}.nsl-content{padding:30px 5%}.nsl-content .nsl-form{width:100%}}@media screen and (min-width:740px){.nsl-content .nsl-form .field-set{width:45%;margin-right:5%}.nsl-content .nsl-form .field-set.btns{width:auto;margin-right:0}.nsl-content .nsl-form .consent-text{min-width:100%}}#cancellation-overlay{background:url(" + __webpack_require__(182) + ") no-repeat 100% 0;background-size:cover;position:fixed;top:0;left:0;width:100%;height:100%;z-index:1000;overflow-x:hidden;overflow-y:auto}#cancellation-overlay *{box-sizing:border-box}#cancellation-overlay .overlay-content{line-height:2em;font-size:13px;font-family:pt_sansregular,Arial;text-align:center;position:absolute;top:0;left:0;width:100%;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;min-height:100%}#cancellation-overlay .overlay-content a:hover{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}#cancellation-overlay .overlay-content .cancellation-main{max-width:980px;padding:30px;margin:0 auto;width:100%}#cancellation-overlay .overlay-content .main-text{letter-spacing:4px;font-size:18px;font-family:pt_sansbold,Arial}#cancellation-overlay .overlay-content .general-text{letter-spacing:10px;padding:18px 0 30px;line-height:1em;font-size:60px;font-family:pt_sansbold,Arial}#cancellation-overlay .overlay-content .submit-box{margin-top:35px;margin-bottom:13px;width:100%;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}#cancellation-overlay .overlay-content .submit-box .line-decor{-moz-flex:1;-ms-flex:1;flex:1;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;height:1px;max-width:100%;width:30%}#cancellation-overlay .overlay-content .submit-box .submit-btn{white-space:nowrap;font-family:pt_sansbold,Arial;letter-spacing:1px;display:inline-block;border-radius:2px;padding:10px 32px;font-size:16px;text-align:center;text-transform:uppercase;position:relative;text-decoration:none;cursor:pointer}#cancellation-overlay .overlay-content .submit-box .submit-btn-box{margin-left:30px;margin-right:30px}#cancellation-overlay .overlay-content .cancellation-content{width:100%}#cancellation-overlay .overlay-content .cancellation-content .cancellation-main{width:100%;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}#cancellation-overlay .overlay-content .cancellation-content .cancellation-info{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-item-align:stretch;align-self:stretch;-ms-flex-pack:space-around;-moz-justify-content:space-around;justify-content:space-around;max-width:38%;width:38%;border-radius:2px}#cancellation-overlay .overlay-content .cancellation-content .cancellation-info .inner{padding:5% 20px}#cancellation-overlay .overlay-content .cancellation-content .bigger-text{font-size:14px;font-family:pt_sansbold,Arial}#cancellation-overlay .overlay-content .cancellation-content .price{padding:4% 20px}#cancellation-overlay .overlay-content .cancellation-content .old-price{font-size:16px;margin-bottom:5px;font-family:pt_sansbold,Arial;position:relative}#cancellation-overlay .overlay-content .cancellation-content .old-price:after{content:\"\";height:1px;position:absolute;top:10px;left:44%;width:35px;transform:rotate(-43deg)}#cancellation-overlay .overlay-content .cancellation-content .new-price{text-transform:uppercase;font-size:24px;font-family:pt_sansbold,Arial}#cancellation-overlay .overlay-content .cancellation-content .site-logo-box{display:-moz-flex;display:-ms-flexbox;display:flex;height:69px;width:100%;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;margin-bottom:10px}#cancellation-overlay .overlay-content .cancellation-content .site-logo-box .site-logo{max-height:100%;max-width:100%}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs{position:relative;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-item-align:stretch;align-self:stretch;-ms-flex-line-pack:space-between;align-content:space-between;-moz-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;margin-left:30px}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb-item{-moz-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;margin-top:20px;min-width:40%;width:40%}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb-item:nth-child(2n){margin-left:20px}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb-item:first-child,#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb-item:nth-child(2){margin-top:0}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb{height:0;padding-bottom:56.25%;background-repeat:no-repeat;background-size:cover;border-radius:2px}#cancellation-overlay .overlay-content .cancellation-footer{padding-top:13px}#cancellation-overlay .overlay-content .cancellation-footer .exit-box{font-family:pt_sansbold,Arial;font-size:11px;margin-top:37px}#cancellation-overlay .overlay-content .cancellation-footer .exit-box .icon{font-size:17px;vertical-align:-3px;margin-right:8px}@media (max-width:900px){#cancellation-overlay{background-image:url(" + __webpack_require__(183) + ")}}@media (max-width:900px) and (min-width:641px){#cancellation-overlay .overlay-content .general-text{font-size:45px}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs{width:280px;max-width:280px;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:none;flex-wrap:nowrap}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb-item{width:100%}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb-item:nth-child(3),#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb-item:nth-child(4){display:none}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb-item:nth-child(2n){margin-left:0}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs .thumb-item:nth-child(2){margin-top:20px}#cancellation-overlay .overlay-content .cancellation-content .cancellation-info{max-width:70%;-moz-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}}@media (max-width:640px){#cancellation-overlay .overlay-content .general-text{font-size:35px;letter-spacing:2px;padding-bottom:20px}#cancellation-overlay .overlay-content .submit-box{margin-bottom:0;margin-top:20px}#cancellation-overlay .overlay-content .submit-box .submit-btn-box{margin-left:10px;margin-right:10px}#cancellation-overlay .overlay-content .submit-box .submit-btn{padding-left:15px;padding-right:15px}#cancellation-overlay .overlay-content .cancellation-content .cancellation-main{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;-moz-align-items:stretch;align-items:stretch;padding:20px}#cancellation-overlay .overlay-content .cancellation-content .cancellation-thumbs{margin-left:0;margin-top:30px}#cancellation-overlay .overlay-content .cancellation-content .cancellation-info{max-width:100%;width:100%}}@media (max-width:400px){#cancellation-overlay .overlay-content .general-text{font-size:30px;letter-spacing:0}#cancellation-overlay .overlay-content .main-text{font-size:16px;letter-spacing:2px}}#cancellation-overlay a{color:#fff}#cancellation-overlay .overlay-content{background-color:rgba(32,31,34,.92);color:#fff}#cancellation-overlay .overlay-content .submit-btn{color:#fff;background-color:hsla(0,0%,100%,.15)}#cancellation-overlay .overlay-content .line-decor{background-color:hsla(0,0%,100%,.15)}#cancellation-overlay .overlay-content .cancellation-content{background-color:hsla(0,0%,100%,.03)}#cancellation-overlay .overlay-content .cancellation-content .price{background-color:hsla(0,0%,100%,.05)}#cancellation-overlay .overlay-content .cancellation-info{background-color:#201f22}#cancellation-overlay .overlay-content .old-price{color:hsla(0,0%,100%,.3)}#cancellation-overlay .overlay-content .old-price:after{background-color:#fff}.cancellation-offers{width:100%;position:relative;padding:50px 0;line-height:22px}.cancellation-offers .title-block{text-align:center;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.cancellation-offers .title-block .text{font-weight:700;font-size:12px;padding-bottom:5px}.cancellation-offers .title-block .title{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-item-align:center;align-self:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}.cancellation-offers .title-block .line{height:3px;width:120px;-moz-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;display:none;background-color:#ccc}.cancellation-offers .title-block .global-title{margin-bottom:0;padding:0 30px}.cancellation-offers .list-items-wrap{display:-moz-flex;display:-ms-flexbox;display:flex;margin:50px 0 40px}.cancellation-offers .list-items{-moz-flex:1;-ms-flex:1;flex:1;margin:0;text-align:center;overflow:hidden}.cancellation-offers .list-items .item{outline:none}.cancellation-offers .list-items .item-wrap{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center}.cancellation-offers .list-items .photo{width:236px;height:236px;box-sizing:border-box;border-width:8px;border-style:solid;border-radius:50%;overflow:hidden;margin-bottom:25px}.cancellation-offers .list-items .photo a{display:block;width:100%;height:100%}.cancellation-offers .list-items .photo img{width:100%}.cancellation-offers .list-items .name{font-size:30px;font-family:simplifica;margin-bottom:10px}.cancellation-offers .list-items .price{margin-bottom:20px}.cancellation-offers .list-items .price .old{font-size:18px;font-weight:700;padding-right:10px;display:inline-block;position:relative}.cancellation-offers .list-items .price .old .amount{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.cancellation-offers .list-items .price .old:before{content:\"\";display:block;width:32px;height:1px;position:absolute;top:50%;left:50%;margin-left:-16px;transform:rotate(-45deg);z-index:1}.cancellation-offers .list-items .price .new{font-size:24px;font-weight:700;display:inline-block}.cancellation-offers .list-items .btn-join{line-height:30px}.cancellation-offers .arrow{width:20px;height:58px;font-size:18px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;cursor:pointer;margin-top:90px;outline:none}.cancellation-offers .arrow.slick-disabled,.cancellation-offers .arrow.slick-hidden{cursor:default;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.cancellation-offers .arrow-prev{border-radius:0 3px 3px 0}.cancellation-offers .arrow-next{border-radius:3px 0 0 3px}.cancellation-offers .description{text-align:center;font-size:12px}.mc-site-common-popup.offermodel-popup{max-width:450px}.mc-site-common-popup.offermodel-popup .mc-common-button{line-height:22px}@media (min-width:960px){.cancellation-offers .list-items{margin:0 55px}}@media (min-width:768px){.cancellation-offers .title-block .text{font-size:16px}}@media (min-width:480px){.cancellation-offers .title-block .line{display:block}.cancellation-offers .list-items{margin:0 20px}.cancellation-offers .arrow{width:51px}}.success-canceled.pad-tb{padding-bottom:0}.success-canceled .success-canceled-page{border-width:3px 0 0;border-style:solid}.success-canceled .success-canceled-page .btn-to-account{line-height:32px;font-size:12px}.success-canceled .success-canceled-page .offers-list{margin-top:60px}.offer-modelrelated-popup .common-input-holder{position:relative}@media (max-width:668px){.offer-modelrelated-popup .popup-footer-wrapper.multiple-btns #join{-moz-order:1;-ms-flex-order:1;order:1;margin-bottom:15px}.offer-modelrelated-popup .popup-footer-wrapper.multiple-btns #cancel{-moz-order:2;-ms-flex-order:2;order:2;margin-bottom:0}}.content-actions.new-wrap .more-actions-container .fav-link .action-link-text{padding-left:7px}.rating-new{min-width:120px;margin-right:15px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:baseline;-moz-align-items:baseline;align-items:baseline}.rating-new .rating-separate{margin:0 20px;width:1px;height:auto;background-color:rgba(250,92,107,.3);font-size:0;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center}.rating-new .rate{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:baseline;-moz-align-items:baseline;align-items:baseline}.rating-new .rate .num{font-size:14px;display:inline-block}.rating-new .rate i{position:relative}.rating-new .rate.bad .rating-icon{top:6px}.rating-new .rate.good .rating-icon{top:1px}[data-widget-class=Layout_Stateoff].wrapper{background-color:#201f22;color:#fff}.stateoff-container .errors-block,.stateoff-tips-popup .errors-block{color:#d8455a}.stateoff-container .mc-common-input,.stateoff-tips-popup .mc-common-input{background-color:rgba(0,0,0,.15);border-color:hsla(0,0%,100%,.15)}.stateoff-container .mc-common-input.error,.stateoff-tips-popup .mc-common-input.error{border-color:#d8455a}.stateoff-container .mc-common-input.error+.error-message,.stateoff-tips-popup .mc-common-input.error+.error-message{color:#d8455a}.stateoff-container .mc-common-input input[type=password],.stateoff-container .mc-common-input input[type=text],.stateoff-container .mc-common-input textarea,.stateoff-tips-popup .mc-common-input input[type=password],.stateoff-tips-popup .mc-common-input input[type=text],.stateoff-tips-popup .mc-common-input textarea{color:#fff}.stateoff-container .mc-common-input input[type=password]::-webkit-input-placeholder,.stateoff-container .mc-common-input input[type=text]::-webkit-input-placeholder,.stateoff-container .mc-common-input textarea::-webkit-input-placeholder,.stateoff-tips-popup .mc-common-input input[type=password]::-webkit-input-placeholder,.stateoff-tips-popup .mc-common-input input[type=text]::-webkit-input-placeholder,.stateoff-tips-popup .mc-common-input textarea::-webkit-input-placeholder{color:hsla(0,0%,100%,.3)}.stateoff-container .mc-common-input input[type=password]:-moz-placeholder,.stateoff-container .mc-common-input input[type=password]::-moz-placeholder,.stateoff-container .mc-common-input input[type=text]:-moz-placeholder,.stateoff-container .mc-common-input input[type=text]::-moz-placeholder,.stateoff-container .mc-common-input textarea:-moz-placeholder,.stateoff-container .mc-common-input textarea::-moz-placeholder,.stateoff-tips-popup .mc-common-input input[type=password]:-moz-placeholder,.stateoff-tips-popup .mc-common-input input[type=password]::-moz-placeholder,.stateoff-tips-popup .mc-common-input input[type=text]:-moz-placeholder,.stateoff-tips-popup .mc-common-input input[type=text]::-moz-placeholder,.stateoff-tips-popup .mc-common-input textarea:-moz-placeholder,.stateoff-tips-popup .mc-common-input textarea::-moz-placeholder{color:hsla(0,0%,100%,.3)}.stateoff-container .mc-common-input input[type=password]:-ms-input-placeholder,.stateoff-container .mc-common-input input[type=text]:-ms-input-placeholder,.stateoff-container .mc-common-input textarea:-ms-input-placeholder,.stateoff-tips-popup .mc-common-input input[type=password]:-ms-input-placeholder,.stateoff-tips-popup .mc-common-input input[type=text]:-ms-input-placeholder,.stateoff-tips-popup .mc-common-input textarea:-ms-input-placeholder{color:hsla(0,0%,100%,.3)}.stateoff-container .mc-common-input textarea::-webkit-input-placeholder,.stateoff-tips-popup .mc-common-input textarea::-webkit-input-placeholder{color:hsla(0,0%,100%,.3)}.stateoff-container .mc-common-input textarea:-moz-placeholder,.stateoff-container .mc-common-input textarea::-moz-placeholder,.stateoff-tips-popup .mc-common-input textarea:-moz-placeholder,.stateoff-tips-popup .mc-common-input textarea::-moz-placeholder{color:hsla(0,0%,100%,.3)}.stateoff-container .mc-common-input textarea:-ms-input-placeholder,.stateoff-tips-popup .mc-common-input textarea:-ms-input-placeholder{color:hsla(0,0%,100%,.3)}.stateoff-container .mc-common-button,.stateoff-tips-popup .mc-common-button{background-color:hsla(0,0%,100%,.15);border-color:transparent;color:#fff}.stateoff-container .stateoff-page-bg-overlay{background-color:rgba(32,31,34,.92)}.stateoff-container .avatar-img{border-color:#39383c}.stateoff-container .avatar-line,.stateoff-container .h-separator{background-color:hsla(0,0%,100%,.15)}.stateoff-container a{color:#fff}.stateoff-container .authorization .caption{color:hsla(0,0%,100%,.3)}.stateoff-container .authorization .capcha-wrapper{border-color:hsla(0,0%,100%,.15)}.stateoff-container .authorization .reload-captcha{border-left-color:hsla(0,0%,100%,.15)}.stateoff-container .tipme .caption{color:hsla(0,0%,100%,.3)}.stateoff-container .tipme .tip-btn{background-color:hsla(0,0%,100%,.15)}.stateoff-container .tipme .icon{color:hsla(0,0%,100%,.25)}.stateoff-container .find-me .caption{color:hsla(0,0%,100%,.3)}.stateoff-container .find-me a{color:hsla(0,0%,100%,.2)}.stateoff-container .contact{color:hsla(0,0%,100%,.3)}.stateoff-tips-popup{background-color:#1f1e21}.stateoff-tips-popup .popup-title{color:#fff}.stateoff-tips-popup .tips-popup-notice{color:hsla(0,0%,100%,.3)}.stateoff-tips-popup .stateoff-icon-close_9{color:#fff}.stateoff-dialog~.ui-widget-overlay{background-color:rgba(0,0,0,.8)}.site-closed .find-me .caption,.site-closed .find-me a{color:#fff}[data-widget-class=Layout_Stateoff].wrapper{max-width:100%;min-height:100vh;font-family:pt_sansregular;background-image:none}.stateoff-container .mc-common-input,.stateoff-tips-popup .mc-common-input{margin-bottom:10px;height:35px;border-width:1px;border-style:solid;border-radius:2px;padding:0;overflow:hidden;display:block;box-sizing:border-box}.stateoff-container .mc-common-input.error+.error-message,.stateoff-tips-popup .mc-common-input.error+.error-message{margin:-5px 0 5px;font-size:11px}.stateoff-container .mc-common-input input[type=password],.stateoff-container .mc-common-input input[type=text],.stateoff-tips-popup .mc-common-input input[type=password],.stateoff-tips-popup .mc-common-input input[type=text]{font-size:12px;border-radius:0;height:35px;line-height:normal;padding:10px;font-family:pt_sansregular;margin:0}.stateoff-container .mc-common-input textarea,.stateoff-tips-popup .mc-common-input textarea{font-size:12px;border-radius:0;height:60px;font-family:pt_sansregular;margin:0}.stateoff-container .mc-common-input.textarea,.stateoff-tips-popup .mc-common-input.textarea{height:60px}.stateoff-container .mc-common-button,.stateoff-tips-popup .mc-common-button{font-family:pt_sansbold;font-size:12px;padding:0 20px;min-width:70px;height:35px;line-height:35px;letter-spacing:1px;border-radius:2px}.stateoff-container .mc-common-button:hover,.stateoff-tips-popup .mc-common-button:hover{transform:none}.stateoff-container .login-form-error-message,.stateoff-tips-popup .login-form-error-message{font-size:13px;margin-bottom:20px;text-align:center}.stateoff-container .forgotform_container .login-form-error-message,.stateoff-tips-popup .forgotform_container .login-form-error-message{display:block}.stateoff-container .forgotform_container .login-form-error-message:empty,.stateoff-tips-popup .forgotform_container .login-form-error-message:empty{display:none}#container.stateoff-container{min-height:100vh;width:100%;float:none}.stateoff-container a{text-decoration:none}.stateoff-container .fox-dictionary p{display:inline}.stateoff-container .stateoff-page-bg{position:fixed;z-index:1;top:0;left:0;width:100%;height:100%;background-image:none;background-position:50% 50%;background-repeat:no-repeat;background-size:cover}.stateoff-container .stateoff-page-bg-overlay{width:100%;height:100%}.stateoff-container .stateoff-page{min-height:100vh;position:relative;z-index:2}.stateoff-container .stateoff-page-wrap{max-width:960px;margin:0 auto;height:100%;padding:30px 30px 60px}.stateoff-container .h-separator{height:1px}.stateoff-container .avatar-wrap{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}.stateoff-container .avatar-img{margin:0 15px;width:64px;height:64px;min-width:64px;min-height:64px;border-radius:64px;border-width:4px;border-style:solid;overflow:hidden}.stateoff-container .avatar-img img{width:100%;height:auto}.stateoff-container .avatar-line{height:1px;width:100%}.stateoff-container .avatar-name{text-transform:uppercase;text-align:center;padding-top:15px;font-size:12px;letter-spacing:3px}.stateoff-container .info-text{font-size:16px;text-align:center;text-transform:uppercase;letter-spacing:3px;line-height:1.9;padding:30px 0 40px;margin:0 auto;max-width:270px}.stateoff-container .subscribe{max-width:625px;margin:0 auto}.stateoff-container .subscribe .nsl-wrapper{border:0}.stateoff-container .subscribe .caption{text-align:center;line-height:1.5;font-size:13px;margin-bottom:15px}.stateoff-container .subscribe .btns{text-align:center;margin-top:20px}.stateoff-container .subscribe .subscribe-btn{min-width:195px}.stateoff-container .tipme{margin-bottom:60px}.stateoff-container .tipme .tipme-container{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.stateoff-container .tipme .caption{text-align:center;line-height:1.15;font-size:14px;padding-bottom:15px}.stateoff-container .tipme .stateoff-icon-gift_18{font-size:18px}.stateoff-container .tipme .icon{position:absolute;left:10px;top:5px}.stateoff-container .tipme .mc-common-input input{padding-left:35px}.stateoff-container .tipme .tip{width:134px;position:relative;margin-right:20px}.stateoff-container .tipme .tip-btn{min-width:94px}.stateoff-container .find-me .caption{text-align:center;line-height:1.5;font-size:13px}.stateoff-container .find-me .find-me-container{font-size:44px;text-align:center;padding-top:15px}.stateoff-container .find-me a{letter-spacing:-3px}.stateoff-container .form_block{border-bottom:none;padding:0}.stateoff-container .authorization .caption{text-align:center;line-height:1.5;font-size:13px;padding-bottom:15px}.stateoff-container .authorization .autorization-container{max-width:333px;margin:0 auto}.stateoff-container .authorization .btns{text-align:center;margin-top:20px}.stateoff-container .authorization .capcha-block-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;margin-top:20px}.stateoff-container .authorization .capcha-img-wrap{width:90px;height:100%}.stateoff-container .authorization .capcha-wrapper{margin-right:8px;border-width:1px;border-style:solid;border-radius:2px;max-height:35px;overflow:hidden;display:-moz-flex;display:-ms-flexbox;display:flex}.stateoff-container .authorization .capcha-input{-moz-flex:1;-ms-flex:1;flex:1;margin-bottom:0}.stateoff-container .authorization .row{margin:0}.stateoff-container .authorization .row.capcha{margin-bottom:10px}.stateoff-container .authorization .row.capcha .reload-captcha{width:35px;height:35px;border-left-width:1px;border-left-style:solid;font-size:17px;text-align:center;line-height:35px;cursor:pointer;position:relative;margin:0;right:auto;top:auto}.stateoff-container .contact{text-align:center;line-height:1.5;font-size:13px;max-width:160px;margin:0 auto}.stateoff-dialog{position:fixed;z-index:1000;max-width:100%;border:0;outline:none}.stateoff-dialog .ui-dialog-titlebar{height:0;overflow:hidden}.stateoff-dialog .ui-dialog-content{padding:0}.stateoff-tips-popup{padding:30px 40px;position:relative;border-radius:2px;font-family:pt_sansregular}.stateoff-tips-popup .popup-title{text-align:center;font-size:16px;text-transform:uppercase;font-family:pt_sansbold;line-height:1;padding:0}.stateoff-tips-popup .tips-popup-notice{text-align:center;margin:25px 0;font-size:12px;font-family:pt_sansregular}.stateoff-tips-popup .tips-popup-notice.small-notice{margin:5px 0 25px}.stateoff-tips-popup .msg-block{margin-bottom:0}.stateoff-tips-popup .popup-footer{text-align:center;margin-top:30px}.stateoff-tips-popup .popup-footer .confirm{width:130px}.stateoff-tips-popup .stateoff-icon-close_9{font-size:9px;position:absolute;right:10px;top:10px;cursor:pointer}@media (min-width:768px){.stateoff-container .stateoff-page-wrap{padding:100px 40px 90px}.stateoff-container .avatar-name{font-size:14px}.stateoff-container .info-text{font-size:26px;line-height:1.5}.stateoff-container .authorization .btns{margin-top:30px}.stateoff-container .tipme{margin-bottom:90px}.stateoff-container .find-me a{letter-spacing:normal}.stateoff-container .subscribe .nsl-form{display:-moz-flex;display:-ms-flexbox;display:flex}.stateoff-container .subscribe .nsl-form .field-email,.stateoff-container .subscribe .nsl-form .field-name{-moz-flex:1;-ms-flex:1;flex:1}.stateoff-container .subscribe .nsl-form .field-set{margin-right:20px}.stateoff-container .subscribe .nsl-form .field-set:last-child{margin-right:0}.stateoff-container .subscribe .btns{margin-top:0}}.site-under-construction+.stateoff-page-bg{background-image:url(" + __webpack_require__(184) + ")}.site-under-construction .h-separator{margin:40px 0 50px}@media (max-width:767px){.stateoff-container .site-under-construction-bg-img{background-image:none}}@media (min-width:768px){.site-under-construction .info-text{padding:35px 0 60px;max-width:630px}}.site-closed+.stateoff-page-bg{background-image:url(" + __webpack_require__(185) + ")}.site-closed .h-separator{margin:30px 0 40px}.site-closed .info-text{font-family:pt_sansbold}.site-closed .authorization{margin-bottom:35px}@media (min-width:768px){.site-closed .h-separator{margin:45px 0 95px}.site-closed .info-text{max-width:600px}.site-closed .authorization{margin-bottom:65px}.site-closed .contact{max-width:none}}@media (min-width:1300px){.site-closed .info-text{max-width:800px}}.activity-event-viewer .activity-filter{display:-moz-flex;display:-ms-flexbox;display:flex;display:-moz-inline-flex;display:-ms-inline-flexbox;display:inline-flex}.activity-event-viewer .activity-action{position:relative;z-index:3}.activity-event-viewer .activity-action.calendar{margin-right:12px}.activity-event-viewer .activity-action>div{position:relative}.activity-event-viewer .settings-button{border-radius:3px;background-color:#b2b2b2;color:#fff;padding:6px;height:30px;cursor:pointer}.activity-event-viewer .settings-button .ico{font-size:16px;padding:0;width:auto;height:auto;top:0}.activity-event-viewer .settings-button .ico.arr{font-size:12px}.activity-event-viewer .settings-button .ico.arr-d{font-size:8px;transform:rotate(90deg);display:inline-block;position:relative;top:-5px;margin-left:5px;transition:transform .2s}.activity-event-viewer .settings-button.opened{background-color:#333}.activity-event-viewer .settings-button.opened .ico.arr-d{transform:rotate(-90deg)}.activity-event-viewer .settings-button.opened+.setup-list{-ms-filter:none;filter:none;opacity:1;visibility:visible;margin-top:-3px}.activity-event-viewer .setup-list{position:absolute;right:0;top:100%;margin-top:17px;background-color:#b2b2b2;visibility:hidden;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:opacity .2s,margin-top .3s;padding:12px;border-radius:3px 0 3px 3px;background-color:#333}.activity-event-viewer .setup-list.view-settings-list .view-settings-list-item{padding:10px 0;white-space:nowrap;line-height:22px;cursor:pointer}.activity-event-viewer .setup-list.view-settings-list .view-settings-list-item .switch-wrapper{position:relative;padding:1px;width:29px;height:13px;border-radius:1px;display:inline-block;vertical-align:top;margin-right:10px;margin-top:5px}.activity-event-viewer .setup-list.view-settings-list .view-settings-list-item .switch-wrapper .slider{transition:margin-left .2s}.activity-event-viewer .setup-list.view-settings-list .view-settings-list-item .switch-wrapper.on{background-color:#000}.activity-event-viewer .setup-list.view-settings-list .view-settings-list-item .switch-wrapper.on .slider{margin-left:14px}.activity-event-viewer .setup-list.view-settings-list .view-settings-list-item .switch-wrapper.off{background-color:#464646}.activity-event-viewer .setup-list.view-settings-list .view-settings-list-item .switch-wrapper.off .slider{margin-left:1px}.activity-event-viewer .setup-list.view-settings-list .view-settings-list-item .switch-wrapper .slider{position:absolute;width:12px;height:9px;background-color:#fff;border-radius:1px;display:inline-block;top:2px}.activity-event-viewer .activity-filter-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;margin:20px 0;font-size:16px;text-align:center;border-width:3px 0;border-style:solid;border-color:rgba(250,92,107,.2)}.activity-event-viewer .activity-filter-wrapper>div{padding:15px;font-size:11px;min-width:40%;font-weight:700;line-height:21px}.activity-event-viewer .activity-filter-wrapper>div.exists{border-color:rgba(250,92,107,.2)}.activity-event-viewer .activity-filter-wrapper .prev-container{border-width:0 1px 0 0}.activity-event-viewer .activity-filter-wrapper .next-container{border-width:0 0 0 1px}.activity-event-viewer .activity-filter-wrapper .next-container,.activity-event-viewer .activity-filter-wrapper .prev-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;min-width:30%;border-style:solid;border-color:transparent}.activity-event-viewer .activity-filter-wrapper .next-container a,.activity-event-viewer .activity-filter-wrapper .prev-container a{white-space:nowrap;font-weight:700}.activity-event-viewer .activity-filter-wrapper .next-container a span,.activity-event-viewer .activity-filter-wrapper .prev-container a span{display:none}.activity-event-viewer .activity-filter-wrapper .next-container a i,.activity-event-viewer .activity-filter-wrapper .prev-container a i{font-size:18px;position:relative;top:3px}.activity-event-viewer .activity-column{display:block;margin-left:0;width:auto}.activity-event-viewer .activity-card{border-radius:3px;overflow:hidden;margin-bottom:15px;max-height:300px;height:300px;position:relative;background-color:#000}.activity-event-viewer .activity-card a{text-decoration:none}.activity-event-viewer .activity-card .card-header{padding:20px;height:90px;text-align:center;white-space:nowrap;top:0;transition:margin-top .2s}.activity-event-viewer .activity-card .card-header .date-wrapper{display:inline-block;font-family:Arial,Helvetica Neue,Helvetica,sans-serif}.activity-event-viewer .activity-card .card-header .date{font-size:45px;float:left;line-height:50px;font-family:simplifica}.activity-event-viewer .activity-card .card-header .month{margin-top:12px}.activity-event-viewer .activity-card .card-header .dash{width:30%;vertical-align:top;font-size:50px;line-height:50px;font-family:simplifica}.activity-event-viewer .activity-card .card-header .month,.activity-event-viewer .activity-card .card-header .time{display:block;font-size:11px;line-height:15px;margin-left:40px;text-align:left}.activity-event-viewer .activity-card .card-body-wrapper{max-height:210px;overflow:hidden;position:relative;bottom:0;transition:bottom .2s}.activity-event-viewer .activity-card .card-body-wrapper.wide{text-align:center}.activity-event-viewer .activity-card .card-body-wrapper.wide img{position:absolute;max-height:100%;width:auto}.activity-event-viewer .activity-card .card-body-wrapper .cover img{transform:scale(1.1);transition:transform .2s}.activity-event-viewer .activity-card .card-body-wrapper .cover:hover{-ms-filter:none;filter:none;opacity:1}.activity-event-viewer .activity-card .card-body-wrapper .cover:before{position:absolute;left:0;right:0;top:0;bottom:0;background-color:rgba(0,0,0,.65);content:\"\";display:block;z-index:1}.activity-event-viewer .activity-card .card-body-wrapper .cover a{display:block;position:relative;z-index:1}.activity-event-viewer .activity-card .card-body-wrapper .card-body{border-top:1px solid hsla(0,0%,100%,.2);position:relative}.activity-event-viewer .activity-card .card-body-wrapper .card-body.wide img{max-height:100%;min-height:100%;position:absolute;max-width:none;left:50%;transform:translate(-50%) scale(1.1)}.activity-event-viewer .activity-card .card-body-wrapper .card-body.image-exists{border-top-width:0}.activity-event-viewer .activity-card .card-body-wrapper .card-body>.event-title{position:absolute;top:20px;left:0;right:0;z-index:2;padding:0 20px}.activity-event-viewer .activity-card .card-body-wrapper .card-body>.event-title .event-type a{color:inherit;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.activity-event-viewer .activity-card .card-body-wrapper .card-body>.event-title .event-type,.activity-event-viewer .activity-card .card-body-wrapper .card-body>.event-title span[title]{margin-left:30px;display:block;font-size:12px;text-transform:none}.activity-event-viewer .activity-card .card-body-wrapper .card-body>.event-title span{font-size:14px;text-transform:uppercase}.activity-event-viewer .activity-card .card-body-wrapper .card-body .counter-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;position:absolute;left:20px;right:20px;top:95px;z-index:2}.activity-event-viewer .activity-card .card-body-wrapper .card-body .counter-wrapper .counter{display:-moz-flex;display:-ms-flexbox;display:flex}.activity-event-viewer .activity-card .card-body-wrapper .card-body img{min-height:100%;transform:scale(1.1);transition:transform .2s;min-width:100%}.activity-event-viewer .activity-card .card-body-wrapper .card-body .event-description{top:80px;left:0;right:0;padding:0 20px;position:absolute;font-size:12px;line-height:20px;z-index:2}.activity-event-viewer .activity-card .card-body-wrapper .card-body .event-description .more{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.activity-event-viewer .activity-card .card-body-wrapper .card-body .event-description .more a{color:inherit}.activity-event-viewer .activity-card .card-body-wrapper .card-body .event-description .more i{font-size:8px}.activity-event-viewer .activity-card .card-body-wrapper .card-body .event-description.full{top:0}.activity-event-viewer .activity-card .card-body-wrapper .card-footer{position:absolute;bottom:20px;left:0;right:0;padding-left:20px;padding-right:20px;z-index:2}.activity-event-viewer .activity-card .event-title{font-size:14px;text-transform:uppercase;line-height:20px}.activity-event-viewer .activity-card .event-title .ico{font-size:20px;float:left;padding:0;width:auto;height:auto;top:0}.activity-event-viewer .activity-card .card-body-wrapper,.activity-event-viewer .activity-card .card-body-wrapper .card-body,.activity-event-viewer .activity-card .cover{height:210px;z-index:1}.activity-event-viewer .activity-card:hover .card-body-wrapper .cover img{transform:scale(1)}.activity-event-viewer .activity-card:hover .card-body-wrapper .card-body.wide .cover img{transform:scale(1) translate(-50%)}.activity-event-viewer .activity-card .full-description-wrapper{position:absolute;top:0;left:0;right:0;bottom:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;visibility:hidden;padding:20px;transform:scale(.8);transition:transform .2s,opacity .2s}.activity-event-viewer .activity-card .full-description-wrapper .event-title{margin-bottom:20px}.activity-event-viewer .activity-card .full-description-wrapper .event-title span{margin-left:30px;display:block}.activity-event-viewer .activity-card .full-description-wrapper .event-description{max-height:220px}.activity-event-viewer .activity-card .full-description-wrapper .event-description .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:hsla(0,0%,100%,.3)}.activity-event-viewer .activity-card .full-description-wrapper .event-description .mCS-light-thin.mCSB_scrollTools .mCSB_draggerRail{background-color:hsla(0,0%,100%,.1)}.activity-event-viewer .activity-card .close{position:absolute;right:23px;top:19px;font-size:23px;display:block;transform:rotate(45deg);transition:transform .2s}.activity-event-viewer .activity-card .close:hover{transform:rotate(135deg)}.activity-event-viewer .activity-card.show-full-description .card-header{margin-top:-90px}.activity-event-viewer .activity-card.show-full-description .card-body-wrapper{bottom:-100%}.activity-event-viewer .activity-card.show-full-description .full-description-wrapper{transform:scale(1);-ms-filter:none;filter:none;opacity:1;visibility:visible}.activity-event-viewer .activity-card .counter .part{font-size:18px;line-height:20px;padding:5px;width:46px;text-align:center}.activity-event-viewer .activity-card .counter .part div{font-size:10px;line-height:12px;margin-top:3px}.activity-event-viewer .activity-card .counter .separator{text-indent:-1000px;width:1px;background-color:hsla(0,0%,100%,.2)}-moz-osx-font-smoothing grayscale,-webkit-font-smoothing antialiased,.ui-helper-hidden,[class*=\" ui-icon\"],[class^=ui-icon-],font-family \"activity_icons\",font-style normal,font-variant normal,font-weight normal,line-height 1,speak none,text-transform none{display:none}.ui-helper-hidden-accessible{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.ui-helper-reset{margin:0;padding:0;border:0;outline:0;line-height:1.3;text-decoration:none;font-size:100%;list-style:none}.ui-helper-clearfix:after,.ui-helper-clearfix:before{content:\"\";display:table}.ui-helper-clearfix{zoom:1}.ui-helper-clearfix:after{clear:both}.ui-helper-zfix{width:100%;height:100%;top:0;left:0;position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;filter:Alpha(0)}.ui-state-disabled{cursor:default!important}.ui-icon{display:block;overflow:hidden;background-repeat:no-repeat;font-family:activity_icons}.ui-icon.ui-icon-circle-triangle-w:before{content:\"\\E603\"}.ui-icon.ui-icon-circle-triangle-e:before{content:\"\\E604\"}.ui-widget-overlay{position:absolute;top:0;left:0;width:100%;height:100%}.ui-datepicker{width:17em;padding:.2em .2em 0;display:none}.ui-datepicker .ui-datepicker-header{position:relative;padding:0;border:1px solid hsla(0,0%,100%,.15);border-radius:3px;line-height:28px;height:30px;vertical-align:middle;margin-bottom:10px}.ui-datepicker .ui-datepicker-prev{left:2px}.ui-datepicker .ui-datepicker-next{right:2px}.ui-datepicker .ui-datepicker-prev-hover{left:1px}.ui-datepicker .ui-datepicker-next-hover{right:1px}.ui-datepicker .ui-datepicker-title{margin:0 2.3em;text-align:center;border-width:0 1px;border-style:inherit;border-color:hsla(0,0%,100%,.15)}.ui-datepicker .ui-datepicker-title select{font-size:1em;margin:1px 0}.ui-datepicker select.ui-datepicker-month-year{width:100%}.ui-datepicker table{width:100%;font-size:.9em;border-collapse:collapse;margin:0 0 .4em}.ui-datepicker table thead{display:none}.ui-datepicker th{padding:.7em .3em;text-align:center;font-weight:700;border:0}.ui-datepicker td{border:0;padding:2px}.ui-datepicker .ui-datepicker-buttonpane{background-image:none;margin:.7em 0 0;padding:0 .2em;border-left:0;border-right:0;border-bottom:0}.ui-datepicker .ui-datepicker-buttonpane button{float:right;margin:.5em .2em .4em;cursor:pointer;padding:.2em .6em .3em;width:auto;overflow:visible}.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current{float:left}.ui-datepicker.ui-datepicker-multi{width:auto}.ui-datepicker .ui-datepicker-next,.ui-datepicker .ui-datepicker-prev{position:absolute;top:2px;width:1.8em;height:1.8em}.ui-datepicker .ui-datepicker-next-hover,.ui-datepicker .ui-datepicker-prev-hover{top:1px}.ui-datepicker .ui-datepicker-next span,.ui-datepicker .ui-datepicker-prev span{display:block;font-size:9px;text-align:center}.ui-datepicker .ui-datepicker-calendar{border-width:1px 0 0 1px;border-style:solid;border-color:hsla(0,0%,100%,.15);border-radius:3px}.ui-datepicker .ui-datepicker-calendar td{border-width:0 1px 1px 0;border-style:solid;border-color:hsla(0,0%,100%,.15)}.ui-datepicker .ui-datepicker-calendar td span{text-align:center;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.ui-datepicker select.ui-datepicker-month,.ui-datepicker select.ui-datepicker-year{width:49%}.ui-datepicker td a,.ui-datepicker td span{display:block;padding:.2em;text-align:right;text-decoration:none}.ui-datepicker-multi .ui-datepicker-group{float:left}.ui-datepicker-multi .ui-datepicker-group table{width:95%;margin:0 auto .4em}.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header{border-left-width:0}.ui-datepicker-multi .ui-datepicker-buttonpane{clear:left}.ui-datepicker-multi-2 .ui-datepicker-group{width:50%}.ui-datepicker-multi-3 .ui-datepicker-group{width:33.3%}.ui-datepicker-multi-4 .ui-datepicker-group{width:25%}.ui-datepicker-row-break{clear:both;width:100%;font-size:0}.ui-datepicker-rtl{direction:rtl}.ui-datepicker-rtl .ui-datepicker-prev{right:2px;left:auto;text-indent:-1000px}.ui-datepicker-rtl .ui-datepicker-prev:hover{right:1px;left:auto}.ui-datepicker-rtl .ui-datepicker-next{left:2px;right:auto;text-indent:-1000px}.ui-datepicker-rtl .ui-datepicker-next:hover{left:1px;right:auto}.ui-datepicker-rtl .ui-datepicker-buttonpane{clear:right}.ui-datepicker-rtl .ui-datepicker-buttonpane button{float:left}.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,.ui-datepicker-rtl .ui-datepicker-group{float:right}.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header{border-right-width:0;border-left-width:1px}.ui-datepicker .clickable-date a{color:#fff;text-align:center}@media (min-width:490px){.activity-event-viewer .activity-column{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-left:-2%;margin-bottom:-2%}.activity-event-viewer .activity-card{margin-left:2%;width:48%;margin-bottom:2%}}@media (min-width:600px){.activity-event-viewer .activity-filter-wrapper>div{font-size:12px}.activity-event-viewer .activity-filter-wrapper .next-container a span,.activity-event-viewer .activity-filter-wrapper .prev-container a span{display:inline-block}}@media (min-width:768px){.activity-event-viewer .activity-filter-wrapper>div{min-width:50%}.activity-event-viewer .activity-filter-wrapper .next-container,.activity-event-viewer .activity-filter-wrapper .prev-container{min-width:25%}.activity-event-viewer .settings-button{padding:12px;height:46px}.activity-event-viewer .settings-button .ico{font-size:22px}.activity-event-viewer .activity-column{margin-left:-1.3%;margin-bottom:-1.3%}.activity-event-viewer .activity-card{margin-left:1.3%;width:32%;margin-bottom:1.3%}}.marg-left{position:relative;margin-left:40px!important}.sp-part{padding-top:20px}.sp-part .num{float:left;display:block;padding-right:10px}.sp-title{font-size:24px;line-height:24px;margin-bottom:20px}.sp-title sup{font-size:12px}.sp-part-title{font-size:16px}.sp-up-time{font-size:14px}.list li{list-style-type:disc;margin-left:60px}.sp-part p{padding-left:40px!important}.billing-support-page .description{margin-bottom:20px}.billing-contact-form .form-block,.billing-contact-form .row{margin-bottom:15px}.billing-contact-form .row:last-child{margin-bottom:0}.billing-contact-form .row label{display:block;margin-bottom:5px;line-height:18px}.billing-contact-form .row textarea{height:100px}.billing-support-wrapper .links a{display:block;margin-bottom:5px;margin-top:5px}.billing-support-wrapper .links>span{display:none}@media (min-width:768px){.billing-contact-form .row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row wrap;flex-flow:row wrap}.billing-contact-form .row .form-block{max-width:48%;-moz-flex:1 auto;-ms-flex:1 auto;flex:1 auto}.billing-contact-form .row.wide .form-block{max-width:none;min-width:100%}.billing-support-wrapper .links a{display:inline-block;margin-top:0;margin-bottom:0}.billing-support-wrapper .links span{display:inline-block;margin:0 5px}}.blog ol:not(.pagination),.blog ul:not(.pagination),.post-content ol:not(.pagination),.post-content ul:not(.pagination){list-style:inherit;text-align:left}.blog ul,.post-content ul{list-style-type:disc}.blog ol,.post-content ol{list-style-type:decimal;padding:0}.blog li,.post-content li{list-style:inherit;margin-left:20px}.blog iframe,.post-content iframe{max-width:100%}.cancellation-page .description{margin-bottom:20px}.cancellation-page .cancellation-model-text .message-row .message-bubble{max-width:720px}.cancellation-page .cancellation-model-text .message-row .message-bubble .bubble-arrow{border-width:0 1px 1px 0}.cancellation-page .cancellation-model-text .message-row .message-bubble .avatar{float:left;width:70px;height:70px;overflow:hidden;border-radius:50%;margin-left:10px;margin-top:10px;display:none}.cancellation-page .cancellation-model-text .message-row .message-bubble .message-content{margin-left:0;font-style:italic}.cancellation-page .cancellation-model-text .message-row .message-bubble .message-content .title{margin-bottom:5px}.cancellation-page .cancellation-model-text .message-row .message-bubble .message-content .model-message{line-height:18px}.cancellation-page .cancellation-form-wrapper{overflow:hidden;margin-top:15px;padding:0 1px}.cancellation-page .cancellation-form-wrapper .cancellation-form{float:right;max-width:692px;width:100%}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-reason-wrapper{margin-bottom:20px;font-size:12px}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-reason-wrapper>*{line-height:32px}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-reason-wrapper .label{float:none}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-reason-wrapper .select-wrapper{margin-left:0}.cancellation-page .cancellation-form-wrapper .cancellation-form .error.message{border-color:rgba(255,0,0,.3)}.cancellation-page .cancellation-form-wrapper .cancellation-form .error textarea:-ms-input-placeholder{color:red}.cancellation-page .cancellation-form-wrapper .cancellation-form .error textarea::placeholder{color:red}.cancellation-page .cancellation-form-wrapper .cancellation-form .message{margin-bottom:10px}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-submit{text-align:right}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-submit .send-message{float:none}@media (min-width:768px){.cancellation-page .cancellation-model-text .message-row .message-bubble .avatar{display:block}.cancellation-page .cancellation-model-text .message-row .message-bubble .message-content{margin-left:105px}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-reason-wrapper{text-align:right}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-reason-wrapper .label{float:left}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-reason-wrapper .select-wrapper{margin-left:120px}.cancellation-page .cancellation-form-wrapper .cancellation-form .cancellation-submit .send-message{float:right}}.ui-dialog.cb-payment-popup{max-width:740px;border-radius:4px;background-color:#fff;outline:none;overflow:hidden;box-shadow:0 0 10px 1px rgba(0,0,0,.5)}.ui-dialog.cb-payment-popup .ui-dialog-titlebar-close{border:none;font-family:mc-icons-liveshow;font-size:24px;line-height:14px;position:absolute;right:13px;top:21px;cursor:pointer;padding:0;display:block!important;color:#464646}.ui-dialog.cb-payment-popup .ui-dialog-titlebar-close:before{content:\"\\E611\"}.ui-dialog.cb-payment-popup .ui-dialog-titlebar{padding:20px;color:#464646;border-bottom:1px solid #e1e1e1}.ui-dialog.cb-payment-popup .ui-dialog-titlebar .ui-dialog-title{font-weight:700}.ui-dialog.cb-payment-popup iframe{border:none;min-height:760px;width:100%}[data-font-size^=\"8px\"]{font-size:8px}[data-font-size^=\"9px\"]{font-size:9px}[data-font-size^=\"10px\"]{font-size:10px}[data-font-size^=\"11px\"]{font-size:11px}[data-font-size^=\"12px\"]{font-size:12px}[data-font-size^=\"14px\"]{font-size:14px}[data-font-size^=\"16px\"]{font-size:16px}[data-font-size^=\"18px\"]{font-size:18px}[data-font-size^=\"20px\"]{font-size:20px}[data-font-size^=\"22px\"]{font-size:22px}[data-font-size^=\"24px\"]{font-size:24px}[data-font-size^=\"26px\"]{font-size:26px}[data-font-size^=\"28px\"]{font-size:28px}[data-font-size^=\"36px\"]{font-size:36px}[data-font-size^=\"48px\"]{font-size:48px}[data-font-size^=\"72px\"]{font-size:72px}[data-font-family^=Arial]{font-family:Arial}[data-font-family^=\"Comic Sans MS\"]{font-family:Comic Sans MS}[data-font-family^=\"Courier New\"]{font-family:Courier New}[data-font-family^=Georgia]{font-family:Georgia}[data-font-family^=\"Lucida Sans Unicode\"]{font-family:Lucida Sans Unicode}[data-font-family^=Tahoma]{font-family:Tahoma}[data-font-family^=\"Times New Roman\"]{font-family:Times New Roman}[data-font-family^=\"Trebuchet MS\"]{font-family:Trebuchet MS}[data-font-family^=Verdana]{font-family:Verdana}.content-actions.new-wrap{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.content-actions.new-wrap .attach-title{font-size:22px;font-weight:400;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;padding-left:10px}.content-actions.new-wrap .rating{-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-moz-order:1;-ms-flex-order:1;order:1;display:-moz-flex;display:-ms-flexbox;display:flex}.content-actions.new-wrap .rating .rating-new{min-width:auto;-ms-flex-align:center;-moz-align-items:center;align-items:center;margin-right:0}.content-actions.new-wrap .rating .rating-new .rating-separate{margin:0 7px}.content-actions.new-wrap .tipme-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex:1 100%;-ms-flex:1 100%;flex:1 100%;-moz-order:3;-ms-flex-order:3;order:3;-ms-flex-align:center;-moz-align-items:center;align-items:center}.content-actions.new-wrap .tipme-container .tip{-moz-flex:1;-ms-flex:1;flex:1}.content-actions.new-wrap .more-actions-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-moz-order:2;-ms-flex-order:2;order:2;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;-ms-flex-align:center;-moz-align-items:center;align-items:center}.content-actions.new-wrap .more-actions-container .action-link-text{display:none;padding-left:7px}.content-actions{margin-bottom:0;border-width:0 0 3px;border-style:solid;margin-bottom:30px;padding-top:30px}.content-actions>*{margin-bottom:20px}.content-actions i{font-size:22px}.content-actions .rating,.content-actions .tipme-container .common-input{line-height:32px}.content-actions .tipme-container .common-input i{padding-left:12px;font-size:18px}.content-actions .tipme-container .common-input #tip-amount{height:32px;line-height:32px}.content-actions .tipme-container .tip-me{line-height:30px;margin-left:10px;z-index:10}.content-actions .more-actions-container .action-link-text{font-size:11px;text-transform:uppercase;font-weight:700}.content-actions .more-actions-container .content-report-link,.content-actions .more-actions-container .download,.content-actions .more-actions-container .fav-link,.content-actions .more-actions-container .related-link{margin-left:15px}.content-report{display:-ms-flexbox;display:flex;-ms-flex-item-align:center;align-self:center;padding:10px 0}@media (min-width:440px){.more-actions-container .content-report-link,.more-actions-container .download,.more-actions-container .fav-link,.more-actions-container .related-link{margin-left:20px}.new-wrap .rating .rating-new{margin-right:10px}.new-wrap .rating .rating-new .rating-separate{margin:0 10px}}@media (min-width:540px){.content-actions>*{margin-bottom:25px}.content-actions.new-wrap .rating{-moz-order:1;-ms-flex-order:1;order:1}.content-actions.new-wrap .rating .num{display:inline-block}.content-actions.new-wrap .tipme-container{-moz-order:2;-ms-flex-order:2;order:2;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;min-width:160px;max-width:207px}.content-actions.new-wrap .more-actions-container{-moz-order:3;-ms-flex-order:3;order:3;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto}.fav-link .action-link-text.fav-add{display:block!important}.fav-link .action-link-text.fav-remove,.fav-link.checked .action-link-text.fav-add{display:none!important}.fav-link.checked .action-link-text.fav-remove{display:block!important}.content-actions.new-wrap .more-actions-container .content-report-link,.content-actions.new-wrap .more-actions-container .download,.content-actions.new-wrap .more-actions-container .fav-link,.content-actions.new-wrap .more-actions-container .related-link{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}.content-actions.new-wrap .more-actions-container .content-report-link .action-link-text,.content-actions.new-wrap .more-actions-container .download .action-link-text,.content-actions.new-wrap .more-actions-container .fav-link .action-link-text,.content-actions.new-wrap .more-actions-container .related-link .action-link-text{display:block}}@media (min-width:640px){.content-actions.new-wrap .more-actions-container .content-report-link,.content-actions.new-wrap .more-actions-container .download,.content-actions.new-wrap .more-actions-container .fav-link,.content-actions.new-wrap .more-actions-container .related-link{margin-left:30px}}.blured{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.send-hint{font-size:12px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;margin-left:15px}@media screen and (max-width:420px){.send-hint{display:none!important}}.ui-dialog.preview-content{max-width:955px;outline:none}.ui-dialog.preview-content .additional-attach-info{margin-top:20px}.ui-dialog.preview-content .additional-attach-info .attach-title{font-size:22px;display:inline-block;max-width:60%;line-height:32px}.ui-dialog.preview-content .additional-attach-info .attach-actions{display:inline-block;text-align:right;float:right}.ui-dialog.preview-content .additional-attach-info .download-button .download-links{transform:scale(0);transition:transform .2s}.ui-dialog.preview-content .additional-attach-info .download-button.down-list .download-links{transform:scale(1)}.ui-dialog.preview-content .ui-dialog-title{display:none}.ui-dialog.preview-content .ui-dialog-content{padding:40px 50px;max-width:inherit}.ui-dialog.preview-content .uploaded-image{background-size:contain;background-position:50%;background-repeat:no-repeat;padding-top:57%}.ui-dialog.preview-content .uploaded-video{max-height:600px;min-height:200px}.ui-dialog.preview-content .uploaded-video .ac-p-video-container{max-height:600px}.ui-dialog.preview-content .nav-arrows{position:absolute;font-size:40px;width:50px;top:30px;bottom:30px;cursor:pointer}.ui-dialog.preview-content .nav-arrows:before{position:absolute;top:45%;left:50%;margin-left:-9px;margin-top:-8px}.ui-dialog.preview-content .nav-arrows.a-left{left:0}.ui-dialog.preview-content .nav-arrows.a-right{right:0}.conversation-container{position:relative}.conversation-container:after,.conversation-container:before{position:absolute;left:0;right:0;width:100%;height:40px;z-index:10}.conversation-container:before{top:0;background-image:linear-gradient(180deg,#fff 0,#fff 12%,hsla(0,0%,100%,0))}.conversation-container:after{bottom:0;background-image:linear-gradient(180deg,hsla(0,0%,100%,0) 0,#fff 88%,#fff)}.messages{transition:opacity .5s}.messages *,.messages :after,.messages :before{box-sizing:border-box}.messages .message-buble-wrapper{display:inline-block}.messages .message-buble-wrapper .message-read-status{display:none!important;font-weight:400;float:right;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;text-transform:none;margin-left:10px}.messages .chat-preloader *,.messages .chat-preloader :after,.messages .chat-preloader :before,.messages .preload *,.messages .preload :after,.messages .preload :before{box-sizing:content-box}.messages .chat-preloader{min-height:440px}.messages .preload{top:0;right:25%;bottom:0;left:0;margin:auto;height:21px}.messages .message-date-separator{height:1px;text-align:center;margin:30px 0}.messages .message-date-separator .messages-group-date{text-transform:uppercase;padding:9px 16px;border-width:1px;border-style:solid;border-radius:2px;position:relative;top:-6px}.messages .message-row .message-time{margin-top:10px;display:inline-block}.messages .message-row .message-bubble{border-radius:1px;padding:15px;box-shadow:0 1px 3px 0 rgba(0,0,0,.1);position:relative;display:inline-block;max-width:570px;min-width:140px;border-width:1px;border-style:solid;margin-bottom:10px}.messages .message-row .message-from-who{text-transform:uppercase;margin-left:25px;margin-top:-5px;margin-bottom:10px;display:block}.messages .message-row.not-my{text-align:right}.messages .message-row.not-my .message-from-who{margin-right:25px}.messages .message-row .attachment-list{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}.messages .message-row .attachment-list>li{-ms-flex:0 auto;flex:0 auto;margin:0 5px}.messages .message-row .attachment-list .attach-item{border-radius:1px;overflow:hidden;width:168px;height:95px;position:relative;margin-top:17px;display:inline-block}.messages .message-row .attachment-list .attach-item .attach-error{background-color:rgba(0,0,0,.5);position:absolute;z-index:1;top:0;right:0;left:0;bottom:0;width:100%;height:100%;transform:translateY(-100%);transition:transform .5s;text-align:center}.messages .message-row .attachment-list .attach-item .attach-error.content-error{transform:translate(0)}.messages .message-row .attachment-list .attach-item .attach-error .att-error-message{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;display:inline-block;font-size:11px;color:#fff;width:100%;height:16px}.messages .message-row .attachment-list .attach-item .attach-preview{background-size:contain;background-color:#000;background-repeat:no-repeat;background-position:50%;position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;z-index:2;cursor:pointer;transform:translateY(105%);transition:transform .5s}.messages .message-row .attachment-list .attach-item .attach-preview.success{transform:translate(0)}.messages .message-row .attachment-list .attach-item.locked .attach-preview{filter:blur(2px)}.messages .message-row .attachment-list .attach-item .attach-lock,.messages .message-row .attachment-list .attach-item .attach-processing{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;z-index:2;padding:7px;padding-top:13px;color:#fff;transition:transform .4s;transform:translateY(-100%)}.messages .message-row .attachment-list .attach-item .attach-lock .content-name,.messages .message-row .attachment-list .attach-item .attach-lock .content-price,.messages .message-row .attachment-list .attach-item .attach-lock .unlock-btn,.messages .message-row .attachment-list .attach-item .attach-processing .content-name,.messages .message-row .attachment-list .attach-item .attach-processing .content-price,.messages .message-row .attachment-list .attach-item .attach-processing .unlock-btn{text-transform:uppercase;display:block;text-align:center}.messages .message-row .attachment-list .attach-item .attach-lock .content-price,.messages .message-row .attachment-list .attach-item .attach-processing .content-price{font-size:16px}.messages .message-row .attachment-list .attach-item .attach-lock .content-name,.messages .message-row .attachment-list .attach-item .attach-processing .content-name{font-size:10px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.messages .message-row .attachment-list .attach-item .attach-lock .unlock-btn,.messages .message-row .attachment-list .attach-item .attach-processing .unlock-btn{position:absolute;right:7px;bottom:7px;left:7px;border-radius:1px;padding:10px 0;height:35px;border:none;cursor:pointer}.messages .message-row .attachment-list .attach-item .attach-processing{background-color:#000;z-index:3}.messages .message-row .attachment-list .attach-item .attach-processing .processing-loader{position:relative!important;width:29px!important;height:40px!important}.messages .message-row .attachment-list .attach-item .attach-processing .processing-loader .pie{width:20px;height:20px}.messages .message-row .attachment-list .attach-item .attach-processing .processing-loader #left-spin{clip:rect(0,34px,34px,13px)}.messages .message-row .attachment-list .attach-item .attach-processing .processing-loader #left-spin .spin{clip:rect(0,14px,34px,0)}.messages .message-row .attachment-list .attach-item .attach-processing .processing-loader #right-spin{clip:rect(0,13px,34px,0)}.messages .message-row .attachment-list .attach-item .attach-processing .processing-loader #right-spin .spin{clip:rect(0,34px,34px,14px)}.messages .message-row .attachment-list .attach-item.locked .attach-lock,.messages .message-row .attachment-list .attach-item.processing .attach-processing{transform:translate(0)}@media (max-width:550px){.ui-dialog.preview-content .nav-arrows{width:20px}.ui-dialog.preview-content .attach-actions i+span{display:none}}[class*=\" i_cf-\"],[class^=i_cf-]{font-family:amc-cf!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.i_cf-info_8:before{content:\"\\E900\"}.i_cf-sponsors_24:before{content:\"\\E902\"}.i_cf-timeLeft_29:before{content:\"\\E903\"}.i_cf-raised_27:before{content:\"\\E901\"}.cf-widget .img-wrapper.foxEditor{z-index:0}.cf-widget .img-wrapper.foxEditor:hover:after{right:auto;left:10px}.cf-widget{position:relative}.cf-widget .cf-title{font-size:20px;line-height:20px;font-family:simplifica;text-align:center}.cf-widget .img-wrapper{position:relative}.cf-widget .cf-bg{background-position:top;background-size:cover;background-image:url(" + __webpack_require__(186) + ");position:absolute;top:0;bottom:0;left:0;right:0}.cf-widget .cf-data{padding:25px 20px;border-radius:0 0 2px 2px}.cf-widget .cf-data .corner{position:absolute;width:0;height:0;border-style:solid;border-width:0 0 5px 5px;display:none}.cf-widget .cf-data .corner.t.r{transform:rotate(90deg)}.cf-widget .cf-data .corner.b.l{transform:rotate(-90deg)}.cf-widget .cf-data .corner.b.r{transform:rotate(180deg)}.cf-widget .cf-data .corner.t{top:0}.cf-widget .cf-data .corner.l{left:-5px}.cf-widget .cf-data .corner.r{right:-5px}.cf-widget .cf-data .corner.b{bottom:0}.cf-widget .cf-data .read-more{margin-top:12px;margin-bottom:25px;font-size:12px;text-align:center;line-height:14px}.cf-widget .cf-data .read-more i{display:inline-block;width:14px;height:14px;font-size:8px;text-align:center;line-height:14px;border-radius:50%;margin-right:10px;position:relative;top:-1px}.cf-widget .cf-data .cf-progress-data .icons-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-bottom:12px;text-align:center}.cf-widget .cf-data .cf-progress-data .icons-wrapper .sponsors{margin:0 30px}.cf-widget .cf-data .cf-progress-data .icons-wrapper .ico{height:30px}.cf-widget .cf-data .cf-progress-data .icons-wrapper .ico i{vertical-align:middle}.cf-widget .cf-data .cf-progress-data .icons-wrapper .money i{font-size:27px}.cf-widget .cf-data .cf-progress-data .icons-wrapper .sponsors i{font-size:24px;position:relative;top:3px}.cf-widget .cf-data .cf-progress-data .icons-wrapper .remaining-time i{font-size:29px}.cf-widget .cf-data .cf-progress-data .icons-wrapper .info{font-size:13px;line-height:14px;margin-top:10px}.cf-widget .cf-data .cf-progress-data .icons-wrapper .info span{display:block;font-size:11px}.cf-widget .cf-data .btn-wrapper{text-align:center;margin-top:10px}.cf-widget .cf-data .btn-wrapper a{display:block}.cf-widget .cf-data .progress-bar{height:16px;position:relative;text-align:center}.cf-widget .cf-data .progress-bar .progress{position:absolute;left:0;top:0;bottom:0;z-index:1;display:block;max-width:100%}.cf-widget .cf-data .progress-bar span{position:relative;z-index:2;line-height:16px;font-size:11px;display:block}.cf-widget .cf-data .share-wrapper .cf-title{margin-top:30px;margin-bottom:10px}.cf-widget .cf-data .share-wrapper .networks{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.cf-widget .cf-data .share-wrapper .networks .cf-title{margin-top:0;margin-bottom:0;margin-right:10px}.cf-widget .cf-data .share-wrapper .networks i{font-size:18px}.cf-widget .cf-data .share-wrapper .networks .list{text-align:center}.cf-widget .cf-data .share-wrapper .networks .list a{display:inline-block;margin:0 6px}.cf-confirm .rowamount{display:table;border-width:1px 0;padding:10px 0;border-style:solid;width:100%}.cf-confirm .rowamount p{width:30%;display:table-cell;font-size:14px}@media (min-width:768px){.cf-widget .cf-title{font-size:35px;line-height:35px}.cf-widget .cf-data .cf-progress-data{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.cf-widget .cf-data .cf-progress-data .icons-wrapper,.cf-widget .cf-data .cf-progress-data .progress-wrapper{width:40%}.cf-widget .cf-data .cf-progress-data .icons-wrapper{min-width:240px;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;margin-right:35px}.cf-widget .cf-data .cf-progress-data .progress-wrapper{min-width:252px;margin-left:35px}.cf-widget .cf-data .share-wrapper .cf-title{font-size:25px}.cf-widget .cf-data .share-wrapper .networks .list a{position:relative;top:9px}}@media (min-width:960px){.cf-widget .cf-bg{border-radius:2px}.cf-widget .cf-data{position:absolute;top:-5px;bottom:-5px;right:30px;width:350px;border-radius:0}.cf-widget .cf-data .cf-progress-data,.cf-widget .cf-data .corner{display:block}.cf-widget .cf-data .cf-progress-data .icons-wrapper,.cf-widget .cf-data .cf-progress-data .progress-wrapper{width:auto}.cf-widget .cf-data .cf-progress-data .icons-wrapper{min-width:auto;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-right:0}.cf-widget .cf-data .cf-progress-data .progress-wrapper{min-width:auto;margin-left:0}.cf-widget .cf-data .btn-wrapper{margin-top:20px}}.ui-dialog-titlebar-close{background:none}.guest-confirm-popup .auth-form{max-width:100%}.guest-confirm-popup .auth-form .popup-footer-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-ms-align-items:center;-ms-flex-align:center;align-items:center}.content-actions .video-download{position:relative}.content-actions .video-download .download{position:relative;z-index:10}.content-actions .video-download .download.hidden{display:none}.content-actions .video-download .download.active{-ms-filter:none;filter:none;opacity:1}.content-actions .video-download .download i{font-size:20px}.content-actions .photoset-download .p-zip-download{display:-moz-flex;display:-ms-flexbox;display:flex}.content-actions .download-links{border-radius:4px 0 4px 4px;line-height:30px;font-size:12px;position:absolute;right:-7px;margin-top:3px;display:none;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;z-index:3;padding:5px 5px 5px 1px}.content-actions .download-links.active{-ms-filter:none;filter:none;opacity:1;display:-moz-flex;display:-ms-flexbox;display:flex}.content-actions .download-links:before{position:absolute;z-index:1;content:\"\";display:block;right:0;bottom:100%;border-radius:4px 4px 0 0;height:33px;width:34px}.content-actions .download-links li{position:relative;min-width:56px;text-align:center;margin-left:4px;padding:0;backface-visibility:visible!important;animation-duration:.9s}.content-actions .download-links li.active{animation-name:flipInY}.content-actions .download-links li:before{transform:scale(1.3);position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;visibility:hidden;display:block;content:\"\";border-radius:4px}.content-actions .download-links li:hover:before{transform:scale(1);visibility:visible;transition:all .3s}.content-actions .download-links li a{position:relative;z-index:2;padding:5px 0;display:block;white-space:nowrap}.content-actions .download-links li a .format-icon{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;-ms-align-items:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}.content-actions .download-links li a .format-icon i{font-size:25px;line-height:30px}.content-actions .download-links li a .format-icon .vr i{font-size:17px;display:inline-block;vertical-align:top}.content-actions .download-links li a .format-icon .format-label,.content-actions .download-links li a .format-size{line-height:16px}@media (min-width:768px){.content-actions .video-download .download-links:before{width:110px}}@font-face{font-family:mc-icons-liveshow;src:url(" + __webpack_require__(187) + ") format(\"woff\"),url(" + __webpack_require__(188) + ") format(\"truetype\"),url(" + __webpack_require__(189) + "#mc-icons-liveshow) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:mc-common-icons;src:url(" + __webpack_require__(190) + ") format(\"woff\"),url(" + __webpack_require__(191) + ") format(\"truetype\"),url(" + __webpack_require__(192) + "#mc-common-icons) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:pt_sansregular;src:url(" + __webpack_require__(193) + ") format(\"woff\"),url(" + __webpack_require__(194) + ") format(\"truetype\"),url(" + __webpack_require__(195) + "#pt_sansregular) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:pt_sansbold;src:url(" + __webpack_require__(196) + ") format(\"woff\"),url(" + __webpack_require__(197) + ") format(\"truetype\"),url(" + __webpack_require__(198) + "#pt_sansbold) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:amc-cf;src:url(\"data:application/font-woff;base64,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\") format(\"woff\"),url(\"data:application/x-font-ttf;base64,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\") format(\"truetype\"),url(" + __webpack_require__(199) + "#amc-cf) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:simplifica;src:url(" + __webpack_require__(44) + ") format(\"woff\"),url(" + __webpack_require__(45) + ") format(\"truetype\"),url(" + __webpack_require__(46) + "#simplifica) format(\"svg\");font-weight:400;font-style:\"normal\"}.gift-list{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;-ms-flex-flow:row wrap;flex-flow:row wrap;margin:20px 0}.gift-list .gift-item{max-width:80px;border-radius:4px;width:80px;background-repeat:no-repeat;height:95px;background-position:center 30%;background-color:transparent;padding-top:80px;text-align:center;cursor:pointer;transition:background-color .2s;margin-bottom:3px;-ms-flex:1 auto;flex:1 auto}.gift-list .gift-item.active,.gift-list .gift-item:active{background-color:hsla(0,0%,7%,.5)}.gift-0{background-image:url(" + __webpack_require__(200) + ")}.gift-1{background-image:url(" + __webpack_require__(201) + ")}.gift-2{background-image:url(" + __webpack_require__(202) + ")}.gift-3{background-image:url(" + __webpack_require__(203) + ")}.gift-4{background-image:url(" + __webpack_require__(204) + ")}.gift-5{background-image:url(" + __webpack_require__(205) + ")}.gift-6{background-image:url(" + __webpack_require__(206) + ")}.gift-7{background-image:url(" + __webpack_require__(207) + ")}.gift-8{background-image:url(" + __webpack_require__(208) + ")}.gift-9{background-image:url(" + __webpack_require__(209) + ")}.gift-10{background-image:url(" + __webpack_require__(210) + ")}.gift-11{background-image:url(" + __webpack_require__(211) + ")}.gift-12{background-image:url(" + __webpack_require__(212) + ")}.gift-13{background-image:url(" + __webpack_require__(213) + ")}.gift-14{background-image:url(" + __webpack_require__(214) + ")}.gift-15{background-image:url(" + __webpack_require__(215) + ")}.gift-16{background-image:url(" + __webpack_require__(216) + ")}.gift-17{background-image:url(" + __webpack_require__(217) + ")}.gift-18{background-image:url(" + __webpack_require__(218) + ")}.gift-19{background-image:url(" + __webpack_require__(219) + ")}.gift-20{background-image:url(" + __webpack_require__(220) + ")}.gift-21{background-image:url(" + __webpack_require__(221) + ")}.gift-22{background-image:url(" + __webpack_require__(222) + ")}.gift-23{background-image:url(" + __webpack_require__(223) + ")}.gift-24{background-image:url(" + __webpack_require__(224) + ")}.gift-25{background-image:url(" + __webpack_require__(225) + ")}.gift-26{background-image:url(" + __webpack_require__(226) + ")}.gift-27{background-image:url(" + __webpack_require__(227) + ")}.gift-28{background-image:url(" + __webpack_require__(228) + ")}.gift-29{background-image:url(" + __webpack_require__(229) + ")}.gift-30{background-image:url(" + __webpack_require__(230) + ")}.gift-31{background-image:url(" + __webpack_require__(231) + ")}.gift-32{background-image:url(" + __webpack_require__(232) + ")}.gift-33{background-image:url(" + __webpack_require__(233) + ")}.gift-34{background-image:url(" + __webpack_require__(234) + ")}.gift-35{background-image:url(" + __webpack_require__(235) + ")}.gift-36{background-image:url(" + __webpack_require__(236) + ")}.gift-37{background-image:url(" + __webpack_require__(237) + ")}.gift-38{background-image:url(" + __webpack_require__(238) + ")}.gift-39{background-image:url(" + __webpack_require__(239) + ")}.gift-40{background-image:url(" + __webpack_require__(240) + ")}.gift-41{background-image:url(" + __webpack_require__(241) + ")}.gift-42{background-image:url(" + __webpack_require__(242) + ")}.gift-43{background-image:url(" + __webpack_require__(243) + ")}.gift-44{background-image:url(" + __webpack_require__(244) + ")}.gift-45{background-image:url(" + __webpack_require__(245) + ")}.gift-46{background-image:url(" + __webpack_require__(246) + ")}.gift-47{background-image:url(" + __webpack_require__(247) + ")}.gift-48{background-image:url(" + __webpack_require__(248) + ")}.gift-49{background-image:url(" + __webpack_require__(249) + ")}.gift-50{background-image:url(" + __webpack_require__(250) + ")}.gift-51{background-image:url(" + __webpack_require__(251) + ")}.gift-52{background-image:url(" + __webpack_require__(252) + ")}.gift-53{background-image:url(" + __webpack_require__(253) + ")}.gift-54{background-image:url(" + __webpack_require__(254) + ")}.gift-55{background-image:url(" + __webpack_require__(255) + ")}.gift-56{background-image:url(" + __webpack_require__(256) + ")}.gift-57{background-image:url(" + __webpack_require__(257) + ")}.gift-58{background-image:url(" + __webpack_require__(258) + ")}.gift-59{background-image:url(" + __webpack_require__(259) + ")}.gift-60{background-image:url(" + __webpack_require__(260) + ")}.gift-61{background-image:url(" + __webpack_require__(261) + ")}.gift-62{background-image:url(" + __webpack_require__(262) + ")}.gift-63{background-image:url(" + __webpack_require__(263) + ")}.gift-64{background-image:url(" + __webpack_require__(264) + ")}.gift-65{background-image:url(" + __webpack_require__(265) + ")}.gift-66{background-image:url(" + __webpack_require__(266) + ")}.gift-67{background-image:url(" + __webpack_require__(267) + ")}.gift-68{background-image:url(" + __webpack_require__(268) + ")}.gift-69{background-image:url(" + __webpack_require__(269) + ")}.gift-70{background-image:url(" + __webpack_require__(270) + ")}.gift-71{background-image:url(" + __webpack_require__(271) + ")}.gift-72{background-image:url(" + __webpack_require__(272) + ")}.gift-73{background-image:url(" + __webpack_require__(273) + ")}.gift-74{background-image:url(" + __webpack_require__(274) + ")}.gift-75{background-image:url(" + __webpack_require__(275) + ")}.gift-76{background-image:url(" + __webpack_require__(276) + ")}.gift-77{background-image:url(" + __webpack_require__(277) + ")}.gift-78{background-image:url(" + __webpack_require__(278) + ")}.gift-79{background-image:url(" + __webpack_require__(279) + ")}.gift-80{background-image:url(" + __webpack_require__(280) + ")}.gift-81{background-image:url(" + __webpack_require__(281) + ")}.gift-82{background-image:url(" + __webpack_require__(282) + ")}.gift-83{background-image:url(" + __webpack_require__(283) + ")}.gift-84{background-image:url(" + __webpack_require__(284) + ")}.gift-85{background-image:url(" + __webpack_require__(285) + ")}.gift-86{background-image:url(" + __webpack_require__(286) + ")}.gift-87{background-image:url(" + __webpack_require__(287) + ")}.gift-88{background-image:url(" + __webpack_require__(288) + ")}.gift-89{background-image:url(" + __webpack_require__(289) + ")}.gift-90{background-image:url(" + __webpack_require__(290) + ")}.gift-91{background-image:url(" + __webpack_require__(291) + ")}.gift-92{background-image:url(" + __webpack_require__(292) + ")}.gift-93{background-image:url(" + __webpack_require__(293) + ")}.gift-94{background-image:url(" + __webpack_require__(294) + ")}.gift-95{background-image:url(" + __webpack_require__(295) + ")}.gift-96{background-image:url(" + __webpack_require__(296) + ")}.gift-97{background-image:url(" + __webpack_require__(297) + ")}.gift-98{background-image:url(" + __webpack_require__(298) + ")}.gift-99{background-image:url(" + __webpack_require__(299) + ")}.gift-100{background-image:url(" + __webpack_require__(300) + ")}.gift-101{background-image:url(" + __webpack_require__(301) + ")}.gift-102{background-image:url(" + __webpack_require__(302) + ")}.gift-103{background-image:url(" + __webpack_require__(303) + ")}.gift-104{background-image:url(" + __webpack_require__(304) + ")}.gift-105{background-image:url(" + __webpack_require__(305) + ")}.gift-106{background-image:url(" + __webpack_require__(306) + ")}.gift-107{background-image:url(" + __webpack_require__(307) + ")}.gift-108{background-image:url(" + __webpack_require__(308) + ")}.gift-109{background-image:url(" + __webpack_require__(309) + ")}.gift-110{background-image:url(" + __webpack_require__(310) + ")}.gift-111{background-image:url(" + __webpack_require__(311) + ")}.gift-112{background-image:url(" + __webpack_require__(312) + ")}.gift-113{background-image:url(" + __webpack_require__(313) + ")}.gift-114{background-image:url(" + __webpack_require__(314) + ")}.gift-115{background-image:url(" + __webpack_require__(315) + ")}.gift-116{background-image:url(" + __webpack_require__(316) + ")}.gift-116,.gift-117{background-size:contain}.gift-117{background-image:url(" + __webpack_require__(317) + ")}.gift-118{background-image:url(" + __webpack_require__(318) + ")}.gift-118,.gift-119{background-size:contain}.gift-119{background-image:url(" + __webpack_require__(319) + ")}.gift-120{background-image:url(" + __webpack_require__(320) + ")}.gift-120,.gift-121{background-size:contain}.gift-121{background-image:url(" + __webpack_require__(321) + ")}.gift-122{background-image:url(" + __webpack_require__(322) + ")}.gift-122,.gift-123{background-size:contain}.gift-123{background-image:url(" + __webpack_require__(323) + ")}.gift-124{background-image:url(" + __webpack_require__(324) + ")}.gift-124,.gift-125{background-size:contain}.gift-125{background-image:url(" + __webpack_require__(325) + ")}.gift-126{background-image:url(" + __webpack_require__(326) + ")}.gift-126,.gift-127{background-size:contain}.gift-127{background-image:url(" + __webpack_require__(327) + ")}.gift-128{background-image:url(" + __webpack_require__(328) + ")}.gift-128,.gift-129{background-size:contain}.gift-129{background-image:url(" + __webpack_require__(329) + ")}.gift-130{background-image:url(" + __webpack_require__(330) + ")}.gift-130,.gift-131{background-size:contain}.gift-131{background-image:url(" + __webpack_require__(331) + ")}.gift-132{background-image:url(" + __webpack_require__(332) + ")}.gift-132,.gift-133{background-size:contain}.gift-133{background-image:url(" + __webpack_require__(333) + ")}.gift-134{background-image:url(" + __webpack_require__(334) + ")}.gift-134,.gift-135{background-size:contain}.gift-135{background-image:url(" + __webpack_require__(335) + ")}.gift-136{background-image:url(" + __webpack_require__(336) + ")}.gift-136,.gift-137{background-size:contain}.gift-137{background-image:url(" + __webpack_require__(337) + ")}.gift-138{background-image:url(" + __webpack_require__(338) + ")}.gift-138,.gift-139{background-size:contain}.gift-139{background-image:url(" + __webpack_require__(339) + ")}.gift-140{background-image:url(" + __webpack_require__(340) + ")}.gift-140,.gift-141{background-size:contain}.gift-141{background-image:url(" + __webpack_require__(341) + ")}.gift-142{background-image:url(" + __webpack_require__(342) + ")}.gift-142,.gift-143{background-size:contain}.gift-143{background-image:url(" + __webpack_require__(343) + ")}.gift-144{background-image:url(" + __webpack_require__(344) + ")}.gift-144,.gift-145{background-size:contain}.gift-145{background-image:url(" + __webpack_require__(345) + ")}.gift-146{background-image:url(" + __webpack_require__(346) + ")}.gift-146,.gift-147{background-size:contain}.gift-147{background-image:url(" + __webpack_require__(347) + ")}.gift-148{background-image:url(" + __webpack_require__(348) + ")}.gift-148,.gift-149{background-size:contain}.gift-149{background-image:url(" + __webpack_require__(349) + ")}.gift-150{background-image:url(" + __webpack_require__(350) + ")}.gift-150,.gift-151{background-size:contain}.gift-151{background-image:url(" + __webpack_require__(351) + ")}.gift-152{background-image:url(" + __webpack_require__(352) + ")}.gift-153{background-image:url(" + __webpack_require__(353) + ")}.gift-154{background-image:url(" + __webpack_require__(354) + ")}.gift-155{background-image:url(" + __webpack_require__(355) + ")}.gift-156{background-image:url(" + __webpack_require__(356) + ")}.gift-157{background-image:url(" + __webpack_require__(357) + ")}.gift-158{background-image:url(" + __webpack_require__(358) + ")}.gift-159{background-image:url(" + __webpack_require__(359) + ")}.gift-160{background-image:url(" + __webpack_require__(360) + ")}.gift-161{background-image:url(" + __webpack_require__(361) + ")}.gift-162{background-image:url(" + __webpack_require__(362) + ")}.gift-163{background-image:url(" + __webpack_require__(363) + ")}.gift-164{background-image:url(" + __webpack_require__(364) + ")}.gift-165{background-image:url(" + __webpack_require__(365) + ")}.gift-166{background-image:url(" + __webpack_require__(366) + ")}.gift-167{background-image:url(" + __webpack_require__(367) + ")}.gift-168{background-image:url(" + __webpack_require__(368) + ")}.gift-169{background-image:url(" + __webpack_require__(369) + ")}.gift-170{background-image:url(" + __webpack_require__(370) + ")}.gift-171{background-image:url(" + __webpack_require__(371) + ")}.gift-172{background-image:url(" + __webpack_require__(372) + ")}.gift-173{background-image:url(" + __webpack_require__(373) + ")}.gift-174{background-image:url(" + __webpack_require__(374) + ")}.gift-175{background-image:url(" + __webpack_require__(375) + ")}.mc-site-common-popup.conversation-gifts-popup,.valentines-gift-popup{max-width:465px;background-color:#201f22!important;font-family:pt_sansregular,Arial!important;color:#fff!important}.mc-site-common-popup.conversation-gifts-popup .giftbox-wrapper,.valentines-gift-popup .giftbox-wrapper{margin-top:15px}.mc-site-common-popup.conversation-gifts-popup .mc-common-button,.valentines-gift-popup .mc-common-button{font-family:pt_sansbold;font-weight:700;font-size:11px;color:#fff!important;border-radius:2px;height:35px!important;line-height:normal!important;background-color:hsla(0,0%,100%,.15)!important;text-transform:uppercase;max-width:135px;width:100%;border:none!important;padding:12px 0!important}.mc-site-common-popup.conversation-gifts-popup .gift-set-list,.valentines-gift-popup .gift-set-list{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;-ms-align-items:center;-ms-flex-align:center;align-items:center;margin-bottom:20px;margin-top:0}.mc-site-common-popup.conversation-gifts-popup .gift-set-list.hidden,.valentines-gift-popup .gift-set-list.hidden{display:none}.mc-site-common-popup.conversation-gifts-popup .gift-set-list .gift-set,.valentines-gift-popup .gift-set-list .gift-set{font-size:24px;margin-right:10px;cursor:pointer;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;transition:opacity .2s}.mc-site-common-popup.conversation-gifts-popup .gift-set-list .gift-set.active,.valentines-gift-popup .gift-set-list .gift-set.active{-ms-filter:none;filter:none;opacity:1}.mc-site-common-popup.conversation-gifts-popup .gift-set-list .gift-set .ls-iconlove_18,.valentines-gift-popup .gift-set-list .gift-set .ls-iconlove_18{font-size:18px}.mc-site-common-popup.conversation-gifts-popup .popup-footer-wrapper.multiple-btns,.valentines-gift-popup .popup-footer-wrapper.multiple-btns{-ms-align-items:center;-ms-flex-align:center;align-items:center}.mc-site-common-popup.conversation-gifts-popup .ui-dialog-content,.valentines-gift-popup .ui-dialog-content{max-width:none;padding:8%!important}.mc-site-common-popup.conversation-gifts-popup .ui-dialog-content .popup-title-wrapper,.valentines-gift-popup .ui-dialog-content .popup-title-wrapper{text-align:center;padding-bottom:0;margin-bottom:0;border-bottom-width:0;background-color:#201f22!important;font-family:pt_sansbold}.mc-site-common-popup.conversation-gifts-popup .ui-dialog-content .popup-title-wrapper .popup-title,.valentines-gift-popup .ui-dialog-content .popup-title-wrapper .popup-title{font-size:16px!important;color:#fff!important}.mc-site-common-popup.conversation-gifts-popup .ui-dialog-content .popup-content-wrapper,.valentines-gift-popup .ui-dialog-content .popup-content-wrapper{max-height:280px;margin-bottom:0;background-color:#201f22!important;border-width:1px 0!important;border-style:solid;border-color:hsla(0,0%,100%,.3)!important}.mc-site-common-popup.conversation-gifts-popup .ui-dialog-content .popup-content-wrapper .gift-set-title,.valentines-gift-popup .ui-dialog-content .popup-content-wrapper .gift-set-title{font-size:16px;text-align:center;margin-top:25px;font-family:pt_sansbold}.mc-site-common-popup.conversation-gifts-popup .ui-dialog-content .popup-footer-wrapper,.valentines-gift-popup .ui-dialog-content .popup-footer-wrapper{text-align:center;margin-top:0;border-width:0!important;background-color:#201f22!important}.mc-site-common-popup.conversation-gifts-popup .ui-dialog-content .popup-footer-wrapper .gift-billing-hint,.valentines-gift-popup .ui-dialog-content .popup-footer-wrapper .gift-billing-hint{margin-top:10px!important;margin-bottom:30px!important;color:hsla(0,0%,100%,.3);font-size:12px!important}.mc-site-common-popup.conversation-gifts-popup .ui-dialog-content .icon-au_close-delete,.valentines-gift-popup .ui-dialog-content .icon-au_close-delete{right:10px!important;top:10px!important;font-family:iconfont!important}.mc-site-common-popup.conversation-gifts-popup .ui-dialog-content .icon-au_close-delete:before,.valentines-gift-popup .ui-dialog-content .icon-au_close-delete:before{color:#fff!important}.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item,.valentines-gift-popup .gift-list .gift-item{padding:0;max-width:88px;width:88px;height:88px;margin-bottom:4px;border:1px solid transparent;position:relative;border-radius:1px;background-color:transparent;margin-right:2px;margin-left:2px}.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item:before,.valentines-gift-popup .gift-list .gift-item:before{content:\"\";position:absolute;background-color:#252428;top:7px;right:7px;bottom:7px;left:7px;border-radius:50%}.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item .gift-icon,.valentines-gift-popup .gift-list .gift-item .gift-icon{z-index:1;display:block;position:absolute;top:0;right:0;bottom:0;left:0;height:100%;background-size:contain;background-position:50%;background-repeat:no-repeat;transition:opacity .4s}.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item .gift-item-price,.valentines-gift-popup .gift-list .gift-item .gift-item-price{border-radius:1%;border-width:2px;border-style:solid;position:absolute;top:2px;right:2px;bottom:2px;left:2px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;z-index:2;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;-ms-align-items:center;-ms-flex-align:center;align-items:center;transition:opacity .4s,border-radius .4s;font-size:16px}.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item.active:before,.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item:active:before,.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item:hover:before,.valentines-gift-popup .gift-list .gift-item.active:before,.valentines-gift-popup .gift-list .gift-item:active:before,.valentines-gift-popup .gift-list .gift-item:hover:before{background-color:transparent}.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item.active .gift-icon,.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item:active .gift-icon,.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item:hover .gift-icon,.valentines-gift-popup .gift-list .gift-item.active .gift-icon,.valentines-gift-popup .gift-list .gift-item:active .gift-icon,.valentines-gift-popup .gift-list .gift-item:hover .gift-icon{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";filter:alpha(opacity=20);opacity:.2}.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item.active .gift-item-price,.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item:active .gift-item-price,.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item:hover .gift-item-price,.valentines-gift-popup .gift-list .gift-item.active .gift-item-price,.valentines-gift-popup .gift-list .gift-item:active .gift-item-price,.valentines-gift-popup .gift-list .gift-item:hover .gift-item-price{-ms-filter:none;filter:none;opacity:1;border-radius:50%}.valentines-gift-popup .gift-list .gift-item .gift-icon{background-size:contain;height:82px;width:82px}.messages .message-gift .message-bubble{height:115px;width:300px;border-color:transparent!important;margin-bottom:20px;margin-top:20px;padding-left:40px!important;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.messages .message-gift .message-bubble .gift-amount{font-size:16px}.messages .message-gift .message-bubble i{font-size:20px}.messages .message-gift .gift{width:140px;height:140px;border-radius:50%;border-width:3px;border-style:solid;background-position:50%;background-repeat:no-repeat;position:absolute;top:-16px;right:-100px}.messages .message-gift .gift.gift-20,.messages .message-gift .gift.gift-23,.messages .message-gift .gift.gift-24,.messages .message-gift .gift.gift-25,.messages .message-gift .gift.gift-27,.messages .message-gift .gift.gift-28,.messages .message-gift .gift.gift-29,.messages .message-gift .gift.gift-31{background-size:75%}.messages .message-gift .gift.gift-21,.messages .message-gift .gift.gift-22,.messages .message-gift .gift.gift-26,.messages .message-gift .gift.gift-30{background-size:55%}.messages .message-gift .gift.gift-0,.messages .message-gift .gift.gift-1,.messages .message-gift .gift.gift-2,.messages .message-gift .gift.gift-3,.messages .message-gift .gift.gift-4,.messages .message-gift .gift.gift-5,.messages .message-gift .gift.gift-6,.messages .message-gift .gift.gift-7,.messages .message-gift .gift.gift-8,.messages .message-gift .gift.gift-9,.messages .message-gift .gift.gift-10,.messages .message-gift .gift.gift-11,.messages .message-gift .gift.gift-12,.messages .message-gift .gift.gift-13,.messages .message-gift .gift.gift-14,.messages .message-gift .gift.gift-15,.messages .message-gift .gift.gift-16,.messages .message-gift .gift.gift-17,.messages .message-gift .gift.gift-18,.messages .message-gift .gift.gift-19,.messages .message-gift .gift.gift-32,.messages .message-gift .gift.gift-33,.messages .message-gift .gift.gift-34,.messages .message-gift .gift.gift-35,.messages .message-gift .gift.gift-36,.messages .message-gift .gift.gift-37,.messages .message-gift .gift.gift-38,.messages .message-gift .gift.gift-39,.messages .message-gift .gift.gift-40,.messages .message-gift .gift.gift-41,.messages .message-gift .gift.gift-42,.messages .message-gift .gift.gift-43{background-size:60%}.messages .message-gift span{max-width:90%;max-height:60px;overflow:hidden}.messages .message-gift span span{word-break:break-all}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row.message-gift{max-width:100%;width:95%}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row.message-gift .message-bubble{height:90px;width:85%;padding-left:20px!important;min-width:inherit}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row.message-gift .gift{width:120px;height:120px;right:-40px}.througth-chat #open-gift-popup{font-size:45px}.througth-chat #open-gift-popup i{margin-bottom:4px}.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item{border:none!important;background-color:transparent!important}.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item .gift-item-price{border-color:#fff!important;color:#fff!important}.messages .message-gift .message-bubble{background-color:#6d3f5c}.messages .message-gift .gift{border-color:#6d3f5c;background-color:#000}@media screen and (max-width:420px){.mc-site-common-popup.conversation-gifts-popup .gift-list .gift-item{max-width:100px;width:100px;height:100px}.gift-list .gift-item{width:100px}.messages .message-gift .message-bubble{width:196px}.messages .message-gift .message-bubble span{width:100px;line-height:15px;word-break:break-all}}@media screen and (max-width:360px){.messages .message-gift .message-bubble{padding-left:5px!important;width:160px}.messages .message-gift .gift{right:-86px}}@media screen and (orientation:landscape){.mc-site-common-popup.conversation-gifts-popup .gift-list{-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}}*,:after,:before{-webkit-font-smoothing:antialiased}object[name^=swfcontainer]{position:absolute;left:-10000px;top:-10000px}.site-checkbox{width:18px;height:18px;min-width:18px;position:relative;display:inline-block;cursor:pointer;vertical-align:top}.site-checkbox input{position:absolute;top:0;left:0;right:0;bottom:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;width:100%;height:100%;border:none;margin:0;padding:0;z-index:2;cursor:pointer}.site-checkbox input:checked+.checkbox:after{-ms-filter:none;filter:none;opacity:1;transform:translateY(0) rotate(-45deg)}.site-checkbox .checkbox{width:100%;height:100%;border:1px solid #fff;position:relative;display:block}.site-checkbox .checkbox:after{content:\"\";width:16px;height:5px;border-width:0 0 2px 2px;border-style:solid;border-color:#fff;position:absolute;top:0;left:3px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:transform .2s,opacity .2s;transform:translateY(-5px) rotate(-45deg)}.site-checkbox+.label{margin-left:20px;font-size:14px;line-height:18px;display:inline-block;vertical-align:top;cursor:pointer}.site-checkbox.disabled,.site-checkbox.disabled+.label{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.site-checkbox .r-sign{position:absolute;left:-11px;font-size:18px;line-height:18px;top:50%;margin-top:-5px}.lazyload{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.lazyloaded{-ms-filter:none;filter:none;opacity:1;transition:opacity,.2s}.header-block-wrapper{position:relative}.header-block-wrapper .header-images-slider{overflow:hidden;visibility:hidden;position:relative}.header-block-wrapper .header-images-slider .items{overflow:hidden;position:relative;height:117px}.header-block-wrapper .header-images-slider .slide-item{float:left;width:100%;height:inherit;background-repeat:no-repeat;background-size:cover;background-position:top;position:relative}.header-block-wrapper .header-images-slider .slide-item img{display:block;max-width:100%;min-width:100%}.header-block-wrapper .slider-pager{position:absolute;left:30px;right:30px;bottom:10px;text-align:center}.header-block-wrapper .slider-pager .slide{width:10px;height:10px;border-radius:50%;display:inline-block;margin:0 5px;cursor:pointer;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";filter:alpha(opacity=20);opacity:.2}.header-block-wrapper .slider-pager .slide.active{-ms-filter:none;filter:none;opacity:1}.icon-lib-link_23{font-size:23px}.icon-lib-messages_16{font-size:16px}.icon-lib-settings_19{font-size:19px}.icon-lib-favorites_20,.icon-lib-mp_menuPurchased_20{font-size:20px}@font-face{font-family:icons-lib;src:url(" + __webpack_require__(47) + ");src:url(" + __webpack_require__(47) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(376) + ") format(\"truetype\"),url(" + __webpack_require__(377) + ") format(\"woff\"),url(" + __webpack_require__(378) + "#icons-lib) format(\"svg\");font-weight:400;font-style:normal}[class*=\" icon-lib-\"],[class^=icon-lib-]{font-family:icons-lib!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-lib-cross_17:before{content:\"\\E900\"}.icon-lib-bell_17:before{content:\"\\E901\"}.icon-lib-arrow_left_14:before{content:\"\\E902\"}.icon-lib-arrow_right_14:before{content:\"\\E903\"}.icon-lib-messages_16:before{content:\"\\E904\"}.icon-lib-settings_19:before{content:\"\\E905\"}.icon-lib-drop_4:before{content:\"\\E906\"}.icon-lib-favorites_20:before{content:\"\\E907\"}.icon-lib-mp_categories_12:before{content:\"\\E908\"}.icon-lib-mp_menuPurchased_20:before{content:\"\\E909\"}.icon-lib-mp_purchased_10:before{content:\"\\E90A\"}.icon-lib-pr_categories_12:before{content:\"\\E90B\"}.icon-lib-pr_menuPurchased_16:before{content:\"\\E90C\"}.icon-lib-pr_purchased_9:before{content:\"\\E90D\"}.icon-lib-uhd:before{content:\"\\E90E\"}.icon-lib-link_23:before{content:\"\\E90F\"}.icon-lib-4k_19:before{content:\"\\E910\"}.icon-lib-vr_lq_19:before{content:\"\\E911\"}.icon-lib-vr_hq_19:before{content:\"\\E912\"}.icon-lib-uhd2:before{content:\"\\E913\"}.icon-lib-vr-video_15:before{content:\"\\E914\"}.icon-lib-link_232:before{content:\"\\E915\"}.icon-lib-4k_192:before{content:\"\\E916\"}.icon-lib-question-mark_18:before{content:\"\\E917\"}.login-form-error-message{display:none}.login-form-error-message.show{display:block}.mc-common-input+.error-message{display:none;margin-top:10px;color:rgba(255,50,50,.7)}.mc-common-input.error+.error-message{display:block}#login_form .common-input.error,#login_form .mc-common-input.error{border-color:inherit;color:inherit}.login-page-wrapper{text-align:left}.login-page-wrapper *,.login-page-wrapper :after,.login-page-wrapper :before{box-sizing:border-box}.login-page-wrapper .row{margin-bottom:15px}.login-page-wrapper .row label{display:block;width:auto;line-height:normal;margin-bottom:10px}.login-page-wrapper .row.forgot-row{text-align:right}.login-page-wrapper .row.btns>*{display:block}.login-page-wrapper .row.btns>div{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.login-page-wrapper .row.btns>div>*{max-width:48%}.login-page-wrapper .row.btns>div .mc-common-button{padding-left:20px;padding-right:20px}.login-page-wrapper .row.capcha>div{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.login-page-wrapper .row.capcha>div .capcha-img{max-width:80px;height:32px;margin-right:0;width:32%}.login-page-wrapper .row.capcha>div .capcha-img img{display:block;cursor:pointer}.login-page-wrapper .row.capcha>div .mc-common-input{margin-left:5%;width:63%}@media (min-width:768px){.login-page-wrapper .row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.login-page-wrapper .row label{width:225px;line-height:32px;margin:0}.login-page-wrapper .row>div{width:250px}.login-page-wrapper .row.btns>div .mc-common-button{max-width:auto;width:48%}}.mobile-switcher{position:relative;z-index:5}.mobile-switcher .mc-mobile-format-switcher{position:absolute;line-height:20px;color:#fff;font-size:14px;top:10px;right:10px;background-color:rgba(0,0,0,.7);padding:5px 25px 5px 10px;border-radius:4px}.mobile-switcher .mc-mobile-format-switcher .current i{font-size:18px;position:relative;top:2px}.mobile-switcher .mc-mobile-format-switcher .current>*{vertical-align:middle}.mobile-switcher .mc-mobile-format-switcher .current .arr{transform:rotate(-90deg);font-size:14px;display:block;position:absolute;right:7px;top:10px;line-height:normal;width:8px;height:11px}.mobile-switcher .mc-mobile-format-switcher .list{display:none;background-color:#2f2f2f;position:absolute;top:100%;right:0;min-width:100%;margin-top:7px}.mobile-switcher .mc-mobile-format-switcher .list:after{width:0;height:0;border-style:solid;border-width:0 7px 6px;border-color:transparent transparent #2f2f2f;position:absolute;top:-6px;right:5px;content:\"\"}.mobile-switcher .mc-mobile-format-switcher .list .item{display:block;padding:9px 20px;white-space:nowrap;color:#fff;text-align:center;border-bottom:1px solid #000}.mobile-switcher .mc-mobile-format-switcher .list .item:last-child{border-bottom:none}.mobile-switcher .mc-mobile-format-switcher.opened .list{display:block}.mobile-switcher .mc-mobile-format-switcher.opened .current .arr{transform:rotate(90deg)}.mobile-switcher.hide{display:none}#notificationList{position:fixed;bottom:0;right:auto;z-index:11;padding:20px;width:265px;left:0;width:auto;padding:5px 20px;text-align:center}#notificationList,#notificationList *{box-sizing:border-box}#notificationList .notify{padding:10px 20px;margin-bottom:15px;border-radius:8px;position:relative;box-shadow:0 3px 5px 0 rgba(0,0,0,.2);left:150%;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;margin-right:15%;width:32%;padding:20px 7px;font-size:12px;margin-bottom:0;margin-right:1%}#notificationList .notify .info{display:table;width:100%;vertical-align:middle;display:block}#notificationList .notify:last-child{margin-bottom:0;margin-right:0}#notificationList .notify .foto{float:left;width:55px;height:55px;overflow:hidden;border-radius:50%;border-width:4px;border-style:solid;float:none;margin:0 auto}#notificationList .notify .foto img{display:block;max-width:100%}#notificationList .notify .heading{font-size:12px;text-transform:uppercase;line-height:16px;font-weight:700;overflow-x:hidden;width:auto;margin-top:5px;margin-bottom:5px}#notificationList .notify .txt{height:100%;padding-left:10px;padding-left:0}#notificationList .notify .delete{position:absolute;right:10px;top:10px;cursor:pointer;transform:rotate(45deg);font-size:26px;top:5px;right:5px}#notificationList .notify .delete:hover{text-decoration:none}#notificationList .notify.appearence{animation:notifyAppearence .5s;-webkit-animation:notifyAppearence .5s}#notificationList .notify.default{-ms-filter:none;filter:none;opacity:1;left:0}#notificationList .notify .td{display:table-cell;vertical-align:middle;display:block}#notificationList .notify.deleted{animation:notifyDeleting .5s;-webkit-animation:notifyDeleting .5s}#notificationList>div{display:-moz-flex;display:-ms-flexbox;display:flex}@media screen and (min-width:600px){#notificationList{left:0;width:265px;padding:20px;text-align:left}#notificationList>div{display:block}#notificationList .notify{width:auto;padding:10px 20px;font-size:14px;margin-bottom:15px;margin-right:0}#notificationList .notify .txt{padding-left:10px}#notificationList .notify .info{display:table}#notificationList .notify .td{display:table-cell}#notificationList .notify:last-child{margin-bottom:0;margin-right:0}#notificationList .notify .heading{margin-top:0}}@keyframes notifyDeleting{0%{left:0}20%{left:20px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}to{left:-150%;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}}@keyframes notifyAppearence{0%{left:-150%}80%{left:20px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}to{left:0;-ms-filter:none;filter:none;opacity:1}}.password-recovery-form{text-align:center;max-width:310px;margin:0 auto}.password-recovery-form .errors-block.error{color:red;margin-bottom:15px}.password-recovery-form .row{margin-bottom:15px}.mc-site-common-popup{position:fixed;background-color:#fff;max-width:100%;outline:none}.mc-site-common-popup *{box-sizing:border-box}.mc-site-common-popup .ui-dialog-titlebar{height:0;overflow:hidden;display:none}.mc-site-common-popup .ui-dialog-content{padding:15px 20px 20px;max-width:600px}.mc-site-common-popup .ui-dialog-content .cross.close{position:absolute;cursor:pointer;right:20px;top:22px;z-index:1}.mc-site-common-popup .ui-dialog-content .popup-title-wrapper{padding-bottom:15px;margin-bottom:25px;border-bottom-width:1px;border-bottom-style:solid}.mc-site-common-popup .ui-dialog-content .popup-title-wrapper .popup-title{font-size:18px;line-height:normal;font-weight:700;line-height:30px;font-style:normal;margin-top:0}.mc-site-common-popup .ui-dialog-content .popup-content-wrapper{margin-bottom:20px;font-size:12px}.mc-site-common-popup .ui-dialog-content .popup-content-wrapper p{margin-bottom:15px}.mc-site-common-popup .ui-dialog-content .popup-footer-wrapper{text-align:right}.mc-site-common-popup .ui-dialog-content .popup-footer-wrapper.multiple-btns{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-flow:row wrap;flex-flow:row wrap}.mc-site-common-popup .ui-dialog-content .popup-footer-wrapper.multiple-btns>*{display:block;margin-bottom:15px;min-width:100%}.mc-site-common-popup .ui-dialog-content .popup-footer-wrapper.multiple-btns>:last-child{margin-bottom:0}.mc-site-common-popup~.ui-widget-overlay{z-index:999;position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.8)}@media (max-width:668px){.popup-footer-wrapper.multiple-btns>*{width:100%;min-width:none}}@media (min-width:768px){.mc-site-common-popup .ui-dialog-content .popup-footer-wrapper.multiple-btns>*{margin-bottom:0;min-width:0}}@media (max-width:774px) and (max-height:774px){.mc-site-common-popup{position:fixed}}@media (orientation:landscape){.mc-site-common-popup{-ms-flex-flow:column nowrap;flex-flow:column nowrap}}#spin-wrap,.spin-wrap,_centered{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}#spin,#spin-wrap,.spin-wrap,.spinner,_round{border-radius:50%}.preloader-wrap{width:100%;max-height:550px;padding-top:60%;position:relative}#spin-wrap,.spin-wrap{width:90px;height:90px;background:#dedede}#spin-wrap.small,.spin-wrap.small{height:20px;top:10px;left:0;position:relative;vertical-align:top;background-color:#894174;display:inline-block}#spin-wrap.small.back-1 #spin,#spin-wrap.small.back-1 .spinner,.spin-wrap.small.back-1 #spin,.spin-wrap.small.back-1 .spinner{background-color:#984881}#spin-wrap.small #spin,#spin-wrap.small .spinner,.spin-wrap.small #spin,.spin-wrap.small .spinner{width:60%!important;height:60%!important;margin:20%!important}#spin-wrap.back-2,.spin-wrap.back-2{background-color:#1e1e24}#spin-wrap.back-2 #spin,#spin-wrap.back-2 .spinner,.spin-wrap.back-2 #spin,.spin-wrap.back-2 .spinner{background-color:#000}#spin,.spinner{width:78%;height:78%;margin:11%;background:#fff}#spin:after,#spin:before,.spinner:after,.spinner:before{content:\"\";display:block;position:absolute;top:0;width:50%;height:100%;z-index:-1}#spin:before,.spinner:before{left:50%;border-radius:0 100% 100% 0/50%;background:url(\"data:image/png;base64,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\") no-repeat 100%;background-size:200% 100%;transform-origin:left center;animation:spin 1.5s linear infinite reverse}#spin:after,.spinner:after{left:0;border-radius:100% 0 0 100%/50%;background:url(\"data:image/png;base64,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\") no-repeat;background-size:200% 100%;transform-origin:right center;animation:spin 2.5s linear infinite}.loading-text{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;display:block;font-size:12px;font-weight:700;height:16%;text-align:center;color:#a1a1a1;animation:opacityload 2s linear infinite}.btn-spinner #spin-wrap,.btn-spinner .spin-wrap{width:0;transition:width .2s}.btn-spinner.spin #spin-wrap,.btn-spinner.spin .spin-wrap{width:20px}.small-loader{top:50%;margin-top:-10px;display:block;width:19px;height:19px;position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;visibility:hidden;background-repeat:no-repeat;background-position:0 0;transform:scale(1.5)}.small-loader.type-1{background-image:url(" + __webpack_require__(5) + ")}.small-loader.spin{visibility:visible;-ms-filter:none;filter:none;opacity:1;animation:play 1s steps(28) infinite;transform:scale(1)}.spin:before{background-image:url(" + __webpack_require__(5) + ")}@keyframes opacityload{0%{-ms-filter:none;filter:none;opacity:1}50%{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}to{-ms-filter:none;filter:none;opacity:1}}@keyframes spin{0%{transform:rotate(90deg)}to{transform:rotate(-270deg)}}@keyframes reset{0%{transform:translate(-50%,-50%) rotate(-90deg)}to{transform:translate(-50%,-50%) rotate(270deg)}}@keyframes play{0%{background-position:0 0}to{background-position:0 -560px}}.static-page-docs{padding:0 20px}.static-page-docs .error-message,.static-page-docs .red-message{color:red}.static-page-docs p{padding:10px 0}.static-page-docs ol li,.static-page-docs ul li{padding-top:15px}.static-page-docs ul li{list-style-type:disc;margin-left:15px}.static-page-docs ul.latin li{list-style-type:lower-latin}.static-page-docs ul.rome li{list-style-type:lower-roman}.static-page-docs ol{counter-reset:item;margin-top:15px}.static-page-docs ol li{list-style-type:decimal}.static-page-docs ol ul li{list-style-type:disc;margin-left:20px}.static-page-docs ol.dots-num>li{display:block}.static-page-docs ol.dots-num>li:before{content:counters(item,\".\") \" \";counter-increment:item}.static-page-docs sup{font-size:8px}.static-page-docs .notice{border:1px solid hsla(0,0%,100%,.3);padding:20px;text-align:left}.static-page-docs .attention{font-style:italic;font-weight:700}.static-page-docs .crypmail:after{content:attr(data-name) \"@\" attr(data-domain) \".\" attr(data-tld)}.static-page-docs .wrapper-cookie-table{max-width:100%;overflow-x:scroll}.static-page-docs .wrapper-cookie-table .cookie-table{border-collapse:collapse;border:1px solid #cecece}.static-page-docs .wrapper-cookie-table .cookie-table td,.static-page-docs .wrapper-cookie-table .cookie-table th{padding:10px;border:1px solid #cecece}.static-page-docs .wrapper-cookie-table .cookie-table td:nth-child(2),.static-page-docs .wrapper-cookie-table .cookie-table th:nth-child(2){min-width:115px}.static-page-docs .sp-part p{padding-left:0!important}.static-page-docs .numeric li{list-style:none}@media (min-width:1024px){.static-page-docs .wrapper-cookie-table{overflow-x:auto}}.title-with-filter{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-ms-align-items:center;-ms-flex-align:center;align-items:center}.title-with-filter .tags-filter{margin-left:15px}.title-with-filter .added{margin-bottom:20px;line-height:38px;font-size:13px}.title-with-filter .global-title{-ms-flex:1 100 auto;flex:1 100 auto}.tags-filter{float:right}.tags-filter-wrapper{height:30px;border-radius:3px;position:relative;min-width:100px;text-transform:uppercase;cursor:pointer}.tags-filter-wrapper *,.tags-filter-wrapper * *{box-sizing:border-box}.tags-filter-wrapper .current{padding:0 30px 0 10px;border-radius:3px;white-space:nowrap}.tags-filter-wrapper .current i{font-size:16px;margin-right:5px}.tags-filter-wrapper .current i.arr{margin-left:5px;margin-right:0;font-size:10px;transform:rotate(90deg);position:absolute;right:10px;top:0;display:inline-block}.tags-filter-wrapper .current span{display:inline-block;vertical-align:top}.tags-filter-wrapper .tags-list-wrapper{position:absolute;top:100%;right:0;margin-top:-2px;visibility:hidden;min-width:100px;z-index:2;padding:20px 0 20px 20px;border-radius:3px 0 3px 3px;min-width:100%;width:280px}.tags-filter-wrapper .tags-list-wrapper .tags-scroll{padding-right:18px;max-height:120px;overflow:auto}.tags-filter-wrapper .tags-list-wrapper .tags-scroll .mCSB_scrollTools{right:-5px!important}.tags-filter-wrapper .tags-list-wrapper li{line-height:30px;padding:0 15px;display:block;border-radius:3px;cursor:pointer;position:relative}.tags-filter-wrapper .tags-list-wrapper li.empty{font-size:12px;text-transform:none;white-space:nowrap;cursor:default;color:#fff}.tags-filter-wrapper .tags-list-wrapper li.empty.selected,.tags-filter-wrapper .tags-list-wrapper li.empty:hover{background-color:transparent!important}.tags-filter-wrapper .tags-list-wrapper a:hover{-ms-filter:none;filter:none;opacity:1;display:block;white-space:nowrap}.tags-filter-wrapper .tags-list-wrapper .selected a{position:relative;z-index:2}.tags-filter-wrapper.opened .tags-list-wrapper,.tags-filter-wrapper:not(.click-to-open):hover .tags-list-wrapper{visibility:visible;margin-top:-4px;z-index:100}.tags-filter-wrapper.opened .current i.arr,.tags-filter-wrapper:not(.click-to-open):hover .current i.arr{transform:rotate(-90deg)}.tags-filter-wrapper .tag-search-container{height:30px;overflow:hidden;margin-bottom:20px;padding-right:20px}.tags-filter-wrapper .tag-search-container input{border:1px solid transparent;color:#fff;height:30px;line-height:28px;padding:0 15px;display:block;width:100%;border-radius:2px;min-width:100px}.tags-filter-wrapper .current,.tags-filter-wrapper .current i{line-height:30px}.loading,.loading:before{width:19px;height:19px;display:block}.loading:before{content:\"\";position:absolute;background-repeat:no-repeat;background-position:0 0;transform:scale(1.5);transition:all .3s ease;background-image:url(" + __webpack_require__(5) + ")}.mCS-light-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCSB_scrollTools .mCSB_draggerRail{width:3px}.mCSB_inside>.mCSB_container{margin-right:16px}@media screen and (min-width:768px){.tags-filter-wrapper{height:45px}.tags-filter-wrapper .current{padding-left:20px}.tags-filter-wrapper .current i{font-size:22px}.tags-filter-wrapper .current,.tags-filter-wrapper .current i{line-height:45px;display:inline-block;vertical-align:top}}+.througth-chat{position:relative;z-index:12;color:#fff}.througth-chat-wrapper{box-sizing:border-box;position:fixed;right:0;bottom:0;background-color:#000;color:#fff;width:335px;height:440px;z-index:12;border-radius:3px;overflow:hidden;border:1px solid hsla(0,0%,100%,.15);transform:scale(1);transition:transform .2s;visibility:hidden}.througth-chat-wrapper *{box-sizing:border-box}.througth-chat-wrapper .resize{height:4px;position:absolute;left:0;right:0;z-index:2}.througth-chat-wrapper .resize.resize-n{top:-1px;cursor:n-resize}.througth-chat-wrapper .resize.resize-s{bottom:-1px;cursor:s-resize}.througth-chat-wrapper .chat-window{position:relative;height:100%}.througth-chat-wrapper .chat-window .chat-send-message-block,.througth-chat-wrapper .chat-window .chat-title,.througth-chat-wrapper .chat-window .conversation-container{position:absolute;left:0;right:0;padding-left:20px;padding-right:20px}.througth-chat-wrapper .chat-window .chat-title{min-height:60px;border-bottom:1px solid #fff;text-align:center;cursor:move;top:0;border-bottom:1px solid hsla(0,0%,100%,.2);font-size:16px;line-height:18px;padding-top:15px;padding-bottom:15px;color:#fff;text-transform:uppercase;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-ms-align-items:center;-ms-flex-align:center;align-items:center}.througth-chat-wrapper .chat-window .chat-title .content-report{display:inline-block;margin-right:10px;cursor:pointer}.througth-chat-wrapper .chat-window .chat-title .content-report a{color:#fff}.througth-chat-wrapper .chat-window .chat-title .content-report a:hover{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.througth-chat-wrapper .chat-window .chat-title .content-report a i{font-size:17px;font-weight:700}.througth-chat-wrapper .chat-window .chat-title .close{cursor:pointer;transition:transform .2s;width:16px;height:16px;margin-left:15px;display:inline-block}.througth-chat-wrapper .chat-window .chat-title .close:hover{transform:rotate(90deg)}.througth-chat-wrapper .chat-window .chat-title .open-conversation{font-size:17px;line-height:16px;display:inline-block;color:inherit;text-decoration:none}.througth-chat-wrapper .chat-window .chat-title .report-convers{cursor:pointer;font-size:17px;line-height:16px;margin-right:10px}.througth-chat-wrapper .chat-window .chat-title .report-convers:hover{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.througth-chat-wrapper .chat-window .chat-send-message-block{bottom:0;height:60px;border-top:1px solid hsla(0,0%,100%,.2);overflow:hidden;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.througth-chat-wrapper .chat-window .chat-send-message-block .send-message,.througth-chat-wrapper .chat-window .chat-send-message-block div{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.througth-chat-wrapper .chat-window .chat-send-message-block textarea{font-family:Arial;font-size:12px;height:20px;position:relative;z-index:2;width:220px;line-height:19px;overflow:hidden;border:0;color:#fff;background-color:transparent;resize:none;overflow:auto;padding:0}.througth-chat-wrapper .chat-window .chat-send-message-block .send-message{font-size:20px}.througth-chat-wrapper .chat-window .chat-send-message-block .send-message:hover{animation:send-icon-hover 1s}.througth-chat-wrapper .chat-window .conversation-container{top:75px;bottom:75px;padding:0 20px;height:auto;margin:0;border:none}.througth-chat-wrapper .chat-window .conversation-container .messages-list{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.througth-chat-wrapper .chat-window .conversation-container .messages-list .preload{top:0;right:25%;bottom:0;left:0;margin:auto;height:21px;position:absolute}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-date-separator{text-align:center;font-size:12px;padding-bottom:10px;background-color:transparent;height:auto;margin:15px 0}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-date-separator .messages-group-date{display:inline-block;padding:2px 10px;border:1px solid rgba(51,51,51,.5);background-color:transparent}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row{padding-bottom:10px;max-width:75%;-ms-align-self:flex-end;-ms-flex-item-align:end;align-self:flex-end}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .message-item{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;color:#fff;text-align:right}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .message-item .avatar-wrapper{margin-left:15px;-ms-order:2;-ms-flex-order:2;order:2}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .message-item .avatar-wrapper .avatar{width:35px;height:35px;position:relative}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .message-item .avatar-wrapper .avatar img{max-width:100%;display:block;border-radius:50%}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .message-item .avatar-wrapper .avatar .status{position:absolute;bottom:0;left:0;border:1px solid #000;background-color:#333;display:block;width:10px;height:10px;border-radius:50%;overflow:hidden;visibility:hidden}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .message-item .avatar-wrapper .avatar .status.online{background-color:#37b65b}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .message-item .message-data-wrapper{-ms-order:1;-ms-flex-order:1;order:1;max-width:170px;overflow:hidden}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .message-item .message-data-wrapper .message-content{font-size:12px;line-height:18px}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .message-item .message-data-wrapper .message-time{font-size:10px;color:hsla(0,0%,100%,.6);line-height:16px}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row.not-my{-ms-align-self:flex-start;-ms-flex-item-align:start;align-self:flex-start;text-align:left}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row.not-my .message-item{text-align:left}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row.not-my .message-item .avatar-wrapper{-ms-order:1;-ms-flex-order:1;order:1;margin-right:15px;margin-left:0}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row.not-my .message-item .message-data-wrapper{-ms-order:2;-ms-flex-order:2;order:2}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .attachment-list{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .attachment-list .attach-item{border-radius:3px}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .attachment-list .attach-item .attach-lock .content-name{margin-bottom:5px}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .attachment-list .attach-item .attach-lock .content-name,.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .attachment-list .attach-item .attach-lock .content-price,.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .attachment-list .attach-item .attach-lock .unlock-btn{line-height:normal}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .attachment-list .attach-item .attach-preview .play-video-bth:after{display:none}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .attachment-list .attach-item.locked .attach-lock{background-color:hsla(0,0%,100%,.2)}.througth-chat-wrapper .chat-window .conversation-container .messages-list .message-row .attachment-list .attach-item.locked .attach-preview{border-radius:3px;background-color:transparent;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.througth-chat-wrapper.hidden{transform:scale(0)}.througth-chat-wrapper.hidden+.througth-chat-notifications{transform:translateY(-67px)}.througth-chat-notifications{position:fixed;right:85px;top:100%;background-color:#000;border:1px solid hsla(0,0%,100%,.15);height:67px;padding:15px;text-align:center;z-index:3;transition:color .2s,transform .3s;overflow:hidden;border-radius:2px 2px 0 0;cursor:pointer;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-direction:row;flex-direction:row}.througth-chat-notifications .model-image{width:35px;height:35px;position:relative;transition:margin-right .2s}.througth-chat-notifications .model-image img{max-width:100%;display:block;border-radius:50%}.througth-chat-notifications .model-image .status{position:absolute;bottom:0;left:0;border:1px solid #000;background-color:#37b65b;display:block;width:10px;height:10px;border-radius:50%;overflow:hidden;visibility:hidden}.througth-chat-notifications .counter{font-size:14px;font-weight:700;line-height:35px;display:block;white-space:nowrap;position:absolute;transform:translateY(-67px);transition:transform .2s}.througth-chat-notifications .counter .num{margin-left:10px}.througth-chat-notifications .counter i{vertical-align:middle}.througth-chat-notifications.exists .model-image{margin-right:20px}.througth-chat-notifications.exists .counter{transform:translateY(0);position:static}.througth-chat-notifications.exists.new{animation:chat-notifier-blink 2s infinite}.througth-chat-notifications.exists.new .counter{animation:chat-notifier-text 1s}@keyframes chat-notifier-text{0%{transform:translateY(0)}14.5%{transform:translateY(-30px)}23%{transform:translateY(0)}35.5%{transform:translateY(-15px)}48%{transform:translateY(0)}60.5%{transform:translateY(-7px)}73%{transform:translateY(0)}87.5%{transform:translateY(-3px)}to{transform:translateY(0)}}@keyframes send-icon-hover{0%{transform:rotate(0)}30%{transform:rotate(-30deg)}45%{transform:rotate(20deg)}60%{transform:rotate(-10deg)}75%{transform:rotate(10deg)}85%{transform:rotate(-5deg)}95%{transform:rotate(3deg)}to{transform:rotate(0deg)}}.vr-player{width:100%;max-height:700px}.burst-1,.burst-2{background:#87bc16;width:50px;height:50px;position:relative;text-align:center}.burst-1:after,.burst-1:before,.burst-2:after,.burst-2:before{content:\"\";position:absolute;top:0;left:0;height:50px;width:50px;background:#87bc16;z-index:-1}.burst-1{z-index:5}.burst-1:before{transform:rotate(18deg)}.burst-1:after{transform:rotate(36deg)}.burst-2{background:none;font-size:22px;font-family:arial;font-weight:700;padding-top:14px;text-shadow:0 3px 0 rgba(0,0,0,.09)}.burst-2,.burst-2 span{color:#fff}.burst-2:before{transform:rotate(54deg)}.burst-2:after{transform:rotate(72deg)}.discount{-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.discount,.discount .discount-description{-ms-align-items:center;-ms-flex-align:center;align-items:center;text-align:left}.discount .discount-description{color:#fff;padding:5px 18px 5px 16px;font-size:14px;line-height:14px;position:relative;min-height:50px;word-break:break-word;background-image:linear-gradient(180deg,#76ac01 0,#6ea001);overflow:hidden;border-radius:0 3px 3px 0;display:-moz-flex;display:-ms-flexbox;display:flex}.discount .discount-description .burst-1{position:absolute;left:-52px;top:10px;z-index:1;background:#87bc16}.discount .discount-description .burst-1,.discount .discount-description .burst-1:after,.discount .discount-description .burst-1:before,.discount .discount-description .burst-2,.discount .discount-description .burst-2:after,.discount .discount-description .burst-2:before{background:#3d7900;box-shadow:3px -3px 3px 0 rgba(61,121,0,.75)}.join-options .discount,.join-options .dprice{display:none}.join-options .discount-price .dprice{display:block;padding-bottom:20px}.join-options .discount-price .discount{display:-moz-flex;display:-ms-flexbox;display:flex}.join-options .discount-price .price-block .price{position:relative}.join-options .discount-price .price-block .price:after{content:\"\";position:absolute;border-top-width:1px;border-top-style:solid;border-top-color:#000;width:90px;top:9px;left:calc(50% - 45px);z-index:-1}.ac-p-is-paused video.ac-p-video{filter:blur(5px)}.ac-p-toggle-box.user-state{background-color:rgba(0,0,0,.85)}.ac-p-toggle-box.user-state img.small{display:block}.ac-p-toggle-box.user-state img.large{display:none}@media (min-width:768px){.ac-p-toggle-box.user-state img.small{display:none}.ac-p-toggle-box.user-state img.large{display:block}}.disable-player-block{position:relative}.disable-player-block .disable-banner-link{position:absolute;width:100%;height:100%;z-index:10}.disable-player-block .disable-player-scene-img{filter:blur(3px)}.disable-player-block .disable-player-scene-img img{width:100%}.disable-player-block .ac-p-toggle-box{display:block}.content-grid.photos-grid .grid-item.custom1{width:25%;border-right:2px solid #211b24}.content-grid.photos-grid .grid-item.custom1 .empty-img{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}@media (max-width:768px){.content-grid.photos-grid .grid-item.custom1{width:50%}}.link-tags{width:100%;position:absolute;top:40%;left:0;z-index:100;text-align:center;display:none}.grid-item:hover .link-tags{display:block}.link-tags a{position:relative;height:90px;width:90px;border:3px solid #924c4c;border-radius:50%;display:inline-block;line-height:5.2;overflow:hidden;background:rgba(0,0,0,.1);margin:0 10px;text-decoration:none;box-shadow:0 0 20px #e0cca9}.link-tags a:hover{box-shadow:0 0 10px #fff}@media (max-width:940px) and (min-width:768px){.link-tags{top:17%}}@media (max-width:480px){.link-tags{top:17%}.link-tags a{height:80px;width:80px;line-height:4.5;display:block;margin:10px auto 0}}@media (max-width:340px){.link-tags{top:9%}}", ""]);

// exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/offer/acp/freeacp/bbw/overlay-big.jpg", __webpack_require__.p + "_/_/_/root/images/offer/acp/freeacp/bbw/overlay-big.jpg");

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/offer/acp/freeacp/bbw/overlay-small.jpg", __webpack_require__.p + "_/_/_/root/images/offer/acp/freeacp/bbw/overlay-small.jpg");

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/stateoff/site-under-construction-bg.jpg", __webpack_require__.p + "_/_/_/root/images/stateoff/site-under-construction-bg.jpg");

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/stateoff/site-closed-bg.jpg", __webpack_require__.p + "_/_/_/root/images/stateoff/site-closed-bg.jpg");

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/crowdfunding-bg.jpg", __webpack_require__.p + "_/_/_/root/images/crowdfunding-bg.jpg");

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc-icons-liveshow.woff", __webpack_require__.p + "_/_/_/_/common/liveshow/fonts/1pK02sy.woff");

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc-icons-liveshow.ttf", __webpack_require__.p + "_/_/_/_/common/liveshow/fonts/3gZrCOJ.ttf");

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc-icons-liveshow.svg", __webpack_require__.p + "_/_/_/_/common/liveshow/fonts/mc-icons-liveshow.svg");

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc_icons-webfont.woff", __webpack_require__.p + "_/_/_/root/fonts/2qaP9fR.woff");

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc_icons-webfont.ttf", __webpack_require__.p + "_/_/_/root/fonts/pjzlvf8.ttf");

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc_icons-webfont.svg", __webpack_require__.p + "_/_/_/root/fonts/mc_icons-webfont.svg");

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/PTSans-Regular.woff", __webpack_require__.p + "_/_/_/root/fonts/2lRgd_2.woff");

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/PTSans-Regular.ttf", __webpack_require__.p + "_/_/_/root/fonts/3HrsILf.ttf");

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/PTSans-Regular.svg", __webpack_require__.p + "_/_/_/root/fonts/PTSans-Regular.svg");

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/PTSans-Bold.woff", __webpack_require__.p + "_/_/_/root/fonts/1n84fCs.woff");

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/PTSans-Bold.ttf", __webpack_require__.p + "_/_/_/root/fonts/1_9pW5N.ttf");

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/PTSans-Bold.svg", __webpack_require__.p + "_/_/_/root/fonts/PTSans-Bold.svg");

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/amc-cf.svg", __webpack_require__.p + "_/_/_/root/fonts/amc-cf.svg");

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-0.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-0.png");

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-1.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-1.png");

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-2.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-2.png");

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-3.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-3.png");

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-4.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-4.png");

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-5.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-5.png");

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-6.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-6.png");

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-7.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-7.png");

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-8.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-8.png");

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-9.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-9.png");

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-10.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-10.png");

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gifts/gift-11.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/gifts/gift-11.png");

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines/gift-12.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines/gift-12.png");

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines/gift-13.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines/gift-13.png");

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines/gift-14.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines/gift-14.png");

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines/gift-15.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines/gift-15.png");

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines/gift-16.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines/gift-16.png");

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines/gift-17.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines/gift-17.png");

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines/gift-18.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines/gift-18.png");

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines/gift-19.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines/gift-19.png");

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-20.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-20.png");

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-21.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-21.png");

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-22.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-22.png");

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-23.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-23.png");

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-24.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-24.png");

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-25.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-25.png");

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-26.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-26.png");

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-27.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-27.png");

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-28.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-28.png");

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-29.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-29.png");

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-30.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-30.png");

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-31.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-31.png");

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-32.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-32.png");

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-33.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-33.png");

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-34.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-34.png");

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-35.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-35.png");

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-36.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-36.png");

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-37.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-37.png");

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-38.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-38.png");

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-39.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-39.png");

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-40.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-40.png");

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-41.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-41.png");

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-42.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-42.png");

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/chat-gifts/gift-43.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/chat-gifts/gift-43.png");

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-44.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-44.png");

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-45.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-45.png");

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-46.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-46.png");

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-47.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-47.png");

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-48.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-48.png");

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-49.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-49.png");

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-50.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-50.png");

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-51.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-51.png");

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-52.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-52.png");

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-53.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-53.png");

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-54.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-54.png");

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/valentines18/gift-55.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/valentines18/gift-55.png");

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-56.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-56.png");

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-57.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-57.png");

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-58.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-58.png");

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-59.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-59.png");

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-60.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-60.png");

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-61.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-61.png");

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-62.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-62.png");

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-63.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-63.png");

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-64.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-64.png");

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-65.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-65.png");

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-66.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-66.png");

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/spring18/gift-67.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/spring18/gift-67.png");

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-68.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-68.png");

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-69.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-69.png");

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-70.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-70.png");

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-71.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-71.png");

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-72.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-72.png");

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-73.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-73.png");

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-74.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-74.png");

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-75.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-75.png");

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-76.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-76.png");

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-77.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-77.png");

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-78.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-78.png");

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/easter18/gift-79.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/easter18/gift-79.png");

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-80.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-80.png");

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-81.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-81.png");

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-82.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-82.png");

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-83.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-83.png");

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-84.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-84.png");

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-85.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-85.png");

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-86.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-86.png");

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-87.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-87.png");

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-88.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-88.png");

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-89.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-89.png");

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-90.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-90.png");

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/default/gift-91.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/default/gift-91.png");

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-92.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-92.png");

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-93.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-93.png");

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-94.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-94.png");

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-95.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-95.png");

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-96.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-96.png");

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-97.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-97.png");

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-98.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-98.png");

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-99.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-99.png");

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-100.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-100.png");

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-101.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-101.png");

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-102.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-102.png");

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/july4/gift-103.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/july4/gift-103.png");

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-104.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-104.png");

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-105.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-105.png");

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-106.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-106.png");

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-107.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-107.png");

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-108.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-108.png");

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-109.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-109.png");

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-110.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-110.png");

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-111.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-111.png");

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-112.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-112.png");

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-113.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-113.png");

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-114.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-114.png");

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/emoji/gift-115.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/emoji/gift-115.png");

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-116.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-116.png");

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-117.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-117.png");

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-118.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-118.png");

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-119.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-119.png");

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-120.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-120.png");

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-121.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-121.png");

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-122.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-122.png");

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-123.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-123.png");

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-124.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-124.png");

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-125.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-125.png");

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-126.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-126.png");

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pirates/gift-127.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/pirates/gift-127.png");

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-128.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-128.png");

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-129.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-129.png");

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-130.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-130.png");

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-131.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-131.png");

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-132.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-132.png");

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-133.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-133.png");

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-134.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-134.png");

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-135.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-135.png");

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-136.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-136.png");

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-137.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-137.png");

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-138.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-138.png");

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/octoberfest/gift-139.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/octoberfest/gift-139.png");

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-140.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-140.png");

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-141.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-141.png");

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-142.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-142.png");

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-143.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-143.png");

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-144.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-144.png");

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-145.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-145.png");

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-146.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-146.png");

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-147.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-147.png");

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-148.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-148.png");

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-149.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-149.png");

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-150.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-150.png");

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/halloween/gift-151.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/halloween/gift-151.png");

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-152.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-152.png");

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-153.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-153.png");

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-154.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-154.png");

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-155.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-155.png");

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-156.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-156.png");

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-157.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-157.png");

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-158.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-158.png");

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-159.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-159.png");

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-160.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-160.png");

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-161.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-161.png");

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-162.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-162.png");

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/thanksgiving/gift-163.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/thanksgiving/gift-163.png");

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-164.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-164.png");

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-165.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-165.png");

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-166.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-166.png");

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-167.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-167.png");

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-168.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-168.png");

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-169.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-169.png");

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-170.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-170.png");

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-171.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-171.png");

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-172.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-172.png");

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-173.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-173.png");

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-174.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-174.png");

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/christmass/gift-175.png", __webpack_require__.p + "_/_/_/_/common/liveshow/images/christmass/gift-175.png");

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/icons-lib/icons-lib.ttf?n7cb91", __webpack_require__.p + "_/_/_/root/fonts/icons-lib/2PLF60M.ttf");

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/icons-lib/icons-lib.woff?n7cb91", __webpack_require__.p + "_/_/_/root/fonts/icons-lib/3EtfDxI.woff");

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/icons-lib/icons-lib.svg?n7cb91", __webpack_require__.p + "_/_/_/root/fonts/icons-lib/icons-lib.svg");

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/sprite-small-preloader-white.png", __webpack_require__.p + "images/sprite-small-preloader-white.png");

/***/ }),
/* 380 */
/***/ (function(module, exports) {

var isWebpSupport = 'chrome' in window &&
    window.navigator.userAgent.match(/firefox|iceweasel|fxios|edge|msie|trident/i) === null;
var isHeifSupport = false;

var imgRoute = function imgRoute (params, previousRequest) {
    var dir = params.dir;
    var name = params.name;
    var ext = params.ext;
    var query = params.query || '';

    var screenW = window.screen.width;
    var screenH = window.screen.height;

    if (dir.indexOf('/c11n/') !== -1 && !fox.c11nImageOptimized) {
        return previousRequest;
    }

    if (query.indexOf('skipTransform') === -1) {
        if (screenW <= 800) {
            name += '_mobile';
        } else if (screenW <= 1280) {
            name += '_tablet';
        }
    }

    if (isWebpSupport) {
        ext = '.webp';
    } else if (isHeifSupport) {
        ext = '.heic';
    }

    return [dir, name, ext].join('');
};

var master = null;

if ('fox' in window && !fox._r.patched) {
    master = fox._r;

    fox._r = function fox_r (alias, path, isFallback) {
        var masterRes = master(alias, path);

        if (!isFallback || !fox.c11nImageOptimized) {
            return masterRes;
        }

        var fullPath = masterRes;

        if (!fullPath) return '';

        var tmp = fullPath.split('/');
        var dir = tmp.slice(0, -1).join('/') + '/';
        
        tmp = tmp.slice(-1)[0].split('.');
        var ext = '.' + tmp.slice(-1)[0];
        var name = tmp.slice(0, -1).join('.');

        return imgRoute({
            dir: dir,
            name: name,
            ext: ext
        }, fullPath);
    }

    fox._r.patched = true;
}

module.exports = exports = imgRoute;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./activity.css": 382,
	"./animate.css": 387,
	"./blogpost.css": 389,
	"./contentreport.css": 391,
	"./iconfont.css": 393,
	"./iphone.css": 396,
	"./mCustomScrollbar.css": 398,
	"./mcgallery.css": 400,
	"./photoswipe.css": 404,
	"./preloader.css": 410,
	"./stateoff-icons.css": 412,
	"./tags-filter.css": 417,
	"./throughChat.css": 424
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(383);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./activity.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./activity.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:activity_icons;src:url(" + __webpack_require__(48) + ");src:url(" + __webpack_require__(48) + ") format(\"embedded-opentype\"),url(" + __webpack_require__(384) + ") format(\"woff\"),url(" + __webpack_require__(385) + ") format(\"truetype\"),url(" + __webpack_require__(386) + ") format(\"svg\");font-weight:400;font-style:normal}[class*=\" ico-\"],[class^=ico-]{font-family:activity_icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ico-calendar_video:before{content:\"\\E60D\"}.ico-calendar_blogpost:before{content:\"\\E600\"}.ico-calendar_close_event:before{content:\"\\E601\"}.ico-calendar_datapicker:before{content:\"\\E602\"}.ico-calendar_dp_left:before{content:\"\\E603\"}.ico-calendar_dp_right:before{content:\"\\E604\"}.ico-calendar_drop:before{content:\"\\E605\"}.ico-calendar_earliar:before{content:\"\\E606\"}.ico-calendar_event:before{content:\"\\E607\"}.ico-calendar_later:before{content:\"\\E608\"}.ico-calendar_liveshow:before{content:\"\\E609\"}.ico-calendar_location:before{content:\"\\E60A\"}.ico-calendar_photoset:before{content:\"\\E60B\"}.ico-calendar_view_settings:before{content:\"\\E60C\"}", ""]);

// exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/activity.woff", __webpack_require__.p + "_/_/_/root/fonts/3nz_2F5.woff");

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/activity.ttf", __webpack_require__.p + "_/_/_/root/fonts/1ARjj2i.ttf");

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/activity.svg", __webpack_require__.p + "_/_/_/root/fonts/activity.svg");

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(388);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./animate.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./animate.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "/*!\n * animate.css -http://daneden.me/animate\n * Version - 3.5.2\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\n *\n * Copyright (c) 2016 Daniel Eden\n */.animated{animation-duration:.8s!important;animation-fill-mode:both}.animated.infinite{animation-iteration-count:infinite}.animated.hinge{animation-duration:2s}.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY{animation-duration:.75s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-100%,0)}to{opacity:1;transform:none}}.fadeInDown{animation-name:fadeInDown}@keyframes fadeInLeft{0%{opacity:0;transform:translate3d(-100%,0,0)}to{opacity:1;transform:none}}.fadeInLeft{animation-name:fadeInLeft}@keyframes fadeInRight{0%{opacity:0;transform:translate3d(100%,0,0)}to{opacity:1;transform:none}}.fadeInRight{animation-name:fadeInRight}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,100%,0)}to{opacity:1;transform:none}}.fadeInUp{animation-name:fadeInUp}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{animation-name:fadeOutDown}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;transform:translate3d(-100%,0,0)}}.fadeOutLeft{animation-name:fadeOutLeft}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0)}}.fadeOutRight{animation-name:fadeOutRight}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{animation-name:fadeOutUp}@keyframes flipInY{0%{transform:perspective(400px) rotateY(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateY(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateY(10deg);opacity:1}80%{transform:perspective(400px) rotateY(-5deg)}to{transform:perspective(400px)}}.flipInY{backface-visibility:visible!important;animation-name:flipInY}@keyframes flipOutY{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateY(-15deg);opacity:1}to{transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{backface-visibility:visible!important;animation-name:flipOutY}", ""]);

// exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(390);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./blogpost.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./blogpost.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "#post-list-container .pl-text img,#post-list-container img{cursor:pointer;max-height:100%;height:auto!important}#blog-container img,#event-body-container img,#latest-posts img,#post-list-container img,.latest-post img{z-index:-1}", ""]);

// exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(392);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./contentreport.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./contentreport.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".form-container{padding:3px}.form-container #captcha{display:inline-block;border:1px solid #ccc;border-radius:2px;margin-top:5px;margin-bottom:15px;height:33px;width:100px}.form-container .not-logged-user-block:after{content:\"\";display:block;visibility:hidden;height:0;clear:both}.form-container .left{float:left;width:24%;position:relative}.form-container .right{float:right;width:61%}.form-container .reload-captcha{display:inline-block;width:18px;height:14px;position:absolute;top:32px;right:-20px;cursor:pointer}.form-container .not-logged-user-block{margin-top:14px}.form-container .select-category-block{margin:14px 0 27px}.form-container .small-title{font-size:11px;color:#a0a0a0}.form-container input[type=text]{display:inline-block;border:1px solid #ccc;border-radius:2px;padding:8px 10px;margin-top:5px;margin-bottom:15px;outline:none}.form-container input[type=password]{padding:8px 10px}.form-container input.w100{width:100%}.form-container textarea{border:1px solid #ccc;font-style:italic;border-radius:2px;width:100%;font-size:12px;padding:7px 10px 0;margin:5px 0 0}.form-container .tooltip{line-height:18px;margin-bottom:21px}.radio-btn-wrapp{position:relative;display:inline-block;width:153px;height:76px;margin-right:4px;margin-top:7px}.radio-btn-wrapp:last-child{margin-right:0}.radio-btn-wrapp label{position:absolute;cursor:pointer;width:100%;height:100%;top:0;left:0;border:1px solid #ccc;color:#969696;opacity:.4;border-radius:2px;padding:15px;text-align:center;display:flex;justify-content:center;align-items:center}.radio-btn-wrapp input[type=radio]{opacity:0}#error-container{text-align:center;padding:10px 0;border:1px solid #c48282;margin-top:10px;color:#c44a4a}#captcha .captcha-img{width:100%;height:100%}", ""]);

// exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(394);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./iconfont.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./iconfont.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:iconfont;src:url(" + __webpack_require__(395) + ")}@font-face{font-family:iconfont;src:url(data:application/x-font-woff;charset=utf-8;base64,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) format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-\"],[class^=icon-]{font-family:iconfont;font-weight:400;font-style:normal;text-decoration:inherit;-webkit-font-smoothing:antialiased;*margin-right:.3em}[class*=\" icon-\"]:before,[class^=icon-]:before{text-decoration:inherit;display:inline-block;speak:none}a [class*=\" icon-\"],a [class^=icon-]{display:inline}.icon-home:before{content:\"G\"}.icon-star:before{content:\"0\"}.icon-search:before{content:\"V\"}.icon-setting:before{content:\"H\"}.icon-logout:before{content:\"I\"}.icon-refresh:before{content:\"`\"}.icon-mail:before{content:\"X\"}.icon-clock:before{content:\"3\"}.icon-photocard:before{content:\"4\"}.icon-lock:before{content:\"7\"}.icon-text-bubble:before{content:\"8\"}.icon-rating-true:before{content:\"=\"}.icon-rating-false:before{content:\">\"}.icon-copyright:before{content:\"[\"}.icon-bold-arrow-left:before{content:\"i\"}.icon-menu-list:before{content:\"M\"}.icon-round-x:before{content:\"Q\"}.icon-round-play:before{content:\"R\"}.icon-round-prev:before{content:\"S\"}.icon-round-next:before{content:\"T\"}.icon-aboutme:before{content:\"C\"}.icon-arrow-middle-left:before{content:\"O\"}.icon-arrow-middle-right:before{content:\"P\"}.icon-coctail:before{content:\"D\"}.icon-profile:before{content:\"A\"}.icon-video:before{content:\"E\"}.icon-photo:before{content:\"B\"}.icon-liveshowcam:before{content:\"F\"}.icon-guide-arrow:before{content:\"L\"}.icon-like:before{content:\"r\"}.icon-dislike:before{content:\"s\"}.icon-download:before{content:\"t\"}.icon-download-box:before{content:\"\\AB\"}.icon-comment:before{content:\"u\"}.icon-bold-close:before{content:\"g\"}.icon-romb:before{content:\"v\"}.icon-empty-romb:before{content:\"w\"}.icon-fullscreen:before{content:\"\\2013\"}.icon-format-sd:before{content:\"\\2C6\"}.icon-format-hd:before{content:\"\\20AC\"}.icon-soc-tw:before{content:\"\\201A\"}.icon-soc-fb:before{content:\"\\201D\"}.icon-soc-insta:before{content:\"\\B7\"}.icon-soc-t:before{content:\"\\B8\"}.icon-soc-gp:before{content:\"\\2022\"}.icon-soc-yt:before{content:\"\"}.icon-logout-2:before{content:\"b\"}.icon-mail-2:before{content:\"d\"}.icon-settings-2:before{content:\"f\"}.icon-heart:before{content:\"e\"}.icon-reload:before{content:\"h\"}.icon-play:before{content:\"n\"}.icon-pause:before{content:\"}\"}.icon-arrow-think-left:before{content:\"9\"}.icon-arrow-think-right:before{content:\":\"}.icon-clock-2:before{content:\"\\2039\"}.icon-calendar:before{content:\"\\203A\"}.icon-event-type-liveshow:before{content:\"\\A4\"}.icon-event-type-content:before{content:\"\\A1\"}.icon-gift:before{content:\"\\A6\"}.icon-doubleArrDown:before{content:\"\\A5\"}.icon-close:before{content:\"N\"}.icon-domik:before{content:\"\\B4\"}.icon-videocamera:before{content:\"\\2B9\"}.icon-photocamera:before{content:\"\\2C7\"}.icon-telka:before{content:\"\\2D8\"}.icon-webka:before{content:\"\\2D9\"}.icon-serdce:before{content:\"\\2DA\"}.icon-tel-truba:before{content:\"\\B1\"}.icon-skype-me:before{content:\"\\385\"}.icon-gift-2:before{content:\"\\384\"}.icon-activity:before{content:\"\\2DD\"}.icon-blog:before{content:\"\\2DB\"}.icon-bokal:before{content:\"\\BF\"}", ""]);

// exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/mc_icons-webfont.eot", __webpack_require__.p + "_/_/_/affiliate/fonts/PY1Iudj.eot");

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(397);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./iphone.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./iphone.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".virt-player{position:relative;height:100%;width:100%;display:block}.virt-player img{max-width:100%}.virt-player:before{width:0;height:0;border-style:solid;border-width:8px 0 8px 15px;border-color:transparent transparent transparent #747475;margin-left:-4px;margin-top:-7px;z-index:10;opacity:.6}.virt-player:after,.virt-player:before{content:\"\";position:absolute;top:50%;left:50%}.virt-player:after{width:36px;height:36px;margin-top:-18px;margin-left:-18px;border-radius:50%;opacity:.7;background-color:#fff;z-index:1}.virt-player.error:after,.virt-player.error:before,.virt-player.error img,.virt-player .fake-play{display:none}.virt-player.error .fake-play{display:block}.virt-player .fake-play{height:70px;text-align:center;line-height:70px}.virt-player .fake-play>*{display:inline-block;white-space:nowrap}", ""]);

// exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(399);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./mCustomScrollbar.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./mCustomScrollbar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".mCustomScrollbar{-ms-touch-action:none;touch-action:none}.mCustomScrollbar.mCS_no_scrollbar{-ms-touch-action:auto;touch-action:auto}.mCustomScrollBox{position:relative;overflow:hidden;height:100%;max-width:100%;outline:none;direction:ltr}.mCSB_container{overflow:hidden;width:auto;height:auto}.mCSB_inside>.mCSB_container{margin-right:30px}.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden{margin-right:0}.mCS-dir-rtl>.mCSB_inside>.mCSB_container{margin-right:0;margin-left:30px}.mCS-dir-rtl>.mCSB_inside>.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden{margin-left:0}.mCSB_scrollTools{position:absolute;width:16px;height:auto;left:auto;top:0;right:0;bottom:0}.mCSB_outside+.mCSB_scrollTools{right:-20px!important}.mCS-dir-rtl>.mCSB_inside>.mCSB_scrollTools,.mCS-dir-rtl>.mCSB_outside+.mCSB_scrollTools{right:auto;left:0}.mCS-dir-rtl>.mCSB_outside+.mCSB_scrollTools{left:-26px}.mCSB_scrollTools .mCSB_draggerContainer{position:absolute;top:0;left:0;bottom:0;right:0;height:auto}.mCSB_scrollTools a+.mCSB_draggerContainer{margin:20px 0}.mCSB_scrollTools .mCSB_draggerRail{width:2px;height:100%;margin:0 auto;border-radius:16px}.mCSB_scrollTools .mCSB_dragger{cursor:pointer;width:100%;height:30px;z-index:1}.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{position:relative;width:4px;height:100%;margin:0 auto;border-radius:16px;text-align:center}.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{width:12px}.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:8px}.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonUp{display:block;position:absolute;height:20px;width:100%;overflow:hidden;margin:0 auto;cursor:pointer}.mCSB_scrollTools .mCSB_buttonDown{bottom:0}.mCSB_horizontal.mCSB_inside>.mCSB_container{margin-right:0;margin-bottom:30px}.mCSB_horizontal.mCSB_outside>.mCSB_container{min-height:100%}.mCSB_horizontal>.mCSB_container.mCS_no_scrollbar_x.mCS_x_hidden{margin-bottom:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal{width:auto;height:16px;top:auto;right:0;bottom:0;left:0}.mCustomScrollBox+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox+.mCSB_scrollTools.mCSB_scrollTools_horizontal{bottom:-26px}.mCSB_scrollTools.mCSB_scrollTools_horizontal a+.mCSB_draggerContainer{margin:0 20px}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:2px;margin:7px 0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger{width:30px;height:100%;left:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:4px;margin:6px auto}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{height:12px;margin:2px auto}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:8px;margin:4px 0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft,.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight{display:block;position:absolute;width:20px;height:100%;overflow:hidden;margin:0 auto;cursor:pointer}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft{left:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight{right:0}.mCSB_container_wrapper{position:absolute;height:auto;width:auto;overflow:hidden;top:0;left:0;right:0;bottom:0;margin-right:30px;margin-bottom:30px}.mCSB_container_wrapper>.mCSB_container{padding-right:30px;padding-bottom:30px}.mCSB_vertical_horizontal>.mCSB_scrollTools.mCSB_scrollTools_vertical{bottom:20px}.mCSB_vertical_horizontal>.mCSB_scrollTools.mCSB_scrollTools_horizontal{right:20px}.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden+.mCSB_scrollTools.mCSB_scrollTools_vertical{bottom:0}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden+.mCSB_scrollTools~.mCSB_scrollTools.mCSB_scrollTools_horizontal{right:0}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_scrollTools.mCSB_scrollTools_horizontal{left:20px}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden+.mCSB_scrollTools~.mCSB_scrollTools.mCSB_scrollTools_horizontal{left:0}.mCS-dir-rtl>.mCSB_inside>.mCSB_container_wrapper{margin-right:0;margin-left:30px}.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden>.mCSB_container{padding-right:0;box-sizing:border-box}.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden>.mCSB_container{padding-bottom:0;box-sizing:border-box}.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden{margin-right:0;margin-left:0}.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden{margin-bottom:0}.mCSB_scrollTools,.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonLeft,.mCSB_scrollTools .mCSB_buttonRight,.mCSB_scrollTools .mCSB_buttonUp,.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{transition:opacity .2s ease-in-out,background-color .2s ease-in-out}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail{transition:width .2s ease-out .2s,height .2s ease-out .2s,margin-left .2s ease-out .2s,margin-right .2s ease-out .2s,margin-top .2s ease-out .2s,margin-bottom .2s ease-out .2s,opacity .2s ease-in-out,background-color .2s ease-in-out}.mCSB_scrollTools{opacity:.75;filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCS-autoHide>.mCustomScrollBox>.mCSB_scrollTools,.mCS-autoHide>.mCustomScrollBox~.mCSB_scrollTools{opacity:0;filter:\"alpha(opacity=0)\";-ms-filter:\"alpha(opacity=0)\"}.mCS-autoHide:hover>.mCustomScrollBox>.mCSB_scrollTools,.mCS-autoHide:hover>.mCustomScrollBox~.mCSB_scrollTools,.mCustomScrollbar>.mCustomScrollBox>.mCSB_scrollTools.mCSB_scrollTools_onDrag,.mCustomScrollbar>.mCustomScrollBox~.mCSB_scrollTools.mCSB_scrollTools_onDrag,.mCustomScrollBox:hover>.mCSB_scrollTools,.mCustomScrollBox:hover~.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=100)\";-ms-filter:\"alpha(opacity=100)\"}.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.4);filter:\"alpha(opacity=40)\";-ms-filter:\"alpha(opacity=40)\"}.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.75);filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85);filter:\"alpha(opacity=85)\";-ms-filter:\"alpha(opacity=85)\"}.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9);filter:\"alpha(opacity=90)\";-ms-filter:\"alpha(opacity=90)\"}.mCSB_scrollTools .mCSB_buttonUp{background-position:0 0}.mCSB_scrollTools .mCSB_buttonDown{background-position:0 -20px}.mCSB_scrollTools .mCSB_buttonLeft{background-position:0 -40px}.mCSB_scrollTools .mCSB_buttonRight{background-position:0 -56px}.mCSB_scrollTools .mCSB_buttonDown:hover,.mCSB_scrollTools .mCSB_buttonLeft:hover,.mCSB_scrollTools .mCSB_buttonRight:hover,.mCSB_scrollTools .mCSB_buttonUp:hover{opacity:.75;filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCSB_scrollTools .mCSB_buttonDown:active,.mCSB_scrollTools .mCSB_buttonLeft:active,.mCSB_scrollTools .mCSB_buttonRight:active,.mCSB_scrollTools .mCSB_buttonUp:active{opacity:.9;filter:\"alpha(opacity=90)\";-ms-filter:\"alpha(opacity=90)\"}.mCS-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.15)}.mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:rgba(0,0,0,.85)}.mCS-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:rgba(0,0,0,.9)}.mCS-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px 0}.mCS-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -20px}.mCS-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -40px}.mCS-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -56px}.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail,.mCS-light-2.mCSB_scrollTools .mCSB_draggerRail{width:4px;background-color:#fff;background-color:hsla(0,0%,100%,.1);border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:4px;background-color:#fff;background-color:hsla(0,0%,100%,.75);border-radius:1px}.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:4px;margin:6px auto}.mCS-light-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85)}.mCS-light-2.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9)}.mCS-light-2.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px 0}.mCS-light-2.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -20px}.mCS-light-2.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -40px}.mCS-light-2.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -56px}.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1);border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75);border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px 0}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -20px}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -40px}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -56px}.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail,.mCS-light-thick.mCSB_scrollTools .mCSB_draggerRail{width:4px;background-color:#fff;background-color:hsla(0,0%,100%,.1);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px;background-color:#fff;background-color:hsla(0,0%,100%,.75);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:4px;margin:6px 0}.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:6px;margin:5px auto}.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85)}.mCS-light-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9)}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-16px 0}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-16px -20px}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-20px -40px}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-20px -56px}.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-96px 0}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-96px -20px}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-100px -40px}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-100px -56px}.mCS-light-thin.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:hsla(0,0%,100%,.1)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:2px}.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%}.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:2px;margin:7px auto}.mCS-dark-thin.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.15)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px 0}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -20px}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -40px}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -56px}.mCS-rounded.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:hsla(0,0%,100%,.15)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger,.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger,.mCS-rounded.mCSB_scrollTools .mCSB_dragger{height:14px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:14px;margin:0 1px}.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger{width:14px}.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:14px;margin:1px 0}.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{width:16px;height:16px;margin:-1px 0}.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:4px}.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{height:16px;width:16px;margin:0 -1px}.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:4px;margin:6px 0}.mCS-rounded.mCSB_scrollTools .mCSB_buttonUp{background-position:0 -72px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonDown{background-position:0 -92px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonLeft{background-position:0 -112px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonRight{background-position:0 -128px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.15)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px -72px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -92px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -112px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -128px}.mCS-rounded-dots-dark.mCSB_scrollTools_vertical .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_vertical .mCSB_draggerRail{width:4px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail{background-color:transparent;background-position:50%}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANElEQVQYV2NkIAAYiVbw//9/Y6DiM1ANJoyMjGdBbLgJQAX/kU0DKgDLkaQAvxW4HEvQFwCRcxIJK1XznAAAAABJRU5ErkJggg==\");background-repeat:repeat-y;opacity:.3;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail{height:4px;margin:6px 0;background-repeat:repeat-x}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonUp{background-position:-16px -72px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonDown{background-position:-16px -92px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonLeft{background-position:-20px -112px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonRight{background-position:-20px -128px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALElEQVQYV2NkIAAYSVFgDFR8BqrBBEifBbGRTfiPZhpYjiQFBK3A6l6CvgAAE9kGCd1mvgEAAAAASUVORK5CYII=\")}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-96px -72px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-96px -92px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-100px -112px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-100px -128px}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-repeat:repeat-y;background-image:linear-gradient(90deg,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,0))}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{background-repeat:repeat-x;background-image:linear-gradient(180deg,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,0))}.mCS-3d-dark.mCSB_scrollTools_vertical .mCSB_dragger,.mCS-3d.mCSB_scrollTools_vertical .mCSB_dragger{height:70px}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger{width:70px}.mCS-3d-dark.mCSB_scrollTools,.mCS-3d.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_draggerRail{border-radius:16px}.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools .mCSB_draggerRail{width:8px;background-color:#000;background-color:rgba(0,0,0,.2);box-shadow:inset 1px 0 1px rgba(0,0,0,.5),inset -1px 0 1px hsla(0,0%,100%,.2)}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#555}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:8px}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:8px;margin:4px 0;box-shadow:inset 0 1px 1px rgba(0,0,0,.5),inset 0 -1px 1px hsla(0,0%,100%,.2)}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:8px;margin:4px auto}.mCS-3d.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-3d.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-3d.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-3d.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1);box-shadow:inset 1px 0 1px rgba(0,0,0,.1)}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail{box-shadow:inset 0 1px 1px rgba(0,0,0,.1)}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-3d-thick-dark.mCSB_scrollTools,.mCS-3d-thick.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-3d-thick-dark.mCSB_scrollTools,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer,.mCS-3d-thick.mCSB_scrollTools,.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer{border-radius:7px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{border-radius:5px}.mCSB_inside+.mCS-3d-thick-dark.mCSB_scrollTools_vertical,.mCSB_inside+.mCS-3d-thick.mCSB_scrollTools_vertical{right:1px}.mCS-3d-thick-dark.mCSB_scrollTools_vertical,.mCS-3d-thick.mCSB_scrollTools_vertical{box-shadow:inset 1px 0 1px rgba(0,0,0,.1),inset 0 0 14px rgba(0,0,0,.5)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal,.mCS-3d-thick.mCSB_scrollTools_horizontal{bottom:1px;box-shadow:inset 0 1px 1px rgba(0,0,0,.1),inset 0 0 14px rgba(0,0,0,.5)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 1px 0 0 hsla(0,0%,100%,.4);width:12px;margin:2px;position:absolute;height:auto;top:0;bottom:0;left:0;right:0}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.4)}.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#555}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:12px;width:auto}.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer{background-color:#000;background-color:rgba(0,0,0,.05);box-shadow:inset 1px 1px 16px rgba(0,0,0,.1)}.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-3d-thick-dark.mCSB_scrollTools{box-shadow:inset 0 0 14px rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal{box-shadow:inset 0 1px 1px rgba(0,0,0,.1),inset 0 0 14px rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 1px 0 0 hsla(0,0%,100%,.4),inset -1px 0 0 rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.4),inset 0 -1px 0 rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#777}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer{background-color:#fff;background-color:rgba(0,0,0,.05);box-shadow:inset 1px 1px 16px rgba(0,0,0,.1)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical,.mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical{right:0;margin:12px 0}.mCustomScrollBox.mCS-minimal+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal-dark+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal-dark+.mCSB_scrollTools.mCSB_scrollTools_horizontal{bottom:0;margin:0 12px}.mCS-dir-rtl>.mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical,.mCS-dir-rtl>.mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical{left:0;right:auto}.mCS-minimal-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-minimal.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-minimal-dark.mCSB_scrollTools_vertical .mCSB_dragger,.mCS-minimal.mCSB_scrollTools_vertical .mCSB_dragger{height:50px}.mCS-minimal-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-minimal.mCSB_scrollTools_horizontal .mCSB_dragger{width:50px}.mCS-minimal.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.2);filter:\"alpha(opacity=20)\";-ms-filter:\"alpha(opacity=20)\"}.mCS-minimal.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-minimal.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.5);filter:\"alpha(opacity=50)\";-ms-filter:\"alpha(opacity=50)\"}.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.2);filter:\"alpha(opacity=20)\";-ms-filter:\"alpha(opacity=20)\"}.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.5);filter:\"alpha(opacity=50)\";-ms-filter:\"alpha(opacity=50)\"}.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools .mCSB_draggerRail{width:6px;background-color:#000;background-color:rgba(0,0,0,.2)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px}.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:6px;margin:5px 0}.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:12px}.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:12px;margin:2px 0}.mCS-light-3.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1)}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset.mCSB_scrollTools .mCSB_draggerRail{width:12px;background-color:#000;background-color:rgba(0,0,0,.2)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px;margin:3px 5px;position:absolute;height:auto;top:0;bottom:0;left:0;right:0}.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:6px;margin:5px 3px;position:absolute;width:auto;top:0;bottom:0;left:0;right:0}.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:12px;margin:2px 0}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent;border-color:#fff;border:1px solid hsla(0,0%,100%,.2);box-sizing:border-box}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail{border-color:#000;border-color:rgba(0,0,0,.2)}.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:hsla(0,0%,100%,.6)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.6)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.75)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9)}", ""]);

// exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(401);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./mcgallery.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./mcgallery.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "#gallery-fullscreen{font-family:pt_sansregular,Arial}.photo-item{margin-bottom:5px;display:inline-block;vertical-align:top;cursor:pointer;overflow:hidden;position:relative}.photo-item:before{background:url(" + __webpack_require__(402) + ") no-repeat -1px -1px;width:33px;height:33px;top:50%;left:50%;display:block;z-index:2;margin:-16px 0 0 -16px}.photo-item:after,.photo-item:before{content:\"\";position:absolute;opacity:0}.photo-item:after{background-color:rgba(70,69,68,.58);top:0;right:0;bottom:0;left:0;z-index:1}.photo-item.img-load-error:after,.photo-item:hover:after,.photo-item:hover:before{opacity:1}.photo-item.img-load-error:before{background:url(" + __webpack_require__(28) + ") no-repeat -170px 0;width:30px;height:27px;opacity:1}.photo-item:hover{-moz-filter:grayscale(100%);-o-filter:grayscale(100%);-ms-filter:grayscale(100%);filter:grayscale(100%)}.photo-item img{max-width:100%;height:auto;width:100%;position:relative;display:block;float:left}.gallery-fullscreen{position:fixed;z-index:20;background-color:#000}.gallery-full-image,.gallery-fullscreen{top:0;right:0;bottom:0;left:0;width:100%;height:100%}.gallery-full-image{position:absolute;background-position:top;background-repeat:no-repeat;text-align:center}.gallery-full-image img{width:auto;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;max-height:100%;max-width:100%;min-height:inherit;min-width:inherit}#gallery-fullscreen+.wrapper{position:fixed}.gallery-sidebar,.gallery-sidebar *{-ms-box-sizing:border-box;box-sizing:border-box}.gallery-sidebar{position:fixed;top:0;bottom:0;right:0;background-color:rgba(30,30,30,.95);opacity:.5;width:360px;height:100%;z-index:22;color:#fff;transform:translate(310px);transition:all .5s}.gallery-sidebar.opened{opacity:1;transform:translate(0)}.gallery-toggle-arrow{position:absolute;top:0;left:0;bottom:0;height:100%;width:50px;text-align:center;cursor:pointer}.gallery-toggle-arrow>i{font-size:36px;position:relative;top:50%;margin-top:-18px}.gallery-sidebar.opened .icon-arrow-middle-right{display:block}.gallery-sidebar .icon-arrow-middle-right,.gallery-sidebar.opened .icon-arrow-middle-left{display:none}.gallery-sidebar .icon-arrow-middle-left{display:block}.gallery-hint-controll{display:none;position:fixed;z-index:22;background-color:rgba(30,30,30,.95);padding:30px;border-radius:5px;bottom:10%;left:50%;margin-left:-112px}.gallery-preloader{display:block;position:fixed;z-index:21;top:0;left:0;right:0;bottom:0}.gallery-sidebar-key-control{width:100%;position:relative;padding-bottom:40px}.gallery-key-control{position:relative;text-align:center;color:hsla(0,0%,100%,.5)}.gallery-key-control .key{width:25px;height:25px;border:1px solid hsla(0,0%,100%,.5);opacity:.6;padding:1px;margin:0 1px;cursor:pointer}.gallery-key-control .inactive,.gallery-key-control .key{display:inline-block;vertical-align:bottom}.gallery-key-control .inactive .key{display:block;opacity:.3}.gallery-key-control .inactive .key:first-child{margin-bottom:4px}.gallery-key-control .key-hint-text{display:inline-block;width:30px;line-height:12px;vertical-align:bottom}.gallery-key-control .key.active,.gallery-key-control .key.normal:hover{box-shadow:0 0 5px 0 #fff}.gallery-sidebar-content{margin:50px 14% 0;overflow:auto;height:100%}.gallery-btn{background-color:transparent;border:1px solid #464544;color:#fff;border-radius:2px;padding:9px 15px;text-align:center;display:inline-block;vertical-align:top;height:35px;min-width:70px;font-size:11px;cursor:pointer;text-transform:uppercase;font-family:pt_sansbold,Arial,sans-serif;transition:all .2s}.gallery-btn.disabled,.gallery-btn:disabled{opacity:.5}.gallery-input{position:relative;background-color:rgba(0,0,0,.2);border:1px solid #464544;border-radius:2px;display:inline-block;vertical-align:top;height:35px;min-width:70px;font-size:11px}.gallery-input.textarea{min-height:35px}.gallery-input>input[type=password],.gallery-input>input[type=text],.gallery-input>textarea{position:absolute;top:0;right:0;bottom:0;left:0;height:100%;width:100%;padding:9px 10px;color:#fff;background-color:transparent;border:none;font-size:12px}.gallery-btn.filled{background-color:#464544}.gallery-btn:hover{transform:translateY(-4px);-ms-box-shadow:0 5px 6px -2px rgba(0,0,0,.5);box-shadow:0 5px 6px -2px rgba(0,0,0,.5)}.gallery-btn.disabled:hover,.gallery-btn:disabled:hover{transform:translateY(0);-ms-box-shadow:none;box-shadow:none}.gallery-btn.half:after{content:\"\";height:0;display:table;visibility:hidden;clear:both}.gallery-btn.half .part-1{float:left;border-right:1px solid #464544}.gallery-btn.half .part-1,.gallery-btn.half .part-2{display:inline-block;width:50%;height:100%;line-height:33px}.gallery-btn.half .part-2{float:right}.gallery-sidebar-content .button-row{font-size:0;margin-bottom:10px}.gallery-sidebar-content .button-row .gallery-btn:last-child{float:right;width:165px}.gallery-sidebar-content .button-row .gallery-btn.btn-favorite{float:left;margin-left:0;width:60px}.gallery-sidebar-content .button-row .gallery-btn.btn-favorite.checked .favorite{opacity:.3}.gallery-sidebar-action-buttons{padding-bottom:10px;border-bottom:1px solid #464544}.gallery-sidebar-tipme-form{padding-top:20px;padding-bottom:25px}.gallery-sidebar-tipme-form .tipme{float:right}.gallery-sidebar-tipme-form .gallery-input{width:165px}.gallery-sidebar-tipme-form .gallery-input input{padding-left:34px}.gallery-sidebar-tipme-form .gallery-input .icon-gift{font-size:27px;display:inline-block;margin:0 10px;color:#464544}.gallery-sidebar-comments-container{padding-top:25px;padding-bottom:20px}.gallery-sidebar-comments-container .gallery-comments-total{font-size:20px;margin-bottom:20px;font-family:pt_sansbold,Arial,sans-serif}.gallery-sidebar-comments-container .gallery-comments-total>sup{font-size:12px;margin-left:5px}.gallery-comments-form .gallery-input{display:block;width:100%;height:55px;margin-bottom:10px}.gallery-comments-view{margin-top:20px}.gallery-comments-view .comment-item{padding:20px 0;border-top:1px solid #464544;font-size:13px}.gallery-comments-view .comment-info{font-size:11px;color:#818181;margin-bottom:10px}.gallery-comments-view .comment-body{color:#fff}.gallery .description{padding-bottom:20px}.photoset-actions .rating{display:inline-block}.photoset-actions .favorite-block{display:inline-block;float:right}.photoset-actions>div{display:inline-block!important;vertical-align:top;text-align:center}.photoset-actions>.download{float:right;margin-right:5%}.photoset-actions .favorites{padding:0;width:100%;display:inline-block;text-align:right}.photoset-actions .action-link-text{font-size:11px;text-transform:uppercase;position:relative;top:-4px;font-weight:700}.photoset-actions{position:relative;font-size:0;padding-top:8px;border:1px solid hsla(0,0%,100%,.2);border-width:1px 0;margin-bottom:20px;height:48px;box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;-ms-box-sizing:border-box}.photoset-actions .rating{width:10%;min-width:64px}.photoset-actions .rate-count{font-size:12px}.photoset-actions .tipme-container{width:40%}.gallery-fullscreen-hide{position:fixed;top:10px;left:10px;width:40px;height:40px;background-color:#1e1e1e;cursor:pointer;opacity:.7;z-index:22;border-radius:3px;transition:all .4s}.gallery-fullscreen-hide:hover{opacity:1}.gallery-fullscreen-hide:after{content:\"\";background:url(" + __webpack_require__(28) + ") no-repeat 0 0;width:26px;height:26px;display:block;position:absolute;top:7px;left:7px}.gallery-fullscreen-icon{background:url(" + __webpack_require__(28) + ") no-repeat;width:21px;height:17px;display:inline-block;position:relative}.gallery-fullscreen-icon.download{background-position:-100px 0}.gallery-fullscreen-icon.favorite{background-position:-30px 0}.gallery-fullscreen-icon.photo-rate-good{background-position:-54px 0;margin-right:8px;top:2px}.gallery-fullscreen-icon.photo-rate-bad{background-position:-79px 0;margin-left:8px;top:7px}.gallery-btn.half{padding:0}.gallery-btn .photo-scale{font-size:18px;line-height:11px;vertical-align:middle}.gallery-fullscreen-icon-play{width:0;height:0;border-style:solid;border-width:5px 0 5px 9px;border-color:transparent transparent transparent #fff;display:inline-block;position:relative;top:1px;margin-right:10px}.gallery-fullscreen-stop-slide-show{position:fixed;z-index:21;top:10px;right:60px;background-color:#1e1e1e;padding:4px 2px;border-radius:2px}.gallery-fullscreen-stop-slide-show .gallery-fullscreen-icon-stop{width:10px;height:10px;display:inline-block;position:relative;top:1px;border-radius:1px;margin-right:10px;background-color:#fff}.gallery-fullscreen-stop-slide-show .gallery-btn:hover{transform:translateY(0)}.gallery-sidebar-action-buttons .slideshow-section{margin-bottom:30px}.gallery-fullscreen-view-photo-counter{font-family:pt_sansregular,Arial,sans-serif;font-size:12px;display:inline-block;padding:9px 0}.gallery-fullscreen-view-photo-counter .number{font-size:16px;font-family:pt_sansbold,Arial,sans-serif;vertical-align:middle}.gallery-real-pixels-view{position:fixed;top:0;right:0;bottom:0;left:0;height:100%;width:100%;z-index:21;text-align:center;overflow:auto;background-color:#000}.gallery-fullscreen-blog .gallery-full-image img{height:auto;max-width:100%;margin:auto;position:absolute;top:0;right:0;bottom:0;left:0;display:block}.gallery-img-load-error{background:url(" + __webpack_require__(403) + ") no-repeat;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;width:369px;height:369px;z-index:20}@media only screen and (max-width:400px) and (orientation:portrait){.gallery-sidebar.opened{width:100%}.gallery-sidebar-content{margin-right:10%}.gallery-full-image img{height:auto;width:100%;max-width:100%;margin:auto;position:absolute;top:0;right:0;bottom:0;left:0;display:block}}@media only screen and (max-width:645px){.photoset-actions .action-link-text{display:none}}@media only screen and (min-width:768px){.gallery-sidebar:hover{opacity:1}}", ""]);

// exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/root-sprite.png", __webpack_require__.p + "_/_/_/root/images/root-sprite.png");

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/error_image_loading.png", __webpack_require__.p + "_/_/_/root/images/error_image_loading.png");

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(405);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./photoswipe.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./photoswipe.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "body.ps-active,body.ps-building,div.ps-active,div.ps-building{background:#000;overflow:hidden}body.ps-active *,div.ps-active *{-webkit-tap-highlight-color:rgba(255,255,255,0);display:none}body.ps-active :focus,div.ps-active :focus{outline:0}div.ps-document-overlay,div.ps-uilayer{background:#000}div.ps-uilayer{cursor:pointer}div.ps-zoom-pan-rotate{background:#000}div.ps-zoom-pan-rotate *{display:block}div.ps-carousel-item-loading{background:url(" + __webpack_require__(406) + ") no-repeat 50%}div.ps-carousel-item-error{background:url(" + __webpack_require__(407) + ") no-repeat 50%}div.ps-caption{background:#000;background:-moz-linear-gradient(top,#303130 0,#000101 100%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#303130),color-stop(100%,#000101));border-bottom:1px solid #42403f;color:#fff;font-size:13px;font-family:Lucida Grande,Helvetica,Arial,Verdana,sans-serif;text-align:center}div.ps-caption *{display:inline}div.ps-caption-bottom{border-top:1px solid #42403f;border-bottom:none;min-height:44px}div.ps-caption-content{padding:13px;display:block}div.ps-toolbar{background:#000;background:-moz-linear-gradient(top,#303130 0,#000101 100%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#303130),color-stop(100%,#000101));border-top:1px solid #42403f;color:#fff;font-size:13px;font-family:Lucida Grande,Helvetica,Arial,Verdana,sans-serif;text-align:center;height:44px;display:table;table-layout:fixed}div.ps-toolbar *{display:block}div.ps-toolbar-top{border-bottom:1px solid #42403f;border-top:none}div.ps-toolbar-close,div.ps-toolbar-next,div.ps-toolbar-play,div.ps-toolbar-previous{cursor:pointer;display:table-cell}div.ps-toolbar div div.ps-toolbar-content{width:44px;height:44px;margin:0 auto;background-image:url(" + __webpack_require__(408) + ");background-repeat:no-repeat}div.ps-toolbar-close div.ps-toolbar-content{background-position:0 0}div.ps-toolbar-previous div.ps-toolbar-content{background-position:-44px 0}div.ps-toolbar-previous-disabled div.ps-toolbar-content{background-position:-44px -44px}div.ps-toolbar-next div.ps-toolbar-content{background-position:-132px 0}div.ps-toolbar-next-disabled div.ps-toolbar-content{background-position:-132px -44px}div.ps-toolbar-play div.ps-toolbar-content{background-position:-88px 0}@media only screen and (-moz-min-device-pixel-ratio:1.5),only screen and (min-resolution:240dpi){div.ps-toolbar div div.ps-toolbar-content{background-size:176px 88px;background-image:url(" + __webpack_require__(409) + ")}}", ""]);

// exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gallery/loader.gif", __webpack_require__.p + "_/_/_/root/images/gallery/loader.gif");

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gallery/error.gif", __webpack_require__.p + "_/_/_/root/images/gallery/error.gif");

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gallery/icons.png", __webpack_require__.p + "_/_/_/root/images/gallery/icons.png");

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/gallery/icons@2x.png", __webpack_require__.p + "_/_/_/root/images/gallery/icons@2x.png");

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(411);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./preloader.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./preloader.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".preload{width:40px;margin:0 auto 0 -35px;position:absolute;top:50%;left:50%}.preload-thumb{max-width:100%}.loadtxt{padding-left:24px;box-sizing:content-box;animation:opacityload 2s linear infinite}#bg-spin,#left-spin,#right-spin{position:absolute;box-sizing:content-box}.pie{width:12px;height:12px;border-radius:50%;box-sizing:content-box}#bg-spin,.pie{border-width:4px;border-style:solid}#left-spin{clip:rect(0,20px,20px,10px)}#left-spin .spin{position:absolute;animation:rotatespin 2s linear infinite}#left-spin .spin,#right-spin{clip:rect(0,10px,20px,0)}#right-spin .spin{clip:rect(0,20px,20px,10px);position:absolute;animation:rotatespin 2s .5s linear infinite}.big-preload{width:80px;position:absolute;top:50%;left:50%;margin:-40px 0 0 -40px}.big-preload .loadtxt{padding:31px 18px}.big-preload .pie{width:64px;height:64px;border-width:8px}.big-preload #bg-spin{border-width:8px}.big-preload #left-spin{clip:rect(0,80px,80px,40px)}.big-preload #left-spin .spin,.big-preload #right-spin{clip:rect(0,40px,80px,0)}.big-preload #right-spin .spin{clip:rect(0,80px,80px,40px)}#preview .site-title{font-size:56px;line-height:56px;margin:0;font-family:georgia;color:#fff;font-weight:400}@keyframes opacityload{0%{opacity:1}50%{opacity:0}to{opacity:1}}@keyframes rotatespin{0%{transform:rotate(0deg)}25%,50%{transform:rotate(180deg)}75%,to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(413);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./stateoff-icons.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./stateoff-icons.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:stateoff;src:url(" + __webpack_require__(414) + ") format(\"truetype\"),url(" + __webpack_require__(415) + ") format(\"woff\"),url(" + __webpack_require__(416) + "#stateoff) format(\"svg\");font-weight:400;font-style:normal}[class*=\" stateoff-icon-\"],[class^=stateoff-icon-]{font-family:stateoff!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.stateoff-icon-close_9:before{content:\"\\E900\"}.stateoff-icon-alertOops_64:before{content:\"\\E901\"}.stateoff-icon-browserAndroid_61:before{content:\"\\E902\"}.stateoff-icon-browserChrome_61:before{content:\"\\E903\"}.stateoff-icon-browserFirefox_62:before{content:\"\\E904\"}.stateoff-icon-browserIe_66:before{content:\"\\E905\"}.stateoff-icon-browserSafari_69:before{content:\"\\E906\"}.stateoff-icon-captchaRefresh_17:before{content:\"\\E907\"}.stateoff-icon-gift_18:before{content:\"\\E908\"}.stateoff-icon-socaialFacebook_44:before{content:\"\\E909\"}.stateoff-icon-socialInstagram_44:before{content:\"\\E90A\"}.stateoff-icon-socialThumblr_44:before{content:\"\\E90B\"}.stateoff-icon-socialTwitter_44:before{content:\"\\E90C\"}", ""]);

// exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/stateoff.ttf?c8mros", __webpack_require__.p + "_/_/_/root/fonts/2Pd2-cS.ttf");

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/stateoff.woff?c8mros", __webpack_require__.p + "_/_/_/root/fonts/2k32eBC.woff");

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/stateoff.svg?c8mros", __webpack_require__.p + "_/_/_/root/fonts/stateoff.svg");

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(418);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./tags-filter.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./tags-filter.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:tags_filter;src:url(" + __webpack_require__(419) + ");src:url(" + __webpack_require__(420) + "?#iefix3lzqzp) format(\"embedded-opentype\"),url(" + __webpack_require__(421) + ") format(\"woff\"),url(" + __webpack_require__(422) + ") format(\"truetype\"),url(" + __webpack_require__(423) + "#tags-filter) format(\"svg\");font-weight:400;font-style:normal}[class*=root-ico],[class^=root-ico]{font-family:tags_filter;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.root-ico_tags_arr:before{content:\"\\E621\"}.root-ico_tags:before{content:\"\\E629\"}", ""]);

// exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/tags-filter.eot?3lzqzp", __webpack_require__.p + "_/_/_/root/fonts/38LfJPg.eot");

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/tags-filter.eot", __webpack_require__.p + "_/_/_/root/fonts/38LfJPg.eot");

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/tags-filter.woff?3lzqzp", __webpack_require__.p + "_/_/_/root/fonts/29qOVyH.woff");

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/tags-filter.ttf?3lzqzp", __webpack_require__.p + "_/_/_/root/fonts/1MWRmpt.ttf");

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/tags-filter.svg?3lzqzp", __webpack_require__.p + "_/_/_/root/fonts/tags-filter.svg");

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(425);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./throughChat.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./throughChat.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:throughChat;src:url(" + __webpack_require__(49) + ");src:url(" + __webpack_require__(49) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(426) + ") format(\"truetype\"),url(" + __webpack_require__(427) + ") format(\"woff\"),url(" + __webpack_require__(428) + "#throughChat) format(\"svg\");font-weight:400;font-style:normal}[class*=\" chat-icon-\"],[class^=chat-icon-]{font-family:throughChat;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.chat-icon-root_chat_send:before{content:\"\\E800\"}.chat-icon-root_chat_newMessage:before{content:\"\\E801\"}.chat-icon-root_chat_move:before{content:\"\\E802\"}.chat-icon-root_chat_openConversation:before{content:\"\\E803\"}", ""]);

// exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/throughChat.ttf?exnqbq", __webpack_require__.p + "_/_/_/root/fonts/saGLfpa.ttf");

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/throughChat.woff?exnqbq", __webpack_require__.p + "_/_/_/root/fonts/2iTfW7j.woff");

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/throughChat.svg?exnqbq", __webpack_require__.p + "_/_/_/root/fonts/throughChat.svg");

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dependencies.js": 430,
	"./modifiers.es.js": 626
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 429;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	__webpack_require__(431);

	__webpack_require__(433)(fox);
	
	__webpack_require__(434)(fox);
	__webpack_require__(435)(fox);
	__webpack_require__(437)(fox);
	__webpack_require__(439)(fox);
	__webpack_require__(440)(fox);
	__webpack_require__(441)(fox);
	__webpack_require__(442)(fox);
	__webpack_require__(443)(fox);
	__webpack_require__(444)(fox);
	__webpack_require__(448)(fox);
	
	__webpack_require__(450)(fox);
	__webpack_require__(451)(fox);
	__webpack_require__(452)(fox);
	__webpack_require__(453)(fox);
	__webpack_require__(454)(fox);
	
	__webpack_require__(455)(fox);
	__webpack_require__(456)(fox);
	__webpack_require__(457)(fox);
	__webpack_require__(458)(fox);
	__webpack_require__(460)(fox);
	__webpack_require__(461)(fox);

	__webpack_require__(462)(fox);

	__webpack_require__(8);
	__webpack_require__(9);
	__webpack_require__(491);
	__webpack_require__(496);

	__webpack_require__(497);
	__webpack_require__(499);
	__webpack_require__(501);
	__webpack_require__(503);
	__webpack_require__(505);

	__webpack_require__(507);
	__webpack_require__(509);

	__webpack_require__(511);
	
	__webpack_require__(513);
	__webpack_require__(515)(fox);

	__webpack_require__(532);
	__webpack_require__(534);
	//images;
	__webpack_require__(50);

	__webpack_require__(536)(fox);
	
	__webpack_require__(543)(fox);
	__webpack_require__(546)(fox);
	__webpack_require__(551)(fox);


	__webpack_require__(556)(fox);

	__webpack_require__(572)(fox);
	
	__webpack_require__(582)(fox);
	__webpack_require__(586)(fox);
	__webpack_require__(54)(fox);

	__webpack_require__(594)(fox);

	__webpack_require__(602);
	window.lazySizesConfig = window.lazySizesConfig || {};
	window.lazySizesConfig.loadMode = 1;
	window.lazySizesConfig.minSize = 30;

	// common widgets
	__webpack_require__(604)(fox);
	// GDPR popups
	__webpack_require__(608)(fox);
		// CCPA Form
	__webpack_require__(617)(fox);
	__webpack_require__(622)(fox);
	__webpack_require__(623)(fox);
	__webpack_require__(624)(fox);
	__webpack_require__(625)(fox);

	__webpack_require__(54)(fox);

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(432);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_shortcuts-bootstrapper.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_shortcuts-bootstrapper.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._flex{display:-moz-flex;display:-ms-flexbox;display:flex}._row-w{-ms-flex-flow:row wrap;flex-flow:row wrap}._row-n{-ms-flex-flow:row nowrap;flex-flow:row nowrap}._col-w{-ms-flex-flow:column wrap;flex-flow:column wrap}._col-n{-ms-flex-flow:column nowrap;flex-flow:column nowrap}._flex-1{-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto}._flex-1-5{-moz-flex:1.5 0 auto;-ms-flex:1.5 0 auto;flex:1.5 0 auto}._flex-2{-moz-flex:2 0 auto;-ms-flex:2 0 auto;flex:2 0 auto}._flex-2-5{-moz-flex:2.5 0 auto;-ms-flex:2.5 0 auto;flex:2.5 0 auto}._flex-3{-moz-flex:3 0 auto;-ms-flex:3 0 auto;flex:3 0 auto}._flex-3-5{-moz-flex:3.5 0 auto;-ms-flex:3.5 0 auto;flex:3.5 0 auto}._flex-4{-moz-flex:4 0 auto;-ms-flex:4 0 auto;flex:4 0 auto}._flex-4-5{-moz-flex:4.5 0 auto;-ms-flex:4.5 0 auto;flex:4.5 0 auto}._flex-5{-moz-flex:5 0 auto;-ms-flex:5 0 auto;flex:5 0 auto}._flex-5-5{-moz-flex:5.5 0 auto;-ms-flex:5.5 0 auto;flex:5.5 0 auto}._flex-6{-moz-flex:6 0 auto;-ms-flex:6 0 auto;flex:6 0 auto}._flex-6-5{-moz-flex:6.5 0 auto;-ms-flex:6.5 0 auto;flex:6.5 0 auto}._flex-7{-moz-flex:7 0 auto;-ms-flex:7 0 auto;flex:7 0 auto}._flex-7-5{-moz-flex:7.5 0 auto;-ms-flex:7.5 0 auto;flex:7.5 0 auto}._flex-8{-moz-flex:8 0 auto;-ms-flex:8 0 auto;flex:8 0 auto}._flex-8-5{-moz-flex:8.5 0 auto;-ms-flex:8.5 0 auto;flex:8.5 0 auto}._flex-9{-moz-flex:9 0 auto;-ms-flex:9 0 auto;flex:9 0 auto}._flex-9-5{-moz-flex:9.5 0 auto;-ms-flex:9.5 0 auto;flex:9.5 0 auto}._flex-10{-moz-flex:10 0 auto;-ms-flex:10 0 auto;flex:10 0 auto}._flex-10-5{-moz-flex:10.5 0 auto;-ms-flex:10.5 0 auto;flex:10.5 0 auto}._flex-0{-moz-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto}._r-h-center{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}._r-h-start{-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start}._r-h-end{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}._r-h-justify{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}._r-h-around{-ms-flex-pack:space-around;-moz-justify-content:space-around;justify-content:space-around}._r-v-center{-ms-flex-align:center;-moz-align-items:center;align-items:center}._r-v-start{-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}._r-v-end{-ms-flex-align:end;-moz-align-items:flex-end;align-items:flex-end}._c-v-center{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}._c-v-start{-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start}._c-v-end{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}._c-v-justify{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}._c-h-center{-ms-flex-align:center;-moz-align-items:center;align-items:center}._c-h-start{-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}._c-h-end{-ms-flex-align:end;-moz-align-items:flex-end;align-items:flex-end}._fs-11{font-size:11px}._fs-12{font-size:12px}._fs-14{font-size:14px}._fs-16{font-size:16px}._fs-18{font-size:18px}._fs-20{font-size:20px}._fs-24{font-size:24px}._fs-28{font-size:28px}._fs-32{font-size:32px}._fs-40{font-size:40px}._lh-11{line-height:11px}._lh-12{line-height:12px}._lh-14{line-height:14px}._lh-16{line-height:16px}._lh-18{line-height:18px}._lh-20{line-height:20px}._lh-24{line-height:24px}._lh-28{line-height:28px}._lh-32{line-height:32px}._lh-40{line-height:40px}._tc-err{color:#bd4147!important}._tc-white{color:#fff!important}._tc-green{color:#6cb758!important}._tc-gold{color:gold!important}._tc-i{color:inherit}._m-a-0{margin:0}._m-t-0{margin-top:0}._m-b-0{margin-bottom:0}._m-l-0{margin-left:0}._m-h-0,._m-r-0{margin-right:0}._m-h-0{margin-left:0}._m-v-0{margin-top:0;margin-bottom:0}._p-a-0{padding:0}._p-t-0{padding-top:0}._p-b-0{padding-bottom:0}._p-l-0{padding-left:0}._p-h-0,._p-r-0{padding-right:0}._p-h-0{padding-left:0}._p-v-0{padding-top:0;padding-bottom:0}._m-a-5{margin:5px}._m-t-5{margin-top:5px}._m-b-5{margin-bottom:5px}._m-l-5{margin-left:5px}._m-h-5,._m-r-5{margin-right:5px}._m-h-5{margin-left:5px}._m-v-5{margin-top:5px;margin-bottom:5px}._p-a-5{padding:5px}._p-t-5{padding-top:5px}._p-b-5{padding-bottom:5px}._p-l-5{padding-left:5px}._p-h-5,._p-r-5{padding-right:5px}._p-h-5{padding-left:5px}._p-v-5{padding-top:5px;padding-bottom:5px}._m-a-10{margin:10px}._m-t-10{margin-top:10px}._m-b-10{margin-bottom:10px}._m-l-10{margin-left:10px}._m-h-10,._m-r-10{margin-right:10px}._m-h-10{margin-left:10px}._m-v-10{margin-top:10px;margin-bottom:10px}._p-a-10{padding:10px}._p-t-10{padding-top:10px}._p-b-10{padding-bottom:10px}._p-l-10{padding-left:10px}._p-h-10,._p-r-10{padding-right:10px}._p-h-10{padding-left:10px}._p-v-10{padding-top:10px;padding-bottom:10px}._m-a-15{margin:15px}._m-t-15{margin-top:15px}._m-b-15{margin-bottom:15px}._m-l-15{margin-left:15px}._m-h-15,._m-r-15{margin-right:15px}._m-h-15{margin-left:15px}._m-v-15{margin-top:15px;margin-bottom:15px}._p-a-15{padding:15px}._p-t-15{padding-top:15px}._p-b-15{padding-bottom:15px}._p-l-15{padding-left:15px}._p-h-15,._p-r-15{padding-right:15px}._p-h-15{padding-left:15px}._p-v-15{padding-top:15px;padding-bottom:15px}._m-a-20{margin:20px}._m-t-20{margin-top:20px}._m-b-20{margin-bottom:20px}._m-l-20{margin-left:20px}._m-h-20,._m-r-20{margin-right:20px}._m-h-20{margin-left:20px}._m-v-20{margin-top:20px;margin-bottom:20px}._p-a-20{padding:20px}._p-t-20{padding-top:20px}._p-b-20{padding-bottom:20px}._p-l-20{padding-left:20px}._p-h-20,._p-r-20{padding-right:20px}._p-h-20{padding-left:20px}._p-v-20{padding-top:20px;padding-bottom:20px}._m-a-25{margin:25px}._m-t-25{margin-top:25px}._m-b-25{margin-bottom:25px}._m-l-25{margin-left:25px}._m-h-25,._m-r-25{margin-right:25px}._m-h-25{margin-left:25px}._m-v-25{margin-top:25px;margin-bottom:25px}._p-a-25{padding:25px}._p-t-25{padding-top:25px}._p-b-25{padding-bottom:25px}._p-l-25{padding-left:25px}._p-h-25,._p-r-25{padding-right:25px}._p-h-25{padding-left:25px}._p-v-25{padding-top:25px;padding-bottom:25px}._m-a-30{margin:30px}._m-t-30{margin-top:30px}._m-b-30{margin-bottom:30px}._m-l-30{margin-left:30px}._m-h-30,._m-r-30{margin-right:30px}._m-h-30{margin-left:30px}._m-v-30{margin-top:30px;margin-bottom:30px}._p-a-30{padding:30px}._p-t-30{padding-top:30px}._p-b-30{padding-bottom:30px}._p-l-30{padding-left:30px}._p-h-30,._p-r-30{padding-right:30px}._p-h-30{padding-left:30px}._p-v-30{padding-top:30px;padding-bottom:30px}._m-a-35{margin:35px}._m-t-35{margin-top:35px}._m-b-35{margin-bottom:35px}._m-l-35{margin-left:35px}._m-h-35,._m-r-35{margin-right:35px}._m-h-35{margin-left:35px}._m-v-35{margin-top:35px;margin-bottom:35px}._p-a-35{padding:35px}._p-t-35{padding-top:35px}._p-b-35{padding-bottom:35px}._p-l-35{padding-left:35px}._p-h-35,._p-r-35{padding-right:35px}._p-h-35{padding-left:35px}._p-v-35{padding-top:35px;padding-bottom:35px}._m-a-40{margin:40px}._m-t-40{margin-top:40px}._m-b-40{margin-bottom:40px}._m-l-40{margin-left:40px}._m-h-40,._m-r-40{margin-right:40px}._m-h-40{margin-left:40px}._m-v-40{margin-top:40px;margin-bottom:40px}._p-a-40{padding:40px}._p-t-40{padding-top:40px}._p-b-40{padding-bottom:40px}._p-l-40{padding-left:40px}._p-h-40,._p-r-40{padding-right:40px}._p-h-40{padding-left:40px}._p-v-40{padding-top:40px;padding-bottom:40px}._m-a-50{margin:50px}._m-t-50{margin-top:50px}._m-b-50{margin-bottom:50px}._m-l-50{margin-left:50px}._m-h-50,._m-r-50{margin-right:50px}._m-h-50{margin-left:50px}._m-v-50{margin-top:50px;margin-bottom:50px}._p-a-50{padding:50px}._p-t-50{padding-top:50px}._p-b-50{padding-bottom:50px}._p-l-50{padding-left:50px}._p-h-50,._p-r-50{padding-right:50px}._p-h-50{padding-left:50px}._p-v-50{padding-top:50px;padding-bottom:50px}._bgc-err{background-color:#bd4147!important}._bgc-white{background-color:#fff!important}._bgc-green{background-color:#6cb758!important}._bgc-gold{background-color:gold!important}._brc-a-err{border-color:#bd4147}._brc-t-err{border-top-color:#bd4147}._brc-r-err{border-right-color:#bd4147}._brc-b-err{border-bottom-color:#bd4147}._brc-l-err{border-left-color:#bd4147}._brc-a-white{border-color:#fff}._brc-t-white{border-top-color:#fff}._brc-r-white{border-right-color:#fff}._brc-b-white{border-bottom-color:#fff}._brc-l-white{border-left-color:#fff}._brc-a-green{border-color:#6cb758}._brc-t-green{border-top-color:#6cb758}._brc-r-green{border-right-color:#6cb758}._brc-b-green{border-bottom-color:#6cb758}._brc-l-green{border-left-color:#6cb758}._brc-a-gold{border-color:gold}._brc-t-gold{border-top-color:gold}._brc-r-gold{border-right-color:gold}._brc-b-gold{border-bottom-color:gold}._brc-l-gold{border-left-color:gold}._blur-1{filter:blur(1px)}._blur-2{filter:blur(2px)}._blur-3{filter:blur(3px)}._blur-4{filter:blur(4px)}._blur-5{filter:blur(5px)}._blur-6{filter:blur(6px)}._blur-7{filter:blur(7px)}._blur-8{filter:blur(8px)}._blur-9{filter:blur(9px)}._blur-10{filter:blur(10px)}._z-index-1{z-index:1}._z-index-2{z-index:2}._z-index-3{z-index:3}._z-index-4{z-index:4}._z-index-5{z-index:5}._z-index-6{z-index:6}._z-index-7{z-index:7}._z-index-8{z-index:8}._z-index-9{z-index:9}._z-index-10{z-index:10}._hidden{display:none!important}._break-w{word-break:break-word}._break-a{word-break:break-all}._abs-fill,._disabled:before{position:absolute;top:0;right:0;bottom:0;left:0}._disabled:before{content:\"\";background-color:hsla(0,0%,100%,.8);z-index:2}._img-contain{background-size:contain}._img-contain,._img-cover{background-position:50%;background-repeat:no-repeat}._img-cover{background-size:cover}._ofl-hidden{overflow:hidden}._opacity-40{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";filter:alpha(opacity=40);opacity:.4}", ""]);

// exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	var UID_LABEL = 'exo_uid';

	fox.registerService('exodentity', {
		_included: false,
		_fingerprint: null,

		include: function include() {
			var _this = this;

			if (this._included) return fox.Promise.resolve(false);

			return new fox.Promise(function (resolve) {
				__webpack_require__.e/* require.ensure */(3).then((function () {
					_this.addExodentityScript();

					return resolve(__webpack_require__(1283));
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			});
		},
		getSavedUid: function getSavedUid() {
			return [function () {
				return localStorage.getItem(UID_LABEL);
			}, function () {
				var uid = fox.cookie.get(UID_LABEL);

				if (uid) return decodeURIComponent(unescape(uid));

				return false;
			}].reduce(function (fingerprint, next) {
				if (fingerprint) return fingerprint;

				return next();
			}, this._fingerprint);
		},
		addExodentityScript: function addExodentityScript() {
			var _this2 = this;

			var loadAsync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			window.__exoCallback = function (response) {
				_this2._fingerprint = response;

				fox.site.dispatchEvent('exodentity_fingerprint_recieved', {
					fingerprint: response
				});

				fox.cookie.set(UID_LABEL, window.escape(response));

				try {
					localStorage.setItem(UID_LABEL, response);
				} catch (e) {/* do nothing... */}
			};

			window._axq = {
				'js_callback': '__exoCallback'
			};

			this._included = true;
		}
	});
};

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('PeriodicalUpdater', {
		configure: function(options) {
			this.registerOptions('', {
				started: false,
				updateTime: 100000,
				loadOnStart: false,
			});

			this.callParent('configure', arguments);
		},

		init: function() {
				this.visual = false;
				this.timerId = 0;
		},

		todo: function() {},

		startUpdate: function() {
			if (fox.isEmpty(this.timerId)) {
				if (this.getOption('loadOnStart')) {
					this.todo();
				};

				this.timerId = setInterval(fox.bind(this.todo, this), fox.cookie.get('updateTimeout') || this.getOption('updateTime'));
				this.setOption('started', true);
			};
		},
		
		stopUpdate: function() {
				if (!fox.isEmpty(this.timerId)) {
						clearInterval(this.timerId);
						this.timerId = 0;
						this.setOption('started', false);
				}
		},

		isStarted: function() {
			return this.getOption('started');
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	if (fox._isNewfe) {
		window.Favico = __webpack_require__(436);
	}

	fox.registerWidget('Favico', {
		configure: function(options) {
			this.currentNumber = null;

			this.registerOptions('', {
				applyOptionsOnChange: true,

				//http://lab.ejci.net/favico.js/
				favico: {
					//	Badge animation type (slide, fade, pop, popFade, none )
					animation:'slide',
					//	Badge position (up, down, left, upleft)
					position: 'down',
					//	Badge shape (circle, rectangle)
					type: 'circle',
					//	Font style (normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900)
					fontStyle: 'bold',
					//	Text font family (Arial, Verdana, Times New Roman, serif, sans-serif,...)
					fontFamily:	'sans-serif',
					//	Badge text color
					textColor:'#fff',
					//	Badge background color
					bgColor: '#d00',
				},

				handleWom: {
					optionsChange: {
						widget: '@this',
						event: 'optionsChanged',
						callback: '_handleOptionsChange'	
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function (argument) {
			this.favicoOptions = this.getOption('favico');

			this._createFavicoInstance();

			if (!this.favico.browser.supported) {
				console.warn('favicon change doesn\'t supported by browser');
			}

			this.callParent('init', arguments);
		},

		_createFavicoInstance: function () {
			if (this.favico) {
				this.favico.reset();
				delete this.favico;
			}

			this.favico = new Favico(this.favicoOptions);

			return this;
		},

		setFavicoOptions: function () {
			this.dispatchEvent('optionsChanged');

			if (fox.isObject(arguments[0])) {
				this.favicoOptions = arguments[0];

				return;
			}

			if (fox.isString(arguments[0]) && fox.isString(arguments[1])) {
				this.favicoOptions[arguments[0]] = arguments[1];

				return;
			}
		},

		getFavicoOptions: function (argument) {
			return this.favicoOptions;
		},

		_handleOptionsChange: function () {
			if (this.getOption('applyOptionsOnChange')) {
				this._createFavicoInstance();

				if (this.currentNumber) {
					this.insertNumber(this.currentNumber);
				}

				return;
			}
		},

		insertNumber: function (num) {
			this.favico.badge(num);
			this.currentNumber = num;

			return this;
		},

		reset: function (argument) {
			this.favico.reset();
			this.currentNumber = null;

			return this;
		},

		inserImage: function (img) {
			if (img.tagName.toLowerCase() !== 'img') {
				console.error('img should be an image element')

				return;
			}

			this.favico.image(img);

			return this;
		},

		inserImageFromURL: function (src) {
			if (!src.length) {
				return;
			}

			var img = document.createElement('img');
			img.src = src;

			this.inserImage(img);

			return this;
		}
	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license MIT
 * @fileOverview Favico animations
 * @author Miroslav Magda, http://blog.ejci.net
 * @version 0.3.10
 */

/**
 * Create new favico instance
 * @param {Object} Options
 * @return {Object} Favico object
 * @example
 * var favico = new Favico({
 *    bgColor : '#d00',
 *    textColor : '#fff',
 *    fontFamily : 'sans-serif',
 *    fontStyle : 'bold',
 *    position : 'down',
 *    type : 'circle',
 *    animation : 'slide',
 *    dataUrl: function(url){},
 *    win: top
 * });
 */
(function () {

	var Favico = (function (opt) {
		'use strict';
		opt = (opt) ? opt : {};
		var _def = {
			bgColor: '#d00',
			textColor: '#fff',
			fontFamily: 'sans-serif', //Arial,Verdana,Times New Roman,serif,sans-serif,...
			fontStyle: 'bold', //normal,italic,oblique,bold,bolder,lighter,100,200,300,400,500,600,700,800,900
			type: 'circle',
			position: 'down', // down, up, left, leftup (upleft)
			animation: 'slide',
			elementId: false,
			dataUrl: false,
			win: window
		};
		var _opt, _orig, _h, _w, _canvas, _context, _img, _ready, _lastBadge, _running, _readyCb, _stop, _browser, _animTimeout, _drawTimeout, _doc;

		_browser = {};
		_browser.ff = typeof InstallTrigger != 'undefined';
		_browser.chrome = !!window.chrome;
		_browser.opera = !!window.opera || navigator.userAgent.indexOf('Opera') >= 0;
		_browser.ie = /*@cc_on!@*/false;
		_browser.safari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
		_browser.supported = (_browser.chrome || _browser.ff || _browser.opera);

		var _queue = [];
		_readyCb = function () {
		};
		_ready = _stop = false;
		/**
		 * Initialize favico
		 */
		var init = function () {
			//merge initial options
			_opt = merge(_def, opt);
			_opt.bgColor = hexToRgb(_opt.bgColor);
			_opt.textColor = hexToRgb(_opt.textColor);
			_opt.position = _opt.position.toLowerCase();
			_opt.animation = (animation.types['' + _opt.animation]) ? _opt.animation : _def.animation;

			_doc = _opt.win.document;

			var isUp = _opt.position.indexOf('up') > -1;
			var isLeft = _opt.position.indexOf('left') > -1;

			//transform animation
			if (isUp || isLeft) {
				for (var i = 0; i < animation.types['' + _opt.animation].length; i++) {
					var step = animation.types['' + _opt.animation][i];

					if (isUp) {
						if (step.y < 0.6) {
							step.y = step.y - 0.4;
						} else {
							step.y = step.y - 2 * step.y + (1 - step.w);
						}
					}

					if (isLeft) {
						if (step.x < 0.6) {
							step.x = step.x - 0.4;
						} else {
							step.x = step.x - 2 * step.x + (1 - step.h);
						}
					}

					animation.types['' + _opt.animation][i] = step;
				}
			}
			_opt.type = (type['' + _opt.type]) ? _opt.type : _def.type;

			_orig = link.getIcon();
			//create temp canvas
			_canvas = document.createElement('canvas');
			//create temp image
			_img = document.createElement('img');
			if (_orig.hasAttribute('href')) {
				_img.setAttribute('crossOrigin', 'anonymous');
				//get width/height
				_img.onload = function () {
					_h = (_img.height > 0) ? _img.height : 32;
					_w = (_img.width > 0) ? _img.width : 32;
					_canvas.height = _h;
					_canvas.width = _w;
					_context = _canvas.getContext('2d');
					icon.ready();
				};
				_img.setAttribute('src', _orig.getAttribute('href'));
			} else {
				_img.onload = function () {
					_h = 32;
					_w = 32;
					_img.height = _h;
					_img.width = _w;
					_canvas.height = _h;
					_canvas.width = _w;
					_context = _canvas.getContext('2d');
					icon.ready();
				};
				_img.setAttribute('src', '');
			}

		};
		/**
		 * Icon namespace
		 */
		var icon = {};
		/**
		 * Icon is ready (reset icon) and start animation (if ther is any)
		 */
		icon.ready = function () {
			_ready = true;
			icon.reset();
			_readyCb();
		};
		/**
		 * Reset icon to default state
		 */
		icon.reset = function () {
			//reset
			if (!_ready) {
				return;
			}
			_queue = [];
			_lastBadge = false;
			_running = false;
			_context.clearRect(0, 0, _w, _h);
			_context.drawImage(_img, 0, 0, _w, _h);
			//_stop=true;
			link.setIcon(_canvas);
			//webcam('stop');
			//video('stop');
			window.clearTimeout(_animTimeout);
			window.clearTimeout(_drawTimeout);
		};
		/**
		 * Start animation
		 */
		icon.start = function () {
			if (!_ready || _running) {
				return;
			}
			var finished = function () {
				_lastBadge = _queue[0];
				_running = false;
				if (_queue.length > 0) {
					_queue.shift();
					icon.start();
				} else {

				}
			};
			if (_queue.length > 0) {
				_running = true;
				var run = function () {
					// apply options for this animation
					['type', 'animation', 'bgColor', 'textColor', 'fontFamily', 'fontStyle'].forEach(function (a) {
						if (a in _queue[0].options) {
							_opt[a] = _queue[0].options[a];
						}
					});
					animation.run(_queue[0].options, function () {
						finished();
					}, false);
				};
				if (_lastBadge) {
					animation.run(_lastBadge.options, function () {
						run();
					}, true);
				} else {
					run();
				}
			}
		};

		/**
		 * Badge types
		 */
		var type = {};
		var options = function (opt) {
			opt.n = ((typeof opt.n) === 'number') ? Math.abs(opt.n | 0) : opt.n;
			opt.x = _w * opt.x;
			opt.y = _h * opt.y;
			opt.w = _w * opt.w;
			opt.h = _h * opt.h;
			opt.len = ("" + opt.n).length;
			return opt;
		};
		/**
		 * Generate circle
		 * @param {Object} opt Badge options
		 */
		type.circle = function (opt) {
			opt = options(opt);
			var more = false;
			if (opt.len === 2) {
				opt.x = opt.x - opt.w * 0.4;
				opt.w = opt.w * 1.4;
				more = true;
			} else if (opt.len >= 3) {
				opt.x = opt.x - opt.w * 0.65;
				opt.w = opt.w * 1.65;
				more = true;
			}
			_context.clearRect(0, 0, _w, _h);
			_context.drawImage(_img, 0, 0, _w, _h);
			_context.beginPath();
			_context.font = _opt.fontStyle + " " + Math.floor(opt.h * (opt.n > 99 ? 0.85 : 1)) + "px " + _opt.fontFamily;
			_context.textAlign = 'center';
			if (more) {
				_context.moveTo(opt.x + opt.w / 2, opt.y);
				_context.lineTo(opt.x + opt.w - opt.h / 2, opt.y);
				_context.quadraticCurveTo(opt.x + opt.w, opt.y, opt.x + opt.w, opt.y + opt.h / 2);
				_context.lineTo(opt.x + opt.w, opt.y + opt.h - opt.h / 2);
				_context.quadraticCurveTo(opt.x + opt.w, opt.y + opt.h, opt.x + opt.w - opt.h / 2, opt.y + opt.h);
				_context.lineTo(opt.x + opt.h / 2, opt.y + opt.h);
				_context.quadraticCurveTo(opt.x, opt.y + opt.h, opt.x, opt.y + opt.h - opt.h / 2);
				_context.lineTo(opt.x, opt.y + opt.h / 2);
				_context.quadraticCurveTo(opt.x, opt.y, opt.x + opt.h / 2, opt.y);
			} else {
				_context.arc(opt.x + opt.w / 2, opt.y + opt.h / 2, opt.h / 2, 0, 2 * Math.PI);
			}
			_context.fillStyle = 'rgba(' + _opt.bgColor.r + ',' + _opt.bgColor.g + ',' + _opt.bgColor.b + ',' + opt.o + ')';
			_context.fill();
			_context.closePath();
			_context.beginPath();
			_context.stroke();
			_context.fillStyle = 'rgba(' + _opt.textColor.r + ',' + _opt.textColor.g + ',' + _opt.textColor.b + ',' + opt.o + ')';
			//_context.fillText((more) ? '9+' : opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
			if ((typeof opt.n) === 'number' && opt.n > 999) {
				_context.fillText(((opt.n > 9999) ? 9 : Math.floor(opt.n / 1000)) + 'k+', Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.2));
			} else {
				_context.fillText(opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
			}
			_context.closePath();
		};
		/**
		 * Generate rectangle
		 * @param {Object} opt Badge options
		 */
		type.rectangle = function (opt) {
			opt = options(opt);
			var more = false;
			if (opt.len === 2) {
				opt.x = opt.x - opt.w * 0.4;
				opt.w = opt.w * 1.4;
				more = true;
			} else if (opt.len >= 3) {
				opt.x = opt.x - opt.w * 0.65;
				opt.w = opt.w * 1.65;
				more = true;
			}
			_context.clearRect(0, 0, _w, _h);
			_context.drawImage(_img, 0, 0, _w, _h);
			_context.beginPath();
			_context.font = _opt.fontStyle + " " + Math.floor(opt.h * (opt.n > 99 ? 0.9 : 1)) + "px " + _opt.fontFamily;
			_context.textAlign = 'center';
			_context.fillStyle = 'rgba(' + _opt.bgColor.r + ',' + _opt.bgColor.g + ',' + _opt.bgColor.b + ',' + opt.o + ')';
			_context.fillRect(opt.x, opt.y, opt.w, opt.h);
			_context.fillStyle = 'rgba(' + _opt.textColor.r + ',' + _opt.textColor.g + ',' + _opt.textColor.b + ',' + opt.o + ')';
			//_context.fillText((more) ? '9+' : opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
			if ((typeof opt.n) === 'number' && opt.n > 999) {
				_context.fillText(((opt.n > 9999) ? 9 : Math.floor(opt.n / 1000)) + 'k+', Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.2));
			} else {
				_context.fillText(opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
			}
			_context.closePath();
		};

		/**
		 * Set badge
		 */
		var badge = function (number, opts) {
			opts = ((typeof opts) === 'string' ? {
				animation: opts
			} : opts) || {};
			_readyCb = function () {
				try {
					if (typeof (number) === 'number' ? (number > 0) : (number !== '')) {
						var q = {
							type: 'badge',
							options: {
								n: number
							}
						};
						if ('animation' in opts && animation.types['' + opts.animation]) {
							q.options.animation = '' + opts.animation;
						}
						if ('type' in opts && type['' + opts.type]) {
							q.options.type = '' + opts.type;
						}
						['bgColor', 'textColor'].forEach(function (o) {
							if (o in opts) {
								q.options[o] = hexToRgb(opts[o]);
							}
						});
						['fontStyle', 'fontFamily'].forEach(function (o) {
							if (o in opts) {
								q.options[o] = opts[o];
							}
						});
						_queue.push(q);
						if (_queue.length > 100) {
							throw new Error('Too many badges requests in queue.');
						}
						icon.start();
					} else {
						icon.reset();
					}
				} catch (e) {
					throw new Error('Error setting badge. Message: ' + e.message);
				}
			};
			if (_ready) {
				_readyCb();
			}
		};

		/**
		 * Set image as icon
		 */
		var image = function (imageElement) {
			_readyCb = function () {
				try {
					var w = imageElement.width;
					var h = imageElement.height;
					var newImg = document.createElement('img');
					var ratio = (w / _w < h / _h) ? (w / _w) : (h / _h);
					newImg.setAttribute('crossOrigin', 'anonymous');
					newImg.onload=function(){
						_context.clearRect(0, 0, _w, _h);
						_context.drawImage(newImg, 0, 0, _w, _h);
						link.setIcon(_canvas);
					};
					newImg.setAttribute('src', imageElement.getAttribute('src'));
					newImg.height = (h / ratio);
					newImg.width = (w / ratio);
				} catch (e) {
					throw new Error('Error setting image. Message: ' + e.message);
				}
			};
			if (_ready) {
				_readyCb();
			}
		};
		/**
		 * Set video as icon
		 */
		var video = function (videoElement) {
			_readyCb = function () {
				try {
					if (videoElement === 'stop') {
						_stop = true;
						icon.reset();
						_stop = false;
						return;
					}
					//var w = videoElement.width;
					//var h = videoElement.height;
					//var ratio = (w / _w < h / _h) ? (w / _w) : (h / _h);
					videoElement.addEventListener('play', function () {
						drawVideo(this);
					}, false);

				} catch (e) {
					throw new Error('Error setting video. Message: ' + e.message);
				}
			};
			if (_ready) {
				_readyCb();
			}
		};
		/**
		 * Set video as icon
		 */
		var webcam = function (action) {
			//UR
			if (!window.URL || !window.URL.createObjectURL) {
				window.URL = window.URL || {};
				window.URL.createObjectURL = function (obj) {
					return obj;
				};
			}
			if (_browser.supported) {
				var newVideo = false;
				navigator.getUserMedia = navigator.getUserMedia || navigator.oGetUserMedia || navigator.msGetUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia;
				_readyCb = function () {
					try {
						if (action === 'stop') {
							_stop = true;
							icon.reset();
							_stop = false;
							return;
						}
						newVideo = document.createElement('video');
						newVideo.width = _w;
						newVideo.height = _h;
						navigator.getUserMedia({
							video: true,
							audio: false
						}, function (stream) {
							newVideo.src = URL.createObjectURL(stream);
							newVideo.play();
							drawVideo(newVideo);
						}, function () {
						});
					} catch (e) {
						throw new Error('Error setting webcam. Message: ' + e.message);
					}
				};
				if (_ready) {
					_readyCb();
				}
			}

		};

		/**
		 * Draw video to context and repeat :)
		 */
		function drawVideo(video) {
			if (video.paused || video.ended || _stop) {
				return false;
			}
			//nasty hack for FF webcam (Thanks to Julian Ćwirko, kontakt@redsunmedia.pl)
			try {
				_context.clearRect(0, 0, _w, _h);
				_context.drawImage(video, 0, 0, _w, _h);
			} catch (e) {

			}
			_drawTimeout = setTimeout(function () {
				drawVideo(video);
			}, animation.duration);
			link.setIcon(_canvas);
		}

		var link = {};
		/**
		 * Get icon from HEAD tag or create a new <link> element
		 */
		link.getIcon = function () {
			var elm = false;
			//get link element
			var getLink = function () {
				var link = _doc.getElementsByTagName('head')[0].getElementsByTagName('link');
				for (var l = link.length, i = (l - 1); i >= 0; i--) {
					if ((/(^|\s)icon(\s|$)/i).test(link[i].getAttribute('rel'))) {
						return link[i];
					}
				}
				return false;
			};
			if (_opt.element) {
				elm = _opt.element;
			} else if (_opt.elementId) {
				//if img element identified by elementId
				elm = _doc.getElementById(_opt.elementId);
				elm.setAttribute('href', elm.getAttribute('src'));
			} else {
				//if link element
				elm = getLink();
				if (elm === false) {
					elm = _doc.createElement('link');
					elm.setAttribute('rel', 'icon');
					_doc.getElementsByTagName('head')[0].appendChild(elm);
				}
			}
			elm.setAttribute('type', 'image/png');
			return elm;
		};
		link.setIcon = function (canvas) {
			var url = canvas.toDataURL('image/png');
			if (_opt.dataUrl) {
				//if using custom exporter
				_opt.dataUrl(url);
			}
			if (_opt.element) {
				_opt.element.setAttribute('href', url);
				_opt.element.setAttribute('src', url);
			} else if (_opt.elementId) {
				//if is attached to element (image)
				var elm = _doc.getElementById(_opt.elementId);
				elm.setAttribute('href', url);
				elm.setAttribute('src', url);
			} else {
				//if is attached to fav icon
				if (_browser.ff || _browser.opera) {
					//for FF we need to "recreate" element, atach to dom and remove old <link>
					//var originalType = _orig.getAttribute('rel');
					var old = _orig;
					_orig = _doc.createElement('link');
					//_orig.setAttribute('rel', originalType);
					if (_browser.opera) {
						_orig.setAttribute('rel', 'icon');
					}
					_orig.setAttribute('rel', 'icon');
					_orig.setAttribute('type', 'image/png');
					_doc.getElementsByTagName('head')[0].appendChild(_orig);
					_orig.setAttribute('href', url);
					if (old.parentNode) {
						old.parentNode.removeChild(old);
					}
				} else {
					_orig.setAttribute('href', url);
				}
			}
		};

		//http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb#answer-5624139
		//HEX to RGB convertor
		function hexToRgb(hex) {
			var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
			hex = hex.replace(shorthandRegex, function (m, r, g, b) {
				return r + r + g + g + b + b;
			});
			var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16)
			} : false;
		}

		/**
		 * Merge options
		 */
		function merge(def, opt) {
			var mergedOpt = {};
			var attrname;
			for (attrname in def) {
				mergedOpt[attrname] = def[attrname];
			}
			for (attrname in opt) {
				mergedOpt[attrname] = opt[attrname];
			}
			return mergedOpt;
		}

		/**
		 * Cross-browser page visibility shim
		 * http://stackoverflow.com/questions/12536562/detect-whether-a-window-is-visible
		 */
		function isPageHidden() {
			return _doc.hidden || _doc.msHidden || _doc.webkitHidden || _doc.mozHidden;
		}

		/**
		 * @namespace animation
		 */
		var animation = {};
		/**
		 * Animation "frame" duration
		 */
		animation.duration = 40;
		/**
		 * Animation types (none,fade,pop,slide)
		 */
		animation.types = {};
		animation.types.fade = [{
			x: 0.4,
			y: 0.4,
			w: 0.6,
			h: 0.6,
			o: 0.0
		}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.1
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.2
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.3
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.4
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.5
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.6
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.7
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.8
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.9
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 1.0
			}];
		animation.types.none = [{
			x: 0.4,
			y: 0.4,
			w: 0.6,
			h: 0.6,
			o: 1
		}];
		animation.types.pop = [{
			x: 1,
			y: 1,
			w: 0,
			h: 0,
			o: 1
		}, {
				x: 0.9,
				y: 0.9,
				w: 0.1,
				h: 0.1,
				o: 1
			}, {
				x: 0.8,
				y: 0.8,
				w: 0.2,
				h: 0.2,
				o: 1
			}, {
				x: 0.7,
				y: 0.7,
				w: 0.3,
				h: 0.3,
				o: 1
			}, {
				x: 0.6,
				y: 0.6,
				w: 0.4,
				h: 0.4,
				o: 1
			}, {
				x: 0.5,
				y: 0.5,
				w: 0.5,
				h: 0.5,
				o: 1
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 1
			}];
		animation.types.popFade = [{
			x: 0.75,
			y: 0.75,
			w: 0,
			h: 0,
			o: 0
		}, {
				x: 0.65,
				y: 0.65,
				w: 0.1,
				h: 0.1,
				o: 0.2
			}, {
				x: 0.6,
				y: 0.6,
				w: 0.2,
				h: 0.2,
				o: 0.4
			}, {
				x: 0.55,
				y: 0.55,
				w: 0.3,
				h: 0.3,
				o: 0.6
			}, {
				x: 0.50,
				y: 0.50,
				w: 0.4,
				h: 0.4,
				o: 0.8
			}, {
				x: 0.45,
				y: 0.45,
				w: 0.5,
				h: 0.5,
				o: 0.9
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 1
			}];
		animation.types.slide = [{
			x: 0.4,
			y: 1,
			w: 0.6,
			h: 0.6,
			o: 1
		}, {
				x: 0.4,
				y: 0.9,
				w: 0.6,
				h: 0.6,
				o: 1
			}, {
				x: 0.4,
				y: 0.9,
				w: 0.6,
				h: 0.6,
				o: 1
			}, {
				x: 0.4,
				y: 0.8,
				w: 0.6,
				h: 0.6,
				o: 1
			}, {
				x: 0.4,
				y: 0.7,
				w: 0.6,
				h: 0.6,
				o: 1
			}, {
				x: 0.4,
				y: 0.6,
				w: 0.6,
				h: 0.6,
				o: 1
			}, {
				x: 0.4,
				y: 0.5,
				w: 0.6,
				h: 0.6,
				o: 1
			}, {
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 1
			}];
		/**
		 * Run animation
		 * @param {Object} opt Animation options
		 * @param {Object} cb Callabak after all steps are done
		 * @param {Object} revert Reverse order? true|false
		 * @param {Object} step Optional step number (frame bumber)
		 */
		animation.run = function (opt, cb, revert, step) {
			var animationType = animation.types[isPageHidden() ? 'none' : _opt.animation];
			if (revert === true) {
				step = (typeof step !== 'undefined') ? step : animationType.length - 1;
			} else {
				step = (typeof step !== 'undefined') ? step : 0;
			}
			cb = (cb) ? cb : function () {
			};
			if ((step < animationType.length) && (step >= 0)) {
				type[_opt.type](merge(opt, animationType[step]));
				_animTimeout = setTimeout(function () {
					if (revert) {
						step = step - 1;
					} else {
						step = step + 1;
					}
					animation.run(opt, cb, revert, step);
				}, animation.duration);

				link.setIcon(_canvas);
			} else {
				cb();
				return;
			}
		};
		//auto init
		init();
		return {
			badge: badge,
			video: video,
			image: image,
			webcam: webcam,
			reset: icon.reset,
			browser: {
				supported: _browser.supported
			}
		};
	});

	// AMD / RequireJS
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return Favico;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// CommonJS
	else if (typeof module !== 'undefined' && module.exports) {
		module.exports = Favico;
	}
	// included directly via <script> tag
	else {
		this.Favico = Favico;
	}

})();


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	__webpack_require__(438)(fox);

	fox.registerWidget('Copyright', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				startDate: 2013,
				container: '.cp-container',
				template: 'copyright'
			});
			
			this.callParent('configure', arguments);
		},

		rendering: function () {
			this.setTemplateOptions({
				startDate: this.getOption('startDate'),
				endDate: new Date().getFullYear()
			});

			this.callParent('rendering', arguments);
		}

	}, 'Widget');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("copyright", [["span",{"class":"cp-dates"},[["textNode",{"text":" "}],["span",{},[],[["startDate","__text",true]]],["textNode",{"text":" - "}],["span",{},[],[["endDate","__text",true]]],["textNode",{"text":" "}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Content_Browser', {

		configure: function(options) {
			this.registerOptions('', {
				sendTimezone: true,
				dlMethod: 'content.load'
			});
			this.callParent('configure', arguments);
		},

		initDl: function() {
			this.callParent('initDl', arguments)
			
			if (!this.dl) {
				var dl = this.getOption('dataLayer');
				this.dl = fox.createDataLayer().set(dl || {});
			}
			
			if (this.getOption('preset') != 'favorites') {
				this.dl.setOption('cacheChannel', 'content');
			}

			if (!this.dl._transitParameters) {
				debugger;
			}

			var preset = this.getOption('preset');

			if (preset) {
				this.applyPreset(preset);
			}

		},

		init: function() {
			if (this.getOption('mixedContent') === true) {
				var contentRow = {
					0: 'row',
					1: 'dvd',
					2: 'scene',
					3: 'scene',
					20: 'scene', //liveshow
					11: 'photoset'
				};
				
				this.registerOptions('#list', {
					hooks: {
						onRendering: function(obj) {
							this.fragment = this.createFragment();
							while (obj = this.dl.iterateObject('mix')) {
								var rowTpl = this.getOption('tpl.' + contentRow[obj.get('contentType')]) ||
										this.getOption('tpl.row');
								this.fragment.appendChild(fox.Zen(rowTpl, [obj]));
							}
							return true;
						},
						onInitTpl: function() {
							fox.each(this.requireOption('tpl'), function(row, alias) {
								var tmp = fox.Zen(row, 'prepare');
								this.plainVariables = fox.merge(this.plainVariables, tmp.plainVariables);
							}, this);
						}
					}
				});
			}

			this.callParent('init', arguments);
			return this;
		},

		applyPreset: function(preset) {
			var method = (preset !== 'favorites') ? this.getOption('dlMethod') : 'favorite.get';
			this.dl.setMethod(method);
			this.dl.setTransitParameter('preset', this.getOption('preset'));

			return this;
		},

		filter: function(filter) {
			filter.filter.type = 'list' + fox.ucfirst(filter.subject);
			this.dl.setMethod('content.get');
			this.dl.setOffset(0).setTransitParameter('preset', 'search').setCustomFilter(filter.filter).addSorting('sites.publishDate', 'desc', 'lastadded').load();
		},

		setTags: function (tags) {
			this.dispatchEvent('tagsApplied', tags);

			if (tags.length) {
				this.dl.setTransitParameter('tags', tags.join(','));

				return;
			};

			this.dl.clearTransitParameters('tags');
		},

		applyTagsFilter: function (tags) {
			this.dl.setOffset(0);
			this.dl.setCp(1);

			this.setTags(tags);
		},

		filterByTags: function (tags) {
			this.applyTagsFilter(tags);
			this.dl.load();
		},

		generateContentLink: function () {
			var pm = this.wom1('@root .PermissionManager');

			var contentTypes = {
				3: 'scene',
				20: 'scene', //liveshow
				11: 'gallery'
			};

			fox.each(this.dl.getCollection(), function (data) {
				var accessibility = fox.objectGet(data.accessibility, ['collection', data.id])
				var arr = [];

				if (!contentTypes[data.contentType]) {
					console.warn('no such content type for direct link')
				}

				arr = ['/', contentTypes[data.contentType], '/', data.id];

				if (fox.isSet(data.title)) {
					var title = data.title.toString();
					arr.push('/')
					arr.push(fox.utils.toNavigatorAlias(title));
				};

				if (pm) {
					if (!pm.hasAccess('member') && accessibility.previewsForGuests === 0 && data.contentType == 11) {
						arr = [fox.getEnv('siteProps.ubs.joinUrl')];
					}
				} else if (!fox.site.member && accessibility.previewsForGuests === 0 && data.contentType == 11) {
					arr = [fox.getEnv('siteProps.ubs.joinUrl')];
				}

				data.generatedContentLink = arr.join('');
			}, this);
		}

	}, 'Grid');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Photosets Widget

(function (fox) {
	'use strict';
	fox.registerWidget('Content_Photosets', {

		configure: function (options) {
			this.registerOptions('', {
				container: '#mixed_content',
				template: 'sitepage_photoSets_photoSet_container',
				autoRender: true,
				'widgets.dl': {
					widget: 'Datalayer',
					'filter.contentType': {
						fields: ['contentType'],
						values: [[11]]
					}
				},
				list: {
					container: '#last_added',
					'tpl.row': 'sitepage_photoSets_photoSet'
				}
			});
			
			fox.registerTemplateModifier('isWide', function (obj) {
				if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return (w / h > .84);
			});
			this.callParent('configure', arguments);
		},

	}, 'Content_Browser');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Liveshows

(function (fox, $) {
	
	fox.registerWidget('Content_Liveshows', {

		configure: function () {
			this.registerOptions('', {
				preset: 'liveshow',
				'widgets.dl': {
					widget: 'Datalayer',
					limit: 4,
					fields: ['title']
				},
				'handleWom.dlUpdated': {
					widget: '@this',
					event: 'updated',
					callback: '_dlUpdated'
				}
			});

			this.callParent('configure', arguments);
		},

		/*afterEmbed: function () {
			if (!this.dl.getCount()) {
				this.element[0].style.display = 'none';
			}
		
			this.callParent('afterEmbed', arguments);
		},*/

		activate: function () {
			this.dl.load();
		
			this.callParent('activate', arguments);
		},

		_dlUpdated: function () {
			if (!this.dl.getCount()) {
				this.element[0].style.display = 'none';
			}
		}

	}, 'Content_Browser');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Related Widget
(function (fox){

	const hoverVideo = __webpack_require__(27)(fox, $);

	fox.registerWidget('Content_Scenes', {

		configure: function (options) {

			this.registerOptions('', {
				autoRender: true,
				preset: 'lastAddedScenes',
				list: {
					handleDom: {
						rollOver: {
							target: '.item .imgpicker',
							event: 'mouseover',
							callback: 'handlerDom:rollOver'
						},
						titleMove: {
							target: '.title',
							event: 'mouseover',
							callback: 'handlerDom:titleMove'
						},
						titleMoveBack: {
							target: '.title',
							event: 'mouseout',
							callback: 'handlerDom:titleMoveBack'
						},
						error: {
							target: '.item .errorimg',
							event: 'error',
							callback: 'handlerDom:errorImg'
						},
						following:{
							target: '.over-timeline',
							event: 'click',
							callback: function (elt) {
								hoverVideo.followingLink(elt)
							}
						},
						addPrevVideo: {
							event: 'mouseover',
							target: '.over-timeline',
							callback: function (elt, w) {
								var w = this;
								if (fox.utils.isTouchDevice()) return;
								hoverVideo.hoverPreviewVideo(elt, this);
							}
						},
						removePrevVideo: {
							event: 'mouseleave',
							target: '.over-timeline',
							callback: function (elt) {
								var w = this;
								hoverVideo.stopHoverPreviewVideo(elt, this)
							}
						}
					},
					'hooks.onStopRendering': function() {
						var elmArr = this.dom('.over-timeline');
						hoverVideo.handleTouch(elmArr, this)
					}
				},
				'widgets.dl': {
					widget: 'Datalayer',
					'metaFields.resources.thumb': 'baseline.sprite.w225i'
				}

			});
			this.callParent('configure', arguments);
		},

	}, 'Content_Browser');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
 // Content_Related Widget
(function (fox, $){
	'use strict';
	fox.registerWidget('Content_Favorites', {

		configure: function (options) {
			this.bigThumbs = {};
			this.attachedVideos = {};

			this.registerOptions('', {
				externalLoad: true,
				autoRender: true,
				widgets: {
					dl: {
						widget: 'Datalayer',
						limit: 24,
						fields: ['contentType', 'type'],
						'metaFields.resources': {
							bigThumb: 'primary..h1360i',
							originThumb: 'sources..origin',
							info: 'width,height'
						}
					},
					fullscreenView: {
						widget: 'FullscreenView',
						template: 'sitepage_gallery_fullscreenview_cutted'
					},
					previewContent: {
						widget: 'PreviewUploadedContent',
						dialog: {
							close: fox.bind(function () {
								this.dl.load();
								$(fox.dom.selectFirst('.wrapper')).removeClass('blured');
							}, this),
						}
					}
				},
				handleWom: {
					dlLoaded: {
						event: 'loaded',
						widget: '#dl',
						callback: 'dlLoaded'
					},
				},
				list: {
					handleDom: {
						rollOver: {
							target: '.item .imgpicker',
							event: 'mouseover',
							callback: 'handlerDom:rollOver'
						},
						titleMove: {
							target: '.title',
							event: 'mouseover',
							callback: 'handlerDom:titleMove'
						},
						titleMoveBack: {
							target: '.title',
							event: 'mouseout',
							callback: 'handlerDom:titleMoveBack'
						},
						remove: {
							target: '.remove',
							event: 'click',
							callback: 'handlerDom:remove'
						},
						error: {
							target: '.item .errorimg',
							event: 'error',
							callback: 'handlerDom:errorImg'
						},
						openFullscreen: {
							target: '.fullscreen',
							event: 'click',
							callback: '@parent:openFullscreen'
						},
						openAttachedVideo: {
							event: 'click',
							target: '.attached-video',
							callback: '@parent:openAttachedVideo'
						}
					}
				}
			});
			fox.registerTemplateModifier('isWide', function (obj) {
				if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return ((w / h) > .84);
			});
			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#previewContent #videoPreview', {
				'hooks.onStartRendering': function () {
					var
						parent = this.getParent(),
						id = parent.currentId;

					if (!parent.STORE.hasOwnProperty(id)) {
						this.formatGetMap(id, '@parent @parent:getMapResponse');
					} else {
						this.preparePlayerData(parent.STORE[id]);
					}

					this.setTemplateOptions({
						contentId: id,
						attachTitle: parent.currentData.attachTitle,
						targetId: parent.currentResId
					});
				}
			});

			this.registerOptions('#previewContent #videoPreview #downloadLinks', {
				'hooks.onAddedToDom': function () {
					$(this.element[0]).hide();
				},
				'hooks.onStartRendering': function () {
					return true;
				}
			});

			this.registerOptions('#previewContent .Widget #favorites', {
				'hooks.onAddedToDom': function () {
					$(this.element[0]).hide();
				}
			});
		
			this.callParent('init', arguments);
		},

		// running: function () {
		// 	this.dl.load();
		//
		// 	this.callParent('running', arguments);
		// },

		activating: function () {
			this.dl.load();
			this.callParent('activating', arguments);
		},

		getImgById: function (id, c) {
			id = parseInt(id);

			if (fox.isArray(c)) {
				return c.filter(function (value, index) {
					return Number(value.id) === Number(id);
				}).pop();
			}

			return false;
		},

		openFullscreen: function (e) {
			var 
				id = $(e).attr('id'),
				photoData = this.getImgById(id, this.bigThumbs[id]);

			if (photoData) {
				this.rwom1('#fullscreenView').setPhotoCollection(this.bigThumbs[id]).setCurrentPhoto(photoData).show();
			}
		},

		dlLoaded: function (o, dl) {
			var 
				obj,
				resId,
				fType,
				fsv = this.rwom1('#fullscreenView');

			while (obj = dl.iterateObject()) {
				fType = obj.get('favoriteType');

				resId = !fox.isEmpty(obj.get('resourceId'))
					? obj.get('resourceId')
					: obj.get('favoriteType') === 'clientUploadResource' && obj.get('type') === 2
						? obj.get('_resources.bigThumb.id')
						: false;

				if (resId) {
					if (!fox.isEmpty(obj.get('_resources.bigThumb'))) {
						if (!fox.isEmpty(obj.get('_resources.originThumb.info'))) {
							this.bigThumbs[resId] = fsv.mixBigThumb(obj.get('_resources.bigThumb'), obj.get('_resources.originThumb'));
						} else {
							this.bigThumbs[resId] = obj.get('_resources.bigThumb');
						}
					}
				}

				if (fType === 'clientUploadResource' && obj.get('type') === 1) {
					this.attachedVideos[obj.get('clienUploadId')] = {
						id: obj.get('clienUploadId'),
						type: obj.get('type'),
						attachTitle: obj.get('title'),
						posterUrl: obj.get('_resources.primary.url'),
						resId: resId
					};
				}
			}
		},

		openAttachedVideo: function (el) {
			var
				attachContentId = $(el).data('attached-content'),
				pc = this.rwom1('#previewContent');

			if (attachContentId) {
				pc.show({
					collection: [],
					data: this.attachedVideos[attachContentId]
				});
			}
		},

		getMapResponse: function (res) {
			var 
				map = this.rwom1('#previewContent').fillStore(this.rwom1('#previewContent').currentId, res.answer.response),
				p = this.rwom1('#previewContent #videoPreview');

			p.preparePlayerData(map);
		}
	}, 'Content_Browser');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	__webpack_require__(445)(fox);
	__webpack_require__(447)(fox);
	
	fox.registerWidget('Content_FlashPlayer', {
		configure: function (options) {
			this.MOBILE_DEVICES_START_FORMAT = 'ipod';

			this.registerOptions('', {
				getMapMethod: 'site.format.getMap',
				jsonizeMapRequest: true,
				resourceIdParamName: 'contentId',
				'handleWom.recieveContentId': {
					widget: '@this',
					event: 'setContentId',
					callback: 'recieveContentId'
				}
			});

			this.mode = 'format';
			this.callParent('configure', arguments);
		},

		init: function () {
			this.callParent('init', arguments);

			if (fox.utils.isTouchDevice()) {
				this.embedMobileFormatSwitcher();
			}
		},

		recieveContentId: function (id) {
			this.formatGetMap(id);
		},

		getMapApi: function () {
			var
				api = this.wom1('#mapApi');

			if (!api) {
				api = this.embedWidget('mapApi', 'Api', {
					method: this.getOption('getMapMethod')
				});

				api.run();
			}

			return api;
		},

		formatGetMap: function(id, resCallback, callbackParams) {
			var
				api = this.getMapApi(),
				resIdParamName = this.getOption('resourceIdParamName'),
				apiParams = {mode: this.mode == 'preview' ? 'preview' : 'format'};

			this.setContentId(id);
			this.waitEvent(api, 'success', resCallback || 'formatGetMapApiSuccessHandler', callbackParams || {});

			apiParams[resIdParamName] = this.getContentId();
			api.send(apiParams, this.getOption('jsonizeMapRequest'));
		},

		formatGetMapApiSuccessHandler: function(data) {
			this.preparePlayerData(data.answer.response);
		},

		preparePlayerData: function (map) {
			this.setFormatMap(map).changeFormat(this.getStartFormat());
		},

		getStartFormat: function () {
			if(fox.getEnv('siteProps.settingId')){
			    fox.each(this.getFormatMap().download, function(val) {
			        val.link = val.link + (val.link.indexOf('?') == -1 ? '?' : '%26') + 'settingId=' + fox.getEnv('siteProps.settingId');
			    }, this);
			}

			var format, height = 0;

			if (fox.utils.isTouchDevice() && this.getFormatMap().view[this.MOBILE_DEVICES_START_FORMAT]) {
				return this.setVideoFormat(this.MOBILE_DEVICES_START_FORMAT);
			}

			fox.each(this.getFormatMap().view, function(val, name) {
				var fh = Number(val.height);
				if (!format || (height < fh)) {
					height = fh;
					format = name;
				}
			}, this);
			return this.setVideoFormat(format);
		},

		buildBitrates: function() {
			var bitrates = [];

			fox.each(this.getFormatMap().view, function(val, name) {
				if (val.roles && !fox.inArray(val.roles, this.mode)) {
					return; // means 'continue'
				}
				var clip = 'http://' + this.window.location.host + val.link;
				if (this.getOption('useHash')){
					if (clip.indexOf('publisher_auth=') == -1) {
						clip = clip + (clip.indexOf('?') == -1 ? '?' : '%26') + 'publisher_auth=' + fox.getEnv('siteProps.publisher_auth');
					}
				}
				if(fox.getEnv('siteProps.settingId')){
                    clip = clip + (clip.indexOf('?') == -1 ? '?' : '%26') + 'settingId=' + fox.getEnv('siteProps.settingId');
                }
				var template = {
					'value': val.height + 'p.',
					'isHD': val.hd == 1,
					'onSelect': 'changeFormat1',
					'onSelectArguments': name
				};

				if (this.getOption('dontReloadPlayerOnChangeFormat')) {
					template.onSelect = null;
					template.onSelectArguments = {
						clip: {
							url: clip,
							autoPlay: true,
							provider: 'httpstreaming',
							scale: 'orig'
						}
					};
				}

				if (name === this.getVideoFormat()) {
					template.isActive = true;
				}

				bitrates.push(template);
			}, this);

			this.setBitrates(bitrates);
			return this;
		},

		//only mc-admin feature
		switchMode: function(mode) {
			this.mode = mode == 'preview' ? 'preview' : 'format';
			this.buildBitrates();
			var map = this.getFormatMap().view;
			var bitrates = this.getBitrates();

			switch (this.mode) {
				case 'preview':
					fox.each(map, function(format) {
						format.link = format.link + '/preview';
					});

					fox.each(bitrates, function(item) {
						item.onSelectArguments.clip.url = item.onSelectArguments.clip.url + '/preview';
					});
				break;

				default:
					fox.each(map, function(format) {
						format.link = format.link.replace('\/preview', '');
					});

					fox.each(bitrates, function(item) {
						item.onSelectArguments.clip.url = item.onSelectArguments.clip.url.replace('\/preview', '');
					});
				break;
			}

			return this;
		},

		embedMobileFormatSwitcher: function () {
			this.setOption('widgets.mobileFormatSwitcher', fox.mergeRecursive({
				widget: 'Content_FlashPlayer_MobileFormatSwitcher'
			}, this.getOption('mobileSwitcher')));
		}

	}, 'FlashPlayer2');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
'use strict';
	fox.registerWidget('FlashPlayer2', {
		configure: function (options) {
			this.callParent('configure', arguments);
			this.registerOptions('', {
				container: '#flash-player',
				renderPlayer: true,
				dontReloadPlayerOnChangeFormat: true,
				wmode: "opaque",
				standAloneMode: false,
				videoUrl: false,
				useOriginSize: false,
				useHash: false,
				playerConfig: {
					key: '#$0b7ed803a2f8f6a5142',
					showErrors: false,
					clip: {
						url: false,
						autoPlay: true,
						autoBuffering: true,
						provider: 'httpstreaming',
						scaling: 'fit'
					},
					plugins: {
						httpstreaming: {
							url: 'flowplayer.pseudostreaming-3.2.16.swf',
							queryString: encodeURIComponent('?position=${start}') // position param for prev. CDN
						},
						
						relateds: {
							isWaitForConfig: true // wait for config mode;
						},
						errorslogger: {
							serviceUrl: "http://overload.adultcentro.com/logerror.php",
							overloadMessageShowingMaxAttempts: 3,
							overloadSecondsAmount: 10,
						},
						controls: {
							"timeColor": "#414244",
							"durationColor": "#414244",
							"sliderColor": "#414244",
							"bufferColor": "#FFFFFF",
							"ratesConfig": {
								"backgroundColor": 15856113,
								"textColor": 4276804
							},
							"tooltips": {
								"buttons": true,
								"rates": ""
							},
							"autoHide": {
								"enabled": false
							}
						}
					}
				},
				'handleWom.runPlayer': {
					widget: '@this',
					event: '_changeFormat',
					callback: 'runPlayer'
				}
			});
		},

		init: function () {
			this.visual = !!this.getOption('template');
			this._videoFormat = null;
			this._bitrates = [];
			this._formatMap = {};
			this._contentId = null;

			window.addEventListener('orientationchange', fox.bind(function() {
				var htmlPlayer = $('#video_trailer')[0];

				if(!htmlPlayer || !htmlPlayer.videoWidth && !htmlPlayer.videoHeight) {
					return;
				}

				this.setPlayerSize(htmlPlayer.videoWidth, htmlPlayer.videoHeight, true);
			}, this), false);

			this.callParent('init', arguments);
		},

		

		preparePlayerConfig: function () {
			var clip;

			if (!fox.isEmpty(this.getFormatMap()) && this.getVideoFormat()) {
				clip = 'http://' + this.window.location.host + this.getFormatMap().view[this.getVideoFormat()].link;
			}
			else if (this.getOption('standAloneMode') && this.getOption('videoUrl')) {
				clip = this.getOption('videoUrl');
			}
            if(this.getOption('useHash')){
                if (clip.indexOf('publisher_auth=') === -1) {
                    clip = clip + (clip.indexOf('?') === -1 ? '?' : '%26') + 'publisher_auth=' + fox.getEnv('siteProps').publisher_auth;
                }
            }
            if(fox.getEnv('siteProps.settingId')){
				clip = clip + (clip.indexOf('?') === -1 ? '?' : '%26') + 'settingId=' + fox.getEnv('siteProps.settingId');
			}
			this.setOption('playerConfig', fox.mergeRecursive(this.getOption('playerConfig'), {
				clip: {
					url: clip,
					provider: 'httpstreaming',
					onStart: fox.bind(function () {
						this.window.streamTest = 1;
					}, this),
					onMetaData: fox.bind(this._setPlayerSize, this),
					onResized: fox.bind(this._setPlayerSize, this)
				},
				onError: fox.bind(function () {
					this.window.streamTest = 0;
				}, this),
				onStart: fox.bind(this.onStartPlayerHandler, this)

			}));

			this.setOption('playerConfig.plugins.controls.ratesConfig.values', this.getBitrates());

			if (fox.site.member) {
				this.setOption('playerConfig.plugins.controls', fox.mergeRecursive(this.getOption('playerConfig.plugins.controls'), {
					timelineThumbsSprite: this.getOption('disableTimeline') === true ? false : 'http://cdn-small.storage.adultcentro.com/' + this.getContentId() + '/thumb/timeline/sprite/w135i',
					timelineThumbBackgroundColor: this.getOption('playerConfig.plugins.controls.timelineThumbBackgroundColor') || '#F1F1F1',
					timelineThumbTextColor: this.getOption('playerConfig.plugins.controls.timelineThumbTextColor') || '#414244'
				}));
				if(!this.getOption('videoUrl') && this.getFormatMap().view[this.getVideoFormat()].preview === 1) {
					this.setOption('playerConfig.plugins.images.onFinish', {
						url: this.getOption('onFinishPlayerImage') || fox.getEnv('design.url') + '/images/customplayer.png',
						y: 'center',
						x: 'center',
						'goto': encodeURIComponent(this.getOption('onFinishPlayerUrl') || fox.getEnv('siteProps.ubs.joinUrl')),
						isProportionalScaling: true
					});
				}
			} else {

				if (!!fox.getEnv('siteProps.previewsDisabled') && fox.getEnv('siteProps.previewsDisabled') === 1) {
					this.setOption('stub', true);
					return;
				}

				this.setOption('playerConfig.plugins.images.onPause', {
						url: this.getOption('onPausePlayerImage'),
						y: 'center',
						x: 'center',
						'goto': encodeURIComponent(fox.getEnv('siteProps.ubs.joinUrl')) || '/join'
				});

				if (fox.getEnv('siteProps.perUserPreviewsCountLimit') && fox.getEnv('siteProps.perUserPreviewsCountLimit') !== 0) {
					this.setOption('playerConfig.plugins.controls.limit', {
						max: fox.getEnv('siteProps.perUserPreviewsCountLimit'),
						imageProperties: {
							url: encodeURIComponent(fox.getEnv('design.url')) + '/images/' + fox.getEnv('siteProps.currentOrientation') + '.jpg',
							'goto': encodeURIComponent(fox.getEnv('siteProps.ubs.joinUrl')),
							'window': '_parent',
							y: 'center',
							x: 'center'
						},
						labelProperties: {
							textColor: 0xffffff,
							text: ' free',
							x: 214,
							y: 26
						}
					});
				} else {
					this.setOption('playerConfig.plugins.images.onFinish', {
						url: this.getOption('onFinishPlayerImage') || this.getOption('onPausePlayerImage'),
						y: 'center',
						x: 'center',
						'goto': encodeURIComponent(fox.getEnv('siteProps.ubs.joinUrl')) || '/join'
					});
				}
			}

			return this;
		},

		setPlayerSize: function (wSize, hSize, hideToolbar) {
			var playerWidth;
			var playerHeight;

			var playerContainer = this.getPlayerContainer();
			
			playerWidth = playerContainer && playerContainer.clientWidth;
			
			if(playerWidth === 0) return;
			
			if (this.getOption('useOriginSize')) {
				playerHeight = hSize;
			} else {
				playerHeight = (playerWidth * hSize) / wSize;
			}

			playerHeight = hideToolbar ? playerHeight : (playerHeight += this.getOption('playerConfig.toolbarHeight') || 30);

			if (this.getOption('maxPlayerHeight') && this.getOption('maxPlayerHeight') < playerHeight) {
				playerHeight = 885;
			}

			$(this.getPlayerContainer()).height(playerHeight);
			
			return this;
		},

		_setPlayerSize: function (value) {
			var w, h;

			w = value.metaData.width;
			h = value.metaData.height;

			this.setAspectRatio(w, h);

			if (this.getOption('useOriginSize')) {
				w = $(this.getPlayerContainer()).width();
				h = this._calculateOriginHeight(w, value.metaData);
			}

			this.setPlayerSize(w, h, this.getOption('standAloneMode'));
		},

		_calculateOriginHeight: function (containerWidth, metaData) {
			var aspect = (metaData.width/metaData.height);

			return containerWidth/aspect;
		},

		getPlayerContainer: function() {
			if (this.visual) {
				this.playerContainer = this.rdom1(this.requireOption('renderTo'));
			} else {
				this.playerContainer = fox.dom.selectFirst(this.requireOption('container'));
			}

			if (!this.playerContainer) {
				return false;
			}

			if (!this.playerContainer.getAttribute('id')) {
				this.playerContainer.setAttribute('id', fox.uniqid('flashPlayer'));
			}

			return this.playerContainer;
		},

		embedPlayer: function() {
			if (!this.getPlayerContainer()) {
				return;
			}

			if (!!this.getOption('stub')) {
				$(this.options.container).html(fox.Zen(fox.getTemplate('playerStub')));
				return;
			}

			var version = window.swfobject.getFlashPlayerVersion(), hSize, wSize, videoFormat;

			if(this.getVideoFormat() && !fox.isEmpty(this.getFormatMap())){
				videoFormat = this.getFormatMap().view[this.getVideoFormat()].format;
			}

			if (videoFormat === 2) {
				hSize = 720;
				wSize = 1280;
			} else if (this.getOption('useContainerSizeOnInit') === true) {
				var c = this.getPlayerContainer();

				hSize = $(c).height();
				wSize = $(c).width();
			} else {
				hSize = 480;
				wSize = 640;
			}
			if (version.major > 0) {
				this.setPlayerSize(wSize, hSize, false);
				this.createFlashPlayer();
				return;
			}
			if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {
				this.createHtmlPlayer(hSize, true);
			} else {
				this.createHtmlPlayer(hSize);
			}
			
		},

		createFlashPlayer: function () {
			this.window.flowplayer(
				this.getOption('domNodeContainerLink') === true ? this.getPlayerContainer() : this.getPlayerContainer().getAttribute('id'),
				{
					src: fox._isNewFe ? __webpack_require__(446) : (fox.getEnv('design.url') + "/flash/flowplayer.commercial-3.2.16.swf"),
					wmode: this.getOption('wmode')
				},
				this.getOption('playerConfig')
			);
		},

		createHtmlPlayer: function (hSize, ios) {
			var 
				container = $(this.getPlayerContainer()),
				player = $('#video_trailer', container),
				htmlPlayer = document.createElement('video'),
				source = document.createElement('source');

			htmlPlayer.id = 'video_trailer';
			htmlPlayer.style.width = htmlPlayer.style.height = '100%';
			htmlPlayer.poster = (this.getOption('playerConfig.plugins.images.onBegin.url')) ? decodeURIComponent(this.getOption('playerConfig.plugins.images.onBegin.url')) : 'http://cdn-small.nl.storage.adultcentro.com/' + this.getContentId() + '/thumb/primary/h'+ hSize +'i';
			htmlPlayer.controls = true;

			if (this.getOption('playerConfig.clip.autoPlay') === true) {
				htmlPlayer.autoplay = true;
			}

			source.type= 'video/mp4';
			source.src = decodeURIComponent(this.getOption('playerConfig.clip.url'));

			//console.log(source.src);
			
			fox.dom.on('loadedmetadata', htmlPlayer, fox.bind(function(){
				if (htmlPlayer.videoWidth && htmlPlayer.videoHeight) {
					this.setPlayerSize(htmlPlayer.videoWidth, htmlPlayer.videoHeight, true);
				}
			}, this));
			fox.dom.on('canplaythrough', htmlPlayer, fox.bind(function(){
				/* for iOS devices
				if video reaches buffer it's stops plaing
				try to fix this
				*/
				htmlPlayer.play();
			}, this));

			fox.dom.on('play', htmlPlayer, fox.bind(function(){
				this.dispatchEvent('player.play');
			}, this));
			fox.dom.on('pause', htmlPlayer, fox.bind(function(){
				this.dispatchEvent('player.pause');
			}, this));

			htmlPlayer.appendChild(source);

			if (ios === true) {
				var 
					imgWrapper = $('<div>').addClass('virt-player').css('zIndex', 1),
					image = $('<img>');

				if (imgWrapper.css('position') === 'static') {
					imgWrapper.css('position', 'relative');
				}

				container.html('');
				player = [];

				image.attr('src', htmlPlayer.poster).appendTo(imgWrapper.appendTo(container));

				if (this.getOption('standAloneMode')) {
					image.bind('error', fox.bind(function (e) {
						this.hookWrapper('bannerLoadError', {e: e});
					}, this));
				}

				$(htmlPlayer).css({
					opacity: 1,
					position: 'absolute',
					width: '100%',
					height: 'auto',
					left: 0,
					top: 0,
					zIndex: 3
				});

				container.css('position', 'relative');
			}

			if (player.length) {
				player.replaceWith(htmlPlayer);
				return;
			}

			container.append(htmlPlayer);
		}, 

		runPlayer: function() {
			if (this.getOption('renderPlayer')) {
				this.preparePlayerConfig();

				if (this.getOption('contentWidget')) {
					this.handleEvent(this.getOption('contentWidget'), 'addedToDom', fox.bind(this.embedPlayer, this));
				} else {
					setTimeout(fox.bind(this.embedPlayer, this), 100);
				}
			}
		},

		changeFormat: function(format) {
			this.setVideoFormat(format);
			this.buildBitrates().dispatchEvent('_changeFormat');
			return this;
		},

		buildBitrates: function() {
			var tempBitrates = [];
			fox.each(this.getFormatMap().view, function(val, name) {
				if (typeof(val.hd) !== 'undefined') {
					var template = {
						"value": val.height + "p.",
						"isHD": ((val.hd === 1) ? true : false),
						"onSelect": "changeFormat1",
						"onSelectArguments": name
					};

					if (this.getOption('dontReloadPlayerOnChangeFormat')) {
						template.onSelect = null;
						template.onSelectArguments = {
							clip: {
								url: decodeURIComponent('http://' + this.window.location.host + val.link),
								autoPlay: true,
								provider: 'httpstreaming',
								scale: 'orig'
							}
						};
					}

					if (name === this.getVideoFormat()) {
						template.isActive = true;
					}

					tempBitrates.push(template);
				}
			}, this);

			this.setBitrates(tempBitrates);
			return this;
		},

		onStartPlayerHandler: function (h) {
			switch (h.metaData.height) {
				case 1080:
					this.setVideoFormat('hd' + h.metaData.height);
				break;

				case 720:
					this.setVideoFormat('hd' + h.metaData.height);
				break;

				case 480:
					this.setVideoFormat('ipod');
				break;

				case 240: 
					this.setVideoFormat('ipod3g');
				break;
			}

			this.dispatchEvent('playerRunning', {
				format: this.getVideoFormat(),
				downloaded: !!this.getFormatMap().download
			});
		},

		bannerLoadError: function (ev) {},

		setVideoFormat: function(value) {
			this._videoInfo = value;
			return value;
		},

		getVideoFormat: function() {
			return this._videoInfo;
		},

		setFormatMap: function(value) {
			this._formatMap = value;
			return this;
		},

		getFormatMap: function() {
			return this._formatMap;
		},

		setBitrates: function(value) {
			this._bitrates = value;
		},

		getBitrates: function() {
			return this._bitrates;
		},

		setContentId: function(value) {
			this._contentId = value;
		},

		getContentId: function() {
			return this._contentId;
		},

		setAspectRatio: function (w, h) {
			this._aspectRatio = w/h;
		},

		getAspectRatio: function (w, h) {
			return this._aspectRatio;
		}

	}, 'Widget');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/flowplayer.commercial-3.2.16.swf", __webpack_require__.p + "_/_/_/_/publisher/flash/flowplayer.commercial-3.2.16.swf");

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Content_FlashPlayer_MobileFormatSwitcher', {
		configure: function () {
			this._isOpened = false;

			this.registerOptions('', {
				autoRender: false,
				embed: {
					widget: '@parent @parent #currentScene #list',
					container: '.mobile-switcher'
				},
				template: 'player_mobile_format_switcher',

				handleWom: {
					changeFormat: {
						widget: '@parent',
						event: '_changeFormat',
						callback: '_prepareFormatsList'
					},
					formatsDataReady: {
						widget: '@this',
						event: 'formatsDataReady',
						callback: '_handleFormatsReadyStatus'
					},

					play: {
						widget: '@parent',
						event: 'player.play',
						callback: '_onPlay'
					},

					pause: {
						widget: '@parent',
						event: 'player.pause',
						callback: '_onPause'
					}
				},

				handleDom: {
					switchFormat: {
						target: '[data-format-alias]',
						event: 'click',
						callback: '_switchFormat'
					},
					toggle: {
						target: '.mc-mobile-format-switcher',
						event: 'click',
						callback: 'toggleList'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.player = this.wom1('@parent');

			$(window).on('click', {w: this}, this._hideList);

			this.callParent('running', arguments);
		},

		activate: function () {
			$(window).on('click', {w: this}, this._hideList);

			this.callParent('activate', arguments);
		},

		deactivate: function () {
			$(window).off('click', this._hideList);
			this.callParent('deactivate', arguments);
		},

		_prepareFormatsList: function () {
			this.formatsData = {
				current: null,
				list: []
			};

			var formats = this.getFormats();
			var current = this.getCurrentFormat();

			fox.each(formats, function (format, name) {
				if (name == current) {
					this.formatsData.current = format;

					return;
				}
				format.alias = name;
				this.formatsData.list.push(format);
			}, this);

			this.dispatchEvent('formatsDataReady');
		},

		_handleFormatsReadyStatus: function () {
			if (fox.count(this.formatsData.list) > 0) {
				this.setOption('templateOptions.formatsData', this.formatsData);
				this.render();

				return;
			}

			this.removeFromDom();
		},

		getFormats: function () {
			return this.player.getFormatMap().view;
		},

		getCurrentFormat: function () {
			return this.player.getVideoFormat();
		},

		_switchFormat: function (el, alias, w, e) {
			this.switchFormat(fox.dom.wrap(el).attr('data-format-alias'));
			this.closeList();
		},

		switchFormat: function (format) {
			this.player.changeFormat(format);
		},

		toggleList: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			if (this._isOpened) {
				this.closeList();

				return;
			}

			this.openList();
		},

		openList: function () {
			fox.dom.addClass('opened', this.dom1('.mc-mobile-format-switcher'));
			this._isOpened = true;
		},

		closeList: function () {
			fox.dom.removeClass('opened', this.dom1('.mc-mobile-format-switcher'));
			this._isOpened = false;
		},

		_hideList: function (e) {
			e.stopPropagation();
			e.data.w.closeList();
		},

		_onPlay: function () {
			if (this.element) {
				fox.dom.addClass('hide', this.element[0]);
			}
			
		},

		_onPause: function () {
			if (this.element) {
				fox.dom.removeClass('hide', this.element[0]);
			}
			
		}

	}, 'Widget');
})(fox);


 /* fox-dynamic-injection */ 
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Content_SceneViewer', {
		configure: function(options) {
			this.registerOptions('', {
				useCollectionId: true,
				widgets: {
					sceneDl: {
						widget: 'Datalayer',
						limit: 1
					},

					currentScene: {
						widget: 'Content_Browser',
						container: '#scenes-player',
						dataLayer: '@parent #sceneDl',
						externalLoad: true,
						preset: 'search',
						list: {
							manualRender: true,
							'tpl.row': 'sitepage_scene_playerBlock',
							handleDom: {
								downloadLinks: {
									target: '.toggleDownloads',
									'event': 'click',
									callback: '@parent @parent:downloadLinksToggle'
								},
								modelsMore: {
									target: '.model-toggle',
									'event': 'click',
									callback: '@parent @parent:modelsMore'
								},
								decriptionToggle: {
									target: '.desc-toggle',
									'event': 'click',
									callback: '@parent @parent:decriptionToggle'
								}
							}
						}
					},

					flashPlayer: {
						widget: 'Content_FlashPlayer',
						contentWidget: '@parent #currentScene #list',
						'handleWom.recieveContentId.widget': '@parent',
						jsonizeMapRequest: false,
						onPausePlayerImage: this.getBannerSrc()
					},

					currentRating: {
						widget: 'Social_Rating',
						targetDl: '@parent #sceneDl',
						targetField: 'id',
						'embed.widget': '@parent #currentScene #list'
					},

					sceneComments: {
						//showComments: false,
						widget: 'Social_Comments',
						targetDl: '@parent #sceneDl',
						template: 'social_comment_scene',
						'embed.widget': '@parent #currentScene #list',
						'handleDom.toggleForm': {
							targetWidget: '@parent #currentScene #list'
						}
					},

					relatedContent: {
						widget: 'Content_Related'
					}
				},

				handleWom: {
					'navigator': {
						'event': 'modified_1',
						widget: fox.Navigator,
						callback: '_preRunScene',
						'params.listenHistory': true,
						'params.alwaysActive': true
					},

					scrollToPlayer: {
						'event': 'loaded',
						widget: '#sceneDl',
						callback: 'scrollToPlayer',
						'params.prefix': 'scrollToPlayer'
					}
				}
			});
			
			if (fox.site.member) {
				this.registerOptions('', {
					widgets: {
						favorite: {
							widget: 'Social_Favorite',
							targetDl: '@parent #sceneDl',
							targetField: 'id',
							'embed.widget': '@parent #currentScene #list'
						}
					}
				});
			}
			this.callParent('configure', arguments);
		},

		scrollToPlayer: function() {
			var $player = $(this.rwom1('#flashPlayer').getPlayerContainer());

			function scroll ($player) {
				$('body, html').animate({
					scrollTop: $player.offset().top - 50
				}, 500);
			}

			if($player.length){
				scroll($player);
			} else {
				this.wait('#flashPlayer', 'playerRunning').then(function () {
					scroll($(this.rwom1('#flashPlayer').getPlayerContainer()));
				}.bind(this));
			}
		},

		setTitle: function() {
			var metaDescription = fox.dom.selectFirst('meta[name="description"]');
			var parseTitle = fox.Navigator.get(2) ? decodeURIComponent(fox.Navigator.get(2).replace(/-/g, ' ')) : '';

			//document.title = parseTitle + ' - Sex Movies Featuring ' + fox.getEnv('screenName');

			if(!metaDescription.content.length){
				metaDescription.setAttribute('content', 'Watch ' + fox.getEnv('screenName') + ' Best Porn Videos in HD. Free movies ' + parseTitle + '.');
			}
			this.wom1('#downloadButton').render();
		},

		modelsMore: function() {
			$('#cast-list').toggleClass('show');
		},

		decriptionToggle: function() {
			$('.description').toggleClass('show');
		},

		toggleComments: function() {
			$('.reviews-actions-block').toggle();
		},

		init: function() {
			return this.callParent('init', arguments);
		},

		running: function (argument) {
			this._attacheGlobalWindowEvents();

			this.callParent('running', arguments);
		},

		activate: function() {
			//this.rwom1('#currentScene #list')._readyToEmbed = false;
			this.callParent('activate', arguments);
			this.dispatchEvent('activateSceneViewer');

			this._attacheGlobalWindowEvents();
		},

		deactivate: function () {
			this._detacheGlobalWindowEvents();

			this.callParent('deactivate', arguments);
		},

		_preRunScene: function(id) {

			this.contentId = id;
			//this.setTitle();
			
			if (this.isActive()) {
				this.runScene();
			}

			this.waitEvent(this, 'activateSceneViewer', 'runScene');

		},

		runScene: function () {
			this.sceneDl = this.requireEmbeddedWidget('sceneDl');

			this.sceneDl.addFilter('id', ['id'], [this.contentId]).load();
			
			if (this.getOption('useCollectionId')) {
				this.handleEvent(this.sceneDl, 'loaded', fox.bind(function () {
					this.rwom1('#otherScenes').setCollectionId(this.sceneDl.getObjectRelation('collectionId').getObjectValue('id'));
					this.dispatchEvent('setContentId', this.contentId);
				}, this));
			} else {
				this.dispatchEvent('setContentId', this.contentId);
			}
		},

		getBannerSrc: function () {
			var orientations = {'straight':'1', 'gay':'2','shemale':'3'};
			var orient = fox.getEnv('siteProps.channelSets.current') || fox.getEnv('siteProps.defaultOrientation');
			
			if (orientations[orient]) {
				return fox._isNewFe ?
					!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../images\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()) :
					(fox.getEnv('design.url') + '/images/player_banner' + orientations[orient] + '.png');
			}

			return fox._isNewFe ? __webpack_require__(29) : (fox.getEnv('design.url') + '/images/player_banner.png');
		},

		downloadLinksToggle: function(elt, alias, w, e) {
			if (e.canceBubble) {
				e.canceBubble = true;
			} else if (e.stopPropagation) {
				e.stopPropagation();
			}

			elt = $(elt);
			// var container = this.rwom1('#downloadLinks').getOption('container');

			// w = ($(container).width()/2)-($(elt).width()/2);

			// $(elt).toggleClass('active');
			// $(container).css({'margin-left':'-' + w + 'px' });
			// $(container).toggleClass('active');

			if (elt.hasClass('active')) {
				this._closeDownloadBlock();
			} else {
				this._openDownloadBlock();
			}
		},

		_attacheGlobalWindowEvents: function (argument) {
			$(document).on('click', {widget: this}, this._closeDownloadBlock);
			$(document).on('keyup', {widget: this}, this._closeOnEsc);
		},

		_detacheGlobalWindowEvents: function (argument) {
			$(document).off('click', this._closeDownloadBlock);
			$(document).off('keyup', this._closeOnEsc);
		},

		_openDownloadBlock: function (el, w, alias, e) {
			this.hookWrapper('openDownloadBlock');
		},

		openDownloadBlock: function () {
			var elt = $('.toggleDownloads');
			var container = this.rwom1('#downloadLinks').getOption('container');
			var w = ($(container).width()/2)-($(elt).width()/2);

			$(elt).addClass('active');
			$(container).css({'margin-left':'-' + w + 'px' });
			$(container).addClass('active');
		},

		_closeDownloadBlock: function (e) {

			if (fox.objectGet(e, 'data.widget')) {
				e.data.widget.hookWrapper('closeDownloadBlock');
				
				return;
			}

			this.hookWrapper('closeDownloadBlock');
		},

		closeDownloadBlock: function () {
			var elt = $('.toggleDownloads');
			var container = this.rwom1('#downloadLinks').getOption('container');

			$(elt).removeClass('active');
			$(container).removeClass('active');
		},

		_closeOnEsc: function (e) {
			if (e.keyCode === 27) {
				e.data.widget._closeDownloadBlock(e);
			}
		},

		getContentId: function () {
			return this.contentId;
		}

	}, 'Controller');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 449 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 449;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, undefined) {
	'use strict';
	fox.registerWidget('Social_Favorite', {
		
		configure: function() {
			this.registerOptions('', {
				'handleDom.toggle': {
					event: 'click',
					target: '.bookmark',
					callback: fox.bind(this.saveDomHandler, this),
				},
				subject: 'content',
				template: 'social_favorite',
				container: '.bookmark',
				'methods.load': 'social.favorite.load',
				'methods.save': 'social.favorite.save'
			});

			this.callParent('configure', arguments);
		},

		saveDomHandler: function(elt) {
			var 
				targetId = 
					parseInt(elt.getAttribute('data-target-id')) || 
					parseInt(elt.parentNode.getAttribute('data-target-id'));
			
			this.save(targetId);
		},

		save: function(targetId) {
			if(this.data[targetId] !== undefined){
				this.data[targetId].isFavorite = this.data[targetId].isFavorite ? 0 : 1;
			}

			this.render();

			this.getApi('save').send({
				targetId: targetId, 
				isHidePreloader: true,
				subject: this.getOption('subject')
			}, false);
		}

	}, 'Social_Activity');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, undefined) {
	'use strict';
	var _ = {
		getApi: function (alias, apiConf) {
			var 
				def = {method: this.getOption(['methods', alias].join('.'))},
				w = this.wom1(['#api', fox.ucfirst(alias)].join(''));

			if (apiConf === undefined) {
				apiConf = fox.clone(def);
			} else {
				apiConf = fox.merge(def, apiConf);
			}

			if (!w) {
				w = this.embedWidget(['api', fox.ucfirst(alias)].join(''), 'Api', apiConf);

				if (!w.isRun()) {
					w.run();
				}
			}

			return w;
		}
	};

	fox.registerWidget('Social_Activity', {

		getApi: function () {
			return _.getApi.apply(this, arguments);
		},

		configure: function() {
			this.registerOptions('', {
				subject: 'content'
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.data = {};

			if (this.getOption('targetDl')) {
				this.handleEvent(this.getOption('targetDl'), 'loaded', 'targetDlLoaded');
			}
			return this.callParent('init', arguments);
		},

		//instead running
		loadData: function() {
			if (fox.isEmpty(this.targetIds)) {
				fox.log('targetIds are empty. Load skipped');
				return;
			}

			var api = this.getApi('load');

			this.handleEvent(api, 'ready', '_loaded');
			api.send(this.getLoadParams(), false);
		},

		getLoadParams: function() {
			return {'ids': this.targetIds, 'subject': this.requireOption('subject')};
		},

		_loaded: function(response) {
			this.data = this.prepareData(response);
			this.render();
		},

		prepareData: function(data) {
			fox.each(data, this.prepareDataItem, this);

			return data;
		},

		prepareDataItem: function(item, targetId) {
			if (targetId) {
				item.targetId = parseInt(targetId);
			}
			return item;
		},

		rendering: function() {
			if (fox._isNewfe) {
				this.fragment = this.getTemplater().setData([fox.mixin(this.data[this.currentTargetId] || {}, this.getTemplateOptions() || {})]).compile();
			} else {
				this.fragment = fox.Zen(this.options.template, [this.data[this.currentTargetId] || {}]);
			}
			this.currentTargetId = null;
		},

		embedding: function() {
			this.element = [];
			var containers = fox.dom.select(this.requireOption('embed.container'), this.visualParent.element);
			fox.each(containers, function(container) {
				if (!!this.getOption('targetDl') && !!this.getOption('targetField')) {
					var dl = this.wom1(this.getOption('targetDl'));
					fox.each(dl.getCollection(), function (obj) {
						this.currentTargetId = fox.objectGet(obj, this.getOption('targetField'));
					}, this);
				} else {
					this.currentTargetId = container.getAttribute('data-target-id');
				}
				this._render(true);
				this.embedToDom(container, this.fragment);
			}, this);
			this._rendered = false;
		},

		setTargetIds: function(ids) {
			this.targetIds = ids;
			this.dispatchEvent('targetUpdated', ids);
			this.loadData();
		},

		targetDlLoaded: function(params, dl) {
			var obj, ids = [];
			
			fox.each(dl.getCollection(), function (obj) {
				ids.push(fox.objectGet(obj, this.getOption('targetField') || 'id'));
			}, this);
			
			this.setTargetIds(ids);
		},

		prepareCollection: function() {}

	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	fox.registerWidget('Social_Comments', {
		configure: function(options) {
			this.registerOptions('', {
				'showComments': false,
				'template': 'social_comments_block',
				'embed.container': '.reviews',
				'methods.load': 'social.comments.count',
				'methods.loadComments': 'social.comments.load',
				'methods.delete': 'social.comments.delete',
				'methods.post': 'social.comments.post',
				'handleDom.toggleForm': {
					event: 'click',
					target: '.toggleForm',
					callback: 'toggleHandler'
				},
				'handleDom.delete': {
					event: 'click',
					target: '.comment-delete',
					targetWidget: '.Grid #list',
					callback: 'deleteCommentHandler'
				}//,
				//'widgetGroupInfo.workers.manualActivation': 1
			}, false, 'comments.js');

			this.registerOptions('.Grid', {
				'list.tpl.row': 'social_comment',
				'list.container': '.reviews-list',
				'template': 'social_comments_grid',
				'container': '._reviews',
				'externalLoad': true
			}, false, 'comments.js');


			this.registerOptions('~#form', {
				'formElements.comment.element': '[name=comment]',
				'submit.target': '.add-review',
				'submit.event': 'submit'
			});


			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('.Social_Comments_Form', fox.mergeRecursive({
				'template': 'social_comments_addform',
				'embed.container': '.addreview-container',
			}, this.getOption('formOptions')), false, 'comments.js');
		
			this.callParent('init', arguments);
		},

		embedding: function() {
			this.element = [];
			var containers = fox.dom.select(this.requireOption('embed.container'), this.visualParent.element);
			fox.each(containers, function(container) {
				this.currentTargetId = container.getAttribute('data-target-id');
				this._render(true);
				this.embedToDom(container, this.fragment);
			}, this);
			this._rendered = false;
		},

		getDlForGrid: function (indx) {
			var dl = this.wom1(['#gridDl', indx].join('_'));

			if (!dl) {
				dl = this.embedWidget(['gridDl', indx].join('_'), 'Datalayer', {
						method: this.requireOption('methods.loadComments'),
						limit: this.getOption('dlLimit') || 10
				});

				dl.run();
			}

			return dl;
		},

		prepareData: function(data) {
			data = this.callParent('prepareData', arguments);
			var i = 0;
			this.consist = {};
			fox.each(data, function(data, id) {
				this.consist[id] = i;
				var grid, form, dl;
				if (!(grid = this.getEmbeddedWidget('grid_' + i))) {
					grid = this.embedWidget('grid_' + i, 'Grid', {
						dl: this.getDlForGrid(i)
					});

					grid.run();
				}

				grid.dl.setTransitParameter('targetId', id);
				
				if (this.getOption('subject')) {
					grid.dl.setTransitParameter('subject', this.getOption('subject'));
				}

				if (this.getOption('skipParentId')) {
					grid.dl.setTransitParameter('skipParentId', this.getOption('skipParentId'));
				}

				grid.dl.clearCollection();

				if (this.getOption('showComments')) {
					this.loadComments(id);
				}
				
				if (!(form = this.getEmbeddedWidget('form_' + i))) {
					form = this.embedWidget('form_' + i, 'Social_Comments_Form');
					form.run();
				}
				form.setOption('targetId', id);
				
				i++;
			}, this);
			return data;
		},

		toggleHandler: function(elt) {
			var targetId = elt.getAttribute('data-target-id');
			this.loadComments(targetId);

			var el = fox.dom.selectFirst('.reviews-actions-block', this.element);

			if (this.data[targetId].show) {
				fox.dom.removeClass('show-reviews', el);
				this.data[targetId].show = 0;
			} else {
				this.data[targetId].show = 1;
				fox.dom.addClass('show-reviews', el);
			}
		},

		deleteCommentHandler: function(elt) {
			var targetId = elt.getAttribute('data-target-id');
			var id = elt.getAttribute('data-iteration');
			this.deleteComment(targetId, id);
		},

		deleteComment: function(targetId, id) {
			var dl = this.requireEmbeddedWidget('grid_' + this.consist[targetId]).dl;
			var row = dl.extractObjectByIndex(id - 1);
			this.data[targetId].total = this.data[targetId].total && (this.data[targetId].total - 1);
			this.render();

			if (row.id) {
				this.getApi('delete').method(this.requireOption('methods.delete')).send(
					{targetId: targetId, id: row.id, isHidePreloader: true}, false
				);
			} else {
				this.getApi('delete').method(this.requireOption('methods.delete')).send(
					{targetId: targetId, obj: JSON.stringify(row), isHidePreloader: true}, false
				);
			}
		},

		addComment: function(obj) {
			if(!fox.trim(obj.comment).length) {
				$('textarea').addClass('warning');
				return;
			}
			$('textarea').removeClass('warning');
			var dl = this.requireEmbeddedWidget('grid_' + this.consist[obj.targetId]).dl;
			var collectionToArray = dl.setCollection(fox.toArray(dl.getCollection()));
			dl.addObject(fox.clone(obj, true), {top: true});
			this.data[obj.targetId].total = this.data[obj.targetId].total + 1;
			this.render();

			var apiData = {
				targetId: obj.targetId,
				comment: window.encodeURIComponent(this.changeInalidValue(obj.comment)),
				isHidePreloader: true
			};

			if (this.getOption('subject')) {
				apiData.subject = this.getOption('subject');
			}

			return this.getApi('post', {sendTimezone: true, httpMethod: 'post'}).send(apiData);
		},

		loadComments: function(targetId) {
			this.requireEmbeddedWidget('grid_' + this.consist[targetId]).dl.load(true);
		},
		changeInalidValue: function (params) {
			var regExps = /<\s*[^>]*>/g;
			var entities = {'<': '', '>': ''};
			if(regExps.test(params)){
				params = params.replace(/[<>]/g, function (s) {return entities[s];});
			}
			return 	params;
		},

	}, 'Social_Activity');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Social_Comments_Form', {
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				handleDom: {
					bindSubmitHandler: {
						target: 'textarea',
						event: 'focus',
						callback: '_bindSubmitHandler'
					},
					unbindSubmitHandler: {
						target: 'textarea',
						event: 'blur',
						callback: '_unbindSubmitHandler'
					}
				}
			});
			return this.callParent('configure', arguments);
		},

		init: function() {
			this.embedWidget('form', 'Form', {
				'hooks.onSubmit': fox.bind(this.submit, this),
			});

			return this.callParent('init', arguments);
		},

		submit: function(obj) {
			var date = new Date();

			obj.userId = fox.site.member.getObjectValue('id');
			obj.name = fox.site.member.getObjectValue('login');

			obj.date = fox.utils.dateFormat('%Y-%m-%d %I:%M:%S %p', new Date());
			obj.targetId = this.requireOption('targetId');
			this.getParent().addComment(obj);
		},

		_bindSubmitHandler: function (el) {
			$(el).on('keyup', {widget: this}, this._kbSubmitHandler)
		},

		_unbindSubmitHandler: function (el) {
			$(el).off('keyup', this._kbSubmitHandler)
		},

		_kbSubmitHandler: function (e) {
			if (e.keyCode == 13 && e.ctrlKey) {
				e.data.widget.rwom1('#form')._submit();
			}
		}

	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	fox.registerWidget('Social_Rating', {
		configure: function() {
			this.registerOptions('', {
				'handleDom.rate': {
					event: 'click',
					target: '.rate',
					callback: 'rateDomHandler'
				},
				template: 'social_rating',
				container: '.rating',
				'methods.load': 'social.rater.load',
				'methods.rate': 'social.rater.rate'
			});

			this.callParent('configure', arguments);
		},

		rateDomHandler: function(elt) {
			var targetId = parseInt(elt.getAttribute('data-target-id'));
			var value = parseInt(elt.getAttribute('data-value'));
			this.rate(targetId, value);
		},

		rate: function(targetId, value) {
			var info = this.prepareDataItem(this.data[targetId], targetId);

			value = Number(value);

			if (fox.isSet(info.currentMemberRating)) {
				if (info.currentMemberRating === value) {
					return;
				} else {
					info.rating = info.rating - info.currentMemberRating + value;
					info.currentMemberRating = value;
				}
			} else {
				info.rating = info.rating + value;
				info.voters++;
				info.currentMemberRating = value;
			}

			this.data[targetId] = this.prepareDataItem(info, targetId);
			this.render();

			var apiData = {
				targetId: targetId,
				value: value,
				isHidePreloader: true,
				subject: this.getOption('subject')
			};

			return this.getApi('rate').send(apiData, false);
		},

		prepareDataItem: function(item, targetId) {
			item.good = Math.floor(item.rating / 5) || 0;
			item.bad = Math.floor(item.voters - item.good) || 0;
			item.total = item.good - item.bad;
			return this.callParent('prepareDataItem', arguments);
		}

	}, 'Social_Activity');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// JQTimer Widget

(function (fox) {

	fox.registerWidget('JQTimer', {

		configure: function (options) {
			this.registerOptions('', {
				counterWrapperId: '#counter',
				skipPreloader: true,
				dontReuseSn: true,
				initial: "00:00:30:00",
		        direction: 'down',
		        format: "99:23:59:59",
		        interval: 1000,
		        stop: "00:00:00:00",
				'handleWom.timerStopHandler': {
					widget: '@this',
					event: 'timerStop',
					callback: 'timerStopHandler'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this._counterOptions = {};

			this
				.setOption('template', 'span' + this.getOption('counterWrapperId'))
				.prepareCounterOptions();

			this.callParent('init', arguments);
		},

		afterEmbed: function () {
			this._counter = this.initCounter();

			if (this.hook === true) {
				this.counterStop();
				this.counterReset();
			}
			
			this.callParent('afterEmbed', arguments);
		},

		initCounter: function () {
			return $(this.dom1(this.getOption('counterWrapperId')))
					.counter(this._counterOptions)
					.on('counterStop', fox.bind(function () {
						this.dispatchEvent('timerStop');
					}, this));
		},

		prepareCounterOptions: function () {
			var neededCounterOptions = ['initial', 'direction', 'format', 'interval', 'stop'];

			for (var i = neededCounterOptions.length; i--;) {
				this._counterOptions[neededCounterOptions[i]] = this.getOption(neededCounterOptions[i]);
			}
		},

		timerStopHandler: function () {
			// console.log('Timer Stop')
		},

		counterStop: function () {
			this._counter.counter('stop');

			return this;
		},

		counterStart: function (remTime) {
			var remDays, fArr;
			
			if (remTime){
				if ((remDays = remTime.split(':').shift()).length > 2) {
					fArr = this._counterOptions.format.split(':');
					fArr[0] = remDays.split('').map(function () {return 9;}).join('');

					this._counterOptions.format = fArr.join(':');
				}

				this._counterOptions.initial = remTime;
				this.embed();
			}
			else if (this._counter) {
				this._counter.counter('play');
			}

			return this;
		},

		counterReset: function () {
			this._counter.counter('reset');

			return this;
		}

	}, 'Widget');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Join_Form', {
		configure: function() {
			this.callParent('configure', arguments);
			this.registerOptions('', {
				autoRender: true,
				optionsBy: 'groupId', //any other value mean optionId (settings.id)
				totalContentAllowed: false,
				widgets: {
					totalApi: {
						widget: 'Api',
						method: 'site.totalPublished',
						cacheChannel: 'content'
					},
					joinOptions: {
						widget: 'List'
					},
					errors: {
						widget: 'List',
						tpl: {
							row: 'sitepage_join_form_error_row'
						},
						container: '#join-form-errors',
						autoRender: false
					},
					form: {
						widget: 'DomForm',
						validateOnFly: true,
						elements: {
							joinOptions: {
								womContainer: '@parent #joinOptions'
							}
						},
						handleWom: {
							formvalidate: {
								event: 'form_not_valid',
								widget: '@this',
								callback: function (infos) {
									var obj = {answer: {data: {}}};
									var s = obj.answer.data;

									infos.reverse().forEach(function (info) {
										if (info.result === false) {
											s[info.field] = [
												{message: info.message}
											];
											obj.answer.reason = info.message;
										}
									});

									this.onPrepareFailed(obj);
								}.bind(this)
							}
						}
					},

					prepareTransactionApi: {
						widget: 'Api',
						method: 'ubs.prepareTransaction',
						project: 'publisher'
					},
					billerOptionsForm: {
						widget: 'Widget',
						widgets: {
							optionsList: {
								widget: 'List',
								autoRender: true
							}
						},
						handleWom: {
							onListInDom: {
								event: 'addedToDom',
								widget: '#optionsList',
								callback: '@parent:_sendBillerForm'
							}
						},
						autoRender: false
					}
				},
				handleWom: {
					onSubmit: {
						widget: '#form',
						event: 'submit',
						callback: 'onSubmit'
					}
				}
			});
		},

		init: function() {
			this.siteId = fox.site.dl.getObjectValue('id');
			this.userData = {};
			this.api = null;

			this.registerOptions('#form', {
				formSelector: this.getOption('widgets.form.formContainer'),
				handleDom: {
					onFormSubmit: fox.merge(this.getOption('widgets.form.submit'), {
						targetWidget: '@parent',
						callback: function (a, b, c, e) {
							e.preventDefault();

							this.rwom1('#form').submit();

							return false;
						}.bind(this)
					})
				}
			});

			this.callParent('init', arguments);
		},

		running: function() {
			if (typeof this.prepareTransactionApi === 'undefined') {
				this.prepareTransactionApi = this.rwom1('#prepareTransactionApi');
			}

			try {
				this._prepareJoinOptions();
			} catch (e) {
				this._error('Internal error: cannot get join options');
				fox.log(e.message);
				return;
			}

			this.getTotalContentAmount();

			this.handleEvent('#form', 'form_ready', fox.bind(this.initSelect, this));
			this.handleEvent(this.prepareTransactionApi, 'ready', 'onPrepareTransaction');
			this.handleEvent(this.prepareTransactionApi, ['failure', 'error'], 'onPrepareFailed');
			this.callParent('running', arguments);
		},
		activate: function() {
			this.callParent('activate', arguments);

			this.getTotalContentAmount();
		},

		getTotalContentAmount: function() {
			if (this.getOption('totalContentAllowed')) {
				this.rwom1('#totalApi').send({});
			}
		},

		initSelect: function() {
			this.handleEvent('#form #joinOptions', 'valueChanged', fox.bind(this.changeSelect, this));
			this.requireEmbeddedWidget('form').setValue('joinOptions', this.defaultJoinOption.toString());
		},

		changeSelect: function(w) {
			var selected = fox.dom.selectFirst('.selected');
			var option;
			try {
				option = w.getSelectedOption();
			} catch (e) {
				return;
			}

			if (selected && option) {
				selected.innerHTML = option.text;
			} else {
				selected.innerHTML = 'Select Option';
			}
		},

		onSubmit: function (userData, enhanceData) {
			if (this.__inProgress)
				return false;

			var args = fox.clone(arguments);

			this.userData = userData;
			var transactionParams = fox.merge({
				username: encodeURIComponent(this.userData.login),
				email: encodeURIComponent(this.userData.email)
			}, enhanceData || {});

			if (this.userData.password) {
				transactionParams.password = encodeURIComponent(this.userData.password);
			}

			if (this.getOption('optionsBy') === 'groupId') {
				transactionParams.groupId = this.userData.joinOptions;
			} else {
				transactionParams.optionId = this.userData.joinOptions;
			}

			this.hookWrapper('prepareTransactionParams', transactionParams);
			args[0] = transactionParams;

			this.requireEmbeddedWidget('form').disable();
			this.__inProgress = true;
			return this.prepareTransaction.apply(this, args);
		},

		prepareTransactionParams: function (params) {
			return params;
		},

		prepareTransaction: function(formData, resolve, reject) {
			formData.event = 'user_join';
			var extParams = fox.Navigator.getAll();
			delete extParams[0];

			fox.each(extParams, function(v, k) {
				if (!fox.isSet(formData[k])) {
					formData[k] = encodeURIComponent(v);
				}
			});

			return this.prepareTransactionApi
				.psend(this._prepareUbsOptions(formData)).then(resolve, reject);
		},

		onPrepareTransaction: function(data) {
			this.__inProgress = false;
			this.requireEmbeddedWidget('form').enable();
			$(this.rwom1('#errors').getOption('container')).hide();

			var fields = [];

			fox.each(data.added_fields, function(v, k) {
				fields.push({ key: k, val: v });
			});

			this.rwom1('#billerOptionsForm #optionsList').setCollection(fields);
			this.rwom1('#billerOptionsForm')
				.setTemplateOptions({
					billerUrl: data.submit_url,
					formMethod: data.form_method
				})
				.render();
		},

		onPrepareFailed: function(data) {
			this.__inProgress = false;
			var err = data.answer;
			var messages = [];

			this.requireEmbeddedWidget('form').enable();

			if (!err) {
				console.error('Prepare failed without answer property', data);
				this.dispatchEvent('onPrepareFailed', data);

				return;
			}

			if (fox.isSet(err.type) && (err.type === 6)) {
				fox.each(err.data, function(items) {
					fox.each(items, function(item) {
						messages.push({
							message: item.message
						});
					});
				});
			} else {
				messages.push({
					message: err.reason
				});
			}
			this.rwom1('#errors')
				.setCollection(messages)
				.render();
			$(this.rwom1('#errors').getOption('container')).show();
			this.dispatchEvent('onPrepareFailed', err);
		},

		_prepareJoinOptions: function() {
			var jo = fox.getEnv('siteProps.ubs.joinOptions.options');
			this.hookWrapper('joinOptionsPrepare', jo);

			fox.each(jo, function(o) {
				if (o['default'] === 1) {
					if (this.getOption('optionsBy') === 'groupId') {
						this.defaultJoinOption = o.groupId;
					} else {
						this.defaultJoinOption = o.settings.id;
					}

				}
			}, this);

			if (!this.defaultJoinOption && jo.length) {
				if (this.getOption('optionsBy') === 'groupId') {
					this.defaultJoinOption = jo[fox.getObjectKeys(jo)[0]].groupId;
				} else {
					this.defaultJoinOption = jo[fox.getObjectKeys(jo)[0]].settings.id;
				}
			}

			this.requireEmbeddedWidget('joinOptions')
				.setCollection(jo, false);
			this.dispatchEvent('joinOptionsPrepared');
		},

		joinOptionsPrepare: function (joinOptions) {
			return joinOptions;
		},

		_prepareUbsOptions: function(opts) {
			opts.project = this.rwom1('#prepareTransactionApi').getOption('project');
			opts.site = this.siteId;
			return opts;
		},

		_error: function(text) {
			$(this.rwom1('#errors').getOption('container')).text(text).show();
		},

		_sendBillerForm: function() {
			if (fox.count(this.rwom1('~#optionsList').getCollection())) {
				fox.dom.selectFirst(this.rwom1('#billerOptionsForm').getOption('billerFormSelector')).submit();
			}
		}
	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	var _ = {
		MAXFAILSTOCAPTCHA: 5,
		LOGINAPINAME: 'loginApi'
	};

	fox.registerWidget('User_Login', {
		configure: function(options) {
			this.registerOptions('', {
				captchaAlias: 'default',
				captchaContainer: false,
				useCaptcha: false,
				reloadCaptchaOnError: false,
				captchaBlockSelector: false,
				errorRedirect: true,
				customLoginRedirect: false,
				'widgets.lform': {
					widget: 'Form',
					formElements: {
						'le': {
							element: '[name=le]'
						},
						'password': {
							element: '[name=password]'
						},
						'captcha': {
							element: '[name=captcha]'
						}
					},
					resetOnBuilt: false,
					submit: {
						target: '.auth-form',
						event: 'submit'
					}
				},
				handleDom: {
					openLogin: {
						event: 'click',
						target: '#auth-link',
						callback: 'openLogin'
					},
					reloadCaptcha: {
						event: 'click',
						target: '.reload-captcha',
						callback: '#captcha:loadCaptcha'
					},
					report: {
						event: 'click',
						target: '#_reportProblem',
						callback: '_report'	
					}
				},
				handleWom: {
					formSubmit: {
						widget: '#lform',
						event: 'submit',
						callback: 'formSubmit'
					},
					addedToDom: {
						widget: '@this',
						event: 'addedToDom',
						callback: '_startCaptcha'
					}
				}
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			$('body').on('click', function(e){ 
				if($(e.target).parents('#auth').length < 1){
					$('#auth').removeClass('auth-opened').addClass('auth-closed');
					$('#auth').removeClass('stem')
				}
			});

			this.callParent('init', arguments);
		},
		
		running: function () {
			/* var captcha = fox.getEnv('showCaptchaOnLogin') === undefined ? this.getOption('useCaptcha') : fox.getEnv('showCaptchaOnLogin');
			if ( captcha ){
				this._showCaptcha();
			}  */

			this.callParent('running', arguments);
		},

		openLogin: function() {
			$(this.options.container).removeClass('auth-closed').addClass('auth-opened').addClass('stem');
		},

		formSubmit: function(userData) {
			var data;

			if (fox.Navigator.get(0) != 'login') {
				fox.site.setCustomData('hashOnLoginSuccess', fox.Navigator.getAll());
			}

			if (this.getOption('useCaptcha')) {
				data = {memberFields: ['login'], captchaId: this.rwom1('.Captcha').captchaId};
			} else {
				data = {memberFields: ['login']};
			}

			fox.each(userData, function(val, key) {
				if (val) {
					data[key] = window.encodeURIComponent(fox.trim(val));
				}
			}, this);

			$(this.options.container).removeClass('auth-opened').addClass('auth-closed');

			var api = this.getApi(_.LOGINAPINAME, {
				httpMethod: 'post',
				method: 'site.authorizer.auth',
				secure: fox.getEnv('ah') && [fox.getEnv('ah').split('').reverse().join(''), fox.getEnv('aet')]
			});
			
			this.waitEvent(api, 'success', fox.bind(this.formSubmitted, this));
			this.waitEvent(api, ['error', 'failure'], fox.bind(this.formSubmitError, this));

			api.send(data, true);
		},

		formSubmitted: function(data) {
			var response = data.answer.response;
			var redirect = this.getOption('customRedirectOnLogin');
			
			if (!response.member) {
				fox.log('login failed: ' + response.message);

				if (this.getOption('errorRedirect')) {
					fox.site.gotoPage('login');
				}

				fox.site.dispatchEvent('loginError', response);

				return;
			}

			var redirectTo = fox.Navigator.getAll();

			fox.log('logged in, hash is "' + response.hash + '", member is ' + response.member.collection + ', redirecting to ' + redirectTo[0]);
			
			fox.site.login(response.member, response.hash, 'home');

			if (redirect) {
				fox.site.gotoPage(redirect, {skipEvent: true});
			}
			
			this.dispatchEvent('loginSuccess');
			
			if(response.downgradedToFree !== undefined) {
				fox.utils.localStorage('setItem', 'exPremiumUser', 1);
			}

			window.location.reload(true);
		},

		formSubmitError: function(data) {
			var response = data.answer;

			if (!response) return false;
			
			fox.site.dispatchEvent('loginError', response);

			if (response.code === 3 && response.type === 0) {
				this.setOption('useCaptcha', true);
				if(!this.wom1('#captcha')){
					this._embedCaptcha()
				}
				this._showCaptcha()
			}

			this.hookWrapper('insertErrorMessage', response);
		},

		getErrorContainer: function () {
			return $(this.element[0]).find('#message');
		},

		getDefaultErrorContainer: function () {
			return $('.login-form-error-message.default');
		},

		insertErrorMessage: function (response) {
			if (response.reason){
				this.getErrorContainer().text(response.reason);
			}
		},

		toggleErrorBlock: function (state) {
			var block = this.getErrorContainer();

			if (fox.isObject(state)) {
				this[(state.action === true ? 'showErrorBlock' : 'hideErrorBlock')]();
				
				return;
			}

			if (block.hasClass('show')) {
				this.hideErrorBlock();

				return;
			}

			this.showErrorBlock();
		},

		showErrorBlock: function () {
			this.getErrorContainer().addClass('show');
		},

		hideErrorBlock: function () {
			this.getErrorContainer().removeClass('show');
		},


		showDefaultErrorBlock: function () {
			this.getDefaultErrorContainer().addClass('show');
		},

		hideDefaultErrorBlock: function () {
			this.getDefaultErrorContainer().removeClass('show');
		},

		_report: function (argument) {
			this.hookWrapper('report');
		},

		_embedCaptcha: function () {
			this.embedWidget('captcha', 'Captcha', {
				'embed.container': this.getOption('captchaContainer') || '#captcha',
				captchaAlias: this.getOption('captchaAlias') || 'default'
			}).run();
		},

		_startCaptcha: function() {
			if (fox.getEnv('showCaptchaOnLogin')){
				this.setOption('useCaptcha', true)
				this._embedCaptcha();
				this._showCaptcha();
			}else{
				this._embedCaptcha();
			}
		},

		_showCaptcha: function () {
			var wCaptcha = this.wom1('#captcha');
			if (!wCaptcha._indom) {
				wCaptcha.render();
				this.handleEvent(wCaptcha, 'addedToDom', fox.bind(function () {
					wCaptcha.loadCaptcha();
					$(this.dom1(this.getOption('captchaBlockSelector') || '#captchaBlock')).show();
				}, this), {once: true});
			} else if (this.getOption('reloadCaptchaOnError') === true) {
				wCaptcha.loadCaptcha();
				$(this.dom1(this.getOption('captchaBlockSelector') || '#captchaBlock')).show();
			}
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Captcha

(function (fox) {
	'use strict';
	__webpack_require__(459)(fox);

	fox.registerWidget('Captcha', {
		configure: function () {
			this.registerOptions('', {
				getCaptchaMethod: 'captcha.genId',
				template: 'captchaimg',
				captchaAlias: 'brettrossi',
				autoRender: false,
				'widgets.captchaApi': {
					widget: 'Api',
					'handleWom.captchaApiSuccessHandler': {
						widget: '@this',
						event: 'success',
						callback: '@parent:captchaApiSuccessHandler'
					}
				},
				'handleWom.putCaptcha': {
					widget: '@parent',
					event: 'addedToDom',
					callback: 'loadCaptcha'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#captchaApi', {
				method: this.getOption('getCaptchaMethod')
			});

			this.visualParent = this.getParent();

			this.callParent('init', arguments);
		},

		embed: function () {
			this
				.fragment
				.childNodes[0]
				.setAttribute('src', this._captchaSrc);

			this.callParent('embed', arguments);
		},

		captchaApiSuccessHandler: function (data) {
			this.captchaId = this.getOption('captchaAlias') + ':' + data.answer.response.sid;
			var secure = this.getOption('secure'), address;
			if (secure) {
				address = '/sapi/' + secure[0] + '/' + secure[1] + '/captcha.show';
			} else {
				address = '/api/captcha.show';
			}

			this._captchaSrc = address + '?params={"id":"' + this.captchaId + '"}&rand=' + Math.random();
			this.render();
		},

		loadCaptcha: function () {
			this
				.rwom1('#captchaApi')
				.send({alias: this.getOption('captchaAlias')}, false);
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("captchaimg", [["img",{"class":"captcha-img"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Related Widget
(function (fox, $){
	'use strict';

	fox.registerWidget('Pager_Simple', {
		configure: function (options) {
			this.registerOptions('', {
				skipPreloader: true,
				pagesCount: 4,
				'tpl.container': 'pager',
				noScroll: true,
				currentPageClass: 'cp',
				addHrefAttribute: false,
				page: '',
				handleDom: {
					setPage: {
						target: '.pager-click',
						event: 'click'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			if (!fox.isEmpty(fox.site.member) && this.getOption('logged.tpl.container')) {
				this.setOption('tpl.container', this.getOption('logged.tpl.container'))
					.setOption('pagesCount', this.getOption('logged.pagesCount'));
			}
			
			this.callParent('init', arguments);
		},

		addedToDom: function () {
			var $jDoc, $mainElement, embedWidget;
			
			if (this.getOption('noScroll') !== true) {
				$jDoc = $(document);

				if (!!this.getOption('embed.widget')){
					embedWidget = this.wom1(this.getOption('embed.widget'));
				} else {
					embedWidget = this.getParent();
				}

				try {
					$mainElement = $(embedWidget.element[0]);
				} catch (e) {
					console.log(e);
				}
				
				if ($jDoc.scrollTop() > $jDoc.height() * 0.2) {
					$('body, html').animate({
						scrollTop: $mainElement && $mainElement.offset().top || 0
					}, 500);
				}
			}
		},

		_calculatePagerData: function () {
			this.callParent('_calculatePagerData', arguments);

			if (this.getOption('addHrefAttribute') === true && this.navPrefix) {
				if (fox.Navigator.get('tags')){
					var tagFilter = 'tags=' + fox.Navigator.get('tags');
					this._pagerData.link = [fox.site.page.alias, tagFilter, this.navPrefix].join('/');
				}else{
					this._pagerData.link = [fox.site.page.alias, this.navPrefix].join('/');
				}
			}
		}

	}, 'Grid_Pager');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/**
 * 
 * @param {Fox} fox 
 */
module.exports = function (fox) {
	var $ = fox.jQuery;

	fox.registerWidget('Tips_Form', {
		configure: function configure() {
			var _this = this;

			this.minCustomPriceAmount = 2; //$
			this.recomendedCustomPriceAmount = 10; //$
			this.paymentPending = [];

			this.registerOptions('', {
				autoRender: true,
				widgets: {
					tipsDl: {
						widget: 'Datalayer',
						method: 'tips.getTips',
						cacheChannel: 'site'
					},
					tipItems: {
						widget: 'Grid',
						container: '.tips-list-container',
						dataLayer: '@parent #tipsDl',
						autoRender: true,
						list: {
							'tpl.row': 'sitepage_tips_form_item',
							hooks: {
								onAddedToDom: function onAddedToDom() {
									return _this._updateForm();
								}
							},
							handleDom: {
								handleCustomPriceFocus: {
									target: '[name="custom_price"]',
									event: 'focus',
									callback: function callback(el) {
										var form = this.getParent().getParent().rwom1('#form');

										form.setValue('tips', fox.dom.wrap(el).attr('alias'));
									}
								},
								handleCustomPriceBlur: {
									target: '[name="custom_price"]',
									event: 'blur',
									callback: function callback(el) {
										var id = fox.dom.wrap(el).attr('alias');
										var target = fox.dom.selectFirst('[data-amount][data-id="' + id + '"]');

										if (!target) return;

										fox.dom.wrap(target).attr('data-amount', el.value);
									}
								}
							}
						}
					},
					errors: {
						widget: 'List',
						tpl: {
							row: 'sitepage_tips_form_error_row'
						},
						container: '#errors.errors',
						autoRender: false
					},
					form: {
						widget: 'Form',
						loadValuesOnRun: true,
						formElements: {
							'message.element': '[name=tipsMessage]',
							'amount.element': '[name=custom_price]',
							'amount.defaultValue': this.recomendedCustomPriceAmount,
							'tips.element': '[name=tips]',
							'tips.autoApply': true
						},
						resetOnBuilt: false,
						'hooks.onStartSubmit': '@parent:validateData'
					},
					prepareApi: {
						widget: 'Api',
						method: 'tips.prepare'
					},
					billerOptionsForm: {
						widget: 'Widget',
						'embed.widget': '@parent @parent',
						'embed.container': '#biller-form-container',
						template: 'sitepage_tips_form_billing',
						billerFormSelector: '#biller-form',
						widgets: {
							optionsList: {
								widget: 'List',
								autoRender: true,
								container: '#biller-form',
								tpl: {
									row: 'sitepage_tips_form_billing_row'
								}
							}
						},
						handleWom: {
							onListInDom: {
								event: 'addedToDom',
								widget: '#optionsList',
								callback: '@parent:_sendBillerForm'
							}
						},
						autoRender: false
					},

					successPopup: {
						widget: 'Dialog',
						template: '',
						dialog: {
							closeText: ''
						},
						widgets: {
							tipsPopupContainer: {
								widget: 'Widget',
								widgets: {
									content: {
										widget: 'Widget',
										template: 'popup_thanks'
									}
								}
							}
						}
					},
					errorPopup: {
						widget: 'Dialog',
						template: '',
						dialog: {
							closeText: ''
						},
						widgets: {
							tipsPopupContainer: {
								widget: 'Widget',
								widgets: {
									content: {
										widget: 'Widget',
										template: 'popup_wrong',
										'handleDom.hide': {
											target: 'a',
											callback: '@parent @parent:hide'
										}
									}
								}
							}
						}
					},
					confirmPopup: {
						widget: 'Dialog',
						template: '',
						dialog: {
							closeText: ''
						},
						widgets: {
							tipsPopupContainer: {
								widget: 'Widget',
								widgets: {
									content: {
										widget: 'Widget',
										template: 'popup_attention',
										'handleDom.confirm': {
											target: '.confirm',
											event: 'click',
											callback: '@parent @parent @parent:submit'
										}
									}
								}
							}
						}
					}
				},
				handleWom: {
					tipsPaymentSuccess: {
						event: 'inboxSocketEventTips:unlock',
						widget: '@root #socket',
						callback: 'tipsPaymentSuccess',
						params: {
							alwaysActive: true
						}
					}
				}
			});

			this.registerOptions('~.Dialog #tipsPopupContainer', {
				template: 'popup_container',
				autoRender: true,
				'handleDom.close': {
					target: '.close',
					event: 'click',
					callback: '@parent:hide'
				}
			});

			this.registerOptions('~.Dialog #tipsPopupContainer #content', {
				autoRender: true,
				container: '#popup-widget-container',
				'handleDom.close': {
					target: '.close',
					event: 'click',
					callback: '@parent @parent:hide'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			this.userData = {};
			this.api = null;
			this.callParent('init', arguments);

			if (fox.isEmpty(this.getMemberInfo())) {
				this.registerOptions('#form', {
					formElements: {
						'login.element': '[name=login]',
						'login.autoApply': true,
						'email.element': '[name=email]',
						'email.autoApply': true
					}
				});
			}
		},

		running: function running() {
			if (!this.prepareApi) {
				this.prepareApi = this.rwom1('#prepareApi');
			}

			this.confirmPopup = this.wom1('#confirmPopup');
			this.successPopup = this.wom1('#successPopup');
			this.errorPopup = this.wom1('#errorPopup');

			this.handleEvent('#form', 'submit', 'onSubmit');
			this.callParent('running', arguments);
		},

		onSubmit: function onSubmit(userData) {
			if (!this._isValid) {
				return;
			}

			this.userData = userData;

			if (!this.confirmPopup) {
				console.warn('Confiramation popup doesn\'t exist');
				return;
			}

			this.confirmPopup.wom1('#tipsPopupContainer #content').setTemplateOptions({ amount: this._getAmount() }).render();

			this.confirmPopup.show();
		},

		submit: function submit() {
			var _this2 = this;

			this.requireEmbeddedWidget('form').ignoreSubmit(true);

			var transactionParams = {
				tipId: this.userData.tips,
				amount: this.userData.amount
			};

			if (this.userData.login && this.userData.email) {
				transactionParams.login = fox.trim(this.userData.login);
				transactionParams.email = fox.trim(this.userData.email);
			}

			if (this.userData.message) {
				transactionParams.message = this.userData.message;
			}

			if (this.userData.targetId && this.userData.subject) {
				transactionParams.targetId = this.userData.targetId;
				transactionParams.subject = this.userData.subject;
			}

			transactionParams = fox.mixin(transactionParams, this.getOption('preparedTransactionParams'));

			var showCbInPopup = this.getOption('showCbInPopup');
			var showCbCallback = fox.isBoolean(showCbInPopup) ? this.showCbWindow : fox.isFunction(showCbInPopup) ? function () {
				for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
					args[_key] = arguments[_key];
				}

				return showCbInPopup.apply(_this2, args);
			} : null;

			var promise = this.prepareTransaction(transactionParams).then(function (res) {
				if (showCbCallback) return new fox.Promise(function (resolve) {
					return _this2.onPrepareSuccess(res, transactionParams.tipId, resolve);
				});

				return _this2.onPrepareSuccess(res, transactionParams.tipId);
			}).catch(function () {
				return _this2.onPrepareFailed.apply(_this2, arguments);
			});

			if (showCbCallback) return showCbCallback(promise);
		},

		tipsPaymentSuccess: function tipsPaymentSuccess(res) {
			var args = Array.prototype.slice.call(arguments);

			if (this.prepareTransactionInProgress === true) {
				return this.prepareApi.wait('@this', 'success', { prefix: 'waitForApiSuccess' }).then(fox.bind(function () {
					this.tipsPaymentSuccess.apply(this, args);
				}, this));
			}

			res = res.answer;

			var indx = this.paymentPending.indexOf(Number(res));

			if (indx !== -1) {
				this.paymentPending.splice(indx, 1);

				if (this.isActive()) {
					this.hookWrapper('showSuccessPopup');
				}
			}
		},

		prepareTransaction: function prepareTransaction(formData) {
			$(this.rwom1('#errors').getOption('container')).hide();
			var extParams = fox.Navigator.getAll();
			delete extParams[0];

			fox.each(extParams, function (v, k) {
				if (!fox.isSet(formData[k])) {
					formData[k] = v;
				}
			});

			this.confirmPopup.hide();

			this.prepareTransactionInProgress = true;

			return this.prepareApi.psend(formData);
		},

		onPrepareTransaction: function onPrepareTransaction(data) {
			$(this.rwom1('#errors').getOption('container')).hide();
			var fields = [];

			fox.each(data.added_fields, function (v, k) {
				fields.push({ key: k, val: v });
			});

			this.rwom1('#billerOptionsForm #optionsList').setCollection(fields);
			this.rwom1('#billerOptionsForm').setTemplateOptions({
				billerUrl: data.submit_url,
				formMethod: data.form_method
			}).render();
		},

		showCbWindow: function showCbWindow(promise) {
			var cbPopup = this.wom1('#cbPaymentPopup');

			if (!cbPopup) {
				cbPopup = this.embedWidget('cbPaymentPopup', 'CBPaymentPopup', {});

				cbPopup.run();
			}

			return cbPopup.show(promise.then(function (data) {
				var url = data.submit_url + '?' + fox.toQueryString(data.added_fields);

				return { url: url };
			}));
		},

		onPrepareFailed: function onPrepareFailed(data) {
			this.prepareTransactionInProgress = false;

			var err = fox.objectGet(data, 'answer') || fox.objectGet(data, 'params.answer');
			var messages = [];

			if (data.error === 'jsonParse' || fox.isEmpty(data)) {
				console.warn('bad internet connection');
			} else if (fox.isSet(err.type) && err.type === 6) {
				fox.each(err.data, function (items) {
					fox.each(items, function (item) {
						messages.push({
							message: item.message
						});
					});
				});
			}

			this.showMessages(messages);

			this.setTplOptionToErrorPopup(err.code);
			this.errorPopup.show();

			this.requireEmbeddedWidget('form').enableAllElements().ignoreSubmit(false);

			this.dispatchEvent('onPrepareFailed', err);
		},

		onPrepareSuccess: function onPrepareSuccess(r, tipId, resolver) {
			this.prepareTransactionInProgress = false;

			function pendingPayment(tipId) {
				this.rwom1('#form').enableAllElements().ignoreSubmit(false);

				this.paymentPending.push(Number(tipId));
			}

			r = r.params.answer.response;

			if (r.submit_url) {
				if (resolver) {
					resolver(r);
				} else {
					this.onPrepareTransaction(r);
				}

				return pendingPayment.call(this, tipId);
			} else if (r === true || r === 'Event successfully processed') {
				if (resolver) resolver(true);

				return pendingPayment.call(this, tipId);
			}

			throw new Error('Payment error');
		},

		showSuccessPopup: function showSuccessPopup() {
			var nickname = fox.isEmpty(this.getMemberInfo()) ? this.userData.login : this.getMemberInfo('login');
			this.successPopup.render();
			this.successPopup.wom1('#tipsPopupContainer #content').setTemplateOptions({ name: nickname }).render();

			this.successPopup.show();
			this.dispatchEvent('showedSuccessPopup');
		},

		showMessages: function showMessages(messages) {
			this.rwom1('#errors').setCollection(messages).render();
			$(this.rwom1('#errors').getOption('container')).show();
		},

		_updateForm: function _updateForm() {
			var form = this.rwom1('#form');

			fox.each(this.rwom1('#tipsDl').getCollection(), function (item, key) {
				var chkbx = fox.dom.selectFirst('#tip_' + (this.getOption('useIdForDomId') === true ? item.id : key + 1), this.element);
				fox.dom.removeClass('checked', chkbx.parentNode);

				if (item.isDefault) {
					chkbx.checked = true;
					fox.dom.addClass('checked', chkbx.parentNode);
				}
			}, this);

			form._runSelectors();
			form.createWidgetsFromSelectors();

			this.window.setTimeout(fox.bind(function () {
				var el = form.getFormElement('amount')[0];

				if (!el) {
					return;
				}

				form.setValue('amount', this.recomendedCustomPriceAmount);

				var id = fox.dom.wrap(el).attr('alias');
				var target = fox.dom.selectFirst('[data-amount][data-id="' + id + '"]');

				fox.dom.wrap(target).attr('data-amount', el.value);
			}, this), 200);
		},

		_error: function _error(text) {
			$(this.rwom1('#errors').getOption('container')).text(text).show();
		},

		_sendBillerForm: function _sendBillerForm() {
			if (fox.count(this.rwom1('~#billerOptionsForm #optionsList').getCollection())) {
				var bof = this.rwom1('#billerOptionsForm');

				/** @type {HTMLFormElement} */
				var form = bof.dom1(bof.getOption('billerFormSelector'));

				form.submit();
			}
		},

		_getAmount: function _getAmount() {
			var result = false;
			var elems = fox.dom.select('label[data-amount]');

			fox.each(elems, function (el) {
				el = fox.dom.wrap(el);

				if (el.attr('data-id') === this.userData.tips) {
					result = el.attr('data-amount');
				}
			}, this);

			return result;
		},

		validateData: function validateData() {
			this._isValid = false;
			var result = {
				email: false,
				login: false,
				custom: false
			};

			if (fox.isEmpty(this.getMemberInfo())) {
				result.email = this._validateEmail();
				result.name = this._validateName();
			} else {
				result.email = true;
				result.name = true;
			}

			result.custom = this._validateCustomValue();
			if (result.name && result.email && result.custom) {
				this._isValid = true;
				this.wom1('#form').dispatchEvent('submit', this._preparedValues);
				return;
			}
		},

		_validateCustomValue: function _validateCustomValue() {
			if (!this.wom1('#form #amount')) {
				return true;
			}

			var amount = this.wom1('#form').getValue('amount');
			var elem = this.dom1('[custom-price]');
			/** @type {any} */
			var input;
			var regExp = /^[0-9]+(\.?[0-9]+)?$/;

			if (elem) {
				input = fox.dom.selectFirst('[name="tips"]', elem);
			}

			if (!input) {
				return false;
			}

			if (input.checked) {
				if (!amount || !amount.length || !amount.match(regExp)) {
					this.toggleError('custom_price', false);
					return false;
				}

				if (amount.match(regExp)) {
					amount = this.window.parseInt(amount);

					if (amount >= this.minCustomPriceAmount && amount <= 99999) {
						this.toggleError('custom_price', true);
						return true;
					}

					this.toggleError('custom_price', false);
					return false;
				}
			}

			return true;
		},

		_validateEmail: function _validateEmail() {
			var regExp = new RegExp('^[a-zA-Z0-9#\!\$%&\'\*\+\/=\?\^_`\{\}\|~-]+(?:\.[a-z0-9#\!\$%&\'\*\+\/=\?\^_`\{\}\|~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$'),
			    el = fox.dom.selectFirst('[name="email"]', this.rwom1('#form').getContainer());

			if (!el) {
				return false;
			}

			if (this.isNotEmpty('email') && el.value.match(regExp)) {
				this.toggleError('email', true);
				return true;
			}

			this.toggleError('email', false);
			return false;
		},

		_validateName: function _validateName() {
			if (this.isNotEmpty('login')) {
				this.toggleError('login', true);
				return true;
			}

			this.toggleError('login', false);
			return false;
		},

		toggleError: function toggleError(name, state) {
			var el = fox.dom.selectFirst('[name="' + name + '"]', this.rwom1('#form').getContainer());

			if (!el) {
				return;
			}

			fox.dom[!state ? 'addClass' : 'removeClass']('error', el);
			this.hookWrapper('handleErrorToggle', { state: state, el: el });
		},

		isNotEmpty: function isNotEmpty(name) {
			return fox.dom.selectFirst('[name="' + name + '"]', this.rwom1('#form').getContainer()).value.length;
		},

		handleErrorToggle: function handleErrorToggle() {},

		getMemberInfo: function getMemberInfo(field) {
			var pm = this.wom1('@root #permissionManager');

			if (pm) return pm.getMemberInfo(field);

			return field ? fox.site.member && fox.site.member.getObjectValue(field) : fox.site.member;
		},

		setTplOptionToErrorPopup: function setTplOptionToErrorPopup(code) {
			var w = this.errorPopup.wom1('~#content');

			w.setTemplateOptions({});

			//user already exists
			if (code === 3003) {
				w.setTemplateOptions({ errorAlias: 'userExists' });
			}

			w.render();
		}
	}, 'Widget');
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';

	var getSkinComponent = __webpack_require__(79);
	
	getSkinComponent('splash')(fox);

	var require__widgets = __webpack_require__(487);
	var widgetsFiles = require__widgets.keys();

	widgetsFiles.forEach(function (file) {
		require__widgets(file)(fox);
	});

	__webpack_require__(489);
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./fhg/index": 464,
	"./splash/index": 474,
	"./store/index": 479
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function () {
	'use strict';

	__webpack_require__(465);
	__webpack_require__(467);

	__webpack_require__(469)(fox);

	var require__template = __webpack_require__(470);
	var template__files = require__template.keys();

	template__files.forEach(function (file) {require__template(file)(fox);});
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(466);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_freeHostedGallery.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_freeHostedGallery.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "[data-widget-class=Layout_FreeHostedGallery] .container{padding:20px 20px 0}[data-widget-class=Layout_FreeHostedGallery] .fhg-image-block{margin-bottom:-5px}[data-widget-class=Layout_FreeHostedGallery] .fhg-image-block .photo-item{border-radius:2px}[data-widget-class=Layout_FreeHostedGallery] .fhg-banner{text-align:center;line-height:normal;font-size:28px;font-family:simplifica;border-radius:3px;overflow:hidden}[data-widget-class=Layout_FreeHostedGallery] .fhg-banner .fhg-banner-btn,[data-widget-class=Layout_FreeHostedGallery] .fhg-banner .fhg-banner-text{padding:15px;display:block}[data-widget-class=Layout_FreeHostedGallery] .banner-get-in-touch,[data-widget-class=Layout_FreeHostedGallery] .banner-get-my-fun{margin:20px 0}[data-widget-class=Layout_FreeHostedGallery] .banner-get-access{margin:20px 0 10px}[data-widget-class=Layout_FreeHostedGallery] .fhg-title-block{text-align:center;line-height:normal;margin:0 0 20px}[data-widget-class=Layout_FreeHostedGallery] .fhg-title-block .title{display:block;font-size:32px;font-family:simplifica;padding-bottom:10px}[data-widget-class=Layout_FreeHostedGallery] .fhg-title-block .link-download{font-size:12px;text-transform:uppercase}[data-widget-class=Layout_FreeHostedGallery] .fhg-title-block .description{margin-top:15px}[data-widget-class=Layout_FreeHostedGallery] .pl-about-image{background-size:cover}[data-widget-class=Layout_FreeHostedGallery] .about-me{border-radius:3px;overflow:hidden;margin-top:20px}[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .txt{padding:20px 15px}[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .about-me-title{line-height:normal;font-size:30px;font-family:simplifica}[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .intro{margin:20px 0;font-size:12px}[data-widget-class=Layout_FreeHostedGallery] .about-me .my-website{display:none;font-size:25px;font-family:simplifica}[data-widget-class=Layout_FreeHostedGallery] .about-me .icon-lib-link_23{padding-right:8px}[data-widget-class=Layout_FreeHostedGallery] .footer .powered .text-color-1{color:#adadad!important}@media (min-width:768px) and (max-width:999px){[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .intro{margin:25px 0 35px;max-height:200px}[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .img{max-width:375px;max-height:375px}[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .txt{margin-left:390px}}@media (min-width:768px){[data-widget-class=Layout_FreeHostedGallery] .container{padding:30px 30px 0}[data-widget-class=Layout_FreeHostedGallery] .fhg-banner{display:-moz-flex;display:-ms-flexbox;display:flex;font-size:32px}[data-widget-class=Layout_FreeHostedGallery] .fhg-banner .fhg-banner-btn,[data-widget-class=Layout_FreeHostedGallery] .fhg-banner .fhg-banner-text{height:100%;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;min-height:90px}[data-widget-class=Layout_FreeHostedGallery] .fhg-banner .fhg-banner-btn{width:250px}[data-widget-class=Layout_FreeHostedGallery] .fhg-banner .fhg-banner-text{-moz-flex:1;-ms-flex:1;flex:1}[data-widget-class=Layout_FreeHostedGallery] .banner-get-in-touch .fhg-banner-btn{max-width:250px}[data-widget-class=Layout_FreeHostedGallery] .banner-get-in-touch,[data-widget-class=Layout_FreeHostedGallery] .banner-get-my-fun{margin:30px 0}[data-widget-class=Layout_FreeHostedGallery] .banner-get-in-touch .fhg-banner-btn,[data-widget-class=Layout_FreeHostedGallery] .banner-get-my-fun .fhg-banner-btn{max-width:185px}[data-widget-class=Layout_FreeHostedGallery] .banner-get-access{margin:30px 0 10px}[data-widget-class=Layout_FreeHostedGallery] .banner-get-access .fhg-banner-btn{max-width:215px}[data-widget-class=Layout_FreeHostedGallery] .fhg-title-block{margin:0 0 40px}[data-widget-class=Layout_FreeHostedGallery] .fhg-title-block .title{font-size:45px}[data-widget-class=Layout_FreeHostedGallery] .about-me{margin-top:30px}[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .about-me-title{font-size:35px}[data-widget-class=Layout_FreeHostedGallery] .about-me .my-website{display:block}}@media (min-width:1000px){[data-widget-class=Layout_FreeHostedGallery] .fhg-banner{display:-moz-flex;display:-ms-flexbox;display:flex;font-size:45px}[data-widget-class=Layout_FreeHostedGallery] .fhg-banner .fhg-banner-btn,[data-widget-class=Layout_FreeHostedGallery] .fhg-banner .fhg-banner-text{min-height:100px}[data-widget-class=Layout_FreeHostedGallery] .fhg-banner .fhg-banner-btn{width:320px}[data-widget-class=Layout_FreeHostedGallery] .fhg-title-block{margin:0 0 45px}[data-widget-class=Layout_FreeHostedGallery] .banner-get-in-touch .fhg-banner-btn{max-width:320px}[data-widget-class=Layout_FreeHostedGallery] .banner-get-my-fun .fhg-banner-btn{max-width:260px}[data-widget-class=Layout_FreeHostedGallery] .banner-get-access .fhg-banner-text{font-size:40px}[data-widget-class=Layout_FreeHostedGallery] .banner-get-access .fhg-banner-btn{max-width:320px}[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .about-me-title{font-size:45px}[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .intro{max-height:270px}[data-widget-class=Layout_FreeHostedGallery] .about-me .about-info .txt{margin-left:470px}}", ""]);

// exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(468);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_freeHostedVideos.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_freeHostedVideos.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".free-hosted-videos-wrapper #banner-get-my-fun{margin:30px 0}.free-hosted-videos-wrapper #banner-get-access{margin-top:30px}.free-hosted-videos-wrapper #banner-get-in-touch{margin-bottom:30px}@media screen and (min-width:425px){.free-hosted-videos-wrapper .other-videos.content-list.grid .item{max-width:460px;width:49%}}.free-hosted-videos-wrapper .photos-part#first-photos-part{margin-bottom:25px}.free-hosted-videos-wrapper .photos-part#second-photos-part{margin-bottom:-5px;margin-top:10px}", ""]);

// exports


/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_FreeHostedGallery .Site_Page .FreeHostedVideos #firstVideo #play":{"template":[{"value":"other_videos_play_button","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedVideos #firstVideo #play","_fox_":1}]},"~.Layout_FreeHostedGallery .Site_Page .FreeHostedVideos #otherVideos .Content_Html5Player #play":{"template":[{"value":"other_videos_play_button","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedVideos #otherVideos .Content_Html5Player #play","_fox_":1}]},"~.Layout_FreeHostedGallery .Site_Page .FreeHostedVideos #photoList":{"locationConfig.part1.amountItems":[{"value":6,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedVideos #photoList","_fox_":1}],"locationConfig.part1.amountInRow":[{"value":2,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedVideos #photoList","_fox_":1}],"locationConfig.part2.amountItems":[{"value":8,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedVideos #photoList","_fox_":1}],"locationConfig.part2.amountInRow":[{"value":2,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedVideos #photoList","_fox_":1}]},"~.Layout_FreeHostedGallery .Site_Page .FreeHostedGallery #photoList":{"locationConfig.part1.embed.container":[{"value":".fhg-image-block-1","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedGallery #photoList","_fox_":1}],"locationConfig.part1.amountItems":[{"value":6,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedGallery #photoList","_fox_":1}],"locationConfig.part1.amountInRow":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedGallery #photoList","_fox_":1}],"locationConfig.part2.embed.container":[{"value":".fhg-image-block-2","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedGallery #photoList","_fox_":1}],"locationConfig.part2.amountItems":[{"value":9,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107029},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedGallery #photoList","_fox_":1}],"locationConfig.part2.amountInRow":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"~.Layout_FreeHostedGallery .Site_Page .FreeHostedGallery #photoList","_fox_":1}]},"~.Layout_FreeHostedGallery .Site_Page ~#photoList":{"locationConfig.part1.itemRightMargin":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.Layout_FreeHostedGallery .Site_Page ~#photoList","_fox_":1}],"locationConfig.part1.minItemInRow":[{"value":2,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107035},"path":"~.Layout_FreeHostedGallery .Site_Page ~#photoList","_fox_":1}],"locationConfig.part1.widthsConfig":[{"value":[{"dWidth":1000,"amountInRow":3},{"dWidth":768,"amountInRow":3},{"dWidth":320,"amountInRow":2}],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":"~.Layout_FreeHostedGallery .Site_Page ~#photoList","_fox_":1}],"locationConfig.part2.itemRightMargin":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"~.Layout_FreeHostedGallery .Site_Page ~#photoList","_fox_":1}],"locationConfig.part2.minItemInRow":[{"value":2,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"~.Layout_FreeHostedGallery .Site_Page ~#photoList","_fox_":1}],"locationConfig.part2.widthsConfig":[{"value":[{"dWidth":1000,"amountInRow":3},{"dWidth":768,"amountInRow":3},{"dWidth":320,"amountInRow":2}],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.Layout_FreeHostedGallery .Site_Page ~#photoList","_fox_":1}]},"~.Layout_FreeHostedGallery .Site_Page ~#lsCounter":{"template":[{"value":"liveShowCounter","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107050},"path":"~.Layout_FreeHostedGallery .Site_Page ~#lsCounter","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./fhg-autumn-new.tpl": 471,
	"./fhv-autumn-new.tpl": 473
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 470;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("fhg_aboutme", [["div",{"class":"bg-color-3 about-info text-color-1"},[["div",{"class":"photo-block clearfix"},[["div",{"class":"img","data-fox-editor-type":"image"},[["div",{"class":"pl-about-image"},[["img",{"src":"" + __webpack_require__(30) + "","alt":"about me &&0&&"},[],[["name","alt",false,[],"client"]]]]]]],["div",{"class":"txt"},[["div",{"class":"about-me-title"},[["textNode",{"text":"About "}],["span",{},[],[["stats.name","__text",true]]]]],["if",{"notempty":""},[["div",{"class":"intro nice-scroll fhg-aboutme-scroll"},[["p",{},[["span",{},[],[["stats.introduction","__text",true,[{"name":"html","params":[]},{"name":"transformNewLines","params":[]}]]]]]]]],["div",{"class":"bg-color-2 common-btn show-more"},[["textNode",{"text":" show more "}],["i",{"class":"icon-au_drop"}]]],["a",{"href":"/","class":"my-website text-color-1"},[["i",{"class":"icon-lib-link_23"}],["textNode",{"text":" My website"}]]]],[["stats.introduction","notempty",true]]]]]]]]]]);
fox.registerTemplate("fhg_banner_1", [["div",{"class":"fhg-banner"},[["div",{"class":"fhg-banner-text bg-color-3 text-color-1"},[["textNode",{"text":" Like what you see? Visit my fanpage! "}]]],["a",{"href":"/","class":"fhg-banner-btn bg-color-2 text-color-1"},[["textNode",{"text":"Check it out!"}]]]]]]);
fox.registerTemplate("fhg_banner_2", [["div",{"class":"fhg-banner"},[["div",{"class":"fhg-banner-text bg-color-3 text-color-1"},[["textNode",{"text":" Want to see more photosets? "}]]],["a",{"href":"/photosets","class":"fhg-banner-btn bg-color-2 text-color-1"},[["textNode",{"text":"Continue here!"}]]]]]]);
fox.registerTemplate("fhg_banner_3", [["div",{"class":"fhg-banner"},[["div",{"class":"fhg-banner-text bg-color-3 text-color-1"},[["textNode",{"text":" Let's get in touch at my personal website! "}]]],["a",{"href":"/","class":"fhg-banner-btn bg-color-2 text-color-1"},[["textNode",{"text":"Click here!"}]]]]]]);
fox.registerTemplate("fhv_banner_1", [["div",{"class":"fhg-banner"},[["div",{"class":"fhg-banner-text bg-color-3 text-color-1"},[["textNode",{"text":" Want to see more videos? "}]]],["a",{"href":"/videos","class":"fhg-banner-btn bg-color-2 text-color-1"},[["textNode",{"text":"Continue here!"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/aboutPhotoEmpty.png", __webpack_require__.p + "images/aboutPhotoEmpty.png");

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("fhv_liveshow_counter", [["div",{"class":"bg-color-2 text-color-1"},[["div",{"class":"liveshow-timer &&0&& pad-lr pad-tb"},[["div",{"class":"global-title"},[["textNode",{"text":"Next Live Show"}]]],["div",{"class":"ls-info"},[["div",{"class":"next-date"},[["span",{},[],[["addVars.startDate","__text",true,[{"name":"dateFormat","params":["%B %e, %Y %I"]}]]]],["textNode",{"text":":"}],["span",{},[],[["addVars.startDate","__text",true,[{"name":"dateFormat","params":["%M %P"]}]]]]]],["if",{"notempty":""},[["div",{"class":"ls-title"},[["span",{},[],[["addVars.title","__text",true]]]]]],[["addVars.title","notempty",true]]]]],["div",{"class":"show-start-time"}]],[["success.status","class"]]]]]]);
fox.registerTemplate("other_videos_tpl", [["div",{"class":"bg-color-3 text-color-1 item scene other-video-item"},[["div",{"id":"video-&&0&&"},[],[["id","id"]]]]]]);
fox.registerTemplate("other_videos_container", [["div",{"id":"videos-list","class":"other-videos content-list grid"}]]);
fox.registerTemplate("other_videos_play_button", [["div",{"class":"ac-p-toggle-box ac-p-play-box animated fadeIn","data-component":"toggleplay"},[["div",{"class":"ac-p-play-btn"},[["span",{"class":"play bg-color bg-color-2-trans-70"},[["i",{"class":"icon-au_play text-color-1"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';

	var require__templates = __webpack_require__(475);
	var templateFiles = require__templates.keys();

	templateFiles.forEach(function (file) {
		require__templates(file)(fox);
	});
	__webpack_require__(477);
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./splash.tpl": 476
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 475;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_splash", [["div",{"id":"splash"},[["import",{"name":"Layout_Join"}]]]]);
fox.registerTemplate("sitepage_splash", [["div",{"class":"page-width"},[["div",{"class":"pad-lr pad-tb text-color-1"},[["header",{"class":"header join-header logo-wrapper border-color-1-trans-50 text-color-1","id":"header"},[["a",{"href":"/","class":"logo text-color-1 text"},[["div",{"class":"logo-img","data-fox-alias":"logoText2"},[["img",{"src":"" + __webpack_require__(7) + "","alt":"logo"}]]],["div",{"class":"logo-text"},[["div",{"class":"desk-logo","data-fox-alias":"logoText"},[["p",{"class":"logo-main"},[["span",{},[["textNode",{"text":"Autumn"}]]]]]]],["if",{"notempty":"","addclass":"logo-text-long"},[["p",{"class":"mobile-logo"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]],[["showDefaultMobileLogo","notempty",true]]]]]]]]],["section",{"class":"splash-page"},[["h2",{"class":"global-title text-color-3"},[["textNode",{"text":"Warning 18+"}]]],["div",{"class":""},[["div",{"data-fox-alias":"splashTitleText","data-fox-context":"splash"},[["p",{},[["textNode",{"text":"Warning, this site is for adults only!"}]]]]]]],["div",{"class":"intro-txt","data-fox-alias":"splashIntroText","data-fox-context":"splash"},[["p",{},[["textNode",{"text":" This site includes explicit sexually oriented material. By continuing to view the following pages you are acknowledging that you are 18 YEARS OF AGE or older. Persons under eighteen (18) years of age, and persons who may be offended by such depictions are not authorized and are forbidden to directly or indirectly access, download, acquire, view, read and listen to, at, in, or through this site. If you proceed and follow a link on this site, you assume full responsibility for your actions. "}]]]]],["div",{"class":"action"},[["a",{"class":"common-btn no bg-color-1-trans-10 text-color-1","href":"https://google.com","rel":"nofollow"},[["div",{"data-fox-alias":"splashExitText"},[["textNode",{"text":" No Thanks "}]]]]],["textNode",{"text":" "}],["a",{"class":"common-btn enter bg-color-2 text-color-1"},[["div",{"data-fox-alias":"splashEnterText"},[["textNode",{"text":" Enter Here "}]]]]]]],["div",{"class":"parents"},[["p",{},[["textNode",{"text":" Parents, please protect your children from adult oriented sites by using any of the following software: "}]]],["a",{"href":"http://www.netnanny.com/","alt":"$","rel":"nofollow"},[["textNode",{"text":"Net Nanny"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"|"}]]],["textNode",{"text":" "}],["a",{"href":"http://www.cyberpatrol.com/","rel":"nofollow"},[["textNode",{"text":"Cyber Patrol"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"|"}]]],["textNode",{"text":" "}],["a",{"href":"http://www.safesurf.com/","rel":"nofollow"},[["textNode",{"text":"Safe Surf"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(478);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_splash.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_splash.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "#splash .left-back,#splash .right-back{display:none}.splash-page{padding-bottom:130px}.splash-page .intro-txt{margin-top:30px;font-size:13px}.splash-page .action{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;margin-top:40px;margin-bottom:40px}.splash-page .action .no{border-top-right-radius:0;border-bottom-right-radius:0;border-width:0}.splash-page .action .enter{border-top-left-radius:0;border-bottom-left-radius:0;border-width:0}.splash-page .parents{font-size:13px;left:30px;right:30px;bottom:30px;position:absolute}.splash-page .parents p{margin-bottom:10px}", ""]);

// exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';

	var require__templates = __webpack_require__(480);
	var templateFiles = require__templates.keys();

	templateFiles.forEach(function (file) {
		require__templates(file)(fox);
	});

	__webpack_require__(484)(fox);
	__webpack_require__(485);
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./emptypurchase.tpl": 481,
	"./grid.tpl": 482,
	"./productBlock.tpl": 483
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("store_purchase_empty", [["div",{"class":"empty-purchase"},[["textNode",{"text":" This is the page where you will easily be able to find everything you have purchased in my store. To start shopping, check out the "}],["a",{"href":"/store","title":"Store"},[["textNode",{"text":"Store"}]]],["textNode",{"text":". "}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_storelist", [["div",{"class":"block background-color-1 store-list-page"},[["div",{"class":"pad-lr pad-tb"},[["div",{"class":"block-title global-title title-with-filter"},[["h2",{"data-fox-alias":"storeTitle","class":"title_block"},[["textNode",{"text":"Store"}]]],["div",{"class":"tags-filter title-with-filter"}]]],["div",{"class":"clearfix"},[["div",{"id":"store-list-wrapper","class":"items store-list-wrapper content-list clearfix grid","itemscope":"","itemtype":"http://schema.org/ItemList"}],["div",{"class":"pager-wrapper"}]]]]],["div",{"class":"next-liveshow"}]]]]);
fox.registerTemplate("store_grid_category", [["a",{"href":"store/&&0&&","class":"grid-item","title":"","itemprop":"itemListElement","itemscope":"","itemtype":"http://schema.org/Product"},[["div",{"class":"grid-item-title","itemprop":"name"},[["textNode",{"text":" "}],["span",{},[],[["contentProduct.contentId.title","__text",true]]],["textNode",{"text":" "}]]]],[["id","href"],["contentProduct.contentId.title","title",true]]]]);
fox.registerTemplate("store_grid_item", [["div",{"class":"store-item","data-attr":"","itemprop":"itemListElement","itemscope":"","itemtype":"http://schema.org/Product"},[["if",{"notempty":"","addclass":"wide"},[],[["contentProduct.contentId._resources.primary.info","notempty",true,[{"name":"isWide","params":[]}]]]],["a",{"href":"product/&&0&&/&&1&&","data-target-id":"","data-target-category":"","data-target-contentid":"","class":"product-image img","title":""},[["if",{"notempty":"","addclass":"product-bought"},[],[["userBoughtProduct","notempty",true]]],["img",{"itemprop":"image","data-src":"","alt":"","class":"lazyload"},[],[["contentProduct.contentId._resources.primary.url","data-src",true],["contentProduct.contentId.title","alt",true]]],["if",{"notempty":""},[["video",{"class":"hov-video","playsinline":"","autoplay":"autoplay","loop":"loop","width":"100%","data-src":""},[],[["contentProduct.contentId._resources.hoverPreview","data-src",true]]],["else",{},[["div",{"class":"baseline"},[["foreach",{"from":"","item":"thumb"},[["img",{"class":"loadImg _hidden","data-img":""},[],[["thumb.url","data-img",true]]]],[["contentProduct.contentId._resources.base","from",true]]]]]]]],[["contentProduct.contentId._resources.hoverPreview","notempty",true]]],["div",{"class":"grid-item-data"},[["p",{"class":"title","itemprop":"name"},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["contentProduct.contentId.title","__text",true,[{"name":"truncate","params":["27","..."]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":" "}],["span",{},[],[["contentProduct.contentId.title","__text",true]]],["textNode",{"text":" "}]]]],[["contentProduct.contentId.title","notempty",true,[{"name":"count","params":[]},{"name":"gt","params":["30"]}]]]]]],["p",{"class":"publish-date"},[["if",{"notempty":""},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["contentProduct.contentId.length","__text",true,[{"name":"timeLength","params":["h m"]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":" "}],["span",{},[],[["contentProduct.contentId.length","__text",true]]],["textNode",{"text":" sec "}]]],["if",{"notempty":""},[["span",{"class":"info-delim"},[["textNode",{"text":"|"}]]],["if",{"notempty":""},[["textNode",{"text":" SD "}]],[["contentProduct.contentId.sourceFormat","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":""},[["textNode",{"text":" 720p. "}]],[["contentProduct.contentId.sourceFormat","notempty",true,[{"name":"eq","params":["2"]}]]]],["if",{"notempty":""},[["textNode",{"text":" 1080p. "}]],[["contentProduct.contentId.sourceFormat","notempty",true,[{"name":"eq","params":["3"]}]]]],["if",{"notempty":""},[["textNode",{"text":" 2160p. "}]],[["contentProduct.contentId.sourceFormat","notempty",true,[{"name":"eq","params":["4"]}]]]]],[["contentProduct.contentId.sourceFormat","notempty",true]]]],[["contentProduct.contentId.length","notempty",true,[{"name":"gt","params":["60"]}]]]],["else",{},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["contentProduct.contentId._numberPhotos","__text",true]]],["textNode",{"text":" "}],["span",{"class":"pics"},[["textNode",{"text":"photos "}],["span",{"class":"info-delim"},[["textNode",{"text":"|"}]]],["textNode",{"text":" High-resolution"}]]]],[["contentProduct.contentId.contentType","notempty",true,[{"name":"eq","params":["40"]}]]]]]]],[["contentProduct.contentId.contentType","notempty",true,[{"name":"eq","params":["41"]}]]]]]]]]],[["id","href"],["contentProduct.contentId.title","href",false,[{"name":"toNavigatorAlias","params":[]}]],["id","data-target-id",true],["categories.categoryId","data-target-category",true],["extender.contentId","data-target-contentid",true],["contentProduct.contentId.title","title",true]]],["if",{"notempty":""},[["div",{"class":"over-timeline","data-target-id":""},[["div",{"class":"progressbar"},[["div",{"class":"filling"}]]]],[["id","data-target-id",true]]]],[["contentProduct.contentId.contentType","notempty",true,[{"name":"eq","params":["41"]}]]]],["div",{"class":"field-set btns list-buy-now","itemprop":"offers","itemscope":"","itemtype":"http://schema.org/Offer"},[["if",{"empty":""},[["span",{"class":"price","itemprop":"price","content":""},[["meta",{"itemprop":"priceCurrency","content":""},[],[["price","content",true]]],["textNode",{"text":" $"}],["span",{},[],[["price","__text",true]]],["textNode",{"text":" "}]],[["price","content",true]]],["textNode",{"text":" "}],["a",{"href":"product/&&0&&/&&1&&","data-target-id":"","class":"mc-common-button decorated"},[["textNode",{"text":"buy!"}]],[["id","href"],["contentProduct.contentId.title","href",false,[{"name":"toNavigatorAlias","params":[]}]],["id","data-target-id",true]]],["else",{},[["span",{"class":"purchased"},[["i",{"class":"icon-au_purchased_10"}],["textNode",{"text":" "}],["span",{"class":"purchased-text"},[["textNode",{"text":"Purchased"}]]]]],["textNode",{"text":" "}],["a",{"href":"product/&&0&&/&&1&&","data-target-id":"","class":"mc-common-button decorated"},[["if",{"notempty":""},[["textNode",{"text":" watch! "}],["else",{},[["textNode",{"text":" view! "}]]]],[["contentProduct.contentId.contentType","notempty",true,[{"name":"eq","params":["41"]}]]]]],[["id","href"],["contentProduct.contentId.title","href",false,[{"name":"toNavigatorAlias","params":[]}]],["id","data-target-id",true]]]]]],[["userBoughtProduct","empty",true]]]]]],[["contentProduct.contentId.sourceFormat","data-attr",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_store_productblock", [["div",{"class":"store-product-page content-block content-page"},[["div",{"class":"pad-lr pad-tb"},[["div",{"class":"title-block clearfix"},[["if",{"notempty":""},[["div",{"class":"user-menu-item"},[["a",{"href":"/store","class":"back-to-store"},[["i",{"class":"icon-au_backToStore_7"}],["textNode",{"text":" "}],["span",{"class":"text"},[["textNode",{"text":"Back to store"}]]]]]]],["else",{},[["if",{"notempty":""},[["div",{"class":"user-menu-item"},[["a",{"href":"/purchases","class":"back-to-store"},[["i",{"class":"icon-au_backToStore_7"}],["textNode",{"text":" "}],["span",{"class":"text"},[["textNode",{"text":"Back to purchases"}]]]]]]]],[["member.hasPurchasedProducts","notempty",true,[],"env"]]],["else"]]]],[["store.enabled","notempty",true,[],"env"]]],["div",{"class":"global-title"},[["span",{},[],[["contentProduct.contentId.title","__text",true]]]]]]],["import",{"name":"store_product_logic"}],["import",{"name":"report"}],["if",{"notempty":""},[["div",{"id":"comment-form","class":"comments-block comments-block-wrapper reviews","data-target-id":""},[],[["id","data-target-id",true]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]],["div",{"class":"related-container last-added-videos-wrapper"}]]],["div",{"class":"next-liveshow"}]]]]);
fox.registerTemplate("store_gallery_container", [["div",{"class":"block-with-label"},[["div",{"id":"gallery-cut","class":"photos-list"}],["div",{"id":"gallery-all"}],["div",{"class":"more-photos"},[["button",{"class":"bg-color-2 text-color-1 common-btn show-more","id":"show-all-photos"},[["textNode",{"text":"Show all photos "}],["i",{"class":"icon-au_drop"}]]]]]]]]);
fox.registerTemplate("store_grid_related", [["div",{"id":"related"},[["div",{"class":"global-title text-color-2"},[["textNode",{"text":"Related products"}]]],["section",{"class":"content-grid store-grid store-related"}]]]]);
fox.registerTemplate("store_buynow_button", [["button",{"id":"buy-now","class":"mc-common-button decorated post-comment buy-now-btn","type":"submit","name":"submit"},[["textNode",{"text":"BUY NOW!"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Store_List #storeDl":{"limit":[{"value":18,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Store_List #storeDl","_fox_":1}]},"~.Store_Categories_Select #selectCategories":{"selectIconClass":[{"value":"icon-au_categories_16","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.Store_Categories_Select #selectCategories","_fox_":1}],"selectArrClass":[{"value":"icon-au_drop_6","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.Store_Categories_Select #selectCategories","_fox_":1}]},"~.Store_Content #currentRating":{"template":[{"value":"social_rating","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.Store_Content #currentRating","_fox_":1}],"templateOptions.iconLike":[{"value":"icon-au_like","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.Store_Content #currentRating","_fox_":1}],"templateOptions.iconDislike":[{"value":"icon-au_dislike","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.Store_Content #currentRating","_fox_":1}]},"~.Store_PurchasesList #purchasesList":{"tpl.row":[{"value":"store_grid_item","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107017},"path":"~.Store_PurchasesList #purchasesList","_fox_":1}]},"~.Store_PurchasesList #purchasesList #list":{"hooks.onStartInit":[{"value":function() {
this.hoverVideo = __webpack_require__(27)(fox);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"hooks.onStopRendering":[{"value":function() {
var elmArr = this.dom('.over-timeline');
this.hoverVideo.handleTouch(elmArr, this)
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"handleDom.following.target":[{"value":".over-timeline","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107029},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"handleDom.following.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"handleDom.following.callback":[{"value":function (elt) {
this.hoverVideo.followingLink(elt)
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107033},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"handleDom.addPrevVideo.event":[{"value":"mouseover","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107035},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"handleDom.addPrevVideo.target":[{"value":".over-timeline","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107036},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"handleDom.addPrevVideo.callback":[{"value":function (elt) {
if (fox.utils.isTouchDevice()) return;
this.hoverVideo.hoverPreviewVideo(elt, this);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"handleDom.removePrevVideo.event":[{"value":"mouseleave","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"handleDom.removePrevVideo.target":[{"value":".over-timeline","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}],"handleDom.removePrevVideo.callback":[{"value":function (elt) {
this.hoverVideo.stopHoverPreviewVideo(elt, this)
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107047},"path":"~.Store_PurchasesList #purchasesList #list","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(486);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_store.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_store.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".store-list-page{position:relative}.store-list-page .next-liveshow .liveshow-timer,.store-product-page .next-liveshow .liveshow-timer{margin-bottom:0;padding-bottom:30px}.store-product-page .content-report{padding:10px}.content-list.store-list-wrapper.grid>div{width:100%}.content-list.store-list-wrapper.grid>div:first-child,.content-list.store-list-wrapper.grid>div:last-child{float:none}.category-select{position:relative;font-family:Arial,Helvetica,sans-serif;line-height:normal}.category-select .view-category-list.list-wrapper{padding:20px}.category-select .view-category-list.list-wrapper .view-category-list-item{padding:10px 15px;text-transform:uppercase;font-size:12px;color:#fff;font-weight:700}.category-select .current{padding:10px 17px;border-radius:3px}.category-select .current.open{border-radius:3px 3px 0 0}.category-select .current .icon-au_categories_16{font-size:16px}.category-select .current .txt{font-size:12px;text-transform:uppercase;padding-left:10px}.category-select .current .arr{font-size:6px;padding-left:5px}.guest-confirm-popup .msg-block .row{margin-top:15px;position:relative}.guest-confirm-popup .msg-block .row .error{z-index:5;position:relative}.guest-confirm-popup .msg-block .row .error+.error-message{position:absolute;left:0;right:0;top:0;bottom:0;margin:0;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;font-size:12px;line-height:14px;z-index:1;width:100%}.guest-confirm-popup .msg-block .row .error input{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.content-grid.store-grid{display:block}.content-grid.store-grid .store-item{width:100%;padding-top:calc(100% + 67px);height:0;position:relative;margin-bottom:10px;overflow:hidden;border-radius:3px;display:inline-block}.content-grid.store-grid .store-item img{min-width:100%}.content-grid.store-grid .store-item .product-image{position:absolute;top:0;left:0;width:100%;height:calc(100% - 67px)}.content-grid.store-grid .store-item .product-image .grid-item-data{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;position:absolute;bottom:0;width:100%;padding:14px 0 9px;height:67px}.content-grid.store-grid .store-item .product-image .grid-item-data .publish-date{font-size:11px;text-align:center}.content-grid.store-grid .store-item .product-image .grid-item-data .title{font-size:24px;font-weight:700;text-align:center;font-family:simplifica}.content-grid.store-grid .store-item .over-timeline{cursor:pointer;width:100%;position:absolute;top:0;padding-top:90%;z-index:10}.content-grid.store-grid .store-item .over-timeline .progressbar{position:absolute;top:0;display:-ms-flexbox;display:flex;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;width:100%;height:3px}.content-grid.store-grid .store-item .over-timeline .progressbar .filling{height:3px}.content-grid.store-grid .store-item.loaderhover .filling,.content-grid.store-grid .store-item .over-timeline:hover .filling{animation:bar .8s linear}.content-grid.store-grid .store-item.previewVideo video{display:block}.content-grid.store-grid .store-item .baseline{position:relative;height:calc(100% - 67px)}.content-grid.store-grid .store-item .field-set{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center;position:absolute;bottom:0;height:67px;width:100%;padding:0 20px;box-sizing:border-box;z-index:3}.content-grid.store-grid .store-item .field-set .price{font-size:26px}.content-grid.store-grid .store-item .field-set .purchased{font-size:12px}.content-grid.store-grid .store-item .field-set .purchased .icon-au_purchased_10{font-size:10px}.content-grid.store-grid .store-item .field-set .purchased-text{padding-left:5px}.content-grid.store-grid .store-item .field-set .mc-common-button{font-size:12px;height:37px;line-height:35px;min-width:68px}.content-grid .wide{text-align:center}.content-grid .wide img,.content-grid .wide video{position:relative;left:50%;max-height:100%;width:auto;max-width:none;transform:translate(-50%)}.content-grid .wide video{min-height:100%}.store-product-page .title-block{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.store-product-page .back-to-store{font-size:12px;padding-bottom:3px;display:inline-block}.store-product-page .back-to-store .text{font-weight:700;vertical-align:middle;padding-left:5px}.store-product-page .back-to-store .icon-au_backToStore_7{font-size:7px}.store-product-page .price{font-size:40px;font-family:simplifica}.store-product-page .price .label{display:none}.store-product-page .photos-cover{border-radius:3px;overflow:hidden;text-align:center}.store-product-page .content-description .label{font-size:30px;line-height:30px;font-family:simplifica;padding-bottom:20px}.store-product-page .content-description .short-desc span{font-size:14px;line-height:1.42;display:block;display:-webkit-box;height:59.64px;margin:0 auto;-webkit-line-clamp:3;overflow:hidden;text-overflow:ellipsis}.store-product-page .content-description .full-desc{line-height:20px}.store-product-page .content-description .desc-toggle{height:auto;line-height:20px;position:relative}.store-product-page .content-description .desc-toggle.show-more:after{content:\"\";width:0;height:0;border-style:solid;border-width:5px 4px 0;position:absolute;line-height:0;top:9px;margin-left:5px}.store-product-page .comments-block-wrapper{margin-top:20px}.store-product-page .related-container{margin-top:40px}.store-product-page .purchased .content-actions{border-width:3px 0}.product-wrapper-video{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.product-wrapper-video .product-preview{-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-moz-order:1;-ms-flex-order:1;order:1}.product-wrapper-video .content-description{-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-moz-order:3;-ms-flex-order:3;order:3;margin-top:25px}.product-wrapper-video .buy-item-block{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-moz-order:2;-ms-flex-order:2;order:2;margin-top:10px;padding:15px;border-radius:2px;box-sizing:border-box}.product-wrapper-video .buy-item-block .price{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}.product-wrapper-video.purchased{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.product-wrapper-video.purchased .product-preview{margin-bottom:0;max-width:100%}.product-wrapper-video.purchased .content-actions.new-wrap{-moz-order:2;-ms-flex-order:2;order:2}.product-wrapper-video .unpurchased-video{-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;position:relative;width:100%}@media (min-width:768px){.product-wrapper-video{-ms-flex-flow:row wrap;flex-flow:row wrap}.product-wrapper-video .product-preview{width:100%;-ms-flex-line-pack:stretch;align-content:stretch}.product-wrapper-video .content-description{-moz-flex:10 0;-ms-flex:10 0;flex:10 0;-moz-order:2;-ms-flex-order:2;order:2;margin:30px 40px 0 0}.product-wrapper-video .buy-item-block{-moz-order:3;-ms-flex-order:3;order:3;-moz-flex:1 0;-ms-flex:1 0;flex:1 0;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;width:210px;min-width:210px;height:166px;margin-top:30px;padding:30px}.product-wrapper-video .buy-item-block .price{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}}.product-wrapper-video{padding-bottom:30px;border-width:0 0 3px;border-style:solid}.product-wrapper-video.purchased{border:none}.product-wrapper-photo{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;border-radius:2px}.product-wrapper-photo .product-preview{-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-moz-order:1;-ms-flex-order:1;order:1;width:46%;margin-right:5px}.product-wrapper-photo .buy-item-block{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-moz-order:2;-ms-flex-order:2;order:2;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;box-sizing:border-box;max-width:50%;text-align:center}.product-wrapper-photo .buy-item-block .label{display:none}.product-wrapper-photo .photo-buy{-moz-order:3;-ms-flex-order:3;order:3;width:100%}.product-wrapper-photo .photo-buy .buy-item-block{display:none}.product-wrapper-photo.purchased{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.product-wrapper-photo.purchased .product-preview{width:100%;max-width:none}.product-wrapper-photo.purchased .content-actions.new-wrap{-moz-order:2;-ms-flex-order:2;order:2}.product-wrapper-photo.purchased .content-description{-moz-order:3;-ms-flex-order:3;order:3}@media (min-width:550px){.product-wrapper-photo .product-preview{max-width:30%}.product-wrapper-photo .buy-item-block{display:none}.product-wrapper-photo .photo-buy{-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;width:55%;min-width:55%}.product-wrapper-photo .photo-buy,.product-wrapper-photo .photo-buy .buy-item-block{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.product-wrapper-photo .photo-buy .buy-item-block{-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;max-width:none}.product-wrapper-photo .photo-buy .buy-item-block .label{display:inline-block}.product-wrapper-photo .photo-buy .buy-item-block .price{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:baseline;-moz-align-items:baseline;align-items:baseline;-ms-flex-item-align:center;align-self:center}.product-wrapper-photo .photo-buy .content-description{-moz-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}}.product-wrapper-photo{padding-bottom:30px;border-width:0 0 3px;border-style:solid}.product-wrapper-photo.purchased{border:none}.product-wrapper-photo .buy-item-block{margin-left:5px;padding:35px 15px 25px;border-radius:2px}.product-wrapper-photo .content-description{margin-top:25px}@media (min-width:550px){.product-wrapper-photo .photo-buy{margin-left:15px}.product-wrapper-photo .photo-buy .buy-item-block{padding:20px 30px;margin:0;height:86px;max-height:86px}.product-wrapper-photo .content-description{margin-top:0}}@media (min-width:535px){.content-grid.store-grid .store-item{width:calc(100% / 2 - 10px);padding-top:calc(50% + 67px - 10px);margin-bottom:20px;margin-right:20px}.content-grid.store-grid .store-item:nth-child(2n){margin-right:0}}@media (min-width:768px){.content-grid.store-grid .store-item{width:calc(100% / 3 - 14px);padding-top:calc(100% / 3 + 67px - 14px);margin-bottom:20px}.content-grid.store-grid .store-item:nth-child(2n){margin-right:20px}.content-grid.store-grid .store-item:nth-child(3n){margin-right:0}.store-product-page.content-page .title-block .global-title{font-size:45px;line-height:45px}.store-product-page .product-wrapper-video .buy-item-block .price{font-size:55px;padding-top:10px}.category-select .current .txt{display:inline-block}}@media (min-width:1000px){.store-list-page .block-title{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}.store-list-page .tags-filter{margin-left:0}.category-select{display:-moz-flex;display:-ms-flexbox;display:flex;float:none}.category-select .current{display:none}.category-select .view-category-list.list-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-flow:row wrap;flex-flow:row wrap;max-height:none;-webkit-transform:initial;overflow:visible;width:100%;border:none;float:none;position:relative;padding:0;margin-top:15px}.category-select .view-category-list .view-category-list-item{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;height:42px;font-size:12px;white-space:nowrap;border-radius:3px;margin:0 2px 2px 0}.category-select .view-category-list .view-category-list-item:last-child{margin-right:0}}@keyframes bar{0%{width:0}to{width:100%}}", ""]);

// exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./splash.js": 488
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 487;

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	fox.registerWidget('Splash', {

		configure: function (options) {
			this.registerOptions('', {
				'embed.container': '.wrapper',
				'embed.location': 'under', // this location for SEO
				template: 'layout_splash',
				autoRender: true,
				active: true,
				group: 'splash',
				widgets: {
					splashBody: {
						widget: 'Widget',
						autoRender: true,
						'embed.container': '#container',
						template: 'sitepage_splash',
						'handleDom.enterSite': {
							event: 'click',
							target: '.enter',
							callback: this.enterSite.bind(this)
						},
					}
				}
			});

			this.callParent('configure', arguments);
		},

		activate: function() {
			this.callParent('activate', arguments);
			this.toggleOverflow(true);
		},

		deactivate: function() {
			this.callParent('deactivate', arguments);
			this.toggleOverflow();
		},

		toggleOverflow: function(hidden) {
			$('html').css('overflow', hidden ? 'hidden' : '');
		},

		enterSite: function () {
			var retUrl = fox.Navigator.get(0);
			var video = $('video')[0];
			var autoPlay = Number(fox.site.environment.siteProps.welcomeVideoAutoplay);

			fox.cookie.set('splash', 1);
			fox.site.showSplash = false;

			if (!!video && !!autoPlay) {
				video.play();
			}
			
			if(fox.Navigator.get(0) == 'splash'){
				fox.site.gotoPage('', { skipEvent: true });
			}
			
			$('#splash').remove();
			this.toggleOverflow();
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(490);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_splash.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_splash.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "#splash{position:fixed;height:100vh;width:100vw;z-index:100;overflow:auto;top:0}", ""]);

// exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Dialog 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/dialog/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(4),
			__webpack_require__(8),
			__webpack_require__(9),
			__webpack_require__(492),
			__webpack_require__(493),
			__webpack_require__(31),
			__webpack_require__(494),
			__webpack_require__(495)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

return $.widget( "ui.dialog", {
	version: "1.11.4",
	options: {
		appendTo: "body",
		autoOpen: true,
		buttons: [],
		closeOnEscape: true,
		closeText: "Close",
		dialogClass: "",
		draggable: true,
		hide: null,
		height: "auto",
		maxHeight: null,
		maxWidth: null,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: "center",
			at: "center",
			of: window,
			collision: "fit",
			// Ensure the titlebar is always visible
			using: function( pos ) {
				var topOffset = $( this ).css( pos ).offset().top;
				if ( topOffset < 0 ) {
					$( this ).css( "top", pos.top - topOffset );
				}
			}
		},
		resizable: true,
		show: null,
		title: null,
		width: 300,

		// callbacks
		beforeClose: null,
		close: null,
		drag: null,
		dragStart: null,
		dragStop: null,
		focus: null,
		open: null,
		resize: null,
		resizeStart: null,
		resizeStop: null
	},

	sizeRelatedOptions: {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},

	resizableRelatedOptions: {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},

	_create: function() {
		this.originalCss = {
			display: this.element[ 0 ].style.display,
			width: this.element[ 0 ].style.width,
			minHeight: this.element[ 0 ].style.minHeight,
			maxHeight: this.element[ 0 ].style.maxHeight,
			height: this.element[ 0 ].style.height
		};
		this.originalPosition = {
			parent: this.element.parent(),
			index: this.element.parent().children().index( this.element )
		};
		this.originalTitle = this.element.attr( "title" );
		this.options.title = this.options.title || this.originalTitle;

		this._createWrapper();

		this.element
			.show()
			.removeAttr( "title" )
			.addClass( "ui-dialog-content ui-widget-content" )
			.appendTo( this.uiDialog );

		this._createTitlebar();
		this._createButtonPane();

		if ( this.options.draggable && $.fn.draggable ) {
			this._makeDraggable();
		}
		if ( this.options.resizable && $.fn.resizable ) {
			this._makeResizable();
		}

		this._isOpen = false;

		this._trackFocus();
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;
		if ( element && (element.jquery || element.nodeType) ) {
			return $( element );
		}
		return this.document.find( element || "body" ).eq( 0 );
	},

	_destroy: function() {
		var next,
			originalPosition = this.originalPosition;

		this._untrackInstance();
		this._destroyOverlay();

		this.element
			.removeUniqueId()
			.removeClass( "ui-dialog-content ui-widget-content" )
			.css( this.originalCss )
			// Without detaching first, the following becomes really slow
			.detach();

		this.uiDialog.stop( true, true ).remove();

		if ( this.originalTitle ) {
			this.element.attr( "title", this.originalTitle );
		}

		next = originalPosition.parent.children().eq( originalPosition.index );
		// Don't try to place the dialog next to itself (#8613)
		if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
			next.before( this.element );
		} else {
			originalPosition.parent.append( this.element );
		}
	},

	widget: function() {
		return this.uiDialog;
	},

	disable: $.noop,
	enable: $.noop,

	close: function( event ) {
		var activeElement,
			that = this;

		if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
			return;
		}

		this._isOpen = false;
		this._focusedElement = null;
		this._destroyOverlay();
		this._untrackInstance();

		if ( !this.opener.filter( ":focusable" ).focus().length ) {

			// support: IE9
			// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
			try {
				activeElement = this.document[ 0 ].activeElement;

				// Support: IE9, IE10
				// If the <body> is blurred, IE will switch windows, see #4520
				if ( activeElement && activeElement.nodeName.toLowerCase() !== "body" ) {

					// Hiding a focused element doesn't trigger blur in WebKit
					// so in case we have nothing to focus on, explicitly blur the active element
					// https://bugs.webkit.org/show_bug.cgi?id=47182
					$( activeElement ).blur();
				}
			} catch ( error ) {}
		}

		this._hide( this.uiDialog, this.options.hide, function() {
			that._trigger( "close", event );
		});
	},

	isOpen: function() {
		return this._isOpen;
	},

	moveToTop: function() {
		this._moveToTop();
	},

	_moveToTop: function( event, silent ) {
		var moved = false,
			zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map(function() {
				return +$( this ).css( "z-index" );
			}).get(),
			zIndexMax = Math.max.apply( null, zIndices );

		if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
			this.uiDialog.css( "z-index", zIndexMax + 1 );
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}
		return moved;
	},

	open: function() {
		var that = this;
		if ( this._isOpen ) {
			if ( this._moveToTop() ) {
				this._focusTabbable();
			}
			return;
		}

		this._isOpen = true;
		this.opener = $( this.document[ 0 ].activeElement );

		this._size();
		this._position();
		this._createOverlay();
		this._moveToTop( null, true );

		// Ensure the overlay is moved to the top with the dialog, but only when
		// opening. The overlay shouldn't move after the dialog is open so that
		// modeless dialogs opened after the modal dialog stack properly.
		if ( this.overlay ) {
			this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
		}

		this._show( this.uiDialog, this.options.show, function() {
			that._focusTabbable();
			that._trigger( "focus" );
		});

		// Track the dialog immediately upon openening in case a focus event
		// somehow occurs outside of the dialog before an element inside the
		// dialog is focused (#10152)
		this._makeFocusTarget();

		this._trigger( "open" );
	},

	_focusTabbable: function() {
		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// 5. The close button
		// 6. The dialog itself
		var hasFocus = this._focusedElement;
		if ( !hasFocus ) {
			hasFocus = this.element.find( "[autofocus]" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.element.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialog;
		}
		hasFocus.eq( 0 ).focus();
	},

	_keepFocus: function( event ) {
		function checkFocus() {
			var activeElement = this.document[0].activeElement,
				isActive = this.uiDialog[0] === activeElement ||
					$.contains( this.uiDialog[0], activeElement );
			if ( !isActive ) {
				this._focusTabbable();
			}
		}
		event.preventDefault();
		checkFocus.call( this );
		// support: IE
		// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
		// so we check again later
		this._delay( checkFocus );
	},

	_createWrapper: function() {
		this.uiDialog = $("<div>")
			.addClass( "ui-dialog ui-widget ui-widget-content ui-corner-all ui-front " +
				this.options.dialogClass )
			.hide()
			.attr({
				// Setting tabIndex makes the div focusable
				tabIndex: -1,
				role: "dialog"
			})
			.appendTo( this._appendTo() );

		this._on( this.uiDialog, {
			keydown: function( event ) {
				if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
					event.preventDefault();
					this.close( event );
					return;
				}

				// prevent tabbing out of dialogs
				if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
					return;
				}
				var tabbables = this.uiDialog.find( ":tabbable" ),
					first = tabbables.filter( ":first" ),
					last = tabbables.filter( ":last" );

				if ( ( event.target === last[0] || event.target === this.uiDialog[0] ) && !event.shiftKey ) {
					this._delay(function() {
						first.focus();
					});
					event.preventDefault();
				} else if ( ( event.target === first[0] || event.target === this.uiDialog[0] ) && event.shiftKey ) {
					this._delay(function() {
						last.focus();
					});
					event.preventDefault();
				}
			},
			mousedown: function( event ) {
				if ( this._moveToTop( event ) ) {
					this._focusTabbable();
				}
			}
		});

		// We assume that any existing aria-describedby attribute means
		// that the dialog content is marked up properly
		// otherwise we brute force the content as the description
		if ( !this.element.find( "[aria-describedby]" ).length ) {
			this.uiDialog.attr({
				"aria-describedby": this.element.uniqueId().attr( "id" )
			});
		}
	},

	_createTitlebar: function() {
		var uiDialogTitle;

		this.uiDialogTitlebar = $( "<div>" )
			.addClass( "ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix" )
			.prependTo( this.uiDialog );
		this._on( this.uiDialogTitlebar, {
			mousedown: function( event ) {
				// Don't prevent click on close button (#8838)
				// Focusing a dialog that is partially scrolled out of view
				// causes the browser to scroll it into view, preventing the click event
				if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {
					// Dialog isn't getting focus when dragging (#8063)
					this.uiDialog.focus();
				}
			}
		});

		// support: IE
		// Use type="button" to prevent enter keypresses in textboxes from closing the
		// dialog in IE (#9312)
		this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
			.button({
				label: this.options.closeText,
				icons: {
					primary: "ui-icon-closethick"
				},
				text: false
			})
			.addClass( "ui-dialog-titlebar-close" )
			.appendTo( this.uiDialogTitlebar );
		this._on( this.uiDialogTitlebarClose, {
			click: function( event ) {
				event.preventDefault();
				this.close( event );
			}
		});

		uiDialogTitle = $( "<span>" )
			.uniqueId()
			.addClass( "ui-dialog-title" )
			.prependTo( this.uiDialogTitlebar );
		this._title( uiDialogTitle );

		this.uiDialog.attr({
			"aria-labelledby": uiDialogTitle.attr( "id" )
		});
	},

	_title: function( title ) {
		if ( !this.options.title ) {
			title.html( "&#160;" );
		}
		title.text( this.options.title );
	},

	_createButtonPane: function() {
		this.uiDialogButtonPane = $( "<div>" )
			.addClass( "ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" );

		this.uiButtonSet = $( "<div>" )
			.addClass( "ui-dialog-buttonset" )
			.appendTo( this.uiDialogButtonPane );

		this._createButtons();
	},

	_createButtons: function() {
		var that = this,
			buttons = this.options.buttons;

		// if we already have a button pane, remove it
		this.uiDialogButtonPane.remove();
		this.uiButtonSet.empty();

		if ( $.isEmptyObject( buttons ) || ($.isArray( buttons ) && !buttons.length) ) {
			this.uiDialog.removeClass( "ui-dialog-buttons" );
			return;
		}

		$.each( buttons, function( name, props ) {
			var click, buttonOptions;
			props = $.isFunction( props ) ?
				{ click: props, text: name } :
				props;
			// Default to a non-submitting button
			props = $.extend( { type: "button" }, props );
			// Change the context for the click callback to be the main element
			click = props.click;
			props.click = function() {
				click.apply( that.element[ 0 ], arguments );
			};
			buttonOptions = {
				icons: props.icons,
				text: props.showText
			};
			delete props.icons;
			delete props.showText;
			$( "<button></button>", props )
				.button( buttonOptions )
				.appendTo( that.uiButtonSet );
		});
		this.uiDialog.addClass( "ui-dialog-buttons" );
		this.uiDialogButtonPane.appendTo( this.uiDialog );
	},

	_makeDraggable: function() {
		var that = this,
			options = this.options;

		function filteredUi( ui ) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		this.uiDialog.draggable({
			cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
			handle: ".ui-dialog-titlebar",
			containment: "document",
			start: function( event, ui ) {
				$( this ).addClass( "ui-dialog-dragging" );
				that._blockFrames();
				that._trigger( "dragStart", event, filteredUi( ui ) );
			},
			drag: function( event, ui ) {
				that._trigger( "drag", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var left = ui.offset.left - that.document.scrollLeft(),
					top = ui.offset.top - that.document.scrollTop();

				options.position = {
					my: "left top",
					at: "left" + (left >= 0 ? "+" : "") + left + " " +
						"top" + (top >= 0 ? "+" : "") + top,
					of: that.window
				};
				$( this ).removeClass( "ui-dialog-dragging" );
				that._unblockFrames();
				that._trigger( "dragStop", event, filteredUi( ui ) );
			}
		});
	},

	_makeResizable: function() {
		var that = this,
			options = this.options,
			handles = options.resizable,
			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = this.uiDialog.css("position"),
			resizeHandles = typeof handles === "string" ?
				handles	:
				"n,e,s,w,se,sw,ne,nw";

		function filteredUi( ui ) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		this.uiDialog.resizable({
			cancel: ".ui-dialog-content",
			containment: "document",
			alsoResize: this.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: this._minHeight(),
			handles: resizeHandles,
			start: function( event, ui ) {
				$( this ).addClass( "ui-dialog-resizing" );
				that._blockFrames();
				that._trigger( "resizeStart", event, filteredUi( ui ) );
			},
			resize: function( event, ui ) {
				that._trigger( "resize", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var offset = that.uiDialog.offset(),
					left = offset.left - that.document.scrollLeft(),
					top = offset.top - that.document.scrollTop();

				options.height = that.uiDialog.height();
				options.width = that.uiDialog.width();
				options.position = {
					my: "left top",
					at: "left" + (left >= 0 ? "+" : "") + left + " " +
						"top" + (top >= 0 ? "+" : "") + top,
					of: that.window
				};
				$( this ).removeClass( "ui-dialog-resizing" );
				that._unblockFrames();
				that._trigger( "resizeStop", event, filteredUi( ui ) );
			}
		})
		.css( "position", position );
	},

	_trackFocus: function() {
		this._on( this.widget(), {
			focusin: function( event ) {
				this._makeFocusTarget();
				this._focusedElement = $( event.target );
			}
		});
	},

	_makeFocusTarget: function() {
		this._untrackInstance();
		this._trackingInstances().unshift( this );
	},

	_untrackInstance: function() {
		var instances = this._trackingInstances(),
			exists = $.inArray( this, instances );
		if ( exists !== -1 ) {
			instances.splice( exists, 1 );
		}
	},

	_trackingInstances: function() {
		var instances = this.document.data( "ui-dialog-instances" );
		if ( !instances ) {
			instances = [];
			this.document.data( "ui-dialog-instances", instances );
		}
		return instances;
	},

	_minHeight: function() {
		var options = this.options;

		return options.height === "auto" ?
			options.minHeight :
			Math.min( options.minHeight, options.height );
	},

	_position: function() {
		// Need to show the dialog to get the actual offset in the position plugin
		var isVisible = this.uiDialog.is( ":visible" );
		if ( !isVisible ) {
			this.uiDialog.show();
		}
		this.uiDialog.position( this.options.position );
		if ( !isVisible ) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var that = this,
			resize = false,
			resizableOptions = {};

		$.each( options, function( key, value ) {
			that._setOption( key, value );

			if ( key in that.sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in that.resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		});

		if ( resize ) {
			this._size();
			this._position();
		}
		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function( key, value ) {
		var isDraggable, isResizable,
			uiDialog = this.uiDialog;

		if ( key === "dialogClass" ) {
			uiDialog
				.removeClass( this.options.dialogClass )
				.addClass( value );
		}

		if ( key === "disabled" ) {
			return;
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.uiDialog.appendTo( this._appendTo() );
		}

		if ( key === "buttons" ) {
			this._createButtons();
		}

		if ( key === "closeText" ) {
			this.uiDialogTitlebarClose.button({
				// Ensure that we always pass a string
				label: "" + value
			});
		}

		if ( key === "draggable" ) {
			isDraggable = uiDialog.is( ":data(ui-draggable)" );
			if ( isDraggable && !value ) {
				uiDialog.draggable( "destroy" );
			}

			if ( !isDraggable && value ) {
				this._makeDraggable();
			}
		}

		if ( key === "position" ) {
			this._position();
		}

		if ( key === "resizable" ) {
			// currently resizable, becoming non-resizable
			isResizable = uiDialog.is( ":data(ui-resizable)" );
			if ( isResizable && !value ) {
				uiDialog.resizable( "destroy" );
			}

			// currently resizable, changing handles
			if ( isResizable && typeof value === "string" ) {
				uiDialog.resizable( "option", "handles", value );
			}

			// currently non-resizable, becoming resizable
			if ( !isResizable && value !== false ) {
				this._makeResizable();
			}
		}

		if ( key === "title" ) {
			this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
		}
	},

	_size: function() {
		// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		// divs will both have width and height set, so we need to reset them
		var nonContentHeight, minContentHeight, maxContentHeight,
			options = this.options;

		// Reset content sizing
		this.element.show().css({
			width: "auto",
			minHeight: 0,
			maxHeight: "none",
			height: 0
		});

		if ( options.minWidth > options.width ) {
			options.width = options.minWidth;
		}

		// reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css({
				height: "auto",
				width: options.width
			})
			.outerHeight();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		maxContentHeight = typeof options.maxHeight === "number" ?
			Math.max( 0, options.maxHeight - nonContentHeight ) :
			"none";

		if ( options.height === "auto" ) {
			this.element.css({
				minHeight: minContentHeight,
				maxHeight: maxContentHeight,
				height: "auto"
			});
		} else {
			this.element.height( Math.max( 0, options.height - nonContentHeight ) );
		}

		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
		}
	},

	_blockFrames: function() {
		this.iframeBlocks = this.document.find( "iframe" ).map(function() {
			var iframe = $( this );

			return $( "<div>" )
				.css({
					position: "absolute",
					width: iframe.outerWidth(),
					height: iframe.outerHeight()
				})
				.appendTo( iframe.parent() )
				.offset( iframe.offset() )[0];
		});
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_allowInteraction: function( event ) {
		if ( $( event.target ).closest( ".ui-dialog" ).length ) {
			return true;
		}

		// TODO: Remove hack when datepicker implements
		// the .ui-front logic (#8989)
		return !!$( event.target ).closest( ".ui-datepicker" ).length;
	},

	_createOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		// We use a delay in case the overlay is created from an
		// event that we're going to be cancelling (#2804)
		var isOpening = true;
		this._delay(function() {
			isOpening = false;
		});

		if ( !this.document.data( "ui-dialog-overlays" ) ) {

			// Prevent use of anchors and inputs
			// Using _on() for an event handler shared across many instances is
			// safe because the dialogs stack and must be closed in reverse order
			this._on( this.document, {
				focusin: function( event ) {
					if ( isOpening ) {
						return;
					}

					if ( !this._allowInteraction( event ) ) {
						event.preventDefault();
						this._trackingInstances()[ 0 ]._focusTabbable();
					}
				}
			});
		}

		this.overlay = $( "<div>" )
			.addClass( "ui-widget-overlay ui-front" )
			.appendTo( this._appendTo() );
		this._on( this.overlay, {
			mousedown: "_keepFocus"
		});
		this.document.data( "ui-dialog-overlays",
			(this.document.data( "ui-dialog-overlays" ) || 0) + 1 );
	},

	_destroyOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		if ( this.overlay ) {
			var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

			if ( !overlays ) {
				this.document
					.unbind( "focusin" )
					.removeData( "ui-dialog-overlays" );
			} else {
				this.document.data( "ui-dialog-overlays", overlays );
			}

			this.overlay.remove();
			this.overlay = null;
		}
	}
});

}));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Button 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/button/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(4),
			__webpack_require__(8),
			__webpack_require__(9)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var lastActive,
	baseClasses = "ui-button ui-widget ui-state-default ui-corner-all",
	typeClasses = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",
	formResetHandler = function() {
		var form = $( this );
		setTimeout(function() {
			form.find( ":ui-button" ).button( "refresh" );
		}, 1 );
	},
	radioGroup = function( radio ) {
		var name = radio.name,
			form = radio.form,
			radios = $( [] );
		if ( name ) {
			name = name.replace( /'/g, "\\'" );
			if ( form ) {
				radios = $( form ).find( "[name='" + name + "'][type=radio]" );
			} else {
				radios = $( "[name='" + name + "'][type=radio]", radio.ownerDocument )
					.filter(function() {
						return !this.form;
					});
			}
		}
		return radios;
	};

$.widget( "ui.button", {
	version: "1.11.4",
	defaultElement: "<button>",
	options: {
		disabled: null,
		text: true,
		label: null,
		icons: {
			primary: null,
			secondary: null
		}
	},
	_create: function() {
		this.element.closest( "form" )
			.unbind( "reset" + this.eventNamespace )
			.bind( "reset" + this.eventNamespace, formResetHandler );

		if ( typeof this.options.disabled !== "boolean" ) {
			this.options.disabled = !!this.element.prop( "disabled" );
		} else {
			this.element.prop( "disabled", this.options.disabled );
		}

		this._determineButtonType();
		this.hasTitle = !!this.buttonElement.attr( "title" );

		var that = this,
			options = this.options,
			toggleButton = this.type === "checkbox" || this.type === "radio",
			activeClass = !toggleButton ? "ui-state-active" : "";

		if ( options.label === null ) {
			options.label = (this.type === "input" ? this.buttonElement.val() : this.buttonElement.html());
		}

		this._hoverable( this.buttonElement );

		this.buttonElement
			.addClass( baseClasses )
			.attr( "role", "button" )
			.bind( "mouseenter" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return;
				}
				if ( this === lastActive ) {
					$( this ).addClass( "ui-state-active" );
				}
			})
			.bind( "mouseleave" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).removeClass( activeClass );
			})
			.bind( "click" + this.eventNamespace, function( event ) {
				if ( options.disabled ) {
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			});

		// Can't use _focusable() because the element that receives focus
		// and the element that gets the ui-state-focus class are different
		this._on({
			focus: function() {
				this.buttonElement.addClass( "ui-state-focus" );
			},
			blur: function() {
				this.buttonElement.removeClass( "ui-state-focus" );
			}
		});

		if ( toggleButton ) {
			this.element.bind( "change" + this.eventNamespace, function() {
				that.refresh();
			});
		}

		if ( this.type === "checkbox" ) {
			this.buttonElement.bind( "click" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return false;
				}
			});
		} else if ( this.type === "radio" ) {
			this.buttonElement.bind( "click" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return false;
				}
				$( this ).addClass( "ui-state-active" );
				that.buttonElement.attr( "aria-pressed", "true" );

				var radio = that.element[ 0 ];
				radioGroup( radio )
					.not( radio )
					.map(function() {
						return $( this ).button( "widget" )[ 0 ];
					})
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			});
		} else {
			this.buttonElement
				.bind( "mousedown" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).addClass( "ui-state-active" );
					lastActive = this;
					that.document.one( "mouseup", function() {
						lastActive = null;
					});
				})
				.bind( "mouseup" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).removeClass( "ui-state-active" );
				})
				.bind( "keydown" + this.eventNamespace, function(event) {
					if ( options.disabled ) {
						return false;
					}
					if ( event.keyCode === $.ui.keyCode.SPACE || event.keyCode === $.ui.keyCode.ENTER ) {
						$( this ).addClass( "ui-state-active" );
					}
				})
				// see #8559, we bind to blur here in case the button element loses
				// focus between keydown and keyup, it would be left in an "active" state
				.bind( "keyup" + this.eventNamespace + " blur" + this.eventNamespace, function() {
					$( this ).removeClass( "ui-state-active" );
				});

			if ( this.buttonElement.is("a") ) {
				this.buttonElement.keyup(function(event) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						// TODO pass through original event correctly (just as 2nd argument doesn't work)
						$( this ).click();
					}
				});
			}
		}

		this._setOption( "disabled", options.disabled );
		this._resetButton();
	},

	_determineButtonType: function() {
		var ancestor, labelSelector, checked;

		if ( this.element.is("[type=checkbox]") ) {
			this.type = "checkbox";
		} else if ( this.element.is("[type=radio]") ) {
			this.type = "radio";
		} else if ( this.element.is("input") ) {
			this.type = "input";
		} else {
			this.type = "button";
		}

		if ( this.type === "checkbox" || this.type === "radio" ) {
			// we don't search against the document in case the element
			// is disconnected from the DOM
			ancestor = this.element.parents().last();
			labelSelector = "label[for='" + this.element.attr("id") + "']";
			this.buttonElement = ancestor.find( labelSelector );
			if ( !this.buttonElement.length ) {
				ancestor = ancestor.length ? ancestor.siblings() : this.element.siblings();
				this.buttonElement = ancestor.filter( labelSelector );
				if ( !this.buttonElement.length ) {
					this.buttonElement = ancestor.find( labelSelector );
				}
			}
			this.element.addClass( "ui-helper-hidden-accessible" );

			checked = this.element.is( ":checked" );
			if ( checked ) {
				this.buttonElement.addClass( "ui-state-active" );
			}
			this.buttonElement.prop( "aria-pressed", checked );
		} else {
			this.buttonElement = this.element;
		}
	},

	widget: function() {
		return this.buttonElement;
	},

	_destroy: function() {
		this.element
			.removeClass( "ui-helper-hidden-accessible" );
		this.buttonElement
			.removeClass( baseClasses + " ui-state-active " + typeClasses )
			.removeAttr( "role" )
			.removeAttr( "aria-pressed" )
			.html( this.buttonElement.find(".ui-button-text").html() );

		if ( !this.hasTitle ) {
			this.buttonElement.removeAttr( "title" );
		}
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "disabled" ) {
			this.widget().toggleClass( "ui-state-disabled", !!value );
			this.element.prop( "disabled", !!value );
			if ( value ) {
				if ( this.type === "checkbox" || this.type === "radio" ) {
					this.buttonElement.removeClass( "ui-state-focus" );
				} else {
					this.buttonElement.removeClass( "ui-state-focus ui-state-active" );
				}
			}
			return;
		}
		this._resetButton();
	},

	refresh: function() {
		//See #8237 & #8828
		var isDisabled = this.element.is( "input, button" ) ? this.element.is( ":disabled" ) : this.element.hasClass( "ui-button-disabled" );

		if ( isDisabled !== this.options.disabled ) {
			this._setOption( "disabled", isDisabled );
		}
		if ( this.type === "radio" ) {
			radioGroup( this.element[0] ).each(function() {
				if ( $( this ).is( ":checked" ) ) {
					$( this ).button( "widget" )
						.addClass( "ui-state-active" )
						.attr( "aria-pressed", "true" );
				} else {
					$( this ).button( "widget" )
						.removeClass( "ui-state-active" )
						.attr( "aria-pressed", "false" );
				}
			});
		} else if ( this.type === "checkbox" ) {
			if ( this.element.is( ":checked" ) ) {
				this.buttonElement
					.addClass( "ui-state-active" )
					.attr( "aria-pressed", "true" );
			} else {
				this.buttonElement
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			}
		}
	},

	_resetButton: function() {
		if ( this.type === "input" ) {
			if ( this.options.label ) {
				this.element.val( this.options.label );
			}
			return;
		}
		var buttonElement = this.buttonElement.removeClass( typeClasses ),
			buttonText = $( "<span></span>", this.document[0] )
				.addClass( "ui-button-text" )
				.html( this.options.label )
				.appendTo( buttonElement.empty() )
				.text(),
			icons = this.options.icons,
			multipleIcons = icons.primary && icons.secondary,
			buttonClasses = [];

		if ( icons.primary || icons.secondary ) {
			if ( this.options.text ) {
				buttonClasses.push( "ui-button-text-icon" + ( multipleIcons ? "s" : ( icons.primary ? "-primary" : "-secondary" ) ) );
			}

			if ( icons.primary ) {
				buttonElement.prepend( "<span class='ui-button-icon-primary ui-icon " + icons.primary + "'></span>" );
			}

			if ( icons.secondary ) {
				buttonElement.append( "<span class='ui-button-icon-secondary ui-icon " + icons.secondary + "'></span>" );
			}

			if ( !this.options.text ) {
				buttonClasses.push( multipleIcons ? "ui-button-icons-only" : "ui-button-icon-only" );

				if ( !this.hasTitle ) {
					buttonElement.attr( "title", $.trim( buttonText ) );
				}
			}
		} else {
			buttonClasses.push( "ui-button-text-only" );
		}
		buttonElement.addClass( buttonClasses.join( " " ) );
	}
});

$.widget( "ui.buttonset", {
	version: "1.11.4",
	options: {
		items: "button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"
	},

	_create: function() {
		this.element.addClass( "ui-buttonset" );
	},

	_init: function() {
		this.refresh();
	},

	_setOption: function( key, value ) {
		if ( key === "disabled" ) {
			this.buttons.button( "option", key, value );
		}

		this._super( key, value );
	},

	refresh: function() {
		var rtl = this.element.css( "direction" ) === "rtl",
			allButtons = this.element.find( this.options.items ),
			existingButtons = allButtons.filter( ":ui-button" );

		// Initialize new buttons
		allButtons.not( ":ui-button" ).button();

		// Refresh existing buttons
		existingButtons.button( "refresh" );

		this.buttons = allButtons
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-all ui-corner-left ui-corner-right" )
				.filter( ":first" )
					.addClass( rtl ? "ui-corner-right" : "ui-corner-left" )
				.end()
				.filter( ":last" )
					.addClass( rtl ? "ui-corner-left" : "ui-corner-right" )
				.end()
			.end();
	},

	_destroy: function() {
		this.element.removeClass( "ui-buttonset" );
		this.buttons
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-left ui-corner-right" )
			.end()
			.button( "destroy" );
	}
});

return $.ui.button;

}));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Draggable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/draggable/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(4),
			__webpack_require__(8),
			__webpack_require__(31),
			__webpack_require__(9)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.widget("ui.draggable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if (this.options.addClasses){
			this.element.addClass("ui-draggable");
		}
		if (this.options.disabled){
			this.element.addClass("ui-draggable-disabled");
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this.element.removeClass( "ui-draggable ui-draggable-dragging ui-draggable-disabled" );
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function(event) {
		var o = this.options;

		this._blurActiveElement( event );

		// among others, prevent a drag on a resizable-handle
		if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle(event);
		if (!this.handle) {
			return false;
		}

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map(function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		});
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var document = this.document[ 0 ];

		// Only need to blur if the event occurred on the draggable itself, see #10527
		if ( !this.handleElement.is( event.target ) ) {
			return;
		}

		// support: IE9
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {

			// Support: IE9, IE10
			// If the <body> is blurred, IE will switch windows, see #9520
			if ( document.activeElement && document.activeElement.nodeName.toLowerCase() !== "body" ) {

				// Blur any element that currently has focus, see #4261
				$( document.activeElement ).blur();
			}
		} catch ( error ) {}
	},

	_mouseStart: function(event) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper(event);

		this.helper.addClass("ui-draggable-dragging");

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ($.ui.ddmanager) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter(function() {
				return $( this ).css( "position" ) === "fixed";
			}).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if (this._trigger("start", event) === false) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ($.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(this, event);
		}

		// Reset helper's right/bottom css if they're set and set explicit width/height instead
		// as this prevents resizing of elements with right/bottom set (see #7772)
		this._normalizeRightBottom();

		this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position

		//If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart(this, event);
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function(event, noPropagation) {
		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo("absolute");

		//Call plugins and callbacks and use the resulting position if something is returned
		if (!noPropagation) {
			var ui = this._uiHash();
			if (this._trigger("drag", event, ui) === false) {
				this._mouseUp({});
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ($.ui.ddmanager) {
			$.ui.ddmanager.drag(this, event);
		}

		return false;
	},

	_mouseStop: function(event) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ($.ui.ddmanager && !this.options.dropBehaviour) {
			dropped = $.ui.ddmanager.drop(this, event);
		}

		//if a drop comes from outside (a sortable)
		if (this.dropped) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ((this.options.revert === "invalid" && !dropped) || (this.options.revert === "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
			$(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
				if (that._trigger("stop", event) !== false) {
					that._clear();
				}
			});
		} else {
			if (this._trigger("stop", event) !== false) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		//If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop(this, event);
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {
			// The interaction is over; whether or not the click resulted in a drag, focus the element
			this.element.focus();
		}

		return $.ui.mouse.prototype._mouseUp.call(this, event);
	},

	cancel: function() {

		if (this.helper.is(".ui-draggable-dragging")) {
			this._mouseUp({});
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function(event) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this.handleElement.addClass( "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this.handleElement.removeClass( "ui-draggable-handle" );
	},

	_createHelper: function(event) {

		var o = this.options,
			helperIsFunction = $.isFunction( o.helper ),
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if (!helper.parents("body").length) {
			helper.appendTo((o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo));
		}

		// http://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if (helper[0] !== this.element[0] && !(/(fixed|absolute)/).test(helper.css("position"))) {
			helper.css("position", "absolute");
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function(obj) {
		if (typeof obj === "string") {
			obj = obj.split(" ");
		}
		if ($.isArray(obj)) {
			obj = { left: +obj[0], top: +obj[1] || 0 };
		}
		if ("left" in obj) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ("right" in obj) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ("top" in obj) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ("bottom" in obj) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
		//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
		if (this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
			left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt(this.helper.css( "top" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt(this.helper.css( "left" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: (parseInt(this.element.css("marginLeft"), 10) || 0),
			top: (parseInt(this.element.css("marginTop"), 10) || 0),
			right: (parseInt(this.element.css("marginRight"), 10) || 0),
			bottom: (parseInt(this.element.css("marginBottom"), 10) || 0)
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() - this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() + ( $( window ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document") {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function(d, pos) {

		if (!pos) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (
				pos.top	+																// The absolute mouse position
				this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top * mod -										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod)
			),
			left: (
				pos.left +																// The absolute mouse position
				this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod)
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ){
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if (event.pageX - this.offset.click.left < containment[0]) {
					pageX = containment[0] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top < containment[1]) {
					pageY = containment[1] + this.offset.click.top;
				}
				if (event.pageX - this.offset.click.left > containment[2]) {
					pageX = containment[2] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top > containment[3]) {
					pageY = containment[3] + this.offset.click.top;
				}
			}

			if (o.grid) {
				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
				top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
				pageY = containment ? ((top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3]) ? top : ((top - this.offset.click.top >= containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

				left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
				pageX = containment ? ((left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2]) ? left : ((left - this.offset.click.left >= containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (
				pageY -																	// The absolute mouse position
				this.offset.click.top	-												// Click offset (relative to the element)
				this.offset.relative.top -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (
				pageX -																	// The absolute mouse position
				this.offset.click.left -												// Click offset (relative to the element)
				this.offset.relative.left -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this.helper.removeClass("ui-draggable-dragging");
		if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	_normalizeRightBottom: function() {
		if ( this.options.axis !== "y" && this.helper.css( "right" ) !== "auto" ) {
			this.helper.width( this.helper.width() );
			this.helper.css( "right", "auto" );
		}
		if ( this.options.axis !== "x" && this.helper.css( "bottom" ) !== "auto" ) {
			this.helper.height( this.helper.height() );
			this.helper.css( "bottom", "auto" );
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

});

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each(function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// refreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger("activate", event, uiSortable);
			}
		});
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop(event);

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {
				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		});
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {
					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				});
			}

			if ( innermostIntersecting ) {
				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});

					// hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );
					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {
				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});
				}
			}
		});
	}
});

$.ui.plugin.add("draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if (t.css("cursor")) {
			o._cursor = t.css("cursor");
		}
		t.css("cursor", o.cursor);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._cursor) {
			$("body").css("cursor", o._cursor);
		}
	}
});

$.ui.plugin.add("draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if (t.css("opacity")) {
			o._opacity = t.css("opacity");
		}
		t.css("opacity", o.opacity);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._opacity) {
			$(ui.helper).css("opacity", o._opacity);
		}
	}
});

$.ui.plugin.add("draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] && i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if (!o.axis || o.axis !== "x") {
				if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
				} else if ($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
				}
			}

			if (!o.axis || o.axis !== "y") {
				if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
				} else if ($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
				}
			}

		}

		if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(i, event);
		}

	}
});

$.ui.plugin.add("draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$(o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap).each(function() {
			var $t = $(this),
				$o = $t.offset();
			if (this !== i.element[0]) {
				i.snapElements.push({
					item: this,
					width: $t.outerWidth(), height: $t.outerHeight(),
					top: $o.top, left: $o.left
				});
			}
		});

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for (i = inst.snapElements.length - 1; i >= 0; i--){

			l = inst.snapElements[i].left - inst.margins.left;
			r = l + inst.snapElements[i].width;
			t = inst.snapElements[i].top - inst.margins.top;
			b = t + inst.snapElements[i].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains( inst.snapElements[ i ].item.ownerDocument, inst.snapElements[ i ].item ) ) {
				if (inst.snapElements[i].snapping) {
					(inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
				}
				inst.snapElements[i].snapping = false;
				continue;
			}

			if (o.snapMode !== "inner") {
				ts = Math.abs(t - y2) <= d;
				bs = Math.abs(b - y1) <= d;
				ls = Math.abs(l - x2) <= d;
				rs = Math.abs(r - x1) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left;
				}
			}

			first = (ts || bs || ls || rs);

			if (o.snapMode !== "outer") {
				ts = Math.abs(t - y1) <= d;
				bs = Math.abs(b - y2) <= d;
				ls = Math.abs(l - x1) <= d;
				rs = Math.abs(r - x2) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left;
				}
			}

			if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
				(inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
			}
			inst.snapElements[i].snapping = (ts || bs || ls || rs || first);

		}

	}
});

$.ui.plugin.add("draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray($(o.stack)).sort(function(a, b) {
				return (parseInt($(a).css("zIndex"), 10) || 0) - (parseInt($(b).css("zIndex"), 10) || 0);
			});

		if (!group.length) { return; }

		min = parseInt($(group[0]).css("zIndex"), 10) || 0;
		$(group).each(function(i) {
			$(this).css("zIndex", min + i);
		});
		this.css("zIndex", (min + group.length));
	}
});

$.ui.plugin.add("draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if (t.css("zIndex")) {
			o._zIndex = t.css("zIndex");
		}
		t.css("zIndex", o.zIndex);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if (o._zIndex) {
			$(ui.helper).css("zIndex", o._zIndex);
		}
	}
});

return $.ui.draggable;

}));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Position 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(4) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {
(function() {

$.ui = $.ui || {};

var cachedScrollbarWidth, supportsOffsetFractions,
	max = Math.max,
	abs = Math.abs,
	round = Math.round,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[0];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[0];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[0].clientWidth;
		}

		div.remove();

		return (cachedScrollbarWidth = w1 - w2);
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[0].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[0] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: withinElement.offset() || { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),

			// support: jQuery 1.6.x
			// jQuery 1.6 doesn't support .outerWidth/Height() on documents or windows
			width: isWindow || isDocument ? withinElement.width() : withinElement.outerWidth(),
			height: isWindow || isDocument ? withinElement.height() : withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[0].preventDefault ) {
		// force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;
	// clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	});

	// normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each(function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		// if the browser doesn't support fractions, then round for consistent results
		if ( !supportsOffsetFractions ) {
			position.left = round( position.left );
			position.top = round( position.top );
		}

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				});
			}
		});

		if ( options.using ) {
			// adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	});
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// element is wider than within
			if ( data.collisionWidth > outerWidth ) {
				// element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
					position.left += overLeft - newOverRight;
				// element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;
				// element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}
			// too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;
			// too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;
			// adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// element is taller than within
			if ( data.collisionHeight > outerHeight ) {
				// element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
					position.top += overTop - newOverBottom;
				// element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;
				// element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}
			// too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;
			// too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;
			// adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

// fraction support test
(function() {
	var testElement, testElementParent, testElementStyle, offsetLeft, i,
		body = document.getElementsByTagName( "body" )[ 0 ],
		div = document.createElement( "div" );

	//Create a "fake body" for testing based on method used in jQuery.support
	testElement = document.createElement( body ? "div" : "body" );
	testElementStyle = {
		visibility: "hidden",
		width: 0,
		height: 0,
		border: 0,
		margin: 0,
		background: "none"
	};
	if ( body ) {
		$.extend( testElementStyle, {
			position: "absolute",
			left: "-1000px",
			top: "-1000px"
		});
	}
	for ( i in testElementStyle ) {
		testElement.style[ i ] = testElementStyle[ i ];
	}
	testElement.appendChild( div );
	testElementParent = body || document.documentElement;
	testElementParent.insertBefore( testElement, testElementParent.firstChild );

	div.style.cssText = "position: absolute; left: 10.7432222px;";

	offsetLeft = $( div ).offset().left;
	supportsOffsetFractions = offsetLeft > 10 && offsetLeft < 11;

	testElement.innerHTML = "";
	testElementParent.removeChild( testElement );
})();

})();

return $.ui.position;

}));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Resizable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/resizable/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(4),
			__webpack_require__(8),
			__webpack_require__(31),
			__webpack_require__(9)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.widget("ui.resizable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,
		// See #7960
		zIndex: 90,

		// callbacks
		resize: null,
		start: null,
		stop: null
	},

	_num: function( value ) {
		return parseInt( value, 10 ) || 0;
	},

	_isNumber: function( value ) {
		return !isNaN( parseInt( value, 10 ) );
	},

	_hasScroll: function( el, a ) {

		if ( $( el ).css( "overflow" ) === "hidden") {
			return false;
		}

		var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
			has = false;

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		el[ scroll ] = 1;
		has = ( el[ scroll ] > 0 );
		el[ scroll ] = 0;
		return has;
	},

	_create: function() {

		var n, i, handle, axis, hname,
			that = this,
			o = this.options;
		this.element.addClass("ui-resizable");

		$.extend(this, {
			_aspectRatio: !!(o.aspectRatio),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
		});

		// Wrap the element if it cannot hold child nodes
		if (this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)) {

			this.element.wrap(
				$("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
					position: this.element.css("position"),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css("top"),
					left: this.element.css("left")
				})
			);

			this.element = this.element.parent().data(
				"ui-resizable", this.element.resizable( "instance" )
			);

			this.elementIsWrapper = true;

			this.element.css({
				marginLeft: this.originalElement.css("marginLeft"),
				marginTop: this.originalElement.css("marginTop"),
				marginRight: this.originalElement.css("marginRight"),
				marginBottom: this.originalElement.css("marginBottom")
			});
			this.originalElement.css({
				marginLeft: 0,
				marginTop: 0,
				marginRight: 0,
				marginBottom: 0
			});
			// support: Safari
			// Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css("resize");
			this.originalElement.css("resize", "none");

			this._proportionallyResizeElements.push( this.originalElement.css({
				position: "static",
				zoom: 1,
				display: "block"
			}) );

			// support: IE9
			// avoid IE jump (hard set the margin)
			this.originalElement.css({ margin: this.originalElement.css("margin") });

			this._proportionallyResize();
		}

		this.handles = o.handles ||
			( !$(".ui-resizable-handle", this.element).length ?
				"e,s,se" : {
					n: ".ui-resizable-n",
					e: ".ui-resizable-e",
					s: ".ui-resizable-s",
					w: ".ui-resizable-w",
					se: ".ui-resizable-se",
					sw: ".ui-resizable-sw",
					ne: ".ui-resizable-ne",
					nw: ".ui-resizable-nw"
				} );

		this._handles = $();
		if ( this.handles.constructor === String ) {

			if ( this.handles === "all") {
				this.handles = "n,e,s,w,se,sw,ne,nw";
			}

			n = this.handles.split(",");
			this.handles = {};

			for (i = 0; i < n.length; i++) {

				handle = $.trim(n[i]);
				hname = "ui-resizable-" + handle;
				axis = $("<div class='ui-resizable-handle " + hname + "'></div>");

				axis.css({ zIndex: o.zIndex });

				// TODO : What's going on here?
				if ("se" === handle) {
					axis.addClass("ui-icon ui-icon-gripsmall-diagonal-se");
				}

				this.handles[handle] = ".ui-resizable-" + handle;
				this.element.append(axis);
			}

		}

		this._renderAxis = function(target) {

			var i, axis, padPos, padWrapper;

			target = target || this.element;

			for (i in this.handles) {

				if (this.handles[i].constructor === String) {
					this.handles[i] = this.element.children( this.handles[ i ] ).first().show();
				} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
					this.handles[ i ] = $( this.handles[ i ] );
					this._on( this.handles[ i ], { "mousedown": that._mouseDown });
				}

				if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)) {

					axis = $(this.handles[i], this.element);

					padWrapper = /sw|ne|nw|se|n|s/.test(i) ? axis.outerHeight() : axis.outerWidth();

					padPos = [ "padding",
						/ne|nw|n/.test(i) ? "Top" :
						/se|sw|s/.test(i) ? "Bottom" :
						/^e$/.test(i) ? "Right" : "Left" ].join("");

					target.css(padPos, padWrapper);

					this._proportionallyResize();
				}

				this._handles = this._handles.add( this.handles[ i ] );
			}
		};

		// TODO: make renderAxis a prototype function
		this._renderAxis(this.element);

		this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
		this._handles.disableSelection();

		this._handles.mouseover(function() {
			if (!that.resizing) {
				if (this.className) {
					axis = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
				}
				that.axis = axis && axis[1] ? axis[1] : "se";
			}
		});

		if (o.autoHide) {
			this._handles.hide();
			$(this.element)
				.addClass("ui-resizable-autohide")
				.mouseenter(function() {
					if (o.disabled) {
						return;
					}
					$(this).removeClass("ui-resizable-autohide");
					that._handles.show();
				})
				.mouseleave(function() {
					if (o.disabled) {
						return;
					}
					if (!that.resizing) {
						$(this).addClass("ui-resizable-autohide");
						that._handles.hide();
					}
				});
		}

		this._mouseInit();
	},

	_destroy: function() {

		this._mouseDestroy();

		var wrapper,
			_destroy = function(exp) {
				$(exp)
					.removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing")
					.removeData("resizable")
					.removeData("ui-resizable")
					.unbind(".resizable")
					.find(".ui-resizable-handle")
						.remove();
			};

		// TODO: Unwrap at same DOM position
		if (this.elementIsWrapper) {
			_destroy(this.element);
			wrapper = this.element;
			this.originalElement.css({
				position: wrapper.css("position"),
				width: wrapper.outerWidth(),
				height: wrapper.outerHeight(),
				top: wrapper.css("top"),
				left: wrapper.css("left")
			}).insertAfter( wrapper );
			wrapper.remove();
		}

		this.originalElement.css("resize", this.originalResizeStyle);
		_destroy(this.originalElement);

		return this;
	},

	_mouseCapture: function(event) {
		var i, handle,
			capture = false;

		for (i in this.handles) {
			handle = $(this.handles[i])[0];
			if (handle === event.target || $.contains(handle, event.target)) {
				capture = true;
			}
		}

		return !this.options.disabled && capture;
	},

	_mouseStart: function(event) {

		var curleft, curtop, cursor,
			o = this.options,
			el = this.element;

		this.resizing = true;

		this._renderProxy();

		curleft = this._num(this.helper.css("left"));
		curtop = this._num(this.helper.css("top"));

		if (o.containment) {
			curleft += $(o.containment).scrollLeft() || 0;
			curtop += $(o.containment).scrollTop() || 0;
		}

		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };

		this.size = this._helper ? {
				width: this.helper.width(),
				height: this.helper.height()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.originalSize = this._helper ? {
				width: el.outerWidth(),
				height: el.outerHeight()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.sizeDiff = {
			width: el.outerWidth() - el.width(),
			height: el.outerHeight() - el.height()
		};

		this.originalPosition = { left: curleft, top: curtop };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		this.aspectRatio = (typeof o.aspectRatio === "number") ?
			o.aspectRatio :
			((this.originalSize.width / this.originalSize.height) || 1);

		cursor = $(".ui-resizable-" + this.axis).css("cursor");
		$("body").css("cursor", cursor === "auto" ? this.axis + "-resize" : cursor);

		el.addClass("ui-resizable-resizing");
		this._propagate("start", event);
		return true;
	},

	_mouseDrag: function(event) {

		var data, props,
			smp = this.originalMousePosition,
			a = this.axis,
			dx = (event.pageX - smp.left) || 0,
			dy = (event.pageY - smp.top) || 0,
			trigger = this._change[a];

		this._updatePrevProperties();

		if (!trigger) {
			return false;
		}

		data = trigger.apply(this, [ event, dx, dy ]);

		this._updateVirtualBoundaries(event.shiftKey);
		if (this._aspectRatio || event.shiftKey) {
			data = this._updateRatio(data, event);
		}

		data = this._respectSize(data, event);

		this._updateCache(data);

		this._propagate("resize", event);

		props = this._applyChanges();

		if ( !this._helper && this._proportionallyResizeElements.length ) {
			this._proportionallyResize();
		}

		if ( !$.isEmptyObject( props ) ) {
			this._updatePrevProperties();
			this._trigger( "resize", event, this.ui() );
			this._applyChanges();
		}

		return false;
	},

	_mouseStop: function(event) {

		this.resizing = false;
		var pr, ista, soffseth, soffsetw, s, left, top,
			o = this.options, that = this;

		if (this._helper) {

			pr = this._proportionallyResizeElements;
			ista = pr.length && (/textarea/i).test(pr[0].nodeName);
			soffseth = ista && this._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height;
			soffsetw = ista ? 0 : that.sizeDiff.width;

			s = {
				width: (that.helper.width()  - soffsetw),
				height: (that.helper.height() - soffseth)
			};
			left = (parseInt(that.element.css("left"), 10) +
				(that.position.left - that.originalPosition.left)) || null;
			top = (parseInt(that.element.css("top"), 10) +
				(that.position.top - that.originalPosition.top)) || null;

			if (!o.animate) {
				this.element.css($.extend(s, { top: top, left: left }));
			}

			that.helper.height(that.size.height);
			that.helper.width(that.size.width);

			if (this._helper && !o.animate) {
				this._proportionallyResize();
			}
		}

		$("body").css("cursor", "auto");

		this.element.removeClass("ui-resizable-resizing");

		this._propagate("stop", event);

		if (this._helper) {
			this.helper.remove();
		}

		return false;

	},

	_updatePrevProperties: function() {
		this.prevPosition = {
			top: this.position.top,
			left: this.position.left
		};
		this.prevSize = {
			width: this.size.width,
			height: this.size.height
		};
	},

	_applyChanges: function() {
		var props = {};

		if ( this.position.top !== this.prevPosition.top ) {
			props.top = this.position.top + "px";
		}
		if ( this.position.left !== this.prevPosition.left ) {
			props.left = this.position.left + "px";
		}
		if ( this.size.width !== this.prevSize.width ) {
			props.width = this.size.width + "px";
		}
		if ( this.size.height !== this.prevSize.height ) {
			props.height = this.size.height + "px";
		}

		this.helper.css( props );

		return props;
	},

	_updateVirtualBoundaries: function(forceAspectRatio) {
		var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
			o = this.options;

		b = {
			minWidth: this._isNumber(o.minWidth) ? o.minWidth : 0,
			maxWidth: this._isNumber(o.maxWidth) ? o.maxWidth : Infinity,
			minHeight: this._isNumber(o.minHeight) ? o.minHeight : 0,
			maxHeight: this._isNumber(o.maxHeight) ? o.maxHeight : Infinity
		};

		if (this._aspectRatio || forceAspectRatio) {
			pMinWidth = b.minHeight * this.aspectRatio;
			pMinHeight = b.minWidth / this.aspectRatio;
			pMaxWidth = b.maxHeight * this.aspectRatio;
			pMaxHeight = b.maxWidth / this.aspectRatio;

			if (pMinWidth > b.minWidth) {
				b.minWidth = pMinWidth;
			}
			if (pMinHeight > b.minHeight) {
				b.minHeight = pMinHeight;
			}
			if (pMaxWidth < b.maxWidth) {
				b.maxWidth = pMaxWidth;
			}
			if (pMaxHeight < b.maxHeight) {
				b.maxHeight = pMaxHeight;
			}
		}
		this._vBoundaries = b;
	},

	_updateCache: function(data) {
		this.offset = this.helper.offset();
		if (this._isNumber(data.left)) {
			this.position.left = data.left;
		}
		if (this._isNumber(data.top)) {
			this.position.top = data.top;
		}
		if (this._isNumber(data.height)) {
			this.size.height = data.height;
		}
		if (this._isNumber(data.width)) {
			this.size.width = data.width;
		}
	},

	_updateRatio: function( data ) {

		var cpos = this.position,
			csize = this.size,
			a = this.axis;

		if (this._isNumber(data.height)) {
			data.width = (data.height * this.aspectRatio);
		} else if (this._isNumber(data.width)) {
			data.height = (data.width / this.aspectRatio);
		}

		if (a === "sw") {
			data.left = cpos.left + (csize.width - data.width);
			data.top = null;
		}
		if (a === "nw") {
			data.top = cpos.top + (csize.height - data.height);
			data.left = cpos.left + (csize.width - data.width);
		}

		return data;
	},

	_respectSize: function( data ) {

		var o = this._vBoundaries,
			a = this.axis,
			ismaxw = this._isNumber(data.width) && o.maxWidth && (o.maxWidth < data.width),
			ismaxh = this._isNumber(data.height) && o.maxHeight && (o.maxHeight < data.height),
			isminw = this._isNumber(data.width) && o.minWidth && (o.minWidth > data.width),
			isminh = this._isNumber(data.height) && o.minHeight && (o.minHeight > data.height),
			dw = this.originalPosition.left + this.originalSize.width,
			dh = this.position.top + this.size.height,
			cw = /sw|nw|w/.test(a), ch = /nw|ne|n/.test(a);
		if (isminw) {
			data.width = o.minWidth;
		}
		if (isminh) {
			data.height = o.minHeight;
		}
		if (ismaxw) {
			data.width = o.maxWidth;
		}
		if (ismaxh) {
			data.height = o.maxHeight;
		}

		if (isminw && cw) {
			data.left = dw - o.minWidth;
		}
		if (ismaxw && cw) {
			data.left = dw - o.maxWidth;
		}
		if (isminh && ch) {
			data.top = dh - o.minHeight;
		}
		if (ismaxh && ch) {
			data.top = dh - o.maxHeight;
		}

		// Fixing jump error on top/left - bug #2330
		if (!data.width && !data.height && !data.left && data.top) {
			data.top = null;
		} else if (!data.width && !data.height && !data.top && data.left) {
			data.left = null;
		}

		return data;
	},

	_getPaddingPlusBorderDimensions: function( element ) {
		var i = 0,
			widths = [],
			borders = [
				element.css( "borderTopWidth" ),
				element.css( "borderRightWidth" ),
				element.css( "borderBottomWidth" ),
				element.css( "borderLeftWidth" )
			],
			paddings = [
				element.css( "paddingTop" ),
				element.css( "paddingRight" ),
				element.css( "paddingBottom" ),
				element.css( "paddingLeft" )
			];

		for ( ; i < 4; i++ ) {
			widths[ i ] = ( parseInt( borders[ i ], 10 ) || 0 );
			widths[ i ] += ( parseInt( paddings[ i ], 10 ) || 0 );
		}

		return {
			height: widths[ 0 ] + widths[ 2 ],
			width: widths[ 1 ] + widths[ 3 ]
		};
	},

	_proportionallyResize: function() {

		if (!this._proportionallyResizeElements.length) {
			return;
		}

		var prel,
			i = 0,
			element = this.helper || this.element;

		for ( ; i < this._proportionallyResizeElements.length; i++) {

			prel = this._proportionallyResizeElements[i];

			// TODO: Seems like a bug to cache this.outerDimensions
			// considering that we are in a loop.
			if (!this.outerDimensions) {
				this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
			}

			prel.css({
				height: (element.height() - this.outerDimensions.height) || 0,
				width: (element.width() - this.outerDimensions.width) || 0
			});

		}

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if (this._helper) {

			this.helper = this.helper || $("<div style='overflow:hidden;'></div>");

			this.helper.addClass(this._helper).css({
				width: this.element.outerWidth() - 1,
				height: this.element.outerHeight() - 1,
				position: "absolute",
				left: this.elementOffset.left + "px",
				top: this.elementOffset.top + "px",
				zIndex: ++o.zIndex //TODO: Don't modify option
			});

			this.helper
				.appendTo("body")
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function(event, dx) {
			return { width: this.originalSize.width + dx };
		},
		w: function(event, dx) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function(event, dx, dy) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function(event, dx, dy) {
			return { height: this.originalSize.height + dy };
		},
		se: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments),
				this._change.e.apply(this, [ event, dx, dy ]));
		},
		sw: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments),
				this._change.w.apply(this, [ event, dx, dy ]));
		},
		ne: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments),
				this._change.e.apply(this, [ event, dx, dy ]));
		},
		nw: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments),
				this._change.w.apply(this, [ event, dx, dy ]));
		}
	},

	_propagate: function(n, event) {
		$.ui.plugin.call(this, n, [ event, this.ui() ]);
		(n !== "resize" && this._trigger(n, event, this.ui()));
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

});

/*
 * Resizable Extensions
 */

$.ui.plugin.add("resizable", "animate", {

	stop: function( event ) {
		var that = $(this).resizable( "instance" ),
			o = that.options,
			pr = that._proportionallyResizeElements,
			ista = pr.length && (/textarea/i).test(pr[0].nodeName),
			soffseth = ista && that._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height,
			soffsetw = ista ? 0 : that.sizeDiff.width,
			style = { width: (that.size.width - soffsetw), height: (that.size.height - soffseth) },
			left = (parseInt(that.element.css("left"), 10) +
				(that.position.left - that.originalPosition.left)) || null,
			top = (parseInt(that.element.css("top"), 10) +
				(that.position.top - that.originalPosition.top)) || null;

		that.element.animate(
			$.extend(style, top && left ? { top: top, left: left } : {}), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseInt(that.element.css("width"), 10),
						height: parseInt(that.element.css("height"), 10),
						top: parseInt(that.element.css("top"), 10),
						left: parseInt(that.element.css("left"), 10)
					};

					if (pr && pr.length) {
						$(pr[0]).css({ width: data.width, height: data.height });
					}

					// propagating resize, and updating values for each animation step
					that._updateCache(data);
					that._propagate("resize", event);

				}
			}
		);
	}

});

$.ui.plugin.add( "resizable", "containment", {

	start: function() {
		var element, p, co, ch, cw, width, height,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			el = that.element,
			oc = o.containment,
			ce = ( oc instanceof $ ) ? oc.get( 0 ) : ( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

		if ( !ce ) {
			return;
		}

		that.containerElement = $( ce );

		if ( /document/.test( oc ) || oc === document ) {
			that.containerOffset = {
				left: 0,
				top: 0
			};
			that.containerPosition = {
				left: 0,
				top: 0
			};

			that.parentData = {
				element: $( document ),
				left: 0,
				top: 0,
				width: $( document ).width(),
				height: $( document ).height() || document.body.parentNode.scrollHeight
			};
		} else {
			element = $( ce );
			p = [];
			$([ "Top", "Right", "Left", "Bottom" ]).each(function( i, name ) {
				p[ i ] = that._num( element.css( "padding" + name ) );
			});

			that.containerOffset = element.offset();
			that.containerPosition = element.position();
			that.containerSize = {
				height: ( element.innerHeight() - p[ 3 ] ),
				width: ( element.innerWidth() - p[ 1 ] )
			};

			co = that.containerOffset;
			ch = that.containerSize.height;
			cw = that.containerSize.width;
			width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
			height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;

			that.parentData = {
				element: ce,
				left: co.left,
				top: co.top,
				width: width,
				height: height
			};
		}
	},

	resize: function( event ) {
		var woset, hoset, isParent, isOffsetRelative,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cp = that.position,
			pRatio = that._aspectRatio || event.shiftKey,
			cop = {
				top: 0,
				left: 0
			},
			ce = that.containerElement,
			continueResize = true;

		if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
			cop = co;
		}

		if ( cp.left < ( that._helper ? co.left : 0 ) ) {
			that.size.width = that.size.width +
				( that._helper ?
					( that.position.left - co.left ) :
					( that.position.left - cop.left ) );

			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
			that.position.left = o.helper ? co.left : 0;
		}

		if ( cp.top < ( that._helper ? co.top : 0 ) ) {
			that.size.height = that.size.height +
				( that._helper ?
					( that.position.top - co.top ) :
					that.position.top );

			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
			that.position.top = that._helper ? co.top : 0;
		}

		isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
		isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

		if ( isParent && isOffsetRelative ) {
			that.offset.left = that.parentData.left + that.position.left;
			that.offset.top = that.parentData.top + that.position.top;
		} else {
			that.offset.left = that.element.offset().left;
			that.offset.top = that.element.offset().top;
		}

		woset = Math.abs( that.sizeDiff.width +
			(that._helper ?
				that.offset.left - cop.left :
				(that.offset.left - co.left)) );

		hoset = Math.abs( that.sizeDiff.height +
			(that._helper ?
				that.offset.top - cop.top :
				(that.offset.top - co.top)) );

		if ( woset + that.size.width >= that.parentData.width ) {
			that.size.width = that.parentData.width - woset;
			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
		}

		if ( hoset + that.size.height >= that.parentData.height ) {
			that.size.height = that.parentData.height - hoset;
			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
		}

		if ( !continueResize ) {
			that.position.left = that.prevPosition.left;
			that.position.top = that.prevPosition.top;
			that.size.width = that.prevSize.width;
			that.size.height = that.prevSize.height;
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cop = that.containerPosition,
			ce = that.containerElement,
			helper = $( that.helper ),
			ho = helper.offset(),
			w = helper.outerWidth() - that.sizeDiff.width,
			h = helper.outerHeight() - that.sizeDiff.height;

		if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
			$( this ).css({
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			});
		}

		if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
			$( this ).css({
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			});
		}
	}
});

$.ui.plugin.add("resizable", "alsoResize", {

	start: function() {
		var that = $(this).resizable( "instance" ),
			o = that.options;

		$(o.alsoResize).each(function() {
			var el = $(this);
			el.data("ui-resizable-alsoresize", {
				width: parseInt(el.width(), 10), height: parseInt(el.height(), 10),
				left: parseInt(el.css("left"), 10), top: parseInt(el.css("top"), 10)
			});
		});
	},

	resize: function(event, ui) {
		var that = $(this).resizable( "instance" ),
			o = that.options,
			os = that.originalSize,
			op = that.originalPosition,
			delta = {
				height: (that.size.height - os.height) || 0,
				width: (that.size.width - os.width) || 0,
				top: (that.position.top - op.top) || 0,
				left: (that.position.left - op.left) || 0
			};

			$(o.alsoResize).each(function() {
				var el = $(this), start = $(this).data("ui-resizable-alsoresize"), style = {},
					css = el.parents(ui.originalElement[0]).length ?
							[ "width", "height" ] :
							[ "width", "height", "top", "left" ];

				$.each(css, function(i, prop) {
					var sum = (start[prop] || 0) + (delta[prop] || 0);
					if (sum && sum >= 0) {
						style[prop] = sum || null;
					}
				});

				el.css(style);
			});
	},

	stop: function() {
		$(this).removeData("resizable-alsoresize");
	}
});

$.ui.plugin.add("resizable", "ghost", {

	start: function() {

		var that = $(this).resizable( "instance" ), o = that.options, cs = that.size;

		that.ghost = that.originalElement.clone();
		that.ghost
			.css({
				opacity: 0.25,
				display: "block",
				position: "relative",
				height: cs.height,
				width: cs.width,
				margin: 0,
				left: 0,
				top: 0
			})
			.addClass("ui-resizable-ghost")
			.addClass(typeof o.ghost === "string" ? o.ghost : "");

		that.ghost.appendTo(that.helper);

	},

	resize: function() {
		var that = $(this).resizable( "instance" );
		if (that.ghost) {
			that.ghost.css({
				position: "relative",
				height: that.size.height,
				width: that.size.width
			});
		}
	},

	stop: function() {
		var that = $(this).resizable( "instance" );
		if (that.ghost && that.helper) {
			that.helper.get(0).removeChild(that.ghost.get(0));
		}
	}

});

$.ui.plugin.add("resizable", "grid", {

	resize: function() {
		var outerDimensions,
			that = $(this).resizable( "instance" ),
			o = that.options,
			cs = that.size,
			os = that.originalSize,
			op = that.originalPosition,
			a = that.axis,
			grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
			gridX = (grid[0] || 1),
			gridY = (grid[1] || 1),
			ox = Math.round((cs.width - os.width) / gridX) * gridX,
			oy = Math.round((cs.height - os.height) / gridY) * gridY,
			newWidth = os.width + ox,
			newHeight = os.height + oy,
			isMaxWidth = o.maxWidth && (o.maxWidth < newWidth),
			isMaxHeight = o.maxHeight && (o.maxHeight < newHeight),
			isMinWidth = o.minWidth && (o.minWidth > newWidth),
			isMinHeight = o.minHeight && (o.minHeight > newHeight);

		o.grid = grid;

		if (isMinWidth) {
			newWidth += gridX;
		}
		if (isMinHeight) {
			newHeight += gridY;
		}
		if (isMaxWidth) {
			newWidth -= gridX;
		}
		if (isMaxHeight) {
			newHeight -= gridY;
		}

		if (/^(se|s|e)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
		} else if (/^(ne)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.top = op.top - oy;
		} else if (/^(sw)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.left = op.left - ox;
		} else {
			if ( newHeight - gridY <= 0 || newWidth - gridX <= 0) {
				outerDimensions = that._getPaddingPlusBorderDimensions( this );
			}

			if ( newHeight - gridY > 0 ) {
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else {
				newHeight = gridY - outerDimensions.height;
				that.size.height = newHeight;
				that.position.top = op.top + os.height - newHeight;
			}
			if ( newWidth - gridX > 0 ) {
				that.size.width = newWidth;
				that.position.left = op.left - ox;
			} else {
				newWidth = gridX - outerDimensions.width;
				that.size.width = newWidth;
				that.position.left = op.left + os.width - newWidth;
			}
		}
	}

});

return $.ui.resizable;

}));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Datepicker 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/datepicker/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(4),
			__webpack_require__(8)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.extend($.ui, { datepicker: { version: "1.11.4" } });

var datepicker_instActive;

function datepicker_getZindex( elem ) {
	var position, value;
	while ( elem.length && elem[ 0 ] !== document ) {
		// Ignore z-index if position is set to a value where z-index is ignored by the browser
		// This makes behavior of this function consistent across browsers
		// WebKit always returns auto if the element is positioned
		position = elem.css( "position" );
		if ( position === "absolute" || position === "relative" || position === "fixed" ) {
			// IE returns 0 when zIndex is not specified
			// other browsers return a string
			// we ignore the case of nested elements with an explicit value of 0
			// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
			value = parseInt( elem.css( "zIndex" ), 10 );
			if ( !isNaN( value ) && value !== 0 ) {
				return value;
			}
		}
		elem = elem.parent();
	}

	return 0;
}
/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
	this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
	this._appendClass = "ui-datepicker-append"; // The name of the append marker class
	this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
	this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
	this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
	this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
	this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
	this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[""] = { // Default regional settings
		closeText: "Done", // Display text for close link
		prevText: "Prev", // Display text for previous month link
		nextText: "Next", // Display text for next month link
		currentText: "Today", // Display text for current month link
		monthNames: ["January","February","March","April","May","June",
			"July","August","September","October","November","December"], // Names of months for drop-down and formatting
		monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // For formatting
		dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], // For formatting
		dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], // For formatting
		dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"], // Column headings for days starting at Sunday
		weekHeader: "Wk", // Column header for week of the year
		dateFormat: "mm/dd/yy", // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: "" // Additional text to append to the year in the month headers
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: "focus", // "focus" for popup on focus,
			// "button" for trigger button, or "both" for either
		showAnim: "fadeIn", // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: "", // Display text following the input box, e.g. showing the format
		buttonText: "...", // Text for trigger button
		buttonImage: "", // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: "c-10:c+10", // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: "+10", // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with "+" for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: "fast", // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: "", // Selector for an alternate field to store selected dates into
		altFormat: "", // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend(this._defaults, this.regional[""]);
	this.regional.en = $.extend( true, {}, this.regional[ "" ]);
	this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
	this.dpDiv = datepicker_bindHover($("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
}

$.extend(Datepicker.prototype, {
	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: "hasDatepicker",

	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
	setDefaults: function(settings) {
		datepicker_extendRemove(this._defaults, settings || {});
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
	_attachDatepicker: function(target, settings) {
		var nodeName, inline, inst;
		nodeName = target.nodeName.toLowerCase();
		inline = (nodeName === "div" || nodeName === "span");
		if (!target.id) {
			this.uuid += 1;
			target.id = "dp" + this.uuid;
		}
		inst = this._newInst($(target), inline);
		inst.settings = $.extend({}, settings || {});
		if (nodeName === "input") {
			this._connectDatepicker(target, inst);
		} else if (inline) {
			this._inlineDatepicker(target, inst);
		}
	},

	/* Create a new instance object. */
	_newInst: function(target, inline) {
		var id = target[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"); // escape jQuery meta chars
		return {id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: (!inline ? this.dpDiv : // presentation div
			datepicker_bindHover($("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")))};
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function(target, inst) {
		var input = $(target);
		inst.append = $([]);
		inst.trigger = $([]);
		if (input.hasClass(this.markerClassName)) {
			return;
		}
		this._attachments(input, inst);
		input.addClass(this.markerClassName).keydown(this._doKeyDown).
			keypress(this._doKeyPress).keyup(this._doKeyUp);
		this._autoSize(inst);
		$.data(target, "datepicker", inst);
		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function(input, inst) {
		var showOn, buttonText, buttonImage,
			appendText = this._get(inst, "appendText"),
			isRTL = this._get(inst, "isRTL");

		if (inst.append) {
			inst.append.remove();
		}
		if (appendText) {
			inst.append = $("<span class='" + this._appendClass + "'>" + appendText + "</span>");
			input[isRTL ? "before" : "after"](inst.append);
		}

		input.unbind("focus", this._showDatepicker);

		if (inst.trigger) {
			inst.trigger.remove();
		}

		showOn = this._get(inst, "showOn");
		if (showOn === "focus" || showOn === "both") { // pop-up date picker when in the marked field
			input.focus(this._showDatepicker);
		}
		if (showOn === "button" || showOn === "both") { // pop-up date picker when button clicked
			buttonText = this._get(inst, "buttonText");
			buttonImage = this._get(inst, "buttonImage");
			inst.trigger = $(this._get(inst, "buttonImageOnly") ?
				$("<img/>").addClass(this._triggerClass).
					attr({ src: buttonImage, alt: buttonText, title: buttonText }) :
				$("<button type='button'></button>").addClass(this._triggerClass).
					html(!buttonImage ? buttonText : $("<img/>").attr(
					{ src:buttonImage, alt:buttonText, title:buttonText })));
			input[isRTL ? "before" : "after"](inst.trigger);
			inst.trigger.click(function() {
				if ($.datepicker._datepickerShowing && $.datepicker._lastInput === input[0]) {
					$.datepicker._hideDatepicker();
				} else if ($.datepicker._datepickerShowing && $.datepicker._lastInput !== input[0]) {
					$.datepicker._hideDatepicker();
					$.datepicker._showDatepicker(input[0]);
				} else {
					$.datepicker._showDatepicker(input[0]);
				}
				return false;
			});
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function(inst) {
		if (this._get(inst, "autoSize") && !inst.inline) {
			var findMax, max, maxI, i,
				date = new Date(2009, 12 - 1, 20), // Ensure double digits
				dateFormat = this._get(inst, "dateFormat");

			if (dateFormat.match(/[DM]/)) {
				findMax = function(names) {
					max = 0;
					maxI = 0;
					for (i = 0; i < names.length; i++) {
						if (names[i].length > max) {
							max = names[i].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth(findMax(this._get(inst, (dateFormat.match(/MM/) ?
					"monthNames" : "monthNamesShort"))));
				date.setDate(findMax(this._get(inst, (dateFormat.match(/DD/) ?
					"dayNames" : "dayNamesShort"))) + 20 - date.getDay());
			}
			inst.input.attr("size", this._formatDate(inst, date).length);
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function(target, inst) {
		var divSpan = $(target);
		if (divSpan.hasClass(this.markerClassName)) {
			return;
		}
		divSpan.addClass(this.markerClassName).append(inst.dpDiv);
		$.data(target, "datepicker", inst);
		this._setDate(inst, this._getDefaultDate(inst), true);
		this._updateDatepicker(inst);
		this._updateAlternate(inst);
		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
	_dialogDatepicker: function(input, date, onSelect, settings, pos) {
		var id, browserWidth, browserHeight, scrollX, scrollY,
			inst = this._dialogInst; // internal instance

		if (!inst) {
			this.uuid += 1;
			id = "dp" + this.uuid;
			this._dialogInput = $("<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>");
			this._dialogInput.keydown(this._doKeyDown);
			$("body").append(this._dialogInput);
			inst = this._dialogInst = this._newInst(this._dialogInput, false);
			inst.settings = {};
			$.data(this._dialogInput[0], "datepicker", inst);
		}
		datepicker_extendRemove(inst.settings, settings || {});
		date = (date && date.constructor === Date ? this._formatDate(inst, date) : date);
		this._dialogInput.val(date);

		this._pos = (pos ? (pos.length ? pos : [pos.pageX, pos.pageY]) : null);
		if (!this._pos) {
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;
			scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[(browserWidth / 2) - 100 + scrollX, (browserHeight / 2) - 150 + scrollY];
		}

		// move input on screen for focus, but hidden behind dialog
		this._dialogInput.css("left", (this._pos[0] + 20) + "px").css("top", this._pos[1] + "px");
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass(this._dialogClass);
		this._showDatepicker(this._dialogInput[0]);
		if ($.blockUI) {
			$.blockUI(this.dpDiv);
		}
		$.data(this._dialogInput[0], "datepicker", inst);
		return this;
	},

	/* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
	_destroyDatepicker: function(target) {
		var nodeName,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		$.removeData(target, "datepicker");
		if (nodeName === "input") {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass(this.markerClassName).
				unbind("focus", this._showDatepicker).
				unbind("keydown", this._doKeyDown).
				unbind("keypress", this._doKeyPress).
				unbind("keyup", this._doKeyUp);
		} else if (nodeName === "div" || nodeName === "span") {
			$target.removeClass(this.markerClassName).empty();
		}

		if ( datepicker_instActive === inst ) {
			datepicker_instActive = null;
		}
	},

	/* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_enableDatepicker: function(target) {
		var nodeName, inline,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if (nodeName === "input") {
			target.disabled = false;
			inst.trigger.filter("button").
				each(function() { this.disabled = false; }).end().
				filter("img").css({opacity: "1.0", cursor: ""});
		} else if (nodeName === "div" || nodeName === "span") {
			inline = $target.children("." + this._inlineClass);
			inline.children().removeClass("ui-state-disabled");
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				prop("disabled", false);
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value === target ? null : value); }); // delete entry
	},

	/* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_disableDatepicker: function(target) {
		var nodeName, inline,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if (nodeName === "input") {
			target.disabled = true;
			inst.trigger.filter("button").
				each(function() { this.disabled = true; }).end().
				filter("img").css({opacity: "0.5", cursor: "default"});
		} else if (nodeName === "div" || nodeName === "span") {
			inline = $target.children("." + this._inlineClass);
			inline.children().addClass("ui-state-disabled");
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				prop("disabled", true);
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value === target ? null : value); }); // delete entry
		this._disabledInputs[this._disabledInputs.length] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
	_isDisabledDatepicker: function(target) {
		if (!target) {
			return false;
		}
		for (var i = 0; i < this._disabledInputs.length; i++) {
			if (this._disabledInputs[i] === target) {
				return true;
			}
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
	_getInst: function(target) {
		try {
			return $.data(target, "datepicker");
		}
		catch (err) {
			throw "Missing instance data for this datepicker";
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
	_optionDatepicker: function(target, name, value) {
		var settings, date, minDate, maxDate,
			inst = this._getInst(target);

		if (arguments.length === 2 && typeof name === "string") {
			return (name === "defaults" ? $.extend({}, $.datepicker._defaults) :
				(inst ? (name === "all" ? $.extend({}, inst.settings) :
				this._get(inst, name)) : null));
		}

		settings = name || {};
		if (typeof name === "string") {
			settings = {};
			settings[name] = value;
		}

		if (inst) {
			if (this._curInst === inst) {
				this._hideDatepicker();
			}

			date = this._getDateDatepicker(target, true);
			minDate = this._getMinMaxDate(inst, "min");
			maxDate = this._getMinMaxDate(inst, "max");
			datepicker_extendRemove(inst.settings, settings);
			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) {
				inst.settings.minDate = this._formatDate(inst, minDate);
			}
			if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) {
				inst.settings.maxDate = this._formatDate(inst, maxDate);
			}
			if ( "disabled" in settings ) {
				if ( settings.disabled ) {
					this._disableDatepicker(target);
				} else {
					this._enableDatepicker(target);
				}
			}
			this._attachments($(target), inst);
			this._autoSize(inst);
			this._setDate(inst, date);
			this._updateAlternate(inst);
			this._updateDatepicker(inst);
		}
	},

	// change method deprecated
	_changeDatepicker: function(target, name, value) {
		this._optionDatepicker(target, name, value);
	},

	/* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
	_refreshDatepicker: function(target) {
		var inst = this._getInst(target);
		if (inst) {
			this._updateDatepicker(inst);
		}
	},

	/* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
	_setDateDatepicker: function(target, date) {
		var inst = this._getInst(target);
		if (inst) {
			this._setDate(inst, date);
			this._updateDatepicker(inst);
			this._updateAlternate(inst);
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
	_getDateDatepicker: function(target, noDefault) {
		var inst = this._getInst(target);
		if (inst && !inst.inline) {
			this._setDateFromField(inst, noDefault);
		}
		return (inst ? this._getDate(inst) : null);
	},

	/* Handle keystrokes. */
	_doKeyDown: function(event) {
		var onSelect, dateStr, sel,
			inst = $.datepicker._getInst(event.target),
			handled = true,
			isRTL = inst.dpDiv.is(".ui-datepicker-rtl");

		inst._keyEvent = true;
		if ($.datepicker._datepickerShowing) {
			switch (event.keyCode) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: sel = $("td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv);
						if (sel[0]) {
							$.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
						}

						onSelect = $.datepicker._get(inst, "onSelect");
						if (onSelect) {
							dateStr = $.datepicker._formatDate(inst);

							// trigger custom callback
							onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);
						} else {
							$.datepicker._hideDatepicker();
						}

						return false; // don't submit the form
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							-$.datepicker._get(inst, "stepBigMonths") :
							-$.datepicker._get(inst, "stepMonths")), "M");
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							+$.datepicker._get(inst, "stepBigMonths") :
							+$.datepicker._get(inst, "stepMonths")), "M");
						break; // next month/year on page down/+ ctrl
				case 35: if (event.ctrlKey || event.metaKey) {
							$.datepicker._clearDate(event.target);
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if (event.ctrlKey || event.metaKey) {
							$.datepicker._gotoToday(event.target);
						}
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, (isRTL ? +1 : -1), "D");
						}
						handled = event.ctrlKey || event.metaKey;
						// -1 day on ctrl or command +left
						if (event.originalEvent.altKey) {
							$.datepicker._adjustDate(event.target, (event.ctrlKey ?
								-$.datepicker._get(inst, "stepBigMonths") :
								-$.datepicker._get(inst, "stepMonths")), "M");
						}
						// next month/year on alt +left on Mac
						break;
				case 38: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, -7, "D");
						}
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, (isRTL ? -1 : +1), "D");
						}
						handled = event.ctrlKey || event.metaKey;
						// +1 day on ctrl or command +right
						if (event.originalEvent.altKey) {
							$.datepicker._adjustDate(event.target, (event.ctrlKey ?
								+$.datepicker._get(inst, "stepBigMonths") :
								+$.datepicker._get(inst, "stepMonths")), "M");
						}
						// next month/year on alt +right
						break;
				case 40: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, +7, "D");
						}
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		} else if (event.keyCode === 36 && event.ctrlKey) { // display the date picker on ctrl+home
			$.datepicker._showDatepicker(this);
		} else {
			handled = false;
		}

		if (handled) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function(event) {
		var chars, chr,
			inst = $.datepicker._getInst(event.target);

		if ($.datepicker._get(inst, "constrainInput")) {
			chars = $.datepicker._possibleChars($.datepicker._get(inst, "dateFormat"));
			chr = String.fromCharCode(event.charCode == null ? event.keyCode : event.charCode);
			return event.ctrlKey || event.metaKey || (chr < " " || !chars || chars.indexOf(chr) > -1);
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function(event) {
		var date,
			inst = $.datepicker._getInst(event.target);

		if (inst.input.val() !== inst.lastVal) {
			try {
				date = $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
					(inst.input ? inst.input.val() : null),
					$.datepicker._getFormatConfig(inst));

				if (date) { // only if valid
					$.datepicker._setDateFromField(inst);
					$.datepicker._updateAlternate(inst);
					$.datepicker._updateDatepicker(inst);
				}
			}
			catch (err) {
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
	_showDatepicker: function(input) {
		input = input.target || input;
		if (input.nodeName.toLowerCase() !== "input") { // find from button/image trigger
			input = $("input", input.parentNode)[0];
		}

		if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput === input) { // already here
			return;
		}

		var inst, beforeShow, beforeShowSettings, isFixed,
			offset, showAnim, duration;

		inst = $.datepicker._getInst(input);
		if ($.datepicker._curInst && $.datepicker._curInst !== inst) {
			$.datepicker._curInst.dpDiv.stop(true, true);
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[0] );
			}
		}

		beforeShow = $.datepicker._get(inst, "beforeShow");
		beforeShowSettings = beforeShow ? beforeShow.apply(input, [input, inst]) : {};
		if(beforeShowSettings === false){
			return;
		}
		datepicker_extendRemove(inst.settings, beforeShowSettings);

		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField(inst);

		if ($.datepicker._inDialog) { // hide cursor
			input.value = "";
		}
		if (!$.datepicker._pos) { // position below input
			$.datepicker._pos = $.datepicker._findPos(input);
			$.datepicker._pos[1] += input.offsetHeight; // add the height
		}

		isFixed = false;
		$(input).parents().each(function() {
			isFixed |= $(this).css("position") === "fixed";
			return !isFixed;
		});

		offset = {left: $.datepicker._pos[0], top: $.datepicker._pos[1]};
		$.datepicker._pos = null;
		//to avoid flashes on Firefox
		inst.dpDiv.empty();
		// determine sizing offscreen
		inst.dpDiv.css({position: "absolute", display: "block", top: "-1000px"});
		$.datepicker._updateDatepicker(inst);
		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset(inst, offset, isFixed);
		inst.dpDiv.css({position: ($.datepicker._inDialog && $.blockUI ?
			"static" : (isFixed ? "fixed" : "absolute")), display: "none",
			left: offset.left + "px", top: offset.top + "px"});

		if (!inst.inline) {
			showAnim = $.datepicker._get(inst, "showAnim");
			duration = $.datepicker._get(inst, "duration");
			inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
			$.datepicker._datepickerShowing = true;

			if ( $.effects && $.effects.effect[ showAnim ] ) {
				inst.dpDiv.show(showAnim, $.datepicker._get(inst, "showOptions"), duration);
			} else {
				inst.dpDiv[showAnim || "show"](showAnim ? duration : null);
			}

			if ( $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.focus();
			}

			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function(inst) {
		this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		datepicker_instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append(this._generateHTML(inst));
		this._attachHandlers(inst);

		var origyearshtml,
			numMonths = this._getNumberOfMonths(inst),
			cols = numMonths[1],
			width = 17,
			activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );

		if ( activeCell.length > 0 ) {
			datepicker_handleMouseover.apply( activeCell.get( 0 ) );
		}

		inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
		if (cols > 1) {
			inst.dpDiv.addClass("ui-datepicker-multi-" + cols).css("width", (width * cols) + "em");
		}
		inst.dpDiv[(numMonths[0] !== 1 || numMonths[1] !== 1 ? "add" : "remove") +
			"Class"]("ui-datepicker-multi");
		inst.dpDiv[(this._get(inst, "isRTL") ? "add" : "remove") +
			"Class"]("ui-datepicker-rtl");

		if (inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
			inst.input.focus();
		}

		// deffered render of the years select (to avoid flashes on Firefox)
		if( inst.yearshtml ){
			origyearshtml = inst.yearshtml;
			setTimeout(function(){
				//assure that inst.yearshtml didn't change.
				if( origyearshtml === inst.yearshtml && inst.yearshtml ){
					inst.dpDiv.find("select.ui-datepicker-year:first").replaceWith(inst.yearshtml);
				}
				origyearshtml = inst.yearshtml = null;
			}, 0);
		}
	},

	// #6694 - don't focus the input if it's already focused
	// this breaks the change event in IE
	// Support: IE and jQuery <1.9
	_shouldFocusInput: function( inst ) {
		return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function(inst, offset, isFixed) {
		var dpWidth = inst.dpDiv.outerWidth(),
			dpHeight = inst.dpDiv.outerHeight(),
			inputWidth = inst.input ? inst.input.outerWidth() : 0,
			inputHeight = inst.input ? inst.input.outerHeight() : 0,
			viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft()),
			viewHeight = document.documentElement.clientHeight + (isFixed ? 0 : $(document).scrollTop());

		offset.left -= (this._get(inst, "isRTL") ? (dpWidth - inputWidth) : 0);
		offset.left -= (isFixed && offset.left === inst.input.offset().left) ? $(document).scrollLeft() : 0;
		offset.top -= (isFixed && offset.top === (inst.input.offset().top + inputHeight)) ? $(document).scrollTop() : 0;

		// now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
			Math.abs(offset.left + dpWidth - viewWidth) : 0);
		offset.top -= Math.min(offset.top, (offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
			Math.abs(dpHeight + inputHeight) : 0);

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function(obj) {
		var position,
			inst = this._getInst(obj),
			isRTL = this._get(inst, "isRTL");

		while (obj && (obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden(obj))) {
			obj = obj[isRTL ? "previousSibling" : "nextSibling"];
		}

		position = $(obj).offset();
		return [position.left, position.top];
	},

	/* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
	_hideDatepicker: function(input) {
		var showAnim, duration, postProcess, onClose,
			inst = this._curInst;

		if (!inst || (input && inst !== $.data(input, "datepicker"))) {
			return;
		}

		if (this._datepickerShowing) {
			showAnim = this._get(inst, "showAnim");
			duration = this._get(inst, "duration");
			postProcess = function() {
				$.datepicker._tidyDialog(inst);
			};

			// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
			if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
				inst.dpDiv.hide(showAnim, $.datepicker._get(inst, "showOptions"), duration, postProcess);
			} else {
				inst.dpDiv[(showAnim === "slideDown" ? "slideUp" :
					(showAnim === "fadeIn" ? "fadeOut" : "hide"))]((showAnim ? duration : null), postProcess);
			}

			if (!showAnim) {
				postProcess();
			}
			this._datepickerShowing = false;

			onClose = this._get(inst, "onClose");
			if (onClose) {
				onClose.apply((inst.input ? inst.input[0] : null), [(inst.input ? inst.input.val() : ""), inst]);
			}

			this._lastInput = null;
			if (this._inDialog) {
				this._dialogInput.css({ position: "absolute", left: "0", top: "-100px" });
				if ($.blockUI) {
					$.unblockUI();
					$("body").append(this.dpDiv);
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function(inst) {
		inst.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar");
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function(event) {
		if (!$.datepicker._curInst) {
			return;
		}

		var $target = $(event.target),
			inst = $.datepicker._getInst($target[0]);

		if ( ( ( $target[0].id !== $.datepicker._mainDivId &&
				$target.parents("#" + $.datepicker._mainDivId).length === 0 &&
				!$target.hasClass($.datepicker.markerClassName) &&
				!$target.closest("." + $.datepicker._triggerClass).length &&
				$.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) ) ) ||
			( $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst !== inst ) ) {
				$.datepicker._hideDatepicker();
		}
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function(id, offset, period) {
		var target = $(id),
			inst = this._getInst(target[0]);

		if (this._isDisabledDatepicker(target[0])) {
			return;
		}
		this._adjustInstDate(inst, offset +
			(period === "M" ? this._get(inst, "showCurrentAtPos") : 0), // undo positioning
			period);
		this._updateDatepicker(inst);
	},

	/* Action for current link. */
	_gotoToday: function(id) {
		var date,
			target = $(id),
			inst = this._getInst(target[0]);

		if (this._get(inst, "gotoCurrent") && inst.currentDay) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		} else {
			date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function(id, select, period) {
		var target = $(id),
			inst = this._getInst(target[0]);

		inst["selected" + (period === "M" ? "Month" : "Year")] =
		inst["draw" + (period === "M" ? "Month" : "Year")] =
			parseInt(select.options[select.selectedIndex].value,10);

		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a day. */
	_selectDay: function(id, month, year, td) {
		var inst,
			target = $(id);

		if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) {
			return;
		}

		inst = this._getInst(target[0]);
		inst.selectedDay = inst.currentDay = $("a", td).html();
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate(id, this._formatDate(inst,
			inst.currentDay, inst.currentMonth, inst.currentYear));
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function(id) {
		var target = $(id);
		this._selectDate(target, "");
	},

	/* Update the input field with the selected date. */
	_selectDate: function(id, dateStr) {
		var onSelect,
			target = $(id),
			inst = this._getInst(target[0]);

		dateStr = (dateStr != null ? dateStr : this._formatDate(inst));
		if (inst.input) {
			inst.input.val(dateStr);
		}
		this._updateAlternate(inst);

		onSelect = this._get(inst, "onSelect");
		if (onSelect) {
			onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);  // trigger custom callback
		} else if (inst.input) {
			inst.input.trigger("change"); // fire the change event
		}

		if (inst.inline){
			this._updateDatepicker(inst);
		} else {
			this._hideDatepicker();
			this._lastInput = inst.input[0];
			if (typeof(inst.input[0]) !== "object") {
				inst.input.focus(); // restore focus
			}
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function(inst) {
		var altFormat, date, dateStr,
			altField = this._get(inst, "altField");

		if (altField) { // update alternate field too
			altFormat = this._get(inst, "altFormat") || this._get(inst, "dateFormat");
			date = this._getDate(inst);
			dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
			$(altField).each(function() { $(this).val(dateStr); });
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
	noWeekends: function(date) {
		var day = date.getDay();
		return [(day > 0 && day < 6), ""];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
	iso8601Week: function(date) {
		var time,
			checkDate = new Date(date.getTime());

		// Find Thursday of this week starting on Monday
		checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));

		time = checkDate.getTime();
		checkDate.setMonth(0); // Compare with Jan 1
		checkDate.setDate(1);
		return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	},

	/* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
	parseDate: function (format, value, settings) {
		if (format == null || value == null) {
			throw "Invalid arguments";
		}

		value = (typeof value === "object" ? value.toString() : value + "");
		if (value === "") {
			return null;
		}

		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff,
			shortYearCutoff = (typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt(shortYearCutoffTemp, 10)),
			dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
			dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
			monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
			monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
			year = -1,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			},
			// Extract a number from the string value
			getNumber = function(match) {
				var isDoubled = lookAhead(match),
					size = (match === "@" ? 14 : (match === "!" ? 20 :
					(match === "y" && isDoubled ? 4 : (match === "o" ? 3 : 2)))),
					minSize = (match === "y" ? size : 1),
					digits = new RegExp("^\\d{" + minSize + "," + size + "}"),
					num = value.substring(iValue).match(digits);
				if (!num) {
					throw "Missing number at position " + iValue;
				}
				iValue += num[0].length;
				return parseInt(num[0], 10);
			},
			// Extract a name from the string value and convert to an index
			getName = function(match, shortNames, longNames) {
				var index = -1,
					names = $.map(lookAhead(match) ? longNames : shortNames, function (v, k) {
						return [ [k, v] ];
					}).sort(function (a, b) {
						return -(a[1].length - b[1].length);
					});

				$.each(names, function (i, pair) {
					var name = pair[1];
					if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
						index = pair[0];
						iValue += name.length;
						return false;
					}
				});
				if (index !== -1) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},
			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if (value.charAt(iValue) !== format.charAt(iFormat)) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};

		for (iFormat = 0; iFormat < format.length; iFormat++) {
			if (literal) {
				if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch (format.charAt(iFormat)) {
					case "d":
						day = getNumber("d");
						break;
					case "D":
						getName("D", dayNamesShort, dayNames);
						break;
					case "o":
						doy = getNumber("o");
						break;
					case "m":
						month = getNumber("m");
						break;
					case "M":
						month = getName("M", monthNamesShort, monthNames);
						break;
					case "y":
						year = getNumber("y");
						break;
					case "@":
						date = new Date(getNumber("@"));
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date((getNumber("!") - this._ticksTo1970) / 10000);
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if (lookAhead("'")){
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}

		if (iValue < value.length){
			extra = value.substr(iValue);
			if (!/^\s+/.test(extra)) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}

		if (year === -1) {
			year = new Date().getFullYear();
		} else if (year < 100) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				(year <= shortYearCutoff ? 0 : -100);
		}

		if (doy > -1) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth(year, month - 1);
				if (day <= dim) {
					break;
				}
				month++;
				day -= dim;
			} while (true);
		}

		date = this._daylightSavingAdjust(new Date(year, month - 1, day));
		if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	},

	/* Standard date formats. */
	ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
	COOKIE: "D, dd M yy",
	ISO_8601: "yy-mm-dd",
	RFC_822: "D, d M y",
	RFC_850: "DD, dd-M-y",
	RFC_1036: "D, d M y",
	RFC_1123: "D, d M yy",
	RFC_2822: "D, d M yy",
	RSS: "D, d M y", // RFC 822
	TICKS: "!",
	TIMESTAMP: "@",
	W3C: "yy-mm-dd", // ISO 8601

	_ticksTo1970: (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) +
		Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000),

	/* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
	formatDate: function (format, date, settings) {
		if (!date) {
			return "";
		}

		var iFormat,
			dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
			dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
			monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
			monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			},
			// Format a number, with leading zero if necessary
			formatNumber = function(match, value, len) {
				var num = "" + value;
				if (lookAhead(match)) {
					while (num.length < len) {
						num = "0" + num;
					}
				}
				return num;
			},
			// Format a name, short or long as requested
			formatName = function(match, value, shortNames, longNames) {
				return (lookAhead(match) ? longNames[value] : shortNames[value]);
			},
			output = "",
			literal = false;

		if (date) {
			for (iFormat = 0; iFormat < format.length; iFormat++) {
				if (literal) {
					if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
						literal = false;
					} else {
						output += format.charAt(iFormat);
					}
				} else {
					switch (format.charAt(iFormat)) {
						case "d":
							output += formatNumber("d", date.getDate(), 2);
							break;
						case "D":
							output += formatName("D", date.getDay(), dayNamesShort, dayNames);
							break;
						case "o":
							output += formatNumber("o",
								Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
							break;
						case "m":
							output += formatNumber("m", date.getMonth() + 1, 2);
							break;
						case "M":
							output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
							break;
						case "y":
							output += (lookAhead("y") ? date.getFullYear() :
								(date.getYear() % 100 < 10 ? "0" : "") + date.getYear() % 100);
							break;
						case "@":
							output += date.getTime();
							break;
						case "!":
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if (lookAhead("'")) {
								output += "'";
							} else {
								literal = true;
							}
							break;
						default:
							output += format.charAt(iFormat);
					}
				}
			}
		}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function (format) {
		var iFormat,
			chars = "",
			literal = false,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			};

		for (iFormat = 0; iFormat < format.length; iFormat++) {
			if (literal) {
				if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
					literal = false;
				} else {
					chars += format.charAt(iFormat);
				}
			} else {
				switch (format.charAt(iFormat)) {
					case "d": case "m": case "y": case "@":
						chars += "0123456789";
						break;
					case "D": case "M":
						return null; // Accept anything
					case "'":
						if (lookAhead("'")) {
							chars += "'";
						} else {
							literal = true;
						}
						break;
					default:
						chars += format.charAt(iFormat);
				}
			}
		}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function(inst, name) {
		return inst.settings[name] !== undefined ?
			inst.settings[name] : this._defaults[name];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function(inst, noDefault) {
		if (inst.input.val() === inst.lastVal) {
			return;
		}

		var dateFormat = this._get(inst, "dateFormat"),
			dates = inst.lastVal = inst.input ? inst.input.val() : null,
			defaultDate = this._getDefaultDate(inst),
			date = defaultDate,
			settings = this._getFormatConfig(inst);

		try {
			date = this.parseDate(dateFormat, dates, settings) || defaultDate;
		} catch (event) {
			dates = (noDefault ? "" : dates);
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = (dates ? date.getDate() : 0);
		inst.currentMonth = (dates ? date.getMonth() : 0);
		inst.currentYear = (dates ? date.getFullYear() : 0);
		this._adjustInstDate(inst);
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function(inst) {
		return this._restrictMinMax(inst,
			this._determineDate(inst, this._get(inst, "defaultDate"), new Date()));
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function(inst, date, defaultDate) {
		var offsetNumeric = function(offset) {
				var date = new Date();
				date.setDate(date.getDate() + offset);
				return date;
			},
			offsetString = function(offset) {
				try {
					return $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
						offset, $.datepicker._getFormatConfig(inst));
				}
				catch (e) {
					// Ignore
				}

				var date = (offset.toLowerCase().match(/^c/) ?
					$.datepicker._getDate(inst) : null) || new Date(),
					year = date.getFullYear(),
					month = date.getMonth(),
					day = date.getDate(),
					pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					matches = pattern.exec(offset);

				while (matches) {
					switch (matches[2] || "d") {
						case "d" : case "D" :
							day += parseInt(matches[1],10); break;
						case "w" : case "W" :
							day += parseInt(matches[1],10) * 7; break;
						case "m" : case "M" :
							month += parseInt(matches[1],10);
							day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
							break;
						case "y": case "Y" :
							year += parseInt(matches[1],10);
							day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
							break;
					}
					matches = pattern.exec(offset);
				}
				return new Date(year, month, day);
			},
			newDate = (date == null || date === "" ? defaultDate : (typeof date === "string" ? offsetString(date) :
				(typeof date === "number" ? (isNaN(date) ? defaultDate : offsetNumeric(date)) : new Date(date.getTime()))));

		newDate = (newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate);
		if (newDate) {
			newDate.setHours(0);
			newDate.setMinutes(0);
			newDate.setSeconds(0);
			newDate.setMilliseconds(0);
		}
		return this._daylightSavingAdjust(newDate);
	},

	/* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
	_daylightSavingAdjust: function(date) {
		if (!date) {
			return null;
		}
		date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function(inst, date, noChange) {
		var clear = !date,
			origMonth = inst.selectedMonth,
			origYear = inst.selectedYear,
			newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));

		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ((origMonth !== inst.selectedMonth || origYear !== inst.selectedYear) && !noChange) {
			this._notifyChange(inst);
		}
		this._adjustInstDate(inst);
		if (inst.input) {
			inst.input.val(clear ? "" : this._formatDate(inst));
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function(inst) {
		var startDate = (!inst.currentYear || (inst.input && inst.input.val() === "") ? null :
			this._daylightSavingAdjust(new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay)));
			return startDate;
	},

	/* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
	_attachHandlers: function(inst) {
		var stepMonths = this._get(inst, "stepMonths"),
			id = "#" + inst.id.replace( /\\\\/g, "\\" );
		inst.dpDiv.find("[data-handler]").map(function () {
			var handler = {
				prev: function () {
					$.datepicker._adjustDate(id, -stepMonths, "M");
				},
				next: function () {
					$.datepicker._adjustDate(id, +stepMonths, "M");
				},
				hide: function () {
					$.datepicker._hideDatepicker();
				},
				today: function () {
					$.datepicker._gotoToday(id);
				},
				selectDay: function () {
					$.datepicker._selectDay(id, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this);
					return false;
				},
				selectMonth: function () {
					$.datepicker._selectMonthYear(id, this, "M");
					return false;
				},
				selectYear: function () {
					$.datepicker._selectMonthYear(id, this, "Y");
					return false;
				}
			};
			$(this).bind(this.getAttribute("data-event"), handler[this.getAttribute("data-handler")]);
		});
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function(inst) {
		var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
			controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
			monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
			selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
			cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
			printDate, dRow, tbody, daySettings, otherMonth, unselectable,
			tempDate = new Date(),
			today = this._daylightSavingAdjust(
				new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate())), // clear time
			isRTL = this._get(inst, "isRTL"),
			showButtonPanel = this._get(inst, "showButtonPanel"),
			hideIfNoPrevNext = this._get(inst, "hideIfNoPrevNext"),
			navigationAsDateFormat = this._get(inst, "navigationAsDateFormat"),
			numMonths = this._getNumberOfMonths(inst),
			showCurrentAtPos = this._get(inst, "showCurrentAtPos"),
			stepMonths = this._get(inst, "stepMonths"),
			isMultiMonth = (numMonths[0] !== 1 || numMonths[1] !== 1),
			currentDate = this._daylightSavingAdjust((!inst.currentDay ? new Date(9999, 9, 9) :
				new Date(inst.currentYear, inst.currentMonth, inst.currentDay))),
			minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			drawMonth = inst.drawMonth - showCurrentAtPos,
			drawYear = inst.drawYear;

		if (drawMonth < 0) {
			drawMonth += 12;
			drawYear--;
		}
		if (maxDate) {
			maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(),
				maxDate.getMonth() - (numMonths[0] * numMonths[1]) + 1, maxDate.getDate()));
			maxDraw = (minDate && maxDraw < minDate ? minDate : maxDraw);
			while (this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw) {
				drawMonth--;
				if (drawMonth < 0) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;

		prevText = this._get(inst, "prevText");
		prevText = (!navigationAsDateFormat ? prevText : this.formatDate(prevText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)),
			this._getFormatConfig(inst)));

		prev = (this._canAdjustMonth(inst, -1, drawYear, drawMonth) ?
			"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
			" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>" :
			(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+ prevText +"'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>"));

		nextText = this._get(inst, "nextText");
		nextText = (!navigationAsDateFormat ? nextText : this.formatDate(nextText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)),
			this._getFormatConfig(inst)));

		next = (this._canAdjustMonth(inst, +1, drawYear, drawMonth) ?
			"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
			" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>" :
			(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+ nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>"));

		currentText = this._get(inst, "currentText");
		gotoDate = (this._get(inst, "gotoCurrent") && inst.currentDay ? currentDate : today);
		currentText = (!navigationAsDateFormat ? currentText :
			this.formatDate(currentText, gotoDate, this._getFormatConfig(inst)));

		controls = (!inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
			this._get(inst, "closeText") + "</button>" : "");

		buttonPanel = (showButtonPanel) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (isRTL ? controls : "") +
			(this._isInRange(inst, gotoDate) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
			">" + currentText + "</button>" : "") + (isRTL ? "" : controls) + "</div>" : "";

		firstDay = parseInt(this._get(inst, "firstDay"),10);
		firstDay = (isNaN(firstDay) ? 0 : firstDay);

		showWeek = this._get(inst, "showWeek");
		dayNames = this._get(inst, "dayNames");
		dayNamesMin = this._get(inst, "dayNamesMin");
		monthNames = this._get(inst, "monthNames");
		monthNamesShort = this._get(inst, "monthNamesShort");
		beforeShowDay = this._get(inst, "beforeShowDay");
		showOtherMonths = this._get(inst, "showOtherMonths");
		selectOtherMonths = this._get(inst, "selectOtherMonths");
		defaultDate = this._getDefaultDate(inst);
		html = "";
		dow;
		for (row = 0; row < numMonths[0]; row++) {
			group = "";
			this.maxRows = 4;
			for (col = 0; col < numMonths[1]; col++) {
				selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
				cornerClass = " ui-corner-all";
				calender = "";
				if (isMultiMonth) {
					calender += "<div class='ui-datepicker-group";
					if (numMonths[1] > 1) {
						switch (col) {
							case 0: calender += " ui-datepicker-group-first";
								cornerClass = " ui-corner-" + (isRTL ? "right" : "left"); break;
							case numMonths[1]-1: calender += " ui-datepicker-group-last";
								cornerClass = " ui-corner-" + (isRTL ? "left" : "right"); break;
							default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
						}
					}
					calender += "'>";
				}
				calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					(/all|left/.test(cornerClass) && row === 0 ? (isRTL ? next : prev) : "") +
					(/all|right/.test(cornerClass) && row === 0 ? (isRTL ? prev : next) : "") +
					this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
				thead = (showWeek ? "<th class='ui-datepicker-week-col'>" + this._get(inst, "weekHeader") + "</th>" : "");
				for (dow = 0; dow < 7; dow++) { // days of the week
					day = (dow + firstDay) % 7;
					thead += "<th scope='col'" + ((dow + firstDay + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" +
						"<span title='" + dayNames[day] + "'>" + dayNamesMin[day] + "</span></th>";
				}
				calender += thead + "</tr></thead><tbody>";
				daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
				if (drawYear === inst.selectedYear && drawMonth === inst.selectedMonth) {
					inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
				}
				leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
				curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
				numRows = (isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
				for (dRow = 0; dRow < numRows; dRow++) { // create date picker rows
					calender += "<tr>";
					tbody = (!showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get(inst, "calculateWeek")(printDate) + "</td>");
					for (dow = 0; dow < 7; dow++) { // create date picker days
						daySettings = (beforeShowDay ?
							beforeShowDay.apply((inst.input ? inst.input[0] : null), [printDate]) : [true, ""]);
						otherMonth = (printDate.getMonth() !== drawMonth);
						unselectable = (otherMonth && !selectOtherMonths) || !daySettings[0] ||
							(minDate && printDate < minDate) || (maxDate && printDate > maxDate);
						tbody += "<td class='" +
							((dow + firstDay + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + // highlight weekends
							(otherMonth ? " ui-datepicker-other-month" : "") + // highlight days from other months
							((printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent) || // user pressed key
							(defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime()) ?
							// or defaultDate is current printedDate and defaultDate is selectedDate
							" " + this._dayOverClass : "") + // highlight selected day
							(unselectable ? " " + this._unselectableClass + " ui-state-disabled": "") +  // highlight unselectable days
							(otherMonth && !showOtherMonths ? "" : " " + daySettings[1] + // highlight custom dates
							(printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "") + // highlight selected day
							(printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "")) + "'" + // highlight today (if different)
							((!otherMonth || showOtherMonths) && daySettings[2] ? " title='" + daySettings[2].replace(/'/g, "&#39;") + "'" : "") + // cell title
							(unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'") + ">" + // actions
							(otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							(unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							(printDate.getTime() === today.getTime() ? " ui-state-highlight" : "") +
							(printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "") + // highlight selected day
							(otherMonth ? " ui-priority-secondary" : "") + // distinguish dates from other months
							"' href='#'>" + printDate.getDate() + "</a>")) + "</td>"; // display selectable date
						printDate.setDate(printDate.getDate() + 1);
						printDate = this._daylightSavingAdjust(printDate);
					}
					calender += tbody + "</tr>";
				}
				drawMonth++;
				if (drawMonth > 11) {
					drawMonth = 0;
					drawYear++;
				}
				calender += "</tbody></table>" + (isMultiMonth ? "</div>" +
							((numMonths[0] > 0 && col === numMonths[1]-1) ? "<div class='ui-datepicker-row-break'></div>" : "") : "");
				group += calender;
			}
			html += group;
		}
		html += buttonPanel;
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function(inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort) {

		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get(inst, "changeMonth"),
			changeYear = this._get(inst, "changeYear"),
			showMonthAfterYear = this._get(inst, "showMonthAfterYear"),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";

		// month selection
		if (secondary || !changeMonth) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[drawMonth] + "</span>";
		} else {
			inMinYear = (minDate && minDate.getFullYear() === drawYear);
			inMaxYear = (maxDate && maxDate.getFullYear() === drawYear);
			monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++) {
				if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) {
					monthHtml += "<option value='" + month + "'" +
						(month === drawMonth ? " selected='selected'" : "") +
						">" + monthNamesShort[month] + "</option>";
				}
			}
			monthHtml += "</select>";
		}

		if (!showMonthAfterYear) {
			html += monthHtml + (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "");
		}

		// year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if (secondary || !changeYear) {
				html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
			} else {
				// determine range of years to display
				years = this._get(inst, "yearRange").split(":");
				thisYear = new Date().getFullYear();
				determineYear = function(value) {
					var year = (value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) :
						(value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) :
						parseInt(value, 10)));
					return (isNaN(year) ? thisYear : year);
				};
				year = determineYear(years[0]);
				endYear = Math.max(year, determineYear(years[1] || ""));
				year = (minDate ? Math.max(year, minDate.getFullYear()) : year);
				endYear = (maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear);
				inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
				for (; year <= endYear; year++) {
					inst.yearshtml += "<option value='" + year + "'" +
						(year === drawYear ? " selected='selected'" : "") +
						">" + year + "</option>";
				}
				inst.yearshtml += "</select>";

				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}

		html += this._get(inst, "yearSuffix");
		if (showMonthAfterYear) {
			html += (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "") + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function(inst, offset, period) {
		var year = inst.drawYear + (period === "Y" ? offset : 0),
			month = inst.drawMonth + (period === "M" ? offset : 0),
			day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) + (period === "D" ? offset : 0),
			date = this._restrictMinMax(inst, this._daylightSavingAdjust(new Date(year, month, day)));

		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if (period === "M" || period === "Y") {
			this._notifyChange(inst);
		}
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function(inst, date) {
		var minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			newDate = (minDate && date < minDate ? minDate : date);
		return (maxDate && newDate > maxDate ? maxDate : newDate);
	},

	/* Notify change of month/year. */
	_notifyChange: function(inst) {
		var onChange = this._get(inst, "onChangeMonthYear");
		if (onChange) {
			onChange.apply((inst.input ? inst.input[0] : null),
				[inst.selectedYear, inst.selectedMonth + 1, inst]);
		}
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function(inst) {
		var numMonths = this._get(inst, "numberOfMonths");
		return (numMonths == null ? [1, 1] : (typeof numMonths === "number" ? [1, numMonths] : numMonths));
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function(inst, minMax) {
		return this._determineDate(inst, this._get(inst, minMax + "Date"), null);
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function(year, month) {
		return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function(year, month) {
		return new Date(year, month, 1).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function(inst, offset, curYear, curMonth) {
		var numMonths = this._getNumberOfMonths(inst),
			date = this._daylightSavingAdjust(new Date(curYear,
			curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));

		if (offset < 0) {
			date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
		}
		return this._isInRange(inst, date);
	},

	/* Is the given date in the accepted range? */
	_isInRange: function(inst, date) {
		var yearSplit, currentYear,
			minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			minYear = null,
			maxYear = null,
			years = this._get(inst, "yearRange");
			if (years){
				yearSplit = years.split(":");
				currentYear = new Date().getFullYear();
				minYear = parseInt(yearSplit[0], 10);
				maxYear = parseInt(yearSplit[1], 10);
				if ( yearSplit[0].match(/[+\-].*/) ) {
					minYear += currentYear;
				}
				if ( yearSplit[1].match(/[+\-].*/) ) {
					maxYear += currentYear;
				}
			}

		return ((!minDate || date.getTime() >= minDate.getTime()) &&
			(!maxDate || date.getTime() <= maxDate.getTime()) &&
			(!minYear || date.getFullYear() >= minYear) &&
			(!maxYear || date.getFullYear() <= maxYear));
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function(inst) {
		var shortYearCutoff = this._get(inst, "shortYearCutoff");
		shortYearCutoff = (typeof shortYearCutoff !== "string" ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10));
		return {shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get(inst, "dayNamesShort"), dayNames: this._get(inst, "dayNames"),
			monthNamesShort: this._get(inst, "monthNamesShort"), monthNames: this._get(inst, "monthNames")};
	},

	/* Format the given date for display. */
	_formatDate: function(inst, day, month, year) {
		if (!day) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = (day ? (typeof day === "object" ? day :
			this._daylightSavingAdjust(new Date(year, month, day))) :
			this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay)));
		return this.formatDate(this._get(inst, "dateFormat"), date, this._getFormatConfig(inst));
	}
});

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
function datepicker_bindHover(dpDiv) {
	var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
	return dpDiv.delegate(selector, "mouseout", function() {
			$(this).removeClass("ui-state-hover");
			if (this.className.indexOf("ui-datepicker-prev") !== -1) {
				$(this).removeClass("ui-datepicker-prev-hover");
			}
			if (this.className.indexOf("ui-datepicker-next") !== -1) {
				$(this).removeClass("ui-datepicker-next-hover");
			}
		})
		.delegate( selector, "mouseover", datepicker_handleMouseover );
}

function datepicker_handleMouseover() {
	if (!$.datepicker._isDisabledDatepicker( datepicker_instActive.inline? datepicker_instActive.dpDiv.parent()[0] : datepicker_instActive.input[0])) {
		$(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");
		$(this).addClass("ui-state-hover");
		if (this.className.indexOf("ui-datepicker-prev") !== -1) {
			$(this).addClass("ui-datepicker-prev-hover");
		}
		if (this.className.indexOf("ui-datepicker-next") !== -1) {
			$(this).addClass("ui-datepicker-next-hover");
		}
	}
}

/* jQuery extend now ignores nulls! */
function datepicker_extendRemove(target, props) {
	$.extend(target, props);
	for (var name in props) {
		if (props[name] == null) {
			target[name] = props[name];
		}
	}
	return target;
}

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function(options){

	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}

	/* Initialise the date picker. */
	if (!$.datepicker.initialized) {
		$(document).mousedown($.datepicker._checkExternalClick);
		$.datepicker.initialized = true;
	}

	/* Append datepicker main container to body if not exist. */
	if ($("#"+$.datepicker._mainDivId).length === 0) {
		$("body").append($.datepicker.dpDiv);
	}

	var otherArgs = Array.prototype.slice.call(arguments, 1);
	if (typeof options === "string" && (options === "isDisabled" || options === "getDate" || options === "widget")) {
		return $.datepicker["_" + options + "Datepicker"].
			apply($.datepicker, [this[0]].concat(otherArgs));
	}
	if (options === "option" && arguments.length === 2 && typeof arguments[1] === "string") {
		return $.datepicker["_" + options + "Datepicker"].
			apply($.datepicker, [this[0]].concat(otherArgs));
	}
	return this.each(function() {
		typeof options === "string" ?
			$.datepicker["_" + options + "Datepicker"].
				apply($.datepicker, [this].concat(otherArgs)) :
			$.datepicker._attachDatepicker(this, options);
	});
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.11.4";

return $.datepicker;

}));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(498))

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "/* == jquery mousewheel plugin == Version: 3.1.11, License: MIT License (MIT) */\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof exports?module.exports=a:a(jQuery)}(function(a){function b(b){var g=b||window.event,h=i.call(arguments,1),j=0,l=0,m=0,n=0,o=0,p=0;if(b=a.event.fix(g),b.type=\"mousewheel\",\"detail\"in g&&(m=-1*g.detail),\"wheelDelta\"in g&&(m=g.wheelDelta),\"wheelDeltaY\"in g&&(m=g.wheelDeltaY),\"wheelDeltaX\"in g&&(l=-1*g.wheelDeltaX),\"axis\"in g&&g.axis===g.HORIZONTAL_AXIS&&(l=-1*m,m=0),j=0===m?l:m,\"deltaY\"in g&&(m=-1*g.deltaY,j=m),\"deltaX\"in g&&(l=g.deltaX,0===m&&(j=-1*l)),0!==m||0!==l){if(1===g.deltaMode){var q=a.data(this,\"mousewheel-line-height\");j*=q,m*=q,l*=q}else if(2===g.deltaMode){var r=a.data(this,\"mousewheel-page-height\");j*=r,m*=r,l*=r}if(n=Math.max(Math.abs(m),Math.abs(l)),(!f||f>n)&&(f=n,d(g,n)&&(f/=40)),d(g,n)&&(j/=40,l/=40,m/=40),j=Math[j>=1?\"floor\":\"ceil\"](j/f),l=Math[l>=1?\"floor\":\"ceil\"](l/f),m=Math[m>=1?\"floor\":\"ceil\"](m/f),k.settings.normalizeOffset&&this.getBoundingClientRect){var s=this.getBoundingClientRect();o=b.clientX-s.left,p=b.clientY-s.top}return b.deltaX=l,b.deltaY=m,b.deltaFactor=f,b.offsetX=o,b.offsetY=p,b.deltaMode=0,h.unshift(b,j,l,m),e&&clearTimeout(e),e=setTimeout(c,200),(a.event.dispatch||a.event.handle).apply(this,h)}}function c(){f=null}function d(a,b){return k.settings.adjustOldDeltas&&\"mousewheel\"===a.type&&b%120===0}var e,f,g=[\"wheel\",\"mousewheel\",\"DOMMouseScroll\",\"MozMousePixelScroll\"],h=\"onwheel\"in document||document.documentMode>=9?[\"wheel\"]:[\"mousewheel\",\"DomMouseScroll\",\"MozMousePixelScroll\"],i=Array.prototype.slice;if(a.event.fixHooks)for(var j=g.length;j;)a.event.fixHooks[g[--j]]=a.event.mouseHooks;var k=a.event.special.mousewheel={version:\"3.1.11\",setup:function(){if(this.addEventListener)for(var c=h.length;c;)this.addEventListener(h[--c],b,!1);else this.onmousewheel=b;a.data(this,\"mousewheel-line-height\",k.getLineHeight(this)),a.data(this,\"mousewheel-page-height\",k.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var c=h.length;c;)this.removeEventListener(h[--c],b,!1);else this.onmousewheel=null;a.removeData(this,\"mousewheel-line-height\"),a.removeData(this,\"mousewheel-page-height\")},getLineHeight:function(b){var c=a(b)[\"offsetParent\"in a.fn?\"offsetParent\":\"parent\"]();return c.length||(c=a(\"body\")),parseInt(c.css(\"fontSize\"),10)},getPageHeight:function(b){return a(b).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};a.fn.extend({mousewheel:function(a){return a?this.bind(\"mousewheel\",a):this.trigger(\"mousewheel\")},unmousewheel:function(a){return this.unbind(\"mousewheel\",a)}})});\n/* == malihu jquery custom scrollbar plugin == Version: 3.0.5, License: MIT License (MIT) */\n!function(e,t,o){!function(t){var a=\"function\"==typeof define&&define.amd,n=\"https:\"==o.location.protocol?\"https:\":\"http:\",r=\"cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.11/jquery.mousewheel.min.js\";a||e.event.special.mousewheel||e(\"head\").append(decodeURI(\"%3Cscript src=\"+n+\"//\"+r+\"%3E%3C/script%3E\")),t()}(function(){var a=\"mCustomScrollbar\",n=\"mCS\",r=\".mCustomScrollbar\",i={setWidth:!1,setHeight:!1,setTop:0,setLeft:0,axis:\"y\",scrollbarPosition:\"inside\",scrollInertia:950,autoDraggerLength:!0,autoHideScrollbar:!1,autoExpandScrollbar:!1,alwaysShowScrollbar:0,snapAmount:null,snapOffset:0,mouseWheel:{enable:!0,scrollAmount:\"auto\",axis:\"y\",preventDefault:!1,deltaFactor:\"auto\",normalizeDelta:!1,invert:!1,disableOver:[\"select\",\"option\",\"keygen\",\"datalist\",\"textarea\"]},scrollButtons:{enable:!1,scrollType:\"stepless\",scrollAmount:\"auto\"},keyboard:{enable:!0,scrollType:\"stepless\",scrollAmount:\"auto\"},contentTouchScroll:25,advanced:{autoExpandHorizontalScroll:!1,autoScrollOnFocus:\"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']\",updateOnContentResize:!0,updateOnImageLoad:!0,updateOnSelectorChange:!1,releaseDraggableSelectors:!1},theme:\"light\",callbacks:{onInit:!1,onScrollStart:!1,onScroll:!1,onTotalScroll:!1,onTotalScrollBack:!1,whileScrolling:!1,onTotalScrollOffset:0,onTotalScrollBackOffset:0,alwaysTriggerOffsets:!0,onOverflowY:!1,onOverflowX:!1,onOverflowYNone:!1,onOverflowXNone:!1},live:!1,liveSelector:null},l=0,s={},c=function(e){s[e]&&(clearTimeout(s[e]),h._delete.call(null,s[e]))},d=t.attachEvent&&!t.addEventListener?1:0,u=!1,f={init:function(t){var t=e.extend(!0,{},i,t),o=h._selector.call(this);if(t.live){var a=t.liveSelector||this.selector||r,d=e(a);if(\"off\"===t.live)return void c(a);s[a]=setTimeout(function(){d.mCustomScrollbar(t),\"once\"===t.live&&d.length&&c(a)},500)}else c(a);return t.setWidth=t.set_width?t.set_width:t.setWidth,t.setHeight=t.set_height?t.set_height:t.setHeight,t.axis=t.horizontalScroll?\"x\":h._findAxis.call(null,t.axis),t.scrollInertia=t.scrollInertia>0&&t.scrollInertia<17?17:t.scrollInertia,\"object\"!=typeof t.mouseWheel&&1==t.mouseWheel&&(t.mouseWheel={enable:!0,scrollAmount:\"auto\",axis:\"y\",preventDefault:!1,deltaFactor:\"auto\",normalizeDelta:!1,invert:!1}),t.mouseWheel.scrollAmount=t.mouseWheelPixels?t.mouseWheelPixels:t.mouseWheel.scrollAmount,t.mouseWheel.normalizeDelta=t.advanced.normalizeMouseWheelDelta?t.advanced.normalizeMouseWheelDelta:t.mouseWheel.normalizeDelta,t.scrollButtons.scrollType=h._findScrollButtonsType.call(null,t.scrollButtons.scrollType),h._theme.call(null,t),e(o).each(function(){var o=e(this);if(!o.data(n)){o.data(n,{idx:++l,opt:t,scrollRatio:{y:null,x:null},overflowed:null,contentReset:{y:null,x:null},bindEvents:!1,tweenRunning:!1,sequential:{},langDir:o.css(\"direction\"),cbOffsets:null,trigger:null});var a=o.data(n).opt,r=o.data(\"mcs-axis\"),i=o.data(\"mcs-scrollbar-position\"),s=o.data(\"mcs-theme\");r&&(a.axis=r),i&&(a.scrollbarPosition=i),s&&(a.theme=s,h._theme.call(null,a)),h._pluginMarkup.call(this),f.update.call(null,o)}})},update:function(t){var o=t||h._selector.call(this);return e(o).each(function(){var t=e(this);if(t.data(n)){var o=t.data(n),a=o.opt,r=e(\"#mCSB_\"+o.idx+\"_container\"),i=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")];if(!r.length)return;o.tweenRunning&&h._stop.call(null,t),t.hasClass(\"mCS_disabled\")&&t.removeClass(\"mCS_disabled\"),t.hasClass(\"mCS_destroyed\")&&t.removeClass(\"mCS_destroyed\"),h._maxHeight.call(this),h._expandContentHorizontally.call(this),\"y\"===a.axis||a.advanced.autoExpandHorizontalScroll||r.css(\"width\",h._contentWidth(r.children())),o.overflowed=h._overflowed.call(this),h._scrollbarVisibility.call(this),a.autoDraggerLength&&h._setDraggerLength.call(this),h._scrollRatio.call(this),h._bindEvents.call(this);var l=[Math.abs(r[0].offsetTop),Math.abs(r[0].offsetLeft)];\"x\"!==a.axis&&(o.overflowed[0]?i[0].height()>i[0].parent().height()?h._resetContentPosition.call(this):(h._scrollTo.call(this,t,l[0].toString(),{dir:\"y\",dur:0,overwrite:\"none\"}),o.contentReset.y=null):(h._resetContentPosition.call(this),\"y\"===a.axis?h._unbindEvents.call(this):\"yx\"===a.axis&&o.overflowed[1]&&h._scrollTo.call(this,t,l[1].toString(),{dir:\"x\",dur:0,overwrite:\"none\"}))),\"y\"!==a.axis&&(o.overflowed[1]?i[1].width()>i[1].parent().width()?h._resetContentPosition.call(this):(h._scrollTo.call(this,t,l[1].toString(),{dir:\"x\",dur:0,overwrite:\"none\"}),o.contentReset.x=null):(h._resetContentPosition.call(this),\"x\"===a.axis?h._unbindEvents.call(this):\"yx\"===a.axis&&o.overflowed[0]&&h._scrollTo.call(this,t,l[0].toString(),{dir:\"y\",dur:0,overwrite:\"none\"}))),h._autoUpdate.call(this)}})},scrollTo:function(t,o){if(\"undefined\"!=typeof t&&null!=t){var a=h._selector.call(this);return e(a).each(function(){var a=e(this);if(a.data(n)){var r=a.data(n),i=r.opt,l={trigger:\"external\",scrollInertia:i.scrollInertia,scrollEasing:\"mcsEaseInOut\",moveDragger:!1,timeout:60,callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},s=e.extend(!0,{},l,o),c=h._arr.call(this,t),d=s.scrollInertia>0&&s.scrollInertia<17?17:s.scrollInertia;c[0]=h._to.call(this,c[0],\"y\"),c[1]=h._to.call(this,c[1],\"x\"),s.moveDragger&&(c[0]*=r.scrollRatio.y,c[1]*=r.scrollRatio.x),s.dur=d,setTimeout(function(){null!==c[0]&&\"undefined\"!=typeof c[0]&&\"x\"!==i.axis&&r.overflowed[0]&&(s.dir=\"y\",s.overwrite=\"all\",h._scrollTo.call(this,a,c[0].toString(),s)),null!==c[1]&&\"undefined\"!=typeof c[1]&&\"y\"!==i.axis&&r.overflowed[1]&&(s.dir=\"x\",s.overwrite=\"none\",h._scrollTo.call(this,a,c[1].toString(),s))},s.timeout)}})}},stop:function(){var t=h._selector.call(this);return e(t).each(function(){var t=e(this);t.data(n)&&h._stop.call(null,t)})},disable:function(t){var o=h._selector.call(this);return e(o).each(function(){var o=e(this);if(o.data(n)){{var a=o.data(n);a.opt}h._autoUpdate.call(this,\"remove\"),h._unbindEvents.call(this),t&&h._resetContentPosition.call(this),h._scrollbarVisibility.call(this,!0),o.addClass(\"mCS_disabled\")}})},destroy:function(){var t=h._selector.call(this);return e(t).each(function(){var o=e(this);if(o.data(n)){var r=o.data(n),i=r.opt,l=e(\"#mCSB_\"+r.idx),s=e(\"#mCSB_\"+r.idx+\"_container\"),d=e(\".mCSB_\"+r.idx+\"_scrollbar\");i.live&&c(t),h._autoUpdate.call(this,\"remove\"),h._unbindEvents.call(this),h._resetContentPosition.call(this),o.removeData(n),h._delete.call(null,this.mcs),d.remove(),l.replaceWith(s.contents()),o.removeClass(a+\" _\"+n+\"_\"+r.idx+\" mCS-autoHide mCS-dir-rtl mCS_no_scrollbar mCS_disabled\").addClass(\"mCS_destroyed\")}})}},h={_selector:function(){return\"object\"!=typeof e(this)||e(this).length<1?r:this},_theme:function(t){var o=[\"rounded\",\"rounded-dark\",\"rounded-dots\",\"rounded-dots-dark\"],a=[\"rounded-dots\",\"rounded-dots-dark\",\"3d\",\"3d-dark\",\"3d-thick\",\"3d-thick-dark\",\"inset\",\"inset-dark\",\"inset-2\",\"inset-2-dark\",\"inset-3\",\"inset-3-dark\"],n=[\"minimal\",\"minimal-dark\"],r=[\"minimal\",\"minimal-dark\"],i=[\"minimal\",\"minimal-dark\"];t.autoDraggerLength=e.inArray(t.theme,o)>-1?!1:t.autoDraggerLength,t.autoExpandScrollbar=e.inArray(t.theme,a)>-1?!1:t.autoExpandScrollbar,t.scrollButtons.enable=e.inArray(t.theme,n)>-1?!1:t.scrollButtons.enable,t.autoHideScrollbar=e.inArray(t.theme,r)>-1?!0:t.autoHideScrollbar,t.scrollbarPosition=e.inArray(t.theme,i)>-1?\"outside\":t.scrollbarPosition},_findAxis:function(e){return\"yx\"===e||\"xy\"===e||\"auto\"===e?\"yx\":\"x\"===e||\"horizontal\"===e?\"x\":\"y\"},_findScrollButtonsType:function(e){return\"stepped\"===e||\"pixels\"===e||\"step\"===e||\"click\"===e?\"stepped\":\"stepless\"},_pluginMarkup:function(){var t=e(this),o=t.data(n),r=o.opt,i=r.autoExpandScrollbar?\" mCSB_scrollTools_onDrag_expand\":\"\",l=[\"<div id='mCSB_\"+o.idx+\"_scrollbar_vertical' class='mCSB_scrollTools mCSB_\"+o.idx+\"_scrollbar mCS-\"+r.theme+\" mCSB_scrollTools_vertical\"+i+\"'><div class='mCSB_draggerContainer'><div id='mCSB_\"+o.idx+\"_dragger_vertical' class='mCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>\",\"<div id='mCSB_\"+o.idx+\"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_\"+o.idx+\"_scrollbar mCS-\"+r.theme+\" mCSB_scrollTools_horizontal\"+i+\"'><div class='mCSB_draggerContainer'><div id='mCSB_\"+o.idx+\"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>\"],s=\"yx\"===r.axis?\"mCSB_vertical_horizontal\":\"x\"===r.axis?\"mCSB_horizontal\":\"mCSB_vertical\",c=\"yx\"===r.axis?l[0]+l[1]:\"x\"===r.axis?l[1]:l[0],d=\"yx\"===r.axis?\"<div id='mCSB_\"+o.idx+\"_container_wrapper' class='mCSB_container_wrapper' />\":\"\",u=r.autoHideScrollbar?\" mCS-autoHide\":\"\",f=\"x\"!==r.axis&&\"rtl\"===o.langDir?\" mCS-dir-rtl\":\"\";r.setWidth&&t.css(\"width\",r.setWidth),r.setHeight&&t.css(\"height\",r.setHeight),r.setLeft=\"y\"!==r.axis&&\"rtl\"===o.langDir?\"989999px\":r.setLeft,t.addClass(a+\" _\"+n+\"_\"+o.idx+u+f).wrapInner(\"<div id='mCSB_\"+o.idx+\"' class='mCustomScrollBox mCS-\"+r.theme+\" \"+s+\"'><div id='mCSB_\"+o.idx+\"_container' class='mCSB_container' style='position:relative; top:\"+r.setTop+\"; left:\"+r.setLeft+\";' dir=\"+o.langDir+\" /></div>\");var _=e(\"#mCSB_\"+o.idx),m=e(\"#mCSB_\"+o.idx+\"_container\");\"y\"===r.axis||r.advanced.autoExpandHorizontalScroll||m.css(\"width\",h._contentWidth(m.children())),\"outside\"===r.scrollbarPosition?(\"static\"===t.css(\"position\")&&t.css(\"position\",\"relative\"),t.css(\"overflow\",\"visible\"),_.addClass(\"mCSB_outside\").after(c)):(_.addClass(\"mCSB_inside\").append(c),m.wrap(d)),h._scrollButtons.call(this);var p=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")];p[0].css(\"min-height\",p[0].height()),p[1].css(\"min-width\",p[1].width())},_contentWidth:function(t){return Math.max.apply(Math,t.map(function(){return e(this).outerWidth(!0)}).get())},_expandContentHorizontally:function(){var t=e(this),o=t.data(n),a=o.opt,r=e(\"#mCSB_\"+o.idx+\"_container\");a.advanced.autoExpandHorizontalScroll&&\"y\"!==a.axis&&r.css({position:\"absolute\",width:\"auto\"}).wrap(\"<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />\").css({width:Math.ceil(r[0].getBoundingClientRect().right+.4)-Math.floor(r[0].getBoundingClientRect().left),position:\"relative\"}).unwrap()},_scrollButtons:function(){var t=e(this),o=t.data(n),a=o.opt,r=e(\".mCSB_\"+o.idx+\"_scrollbar:first\"),i=[\"<a href='#' class='mCSB_buttonUp' oncontextmenu='return false;' />\",\"<a href='#' class='mCSB_buttonDown' oncontextmenu='return false;' />\",\"<a href='#' class='mCSB_buttonLeft' oncontextmenu='return false;' />\",\"<a href='#' class='mCSB_buttonRight' oncontextmenu='return false;' />\"],l=[\"x\"===a.axis?i[2]:i[0],\"x\"===a.axis?i[3]:i[1],i[2],i[3]];a.scrollButtons.enable&&r.prepend(l[0]).append(l[1]).next(\".mCSB_scrollTools\").prepend(l[2]).append(l[3])},_maxHeight:function(){var t=e(this),o=t.data(n),a=(o.opt,e(\"#mCSB_\"+o.idx)),r=t.css(\"max-height\"),i=-1!==r.indexOf(\"%\"),l=t.css(\"box-sizing\");if(\"none\"!==r){var s=i?t.parent().height()*parseInt(r)/100:parseInt(r);\"border-box\"===l&&(s-=t.innerHeight()-t.height()+(t.outerHeight()-t.innerHeight())),a.css(\"max-height\",Math.round(s))}},_setDraggerLength:function(){var t=e(this),o=t.data(n),a=e(\"#mCSB_\"+o.idx),r=e(\"#mCSB_\"+o.idx+\"_container\"),i=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")],l=[a.height()/r.outerHeight(!1),a.width()/r.outerWidth(!1)],s=[parseInt(i[0].css(\"min-height\")),Math.round(l[0]*i[0].parent().height()),parseInt(i[1].css(\"min-width\")),Math.round(l[1]*i[1].parent().width())],c=d&&s[1]<s[0]?s[0]:s[1],u=d&&s[3]<s[2]?s[2]:s[3];i[0].css({height:c,\"max-height\":i[0].parent().height()-10}).find(\".mCSB_dragger_bar\").css({\"line-height\":s[0]+\"px\"}),i[1].css({width:u,\"max-width\":i[1].parent().width()-10})},_scrollRatio:function(){var t=e(this),o=t.data(n),a=e(\"#mCSB_\"+o.idx),r=e(\"#mCSB_\"+o.idx+\"_container\"),i=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")],l=[r.outerHeight(!1)-a.height(),r.outerWidth(!1)-a.width()],s=[l[0]/(i[0].parent().height()-i[0].height()),l[1]/(i[1].parent().width()-i[1].width())];o.scrollRatio={y:s[0],x:s[1]}},_onDragClasses:function(e,t,o){var a=o?\"mCSB_dragger_onDrag_expanded\":\"\",n=[\"mCSB_dragger_onDrag\",\"mCSB_scrollTools_onDrag\"],r=e.closest(\".mCSB_scrollTools\");\"active\"===t?(e.toggleClass(n[0]+\" \"+a),r.toggleClass(n[1]),e[0]._draggable=e[0]._draggable?0:1):e[0]._draggable||(\"hide\"===t?(e.removeClass(n[0]),r.removeClass(n[1])):(e.addClass(n[0]),r.addClass(n[1])))},_overflowed:function(){var t=e(this),o=t.data(n),a=e(\"#mCSB_\"+o.idx),r=e(\"#mCSB_\"+o.idx+\"_container\"),i=null==o.overflowed?r.height():r.outerHeight(!1),l=null==o.overflowed?r.width():r.outerWidth(!1);return[i>a.height(),l>a.width()]},_resetContentPosition:function(){var t=e(this),o=t.data(n),a=o.opt,r=e(\"#mCSB_\"+o.idx),i=e(\"#mCSB_\"+o.idx+\"_container\"),l=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")];if(h._stop(t),(\"x\"!==a.axis&&!o.overflowed[0]||\"y\"===a.axis&&o.overflowed[0])&&(l[0].add(i).css(\"top\",0),h._scrollTo(t,\"_resetY\")),\"y\"!==a.axis&&!o.overflowed[1]||\"x\"===a.axis&&o.overflowed[1]){var s=dx=0;\"rtl\"===o.langDir&&(s=r.width()-i.outerWidth(!1),dx=Math.abs(s/o.scrollRatio.x)),i.css(\"left\",s),l[1].css(\"left\",dx),h._scrollTo(t,\"_resetX\")}},_bindEvents:function(){function t(){i=setTimeout(function(){e.event.special.mousewheel?(clearTimeout(i),h._mousewheel.call(o[0])):t()},1e3)}var o=e(this),a=o.data(n),r=a.opt;if(!a.bindEvents){if(h._draggable.call(this),r.contentTouchScroll&&h._contentDraggable.call(this),r.mouseWheel.enable){var i;t()}h._draggerRail.call(this),h._wrapperScroll.call(this),r.advanced.autoScrollOnFocus&&h._focus.call(this),r.scrollButtons.enable&&h._buttons.call(this),r.keyboard.enable&&h._keyboard.call(this),a.bindEvents=!0}},_unbindEvents:function(){var t=e(this),a=t.data(n),r=a.opt,i=n+\"_\"+a.idx,l=\".mCSB_\"+a.idx+\"_scrollbar\",s=e(\"#mCSB_\"+a.idx+\",#mCSB_\"+a.idx+\"_container,#mCSB_\"+a.idx+\"_container_wrapper,\"+l+\" .mCSB_draggerContainer,#mCSB_\"+a.idx+\"_dragger_vertical,#mCSB_\"+a.idx+\"_dragger_horizontal,\"+l+\">a\"),c=e(\"#mCSB_\"+a.idx+\"_container\");r.advanced.releaseDraggableSelectors&&s.add(e(r.advanced.releaseDraggableSelectors)),a.bindEvents&&(e(o).unbind(\".\"+i),s.each(function(){e(this).unbind(\".\"+i)}),clearTimeout(t[0]._focusTimeout),h._delete.call(null,t[0]._focusTimeout),clearTimeout(a.sequential.step),h._delete.call(null,a.sequential.step),clearTimeout(c[0].onCompleteTimeout),h._delete.call(null,c[0].onCompleteTimeout),a.bindEvents=!1)},_scrollbarVisibility:function(t){var o=e(this),a=o.data(n),r=a.opt,i=e(\"#mCSB_\"+a.idx+\"_container_wrapper\"),l=i.length?i:e(\"#mCSB_\"+a.idx+\"_container\"),s=[e(\"#mCSB_\"+a.idx+\"_scrollbar_vertical\"),e(\"#mCSB_\"+a.idx+\"_scrollbar_horizontal\")],c=[s[0].find(\".mCSB_dragger\"),s[1].find(\".mCSB_dragger\")];\"x\"!==r.axis&&(a.overflowed[0]&&!t?(s[0].add(c[0]).add(s[0].children(\"a\")).css(\"display\",\"block\"),l.removeClass(\"mCS_no_scrollbar_y mCS_y_hidden\")):(r.alwaysShowScrollbar?(2!==r.alwaysShowScrollbar&&c[0].add(s[0].children(\"a\")).css(\"display\",\"none\"),l.removeClass(\"mCS_y_hidden\")):(s[0].css(\"display\",\"none\"),l.addClass(\"mCS_y_hidden\")),l.addClass(\"mCS_no_scrollbar_y\"))),\"y\"!==r.axis&&(a.overflowed[1]&&!t?(s[1].add(c[1]).add(s[1].children(\"a\")).css(\"display\",\"block\"),l.removeClass(\"mCS_no_scrollbar_x mCS_x_hidden\")):(r.alwaysShowScrollbar?(2!==r.alwaysShowScrollbar&&c[1].add(s[1].children(\"a\")).css(\"display\",\"none\"),l.removeClass(\"mCS_x_hidden\")):(s[1].css(\"display\",\"none\"),l.addClass(\"mCS_x_hidden\")),l.addClass(\"mCS_no_scrollbar_x\"))),a.overflowed[0]||a.overflowed[1]?o.removeClass(\"mCS_no_scrollbar\"):o.addClass(\"mCS_no_scrollbar\")},_coordinates:function(e){var t=e.type;switch(t){case\"pointerdown\":case\"MSPointerDown\":case\"pointermove\":case\"MSPointerMove\":case\"pointerup\":case\"MSPointerUp\":return[e.originalEvent.pageY,e.originalEvent.pageX,!1];case\"touchstart\":case\"touchmove\":case\"touchend\":var o=e.originalEvent.touches[0]||e.originalEvent.changedTouches[0],a=e.originalEvent.touches.length||e.originalEvent.changedTouches.length;return[o.pageY,o.pageX,a>1];default:return[e.pageY,e.pageX,!1]}},_draggable:function(){function t(e){var t=p.find(\"iframe\");if(t.length){var o=e?\"auto\":\"none\";t.css(\"pointer-events\",o)}}function a(e,t,o,a){if(p[0].idleTimer=f.scrollInertia<233?250:0,r.attr(\"id\")===m[1])var n=\"x\",i=(r[0].offsetLeft-t+a)*c.scrollRatio.x;else var n=\"y\",i=(r[0].offsetTop-e+o)*c.scrollRatio.y;h._scrollTo(s,i.toString(),{dir:n,drag:!0})}var r,i,l,s=e(this),c=s.data(n),f=c.opt,_=n+\"_\"+c.idx,m=[\"mCSB_\"+c.idx+\"_dragger_vertical\",\"mCSB_\"+c.idx+\"_dragger_horizontal\"],p=e(\"#mCSB_\"+c.idx+\"_container\"),g=e(\"#\"+m[0]+\",#\"+m[1]),v=f.advanced.releaseDraggableSelectors?g.add(e(f.advanced.releaseDraggableSelectors)):g;g.bind(\"mousedown.\"+_+\" touchstart.\"+_+\" pointerdown.\"+_+\" MSPointerDown.\"+_,function(a){if(a.stopImmediatePropagation(),a.preventDefault(),h._mouseBtnLeft(a)){u=!0,d&&(o.onselectstart=function(){return!1}),t(!1),h._stop(s),r=e(this);var n=r.offset(),c=h._coordinates(a)[0]-n.top,_=h._coordinates(a)[1]-n.left,m=r.height()+n.top,p=r.width()+n.left;m>c&&c>0&&p>_&&_>0&&(i=c,l=_),h._onDragClasses(r,\"active\",f.autoExpandScrollbar)}}).bind(\"touchmove.\"+_,function(e){e.stopImmediatePropagation(),e.preventDefault();var t=r.offset(),o=h._coordinates(e)[0]-t.top,n=h._coordinates(e)[1]-t.left;a(i,l,o,n)}),e(o).bind(\"mousemove.\"+_+\" pointermove.\"+_+\" MSPointerMove.\"+_,function(e){if(r){var t=r.offset(),o=h._coordinates(e)[0]-t.top,n=h._coordinates(e)[1]-t.left;if(i===o)return;a(i,l,o,n)}}).add(v).bind(\"mouseup.\"+_+\" touchend.\"+_+\" pointerup.\"+_+\" MSPointerUp.\"+_,function(){r&&(h._onDragClasses(r,\"active\",f.autoExpandScrollbar),r=null),u=!1,d&&(o.onselectstart=null),t(!0)})},_contentDraggable:function(){function t(e,t){var o=[1.5*t,2*t,t/1.5,t/2];return e>90?t>4?o[0]:o[3]:e>60?t>3?o[3]:o[2]:e>30?t>8?o[1]:t>6?o[0]:t>4?t:o[2]:t>8?t:o[3]}function o(e,t,o,a,n,r){e&&h._scrollTo(g,e.toString(),{dur:t,scrollEasing:o,dir:a,overwrite:n,drag:r})}var a,r,i,l,s,c,d,f,_,m,p,g=e(this),v=g.data(n),x=v.opt,S=n+\"_\"+v.idx,C=e(\"#mCSB_\"+v.idx),b=e(\"#mCSB_\"+v.idx+\"_container\"),w=[e(\"#mCSB_\"+v.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+v.idx+\"_dragger_horizontal\")],y=[],B=[],T=0,M=\"yx\"===x.axis?\"none\":\"all\",k=[];b.bind(\"touchstart.\"+S+\" pointerdown.\"+S+\" MSPointerDown.\"+S,function(e){if(h._pointerTouch(e)&&!u&&!h._coordinates(e)[2]){var t=b.offset();a=h._coordinates(e)[0]-t.top,r=h._coordinates(e)[1]-t.left,k=[h._coordinates(e)[0],h._coordinates(e)[1]]}}).bind(\"touchmove.\"+S+\" pointermove.\"+S+\" MSPointerMove.\"+S,function(e){if(h._pointerTouch(e)&&!u&&!h._coordinates(e)[2]){e.stopImmediatePropagation(),c=h._getTime();var t=C.offset(),n=h._coordinates(e)[0]-t.top,i=h._coordinates(e)[1]-t.left,l=\"mcsLinearOut\";if(y.push(n),B.push(i),k[2]=Math.abs(h._coordinates(e)[0]-k[0]),k[3]=Math.abs(h._coordinates(e)[1]-k[1]),v.overflowed[0])var s=w[0].parent().height()-w[0].height(),d=a-n>0&&n-a>-(s*v.scrollRatio.y)&&(2*k[3]<k[2]||\"yx\"===x.axis);if(v.overflowed[1])var f=w[1].parent().width()-w[1].width(),_=r-i>0&&i-r>-(f*v.scrollRatio.x)&&(2*k[2]<k[3]||\"yx\"===x.axis);(d||_)&&e.preventDefault(),m=\"yx\"===x.axis?[a-n,r-i]:\"x\"===x.axis?[null,r-i]:[a-n,null],b[0].idleTimer=250,v.overflowed[0]&&o(m[0],T,l,\"y\",\"all\",!0),v.overflowed[1]&&o(m[1],T,l,\"x\",M,!0)}}),C.bind(\"touchstart.\"+S+\" pointerdown.\"+S+\" MSPointerDown.\"+S,function(e){if(h._pointerTouch(e)&&!u&&!h._coordinates(e)[2]){e.stopImmediatePropagation(),h._stop(g),s=h._getTime();var t=C.offset();i=h._coordinates(e)[0]-t.top,l=h._coordinates(e)[1]-t.left,y=[],B=[]}}).bind(\"touchend.\"+S+\" pointerup.\"+S+\" MSPointerUp.\"+S,function(e){if(h._pointerTouch(e)&&!u&&!h._coordinates(e)[2]){e.stopImmediatePropagation(),d=h._getTime();var a=C.offset(),n=h._coordinates(e)[0]-a.top,r=h._coordinates(e)[1]-a.left;if(!(d-c>30)){_=1e3/(d-s);var g=\"mcsEaseOut\",S=2.5>_,w=S?[y[y.length-2],B[B.length-2]]:[0,0];f=S?[n-w[0],r-w[1]]:[n-i,r-l];var T=[Math.abs(f[0]),Math.abs(f[1])];_=S?[Math.abs(f[0]/4),Math.abs(f[1]/4)]:[_,_];var k=[Math.abs(b[0].offsetTop)-f[0]*t(T[0]/_[0],_[0]),Math.abs(b[0].offsetLeft)-f[1]*t(T[1]/_[1],_[1])];m=\"yx\"===x.axis?[k[0],k[1]]:\"x\"===x.axis?[null,k[1]]:[k[0],null],p=[4*T[0]+x.scrollInertia,4*T[1]+x.scrollInertia];var O=parseInt(x.contentTouchScroll)||0;m[0]=T[0]>O?m[0]:0,m[1]=T[1]>O?m[1]:0,v.overflowed[0]&&o(m[0],p[0],g,\"y\",M,!1),v.overflowed[1]&&o(m[1],p[1],g,\"x\",M,!1)}}})},_mousewheel:function(){function t(e){var t=null;try{var o=e.contentDocument||e.contentWindow.document;t=o.body.innerHTML}catch(a){}return null!==t}var o=e(this),a=o.data(n);if(a){var r=a.opt,i=n+\"_\"+a.idx,l=e(\"#mCSB_\"+a.idx),s=[e(\"#mCSB_\"+a.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+a.idx+\"_dragger_horizontal\")],c=e(\"#mCSB_\"+a.idx+\"_container\").find(\"iframe\"),u=l;c.length&&c.each(function(){var o=this;t(o)&&(u=u.add(e(o).contents().find(\"body\")))}),u.bind(\"mousewheel.\"+i,function(t,n){if(h._stop(o),!h._disableMousewheel(o,t.target)){var i=\"auto\"!==r.mouseWheel.deltaFactor?parseInt(r.mouseWheel.deltaFactor):d&&t.deltaFactor<100?100:t.deltaFactor||100;if(\"x\"===r.axis||\"x\"===r.mouseWheel.axis)var c=\"x\",u=[Math.round(i*a.scrollRatio.x),parseInt(r.mouseWheel.scrollAmount)],f=\"auto\"!==r.mouseWheel.scrollAmount?u[1]:u[0]>=l.width()?.9*l.width():u[0],_=Math.abs(e(\"#mCSB_\"+a.idx+\"_container\")[0].offsetLeft),m=s[1][0].offsetLeft,p=s[1].parent().width()-s[1].width(),g=t.deltaX||t.deltaY||n;else var c=\"y\",u=[Math.round(i*a.scrollRatio.y),parseInt(r.mouseWheel.scrollAmount)],f=\"auto\"!==r.mouseWheel.scrollAmount?u[1]:u[0]>=l.height()?.9*l.height():u[0],_=Math.abs(e(\"#mCSB_\"+a.idx+\"_container\")[0].offsetTop),m=s[0][0].offsetTop,p=s[0].parent().height()-s[0].height(),g=t.deltaY||n;\"y\"===c&&!a.overflowed[0]||\"x\"===c&&!a.overflowed[1]||(r.mouseWheel.invert&&(g=-g),r.mouseWheel.normalizeDelta&&(g=0>g?-1:1),(g>0&&0!==m||0>g&&m!==p||r.mouseWheel.preventDefault)&&(t.stopImmediatePropagation(),t.preventDefault()),h._scrollTo(o,(_-g*f).toString(),{dir:c}))}})}},_disableMousewheel:function(t,o){var a=o.nodeName.toLowerCase(),r=t.data(n).opt.mouseWheel.disableOver,i=[\"select\",\"textarea\"];return e.inArray(a,r)>-1&&!(e.inArray(a,i)>-1&&!e(o).is(\":focus\"))},_draggerRail:function(){var t=e(this),o=t.data(n),a=n+\"_\"+o.idx,r=e(\"#mCSB_\"+o.idx+\"_container\"),i=r.parent(),l=e(\".mCSB_\"+o.idx+\"_scrollbar .mCSB_draggerContainer\");l.bind(\"touchstart.\"+a+\" pointerdown.\"+a+\" MSPointerDown.\"+a,function(){u=!0}).bind(\"touchend.\"+a+\" pointerup.\"+a+\" MSPointerUp.\"+a,function(){u=!1}).bind(\"click.\"+a,function(a){if(e(a.target).hasClass(\"mCSB_draggerContainer\")||e(a.target).hasClass(\"mCSB_draggerRail\")){h._stop(t);var n=e(this),l=n.find(\".mCSB_dragger\");if(n.parent(\".mCSB_scrollTools_horizontal\").length>0){if(!o.overflowed[1])return;var s=\"x\",c=a.pageX>l.offset().left?-1:1,d=Math.abs(r[0].offsetLeft)-.9*c*i.width()}else{if(!o.overflowed[0])return;var s=\"y\",c=a.pageY>l.offset().top?-1:1,d=Math.abs(r[0].offsetTop)-.9*c*i.height()}h._scrollTo(t,d.toString(),{dir:s,scrollEasing:\"mcsEaseInOut\"})}})},_focus:function(){var t=e(this),a=t.data(n),r=a.opt,i=n+\"_\"+a.idx,l=e(\"#mCSB_\"+a.idx+\"_container\"),s=l.parent();l.bind(\"focusin.\"+i,function(){var a=e(o.activeElement),n=l.find(\".mCustomScrollBox\").length,i=0;a.is(r.advanced.autoScrollOnFocus)&&(h._stop(t),clearTimeout(t[0]._focusTimeout),t[0]._focusTimer=n?(i+17)*n:0,t[0]._focusTimeout=setTimeout(function(){var e=[a.offset().top-l.offset().top,a.offset().left-l.offset().left],o=[l[0].offsetTop,l[0].offsetLeft],n=[o[0]+e[0]>=0&&o[0]+e[0]<s.height()-a.outerHeight(!1),o[1]+e[1]>=0&&o[0]+e[1]<s.width()-a.outerWidth(!1)],c=\"yx\"!==r.axis||n[0]||n[1]?\"all\":\"none\";\"x\"===r.axis||n[0]||h._scrollTo(t,e[0].toString(),{dir:\"y\",scrollEasing:\"mcsEaseInOut\",overwrite:c,dur:i}),\"y\"===r.axis||n[1]||h._scrollTo(t,e[1].toString(),{dir:\"x\",scrollEasing:\"mcsEaseInOut\",overwrite:c,dur:i})},t[0]._focusTimer))})},_wrapperScroll:function(){var t=e(this),o=t.data(n),a=n+\"_\"+o.idx,r=e(\"#mCSB_\"+o.idx+\"_container\").parent();r.bind(\"scroll.\"+a,function(){(0!==r.scrollTop()||0!==r.scrollLeft())&&e(\".mCSB_\"+o.idx+\"_scrollbar\").css(\"visibility\",\"hidden\")})},_buttons:function(){var t=e(this),o=t.data(n),a=o.opt,r=o.sequential,i=n+\"_\"+o.idx,l=(e(\"#mCSB_\"+o.idx+\"_container\"),\".mCSB_\"+o.idx+\"_scrollbar\"),s=e(l+\">a\");s.bind(\"mousedown.\"+i+\" touchstart.\"+i+\" pointerdown.\"+i+\" MSPointerDown.\"+i+\" mouseup.\"+i+\" touchend.\"+i+\" pointerup.\"+i+\" MSPointerUp.\"+i+\" mouseout.\"+i+\" pointerout.\"+i+\" MSPointerOut.\"+i+\" click.\"+i,function(n){function i(e,o){r.scrollAmount=a.snapAmount||a.scrollButtons.scrollAmount,h._sequentialScroll.call(this,t,e,o)}if(n.preventDefault(),h._mouseBtnLeft(n)){var l=e(this).attr(\"class\");switch(r.type=a.scrollButtons.scrollType,n.type){case\"mousedown\":case\"touchstart\":case\"pointerdown\":case\"MSPointerDown\":if(\"stepped\"===r.type)return;u=!0,o.tweenRunning=!1,i(\"on\",l);break;case\"mouseup\":case\"touchend\":case\"pointerup\":case\"MSPointerUp\":case\"mouseout\":case\"pointerout\":case\"MSPointerOut\":if(\"stepped\"===r.type)return;u=!1,r.dir&&i(\"off\",l);break;case\"click\":if(\"stepped\"!==r.type||o.tweenRunning)return;i(\"on\",l)}}})},_keyboard:function(){var t=e(this),a=t.data(n),r=a.opt,i=a.sequential,l=n+\"_\"+a.idx,s=e(\"#mCSB_\"+a.idx),c=e(\"#mCSB_\"+a.idx+\"_container\"),d=c.parent(),u=\"input,textarea,select,datalist,keygen,[contenteditable='true']\";s.attr(\"tabindex\",\"0\").bind(\"blur.\"+l+\" keydown.\"+l+\" keyup.\"+l,function(n){function l(e,o){i.type=r.keyboard.scrollType,i.scrollAmount=r.snapAmount||r.keyboard.scrollAmount,\"stepped\"===i.type&&a.tweenRunning||h._sequentialScroll.call(this,t,e,o)}switch(n.type){case\"blur\":a.tweenRunning&&i.dir&&l(\"off\",null);break;case\"keydown\":case\"keyup\":var s=n.keyCode?n.keyCode:n.which,f=\"on\";if(\"x\"!==r.axis&&(38===s||40===s)||\"y\"!==r.axis&&(37===s||39===s)){if((38===s||40===s)&&!a.overflowed[0]||(37===s||39===s)&&!a.overflowed[1])return;\"keyup\"===n.type&&(f=\"off\"),e(o.activeElement).is(u)||(n.preventDefault(),n.stopImmediatePropagation(),l(f,s))}else if(33===s||34===s){if((a.overflowed[0]||a.overflowed[1])&&(n.preventDefault(),n.stopImmediatePropagation()),\"keyup\"===n.type){h._stop(t);var _=34===s?-1:1;if(\"x\"===r.axis||\"yx\"===r.axis&&a.overflowed[1]&&!a.overflowed[0])var m=\"x\",p=Math.abs(c[0].offsetLeft)-.9*_*d.width();else var m=\"y\",p=Math.abs(c[0].offsetTop)-.9*_*d.height();h._scrollTo(t,p.toString(),{dir:m,scrollEasing:\"mcsEaseInOut\"})}}else if((35===s||36===s)&&!e(o.activeElement).is(u)&&((a.overflowed[0]||a.overflowed[1])&&(n.preventDefault(),n.stopImmediatePropagation()),\"keyup\"===n.type)){if(\"x\"===r.axis||\"yx\"===r.axis&&a.overflowed[1]&&!a.overflowed[0])var m=\"x\",p=35===s?Math.abs(d.width()-c.outerWidth(!1)):0;else var m=\"y\",p=35===s?Math.abs(d.height()-c.outerHeight(!1)):0;h._scrollTo(t,p.toString(),{dir:m,scrollEasing:\"mcsEaseInOut\"})}}})},_sequentialScroll:function(t,o,a){function r(e){var o=\"stepped\"!==c.type,a=e?o?s.scrollInertia/1.5:s.scrollInertia:1e3/60,n=e?o?7.5:40:2.5,i=[Math.abs(d[0].offsetTop),Math.abs(d[0].offsetLeft)],u=[l.scrollRatio.y>10?10:l.scrollRatio.y,l.scrollRatio.x>10?10:l.scrollRatio.x],f=\"x\"===c.dir[0]?i[1]+c.dir[1]*u[1]*n:i[0]+c.dir[1]*u[0]*n,_=\"x\"===c.dir[0]?i[1]+c.dir[1]*parseInt(c.scrollAmount):i[0]+c.dir[1]*parseInt(c.scrollAmount),m=\"auto\"!==c.scrollAmount?_:f,p=e?o?\"mcsLinearOut\":\"mcsEaseInOut\":\"mcsLinear\",g=e?!0:!1;return e&&17>a&&(m=\"x\"===c.dir[0]?i[1]:i[0]),h._scrollTo(t,m.toString(),{dir:c.dir[0],scrollEasing:p,dur:a,onComplete:g}),e?void(c.dir=!1):(clearTimeout(c.step),void(c.step=setTimeout(function(){r()},a)))}function i(){clearTimeout(c.step),h._stop(t)}var l=t.data(n),s=l.opt,c=l.sequential,d=e(\"#mCSB_\"+l.idx+\"_container\"),u=\"stepped\"===c.type?!0:!1;switch(o){case\"on\":if(c.dir=[\"mCSB_buttonRight\"===a||\"mCSB_buttonLeft\"===a||39===a||37===a?\"x\":\"y\",\"mCSB_buttonUp\"===a||\"mCSB_buttonLeft\"===a||38===a||37===a?-1:1],h._stop(t),h._isNumeric(a)&&\"stepped\"===c.type)return;r(u);break;case\"off\":i(),(u||l.tweenRunning&&c.dir)&&r(!0)}},_arr:function(t){var o=e(this).data(n).opt,a=[];return\"function\"==typeof t&&(t=t()),t instanceof Array?a=t.length>1?[t[0],t[1]]:\"x\"===o.axis?[null,t[0]]:[t[0],null]:(a[0]=t.y?t.y:t.x||\"x\"===o.axis?null:t,a[1]=t.x?t.x:t.y||\"y\"===o.axis?null:t),\"function\"==typeof a[0]&&(a[0]=a[0]()),\"function\"==typeof a[1]&&(a[1]=a[1]()),a},_to:function(t,o){if(null!=t&&\"undefined\"!=typeof t){var a=e(this),r=a.data(n),i=r.opt,l=e(\"#mCSB_\"+r.idx+\"_container\"),s=l.parent(),c=typeof t;o||(o=\"x\"===i.axis?\"x\":\"y\");var d=\"x\"===o?l.outerWidth(!1):l.outerHeight(!1),u=\"x\"===o?l.offset().left:l.offset().top,_=\"x\"===o?l[0].offsetLeft:l[0].offsetTop,m=\"x\"===o?\"left\":\"top\";switch(c){case\"function\":return t();case\"object\":if(t.nodeType)var p=\"x\"===o?e(t).offset().left:e(t).offset().top;else if(t.jquery){if(!t.length)return;var p=\"x\"===o?t.offset().left:t.offset().top}return p-u;case\"string\":case\"number\":if(h._isNumeric.call(null,t))return Math.abs(t);if(-1!==t.indexOf(\"%\"))return Math.abs(d*parseInt(t)/100);if(-1!==t.indexOf(\"-=\"))return Math.abs(_-parseInt(t.split(\"-=\")[1]));if(-1!==t.indexOf(\"+=\")){var g=_+parseInt(t.split(\"+=\")[1]);return g>=0?0:Math.abs(g)}if(-1!==t.indexOf(\"px\")&&h._isNumeric.call(null,t.split(\"px\")[0]))return Math.abs(t.split(\"px\")[0]);if(\"top\"===t||\"left\"===t)return 0;if(\"bottom\"===t)return Math.abs(s.height()-l.outerHeight(!1));if(\"right\"===t)return Math.abs(s.width()-l.outerWidth(!1));if(\"first\"===t||\"last\"===t){var v=l.find(\":\"+t),p=\"x\"===o?e(v).offset().left:e(v).offset().top;return p-u}if(e(t).length){var p=\"x\"===o?e(t).offset().left:e(t).offset().top;return p-u}return l.css(m,t),void f.update.call(null,a[0])}}},_autoUpdate:function(t){function o(){clearTimeout(u[0].autoUpdate),u[0].autoUpdate=setTimeout(function(){return d.advanced.updateOnSelectorChange&&(_=i(),_!==S)?(l(),void(S=_)):(d.advanced.updateOnContentResize&&(m=[u.outerHeight(!1),u.outerWidth(!1),g.height(),g.width(),x()[0],x()[1]],(m[0]!==C[0]||m[1]!==C[1]||m[2]!==C[2]||m[3]!==C[3]||m[4]!==C[4]||m[5]!==C[5])&&(l(),C=m)),d.advanced.updateOnImageLoad&&(p=a(),p!==b&&(u.find(\"img\").each(function(){r(this.src)}),b=p)),void((d.advanced.updateOnSelectorChange||d.advanced.updateOnContentResize||d.advanced.updateOnImageLoad)&&o()))},60)}function a(){var e=0;return d.advanced.updateOnImageLoad&&(e=u.find(\"img\").length),e}function r(e){function t(e,t){return function(){return t.apply(e,arguments)}}function o(){this.onload=null,l()}var a=new Image;a.onload=t(a,o),a.src=e}function i(){d.advanced.updateOnSelectorChange===!0&&(d.advanced.updateOnSelectorChange=\"*\");var t=0,o=u.find(d.advanced.updateOnSelectorChange);return d.advanced.updateOnSelectorChange&&o.length>0&&o.each(function(){t+=e(this).height()+e(this).width()}),t}function l(){clearTimeout(u[0].autoUpdate),f.update.call(null,s[0])}var s=e(this),c=s.data(n),d=c.opt,u=e(\"#mCSB_\"+c.idx+\"_container\");if(t)return clearTimeout(u[0].autoUpdate),void h._delete.call(null,u[0].autoUpdate);var _,m,p,g=u.parent(),v=[e(\"#mCSB_\"+c.idx+\"_scrollbar_vertical\"),e(\"#mCSB_\"+c.idx+\"_scrollbar_horizontal\")],x=function(){return[v[0].is(\":visible\")?v[0].outerHeight(!0):0,v[1].is(\":visible\")?v[1].outerWidth(!0):0]},S=i(),C=[u.outerHeight(!1),u.outerWidth(!1),g.height(),g.width(),x()[0],x()[1]],b=a();o()},_snapAmount:function(e,t,o){return Math.round(e/t)*t-o},_stop:function(t){var o=t.data(n),a=e(\"#mCSB_\"+o.idx+\"_container,#mCSB_\"+o.idx+\"_container_wrapper,#mCSB_\"+o.idx+\"_dragger_vertical,#mCSB_\"+o.idx+\"_dragger_horizontal\");a.each(function(){h._stopTween.call(this)})},_scrollTo:function(t,o,a){function r(e){return s&&c.callbacks[e]&&\"function\"==typeof c.callbacks[e]}function i(){return[c.callbacks.alwaysTriggerOffsets||S>=C[0]+w,c.callbacks.alwaysTriggerOffsets||-y>=S]}function l(){var e=[_[0].offsetTop,_[0].offsetLeft],o=[v[0].offsetTop,v[0].offsetLeft],n=[_.outerHeight(!1),_.outerWidth(!1)],r=[f.height(),f.width()];t[0].mcs={content:_,top:e[0],left:e[1],draggerTop:o[0],draggerLeft:o[1],topPct:Math.round(100*Math.abs(e[0])/(Math.abs(n[0])-r[0])),leftPct:Math.round(100*Math.abs(e[1])/(Math.abs(n[1])-r[1])),direction:a.dir}}var s=t.data(n),c=s.opt,d={trigger:\"internal\",dir:\"y\",scrollEasing:\"mcsEaseOut\",drag:!1,dur:c.scrollInertia,overwrite:\"all\",callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},a=e.extend(d,a),u=[a.dur,a.drag?0:a.dur],f=e(\"#mCSB_\"+s.idx),_=e(\"#mCSB_\"+s.idx+\"_container\"),m=_.parent(),p=c.callbacks.onTotalScrollOffset?h._arr.call(t,c.callbacks.onTotalScrollOffset):[0,0],g=c.callbacks.onTotalScrollBackOffset?h._arr.call(t,c.callbacks.onTotalScrollBackOffset):[0,0];\nif(s.trigger=a.trigger,(0!==m.scrollTop()||0!==m.scrollLeft())&&(e(\".mCSB_\"+s.idx+\"_scrollbar\").css(\"visibility\",\"visible\"),m.scrollTop(0).scrollLeft(0)),\"_resetY\"!==o||s.contentReset.y||(r(\"onOverflowYNone\")&&c.callbacks.onOverflowYNone.call(t[0]),s.contentReset.y=1),\"_resetX\"!==o||s.contentReset.x||(r(\"onOverflowXNone\")&&c.callbacks.onOverflowXNone.call(t[0]),s.contentReset.x=1),\"_resetY\"!==o&&\"_resetX\"!==o){switch(!s.contentReset.y&&t[0].mcs||!s.overflowed[0]||(r(\"onOverflowY\")&&c.callbacks.onOverflowY.call(t[0]),s.contentReset.x=null),!s.contentReset.x&&t[0].mcs||!s.overflowed[1]||(r(\"onOverflowX\")&&c.callbacks.onOverflowX.call(t[0]),s.contentReset.x=null),c.snapAmount&&(o=h._snapAmount(o,c.snapAmount,c.snapOffset)),a.dir){case\"x\":var v=e(\"#mCSB_\"+s.idx+\"_dragger_horizontal\"),x=\"left\",S=_[0].offsetLeft,C=[f.width()-_.outerWidth(!1),v.parent().width()-v.width()],b=[o,0===o?0:o/s.scrollRatio.x],w=p[1],y=g[1],B=w>0?w/s.scrollRatio.x:0,T=y>0?y/s.scrollRatio.x:0;break;case\"y\":var v=e(\"#mCSB_\"+s.idx+\"_dragger_vertical\"),x=\"top\",S=_[0].offsetTop,C=[f.height()-_.outerHeight(!1),v.parent().height()-v.height()],b=[o,0===o?0:o/s.scrollRatio.y],w=p[0],y=g[0],B=w>0?w/s.scrollRatio.y:0,T=y>0?y/s.scrollRatio.y:0}b[1]<0||0===b[0]&&0===b[1]?b=[0,0]:b[1]>=C[1]?b=[C[0],C[1]]:b[0]=-b[0],t[0].mcs||(l(),r(\"onInit\")&&c.callbacks.onInit.call(t[0])),clearTimeout(_[0].onCompleteTimeout),(s.tweenRunning||!(0===S&&b[0]>=0||S===C[0]&&b[0]<=C[0]))&&(h._tweenTo.call(null,v[0],x,Math.round(b[1]),u[1],a.scrollEasing),h._tweenTo.call(null,_[0],x,Math.round(b[0]),u[0],a.scrollEasing,a.overwrite,{onStart:function(){a.callbacks&&a.onStart&&!s.tweenRunning&&(r(\"onScrollStart\")&&(l(),c.callbacks.onScrollStart.call(t[0])),s.tweenRunning=!0,h._onDragClasses(v),s.cbOffsets=i())},onUpdate:function(){a.callbacks&&a.onUpdate&&r(\"whileScrolling\")&&(l(),c.callbacks.whileScrolling.call(t[0]))},onComplete:function(){if(a.callbacks&&a.onComplete){\"yx\"===c.axis&&clearTimeout(_[0].onCompleteTimeout);var e=_[0].idleTimer||0;_[0].onCompleteTimeout=setTimeout(function(){r(\"onScroll\")&&(l(),c.callbacks.onScroll.call(t[0])),r(\"onTotalScroll\")&&b[1]>=C[1]-B&&s.cbOffsets[0]&&(l(),c.callbacks.onTotalScroll.call(t[0])),r(\"onTotalScrollBack\")&&b[1]<=T&&s.cbOffsets[1]&&(l(),c.callbacks.onTotalScrollBack.call(t[0])),s.tweenRunning=!1,_[0].idleTimer=0,h._onDragClasses(v,\"hide\")},e)}}}))}},_tweenTo:function(e,o,a,n,r,i,l){function s(){w.stop||(S||p.call(),S=h._getTime()-x,c(),S>=w.time&&(w.time=S>w.time?S+_-(S-w.time):S+_-1,w.time<S+1&&(w.time=S+1)),w.time<n?w.id=m(s):v.call())}function c(){n>0?(w.currVal=f(w.time,C,y,n,r),b[o]=Math.round(w.currVal)+\"px\"):b[o]=a+\"px\",g.call()}function d(){_=1e3/60,w.time=S+_,m=t.requestAnimationFrame?t.requestAnimationFrame:function(e){return c(),setTimeout(e,.01)},w.id=m(s)}function u(){null!=w.id&&(t.requestAnimationFrame?t.cancelAnimationFrame(w.id):clearTimeout(w.id),w.id=null)}function f(e,t,o,a,n){switch(n){case\"linear\":case\"mcsLinear\":return o*e/a+t;case\"mcsLinearOut\":return e/=a,e--,o*Math.sqrt(1-e*e)+t;case\"easeInOutSmooth\":return e/=a/2,1>e?o/2*e*e+t:(e--,-o/2*(e*(e-2)-1)+t);case\"easeInOutStrong\":return e/=a/2,1>e?o/2*Math.pow(2,10*(e-1))+t:(e--,o/2*(-Math.pow(2,-10*e)+2)+t);case\"easeInOut\":case\"mcsEaseInOut\":return e/=a/2,1>e?o/2*e*e*e+t:(e-=2,o/2*(e*e*e+2)+t);case\"easeOutSmooth\":return e/=a,e--,-o*(e*e*e*e-1)+t;case\"easeOutStrong\":return o*(-Math.pow(2,-10*e/a)+1)+t;case\"easeOut\":case\"mcsEaseOut\":default:var r=(e/=a)*e,i=r*e;return t+o*(.499999999999997*i*r+-2.5*r*r+5.5*i+-6.5*r+4*e)}}e._malihuTween||(e._malihuTween={top:{},left:{}});var _,m,l=l||{},p=l.onStart||function(){},g=l.onUpdate||function(){},v=l.onComplete||function(){},x=h._getTime(),S=0,C=e.offsetTop,b=e.style,w=e._malihuTween[o];\"left\"===o&&(C=e.offsetLeft);var y=a-C;w.stop=0,\"none\"!==i&&u(),d()},_getTime:function(){return t.performance&&t.performance.now?t.performance.now():t.performance&&t.performance.webkitNow?t.performance.webkitNow():Date.now?Date.now():(new Date).getTime()},_stopTween:function(){var e=this;e._malihuTween||(e._malihuTween={top:{},left:{}}),e._malihuTween.top.id&&(t.requestAnimationFrame?t.cancelAnimationFrame(e._malihuTween.top.id):clearTimeout(e._malihuTween.top.id),e._malihuTween.top.id=null,e._malihuTween.top.stop=1),e._malihuTween.left.id&&(t.requestAnimationFrame?t.cancelAnimationFrame(e._malihuTween.left.id):clearTimeout(e._malihuTween.left.id),e._malihuTween.left.id=null,e._malihuTween.left.stop=1)},_delete:function(e){try{delete e}catch(t){e=null}},_mouseBtnLeft:function(e){return!(e.which&&1!==e.which)},_pointerTouch:function(e){var t=e.originalEvent.pointerType;return!(t&&\"touch\"!==t&&2!==t)},_isNumeric:function(e){return!isNaN(parseFloat(e))&&isFinite(e)}};e.fn[a]=function(t){return f[t]?f[t].apply(this,Array.prototype.slice.call(arguments,1)):\"object\"!=typeof t&&t?void e.error(\"Method \"+t+\" does not exist\"):f.init.apply(this,arguments)},e[a]=function(t){return f[t]?f[t].apply(this,Array.prototype.slice.call(arguments,1)):\"object\"!=typeof t&&t?void e.error(\"Method \"+t+\" does not exist\"):f.init.apply(this,arguments)},e[a].defaults=i,t[a]=!0,e(t).load(function(){e(r)[a]()})})}(jQuery,window,document);"

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(500))

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = "/*!\n * imagesLoaded PACKAGED v4.1.4\n * JavaScript is all like \"You images are done yet or what?\"\n * MIT License\n */\n\n/**\n * EvEmitter v1.1.0\n * Lil' event emitter\n * MIT License\n */\n\n/* jshint unused: true, undef: true, strict: true */\n\n( function( global, factory ) {\n  // universal module definition\n  /* jshint strict: false */ /* globals define, module, window */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD - RequireJS\n    define( 'ev-emitter/ev-emitter',factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS - Browserify, Webpack\n    module.exports = factory();\n  } else {\n    // Browser globals\n    global.EvEmitter = factory();\n  }\n\n}( typeof window != 'undefined' ? window : this, function() {\n\n\n\nfunction EvEmitter() {}\n\nvar proto = EvEmitter.prototype;\n\nproto.on = function( eventName, listener ) {\n  if ( !eventName || !listener ) {\n    return;\n  }\n  // set events hash\n  var events = this._events = this._events || {};\n  // set listeners array\n  var listeners = events[ eventName ] = events[ eventName ] || [];\n  // only add once\n  if ( listeners.indexOf( listener ) == -1 ) {\n    listeners.push( listener );\n  }\n\n  return this;\n};\n\nproto.once = function( eventName, listener ) {\n  if ( !eventName || !listener ) {\n    return;\n  }\n  // add event\n  this.on( eventName, listener );\n  // set once flag\n  // set onceEvents hash\n  var onceEvents = this._onceEvents = this._onceEvents || {};\n  // set onceListeners object\n  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};\n  // set flag\n  onceListeners[ listener ] = true;\n\n  return this;\n};\n\nproto.off = function( eventName, listener ) {\n  var listeners = this._events && this._events[ eventName ];\n  if ( !listeners || !listeners.length ) {\n    return;\n  }\n  var index = listeners.indexOf( listener );\n  if ( index != -1 ) {\n    listeners.splice( index, 1 );\n  }\n\n  return this;\n};\n\nproto.emitEvent = function( eventName, args ) {\n  var listeners = this._events && this._events[ eventName ];\n  if ( !listeners || !listeners.length ) {\n    return;\n  }\n  // copy over to avoid interference if .off() in listener\n  listeners = listeners.slice(0);\n  args = args || [];\n  // once stuff\n  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];\n\n  for ( var i=0; i < listeners.length; i++ ) {\n    var listener = listeners[i]\n    var isOnce = onceListeners && onceListeners[ listener ];\n    if ( isOnce ) {\n      // remove listener\n      // remove before trigger to prevent recursion\n      this.off( eventName, listener );\n      // unset once flag\n      delete onceListeners[ listener ];\n    }\n    // trigger listener\n    listener.apply( this, args );\n  }\n\n  return this;\n};\n\nproto.allOff = function() {\n  delete this._events;\n  delete this._onceEvents;\n};\n\nreturn EvEmitter;\n\n}));\n\n/*!\n * imagesLoaded v4.1.4\n * JavaScript is all like \"You images are done yet or what?\"\n * MIT License\n */\n\n( function( window, factory ) { 'use strict';\n  // universal module definition\n\n  /*global define: false, module: false, require: false */\n\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( [\n      'ev-emitter/ev-emitter'\n    ], function( EvEmitter ) {\n      return factory( window, EvEmitter );\n    });\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory(\n      window,\n      require('ev-emitter')\n    );\n  } else {\n    // browser global\n    window.imagesLoaded = factory(\n      window,\n      window.EvEmitter\n    );\n  }\n\n})( typeof window !== 'undefined' ? window : this,\n\n// --------------------------  factory -------------------------- //\n\nfunction factory( window, EvEmitter ) {\n\n\n\nvar $ = window.jQuery;\nvar console = window.console;\n\n// -------------------------- helpers -------------------------- //\n\n// extend objects\nfunction extend( a, b ) {\n  for ( var prop in b ) {\n    a[ prop ] = b[ prop ];\n  }\n  return a;\n}\n\nvar arraySlice = Array.prototype.slice;\n\n// turn element or nodeList into an array\nfunction makeArray( obj ) {\n  if ( Array.isArray( obj ) ) {\n    // use object if already an array\n    return obj;\n  }\n\n  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';\n  if ( isArrayLike ) {\n    // convert nodeList to array\n    return arraySlice.call( obj );\n  }\n\n  // array of single index\n  return [ obj ];\n}\n\n// -------------------------- imagesLoaded -------------------------- //\n\n/**\n * @param {Array, Element, NodeList, String} elem\n * @param {Object or Function} options - if function, use as callback\n * @param {Function} onAlways - callback function\n */\nfunction ImagesLoaded( elem, options, onAlways ) {\n  // coerce ImagesLoaded() without new, to be new ImagesLoaded()\n  if ( !( this instanceof ImagesLoaded ) ) {\n    return new ImagesLoaded( elem, options, onAlways );\n  }\n  // use elem as selector string\n  var queryElem = elem;\n  if ( typeof elem == 'string' ) {\n    queryElem = document.querySelectorAll( elem );\n  }\n  // bail if bad element\n  if ( !queryElem ) {\n    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );\n    return;\n  }\n\n  this.elements = makeArray( queryElem );\n  this.options = extend( {}, this.options );\n  // shift arguments if no options set\n  if ( typeof options == 'function' ) {\n    onAlways = options;\n  } else {\n    extend( this.options, options );\n  }\n\n  if ( onAlways ) {\n    this.on( 'always', onAlways );\n  }\n\n  this.getImages();\n\n  if ( $ ) {\n    // add jQuery Deferred object\n    this.jqDeferred = new $.Deferred();\n  }\n\n  // HACK check async to allow time to bind listeners\n  setTimeout( this.check.bind( this ) );\n}\n\nImagesLoaded.prototype = Object.create( EvEmitter.prototype );\n\nImagesLoaded.prototype.options = {};\n\nImagesLoaded.prototype.getImages = function() {\n  this.images = [];\n\n  // filter & find items if we have an item selector\n  this.elements.forEach( this.addElementImages, this );\n};\n\n/**\n * @param {Node} element\n */\nImagesLoaded.prototype.addElementImages = function( elem ) {\n  // filter siblings\n  if ( elem.nodeName == 'IMG' ) {\n    this.addImage( elem );\n  }\n  // get background image on element\n  if ( this.options.background === true ) {\n    this.addElementBackgroundImages( elem );\n  }\n\n  // find children\n  // no non-element nodes, #143\n  var nodeType = elem.nodeType;\n  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {\n    return;\n  }\n  var childImgs = elem.querySelectorAll('img');\n  // concat childElems to filterFound array\n  for ( var i=0; i < childImgs.length; i++ ) {\n    var img = childImgs[i];\n    this.addImage( img );\n  }\n\n  // get child background images\n  if ( typeof this.options.background == 'string' ) {\n    var children = elem.querySelectorAll( this.options.background );\n    for ( i=0; i < children.length; i++ ) {\n      var child = children[i];\n      this.addElementBackgroundImages( child );\n    }\n  }\n};\n\nvar elementNodeTypes = {\n  1: true,\n  9: true,\n  11: true\n};\n\nImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {\n  var style = getComputedStyle( elem );\n  if ( !style ) {\n    // Firefox returns null if in a hidden iframe https://bugzil.la/548397\n    return;\n  }\n  // get url inside url(\"...\")\n  var reURL = /url\\((['\"])?(.*?)\\1\\)/gi;\n  var matches = reURL.exec( style.backgroundImage );\n  while ( matches !== null ) {\n    var url = matches && matches[2];\n    if ( url ) {\n      this.addBackground( url, elem );\n    }\n    matches = reURL.exec( style.backgroundImage );\n  }\n};\n\n/**\n * @param {Image} img\n */\nImagesLoaded.prototype.addImage = function( img ) {\n  var loadingImage = new LoadingImage( img );\n  this.images.push( loadingImage );\n};\n\nImagesLoaded.prototype.addBackground = function( url, elem ) {\n  var background = new Background( url, elem );\n  this.images.push( background );\n};\n\nImagesLoaded.prototype.check = function() {\n  var _this = this;\n  this.progressedCount = 0;\n  this.hasAnyBroken = false;\n  // complete if no images\n  if ( !this.images.length ) {\n    this.complete();\n    return;\n  }\n\n  function onProgress( image, elem, message ) {\n    // HACK - Chrome triggers event before object properties have changed. #83\n    setTimeout( function() {\n      _this.progress( image, elem, message );\n    });\n  }\n\n  this.images.forEach( function( loadingImage ) {\n    loadingImage.once( 'progress', onProgress );\n    loadingImage.check();\n  });\n};\n\nImagesLoaded.prototype.progress = function( image, elem, message ) {\n  this.progressedCount++;\n  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;\n  // progress event\n  this.emitEvent( 'progress', [ this, image, elem ] );\n  if ( this.jqDeferred && this.jqDeferred.notify ) {\n    this.jqDeferred.notify( this, image );\n  }\n  // check if completed\n  if ( this.progressedCount == this.images.length ) {\n    this.complete();\n  }\n\n  if ( this.options.debug && console ) {\n    console.log( 'progress: ' + message, image, elem );\n  }\n};\n\nImagesLoaded.prototype.complete = function() {\n  var eventName = this.hasAnyBroken ? 'fail' : 'done';\n  this.isComplete = true;\n  this.emitEvent( eventName, [ this ] );\n  this.emitEvent( 'always', [ this ] );\n  if ( this.jqDeferred ) {\n    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';\n    this.jqDeferred[ jqMethod ]( this );\n  }\n};\n\n// --------------------------  -------------------------- //\n\nfunction LoadingImage( img ) {\n  this.img = img;\n}\n\nLoadingImage.prototype = Object.create( EvEmitter.prototype );\n\nLoadingImage.prototype.check = function() {\n  // If complete is true and browser supports natural sizes,\n  // try to check for image status manually.\n  var isComplete = this.getIsImageComplete();\n  if ( isComplete ) {\n    // report based on naturalWidth\n    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );\n    return;\n  }\n\n  // If none of the checks above matched, simulate loading on detached element.\n  this.proxyImage = new Image();\n  this.proxyImage.addEventListener( 'load', this );\n  this.proxyImage.addEventListener( 'error', this );\n  // bind to image as well for Firefox. #191\n  this.img.addEventListener( 'load', this );\n  this.img.addEventListener( 'error', this );\n  this.proxyImage.src = this.img.src;\n};\n\nLoadingImage.prototype.getIsImageComplete = function() {\n  // check for non-zero, non-undefined naturalWidth\n  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671\n  return this.img.complete && this.img.naturalWidth;\n};\n\nLoadingImage.prototype.confirm = function( isLoaded, message ) {\n  this.isLoaded = isLoaded;\n  this.emitEvent( 'progress', [ this, this.img, message ] );\n};\n\n// ----- events ----- //\n\n// trigger specified handler for event type\nLoadingImage.prototype.handleEvent = function( event ) {\n  var method = 'on' + event.type;\n  if ( this[ method ] ) {\n    this[ method ]( event );\n  }\n};\n\nLoadingImage.prototype.onload = function() {\n  this.confirm( true, 'onload' );\n  this.unbindEvents();\n};\n\nLoadingImage.prototype.onerror = function() {\n  this.confirm( false, 'onerror' );\n  this.unbindEvents();\n};\n\nLoadingImage.prototype.unbindEvents = function() {\n  this.proxyImage.removeEventListener( 'load', this );\n  this.proxyImage.removeEventListener( 'error', this );\n  this.img.removeEventListener( 'load', this );\n  this.img.removeEventListener( 'error', this );\n};\n\n// -------------------------- Background -------------------------- //\n\nfunction Background( url, element ) {\n  this.url = url;\n  this.element = element;\n  this.img = new Image();\n}\n\n// inherit LoadingImage prototype\nBackground.prototype = Object.create( LoadingImage.prototype );\n\nBackground.prototype.check = function() {\n  this.img.addEventListener( 'load', this );\n  this.img.addEventListener( 'error', this );\n  this.img.src = this.url;\n  // check if image is already complete\n  var isComplete = this.getIsImageComplete();\n  if ( isComplete ) {\n    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );\n    this.unbindEvents();\n  }\n};\n\nBackground.prototype.unbindEvents = function() {\n  this.img.removeEventListener( 'load', this );\n  this.img.removeEventListener( 'error', this );\n};\n\nBackground.prototype.confirm = function( isLoaded, message ) {\n  this.isLoaded = isLoaded;\n  this.emitEvent( 'progress', [ this, this.element, message ] );\n};\n\n// -------------------------- jQuery -------------------------- //\n\nImagesLoaded.makeJQueryPlugin = function( jQuery ) {\n  jQuery = jQuery || window.jQuery;\n  if ( !jQuery ) {\n    return;\n  }\n  // set local variable\n  $ = jQuery;\n  // $().imagesLoaded()\n  $.fn.imagesLoaded = function( options, callback ) {\n    var instance = new ImagesLoaded( this, options, callback );\n    return instance.jqDeferred.promise( $(this) );\n  };\n};\n// try making plugin\nImagesLoaded.makeJQueryPlugin();\n\n// --------------------------  -------------------------- //\n\nreturn ImagesLoaded;\n\n});\n\n"

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(502))

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = "/*!\n * Masonry PACKAGED v4.2.2\n * Cascading grid layout library\n * https://masonry.desandro.com\n * MIT License\n * by David DeSandro\n */\n\n/**\n * Bridget makes jQuery widgets\n * v2.0.1\n * MIT license\n */\n\n/* jshint browser: true, strict: true, undef: true, unused: true */\n\n( function( window, factory ) {\n  // universal module definition\n  /*jshint strict: false */ /* globals define, module, require */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( 'jquery-bridget/jquery-bridget',[ 'jquery' ], function( jQuery ) {\n      return factory( window, jQuery );\n    });\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory(\n      window,\n      require('jquery')\n    );\n  } else {\n    // browser global\n    window.jQueryBridget = factory(\n      window,\n      window.jQuery\n    );\n  }\n\n}( window, function factory( window, jQuery ) {\n'use strict';\n\n// ----- utils ----- //\n\nvar arraySlice = Array.prototype.slice;\n\n// helper function for logging errors\n// $.error breaks jQuery chaining\nvar console = window.console;\nvar logError = typeof console == 'undefined' ? function() {} :\n  function( message ) {\n    console.error( message );\n  };\n\n// ----- jQueryBridget ----- //\n\nfunction jQueryBridget( namespace, PluginClass, $ ) {\n  $ = $ || jQuery || window.jQuery;\n  if ( !$ ) {\n    return;\n  }\n\n  // add option method -> $().plugin('option', {...})\n  if ( !PluginClass.prototype.option ) {\n    // option setter\n    PluginClass.prototype.option = function( opts ) {\n      // bail out if not an object\n      if ( !$.isPlainObject( opts ) ){\n        return;\n      }\n      this.options = $.extend( true, this.options, opts );\n    };\n  }\n\n  // make jQuery plugin\n  $.fn[ namespace ] = function( arg0 /*, arg1 */ ) {\n    if ( typeof arg0 == 'string' ) {\n      // method call $().plugin( 'methodName', { options } )\n      // shift arguments by 1\n      var args = arraySlice.call( arguments, 1 );\n      return methodCall( this, arg0, args );\n    }\n    // just $().plugin({ options })\n    plainCall( this, arg0 );\n    return this;\n  };\n\n  // $().plugin('methodName')\n  function methodCall( $elems, methodName, args ) {\n    var returnValue;\n    var pluginMethodStr = '$().' + namespace + '(\"' + methodName + '\")';\n\n    $elems.each( function( i, elem ) {\n      // get instance\n      var instance = $.data( elem, namespace );\n      if ( !instance ) {\n        logError( namespace + ' not initialized. Cannot call methods, i.e. ' +\n          pluginMethodStr );\n        return;\n      }\n\n      var method = instance[ methodName ];\n      if ( !method || methodName.charAt(0) == '_' ) {\n        logError( pluginMethodStr + ' is not a valid method' );\n        return;\n      }\n\n      // apply method, get return value\n      var value = method.apply( instance, args );\n      // set return value if value is returned, use only first value\n      returnValue = returnValue === undefined ? value : returnValue;\n    });\n\n    return returnValue !== undefined ? returnValue : $elems;\n  }\n\n  function plainCall( $elems, options ) {\n    $elems.each( function( i, elem ) {\n      var instance = $.data( elem, namespace );\n      if ( instance ) {\n        // set options & init\n        instance.option( options );\n        instance._init();\n      } else {\n        // initialize new instance\n        instance = new PluginClass( elem, options );\n        $.data( elem, namespace, instance );\n      }\n    });\n  }\n\n  updateJQuery( $ );\n\n}\n\n// ----- updateJQuery ----- //\n\n// set $.bridget for v1 backwards compatibility\nfunction updateJQuery( $ ) {\n  if ( !$ || ( $ && $.bridget ) ) {\n    return;\n  }\n  $.bridget = jQueryBridget;\n}\n\nupdateJQuery( jQuery || window.jQuery );\n\n// -----  ----- //\n\nreturn jQueryBridget;\n\n}));\n\n/**\n * EvEmitter v1.1.0\n * Lil' event emitter\n * MIT License\n */\n\n/* jshint unused: true, undef: true, strict: true */\n\n( function( global, factory ) {\n  // universal module definition\n  /* jshint strict: false */ /* globals define, module, window */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD - RequireJS\n    define( 'ev-emitter/ev-emitter',factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS - Browserify, Webpack\n    module.exports = factory();\n  } else {\n    // Browser globals\n    global.EvEmitter = factory();\n  }\n\n}( typeof window != 'undefined' ? window : this, function() {\n\n\n\nfunction EvEmitter() {}\n\nvar proto = EvEmitter.prototype;\n\nproto.on = function( eventName, listener ) {\n  if ( !eventName || !listener ) {\n    return;\n  }\n  // set events hash\n  var events = this._events = this._events || {};\n  // set listeners array\n  var listeners = events[ eventName ] = events[ eventName ] || [];\n  // only add once\n  if ( listeners.indexOf( listener ) == -1 ) {\n    listeners.push( listener );\n  }\n\n  return this;\n};\n\nproto.once = function( eventName, listener ) {\n  if ( !eventName || !listener ) {\n    return;\n  }\n  // add event\n  this.on( eventName, listener );\n  // set once flag\n  // set onceEvents hash\n  var onceEvents = this._onceEvents = this._onceEvents || {};\n  // set onceListeners object\n  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};\n  // set flag\n  onceListeners[ listener ] = true;\n\n  return this;\n};\n\nproto.off = function( eventName, listener ) {\n  var listeners = this._events && this._events[ eventName ];\n  if ( !listeners || !listeners.length ) {\n    return;\n  }\n  var index = listeners.indexOf( listener );\n  if ( index != -1 ) {\n    listeners.splice( index, 1 );\n  }\n\n  return this;\n};\n\nproto.emitEvent = function( eventName, args ) {\n  var listeners = this._events && this._events[ eventName ];\n  if ( !listeners || !listeners.length ) {\n    return;\n  }\n  // copy over to avoid interference if .off() in listener\n  listeners = listeners.slice(0);\n  args = args || [];\n  // once stuff\n  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];\n\n  for ( var i=0; i < listeners.length; i++ ) {\n    var listener = listeners[i]\n    var isOnce = onceListeners && onceListeners[ listener ];\n    if ( isOnce ) {\n      // remove listener\n      // remove before trigger to prevent recursion\n      this.off( eventName, listener );\n      // unset once flag\n      delete onceListeners[ listener ];\n    }\n    // trigger listener\n    listener.apply( this, args );\n  }\n\n  return this;\n};\n\nproto.allOff = function() {\n  delete this._events;\n  delete this._onceEvents;\n};\n\nreturn EvEmitter;\n\n}));\n\n/*!\n * getSize v2.0.3\n * measure size of elements\n * MIT license\n */\n\n/* jshint browser: true, strict: true, undef: true, unused: true */\n/* globals console: false */\n\n( function( window, factory ) {\n  /* jshint strict: false */ /* globals define, module */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( 'get-size/get-size',factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory();\n  } else {\n    // browser global\n    window.getSize = factory();\n  }\n\n})( window, function factory() {\n'use strict';\n\n// -------------------------- helpers -------------------------- //\n\n// get a number from a string, not a percentage\nfunction getStyleSize( value ) {\n  var num = parseFloat( value );\n  // not a percent like '100%', and a number\n  var isValid = value.indexOf('%') == -1 && !isNaN( num );\n  return isValid && num;\n}\n\nfunction noop() {}\n\nvar logError = typeof console == 'undefined' ? noop :\n  function( message ) {\n    console.error( message );\n  };\n\n// -------------------------- measurements -------------------------- //\n\nvar measurements = [\n  'paddingLeft',\n  'paddingRight',\n  'paddingTop',\n  'paddingBottom',\n  'marginLeft',\n  'marginRight',\n  'marginTop',\n  'marginBottom',\n  'borderLeftWidth',\n  'borderRightWidth',\n  'borderTopWidth',\n  'borderBottomWidth'\n];\n\nvar measurementsLength = measurements.length;\n\nfunction getZeroSize() {\n  var size = {\n    width: 0,\n    height: 0,\n    innerWidth: 0,\n    innerHeight: 0,\n    outerWidth: 0,\n    outerHeight: 0\n  };\n  for ( var i=0; i < measurementsLength; i++ ) {\n    var measurement = measurements[i];\n    size[ measurement ] = 0;\n  }\n  return size;\n}\n\n// -------------------------- getStyle -------------------------- //\n\n/**\n * getStyle, get style of element, check for Firefox bug\n * https://bugzilla.mozilla.org/show_bug.cgi?id=548397\n */\nfunction getStyle( elem ) {\n  var style = getComputedStyle( elem );\n  if ( !style ) {\n    logError( 'Style returned ' + style +\n      '. Are you running this code in a hidden iframe on Firefox? ' +\n      'See https://bit.ly/getsizebug1' );\n  }\n  return style;\n}\n\n// -------------------------- setup -------------------------- //\n\nvar isSetup = false;\n\nvar isBoxSizeOuter;\n\n/**\n * setup\n * check isBoxSizerOuter\n * do on first getSize() rather than on page load for Firefox bug\n */\nfunction setup() {\n  // setup once\n  if ( isSetup ) {\n    return;\n  }\n  isSetup = true;\n\n  // -------------------------- box sizing -------------------------- //\n\n  /**\n   * Chrome & Safari measure the outer-width on style.width on border-box elems\n   * IE11 & Firefox<29 measures the inner-width\n   */\n  var div = document.createElement('div');\n  div.style.width = '200px';\n  div.style.padding = '1px 2px 3px 4px';\n  div.style.borderStyle = 'solid';\n  div.style.borderWidth = '1px 2px 3px 4px';\n  div.style.boxSizing = 'border-box';\n\n  var body = document.body || document.documentElement;\n  body.appendChild( div );\n  var style = getStyle( div );\n  // round value for browser zoom. desandro/masonry#928\n  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;\n  getSize.isBoxSizeOuter = isBoxSizeOuter;\n\n  body.removeChild( div );\n}\n\n// -------------------------- getSize -------------------------- //\n\nfunction getSize( elem ) {\n  setup();\n\n  // use querySeletor if elem is string\n  if ( typeof elem == 'string' ) {\n    elem = document.querySelector( elem );\n  }\n\n  // do not proceed on non-objects\n  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {\n    return;\n  }\n\n  var style = getStyle( elem );\n\n  // if hidden, everything is 0\n  if ( style.display == 'none' ) {\n    return getZeroSize();\n  }\n\n  var size = {};\n  size.width = elem.offsetWidth;\n  size.height = elem.offsetHeight;\n\n  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';\n\n  // get all measurements\n  for ( var i=0; i < measurementsLength; i++ ) {\n    var measurement = measurements[i];\n    var value = style[ measurement ];\n    var num = parseFloat( value );\n    // any 'auto', 'medium' value will be 0\n    size[ measurement ] = !isNaN( num ) ? num : 0;\n  }\n\n  var paddingWidth = size.paddingLeft + size.paddingRight;\n  var paddingHeight = size.paddingTop + size.paddingBottom;\n  var marginWidth = size.marginLeft + size.marginRight;\n  var marginHeight = size.marginTop + size.marginBottom;\n  var borderWidth = size.borderLeftWidth + size.borderRightWidth;\n  var borderHeight = size.borderTopWidth + size.borderBottomWidth;\n\n  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;\n\n  // overwrite width and height if we can get it from style\n  var styleWidth = getStyleSize( style.width );\n  if ( styleWidth !== false ) {\n    size.width = styleWidth +\n      // add padding and border unless it's already including it\n      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );\n  }\n\n  var styleHeight = getStyleSize( style.height );\n  if ( styleHeight !== false ) {\n    size.height = styleHeight +\n      // add padding and border unless it's already including it\n      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );\n  }\n\n  size.innerWidth = size.width - ( paddingWidth + borderWidth );\n  size.innerHeight = size.height - ( paddingHeight + borderHeight );\n\n  size.outerWidth = size.width + marginWidth;\n  size.outerHeight = size.height + marginHeight;\n\n  return size;\n}\n\nreturn getSize;\n\n});\n\n/**\n * matchesSelector v2.0.2\n * matchesSelector( element, '.selector' )\n * MIT license\n */\n\n/*jshint browser: true, strict: true, undef: true, unused: true */\n\n( function( window, factory ) {\n  /*global define: false, module: false */\n  'use strict';\n  // universal module definition\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( 'desandro-matches-selector/matches-selector',factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory();\n  } else {\n    // browser global\n    window.matchesSelector = factory();\n  }\n\n}( window, function factory() {\n  'use strict';\n\n  var matchesMethod = ( function() {\n    var ElemProto = window.Element.prototype;\n    // check for the standard method name first\n    if ( ElemProto.matches ) {\n      return 'matches';\n    }\n    // check un-prefixed\n    if ( ElemProto.matchesSelector ) {\n      return 'matchesSelector';\n    }\n    // check vendor prefixes\n    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];\n\n    for ( var i=0; i < prefixes.length; i++ ) {\n      var prefix = prefixes[i];\n      var method = prefix + 'MatchesSelector';\n      if ( ElemProto[ method ] ) {\n        return method;\n      }\n    }\n  })();\n\n  return function matchesSelector( elem, selector ) {\n    return elem[ matchesMethod ]( selector );\n  };\n\n}));\n\n/**\n * Fizzy UI utils v2.0.7\n * MIT license\n */\n\n/*jshint browser: true, undef: true, unused: true, strict: true */\n\n( function( window, factory ) {\n  // universal module definition\n  /*jshint strict: false */ /*globals define, module, require */\n\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( 'fizzy-ui-utils/utils',[\n      'desandro-matches-selector/matches-selector'\n    ], function( matchesSelector ) {\n      return factory( window, matchesSelector );\n    });\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory(\n      window,\n      require('desandro-matches-selector')\n    );\n  } else {\n    // browser global\n    window.fizzyUIUtils = factory(\n      window,\n      window.matchesSelector\n    );\n  }\n\n}( window, function factory( window, matchesSelector ) {\n\n\n\nvar utils = {};\n\n// ----- extend ----- //\n\n// extends objects\nutils.extend = function( a, b ) {\n  for ( var prop in b ) {\n    a[ prop ] = b[ prop ];\n  }\n  return a;\n};\n\n// ----- modulo ----- //\n\nutils.modulo = function( num, div ) {\n  return ( ( num % div ) + div ) % div;\n};\n\n// ----- makeArray ----- //\n\nvar arraySlice = Array.prototype.slice;\n\n// turn element or nodeList into an array\nutils.makeArray = function( obj ) {\n  if ( Array.isArray( obj ) ) {\n    // use object if already an array\n    return obj;\n  }\n  // return empty array if undefined or null. #6\n  if ( obj === null || obj === undefined ) {\n    return [];\n  }\n\n  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';\n  if ( isArrayLike ) {\n    // convert nodeList to array\n    return arraySlice.call( obj );\n  }\n\n  // array of single index\n  return [ obj ];\n};\n\n// ----- removeFrom ----- //\n\nutils.removeFrom = function( ary, obj ) {\n  var index = ary.indexOf( obj );\n  if ( index != -1 ) {\n    ary.splice( index, 1 );\n  }\n};\n\n// ----- getParent ----- //\n\nutils.getParent = function( elem, selector ) {\n  while ( elem.parentNode && elem != document.body ) {\n    elem = elem.parentNode;\n    if ( matchesSelector( elem, selector ) ) {\n      return elem;\n    }\n  }\n};\n\n// ----- getQueryElement ----- //\n\n// use element as selector string\nutils.getQueryElement = function( elem ) {\n  if ( typeof elem == 'string' ) {\n    return document.querySelector( elem );\n  }\n  return elem;\n};\n\n// ----- handleEvent ----- //\n\n// enable .ontype to trigger from .addEventListener( elem, 'type' )\nutils.handleEvent = function( event ) {\n  var method = 'on' + event.type;\n  if ( this[ method ] ) {\n    this[ method ]( event );\n  }\n};\n\n// ----- filterFindElements ----- //\n\nutils.filterFindElements = function( elems, selector ) {\n  // make array of elems\n  elems = utils.makeArray( elems );\n  var ffElems = [];\n\n  elems.forEach( function( elem ) {\n    // check that elem is an actual element\n    if ( !( elem instanceof HTMLElement ) ) {\n      return;\n    }\n    // add elem if no selector\n    if ( !selector ) {\n      ffElems.push( elem );\n      return;\n    }\n    // filter & find items if we have a selector\n    // filter\n    if ( matchesSelector( elem, selector ) ) {\n      ffElems.push( elem );\n    }\n    // find children\n    var childElems = elem.querySelectorAll( selector );\n    // concat childElems to filterFound array\n    for ( var i=0; i < childElems.length; i++ ) {\n      ffElems.push( childElems[i] );\n    }\n  });\n\n  return ffElems;\n};\n\n// ----- debounceMethod ----- //\n\nutils.debounceMethod = function( _class, methodName, threshold ) {\n  threshold = threshold || 100;\n  // original method\n  var method = _class.prototype[ methodName ];\n  var timeoutName = methodName + 'Timeout';\n\n  _class.prototype[ methodName ] = function() {\n    var timeout = this[ timeoutName ];\n    clearTimeout( timeout );\n\n    var args = arguments;\n    var _this = this;\n    this[ timeoutName ] = setTimeout( function() {\n      method.apply( _this, args );\n      delete _this[ timeoutName ];\n    }, threshold );\n  };\n};\n\n// ----- docReady ----- //\n\nutils.docReady = function( callback ) {\n  var readyState = document.readyState;\n  if ( readyState == 'complete' || readyState == 'interactive' ) {\n    // do async to allow for other scripts to run. metafizzy/flickity#441\n    setTimeout( callback );\n  } else {\n    document.addEventListener( 'DOMContentLoaded', callback );\n  }\n};\n\n// ----- htmlInit ----- //\n\n// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/\nutils.toDashed = function( str ) {\n  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {\n    return $1 + '-' + $2;\n  }).toLowerCase();\n};\n\nvar console = window.console;\n/**\n * allow user to initialize classes via [data-namespace] or .js-namespace class\n * htmlInit( Widget, 'widgetName' )\n * options are parsed from data-namespace-options\n */\nutils.htmlInit = function( WidgetClass, namespace ) {\n  utils.docReady( function() {\n    var dashedNamespace = utils.toDashed( namespace );\n    var dataAttr = 'data-' + dashedNamespace;\n    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );\n    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );\n    var elems = utils.makeArray( dataAttrElems )\n      .concat( utils.makeArray( jsDashElems ) );\n    var dataOptionsAttr = dataAttr + '-options';\n    var jQuery = window.jQuery;\n\n    elems.forEach( function( elem ) {\n      var attr = elem.getAttribute( dataAttr ) ||\n        elem.getAttribute( dataOptionsAttr );\n      var options;\n      try {\n        options = attr && JSON.parse( attr );\n      } catch ( error ) {\n        // log error, do not initialize\n        if ( console ) {\n          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +\n          ': ' + error );\n        }\n        return;\n      }\n      // initialize\n      var instance = new WidgetClass( elem, options );\n      // make available via $().data('namespace')\n      if ( jQuery ) {\n        jQuery.data( elem, namespace, instance );\n      }\n    });\n\n  });\n};\n\n// -----  ----- //\n\nreturn utils;\n\n}));\n\n/**\n * Outlayer Item\n */\n\n( function( window, factory ) {\n  // universal module definition\n  /* jshint strict: false */ /* globals define, module, require */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD - RequireJS\n    define( 'outlayer/item',[\n        'ev-emitter/ev-emitter',\n        'get-size/get-size'\n      ],\n      factory\n    );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS - Browserify, Webpack\n    module.exports = factory(\n      require('ev-emitter'),\n      require('get-size')\n    );\n  } else {\n    // browser global\n    window.Outlayer = {};\n    window.Outlayer.Item = factory(\n      window.EvEmitter,\n      window.getSize\n    );\n  }\n\n}( window, function factory( EvEmitter, getSize ) {\n'use strict';\n\n// ----- helpers ----- //\n\nfunction isEmptyObj( obj ) {\n  for ( var prop in obj ) {\n    return false;\n  }\n  prop = null;\n  return true;\n}\n\n// -------------------------- CSS3 support -------------------------- //\n\n\nvar docElemStyle = document.documentElement.style;\n\nvar transitionProperty = typeof docElemStyle.transition == 'string' ?\n  'transition' : 'WebkitTransition';\nvar transformProperty = typeof docElemStyle.transform == 'string' ?\n  'transform' : 'WebkitTransform';\n\nvar transitionEndEvent = {\n  WebkitTransition: 'webkitTransitionEnd',\n  transition: 'transitionend'\n}[ transitionProperty ];\n\n// cache all vendor properties that could have vendor prefix\nvar vendorProperties = {\n  transform: transformProperty,\n  transition: transitionProperty,\n  transitionDuration: transitionProperty + 'Duration',\n  transitionProperty: transitionProperty + 'Property',\n  transitionDelay: transitionProperty + 'Delay'\n};\n\n// -------------------------- Item -------------------------- //\n\nfunction Item( element, layout ) {\n  if ( !element ) {\n    return;\n  }\n\n  this.element = element;\n  // parent layout class, i.e. Masonry, Isotope, or Packery\n  this.layout = layout;\n  this.position = {\n    x: 0,\n    y: 0\n  };\n\n  this._create();\n}\n\n// inherit EvEmitter\nvar proto = Item.prototype = Object.create( EvEmitter.prototype );\nproto.constructor = Item;\n\nproto._create = function() {\n  // transition objects\n  this._transn = {\n    ingProperties: {},\n    clean: {},\n    onEnd: {}\n  };\n\n  this.css({\n    position: 'absolute'\n  });\n};\n\n// trigger specified handler for event type\nproto.handleEvent = function( event ) {\n  var method = 'on' + event.type;\n  if ( this[ method ] ) {\n    this[ method ]( event );\n  }\n};\n\nproto.getSize = function() {\n  this.size = getSize( this.element );\n};\n\n/**\n * apply CSS styles to element\n * @param {Object} style\n */\nproto.css = function( style ) {\n  var elemStyle = this.element.style;\n\n  for ( var prop in style ) {\n    // use vendor property if available\n    var supportedProp = vendorProperties[ prop ] || prop;\n    elemStyle[ supportedProp ] = style[ prop ];\n  }\n};\n\n // measure position, and sets it\nproto.getPosition = function() {\n  var style = getComputedStyle( this.element );\n  var isOriginLeft = this.layout._getOption('originLeft');\n  var isOriginTop = this.layout._getOption('originTop');\n  var xValue = style[ isOriginLeft ? 'left' : 'right' ];\n  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];\n  var x = parseFloat( xValue );\n  var y = parseFloat( yValue );\n  // convert percent to pixels\n  var layoutSize = this.layout.size;\n  if ( xValue.indexOf('%') != -1 ) {\n    x = ( x / 100 ) * layoutSize.width;\n  }\n  if ( yValue.indexOf('%') != -1 ) {\n    y = ( y / 100 ) * layoutSize.height;\n  }\n  // clean up 'auto' or other non-integer values\n  x = isNaN( x ) ? 0 : x;\n  y = isNaN( y ) ? 0 : y;\n  // remove padding from measurement\n  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;\n  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;\n\n  this.position.x = x;\n  this.position.y = y;\n};\n\n// set settled position, apply padding\nproto.layoutPosition = function() {\n  var layoutSize = this.layout.size;\n  var style = {};\n  var isOriginLeft = this.layout._getOption('originLeft');\n  var isOriginTop = this.layout._getOption('originTop');\n\n  // x\n  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';\n  var xProperty = isOriginLeft ? 'left' : 'right';\n  var xResetProperty = isOriginLeft ? 'right' : 'left';\n\n  var x = this.position.x + layoutSize[ xPadding ];\n  // set in percentage or pixels\n  style[ xProperty ] = this.getXValue( x );\n  // reset other property\n  style[ xResetProperty ] = '';\n\n  // y\n  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';\n  var yProperty = isOriginTop ? 'top' : 'bottom';\n  var yResetProperty = isOriginTop ? 'bottom' : 'top';\n\n  var y = this.position.y + layoutSize[ yPadding ];\n  // set in percentage or pixels\n  style[ yProperty ] = this.getYValue( y );\n  // reset other property\n  style[ yResetProperty ] = '';\n\n  this.css( style );\n  this.emitEvent( 'layout', [ this ] );\n};\n\nproto.getXValue = function( x ) {\n  var isHorizontal = this.layout._getOption('horizontal');\n  return this.layout.options.percentPosition && !isHorizontal ?\n    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';\n};\n\nproto.getYValue = function( y ) {\n  var isHorizontal = this.layout._getOption('horizontal');\n  return this.layout.options.percentPosition && isHorizontal ?\n    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';\n};\n\nproto._transitionTo = function( x, y ) {\n  this.getPosition();\n  // get current x & y from top/left\n  var curX = this.position.x;\n  var curY = this.position.y;\n\n  var didNotMove = x == this.position.x && y == this.position.y;\n\n  // save end position\n  this.setPosition( x, y );\n\n  // if did not move and not transitioning, just go to layout\n  if ( didNotMove && !this.isTransitioning ) {\n    this.layoutPosition();\n    return;\n  }\n\n  var transX = x - curX;\n  var transY = y - curY;\n  var transitionStyle = {};\n  transitionStyle.transform = this.getTranslate( transX, transY );\n\n  this.transition({\n    to: transitionStyle,\n    onTransitionEnd: {\n      transform: this.layoutPosition\n    },\n    isCleaning: true\n  });\n};\n\nproto.getTranslate = function( x, y ) {\n  // flip cooridinates if origin on right or bottom\n  var isOriginLeft = this.layout._getOption('originLeft');\n  var isOriginTop = this.layout._getOption('originTop');\n  x = isOriginLeft ? x : -x;\n  y = isOriginTop ? y : -y;\n  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';\n};\n\n// non transition + transform support\nproto.goTo = function( x, y ) {\n  this.setPosition( x, y );\n  this.layoutPosition();\n};\n\nproto.moveTo = proto._transitionTo;\n\nproto.setPosition = function( x, y ) {\n  this.position.x = parseFloat( x );\n  this.position.y = parseFloat( y );\n};\n\n// ----- transition ----- //\n\n/**\n * @param {Object} style - CSS\n * @param {Function} onTransitionEnd\n */\n\n// non transition, just trigger callback\nproto._nonTransition = function( args ) {\n  this.css( args.to );\n  if ( args.isCleaning ) {\n    this._removeStyles( args.to );\n  }\n  for ( var prop in args.onTransitionEnd ) {\n    args.onTransitionEnd[ prop ].call( this );\n  }\n};\n\n/**\n * proper transition\n * @param {Object} args - arguments\n *   @param {Object} to - style to transition to\n *   @param {Object} from - style to start transition from\n *   @param {Boolean} isCleaning - removes transition styles after transition\n *   @param {Function} onTransitionEnd - callback\n */\nproto.transition = function( args ) {\n  // redirect to nonTransition if no transition duration\n  if ( !parseFloat( this.layout.options.transitionDuration ) ) {\n    this._nonTransition( args );\n    return;\n  }\n\n  var _transition = this._transn;\n  // keep track of onTransitionEnd callback by css property\n  for ( var prop in args.onTransitionEnd ) {\n    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];\n  }\n  // keep track of properties that are transitioning\n  for ( prop in args.to ) {\n    _transition.ingProperties[ prop ] = true;\n    // keep track of properties to clean up when transition is done\n    if ( args.isCleaning ) {\n      _transition.clean[ prop ] = true;\n    }\n  }\n\n  // set from styles\n  if ( args.from ) {\n    this.css( args.from );\n    // force redraw. http://blog.alexmaccaw.com/css-transitions\n    var h = this.element.offsetHeight;\n    // hack for JSHint to hush about unused var\n    h = null;\n  }\n  // enable transition\n  this.enableTransition( args.to );\n  // set styles that are transitioning\n  this.css( args.to );\n\n  this.isTransitioning = true;\n\n};\n\n// dash before all cap letters, including first for\n// WebkitTransform => -webkit-transform\nfunction toDashedAll( str ) {\n  return str.replace( /([A-Z])/g, function( $1 ) {\n    return '-' + $1.toLowerCase();\n  });\n}\n\nvar transitionProps = 'opacity,' + toDashedAll( transformProperty );\n\nproto.enableTransition = function(/* style */) {\n  // HACK changing transitionProperty during a transition\n  // will cause transition to jump\n  if ( this.isTransitioning ) {\n    return;\n  }\n\n  // make `transition: foo, bar, baz` from style object\n  // HACK un-comment this when enableTransition can work\n  // while a transition is happening\n  // var transitionValues = [];\n  // for ( var prop in style ) {\n  //   // dash-ify camelCased properties like WebkitTransition\n  //   prop = vendorProperties[ prop ] || prop;\n  //   transitionValues.push( toDashedAll( prop ) );\n  // }\n  // munge number to millisecond, to match stagger\n  var duration = this.layout.options.transitionDuration;\n  duration = typeof duration == 'number' ? duration + 'ms' : duration;\n  // enable transition styles\n  this.css({\n    transitionProperty: transitionProps,\n    transitionDuration: duration,\n    transitionDelay: this.staggerDelay || 0\n  });\n  // listen for transition end event\n  this.element.addEventListener( transitionEndEvent, this, false );\n};\n\n// ----- events ----- //\n\nproto.onwebkitTransitionEnd = function( event ) {\n  this.ontransitionend( event );\n};\n\nproto.onotransitionend = function( event ) {\n  this.ontransitionend( event );\n};\n\n// properties that I munge to make my life easier\nvar dashedVendorProperties = {\n  '-webkit-transform': 'transform'\n};\n\nproto.ontransitionend = function( event ) {\n  // disregard bubbled events from children\n  if ( event.target !== this.element ) {\n    return;\n  }\n  var _transition = this._transn;\n  // get property name of transitioned property, convert to prefix-free\n  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;\n\n  // remove property that has completed transitioning\n  delete _transition.ingProperties[ propertyName ];\n  // check if any properties are still transitioning\n  if ( isEmptyObj( _transition.ingProperties ) ) {\n    // all properties have completed transitioning\n    this.disableTransition();\n  }\n  // clean style\n  if ( propertyName in _transition.clean ) {\n    // clean up style\n    this.element.style[ event.propertyName ] = '';\n    delete _transition.clean[ propertyName ];\n  }\n  // trigger onTransitionEnd callback\n  if ( propertyName in _transition.onEnd ) {\n    var onTransitionEnd = _transition.onEnd[ propertyName ];\n    onTransitionEnd.call( this );\n    delete _transition.onEnd[ propertyName ];\n  }\n\n  this.emitEvent( 'transitionEnd', [ this ] );\n};\n\nproto.disableTransition = function() {\n  this.removeTransitionStyles();\n  this.element.removeEventListener( transitionEndEvent, this, false );\n  this.isTransitioning = false;\n};\n\n/**\n * removes style property from element\n * @param {Object} style\n**/\nproto._removeStyles = function( style ) {\n  // clean up transition styles\n  var cleanStyle = {};\n  for ( var prop in style ) {\n    cleanStyle[ prop ] = '';\n  }\n  this.css( cleanStyle );\n};\n\nvar cleanTransitionStyle = {\n  transitionProperty: '',\n  transitionDuration: '',\n  transitionDelay: ''\n};\n\nproto.removeTransitionStyles = function() {\n  // remove transition\n  this.css( cleanTransitionStyle );\n};\n\n// ----- stagger ----- //\n\nproto.stagger = function( delay ) {\n  delay = isNaN( delay ) ? 0 : delay;\n  this.staggerDelay = delay + 'ms';\n};\n\n// ----- show/hide/remove ----- //\n\n// remove element from DOM\nproto.removeElem = function() {\n  this.element.parentNode.removeChild( this.element );\n  // remove display: none\n  this.css({ display: '' });\n  this.emitEvent( 'remove', [ this ] );\n};\n\nproto.remove = function() {\n  // just remove element if no transition support or no transition\n  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {\n    this.removeElem();\n    return;\n  }\n\n  // start transition\n  this.once( 'transitionEnd', function() {\n    this.removeElem();\n  });\n  this.hide();\n};\n\nproto.reveal = function() {\n  delete this.isHidden;\n  // remove display: none\n  this.css({ display: '' });\n\n  var options = this.layout.options;\n\n  var onTransitionEnd = {};\n  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');\n  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;\n\n  this.transition({\n    from: options.hiddenStyle,\n    to: options.visibleStyle,\n    isCleaning: true,\n    onTransitionEnd: onTransitionEnd\n  });\n};\n\nproto.onRevealTransitionEnd = function() {\n  // check if still visible\n  // during transition, item may have been hidden\n  if ( !this.isHidden ) {\n    this.emitEvent('reveal');\n  }\n};\n\n/**\n * get style property use for hide/reveal transition end\n * @param {String} styleProperty - hiddenStyle/visibleStyle\n * @returns {String}\n */\nproto.getHideRevealTransitionEndProperty = function( styleProperty ) {\n  var optionStyle = this.layout.options[ styleProperty ];\n  // use opacity\n  if ( optionStyle.opacity ) {\n    return 'opacity';\n  }\n  // get first property\n  for ( var prop in optionStyle ) {\n    return prop;\n  }\n};\n\nproto.hide = function() {\n  // set flag\n  this.isHidden = true;\n  // remove display: none\n  this.css({ display: '' });\n\n  var options = this.layout.options;\n\n  var onTransitionEnd = {};\n  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');\n  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;\n\n  this.transition({\n    from: options.visibleStyle,\n    to: options.hiddenStyle,\n    // keep hidden stuff hidden\n    isCleaning: true,\n    onTransitionEnd: onTransitionEnd\n  });\n};\n\nproto.onHideTransitionEnd = function() {\n  // check if still hidden\n  // during transition, item may have been un-hidden\n  if ( this.isHidden ) {\n    this.css({ display: 'none' });\n    this.emitEvent('hide');\n  }\n};\n\nproto.destroy = function() {\n  this.css({\n    position: '',\n    left: '',\n    right: '',\n    top: '',\n    bottom: '',\n    transition: '',\n    transform: ''\n  });\n};\n\nreturn Item;\n\n}));\n\n/*!\n * Outlayer v2.1.1\n * the brains and guts of a layout library\n * MIT license\n */\n\n( function( window, factory ) {\n  'use strict';\n  // universal module definition\n  /* jshint strict: false */ /* globals define, module, require */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD - RequireJS\n    define( 'outlayer/outlayer',[\n        'ev-emitter/ev-emitter',\n        'get-size/get-size',\n        'fizzy-ui-utils/utils',\n        './item'\n      ],\n      function( EvEmitter, getSize, utils, Item ) {\n        return factory( window, EvEmitter, getSize, utils, Item);\n      }\n    );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS - Browserify, Webpack\n    module.exports = factory(\n      window,\n      require('ev-emitter'),\n      require('get-size'),\n      require('fizzy-ui-utils'),\n      require('./item')\n    );\n  } else {\n    // browser global\n    window.Outlayer = factory(\n      window,\n      window.EvEmitter,\n      window.getSize,\n      window.fizzyUIUtils,\n      window.Outlayer.Item\n    );\n  }\n\n}( window, function factory( window, EvEmitter, getSize, utils, Item ) {\n'use strict';\n\n// ----- vars ----- //\n\nvar console = window.console;\nvar jQuery = window.jQuery;\nvar noop = function() {};\n\n// -------------------------- Outlayer -------------------------- //\n\n// globally unique identifiers\nvar GUID = 0;\n// internal store of all Outlayer intances\nvar instances = {};\n\n\n/**\n * @param {Element, String} element\n * @param {Object} options\n * @constructor\n */\nfunction Outlayer( element, options ) {\n  var queryElement = utils.getQueryElement( element );\n  if ( !queryElement ) {\n    if ( console ) {\n      console.error( 'Bad element for ' + this.constructor.namespace +\n        ': ' + ( queryElement || element ) );\n    }\n    return;\n  }\n  this.element = queryElement;\n  // add jQuery\n  if ( jQuery ) {\n    this.$element = jQuery( this.element );\n  }\n\n  // options\n  this.options = utils.extend( {}, this.constructor.defaults );\n  this.option( options );\n\n  // add id for Outlayer.getFromElement\n  var id = ++GUID;\n  this.element.outlayerGUID = id; // expando\n  instances[ id ] = this; // associate via id\n\n  // kick it off\n  this._create();\n\n  var isInitLayout = this._getOption('initLayout');\n  if ( isInitLayout ) {\n    this.layout();\n  }\n}\n\n// settings are for internal use only\nOutlayer.namespace = 'outlayer';\nOutlayer.Item = Item;\n\n// default options\nOutlayer.defaults = {\n  containerStyle: {\n    position: 'relative'\n  },\n  initLayout: true,\n  originLeft: true,\n  originTop: true,\n  resize: true,\n  resizeContainer: true,\n  // item options\n  transitionDuration: '0.4s',\n  hiddenStyle: {\n    opacity: 0,\n    transform: 'scale(0.001)'\n  },\n  visibleStyle: {\n    opacity: 1,\n    transform: 'scale(1)'\n  }\n};\n\nvar proto = Outlayer.prototype;\n// inherit EvEmitter\nutils.extend( proto, EvEmitter.prototype );\n\n/**\n * set options\n * @param {Object} opts\n */\nproto.option = function( opts ) {\n  utils.extend( this.options, opts );\n};\n\n/**\n * get backwards compatible option value, check old name\n */\nproto._getOption = function( option ) {\n  var oldOption = this.constructor.compatOptions[ option ];\n  return oldOption && this.options[ oldOption ] !== undefined ?\n    this.options[ oldOption ] : this.options[ option ];\n};\n\nOutlayer.compatOptions = {\n  // currentName: oldName\n  initLayout: 'isInitLayout',\n  horizontal: 'isHorizontal',\n  layoutInstant: 'isLayoutInstant',\n  originLeft: 'isOriginLeft',\n  originTop: 'isOriginTop',\n  resize: 'isResizeBound',\n  resizeContainer: 'isResizingContainer'\n};\n\nproto._create = function() {\n  // get items from children\n  this.reloadItems();\n  // elements that affect layout, but are not laid out\n  this.stamps = [];\n  this.stamp( this.options.stamp );\n  // set container style\n  utils.extend( this.element.style, this.options.containerStyle );\n\n  // bind resize method\n  var canBindResize = this._getOption('resize');\n  if ( canBindResize ) {\n    this.bindResize();\n  }\n};\n\n// goes through all children again and gets bricks in proper order\nproto.reloadItems = function() {\n  // collection of item elements\n  this.items = this._itemize( this.element.children );\n};\n\n\n/**\n * turn elements into Outlayer.Items to be used in layout\n * @param {Array or NodeList or HTMLElement} elems\n * @returns {Array} items - collection of new Outlayer Items\n */\nproto._itemize = function( elems ) {\n\n  var itemElems = this._filterFindItemElements( elems );\n  var Item = this.constructor.Item;\n\n  // create new Outlayer Items for collection\n  var items = [];\n  for ( var i=0; i < itemElems.length; i++ ) {\n    var elem = itemElems[i];\n    var item = new Item( elem, this );\n    items.push( item );\n  }\n\n  return items;\n};\n\n/**\n * get item elements to be used in layout\n * @param {Array or NodeList or HTMLElement} elems\n * @returns {Array} items - item elements\n */\nproto._filterFindItemElements = function( elems ) {\n  return utils.filterFindElements( elems, this.options.itemSelector );\n};\n\n/**\n * getter method for getting item elements\n * @returns {Array} elems - collection of item elements\n */\nproto.getItemElements = function() {\n  return this.items.map( function( item ) {\n    return item.element;\n  });\n};\n\n// ----- init & layout ----- //\n\n/**\n * lays out all items\n */\nproto.layout = function() {\n  this._resetLayout();\n  this._manageStamps();\n\n  // don't animate first layout\n  var layoutInstant = this._getOption('layoutInstant');\n  var isInstant = layoutInstant !== undefined ?\n    layoutInstant : !this._isLayoutInited;\n  this.layoutItems( this.items, isInstant );\n\n  // flag for initalized\n  this._isLayoutInited = true;\n};\n\n// _init is alias for layout\nproto._init = proto.layout;\n\n/**\n * logic before any new layout\n */\nproto._resetLayout = function() {\n  this.getSize();\n};\n\n\nproto.getSize = function() {\n  this.size = getSize( this.element );\n};\n\n/**\n * get measurement from option, for columnWidth, rowHeight, gutter\n * if option is String -> get element from selector string, & get size of element\n * if option is Element -> get size of element\n * else use option as a number\n *\n * @param {String} measurement\n * @param {String} size - width or height\n * @private\n */\nproto._getMeasurement = function( measurement, size ) {\n  var option = this.options[ measurement ];\n  var elem;\n  if ( !option ) {\n    // default to 0\n    this[ measurement ] = 0;\n  } else {\n    // use option as an element\n    if ( typeof option == 'string' ) {\n      elem = this.element.querySelector( option );\n    } else if ( option instanceof HTMLElement ) {\n      elem = option;\n    }\n    // use size of element, if element\n    this[ measurement ] = elem ? getSize( elem )[ size ] : option;\n  }\n};\n\n/**\n * layout a collection of item elements\n * @api public\n */\nproto.layoutItems = function( items, isInstant ) {\n  items = this._getItemsForLayout( items );\n\n  this._layoutItems( items, isInstant );\n\n  this._postLayout();\n};\n\n/**\n * get the items to be laid out\n * you may want to skip over some items\n * @param {Array} items\n * @returns {Array} items\n */\nproto._getItemsForLayout = function( items ) {\n  return items.filter( function( item ) {\n    return !item.isIgnored;\n  });\n};\n\n/**\n * layout items\n * @param {Array} items\n * @param {Boolean} isInstant\n */\nproto._layoutItems = function( items, isInstant ) {\n  this._emitCompleteOnItems( 'layout', items );\n\n  if ( !items || !items.length ) {\n    // no items, emit event with empty array\n    return;\n  }\n\n  var queue = [];\n\n  items.forEach( function( item ) {\n    // get x/y object from method\n    var position = this._getItemLayoutPosition( item );\n    // enqueue\n    position.item = item;\n    position.isInstant = isInstant || item.isLayoutInstant;\n    queue.push( position );\n  }, this );\n\n  this._processLayoutQueue( queue );\n};\n\n/**\n * get item layout position\n * @param {Outlayer.Item} item\n * @returns {Object} x and y position\n */\nproto._getItemLayoutPosition = function( /* item */ ) {\n  return {\n    x: 0,\n    y: 0\n  };\n};\n\n/**\n * iterate over array and position each item\n * Reason being - separating this logic prevents 'layout invalidation'\n * thx @paul_irish\n * @param {Array} queue\n */\nproto._processLayoutQueue = function( queue ) {\n  this.updateStagger();\n  queue.forEach( function( obj, i ) {\n    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );\n  }, this );\n};\n\n// set stagger from option in milliseconds number\nproto.updateStagger = function() {\n  var stagger = this.options.stagger;\n  if ( stagger === null || stagger === undefined ) {\n    this.stagger = 0;\n    return;\n  }\n  this.stagger = getMilliseconds( stagger );\n  return this.stagger;\n};\n\n/**\n * Sets position of item in DOM\n * @param {Outlayer.Item} item\n * @param {Number} x - horizontal position\n * @param {Number} y - vertical position\n * @param {Boolean} isInstant - disables transitions\n */\nproto._positionItem = function( item, x, y, isInstant, i ) {\n  if ( isInstant ) {\n    // if not transition, just set CSS\n    item.goTo( x, y );\n  } else {\n    item.stagger( i * this.stagger );\n    item.moveTo( x, y );\n  }\n};\n\n/**\n * Any logic you want to do after each layout,\n * i.e. size the container\n */\nproto._postLayout = function() {\n  this.resizeContainer();\n};\n\nproto.resizeContainer = function() {\n  var isResizingContainer = this._getOption('resizeContainer');\n  if ( !isResizingContainer ) {\n    return;\n  }\n  var size = this._getContainerSize();\n  if ( size ) {\n    this._setContainerMeasure( size.width, true );\n    this._setContainerMeasure( size.height, false );\n  }\n};\n\n/**\n * Sets width or height of container if returned\n * @returns {Object} size\n *   @param {Number} width\n *   @param {Number} height\n */\nproto._getContainerSize = noop;\n\n/**\n * @param {Number} measure - size of width or height\n * @param {Boolean} isWidth\n */\nproto._setContainerMeasure = function( measure, isWidth ) {\n  if ( measure === undefined ) {\n    return;\n  }\n\n  var elemSize = this.size;\n  // add padding and border width if border box\n  if ( elemSize.isBorderBox ) {\n    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +\n      elemSize.borderLeftWidth + elemSize.borderRightWidth :\n      elemSize.paddingBottom + elemSize.paddingTop +\n      elemSize.borderTopWidth + elemSize.borderBottomWidth;\n  }\n\n  measure = Math.max( measure, 0 );\n  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';\n};\n\n/**\n * emit eventComplete on a collection of items events\n * @param {String} eventName\n * @param {Array} items - Outlayer.Items\n */\nproto._emitCompleteOnItems = function( eventName, items ) {\n  var _this = this;\n  function onComplete() {\n    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );\n  }\n\n  var count = items.length;\n  if ( !items || !count ) {\n    onComplete();\n    return;\n  }\n\n  var doneCount = 0;\n  function tick() {\n    doneCount++;\n    if ( doneCount == count ) {\n      onComplete();\n    }\n  }\n\n  // bind callback\n  items.forEach( function( item ) {\n    item.once( eventName, tick );\n  });\n};\n\n/**\n * emits events via EvEmitter and jQuery events\n * @param {String} type - name of event\n * @param {Event} event - original event\n * @param {Array} args - extra arguments\n */\nproto.dispatchEvent = function( type, event, args ) {\n  // add original event to arguments\n  var emitArgs = event ? [ event ].concat( args ) : args;\n  this.emitEvent( type, emitArgs );\n\n  if ( jQuery ) {\n    // set this.$element\n    this.$element = this.$element || jQuery( this.element );\n    if ( event ) {\n      // create jQuery event\n      var $event = jQuery.Event( event );\n      $event.type = type;\n      this.$element.trigger( $event, args );\n    } else {\n      // just trigger with type if no event available\n      this.$element.trigger( type, args );\n    }\n  }\n};\n\n// -------------------------- ignore & stamps -------------------------- //\n\n\n/**\n * keep item in collection, but do not lay it out\n * ignored items do not get skipped in layout\n * @param {Element} elem\n */\nproto.ignore = function( elem ) {\n  var item = this.getItem( elem );\n  if ( item ) {\n    item.isIgnored = true;\n  }\n};\n\n/**\n * return item to layout collection\n * @param {Element} elem\n */\nproto.unignore = function( elem ) {\n  var item = this.getItem( elem );\n  if ( item ) {\n    delete item.isIgnored;\n  }\n};\n\n/**\n * adds elements to stamps\n * @param {NodeList, Array, Element, or String} elems\n */\nproto.stamp = function( elems ) {\n  elems = this._find( elems );\n  if ( !elems ) {\n    return;\n  }\n\n  this.stamps = this.stamps.concat( elems );\n  // ignore\n  elems.forEach( this.ignore, this );\n};\n\n/**\n * removes elements to stamps\n * @param {NodeList, Array, or Element} elems\n */\nproto.unstamp = function( elems ) {\n  elems = this._find( elems );\n  if ( !elems ){\n    return;\n  }\n\n  elems.forEach( function( elem ) {\n    // filter out removed stamp elements\n    utils.removeFrom( this.stamps, elem );\n    this.unignore( elem );\n  }, this );\n};\n\n/**\n * finds child elements\n * @param {NodeList, Array, Element, or String} elems\n * @returns {Array} elems\n */\nproto._find = function( elems ) {\n  if ( !elems ) {\n    return;\n  }\n  // if string, use argument as selector string\n  if ( typeof elems == 'string' ) {\n    elems = this.element.querySelectorAll( elems );\n  }\n  elems = utils.makeArray( elems );\n  return elems;\n};\n\nproto._manageStamps = function() {\n  if ( !this.stamps || !this.stamps.length ) {\n    return;\n  }\n\n  this._getBoundingRect();\n\n  this.stamps.forEach( this._manageStamp, this );\n};\n\n// update boundingLeft / Top\nproto._getBoundingRect = function() {\n  // get bounding rect for container element\n  var boundingRect = this.element.getBoundingClientRect();\n  var size = this.size;\n  this._boundingRect = {\n    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,\n    top: boundingRect.top + size.paddingTop + size.borderTopWidth,\n    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),\n    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )\n  };\n};\n\n/**\n * @param {Element} stamp\n**/\nproto._manageStamp = noop;\n\n/**\n * get x/y position of element relative to container element\n * @param {Element} elem\n * @returns {Object} offset - has left, top, right, bottom\n */\nproto._getElementOffset = function( elem ) {\n  var boundingRect = elem.getBoundingClientRect();\n  var thisRect = this._boundingRect;\n  var size = getSize( elem );\n  var offset = {\n    left: boundingRect.left - thisRect.left - size.marginLeft,\n    top: boundingRect.top - thisRect.top - size.marginTop,\n    right: thisRect.right - boundingRect.right - size.marginRight,\n    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom\n  };\n  return offset;\n};\n\n// -------------------------- resize -------------------------- //\n\n// enable event handlers for listeners\n// i.e. resize -> onresize\nproto.handleEvent = utils.handleEvent;\n\n/**\n * Bind layout to window resizing\n */\nproto.bindResize = function() {\n  window.addEventListener( 'resize', this );\n  this.isResizeBound = true;\n};\n\n/**\n * Unbind layout to window resizing\n */\nproto.unbindResize = function() {\n  window.removeEventListener( 'resize', this );\n  this.isResizeBound = false;\n};\n\nproto.onresize = function() {\n  this.resize();\n};\n\nutils.debounceMethod( Outlayer, 'onresize', 100 );\n\nproto.resize = function() {\n  // don't trigger if size did not change\n  // or if resize was unbound. See #9\n  if ( !this.isResizeBound || !this.needsResizeLayout() ) {\n    return;\n  }\n\n  this.layout();\n};\n\n/**\n * check if layout is needed post layout\n * @returns Boolean\n */\nproto.needsResizeLayout = function() {\n  var size = getSize( this.element );\n  // check that this.size and size are there\n  // IE8 triggers resize on body size change, so they might not be\n  var hasSizes = this.size && size;\n  return hasSizes && size.innerWidth !== this.size.innerWidth;\n};\n\n// -------------------------- methods -------------------------- //\n\n/**\n * add items to Outlayer instance\n * @param {Array or NodeList or Element} elems\n * @returns {Array} items - Outlayer.Items\n**/\nproto.addItems = function( elems ) {\n  var items = this._itemize( elems );\n  // add items to collection\n  if ( items.length ) {\n    this.items = this.items.concat( items );\n  }\n  return items;\n};\n\n/**\n * Layout newly-appended item elements\n * @param {Array or NodeList or Element} elems\n */\nproto.appended = function( elems ) {\n  var items = this.addItems( elems );\n  if ( !items.length ) {\n    return;\n  }\n  // layout and reveal just the new items\n  this.layoutItems( items, true );\n  this.reveal( items );\n};\n\n/**\n * Layout prepended elements\n * @param {Array or NodeList or Element} elems\n */\nproto.prepended = function( elems ) {\n  var items = this._itemize( elems );\n  if ( !items.length ) {\n    return;\n  }\n  // add items to beginning of collection\n  var previousItems = this.items.slice(0);\n  this.items = items.concat( previousItems );\n  // start new layout\n  this._resetLayout();\n  this._manageStamps();\n  // layout new stuff without transition\n  this.layoutItems( items, true );\n  this.reveal( items );\n  // layout previous items\n  this.layoutItems( previousItems );\n};\n\n/**\n * reveal a collection of items\n * @param {Array of Outlayer.Items} items\n */\nproto.reveal = function( items ) {\n  this._emitCompleteOnItems( 'reveal', items );\n  if ( !items || !items.length ) {\n    return;\n  }\n  var stagger = this.updateStagger();\n  items.forEach( function( item, i ) {\n    item.stagger( i * stagger );\n    item.reveal();\n  });\n};\n\n/**\n * hide a collection of items\n * @param {Array of Outlayer.Items} items\n */\nproto.hide = function( items ) {\n  this._emitCompleteOnItems( 'hide', items );\n  if ( !items || !items.length ) {\n    return;\n  }\n  var stagger = this.updateStagger();\n  items.forEach( function( item, i ) {\n    item.stagger( i * stagger );\n    item.hide();\n  });\n};\n\n/**\n * reveal item elements\n * @param {Array}, {Element}, {NodeList} items\n */\nproto.revealItemElements = function( elems ) {\n  var items = this.getItems( elems );\n  this.reveal( items );\n};\n\n/**\n * hide item elements\n * @param {Array}, {Element}, {NodeList} items\n */\nproto.hideItemElements = function( elems ) {\n  var items = this.getItems( elems );\n  this.hide( items );\n};\n\n/**\n * get Outlayer.Item, given an Element\n * @param {Element} elem\n * @param {Function} callback\n * @returns {Outlayer.Item} item\n */\nproto.getItem = function( elem ) {\n  // loop through items to get the one that matches\n  for ( var i=0; i < this.items.length; i++ ) {\n    var item = this.items[i];\n    if ( item.element == elem ) {\n      // return item\n      return item;\n    }\n  }\n};\n\n/**\n * get collection of Outlayer.Items, given Elements\n * @param {Array} elems\n * @returns {Array} items - Outlayer.Items\n */\nproto.getItems = function( elems ) {\n  elems = utils.makeArray( elems );\n  var items = [];\n  elems.forEach( function( elem ) {\n    var item = this.getItem( elem );\n    if ( item ) {\n      items.push( item );\n    }\n  }, this );\n\n  return items;\n};\n\n/**\n * remove element(s) from instance and DOM\n * @param {Array or NodeList or Element} elems\n */\nproto.remove = function( elems ) {\n  var removeItems = this.getItems( elems );\n\n  this._emitCompleteOnItems( 'remove', removeItems );\n\n  // bail if no items to remove\n  if ( !removeItems || !removeItems.length ) {\n    return;\n  }\n\n  removeItems.forEach( function( item ) {\n    item.remove();\n    // remove item from collection\n    utils.removeFrom( this.items, item );\n  }, this );\n};\n\n// ----- destroy ----- //\n\n// remove and disable Outlayer instance\nproto.destroy = function() {\n  // clean up dynamic styles\n  var style = this.element.style;\n  style.height = '';\n  style.position = '';\n  style.width = '';\n  // destroy items\n  this.items.forEach( function( item ) {\n    item.destroy();\n  });\n\n  this.unbindResize();\n\n  var id = this.element.outlayerGUID;\n  delete instances[ id ]; // remove reference to instance by id\n  delete this.element.outlayerGUID;\n  // remove data for jQuery\n  if ( jQuery ) {\n    jQuery.removeData( this.element, this.constructor.namespace );\n  }\n\n};\n\n// -------------------------- data -------------------------- //\n\n/**\n * get Outlayer instance from element\n * @param {Element} elem\n * @returns {Outlayer}\n */\nOutlayer.data = function( elem ) {\n  elem = utils.getQueryElement( elem );\n  var id = elem && elem.outlayerGUID;\n  return id && instances[ id ];\n};\n\n\n// -------------------------- create Outlayer class -------------------------- //\n\n/**\n * create a layout class\n * @param {String} namespace\n */\nOutlayer.create = function( namespace, options ) {\n  // sub-class Outlayer\n  var Layout = subclass( Outlayer );\n  // apply new options and compatOptions\n  Layout.defaults = utils.extend( {}, Outlayer.defaults );\n  utils.extend( Layout.defaults, options );\n  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );\n\n  Layout.namespace = namespace;\n\n  Layout.data = Outlayer.data;\n\n  // sub-class Item\n  Layout.Item = subclass( Item );\n\n  // -------------------------- declarative -------------------------- //\n\n  utils.htmlInit( Layout, namespace );\n\n  // -------------------------- jQuery bridge -------------------------- //\n\n  // make into jQuery plugin\n  if ( jQuery && jQuery.bridget ) {\n    jQuery.bridget( namespace, Layout );\n  }\n\n  return Layout;\n};\n\nfunction subclass( Parent ) {\n  function SubClass() {\n    Parent.apply( this, arguments );\n  }\n\n  SubClass.prototype = Object.create( Parent.prototype );\n  SubClass.prototype.constructor = SubClass;\n\n  return SubClass;\n}\n\n// ----- helpers ----- //\n\n// how many milliseconds are in each unit\nvar msUnits = {\n  ms: 1,\n  s: 1000\n};\n\n// munge time-like parameter into millisecond number\n// '0.4s' -> 40\nfunction getMilliseconds( time ) {\n  if ( typeof time == 'number' ) {\n    return time;\n  }\n  var matches = time.match( /(^\\d*\\.?\\d*)(\\w*)/ );\n  var num = matches && matches[1];\n  var unit = matches && matches[2];\n  if ( !num.length ) {\n    return 0;\n  }\n  num = parseFloat( num );\n  var mult = msUnits[ unit ] || 1;\n  return num * mult;\n}\n\n// ----- fin ----- //\n\n// back in global\nOutlayer.Item = Item;\n\nreturn Outlayer;\n\n}));\n\n/*!\n * Masonry v4.2.2\n * Cascading grid layout library\n * https://masonry.desandro.com\n * MIT License\n * by David DeSandro\n */\n\n( function( window, factory ) {\n  // universal module definition\n  /* jshint strict: false */ /*globals define, module, require */\n  if ( typeof define == 'function' && define.amd ) {\n    // AMD\n    define( [\n        'outlayer/outlayer',\n        'get-size/get-size'\n      ],\n      factory );\n  } else if ( typeof module == 'object' && module.exports ) {\n    // CommonJS\n    module.exports = factory(\n      require('outlayer'),\n      require('get-size')\n    );\n  } else {\n    // browser global\n    window.Masonry = factory(\n      window.Outlayer,\n      window.getSize\n    );\n  }\n\n}( window, function factory( Outlayer, getSize ) {\n\n\n\n// -------------------------- masonryDefinition -------------------------- //\n\n  // create an Outlayer layout class\n  var Masonry = Outlayer.create('masonry');\n  // isFitWidth -> fitWidth\n  Masonry.compatOptions.fitWidth = 'isFitWidth';\n\n  var proto = Masonry.prototype;\n\n  proto._resetLayout = function() {\n    this.getSize();\n    this._getMeasurement( 'columnWidth', 'outerWidth' );\n    this._getMeasurement( 'gutter', 'outerWidth' );\n    this.measureColumns();\n\n    // reset column Y\n    this.colYs = [];\n    for ( var i=0; i < this.cols; i++ ) {\n      this.colYs.push( 0 );\n    }\n\n    this.maxY = 0;\n    this.horizontalColIndex = 0;\n  };\n\n  proto.measureColumns = function() {\n    this.getContainerWidth();\n    // if columnWidth is 0, default to outerWidth of first item\n    if ( !this.columnWidth ) {\n      var firstItem = this.items[0];\n      var firstItemElem = firstItem && firstItem.element;\n      // columnWidth fall back to item of first element\n      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||\n        // if first elem has no width, default to size of container\n        this.containerWidth;\n    }\n\n    var columnWidth = this.columnWidth += this.gutter;\n\n    // calculate columns\n    var containerWidth = this.containerWidth + this.gutter;\n    var cols = containerWidth / columnWidth;\n    // fix rounding errors, typically with gutters\n    var excess = columnWidth - containerWidth % columnWidth;\n    // if overshoot is less than a pixel, round up, otherwise floor it\n    var mathMethod = excess && excess < 1 ? 'round' : 'floor';\n    cols = Math[ mathMethod ]( cols );\n    this.cols = Math.max( cols, 1 );\n  };\n\n  proto.getContainerWidth = function() {\n    // container is parent if fit width\n    var isFitWidth = this._getOption('fitWidth');\n    var container = isFitWidth ? this.element.parentNode : this.element;\n    // check that this.size and size are there\n    // IE8 triggers resize on body size change, so they might not be\n    var size = getSize( container );\n    this.containerWidth = size && size.innerWidth;\n  };\n\n  proto._getItemLayoutPosition = function( item ) {\n    item.getSize();\n    // how many columns does this brick span\n    var remainder = item.size.outerWidth % this.columnWidth;\n    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';\n    // round if off by 1 pixel, otherwise use ceil\n    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );\n    colSpan = Math.min( colSpan, this.cols );\n    // use horizontal or top column position\n    var colPosMethod = this.options.horizontalOrder ?\n      '_getHorizontalColPosition' : '_getTopColPosition';\n    var colPosition = this[ colPosMethod ]( colSpan, item );\n    // position the brick\n    var position = {\n      x: this.columnWidth * colPosition.col,\n      y: colPosition.y\n    };\n    // apply setHeight to necessary columns\n    var setHeight = colPosition.y + item.size.outerHeight;\n    var setMax = colSpan + colPosition.col;\n    for ( var i = colPosition.col; i < setMax; i++ ) {\n      this.colYs[i] = setHeight;\n    }\n\n    return position;\n  };\n\n  proto._getTopColPosition = function( colSpan ) {\n    var colGroup = this._getTopColGroup( colSpan );\n    // get the minimum Y value from the columns\n    var minimumY = Math.min.apply( Math, colGroup );\n\n    return {\n      col: colGroup.indexOf( minimumY ),\n      y: minimumY,\n    };\n  };\n\n  /**\n   * @param {Number} colSpan - number of columns the element spans\n   * @returns {Array} colGroup\n   */\n  proto._getTopColGroup = function( colSpan ) {\n    if ( colSpan < 2 ) {\n      // if brick spans only one column, use all the column Ys\n      return this.colYs;\n    }\n\n    var colGroup = [];\n    // how many different places could this brick fit horizontally\n    var groupCount = this.cols + 1 - colSpan;\n    // for each group potential horizontal position\n    for ( var i = 0; i < groupCount; i++ ) {\n      colGroup[i] = this._getColGroupY( i, colSpan );\n    }\n    return colGroup;\n  };\n\n  proto._getColGroupY = function( col, colSpan ) {\n    if ( colSpan < 2 ) {\n      return this.colYs[ col ];\n    }\n    // make an array of colY values for that one group\n    var groupColYs = this.colYs.slice( col, col + colSpan );\n    // and get the max value of the array\n    return Math.max.apply( Math, groupColYs );\n  };\n\n  // get column position based on horizontal index. #873\n  proto._getHorizontalColPosition = function( colSpan, item ) {\n    var col = this.horizontalColIndex % this.cols;\n    var isOver = colSpan > 1 && col + colSpan > this.cols;\n    // shift to next row if item can't fit on current row\n    col = isOver ? 0 : col;\n    // don't let zero-size items take up space\n    var hasSize = item.size.outerWidth && item.size.outerHeight;\n    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;\n\n    return {\n      col: col,\n      y: this._getColGroupY( col, colSpan ),\n    };\n  };\n\n  proto._manageStamp = function( stamp ) {\n    var stampSize = getSize( stamp );\n    var offset = this._getElementOffset( stamp );\n    // get the columns that this stamp affects\n    var isOriginLeft = this._getOption('originLeft');\n    var firstX = isOriginLeft ? offset.left : offset.right;\n    var lastX = firstX + stampSize.outerWidth;\n    var firstCol = Math.floor( firstX / this.columnWidth );\n    firstCol = Math.max( 0, firstCol );\n    var lastCol = Math.floor( lastX / this.columnWidth );\n    // lastCol should not go over if multiple of columnWidth #425\n    lastCol -= lastX % this.columnWidth ? 0 : 1;\n    lastCol = Math.min( this.cols - 1, lastCol );\n    // set colYs to bottom of the stamp\n\n    var isOriginTop = this._getOption('originTop');\n    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +\n      stampSize.outerHeight;\n    for ( var i = firstCol; i <= lastCol; i++ ) {\n      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );\n    }\n  };\n\n  proto._getContainerSize = function() {\n    this.maxY = Math.max.apply( Math, this.colYs );\n    var size = {\n      height: this.maxY\n    };\n\n    if ( this._getOption('fitWidth') ) {\n      size.width = this._getContainerFitWidth();\n    }\n\n    return size;\n  };\n\n  proto._getContainerFitWidth = function() {\n    var unusedCols = 0;\n    // count unused columns\n    var i = this.cols;\n    while ( --i ) {\n      if ( this.colYs[i] !== 0 ) {\n        break;\n      }\n      unusedCols++;\n    }\n    // fit container to columns that have been used\n    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;\n  };\n\n  proto.needsResizeLayout = function() {\n    var previousWidth = this.containerWidth;\n    this.getContainerWidth();\n    return previousWidth != this.containerWidth;\n  };\n\n  return Masonry;\n\n}));\n\n"

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(504))

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = "/*\n * jQuery.counter plugin\n *\n * Copyright (c) 2012 Sophilabs <hi@sophilabs.com>\n * MIT License\n */\n \n!(function (context, definition) {\n  if (typeof define == 'function' && typeof define.amd  == 'object') define(['jquery'], definition);\n  else definition(context['$']);\n}(this, function ($) {\n\n    var checkStop = function(data) {\n        var stop = 0;\n        var current = 0;\n        $.each(data.parts, function(i, part) {\n            stop += (stop * part.limit) + part.stop;\n            current += (current * part.limit) + part.value;\n        });\n        return data.down ? stop >= current : stop <= current;\n    };\n\n    var tick = function() {\n        var e = $(this);\n        var data = e.data('counter');\n        var i = data.parts.length - 1;\n        while(i >= 0) {\n            var part = data.parts[i];\n            part.value += data.down ? -1 : 1;\n            if (data.down && part.value < 0) {\n                part.value = part.limit;\n            } else if (!data.down && part.value > part.limit) {\n                part.value = 0;\n            } else {\n                break;\n            }\n            i--;\n        }\n        refresh(e, i);\n        if (checkStop(data)) {\n            clearInterval(data.intervalId);\n            e.trigger(\"counterStop\");\n        }\n    };\n\n    var refresh = function(e, to) {\n        var data = e.data('counter');\n        var i = data.parts.length - 1;\n        var animateIJ = function(j, digit) {\n            animate(e, i, j, digit);\n        };\n        while (i >= to) {\n            var part = data.parts[i];\n            var digits = part.value + '';\n            while (digits.length < part.padding) {\n                digits = '0' + digits;\n            }\n            $.each(split(digits, ''), animateIJ);\n            i--;\n        }\n    };\n\n    var animate = function(e, ipart, idigit, digit) {\n        var edigit = $($(e.children('span.part').get(ipart)).find('span.digit').get(idigit));\n        edigit.attr('class', 'digit digit' + digit +  ' digit' + edigit.text() + digit).text(digit);\n    };\n\n    //from http://blog.stevenlevithan.com/archives/cross-browser-split\n    var split = function(undef) {\n\n        var nativeSplit = String.prototype.split,\n            compliantExecNpcg = /()??/.exec(\"\")[1] === undef, // NPCG: nonparticipating capturing group\n            self;\n\n        self = function (str, separator, limit) {\n            // If `separator` is not a regex, use `nativeSplit`\n            if (Object.prototype.toString.call(separator) !== \"[object RegExp]\") {\n                return nativeSplit.call(str, separator, limit);\n            }\n            var output = [],\n                flags = (separator.ignoreCase ? \"i\" : \"\") +\n                        (separator.multiline  ? \"m\" : \"\") +\n                        (separator.extended   ? \"x\" : \"\") + // Proposed for ES6\n                        (separator.sticky     ? \"y\" : \"\"), // Firefox 3+\n                lastLastIndex = 0,\n                // Make `global` and avoid `lastIndex` issues by working with a copy\n                separator = new RegExp(separator.source, flags + \"g\"),\n                separator2, match, lastIndex, lastLength;\n            str += \"\"; // Type-convert\n            if (!compliantExecNpcg) {\n                // Doesn't need flags gy, but they don't hurt\n                separator2 = new RegExp(\"^\" + separator.source + \"$(?!\\\\s)\", flags);\n            }\n            /* Values for `limit`, per the spec:\n             * If undefined: 4294967295 // Math.pow(2, 32) - 1\n             * If 0, Infinity, or NaN: 0\n             * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;\n             * If negative number: 4294967296 - Math.floor(Math.abs(limit))\n             * If other: Type-convert, then use the above rules\n             */\n            limit = limit === undef ?\n                -1 >>> 0 : // Math.pow(2, 32) - 1\n                limit >>> 0; // ToUint32(limit)\n            while (match = separator.exec(str)) {\n                // `separator.lastIndex` is not reliable cross-browser\n                lastIndex = match.index + match[0].length;\n                if (lastIndex > lastLastIndex) {\n                    output.push(str.slice(lastLastIndex, match.index));\n                    // Fix browsers whose `exec` methods don't consistently return `undefined` for\n                    // nonparticipating capturing groups\n                    if (!compliantExecNpcg && match.length > 1) {\n                        match[0].replace(separator2, function () {\n                            for (var i = 1; i < arguments.length - 2; i++) {\n                                if (arguments[i] === undef) {\n                                    match[i] = undef;\n                                }\n                            }\n                        });\n                    }\n                    if (match.length > 1 && match.index < str.length) {\n                        Array.prototype.push.apply(output, match.slice(1));\n                    }\n                    lastLength = match[0].length;\n                    lastLastIndex = lastIndex;\n                    if (output.length >= limit) {\n                        break;\n                    }\n                }\n                if (separator.lastIndex === match.index) {\n                    separator.lastIndex++; // Avoid an infinite loop\n                }\n            }\n            if (lastLastIndex === str.length) {\n                if (lastLength || !separator.test(\"\")) {\n                    output.push(\"\");\n                }\n            } else {\n                output.push(str.slice(lastLastIndex));\n            }\n            return output.length > limit ? output.slice(0, limit) : output;\n        };\n        return self;\n    }();\n\n    var methods = {\n        init: function(options) {\n            options = options || {};\n            return this.each(function() {\n                var e = $(this);\n                var data = e.data('counter') || {};\n                data.interval = parseInt(options.interval || e.attr('data-interval') || '1000', 10);\n                data.down = (options.direction || e.attr('data-direction') || 'down') == 'down';\n                data.parts = [];\n                var initial = split(options.initial || e.text(), /([^0-9]+)/);\n                //WARN: Use attr() no data()\n                var format = split(options.format || e.attr('data-format') || \"23:59:59\", /([^0-9]+)/);\n                var stop =  options.stop || e.attr('data-stop');\n                if (stop) {\n                    stop = split(stop, /([^0-9]+)/);\n                }\n                e.html('');\n                $.each(format, function(index, value) {\n                    if (/^\\d+$/.test(value)) {\n                        var part = {};\n                        part.index = index;\n                        part.padding = (value + '').length;\n                        part.limit = parseInt(value, 10);\n                        part.value = parseInt(initial[initial.length - format.length + index] || 0, 10);\n                        part.value = part.value > part.limit ? part.limit : part.value;\n                        part.reset = part.value;\n                        part.stop = parseInt(stop ? stop[stop.length - format.length + index] : (data.down ? 0 : part.limit), 10);\n                        part.stop = part.stop > part.limit ? part.limit : part.stop;\n                        part.stop = part.stop < 0 ? 0 : part.stop;\n                        var epart = $('<span>').addClass('part').addClass('part' + index);\n                        var digits = part.value + '';\n                        while (digits.length < part.padding) {\n                            digits = '0' + digits;\n                        }\n                        $.each(split(digits, ''), function(dindex, dvalue){\n                            epart.append($('<span>').addClass('digit digit' + dvalue).text(dvalue));\n                        });\n                        e.append(epart);\n                        data.parts.push(part);\n                    } else {\n                        e.append($('<span>').addClass('separator').addClass('separator' + index).text(value));\n                    }\n                });\n                if (!checkStop(data)) {\n                    data.intervalId = setInterval($.proxy(tick, this), data.interval);\n                } else {\n                    e.trigger(\"counterStop\");\n                }\n                e.data('counter', data);\n                return this;\n            });\n        },\n        play: function() {\n            return this.each(function() {\n                var e = $(this);\n                var data = e.data('counter');\n                if (!data.intervalId) {\n                    data.intervalId = setInterval($.proxy(tick, this), data.interval);\n                }\n            });\n        },\n        reset: function() {\n            return this.each(function() {\n                var e = $(this);\n                var data = e.data('counter');\n                $.each(data.parts, function(pindex, pvalue){\n                    pvalue.value = pvalue.reset;\n                });\n                refresh($(this), 0);\n                if (data.intervalId) {\n                    clearInterval(data.intervalId);\n                    data.intervalId = setInterval($.proxy(tick, this), data.interval);\n                }\n            });\n        },\n        stop: function() {\n            return this.each(function() {\n                var e = $(this);\n                var data = e.data('counter');\n                clearInterval(data.intervalId);\n                data.intervalId = 0;\n                e.trigger(\"counterStop\");\n            });\n        }\n    };\n\n    $.fn.counter = function(method) {\n        // Method calling logic\n        if (methods[method]) {\n            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));\n        } else if (typeof method === 'object' || ! method) {\n            return methods.init.apply(this, arguments);\n        } else {\n            $.error('Method ' +  method + ' does not exist on jQuery.counter');\n        }\n    };\n\n}));\n"

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(506))

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = "(function(f){if(typeof exports===\"object\"&&typeof module!==\"undefined\"){module.exports=f()}else if(typeof define===\"function\"&&define.amd){define([],f)}else{var g;if(typeof window!==\"undefined\"){g=window}else if(typeof global!==\"undefined\"){g=global}else if(typeof self!==\"undefined\"){g=self}else{g=this}g.io = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require==\"function\"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error(\"Cannot find module '\"+o+\"'\");throw f.code=\"MODULE_NOT_FOUND\",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require==\"function\"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){\n\nmodule.exports =  _dereq_('./lib/');\n\n},{\"./lib/\":2}],2:[function(_dereq_,module,exports){\n\nmodule.exports = _dereq_('./socket');\n\n/**\n * Exports parser\n *\n * @api public\n *\n */\nmodule.exports.parser = _dereq_('engine.io-parser');\n\n},{\"./socket\":3,\"engine.io-parser\":19}],3:[function(_dereq_,module,exports){\n(function (global){\n/**\n * Module dependencies.\n */\n\nvar transports = _dereq_('./transports');\nvar Emitter = _dereq_('component-emitter');\nvar debug = _dereq_('debug')('engine.io-client:socket');\nvar index = _dereq_('indexof');\nvar parser = _dereq_('engine.io-parser');\nvar parseuri = _dereq_('parseuri');\nvar parsejson = _dereq_('parsejson');\nvar parseqs = _dereq_('parseqs');\n\n/**\n * Module exports.\n */\n\nmodule.exports = Socket;\n\n/**\n * Noop function.\n *\n * @api private\n */\n\nfunction noop(){}\n\n/**\n * Socket constructor.\n *\n * @param {String|Object} uri or options\n * @param {Object} options\n * @api public\n */\n\nfunction Socket(uri, opts){\n  if (!(this instanceof Socket)) return new Socket(uri, opts);\n\n  opts = opts || {};\n\n  if (uri && 'object' == typeof uri) {\n    opts = uri;\n    uri = null;\n  }\n\n  if (uri) {\n    uri = parseuri(uri);\n    opts.hostname = uri.host;\n    opts.secure = uri.protocol == 'https' || uri.protocol == 'wss';\n    opts.port = uri.port;\n    if (uri.query) opts.query = uri.query;\n  } else if (opts.host) {\n    opts.hostname = parseuri(opts.host).host;\n  }\n\n  this.secure = null != opts.secure ? opts.secure :\n    (global.location && 'https:' == location.protocol);\n\n  if (opts.hostname && !opts.port) {\n    // if no port is specified manually, use the protocol default\n    opts.port = this.secure ? '443' : '80';\n  }\n\n  this.agent = opts.agent || false;\n  this.hostname = opts.hostname ||\n    (global.location ? location.hostname : 'localhost');\n  this.port = opts.port || (global.location && location.port ?\n       location.port :\n       (this.secure ? 443 : 80));\n  this.query = opts.query || {};\n  if ('string' == typeof this.query) this.query = parseqs.decode(this.query);\n  this.upgrade = false !== opts.upgrade;\n  this.path = (opts.path || '/engine.io').replace(/\\/$/, '') + '/';\n  this.forceJSONP = !!opts.forceJSONP;\n  this.jsonp = false !== opts.jsonp;\n  this.forceBase64 = !!opts.forceBase64;\n  this.enablesXDR = !!opts.enablesXDR;\n  this.timestampParam = opts.timestampParam || 't';\n  this.timestampRequests = opts.timestampRequests;\n  this.transports = opts.transports || ['polling', 'websocket'];\n  this.readyState = '';\n  this.writeBuffer = [];\n  this.policyPort = opts.policyPort || 843;\n  this.rememberUpgrade = opts.rememberUpgrade || false;\n  this.binaryType = null;\n  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;\n  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;\n\n  if (true === this.perMessageDeflate) this.perMessageDeflate = {};\n  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {\n    this.perMessageDeflate.threshold = 1024;\n  }\n\n  // SSL options for Node.js client\n  this.pfx = opts.pfx || null;\n  this.key = opts.key || null;\n  this.passphrase = opts.passphrase || null;\n  this.cert = opts.cert || null;\n  this.ca = opts.ca || null;\n  this.ciphers = opts.ciphers || null;\n  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;\n\n  // other options for Node.js client\n  var freeGlobal = typeof global == 'object' && global;\n  if (freeGlobal.global === freeGlobal) {\n    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {\n      this.extraHeaders = opts.extraHeaders;\n    }\n  }\n\n  this.open();\n}\n\nSocket.priorWebsocketSuccess = false;\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Socket.prototype);\n\n/**\n * Protocol version.\n *\n * @api public\n */\n\nSocket.protocol = parser.protocol; // this is an int\n\n/**\n * Expose deps for legacy compatibility\n * and standalone browser access.\n */\n\nSocket.Socket = Socket;\nSocket.Transport = _dereq_('./transport');\nSocket.transports = _dereq_('./transports');\nSocket.parser = _dereq_('engine.io-parser');\n\n/**\n * Creates transport of the given type.\n *\n * @param {String} transport name\n * @return {Transport}\n * @api private\n */\n\nSocket.prototype.createTransport = function (name) {\n  debug('creating transport \"%s\"', name);\n  var query = clone(this.query);\n\n  // append engine.io protocol identifier\n  query.EIO = parser.protocol;\n\n  // transport name\n  query.transport = name;\n\n  // session id if we already have one\n  if (this.id) query.sid = this.id;\n\n  var transport = new transports[name]({\n    agent: this.agent,\n    hostname: this.hostname,\n    port: this.port,\n    secure: this.secure,\n    path: this.path,\n    query: query,\n    forceJSONP: this.forceJSONP,\n    jsonp: this.jsonp,\n    forceBase64: this.forceBase64,\n    enablesXDR: this.enablesXDR,\n    timestampRequests: this.timestampRequests,\n    timestampParam: this.timestampParam,\n    policyPort: this.policyPort,\n    socket: this,\n    pfx: this.pfx,\n    key: this.key,\n    passphrase: this.passphrase,\n    cert: this.cert,\n    ca: this.ca,\n    ciphers: this.ciphers,\n    rejectUnauthorized: this.rejectUnauthorized,\n    perMessageDeflate: this.perMessageDeflate,\n    extraHeaders: this.extraHeaders\n  });\n\n  return transport;\n};\n\nfunction clone (obj) {\n  var o = {};\n  for (var i in obj) {\n    if (obj.hasOwnProperty(i)) {\n      o[i] = obj[i];\n    }\n  }\n  return o;\n}\n\n/**\n * Initializes transport to use and starts probe.\n *\n * @api private\n */\nSocket.prototype.open = function () {\n  var transport;\n  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') != -1) {\n    transport = 'websocket';\n  } else if (0 === this.transports.length) {\n    // Emit error on next tick so it can be listened to\n    var self = this;\n    setTimeout(function() {\n      self.emit('error', 'No transports available');\n    }, 0);\n    return;\n  } else {\n    transport = this.transports[0];\n  }\n  this.readyState = 'opening';\n\n  // Retry with the next transport if the transport is disabled (jsonp: false)\n  try {\n    transport = this.createTransport(transport);\n  } catch (e) {\n    this.transports.shift();\n    this.open();\n    return;\n  }\n\n  transport.open();\n  this.setTransport(transport);\n};\n\n/**\n * Sets the current transport. Disables the existing one (if any).\n *\n * @api private\n */\n\nSocket.prototype.setTransport = function(transport){\n  debug('setting transport %s', transport.name);\n  var self = this;\n\n  if (this.transport) {\n    debug('clearing existing transport %s', this.transport.name);\n    this.transport.removeAllListeners();\n  }\n\n  // set up transport\n  this.transport = transport;\n\n  // set up transport listeners\n  transport\n  .on('drain', function(){\n    self.onDrain();\n  })\n  .on('packet', function(packet){\n    self.onPacket(packet);\n  })\n  .on('error', function(e){\n    self.onError(e);\n  })\n  .on('close', function(){\n    self.onClose('transport close');\n  });\n};\n\n/**\n * Probes a transport.\n *\n * @param {String} transport name\n * @api private\n */\n\nSocket.prototype.probe = function (name) {\n  debug('probing transport \"%s\"', name);\n  var transport = this.createTransport(name, { probe: 1 })\n    , failed = false\n    , self = this;\n\n  Socket.priorWebsocketSuccess = false;\n\n  function onTransportOpen(){\n    if (self.onlyBinaryUpgrades) {\n      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;\n      failed = failed || upgradeLosesBinary;\n    }\n    if (failed) return;\n\n    debug('probe transport \"%s\" opened', name);\n    transport.send([{ type: 'ping', data: 'probe' }]);\n    transport.once('packet', function (msg) {\n      if (failed) return;\n      if ('pong' == msg.type && 'probe' == msg.data) {\n        debug('probe transport \"%s\" pong', name);\n        self.upgrading = true;\n        self.emit('upgrading', transport);\n        if (!transport) return;\n        Socket.priorWebsocketSuccess = 'websocket' == transport.name;\n\n        debug('pausing current transport \"%s\"', self.transport.name);\n        self.transport.pause(function () {\n          if (failed) return;\n          if ('closed' == self.readyState) return;\n          debug('changing transport and sending upgrade packet');\n\n          cleanup();\n\n          self.setTransport(transport);\n          transport.send([{ type: 'upgrade' }]);\n          self.emit('upgrade', transport);\n          transport = null;\n          self.upgrading = false;\n          self.flush();\n        });\n      } else {\n        debug('probe transport \"%s\" failed', name);\n        var err = new Error('probe error');\n        err.transport = transport.name;\n        self.emit('upgradeError', err);\n      }\n    });\n  }\n\n  function freezeTransport() {\n    if (failed) return;\n\n    // Any callback called by transport should be ignored since now\n    failed = true;\n\n    cleanup();\n\n    transport.close();\n    transport = null;\n  }\n\n  //Handle any error that happens while probing\n  function onerror(err) {\n    var error = new Error('probe error: ' + err);\n    error.transport = transport.name;\n\n    freezeTransport();\n\n    debug('probe transport \"%s\" failed because of error: %s', name, err);\n\n    self.emit('upgradeError', error);\n  }\n\n  function onTransportClose(){\n    onerror(\"transport closed\");\n  }\n\n  //When the socket is closed while we're probing\n  function onclose(){\n    onerror(\"socket closed\");\n  }\n\n  //When the socket is upgraded while we're probing\n  function onupgrade(to){\n    if (transport && to.name != transport.name) {\n      debug('\"%s\" works - aborting \"%s\"', to.name, transport.name);\n      freezeTransport();\n    }\n  }\n\n  //Remove all listeners on the transport and on self\n  function cleanup(){\n    transport.removeListener('open', onTransportOpen);\n    transport.removeListener('error', onerror);\n    transport.removeListener('close', onTransportClose);\n    self.removeListener('close', onclose);\n    self.removeListener('upgrading', onupgrade);\n  }\n\n  transport.once('open', onTransportOpen);\n  transport.once('error', onerror);\n  transport.once('close', onTransportClose);\n\n  this.once('close', onclose);\n  this.once('upgrading', onupgrade);\n\n  transport.open();\n\n};\n\n/**\n * Called when connection is deemed open.\n *\n * @api public\n */\n\nSocket.prototype.onOpen = function () {\n  debug('socket open');\n  this.readyState = 'open';\n  Socket.priorWebsocketSuccess = 'websocket' == this.transport.name;\n  this.emit('open');\n  this.flush();\n\n  // we check for `readyState` in case an `open`\n  // listener already closed the socket\n  if ('open' == this.readyState && this.upgrade && this.transport.pause) {\n    debug('starting upgrade probes');\n    for (var i = 0, l = this.upgrades.length; i < l; i++) {\n      this.probe(this.upgrades[i]);\n    }\n  }\n};\n\n/**\n * Handles a packet.\n *\n * @api private\n */\n\nSocket.prototype.onPacket = function (packet) {\n  if ('opening' == this.readyState || 'open' == this.readyState) {\n    debug('socket receive: type \"%s\", data \"%s\"', packet.type, packet.data);\n\n    this.emit('packet', packet);\n\n    // Socket is live - any packet counts\n    this.emit('heartbeat');\n\n    switch (packet.type) {\n      case 'open':\n        this.onHandshake(parsejson(packet.data));\n        break;\n\n      case 'pong':\n        this.setPing();\n        this.emit('pong');\n        break;\n\n      case 'error':\n        var err = new Error('server error');\n        err.code = packet.data;\n        this.onError(err);\n        break;\n\n      case 'message':\n        this.emit('data', packet.data);\n        this.emit('message', packet.data);\n        break;\n    }\n  } else {\n    debug('packet received with socket readyState \"%s\"', this.readyState);\n  }\n};\n\n/**\n * Called upon handshake completion.\n *\n * @param {Object} handshake obj\n * @api private\n */\n\nSocket.prototype.onHandshake = function (data) {\n  this.emit('handshake', data);\n  this.id = data.sid;\n  this.transport.query.sid = data.sid;\n  this.upgrades = this.filterUpgrades(data.upgrades);\n  this.pingInterval = data.pingInterval;\n  this.pingTimeout = data.pingTimeout;\n  this.onOpen();\n  // In case open handler closes socket\n  if  ('closed' == this.readyState) return;\n  this.setPing();\n\n  // Prolong liveness of socket on heartbeat\n  this.removeListener('heartbeat', this.onHeartbeat);\n  this.on('heartbeat', this.onHeartbeat);\n};\n\n/**\n * Resets ping timeout.\n *\n * @api private\n */\n\nSocket.prototype.onHeartbeat = function (timeout) {\n  clearTimeout(this.pingTimeoutTimer);\n  var self = this;\n  self.pingTimeoutTimer = setTimeout(function () {\n    if ('closed' == self.readyState) return;\n    self.onClose('ping timeout');\n  }, timeout || (self.pingInterval + self.pingTimeout));\n};\n\n/**\n * Pings server every `this.pingInterval` and expects response\n * within `this.pingTimeout` or closes connection.\n *\n * @api private\n */\n\nSocket.prototype.setPing = function () {\n  var self = this;\n  clearTimeout(self.pingIntervalTimer);\n  self.pingIntervalTimer = setTimeout(function () {\n    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);\n    self.ping();\n    self.onHeartbeat(self.pingTimeout);\n  }, self.pingInterval);\n};\n\n/**\n* Sends a ping packet.\n*\n* @api private\n*/\n\nSocket.prototype.ping = function () {\n  var self = this;\n  this.sendPacket('ping', function(){\n    self.emit('ping');\n  });\n};\n\n/**\n * Called on `drain` event\n *\n * @api private\n */\n\nSocket.prototype.onDrain = function() {\n  this.writeBuffer.splice(0, this.prevBufferLen);\n\n  // setting prevBufferLen = 0 is very important\n  // for example, when upgrading, upgrade packet is sent over,\n  // and a nonzero prevBufferLen could cause problems on `drain`\n  this.prevBufferLen = 0;\n\n  if (0 === this.writeBuffer.length) {\n    this.emit('drain');\n  } else {\n    this.flush();\n  }\n};\n\n/**\n * Flush write buffers.\n *\n * @api private\n */\n\nSocket.prototype.flush = function () {\n  if ('closed' != this.readyState && this.transport.writable &&\n    !this.upgrading && this.writeBuffer.length) {\n    debug('flushing %d packets in socket', this.writeBuffer.length);\n    this.transport.send(this.writeBuffer);\n    // keep track of current length of writeBuffer\n    // splice writeBuffer and callbackBuffer on `drain`\n    this.prevBufferLen = this.writeBuffer.length;\n    this.emit('flush');\n  }\n};\n\n/**\n * Sends a message.\n *\n * @param {String} message.\n * @param {Function} callback function.\n * @param {Object} options.\n * @return {Socket} for chaining.\n * @api public\n */\n\nSocket.prototype.write =\nSocket.prototype.send = function (msg, options, fn) {\n  this.sendPacket('message', msg, options, fn);\n  return this;\n};\n\n/**\n * Sends a packet.\n *\n * @param {String} packet type.\n * @param {String} data.\n * @param {Object} options.\n * @param {Function} callback function.\n * @api private\n */\n\nSocket.prototype.sendPacket = function (type, data, options, fn) {\n  if('function' == typeof data) {\n    fn = data;\n    data = undefined;\n  }\n\n  if ('function' == typeof options) {\n    fn = options;\n    options = null;\n  }\n\n  if ('closing' == this.readyState || 'closed' == this.readyState) {\n    return;\n  }\n\n  options = options || {};\n  options.compress = false !== options.compress;\n\n  var packet = {\n    type: type,\n    data: data,\n    options: options\n  };\n  this.emit('packetCreate', packet);\n  this.writeBuffer.push(packet);\n  if (fn) this.once('flush', fn);\n  this.flush();\n};\n\n/**\n * Closes the connection.\n *\n * @api private\n */\n\nSocket.prototype.close = function () {\n  if ('opening' == this.readyState || 'open' == this.readyState) {\n    this.readyState = 'closing';\n\n    var self = this;\n\n    if (this.writeBuffer.length) {\n      this.once('drain', function() {\n        if (this.upgrading) {\n          waitForUpgrade();\n        } else {\n          close();\n        }\n      });\n    } else if (this.upgrading) {\n      waitForUpgrade();\n    } else {\n      close();\n    }\n  }\n\n  function close() {\n    self.onClose('forced close');\n    debug('socket closing - telling transport to close');\n    self.transport.close();\n  }\n\n  function cleanupAndClose() {\n    self.removeListener('upgrade', cleanupAndClose);\n    self.removeListener('upgradeError', cleanupAndClose);\n    close();\n  }\n\n  function waitForUpgrade() {\n    // wait for upgrade to finish since we can't send packets while pausing a transport\n    self.once('upgrade', cleanupAndClose);\n    self.once('upgradeError', cleanupAndClose);\n  }\n\n  return this;\n};\n\n/**\n * Called upon transport error\n *\n * @api private\n */\n\nSocket.prototype.onError = function (err) {\n  debug('socket error %j', err);\n  Socket.priorWebsocketSuccess = false;\n  this.emit('error', err);\n  this.onClose('transport error', err);\n};\n\n/**\n * Called upon transport close.\n *\n * @api private\n */\n\nSocket.prototype.onClose = function (reason, desc) {\n  if ('opening' == this.readyState || 'open' == this.readyState || 'closing' == this.readyState) {\n    debug('socket close with reason: \"%s\"', reason);\n    var self = this;\n\n    // clear timers\n    clearTimeout(this.pingIntervalTimer);\n    clearTimeout(this.pingTimeoutTimer);\n\n    // stop event from firing again for transport\n    this.transport.removeAllListeners('close');\n\n    // ensure transport won't stay open\n    this.transport.close();\n\n    // ignore further transport communication\n    this.transport.removeAllListeners();\n\n    // set ready state\n    this.readyState = 'closed';\n\n    // clear session id\n    this.id = null;\n\n    // emit close event\n    this.emit('close', reason, desc);\n\n    // clean buffers after, so users can still\n    // grab the buffers on `close` event\n    self.writeBuffer = [];\n    self.prevBufferLen = 0;\n  }\n};\n\n/**\n * Filters upgrades, returning only those matching client transports.\n *\n * @param {Array} server upgrades\n * @api private\n *\n */\n\nSocket.prototype.filterUpgrades = function (upgrades) {\n  var filteredUpgrades = [];\n  for (var i = 0, j = upgrades.length; i<j; i++) {\n    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);\n  }\n  return filteredUpgrades;\n};\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"./transport\":4,\"./transports\":5,\"component-emitter\":15,\"debug\":17,\"engine.io-parser\":19,\"indexof\":23,\"parsejson\":26,\"parseqs\":27,\"parseuri\":28}],4:[function(_dereq_,module,exports){\n/**\n * Module dependencies.\n */\n\nvar parser = _dereq_('engine.io-parser');\nvar Emitter = _dereq_('component-emitter');\n\n/**\n * Module exports.\n */\n\nmodule.exports = Transport;\n\n/**\n * Transport abstract constructor.\n *\n * @param {Object} options.\n * @api private\n */\n\nfunction Transport (opts) {\n  this.path = opts.path;\n  this.hostname = opts.hostname;\n  this.port = opts.port;\n  this.secure = opts.secure;\n  this.query = opts.query;\n  this.timestampParam = opts.timestampParam;\n  this.timestampRequests = opts.timestampRequests;\n  this.readyState = '';\n  this.agent = opts.agent || false;\n  this.socket = opts.socket;\n  this.enablesXDR = opts.enablesXDR;\n\n  // SSL options for Node.js client\n  this.pfx = opts.pfx;\n  this.key = opts.key;\n  this.passphrase = opts.passphrase;\n  this.cert = opts.cert;\n  this.ca = opts.ca;\n  this.ciphers = opts.ciphers;\n  this.rejectUnauthorized = opts.rejectUnauthorized;\n\n  // other options for Node.js client\n  this.extraHeaders = opts.extraHeaders;\n}\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Transport.prototype);\n\n/**\n * Emits an error.\n *\n * @param {String} str\n * @return {Transport} for chaining\n * @api public\n */\n\nTransport.prototype.onError = function (msg, desc) {\n  var err = new Error(msg);\n  err.type = 'TransportError';\n  err.description = desc;\n  this.emit('error', err);\n  return this;\n};\n\n/**\n * Opens the transport.\n *\n * @api public\n */\n\nTransport.prototype.open = function () {\n  if ('closed' == this.readyState || '' == this.readyState) {\n    this.readyState = 'opening';\n    this.doOpen();\n  }\n\n  return this;\n};\n\n/**\n * Closes the transport.\n *\n * @api private\n */\n\nTransport.prototype.close = function () {\n  if ('opening' == this.readyState || 'open' == this.readyState) {\n    this.doClose();\n    this.onClose();\n  }\n\n  return this;\n};\n\n/**\n * Sends multiple packets.\n *\n * @param {Array} packets\n * @api private\n */\n\nTransport.prototype.send = function(packets){\n  if ('open' == this.readyState) {\n    this.write(packets);\n  } else {\n    throw new Error('Transport not open');\n  }\n};\n\n/**\n * Called upon open\n *\n * @api private\n */\n\nTransport.prototype.onOpen = function () {\n  this.readyState = 'open';\n  this.writable = true;\n  this.emit('open');\n};\n\n/**\n * Called with data.\n *\n * @param {String} data\n * @api private\n */\n\nTransport.prototype.onData = function(data){\n  var packet = parser.decodePacket(data, this.socket.binaryType);\n  this.onPacket(packet);\n};\n\n/**\n * Called with a decoded packet.\n */\n\nTransport.prototype.onPacket = function (packet) {\n  this.emit('packet', packet);\n};\n\n/**\n * Called upon close.\n *\n * @api private\n */\n\nTransport.prototype.onClose = function () {\n  this.readyState = 'closed';\n  this.emit('close');\n};\n\n},{\"component-emitter\":15,\"engine.io-parser\":19}],5:[function(_dereq_,module,exports){\n(function (global){\n/**\n * Module dependencies\n */\n\nvar XMLHttpRequest = _dereq_('xmlhttprequest-ssl');\nvar XHR = _dereq_('./polling-xhr');\nvar JSONP = _dereq_('./polling-jsonp');\nvar websocket = _dereq_('./websocket');\n\n/**\n * Export transports.\n */\n\nexports.polling = polling;\nexports.websocket = websocket;\n\n/**\n * Polling transport polymorphic constructor.\n * Decides on xhr vs jsonp based on feature detection.\n *\n * @api private\n */\n\nfunction polling(opts){\n  var xhr;\n  var xd = false;\n  var xs = false;\n  var jsonp = false !== opts.jsonp;\n\n  if (global.location) {\n    var isSSL = 'https:' == location.protocol;\n    var port = location.port;\n\n    // some user agents have empty `location.port`\n    if (!port) {\n      port = isSSL ? 443 : 80;\n    }\n\n    xd = opts.hostname != location.hostname || port != opts.port;\n    xs = opts.secure != isSSL;\n  }\n\n  opts.xdomain = xd;\n  opts.xscheme = xs;\n  xhr = new XMLHttpRequest(opts);\n\n  if ('open' in xhr && !opts.forceJSONP) {\n    return new XHR(opts);\n  } else {\n    if (!jsonp) throw new Error('JSONP disabled');\n    return new JSONP(opts);\n  }\n}\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"./polling-jsonp\":6,\"./polling-xhr\":7,\"./websocket\":9,\"xmlhttprequest-ssl\":10}],6:[function(_dereq_,module,exports){\n(function (global){\n\n/**\n * Module requirements.\n */\n\nvar Polling = _dereq_('./polling');\nvar inherit = _dereq_('component-inherit');\n\n/**\n * Module exports.\n */\n\nmodule.exports = JSONPPolling;\n\n/**\n * Cached regular expressions.\n */\n\nvar rNewline = /\\n/g;\nvar rEscapedNewline = /\\\\n/g;\n\n/**\n * Global JSONP callbacks.\n */\n\nvar callbacks;\n\n/**\n * Callbacks count.\n */\n\nvar index = 0;\n\n/**\n * Noop.\n */\n\nfunction empty () { }\n\n/**\n * JSONP Polling constructor.\n *\n * @param {Object} opts.\n * @api public\n */\n\nfunction JSONPPolling (opts) {\n  Polling.call(this, opts);\n\n  this.query = this.query || {};\n\n  // define global callbacks array if not present\n  // we do this here (lazily) to avoid unneeded global pollution\n  if (!callbacks) {\n    // we need to consider multiple engines in the same page\n    if (!global.___eio) global.___eio = [];\n    callbacks = global.___eio;\n  }\n\n  // callback identifier\n  this.index = callbacks.length;\n\n  // add callback to jsonp global\n  var self = this;\n  callbacks.push(function (msg) {\n    self.onData(msg);\n  });\n\n  // append to query string\n  this.query.j = this.index;\n\n  // prevent spurious errors from being emitted when the window is unloaded\n  if (global.document && global.addEventListener) {\n    global.addEventListener('beforeunload', function () {\n      if (self.script) self.script.onerror = empty;\n    }, false);\n  }\n}\n\n/**\n * Inherits from Polling.\n */\n\ninherit(JSONPPolling, Polling);\n\n/*\n * JSONP only supports binary as base64 encoded strings\n */\n\nJSONPPolling.prototype.supportsBinary = false;\n\n/**\n * Closes the socket.\n *\n * @api private\n */\n\nJSONPPolling.prototype.doClose = function () {\n  if (this.script) {\n    this.script.parentNode.removeChild(this.script);\n    this.script = null;\n  }\n\n  if (this.form) {\n    this.form.parentNode.removeChild(this.form);\n    this.form = null;\n    this.iframe = null;\n  }\n\n  Polling.prototype.doClose.call(this);\n};\n\n/**\n * Starts a poll cycle.\n *\n * @api private\n */\n\nJSONPPolling.prototype.doPoll = function () {\n  var self = this;\n  var script = document.createElement('script');\n\n  if (this.script) {\n    this.script.parentNode.removeChild(this.script);\n    this.script = null;\n  }\n\n  script.async = true;\n  script.src = this.uri();\n  script.onerror = function(e){\n    self.onError('jsonp poll error',e);\n  };\n\n  var insertAt = document.getElementsByTagName('script')[0];\n  if (insertAt) {\n    insertAt.parentNode.insertBefore(script, insertAt);\n  }\n  else {\n    (document.head || document.body).appendChild(script);\n  }\n  this.script = script;\n\n  var isUAgecko = 'undefined' != typeof navigator && /gecko/i.test(navigator.userAgent);\n  \n  if (isUAgecko) {\n    setTimeout(function () {\n      var iframe = document.createElement('iframe');\n      document.body.appendChild(iframe);\n      document.body.removeChild(iframe);\n    }, 100);\n  }\n};\n\n/**\n * Writes with a hidden iframe.\n *\n * @param {String} data to send\n * @param {Function} called upon flush.\n * @api private\n */\n\nJSONPPolling.prototype.doWrite = function (data, fn) {\n  var self = this;\n\n  if (!this.form) {\n    var form = document.createElement('form');\n    var area = document.createElement('textarea');\n    var id = this.iframeId = 'eio_iframe_' + this.index;\n    var iframe;\n\n    form.className = 'socketio';\n    form.style.position = 'absolute';\n    form.style.top = '-1000px';\n    form.style.left = '-1000px';\n    form.target = id;\n    form.method = 'POST';\n    form.setAttribute('accept-charset', 'utf-8');\n    area.name = 'd';\n    form.appendChild(area);\n    document.body.appendChild(form);\n\n    this.form = form;\n    this.area = area;\n  }\n\n  this.form.action = this.uri();\n\n  function complete () {\n    initIframe();\n    fn();\n  }\n\n  function initIframe () {\n    if (self.iframe) {\n      try {\n        self.form.removeChild(self.iframe);\n      } catch (e) {\n        self.onError('jsonp polling iframe removal error', e);\n      }\n    }\n\n    try {\n      // ie6 dynamic iframes with target=\"\" support (thanks Chris Lambacher)\n      var html = '<iframe src=\"javascript:0\" name=\"'+ self.iframeId +'\">';\n      iframe = document.createElement(html);\n    } catch (e) {\n      iframe = document.createElement('iframe');\n      iframe.name = self.iframeId;\n      iframe.src = 'javascript:0';\n    }\n\n    iframe.id = self.iframeId;\n\n    self.form.appendChild(iframe);\n    self.iframe = iframe;\n  }\n\n  initIframe();\n\n  // escape \\n to prevent it from being converted into \\r\\n by some UAs\n  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side\n  data = data.replace(rEscapedNewline, '\\\\\\n');\n  this.area.value = data.replace(rNewline, '\\\\n');\n\n  try {\n    this.form.submit();\n  } catch(e) {}\n\n  if (this.iframe.attachEvent) {\n    this.iframe.onreadystatechange = function(){\n      if (self.iframe.readyState == 'complete') {\n        complete();\n      }\n    };\n  } else {\n    this.iframe.onload = complete;\n  }\n};\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"./polling\":8,\"component-inherit\":16}],7:[function(_dereq_,module,exports){\n(function (global){\n/**\n * Module requirements.\n */\n\nvar XMLHttpRequest = _dereq_('xmlhttprequest-ssl');\nvar Polling = _dereq_('./polling');\nvar Emitter = _dereq_('component-emitter');\nvar inherit = _dereq_('component-inherit');\nvar debug = _dereq_('debug')('engine.io-client:polling-xhr');\n\n/**\n * Module exports.\n */\n\nmodule.exports = XHR;\nmodule.exports.Request = Request;\n\n/**\n * Empty function\n */\n\nfunction empty(){}\n\n/**\n * XHR Polling constructor.\n *\n * @param {Object} opts\n * @api public\n */\n\nfunction XHR(opts){\n  Polling.call(this, opts);\n\n  if (global.location) {\n    var isSSL = 'https:' == location.protocol;\n    var port = location.port;\n\n    // some user agents have empty `location.port`\n    if (!port) {\n      port = isSSL ? 443 : 80;\n    }\n\n    this.xd = opts.hostname != global.location.hostname ||\n      port != opts.port;\n    this.xs = opts.secure != isSSL;\n  } else {\n    this.extraHeaders = opts.extraHeaders;\n  }\n}\n\n/**\n * Inherits from Polling.\n */\n\ninherit(XHR, Polling);\n\n/**\n * XHR supports binary\n */\n\nXHR.prototype.supportsBinary = true;\n\n/**\n * Creates a request.\n *\n * @param {String} method\n * @api private\n */\n\nXHR.prototype.request = function(opts){\n  opts = opts || {};\n  opts.uri = this.uri();\n  opts.xd = this.xd;\n  opts.xs = this.xs;\n  opts.agent = this.agent || false;\n  opts.supportsBinary = this.supportsBinary;\n  opts.enablesXDR = this.enablesXDR;\n\n  // SSL options for Node.js client\n  opts.pfx = this.pfx;\n  opts.key = this.key;\n  opts.passphrase = this.passphrase;\n  opts.cert = this.cert;\n  opts.ca = this.ca;\n  opts.ciphers = this.ciphers;\n  opts.rejectUnauthorized = this.rejectUnauthorized;\n\n  // other options for Node.js client\n  opts.extraHeaders = this.extraHeaders;\n\n  return new Request(opts);\n};\n\n/**\n * Sends data.\n *\n * @param {String} data to send.\n * @param {Function} called upon flush.\n * @api private\n */\n\nXHR.prototype.doWrite = function(data, fn){\n  var isBinary = typeof data !== 'string' && data !== undefined;\n  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });\n  var self = this;\n  req.on('success', fn);\n  req.on('error', function(err){\n    self.onError('xhr post error', err);\n  });\n  this.sendXhr = req;\n};\n\n/**\n * Starts a poll cycle.\n *\n * @api private\n */\n\nXHR.prototype.doPoll = function(){\n  debug('xhr poll');\n  var req = this.request();\n  var self = this;\n  req.on('data', function(data){\n    self.onData(data);\n  });\n  req.on('error', function(err){\n    self.onError('xhr poll error', err);\n  });\n  this.pollXhr = req;\n};\n\n/**\n * Request constructor\n *\n * @param {Object} options\n * @api public\n */\n\nfunction Request(opts){\n  this.method = opts.method || 'GET';\n  this.uri = opts.uri;\n  this.xd = !!opts.xd;\n  this.xs = !!opts.xs;\n  this.async = false !== opts.async;\n  this.data = undefined != opts.data ? opts.data : null;\n  this.agent = opts.agent;\n  this.isBinary = opts.isBinary;\n  this.supportsBinary = opts.supportsBinary;\n  this.enablesXDR = opts.enablesXDR;\n\n  // SSL options for Node.js client\n  this.pfx = opts.pfx;\n  this.key = opts.key;\n  this.passphrase = opts.passphrase;\n  this.cert = opts.cert;\n  this.ca = opts.ca;\n  this.ciphers = opts.ciphers;\n  this.rejectUnauthorized = opts.rejectUnauthorized;\n\n  // other options for Node.js client\n  this.extraHeaders = opts.extraHeaders;\n\n  this.create();\n}\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Request.prototype);\n\n/**\n * Creates the XHR object and sends the request.\n *\n * @api private\n */\n\nRequest.prototype.create = function(){\n  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };\n\n  // SSL options for Node.js client\n  opts.pfx = this.pfx;\n  opts.key = this.key;\n  opts.passphrase = this.passphrase;\n  opts.cert = this.cert;\n  opts.ca = this.ca;\n  opts.ciphers = this.ciphers;\n  opts.rejectUnauthorized = this.rejectUnauthorized;\n\n  var xhr = this.xhr = new XMLHttpRequest(opts);\n  var self = this;\n\n  try {\n    debug('xhr open %s: %s', this.method, this.uri);\n    xhr.open(this.method, this.uri, this.async);\n    try {\n      if (this.extraHeaders) {\n        xhr.setDisableHeaderCheck(true);\n        for (var i in this.extraHeaders) {\n          if (this.extraHeaders.hasOwnProperty(i)) {\n            xhr.setRequestHeader(i, this.extraHeaders[i]);\n          }\n        }\n      }\n    } catch (e) {}\n    if (this.supportsBinary) {\n      // This has to be done after open because Firefox is stupid\n      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension\n      xhr.responseType = 'arraybuffer';\n    }\n\n    if ('POST' == this.method) {\n      try {\n        if (this.isBinary) {\n          xhr.setRequestHeader('Content-type', 'application/octet-stream');\n        } else {\n          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');\n        }\n      } catch (e) {}\n    }\n\n    // ie6 check\n    if ('withCredentials' in xhr) {\n      xhr.withCredentials = true;\n    }\n\n    if (this.hasXDR()) {\n      xhr.onload = function(){\n        self.onLoad();\n      };\n      xhr.onerror = function(){\n        self.onError(xhr.responseText);\n      };\n    } else {\n      xhr.onreadystatechange = function(){\n        if (4 != xhr.readyState) return;\n        if (200 == xhr.status || 1223 == xhr.status) {\n          self.onLoad();\n        } else {\n          // make sure the `error` event handler that's user-set\n          // does not throw in the same tick and gets caught here\n          setTimeout(function(){\n            self.onError(xhr.status);\n          }, 0);\n        }\n      };\n    }\n\n    debug('xhr data %s', this.data);\n    xhr.send(this.data);\n  } catch (e) {\n    // Need to defer since .create() is called directly fhrom the constructor\n    // and thus the 'error' event can only be only bound *after* this exception\n    // occurs.  Therefore, also, we cannot throw here at all.\n    setTimeout(function() {\n      self.onError(e);\n    }, 0);\n    return;\n  }\n\n  if (global.document) {\n    this.index = Request.requestsCount++;\n    Request.requests[this.index] = this;\n  }\n};\n\n/**\n * Called upon successful response.\n *\n * @api private\n */\n\nRequest.prototype.onSuccess = function(){\n  this.emit('success');\n  this.cleanup();\n};\n\n/**\n * Called if we have data.\n *\n * @api private\n */\n\nRequest.prototype.onData = function(data){\n  this.emit('data', data);\n  this.onSuccess();\n};\n\n/**\n * Called upon error.\n *\n * @api private\n */\n\nRequest.prototype.onError = function(err){\n  this.emit('error', err);\n  this.cleanup(true);\n};\n\n/**\n * Cleans up house.\n *\n * @api private\n */\n\nRequest.prototype.cleanup = function(fromError){\n  if ('undefined' == typeof this.xhr || null === this.xhr) {\n    return;\n  }\n  // xmlhttprequest\n  if (this.hasXDR()) {\n    this.xhr.onload = this.xhr.onerror = empty;\n  } else {\n    this.xhr.onreadystatechange = empty;\n  }\n\n  if (fromError) {\n    try {\n      this.xhr.abort();\n    } catch(e) {}\n  }\n\n  if (global.document) {\n    delete Request.requests[this.index];\n  }\n\n  this.xhr = null;\n};\n\n/**\n * Called upon load.\n *\n * @api private\n */\n\nRequest.prototype.onLoad = function(){\n  var data;\n  try {\n    var contentType;\n    try {\n      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];\n    } catch (e) {}\n    if (contentType === 'application/octet-stream') {\n      data = this.xhr.response;\n    } else {\n      if (!this.supportsBinary) {\n        data = this.xhr.responseText;\n      } else {\n        try {\n          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));\n        } catch (e) {\n          var ui8Arr = new Uint8Array(this.xhr.response);\n          var dataArray = [];\n          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {\n            dataArray.push(ui8Arr[idx]);\n          }\n\n          data = String.fromCharCode.apply(null, dataArray);\n        }\n      }\n    }\n  } catch (e) {\n    this.onError(e);\n  }\n  if (null != data) {\n    this.onData(data);\n  }\n};\n\n/**\n * Check if it has XDomainRequest.\n *\n * @api private\n */\n\nRequest.prototype.hasXDR = function(){\n  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;\n};\n\n/**\n * Aborts the request.\n *\n * @api public\n */\n\nRequest.prototype.abort = function(){\n  this.cleanup();\n};\n\n/**\n * Aborts pending requests when unloading the window. This is needed to prevent\n * memory leaks (e.g. when using IE) and to ensure that no spurious error is\n * emitted.\n */\n\nif (global.document) {\n  Request.requestsCount = 0;\n  Request.requests = {};\n  if (global.attachEvent) {\n    global.attachEvent('onunload', unloadHandler);\n  } else if (global.addEventListener) {\n    global.addEventListener('beforeunload', unloadHandler, false);\n  }\n}\n\nfunction unloadHandler() {\n  for (var i in Request.requests) {\n    if (Request.requests.hasOwnProperty(i)) {\n      Request.requests[i].abort();\n    }\n  }\n}\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"./polling\":8,\"component-emitter\":15,\"component-inherit\":16,\"debug\":17,\"xmlhttprequest-ssl\":10}],8:[function(_dereq_,module,exports){\n/**\n * Module dependencies.\n */\n\nvar Transport = _dereq_('../transport');\nvar parseqs = _dereq_('parseqs');\nvar parser = _dereq_('engine.io-parser');\nvar inherit = _dereq_('component-inherit');\nvar yeast = _dereq_('yeast');\nvar debug = _dereq_('debug')('engine.io-client:polling');\n\n/**\n * Module exports.\n */\n\nmodule.exports = Polling;\n\n/**\n * Is XHR2 supported?\n */\n\nvar hasXHR2 = (function() {\n  var XMLHttpRequest = _dereq_('xmlhttprequest-ssl');\n  var xhr = new XMLHttpRequest({ xdomain: false });\n  return null != xhr.responseType;\n})();\n\n/**\n * Polling interface.\n *\n * @param {Object} opts\n * @api private\n */\n\nfunction Polling(opts){\n  var forceBase64 = (opts && opts.forceBase64);\n  if (!hasXHR2 || forceBase64) {\n    this.supportsBinary = false;\n  }\n  Transport.call(this, opts);\n}\n\n/**\n * Inherits from Transport.\n */\n\ninherit(Polling, Transport);\n\n/**\n * Transport name.\n */\n\nPolling.prototype.name = 'polling';\n\n/**\n * Opens the socket (triggers polling). We write a PING message to determine\n * when the transport is open.\n *\n * @api private\n */\n\nPolling.prototype.doOpen = function(){\n  this.poll();\n};\n\n/**\n * Pauses polling.\n *\n * @param {Function} callback upon buffers are flushed and transport is paused\n * @api private\n */\n\nPolling.prototype.pause = function(onPause){\n  var pending = 0;\n  var self = this;\n\n  this.readyState = 'pausing';\n\n  function pause(){\n    debug('paused');\n    self.readyState = 'paused';\n    onPause();\n  }\n\n  if (this.polling || !this.writable) {\n    var total = 0;\n\n    if (this.polling) {\n      debug('we are currently polling - waiting to pause');\n      total++;\n      this.once('pollComplete', function(){\n        debug('pre-pause polling complete');\n        --total || pause();\n      });\n    }\n\n    if (!this.writable) {\n      debug('we are currently writing - waiting to pause');\n      total++;\n      this.once('drain', function(){\n        debug('pre-pause writing complete');\n        --total || pause();\n      });\n    }\n  } else {\n    pause();\n  }\n};\n\n/**\n * Starts polling cycle.\n *\n * @api public\n */\n\nPolling.prototype.poll = function(){\n  debug('polling');\n  this.polling = true;\n  this.doPoll();\n  this.emit('poll');\n};\n\n/**\n * Overloads onData to detect payloads.\n *\n * @api private\n */\n\nPolling.prototype.onData = function(data){\n  var self = this;\n  debug('polling got data %s', data);\n  var callback = function(packet, index, total) {\n    // if its the first message we consider the transport open\n    if ('opening' == self.readyState) {\n      self.onOpen();\n    }\n\n    // if its a close packet, we close the ongoing requests\n    if ('close' == packet.type) {\n      self.onClose();\n      return false;\n    }\n\n    // otherwise bypass onData and handle the message\n    self.onPacket(packet);\n  };\n\n  // decode payload\n  parser.decodePayload(data, this.socket.binaryType, callback);\n\n  // if an event did not trigger closing\n  if ('closed' != this.readyState) {\n    // if we got data we're not polling\n    this.polling = false;\n    this.emit('pollComplete');\n\n    if ('open' == this.readyState) {\n      this.poll();\n    } else {\n      debug('ignoring poll - transport state \"%s\"', this.readyState);\n    }\n  }\n};\n\n/**\n * For polling, send a close packet.\n *\n * @api private\n */\n\nPolling.prototype.doClose = function(){\n  var self = this;\n\n  function close(){\n    debug('writing close packet');\n    self.write([{ type: 'close' }]);\n  }\n\n  if ('open' == this.readyState) {\n    debug('transport open - closing');\n    close();\n  } else {\n    // in case we're trying to close while\n    // handshaking is in progress (GH-164)\n    debug('transport not open - deferring close');\n    this.once('open', close);\n  }\n};\n\n/**\n * Writes a packets payload.\n *\n * @param {Array} data packets\n * @param {Function} drain callback\n * @api private\n */\n\nPolling.prototype.write = function(packets){\n  var self = this;\n  this.writable = false;\n  var callbackfn = function() {\n    self.writable = true;\n    self.emit('drain');\n  };\n\n  var self = this;\n  parser.encodePayload(packets, this.supportsBinary, function(data) {\n    self.doWrite(data, callbackfn);\n  });\n};\n\n/**\n * Generates uri for connection.\n *\n * @api private\n */\n\nPolling.prototype.uri = function(){\n  var query = this.query || {};\n  var schema = this.secure ? 'https' : 'http';\n  var port = '';\n\n  // cache busting is forced\n  if (false !== this.timestampRequests) {\n    query[this.timestampParam] = yeast();\n  }\n\n  if (!this.supportsBinary && !query.sid) {\n    query.b64 = 1;\n  }\n\n  query = parseqs.encode(query);\n\n  // avoid port if default for schema\n  if (this.port && (('https' == schema && this.port != 443) ||\n     ('http' == schema && this.port != 80))) {\n    port = ':' + this.port;\n  }\n\n  // prepend ? to query\n  if (query.length) {\n    query = '?' + query;\n  }\n\n  var ipv6 = this.hostname.indexOf(':') !== -1;\n  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;\n};\n\n},{\"../transport\":4,\"component-inherit\":16,\"debug\":17,\"engine.io-parser\":19,\"parseqs\":27,\"xmlhttprequest-ssl\":10,\"yeast\":30}],9:[function(_dereq_,module,exports){\n(function (global){\n/**\n * Module dependencies.\n */\n\nvar Transport = _dereq_('../transport');\nvar parser = _dereq_('engine.io-parser');\nvar parseqs = _dereq_('parseqs');\nvar inherit = _dereq_('component-inherit');\nvar yeast = _dereq_('yeast');\nvar debug = _dereq_('debug')('engine.io-client:websocket');\nvar BrowserWebSocket = global.WebSocket || global.MozWebSocket;\n\n/**\n * Get either the `WebSocket` or `MozWebSocket` globals\n * in the browser or try to resolve WebSocket-compatible\n * interface exposed by `ws` for Node-like environment.\n */\n\nvar WebSocket = BrowserWebSocket;\nif (!WebSocket && typeof window === 'undefined') {\n  try {\n    WebSocket = _dereq_('ws');\n  } catch (e) { }\n}\n\n/**\n * Module exports.\n */\n\nmodule.exports = WS;\n\n/**\n * WebSocket transport constructor.\n *\n * @api {Object} connection options\n * @api public\n */\n\nfunction WS(opts){\n  var forceBase64 = (opts && opts.forceBase64);\n  if (forceBase64) {\n    this.supportsBinary = false;\n  }\n  this.perMessageDeflate = opts.perMessageDeflate;\n  Transport.call(this, opts);\n}\n\n/**\n * Inherits from Transport.\n */\n\ninherit(WS, Transport);\n\n/**\n * Transport name.\n *\n * @api public\n */\n\nWS.prototype.name = 'websocket';\n\n/*\n * WebSockets support binary\n */\n\nWS.prototype.supportsBinary = true;\n\n/**\n * Opens socket.\n *\n * @api private\n */\n\nWS.prototype.doOpen = function(){\n  if (!this.check()) {\n    // let probe timeout\n    return;\n  }\n\n  var self = this;\n  var uri = this.uri();\n  var protocols = void(0);\n  var opts = {\n    agent: this.agent,\n    perMessageDeflate: this.perMessageDeflate\n  };\n\n  // SSL options for Node.js client\n  opts.pfx = this.pfx;\n  opts.key = this.key;\n  opts.passphrase = this.passphrase;\n  opts.cert = this.cert;\n  opts.ca = this.ca;\n  opts.ciphers = this.ciphers;\n  opts.rejectUnauthorized = this.rejectUnauthorized;\n  if (this.extraHeaders) {\n    opts.headers = this.extraHeaders;\n  }\n\n  this.ws = BrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);\n\n  if (this.ws.binaryType === undefined) {\n    this.supportsBinary = false;\n  }\n\n  if (this.ws.supports && this.ws.supports.binary) {\n    this.supportsBinary = true;\n    this.ws.binaryType = 'buffer';\n  } else {\n    this.ws.binaryType = 'arraybuffer';\n  }\n\n  this.addEventListeners();\n};\n\n/**\n * Adds event listeners to the socket\n *\n * @api private\n */\n\nWS.prototype.addEventListeners = function(){\n  var self = this;\n\n  this.ws.onopen = function(){\n    self.onOpen();\n  };\n  this.ws.onclose = function(){\n    self.onClose();\n  };\n  this.ws.onmessage = function(ev){\n    self.onData(ev.data);\n  };\n  this.ws.onerror = function(e){\n    self.onError('websocket error', e);\n  };\n};\n\n/**\n * Override `onData` to use a timer on iOS.\n * See: https://gist.github.com/mloughran/2052006\n *\n * @api private\n */\n\nif ('undefined' != typeof navigator\n  && /iPad|iPhone|iPod/i.test(navigator.userAgent)) {\n  WS.prototype.onData = function(data){\n    var self = this;\n    setTimeout(function(){\n      Transport.prototype.onData.call(self, data);\n    }, 0);\n  };\n}\n\n/**\n * Writes data to socket.\n *\n * @param {Array} array of packets.\n * @api private\n */\n\nWS.prototype.write = function(packets){\n  var self = this;\n  this.writable = false;\n\n  // encodePacket efficient as it uses WS framing\n  // no need for encodePayload\n  var total = packets.length;\n  for (var i = 0, l = total; i < l; i++) {\n    (function(packet) {\n      parser.encodePacket(packet, self.supportsBinary, function(data) {\n        if (!BrowserWebSocket) {\n          // always create a new object (GH-437)\n          var opts = {};\n          if (packet.options) {\n            opts.compress = packet.options.compress;\n          }\n\n          if (self.perMessageDeflate) {\n            var len = 'string' == typeof data ? global.Buffer.byteLength(data) : data.length;\n            if (len < self.perMessageDeflate.threshold) {\n              opts.compress = false;\n            }\n          }\n        }\n\n        //Sometimes the websocket has already been closed but the browser didn't\n        //have a chance of informing us about it yet, in that case send will\n        //throw an error\n        try {\n          if (BrowserWebSocket) {\n            // TypeError is thrown when passing the second argument on Safari\n            self.ws.send(data);\n          } else {\n            self.ws.send(data, opts);\n          }\n        } catch (e){\n          debug('websocket closed before onclose event');\n        }\n\n        --total || done();\n      });\n    })(packets[i]);\n  }\n\n  function done(){\n    self.emit('flush');\n\n    // fake drain\n    // defer to next tick to allow Socket to clear writeBuffer\n    setTimeout(function(){\n      self.writable = true;\n      self.emit('drain');\n    }, 0);\n  }\n};\n\n/**\n * Called upon close\n *\n * @api private\n */\n\nWS.prototype.onClose = function(){\n  Transport.prototype.onClose.call(this);\n};\n\n/**\n * Closes socket.\n *\n * @api private\n */\n\nWS.prototype.doClose = function(){\n  if (typeof this.ws !== 'undefined') {\n    this.ws.close();\n  }\n};\n\n/**\n * Generates uri for connection.\n *\n * @api private\n */\n\nWS.prototype.uri = function(){\n  var query = this.query || {};\n  var schema = this.secure ? 'wss' : 'ws';\n  var port = '';\n\n  // avoid port if default for schema\n  if (this.port && (('wss' == schema && this.port != 443)\n    || ('ws' == schema && this.port != 80))) {\n    port = ':' + this.port;\n  }\n\n  // append timestamp to URI\n  if (this.timestampRequests) {\n    query[this.timestampParam] = yeast();\n  }\n\n  // communicate binary support capabilities\n  if (!this.supportsBinary) {\n    query.b64 = 1;\n  }\n\n  query = parseqs.encode(query);\n\n  // prepend ? to query\n  if (query.length) {\n    query = '?' + query;\n  }\n\n  var ipv6 = this.hostname.indexOf(':') !== -1;\n  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;\n};\n\n/**\n * Feature detection for WebSocket.\n *\n * @return {Boolean} whether this transport is available.\n * @api public\n */\n\nWS.prototype.check = function(){\n  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);\n};\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"../transport\":4,\"component-inherit\":16,\"debug\":17,\"engine.io-parser\":19,\"parseqs\":27,\"ws\":undefined,\"yeast\":30}],10:[function(_dereq_,module,exports){\n// browser shim for xmlhttprequest module\nvar hasCORS = _dereq_('has-cors');\n\nmodule.exports = function(opts) {\n  var xdomain = opts.xdomain;\n\n  // scheme must be same when usign XDomainRequest\n  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx\n  var xscheme = opts.xscheme;\n\n  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.\n  // https://github.com/Automattic/engine.io-client/pull/217\n  var enablesXDR = opts.enablesXDR;\n\n  // XMLHttpRequest can be disabled on IE\n  try {\n    if ('undefined' != typeof XMLHttpRequest && (!xdomain || hasCORS)) {\n      return new XMLHttpRequest();\n    }\n  } catch (e) { }\n\n  // Use XDomainRequest for IE8 if enablesXDR is true\n  // because loading bar keeps flashing when using jsonp-polling\n  // https://github.com/yujiosaka/socke.io-ie8-loading-example\n  try {\n    if ('undefined' != typeof XDomainRequest && !xscheme && enablesXDR) {\n      return new XDomainRequest();\n    }\n  } catch (e) { }\n\n  if (!xdomain) {\n    try {\n      return new ActiveXObject('Microsoft.XMLHTTP');\n    } catch(e) { }\n  }\n}\n\n},{\"has-cors\":22}],11:[function(_dereq_,module,exports){\nmodule.exports = after\n\nfunction after(count, callback, err_cb) {\n    var bail = false\n    err_cb = err_cb || noop\n    proxy.count = count\n\n    return (count === 0) ? callback() : proxy\n\n    function proxy(err, result) {\n        if (proxy.count <= 0) {\n            throw new Error('after called too many times')\n        }\n        --proxy.count\n\n        // after first error, rest are passed to err_cb\n        if (err) {\n            bail = true\n            callback(err)\n            // future error callbacks will go to error handler\n            callback = err_cb\n        } else if (proxy.count === 0 && !bail) {\n            callback(null, result)\n        }\n    }\n}\n\nfunction noop() {}\n\n},{}],12:[function(_dereq_,module,exports){\n/**\n * An abstraction for slicing an arraybuffer even when\n * ArrayBuffer.prototype.slice is not supported\n *\n * @api public\n */\n\nmodule.exports = function(arraybuffer, start, end) {\n  var bytes = arraybuffer.byteLength;\n  start = start || 0;\n  end = end || bytes;\n\n  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }\n\n  if (start < 0) { start += bytes; }\n  if (end < 0) { end += bytes; }\n  if (end > bytes) { end = bytes; }\n\n  if (start >= bytes || start >= end || bytes === 0) {\n    return new ArrayBuffer(0);\n  }\n\n  var abv = new Uint8Array(arraybuffer);\n  var result = new Uint8Array(end - start);\n  for (var i = start, ii = 0; i < end; i++, ii++) {\n    result[ii] = abv[i];\n  }\n  return result.buffer;\n};\n\n},{}],13:[function(_dereq_,module,exports){\n/*\n * base64-arraybuffer\n * https://github.com/niklasvh/base64-arraybuffer\n *\n * Copyright (c) 2012 Niklas von Hertzen\n * Licensed under the MIT license.\n */\n(function(chars){\n  \"use strict\";\n\n  exports.encode = function(arraybuffer) {\n    var bytes = new Uint8Array(arraybuffer),\n    i, len = bytes.length, base64 = \"\";\n\n    for (i = 0; i < len; i+=3) {\n      base64 += chars[bytes[i] >> 2];\n      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];\n      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];\n      base64 += chars[bytes[i + 2] & 63];\n    }\n\n    if ((len % 3) === 2) {\n      base64 = base64.substring(0, base64.length - 1) + \"=\";\n    } else if (len % 3 === 1) {\n      base64 = base64.substring(0, base64.length - 2) + \"==\";\n    }\n\n    return base64;\n  };\n\n  exports.decode =  function(base64) {\n    var bufferLength = base64.length * 0.75,\n    len = base64.length, i, p = 0,\n    encoded1, encoded2, encoded3, encoded4;\n\n    if (base64[base64.length - 1] === \"=\") {\n      bufferLength--;\n      if (base64[base64.length - 2] === \"=\") {\n        bufferLength--;\n      }\n    }\n\n    var arraybuffer = new ArrayBuffer(bufferLength),\n    bytes = new Uint8Array(arraybuffer);\n\n    for (i = 0; i < len; i+=4) {\n      encoded1 = chars.indexOf(base64[i]);\n      encoded2 = chars.indexOf(base64[i+1]);\n      encoded3 = chars.indexOf(base64[i+2]);\n      encoded4 = chars.indexOf(base64[i+3]);\n\n      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);\n      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);\n      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);\n    }\n\n    return arraybuffer;\n  };\n})(\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\");\n\n},{}],14:[function(_dereq_,module,exports){\n(function (global){\n/**\n * Create a blob builder even when vendor prefixes exist\n */\n\nvar BlobBuilder = global.BlobBuilder\n  || global.WebKitBlobBuilder\n  || global.MSBlobBuilder\n  || global.MozBlobBuilder;\n\n/**\n * Check if Blob constructor is supported\n */\n\nvar blobSupported = (function() {\n  try {\n    var a = new Blob(['hi']);\n    return a.size === 2;\n  } catch(e) {\n    return false;\n  }\n})();\n\n/**\n * Check if Blob constructor supports ArrayBufferViews\n * Fails in Safari 6, so we need to map to ArrayBuffers there.\n */\n\nvar blobSupportsArrayBufferView = blobSupported && (function() {\n  try {\n    var b = new Blob([new Uint8Array([1,2])]);\n    return b.size === 2;\n  } catch(e) {\n    return false;\n  }\n})();\n\n/**\n * Check if BlobBuilder is supported\n */\n\nvar blobBuilderSupported = BlobBuilder\n  && BlobBuilder.prototype.append\n  && BlobBuilder.prototype.getBlob;\n\n/**\n * Helper function that maps ArrayBufferViews to ArrayBuffers\n * Used by BlobBuilder constructor and old browsers that didn't\n * support it in the Blob constructor.\n */\n\nfunction mapArrayBufferViews(ary) {\n  for (var i = 0; i < ary.length; i++) {\n    var chunk = ary[i];\n    if (chunk.buffer instanceof ArrayBuffer) {\n      var buf = chunk.buffer;\n\n      // if this is a subarray, make a copy so we only\n      // include the subarray region from the underlying buffer\n      if (chunk.byteLength !== buf.byteLength) {\n        var copy = new Uint8Array(chunk.byteLength);\n        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));\n        buf = copy.buffer;\n      }\n\n      ary[i] = buf;\n    }\n  }\n}\n\nfunction BlobBuilderConstructor(ary, options) {\n  options = options || {};\n\n  var bb = new BlobBuilder();\n  mapArrayBufferViews(ary);\n\n  for (var i = 0; i < ary.length; i++) {\n    bb.append(ary[i]);\n  }\n\n  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();\n};\n\nfunction BlobConstructor(ary, options) {\n  mapArrayBufferViews(ary);\n  return new Blob(ary, options || {});\n};\n\nmodule.exports = (function() {\n  if (blobSupported) {\n    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;\n  } else if (blobBuilderSupported) {\n    return BlobBuilderConstructor;\n  } else {\n    return undefined;\n  }\n})();\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{}],15:[function(_dereq_,module,exports){\n\n/**\n * Expose `Emitter`.\n */\n\nmodule.exports = Emitter;\n\n/**\n * Initialize a new `Emitter`.\n *\n * @api public\n */\n\nfunction Emitter(obj) {\n  if (obj) return mixin(obj);\n};\n\n/**\n * Mixin the emitter properties.\n *\n * @param {Object} obj\n * @return {Object}\n * @api private\n */\n\nfunction mixin(obj) {\n  for (var key in Emitter.prototype) {\n    obj[key] = Emitter.prototype[key];\n  }\n  return obj;\n}\n\n/**\n * Listen on the given `event` with `fn`.\n *\n * @param {String} event\n * @param {Function} fn\n * @return {Emitter}\n * @api public\n */\n\nEmitter.prototype.on =\nEmitter.prototype.addEventListener = function(event, fn){\n  this._callbacks = this._callbacks || {};\n  (this._callbacks[event] = this._callbacks[event] || [])\n    .push(fn);\n  return this;\n};\n\n/**\n * Adds an `event` listener that will be invoked a single\n * time then automatically removed.\n *\n * @param {String} event\n * @param {Function} fn\n * @return {Emitter}\n * @api public\n */\n\nEmitter.prototype.once = function(event, fn){\n  var self = this;\n  this._callbacks = this._callbacks || {};\n\n  function on() {\n    self.off(event, on);\n    fn.apply(this, arguments);\n  }\n\n  on.fn = fn;\n  this.on(event, on);\n  return this;\n};\n\n/**\n * Remove the given callback for `event` or all\n * registered callbacks.\n *\n * @param {String} event\n * @param {Function} fn\n * @return {Emitter}\n * @api public\n */\n\nEmitter.prototype.off =\nEmitter.prototype.removeListener =\nEmitter.prototype.removeAllListeners =\nEmitter.prototype.removeEventListener = function(event, fn){\n  this._callbacks = this._callbacks || {};\n\n  // all\n  if (0 == arguments.length) {\n    this._callbacks = {};\n    return this;\n  }\n\n  // specific event\n  var callbacks = this._callbacks[event];\n  if (!callbacks) return this;\n\n  // remove all handlers\n  if (1 == arguments.length) {\n    delete this._callbacks[event];\n    return this;\n  }\n\n  // remove specific handler\n  var cb;\n  for (var i = 0; i < callbacks.length; i++) {\n    cb = callbacks[i];\n    if (cb === fn || cb.fn === fn) {\n      callbacks.splice(i, 1);\n      break;\n    }\n  }\n  return this;\n};\n\n/**\n * Emit `event` with the given args.\n *\n * @param {String} event\n * @param {Mixed} ...\n * @return {Emitter}\n */\n\nEmitter.prototype.emit = function(event){\n  this._callbacks = this._callbacks || {};\n  var args = [].slice.call(arguments, 1)\n    , callbacks = this._callbacks[event];\n\n  if (callbacks) {\n    callbacks = callbacks.slice(0);\n    for (var i = 0, len = callbacks.length; i < len; ++i) {\n      callbacks[i].apply(this, args);\n    }\n  }\n\n  return this;\n};\n\n/**\n * Return array of callbacks for `event`.\n *\n * @param {String} event\n * @return {Array}\n * @api public\n */\n\nEmitter.prototype.listeners = function(event){\n  this._callbacks = this._callbacks || {};\n  return this._callbacks[event] || [];\n};\n\n/**\n * Check if this emitter has `event` handlers.\n *\n * @param {String} event\n * @return {Boolean}\n * @api public\n */\n\nEmitter.prototype.hasListeners = function(event){\n  return !! this.listeners(event).length;\n};\n\n},{}],16:[function(_dereq_,module,exports){\n\nmodule.exports = function(a, b){\n  var fn = function(){};\n  fn.prototype = b.prototype;\n  a.prototype = new fn;\n  a.prototype.constructor = a;\n};\n},{}],17:[function(_dereq_,module,exports){\n\n/**\n * This is the web browser implementation of `debug()`.\n *\n * Expose `debug()` as the module.\n */\n\nexports = module.exports = _dereq_('./debug');\nexports.log = log;\nexports.formatArgs = formatArgs;\nexports.save = save;\nexports.load = load;\nexports.useColors = useColors;\nexports.storage = 'undefined' != typeof chrome\n               && 'undefined' != typeof chrome.storage\n                  ? chrome.storage.local\n                  : localstorage();\n\n/**\n * Colors.\n */\n\nexports.colors = [\n  'lightseagreen',\n  'forestgreen',\n  'goldenrod',\n  'dodgerblue',\n  'darkorchid',\n  'crimson'\n];\n\n/**\n * Currently only WebKit-based Web Inspectors, Firefox >= v31,\n * and the Firebug extension (any Firefox version) are known\n * to support \"%c\" CSS customizations.\n *\n * TODO: add a `localStorage` variable to explicitly enable/disable colors\n */\n\nfunction useColors() {\n  // is webkit? http://stackoverflow.com/a/16459606/376773\n  return ('WebkitAppearance' in document.documentElement.style) ||\n    // is firebug? http://stackoverflow.com/a/398120/376773\n    (window.console && (console.firebug || (console.exception && console.table))) ||\n    // is firefox >= v31?\n    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages\n    (navigator.userAgent.toLowerCase().match(/firefox\\/(\\d+)/) && parseInt(RegExp.$1, 10) >= 31);\n}\n\n/**\n * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.\n */\n\nexports.formatters.j = function(v) {\n  return JSON.stringify(v);\n};\n\n\n/**\n * Colorize log arguments if enabled.\n *\n * @api public\n */\n\nfunction formatArgs() {\n  var args = arguments;\n  var useColors = this.useColors;\n\n  args[0] = (useColors ? '%c' : '')\n    + this.namespace\n    + (useColors ? ' %c' : ' ')\n    + args[0]\n    + (useColors ? '%c ' : ' ')\n    + '+' + exports.humanize(this.diff);\n\n  if (!useColors) return args;\n\n  var c = 'color: ' + this.color;\n  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));\n\n  // the final \"%c\" is somewhat tricky, because there could be other\n  // arguments passed either before or after the %c, so we need to\n  // figure out the correct index to insert the CSS into\n  var index = 0;\n  var lastC = 0;\n  args[0].replace(/%[a-z%]/g, function(match) {\n    if ('%%' === match) return;\n    index++;\n    if ('%c' === match) {\n      // we only are interested in the *last* %c\n      // (the user may have provided their own)\n      lastC = index;\n    }\n  });\n\n  args.splice(lastC, 0, c);\n  return args;\n}\n\n/**\n * Invokes `console.log()` when available.\n * No-op when `console.log` is not a \"function\".\n *\n * @api public\n */\n\nfunction log() {\n  // this hackery is required for IE8/9, where\n  // the `console.log` function doesn't have 'apply'\n  return 'object' === typeof console\n    && console.log\n    && Function.prototype.apply.call(console.log, console, arguments);\n}\n\n/**\n * Save `namespaces`.\n *\n * @param {String} namespaces\n * @api private\n */\n\nfunction save(namespaces) {\n  try {\n    if (null == namespaces) {\n      exports.storage.removeItem('debug');\n    } else {\n      exports.storage.debug = namespaces;\n    }\n  } catch(e) {}\n}\n\n/**\n * Load `namespaces`.\n *\n * @return {String} returns the previously persisted debug modes\n * @api private\n */\n\nfunction load() {\n  var r;\n  try {\n    r = exports.storage.debug;\n  } catch(e) {}\n  return r;\n}\n\n/**\n * Enable namespaces listed in `localStorage.debug` initially.\n */\n\nexports.enable(load());\n\n/**\n * Localstorage attempts to return the localstorage.\n *\n * This is necessary because safari throws\n * when a user disables cookies/localstorage\n * and you attempt to access it.\n *\n * @return {LocalStorage}\n * @api private\n */\n\nfunction localstorage(){\n  try {\n    return window.localStorage;\n  } catch (e) {}\n}\n\n},{\"./debug\":18}],18:[function(_dereq_,module,exports){\n\n/**\n * This is the common logic for both the Node.js and web browser\n * implementations of `debug()`.\n *\n * Expose `debug()` as the module.\n */\n\nexports = module.exports = debug;\nexports.coerce = coerce;\nexports.disable = disable;\nexports.enable = enable;\nexports.enabled = enabled;\nexports.humanize = _dereq_('ms');\n\n/**\n * The currently active debug mode names, and names to skip.\n */\n\nexports.names = [];\nexports.skips = [];\n\n/**\n * Map of special \"%n\" handling functions, for the debug \"format\" argument.\n *\n * Valid key names are a single, lowercased letter, i.e. \"n\".\n */\n\nexports.formatters = {};\n\n/**\n * Previously assigned color.\n */\n\nvar prevColor = 0;\n\n/**\n * Previous log timestamp.\n */\n\nvar prevTime;\n\n/**\n * Select a color.\n *\n * @return {Number}\n * @api private\n */\n\nfunction selectColor() {\n  return exports.colors[prevColor++ % exports.colors.length];\n}\n\n/**\n * Create a debugger with the given `namespace`.\n *\n * @param {String} namespace\n * @return {Function}\n * @api public\n */\n\nfunction debug(namespace) {\n\n  // define the `disabled` version\n  function disabled() {\n  }\n  disabled.enabled = false;\n\n  // define the `enabled` version\n  function enabled() {\n\n    var self = enabled;\n\n    // set `diff` timestamp\n    var curr = +new Date();\n    var ms = curr - (prevTime || curr);\n    self.diff = ms;\n    self.prev = prevTime;\n    self.curr = curr;\n    prevTime = curr;\n\n    // add the `color` if not set\n    if (null == self.useColors) self.useColors = exports.useColors();\n    if (null == self.color && self.useColors) self.color = selectColor();\n\n    var args = Array.prototype.slice.call(arguments);\n\n    args[0] = exports.coerce(args[0]);\n\n    if ('string' !== typeof args[0]) {\n      // anything else let's inspect with %o\n      args = ['%o'].concat(args);\n    }\n\n    // apply any `formatters` transformations\n    var index = 0;\n    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {\n      // if we encounter an escaped % then don't increase the array index\n      if (match === '%%') return match;\n      index++;\n      var formatter = exports.formatters[format];\n      if ('function' === typeof formatter) {\n        var val = args[index];\n        match = formatter.call(self, val);\n\n        // now we need to remove `args[index]` since it's inlined in the `format`\n        args.splice(index, 1);\n        index--;\n      }\n      return match;\n    });\n\n    if ('function' === typeof exports.formatArgs) {\n      args = exports.formatArgs.apply(self, args);\n    }\n    var logFn = enabled.log || exports.log || console.log.bind(console);\n    logFn.apply(self, args);\n  }\n  enabled.enabled = true;\n\n  var fn = exports.enabled(namespace) ? enabled : disabled;\n\n  fn.namespace = namespace;\n\n  return fn;\n}\n\n/**\n * Enables a debug mode by namespaces. This can include modes\n * separated by a colon and wildcards.\n *\n * @param {String} namespaces\n * @api public\n */\n\nfunction enable(namespaces) {\n  exports.save(namespaces);\n\n  var split = (namespaces || '').split(/[\\s,]+/);\n  var len = split.length;\n\n  for (var i = 0; i < len; i++) {\n    if (!split[i]) continue; // ignore empty strings\n    namespaces = split[i].replace(/\\*/g, '.*?');\n    if (namespaces[0] === '-') {\n      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));\n    } else {\n      exports.names.push(new RegExp('^' + namespaces + '$'));\n    }\n  }\n}\n\n/**\n * Disable debug output.\n *\n * @api public\n */\n\nfunction disable() {\n  exports.enable('');\n}\n\n/**\n * Returns true if the given mode name is enabled, false otherwise.\n *\n * @param {String} name\n * @return {Boolean}\n * @api public\n */\n\nfunction enabled(name) {\n  var i, len;\n  for (i = 0, len = exports.skips.length; i < len; i++) {\n    if (exports.skips[i].test(name)) {\n      return false;\n    }\n  }\n  for (i = 0, len = exports.names.length; i < len; i++) {\n    if (exports.names[i].test(name)) {\n      return true;\n    }\n  }\n  return false;\n}\n\n/**\n * Coerce `val`.\n *\n * @param {Mixed} val\n * @return {Mixed}\n * @api private\n */\n\nfunction coerce(val) {\n  if (val instanceof Error) return val.stack || val.message;\n  return val;\n}\n\n},{\"ms\":25}],19:[function(_dereq_,module,exports){\n(function (global){\n/**\n * Module dependencies.\n */\n\nvar keys = _dereq_('./keys');\nvar hasBinary = _dereq_('has-binary');\nvar sliceBuffer = _dereq_('arraybuffer.slice');\nvar base64encoder = _dereq_('base64-arraybuffer');\nvar after = _dereq_('after');\nvar utf8 = _dereq_('utf8');\n\n/**\n * Check if we are running an android browser. That requires us to use\n * ArrayBuffer with polling transports...\n *\n * http://ghinda.net/jpeg-blob-ajax-android/\n */\n\nvar isAndroid = navigator.userAgent.match(/Android/i);\n\n/**\n * Check if we are running in PhantomJS.\n * Uploading a Blob with PhantomJS does not work correctly, as reported here:\n * https://github.com/ariya/phantomjs/issues/11395\n * @type boolean\n */\nvar isPhantomJS = /PhantomJS/i.test(navigator.userAgent);\n\n/**\n * When true, avoids using Blobs to encode payloads.\n * @type boolean\n */\nvar dontSendBlobs = isAndroid || isPhantomJS;\n\n/**\n * Current protocol version.\n */\n\nexports.protocol = 3;\n\n/**\n * Packet types.\n */\n\nvar packets = exports.packets = {\n    open:     0    // non-ws\n  , close:    1    // non-ws\n  , ping:     2\n  , pong:     3\n  , message:  4\n  , upgrade:  5\n  , noop:     6\n};\n\nvar packetslist = keys(packets);\n\n/**\n * Premade error packet.\n */\n\nvar err = { type: 'error', data: 'parser error' };\n\n/**\n * Create a blob api even for blob builder when vendor prefixes exist\n */\n\nvar Blob = _dereq_('blob');\n\n/**\n * Encodes a packet.\n *\n *     <packet type id> [ <data> ]\n *\n * Example:\n *\n *     5hello world\n *     3\n *     4\n *\n * Binary is encoded in an identical principle\n *\n * @api private\n */\n\nexports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {\n  if ('function' == typeof supportsBinary) {\n    callback = supportsBinary;\n    supportsBinary = false;\n  }\n\n  if ('function' == typeof utf8encode) {\n    callback = utf8encode;\n    utf8encode = null;\n  }\n\n  var data = (packet.data === undefined)\n    ? undefined\n    : packet.data.buffer || packet.data;\n\n  if (global.ArrayBuffer && data instanceof ArrayBuffer) {\n    return encodeArrayBuffer(packet, supportsBinary, callback);\n  } else if (Blob && data instanceof global.Blob) {\n    return encodeBlob(packet, supportsBinary, callback);\n  }\n\n  // might be an object with { base64: true, data: dataAsBase64String }\n  if (data && data.base64) {\n    return encodeBase64Object(packet, callback);\n  }\n\n  // Sending data as a utf-8 string\n  var encoded = packets[packet.type];\n\n  // data fragment is optional\n  if (undefined !== packet.data) {\n    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);\n  }\n\n  return callback('' + encoded);\n\n};\n\nfunction encodeBase64Object(packet, callback) {\n  // packet data is an object { base64: true, data: dataAsBase64String }\n  var message = 'b' + exports.packets[packet.type] + packet.data.data;\n  return callback(message);\n}\n\n/**\n * Encode packet helpers for binary types\n */\n\nfunction encodeArrayBuffer(packet, supportsBinary, callback) {\n  if (!supportsBinary) {\n    return exports.encodeBase64Packet(packet, callback);\n  }\n\n  var data = packet.data;\n  var contentArray = new Uint8Array(data);\n  var resultBuffer = new Uint8Array(1 + data.byteLength);\n\n  resultBuffer[0] = packets[packet.type];\n  for (var i = 0; i < contentArray.length; i++) {\n    resultBuffer[i+1] = contentArray[i];\n  }\n\n  return callback(resultBuffer.buffer);\n}\n\nfunction encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {\n  if (!supportsBinary) {\n    return exports.encodeBase64Packet(packet, callback);\n  }\n\n  var fr = new FileReader();\n  fr.onload = function() {\n    packet.data = fr.result;\n    exports.encodePacket(packet, supportsBinary, true, callback);\n  };\n  return fr.readAsArrayBuffer(packet.data);\n}\n\nfunction encodeBlob(packet, supportsBinary, callback) {\n  if (!supportsBinary) {\n    return exports.encodeBase64Packet(packet, callback);\n  }\n\n  if (dontSendBlobs) {\n    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);\n  }\n\n  var length = new Uint8Array(1);\n  length[0] = packets[packet.type];\n  var blob = new Blob([length.buffer, packet.data]);\n\n  return callback(blob);\n}\n\n/**\n * Encodes a packet with binary data in a base64 string\n *\n * @param {Object} packet, has `type` and `data`\n * @return {String} base64 encoded message\n */\n\nexports.encodeBase64Packet = function(packet, callback) {\n  var message = 'b' + exports.packets[packet.type];\n  if (Blob && packet.data instanceof global.Blob) {\n    var fr = new FileReader();\n    fr.onload = function() {\n      var b64 = fr.result.split(',')[1];\n      callback(message + b64);\n    };\n    return fr.readAsDataURL(packet.data);\n  }\n\n  var b64data;\n  try {\n    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));\n  } catch (e) {\n    // iPhone Safari doesn't let you apply with typed arrays\n    var typed = new Uint8Array(packet.data);\n    var basic = new Array(typed.length);\n    for (var i = 0; i < typed.length; i++) {\n      basic[i] = typed[i];\n    }\n    b64data = String.fromCharCode.apply(null, basic);\n  }\n  message += global.btoa(b64data);\n  return callback(message);\n};\n\n/**\n * Decodes a packet. Changes format to Blob if requested.\n *\n * @return {Object} with `type` and `data` (if any)\n * @api private\n */\n\nexports.decodePacket = function (data, binaryType, utf8decode) {\n  // String data\n  if (typeof data == 'string' || data === undefined) {\n    if (data.charAt(0) == 'b') {\n      return exports.decodeBase64Packet(data.substr(1), binaryType);\n    }\n\n    if (utf8decode) {\n      try {\n        data = utf8.decode(data);\n      } catch (e) {\n        return err;\n      }\n    }\n    var type = data.charAt(0);\n\n    if (Number(type) != type || !packetslist[type]) {\n      return err;\n    }\n\n    if (data.length > 1) {\n      return { type: packetslist[type], data: data.substring(1) };\n    } else {\n      return { type: packetslist[type] };\n    }\n  }\n\n  var asArray = new Uint8Array(data);\n  var type = asArray[0];\n  var rest = sliceBuffer(data, 1);\n  if (Blob && binaryType === 'blob') {\n    rest = new Blob([rest]);\n  }\n  return { type: packetslist[type], data: rest };\n};\n\n/**\n * Decodes a packet encoded in a base64 string\n *\n * @param {String} base64 encoded message\n * @return {Object} with `type` and `data` (if any)\n */\n\nexports.decodeBase64Packet = function(msg, binaryType) {\n  var type = packetslist[msg.charAt(0)];\n  if (!global.ArrayBuffer) {\n    return { type: type, data: { base64: true, data: msg.substr(1) } };\n  }\n\n  var data = base64encoder.decode(msg.substr(1));\n\n  if (binaryType === 'blob' && Blob) {\n    data = new Blob([data]);\n  }\n\n  return { type: type, data: data };\n};\n\n/**\n * Encodes multiple messages (payload).\n *\n *     <length>:data\n *\n * Example:\n *\n *     11:hello world2:hi\n *\n * If any contents are binary, they will be encoded as base64 strings. Base64\n * encoded strings are marked with a b before the length specifier\n *\n * @param {Array} packets\n * @api private\n */\n\nexports.encodePayload = function (packets, supportsBinary, callback) {\n  if (typeof supportsBinary == 'function') {\n    callback = supportsBinary;\n    supportsBinary = null;\n  }\n\n  var isBinary = hasBinary(packets);\n\n  if (supportsBinary && isBinary) {\n    if (Blob && !dontSendBlobs) {\n      return exports.encodePayloadAsBlob(packets, callback);\n    }\n\n    return exports.encodePayloadAsArrayBuffer(packets, callback);\n  }\n\n  if (!packets.length) {\n    return callback('0:');\n  }\n\n  function setLengthHeader(message) {\n    return message.length + ':' + message;\n  }\n\n  function encodeOne(packet, doneCallback) {\n    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {\n      doneCallback(null, setLengthHeader(message));\n    });\n  }\n\n  map(packets, encodeOne, function(err, results) {\n    return callback(results.join(''));\n  });\n};\n\n/**\n * Async array map using after\n */\n\nfunction map(ary, each, done) {\n  var result = new Array(ary.length);\n  var next = after(ary.length, done);\n\n  var eachWithIndex = function(i, el, cb) {\n    each(el, function(error, msg) {\n      result[i] = msg;\n      cb(error, result);\n    });\n  };\n\n  for (var i = 0; i < ary.length; i++) {\n    eachWithIndex(i, ary[i], next);\n  }\n}\n\n/*\n * Decodes data when a payload is maybe expected. Possible binary contents are\n * decoded from their base64 representation\n *\n * @param {String} data, callback method\n * @api public\n */\n\nexports.decodePayload = function (data, binaryType, callback) {\n  if (typeof data != 'string') {\n    return exports.decodePayloadAsBinary(data, binaryType, callback);\n  }\n\n  if (typeof binaryType === 'function') {\n    callback = binaryType;\n    binaryType = null;\n  }\n\n  var packet;\n  if (data == '') {\n    // parser error - ignoring payload\n    return callback(err, 0, 1);\n  }\n\n  var length = ''\n    , n, msg;\n\n  for (var i = 0, l = data.length; i < l; i++) {\n    var chr = data.charAt(i);\n\n    if (':' != chr) {\n      length += chr;\n    } else {\n      if ('' == length || (length != (n = Number(length)))) {\n        // parser error - ignoring payload\n        return callback(err, 0, 1);\n      }\n\n      msg = data.substr(i + 1, n);\n\n      if (length != msg.length) {\n        // parser error - ignoring payload\n        return callback(err, 0, 1);\n      }\n\n      if (msg.length) {\n        packet = exports.decodePacket(msg, binaryType, true);\n\n        if (err.type == packet.type && err.data == packet.data) {\n          // parser error in individual packet - ignoring payload\n          return callback(err, 0, 1);\n        }\n\n        var ret = callback(packet, i + n, l);\n        if (false === ret) return;\n      }\n\n      // advance cursor\n      i += n;\n      length = '';\n    }\n  }\n\n  if (length != '') {\n    // parser error - ignoring payload\n    return callback(err, 0, 1);\n  }\n\n};\n\n/**\n * Encodes multiple messages (payload) as binary.\n *\n * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number\n * 255><data>\n *\n * Example:\n * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers\n *\n * @param {Array} packets\n * @return {ArrayBuffer} encoded payload\n * @api private\n */\n\nexports.encodePayloadAsArrayBuffer = function(packets, callback) {\n  if (!packets.length) {\n    return callback(new ArrayBuffer(0));\n  }\n\n  function encodeOne(packet, doneCallback) {\n    exports.encodePacket(packet, true, true, function(data) {\n      return doneCallback(null, data);\n    });\n  }\n\n  map(packets, encodeOne, function(err, encodedPackets) {\n    var totalLength = encodedPackets.reduce(function(acc, p) {\n      var len;\n      if (typeof p === 'string'){\n        len = p.length;\n      } else {\n        len = p.byteLength;\n      }\n      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2\n    }, 0);\n\n    var resultArray = new Uint8Array(totalLength);\n\n    var bufferIndex = 0;\n    encodedPackets.forEach(function(p) {\n      var isString = typeof p === 'string';\n      var ab = p;\n      if (isString) {\n        var view = new Uint8Array(p.length);\n        for (var i = 0; i < p.length; i++) {\n          view[i] = p.charCodeAt(i);\n        }\n        ab = view.buffer;\n      }\n\n      if (isString) { // not true binary\n        resultArray[bufferIndex++] = 0;\n      } else { // true binary\n        resultArray[bufferIndex++] = 1;\n      }\n\n      var lenStr = ab.byteLength.toString();\n      for (var i = 0; i < lenStr.length; i++) {\n        resultArray[bufferIndex++] = parseInt(lenStr[i]);\n      }\n      resultArray[bufferIndex++] = 255;\n\n      var view = new Uint8Array(ab);\n      for (var i = 0; i < view.length; i++) {\n        resultArray[bufferIndex++] = view[i];\n      }\n    });\n\n    return callback(resultArray.buffer);\n  });\n};\n\n/**\n * Encode as Blob\n */\n\nexports.encodePayloadAsBlob = function(packets, callback) {\n  function encodeOne(packet, doneCallback) {\n    exports.encodePacket(packet, true, true, function(encoded) {\n      var binaryIdentifier = new Uint8Array(1);\n      binaryIdentifier[0] = 1;\n      if (typeof encoded === 'string') {\n        var view = new Uint8Array(encoded.length);\n        for (var i = 0; i < encoded.length; i++) {\n          view[i] = encoded.charCodeAt(i);\n        }\n        encoded = view.buffer;\n        binaryIdentifier[0] = 0;\n      }\n\n      var len = (encoded instanceof ArrayBuffer)\n        ? encoded.byteLength\n        : encoded.size;\n\n      var lenStr = len.toString();\n      var lengthAry = new Uint8Array(lenStr.length + 1);\n      for (var i = 0; i < lenStr.length; i++) {\n        lengthAry[i] = parseInt(lenStr[i]);\n      }\n      lengthAry[lenStr.length] = 255;\n\n      if (Blob) {\n        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);\n        doneCallback(null, blob);\n      }\n    });\n  }\n\n  map(packets, encodeOne, function(err, results) {\n    return callback(new Blob(results));\n  });\n};\n\n/*\n * Decodes data when a payload is maybe expected. Strings are decoded by\n * interpreting each byte as a key code for entries marked to start with 0. See\n * description of encodePayloadAsBinary\n *\n * @param {ArrayBuffer} data, callback method\n * @api public\n */\n\nexports.decodePayloadAsBinary = function (data, binaryType, callback) {\n  if (typeof binaryType === 'function') {\n    callback = binaryType;\n    binaryType = null;\n  }\n\n  var bufferTail = data;\n  var buffers = [];\n\n  var numberTooLong = false;\n  while (bufferTail.byteLength > 0) {\n    var tailArray = new Uint8Array(bufferTail);\n    var isString = tailArray[0] === 0;\n    var msgLength = '';\n\n    for (var i = 1; ; i++) {\n      if (tailArray[i] == 255) break;\n\n      if (msgLength.length > 310) {\n        numberTooLong = true;\n        break;\n      }\n\n      msgLength += tailArray[i];\n    }\n\n    if(numberTooLong) return callback(err, 0, 1);\n\n    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);\n    msgLength = parseInt(msgLength);\n\n    var msg = sliceBuffer(bufferTail, 0, msgLength);\n    if (isString) {\n      try {\n        msg = String.fromCharCode.apply(null, new Uint8Array(msg));\n      } catch (e) {\n        // iPhone Safari doesn't let you apply to typed arrays\n        var typed = new Uint8Array(msg);\n        msg = '';\n        for (var i = 0; i < typed.length; i++) {\n          msg += String.fromCharCode(typed[i]);\n        }\n      }\n    }\n\n    buffers.push(msg);\n    bufferTail = sliceBuffer(bufferTail, msgLength);\n  }\n\n  var total = buffers.length;\n  buffers.forEach(function(buffer, i) {\n    callback(exports.decodePacket(buffer, binaryType, true), i, total);\n  });\n};\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"./keys\":20,\"after\":11,\"arraybuffer.slice\":12,\"base64-arraybuffer\":13,\"blob\":14,\"has-binary\":21,\"utf8\":29}],20:[function(_dereq_,module,exports){\n\n/**\n * Gets the keys for an object.\n *\n * @return {Array} keys\n * @api private\n */\n\nmodule.exports = Object.keys || function keys (obj){\n  var arr = [];\n  var has = Object.prototype.hasOwnProperty;\n\n  for (var i in obj) {\n    if (has.call(obj, i)) {\n      arr.push(i);\n    }\n  }\n  return arr;\n};\n\n},{}],21:[function(_dereq_,module,exports){\n(function (global){\n\n/*\n * Module requirements.\n */\n\nvar isArray = _dereq_('isarray');\n\n/**\n * Module exports.\n */\n\nmodule.exports = hasBinary;\n\n/**\n * Checks for binary data.\n *\n * Right now only Buffer and ArrayBuffer are supported..\n *\n * @param {Object} anything\n * @api public\n */\n\nfunction hasBinary(data) {\n\n  function _hasBinary(obj) {\n    if (!obj) return false;\n\n    if ( (global.Buffer && global.Buffer.isBuffer(obj)) ||\n         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||\n         (global.Blob && obj instanceof Blob) ||\n         (global.File && obj instanceof File)\n        ) {\n      return true;\n    }\n\n    if (isArray(obj)) {\n      for (var i = 0; i < obj.length; i++) {\n          if (_hasBinary(obj[i])) {\n              return true;\n          }\n      }\n    } else if (obj && 'object' == typeof obj) {\n      if (obj.toJSON) {\n        obj = obj.toJSON();\n      }\n\n      for (var key in obj) {\n        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {\n          return true;\n        }\n      }\n    }\n\n    return false;\n  }\n\n  return _hasBinary(data);\n}\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"isarray\":24}],22:[function(_dereq_,module,exports){\n\n/**\n * Module exports.\n *\n * Logic borrowed from Modernizr:\n *\n *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js\n */\n\ntry {\n  module.exports = typeof XMLHttpRequest !== 'undefined' &&\n    'withCredentials' in new XMLHttpRequest();\n} catch (err) {\n  // if XMLHttp support is disabled in IE then it will throw\n  // when trying to create\n  module.exports = false;\n}\n\n},{}],23:[function(_dereq_,module,exports){\n\nvar indexOf = [].indexOf;\n\nmodule.exports = function(arr, obj){\n  if (indexOf) return arr.indexOf(obj);\n  for (var i = 0; i < arr.length; ++i) {\n    if (arr[i] === obj) return i;\n  }\n  return -1;\n};\n},{}],24:[function(_dereq_,module,exports){\nmodule.exports = Array.isArray || function (arr) {\n  return Object.prototype.toString.call(arr) == '[object Array]';\n};\n\n},{}],25:[function(_dereq_,module,exports){\n/**\n * Helpers.\n */\n\nvar s = 1000;\nvar m = s * 60;\nvar h = m * 60;\nvar d = h * 24;\nvar y = d * 365.25;\n\n/**\n * Parse or format the given `val`.\n *\n * Options:\n *\n *  - `long` verbose formatting [false]\n *\n * @param {String|Number} val\n * @param {Object} options\n * @return {String|Number}\n * @api public\n */\n\nmodule.exports = function(val, options){\n  options = options || {};\n  if ('string' == typeof val) return parse(val);\n  return options.long\n    ? long(val)\n    : short(val);\n};\n\n/**\n * Parse the given `str` and return milliseconds.\n *\n * @param {String} str\n * @return {Number}\n * @api private\n */\n\nfunction parse(str) {\n  str = '' + str;\n  if (str.length > 10000) return;\n  var match = /^((?:\\d+)?\\.?\\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);\n  if (!match) return;\n  var n = parseFloat(match[1]);\n  var type = (match[2] || 'ms').toLowerCase();\n  switch (type) {\n    case 'years':\n    case 'year':\n    case 'yrs':\n    case 'yr':\n    case 'y':\n      return n * y;\n    case 'days':\n    case 'day':\n    case 'd':\n      return n * d;\n    case 'hours':\n    case 'hour':\n    case 'hrs':\n    case 'hr':\n    case 'h':\n      return n * h;\n    case 'minutes':\n    case 'minute':\n    case 'mins':\n    case 'min':\n    case 'm':\n      return n * m;\n    case 'seconds':\n    case 'second':\n    case 'secs':\n    case 'sec':\n    case 's':\n      return n * s;\n    case 'milliseconds':\n    case 'millisecond':\n    case 'msecs':\n    case 'msec':\n    case 'ms':\n      return n;\n  }\n}\n\n/**\n * Short format for `ms`.\n *\n * @param {Number} ms\n * @return {String}\n * @api private\n */\n\nfunction short(ms) {\n  if (ms >= d) return Math.round(ms / d) + 'd';\n  if (ms >= h) return Math.round(ms / h) + 'h';\n  if (ms >= m) return Math.round(ms / m) + 'm';\n  if (ms >= s) return Math.round(ms / s) + 's';\n  return ms + 'ms';\n}\n\n/**\n * Long format for `ms`.\n *\n * @param {Number} ms\n * @return {String}\n * @api private\n */\n\nfunction long(ms) {\n  return plural(ms, d, 'day')\n    || plural(ms, h, 'hour')\n    || plural(ms, m, 'minute')\n    || plural(ms, s, 'second')\n    || ms + ' ms';\n}\n\n/**\n * Pluralization helper.\n */\n\nfunction plural(ms, n, name) {\n  if (ms < n) return;\n  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;\n  return Math.ceil(ms / n) + ' ' + name + 's';\n}\n\n},{}],26:[function(_dereq_,module,exports){\n(function (global){\n/**\n * JSON parse.\n *\n * @see Based on jQuery#parseJSON (MIT) and JSON2\n * @api private\n */\n\nvar rvalidchars = /^[\\],:{}\\s]*$/;\nvar rvalidescape = /\\\\(?:[\"\\\\\\/bfnrt]|u[0-9a-fA-F]{4})/g;\nvar rvalidtokens = /\"[^\"\\\\\\n\\r]*\"|true|false|null|-?\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d+)?/g;\nvar rvalidbraces = /(?:^|:|,)(?:\\s*\\[)+/g;\nvar rtrimLeft = /^\\s+/;\nvar rtrimRight = /\\s+$/;\n\nmodule.exports = function parsejson(data) {\n  if ('string' != typeof data || !data) {\n    return null;\n  }\n\n  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');\n\n  // Attempt to parse using the native JSON parser first\n  if (global.JSON && JSON.parse) {\n    return JSON.parse(data);\n  }\n\n  if (rvalidchars.test(data.replace(rvalidescape, '@')\n      .replace(rvalidtokens, ']')\n      .replace(rvalidbraces, ''))) {\n    return (new Function('return ' + data))();\n  }\n};\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{}],27:[function(_dereq_,module,exports){\n/**\n * Compiles a querystring\n * Returns string representation of the object\n *\n * @param {Object}\n * @api private\n */\n\nexports.encode = function (obj) {\n  var str = '';\n\n  for (var i in obj) {\n    if (obj.hasOwnProperty(i)) {\n      if (str.length) str += '&';\n      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);\n    }\n  }\n\n  return str;\n};\n\n/**\n * Parses a simple querystring into an object\n *\n * @param {String} qs\n * @api private\n */\n\nexports.decode = function(qs){\n  var qry = {};\n  var pairs = qs.split('&');\n  for (var i = 0, l = pairs.length; i < l; i++) {\n    var pair = pairs[i].split('=');\n    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);\n  }\n  return qry;\n};\n\n},{}],28:[function(_dereq_,module,exports){\n/**\n * Parses an URI\n *\n * @author Steven Levithan <stevenlevithan.com> (MIT license)\n * @api private\n */\n\nvar re = /^(?:(?![^:@]+:[^:@\\/]*@)(http|https|ws|wss):\\/\\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\\/?#]*)(?::(\\d*))?)(((\\/(?:[^?#](?![^?#\\/]*\\.[^?#\\/.]+(?:[?#]|$)))*\\/?)?([^?#\\/]*))(?:\\?([^#]*))?(?:#(.*))?)/;\n\nvar parts = [\n    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'\n];\n\nmodule.exports = function parseuri(str) {\n    var src = str,\n        b = str.indexOf('['),\n        e = str.indexOf(']');\n\n    if (b != -1 && e != -1) {\n        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);\n    }\n\n    var m = re.exec(str || ''),\n        uri = {},\n        i = 14;\n\n    while (i--) {\n        uri[parts[i]] = m[i] || '';\n    }\n\n    if (b != -1 && e != -1) {\n        uri.source = src;\n        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');\n        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');\n        uri.ipv6uri = true;\n    }\n\n    return uri;\n};\n\n},{}],29:[function(_dereq_,module,exports){\n(function (global){\n/*! https://mths.be/utf8js v2.0.0 by @mathias */\n;(function(root) {\n\n\t// Detect free variables `exports`\n\tvar freeExports = typeof exports == 'object' && exports;\n\n\t// Detect free variable `module`\n\tvar freeModule = typeof module == 'object' && module &&\n\t\tmodule.exports == freeExports && module;\n\n\t// Detect free variable `global`, from Node.js or Browserified code,\n\t// and use it as `root`\n\tvar freeGlobal = typeof global == 'object' && global;\n\tif (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {\n\t\troot = freeGlobal;\n\t}\n\n\t/*--------------------------------------------------------------------------*/\n\n\tvar stringFromCharCode = String.fromCharCode;\n\n\t// Taken from https://mths.be/punycode\n\tfunction ucs2decode(string) {\n\t\tvar output = [];\n\t\tvar counter = 0;\n\t\tvar length = string.length;\n\t\tvar value;\n\t\tvar extra;\n\t\twhile (counter < length) {\n\t\t\tvalue = string.charCodeAt(counter++);\n\t\t\tif (value >= 0xD800 && value <= 0xDBFF && counter < length) {\n\t\t\t\t// high surrogate, and there is a next character\n\t\t\t\textra = string.charCodeAt(counter++);\n\t\t\t\tif ((extra & 0xFC00) == 0xDC00) { // low surrogate\n\t\t\t\t\toutput.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);\n\t\t\t\t} else {\n\t\t\t\t\t// unmatched surrogate; only append this code unit, in case the next\n\t\t\t\t\t// code unit is the high surrogate of a surrogate pair\n\t\t\t\t\toutput.push(value);\n\t\t\t\t\tcounter--;\n\t\t\t\t}\n\t\t\t} else {\n\t\t\t\toutput.push(value);\n\t\t\t}\n\t\t}\n\t\treturn output;\n\t}\n\n\t// Taken from https://mths.be/punycode\n\tfunction ucs2encode(array) {\n\t\tvar length = array.length;\n\t\tvar index = -1;\n\t\tvar value;\n\t\tvar output = '';\n\t\twhile (++index < length) {\n\t\t\tvalue = array[index];\n\t\t\tif (value > 0xFFFF) {\n\t\t\t\tvalue -= 0x10000;\n\t\t\t\toutput += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);\n\t\t\t\tvalue = 0xDC00 | value & 0x3FF;\n\t\t\t}\n\t\t\toutput += stringFromCharCode(value);\n\t\t}\n\t\treturn output;\n\t}\n\n\tfunction checkScalarValue(codePoint) {\n\t\tif (codePoint >= 0xD800 && codePoint <= 0xDFFF) {\n\t\t\tthrow Error(\n\t\t\t\t'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +\n\t\t\t\t' is not a scalar value'\n\t\t\t);\n\t\t}\n\t}\n\t/*--------------------------------------------------------------------------*/\n\n\tfunction createByte(codePoint, shift) {\n\t\treturn stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);\n\t}\n\n\tfunction encodeCodePoint(codePoint) {\n\t\tif ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence\n\t\t\treturn stringFromCharCode(codePoint);\n\t\t}\n\t\tvar symbol = '';\n\t\tif ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence\n\t\t\tsymbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);\n\t\t}\n\t\telse if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence\n\t\t\tcheckScalarValue(codePoint);\n\t\t\tsymbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);\n\t\t\tsymbol += createByte(codePoint, 6);\n\t\t}\n\t\telse if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence\n\t\t\tsymbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);\n\t\t\tsymbol += createByte(codePoint, 12);\n\t\t\tsymbol += createByte(codePoint, 6);\n\t\t}\n\t\tsymbol += stringFromCharCode((codePoint & 0x3F) | 0x80);\n\t\treturn symbol;\n\t}\n\n\tfunction utf8encode(string) {\n\t\tvar codePoints = ucs2decode(string);\n\t\tvar length = codePoints.length;\n\t\tvar index = -1;\n\t\tvar codePoint;\n\t\tvar byteString = '';\n\t\twhile (++index < length) {\n\t\t\tcodePoint = codePoints[index];\n\t\t\tbyteString += encodeCodePoint(codePoint);\n\t\t}\n\t\treturn byteString;\n\t}\n\n\t/*--------------------------------------------------------------------------*/\n\n\tfunction readContinuationByte() {\n\t\tif (byteIndex >= byteCount) {\n\t\t\tthrow Error('Invalid byte index');\n\t\t}\n\n\t\tvar continuationByte = byteArray[byteIndex] & 0xFF;\n\t\tbyteIndex++;\n\n\t\tif ((continuationByte & 0xC0) == 0x80) {\n\t\t\treturn continuationByte & 0x3F;\n\t\t}\n\n\t\t// If we end up here, it’s not a continuation byte\n\t\tthrow Error('Invalid continuation byte');\n\t}\n\n\tfunction decodeSymbol() {\n\t\tvar byte1;\n\t\tvar byte2;\n\t\tvar byte3;\n\t\tvar byte4;\n\t\tvar codePoint;\n\n\t\tif (byteIndex > byteCount) {\n\t\t\tthrow Error('Invalid byte index');\n\t\t}\n\n\t\tif (byteIndex == byteCount) {\n\t\t\treturn false;\n\t\t}\n\n\t\t// Read first byte\n\t\tbyte1 = byteArray[byteIndex] & 0xFF;\n\t\tbyteIndex++;\n\n\t\t// 1-byte sequence (no continuation bytes)\n\t\tif ((byte1 & 0x80) == 0) {\n\t\t\treturn byte1;\n\t\t}\n\n\t\t// 2-byte sequence\n\t\tif ((byte1 & 0xE0) == 0xC0) {\n\t\t\tvar byte2 = readContinuationByte();\n\t\t\tcodePoint = ((byte1 & 0x1F) << 6) | byte2;\n\t\t\tif (codePoint >= 0x80) {\n\t\t\t\treturn codePoint;\n\t\t\t} else {\n\t\t\t\tthrow Error('Invalid continuation byte');\n\t\t\t}\n\t\t}\n\n\t\t// 3-byte sequence (may include unpaired surrogates)\n\t\tif ((byte1 & 0xF0) == 0xE0) {\n\t\t\tbyte2 = readContinuationByte();\n\t\t\tbyte3 = readContinuationByte();\n\t\t\tcodePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;\n\t\t\tif (codePoint >= 0x0800) {\n\t\t\t\tcheckScalarValue(codePoint);\n\t\t\t\treturn codePoint;\n\t\t\t} else {\n\t\t\t\tthrow Error('Invalid continuation byte');\n\t\t\t}\n\t\t}\n\n\t\t// 4-byte sequence\n\t\tif ((byte1 & 0xF8) == 0xF0) {\n\t\t\tbyte2 = readContinuationByte();\n\t\t\tbyte3 = readContinuationByte();\n\t\t\tbyte4 = readContinuationByte();\n\t\t\tcodePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |\n\t\t\t\t(byte3 << 0x06) | byte4;\n\t\t\tif (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {\n\t\t\t\treturn codePoint;\n\t\t\t}\n\t\t}\n\n\t\tthrow Error('Invalid UTF-8 detected');\n\t}\n\n\tvar byteArray;\n\tvar byteCount;\n\tvar byteIndex;\n\tfunction utf8decode(byteString) {\n\t\tbyteArray = ucs2decode(byteString);\n\t\tbyteCount = byteArray.length;\n\t\tbyteIndex = 0;\n\t\tvar codePoints = [];\n\t\tvar tmp;\n\t\twhile ((tmp = decodeSymbol()) !== false) {\n\t\t\tcodePoints.push(tmp);\n\t\t}\n\t\treturn ucs2encode(codePoints);\n\t}\n\n\t/*--------------------------------------------------------------------------*/\n\n\tvar utf8 = {\n\t\t'version': '2.0.0',\n\t\t'encode': utf8encode,\n\t\t'decode': utf8decode\n\t};\n\n\t// Some AMD build optimizers, like r.js, check for specific condition patterns\n\t// like the following:\n\tif (\n\t\ttypeof define == 'function' &&\n\t\ttypeof define.amd == 'object' &&\n\t\tdefine.amd\n\t) {\n\t\tdefine(function() {\n\t\t\treturn utf8;\n\t\t});\n\t}\telse if (freeExports && !freeExports.nodeType) {\n\t\tif (freeModule) { // in Node.js or RingoJS v0.8.0+\n\t\t\tfreeModule.exports = utf8;\n\t\t} else { // in Narwhal or RingoJS v0.7.0-\n\t\t\tvar object = {};\n\t\t\tvar hasOwnProperty = object.hasOwnProperty;\n\t\t\tfor (var key in utf8) {\n\t\t\t\thasOwnProperty.call(utf8, key) && (freeExports[key] = utf8[key]);\n\t\t\t}\n\t\t}\n\t} else { // in Rhino or a web browser\n\t\troot.utf8 = utf8;\n\t}\n\n}(this));\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{}],30:[function(_dereq_,module,exports){\n'use strict';\n\nvar alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')\n  , length = 64\n  , map = {}\n  , seed = 0\n  , i = 0\n  , prev;\n\n/**\n * Return a string representing the specified number.\n *\n * @param {Number} num The number to convert.\n * @returns {String} The string representation of the number.\n * @api public\n */\nfunction encode(num) {\n  var encoded = '';\n\n  do {\n    encoded = alphabet[num % length] + encoded;\n    num = Math.floor(num / length);\n  } while (num > 0);\n\n  return encoded;\n}\n\n/**\n * Return the integer value specified by the given string.\n *\n * @param {String} str The string to convert.\n * @returns {Number} The integer value represented by the string.\n * @api public\n */\nfunction decode(str) {\n  var decoded = 0;\n\n  for (i = 0; i < str.length; i++) {\n    decoded = decoded * length + map[str.charAt(i)];\n  }\n\n  return decoded;\n}\n\n/**\n * Yeast: A tiny growing id generator.\n *\n * @returns {String} A unique id.\n * @api public\n */\nfunction yeast() {\n  var now = encode(+new Date());\n\n  if (now !== prev) return seed = 0, prev = now;\n  return now +'.'+ encode(seed++);\n}\n\n//\n// Map each character to its index.\n//\nfor (; i < length; i++) map[alphabet[i]] = i;\n\n//\n// Expose the `yeast`, `encode` and `decode` functions.\n//\nyeast.encode = encode;\nyeast.decode = decode;\nmodule.exports = yeast;\n\n},{}],31:[function(_dereq_,module,exports){\n\n/**\n * Module dependencies.\n */\n\nvar url = _dereq_('./url');\nvar parser = _dereq_('socket.io-parser');\nvar Manager = _dereq_('./manager');\nvar debug = _dereq_('debug')('socket.io-client');\n\n/**\n * Module exports.\n */\n\nmodule.exports = exports = lookup;\n\n/**\n * Managers cache.\n */\n\nvar cache = exports.managers = {};\n\n/**\n * Looks up an existing `Manager` for multiplexing.\n * If the user summons:\n *\n *   `io('http://localhost/a');`\n *   `io('http://localhost/b');`\n *\n * We reuse the existing instance based on same scheme/port/host,\n * and we initialize sockets for each namespace.\n *\n * @api public\n */\n\nfunction lookup(uri, opts) {\n  if (typeof uri == 'object') {\n    opts = uri;\n    uri = undefined;\n  }\n\n  opts = opts || {};\n\n  var parsed = url(uri);\n  var source = parsed.source;\n  var id = parsed.id;\n  var path = parsed.path;\n  var sameNamespace = cache[id] && path in cache[id].nsps;\n  var newConnection = opts.forceNew || opts['force new connection'] ||\n                      false === opts.multiplex || sameNamespace;\n\n  var io;\n\n  if (newConnection) {\n    debug('ignoring socket cache for %s', source);\n    io = Manager(source, opts);\n  } else {\n    if (!cache[id]) {\n      debug('new io instance for %s', source);\n      cache[id] = Manager(source, opts);\n    }\n    io = cache[id];\n  }\n\n  return io.socket(parsed.path);\n}\n\n/**\n * Protocol version.\n *\n * @api public\n */\n\nexports.protocol = parser.protocol;\n\n/**\n * `connect`.\n *\n * @param {String} uri\n * @api public\n */\n\nexports.connect = lookup;\n\n/**\n * Expose constructors for standalone build.\n *\n * @api public\n */\n\nexports.Manager = _dereq_('./manager');\nexports.Socket = _dereq_('./socket');\n\n},{\"./manager\":32,\"./socket\":34,\"./url\":35,\"debug\":39,\"socket.io-parser\":47}],32:[function(_dereq_,module,exports){\n\n/**\n * Module dependencies.\n */\n\nvar eio = _dereq_('engine.io-client');\nvar Socket = _dereq_('./socket');\nvar Emitter = _dereq_('component-emitter');\nvar parser = _dereq_('socket.io-parser');\nvar on = _dereq_('./on');\nvar bind = _dereq_('component-bind');\nvar debug = _dereq_('debug')('socket.io-client:manager');\nvar indexOf = _dereq_('indexof');\nvar Backoff = _dereq_('backo2');\n\n/**\n * IE6+ hasOwnProperty\n */\n\nvar has = Object.prototype.hasOwnProperty;\n\n/**\n * Module exports\n */\n\nmodule.exports = Manager;\n\n/**\n * `Manager` constructor.\n *\n * @param {String} engine instance or engine uri/opts\n * @param {Object} options\n * @api public\n */\n\nfunction Manager(uri, opts){\n  if (!(this instanceof Manager)) return new Manager(uri, opts);\n  if (uri && ('object' == typeof uri)) {\n    opts = uri;\n    uri = undefined;\n  }\n  opts = opts || {};\n\n  opts.path = opts.path || '/socket.io';\n  this.nsps = {};\n  this.subs = [];\n  this.opts = opts;\n  this.reconnection(opts.reconnection !== false);\n  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);\n  this.reconnectionDelay(opts.reconnectionDelay || 1000);\n  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);\n  this.randomizationFactor(opts.randomizationFactor || 0.5);\n  this.backoff = new Backoff({\n    min: this.reconnectionDelay(),\n    max: this.reconnectionDelayMax(),\n    jitter: this.randomizationFactor()\n  });\n  this.timeout(null == opts.timeout ? 20000 : opts.timeout);\n  this.readyState = 'closed';\n  this.uri = uri;\n  this.connecting = [];\n  this.lastPing = null;\n  this.encoding = false;\n  this.packetBuffer = [];\n  this.encoder = new parser.Encoder();\n  this.decoder = new parser.Decoder();\n  this.autoConnect = opts.autoConnect !== false;\n  if (this.autoConnect) this.open();\n}\n\n/**\n * Propagate given event to sockets and emit on `this`\n *\n * @api private\n */\n\nManager.prototype.emitAll = function() {\n  this.emit.apply(this, arguments);\n  for (var nsp in this.nsps) {\n    if (has.call(this.nsps, nsp)) {\n      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);\n    }\n  }\n};\n\n/**\n * Update `socket.id` of all sockets\n *\n * @api private\n */\n\nManager.prototype.updateSocketIds = function(){\n  for (var nsp in this.nsps) {\n    if (has.call(this.nsps, nsp)) {\n      this.nsps[nsp].id = this.engine.id;\n    }\n  }\n};\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Manager.prototype);\n\n/**\n * Sets the `reconnection` config.\n *\n * @param {Boolean} true/false if it should automatically reconnect\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.reconnection = function(v){\n  if (!arguments.length) return this._reconnection;\n  this._reconnection = !!v;\n  return this;\n};\n\n/**\n * Sets the reconnection attempts config.\n *\n * @param {Number} max reconnection attempts before giving up\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.reconnectionAttempts = function(v){\n  if (!arguments.length) return this._reconnectionAttempts;\n  this._reconnectionAttempts = v;\n  return this;\n};\n\n/**\n * Sets the delay between reconnections.\n *\n * @param {Number} delay\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.reconnectionDelay = function(v){\n  if (!arguments.length) return this._reconnectionDelay;\n  this._reconnectionDelay = v;\n  this.backoff && this.backoff.setMin(v);\n  return this;\n};\n\nManager.prototype.randomizationFactor = function(v){\n  if (!arguments.length) return this._randomizationFactor;\n  this._randomizationFactor = v;\n  this.backoff && this.backoff.setJitter(v);\n  return this;\n};\n\n/**\n * Sets the maximum delay between reconnections.\n *\n * @param {Number} delay\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.reconnectionDelayMax = function(v){\n  if (!arguments.length) return this._reconnectionDelayMax;\n  this._reconnectionDelayMax = v;\n  this.backoff && this.backoff.setMax(v);\n  return this;\n};\n\n/**\n * Sets the connection timeout. `false` to disable\n *\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.timeout = function(v){\n  if (!arguments.length) return this._timeout;\n  this._timeout = v;\n  return this;\n};\n\n/**\n * Starts trying to reconnect if reconnection is enabled and we have not\n * started reconnecting yet\n *\n * @api private\n */\n\nManager.prototype.maybeReconnectOnOpen = function() {\n  // Only try to reconnect if it's the first time we're connecting\n  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {\n    // keeps reconnection from firing twice for the same reconnection loop\n    this.reconnect();\n  }\n};\n\n\n/**\n * Sets the current transport `socket`.\n *\n * @param {Function} optional, callback\n * @return {Manager} self\n * @api public\n */\n\nManager.prototype.open =\nManager.prototype.connect = function(fn){\n  debug('readyState %s', this.readyState);\n  if (~this.readyState.indexOf('open')) return this;\n\n  debug('opening %s', this.uri);\n  this.engine = eio(this.uri, this.opts);\n  var socket = this.engine;\n  var self = this;\n  this.readyState = 'opening';\n  this.skipReconnect = false;\n\n  // emit `open`\n  var openSub = on(socket, 'open', function() {\n    self.onopen();\n    fn && fn();\n  });\n\n  // emit `connect_error`\n  var errorSub = on(socket, 'error', function(data){\n    debug('connect_error');\n    self.cleanup();\n    self.readyState = 'closed';\n    self.emitAll('connect_error', data);\n    if (fn) {\n      var err = new Error('Connection error');\n      err.data = data;\n      fn(err);\n    } else {\n      // Only do this if there is no fn to handle the error\n      self.maybeReconnectOnOpen();\n    }\n  });\n\n  // emit `connect_timeout`\n  if (false !== this._timeout) {\n    var timeout = this._timeout;\n    debug('connect attempt will timeout after %d', timeout);\n\n    // set timer\n    var timer = setTimeout(function(){\n      debug('connect attempt timed out after %d', timeout);\n      openSub.destroy();\n      socket.close();\n      socket.emit('error', 'timeout');\n      self.emitAll('connect_timeout', timeout);\n    }, timeout);\n\n    this.subs.push({\n      destroy: function(){\n        clearTimeout(timer);\n      }\n    });\n  }\n\n  this.subs.push(openSub);\n  this.subs.push(errorSub);\n\n  return this;\n};\n\n/**\n * Called upon transport open.\n *\n * @api private\n */\n\nManager.prototype.onopen = function(){\n  debug('open');\n\n  // clear old subs\n  this.cleanup();\n\n  // mark as open\n  this.readyState = 'open';\n  this.emit('open');\n\n  // add new subs\n  var socket = this.engine;\n  this.subs.push(on(socket, 'data', bind(this, 'ondata')));\n  this.subs.push(on(socket, 'ping', bind(this, 'onping')));\n  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));\n  this.subs.push(on(socket, 'error', bind(this, 'onerror')));\n  this.subs.push(on(socket, 'close', bind(this, 'onclose')));\n  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));\n};\n\n/**\n * Called upon a ping.\n *\n * @api private\n */\n\nManager.prototype.onping = function(){\n  this.lastPing = new Date;\n  this.emitAll('ping');\n};\n\n/**\n * Called upon a packet.\n *\n * @api private\n */\n\nManager.prototype.onpong = function(){\n  this.emitAll('pong', new Date - this.lastPing);\n};\n\n/**\n * Called with data.\n *\n * @api private\n */\n\nManager.prototype.ondata = function(data){\n  this.decoder.add(data);\n};\n\n/**\n * Called when parser fully decodes a packet.\n *\n * @api private\n */\n\nManager.prototype.ondecoded = function(packet) {\n  this.emit('packet', packet);\n};\n\n/**\n * Called upon socket error.\n *\n * @api private\n */\n\nManager.prototype.onerror = function(err){\n  debug('error', err);\n  this.emitAll('error', err);\n};\n\n/**\n * Creates a new socket for the given `nsp`.\n *\n * @return {Socket}\n * @api public\n */\n\nManager.prototype.socket = function(nsp){\n  var socket = this.nsps[nsp];\n  if (!socket) {\n    socket = new Socket(this, nsp);\n    this.nsps[nsp] = socket;\n    var self = this;\n    socket.on('connecting', onConnecting);\n    socket.on('connect', function(){\n      socket.id = self.engine.id;\n    });\n\n    if (this.autoConnect) {\n      // manually call here since connecting evnet is fired before listening\n      onConnecting();\n    }\n  }\n\n  function onConnecting() {\n    if (!~indexOf(self.connecting, socket)) {\n      self.connecting.push(socket);\n    }\n  }\n\n  return socket;\n};\n\n/**\n * Called upon a socket close.\n *\n * @param {Socket} socket\n */\n\nManager.prototype.destroy = function(socket){\n  var index = indexOf(this.connecting, socket);\n  if (~index) this.connecting.splice(index, 1);\n  if (this.connecting.length) return;\n\n  this.close();\n};\n\n/**\n * Writes a packet.\n *\n * @param {Object} packet\n * @api private\n */\n\nManager.prototype.packet = function(packet){\n  debug('writing packet %j', packet);\n  var self = this;\n\n  if (!self.encoding) {\n    // encode, then write to engine with result\n    self.encoding = true;\n    this.encoder.encode(packet, function(encodedPackets) {\n      for (var i = 0; i < encodedPackets.length; i++) {\n        self.engine.write(encodedPackets[i], packet.options);\n      }\n      self.encoding = false;\n      self.processPacketQueue();\n    });\n  } else { // add packet to the queue\n    self.packetBuffer.push(packet);\n  }\n};\n\n/**\n * If packet buffer is non-empty, begins encoding the\n * next packet in line.\n *\n * @api private\n */\n\nManager.prototype.processPacketQueue = function() {\n  if (this.packetBuffer.length > 0 && !this.encoding) {\n    var pack = this.packetBuffer.shift();\n    this.packet(pack);\n  }\n};\n\n/**\n * Clean up transport subscriptions and packet buffer.\n *\n * @api private\n */\n\nManager.prototype.cleanup = function(){\n  debug('cleanup');\n\n  var sub;\n  while (sub = this.subs.shift()) sub.destroy();\n\n  this.packetBuffer = [];\n  this.encoding = false;\n  this.lastPing = null;\n\n  this.decoder.destroy();\n};\n\n/**\n * Close the current socket.\n *\n * @api private\n */\n\nManager.prototype.close =\nManager.prototype.disconnect = function(){\n  debug('disconnect');\n  this.skipReconnect = true;\n  this.reconnecting = false;\n  if ('opening' == this.readyState) {\n    // `onclose` will not fire because\n    // an open event never happened\n    this.cleanup();\n  }\n  this.backoff.reset();\n  this.readyState = 'closed';\n  if (this.engine) this.engine.close();\n};\n\n/**\n * Called upon engine close.\n *\n * @api private\n */\n\nManager.prototype.onclose = function(reason){\n  debug('onclose');\n\n  this.cleanup();\n  this.backoff.reset();\n  this.readyState = 'closed';\n  this.emit('close', reason);\n\n  if (this._reconnection && !this.skipReconnect) {\n    this.reconnect();\n  }\n};\n\n/**\n * Attempt a reconnection.\n *\n * @api private\n */\n\nManager.prototype.reconnect = function(){\n  if (this.reconnecting || this.skipReconnect) return this;\n\n  var self = this;\n\n  if (this.backoff.attempts >= this._reconnectionAttempts) {\n    debug('reconnect failed');\n    this.backoff.reset();\n    this.emitAll('reconnect_failed');\n    this.reconnecting = false;\n  } else {\n    var delay = this.backoff.duration();\n    debug('will wait %dms before reconnect attempt', delay);\n\n    this.reconnecting = true;\n    var timer = setTimeout(function(){\n      if (self.skipReconnect) return;\n\n      debug('attempting reconnect');\n      self.emitAll('reconnect_attempt', self.backoff.attempts);\n      self.emitAll('reconnecting', self.backoff.attempts);\n\n      // check again for the case socket closed in above events\n      if (self.skipReconnect) return;\n\n      self.open(function(err){\n        if (err) {\n          debug('reconnect attempt error');\n          self.reconnecting = false;\n          self.reconnect();\n          self.emitAll('reconnect_error', err.data);\n        } else {\n          debug('reconnect success');\n          self.onreconnect();\n        }\n      });\n    }, delay);\n\n    this.subs.push({\n      destroy: function(){\n        clearTimeout(timer);\n      }\n    });\n  }\n};\n\n/**\n * Called upon successful reconnect.\n *\n * @api private\n */\n\nManager.prototype.onreconnect = function(){\n  var attempt = this.backoff.attempts;\n  this.reconnecting = false;\n  this.backoff.reset();\n  this.updateSocketIds();\n  this.emitAll('reconnect', attempt);\n};\n\n},{\"./on\":33,\"./socket\":34,\"backo2\":36,\"component-bind\":37,\"component-emitter\":38,\"debug\":39,\"engine.io-client\":1,\"indexof\":42,\"socket.io-parser\":47}],33:[function(_dereq_,module,exports){\n\n/**\n * Module exports.\n */\n\nmodule.exports = on;\n\n/**\n * Helper for subscriptions.\n *\n * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`\n * @param {String} event name\n * @param {Function} callback\n * @api public\n */\n\nfunction on(obj, ev, fn) {\n  obj.on(ev, fn);\n  return {\n    destroy: function(){\n      obj.removeListener(ev, fn);\n    }\n  };\n}\n\n},{}],34:[function(_dereq_,module,exports){\n\n/**\n * Module dependencies.\n */\n\nvar parser = _dereq_('socket.io-parser');\nvar Emitter = _dereq_('component-emitter');\nvar toArray = _dereq_('to-array');\nvar on = _dereq_('./on');\nvar bind = _dereq_('component-bind');\nvar debug = _dereq_('debug')('socket.io-client:socket');\nvar hasBin = _dereq_('has-binary');\n\n/**\n * Module exports.\n */\n\nmodule.exports = exports = Socket;\n\n/**\n * Internal events (blacklisted).\n * These events can't be emitted by the user.\n *\n * @api private\n */\n\nvar events = {\n  connect: 1,\n  connect_error: 1,\n  connect_timeout: 1,\n  connecting: 1,\n  disconnect: 1,\n  error: 1,\n  reconnect: 1,\n  reconnect_attempt: 1,\n  reconnect_failed: 1,\n  reconnect_error: 1,\n  reconnecting: 1,\n  ping: 1,\n  pong: 1\n};\n\n/**\n * Shortcut to `Emitter#emit`.\n */\n\nvar emit = Emitter.prototype.emit;\n\n/**\n * `Socket` constructor.\n *\n * @api public\n */\n\nfunction Socket(io, nsp){\n  this.io = io;\n  this.nsp = nsp;\n  this.json = this; // compat\n  this.ids = 0;\n  this.acks = {};\n  this.receiveBuffer = [];\n  this.sendBuffer = [];\n  this.connected = false;\n  this.disconnected = true;\n  if (this.io.autoConnect) this.open();\n}\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Socket.prototype);\n\n/**\n * Subscribe to open, close and packet events\n *\n * @api private\n */\n\nSocket.prototype.subEvents = function() {\n  if (this.subs) return;\n\n  var io = this.io;\n  this.subs = [\n    on(io, 'open', bind(this, 'onopen')),\n    on(io, 'packet', bind(this, 'onpacket')),\n    on(io, 'close', bind(this, 'onclose'))\n  ];\n};\n\n/**\n * \"Opens\" the socket.\n *\n * @api public\n */\n\nSocket.prototype.open =\nSocket.prototype.connect = function(){\n  if (this.connected) return this;\n\n  this.subEvents();\n  this.io.open(); // ensure open\n  if ('open' == this.io.readyState) this.onopen();\n  this.emit('connecting');\n  return this;\n};\n\n/**\n * Sends a `message` event.\n *\n * @return {Socket} self\n * @api public\n */\n\nSocket.prototype.send = function(){\n  var args = toArray(arguments);\n  args.unshift('message');\n  this.emit.apply(this, args);\n  return this;\n};\n\n/**\n * Override `emit`.\n * If the event is in `events`, it's emitted normally.\n *\n * @param {String} event name\n * @return {Socket} self\n * @api public\n */\n\nSocket.prototype.emit = function(ev){\n  if (events.hasOwnProperty(ev)) {\n    emit.apply(this, arguments);\n    return this;\n  }\n\n  var args = toArray(arguments);\n  var parserType = parser.EVENT; // default\n  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary\n  var packet = { type: parserType, data: args };\n\n  packet.options = {};\n  packet.options.compress = !this.flags || false !== this.flags.compress;\n\n  // event ack callback\n  if ('function' == typeof args[args.length - 1]) {\n    debug('emitting packet with ack id %d', this.ids);\n    this.acks[this.ids] = args.pop();\n    packet.id = this.ids++;\n  }\n\n  if (this.connected) {\n    this.packet(packet);\n  } else {\n    this.sendBuffer.push(packet);\n  }\n\n  delete this.flags;\n\n  return this;\n};\n\n/**\n * Sends a packet.\n *\n * @param {Object} packet\n * @api private\n */\n\nSocket.prototype.packet = function(packet){\n  packet.nsp = this.nsp;\n  this.io.packet(packet);\n};\n\n/**\n * Called upon engine `open`.\n *\n * @api private\n */\n\nSocket.prototype.onopen = function(){\n  debug('transport is open - connecting');\n\n  // write connect packet if necessary\n  if ('/' != this.nsp) {\n    this.packet({ type: parser.CONNECT });\n  }\n};\n\n/**\n * Called upon engine `close`.\n *\n * @param {String} reason\n * @api private\n */\n\nSocket.prototype.onclose = function(reason){\n  debug('close (%s)', reason);\n  this.connected = false;\n  this.disconnected = true;\n  delete this.id;\n  this.emit('disconnect', reason);\n};\n\n/**\n * Called with socket packet.\n *\n * @param {Object} packet\n * @api private\n */\n\nSocket.prototype.onpacket = function(packet){\n  if (packet.nsp != this.nsp) return;\n\n  switch (packet.type) {\n    case parser.CONNECT:\n      this.onconnect();\n      break;\n\n    case parser.EVENT:\n      this.onevent(packet);\n      break;\n\n    case parser.BINARY_EVENT:\n      this.onevent(packet);\n      break;\n\n    case parser.ACK:\n      this.onack(packet);\n      break;\n\n    case parser.BINARY_ACK:\n      this.onack(packet);\n      break;\n\n    case parser.DISCONNECT:\n      this.ondisconnect();\n      break;\n\n    case parser.ERROR:\n      this.emit('error', packet.data);\n      break;\n  }\n};\n\n/**\n * Called upon a server event.\n *\n * @param {Object} packet\n * @api private\n */\n\nSocket.prototype.onevent = function(packet){\n  var args = packet.data || [];\n  debug('emitting event %j', args);\n\n  if (null != packet.id) {\n    debug('attaching ack callback to event');\n    args.push(this.ack(packet.id));\n  }\n\n  if (this.connected) {\n    emit.apply(this, args);\n  } else {\n    this.receiveBuffer.push(args);\n  }\n};\n\n/**\n * Produces an ack callback to emit with an event.\n *\n * @api private\n */\n\nSocket.prototype.ack = function(id){\n  var self = this;\n  var sent = false;\n  return function(){\n    // prevent double callbacks\n    if (sent) return;\n    sent = true;\n    var args = toArray(arguments);\n    debug('sending ack %j', args);\n\n    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;\n    self.packet({\n      type: type,\n      id: id,\n      data: args\n    });\n  };\n};\n\n/**\n * Called upon a server acknowlegement.\n *\n * @param {Object} packet\n * @api private\n */\n\nSocket.prototype.onack = function(packet){\n  var ack = this.acks[packet.id];\n  if ('function' == typeof ack) {\n    debug('calling ack %s with %j', packet.id, packet.data);\n    ack.apply(this, packet.data);\n    delete this.acks[packet.id];\n  } else {\n    debug('bad ack %s', packet.id);\n  }\n};\n\n/**\n * Called upon server connect.\n *\n * @api private\n */\n\nSocket.prototype.onconnect = function(){\n  this.connected = true;\n  this.disconnected = false;\n  this.emit('connect');\n  this.emitBuffered();\n};\n\n/**\n * Emit buffered events (received and emitted).\n *\n * @api private\n */\n\nSocket.prototype.emitBuffered = function(){\n  var i;\n  for (i = 0; i < this.receiveBuffer.length; i++) {\n    emit.apply(this, this.receiveBuffer[i]);\n  }\n  this.receiveBuffer = [];\n\n  for (i = 0; i < this.sendBuffer.length; i++) {\n    this.packet(this.sendBuffer[i]);\n  }\n  this.sendBuffer = [];\n};\n\n/**\n * Called upon server disconnect.\n *\n * @api private\n */\n\nSocket.prototype.ondisconnect = function(){\n  debug('server disconnect (%s)', this.nsp);\n  this.destroy();\n  this.onclose('io server disconnect');\n};\n\n/**\n * Called upon forced client/server side disconnections,\n * this method ensures the manager stops tracking us and\n * that reconnections don't get triggered for this.\n *\n * @api private.\n */\n\nSocket.prototype.destroy = function(){\n  if (this.subs) {\n    // clean subscriptions to avoid reconnections\n    for (var i = 0; i < this.subs.length; i++) {\n      this.subs[i].destroy();\n    }\n    this.subs = null;\n  }\n\n  this.io.destroy(this);\n};\n\n/**\n * Disconnects the socket manually.\n *\n * @return {Socket} self\n * @api public\n */\n\nSocket.prototype.close =\nSocket.prototype.disconnect = function(){\n  if (this.connected) {\n    debug('performing disconnect (%s)', this.nsp);\n    this.packet({ type: parser.DISCONNECT });\n  }\n\n  // remove socket from pool\n  this.destroy();\n\n  if (this.connected) {\n    // fire events\n    this.onclose('io client disconnect');\n  }\n  return this;\n};\n\n/**\n * Sets the compress flag.\n *\n * @param {Boolean} if `true`, compresses the sending data\n * @return {Socket} self\n * @api public\n */\n\nSocket.prototype.compress = function(compress){\n  this.flags = this.flags || {};\n  this.flags.compress = compress;\n  return this;\n};\n\n},{\"./on\":33,\"component-bind\":37,\"component-emitter\":38,\"debug\":39,\"has-binary\":41,\"socket.io-parser\":47,\"to-array\":51}],35:[function(_dereq_,module,exports){\n(function (global){\n\n/**\n * Module dependencies.\n */\n\nvar parseuri = _dereq_('parseuri');\nvar debug = _dereq_('debug')('socket.io-client:url');\n\n/**\n * Module exports.\n */\n\nmodule.exports = url;\n\n/**\n * URL parser.\n *\n * @param {String} url\n * @param {Object} An object meant to mimic window.location.\n *                 Defaults to window.location.\n * @api public\n */\n\nfunction url(uri, loc){\n  var obj = uri;\n\n  // default to window.location\n  var loc = loc || global.location;\n  if (null == uri) uri = loc.protocol + '//' + loc.host;\n\n  // relative path support\n  if ('string' == typeof uri) {\n    if ('/' == uri.charAt(0)) {\n      if ('/' == uri.charAt(1)) {\n        uri = loc.protocol + uri;\n      } else {\n        uri = loc.host + uri;\n      }\n    }\n\n    if (!/^(https?|wss?):\\/\\//.test(uri)) {\n      debug('protocol-less url %s', uri);\n      if ('undefined' != typeof loc) {\n        uri = loc.protocol + '//' + uri;\n      } else {\n        uri = 'https://' + uri;\n      }\n    }\n\n    // parse\n    debug('parse %s', uri);\n    obj = parseuri(uri);\n  }\n\n  // make sure we treat `localhost:80` and `localhost` equally\n  if (!obj.port) {\n    if (/^(http|ws)$/.test(obj.protocol)) {\n      obj.port = '80';\n    }\n    else if (/^(http|ws)s$/.test(obj.protocol)) {\n      obj.port = '443';\n    }\n  }\n\n  obj.path = obj.path || '/';\n\n  var ipv6 = obj.host.indexOf(':') !== -1;\n  var host = ipv6 ? '[' + obj.host + ']' : obj.host;\n\n  // define unique id\n  obj.id = obj.protocol + '://' + host + ':' + obj.port;\n  // define href\n  obj.href = obj.protocol + '://' + host + (loc && loc.port == obj.port ? '' : (':' + obj.port));\n\n  return obj;\n}\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"debug\":39,\"parseuri\":45}],36:[function(_dereq_,module,exports){\n\n/**\n * Expose `Backoff`.\n */\n\nmodule.exports = Backoff;\n\n/**\n * Initialize backoff timer with `opts`.\n *\n * - `min` initial timeout in milliseconds [100]\n * - `max` max timeout [10000]\n * - `jitter` [0]\n * - `factor` [2]\n *\n * @param {Object} opts\n * @api public\n */\n\nfunction Backoff(opts) {\n  opts = opts || {};\n  this.ms = opts.min || 100;\n  this.max = opts.max || 10000;\n  this.factor = opts.factor || 2;\n  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;\n  this.attempts = 0;\n}\n\n/**\n * Return the backoff duration.\n *\n * @return {Number}\n * @api public\n */\n\nBackoff.prototype.duration = function(){\n  var ms = this.ms * Math.pow(this.factor, this.attempts++);\n  if (this.jitter) {\n    var rand =  Math.random();\n    var deviation = Math.floor(rand * this.jitter * ms);\n    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;\n  }\n  return Math.min(ms, this.max) | 0;\n};\n\n/**\n * Reset the number of attempts.\n *\n * @api public\n */\n\nBackoff.prototype.reset = function(){\n  this.attempts = 0;\n};\n\n/**\n * Set the minimum duration\n *\n * @api public\n */\n\nBackoff.prototype.setMin = function(min){\n  this.ms = min;\n};\n\n/**\n * Set the maximum duration\n *\n * @api public\n */\n\nBackoff.prototype.setMax = function(max){\n  this.max = max;\n};\n\n/**\n * Set the jitter\n *\n * @api public\n */\n\nBackoff.prototype.setJitter = function(jitter){\n  this.jitter = jitter;\n};\n\n\n},{}],37:[function(_dereq_,module,exports){\n/**\n * Slice reference.\n */\n\nvar slice = [].slice;\n\n/**\n * Bind `obj` to `fn`.\n *\n * @param {Object} obj\n * @param {Function|String} fn or string\n * @return {Function}\n * @api public\n */\n\nmodule.exports = function(obj, fn){\n  if ('string' == typeof fn) fn = obj[fn];\n  if ('function' != typeof fn) throw new Error('bind() requires a function');\n  var args = slice.call(arguments, 2);\n  return function(){\n    return fn.apply(obj, args.concat(slice.call(arguments)));\n  }\n};\n\n},{}],38:[function(_dereq_,module,exports){\n\n/**\n * Expose `Emitter`.\n */\n\nmodule.exports = Emitter;\n\n/**\n * Initialize a new `Emitter`.\n *\n * @api public\n */\n\nfunction Emitter(obj) {\n  if (obj) return mixin(obj);\n};\n\n/**\n * Mixin the emitter properties.\n *\n * @param {Object} obj\n * @return {Object}\n * @api private\n */\n\nfunction mixin(obj) {\n  for (var key in Emitter.prototype) {\n    obj[key] = Emitter.prototype[key];\n  }\n  return obj;\n}\n\n/**\n * Listen on the given `event` with `fn`.\n *\n * @param {String} event\n * @param {Function} fn\n * @return {Emitter}\n * @api public\n */\n\nEmitter.prototype.on =\nEmitter.prototype.addEventListener = function(event, fn){\n  this._callbacks = this._callbacks || {};\n  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])\n    .push(fn);\n  return this;\n};\n\n/**\n * Adds an `event` listener that will be invoked a single\n * time then automatically removed.\n *\n * @param {String} event\n * @param {Function} fn\n * @return {Emitter}\n * @api public\n */\n\nEmitter.prototype.once = function(event, fn){\n  function on() {\n    this.off(event, on);\n    fn.apply(this, arguments);\n  }\n\n  on.fn = fn;\n  this.on(event, on);\n  return this;\n};\n\n/**\n * Remove the given callback for `event` or all\n * registered callbacks.\n *\n * @param {String} event\n * @param {Function} fn\n * @return {Emitter}\n * @api public\n */\n\nEmitter.prototype.off =\nEmitter.prototype.removeListener =\nEmitter.prototype.removeAllListeners =\nEmitter.prototype.removeEventListener = function(event, fn){\n  this._callbacks = this._callbacks || {};\n\n  // all\n  if (0 == arguments.length) {\n    this._callbacks = {};\n    return this;\n  }\n\n  // specific event\n  var callbacks = this._callbacks['$' + event];\n  if (!callbacks) return this;\n\n  // remove all handlers\n  if (1 == arguments.length) {\n    delete this._callbacks['$' + event];\n    return this;\n  }\n\n  // remove specific handler\n  var cb;\n  for (var i = 0; i < callbacks.length; i++) {\n    cb = callbacks[i];\n    if (cb === fn || cb.fn === fn) {\n      callbacks.splice(i, 1);\n      break;\n    }\n  }\n  return this;\n};\n\n/**\n * Emit `event` with the given args.\n *\n * @param {String} event\n * @param {Mixed} ...\n * @return {Emitter}\n */\n\nEmitter.prototype.emit = function(event){\n  this._callbacks = this._callbacks || {};\n  var args = [].slice.call(arguments, 1)\n    , callbacks = this._callbacks['$' + event];\n\n  if (callbacks) {\n    callbacks = callbacks.slice(0);\n    for (var i = 0, len = callbacks.length; i < len; ++i) {\n      callbacks[i].apply(this, args);\n    }\n  }\n\n  return this;\n};\n\n/**\n * Return array of callbacks for `event`.\n *\n * @param {String} event\n * @return {Array}\n * @api public\n */\n\nEmitter.prototype.listeners = function(event){\n  this._callbacks = this._callbacks || {};\n  return this._callbacks['$' + event] || [];\n};\n\n/**\n * Check if this emitter has `event` handlers.\n *\n * @param {String} event\n * @return {Boolean}\n * @api public\n */\n\nEmitter.prototype.hasListeners = function(event){\n  return !! this.listeners(event).length;\n};\n\n},{}],39:[function(_dereq_,module,exports){\narguments[4][17][0].apply(exports,arguments)\n},{\"./debug\":40,\"dup\":17}],40:[function(_dereq_,module,exports){\narguments[4][18][0].apply(exports,arguments)\n},{\"dup\":18,\"ms\":44}],41:[function(_dereq_,module,exports){\n(function (global){\n\n/*\n * Module requirements.\n */\n\nvar isArray = _dereq_('isarray');\n\n/**\n * Module exports.\n */\n\nmodule.exports = hasBinary;\n\n/**\n * Checks for binary data.\n *\n * Right now only Buffer and ArrayBuffer are supported..\n *\n * @param {Object} anything\n * @api public\n */\n\nfunction hasBinary(data) {\n\n  function _hasBinary(obj) {\n    if (!obj) return false;\n\n    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||\n         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||\n         (global.Blob && obj instanceof Blob) ||\n         (global.File && obj instanceof File)\n        ) {\n      return true;\n    }\n\n    if (isArray(obj)) {\n      for (var i = 0; i < obj.length; i++) {\n          if (_hasBinary(obj[i])) {\n              return true;\n          }\n      }\n    } else if (obj && 'object' == typeof obj) {\n      // see: https://github.com/Automattic/has-binary/pull/4\n      if (obj.toJSON && 'function' == typeof obj.toJSON) {\n        obj = obj.toJSON();\n      }\n\n      for (var key in obj) {\n        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {\n          return true;\n        }\n      }\n    }\n\n    return false;\n  }\n\n  return _hasBinary(data);\n}\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"isarray\":43}],42:[function(_dereq_,module,exports){\narguments[4][23][0].apply(exports,arguments)\n},{\"dup\":23}],43:[function(_dereq_,module,exports){\narguments[4][24][0].apply(exports,arguments)\n},{\"dup\":24}],44:[function(_dereq_,module,exports){\narguments[4][25][0].apply(exports,arguments)\n},{\"dup\":25}],45:[function(_dereq_,module,exports){\narguments[4][28][0].apply(exports,arguments)\n},{\"dup\":28}],46:[function(_dereq_,module,exports){\n(function (global){\n/*global Blob,File*/\n\n/**\n * Module requirements\n */\n\nvar isArray = _dereq_('isarray');\nvar isBuf = _dereq_('./is-buffer');\n\n/**\n * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.\n * Anything with blobs or files should be fed through removeBlobs before coming\n * here.\n *\n * @param {Object} packet - socket.io event packet\n * @return {Object} with deconstructed packet and list of buffers\n * @api public\n */\n\nexports.deconstructPacket = function(packet){\n  var buffers = [];\n  var packetData = packet.data;\n\n  function _deconstructPacket(data) {\n    if (!data) return data;\n\n    if (isBuf(data)) {\n      var placeholder = { _placeholder: true, num: buffers.length };\n      buffers.push(data);\n      return placeholder;\n    } else if (isArray(data)) {\n      var newData = new Array(data.length);\n      for (var i = 0; i < data.length; i++) {\n        newData[i] = _deconstructPacket(data[i]);\n      }\n      return newData;\n    } else if ('object' == typeof data && !(data instanceof Date)) {\n      var newData = {};\n      for (var key in data) {\n        newData[key] = _deconstructPacket(data[key]);\n      }\n      return newData;\n    }\n    return data;\n  }\n\n  var pack = packet;\n  pack.data = _deconstructPacket(packetData);\n  pack.attachments = buffers.length; // number of binary 'attachments'\n  return {packet: pack, buffers: buffers};\n};\n\n/**\n * Reconstructs a binary packet from its placeholder packet and buffers\n *\n * @param {Object} packet - event packet with placeholders\n * @param {Array} buffers - binary buffers to put in placeholder positions\n * @return {Object} reconstructed packet\n * @api public\n */\n\nexports.reconstructPacket = function(packet, buffers) {\n  var curPlaceHolder = 0;\n\n  function _reconstructPacket(data) {\n    if (data && data._placeholder) {\n      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)\n      return buf;\n    } else if (isArray(data)) {\n      for (var i = 0; i < data.length; i++) {\n        data[i] = _reconstructPacket(data[i]);\n      }\n      return data;\n    } else if (data && 'object' == typeof data) {\n      for (var key in data) {\n        data[key] = _reconstructPacket(data[key]);\n      }\n      return data;\n    }\n    return data;\n  }\n\n  packet.data = _reconstructPacket(packet.data);\n  packet.attachments = undefined; // no longer useful\n  return packet;\n};\n\n/**\n * Asynchronously removes Blobs or Files from data via\n * FileReader's readAsArrayBuffer method. Used before encoding\n * data as msgpack. Calls callback with the blobless data.\n *\n * @param {Object} data\n * @param {Function} callback\n * @api private\n */\n\nexports.removeBlobs = function(data, callback) {\n  function _removeBlobs(obj, curKey, containingObject) {\n    if (!obj) return obj;\n\n    // convert any blob\n    if ((global.Blob && obj instanceof Blob) ||\n        (global.File && obj instanceof File)) {\n      pendingBlobs++;\n\n      // async filereader\n      var fileReader = new FileReader();\n      fileReader.onload = function() { // this.result == arraybuffer\n        if (containingObject) {\n          containingObject[curKey] = this.result;\n        }\n        else {\n          bloblessData = this.result;\n        }\n\n        // if nothing pending its callback time\n        if(! --pendingBlobs) {\n          callback(bloblessData);\n        }\n      };\n\n      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer\n    } else if (isArray(obj)) { // handle array\n      for (var i = 0; i < obj.length; i++) {\n        _removeBlobs(obj[i], i, obj);\n      }\n    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object\n      for (var key in obj) {\n        _removeBlobs(obj[key], key, obj);\n      }\n    }\n  }\n\n  var pendingBlobs = 0;\n  var bloblessData = data;\n  _removeBlobs(bloblessData);\n  if (!pendingBlobs) {\n    callback(bloblessData);\n  }\n};\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{\"./is-buffer\":48,\"isarray\":43}],47:[function(_dereq_,module,exports){\n\n/**\n * Module dependencies.\n */\n\nvar debug = _dereq_('debug')('socket.io-parser');\nvar json = _dereq_('json3');\nvar isArray = _dereq_('isarray');\nvar Emitter = _dereq_('component-emitter');\nvar binary = _dereq_('./binary');\nvar isBuf = _dereq_('./is-buffer');\n\n/**\n * Protocol version.\n *\n * @api public\n */\n\nexports.protocol = 4;\n\n/**\n * Packet types.\n *\n * @api public\n */\n\nexports.types = [\n  'CONNECT',\n  'DISCONNECT',\n  'EVENT',\n  'BINARY_EVENT',\n  'ACK',\n  'BINARY_ACK',\n  'ERROR'\n];\n\n/**\n * Packet type `connect`.\n *\n * @api public\n */\n\nexports.CONNECT = 0;\n\n/**\n * Packet type `disconnect`.\n *\n * @api public\n */\n\nexports.DISCONNECT = 1;\n\n/**\n * Packet type `event`.\n *\n * @api public\n */\n\nexports.EVENT = 2;\n\n/**\n * Packet type `ack`.\n *\n * @api public\n */\n\nexports.ACK = 3;\n\n/**\n * Packet type `error`.\n *\n * @api public\n */\n\nexports.ERROR = 4;\n\n/**\n * Packet type 'binary event'\n *\n * @api public\n */\n\nexports.BINARY_EVENT = 5;\n\n/**\n * Packet type `binary ack`. For acks with binary arguments.\n *\n * @api public\n */\n\nexports.BINARY_ACK = 6;\n\n/**\n * Encoder constructor.\n *\n * @api public\n */\n\nexports.Encoder = Encoder;\n\n/**\n * Decoder constructor.\n *\n * @api public\n */\n\nexports.Decoder = Decoder;\n\n/**\n * A socket.io Encoder instance\n *\n * @api public\n */\n\nfunction Encoder() {}\n\n/**\n * Encode a packet as a single string if non-binary, or as a\n * buffer sequence, depending on packet type.\n *\n * @param {Object} obj - packet object\n * @param {Function} callback - function to handle encodings (likely engine.write)\n * @return Calls callback with Array of encodings\n * @api public\n */\n\nEncoder.prototype.encode = function(obj, callback){\n  debug('encoding packet %j', obj);\n\n  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {\n    encodeAsBinary(obj, callback);\n  }\n  else {\n    var encoding = encodeAsString(obj);\n    callback([encoding]);\n  }\n};\n\n/**\n * Encode packet as string.\n *\n * @param {Object} packet\n * @return {String} encoded\n * @api private\n */\n\nfunction encodeAsString(obj) {\n  var str = '';\n  var nsp = false;\n\n  // first is type\n  str += obj.type;\n\n  // attachments if we have them\n  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {\n    str += obj.attachments;\n    str += '-';\n  }\n\n  // if we have a namespace other than `/`\n  // we append it followed by a comma `,`\n  if (obj.nsp && '/' != obj.nsp) {\n    nsp = true;\n    str += obj.nsp;\n  }\n\n  // immediately followed by the id\n  if (null != obj.id) {\n    if (nsp) {\n      str += ',';\n      nsp = false;\n    }\n    str += obj.id;\n  }\n\n  // json data\n  if (null != obj.data) {\n    if (nsp) str += ',';\n    str += json.stringify(obj.data);\n  }\n\n  debug('encoded %j as %s', obj, str);\n  return str;\n}\n\n/**\n * Encode packet as 'buffer sequence' by removing blobs, and\n * deconstructing packet into object with placeholders and\n * a list of buffers.\n *\n * @param {Object} packet\n * @return {Buffer} encoded\n * @api private\n */\n\nfunction encodeAsBinary(obj, callback) {\n\n  function writeEncoding(bloblessData) {\n    var deconstruction = binary.deconstructPacket(bloblessData);\n    var pack = encodeAsString(deconstruction.packet);\n    var buffers = deconstruction.buffers;\n\n    buffers.unshift(pack); // add packet info to beginning of data list\n    callback(buffers); // write all the buffers\n  }\n\n  binary.removeBlobs(obj, writeEncoding);\n}\n\n/**\n * A socket.io Decoder instance\n *\n * @return {Object} decoder\n * @api public\n */\n\nfunction Decoder() {\n  this.reconstructor = null;\n}\n\n/**\n * Mix in `Emitter` with Decoder.\n */\n\nEmitter(Decoder.prototype);\n\n/**\n * Decodes an ecoded packet string into packet JSON.\n *\n * @param {String} obj - encoded packet\n * @return {Object} packet\n * @api public\n */\n\nDecoder.prototype.add = function(obj) {\n  var packet;\n  if ('string' == typeof obj) {\n    packet = decodeString(obj);\n    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json\n      this.reconstructor = new BinaryReconstructor(packet);\n\n      // no attachments, labeled binary but no binary data to follow\n      if (this.reconstructor.reconPack.attachments === 0) {\n        this.emit('decoded', packet);\n      }\n    } else { // non-binary full packet\n      this.emit('decoded', packet);\n    }\n  }\n  else if (isBuf(obj) || obj.base64) { // raw binary data\n    if (!this.reconstructor) {\n      throw new Error('got binary data when not reconstructing a packet');\n    } else {\n      packet = this.reconstructor.takeBinaryData(obj);\n      if (packet) { // received final buffer\n        this.reconstructor = null;\n        this.emit('decoded', packet);\n      }\n    }\n  }\n  else {\n    throw new Error('Unknown type: ' + obj);\n  }\n};\n\n/**\n * Decode a packet String (JSON data)\n *\n * @param {String} str\n * @return {Object} packet\n * @api private\n */\n\nfunction decodeString(str) {\n  var p = {};\n  var i = 0;\n\n  // look up type\n  p.type = Number(str.charAt(0));\n  if (null == exports.types[p.type]) return error();\n\n  // look up attachments if type binary\n  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {\n    var buf = '';\n    while (str.charAt(++i) != '-') {\n      buf += str.charAt(i);\n      if (i == str.length) break;\n    }\n    if (buf != Number(buf) || str.charAt(i) != '-') {\n      throw new Error('Illegal attachments');\n    }\n    p.attachments = Number(buf);\n  }\n\n  // look up namespace (if any)\n  if ('/' == str.charAt(i + 1)) {\n    p.nsp = '';\n    while (++i) {\n      var c = str.charAt(i);\n      if (',' == c) break;\n      p.nsp += c;\n      if (i == str.length) break;\n    }\n  } else {\n    p.nsp = '/';\n  }\n\n  // look up id\n  var next = str.charAt(i + 1);\n  if ('' !== next && Number(next) == next) {\n    p.id = '';\n    while (++i) {\n      var c = str.charAt(i);\n      if (null == c || Number(c) != c) {\n        --i;\n        break;\n      }\n      p.id += str.charAt(i);\n      if (i == str.length) break;\n    }\n    p.id = Number(p.id);\n  }\n\n  // look up json data\n  if (str.charAt(++i)) {\n    try {\n      p.data = json.parse(str.substr(i));\n    } catch(e){\n      return error();\n    }\n  }\n\n  debug('decoded %s as %j', str, p);\n  return p;\n}\n\n/**\n * Deallocates a parser's resources\n *\n * @api public\n */\n\nDecoder.prototype.destroy = function() {\n  if (this.reconstructor) {\n    this.reconstructor.finishedReconstruction();\n  }\n};\n\n/**\n * A manager of a binary event's 'buffer sequence'. Should\n * be constructed whenever a packet of type BINARY_EVENT is\n * decoded.\n *\n * @param {Object} packet\n * @return {BinaryReconstructor} initialized reconstructor\n * @api private\n */\n\nfunction BinaryReconstructor(packet) {\n  this.reconPack = packet;\n  this.buffers = [];\n}\n\n/**\n * Method to be called when binary data received from connection\n * after a BINARY_EVENT packet.\n *\n * @param {Buffer | ArrayBuffer} binData - the raw binary data received\n * @return {null | Object} returns null if more binary data is expected or\n *   a reconstructed packet object if all buffers have been received.\n * @api private\n */\n\nBinaryReconstructor.prototype.takeBinaryData = function(binData) {\n  this.buffers.push(binData);\n  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list\n    var packet = binary.reconstructPacket(this.reconPack, this.buffers);\n    this.finishedReconstruction();\n    return packet;\n  }\n  return null;\n};\n\n/**\n * Cleans up binary packet reconstruction variables.\n *\n * @api private\n */\n\nBinaryReconstructor.prototype.finishedReconstruction = function() {\n  this.reconPack = null;\n  this.buffers = [];\n};\n\nfunction error(data){\n  return {\n    type: exports.ERROR,\n    data: 'parser error'\n  };\n}\n\n},{\"./binary\":46,\"./is-buffer\":48,\"component-emitter\":49,\"debug\":39,\"isarray\":43,\"json3\":50}],48:[function(_dereq_,module,exports){\n(function (global){\n\nmodule.exports = isBuf;\n\n/**\n * Returns true if obj is a buffer or an arraybuffer.\n *\n * @api private\n */\n\nfunction isBuf(obj) {\n  return (global.Buffer && global.Buffer.isBuffer(obj)) ||\n         (global.ArrayBuffer && obj instanceof ArrayBuffer);\n}\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{}],49:[function(_dereq_,module,exports){\narguments[4][15][0].apply(exports,arguments)\n},{\"dup\":15}],50:[function(_dereq_,module,exports){\n(function (global){\n/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */\n;(function () {\n  // Detect the `define` function exposed by asynchronous module loaders. The\n  // strict `define` check is necessary for compatibility with `r.js`.\n  var isLoader = typeof define === \"function\" && define.amd;\n\n  // A set of types used to distinguish objects from primitives.\n  var objectTypes = {\n    \"function\": true,\n    \"object\": true\n  };\n\n  // Detect the `exports` object exposed by CommonJS implementations.\n  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;\n\n  // Use the `global` object exposed by Node (including Browserify via\n  // `insert-module-globals`), Narwhal, and Ringo as the default context,\n  // and the `window` object in browsers. Rhino exports a `global` function\n  // instead.\n  var root = objectTypes[typeof window] && window || this,\n      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == \"object\" && global;\n\n  if (freeGlobal && (freeGlobal[\"global\"] === freeGlobal || freeGlobal[\"window\"] === freeGlobal || freeGlobal[\"self\"] === freeGlobal)) {\n    root = freeGlobal;\n  }\n\n  // Public: Initializes JSON 3 using the given `context` object, attaching the\n  // `stringify` and `parse` functions to the specified `exports` object.\n  function runInContext(context, exports) {\n    context || (context = root[\"Object\"]());\n    exports || (exports = root[\"Object\"]());\n\n    // Native constructor aliases.\n    var Number = context[\"Number\"] || root[\"Number\"],\n        String = context[\"String\"] || root[\"String\"],\n        Object = context[\"Object\"] || root[\"Object\"],\n        Date = context[\"Date\"] || root[\"Date\"],\n        SyntaxError = context[\"SyntaxError\"] || root[\"SyntaxError\"],\n        TypeError = context[\"TypeError\"] || root[\"TypeError\"],\n        Math = context[\"Math\"] || root[\"Math\"],\n        nativeJSON = context[\"JSON\"] || root[\"JSON\"];\n\n    // Delegate to the native `stringify` and `parse` implementations.\n    if (typeof nativeJSON == \"object\" && nativeJSON) {\n      exports.stringify = nativeJSON.stringify;\n      exports.parse = nativeJSON.parse;\n    }\n\n    // Convenience aliases.\n    var objectProto = Object.prototype,\n        getClass = objectProto.toString,\n        isProperty, forEach, undef;\n\n    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.\n    var isExtended = new Date(-3509827334573292);\n    try {\n      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical\n      // results for certain dates in Opera >= 10.53.\n      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&\n        // Safari < 2.0.2 stores the internal millisecond time value correctly,\n        // but clips the values returned by the date methods to the range of\n        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).\n        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;\n    } catch (exception) {}\n\n    // Internal: Determines whether the native `JSON.stringify` and `parse`\n    // implementations are spec-compliant. Based on work by Ken Snyder.\n    function has(name) {\n      if (has[name] !== undef) {\n        // Return cached feature test result.\n        return has[name];\n      }\n      var isSupported;\n      if (name == \"bug-string-char-index\") {\n        // IE <= 7 doesn't support accessing string characters using square\n        // bracket notation. IE 8 only supports this for primitives.\n        isSupported = \"a\"[0] != \"a\";\n      } else if (name == \"json\") {\n        // Indicates whether both `JSON.stringify` and `JSON.parse` are\n        // supported.\n        isSupported = has(\"json-stringify\") && has(\"json-parse\");\n      } else {\n        var value, serialized = '{\"a\":[1,true,false,null,\"\\\\u0000\\\\b\\\\n\\\\f\\\\r\\\\t\"]}';\n        // Test `JSON.stringify`.\n        if (name == \"json-stringify\") {\n          var stringify = exports.stringify, stringifySupported = typeof stringify == \"function\" && isExtended;\n          if (stringifySupported) {\n            // A test function object with a custom `toJSON` method.\n            (value = function () {\n              return 1;\n            }).toJSON = value;\n            try {\n              stringifySupported =\n                // Firefox 3.1b1 and b2 serialize string, number, and boolean\n                // primitives as object literals.\n                stringify(0) === \"0\" &&\n                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object\n                // literals.\n                stringify(new Number()) === \"0\" &&\n                stringify(new String()) == '\"\"' &&\n                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or\n                // does not define a canonical JSON representation (this applies to\n                // objects with `toJSON` properties as well, *unless* they are nested\n                // within an object or array).\n                stringify(getClass) === undef &&\n                // IE 8 serializes `undefined` as `\"undefined\"`. Safari <= 5.1.7 and\n                // FF 3.1b3 pass this test.\n                stringify(undef) === undef &&\n                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,\n                // respectively, if the value is omitted entirely.\n                stringify() === undef &&\n                // FF 3.1b1, 2 throw an error if the given value is not a number,\n                // string, array, object, Boolean, or `null` literal. This applies to\n                // objects with custom `toJSON` methods as well, unless they are nested\n                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`\n                // methods entirely.\n                stringify(value) === \"1\" &&\n                stringify([value]) == \"[1]\" &&\n                // Prototype <= 1.6.1 serializes `[undefined]` as `\"[]\"` instead of\n                // `\"[null]\"`.\n                stringify([undef]) == \"[null]\" &&\n                // YUI 3.0.0b1 fails to serialize `null` literals.\n                stringify(null) == \"null\" &&\n                // FF 3.1b1, 2 halts serialization if an array contains a function:\n                // `[1, true, getClass, 1]` serializes as \"[1,true,],\". FF 3.1b3\n                // elides non-JSON values from objects and arrays, unless they\n                // define custom `toJSON` methods.\n                stringify([undef, getClass, null]) == \"[null,null,null]\" &&\n                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences\n                // where character escape codes are expected (e.g., `\\b` => `\\u0008`).\n                stringify({ \"a\": [value, true, false, null, \"\\x00\\b\\n\\f\\r\\t\"] }) == serialized &&\n                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.\n                stringify(null, value) === \"1\" &&\n                stringify([1, 2], null, 1) == \"[\\n 1,\\n 2\\n]\" &&\n                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly\n                // serialize extended years.\n                stringify(new Date(-8.64e15)) == '\"-271821-04-20T00:00:00.000Z\"' &&\n                // The milliseconds are optional in ES 5, but required in 5.1.\n                stringify(new Date(8.64e15)) == '\"+275760-09-13T00:00:00.000Z\"' &&\n                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative\n                // four-digit years instead of six-digit years. Credits: @Yaffle.\n                stringify(new Date(-621987552e5)) == '\"-000001-01-01T00:00:00.000Z\"' &&\n                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond\n                // values less than 1000. Credits: @Yaffle.\n                stringify(new Date(-1)) == '\"1969-12-31T23:59:59.999Z\"';\n            } catch (exception) {\n              stringifySupported = false;\n            }\n          }\n          isSupported = stringifySupported;\n        }\n        // Test `JSON.parse`.\n        if (name == \"json-parse\") {\n          var parse = exports.parse;\n          if (typeof parse == \"function\") {\n            try {\n              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.\n              // Conforming implementations should also coerce the initial argument to\n              // a string prior to parsing.\n              if (parse(\"0\") === 0 && !parse(false)) {\n                // Simple parsing test.\n                value = parse(serialized);\n                var parseSupported = value[\"a\"].length == 5 && value[\"a\"][0] === 1;\n                if (parseSupported) {\n                  try {\n                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.\n                    parseSupported = !parse('\"\\t\"');\n                  } catch (exception) {}\n                  if (parseSupported) {\n                    try {\n                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading\n                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow\n                      // certain octal literals.\n                      parseSupported = parse(\"01\") !== 1;\n                    } catch (exception) {}\n                  }\n                  if (parseSupported) {\n                    try {\n                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal\n                      // points. These environments, along with FF 3.1b1 and 2,\n                      // also allow trailing commas in JSON objects and arrays.\n                      parseSupported = parse(\"1.\") !== 1;\n                    } catch (exception) {}\n                  }\n                }\n              }\n            } catch (exception) {\n              parseSupported = false;\n            }\n          }\n          isSupported = parseSupported;\n        }\n      }\n      return has[name] = !!isSupported;\n    }\n\n    if (!has(\"json\")) {\n      // Common `[[Class]]` name aliases.\n      var functionClass = \"[object Function]\",\n          dateClass = \"[object Date]\",\n          numberClass = \"[object Number]\",\n          stringClass = \"[object String]\",\n          arrayClass = \"[object Array]\",\n          booleanClass = \"[object Boolean]\";\n\n      // Detect incomplete support for accessing string characters by index.\n      var charIndexBuggy = has(\"bug-string-char-index\");\n\n      // Define additional utility methods if the `Date` methods are buggy.\n      if (!isExtended) {\n        var floor = Math.floor;\n        // A mapping between the months of the year and the number of days between\n        // January 1st and the first of the respective month.\n        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];\n        // Internal: Calculates the number of days between the Unix epoch and the\n        // first day of the given month.\n        var getDay = function (year, month) {\n          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);\n        };\n      }\n\n      // Internal: Determines if a property is a direct property of the given\n      // object. Delegates to the native `Object#hasOwnProperty` method.\n      if (!(isProperty = objectProto.hasOwnProperty)) {\n        isProperty = function (property) {\n          var members = {}, constructor;\n          if ((members.__proto__ = null, members.__proto__ = {\n            // The *proto* property cannot be set multiple times in recent\n            // versions of Firefox and SeaMonkey.\n            \"toString\": 1\n          }, members).toString != getClass) {\n            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but\n            // supports the mutable *proto* property.\n            isProperty = function (property) {\n              // Capture and break the object's prototype chain (see section 8.6.2\n              // of the ES 5.1 spec). The parenthesized expression prevents an\n              // unsafe transformation by the Closure Compiler.\n              var original = this.__proto__, result = property in (this.__proto__ = null, this);\n              // Restore the original prototype chain.\n              this.__proto__ = original;\n              return result;\n            };\n          } else {\n            // Capture a reference to the top-level `Object` constructor.\n            constructor = members.constructor;\n            // Use the `constructor` property to simulate `Object#hasOwnProperty` in\n            // other environments.\n            isProperty = function (property) {\n              var parent = (this.constructor || constructor).prototype;\n              return property in this && !(property in parent && this[property] === parent[property]);\n            };\n          }\n          members = null;\n          return isProperty.call(this, property);\n        };\n      }\n\n      // Internal: Normalizes the `for...in` iteration algorithm across\n      // environments. Each enumerated key is yielded to a `callback` function.\n      forEach = function (object, callback) {\n        var size = 0, Properties, members, property;\n\n        // Tests for bugs in the current environment's `for...in` algorithm. The\n        // `valueOf` property inherits the non-enumerable flag from\n        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.\n        (Properties = function () {\n          this.valueOf = 0;\n        }).prototype.valueOf = 0;\n\n        // Iterate over a new instance of the `Properties` class.\n        members = new Properties();\n        for (property in members) {\n          // Ignore all properties inherited from `Object.prototype`.\n          if (isProperty.call(members, property)) {\n            size++;\n          }\n        }\n        Properties = members = null;\n\n        // Normalize the iteration algorithm.\n        if (!size) {\n          // A list of non-enumerable properties inherited from `Object.prototype`.\n          members = [\"valueOf\", \"toString\", \"toLocaleString\", \"propertyIsEnumerable\", \"isPrototypeOf\", \"hasOwnProperty\", \"constructor\"];\n          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable\n          // properties.\n          forEach = function (object, callback) {\n            var isFunction = getClass.call(object) == functionClass, property, length;\n            var hasProperty = !isFunction && typeof object.constructor != \"function\" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;\n            for (property in object) {\n              // Gecko <= 1.0 enumerates the `prototype` property of functions under\n              // certain conditions; IE does not.\n              if (!(isFunction && property == \"prototype\") && hasProperty.call(object, property)) {\n                callback(property);\n              }\n            }\n            // Manually invoke the callback for each non-enumerable property.\n            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));\n          };\n        } else if (size == 2) {\n          // Safari <= 2.0.4 enumerates shadowed properties twice.\n          forEach = function (object, callback) {\n            // Create a set of iterated properties.\n            var members = {}, isFunction = getClass.call(object) == functionClass, property;\n            for (property in object) {\n              // Store each property name to prevent double enumeration. The\n              // `prototype` property of functions is not enumerated due to cross-\n              // environment inconsistencies.\n              if (!(isFunction && property == \"prototype\") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {\n                callback(property);\n              }\n            }\n          };\n        } else {\n          // No bugs detected; use the standard `for...in` algorithm.\n          forEach = function (object, callback) {\n            var isFunction = getClass.call(object) == functionClass, property, isConstructor;\n            for (property in object) {\n              if (!(isFunction && property == \"prototype\") && isProperty.call(object, property) && !(isConstructor = property === \"constructor\")) {\n                callback(property);\n              }\n            }\n            // Manually invoke the callback for the `constructor` property due to\n            // cross-environment inconsistencies.\n            if (isConstructor || isProperty.call(object, (property = \"constructor\"))) {\n              callback(property);\n            }\n          };\n        }\n        return forEach(object, callback);\n      };\n\n      // Public: Serializes a JavaScript `value` as a JSON string. The optional\n      // `filter` argument may specify either a function that alters how object and\n      // array members are serialized, or an array of strings and numbers that\n      // indicates which properties should be serialized. The optional `width`\n      // argument may be either a string or number that specifies the indentation\n      // level of the output.\n      if (!has(\"json-stringify\")) {\n        // Internal: A map of control characters and their escaped equivalents.\n        var Escapes = {\n          92: \"\\\\\\\\\",\n          34: '\\\\\"',\n          8: \"\\\\b\",\n          12: \"\\\\f\",\n          10: \"\\\\n\",\n          13: \"\\\\r\",\n          9: \"\\\\t\"\n        };\n\n        // Internal: Converts `value` into a zero-padded string such that its\n        // length is at least equal to `width`. The `width` must be <= 6.\n        var leadingZeroes = \"000000\";\n        var toPaddedString = function (width, value) {\n          // The `|| 0` expression is necessary to work around a bug in\n          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== \"0\"`.\n          return (leadingZeroes + (value || 0)).slice(-width);\n        };\n\n        // Internal: Double-quotes a string `value`, replacing all ASCII control\n        // characters (characters with code unit values between 0 and 31) with\n        // their escaped equivalents. This is an implementation of the\n        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.\n        var unicodePrefix = \"\\\\u00\";\n        var quote = function (value) {\n          var result = '\"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;\n          var symbols = useCharIndex && (charIndexBuggy ? value.split(\"\") : value);\n          for (; index < length; index++) {\n            var charCode = value.charCodeAt(index);\n            // If the character is a control character, append its Unicode or\n            // shorthand escape sequence; otherwise, append the character as-is.\n            switch (charCode) {\n              case 8: case 9: case 10: case 12: case 13: case 34: case 92:\n                result += Escapes[charCode];\n                break;\n              default:\n                if (charCode < 32) {\n                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));\n                  break;\n                }\n                result += useCharIndex ? symbols[index] : value.charAt(index);\n            }\n          }\n          return result + '\"';\n        };\n\n        // Internal: Recursively serializes an object. Implements the\n        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.\n        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {\n          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;\n          try {\n            // Necessary for host object support.\n            value = object[property];\n          } catch (exception) {}\n          if (typeof value == \"object\" && value) {\n            className = getClass.call(value);\n            if (className == dateClass && !isProperty.call(value, \"toJSON\")) {\n              if (value > -1 / 0 && value < 1 / 0) {\n                // Dates are serialized according to the `Date#toJSON` method\n                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15\n                // for the ISO 8601 date time string format.\n                if (getDay) {\n                  // Manually compute the year, month, date, hours, minutes,\n                  // seconds, and milliseconds if the `getUTC*` methods are\n                  // buggy. Adapted from @Yaffle's `date-shim` project.\n                  date = floor(value / 864e5);\n                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);\n                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);\n                  date = 1 + date - getDay(year, month);\n                  // The `time` value specifies the time within the day (see ES\n                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used\n                  // to compute `A modulo B`, as the `%` operator does not\n                  // correspond to the `modulo` operation for negative numbers.\n                  time = (value % 864e5 + 864e5) % 864e5;\n                  // The hours, minutes, seconds, and milliseconds are obtained by\n                  // decomposing the time within the day. See section 15.9.1.10.\n                  hours = floor(time / 36e5) % 24;\n                  minutes = floor(time / 6e4) % 60;\n                  seconds = floor(time / 1e3) % 60;\n                  milliseconds = time % 1e3;\n                } else {\n                  year = value.getUTCFullYear();\n                  month = value.getUTCMonth();\n                  date = value.getUTCDate();\n                  hours = value.getUTCHours();\n                  minutes = value.getUTCMinutes();\n                  seconds = value.getUTCSeconds();\n                  milliseconds = value.getUTCMilliseconds();\n                }\n                // Serialize extended years correctly.\n                value = (year <= 0 || year >= 1e4 ? (year < 0 ? \"-\" : \"+\") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +\n                  \"-\" + toPaddedString(2, month + 1) + \"-\" + toPaddedString(2, date) +\n                  // Months, dates, hours, minutes, and seconds should have two\n                  // digits; milliseconds should have three.\n                  \"T\" + toPaddedString(2, hours) + \":\" + toPaddedString(2, minutes) + \":\" + toPaddedString(2, seconds) +\n                  // Milliseconds are optional in ES 5.0, but required in 5.1.\n                  \".\" + toPaddedString(3, milliseconds) + \"Z\";\n              } else {\n                value = null;\n              }\n            } else if (typeof value.toJSON == \"function\" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, \"toJSON\"))) {\n              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the\n              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3\n              // ignores all `toJSON` methods on these objects unless they are\n              // defined directly on an instance.\n              value = value.toJSON(property);\n            }\n          }\n          if (callback) {\n            // If a replacement function was provided, call it to obtain the value\n            // for serialization.\n            value = callback.call(object, property, value);\n          }\n          if (value === null) {\n            return \"null\";\n          }\n          className = getClass.call(value);\n          if (className == booleanClass) {\n            // Booleans are represented literally.\n            return \"\" + value;\n          } else if (className == numberClass) {\n            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as\n            // `\"null\"`.\n            return value > -1 / 0 && value < 1 / 0 ? \"\" + value : \"null\";\n          } else if (className == stringClass) {\n            // Strings are double-quoted and escaped.\n            return quote(\"\" + value);\n          }\n          // Recursively serialize objects and arrays.\n          if (typeof value == \"object\") {\n            // Check for cyclic structures. This is a linear search; performance\n            // is inversely proportional to the number of unique nested objects.\n            for (length = stack.length; length--;) {\n              if (stack[length] === value) {\n                // Cyclic structures cannot be serialized by `JSON.stringify`.\n                throw TypeError();\n              }\n            }\n            // Add the object to the stack of traversed objects.\n            stack.push(value);\n            results = [];\n            // Save the current indentation level and indent one additional level.\n            prefix = indentation;\n            indentation += whitespace;\n            if (className == arrayClass) {\n              // Recursively serialize array elements.\n              for (index = 0, length = value.length; index < length; index++) {\n                element = serialize(index, value, callback, properties, whitespace, indentation, stack);\n                results.push(element === undef ? \"null\" : element);\n              }\n              result = results.length ? (whitespace ? \"[\\n\" + indentation + results.join(\",\\n\" + indentation) + \"\\n\" + prefix + \"]\" : (\"[\" + results.join(\",\") + \"]\")) : \"[]\";\n            } else {\n              // Recursively serialize object members. Members are selected from\n              // either a user-specified list of property names, or the object\n              // itself.\n              forEach(properties || value, function (property) {\n                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);\n                if (element !== undef) {\n                  // According to ES 5.1 section 15.12.3: \"If `gap` {whitespace}\n                  // is not the empty string, let `member` {quote(property) + \":\"}\n                  // be the concatenation of `member` and the `space` character.\"\n                  // The \"`space` character\" refers to the literal space\n                  // character, not the `space` {width} argument provided to\n                  // `JSON.stringify`.\n                  results.push(quote(property) + \":\" + (whitespace ? \" \" : \"\") + element);\n                }\n              });\n              result = results.length ? (whitespace ? \"{\\n\" + indentation + results.join(\",\\n\" + indentation) + \"\\n\" + prefix + \"}\" : (\"{\" + results.join(\",\") + \"}\")) : \"{}\";\n            }\n            // Remove the object from the traversed object stack.\n            stack.pop();\n            return result;\n          }\n        };\n\n        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.\n        exports.stringify = function (source, filter, width) {\n          var whitespace, callback, properties, className;\n          if (objectTypes[typeof filter] && filter) {\n            if ((className = getClass.call(filter)) == functionClass) {\n              callback = filter;\n            } else if (className == arrayClass) {\n              // Convert the property names array into a makeshift set.\n              properties = {};\n              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));\n            }\n          }\n          if (width) {\n            if ((className = getClass.call(width)) == numberClass) {\n              // Convert the `width` to an integer and create a string containing\n              // `width` number of space characters.\n              if ((width -= width % 1) > 0) {\n                for (whitespace = \"\", width > 10 && (width = 10); whitespace.length < width; whitespace += \" \");\n              }\n            } else if (className == stringClass) {\n              whitespace = width.length <= 10 ? width : width.slice(0, 10);\n            }\n          }\n          // Opera <= 7.54u2 discards the values associated with empty string keys\n          // (`\"\"`) only if they are used directly within an object member list\n          // (e.g., `!(\"\" in { \"\": 1})`).\n          return serialize(\"\", (value = {}, value[\"\"] = source, value), callback, properties, whitespace, \"\", []);\n        };\n      }\n\n      // Public: Parses a JSON source string.\n      if (!has(\"json-parse\")) {\n        var fromCharCode = String.fromCharCode;\n\n        // Internal: A map of escaped control characters and their unescaped\n        // equivalents.\n        var Unescapes = {\n          92: \"\\\\\",\n          34: '\"',\n          47: \"/\",\n          98: \"\\b\",\n          116: \"\\t\",\n          110: \"\\n\",\n          102: \"\\f\",\n          114: \"\\r\"\n        };\n\n        // Internal: Stores the parser state.\n        var Index, Source;\n\n        // Internal: Resets the parser state and throws a `SyntaxError`.\n        var abort = function () {\n          Index = Source = null;\n          throw SyntaxError();\n        };\n\n        // Internal: Returns the next token, or `\"$\"` if the parser has reached\n        // the end of the source string. A token may be a string, number, `null`\n        // literal, or Boolean literal.\n        var lex = function () {\n          var source = Source, length = source.length, value, begin, position, isSigned, charCode;\n          while (Index < length) {\n            charCode = source.charCodeAt(Index);\n            switch (charCode) {\n              case 9: case 10: case 13: case 32:\n                // Skip whitespace tokens, including tabs, carriage returns, line\n                // feeds, and space characters.\n                Index++;\n                break;\n              case 123: case 125: case 91: case 93: case 58: case 44:\n                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at\n                // the current position.\n                value = charIndexBuggy ? source.charAt(Index) : source[Index];\n                Index++;\n                return value;\n              case 34:\n                // `\"` delimits a JSON string; advance to the next character and\n                // begin parsing the string. String tokens are prefixed with the\n                // sentinel `@` character to distinguish them from punctuators and\n                // end-of-string tokens.\n                for (value = \"@\", Index++; Index < length;) {\n                  charCode = source.charCodeAt(Index);\n                  if (charCode < 32) {\n                    // Unescaped ASCII control characters (those with a code unit\n                    // less than the space character) are not permitted.\n                    abort();\n                  } else if (charCode == 92) {\n                    // A reverse solidus (`\\`) marks the beginning of an escaped\n                    // control character (including `\"`, `\\`, and `/`) or Unicode\n                    // escape sequence.\n                    charCode = source.charCodeAt(++Index);\n                    switch (charCode) {\n                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:\n                        // Revive escaped control characters.\n                        value += Unescapes[charCode];\n                        Index++;\n                        break;\n                      case 117:\n                        // `\\u` marks the beginning of a Unicode escape sequence.\n                        // Advance to the first character and validate the\n                        // four-digit code point.\n                        begin = ++Index;\n                        for (position = Index + 4; Index < position; Index++) {\n                          charCode = source.charCodeAt(Index);\n                          // A valid sequence comprises four hexdigits (case-\n                          // insensitive) that form a single hexadecimal value.\n                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {\n                            // Invalid Unicode escape sequence.\n                            abort();\n                          }\n                        }\n                        // Revive the escaped character.\n                        value += fromCharCode(\"0x\" + source.slice(begin, Index));\n                        break;\n                      default:\n                        // Invalid escape sequence.\n                        abort();\n                    }\n                  } else {\n                    if (charCode == 34) {\n                      // An unescaped double-quote character marks the end of the\n                      // string.\n                      break;\n                    }\n                    charCode = source.charCodeAt(Index);\n                    begin = Index;\n                    // Optimize for the common case where a string is valid.\n                    while (charCode >= 32 && charCode != 92 && charCode != 34) {\n                      charCode = source.charCodeAt(++Index);\n                    }\n                    // Append the string as-is.\n                    value += source.slice(begin, Index);\n                  }\n                }\n                if (source.charCodeAt(Index) == 34) {\n                  // Advance to the next character and return the revived string.\n                  Index++;\n                  return value;\n                }\n                // Unterminated string.\n                abort();\n              default:\n                // Parse numbers and literals.\n                begin = Index;\n                // Advance past the negative sign, if one is specified.\n                if (charCode == 45) {\n                  isSigned = true;\n                  charCode = source.charCodeAt(++Index);\n                }\n                // Parse an integer or floating-point value.\n                if (charCode >= 48 && charCode <= 57) {\n                  // Leading zeroes are interpreted as octal literals.\n                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {\n                    // Illegal octal literal.\n                    abort();\n                  }\n                  isSigned = false;\n                  // Parse the integer component.\n                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);\n                  // Floats cannot contain a leading decimal point; however, this\n                  // case is already accounted for by the parser.\n                  if (source.charCodeAt(Index) == 46) {\n                    position = ++Index;\n                    // Parse the decimal component.\n                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);\n                    if (position == Index) {\n                      // Illegal trailing decimal.\n                      abort();\n                    }\n                    Index = position;\n                  }\n                  // Parse exponents. The `e` denoting the exponent is\n                  // case-insensitive.\n                  charCode = source.charCodeAt(Index);\n                  if (charCode == 101 || charCode == 69) {\n                    charCode = source.charCodeAt(++Index);\n                    // Skip past the sign following the exponent, if one is\n                    // specified.\n                    if (charCode == 43 || charCode == 45) {\n                      Index++;\n                    }\n                    // Parse the exponential component.\n                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);\n                    if (position == Index) {\n                      // Illegal empty exponent.\n                      abort();\n                    }\n                    Index = position;\n                  }\n                  // Coerce the parsed value to a JavaScript number.\n                  return +source.slice(begin, Index);\n                }\n                // A negative sign may only precede numbers.\n                if (isSigned) {\n                  abort();\n                }\n                // `true`, `false`, and `null` literals.\n                if (source.slice(Index, Index + 4) == \"true\") {\n                  Index += 4;\n                  return true;\n                } else if (source.slice(Index, Index + 5) == \"false\") {\n                  Index += 5;\n                  return false;\n                } else if (source.slice(Index, Index + 4) == \"null\") {\n                  Index += 4;\n                  return null;\n                }\n                // Unrecognized token.\n                abort();\n            }\n          }\n          // Return the sentinel `$` character if the parser has reached the end\n          // of the source string.\n          return \"$\";\n        };\n\n        // Internal: Parses a JSON `value` token.\n        var get = function (value) {\n          var results, hasMembers;\n          if (value == \"$\") {\n            // Unexpected end of input.\n            abort();\n          }\n          if (typeof value == \"string\") {\n            if ((charIndexBuggy ? value.charAt(0) : value[0]) == \"@\") {\n              // Remove the sentinel `@` character.\n              return value.slice(1);\n            }\n            // Parse object and array literals.\n            if (value == \"[\") {\n              // Parses a JSON array, returning a new JavaScript array.\n              results = [];\n              for (;; hasMembers || (hasMembers = true)) {\n                value = lex();\n                // A closing square bracket marks the end of the array literal.\n                if (value == \"]\") {\n                  break;\n                }\n                // If the array literal contains elements, the current token\n                // should be a comma separating the previous element from the\n                // next.\n                if (hasMembers) {\n                  if (value == \",\") {\n                    value = lex();\n                    if (value == \"]\") {\n                      // Unexpected trailing `,` in array literal.\n                      abort();\n                    }\n                  } else {\n                    // A `,` must separate each array element.\n                    abort();\n                  }\n                }\n                // Elisions and leading commas are not permitted.\n                if (value == \",\") {\n                  abort();\n                }\n                results.push(get(value));\n              }\n              return results;\n            } else if (value == \"{\") {\n              // Parses a JSON object, returning a new JavaScript object.\n              results = {};\n              for (;; hasMembers || (hasMembers = true)) {\n                value = lex();\n                // A closing curly brace marks the end of the object literal.\n                if (value == \"}\") {\n                  break;\n                }\n                // If the object literal contains members, the current token\n                // should be a comma separator.\n                if (hasMembers) {\n                  if (value == \",\") {\n                    value = lex();\n                    if (value == \"}\") {\n                      // Unexpected trailing `,` in object literal.\n                      abort();\n                    }\n                  } else {\n                    // A `,` must separate each object member.\n                    abort();\n                  }\n                }\n                // Leading commas are not permitted, object property names must be\n                // double-quoted strings, and a `:` must separate each property\n                // name and value.\n                if (value == \",\" || typeof value != \"string\" || (charIndexBuggy ? value.charAt(0) : value[0]) != \"@\" || lex() != \":\") {\n                  abort();\n                }\n                results[value.slice(1)] = get(lex());\n              }\n              return results;\n            }\n            // Unexpected token encountered.\n            abort();\n          }\n          return value;\n        };\n\n        // Internal: Updates a traversed object member.\n        var update = function (source, property, callback) {\n          var element = walk(source, property, callback);\n          if (element === undef) {\n            delete source[property];\n          } else {\n            source[property] = element;\n          }\n        };\n\n        // Internal: Recursively traverses a parsed JSON object, invoking the\n        // `callback` function for each value. This is an implementation of the\n        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.\n        var walk = function (source, property, callback) {\n          var value = source[property], length;\n          if (typeof value == \"object\" && value) {\n            // `forEach` can't be used to traverse an array in Opera <= 8.54\n            // because its `Object#hasOwnProperty` implementation returns `false`\n            // for array indices (e.g., `![1, 2, 3].hasOwnProperty(\"0\")`).\n            if (getClass.call(value) == arrayClass) {\n              for (length = value.length; length--;) {\n                update(value, length, callback);\n              }\n            } else {\n              forEach(value, function (property) {\n                update(value, property, callback);\n              });\n            }\n          }\n          return callback.call(source, property, value);\n        };\n\n        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.\n        exports.parse = function (source, callback) {\n          var result, value;\n          Index = 0;\n          Source = \"\" + source;\n          result = get(lex());\n          // If a JSON string contains multiple tokens, it is invalid.\n          if (lex() != \"$\") {\n            abort();\n          }\n          // Reset the parser state.\n          Index = Source = null;\n          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[\"\"] = result, value), \"\", callback) : result;\n        };\n      }\n    }\n\n    exports[\"runInContext\"] = runInContext;\n    return exports;\n  }\n\n  if (freeExports && !isLoader) {\n    // Export for CommonJS environments.\n    runInContext(root, freeExports);\n  } else {\n    // Export for web browsers and JavaScript engines.\n    var nativeJSON = root.JSON,\n        previousJSON = root[\"JSON3\"],\n        isRestored = false;\n\n    var JSON3 = runInContext(root, (root[\"JSON3\"] = {\n      // Public: Restores the original value of the global `JSON` object and\n      // returns a reference to the `JSON3` object.\n      \"noConflict\": function () {\n        if (!isRestored) {\n          isRestored = true;\n          root.JSON = nativeJSON;\n          root[\"JSON3\"] = previousJSON;\n          nativeJSON = previousJSON = null;\n        }\n        return JSON3;\n      }\n    }));\n\n    root.JSON = {\n      \"parse\": JSON3.parse,\n      \"stringify\": JSON3.stringify\n    };\n  }\n\n  // Export for asynchronous module loaders.\n  if (isLoader) {\n    define(function () {\n      return JSON3;\n    });\n  }\n}).call(this);\n\n}).call(this,typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : typeof global !== \"undefined\" ? global : {})\n},{}],51:[function(_dereq_,module,exports){\nmodule.exports = toArray\n\nfunction toArray(list, index) {\n    var array = []\n\n    index = index || 0\n\n    for (var i = index || 0; i < list.length; i++) {\n        array[i - index] = list[i]\n    }\n\n    return array\n}\n\n},{}]},{},[31])(31)\n});\n"

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(508))

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = "/*\n     _ _      _       _\n ___| (_) ___| | __  (_)___\n/ __| | |/ __| |/ /  | / __|\n\\__ \\ | | (__|   < _ | \\__ \\\n|___/_|_|\\___|_|\\_(_)/ |___/\n                   |__/\n\n Version: 1.6.0\n  Author: Ken Wheeler\n Website: http://kenwheeler.github.io\n    Docs: http://kenwheeler.github.io/slick\n    Repo: http://github.com/kenwheeler/slick\n  Issues: http://github.com/kenwheeler/slick/issues\n\n */\n/* global window, document, define, jQuery, setInterval, clearInterval */\n(function(factory) {\n    'use strict';\n    if (typeof define === 'function' && define.amd) {\n        define(['jquery'], factory);\n    } else if (typeof exports !== 'undefined') {\n        module.exports = factory(require('jquery'));\n    } else {\n        factory(jQuery);\n    }\n\n}(function($) {\n    'use strict';\n    var Slick = window.Slick || {};\n\n    Slick = (function() {\n\n        var instanceUid = 0;\n\n        function Slick(element, settings) {\n\n            var _ = this, dataSettings;\n\n            _.defaults = {\n                accessibility: true,\n                adaptiveHeight: false,\n                appendArrows: $(element),\n                appendDots: $(element),\n                arrows: true,\n                asNavFor: null,\n                prevArrow: '<button type=\"button\" data-role=\"none\" class=\"slick-prev\" aria-label=\"Previous\" tabindex=\"0\" role=\"button\">Previous</button>',\n                nextArrow: '<button type=\"button\" data-role=\"none\" class=\"slick-next\" aria-label=\"Next\" tabindex=\"0\" role=\"button\">Next</button>',\n                autoplay: false,\n                autoplaySpeed: 3000,\n                centerMode: false,\n                centerPadding: '50px',\n                cssEase: 'ease',\n                customPaging: function(slider, i) {\n                    return $('<button type=\"button\" data-role=\"none\" role=\"button\" tabindex=\"0\" />').text(i + 1);\n                },\n                dots: false,\n                dotsClass: 'slick-dots',\n                draggable: true,\n                easing: 'linear',\n                edgeFriction: 0.35,\n                fade: false,\n                focusOnSelect: false,\n                infinite: true,\n                initialSlide: 0,\n                lazyLoad: 'ondemand',\n                mobileFirst: false,\n                pauseOnHover: true,\n                pauseOnFocus: true,\n                pauseOnDotsHover: false,\n                respondTo: 'window',\n                responsive: null,\n                rows: 1,\n                rtl: false,\n                slide: '',\n                slidesPerRow: 1,\n                slidesToShow: 1,\n                slidesToScroll: 1,\n                speed: 500,\n                swipe: true,\n                swipeToSlide: false,\n                touchMove: true,\n                touchThreshold: 5,\n                useCSS: true,\n                useTransform: true,\n                variableWidth: false,\n                vertical: false,\n                verticalSwiping: false,\n                waitForAnimate: true,\n                zIndex: 1000\n            };\n\n            _.initials = {\n                animating: false,\n                dragging: false,\n                autoPlayTimer: null,\n                currentDirection: 0,\n                currentLeft: null,\n                currentSlide: 0,\n                direction: 1,\n                $dots: null,\n                listWidth: null,\n                listHeight: null,\n                loadIndex: 0,\n                $nextArrow: null,\n                $prevArrow: null,\n                slideCount: null,\n                slideWidth: null,\n                $slideTrack: null,\n                $slides: null,\n                sliding: false,\n                slideOffset: 0,\n                swipeLeft: null,\n                $list: null,\n                touchObject: {},\n                transformsEnabled: false,\n                unslicked: false\n            };\n\n            $.extend(_, _.initials);\n\n            _.activeBreakpoint = null;\n            _.animType = null;\n            _.animProp = null;\n            _.breakpoints = [];\n            _.breakpointSettings = [];\n            _.cssTransitions = false;\n            _.focussed = false;\n            _.interrupted = false;\n            _.hidden = 'hidden';\n            _.paused = true;\n            _.positionProp = null;\n            _.respondTo = null;\n            _.rowCount = 1;\n            _.shouldClick = true;\n            _.$slider = $(element);\n            _.$slidesCache = null;\n            _.transformType = null;\n            _.transitionType = null;\n            _.visibilityChange = 'visibilitychange';\n            _.windowWidth = 0;\n            _.windowTimer = null;\n\n            dataSettings = $(element).data('slick') || {};\n\n            _.options = $.extend({}, _.defaults, settings, dataSettings);\n\n            _.currentSlide = _.options.initialSlide;\n\n            _.originalSettings = _.options;\n\n            if (typeof document.mozHidden !== 'undefined') {\n                _.hidden = 'mozHidden';\n                _.visibilityChange = 'mozvisibilitychange';\n            } else if (typeof document.webkitHidden !== 'undefined') {\n                _.hidden = 'webkitHidden';\n                _.visibilityChange = 'webkitvisibilitychange';\n            }\n\n            _.autoPlay = $.proxy(_.autoPlay, _);\n            _.autoPlayClear = $.proxy(_.autoPlayClear, _);\n            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);\n            _.changeSlide = $.proxy(_.changeSlide, _);\n            _.clickHandler = $.proxy(_.clickHandler, _);\n            _.selectHandler = $.proxy(_.selectHandler, _);\n            _.setPosition = $.proxy(_.setPosition, _);\n            _.swipeHandler = $.proxy(_.swipeHandler, _);\n            _.dragHandler = $.proxy(_.dragHandler, _);\n            _.keyHandler = $.proxy(_.keyHandler, _);\n\n            _.instanceUid = instanceUid++;\n\n            // A simple way to check for HTML strings\n            // Strict HTML recognition (must start with <)\n            // Extracted from jQuery v1.11 source\n            _.htmlExpr = /^(?:\\s*(<[\\w\\W]+>)[^>]*)$/;\n\n\n            _.registerBreakpoints();\n            _.init(true);\n\n        }\n\n        return Slick;\n\n    }());\n\n    Slick.prototype.activateADA = function() {\n        var _ = this;\n\n        _.$slideTrack.find('.slick-active').attr({\n            'aria-hidden': 'false'\n        }).find('a, input, button, select').attr({\n            'tabindex': '0'\n        });\n\n    };\n\n    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {\n\n        var _ = this;\n\n        if (typeof(index) === 'boolean') {\n            addBefore = index;\n            index = null;\n        } else if (index < 0 || (index >= _.slideCount)) {\n            return false;\n        }\n\n        _.unload();\n\n        if (typeof(index) === 'number') {\n            if (index === 0 && _.$slides.length === 0) {\n                $(markup).appendTo(_.$slideTrack);\n            } else if (addBefore) {\n                $(markup).insertBefore(_.$slides.eq(index));\n            } else {\n                $(markup).insertAfter(_.$slides.eq(index));\n            }\n        } else {\n            if (addBefore === true) {\n                $(markup).prependTo(_.$slideTrack);\n            } else {\n                $(markup).appendTo(_.$slideTrack);\n            }\n        }\n\n        _.$slides = _.$slideTrack.children(this.options.slide);\n\n        _.$slideTrack.children(this.options.slide).detach();\n\n        _.$slideTrack.append(_.$slides);\n\n        _.$slides.each(function(index, element) {\n            $(element).attr('data-slick-index', index);\n        });\n\n        _.$slidesCache = _.$slides;\n\n        _.reinit();\n\n    };\n\n    Slick.prototype.animateHeight = function() {\n        var _ = this;\n        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {\n            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);\n            _.$list.animate({\n                height: targetHeight\n            }, _.options.speed);\n        }\n    };\n\n    Slick.prototype.animateSlide = function(targetLeft, callback) {\n\n        var animProps = {},\n            _ = this;\n\n        _.animateHeight();\n\n        if (_.options.rtl === true && _.options.vertical === false) {\n            targetLeft = -targetLeft;\n        }\n        if (_.transformsEnabled === false) {\n            if (_.options.vertical === false) {\n                _.$slideTrack.animate({\n                    left: targetLeft\n                }, _.options.speed, _.options.easing, callback);\n            } else {\n                _.$slideTrack.animate({\n                    top: targetLeft\n                }, _.options.speed, _.options.easing, callback);\n            }\n\n        } else {\n\n            if (_.cssTransitions === false) {\n                if (_.options.rtl === true) {\n                    _.currentLeft = -(_.currentLeft);\n                }\n                $({\n                    animStart: _.currentLeft\n                }).animate({\n                    animStart: targetLeft\n                }, {\n                    duration: _.options.speed,\n                    easing: _.options.easing,\n                    step: function(now) {\n                        now = Math.ceil(now);\n                        if (_.options.vertical === false) {\n                            animProps[_.animType] = 'translate(' +\n                                now + 'px, 0px)';\n                            _.$slideTrack.css(animProps);\n                        } else {\n                            animProps[_.animType] = 'translate(0px,' +\n                                now + 'px)';\n                            _.$slideTrack.css(animProps);\n                        }\n                    },\n                    complete: function() {\n                        if (callback) {\n                            callback.call();\n                        }\n                    }\n                });\n\n            } else {\n\n                _.applyTransition();\n                targetLeft = Math.ceil(targetLeft);\n\n                if (_.options.vertical === false) {\n                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';\n                } else {\n                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';\n                }\n                _.$slideTrack.css(animProps);\n\n                if (callback) {\n                    setTimeout(function() {\n\n                        _.disableTransition();\n\n                        callback.call();\n                    }, _.options.speed);\n                }\n\n            }\n\n        }\n\n    };\n\n    Slick.prototype.getNavTarget = function() {\n\n        var _ = this,\n            asNavFor = _.options.asNavFor;\n\n        if ( asNavFor && asNavFor !== null ) {\n            asNavFor = $(asNavFor).not(_.$slider);\n        }\n\n        return asNavFor;\n\n    };\n\n    Slick.prototype.asNavFor = function(index) {\n\n        var _ = this,\n            asNavFor = _.getNavTarget();\n\n        if ( asNavFor !== null && typeof asNavFor === 'object' ) {\n            asNavFor.each(function() {\n                var target = $(this).slick('getSlick');\n                if(!target.unslicked) {\n                    target.slideHandler(index, true);\n                }\n            });\n        }\n\n    };\n\n    Slick.prototype.applyTransition = function(slide) {\n\n        var _ = this,\n            transition = {};\n\n        if (_.options.fade === false) {\n            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;\n        } else {\n            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;\n        }\n\n        if (_.options.fade === false) {\n            _.$slideTrack.css(transition);\n        } else {\n            _.$slides.eq(slide).css(transition);\n        }\n\n    };\n\n    Slick.prototype.autoPlay = function() {\n\n        var _ = this;\n\n        _.autoPlayClear();\n\n        if ( _.slideCount > _.options.slidesToShow ) {\n            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );\n        }\n\n    };\n\n    Slick.prototype.autoPlayClear = function() {\n\n        var _ = this;\n\n        if (_.autoPlayTimer) {\n            clearInterval(_.autoPlayTimer);\n        }\n\n    };\n\n    Slick.prototype.autoPlayIterator = function() {\n\n        var _ = this,\n            slideTo = _.currentSlide + _.options.slidesToScroll;\n\n        if ( !_.paused && !_.interrupted && !_.focussed ) {\n\n            if ( _.options.infinite === false ) {\n\n                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {\n                    _.direction = 0;\n                }\n\n                else if ( _.direction === 0 ) {\n\n                    slideTo = _.currentSlide - _.options.slidesToScroll;\n\n                    if ( _.currentSlide - 1 === 0 ) {\n                        _.direction = 1;\n                    }\n\n                }\n\n            }\n\n            _.slideHandler( slideTo );\n\n        }\n\n    };\n\n    Slick.prototype.buildArrows = function() {\n\n        var _ = this;\n\n        if (_.options.arrows === true ) {\n\n            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');\n            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');\n\n            if( _.slideCount > _.options.slidesToShow ) {\n\n                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');\n                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');\n\n                if (_.htmlExpr.test(_.options.prevArrow)) {\n                    _.$prevArrow.prependTo(_.options.appendArrows);\n                }\n\n                if (_.htmlExpr.test(_.options.nextArrow)) {\n                    _.$nextArrow.appendTo(_.options.appendArrows);\n                }\n\n                if (_.options.infinite !== true) {\n                    _.$prevArrow\n                        .addClass('slick-disabled')\n                        .attr('aria-disabled', 'true');\n                }\n\n            } else {\n\n                _.$prevArrow.add( _.$nextArrow )\n\n                    .addClass('slick-hidden')\n                    .attr({\n                        'aria-disabled': 'true',\n                        'tabindex': '-1'\n                    });\n\n            }\n\n        }\n\n    };\n\n    Slick.prototype.buildDots = function() {\n\n        var _ = this,\n            i, dot;\n\n        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {\n\n            _.$slider.addClass('slick-dotted');\n\n            dot = $('<ul />').addClass(_.options.dotsClass);\n\n            for (i = 0; i <= _.getDotCount(); i += 1) {\n                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));\n            }\n\n            _.$dots = dot.appendTo(_.options.appendDots);\n\n            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');\n\n        }\n\n    };\n\n    Slick.prototype.buildOut = function() {\n\n        var _ = this;\n\n        _.$slides =\n            _.$slider\n                .children( _.options.slide + ':not(.slick-cloned)')\n                .addClass('slick-slide');\n\n        _.slideCount = _.$slides.length;\n\n        _.$slides.each(function(index, element) {\n            $(element)\n                .attr('data-slick-index', index)\n                .data('originalStyling', $(element).attr('style') || '');\n        });\n\n        _.$slider.addClass('slick-slider');\n\n        _.$slideTrack = (_.slideCount === 0) ?\n            $('<div class=\"slick-track\"/>').appendTo(_.$slider) :\n            _.$slides.wrapAll('<div class=\"slick-track\"/>').parent();\n\n        _.$list = _.$slideTrack.wrap(\n            '<div aria-live=\"polite\" class=\"slick-list\"/>').parent();\n        _.$slideTrack.css('opacity', 0);\n\n        if (_.options.centerMode === true || _.options.swipeToSlide === true) {\n            _.options.slidesToScroll = 1;\n        }\n\n        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');\n\n        _.setupInfinite();\n\n        _.buildArrows();\n\n        _.buildDots();\n\n        _.updateDots();\n\n\n        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);\n\n        if (_.options.draggable === true) {\n            _.$list.addClass('draggable');\n        }\n\n    };\n\n    Slick.prototype.buildRows = function() {\n\n        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;\n\n        newSlides = document.createDocumentFragment();\n        originalSlides = _.$slider.children();\n\n        if(_.options.rows > 1) {\n\n            slidesPerSection = _.options.slidesPerRow * _.options.rows;\n            numOfSlides = Math.ceil(\n                originalSlides.length / slidesPerSection\n            );\n\n            for(a = 0; a < numOfSlides; a++){\n                var slide = document.createElement('div');\n                for(b = 0; b < _.options.rows; b++) {\n                    var row = document.createElement('div');\n                    for(c = 0; c < _.options.slidesPerRow; c++) {\n                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));\n                        if (originalSlides.get(target)) {\n                            row.appendChild(originalSlides.get(target));\n                        }\n                    }\n                    slide.appendChild(row);\n                }\n                newSlides.appendChild(slide);\n            }\n\n            _.$slider.empty().append(newSlides);\n            _.$slider.children().children().children()\n                .css({\n                    'width':(100 / _.options.slidesPerRow) + '%',\n                    'display': 'inline-block'\n                });\n\n        }\n\n    };\n\n    Slick.prototype.checkResponsive = function(initial, forceUpdate) {\n\n        var _ = this,\n            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;\n        var sliderWidth = _.$slider.width();\n        var windowWidth = window.innerWidth || $(window).width();\n\n        if (_.respondTo === 'window') {\n            respondToWidth = windowWidth;\n        } else if (_.respondTo === 'slider') {\n            respondToWidth = sliderWidth;\n        } else if (_.respondTo === 'min') {\n            respondToWidth = Math.min(windowWidth, sliderWidth);\n        }\n\n        if ( _.options.responsive &&\n            _.options.responsive.length &&\n            _.options.responsive !== null) {\n\n            targetBreakpoint = null;\n\n            for (breakpoint in _.breakpoints) {\n                if (_.breakpoints.hasOwnProperty(breakpoint)) {\n                    if (_.originalSettings.mobileFirst === false) {\n                        if (respondToWidth < _.breakpoints[breakpoint]) {\n                            targetBreakpoint = _.breakpoints[breakpoint];\n                        }\n                    } else {\n                        if (respondToWidth > _.breakpoints[breakpoint]) {\n                            targetBreakpoint = _.breakpoints[breakpoint];\n                        }\n                    }\n                }\n            }\n\n            if (targetBreakpoint !== null) {\n                if (_.activeBreakpoint !== null) {\n                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {\n                        _.activeBreakpoint =\n                            targetBreakpoint;\n                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {\n                            _.unslick(targetBreakpoint);\n                        } else {\n                            _.options = $.extend({}, _.originalSettings,\n                                _.breakpointSettings[\n                                    targetBreakpoint]);\n                            if (initial === true) {\n                                _.currentSlide = _.options.initialSlide;\n                            }\n                            _.refresh(initial);\n                        }\n                        triggerBreakpoint = targetBreakpoint;\n                    }\n                } else {\n                    _.activeBreakpoint = targetBreakpoint;\n                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {\n                        _.unslick(targetBreakpoint);\n                    } else {\n                        _.options = $.extend({}, _.originalSettings,\n                            _.breakpointSettings[\n                                targetBreakpoint]);\n                        if (initial === true) {\n                            _.currentSlide = _.options.initialSlide;\n                        }\n                        _.refresh(initial);\n                    }\n                    triggerBreakpoint = targetBreakpoint;\n                }\n            } else {\n                if (_.activeBreakpoint !== null) {\n                    _.activeBreakpoint = null;\n                    _.options = _.originalSettings;\n                    if (initial === true) {\n                        _.currentSlide = _.options.initialSlide;\n                    }\n                    _.refresh(initial);\n                    triggerBreakpoint = targetBreakpoint;\n                }\n            }\n\n            // only trigger breakpoints during an actual break. not on initialize.\n            if( !initial && triggerBreakpoint !== false ) {\n                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);\n            }\n        }\n\n    };\n\n    Slick.prototype.changeSlide = function(event, dontAnimate) {\n\n        var _ = this,\n            $target = $(event.currentTarget),\n            indexOffset, slideOffset, unevenOffset;\n\n        // If target is a link, prevent default action.\n        if($target.is('a')) {\n            event.preventDefault();\n        }\n\n        // If target is not the <li> element (ie: a child), find the <li>.\n        if(!$target.is('li')) {\n            $target = $target.closest('li');\n        }\n\n        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);\n        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;\n\n        switch (event.data.message) {\n\n            case 'previous':\n                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;\n                if (_.slideCount > _.options.slidesToShow) {\n                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);\n                }\n                break;\n\n            case 'next':\n                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;\n                if (_.slideCount > _.options.slidesToShow) {\n                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);\n                }\n                break;\n\n            case 'index':\n                var index = event.data.index === 0 ? 0 :\n                    event.data.index || $target.index() * _.options.slidesToScroll;\n\n                _.slideHandler(_.checkNavigable(index), false, dontAnimate);\n                $target.children().trigger('focus');\n                break;\n\n            default:\n                return;\n        }\n\n    };\n\n    Slick.prototype.checkNavigable = function(index) {\n\n        var _ = this,\n            navigables, prevNavigable;\n\n        navigables = _.getNavigableIndexes();\n        prevNavigable = 0;\n        if (index > navigables[navigables.length - 1]) {\n            index = navigables[navigables.length - 1];\n        } else {\n            for (var n in navigables) {\n                if (index < navigables[n]) {\n                    index = prevNavigable;\n                    break;\n                }\n                prevNavigable = navigables[n];\n            }\n        }\n\n        return index;\n    };\n\n    Slick.prototype.cleanUpEvents = function() {\n\n        var _ = this;\n\n        if (_.options.dots && _.$dots !== null) {\n\n            $('li', _.$dots)\n                .off('click.slick', _.changeSlide)\n                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))\n                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));\n\n        }\n\n        _.$slider.off('focus.slick blur.slick');\n\n        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {\n            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);\n            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);\n        }\n\n        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);\n        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);\n        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);\n        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);\n\n        _.$list.off('click.slick', _.clickHandler);\n\n        $(document).off(_.visibilityChange, _.visibility);\n\n        _.cleanUpSlideEvents();\n\n        if (_.options.accessibility === true) {\n            _.$list.off('keydown.slick', _.keyHandler);\n        }\n\n        if (_.options.focusOnSelect === true) {\n            $(_.$slideTrack).children().off('click.slick', _.selectHandler);\n        }\n\n        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);\n\n        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);\n\n        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);\n\n        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);\n        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);\n\n    };\n\n    Slick.prototype.cleanUpSlideEvents = function() {\n\n        var _ = this;\n\n        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));\n        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));\n\n    };\n\n    Slick.prototype.cleanUpRows = function() {\n\n        var _ = this, originalSlides;\n\n        if(_.options.rows > 1) {\n            originalSlides = _.$slides.children().children();\n            originalSlides.removeAttr('style');\n            _.$slider.empty().append(originalSlides);\n        }\n\n    };\n\n    Slick.prototype.clickHandler = function(event) {\n\n        var _ = this;\n\n        if (_.shouldClick === false) {\n            event.stopImmediatePropagation();\n            event.stopPropagation();\n            event.preventDefault();\n        }\n\n    };\n\n    Slick.prototype.destroy = function(refresh) {\n\n        var _ = this;\n\n        _.autoPlayClear();\n\n        _.touchObject = {};\n\n        _.cleanUpEvents();\n\n        $('.slick-cloned', _.$slider).detach();\n\n        if (_.$dots) {\n            _.$dots.remove();\n        }\n\n\n        if ( _.$prevArrow && _.$prevArrow.length ) {\n\n            _.$prevArrow\n                .removeClass('slick-disabled slick-arrow slick-hidden')\n                .removeAttr('aria-hidden aria-disabled tabindex')\n                .css('display','');\n\n            if ( _.htmlExpr.test( _.options.prevArrow )) {\n                _.$prevArrow.remove();\n            }\n        }\n\n        if ( _.$nextArrow && _.$nextArrow.length ) {\n\n            _.$nextArrow\n                .removeClass('slick-disabled slick-arrow slick-hidden')\n                .removeAttr('aria-hidden aria-disabled tabindex')\n                .css('display','');\n\n            if ( _.htmlExpr.test( _.options.nextArrow )) {\n                _.$nextArrow.remove();\n            }\n\n        }\n\n\n        if (_.$slides) {\n\n            _.$slides\n                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')\n                .removeAttr('aria-hidden')\n                .removeAttr('data-slick-index')\n                .each(function(){\n                    $(this).attr('style', $(this).data('originalStyling'));\n                });\n\n            _.$slideTrack.children(this.options.slide).detach();\n\n            _.$slideTrack.detach();\n\n            _.$list.detach();\n\n            _.$slider.append(_.$slides);\n        }\n\n        _.cleanUpRows();\n\n        _.$slider.removeClass('slick-slider');\n        _.$slider.removeClass('slick-initialized');\n        _.$slider.removeClass('slick-dotted');\n\n        _.unslicked = true;\n\n        if(!refresh) {\n            _.$slider.trigger('destroy', [_]);\n        }\n\n    };\n\n    Slick.prototype.disableTransition = function(slide) {\n\n        var _ = this,\n            transition = {};\n\n        transition[_.transitionType] = '';\n\n        if (_.options.fade === false) {\n            _.$slideTrack.css(transition);\n        } else {\n            _.$slides.eq(slide).css(transition);\n        }\n\n    };\n\n    Slick.prototype.fadeSlide = function(slideIndex, callback) {\n\n        var _ = this;\n\n        if (_.cssTransitions === false) {\n\n            _.$slides.eq(slideIndex).css({\n                zIndex: _.options.zIndex\n            });\n\n            _.$slides.eq(slideIndex).animate({\n                opacity: 1\n            }, _.options.speed, _.options.easing, callback);\n\n        } else {\n\n            _.applyTransition(slideIndex);\n\n            _.$slides.eq(slideIndex).css({\n                opacity: 1,\n                zIndex: _.options.zIndex\n            });\n\n            if (callback) {\n                setTimeout(function() {\n\n                    _.disableTransition(slideIndex);\n\n                    callback.call();\n                }, _.options.speed);\n            }\n\n        }\n\n    };\n\n    Slick.prototype.fadeSlideOut = function(slideIndex) {\n\n        var _ = this;\n\n        if (_.cssTransitions === false) {\n\n            _.$slides.eq(slideIndex).animate({\n                opacity: 0,\n                zIndex: _.options.zIndex - 2\n            }, _.options.speed, _.options.easing);\n\n        } else {\n\n            _.applyTransition(slideIndex);\n\n            _.$slides.eq(slideIndex).css({\n                opacity: 0,\n                zIndex: _.options.zIndex - 2\n            });\n\n        }\n\n    };\n\n    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {\n\n        var _ = this;\n\n        if (filter !== null) {\n\n            _.$slidesCache = _.$slides;\n\n            _.unload();\n\n            _.$slideTrack.children(this.options.slide).detach();\n\n            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);\n\n            _.reinit();\n\n        }\n\n    };\n\n    Slick.prototype.focusHandler = function() {\n\n        var _ = this;\n\n        _.$slider\n            .off('focus.slick blur.slick')\n            .on('focus.slick blur.slick',\n                '*:not(.slick-arrow)', function(event) {\n\n            event.stopImmediatePropagation();\n            var $sf = $(this);\n\n            setTimeout(function() {\n\n                if( _.options.pauseOnFocus ) {\n                    _.focussed = $sf.is(':focus');\n                    _.autoPlay();\n                }\n\n            }, 0);\n\n        });\n    };\n\n    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {\n\n        var _ = this;\n        return _.currentSlide;\n\n    };\n\n    Slick.prototype.getDotCount = function() {\n\n        var _ = this;\n\n        var breakPoint = 0;\n        var counter = 0;\n        var pagerQty = 0;\n\n        if (_.options.infinite === true) {\n            while (breakPoint < _.slideCount) {\n                ++pagerQty;\n                breakPoint = counter + _.options.slidesToScroll;\n                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;\n            }\n        } else if (_.options.centerMode === true) {\n            pagerQty = _.slideCount;\n        } else if(!_.options.asNavFor) {\n            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);\n        }else {\n            while (breakPoint < _.slideCount) {\n                ++pagerQty;\n                breakPoint = counter + _.options.slidesToScroll;\n                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;\n            }\n        }\n\n        return pagerQty - 1;\n\n    };\n\n    Slick.prototype.getLeft = function(slideIndex) {\n\n        var _ = this,\n            targetLeft,\n            verticalHeight,\n            verticalOffset = 0,\n            targetSlide;\n\n        _.slideOffset = 0;\n        verticalHeight = _.$slides.first().outerHeight(true);\n\n        if (_.options.infinite === true) {\n            if (_.slideCount > _.options.slidesToShow) {\n                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;\n                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;\n            }\n            if (_.slideCount % _.options.slidesToScroll !== 0) {\n                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {\n                    if (slideIndex > _.slideCount) {\n                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;\n                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;\n                    } else {\n                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;\n                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;\n                    }\n                }\n            }\n        } else {\n            if (slideIndex + _.options.slidesToShow > _.slideCount) {\n                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;\n                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;\n            }\n        }\n\n        if (_.slideCount <= _.options.slidesToShow) {\n            _.slideOffset = 0;\n            verticalOffset = 0;\n        }\n\n        if (_.options.centerMode === true && _.options.infinite === true) {\n            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;\n        } else if (_.options.centerMode === true) {\n            _.slideOffset = 0;\n            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);\n        }\n\n        if (_.options.vertical === false) {\n            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;\n        } else {\n            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;\n        }\n\n        if (_.options.variableWidth === true) {\n\n            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {\n                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);\n            } else {\n                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);\n            }\n\n            if (_.options.rtl === true) {\n                if (targetSlide[0]) {\n                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;\n                } else {\n                    targetLeft =  0;\n                }\n            } else {\n                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;\n            }\n\n            if (_.options.centerMode === true) {\n                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {\n                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);\n                } else {\n                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);\n                }\n\n                if (_.options.rtl === true) {\n                    if (targetSlide[0]) {\n                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;\n                    } else {\n                        targetLeft =  0;\n                    }\n                } else {\n                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;\n                }\n\n                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;\n            }\n        }\n\n        return targetLeft;\n\n    };\n\n    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {\n\n        var _ = this;\n\n        return _.options[option];\n\n    };\n\n    Slick.prototype.getNavigableIndexes = function() {\n\n        var _ = this,\n            breakPoint = 0,\n            counter = 0,\n            indexes = [],\n            max;\n\n        if (_.options.infinite === false) {\n            max = _.slideCount;\n        } else {\n            breakPoint = _.options.slidesToScroll * -1;\n            counter = _.options.slidesToScroll * -1;\n            max = _.slideCount * 2;\n        }\n\n        while (breakPoint < max) {\n            indexes.push(breakPoint);\n            breakPoint = counter + _.options.slidesToScroll;\n            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;\n        }\n\n        return indexes;\n\n    };\n\n    Slick.prototype.getSlick = function() {\n\n        return this;\n\n    };\n\n    Slick.prototype.getSlideCount = function() {\n\n        var _ = this,\n            slidesTraversed, swipedSlide, centerOffset;\n\n        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;\n\n        if (_.options.swipeToSlide === true) {\n            _.$slideTrack.find('.slick-slide').each(function(index, slide) {\n                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {\n                    swipedSlide = slide;\n                    return false;\n                }\n            });\n\n            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;\n\n            return slidesTraversed;\n\n        } else {\n            return _.options.slidesToScroll;\n        }\n\n    };\n\n    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {\n\n        var _ = this;\n\n        _.changeSlide({\n            data: {\n                message: 'index',\n                index: parseInt(slide)\n            }\n        }, dontAnimate);\n\n    };\n\n    Slick.prototype.init = function(creation) {\n\n        var _ = this;\n\n        if (!$(_.$slider).hasClass('slick-initialized')) {\n\n            $(_.$slider).addClass('slick-initialized');\n\n            _.buildRows();\n            _.buildOut();\n            _.setProps();\n            _.startLoad();\n            _.loadSlider();\n            _.initializeEvents();\n            _.updateArrows();\n            _.updateDots();\n            _.checkResponsive(true);\n            _.focusHandler();\n\n        }\n\n        if (creation) {\n            _.$slider.trigger('init', [_]);\n        }\n\n        if (_.options.accessibility === true) {\n            _.initADA();\n        }\n\n        if ( _.options.autoplay ) {\n\n            _.paused = false;\n            _.autoPlay();\n\n        }\n\n    };\n\n    Slick.prototype.initADA = function() {\n        var _ = this;\n        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({\n            'aria-hidden': 'true',\n            'tabindex': '-1'\n        }).find('a, input, button, select').attr({\n            'tabindex': '-1'\n        });\n\n        _.$slideTrack.attr('role', 'listbox');\n\n        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {\n            $(this).attr({\n                'role': 'option',\n                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''\n            });\n        });\n\n        if (_.$dots !== null) {\n            _.$dots.attr('role', 'tablist').find('li').each(function(i) {\n                $(this).attr({\n                    'role': 'presentation',\n                    'aria-selected': 'false',\n                    'aria-controls': 'navigation' + _.instanceUid + i + '',\n                    'id': 'slick-slide' + _.instanceUid + i + ''\n                });\n            })\n                .first().attr('aria-selected', 'true').end()\n                .find('button').attr('role', 'button').end()\n                .closest('div').attr('role', 'toolbar');\n        }\n        _.activateADA();\n\n    };\n\n    Slick.prototype.initArrowEvents = function() {\n\n        var _ = this;\n\n        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {\n            _.$prevArrow\n               .off('click.slick')\n               .on('click.slick', {\n                    message: 'previous'\n               }, _.changeSlide);\n            _.$nextArrow\n               .off('click.slick')\n               .on('click.slick', {\n                    message: 'next'\n               }, _.changeSlide);\n        }\n\n    };\n\n    Slick.prototype.initDotEvents = function() {\n\n        var _ = this;\n\n        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {\n            $('li', _.$dots).on('click.slick', {\n                message: 'index'\n            }, _.changeSlide);\n        }\n\n        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {\n\n            $('li', _.$dots)\n                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))\n                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));\n\n        }\n\n    };\n\n    Slick.prototype.initSlideEvents = function() {\n\n        var _ = this;\n\n        if ( _.options.pauseOnHover ) {\n\n            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));\n            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));\n\n        }\n\n    };\n\n    Slick.prototype.initializeEvents = function() {\n\n        var _ = this;\n\n        _.initArrowEvents();\n\n        _.initDotEvents();\n        _.initSlideEvents();\n\n        _.$list.on('touchstart.slick mousedown.slick', {\n            action: 'start'\n        }, _.swipeHandler);\n        _.$list.on('touchmove.slick mousemove.slick', {\n            action: 'move'\n        }, _.swipeHandler);\n        _.$list.on('touchend.slick mouseup.slick', {\n            action: 'end'\n        }, _.swipeHandler);\n        _.$list.on('touchcancel.slick mouseleave.slick', {\n            action: 'end'\n        }, _.swipeHandler);\n\n        _.$list.on('click.slick', _.clickHandler);\n\n        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));\n\n        if (_.options.accessibility === true) {\n            _.$list.on('keydown.slick', _.keyHandler);\n        }\n\n        if (_.options.focusOnSelect === true) {\n            $(_.$slideTrack).children().on('click.slick', _.selectHandler);\n        }\n\n        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));\n\n        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));\n\n        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);\n\n        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);\n        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);\n\n    };\n\n    Slick.prototype.initUI = function() {\n\n        var _ = this;\n\n        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {\n\n            _.$prevArrow.show();\n            _.$nextArrow.show();\n\n        }\n\n        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {\n\n            _.$dots.show();\n\n        }\n\n    };\n\n    Slick.prototype.keyHandler = function(event) {\n\n        var _ = this;\n         //Dont slide if the cursor is inside the form fields and arrow keys are pressed\n        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {\n            if (event.keyCode === 37 && _.options.accessibility === true) {\n                _.changeSlide({\n                    data: {\n                        message: _.options.rtl === true ? 'next' :  'previous'\n                    }\n                });\n            } else if (event.keyCode === 39 && _.options.accessibility === true) {\n                _.changeSlide({\n                    data: {\n                        message: _.options.rtl === true ? 'previous' : 'next'\n                    }\n                });\n            }\n        }\n\n    };\n\n    Slick.prototype.lazyLoad = function() {\n\n        var _ = this,\n            loadRange, cloneRange, rangeStart, rangeEnd;\n\n        function loadImages(imagesScope) {\n\n            $('img[data-lazy]', imagesScope).each(function() {\n\n                var image = $(this),\n                    imageSource = $(this).attr('data-lazy'),\n                    imageToLoad = document.createElement('img');\n\n                imageToLoad.onload = function() {\n\n                    image\n                        .animate({ opacity: 0 }, 100, function() {\n                            image\n                                .attr('src', imageSource)\n                                .animate({ opacity: 1 }, 200, function() {\n                                    image\n                                        .removeAttr('data-lazy')\n                                        .removeClass('slick-loading');\n                                });\n                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);\n                        });\n\n                };\n\n                imageToLoad.onerror = function() {\n\n                    image\n                        .removeAttr( 'data-lazy' )\n                        .removeClass( 'slick-loading' )\n                        .addClass( 'slick-lazyload-error' );\n\n                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);\n\n                };\n\n                imageToLoad.src = imageSource;\n\n            });\n\n        }\n\n        if (_.options.centerMode === true) {\n            if (_.options.infinite === true) {\n                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);\n                rangeEnd = rangeStart + _.options.slidesToShow + 2;\n            } else {\n                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));\n                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;\n            }\n        } else {\n            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;\n            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);\n            if (_.options.fade === true) {\n                if (rangeStart > 0) rangeStart--;\n                if (rangeEnd <= _.slideCount) rangeEnd++;\n            }\n        }\n\n        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);\n        loadImages(loadRange);\n\n        if (_.slideCount <= _.options.slidesToShow) {\n            cloneRange = _.$slider.find('.slick-slide');\n            loadImages(cloneRange);\n        } else\n        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {\n            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);\n            loadImages(cloneRange);\n        } else if (_.currentSlide === 0) {\n            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);\n            loadImages(cloneRange);\n        }\n\n    };\n\n    Slick.prototype.loadSlider = function() {\n\n        var _ = this;\n\n        _.setPosition();\n\n        _.$slideTrack.css({\n            opacity: 1\n        });\n\n        _.$slider.removeClass('slick-loading');\n\n        _.initUI();\n\n        if (_.options.lazyLoad === 'progressive') {\n            _.progressiveLazyLoad();\n        }\n\n    };\n\n    Slick.prototype.next = Slick.prototype.slickNext = function() {\n\n        var _ = this;\n\n        _.changeSlide({\n            data: {\n                message: 'next'\n            }\n        });\n\n    };\n\n    Slick.prototype.orientationChange = function() {\n\n        var _ = this;\n\n        _.checkResponsive();\n        _.setPosition();\n\n    };\n\n    Slick.prototype.pause = Slick.prototype.slickPause = function() {\n\n        var _ = this;\n\n        _.autoPlayClear();\n        _.paused = true;\n\n    };\n\n    Slick.prototype.play = Slick.prototype.slickPlay = function() {\n\n        var _ = this;\n\n        _.autoPlay();\n        _.options.autoplay = true;\n        _.paused = false;\n        _.focussed = false;\n        _.interrupted = false;\n\n    };\n\n    Slick.prototype.postSlide = function(index) {\n\n        var _ = this;\n\n        if( !_.unslicked ) {\n\n            _.$slider.trigger('afterChange', [_, index]);\n\n            _.animating = false;\n\n            _.setPosition();\n\n            _.swipeLeft = null;\n\n            if ( _.options.autoplay ) {\n                _.autoPlay();\n            }\n\n            if (_.options.accessibility === true) {\n                _.initADA();\n            }\n\n        }\n\n    };\n\n    Slick.prototype.prev = Slick.prototype.slickPrev = function() {\n\n        var _ = this;\n\n        _.changeSlide({\n            data: {\n                message: 'previous'\n            }\n        });\n\n    };\n\n    Slick.prototype.preventDefault = function(event) {\n\n        event.preventDefault();\n\n    };\n\n    Slick.prototype.progressiveLazyLoad = function( tryCount ) {\n\n        tryCount = tryCount || 1;\n\n        var _ = this,\n            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),\n            image,\n            imageSource,\n            imageToLoad;\n\n        if ( $imgsToLoad.length ) {\n\n            image = $imgsToLoad.first();\n            imageSource = image.attr('data-lazy');\n            imageToLoad = document.createElement('img');\n\n            imageToLoad.onload = function() {\n\n                image\n                    .attr( 'src', imageSource )\n                    .removeAttr('data-lazy')\n                    .removeClass('slick-loading');\n\n                if ( _.options.adaptiveHeight === true ) {\n                    _.setPosition();\n                }\n\n                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);\n                _.progressiveLazyLoad();\n\n            };\n\n            imageToLoad.onerror = function() {\n\n                if ( tryCount < 3 ) {\n\n                    /**\n                     * try to load the image 3 times,\n                     * leave a slight delay so we don't get\n                     * servers blocking the request.\n                     */\n                    setTimeout( function() {\n                        _.progressiveLazyLoad( tryCount + 1 );\n                    }, 500 );\n\n                } else {\n\n                    image\n                        .removeAttr( 'data-lazy' )\n                        .removeClass( 'slick-loading' )\n                        .addClass( 'slick-lazyload-error' );\n\n                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);\n\n                    _.progressiveLazyLoad();\n\n                }\n\n            };\n\n            imageToLoad.src = imageSource;\n\n        } else {\n\n            _.$slider.trigger('allImagesLoaded', [ _ ]);\n\n        }\n\n    };\n\n    Slick.prototype.refresh = function( initializing ) {\n\n        var _ = this, currentSlide, lastVisibleIndex;\n\n        lastVisibleIndex = _.slideCount - _.options.slidesToShow;\n\n        // in non-infinite sliders, we don't want to go past the\n        // last visible index.\n        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {\n            _.currentSlide = lastVisibleIndex;\n        }\n\n        // if less slides than to show, go to start.\n        if ( _.slideCount <= _.options.slidesToShow ) {\n            _.currentSlide = 0;\n\n        }\n\n        currentSlide = _.currentSlide;\n\n        _.destroy(true);\n\n        $.extend(_, _.initials, { currentSlide: currentSlide });\n\n        _.init();\n\n        if( !initializing ) {\n\n            _.changeSlide({\n                data: {\n                    message: 'index',\n                    index: currentSlide\n                }\n            }, false);\n\n        }\n\n    };\n\n    Slick.prototype.registerBreakpoints = function() {\n\n        var _ = this, breakpoint, currentBreakpoint, l,\n            responsiveSettings = _.options.responsive || null;\n\n        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {\n\n            _.respondTo = _.options.respondTo || 'window';\n\n            for ( breakpoint in responsiveSettings ) {\n\n                l = _.breakpoints.length-1;\n                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;\n\n                if (responsiveSettings.hasOwnProperty(breakpoint)) {\n\n                    // loop through the breakpoints and cut out any existing\n                    // ones with the same breakpoint number, we don't want dupes.\n                    while( l >= 0 ) {\n                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {\n                            _.breakpoints.splice(l,1);\n                        }\n                        l--;\n                    }\n\n                    _.breakpoints.push(currentBreakpoint);\n                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;\n\n                }\n\n            }\n\n            _.breakpoints.sort(function(a, b) {\n                return ( _.options.mobileFirst ) ? a-b : b-a;\n            });\n\n        }\n\n    };\n\n    Slick.prototype.reinit = function() {\n\n        var _ = this;\n\n        _.$slides =\n            _.$slideTrack\n                .children(_.options.slide)\n                .addClass('slick-slide');\n\n        _.slideCount = _.$slides.length;\n\n        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {\n            _.currentSlide = _.currentSlide - _.options.slidesToScroll;\n        }\n\n        if (_.slideCount <= _.options.slidesToShow) {\n            _.currentSlide = 0;\n        }\n\n        _.registerBreakpoints();\n\n        _.setProps();\n        _.setupInfinite();\n        _.buildArrows();\n        _.updateArrows();\n        _.initArrowEvents();\n        _.buildDots();\n        _.updateDots();\n        _.initDotEvents();\n        _.cleanUpSlideEvents();\n        _.initSlideEvents();\n\n        _.checkResponsive(false, true);\n\n        if (_.options.focusOnSelect === true) {\n            $(_.$slideTrack).children().on('click.slick', _.selectHandler);\n        }\n\n        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);\n\n        _.setPosition();\n        _.focusHandler();\n\n        _.paused = !_.options.autoplay;\n        _.autoPlay();\n\n        _.$slider.trigger('reInit', [_]);\n\n    };\n\n    Slick.prototype.resize = function() {\n\n        var _ = this;\n\n        if ($(window).width() !== _.windowWidth) {\n            clearTimeout(_.windowDelay);\n            _.windowDelay = window.setTimeout(function() {\n                _.windowWidth = $(window).width();\n                _.checkResponsive();\n                if( !_.unslicked ) { _.setPosition(); }\n            }, 50);\n        }\n    };\n\n    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {\n\n        var _ = this;\n\n        if (typeof(index) === 'boolean') {\n            removeBefore = index;\n            index = removeBefore === true ? 0 : _.slideCount - 1;\n        } else {\n            index = removeBefore === true ? --index : index;\n        }\n\n        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {\n            return false;\n        }\n\n        _.unload();\n\n        if (removeAll === true) {\n            _.$slideTrack.children().remove();\n        } else {\n            _.$slideTrack.children(this.options.slide).eq(index).remove();\n        }\n\n        _.$slides = _.$slideTrack.children(this.options.slide);\n\n        _.$slideTrack.children(this.options.slide).detach();\n\n        _.$slideTrack.append(_.$slides);\n\n        _.$slidesCache = _.$slides;\n\n        _.reinit();\n\n    };\n\n    Slick.prototype.setCSS = function(position) {\n\n        var _ = this,\n            positionProps = {},\n            x, y;\n\n        if (_.options.rtl === true) {\n            position = -position;\n        }\n        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';\n        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';\n\n        positionProps[_.positionProp] = position;\n\n        if (_.transformsEnabled === false) {\n            _.$slideTrack.css(positionProps);\n        } else {\n            positionProps = {};\n            if (_.cssTransitions === false) {\n                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';\n                _.$slideTrack.css(positionProps);\n            } else {\n                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';\n                _.$slideTrack.css(positionProps);\n            }\n        }\n\n    };\n\n    Slick.prototype.setDimensions = function() {\n\n        var _ = this;\n\n        if (_.options.vertical === false) {\n            if (_.options.centerMode === true) {\n                _.$list.css({\n                    padding: ('0px ' + _.options.centerPadding)\n                });\n            }\n        } else {\n            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);\n            if (_.options.centerMode === true) {\n                _.$list.css({\n                    padding: (_.options.centerPadding + ' 0px')\n                });\n            }\n        }\n\n        _.listWidth = _.$list.width();\n        _.listHeight = _.$list.height();\n\n\n        if (_.options.vertical === false && _.options.variableWidth === false) {\n            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);\n            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));\n\n        } else if (_.options.variableWidth === true) {\n            _.$slideTrack.width(5000 * _.slideCount);\n        } else {\n            _.slideWidth = Math.ceil(_.listWidth);\n            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));\n        }\n\n        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();\n        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);\n\n    };\n\n    Slick.prototype.setFade = function() {\n\n        var _ = this,\n            targetLeft;\n\n        _.$slides.each(function(index, element) {\n            targetLeft = (_.slideWidth * index) * -1;\n            if (_.options.rtl === true) {\n                $(element).css({\n                    position: 'relative',\n                    right: targetLeft,\n                    top: 0,\n                    zIndex: _.options.zIndex - 2,\n                    opacity: 0\n                });\n            } else {\n                $(element).css({\n                    position: 'relative',\n                    left: targetLeft,\n                    top: 0,\n                    zIndex: _.options.zIndex - 2,\n                    opacity: 0\n                });\n            }\n        });\n\n        _.$slides.eq(_.currentSlide).css({\n            zIndex: _.options.zIndex - 1,\n            opacity: 1\n        });\n\n    };\n\n    Slick.prototype.setHeight = function() {\n\n        var _ = this;\n\n        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {\n            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);\n            _.$list.css('height', targetHeight);\n        }\n\n    };\n\n    Slick.prototype.setOption =\n    Slick.prototype.slickSetOption = function() {\n\n        /**\n         * accepts arguments in format of:\n         *\n         *  - for changing a single option's value:\n         *     .slick(\"setOption\", option, value, refresh )\n         *\n         *  - for changing a set of responsive options:\n         *     .slick(\"setOption\", 'responsive', [{}, ...], refresh )\n         *\n         *  - for updating multiple values at once (not responsive)\n         *     .slick(\"setOption\", { 'option': value, ... }, refresh )\n         */\n\n        var _ = this, l, item, option, value, refresh = false, type;\n\n        if( $.type( arguments[0] ) === 'object' ) {\n\n            option =  arguments[0];\n            refresh = arguments[1];\n            type = 'multiple';\n\n        } else if ( $.type( arguments[0] ) === 'string' ) {\n\n            option =  arguments[0];\n            value = arguments[1];\n            refresh = arguments[2];\n\n            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {\n\n                type = 'responsive';\n\n            } else if ( typeof arguments[1] !== 'undefined' ) {\n\n                type = 'single';\n\n            }\n\n        }\n\n        if ( type === 'single' ) {\n\n            _.options[option] = value;\n\n\n        } else if ( type === 'multiple' ) {\n\n            $.each( option , function( opt, val ) {\n\n                _.options[opt] = val;\n\n            });\n\n\n        } else if ( type === 'responsive' ) {\n\n            for ( item in value ) {\n\n                if( $.type( _.options.responsive ) !== 'array' ) {\n\n                    _.options.responsive = [ value[item] ];\n\n                } else {\n\n                    l = _.options.responsive.length-1;\n\n                    // loop through the responsive object and splice out duplicates.\n                    while( l >= 0 ) {\n\n                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {\n\n                            _.options.responsive.splice(l,1);\n\n                        }\n\n                        l--;\n\n                    }\n\n                    _.options.responsive.push( value[item] );\n\n                }\n\n            }\n\n        }\n\n        if ( refresh ) {\n\n            _.unload();\n            _.reinit();\n\n        }\n\n    };\n\n    Slick.prototype.setPosition = function() {\n\n        var _ = this;\n\n        _.setDimensions();\n\n        _.setHeight();\n\n        if (_.options.fade === false) {\n            _.setCSS(_.getLeft(_.currentSlide));\n        } else {\n            _.setFade();\n        }\n\n        _.$slider.trigger('setPosition', [_]);\n\n    };\n\n    Slick.prototype.setProps = function() {\n\n        var _ = this,\n            bodyStyle = document.body.style;\n\n        _.positionProp = _.options.vertical === true ? 'top' : 'left';\n\n        if (_.positionProp === 'top') {\n            _.$slider.addClass('slick-vertical');\n        } else {\n            _.$slider.removeClass('slick-vertical');\n        }\n\n        if (bodyStyle.WebkitTransition !== undefined ||\n            bodyStyle.MozTransition !== undefined ||\n            bodyStyle.msTransition !== undefined) {\n            if (_.options.useCSS === true) {\n                _.cssTransitions = true;\n            }\n        }\n\n        if ( _.options.fade ) {\n            if ( typeof _.options.zIndex === 'number' ) {\n                if( _.options.zIndex < 3 ) {\n                    _.options.zIndex = 3;\n                }\n            } else {\n                _.options.zIndex = _.defaults.zIndex;\n            }\n        }\n\n        if (bodyStyle.OTransform !== undefined) {\n            _.animType = 'OTransform';\n            _.transformType = '-o-transform';\n            _.transitionType = 'OTransition';\n            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;\n        }\n        if (bodyStyle.MozTransform !== undefined) {\n            _.animType = 'MozTransform';\n            _.transformType = '-moz-transform';\n            _.transitionType = 'MozTransition';\n            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;\n        }\n        if (bodyStyle.webkitTransform !== undefined) {\n            _.animType = 'webkitTransform';\n            _.transformType = '-webkit-transform';\n            _.transitionType = 'webkitTransition';\n            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;\n        }\n        if (bodyStyle.msTransform !== undefined) {\n            _.animType = 'msTransform';\n            _.transformType = '-ms-transform';\n            _.transitionType = 'msTransition';\n            if (bodyStyle.msTransform === undefined) _.animType = false;\n        }\n        if (bodyStyle.transform !== undefined && _.animType !== false) {\n            _.animType = 'transform';\n            _.transformType = 'transform';\n            _.transitionType = 'transition';\n        }\n        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);\n    };\n\n\n    Slick.prototype.setSlideClasses = function(index) {\n\n        var _ = this,\n            centerOffset, allSlides, indexOffset, remainder;\n\n        allSlides = _.$slider\n            .find('.slick-slide')\n            .removeClass('slick-active slick-center slick-current')\n            .attr('aria-hidden', 'true');\n\n        _.$slides\n            .eq(index)\n            .addClass('slick-current');\n\n        if (_.options.centerMode === true) {\n\n            centerOffset = Math.floor(_.options.slidesToShow / 2);\n\n            if (_.options.infinite === true) {\n\n                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {\n\n                    _.$slides\n                        .slice(index - centerOffset, index + centerOffset + 1)\n                        .addClass('slick-active')\n                        .attr('aria-hidden', 'false');\n\n                } else {\n\n                    indexOffset = _.options.slidesToShow + index;\n                    allSlides\n                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)\n                        .addClass('slick-active')\n                        .attr('aria-hidden', 'false');\n\n                }\n\n                if (index === 0) {\n\n                    allSlides\n                        .eq(allSlides.length - 1 - _.options.slidesToShow)\n                        .addClass('slick-center');\n\n                } else if (index === _.slideCount - 1) {\n\n                    allSlides\n                        .eq(_.options.slidesToShow)\n                        .addClass('slick-center');\n\n                }\n\n            }\n\n            _.$slides\n                .eq(index)\n                .addClass('slick-center');\n\n        } else {\n\n            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {\n\n                _.$slides\n                    .slice(index, index + _.options.slidesToShow)\n                    .addClass('slick-active')\n                    .attr('aria-hidden', 'false');\n\n            } else if (allSlides.length <= _.options.slidesToShow) {\n\n                allSlides\n                    .addClass('slick-active')\n                    .attr('aria-hidden', 'false');\n\n            } else {\n\n                remainder = _.slideCount % _.options.slidesToShow;\n                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;\n\n                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {\n\n                    allSlides\n                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)\n                        .addClass('slick-active')\n                        .attr('aria-hidden', 'false');\n\n                } else {\n\n                    allSlides\n                        .slice(indexOffset, indexOffset + _.options.slidesToShow)\n                        .addClass('slick-active')\n                        .attr('aria-hidden', 'false');\n\n                }\n\n            }\n\n        }\n\n        if (_.options.lazyLoad === 'ondemand') {\n            _.lazyLoad();\n        }\n\n    };\n\n    Slick.prototype.setupInfinite = function() {\n\n        var _ = this,\n            i, slideIndex, infiniteCount;\n\n        if (_.options.fade === true) {\n            _.options.centerMode = false;\n        }\n\n        if (_.options.infinite === true && _.options.fade === false) {\n\n            slideIndex = null;\n\n            if (_.slideCount > _.options.slidesToShow) {\n\n                if (_.options.centerMode === true) {\n                    infiniteCount = _.options.slidesToShow + 1;\n                } else {\n                    infiniteCount = _.options.slidesToShow;\n                }\n\n                for (i = _.slideCount; i > (_.slideCount -\n                        infiniteCount); i -= 1) {\n                    slideIndex = i - 1;\n                    $(_.$slides[slideIndex]).clone(true).attr('id', '')\n                        .attr('data-slick-index', slideIndex - _.slideCount)\n                        .prependTo(_.$slideTrack).addClass('slick-cloned');\n                }\n                for (i = 0; i < infiniteCount; i += 1) {\n                    slideIndex = i;\n                    $(_.$slides[slideIndex]).clone(true).attr('id', '')\n                        .attr('data-slick-index', slideIndex + _.slideCount)\n                        .appendTo(_.$slideTrack).addClass('slick-cloned');\n                }\n                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {\n                    $(this).attr('id', '');\n                });\n\n            }\n\n        }\n\n    };\n\n    Slick.prototype.interrupt = function( toggle ) {\n\n        var _ = this;\n\n        if( !toggle ) {\n            _.autoPlay();\n        }\n        _.interrupted = toggle;\n\n    };\n\n    Slick.prototype.selectHandler = function(event) {\n\n        var _ = this;\n\n        var targetElement =\n            $(event.target).is('.slick-slide') ?\n                $(event.target) :\n                $(event.target).parents('.slick-slide');\n\n        var index = parseInt(targetElement.attr('data-slick-index'));\n\n        if (!index) index = 0;\n\n        if (_.slideCount <= _.options.slidesToShow) {\n\n            _.setSlideClasses(index);\n            _.asNavFor(index);\n            return;\n\n        }\n\n        _.slideHandler(index);\n\n    };\n\n    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {\n\n        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,\n            _ = this, navTarget;\n\n        sync = sync || false;\n\n        if (_.animating === true && _.options.waitForAnimate === true) {\n            return;\n        }\n\n        if (_.options.fade === true && _.currentSlide === index) {\n            return;\n        }\n\n        if (_.slideCount <= _.options.slidesToShow) {\n            return;\n        }\n\n        if (sync === false) {\n            _.asNavFor(index);\n        }\n\n        targetSlide = index;\n        targetLeft = _.getLeft(targetSlide);\n        slideLeft = _.getLeft(_.currentSlide);\n\n        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;\n\n        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {\n            if (_.options.fade === false) {\n                targetSlide = _.currentSlide;\n                if (dontAnimate !== true) {\n                    _.animateSlide(slideLeft, function() {\n                        _.postSlide(targetSlide);\n                    });\n                } else {\n                    _.postSlide(targetSlide);\n                }\n            }\n            return;\n        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {\n            if (_.options.fade === false) {\n                targetSlide = _.currentSlide;\n                if (dontAnimate !== true) {\n                    _.animateSlide(slideLeft, function() {\n                        _.postSlide(targetSlide);\n                    });\n                } else {\n                    _.postSlide(targetSlide);\n                }\n            }\n            return;\n        }\n\n        if ( _.options.autoplay ) {\n            clearInterval(_.autoPlayTimer);\n        }\n\n        if (targetSlide < 0) {\n            if (_.slideCount % _.options.slidesToScroll !== 0) {\n                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);\n            } else {\n                animSlide = _.slideCount + targetSlide;\n            }\n        } else if (targetSlide >= _.slideCount) {\n            if (_.slideCount % _.options.slidesToScroll !== 0) {\n                animSlide = 0;\n            } else {\n                animSlide = targetSlide - _.slideCount;\n            }\n        } else {\n            animSlide = targetSlide;\n        }\n\n        _.animating = true;\n\n        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);\n\n        oldSlide = _.currentSlide;\n        _.currentSlide = animSlide;\n\n        _.setSlideClasses(_.currentSlide);\n\n        if ( _.options.asNavFor ) {\n\n            navTarget = _.getNavTarget();\n            navTarget = navTarget.slick('getSlick');\n\n            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {\n                navTarget.setSlideClasses(_.currentSlide);\n            }\n\n        }\n\n        _.updateDots();\n        _.updateArrows();\n\n        if (_.options.fade === true) {\n            if (dontAnimate !== true) {\n\n                _.fadeSlideOut(oldSlide);\n\n                _.fadeSlide(animSlide, function() {\n                    _.postSlide(animSlide);\n                });\n\n            } else {\n                _.postSlide(animSlide);\n            }\n            _.animateHeight();\n            return;\n        }\n\n        if (dontAnimate !== true) {\n            _.animateSlide(targetLeft, function() {\n                _.postSlide(animSlide);\n            });\n        } else {\n            _.postSlide(animSlide);\n        }\n\n    };\n\n    Slick.prototype.startLoad = function() {\n\n        var _ = this;\n\n        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {\n\n            _.$prevArrow.hide();\n            _.$nextArrow.hide();\n\n        }\n\n        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {\n\n            _.$dots.hide();\n\n        }\n\n        _.$slider.addClass('slick-loading');\n\n    };\n\n    Slick.prototype.swipeDirection = function() {\n\n        var xDist, yDist, r, swipeAngle, _ = this;\n\n        xDist = _.touchObject.startX - _.touchObject.curX;\n        yDist = _.touchObject.startY - _.touchObject.curY;\n        r = Math.atan2(yDist, xDist);\n\n        swipeAngle = Math.round(r * 180 / Math.PI);\n        if (swipeAngle < 0) {\n            swipeAngle = 360 - Math.abs(swipeAngle);\n        }\n\n        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {\n            return (_.options.rtl === false ? 'left' : 'right');\n        }\n        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {\n            return (_.options.rtl === false ? 'left' : 'right');\n        }\n        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {\n            return (_.options.rtl === false ? 'right' : 'left');\n        }\n        if (_.options.verticalSwiping === true) {\n            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {\n                return 'down';\n            } else {\n                return 'up';\n            }\n        }\n\n        return 'vertical';\n\n    };\n\n    Slick.prototype.swipeEnd = function(event) {\n\n        var _ = this,\n            slideCount,\n            direction;\n\n        _.dragging = false;\n        _.interrupted = false;\n        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;\n\n        if ( _.touchObject.curX === undefined ) {\n            return false;\n        }\n\n        if ( _.touchObject.edgeHit === true ) {\n            _.$slider.trigger('edge', [_, _.swipeDirection() ]);\n        }\n\n        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {\n\n            direction = _.swipeDirection();\n\n            switch ( direction ) {\n\n                case 'left':\n                case 'down':\n\n                    slideCount =\n                        _.options.swipeToSlide ?\n                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :\n                            _.currentSlide + _.getSlideCount();\n\n                    _.currentDirection = 0;\n\n                    break;\n\n                case 'right':\n                case 'up':\n\n                    slideCount =\n                        _.options.swipeToSlide ?\n                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :\n                            _.currentSlide - _.getSlideCount();\n\n                    _.currentDirection = 1;\n\n                    break;\n\n                default:\n\n\n            }\n\n            if( direction != 'vertical' ) {\n\n                _.slideHandler( slideCount );\n                _.touchObject = {};\n                _.$slider.trigger('swipe', [_, direction ]);\n\n            }\n\n        } else {\n\n            if ( _.touchObject.startX !== _.touchObject.curX ) {\n\n                _.slideHandler( _.currentSlide );\n                _.touchObject = {};\n\n            }\n\n        }\n\n    };\n\n    Slick.prototype.swipeHandler = function(event) {\n\n        var _ = this;\n\n        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {\n            return;\n        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {\n            return;\n        }\n\n        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?\n            event.originalEvent.touches.length : 1;\n\n        _.touchObject.minSwipe = _.listWidth / _.options\n            .touchThreshold;\n\n        if (_.options.verticalSwiping === true) {\n            _.touchObject.minSwipe = _.listHeight / _.options\n                .touchThreshold;\n        }\n\n        switch (event.data.action) {\n\n            case 'start':\n                _.swipeStart(event);\n                break;\n\n            case 'move':\n                _.swipeMove(event);\n                break;\n\n            case 'end':\n                _.swipeEnd(event);\n                break;\n\n        }\n\n    };\n\n    Slick.prototype.swipeMove = function(event) {\n\n        var _ = this,\n            edgeWasHit = false,\n            curLeft, swipeDirection, swipeLength, positionOffset, touches;\n\n        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;\n\n        if (!_.dragging || touches && touches.length !== 1) {\n            return false;\n        }\n\n        curLeft = _.getLeft(_.currentSlide);\n\n        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;\n        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;\n\n        _.touchObject.swipeLength = Math.round(Math.sqrt(\n            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));\n\n        if (_.options.verticalSwiping === true) {\n            _.touchObject.swipeLength = Math.round(Math.sqrt(\n                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));\n        }\n\n        swipeDirection = _.swipeDirection();\n\n        if (swipeDirection === 'vertical') {\n            return;\n        }\n\n        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {\n            event.preventDefault();\n        }\n\n        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);\n        if (_.options.verticalSwiping === true) {\n            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;\n        }\n\n\n        swipeLength = _.touchObject.swipeLength;\n\n        _.touchObject.edgeHit = false;\n\n        if (_.options.infinite === false) {\n            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {\n                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;\n                _.touchObject.edgeHit = true;\n            }\n        }\n\n        if (_.options.vertical === false) {\n            _.swipeLeft = curLeft + swipeLength * positionOffset;\n        } else {\n            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;\n        }\n        if (_.options.verticalSwiping === true) {\n            _.swipeLeft = curLeft + swipeLength * positionOffset;\n        }\n\n        if (_.options.fade === true || _.options.touchMove === false) {\n            return false;\n        }\n\n        if (_.animating === true) {\n            _.swipeLeft = null;\n            return false;\n        }\n\n        _.setCSS(_.swipeLeft);\n\n    };\n\n    Slick.prototype.swipeStart = function(event) {\n\n        var _ = this,\n            touches;\n\n        _.interrupted = true;\n\n        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {\n            _.touchObject = {};\n            return false;\n        }\n\n        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {\n            touches = event.originalEvent.touches[0];\n        }\n\n        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;\n        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;\n\n        _.dragging = true;\n\n    };\n\n    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {\n\n        var _ = this;\n\n        if (_.$slidesCache !== null) {\n\n            _.unload();\n\n            _.$slideTrack.children(this.options.slide).detach();\n\n            _.$slidesCache.appendTo(_.$slideTrack);\n\n            _.reinit();\n\n        }\n\n    };\n\n    Slick.prototype.unload = function() {\n\n        var _ = this;\n\n        $('.slick-cloned', _.$slider).remove();\n\n        if (_.$dots) {\n            _.$dots.remove();\n        }\n\n        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {\n            _.$prevArrow.remove();\n        }\n\n        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {\n            _.$nextArrow.remove();\n        }\n\n        _.$slides\n            .removeClass('slick-slide slick-active slick-visible slick-current')\n            .attr('aria-hidden', 'true')\n            .css('width', '');\n\n    };\n\n    Slick.prototype.unslick = function(fromBreakpoint) {\n\n        var _ = this;\n        _.$slider.trigger('unslick', [_, fromBreakpoint]);\n        _.destroy();\n\n    };\n\n    Slick.prototype.updateArrows = function() {\n\n        var _ = this,\n            centerOffset;\n\n        centerOffset = Math.floor(_.options.slidesToShow / 2);\n\n        if ( _.options.arrows === true &&\n            _.slideCount > _.options.slidesToShow &&\n            !_.options.infinite ) {\n\n            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');\n            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');\n\n            if (_.currentSlide === 0) {\n\n                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');\n                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');\n\n            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {\n\n                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');\n                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');\n\n            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {\n\n                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');\n                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');\n\n            }\n\n        }\n\n    };\n\n    Slick.prototype.updateDots = function() {\n\n        var _ = this;\n\n        if (_.$dots !== null) {\n\n            _.$dots\n                .find('li')\n                .removeClass('slick-active')\n                .attr('aria-hidden', 'true');\n\n            _.$dots\n                .find('li')\n                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))\n                .addClass('slick-active')\n                .attr('aria-hidden', 'false');\n\n        }\n\n    };\n\n    Slick.prototype.visibility = function() {\n\n        var _ = this;\n\n        if ( _.options.autoplay ) {\n\n            if ( document[_.hidden] ) {\n\n                _.interrupted = true;\n\n            } else {\n\n                _.interrupted = false;\n\n            }\n\n        }\n\n    };\n\n    $.fn.slick = function() {\n        var _ = this,\n            opt = arguments[0],\n            args = Array.prototype.slice.call(arguments, 1),\n            l = _.length,\n            i,\n            ret;\n        for (i = 0; i < l; i++) {\n            if (typeof opt == 'object' || typeof opt == 'undefined')\n                _[i].slick = new Slick(_[i], opt);\n            else\n                ret = _[i].slick[opt].apply(_[i].slick, args);\n            if (typeof ret != 'undefined') return ret;\n        }\n        return _;\n    };\n\n}));\n"

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(510);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./slick.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./slick.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list,.slick-slider{position:relative;display:block}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:none}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{transform:translateZ(0)}.slick-track{position:relative;top:0;left:0;display:block}.slick-track:after,.slick-track:before{display:table;content:\"\"}.slick-track:after{clear:both}.slick-loading .slick-track{visibility:hidden}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-loading .slick-slide{visibility:hidden}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}", ""]);

// exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(512))

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = "/*!    SWFObject v2.3.20130521 <http://github.com/swfobject/swfobject>\n    is released under the MIT License <http://www.opensource.org/licenses/mit-license.php>\n*/\nvar swfobject=function(){var D=\"undefined\",r=\"object\",T=\"Shockwave Flash\",Z=\"ShockwaveFlash.ShockwaveFlash\",q=\"application/x-shockwave-flash\",S=\"SWFObjectExprInst\",x=\"onreadystatechange\",Q=window,h=document,t=navigator,V=false,X=[],o=[],P=[],K=[],I,p,E,B,L=false,a=false,m,G,j=true,l=false,O=function(){var ad=typeof h.getElementById!=D&&typeof h.getElementsByTagName!=D&&typeof h.createElement!=D,ak=t.userAgent.toLowerCase(),ab=t.platform.toLowerCase(),ah=ab?/win/.test(ab):/win/.test(ak),af=ab?/mac/.test(ab):/mac/.test(ak),ai=/webkit/.test(ak)?parseFloat(ak.replace(/^.*webkit\\/(\\d+(\\.\\d+)?).*$/,\"$1\")):false,aa=t.appName===\"Microsoft Internet Explorer\",aj=[0,0,0],ae=null;if(typeof t.plugins!=D&&typeof t.plugins[T]==r){ae=t.plugins[T].description;if(ae&&(typeof t.mimeTypes!=D&&t.mimeTypes[q]&&t.mimeTypes[q].enabledPlugin)){V=true;aa=false;ae=ae.replace(/^.*\\s+(\\S+\\s+\\S+$)/,\"$1\");aj[0]=n(ae.replace(/^(.*)\\..*$/,\"$1\"));aj[1]=n(ae.replace(/^.*\\.(.*)\\s.*$/,\"$1\"));aj[2]=/[a-zA-Z]/.test(ae)?n(ae.replace(/^.*[a-zA-Z]+(.*)$/,\"$1\")):0}}else{if(typeof Q.ActiveXObject!=D){try{var ag=new ActiveXObject(Z);if(ag){ae=ag.GetVariable(\"$version\");if(ae){aa=true;ae=ae.split(\" \")[1].split(\",\");aj=[n(ae[0]),n(ae[1]),n(ae[2])]}}}catch(ac){}}}return{w3:ad,pv:aj,wk:ai,ie:aa,win:ah,mac:af}}(),i=function(){if(!O.w3){return}if((typeof h.readyState!=D&&(h.readyState===\"complete\"||h.readyState===\"interactive\"))||(typeof h.readyState==D&&(h.getElementsByTagName(\"body\")[0]||h.body))){f()}if(!L){if(typeof h.addEventListener!=D){h.addEventListener(\"DOMContentLoaded\",f,false)}if(O.ie){h.attachEvent(x,function aa(){if(h.readyState==\"complete\"){h.detachEvent(x,aa);f()}});if(Q==top){(function ac(){if(L){return}try{h.documentElement.doScroll(\"left\")}catch(ad){setTimeout(ac,0);return}f()}())}}if(O.wk){(function ab(){if(L){return}if(!/loaded|complete/.test(h.readyState)){setTimeout(ab,0);return}f()}())}}}();function f(){if(L||!document.getElementsByTagName(\"body\")[0]){return}try{var ac,ad=C(\"span\");ad.style.display=\"none\";ac=h.getElementsByTagName(\"body\")[0].appendChild(ad);ac.parentNode.removeChild(ac);ac=null;ad=null}catch(ae){return}L=true;var aa=X.length;for(var ab=0;ab<aa;ab++){X[ab]()}}function M(aa){if(L){aa()}else{X[X.length]=aa}}function s(ab){if(typeof Q.addEventListener!=D){Q.addEventListener(\"load\",ab,false)}else{if(typeof h.addEventListener!=D){h.addEventListener(\"load\",ab,false)}else{if(typeof Q.attachEvent!=D){g(Q,\"onload\",ab)}else{if(typeof Q.onload==\"function\"){var aa=Q.onload;Q.onload=function(){aa();ab()}}else{Q.onload=ab}}}}}function Y(){var aa=h.getElementsByTagName(\"body\")[0];var ae=C(r);ae.setAttribute(\"style\",\"visibility: hidden;\");ae.setAttribute(\"type\",q);var ad=aa.appendChild(ae);if(ad){var ac=0;(function ab(){if(typeof ad.GetVariable!=D){try{var ag=ad.GetVariable(\"$version\");if(ag){ag=ag.split(\" \")[1].split(\",\");O.pv=[n(ag[0]),n(ag[1]),n(ag[2])]}}catch(af){O.pv=[8,0,0]}}else{if(ac<10){ac++;setTimeout(ab,10);return}}aa.removeChild(ae);ad=null;H()}())}else{H()}}function H(){var aj=o.length;if(aj>0){for(var ai=0;ai<aj;ai++){var ab=o[ai].id;var ae=o[ai].callbackFn;var ad={success:false,id:ab};if(O.pv[0]>0){var ah=c(ab);if(ah){if(F(o[ai].swfVersion)&&!(O.wk&&O.wk<312)){w(ab,true);if(ae){ad.success=true;ad.ref=z(ab);ad.id=ab;ae(ad)}}else{if(o[ai].expressInstall&&A()){var al={};al.data=o[ai].expressInstall;al.width=ah.getAttribute(\"width\")||\"0\";al.height=ah.getAttribute(\"height\")||\"0\";if(ah.getAttribute(\"class\")){al.styleclass=ah.getAttribute(\"class\")}if(ah.getAttribute(\"align\")){al.align=ah.getAttribute(\"align\")}var ak={};var aa=ah.getElementsByTagName(\"param\");var af=aa.length;for(var ag=0;ag<af;ag++){if(aa[ag].getAttribute(\"name\").toLowerCase()!=\"movie\"){ak[aa[ag].getAttribute(\"name\")]=aa[ag].getAttribute(\"value\")}}R(al,ak,ab,ae)}else{b(ah);if(ae){ae(ad)}}}}}else{w(ab,true);if(ae){var ac=z(ab);if(ac&&typeof ac.SetVariable!=D){ad.success=true;ad.ref=ac;ad.id=ac.id}ae(ad)}}}}}X[0]=function(){if(V){Y()}else{H()}};function z(ac){var aa=null,ab=c(ac);if(ab&&ab.nodeName.toUpperCase()===\"OBJECT\"){if(typeof ab.SetVariable!==D){aa=ab}else{aa=ab.getElementsByTagName(r)[0]||ab}}return aa}function A(){return !a&&F(\"6.0.65\")&&(O.win||O.mac)&&!(O.wk&&O.wk<312)}function R(ad,ae,aa,ac){var ah=c(aa);aa=W(aa);a=true;E=ac||null;B={success:false,id:aa};if(ah){if(ah.nodeName.toUpperCase()==\"OBJECT\"){I=J(ah);p=null}else{I=ah;p=aa}ad.id=S;if(typeof ad.width==D||(!/%$/.test(ad.width)&&n(ad.width)<310)){ad.width=\"310\"}if(typeof ad.height==D||(!/%$/.test(ad.height)&&n(ad.height)<137)){ad.height=\"137\"}var ag=O.ie?\"ActiveX\":\"PlugIn\",af=\"MMredirectURL=\"+encodeURIComponent(Q.location.toString().replace(/&/g,\"%26\"))+\"&MMplayerType=\"+ag+\"&MMdoctitle=\"+encodeURIComponent(h.title.slice(0,47)+\" - Flash Player Installation\");if(typeof ae.flashvars!=D){ae.flashvars+=\"&\"+af}else{ae.flashvars=af}if(O.ie&&ah.readyState!=4){var ab=C(\"div\");\naa+=\"SWFObjectNew\";ab.setAttribute(\"id\",aa);ah.parentNode.insertBefore(ab,ah);ah.style.display=\"none\";y(ah)}u(ad,ae,aa)}}function b(ab){if(O.ie&&ab.readyState!=4){ab.style.display=\"none\";var aa=C(\"div\");ab.parentNode.insertBefore(aa,ab);aa.parentNode.replaceChild(J(ab),aa);y(ab)}else{ab.parentNode.replaceChild(J(ab),ab)}}function J(af){var ae=C(\"div\");if(O.win&&O.ie){ae.innerHTML=af.innerHTML}else{var ab=af.getElementsByTagName(r)[0];if(ab){var ag=ab.childNodes;if(ag){var aa=ag.length;for(var ad=0;ad<aa;ad++){if(!(ag[ad].nodeType==1&&ag[ad].nodeName==\"PARAM\")&&!(ag[ad].nodeType==8)){ae.appendChild(ag[ad].cloneNode(true))}}}}}return ae}function k(aa,ab){var ac=C(\"div\");ac.innerHTML=\"<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000'><param name='movie' value='\"+aa+\"'>\"+ab+\"</object>\";return ac.firstChild}function u(ai,ag,ab){var aa,ad=c(ab);ab=W(ab);if(O.wk&&O.wk<312){return aa}if(ad){var ac=(O.ie)?C(\"div\"):C(r),af,ah,ae;if(typeof ai.id==D){ai.id=ab}for(ae in ag){if(ag.hasOwnProperty(ae)&&ae.toLowerCase()!==\"movie\"){e(ac,ae,ag[ae])}}if(O.ie){ac=k(ai.data,ac.innerHTML)}for(af in ai){if(ai.hasOwnProperty(af)){ah=af.toLowerCase();if(ah===\"styleclass\"){ac.setAttribute(\"class\",ai[af])}else{if(ah!==\"classid\"&&ah!==\"data\"){ac.setAttribute(af,ai[af])}}}}if(O.ie){P[P.length]=ai.id}else{ac.setAttribute(\"type\",q);ac.setAttribute(\"data\",ai.data)}ad.parentNode.replaceChild(ac,ad);aa=ac}return aa}function e(ac,aa,ab){var ad=C(\"param\");ad.setAttribute(\"name\",aa);ad.setAttribute(\"value\",ab);ac.appendChild(ad)}function y(ac){var ab=c(ac);if(ab&&ab.nodeName.toUpperCase()==\"OBJECT\"){if(O.ie){ab.style.display=\"none\";(function aa(){if(ab.readyState==4){for(var ad in ab){if(typeof ab[ad]==\"function\"){ab[ad]=null}}ab.parentNode.removeChild(ab)}else{setTimeout(aa,10)}}())}else{ab.parentNode.removeChild(ab)}}}function U(aa){return(aa&&aa.nodeType&&aa.nodeType===1)}function W(aa){return(U(aa))?aa.id:aa}function c(ac){if(U(ac)){return ac}var aa=null;try{aa=h.getElementById(ac)}catch(ab){}return aa}function C(aa){return h.createElement(aa)}function n(aa){return parseInt(aa,10)}function g(ac,aa,ab){ac.attachEvent(aa,ab);K[K.length]=[ac,aa,ab]}function F(ac){ac+=\"\";var ab=O.pv,aa=ac.split(\".\");aa[0]=n(aa[0]);aa[1]=n(aa[1])||0;aa[2]=n(aa[2])||0;return(ab[0]>aa[0]||(ab[0]==aa[0]&&ab[1]>aa[1])||(ab[0]==aa[0]&&ab[1]==aa[1]&&ab[2]>=aa[2]))?true:false}function v(af,ab,ag,ae){var ad=h.getElementsByTagName(\"head\")[0];if(!ad){return}var aa=(typeof ag==\"string\")?ag:\"screen\";if(ae){m=null;G=null}if(!m||G!=aa){var ac=C(\"style\");ac.setAttribute(\"type\",\"text/css\");ac.setAttribute(\"media\",aa);m=ad.appendChild(ac);if(O.ie&&typeof h.styleSheets!=D&&h.styleSheets.length>0){m=h.styleSheets[h.styleSheets.length-1]}G=aa}if(m){if(typeof m.addRule!=D){m.addRule(af,ab)}else{if(typeof h.createTextNode!=D){m.appendChild(h.createTextNode(af+\" {\"+ab+\"}\"))}}}}function w(ad,aa){if(!j){return}var ab=aa?\"visible\":\"hidden\",ac=c(ad);if(L&&ac){ac.style.visibility=ab}else{if(typeof ad===\"string\"){v(\"#\"+ad,\"visibility:\"+ab)}}}function N(ab){var ac=/[\\\\\\\"<>\\.;]/;var aa=ac.exec(ab)!=null;return aa&&typeof encodeURIComponent!=D?encodeURIComponent(ab):ab}var d=function(){if(O.ie){window.attachEvent(\"onunload\",function(){var af=K.length;for(var ae=0;ae<af;ae++){K[ae][0].detachEvent(K[ae][1],K[ae][2])}var ac=P.length;for(var ad=0;ad<ac;ad++){y(P[ad])}for(var ab in O){O[ab]=null}O=null;for(var aa in swfobject){swfobject[aa]=null}swfobject=null})}}();return{registerObject:function(ae,aa,ad,ac){if(O.w3&&ae&&aa){var ab={};ab.id=ae;ab.swfVersion=aa;ab.expressInstall=ad;ab.callbackFn=ac;o[o.length]=ab;w(ae,false)}else{if(ac){ac({success:false,id:ae})}}},getObjectById:function(aa){if(O.w3){return z(aa)}},embedSWF:function(af,al,ai,ak,ab,ae,ad,ah,aj,ag){var ac=W(al),aa={success:false,id:ac};if(O.w3&&!(O.wk&&O.wk<312)&&af&&al&&ai&&ak&&ab){w(ac,false);M(function(){ai+=\"\";ak+=\"\";var an={};if(aj&&typeof aj===r){for(var aq in aj){an[aq]=aj[aq]}}an.data=af;an.width=ai;an.height=ak;var ar={};if(ah&&typeof ah===r){for(var ao in ah){ar[ao]=ah[ao]}}if(ad&&typeof ad===r){for(var am in ad){if(ad.hasOwnProperty(am)){var ap=(l)?encodeURIComponent(am):am,at=(l)?encodeURIComponent(ad[am]):ad[am];if(typeof ar.flashvars!=D){ar.flashvars+=\"&\"+ap+\"=\"+at}else{ar.flashvars=ap+\"=\"+at}}}}if(F(ab)){var au=u(an,ar,al);if(an.id==ac){w(ac,true)}aa.success=true;aa.ref=au;aa.id=au.id}else{if(ae&&A()){an.data=ae;R(an,ar,al,ag);return}else{w(ac,true)}}if(ag){ag(aa)}})}else{if(ag){ag(aa)}}},switchOffAutoHideShow:function(){j=false},enableUriEncoding:function(aa){l=(typeof aa===D)?true:aa},ua:O,getFlashPlayerVersion:function(){return{major:O.pv[0],minor:O.pv[1],release:O.pv[2]}},hasFlashPlayerVersion:F,createSWF:function(ac,ab,aa){if(O.w3){return u(ac,ab,aa)}else{return undefined}},showExpressInstall:function(ac,ad,aa,ab){if(O.w3&&A()){R(ac,ad,aa,ab)}},removeSWF:function(aa){if(O.w3){y(aa)}},createCSS:function(ad,ac,ab,aa){if(O.w3){v(ad,ac,ab,aa)}},addDomLoadEvent:M,addLoadEvent:s,getQueryParamValue:function(ad){var ac=h.location.search||h.location.hash;\nif(ac){if(/\\?/.test(ac)){ac=ac.split(\"?\")[1]}if(ad==null){return N(ac)}var ab=ac.split(\"&\");for(var aa=0;aa<ab.length;aa++){if(ab[aa].substring(0,ab[aa].indexOf(\"=\"))==ad){return N(ab[aa].substring((ab[aa].indexOf(\"=\")+1)))}}}return\"\"},expressInstallCallback:function(){if(a){var aa=c(S);if(aa&&I){aa.parentNode.replaceChild(I,aa);if(p){w(p,true);if(O.ie){I.style.display=\"block\"}}if(E){E(B)}}a=false}},version:\"2.3\"}}();\n"

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(514);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./acplayercolors.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./acplayercolors.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".ac-p,.ac-p-video{background-color:#000}.ac-p-controls{color:#fff;background-color:rgba(32,31,34,.9)}.ac-p:not(.ac-p-is-touch) .ac-p-action:hover{color:hsla(0,0%,100%,.5)}.ac-p-progressbar,.ac-p-progressbar.ac-p-action{background-color:rgba(32,31,34,.3)}.ac-p-buffered{background-color:hsla(0,0%,100%,.3)}.ac-p-progress{background-color:hsla(0,0%,100%,.8)}.ac-p:not(.ac-p-is-touch) .ac-p-progressbar:hover .ac-p-progress{background-color:hsla(0,0%,100%,.5)}.ac-p-volume{background-color:hsla(0,0%,100%,.15)}.ac-p-level{background-color:#fff}.ac-p-timeline{background-color:#111;color:#fff}.ac-p-formats-box{background-color:rgba(32,31,34,.9);color:#fff}.ac-p-formats-box:after{border-color:rgba(32,31,34,.9) transparent transparent}.ac-p-formats-current-item,.ac-p:not(.ac-p-is-touch) .ac-p-formats-item:hover{background-color:#000}.ac-p-toggle-box{box-shadow:inset 0 0 100px #000;background-color:rgba(0,0,0,.7)}.ac-p-limit-banner{background-color:#32353d;color:#fff}.ac-p-limit-text{color:#fff}.ac-p-error{background-color:#32353d;color:#fff}.ac-p-error .ac-p-color{color:#ff007e}.ac-p-error .ac-p-refresh{color:#7c818f}.ac-p-error .ac-p-link,.ac-p-error .ac-p-link:active,.ac-p-error .ac-p-link:hover{cursor:pointer;color:#69ccff}.ac-p-is-fullscreen{background-color:#000}.ac-p-spinner:after{border-top:5px solid hsla(0,0%,100%,.2);border-right:5px solid hsla(0,0%,100%,.2);border-bottom:5px solid hsla(0,0%,100%,.2);border-left:5px solid #fff}.ac-p-play-btn .ac-p-play{background-color:rgba(0,0,0,.8);color:#fff}", ""]);

// exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	__webpack_require__(516)(fox);

	fox.registerWidget('Content_Html5Player', {
		configure: function configure(options) {
			this.available4K = !(/iPhone|iPad/.test(navigator.platform) || /Windows NT 6.1/.test(navigator.userAgent) && /rv:11.0/.test(navigator.userAgent));
			this.MOBILE_DEVICES_START_FORMAT = 'ipod';
			this.DESKTOP_START_FORMAT = 'hd1080'; /* !!! do not set this.DESKTOP_START_FORMAT > hd1080 */

			this.registerOptions('', {
				getMapMethod: 'site.format.getMap',
				jsonizeMapRequest: true,
				resourceIdParamName: 'contentId',
				'handleWom.recieveContentId': {
					widget: '@this',
					event: 'setContentId',
					callback: 'recieveContentId'
				}
			});

			this.mode = 'format';
			this.callParent('configure', arguments);
		},

		recieveContentId: function recieveContentId(id) {
			this.setPoster('');
			this.formatGetMap(id);
		},

		getMapApi: function getMapApi() {
			var api = this.wom1('#mapApi');

			if (!api) {
				api = this.embedWidget('mapApi', 'Api', {
					method: this.getOption('getMapMethod')
				});

				api.run();
			}

			return api;
		},

		formatGetMap: function formatGetMap(id, resCallback, callbackParams) {
			var api = this.getMapApi(),
			    resIdParamName = this.getOption('resourceIdParamName'),
			    apiParams = { mode: this.mode == 'preview' ? 'preview' : 'format' };

			this.setContentId(id);
			this.waitEvent(api, 'success', resCallback || 'formatGetMapApiSuccessHandler', callbackParams || {});

			apiParams[resIdParamName] = this.getContentId();
			api.send(apiParams, this.getOption('jsonizeMapRequest'));
		},

		formatGetMapApiSuccessHandler: function formatGetMapApiSuccessHandler(data) {
			this.preparePlayerData(data.answer.response);
		},

		preparePlayerData: function preparePlayerData(map) {
			this.setFormatMap(map).changeFormat(this.getStartFormat());
			if (fox.utils.isTouchDevice() && !this.getPoster()) {
				this.setPoster(this.getPrimaryThumb());
			}
		},

		getStartFormat: function getStartFormat() {
			if (fox.getEnv('siteProps.settingId')) {
				fox.each(this.getFormatMap().download, function (val) {
					val.link = val.link + (val.link.indexOf('?') == -1 ? '?' : '%26') + 'settingId=' + fox.getEnv('siteProps.settingId');
				}, this);
			}

			var format,
			    height = 0;

			if (fox.utils.isTouchDevice() && this.getFormatMap().view[this.MOBILE_DEVICES_START_FORMAT]) {
				return this.setVideoFormat(this.MOBILE_DEVICES_START_FORMAT);
			} else if (this.getFormatMap().view[this.DESKTOP_START_FORMAT]) {
				return this.setVideoFormat(this.DESKTOP_START_FORMAT);
			}

			fox.each(this.getFormatMap().view, function (val, name) {
				var fh = Number(val.height);
				if (!format || height < fh) {
					height = fh;
					format = name;
				}
			}, this);

			return this.setVideoFormat(format);
		},

		buildBitrates: function buildBitrates() {
			var bitrates = [];

			fox.each(this.getFormatMap().view, function (val, name) {

				if (!this.available4K && name === 'hd2160') {
					return;
				}
				if (val.roles && !fox.inArray(val.roles, this.mode)) {
					return; // means 'continue'
				}
				var domain = fox.site.getOption('siteDomain') || window.location.protocol + '//' + window.location.host;
				var clip = domain + val.link,
				    params = ['video=1', 'rand=' + Date.parse(new Date())];

				if (this.getOption('useHash') && clip.indexOf('publisher_auth=') === -1) {
					params.push('publisher_auth=' + fox.getEnv('siteProps.publisher_auth'));
				}

				if (fox.utils.safari()) params.push('auth_hash=' + (this.isAuthorized() ? fox.cookie.get('user_auth') || '' : 'empty'));

				if (fox.getEnv('siteProps.settingId')) params.push('settingId=' + fox.getEnv('siteProps.settingId'));

				clip += (clip.indexOf('?') === -1 ? '?' : '&') + params.join('&');

				var bitrate = {
					icon: parseInt(val.hd) ? name === 'hd2160' ? '4k_19' : 'hd' : 'sd',
					name: val.height + 'p.',
					height: val.height,
					sources: [{
						type: 'video/mp4',
						src: clip
					}],
					isDefault: name === this.getVideoFormat()
				};

				bitrates.push(bitrate);
			}, this);

			if (bitrates.length) {
				bitrates.sort(function (a, b) {
					var aH = parseInt(a.height);
					var bH = parseInt(b.height);
					if (aH > bH) {
						return -1;
					}

					if (aH < bH) {
						return 1;
					}

					return 0;
				});
			}
			this.setBitrates(bitrates);
			return this;
		},

		addParamToLink: function addParamToLink() {},

		//only mc-admin feature
		switchMode: function switchMode(mode) {
			this.mode = mode == 'preview' ? 'preview' : 'format';
			this.buildBitrates();
			var map = this.getFormatMap().view;
			var bitrates = this.getBitrates();

			switch (this.mode) {
				case 'preview':
					fox.each(map, function (format) {
						format.link = format.link + '/preview';
					});

					fox.each(bitrates, function (item) {
						item.onSelectArguments.clip.url = item.onSelectArguments.clip.url + '/preview';
					});
					break;

				default:
					fox.each(map, function (format) {
						format.link = format.link.replace('\/preview', '');
					});

					fox.each(bitrates, function (item) {
						item.onSelectArguments.clip.url = item.onSelectArguments.clip.url.replace('\/preview', '');
					});
					break;
			}

			return this;
		},

		getPrimaryThumb: function getPrimaryThumb(size) {
			var hSize = size,
			    formats = this.getFormatMap(),
			    alias;

			if (!hSize) {
				if (fox.utils.isTouchDevice()) {
					var format = formats.view[this.MOBILE_DEVICES_START_FORMAT];
					if (format) {
						hSize = format.height;
					} else {
						hSize = 480;
					}
				} else {
					var format = formats.view[this.DESKTOP_START_FORMAT];
					if (format) {
						hSize = format.height;
					} else {
						hSize = 1080;
					}
				}
			}
			if (hSize > 1080) {
				alias = 'h1360i';
			} else if (hSize > 720) {
				alias = 'h720i'; /* because h1080i doesn't exist */
			} else if (hSize > 480) {
				alias = 'h720i';
			} else {
				alias = 'h480i';
			}
			return (fox.getEnv('smallUrl') || 'http://cdn-small.nl.storage.adultcentro.com/') + this.getContentId() + '/thumb/primary/' + alias;
		},

		isAuthorized: function isAuthorized() {
			var pm = this.wom1('@root #permissionManager');

			if (pm) return pm.hasAccess('member') || pm.hasAccess('free');

			return !fox.isEmpty(this._wom.getRoot().member);
		}
	}, 'Html5Player');
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (fox) {
	if (console.warn) {
		console.warn('[html5player package]: html5player folder is no longer maintainable and will be removed in next minor version.');
		console.warn('[html5player package]: all widgets and other content moved to common-componnets/htmlplayer folder.');
	}

	var $ = fox.jQuery;

	__webpack_require__(517);

	__webpack_require__(519)(fox);
	__webpack_require__(520)(fox);
	__webpack_require__(521)(fox);

	__webpack_require__(522)(fox);

	__webpack_require__(523);
	__webpack_require__(528);

	var url = __webpack_require__(531);

	fox.registerWidget('Html5Player', {
		configure: function configure(options) {
			this.registerOptions('', {
				container: '#player',
				renderPlayer: true,
				videoUrl: false,
				dontReuseSn: true,
				widgets: {
					controls: {
						widget: 'Widget',
						template: 'Html5Player_Controls',
						autoRender: true,
						widgets: {
							play: {
								widget: 'Widget',
								template: 'Html5Player_Play',
								container: '#ac-p-play',
								autoRender: true
							},
							error: {
								widget: 'Widget',
								template: 'Html5Player_Error',
								container: '#ac-p-error',
								autoRender: true,
								templateOptions: { url: url }
							},
							spinner: {
								widget: 'Widget',
								template: 'Html5Player_Spinner',
								container: '#ac-p-spinner',
								autoRender: true
							},
							startBanner: {
								widget: 'Html5Player_StartBanner',
								template: 'Html5Player_StartBanner',
								container: '#ac-p-start-banner'
							},
							stopBanner: {
								widget: 'Html5Player_StopBanner',
								template: 'Html5Player_StopBanner',
								container: '#ac-p-stop-banner'
							},
							endBanner: {
								widget: 'Html5Player_EndBanner',
								template: 'Html5Player_EndBanner',
								container: '#ac-p-end-banner'
							}
						}
					}
				},
				html5PlayerConfig: {
					originalSize: {
						min: 30,
						max: 'auto'
					},
					movie: {
						container: '.ac-p-video-container',
						autoplay: false
					},
					plugins: {
						spinner: true,
						startbanner: true,
						stopbanner: true,
						endbanner: true,
						timeline: true,
						error: {
							timer: 10
						}
					},
					media: [500, 400]
				},
				handleWom: {
					runPlayer: {
						widget: '@this',
						event: '_changeFormat',
						callback: function callback() {
							if (!!this._player) {
								this.resetPlayer();
								this.runPlayer(null, this.rwom1('#controls'));
							}
						}
					}
				}
			});

			this.registerOptions('.Widget', {
				dontReuseSn: true
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			this._contentId = null;
			this._formatMap = {};
			this._videoFormat = null;
			this._bitrates = [];
			this._poster = null;
			this._endBanner = null;

			this.registerOptions('#controls', {
				container: this.getOption('renderTo') || this.getOption('container')
			});

			this.callParent('init', arguments);
		},

		running: function running() {
			this.runPlayer(null, this.rwom1('#controls'));

			this.callParent('running', arguments);
		},

		activate: function activate() {
			this.resetPlayer();

			this.runPlayer(null, this.rwom1('#controls'));

			this.callParent('activate', arguments);
		},

		deactivate: function deactivate() {
			this.resetPlayer();

			this.callParent('deactivate', arguments);
		},

		resetPlayer: function resetPlayer() {
			if (!!this._player) {
				this._player.destroy();
			}
			this._player = null;
		},

		playerCmd: function playerCmd(cmd) {
			if (!this._player) {
				return false;
			}
			var params = Array.prototype.slice.call(arguments, 1);
			return this._player[cmd].apply(this._player, params);
		},

		getPlayerContainer: function getPlayerContainer() {
			if (this.visual) {
				this.playerContainer = this.rdom1(this.requireOption('renderTo'));
			} else {
				this.playerContainer = fox.dom.selectFirst(this.requireOption('container'));
			}

			if (!this.playerContainer) {
				return false;
			}

			if (!this.playerContainer.getAttribute('id')) {
				this.playerContainer.setAttribute('id', fox.uniqid('Html5Player'));
			}
			return this.playerContainer;
		},

		preparePlayerConfig: function preparePlayerConfig() {
			this.getFormatMap();

			if (fox.site.member && !this.getOption('disableTimeline') && _typeof(this.getOption('html5PlayerConfig.plugins.timeline'))) {
				this.setOption('html5PlayerConfig.plugins.timeline', {
					theme: 'thumbs',
					sprite: (fox.getEnv('smallUrl') || 'https://ec-small.centrofiles.com/') + this.getContentId() + '/thumb/timeline/sprite/w135i',
					thumbWidth: 135
				});
			}

			var conf = this.getOption('html5PlayerConfig'),
			    src = this.getOption('videoUrl');

			if (src) {
				conf.movie.sources = [{
					type: 'video/mp4',
					src: src
				}];
			} else {
				conf.plugins.formats = this.getBitrates() || false;
			}

			conf.plugins.poster = this.getPoster() || false;

			this.setOption('html5PlayerConfig', conf);

			return this;
		},

		embedPlayer: function embedPlayer() {
			this.preparePlayerConfig();

			var $container = $(this.getPlayerContainer());
			if (!$container.length) {
				return;
			}

			if (!this._player) {
				this.createHtml5Player();
			} else {
				this._player.update('poster', this.getPoster());
				this._player.update('formats', this.getBitrates());
			}
		},

		createHtml5Player: function createHtml5Player() {
			var id = '#' + (this.getOption('domNodeContainerLink') === true ? this.getPlayerContainer() : this.getPlayerContainer().getAttribute('id'));
			var conf = this.getOption('html5PlayerConfig');

			var $el = this.rdom1(id);

			this._player = acplayer.create($el, conf);

			this.dispatchEvent('playerRunning');
		},

		runPlayer: function runPlayer(params, controls) {
			var aliases = ['play', 'error', 'spinner'];
			var isEmbedded = aliases.every(function (alias) {
				return controls.rwom1('#' + alias).isEmbedded();
			});

			if (this.getOption('renderPlayer')) {
				if (isEmbedded) return this.embedPlayer();

				return fox.Promise.all(['play', 'error', 'spinner'].map(function (alias) {
					return controls.rwom1('#' + alias).wait('addedToDom');
				})).then(function () {
					this.embedPlayer();
				}.bind(this));
			}
		},

		changeFormat: function changeFormat(format) {
			this.setVideoFormat(format);
			this.buildBitrates().dispatchEvent('_changeFormat');
			return this;
		},

		setVideoFormat: function setVideoFormat(value) {
			this._videoInfo = value;
			return value;
		},

		getVideoFormat: function getVideoFormat() {
			return this._videoInfo;
		},

		setFormatMap: function setFormatMap(value) {
			this._formatMap = value;
			return this;
		},

		getFormatMap: function getFormatMap() {
			return this._formatMap;
		},

		setBitrates: function setBitrates(value) {
			this._bitrates = value;
		},

		getBitrates: function getBitrates() {
			return this._bitrates;
		},

		setPoster: function setPoster(value) {
			this._poster = value;
		},

		getPoster: function getPoster() {
			return this._poster;
		},

		setEndBanner: function setEndBanner(value) {
			this._endBanner = value;
		},

		getEndBanner: function getEndBanner() {
			return this._endBanner;
		},

		setContentId: function setContentId(value) {
			this._contentId = value;
		},

		getContentId: function getContentId() {
			return this._contentId;
		}
	}, 'Widget');
};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(518))

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = "var acplayer=function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p=\"\",e(0)}([function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}var i=n(1),o=r(i),u=n(3),a=r(u),s=n(4),c=(r(s),{plugin:a.default,create:function(t,e){return new o.default(t,e)}});t.exports=c},function(t,e,n){(function(t){\"use strict\";function n(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(e,\"__esModule\",{value:!0});var r=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function(){function e(t,r){n(this,e),this._init(t,r)}return i(e,[{key:\"_init\",value:function(e,n){this.options=$.extend(!0,{},t.defaults,n),this.$window=$(window),this.$document=$(document),this.$container=$(e),this.$container.addClass(t.prefix),this.$components=this.$container.find(\"[data-component]\"),this.autoplayAllowed=!this.isTouchDevice(),this.isTouchDevice()?this.$container.addClass(t.prefix+\"-is-touch\"):(this.$container.timerHover=null,this.$container.on(\"mousemove\",$.proxy(function(e){e.stopPropagation(),clearTimeout(this.$container.timerHover),this.$container.addClass(t.prefix+\"-is-hover\"),this.$container.timerHover=setTimeout($.proxy(function(){this.$container.removeClass(t.prefix+\"-is-hover\"),clearTimeout(this.$container.timerHover)},this),3e3)},this))),this._initOptions(this.options),this.$container.get(0).acplayer=this}},{key:\"_initOptions\",value:function(t){for(var e in t)if(\"function\"==typeof t[e])this.$container.on(e,$.proxy(t[e],this));else if(\"function\"==typeof this[e])if(t[e])this[e](e,t[e]);else{var n=this.getView(e);n&&n.hide()}else t[e]instanceof Object&&this._initOptions(t[e])}},{key:\"movie\",value:function(e,n){n.container&&(this.$videoContainer=this.$container.find(n.container)),this.$videoContainer=this.$container.find(\".\"+t.prefix+\"-video-container\"),n.container||this.$videoContainer.length||(this.$videoContainer=$('<div class=\"'+t.prefix+'-video-container\" />').prependTo(this.$container)),this.$videoWrapper=this.$videoContainer.find(\".\"+t.prefix+\"-video-wrapper\"),this.$videoWrapper.length||(this.$videoWrapper=$('<div class=\"'+t.prefix+'-video-wrapper\" />').prependTo(this.$videoContainer)),this.$video=$('<video class=\"'+t.prefix+'-video\" />'),this.video=this.$video[0],this.video.controls=!1;var r=this.$videoWrapper.find(\"video\");r.length?r.replaceWith(this.$video):this.$video.prependTo(this.$videoWrapper);for(var i in n)\"sources\"===i?this.createSources.call(this,i,n[i]):\"container\"!==i&&(this[i]?this[i](i,n[i]):\"autoplay\"!==i||this.autoplayAllowed?this.video[i]=n[i]:this.video[i]=n[i]=!1,\"autoplay\"===i?n[i]||(this.$container.addClass(t.prefix+\"-is-paused\"),this.posterExist&&this.$container.addClass(t.prefix+\"-is-paused\")):n[i]&&this.$container.addClass(t.prefix+\"-is-\"+i));this.video.userPaused=!this.video.autoplay,this.$video.on(\"pause\",$.proxy(function(){this.$container.addClass(t.prefix+\"-is-paused\"),this.$container.trigger(\"onPause\"),this.video.userPaused=!0},this)).on(\"playing\",$.proxy(function(){this.$container.removeClass(t.prefix+\"-is-paused\"),this.$video.trigger(\"durationchange\"),this.$container.trigger(\"onStart\"),this.video.userPaused=!1},this)).on(\"ended\",$.proxy(function(){this.video.loop||(this.$container.addClass(t.prefix+\"-is-paused\"),this.pause()),this.$container.trigger(\"onEnded\")},this)).on(\"canplay\",$.proxy(function(t){!this.video.userPaused&&this.video.paused&&this.play()},this)).on(\"loadstart\",$.proxy(function(t){this.$video.trigger(\"timeupdate\")},this)).on(\"click\",$.proxy(function(t){t.stopPropagation(),this.toggleplay&&this.toggleplay(t)},this)).on(\"contextmenu\",function(t){return!1}),{}.LOG&&this.$video.on(\"abort canplay canplaythrough durationchange emptied ended error interruptbegin interruptendloadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seekingstalled suspend timeupdate volumechange waiting\",console.log)}},{key:\"createSources\",value:function(t,e,n,r){if(!e.length)return!1;for(var i=\"\",o=0;o<e.length;o++)if(this.video.canPlayType(e[o].type)){i=e[o].src;break}this.$video.attr(\"src\",i)}},{key:\"media\",value:function(t,e){return e instanceof Array&&(this.updateSize(),void this.$window.on(\"resize.acplayer orientationchange.acplayer\",$.proxy(function(){this.updateSize()},this)))}},{key:\"getView\",value:function(t){var e=this.$components.filter('[data-component=\"'+t+'\"]');return!!e.length&&(this[\"$\"+t]=e,e)}},{key:\"setLineWidth\",value:function(t,e,n){var r=t;r||(r=n.parent().width()),n.css(\"width\",(100*e/t).toFixed(2)+\"%\")}},{key:\"timeFormat\",value:function(t){var e,n,r,i=parseInt(t,10);return e=Math.floor(i/3600),n=Math.floor((i-60*e*60)/60),r=i-60*e*60-60*n,e=0===e?\"\":e<10?\"0\"+e+\":\":e+\":\",n=(0===n?\"00\":n<10?\"0\"+n:n)+\":\",r=0===r?\"00\":r<10?\"0\"+r:r,e+n+r}},{key:\"isTouchDevice\",value:function(){return\"ontouchstart\"in window||window.DocumentTouch&&document instanceof DocumentTouch}},{key:\"isMobileIos\",value:function(){return!!navigator.platform&&/iPhone|iPad/.test(navigator.platform)}},{key:\"isIPhone\",value:function(){return!!navigator.platform&&/iPhone/.test(navigator.platform)}},{key:\"isIEWin7\",value:function(){var t=navigator.userAgent;return/Windows NT 6.1/.test(t)&&/rv:11.0/.test(t)}},{key:\"load\",value:function(e,n){var r=this.video.autoplay;this.$container.removeClass(t.prefix+\"-is-error\"),r&&!e&&this.$container.removeClass(t.prefix+\"-is-paused\"),e===!0&&this.$container.addClass(t.prefix+\"-is-paused\"),this.$video.one(\"canplaythrough\",$.proxy(function(){void 0!==n&&n&&(this.$video.off(\"durationchange.load\"),this.getDuration()?this.setCurrentTime(n):this.$video.on(\"durationchange.load\",$.proxy(function(){this.getDuration()>0&&(this.setCurrentTime(n),this.$video.off(\"durationchange.load\"))},this))),void 0!==e&&e!==!0&&this.play()},this))}},{key:\"play\",value:function(e){this.$container.trigger(\"start_play\"),this.posterExist&&(this.$container.removeClass(t.prefix+\"-is-poster\"),this.posterExist=!1),this.isIPhone()||this.$container.removeClass(t.prefix+\"-is-paused\"),void 0!==this.timerTogglePlay&&(clearTimeout(this.timerTogglePlay),this.timerTogglePlay=void 0,this.$container.removeClass(t.prefix+\"-is-touched\")),this.$container.removeClass(t.prefix+\"-is-startbanner\").removeClass(t.prefix+\"-is-stopbanner\").removeClass(t.prefix+\"-is-endbanner\"),this.video.play()}},{key:\"pause\",value:function(){this.isIPhone()||this.$container.addClass(t.prefix+\"-is-paused\"),this.video.pause()}},{key:\"mute\",value:function(){this.$container.addClass(t.prefix+\"-is-muted\"),this.video.muted=!0}},{key:\"unmute\",value:function(){this.$container.removeClass(t.prefix+\"-is-muted\"),this.video.muted=!1}},{key:\"getDuration\",value:function(){return this.video.duration}},{key:\"setCurrentTime\",value:function(t){this.$video.off(\"canplaythrough.setCurrentTime\"),this.video.readyState?this.video.currentTime=t:this.$video.one(\"canplaythrough.setCurrentTime\",$.proxy(function(){this.video.currentTime=t},this))}},{key:\"getCurrentTime\",value:function(){return this.video.currentTime}},{key:\"setVolumeLevel\",value:function(t){this.video.volume=t}},{key:\"getVolumeLevel\",value:function(){return this.video.volume}},{key:\"fullscreen\",value:function(){document.documentElement.requestFullscreen?this.$container[0].requestFullscreen():document.documentElement.msRequestFullscreen?this.$container[0].msRequestFullscreen():document.documentElement.mozRequestFullScreen?this.$container[0].mozRequestFullScreen():document.documentElement.webkitRequestFullscreen&&this.$container[0].webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT),this.$document.on(\"keydown.fullscreen\",$.proxy(function(e){e.stopPropagation(),27===e.keyCode&&(this.$container.removeClass(t.prefix+\"-is-fullscreen\"),this.$container.parents().removeClass(t.prefix+\"-parent-fullscreen\"),this.$document.off(\"keydown.fullscreen\"))},this)),this.$container.addClass(t.prefix+\"-is-fullscreen\"),this.$container.parents().addClass(t.prefix+\"-parent-fullscreen\")}},{key:\"exitFullscreen\",value:function(){document.exitFullscreen?document.exitFullscreen():document.msExitFullscreen?document.msExitFullscreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.webkitExitFullscreen&&document.webkitExitFullscreen(),this.$container.removeClass(t.prefix+\"-is-fullscreen\"),this.$container.parents().removeClass(t.prefix+\"-parent-fullscreen\")}},{key:\"update\",value:function(t,e,n){var i={};i[t]=e;var o=function i(o){for(var u in o){if(u===t){n?$.extend(!0,o[u],t):o[u]=e;break}\"object\"===r(o[u])&&i(o[u])}};return o(this.options),this._initOptions.call(this,i),this}},{key:\"updateSize\",value:function(){var t=this.options.media;if(t instanceof Array){t=t.sort();for(var e=this.$container.innerWidth(),n=\"\",r=0;r<t.length;r++)e<=t[r]&&(n+=\" \"+t[r]);n.length?this.$container.attr(\"max-width\",n):this.$container.removeAttr(\"max-width\")}}},{key:\"destroy\",value:function(){this.$container.trigger(\"destroyed\"),this.pause(),this.video.src=\"\",this.$video.remove(),this.$container.off()}}]),e}();e.default=o}).call(e,n(2))},function(t,e){\"use strict\";t.exports={version:\"0.1\",prefix:\"ac-p\",defaults:{movie:{autoplay:!1,muted:!1,preload:\"metadata\",container:!1},plugins:{controls:{autoHide:!0,progressbar:!0,toggleplay:!0,togglemute:!0,volume:.5,togglefullscreen:!0,duration:!0,time:!0,timeline:!0,formats:!1},spinner:!0,limit:!1,error:{timer:!1,refresh:!0},startbanner:!1,stopbanner:!1,endbanner:!1,poster:!1,denypausebuffering:!1},media:!1}}},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,\"__esModule\",{value:!0});var i=n(1),o=r(i);e.default=function(t,e){o.default.prototype[t]=e}},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}var i=n(3),o=r(i),u=n(5),a=r(u),s=n(6),c=r(s),f=n(7),l=r(f),h=n(8),d=r(h),p=n(9),v=r(p),g=n(10),y=r(g),_=n(11),m=r(_),b=n(12),w=r(b),x=n(13),E=r(x),P=n(14),S=r(P),O=n(15),A=r(O),T=n(16),$=r(T),C=n(17),R=r(C),j=n(18),D=r(j),k=n(19),M=r(k),F=n(20),I=r(F),L=n(21),N=r(L),G=n(22),U=r(G),W=n(23),X=r(W),V=n(24),B=r(V),z=n(25),H=r(z);(0,o.default)(\"poster\",a.default),(0,o.default)(\"startbanner\",c.default),(0,o.default)(\"stopbanner\",l.default),(0,o.default)(\"endbanner\",d.default),(0,o.default)(\"error\",v.default),(0,o.default)(\"togglefullscreen\",y.default),(0,o.default)(\"progressbar\",m.default),(0,o.default)(\"spinner\",w.default),(0,o.default)(\"controls\",E.default),(0,o.default)(\"duration\",S.default),(0,o.default)(\"time\",A.default),(0,o.default)(\"togglemute\",$.default),(0,o.default)(\"toggleplay\",R.default),(0,o.default)(\"formats\",M.default),(0,o.default)(\"timeline\",I.default),(0,o.default)(\"limit\",D.default),(0,o.default)(\"volume\",N.default),(0,o.default)(\"originalSize\",U.default),(0,o.default)(\"snapshot\",X.default),(0,o.default)(\"denypausebuffering\",B.default),(0,o.default)(\"cuttingtool\",H.default)},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){if(n&&!this.video.autoplay){this.posterExist=!0;var r=this.$container.find(\".\"+t.prefix+\"-poster\");r.length||(r=$('<div class=\"'+t.prefix+'-poster\" />').prependTo(this.$videoContainer)),r.on(\"click\",$.proxy(function(t){t.stopPropagation(),this.play()},this)).css(\"background-image\",\"url(\"+n+\")\"),this.$container.addClass(t.prefix+\"-is-poster\"),this.$container.one(\"destroyed\",$.proxy(function(){this.posterExist=!1,r.off()},this))}}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){var r=this.getView(e);return!!r&&void(this.video.autoplay||(this.$video.one(\"loadstart\",$.proxy(function(){this.$container.addClass(t.prefix+\"-is-startbanner\")},this)),this.$video.on(\"playing\",$.proxy(function(){this.$container.removeClass(t.prefix+\"-is-startbanner\")},this))))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){var r=this.getView(e);return!!r&&(this.$video.on(\"pause\",$.proxy(function(e){this.getDuration()!==this.getCurrentTime()&&this.$container.addClass(t.prefix+\"-is-stopbanner\")},this)),void this.$video.on(\"playing\",$.proxy(function(){this.$container.removeClass(t.prefix+\"-is-stopbanner\")},this)))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){var r=this.getView(e);return!!r&&(this.$video.on(\"ended\",$.proxy(function(){this.$container.addClass(t.prefix+\"-is-endbanner\")},this)),void this.$video.on(\"playing loadstart seeking\",$.proxy(function(){this.$container.removeClass(t.prefix+\"-is-endbanner\")},this)))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){function r(){u&&c&&(clearInterval(o),a=u,c.text(a),o=setInterval($.proxy(function(){c.text(--a),a||(this.load(),clearInterval(o))},this),1e3)),this.$container.addClass(t.prefix+\"-is-error\")}var i=this.getView(e);if(!i)return!1;var o,u=!!n.timer&&(isNaN(parseInt(n.timer))?10:parseInt(n.timer)),a=!1,s=this.getView(\"refresh\"),c=this.getView(\"timer\");this.$video.on(\"error\",$.proxy(function(t){r.call(this)},this)),s&&(s.on(\"click\",$.proxy(function(t){t.stopPropagation(),this.load()},this)),this.$container.one(\"destroyed\",$.proxy(function(){s.off()},this)))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e){var n=this.getView(e);return!!this.getView(e)&&((document.documentElement.requestFullscreen||document.documentElement.msRequestFullscreen||document.documentElement.mozRequestFullScreen||document.documentElement.webkitRequestFullscreen)&&this.$document.on(\"fullscreenchange.acPlayer mozfullscreenchange.acPlayer webkitfullscreenchange.acPlayer MSFullscreenChange.acPlayer\",$.proxy(function(e){document.fullscreenElement||document.mozFullScreenElement||document.webkitFullscreenElement||document.msFullscreenElement||this.$container.removeClass(t.prefix+\"-is-fullscreen\")},this)),n.on(\"click\",$.proxy(function(e){e.stopPropagation(),this.$container.hasClass(t.prefix+\"-is-fullscreen\")?this.exitFullscreen.call(this):this.fullscreen.call(this)},this)),void this.$container.one(\"destroyed\",$.proxy(function(){n.off()},this)))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e){if(!this.getView(e))return!1;var n=0,r=function(t){if(n=this.getDuration(),!n)return!1;var e=t-this.$progressbar.offset().left,r=100*e/this.$progressbar.outerWidth();r>100?r=100:r<0&&(r=0),this.$progress.css(\"width\",r+\"%\"),this.setCurrentTime(n*r/100)};this.$buffered=$('<div class=\"'+t.prefix+'-buffered\" />').appendTo(this.$progressbar),this.$progress=$('<div class=\"'+t.prefix+'-progress\" />').appendTo(this.$progressbar),this.$video.on(\"canplaythrough\",$.proxy(function(){n=this.getDuration(),this.$video.on(\"timeupdate.progressbar\",$.proxy(function(t){n=this.getDuration(),this.setLineWidth(n,this.getCurrentTime(),this.$progress)},this)),this.$video.on(\"progress\",$.proxy(function(t,e){n=this.getDuration(),this.video.buffered.length&&this.setLineWidth(n,this.video.buffered.end(0),this.$buffered)},this)),this.$progressbar.on(\"mousedown.progressbar touchstart.progressbar\",$.proxy(function(t){t.stopPropagation(),this.$document.on(\"mouseup.progressbar touchend.progressbar\",$.proxy(function(t){t.stopPropagation();var e=t.pageX||t.originalEvent.changedTouches[0].pageX;r.call(this,e),this.$document.off(\".progressbar\")},this)),this.$document.on(\"mousemove.progressbar touchmove.progressbar\",$.proxy(function(t){t.stopPropagation();var e=t.pageX||t.originalEvent.changedTouches[0].pageX;r.call(this,e)},this))},this))},this)),this.$container.one(\"destroyed\",$.proxy(function(){this.$document.off(\".progressbar\")},this))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e){return!!this.getView(e)&&void this.$video.on(\"loadstart waiting seeking\",$.proxy(function(e){this.$container.addClass(t.prefix+\"-is-spinner\")},this)).on(\"canplay seeked pause error\",$.proxy(function(e){this.$container.removeClass(t.prefix+\"-is-spinner\")},this))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){n&&n.autoHide===!1&&this.$container.addClass(t.prefix+\"-show-controls\"),this._initOptions(n);var r=this.getView(\"controls\");return r&&r.on(\"click touchstart touchend touchmove\",function(t){return t.stopPropagation()})}}).call(e,n(2))},function(t,e){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(t){if(!this.getView(t))return!1;var e=this.getDuration();isNaN(e)?this.$video.on(\"loadedmetadata playing durationchange\",$.proxy(function(){e=this.getDuration(),this.$duration.text(this.timeFormat(e))},this)):this.$duration.text(this.timeFormat(e))}},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e){return!!this.getView(e)&&void this.$video.on(\"timeupdate.time\",$.proxy(function(){var e=this.getCurrentTime();this.$time.text(this.timeFormat(e)),this.posterExist&&e>0&&this.$container.removeClass(t.prefix+\"-is-poster\")},this))}}).call(e,n(2))},function(t,e){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(t){var e=this.getView(t);return!!e&&(this.isMobileIos()&&e.hide(),this[\"$\"+t].on(\"click\",$.proxy(function(t){t.stopPropagation(),this.video.muted?this.unmute():this.mute()},this)),void this.$container.one(\"destroyed\",$.proxy(function(){this[\"$\"+t].off()},this)))}},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e){if(e instanceof Object)this.video.paused?this.play():this.isTouchDevice()?void 0===this.timerTogglePlay?(this.$container.addClass(t.prefix+\"-is-touched\"),this.timerTogglePlay=setTimeout($.proxy(function(){clearTimeout(this.timerTogglePlay),this.timerTogglePlay=void 0,this.$container.removeClass(t.prefix+\"-is-touched\")},this),3e3)):(clearTimeout(this.timerTogglePlay),this.pause()):this.pause();else if(e){if(!this.getView(e))return!1;this[\"$\"+e].on(\"click\",$.proxy(function(t){t.stopPropagation(),this.video.paused||this.video.ended?this.play():this.pause()},this)),this.$container.one(\"destroyed\",$.proxy(function(){this[\"$\"+e].off()},this))}else this.video.paused?this.play():this.pause()}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){var r=this.getView(e);if(!r||!n)return!1;var i=this.getView(\"limit-counter\"),o=localStorage.getItem(\"limit\"),u=localStorage.getItem(\"limitedTo\"),a=(new Date).getTime(),s=!1;(null===o&&null===u||parseInt(u)<=a)&&(o=n.count,u=(new Date).getTime()+24*n.period*60*60*1e3),o=parseInt(o),u=parseInt(u),this.$video.on(\"playing\",$.proxy(function(){o<=0&&!s&&(this.video.paused||this.pause(),this.$container.addClass(t.prefix+\"-is-limit\"),i&&i.text(o)),s||(o>0&&--o,s=!0),localStorage.setItem(\"limit\",o),localStorage.setItem(\"limitedTo\",u)},this)),this.$video.on(\"ended\",$.proxy(function(){s=!1,this.$container.addClass(t.prefix+\"-is-limit\"),i.text(o)},this))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){var r=this.getView(e);if(!r)return!1;var i,o,u=!!r.data(\"inited\"),a=t.prefix+\"-formats-current-item\",s=r.find(\".\"+t.prefix+\"-formats-current\"),c=0;u?(i=this.$container.find(\".\"+t.prefix+\"-formats-box\"),o=i.find(\".\"+t.prefix+\"-formats-list\").empty()):(i=$('<div class=\"'+t.prefix+'-formats-box\" />'),o=$('<ul class=\"'+t.prefix+'-formats-list\" />').appendTo(i)),s.length||(s=$('<span class=\"'+t.prefix+'-formats-current\" />').appendTo(r));for(var f in n){var l=n[f],h=(l.name||\"noname\",$('<li class=\"'+t.prefix+'-formats-item\">'+l.name+\"</li>\")),d=$(\"<span />\");l.isDefault&&(s.text(l.name),this.createSources.call(this,f,l.sources),h.addClass(a)),l.icon&&d.addClass(t.prefix+\"-\"+l.icon+\" \"+t.prefix+\"-icon\"),d.prependTo(h),h.appendTo(o).data(\"format\",l).click($.proxy(function(e){e.stopPropagation();var n=$(e.currentTarget),r=this.video.paused,i=this.getCurrentTime();if(!n.hasClass(a)){var u=o.find(\".\"+a),c=n.data(\"format\");return s.text(c.name),u.removeClass(a),n.addClass(a),this.createSources.call(this,f,c.sources,r,i),this.$container.removeClass(t.prefix+\"-show-formats\"),this.$container.trigger(\"onChangeFormat\"),!1}},this)),++c}return c<=1?(r.css(\"display\",\"none\"),!1):(r.css(\"display\",\"\"),void(u||(r.data(\"inited\",!0),i.appendTo(r),r.on(\"click.toggleFormats\",$.proxy(function(e){e.stopPropagation(),this.$container.toggleClass(t.prefix+\"-show-formats\")},this)),$(\"body\").on(\"click.toggleFormats\",$.proxy(function(e){e.stopPropagation();var n=$(e.target);n.is(r)||n.closest(r).length||this.$container.removeClass(t.prefix+\"-show-formats\")},this)),this.$container.one(\"destroyed\",$.proxy(function(){r.data(\"inited\",!1).off(\".toggleFormats\"),this.$document.off(\".toggleFormats\"),i.remove(),s.remove()},this)))))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){if(!this.$progressbar||this.isTouchDevice())return!1;var r=function(t,e){var n=this.getDuration(),r=t-this.$progressbar.offset().left,i=this.$progressbar.outerWidth(),o=100*r/i;if(this.$timelineTime.text(this.timeFormat(n*o/100)),\"thumbs\"===e.theme){var u=(this.thumbsSprite.width,this.thumbsSprite.width/e.thumbWidth);this.$timelineSprite.css({\"background-position\":-Math.floor(u*o/100)*e.thumbWidth})}var a=this.$timeline.outerWidth(),s=a/2;s>r?s=r:i<r+s&&(s=a-(i-r)),this.$timeline.css({left:r,\"margin-left\":-s})},i=function(){if(this.$timeline=$('<div class=\"'+t.prefix+'-timeline\" />').appendTo(this.$progressbar),this.$timelineTime=$('<div class=\"'+t.prefix+'-timeline-time\" />').appendTo(this.$timeline),\"thumbs\"===n.theme){var e=n;n=!1,this.$timelineSprite=$('<div class=\"'+t.prefix+'-timeline-thumb\" />'),this.$timelineSprite.css({\"background-image\":\"url(\"+e.sprite+\")\"}),this.thumbsSprite=new Image,this.thumbsSprite.src=e.sprite,$(this.thumbsSprite).on(\"load\",$.proxy(function(t){this.$timelineSprite.prependTo(this.$timeline),n=e},this))}this.$progressbar.on(\"mouseenter\",$.proxy(function(e){return e.stopPropagation(),!this.$container.hasClass(t.prefix+\"-show-formats\")&&!isNaN(parseInt(this.getDuration()))&&(this.$timeline.show(),r.call(this,e.pageX,n),this.$progressbar.on(\"mouseleave.timeline\",$.proxy(function(t){t.stopPropagation(),this.$timeline.hide(),this.$document.off(\".timeline\")},this)),void this.$progressbar.on(\"mousemove.timeline\",$.proxy(function(t){t.stopPropagation(),r.call(this,t.pageX,n)},this)))},this))};this.getDuration()?i.call(this):this.$video.one(\"durationchange\",$.proxy(function(){i.call(this)},this)),this.$container.one(\"destroyed\",$.proxy(function(){this.$progressbar.off(\".timeline\"),this.$document.off(\".timeline\")},this))}}).call(e,n(2))},function(t,e,n){(function(t){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(e,n){var r=this.getView(e),i=1;if(!r)return!1;if(this.isMobileIos())return r.hide(),!1;var o=function(t){var e,n=1,r=t-this.$volume.offset().left,i=100*r/this.$volume.outerWidth();i>100?i=100:i<0&&(i=0),e=n*i/100,this.setVolumeLevel(e)};this.$level=$('<div class=\"'+t.prefix+'-level\" />').appendTo(this.$volume),this.$video.on(\"volumechange\",$.proxy(function(){i=this.video.muted?0:this.getVolumeLevel(),this.setLineWidth(1,i,this.$level)},this)),this.$volume.on(\"mousedown.volume\",$.proxy(function(e){e.stopPropagation(),this.$container.removeClass(t.prefix+\"-is-muted\"),this.video.muted=!1,this.$document.on(\"mouseup.volume\",$.proxy(function(t){t.stopPropagation(),o.call(this,t.pageX),this.$document.off(\".volume\")},this)),this.$document.on(\"mousemove.volume\",$.proxy(function(t){t.stopPropagation(),o.call(this,t.pageX)},this))},this)),isNaN(Number(n))||(this.setVolumeLevel(n),this.$video.trigger(\"volumechange\")),this.$container.one(\"destroyed\",$.proxy(function(){this.$document.off(\".volume\"),this.$volume.off(\".volume\"),this.$video.off(\"volumechange\")},this))}}).call(e,n(2))},function(t,e){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var n=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t};e.default=function(t,e){return!!e&&void this.$video.on(\"loadedmetadata\",$.proxy(function(){var t=this.video.videoWidth,r=this.video.videoHeight,i=56.25;i=100*r/t,\"object\"===(\"undefined\"==typeof e?\"undefined\":n(e))&&(e.min&&\"auto\"!==e.min&&e.min>i&&(i=e.min),e.max&&\"auto\"!==e.max&&e.max<i&&(i=e.max)),this.$videoWrapper.css(\"padding-bottom\",i+\"%\"),$(this).trigger(\"changedsize\")},this))}},function(t,e){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(){var t=n({w:this.$video.width(),h:this.$video.height()});return r(t,this.video)};var n=function(t){var e=t.w,n=t.h,r=document.createElement(\"canvas\");return r.width=e,r.height=n,r},r=function(t,e){var n=t.getContext(\"2d\"),r=t.width,i=t.height;return n.drawImage(e,0,0,r,i),t}},function(t,e){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=function(t,e){var n=this,r=e.delay,i=void 0,o=void 0,u=void 0,a=!!this.options.plugins.error;\"metadata\"===this.options.movie.preload&&this.$video.one(\"loadedmetadata\",function(){n.$container.one(\"start_play\",function(){n.load()})}),this.$video.on(\"pause\",function(){clearTimeout(i),n.$video.one(\"play\",function(){return clearTimeout(i)});var t=void 0;a&&n.$video.off(\"error\"),i=setTimeout(function(){o=n.video.currentSrc,u=n.getCurrentTime(),n.snapshot&&(t=n.snapshot(),$(t).addClass(\"ac-p-video\"),n.$videoWrapper.append(t)),n.$container.one(\"start_play\",function(){$(t).remove(),n.video.src=o,n.setCurrentTime(u),a&&n.error(\"error\",n.options.plugins.error)}),n.video.src=\"\"},r)})}},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,\"__esModule\",{value:!0});var i=n(26),o=r(i),u=function(t,e){var n=Object.assign({},t);Object.keys(n).forEach(function(t){var r=n[t];n[t]=e.timeFormat(r)}),e.$container.trigger(\"cuttingtoolOnChange\",n)},a=function(t){if(!t.video.paused)return t.pause()},s=function(t,e){var n=t.current;return e.setCurrentTime(n)},c=function(t,e){return e.timeFormat(t)},f=function(t){t.$container.trigger(\"cuttingtoolAfterRender\")},l=void 0,h=function t(e,n){var r=this,i=80;t.getInstance=function(){return l};var h={position:\"relative\",zIndex:10,marginTop:[\"-\",i/2+3,\"px\"].join(\"\")};this.$controls&&this.$controls.is(\":visible\")&&(h.marginBottom=i/2,this.$progressbar&&(h.marginBottom+=this.$progressbar.height()),h.marginBottom+=\"px\");var d=l=(0,o.default)(this.$container.get(0),Object.assign({},{canvas:{width:this.$video.width(),height:120,styles:h},slider:{height:i},timeline:{maxAmount:6},callbacks:{onChanged:function(t){return u(t,r)},onCurrentEndReached:function(){return a(r)},onCurrentChanged:function(t){return s(t,r)},lengthFormater:function(t){return c(t,r)},afterRender:function(){return f(r)}}},n));this.$container.on(\"destroyed\",function(){d.destroy()}),this.$video.on(\"loadedmetadata\",function(){var t={timeLength:r.getDuration()},e=r.options.plugins.timeline,i=o.default.isSafari()||o.default.isWindowsBrowser();i&&n.getBaselineUrl?t.image=n.getBaselineUrl():e&&e.sprite&&(t.image=e.sprite),d.setData(t);var u=function(){var t=d.getData();t.current>=0&&d.callMethod(\"updateCurrent\",{length:r.getCurrentTime()})};r.$video.on(\"play playing\",function(){r.$video.on(\"timeupdate.time\",u),r.$video.one(\"pause\",function(){r.$video.off(\"timeupdate.time\",u)})})})};e.default=h},function(t,e){!function(n,r){\"object\"==typeof e&&\"object\"==typeof t?t.exports=r():\"function\"==typeof define&&define.amd?define([],r):\"object\"==typeof e?e.rangeSlider=r():n.rangeSlider=r()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p=\"\",e(0)}([function(t,e,n){n(1),t.exports=n(298)},function(t,e,n){(function(t){\"use strict\";function e(t,e,n){t[e]||Object[r](t,e,{writable:!0,configurable:!0,value:n})}if(n(2),n(293),n(295),t._babelPolyfill)throw new Error(\"only one instance of babel-polyfill is allowed\");t._babelPolyfill=!0;var r=\"defineProperty\";e(String.prototype,\"padLeft\",\"\".padStart),e(String.prototype,\"padRight\",\"\".padEnd),\"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill\".split(\",\").forEach(function(t){[][t]&&e(Array,t,Function.call.bind([][t]))})}).call(e,function(){return this}())},function(t,e,n){n(3),n(52),n(53),n(54),n(55),n(57),n(60),n(61),n(62),n(63),n(64),n(65),n(66),n(67),n(68),n(70),n(72),n(74),n(76),n(79),n(80),n(81),n(85),n(87),n(89),n(92),n(93),n(94),n(95),n(97),n(98),n(99),n(100),n(101),n(102),n(103),n(105),n(106),n(107),n(109),n(110),n(111),n(113),n(114),n(115),n(116),n(117),n(118),n(119),n(120),n(121),n(122),n(123),n(124),n(125),n(126),n(131),n(132),n(136),n(137),n(138),n(139),n(141),n(142),n(143),n(144),n(145),n(146),n(147),n(148),n(149),n(150),n(151),n(152),n(153),n(154),n(155),n(156),n(157),n(159),n(160),n(166),n(167),n(169),n(170),n(171),n(175),n(176),n(177),n(178),n(179),n(181),n(182),n(183),n(184),n(187),n(189),n(190),n(191),n(193),n(195),n(197),n(198),n(199),n(201),n(202),n(203),n(204),n(211),n(214),n(215),n(217),n(218),n(221),n(222),n(224),n(225),n(226),n(227),n(228),n(229),n(230),n(231),n(232),n(233),n(234),n(235),n(236),n(237),n(238),n(239),n(240),n(241),n(242),n(244),n(245),n(246),n(247),n(248),n(249),n(251),n(252),n(253),n(254),n(255),n(256),n(257),n(258),n(260),n(261),n(263),n(264),n(265),n(266),n(269),n(270),n(271),n(272),n(273),n(274),n(275),n(276),n(278),n(279),n(280),n(281),n(282),n(283),n(284),n(285),n(286),n(287),n(288),n(291),n(292),t.exports=n(9)},function(t,e,n){\"use strict\";var r=n(4),i=n(5),o=n(6),u=n(8),a=n(18),s=n(22).KEY,c=n(7),f=n(23),l=n(24),h=n(19),d=n(25),p=n(26),v=n(27),g=n(29),y=n(42),_=n(45),m=n(12),b=n(32),w=n(16),x=n(17),E=n(46),P=n(49),S=n(51),O=n(11),A=n(30),T=S.f,$=O.f,C=P.f,R=r.Symbol,j=r.JSON,D=j&&j.stringify,k=\"prototype\",M=d(\"_hidden\"),F=d(\"toPrimitive\"),I={}.propertyIsEnumerable,L=f(\"symbol-registry\"),N=f(\"symbols\"),G=f(\"op-symbols\"),U=Object[k],W=\"function\"==typeof R,X=r.QObject,V=!X||!X[k]||!X[k].findChild,B=o&&c(function(){return 7!=E($({},\"a\",{get:function(){return $(this,\"a\",{value:7}).a}})).a})?function(t,e,n){var r=T(U,e);r&&delete U[e],$(t,e,n),r&&t!==U&&$(U,e,r)}:$,z=function(t){var e=N[t]=E(R[k]);return e._k=t,e},H=W&&\"symbol\"==typeof R.iterator?function(t){return\"symbol\"==typeof t}:function(t){return t instanceof R},Y=function(t,e,n){return t===U&&Y(G,e,n),m(t),e=w(e,!0),m(n),i(N,e)?(n.enumerable?(i(t,M)&&t[M][e]&&(t[M][e]=!1),n=E(n,{enumerable:x(0,!1)})):(i(t,M)||$(t,M,x(1,{})),t[M][e]=!0),B(t,e,n)):$(t,e,n)},q=function(t,e){m(t);for(var n,r=y(e=b(e)),i=0,o=r.length;o>i;)Y(t,n=r[i++],e[n]);return t},K=function(t,e){return void 0===e?E(t):q(E(t),e)},J=function(t){var e=I.call(this,t=w(t,!0));return!(this===U&&i(N,t)&&!i(G,t))&&(!(e||!i(this,t)||!i(N,t)||i(this,M)&&this[M][t])||e)},Z=function(t,e){if(t=b(t),e=w(e,!0),t!==U||!i(N,e)||i(G,e)){var n=T(t,e);return!n||!i(N,e)||i(t,M)&&t[M][e]||(n.enumerable=!0),n}},Q=function(t){\nfor(var e,n=C(b(t)),r=[],o=0;n.length>o;)i(N,e=n[o++])||e==M||e==s||r.push(e);return r},tt=function(t){for(var e,n=t===U,r=C(n?G:b(t)),o=[],u=0;r.length>u;)!i(N,e=r[u++])||n&&!i(U,e)||o.push(N[e]);return o};W||(R=function(){if(this instanceof R)throw TypeError(\"Symbol is not a constructor!\");var t=h(arguments.length>0?arguments[0]:void 0),e=function(n){this===U&&e.call(G,n),i(this,M)&&i(this[M],t)&&(this[M][t]=!1),B(this,t,x(1,n))};return o&&V&&B(U,t,{configurable:!0,set:e}),z(t)},a(R[k],\"toString\",function(){return this._k}),S.f=Z,O.f=Y,n(50).f=P.f=Q,n(44).f=J,n(43).f=tt,o&&!n(28)&&a(U,\"propertyIsEnumerable\",J,!0),p.f=function(t){return z(d(t))}),u(u.G+u.W+u.F*!W,{Symbol:R});for(var et=\"hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables\".split(\",\"),nt=0;et.length>nt;)d(et[nt++]);for(var et=A(d.store),nt=0;et.length>nt;)v(et[nt++]);u(u.S+u.F*!W,\"Symbol\",{for:function(t){return i(L,t+=\"\")?L[t]:L[t]=R(t)},keyFor:function(t){if(H(t))return g(L,t);throw TypeError(t+\" is not a symbol!\")},useSetter:function(){V=!0},useSimple:function(){V=!1}}),u(u.S+u.F*!W,\"Object\",{create:K,defineProperty:Y,defineProperties:q,getOwnPropertyDescriptor:Z,getOwnPropertyNames:Q,getOwnPropertySymbols:tt}),j&&u(u.S+u.F*(!W||c(function(){var t=R();return\"[null]\"!=D([t])||\"{}\"!=D({a:t})||\"{}\"!=D(Object(t))})),\"JSON\",{stringify:function(t){if(void 0!==t&&!H(t)){for(var e,n,r=[t],i=1;arguments.length>i;)r.push(arguments[i++]);return e=r[1],\"function\"==typeof e&&(n=e),!n&&_(e)||(e=function(t,e){if(n&&(e=n.call(this,t,e)),!H(e))return e}),r[1]=e,D.apply(j,r)}}}),R[k][F]||n(10)(R[k],F,R[k].valueOf),l(R,\"Symbol\"),l(Math,\"Math\",!0),l(r.JSON,\"JSON\",!0)},function(t,e){var n=t.exports=\"undefined\"!=typeof window&&window.Math==Math?window:\"undefined\"!=typeof self&&self.Math==Math?self:Function(\"return this\")();\"number\"==typeof __g&&(__g=n)},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},\"a\",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(4),i=n(9),o=n(10),u=n(18),a=n(20),s=\"prototype\",c=function(t,e,n){var f,l,h,d,p=t&c.F,v=t&c.G,g=t&c.S,y=t&c.P,_=t&c.B,m=v?r:g?r[e]||(r[e]={}):(r[e]||{})[s],b=v?i:i[e]||(i[e]={}),w=b[s]||(b[s]={});v&&(n=e);for(f in n)l=!p&&m&&void 0!==m[f],h=(l?m:n)[f],d=_&&l?a(h,r):y&&\"function\"==typeof h?a(Function.call,h):h,m&&u(m,f,h,t&c.U),b[f]!=h&&o(b,f,d),y&&w[f]!=h&&(w[f]=h)};r.core=i,c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,t.exports=c},function(t,e){var n=t.exports={version:\"2.4.0\"};\"number\"==typeof __e&&(__e=n)},function(t,e,n){var r=n(11),i=n(17);t.exports=n(6)?function(t,e,n){return r.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(12),i=n(14),o=n(16),u=Object.defineProperty;e.f=n(6)?Object.defineProperty:function(t,e,n){if(r(t),e=o(e,!0),r(n),i)try{return u(t,e,n)}catch(t){}if(\"get\"in n||\"set\"in n)throw TypeError(\"Accessors not supported!\");return\"value\"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(13);t.exports=function(t){if(!r(t))throw TypeError(t+\" is not an object!\");return t}},function(t,e){t.exports=function(t){return\"object\"==typeof t?null!==t:\"function\"==typeof t}},function(t,e,n){t.exports=!n(6)&&!n(7)(function(){return 7!=Object.defineProperty(n(15)(\"div\"),\"a\",{get:function(){return 7}}).a})},function(t,e,n){var r=n(13),i=n(4).document,o=r(i)&&r(i.createElement);t.exports=function(t){return o?i.createElement(t):{}}},function(t,e,n){var r=n(13);t.exports=function(t,e){if(!r(t))return t;var n,i;if(e&&\"function\"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;if(\"function\"==typeof(n=t.valueOf)&&!r(i=n.call(t)))return i;if(!e&&\"function\"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;throw TypeError(\"Can't convert object to primitive value\")}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var r=n(4),i=n(10),o=n(5),u=n(19)(\"src\"),a=\"toString\",s=Function[a],c=(\"\"+s).split(a);n(9).inspectSource=function(t){return s.call(t)},(t.exports=function(t,e,n,a){var s=\"function\"==typeof n;s&&(o(n,\"name\")||i(n,\"name\",e)),t[e]!==n&&(s&&(o(n,u)||i(n,u,t[e]?\"\"+t[e]:c.join(String(e)))),t===r?t[e]=n:a?t[e]?t[e]=n:i(t,e,n):(delete t[e],i(t,e,n)))})(Function.prototype,a,function(){return\"function\"==typeof this&&this[u]||s.call(this)})},function(t,e){var n=0,r=Math.random();t.exports=function(t){return\"Symbol(\".concat(void 0===t?\"\":t,\")_\",(++n+r).toString(36))}},function(t,e,n){var r=n(21);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,i){return t.call(e,n,r,i)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){if(\"function\"!=typeof t)throw TypeError(t+\" is not a function!\");return t}},function(t,e,n){var r=n(19)(\"meta\"),i=n(13),o=n(5),u=n(11).f,a=0,s=Object.isExtensible||function(){return!0},c=!n(7)(function(){return s(Object.preventExtensions({}))}),f=function(t){u(t,r,{value:{i:\"O\"+ ++a,w:{}}})},l=function(t,e){if(!i(t))return\"symbol\"==typeof t?t:(\"string\"==typeof t?\"S\":\"P\")+t;if(!o(t,r)){if(!s(t))return\"F\";if(!e)return\"E\";f(t)}return t[r].i},h=function(t,e){if(!o(t,r)){if(!s(t))return!0;if(!e)return!1;f(t)}return t[r].w},d=function(t){return c&&p.NEED&&s(t)&&!o(t,r)&&f(t),t},p=t.exports={KEY:r,NEED:!1,fastKey:l,getWeak:h,onFreeze:d}},function(t,e,n){var r=n(4),i=\"__core-js_shared__\",o=r[i]||(r[i]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,e,n){var r=n(11).f,i=n(5),o=n(25)(\"toStringTag\");t.exports=function(t,e,n){t&&!i(t=n?t:t.prototype,o)&&r(t,o,{configurable:!0,value:e})}},function(t,e,n){var r=n(23)(\"wks\"),i=n(19),o=n(4).Symbol,u=\"function\"==typeof o,a=t.exports=function(t){return r[t]||(r[t]=u&&o[t]||(u?o:i)(\"Symbol.\"+t))};a.store=r},function(t,e,n){e.f=n(25)},function(t,e,n){var r=n(4),i=n(9),o=n(28),u=n(26),a=n(11).f;t.exports=function(t){var e=i.Symbol||(i.Symbol=o?{}:r.Symbol||{});\"_\"==t.charAt(0)||t in e||a(e,t,{value:u.f(t)})}},function(t,e){t.exports=!1},function(t,e,n){var r=n(30),i=n(32);t.exports=function(t,e){for(var n,o=i(t),u=r(o),a=u.length,s=0;a>s;)if(o[n=u[s++]]===e)return n}},function(t,e,n){var r=n(31),i=n(41);t.exports=Object.keys||function(t){return r(t,i)}},function(t,e,n){var r=n(5),i=n(32),o=n(36)(!1),u=n(40)(\"IE_PROTO\");t.exports=function(t,e){var n,a=i(t),s=0,c=[];for(n in a)n!=u&&r(a,n)&&c.push(n);for(;e.length>s;)r(a,n=e[s++])&&(~o(c,n)||c.push(n));return c}},function(t,e,n){var r=n(33),i=n(35);t.exports=function(t){return r(i(t))}},function(t,e,n){var r=n(34);t.exports=Object(\"z\").propertyIsEnumerable(0)?Object:function(t){return\"String\"==r(t)?t.split(\"\"):Object(t)}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError(\"Can't call method on  \"+t);return t}},function(t,e,n){var r=n(32),i=n(37),o=n(39);t.exports=function(t){return function(e,n,u){var a,s=r(e),c=i(s.length),f=o(u,c);if(t&&n!=n){for(;c>f;)if(a=s[f++],a!=a)return!0}else for(;c>f;f++)if((t||f in s)&&s[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(38),i=Math.min;t.exports=function(t){return t>0?i(r(t),9007199254740991):0}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(38),i=Math.max,o=Math.min;t.exports=function(t,e){return t=r(t),t<0?i(t+e,0):o(t,e)}},function(t,e,n){var r=n(23)(\"keys\"),i=n(19);t.exports=function(t){return r[t]||(r[t]=i(t))}},function(t,e){t.exports=\"constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf\".split(\",\")},function(t,e,n){var r=n(30),i=n(43),o=n(44);t.exports=function(t){var e=r(t),n=i.f;if(n)for(var u,a=n(t),s=o.f,c=0;a.length>c;)s.call(t,u=a[c++])&&e.push(u);return e}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var r=n(34);t.exports=Array.isArray||function(t){return\"Array\"==r(t)}},function(t,e,n){var r=n(12),i=n(47),o=n(41),u=n(40)(\"IE_PROTO\"),a=function(){},s=\"prototype\",c=function(){var t,e=n(15)(\"iframe\"),r=o.length,i=\"<\",u=\">\";for(e.style.display=\"none\",n(48).appendChild(e),e.src=\"javascript:\",t=e.contentWindow.document,t.open(),t.write(i+\"script\"+u+\"document.F=Object\"+i+\"/script\"+u),t.close(),c=t.F;r--;)delete c[s][o[r]];return c()};t.exports=Object.create||function(t,e){var n;return null!==t?(a[s]=r(t),n=new a,a[s]=null,n[u]=t):n=c(),void 0===e?n:i(n,e)}},function(t,e,n){var r=n(11),i=n(12),o=n(30);t.exports=n(6)?Object.defineProperties:function(t,e){i(t);for(var n,u=o(e),a=u.length,s=0;a>s;)r.f(t,n=u[s++],e[n]);return t}},function(t,e,n){t.exports=n(4).document&&document.documentElement},function(t,e,n){var r=n(32),i=n(50).f,o={}.toString,u=\"object\"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],a=function(t){try{return i(t)}catch(t){return u.slice()}};t.exports.f=function(t){return u&&\"[object Window]\"==o.call(t)?a(t):i(r(t))}},function(t,e,n){var r=n(31),i=n(41).concat(\"length\",\"prototype\");e.f=Object.getOwnPropertyNames||function(t){return r(t,i)}},function(t,e,n){var r=n(44),i=n(17),o=n(32),u=n(16),a=n(5),s=n(14),c=Object.getOwnPropertyDescriptor;e.f=n(6)?c:function(t,e){if(t=o(t),e=u(e,!0),s)try{return c(t,e)}catch(t){}if(a(t,e))return i(!r.f.call(t,e),t[e])}},function(t,e,n){var r=n(8);r(r.S,\"Object\",{create:n(46)})},function(t,e,n){var r=n(8);r(r.S+r.F*!n(6),\"Object\",{defineProperty:n(11).f})},function(t,e,n){var r=n(8);r(r.S+r.F*!n(6),\"Object\",{defineProperties:n(47)})},function(t,e,n){var r=n(32),i=n(51).f;n(56)(\"getOwnPropertyDescriptor\",function(){return function(t,e){return i(r(t),e)}})},function(t,e,n){var r=n(8),i=n(9),o=n(7);t.exports=function(t,e){var n=(i.Object||{})[t]||Object[t],u={};u[t]=e(n),r(r.S+r.F*o(function(){n(1)}),\"Object\",u)}},function(t,e,n){var r=n(58),i=n(59);n(56)(\"getPrototypeOf\",function(){return function(t){return i(r(t))}})},function(t,e,n){var r=n(35);t.exports=function(t){return Object(r(t))}},function(t,e,n){var r=n(5),i=n(58),o=n(40)(\"IE_PROTO\"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),r(t,o)?t[o]:\"function\"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},function(t,e,n){var r=n(58),i=n(30);n(56)(\"keys\",function(){return function(t){return i(r(t))}})},function(t,e,n){n(56)(\"getOwnPropertyNames\",function(){return n(49).f})},function(t,e,n){var r=n(13),i=n(22).onFreeze;n(56)(\"freeze\",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){var r=n(13),i=n(22).onFreeze;n(56)(\"seal\",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){var r=n(13),i=n(22).onFreeze;n(56)(\"preventExtensions\",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){var r=n(13);n(56)(\"isFrozen\",function(t){return function(e){return!r(e)||!!t&&t(e)}})},function(t,e,n){var r=n(13);n(56)(\"isSealed\",function(t){return function(e){return!r(e)||!!t&&t(e)}})},function(t,e,n){var r=n(13);n(56)(\"isExtensible\",function(t){return function(e){return!!r(e)&&(!t||t(e))}})},function(t,e,n){var r=n(8);r(r.S+r.F,\"Object\",{assign:n(69)})},function(t,e,n){\"use strict\";var r=n(30),i=n(43),o=n(44),u=n(58),a=n(33),s=Object.assign;t.exports=!s||n(7)(function(){var t={},e={},n=Symbol(),r=\"abcdefghijklmnopqrst\";return t[n]=7,r.split(\"\").forEach(function(t){e[t]=t}),7!=s({},t)[n]||Object.keys(s({},e)).join(\"\")!=r})?function(t,e){for(var n=u(t),s=arguments.length,c=1,f=i.f,l=o.f;s>c;)for(var h,d=a(arguments[c++]),p=f?r(d).concat(f(d)):r(d),v=p.length,g=0;v>g;)l.call(d,h=p[g++])&&(n[h]=d[h]);return n}:s},function(t,e,n){var r=n(8);r(r.S,\"Object\",{is:n(71)})},function(t,e){t.exports=Object.is||function(t,e){return t===e?0!==t||1/t===1/e:t!=t&&e!=e}},function(t,e,n){var r=n(8);r(r.S,\"Object\",{setPrototypeOf:n(73).set})},function(t,e,n){var r=n(13),i=n(12),o=function(t,e){if(i(t),!r(e)&&null!==e)throw TypeError(e+\": can't set as prototype!\")};t.exports={set:Object.setPrototypeOf||(\"__proto__\"in{}?function(t,e,r){try{r=n(20)(Function.call,n(51).f(Object.prototype,\"__proto__\").set,2),r(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:r(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){\"use strict\";var r=n(75),i={};i[n(25)(\"toStringTag\")]=\"z\",i+\"\"!=\"[object z]\"&&n(18)(Object.prototype,\"toString\",function(){return\"[object \"+r(this)+\"]\"},!0)},function(t,e,n){var r=n(34),i=n(25)(\"toStringTag\"),o=\"Arguments\"==r(function(){return arguments}()),u=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,a;return void 0===t?\"Undefined\":null===t?\"Null\":\"string\"==typeof(n=u(e=Object(t),i))?n:o?r(e):\"Object\"==(a=r(e))&&\"function\"==typeof e.callee?\"Arguments\":a}},function(t,e,n){var r=n(8);r(r.P,\"Function\",{bind:n(77)})},function(t,e,n){\"use strict\";var r=n(21),i=n(13),o=n(78),u=[].slice,a={},s=function(t,e,n){if(!(e in a)){for(var r=[],i=0;i<e;i++)r[i]=\"a[\"+i+\"]\";a[e]=Function(\"F,a\",\"return new F(\"+r.join(\",\")+\")\")}return a[e](t,n)};t.exports=Function.bind||function(t){var e=r(this),n=u.call(arguments,1),a=function(){var r=n.concat(u.call(arguments));return this instanceof a?s(e,r.length,r):o(e,r,t)};return i(e.prototype)&&(a.prototype=e.prototype),a}},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(11).f,i=n(17),o=n(5),u=Function.prototype,a=/^\\s*function ([^ (]*)/,s=\"name\",c=Object.isExtensible||function(){return!0};s in u||n(6)&&r(u,s,{configurable:!0,get:function(){try{var t=this,e=(\"\"+t).match(a)[1];return o(t,s)||!c(t)||r(t,s,i(5,e)),e}catch(t){return\"\"}}})},function(t,e,n){\"use strict\";var r=n(13),i=n(59),o=n(25)(\"hasInstance\"),u=Function.prototype;o in u||n(11).f(u,o,{value:function(t){if(\"function\"!=typeof this||!r(t))return!1;if(!r(this.prototype))return t instanceof this;for(;t=i(t);)if(this.prototype===t)return!0;return!1}})},function(t,e,n){var r=n(8),i=n(82);r(r.G+r.F*(parseInt!=i),{parseInt:i})},function(t,e,n){var r=n(4).parseInt,i=n(83).trim,o=n(84),u=/^[\\-+]?0[xX]/;t.exports=8!==r(o+\"08\")||22!==r(o+\"0x16\")?function(t,e){var n=i(String(t),3);return r(n,e>>>0||(u.test(n)?16:10))}:r},function(t,e,n){var r=n(8),i=n(35),o=n(7),u=n(84),a=\"[\"+u+\"]\",s=\"​\",c=RegExp(\"^\"+a+a+\"*\"),f=RegExp(a+a+\"*$\"),l=function(t,e,n){var i={},a=o(function(){return!!u[t]()||s[t]()!=s}),c=i[t]=a?e(h):u[t];n&&(i[n]=c),r(r.P+r.F*a,\"String\",i)},h=l.trim=function(t,e){return t=String(i(t)),1&e&&(t=t.replace(c,\"\")),2&e&&(t=t.replace(f,\"\")),t};t.exports=l},function(t,e){t.exports=\"\\t\\n\\v\\f\\r   ᠎             　\\u2028\\u2029\\ufeff\"},function(t,e,n){var r=n(8),i=n(86);r(r.G+r.F*(parseFloat!=i),{parseFloat:i})},function(t,e,n){var r=n(4).parseFloat,i=n(83).trim;t.exports=1/r(n(84)+\"-0\")!==-(1/0)?function(t){var e=i(String(t),3),n=r(e);return 0===n&&\"-\"==e.charAt(0)?-0:n}:r},function(t,e,n){\"use strict\";var r=n(4),i=n(5),o=n(34),u=n(88),a=n(16),s=n(7),c=n(50).f,f=n(51).f,l=n(11).f,h=n(83).trim,d=\"Number\",p=r[d],v=p,g=p.prototype,y=o(n(46)(g))==d,_=\"trim\"in String.prototype,m=function(t){var e=a(t,!1);if(\"string\"==typeof e&&e.length>2){e=_?e.trim():h(e,3);var n,r,i,o=e.charCodeAt(0);if(43===o||45===o){if(n=e.charCodeAt(2),88===n||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:r=2,i=49;break;case 79:case 111:r=8,i=55;break;default:return+e}for(var u,s=e.slice(2),c=0,f=s.length;c<f;c++)if(u=s.charCodeAt(c),u<48||u>i)return NaN;return parseInt(s,r)}}return+e};if(!p(\" 0o1\")||!p(\"0b1\")||p(\"+0x1\")){p=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof p&&(y?s(function(){g.valueOf.call(n)}):o(n)!=d)?u(new v(m(e)),n,p):m(e)};for(var b,w=n(6)?c(v):\"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger\".split(\",\"),x=0;w.length>x;x++)i(v,b=w[x])&&!i(p,b)&&l(p,b,f(v,b));p.prototype=g,g.constructor=p,n(18)(r,d,p)}},function(t,e,n){var r=n(13),i=n(73).set;t.exports=function(t,e,n){var o,u=e.constructor;return u!==n&&\"function\"==typeof u&&(o=u.prototype)!==n.prototype&&r(o)&&i&&i(t,o),t}},function(t,e,n){\"use strict\";var r=n(8),i=n(38),o=n(90),u=n(91),a=1..toFixed,s=Math.floor,c=[0,0,0,0,0,0],f=\"Number.toFixed: incorrect invocation!\",l=\"0\",h=function(t,e){for(var n=-1,r=e;++n<6;)r+=t*c[n],c[n]=r%1e7,r=s(r/1e7)},d=function(t){for(var e=6,n=0;--e>=0;)n+=c[e],c[e]=s(n/t),n=n%t*1e7},p=function(){for(var t=6,e=\"\";--t>=0;)if(\"\"!==e||0===t||0!==c[t]){var n=String(c[t]);e=\"\"===e?n:e+u.call(l,7-n.length)+n}return e},v=function(t,e,n){return 0===e?n:e%2===1?v(t,e-1,n*t):v(t*t,e/2,n)},g=function(t){for(var e=0,n=t;n>=4096;)e+=12,n/=4096;for(;n>=2;)e+=1,n/=2;return e};r(r.P+r.F*(!!a&&(\"0.000\"!==8e-5.toFixed(3)||\"1\"!==.9.toFixed(0)||\"1.25\"!==1.255.toFixed(2)||\"1000000000000000128\"!==(0xde0b6b3a7640080).toFixed(0))||!n(7)(function(){a.call({})})),\"Number\",{toFixed:function(t){var e,n,r,a,s=o(this,f),c=i(t),y=\"\",_=l;if(c<0||c>20)throw RangeError(f);if(s!=s)return\"NaN\";if(s<=-1e21||s>=1e21)return String(s);if(s<0&&(y=\"-\",s=-s),s>1e-21)if(e=g(s*v(2,69,1))-69,n=e<0?s*v(2,-e,1):s/v(2,e,1),n*=4503599627370496,e=52-e,e>0){for(h(0,n),r=c;r>=7;)h(1e7,0),r-=7;for(h(v(10,r,1),0),r=e-1;r>=23;)d(1<<23),r-=23;d(1<<r),h(1,1),d(2),_=p()}else h(0,n),h(1<<-e,0),_=p()+u.call(l,c);return c>0?(a=_.length,_=y+(a<=c?\"0.\"+u.call(l,c-a)+_:_.slice(0,a-c)+\".\"+_.slice(a-c))):_=y+_,_}})},function(t,e,n){var r=n(34);t.exports=function(t,e){if(\"number\"!=typeof t&&\"Number\"!=r(t))throw TypeError(e);return+t}},function(t,e,n){\"use strict\";var r=n(38),i=n(35);t.exports=function(t){var e=String(i(this)),n=\"\",o=r(t);if(o<0||o==1/0)throw RangeError(\"Count can't be negative\");for(;o>0;(o>>>=1)&&(e+=e))1&o&&(n+=e);return n}},function(t,e,n){\"use strict\";var r=n(8),i=n(7),o=n(90),u=1..toPrecision;r(r.P+r.F*(i(function(){return\"1\"!==u.call(1,void 0)})||!i(function(){u.call({})})),\"Number\",{toPrecision:function(t){var e=o(this,\"Number#toPrecision: incorrect invocation!\");return void 0===t?u.call(e):u.call(e,t)}})},function(t,e,n){var r=n(8);r(r.S,\"Number\",{EPSILON:Math.pow(2,-52)})},function(t,e,n){var r=n(8),i=n(4).isFinite;r(r.S,\"Number\",{isFinite:function(t){return\"number\"==typeof t&&i(t)}})},function(t,e,n){var r=n(8);r(r.S,\"Number\",{isInteger:n(96)})},function(t,e,n){var r=n(13),i=Math.floor;t.exports=function(t){return!r(t)&&isFinite(t)&&i(t)===t}},function(t,e,n){var r=n(8);r(r.S,\"Number\",{isNaN:function(t){return t!=t}})},function(t,e,n){var r=n(8),i=n(96),o=Math.abs;r(r.S,\"Number\",{isSafeInteger:function(t){return i(t)&&o(t)<=9007199254740991}})},function(t,e,n){var r=n(8);r(r.S,\"Number\",{MAX_SAFE_INTEGER:9007199254740991})},function(t,e,n){var r=n(8);r(r.S,\"Number\",{MIN_SAFE_INTEGER:-9007199254740991})},function(t,e,n){var r=n(8),i=n(86);r(r.S+r.F*(Number.parseFloat!=i),\"Number\",{parseFloat:i})},function(t,e,n){var r=n(8),i=n(82);r(r.S+r.F*(Number.parseInt!=i),\"Number\",{parseInt:i})},function(t,e,n){var r=n(8),i=n(104),o=Math.sqrt,u=Math.acosh;r(r.S+r.F*!(u&&710==Math.floor(u(Number.MAX_VALUE))&&u(1/0)==1/0),\"Math\",{acosh:function(t){return(t=+t)<1?NaN:t>94906265.62425156?Math.log(t)+Math.LN2:i(t-1+o(t-1)*o(t+1))}})},function(t,e){t.exports=Math.log1p||function(t){return(t=+t)>-1e-8&&t<1e-8?t-t*t/2:Math.log(1+t)}},function(t,e,n){function r(t){return isFinite(t=+t)&&0!=t?t<0?-r(-t):Math.log(t+Math.sqrt(t*t+1)):t}var i=n(8),o=Math.asinh;i(i.S+i.F*!(o&&1/o(0)>0),\"Math\",{asinh:r})},function(t,e,n){var r=n(8),i=Math.atanh;r(r.S+r.F*!(i&&1/i(-0)<0),\"Math\",{atanh:function(t){return 0==(t=+t)?t:Math.log((1+t)/(1-t))/2}})},function(t,e,n){var r=n(8),i=n(108);r(r.S,\"Math\",{cbrt:function(t){return i(t=+t)*Math.pow(Math.abs(t),1/3)}})},function(t,e){t.exports=Math.sign||function(t){return 0==(t=+t)||t!=t?t:t<0?-1:1}},function(t,e,n){var r=n(8);r(r.S,\"Math\",{clz32:function(t){return(t>>>=0)?31-Math.floor(Math.log(t+.5)*Math.LOG2E):32}})},function(t,e,n){var r=n(8),i=Math.exp;r(r.S,\"Math\",{cosh:function(t){return(i(t=+t)+i(-t))/2}})},function(t,e,n){var r=n(8),i=n(112);r(r.S+r.F*(i!=Math.expm1),\"Math\",{expm1:i})},function(t,e){var n=Math.expm1;t.exports=!n||n(10)>22025.465794806718||n(10)<22025.465794806718||n(-2e-17)!=-2e-17?function(t){return 0==(t=+t)?t:t>-1e-6&&t<1e-6?t+t*t/2:Math.exp(t)-1}:n},function(t,e,n){var r=n(8),i=n(108),o=Math.pow,u=o(2,-52),a=o(2,-23),s=o(2,127)*(2-a),c=o(2,-126),f=function(t){return t+1/u-1/u};r(r.S,\"Math\",{fround:function(t){var e,n,r=Math.abs(t),o=i(t);return r<c?o*f(r/c/a)*c*a:(e=(1+a/u)*r,n=e-(e-r),n>s||n!=n?o*(1/0):o*n)}})},function(t,e,n){var r=n(8),i=Math.abs;r(r.S,\"Math\",{hypot:function(t,e){for(var n,r,o=0,u=0,a=arguments.length,s=0;u<a;)n=i(arguments[u++]),s<n?(r=s/n,o=o*r*r+1,s=n):n>0?(r=n/s,o+=r*r):o+=n;return s===1/0?1/0:s*Math.sqrt(o)}})},function(t,e,n){var r=n(8),i=Math.imul;r(r.S+r.F*n(7)(function(){return i(4294967295,5)!=-5||2!=i.length}),\"Math\",{imul:function(t,e){var n=65535,r=+t,i=+e,o=n&r,u=n&i;return 0|o*u+((n&r>>>16)*u+o*(n&i>>>16)<<16>>>0)}})},function(t,e,n){var r=n(8);r(r.S,\"Math\",{log10:function(t){return Math.log(t)/Math.LN10}})},function(t,e,n){var r=n(8);r(r.S,\"Math\",{log1p:n(104)})},function(t,e,n){var r=n(8);r(r.S,\"Math\",{log2:function(t){return Math.log(t)/Math.LN2}})},function(t,e,n){var r=n(8);r(r.S,\"Math\",{sign:n(108)})},function(t,e,n){var r=n(8),i=n(112),o=Math.exp;r(r.S+r.F*n(7)(function(){return!Math.sinh(-2e-17)!=-2e-17}),\"Math\",{sinh:function(t){return Math.abs(t=+t)<1?(i(t)-i(-t))/2:(o(t-1)-o(-t-1))*(Math.E/2)}})},function(t,e,n){var r=n(8),i=n(112),o=Math.exp;r(r.S,\"Math\",{tanh:function(t){var e=i(t=+t),n=i(-t);return e==1/0?1:n==1/0?-1:(e-n)/(o(t)+o(-t))}})},function(t,e,n){var r=n(8);r(r.S,\"Math\",{trunc:function(t){return(t>0?Math.floor:Math.ceil)(t)}})},function(t,e,n){var r=n(8),i=n(39),o=String.fromCharCode,u=String.fromCodePoint;r(r.S+r.F*(!!u&&1!=u.length),\"String\",{fromCodePoint:function(t){for(var e,n=[],r=arguments.length,u=0;r>u;){if(e=+arguments[u++],i(e,1114111)!==e)throw RangeError(e+\" is not a valid code point\");n.push(e<65536?o(e):o(((e-=65536)>>10)+55296,e%1024+56320))}return n.join(\"\")}})},function(t,e,n){var r=n(8),i=n(32),o=n(37);r(r.S,\"String\",{raw:function(t){for(var e=i(t.raw),n=o(e.length),r=arguments.length,u=[],a=0;n>a;)u.push(String(e[a++])),a<r&&u.push(String(arguments[a]));return u.join(\"\")}})},function(t,e,n){\"use strict\";n(83)(\"trim\",function(t){return function(){return t(this,3)}})},function(t,e,n){\"use strict\";var r=n(127)(!0);n(128)(String,\"String\",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){var r=n(38),i=n(35);t.exports=function(t){return function(e,n){var o,u,a=String(i(e)),s=r(n),c=a.length;return s<0||s>=c?t?\"\":void 0:(o=a.charCodeAt(s),o<55296||o>56319||s+1===c||(u=a.charCodeAt(s+1))<56320||u>57343?t?a.charAt(s):o:t?a.slice(s,s+2):(o-55296<<10)+(u-56320)+65536)}}},function(t,e,n){\"use strict\";var r=n(28),i=n(8),o=n(18),u=n(10),a=n(5),s=n(129),c=n(130),f=n(24),l=n(59),h=n(25)(\"iterator\"),d=!([].keys&&\"next\"in[].keys()),p=\"@@iterator\",v=\"keys\",g=\"values\",y=function(){return this};t.exports=function(t,e,n,_,m,b,w){c(n,e,_);var x,E,P,S=function(t){if(!d&&t in $)return $[t];switch(t){case v:return function(){return new n(this,t)};case g:return function(){return new n(this,t)}}return function(){return new n(this,t)}},O=e+\" Iterator\",A=m==g,T=!1,$=t.prototype,C=$[h]||$[p]||m&&$[m],R=C||S(m),j=m?A?S(\"entries\"):R:void 0,D=\"Array\"==e?$.entries||C:C;if(D&&(P=l(D.call(new t)),P!==Object.prototype&&(f(P,O,!0),r||a(P,h)||u(P,h,y))),A&&C&&C.name!==g&&(T=!0,R=function(){return C.call(this)}),r&&!w||!d&&!T&&$[h]||u($,h,R),s[e]=R,s[O]=y,m)if(x={values:A?R:S(g),keys:b?R:S(v),entries:j},w)for(E in x)E in $||o($,E,x[E]);else i(i.P+i.F*(d||T),e,x);return x}},function(t,e){t.exports={}},function(t,e,n){\"use strict\";var r=n(46),i=n(17),o=n(24),u={};n(10)(u,n(25)(\"iterator\"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(u,{next:i(1,n)}),o(t,e+\" Iterator\")}},function(t,e,n){\"use strict\";var r=n(8),i=n(127)(!1);r(r.P,\"String\",{codePointAt:function(t){return i(this,t)}})},function(t,e,n){\"use strict\";var r=n(8),i=n(37),o=n(133),u=\"endsWith\",a=\"\"[u];r(r.P+r.F*n(135)(u),\"String\",{endsWith:function(t){var e=o(this,t,u),n=arguments.length>1?arguments[1]:void 0,r=i(e.length),s=void 0===n?r:Math.min(i(n),r),c=String(t);return a?a.call(e,c,s):e.slice(s-c.length,s)===c}})},function(t,e,n){var r=n(134),i=n(35);t.exports=function(t,e,n){if(r(e))throw TypeError(\"String#\"+n+\" doesn't accept regex!\");return String(i(t))}},function(t,e,n){var r=n(13),i=n(34),o=n(25)(\"match\");t.exports=function(t){var e;return r(t)&&(void 0!==(e=t[o])?!!e:\"RegExp\"==i(t))}},function(t,e,n){var r=n(25)(\"match\");t.exports=function(t){var e=/./;try{\"/./\"[t](e)}catch(n){try{return e[r]=!1,!\"/./\"[t](e)}catch(t){}}return!0}},function(t,e,n){\"use strict\";var r=n(8),i=n(133),o=\"includes\";r(r.P+r.F*n(135)(o),\"String\",{includes:function(t){return!!~i(this,t,o).indexOf(t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){var r=n(8);r(r.P,\"String\",{repeat:n(91)})},function(t,e,n){\"use strict\";var r=n(8),i=n(37),o=n(133),u=\"startsWith\",a=\"\"[u];r(r.P+r.F*n(135)(u),\"String\",{startsWith:function(t){var e=o(this,t,u),n=i(Math.min(arguments.length>1?arguments[1]:void 0,e.length)),r=String(t);return a?a.call(e,r,n):e.slice(n,n+r.length)===r}})},function(t,e,n){\"use strict\";n(140)(\"anchor\",function(t){return function(e){return t(this,\"a\",\"name\",e)}})},function(t,e,n){var r=n(8),i=n(7),o=n(35),u=/\"/g,a=function(t,e,n,r){var i=String(o(t)),a=\"<\"+e;return\"\"!==n&&(a+=\" \"+n+'=\"'+String(r).replace(u,\"&quot;\")+'\"'),a+\">\"+i+\"</\"+e+\">\"};t.exports=function(t,e){var n={};n[t]=e(a),r(r.P+r.F*i(function(){var e=\"\"[t]('\"');return e!==e.toLowerCase()||e.split('\"').length>3}),\"String\",n)}},function(t,e,n){\"use strict\";n(140)(\"big\",function(t){return function(){return t(this,\"big\",\"\",\"\")}})},function(t,e,n){\"use strict\";n(140)(\"blink\",function(t){return function(){return t(this,\"blink\",\"\",\"\")}})},function(t,e,n){\"use strict\";n(140)(\"bold\",function(t){return function(){return t(this,\"b\",\"\",\"\")}})},function(t,e,n){\"use strict\";n(140)(\"fixed\",function(t){return function(){return t(this,\"tt\",\"\",\"\")}})},function(t,e,n){\"use strict\";n(140)(\"fontcolor\",function(t){return function(e){return t(this,\"font\",\"color\",e)}})},function(t,e,n){\"use strict\";n(140)(\"fontsize\",function(t){return function(e){return t(this,\"font\",\"size\",e)}})},function(t,e,n){\"use strict\";n(140)(\"italics\",function(t){return function(){return t(this,\"i\",\"\",\"\")}})},function(t,e,n){\"use strict\";n(140)(\"link\",function(t){return function(e){return t(this,\"a\",\"href\",e)}})},function(t,e,n){\"use strict\";n(140)(\"small\",function(t){return function(){return t(this,\"small\",\"\",\"\")}})},function(t,e,n){\"use strict\";n(140)(\"strike\",function(t){return function(){return t(this,\"strike\",\"\",\"\")}})},function(t,e,n){\"use strict\";n(140)(\"sub\",function(t){return function(){return t(this,\"sub\",\"\",\"\")}})},function(t,e,n){\"use strict\";n(140)(\"sup\",function(t){return function(){return t(this,\"sup\",\"\",\"\")}})},function(t,e,n){var r=n(8);r(r.S,\"Date\",{now:function(){return(new Date).getTime()}})},function(t,e,n){\"use strict\";var r=n(8),i=n(58),o=n(16);r(r.P+r.F*n(7)(function(){return null!==new Date(NaN).toJSON()||1!==Date.prototype.toJSON.call({toISOString:function(){return 1}})}),\"Date\",{toJSON:function(t){var e=i(this),n=o(e);return\"number\"!=typeof n||isFinite(n)?e.toISOString():null}})},function(t,e,n){\"use strict\";var r=n(8),i=n(7),o=Date.prototype.getTime,u=function(t){return t>9?t:\"0\"+t};r(r.P+r.F*(i(function(){return\"0385-07-25T07:06:39.999Z\"!=new Date(-5e13-1).toISOString()})||!i(function(){new Date(NaN).toISOString()})),\"Date\",{toISOString:function(){if(!isFinite(o.call(this)))throw RangeError(\"Invalid time value\");var t=this,e=t.getUTCFullYear(),n=t.getUTCMilliseconds(),r=e<0?\"-\":e>9999?\"+\":\"\";return r+(\"00000\"+Math.abs(e)).slice(r?-6:-4)+\"-\"+u(t.getUTCMonth()+1)+\"-\"+u(t.getUTCDate())+\"T\"+u(t.getUTCHours())+\":\"+u(t.getUTCMinutes())+\":\"+u(t.getUTCSeconds())+\".\"+(n>99?n:\"0\"+u(n))+\"Z\"}})},function(t,e,n){var r=Date.prototype,i=\"Invalid Date\",o=\"toString\",u=r[o],a=r.getTime;new Date(NaN)+\"\"!=i&&n(18)(r,o,function(){var t=a.call(this);return t===t?u.call(this):i})},function(t,e,n){var r=n(25)(\"toPrimitive\"),i=Date.prototype;r in i||n(10)(i,r,n(158))},function(t,e,n){\"use strict\";var r=n(12),i=n(16),o=\"number\";t.exports=function(t){if(\"string\"!==t&&t!==o&&\"default\"!==t)throw TypeError(\"Incorrect hint\");return i(r(this),t!=o)}},function(t,e,n){var r=n(8);r(r.S,\"Array\",{isArray:n(45)})},function(t,e,n){\"use strict\";var r=n(20),i=n(8),o=n(58),u=n(161),a=n(162),s=n(37),c=n(163),f=n(164);i(i.S+i.F*!n(165)(function(t){Array.from(t)}),\"Array\",{from:function(t){var e,n,i,l,h=o(t),d=\"function\"==typeof this?this:Array,p=arguments.length,v=p>1?arguments[1]:void 0,g=void 0!==v,y=0,_=f(h);if(g&&(v=r(v,p>2?arguments[2]:void 0,2)),void 0==_||d==Array&&a(_))for(e=s(h.length),n=new d(e);e>y;y++)c(n,y,g?v(h[y],y):h[y]);else for(l=_.call(h),n=new d;!(i=l.next()).done;y++)c(n,y,g?u(l,v,[i.value,y],!0):i.value);return n.length=y,n}})},function(t,e,n){var r=n(12);t.exports=function(t,e,n,i){try{return i?e(r(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&r(o.call(t)),e}}},function(t,e,n){var r=n(129),i=n(25)(\"iterator\"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||o[i]===t)}},function(t,e,n){\"use strict\";var r=n(11),i=n(17);t.exports=function(t,e,n){e in t?r.f(t,e,i(0,n)):t[e]=n}},function(t,e,n){var r=n(75),i=n(25)(\"iterator\"),o=n(129);t.exports=n(9).getIteratorMethod=function(t){if(void 0!=t)return t[i]||t[\"@@iterator\"]||o[r(t)]}},function(t,e,n){var r=n(25)(\"iterator\"),i=!1;try{var o=[7][r]();o.return=function(){i=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!i)return!1;var n=!1;try{var o=[7],u=o[r]();u.next=function(){return{done:n=!0}},o[r]=function(){return u},t(o)}catch(t){}return n}},function(t,e,n){\"use strict\";var r=n(8),i=n(163);r(r.S+r.F*n(7)(function(){function t(){}return!(Array.of.call(t)instanceof t)}),\"Array\",{of:function(){for(var t=0,e=arguments.length,n=new(\"function\"==typeof this?this:Array)(e);e>t;)i(n,t,arguments[t++]);return n.length=e,n}})},function(t,e,n){\"use strict\";var r=n(8),i=n(32),o=[].join;r(r.P+r.F*(n(33)!=Object||!n(168)(o)),\"Array\",{join:function(t){return o.call(i(this),void 0===t?\",\":t)}})},function(t,e,n){var r=n(7);t.exports=function(t,e){return!!t&&r(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){\"use strict\";var r=n(8),i=n(48),o=n(34),u=n(39),a=n(37),s=[].slice;r(r.P+r.F*n(7)(function(){i&&s.call(i)}),\"Array\",{slice:function(t,e){var n=a(this.length),r=o(this);if(e=void 0===e?n:e,\"Array\"==r)return s.call(this,t,e);for(var i=u(t,n),c=u(e,n),f=a(c-i),l=Array(f),h=0;h<f;h++)l[h]=\"String\"==r?this.charAt(i+h):this[i+h];return l}})},function(t,e,n){\"use strict\";var r=n(8),i=n(21),o=n(58),u=n(7),a=[].sort,s=[1,2,3];r(r.P+r.F*(u(function(){s.sort(void 0)})||!u(function(){s.sort(null)})||!n(168)(a)),\"Array\",{sort:function(t){return void 0===t?a.call(o(this)):a.call(o(this),i(t))}})},function(t,e,n){\"use strict\";var r=n(8),i=n(172)(0),o=n(168)([].forEach,!0);r(r.P+r.F*!o,\"Array\",{forEach:function(t){return i(this,t,arguments[1])}})},function(t,e,n){var r=n(20),i=n(33),o=n(58),u=n(37),a=n(173);t.exports=function(t,e){var n=1==t,s=2==t,c=3==t,f=4==t,l=6==t,h=5==t||l,d=e||a;return function(e,a,p){for(var v,g,y=o(e),_=i(y),m=r(a,p,3),b=u(_.length),w=0,x=n?d(e,b):s?d(e,0):void 0;b>w;w++)if((h||w in _)&&(v=_[w],\ng=m(v,w,y),t))if(n)x[w]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return w;case 2:x.push(v)}else if(f)return!1;return l?-1:c||f?f:x}}},function(t,e,n){var r=n(174);t.exports=function(t,e){return new(r(t))(e)}},function(t,e,n){var r=n(13),i=n(45),o=n(25)(\"species\");t.exports=function(t){var e;return i(t)&&(e=t.constructor,\"function\"!=typeof e||e!==Array&&!i(e.prototype)||(e=void 0),r(e)&&(e=e[o],null===e&&(e=void 0))),void 0===e?Array:e}},function(t,e,n){\"use strict\";var r=n(8),i=n(172)(1);r(r.P+r.F*!n(168)([].map,!0),\"Array\",{map:function(t){return i(this,t,arguments[1])}})},function(t,e,n){\"use strict\";var r=n(8),i=n(172)(2);r(r.P+r.F*!n(168)([].filter,!0),\"Array\",{filter:function(t){return i(this,t,arguments[1])}})},function(t,e,n){\"use strict\";var r=n(8),i=n(172)(3);r(r.P+r.F*!n(168)([].some,!0),\"Array\",{some:function(t){return i(this,t,arguments[1])}})},function(t,e,n){\"use strict\";var r=n(8),i=n(172)(4);r(r.P+r.F*!n(168)([].every,!0),\"Array\",{every:function(t){return i(this,t,arguments[1])}})},function(t,e,n){\"use strict\";var r=n(8),i=n(180);r(r.P+r.F*!n(168)([].reduce,!0),\"Array\",{reduce:function(t){return i(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var r=n(21),i=n(58),o=n(33),u=n(37);t.exports=function(t,e,n,a,s){r(e);var c=i(t),f=o(c),l=u(c.length),h=s?l-1:0,d=s?-1:1;if(n<2)for(;;){if(h in f){a=f[h],h+=d;break}if(h+=d,s?h<0:l<=h)throw TypeError(\"Reduce of empty array with no initial value\")}for(;s?h>=0:l>h;h+=d)h in f&&(a=e(a,f[h],h,c));return a}},function(t,e,n){\"use strict\";var r=n(8),i=n(180);r(r.P+r.F*!n(168)([].reduceRight,!0),\"Array\",{reduceRight:function(t){return i(this,t,arguments.length,arguments[1],!0)}})},function(t,e,n){\"use strict\";var r=n(8),i=n(36)(!1),o=[].indexOf,u=!!o&&1/[1].indexOf(1,-0)<0;r(r.P+r.F*(u||!n(168)(o)),\"Array\",{indexOf:function(t){return u?o.apply(this,arguments)||0:i(this,t,arguments[1])}})},function(t,e,n){\"use strict\";var r=n(8),i=n(32),o=n(38),u=n(37),a=[].lastIndexOf,s=!!a&&1/[1].lastIndexOf(1,-0)<0;r(r.P+r.F*(s||!n(168)(a)),\"Array\",{lastIndexOf:function(t){if(s)return a.apply(this,arguments)||0;var e=i(this),n=u(e.length),r=n-1;for(arguments.length>1&&(r=Math.min(r,o(arguments[1]))),r<0&&(r=n+r);r>=0;r--)if(r in e&&e[r]===t)return r||0;return-1}})},function(t,e,n){var r=n(8);r(r.P,\"Array\",{copyWithin:n(185)}),n(186)(\"copyWithin\")},function(t,e,n){\"use strict\";var r=n(58),i=n(39),o=n(37);t.exports=[].copyWithin||function(t,e){var n=r(this),u=o(n.length),a=i(t,u),s=i(e,u),c=arguments.length>2?arguments[2]:void 0,f=Math.min((void 0===c?u:i(c,u))-s,u-a),l=1;for(s<a&&a<s+f&&(l=-1,s+=f-1,a+=f-1);f-- >0;)s in n?n[a]=n[s]:delete n[a],a+=l,s+=l;return n}},function(t,e,n){var r=n(25)(\"unscopables\"),i=Array.prototype;void 0==i[r]&&n(10)(i,r,{}),t.exports=function(t){i[r][t]=!0}},function(t,e,n){var r=n(8);r(r.P,\"Array\",{fill:n(188)}),n(186)(\"fill\")},function(t,e,n){\"use strict\";var r=n(58),i=n(39),o=n(37);t.exports=function(t){for(var e=r(this),n=o(e.length),u=arguments.length,a=i(u>1?arguments[1]:void 0,n),s=u>2?arguments[2]:void 0,c=void 0===s?n:i(s,n);c>a;)e[a++]=t;return e}},function(t,e,n){\"use strict\";var r=n(8),i=n(172)(5),o=\"find\",u=!0;o in[]&&Array(1)[o](function(){u=!1}),r(r.P+r.F*u,\"Array\",{find:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),n(186)(o)},function(t,e,n){\"use strict\";var r=n(8),i=n(172)(6),o=\"findIndex\",u=!0;o in[]&&Array(1)[o](function(){u=!1}),r(r.P+r.F*u,\"Array\",{findIndex:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),n(186)(o)},function(t,e,n){n(192)(\"Array\")},function(t,e,n){\"use strict\";var r=n(4),i=n(11),o=n(6),u=n(25)(\"species\");t.exports=function(t){var e=r[t];o&&e&&!e[u]&&i.f(e,u,{configurable:!0,get:function(){return this}})}},function(t,e,n){\"use strict\";var r=n(186),i=n(194),o=n(129),u=n(32);t.exports=n(128)(Array,\"Array\",function(t,e){this._t=u(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,i(1)):\"keys\"==e?i(0,n):\"values\"==e?i(0,t[n]):i(0,[n,t[n]])},\"values\"),o.Arguments=o.Array,r(\"keys\"),r(\"values\"),r(\"entries\")},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var r=n(4),i=n(88),o=n(11).f,u=n(50).f,a=n(134),s=n(196),c=r.RegExp,f=c,l=c.prototype,h=/a/g,d=/a/g,p=new c(h)!==h;if(n(6)&&(!p||n(7)(function(){return d[n(25)(\"match\")]=!1,c(h)!=h||c(d)==d||\"/a/i\"!=c(h,\"i\")}))){c=function(t,e){var n=this instanceof c,r=a(t),o=void 0===e;return!n&&r&&t.constructor===c&&o?t:i(p?new f(r&&!o?t.source:t,e):f((r=t instanceof c)?t.source:t,r&&o?s.call(t):e),n?this:l,c)};for(var v=(function(t){t in c||o(c,t,{configurable:!0,get:function(){return f[t]},set:function(e){f[t]=e}})}),g=u(f),y=0;g.length>y;)v(g[y++]);l.constructor=c,c.prototype=l,n(18)(r,\"RegExp\",c)}n(192)(\"RegExp\")},function(t,e,n){\"use strict\";var r=n(12);t.exports=function(){var t=r(this),e=\"\";return t.global&&(e+=\"g\"),t.ignoreCase&&(e+=\"i\"),t.multiline&&(e+=\"m\"),t.unicode&&(e+=\"u\"),t.sticky&&(e+=\"y\"),e}},function(t,e,n){\"use strict\";n(198);var r=n(12),i=n(196),o=n(6),u=\"toString\",a=/./[u],s=function(t){n(18)(RegExp.prototype,u,t,!0)};n(7)(function(){return\"/a/b\"!=a.call({source:\"a\",flags:\"b\"})})?s(function(){var t=r(this);return\"/\".concat(t.source,\"/\",\"flags\"in t?t.flags:!o&&t instanceof RegExp?i.call(t):void 0)}):a.name!=u&&s(function(){return a.call(this)})},function(t,e,n){n(6)&&\"g\"!=/./g.flags&&n(11).f(RegExp.prototype,\"flags\",{configurable:!0,get:n(196)})},function(t,e,n){n(200)(\"match\",1,function(t,e,n){return[function(n){\"use strict\";var r=t(this),i=void 0==n?void 0:n[e];return void 0!==i?i.call(n,r):new RegExp(n)[e](String(r))},n]})},function(t,e,n){\"use strict\";var r=n(10),i=n(18),o=n(7),u=n(35),a=n(25);t.exports=function(t,e,n){var s=a(t),c=n(u,s,\"\"[t]),f=c[0],l=c[1];o(function(){var e={};return e[s]=function(){return 7},7!=\"\"[t](e)})&&(i(String.prototype,t,f),r(RegExp.prototype,s,2==e?function(t,e){return l.call(t,this,e)}:function(t){return l.call(t,this)}))}},function(t,e,n){n(200)(\"replace\",2,function(t,e,n){return[function(r,i){\"use strict\";var o=t(this),u=void 0==r?void 0:r[e];return void 0!==u?u.call(r,o,i):n.call(String(o),r,i)},n]})},function(t,e,n){n(200)(\"search\",1,function(t,e,n){return[function(n){\"use strict\";var r=t(this),i=void 0==n?void 0:n[e];return void 0!==i?i.call(n,r):new RegExp(n)[e](String(r))},n]})},function(t,e,n){n(200)(\"split\",2,function(t,e,r){\"use strict\";var i=n(134),o=r,u=[].push,a=\"split\",s=\"length\",c=\"lastIndex\";if(\"c\"==\"abbc\"[a](/(b)*/)[1]||4!=\"test\"[a](/(?:)/,-1)[s]||2!=\"ab\"[a](/(?:ab)*/)[s]||4!=\".\"[a](/(.?)(.?)/)[s]||\".\"[a](/()()/)[s]>1||\"\"[a](/.?/)[s]){var f=void 0===/()??/.exec(\"\")[1];r=function(t,e){var n=String(this);if(void 0===t&&0===e)return[];if(!i(t))return o.call(n,t,e);var r,a,l,h,d,p=[],v=(t.ignoreCase?\"i\":\"\")+(t.multiline?\"m\":\"\")+(t.unicode?\"u\":\"\")+(t.sticky?\"y\":\"\"),g=0,y=void 0===e?4294967295:e>>>0,_=new RegExp(t.source,v+\"g\");for(f||(r=new RegExp(\"^\"+_.source+\"$(?!\\\\s)\",v));(a=_.exec(n))&&(l=a.index+a[0][s],!(l>g&&(p.push(n.slice(g,a.index)),!f&&a[s]>1&&a[0].replace(r,function(){for(d=1;d<arguments[s]-2;d++)void 0===arguments[d]&&(a[d]=void 0)}),a[s]>1&&a.index<n[s]&&u.apply(p,a.slice(1)),h=a[0][s],g=l,p[s]>=y)));)_[c]===a.index&&_[c]++;return g===n[s]?!h&&_.test(\"\")||p.push(\"\"):p.push(n.slice(g)),p[s]>y?p.slice(0,y):p}}else\"0\"[a](void 0,0)[s]&&(r=function(t,e){return void 0===t&&0===e?[]:o.call(this,t,e)});return[function(n,i){var o=t(this),u=void 0==n?void 0:n[e];return void 0!==u?u.call(n,o,i):r.call(String(o),n,i)},r]})},function(t,e,n){\"use strict\";var r,i,o,u=n(28),a=n(4),s=n(20),c=n(75),f=n(8),l=n(13),h=n(21),d=n(205),p=n(206),v=n(207),g=n(208).set,y=n(209)(),_=\"Promise\",m=a.TypeError,b=a.process,w=a[_],b=a.process,x=\"process\"==c(b),E=function(){},P=!!function(){try{var t=w.resolve(1),e=(t.constructor={})[n(25)(\"species\")]=function(t){t(E,E)};return(x||\"function\"==typeof PromiseRejectionEvent)&&t.then(E)instanceof e}catch(t){}}(),S=function(t,e){return t===e||t===w&&e===o},O=function(t){var e;return!(!l(t)||\"function\"!=typeof(e=t.then))&&e},A=function(t){return S(w,t)?new T(t):new i(t)},T=i=function(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw m(\"Bad Promise constructor\");e=t,n=r}),this.resolve=h(e),this.reject=h(n)},$=function(t){try{t()}catch(t){return{error:t}}},C=function(t,e){if(!t._n){t._n=!0;var n=t._c;y(function(){for(var r=t._v,i=1==t._s,o=0,u=function(e){var n,o,u=i?e.ok:e.fail,a=e.resolve,s=e.reject,c=e.domain;try{u?(i||(2==t._h&&D(t),t._h=1),u===!0?n=r:(c&&c.enter(),n=u(r),c&&c.exit()),n===e.promise?s(m(\"Promise-chain cycle\")):(o=O(n))?o.call(n,a,s):a(n)):s(r)}catch(t){s(t)}};n.length>o;)u(n[o++]);t._c=[],t._n=!1,e&&!t._h&&R(t)})}},R=function(t){g.call(a,function(){var e,n,r,i=t._v;if(j(t)&&(e=$(function(){x?b.emit(\"unhandledRejection\",i,t):(n=a.onunhandledrejection)?n({promise:t,reason:i}):(r=a.console)&&r.error&&r.error(\"Unhandled promise rejection\",i)}),t._h=x||j(t)?2:1),t._a=void 0,e)throw e.error})},j=function(t){if(1==t._h)return!1;for(var e,n=t._a||t._c,r=0;n.length>r;)if(e=n[r++],e.fail||!j(e.promise))return!1;return!0},D=function(t){g.call(a,function(){var e;x?b.emit(\"rejectionHandled\",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},k=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),C(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw m(\"Promise can't be resolved itself\");(e=O(t))?y(function(){var r={_w:n,_d:!1};try{e.call(t,s(M,r,1),s(k,r,1))}catch(t){k.call(r,t)}}):(n._v=t,n._s=1,C(n,!1))}catch(t){k.call({_w:n,_d:!1},t)}}};P||(w=function(t){d(this,w,_,\"_h\"),h(t),r.call(this);try{t(s(M,this,1),s(k,this,1))}catch(t){k.call(this,t)}},r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},r.prototype=n(210)(w.prototype,{then:function(t,e){var n=A(v(this,w));return n.ok=\"function\"!=typeof t||t,n.fail=\"function\"==typeof e&&e,n.domain=x?b.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&C(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),T=function(){var t=new r;this.promise=t,this.resolve=s(M,t,1),this.reject=s(k,t,1)}),f(f.G+f.W+f.F*!P,{Promise:w}),n(24)(w,_),n(192)(_),o=n(9)[_],f(f.S+f.F*!P,_,{reject:function(t){var e=A(this),n=e.reject;return n(t),e.promise}}),f(f.S+f.F*(u||!P),_,{resolve:function(t){if(t instanceof w&&S(t.constructor,this))return t;var e=A(this),n=e.resolve;return n(t),e.promise}}),f(f.S+f.F*!(P&&n(165)(function(t){w.all(t).catch(E)})),_,{all:function(t){var e=this,n=A(e),r=n.resolve,i=n.reject,o=$(function(){var n=[],o=0,u=1;p(t,!1,function(t){var a=o++,s=!1;n.push(void 0),u++,e.resolve(t).then(function(t){s||(s=!0,n[a]=t,--u||r(n))},i)}),--u||r(n)});return o&&i(o.error),n.promise},race:function(t){var e=this,n=A(e),r=n.reject,i=$(function(){p(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return i&&r(i.error),n.promise}})},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+\": incorrect invocation!\");return t}},function(t,e,n){var r=n(20),i=n(161),o=n(162),u=n(12),a=n(37),s=n(164),c={},f={},e=t.exports=function(t,e,n,l,h){var d,p,v,g,y=h?function(){return t}:s(t),_=r(n,l,e?2:1),m=0;if(\"function\"!=typeof y)throw TypeError(t+\" is not iterable!\");if(o(y)){for(d=a(t.length);d>m;m++)if(g=e?_(u(p=t[m])[0],p[1]):_(t[m]),g===c||g===f)return g}else for(v=y.call(t);!(p=v.next()).done;)if(g=i(v,_,p.value,e),g===c||g===f)return g};e.BREAK=c,e.RETURN=f},function(t,e,n){var r=n(12),i=n(21),o=n(25)(\"species\");t.exports=function(t,e){var n,u=r(t).constructor;return void 0===u||void 0==(n=r(u)[o])?e:i(n)}},function(t,e,n){var r,i,o,u=n(20),a=n(78),s=n(48),c=n(15),f=n(4),l=f.process,h=f.setImmediate,d=f.clearImmediate,p=f.MessageChannel,v=0,g={},y=\"onreadystatechange\",_=function(){var t=+this;if(g.hasOwnProperty(t)){var e=g[t];delete g[t],e()}},m=function(t){_.call(t.data)};h&&d||(h=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return g[++v]=function(){a(\"function\"==typeof t?t:Function(t),e)},r(v),v},d=function(t){delete g[t]},\"process\"==n(34)(l)?r=function(t){l.nextTick(u(_,t,1))}:p?(i=new p,o=i.port2,i.port1.onmessage=m,r=u(o.postMessage,o,1)):f.addEventListener&&\"function\"==typeof postMessage&&!f.importScripts?(r=function(t){f.postMessage(t+\"\",\"*\")},f.addEventListener(\"message\",m,!1)):r=y in c(\"script\")?function(t){s.appendChild(c(\"script\"))[y]=function(){s.removeChild(this),_.call(t)}}:function(t){setTimeout(u(_,t,1),0)}),t.exports={set:h,clear:d}},function(t,e,n){var r=n(4),i=n(208).set,o=r.MutationObserver||r.WebKitMutationObserver,u=r.process,a=r.Promise,s=\"process\"==n(34)(u);t.exports=function(){var t,e,n,c=function(){var r,i;for(s&&(r=u.domain)&&r.exit();t;){i=t.fn,t=t.next;try{i()}catch(r){throw t?n():e=void 0,r}}e=void 0,r&&r.enter()};if(s)n=function(){u.nextTick(c)};else if(o){var f=!0,l=document.createTextNode(\"\");new o(c).observe(l,{characterData:!0}),n=function(){l.data=f=!f}}else if(a&&a.resolve){var h=a.resolve();n=function(){h.then(c)}}else n=function(){i.call(r,c)};return function(r){var i={fn:r,next:void 0};e&&(e.next=i),t||(t=i,n()),e=i}}},function(t,e,n){var r=n(18);t.exports=function(t,e,n){for(var i in e)r(t,i,e[i],n);return t}},function(t,e,n){\"use strict\";var r=n(212);t.exports=n(213)(\"Map\",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{get:function(t){var e=r.getEntry(this,t);return e&&e.v},set:function(t,e){return r.def(this,0===t?0:t,e)}},r,!0)},function(t,e,n){\"use strict\";var r=n(11).f,i=n(46),o=n(210),u=n(20),a=n(205),s=n(35),c=n(206),f=n(128),l=n(194),h=n(192),d=n(6),p=n(22).fastKey,v=d?\"_s\":\"size\",g=function(t,e){var n,r=p(e);if(\"F\"!==r)return t._i[r];for(n=t._f;n;n=n.n)if(n.k==e)return n};t.exports={getConstructor:function(t,e,n,f){var l=t(function(t,r){a(t,l,e,\"_i\"),t._i=i(null),t._f=void 0,t._l=void 0,t[v]=0,void 0!=r&&c(r,n,t[f],t)});return o(l.prototype,{clear:function(){for(var t=this,e=t._i,n=t._f;n;n=n.n)n.r=!0,n.p&&(n.p=n.p.n=void 0),delete e[n.i];t._f=t._l=void 0,t[v]=0},delete:function(t){var e=this,n=g(e,t);if(n){var r=n.n,i=n.p;delete e._i[n.i],n.r=!0,i&&(i.n=r),r&&(r.p=i),e._f==n&&(e._f=r),e._l==n&&(e._l=i),e[v]--}return!!n},forEach:function(t){a(this,l,\"forEach\");for(var e,n=u(t,arguments.length>1?arguments[1]:void 0,3);e=e?e.n:this._f;)for(n(e.v,e.k,this);e&&e.r;)e=e.p},has:function(t){return!!g(this,t)}}),d&&r(l.prototype,\"size\",{get:function(){return s(this[v])}}),l},def:function(t,e,n){var r,i,o=g(t,e);return o?o.v=n:(t._l=o={i:i=p(e,!0),k:e,v:n,p:r=t._l,n:void 0,r:!1},t._f||(t._f=o),r&&(r.n=o),t[v]++,\"F\"!==i&&(t._i[i]=o)),t},getEntry:g,setStrong:function(t,e,n){f(t,e,function(t,e){this._t=t,this._k=e,this._l=void 0},function(){for(var t=this,e=t._k,n=t._l;n&&n.r;)n=n.p;return t._t&&(t._l=n=n?n.n:t._t._f)?\"keys\"==e?l(0,n.k):\"values\"==e?l(0,n.v):l(0,[n.k,n.v]):(t._t=void 0,l(1))},n?\"entries\":\"values\",!n,!0),h(e)}}},function(t,e,n){\"use strict\";var r=n(4),i=n(8),o=n(18),u=n(210),a=n(22),s=n(206),c=n(205),f=n(13),l=n(7),h=n(165),d=n(24),p=n(88);t.exports=function(t,e,n,v,g,y){var _=r[t],m=_,b=g?\"set\":\"add\",w=m&&m.prototype,x={},E=function(t){var e=w[t];o(w,t,\"delete\"==t?function(t){return!(y&&!f(t))&&e.call(this,0===t?0:t)}:\"has\"==t?function(t){return!(y&&!f(t))&&e.call(this,0===t?0:t)}:\"get\"==t?function(t){return y&&!f(t)?void 0:e.call(this,0===t?0:t)}:\"add\"==t?function(t){return e.call(this,0===t?0:t),this}:function(t,n){return e.call(this,0===t?0:t,n),this})};if(\"function\"==typeof m&&(y||w.forEach&&!l(function(){(new m).entries().next()}))){var P=new m,S=P[b](y?{}:-0,1)!=P,O=l(function(){P.has(1)}),A=h(function(t){new m(t)}),T=!y&&l(function(){for(var t=new m,e=5;e--;)t[b](e,e);return!t.has(-0)});A||(m=e(function(e,n){c(e,m,t);var r=p(new _,e,m);return void 0!=n&&s(n,g,r[b],r),r}),m.prototype=w,w.constructor=m),(O||T)&&(E(\"delete\"),E(\"has\"),g&&E(\"get\")),(T||S)&&E(b),y&&w.clear&&delete w.clear}else m=v.getConstructor(e,t,g,b),u(m.prototype,n),a.NEED=!0;return d(m,t),x[t]=m,i(i.G+i.W+i.F*(m!=_),x),y||v.setStrong(m,t,g),m}},function(t,e,n){\"use strict\";var r=n(212);t.exports=n(213)(\"Set\",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return r.def(this,t=0===t?0:t,t)}},r)},function(t,e,n){\"use strict\";var r,i=n(172)(0),o=n(18),u=n(22),a=n(69),s=n(216),c=n(13),f=u.getWeak,l=Object.isExtensible,h=s.ufstore,d={},p=function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},v={get:function(t){if(c(t)){var e=f(t);return e===!0?h(this).get(t):e?e[this._i]:void 0}},set:function(t,e){return s.def(this,t,e)}},g=t.exports=n(213)(\"WeakMap\",p,v,s,!0,!0);7!=(new g).set((Object.freeze||Object)(d),7).get(d)&&(r=s.getConstructor(p),a(r.prototype,v),u.NEED=!0,i([\"delete\",\"has\",\"get\",\"set\"],function(t){var e=g.prototype,n=e[t];o(e,t,function(e,i){if(c(e)&&!l(e)){this._f||(this._f=new r);var o=this._f[t](e,i);return\"set\"==t?this:o}return n.call(this,e,i)})}))},function(t,e,n){\"use strict\";var r=n(210),i=n(22).getWeak,o=n(12),u=n(13),a=n(205),s=n(206),c=n(172),f=n(5),l=c(5),h=c(6),d=0,p=function(t){return t._l||(t._l=new v)},v=function(){this.a=[]},g=function(t,e){return l(t.a,function(t){return t[0]===e})};v.prototype={get:function(t){var e=g(this,t);if(e)return e[1]},has:function(t){return!!g(this,t)},set:function(t,e){var n=g(this,t);n?n[1]=e:this.a.push([t,e])},delete:function(t){var e=h(this.a,function(e){return e[0]===t});return~e&&this.a.splice(e,1),!!~e}},t.exports={getConstructor:function(t,e,n,o){var c=t(function(t,r){a(t,c,e,\"_i\"),t._i=d++,t._l=void 0,void 0!=r&&s(r,n,t[o],t)});return r(c.prototype,{delete:function(t){if(!u(t))return!1;var e=i(t);return e===!0?p(this).delete(t):e&&f(e,this._i)&&delete e[this._i]},has:function(t){if(!u(t))return!1;var e=i(t);return e===!0?p(this).has(t):e&&f(e,this._i)}}),c},def:function(t,e,n){var r=i(o(e),!0);return r===!0?p(t).set(e,n):r[t._i]=n,t},ufstore:p}},function(t,e,n){\"use strict\";var r=n(216);n(213)(\"WeakSet\",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return r.def(this,t,!0)}},r,!1,!0)},function(t,e,n){\"use strict\";var r=n(8),i=n(219),o=n(220),u=n(12),a=n(39),s=n(37),c=n(13),f=n(4).ArrayBuffer,l=n(207),h=o.ArrayBuffer,d=o.DataView,p=i.ABV&&f.isView,v=h.prototype.slice,g=i.VIEW,y=\"ArrayBuffer\";r(r.G+r.W+r.F*(f!==h),{ArrayBuffer:h}),r(r.S+r.F*!i.CONSTR,y,{isView:function(t){return p&&p(t)||c(t)&&g in t}}),r(r.P+r.U+r.F*n(7)(function(){return!new h(2).slice(1,void 0).byteLength}),y,{slice:function(t,e){if(void 0!==v&&void 0===e)return v.call(u(this),t);for(var n=u(this).byteLength,r=a(t,n),i=a(void 0===e?n:e,n),o=new(l(this,h))(s(i-r)),c=new d(this),f=new d(o),p=0;r<i;)f.setUint8(p++,c.getUint8(r++));return o}}),n(192)(y)},function(t,e,n){for(var r,i=n(4),o=n(10),u=n(19),a=u(\"typed_array\"),s=u(\"view\"),c=!(!i.ArrayBuffer||!i.DataView),f=c,l=0,h=9,d=\"Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array\".split(\",\");l<h;)(r=i[d[l++]])?(o(r.prototype,a,!0),o(r.prototype,s,!0)):f=!1;t.exports={ABV:c,CONSTR:f,TYPED:a,VIEW:s}},function(t,e,n){\"use strict\";var r=n(4),i=n(6),o=n(28),u=n(219),a=n(10),s=n(210),c=n(7),f=n(205),l=n(38),h=n(37),d=n(50).f,p=n(11).f,v=n(188),g=n(24),y=\"ArrayBuffer\",_=\"DataView\",m=\"prototype\",b=\"Wrong length!\",w=\"Wrong index!\",x=r[y],E=r[_],P=r.Math,S=r.RangeError,O=r.Infinity,A=x,T=P.abs,$=P.pow,C=P.floor,R=P.log,j=P.LN2,D=\"buffer\",k=\"byteLength\",M=\"byteOffset\",F=i?\"_b\":D,I=i?\"_l\":k,L=i?\"_o\":M,N=function(t,e,n){var r,i,o,u=Array(n),a=8*n-e-1,s=(1<<a)-1,c=s>>1,f=23===e?$(2,-24)-$(2,-77):0,l=0,h=t<0||0===t&&1/t<0?1:0;for(t=T(t),t!=t||t===O?(i=t!=t?1:0,r=s):(r=C(R(t)/j),t*(o=$(2,-r))<1&&(r--,o*=2),t+=r+c>=1?f/o:f*$(2,1-c),t*o>=2&&(r++,o/=2),r+c>=s?(i=0,r=s):r+c>=1?(i=(t*o-1)*$(2,e),r+=c):(i=t*$(2,c-1)*$(2,e),r=0));e>=8;u[l++]=255&i,i/=256,e-=8);for(r=r<<e|i,a+=e;a>0;u[l++]=255&r,r/=256,a-=8);return u[--l]|=128*h,u},G=function(t,e,n){var r,i=8*n-e-1,o=(1<<i)-1,u=o>>1,a=i-7,s=n-1,c=t[s--],f=127&c;for(c>>=7;a>0;f=256*f+t[s],s--,a-=8);for(r=f&(1<<-a)-1,f>>=-a,a+=e;a>0;r=256*r+t[s],s--,a-=8);if(0===f)f=1-u;else{if(f===o)return r?NaN:c?-O:O;r+=$(2,e),f-=u}return(c?-1:1)*r*$(2,f-e)},U=function(t){return t[3]<<24|t[2]<<16|t[1]<<8|t[0]},W=function(t){return[255&t]},X=function(t){return[255&t,t>>8&255]},V=function(t){return[255&t,t>>8&255,t>>16&255,t>>24&255]},B=function(t){return N(t,52,8)},z=function(t){return N(t,23,4)},H=function(t,e,n){p(t[m],e,{get:function(){return this[n]}})},Y=function(t,e,n,r){var i=+n,o=l(i);if(i!=o||o<0||o+e>t[I])throw S(w);var u=t[F]._b,a=o+t[L],s=u.slice(a,a+e);return r?s:s.reverse()},q=function(t,e,n,r,i,o){var u=+n,a=l(u);if(u!=a||a<0||a+e>t[I])throw S(w);for(var s=t[F]._b,c=a+t[L],f=r(+i),h=0;h<e;h++)s[c+h]=f[o?h:e-h-1]},K=function(t,e){f(t,x,y);var n=+e,r=h(n);if(n!=r)throw S(b);return r};if(u.ABV){if(!c(function(){new x})||!c(function(){new x(.5)})){x=function(t){return new A(K(this,t))};for(var J,Z=x[m]=A[m],Q=d(A),tt=0;Q.length>tt;)(J=Q[tt++])in x||a(x,J,A[J]);o||(Z.constructor=x)}var et=new E(new x(2)),nt=E[m].setInt8;et.setInt8(0,2147483648),et.setInt8(1,2147483649),!et.getInt8(0)&&et.getInt8(1)||s(E[m],{setInt8:function(t,e){nt.call(this,t,e<<24>>24)},setUint8:function(t,e){nt.call(this,t,e<<24>>24)}},!0)}else x=function(t){var e=K(this,t);this._b=v.call(Array(e),0),this[I]=e},E=function(t,e,n){f(this,E,_),f(t,x,_);var r=t[I],i=l(e);if(i<0||i>r)throw S(\"Wrong offset!\");if(n=void 0===n?r-i:h(n),i+n>r)throw S(b);this[F]=t,this[L]=i,this[I]=n},i&&(H(x,k,\"_l\"),H(E,D,\"_b\"),H(E,k,\"_l\"),H(E,M,\"_o\")),s(E[m],{getInt8:function(t){return Y(this,1,t)[0]<<24>>24},getUint8:function(t){return Y(this,1,t)[0]},getInt16:function(t){var e=Y(this,2,t,arguments[1]);return(e[1]<<8|e[0])<<16>>16},getUint16:function(t){var e=Y(this,2,t,arguments[1]);return e[1]<<8|e[0]},getInt32:function(t){return U(Y(this,4,t,arguments[1]))},getUint32:function(t){return U(Y(this,4,t,arguments[1]))>>>0},getFloat32:function(t){return G(Y(this,4,t,arguments[1]),23,4)},getFloat64:function(t){return G(Y(this,8,t,arguments[1]),52,8)},setInt8:function(t,e){q(this,1,t,W,e)},setUint8:function(t,e){q(this,1,t,W,e)},setInt16:function(t,e){q(this,2,t,X,e,arguments[2])},setUint16:function(t,e){q(this,2,t,X,e,arguments[2])},setInt32:function(t,e){q(this,4,t,V,e,arguments[2])},setUint32:function(t,e){q(this,4,t,V,e,arguments[2])},setFloat32:function(t,e){q(this,4,t,z,e,arguments[2])},setFloat64:function(t,e){q(this,8,t,B,e,arguments[2])}});g(x,y),g(E,_),a(E[m],u.VIEW,!0),e[y]=x,e[_]=E},function(t,e,n){var r=n(8);r(r.G+r.W+r.F*!n(219).ABV,{DataView:n(220).DataView})},function(t,e,n){n(223)(\"Int8\",1,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){\"use strict\";if(n(6)){var r=n(28),i=n(4),o=n(7),u=n(8),a=n(219),s=n(220),c=n(20),f=n(205),l=n(17),h=n(10),d=n(210),p=n(38),v=n(37),g=n(39),y=n(16),_=n(5),m=n(71),b=n(75),w=n(13),x=n(58),E=n(162),P=n(46),S=n(59),O=n(50).f,A=n(164),T=n(19),$=n(25),C=n(172),R=n(36),j=n(207),D=n(193),k=n(129),M=n(165),F=n(192),I=n(188),L=n(185),N=n(11),G=n(51),U=N.f,W=G.f,X=i.RangeError,V=i.TypeError,B=i.Uint8Array,z=\"ArrayBuffer\",H=\"Shared\"+z,Y=\"BYTES_PER_ELEMENT\",q=\"prototype\",K=Array[q],J=s.ArrayBuffer,Z=s.DataView,Q=C(0),tt=C(2),et=C(3),nt=C(4),rt=C(5),it=C(6),ot=R(!0),ut=R(!1),at=D.values,st=D.keys,ct=D.entries,ft=K.lastIndexOf,lt=K.reduce,ht=K.reduceRight,dt=K.join,pt=K.sort,vt=K.slice,gt=K.toString,yt=K.toLocaleString,_t=$(\"iterator\"),mt=$(\"toStringTag\"),bt=T(\"typed_constructor\"),wt=T(\"def_constructor\"),xt=a.CONSTR,Et=a.TYPED,Pt=a.VIEW,St=\"Wrong length!\",Ot=C(1,function(t,e){return jt(j(t,t[wt]),e)}),At=o(function(){return 1===new B(new Uint16Array([1]).buffer)[0]}),Tt=!!B&&!!B[q].set&&o(function(){new B(1).set({})}),$t=function(t,e){if(void 0===t)throw V(St);var n=+t,r=v(t);if(e&&!m(n,r))throw X(St);return r},Ct=function(t,e){var n=p(t);if(n<0||n%e)throw X(\"Wrong offset!\");return n},Rt=function(t){if(w(t)&&Et in t)return t;throw V(t+\" is not a typed array!\")},jt=function(t,e){if(!(w(t)&&bt in t))throw V(\"It is not a typed array constructor!\");return new t(e)},Dt=function(t,e){return kt(j(t,t[wt]),e)},kt=function(t,e){for(var n=0,r=e.length,i=jt(t,r);r>n;)i[n]=e[n++];return i},Mt=function(t,e,n){U(t,e,{get:function(){return this._d[n]}})},Ft=function(t){var e,n,r,i,o,u,a=x(t),s=arguments.length,f=s>1?arguments[1]:void 0,l=void 0!==f,h=A(a);if(void 0!=h&&!E(h)){for(u=h.call(a),r=[],e=0;!(o=u.next()).done;e++)r.push(o.value);a=r}for(l&&s>2&&(f=c(f,arguments[2],2)),e=0,n=v(a.length),i=jt(this,n);n>e;e++)i[e]=l?f(a[e],e):a[e];return i},It=function(){for(var t=0,e=arguments.length,n=jt(this,e);e>t;)n[t]=arguments[t++];return n},Lt=!!B&&o(function(){yt.call(new B(1))}),Nt=function(){return yt.apply(Lt?vt.call(Rt(this)):Rt(this),arguments)},Gt={copyWithin:function(t,e){return L.call(Rt(this),t,e,arguments.length>2?arguments[2]:void 0)},every:function(t){return nt(Rt(this),t,arguments.length>1?arguments[1]:void 0)},fill:function(t){return I.apply(Rt(this),arguments)},filter:function(t){return Dt(this,tt(Rt(this),t,arguments.length>1?arguments[1]:void 0))},find:function(t){return rt(Rt(this),t,arguments.length>1?arguments[1]:void 0)},findIndex:function(t){return it(Rt(this),t,arguments.length>1?arguments[1]:void 0)},forEach:function(t){Q(Rt(this),t,arguments.length>1?arguments[1]:void 0)},indexOf:function(t){return ut(Rt(this),t,arguments.length>1?arguments[1]:void 0)},includes:function(t){return ot(Rt(this),t,arguments.length>1?arguments[1]:void 0)},join:function(t){return dt.apply(Rt(this),arguments)},lastIndexOf:function(t){return ft.apply(Rt(this),arguments)},map:function(t){return Ot(Rt(this),t,arguments.length>1?arguments[1]:void 0)},reduce:function(t){return lt.apply(Rt(this),arguments)},reduceRight:function(t){return ht.apply(Rt(this),arguments)},reverse:function(){for(var t,e=this,n=Rt(e).length,r=Math.floor(n/2),i=0;i<r;)t=e[i],e[i++]=e[--n],e[n]=t;return e},some:function(t){return et(Rt(this),t,arguments.length>1?arguments[1]:void 0)},sort:function(t){return pt.call(Rt(this),t)},subarray:function(t,e){var n=Rt(this),r=n.length,i=g(t,r);return new(j(n,n[wt]))(n.buffer,n.byteOffset+i*n.BYTES_PER_ELEMENT,v((void 0===e?r:g(e,r))-i))}},Ut=function(t,e){return Dt(this,vt.call(Rt(this),t,e))},Wt=function(t){Rt(this);var e=Ct(arguments[1],1),n=this.length,r=x(t),i=v(r.length),o=0;if(i+e>n)throw X(St);for(;o<i;)this[e+o]=r[o++]},Xt={entries:function(){return ct.call(Rt(this))},keys:function(){return st.call(Rt(this))},values:function(){return at.call(Rt(this))}},Vt=function(t,e){return w(t)&&t[Et]&&\"symbol\"!=typeof e&&e in t&&String(+e)==String(e)},Bt=function(t,e){return Vt(t,e=y(e,!0))?l(2,t[e]):W(t,e)},zt=function(t,e,n){return!(Vt(t,e=y(e,!0))&&w(n)&&_(n,\"value\"))||_(n,\"get\")||_(n,\"set\")||n.configurable||_(n,\"writable\")&&!n.writable||_(n,\"enumerable\")&&!n.enumerable?U(t,e,n):(t[e]=n.value,t)};xt||(G.f=Bt,N.f=zt),u(u.S+u.F*!xt,\"Object\",{getOwnPropertyDescriptor:Bt,defineProperty:zt}),o(function(){gt.call({})})&&(gt=yt=function(){return dt.call(this)});var Ht=d({},Gt);d(Ht,Xt),h(Ht,_t,Xt.values),d(Ht,{slice:Ut,set:Wt,constructor:function(){},toString:gt,toLocaleString:Nt}),Mt(Ht,\"buffer\",\"b\"),Mt(Ht,\"byteOffset\",\"o\"),Mt(Ht,\"byteLength\",\"l\"),Mt(Ht,\"length\",\"e\"),U(Ht,mt,{get:function(){return this[Et]}}),t.exports=function(t,e,n,s){s=!!s;var c=t+(s?\"Clamped\":\"\")+\"Array\",l=\"Uint8Array\"!=c,d=\"get\"+t,p=\"set\"+t,g=i[c],y=g||{},_=g&&S(g),m=!g||!a.ABV,x={},E=g&&g[q],A=function(t,n){var r=t._d;return r.v[d](n*e+r.o,At)},T=function(t,n,r){var i=t._d;s&&(r=(r=Math.round(r))<0?0:r>255?255:255&r),i.v[p](n*e+i.o,r,At)},$=function(t,e){U(t,e,{get:function(){return A(this,e)},set:function(t){return T(this,e,t)},enumerable:!0})};m?(g=n(function(t,n,r,i){f(t,g,c,\"_d\");var o,u,a,s,l=0,d=0;if(w(n)){if(!(n instanceof J||(s=b(n))==z||s==H))return Et in n?kt(g,n):Ft.call(g,n);o=n,d=Ct(r,e);var p=n.byteLength;if(void 0===i){if(p%e)throw X(St);if(u=p-d,u<0)throw X(St)}else if(u=v(i)*e,u+d>p)throw X(St);a=u/e}else a=$t(n,!0),u=a*e,o=new J(u);for(h(t,\"_d\",{b:o,o:d,l:u,e:a,v:new Z(o)});l<a;)$(t,l++)}),E=g[q]=P(Ht),h(E,\"constructor\",g)):M(function(t){new g(null),new g(t)},!0)||(g=n(function(t,n,r,i){f(t,g,c);var o;return w(n)?n instanceof J||(o=b(n))==z||o==H?void 0!==i?new y(n,Ct(r,e),i):void 0!==r?new y(n,Ct(r,e)):new y(n):Et in n?kt(g,n):Ft.call(g,n):new y($t(n,l))}),Q(_!==Function.prototype?O(y).concat(O(_)):O(y),function(t){t in g||h(g,t,y[t])}),g[q]=E,r||(E.constructor=g));var C=E[_t],R=!!C&&(\"values\"==C.name||void 0==C.name),j=Xt.values;h(g,bt,!0),h(E,Et,c),h(E,Pt,!0),h(E,wt,g),(s?new g(1)[mt]==c:mt in E)||U(E,mt,{get:function(){return c}}),x[c]=g,u(u.G+u.W+u.F*(g!=y),x),u(u.S,c,{BYTES_PER_ELEMENT:e,from:Ft,of:It}),Y in E||h(E,Y,e),u(u.P,c,Gt),F(c),u(u.P+u.F*Tt,c,{set:Wt}),u(u.P+u.F*!R,c,Xt),u(u.P+u.F*(E.toString!=gt),c,{toString:gt}),u(u.P+u.F*o(function(){new g(1).slice()}),c,{slice:Ut}),u(u.P+u.F*(o(function(){return[1,2].toLocaleString()!=new g([1,2]).toLocaleString()})||!o(function(){E.toLocaleString.call([1,2])})),c,{toLocaleString:Nt}),k[c]=R?C:j,r||R||h(E,_t,j)}}else t.exports=function(){}},function(t,e,n){n(223)(\"Uint8\",1,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)(\"Uint8\",1,function(t){return function(e,n,r){return t(this,e,n,r)}},!0)},function(t,e,n){n(223)(\"Int16\",2,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)(\"Uint16\",2,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)(\"Int32\",4,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)(\"Uint32\",4,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)(\"Float32\",4,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)(\"Float64\",8,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){var r=n(8),i=n(21),o=n(12),u=(n(4).Reflect||{}).apply,a=Function.apply;r(r.S+r.F*!n(7)(function(){u(function(){})}),\"Reflect\",{apply:function(t,e,n){var r=i(t),s=o(n);return u?u(r,e,s):a.call(r,e,s)}})},function(t,e,n){var r=n(8),i=n(46),o=n(21),u=n(12),a=n(13),s=n(7),c=n(77),f=(n(4).Reflect||{}).construct,l=s(function(){function t(){}return!(f(function(){},[],t)instanceof t)}),h=!s(function(){f(function(){})});r(r.S+r.F*(l||h),\"Reflect\",{construct:function(t,e){o(t),u(e);var n=arguments.length<3?t:o(arguments[2]);if(h&&!l)return f(t,e,n);if(t==n){switch(e.length){case 0:return new t;case 1:return new t(e[0]);case 2:return new t(e[0],e[1]);case 3:return new t(e[0],e[1],e[2]);case 4:return new t(e[0],e[1],e[2],e[3])}var r=[null];return r.push.apply(r,e),new(c.apply(t,r))}var s=n.prototype,d=i(a(s)?s:Object.prototype),p=Function.apply.call(t,d,e);return a(p)?p:d}})},function(t,e,n){var r=n(11),i=n(8),o=n(12),u=n(16);i(i.S+i.F*n(7)(function(){Reflect.defineProperty(r.f({},1,{value:1}),1,{value:2})}),\"Reflect\",{defineProperty:function(t,e,n){o(t),e=u(e,!0),o(n);try{return r.f(t,e,n),!0}catch(t){return!1}}})},function(t,e,n){var r=n(8),i=n(51).f,o=n(12);r(r.S,\"Reflect\",{deleteProperty:function(t,e){var n=i(o(t),e);return!(n&&!n.configurable)&&delete t[e]}})},function(t,e,n){\"use strict\";var r=n(8),i=n(12),o=function(t){this._t=i(t),this._i=0;var e,n=this._k=[];for(e in t)n.push(e)};n(130)(o,\"Object\",function(){var t,e=this,n=e._k;do if(e._i>=n.length)return{value:void 0,done:!0};while(!((t=n[e._i++])in e._t));return{value:t,done:!1}}),r(r.S,\"Reflect\",{enumerate:function(t){return new o(t)}})},function(t,e,n){function r(t,e){var n,a,f=arguments.length<3?t:arguments[2];return c(t)===f?t[e]:(n=i.f(t,e))?u(n,\"value\")?n.value:void 0!==n.get?n.get.call(f):void 0:s(a=o(t))?r(a,e,f):void 0}var i=n(51),o=n(59),u=n(5),a=n(8),s=n(13),c=n(12);a(a.S,\"Reflect\",{get:r})},function(t,e,n){var r=n(51),i=n(8),o=n(12);i(i.S,\"Reflect\",{getOwnPropertyDescriptor:function(t,e){return r.f(o(t),e)}})},function(t,e,n){var r=n(8),i=n(59),o=n(12);r(r.S,\"Reflect\",{getPrototypeOf:function(t){\nreturn i(o(t))}})},function(t,e,n){var r=n(8);r(r.S,\"Reflect\",{has:function(t,e){return e in t}})},function(t,e,n){var r=n(8),i=n(12),o=Object.isExtensible;r(r.S,\"Reflect\",{isExtensible:function(t){return i(t),!o||o(t)}})},function(t,e,n){var r=n(8);r(r.S,\"Reflect\",{ownKeys:n(243)})},function(t,e,n){var r=n(50),i=n(43),o=n(12),u=n(4).Reflect;t.exports=u&&u.ownKeys||function(t){var e=r.f(o(t)),n=i.f;return n?e.concat(n(t)):e}},function(t,e,n){var r=n(8),i=n(12),o=Object.preventExtensions;r(r.S,\"Reflect\",{preventExtensions:function(t){i(t);try{return o&&o(t),!0}catch(t){return!1}}})},function(t,e,n){function r(t,e,n){var s,h,d=arguments.length<4?t:arguments[3],p=o.f(f(t),e);if(!p){if(l(h=u(t)))return r(h,e,n,d);p=c(0)}return a(p,\"value\")?!(p.writable===!1||!l(d)||(s=o.f(d,e)||c(0),s.value=n,i.f(d,e,s),0)):void 0!==p.set&&(p.set.call(d,n),!0)}var i=n(11),o=n(51),u=n(59),a=n(5),s=n(8),c=n(17),f=n(12),l=n(13);s(s.S,\"Reflect\",{set:r})},function(t,e,n){var r=n(8),i=n(73);i&&r(r.S,\"Reflect\",{setPrototypeOf:function(t,e){i.check(t,e);try{return i.set(t,e),!0}catch(t){return!1}}})},function(t,e,n){\"use strict\";var r=n(8),i=n(36)(!0);r(r.P,\"Array\",{includes:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),n(186)(\"includes\")},function(t,e,n){\"use strict\";var r=n(8),i=n(127)(!0);r(r.P,\"String\",{at:function(t){return i(this,t)}})},function(t,e,n){\"use strict\";var r=n(8),i=n(250);r(r.P,\"String\",{padStart:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!0)}})},function(t,e,n){var r=n(37),i=n(91),o=n(35);t.exports=function(t,e,n,u){var a=String(o(t)),s=a.length,c=void 0===n?\" \":String(n),f=r(e);if(f<=s||\"\"==c)return a;var l=f-s,h=i.call(c,Math.ceil(l/c.length));return h.length>l&&(h=h.slice(0,l)),u?h+a:a+h}},function(t,e,n){\"use strict\";var r=n(8),i=n(250);r(r.P,\"String\",{padEnd:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!1)}})},function(t,e,n){\"use strict\";n(83)(\"trimLeft\",function(t){return function(){return t(this,1)}},\"trimStart\")},function(t,e,n){\"use strict\";n(83)(\"trimRight\",function(t){return function(){return t(this,2)}},\"trimEnd\")},function(t,e,n){\"use strict\";var r=n(8),i=n(35),o=n(37),u=n(134),a=n(196),s=RegExp.prototype,c=function(t,e){this._r=t,this._s=e};n(130)(c,\"RegExp String\",function(){var t=this._r.exec(this._s);return{value:t,done:null===t}}),r(r.P,\"String\",{matchAll:function(t){if(i(this),!u(t))throw TypeError(t+\" is not a regexp!\");var e=String(this),n=\"flags\"in s?String(t.flags):a.call(t),r=new RegExp(t.source,~n.indexOf(\"g\")?n:\"g\"+n);return r.lastIndex=o(t.lastIndex),new c(r,e)}})},function(t,e,n){n(27)(\"asyncIterator\")},function(t,e,n){n(27)(\"observable\")},function(t,e,n){var r=n(8),i=n(243),o=n(32),u=n(51),a=n(163);r(r.S,\"Object\",{getOwnPropertyDescriptors:function(t){for(var e,n=o(t),r=u.f,s=i(n),c={},f=0;s.length>f;)a(c,e=s[f++],r(n,e));return c}})},function(t,e,n){var r=n(8),i=n(259)(!1);r(r.S,\"Object\",{values:function(t){return i(t)}})},function(t,e,n){var r=n(30),i=n(32),o=n(44).f;t.exports=function(t){return function(e){for(var n,u=i(e),a=r(u),s=a.length,c=0,f=[];s>c;)o.call(u,n=a[c++])&&f.push(t?[n,u[n]]:u[n]);return f}}},function(t,e,n){var r=n(8),i=n(259)(!0);r(r.S,\"Object\",{entries:function(t){return i(t)}})},function(t,e,n){\"use strict\";var r=n(8),i=n(58),o=n(21),u=n(11);n(6)&&r(r.P+n(262),\"Object\",{__defineGetter__:function(t,e){u.f(i(this),t,{get:o(e),enumerable:!0,configurable:!0})}})},function(t,e,n){t.exports=n(28)||!n(7)(function(){var t=Math.random();__defineSetter__.call(null,t,function(){}),delete n(4)[t]})},function(t,e,n){\"use strict\";var r=n(8),i=n(58),o=n(21),u=n(11);n(6)&&r(r.P+n(262),\"Object\",{__defineSetter__:function(t,e){u.f(i(this),t,{set:o(e),enumerable:!0,configurable:!0})}})},function(t,e,n){\"use strict\";var r=n(8),i=n(58),o=n(16),u=n(59),a=n(51).f;n(6)&&r(r.P+n(262),\"Object\",{__lookupGetter__:function(t){var e,n=i(this),r=o(t,!0);do if(e=a(n,r))return e.get;while(n=u(n))}})},function(t,e,n){\"use strict\";var r=n(8),i=n(58),o=n(16),u=n(59),a=n(51).f;n(6)&&r(r.P+n(262),\"Object\",{__lookupSetter__:function(t){var e,n=i(this),r=o(t,!0);do if(e=a(n,r))return e.set;while(n=u(n))}})},function(t,e,n){var r=n(8);r(r.P+r.R,\"Map\",{toJSON:n(267)(\"Map\")})},function(t,e,n){var r=n(75),i=n(268);t.exports=function(t){return function(){if(r(this)!=t)throw TypeError(t+\"#toJSON isn't generic\");return i(this)}}},function(t,e,n){var r=n(206);t.exports=function(t,e){var n=[];return r(t,!1,n.push,n,e),n}},function(t,e,n){var r=n(8);r(r.P+r.R,\"Set\",{toJSON:n(267)(\"Set\")})},function(t,e,n){var r=n(8);r(r.S,\"System\",{global:n(4)})},function(t,e,n){var r=n(8),i=n(34);r(r.S,\"Error\",{isError:function(t){return\"Error\"===i(t)}})},function(t,e,n){var r=n(8);r(r.S,\"Math\",{iaddh:function(t,e,n,r){var i=t>>>0,o=e>>>0,u=n>>>0;return o+(r>>>0)+((i&u|(i|u)&~(i+u>>>0))>>>31)|0}})},function(t,e,n){var r=n(8);r(r.S,\"Math\",{isubh:function(t,e,n,r){var i=t>>>0,o=e>>>0,u=n>>>0;return o-(r>>>0)-((~i&u|~(i^u)&i-u>>>0)>>>31)|0}})},function(t,e,n){var r=n(8);r(r.S,\"Math\",{imulh:function(t,e){var n=65535,r=+t,i=+e,o=r&n,u=i&n,a=r>>16,s=i>>16,c=(a*u>>>0)+(o*u>>>16);return a*s+(c>>16)+((o*s>>>0)+(c&n)>>16)}})},function(t,e,n){var r=n(8);r(r.S,\"Math\",{umulh:function(t,e){var n=65535,r=+t,i=+e,o=r&n,u=i&n,a=r>>>16,s=i>>>16,c=(a*u>>>0)+(o*u>>>16);return a*s+(c>>>16)+((o*s>>>0)+(c&n)>>>16)}})},function(t,e,n){var r=n(277),i=n(12),o=r.key,u=r.set;r.exp({defineMetadata:function(t,e,n,r){u(t,e,i(n),o(r))}})},function(t,e,n){var r=n(211),i=n(8),o=n(23)(\"metadata\"),u=o.store||(o.store=new(n(215))),a=function(t,e,n){var i=u.get(t);if(!i){if(!n)return;u.set(t,i=new r)}var o=i.get(e);if(!o){if(!n)return;i.set(e,o=new r)}return o},s=function(t,e,n){var r=a(e,n,!1);return void 0!==r&&r.has(t)},c=function(t,e,n){var r=a(e,n,!1);return void 0===r?void 0:r.get(t)},f=function(t,e,n,r){a(n,r,!0).set(t,e)},l=function(t,e){var n=a(t,e,!1),r=[];return n&&n.forEach(function(t,e){r.push(e)}),r},h=function(t){return void 0===t||\"symbol\"==typeof t?t:String(t)},d=function(t){i(i.S,\"Reflect\",t)};t.exports={store:u,map:a,has:s,get:c,set:f,keys:l,key:h,exp:d}},function(t,e,n){var r=n(277),i=n(12),o=r.key,u=r.map,a=r.store;r.exp({deleteMetadata:function(t,e){var n=arguments.length<3?void 0:o(arguments[2]),r=u(i(e),n,!1);if(void 0===r||!r.delete(t))return!1;if(r.size)return!0;var s=a.get(e);return s.delete(n),!!s.size||a.delete(e)}})},function(t,e,n){var r=n(277),i=n(12),o=n(59),u=r.has,a=r.get,s=r.key,c=function(t,e,n){var r=u(t,e,n);if(r)return a(t,e,n);var i=o(e);return null!==i?c(t,i,n):void 0};r.exp({getMetadata:function(t,e){return c(t,i(e),arguments.length<3?void 0:s(arguments[2]))}})},function(t,e,n){var r=n(214),i=n(268),o=n(277),u=n(12),a=n(59),s=o.keys,c=o.key,f=function(t,e){var n=s(t,e),o=a(t);if(null===o)return n;var u=f(o,e);return u.length?n.length?i(new r(n.concat(u))):u:n};o.exp({getMetadataKeys:function(t){return f(u(t),arguments.length<2?void 0:c(arguments[1]))}})},function(t,e,n){var r=n(277),i=n(12),o=r.get,u=r.key;r.exp({getOwnMetadata:function(t,e){return o(t,i(e),arguments.length<3?void 0:u(arguments[2]))}})},function(t,e,n){var r=n(277),i=n(12),o=r.keys,u=r.key;r.exp({getOwnMetadataKeys:function(t){return o(i(t),arguments.length<2?void 0:u(arguments[1]))}})},function(t,e,n){var r=n(277),i=n(12),o=n(59),u=r.has,a=r.key,s=function(t,e,n){var r=u(t,e,n);if(r)return!0;var i=o(e);return null!==i&&s(t,i,n)};r.exp({hasMetadata:function(t,e){return s(t,i(e),arguments.length<3?void 0:a(arguments[2]))}})},function(t,e,n){var r=n(277),i=n(12),o=r.has,u=r.key;r.exp({hasOwnMetadata:function(t,e){return o(t,i(e),arguments.length<3?void 0:u(arguments[2]))}})},function(t,e,n){var r=n(277),i=n(12),o=n(21),u=r.key,a=r.set;r.exp({metadata:function(t,e){return function(n,r){a(t,e,(void 0!==r?i:o)(n),u(r))}}})},function(t,e,n){var r=n(8),i=n(209)(),o=n(4).process,u=\"process\"==n(34)(o);r(r.G,{asap:function(t){var e=u&&o.domain;i(e?e.bind(t):t)}})},function(t,e,n){\"use strict\";var r=n(8),i=n(4),o=n(9),u=n(209)(),a=n(25)(\"observable\"),s=n(21),c=n(12),f=n(205),l=n(210),h=n(10),d=n(206),p=d.RETURN,v=function(t){return null==t?void 0:s(t)},g=function(t){var e=t._c;e&&(t._c=void 0,e())},y=function(t){return void 0===t._o},_=function(t){y(t)||(t._o=void 0,g(t))},m=function(t,e){c(t),this._c=void 0,this._o=t,t=new b(this);try{var n=e(t),r=n;null!=n&&(\"function\"==typeof n.unsubscribe?n=function(){r.unsubscribe()}:s(n),this._c=n)}catch(e){return void t.error(e)}y(this)&&g(this)};m.prototype=l({},{unsubscribe:function(){_(this)}});var b=function(t){this._s=t};b.prototype=l({},{next:function(t){var e=this._s;if(!y(e)){var n=e._o;try{var r=v(n.next);if(r)return r.call(n,t)}catch(t){try{_(e)}finally{throw t}}}},error:function(t){var e=this._s;if(y(e))throw t;var n=e._o;e._o=void 0;try{var r=v(n.error);if(!r)throw t;t=r.call(n,t)}catch(t){try{g(e)}finally{throw t}}return g(e),t},complete:function(t){var e=this._s;if(!y(e)){var n=e._o;e._o=void 0;try{var r=v(n.complete);t=r?r.call(n,t):void 0}catch(t){try{g(e)}finally{throw t}}return g(e),t}}});var w=function(t){f(this,w,\"Observable\",\"_f\")._f=s(t)};l(w.prototype,{subscribe:function(t){return new m(t,this._f)},forEach:function(t){var e=this;return new(o.Promise||i.Promise)(function(n,r){s(t);var i=e.subscribe({next:function(e){try{return t(e)}catch(t){r(t),i.unsubscribe()}},error:r,complete:n})})}}),l(w,{from:function(t){var e=\"function\"==typeof this?this:w,n=v(c(t)[a]);if(n){var r=c(n.call(t));return r.constructor===e?r:new e(function(t){return r.subscribe(t)})}return new e(function(e){var n=!1;return u(function(){if(!n){try{if(d(t,!1,function(t){if(e.next(t),n)return p})===p)return}catch(t){if(n)throw t;return void e.error(t)}e.complete()}}),function(){n=!0}})},of:function(){for(var t=0,e=arguments.length,n=Array(e);t<e;)n[t]=arguments[t++];return new(\"function\"==typeof this?this:w)(function(t){var e=!1;return u(function(){if(!e){for(var r=0;r<n.length;++r)if(t.next(n[r]),e)return;t.complete()}}),function(){e=!0}})}}),h(w.prototype,a,function(){return this}),r(r.G,{Observable:w}),n(192)(\"Observable\")},function(t,e,n){var r=n(4),i=n(8),o=n(78),u=n(289),a=r.navigator,s=!!a&&/MSIE .\\./.test(a.userAgent),c=function(t){return s?function(e,n){return t(o(u,[].slice.call(arguments,2),\"function\"==typeof e?e:Function(e)),n)}:t};i(i.G+i.B+i.F*s,{setTimeout:c(r.setTimeout),setInterval:c(r.setInterval)})},function(t,e,n){\"use strict\";var r=n(290),i=n(78),o=n(21);t.exports=function(){for(var t=o(this),e=arguments.length,n=Array(e),u=0,a=r._,s=!1;e>u;)(n[u]=arguments[u++])===a&&(s=!0);return function(){var r,o=this,u=arguments.length,c=0,f=0;if(!s&&!u)return i(t,n,o);if(r=n.slice(),s)for(;e>c;c++)r[c]===a&&(r[c]=arguments[f++]);for(;u>f;)r.push(arguments[f++]);return i(t,r,o)}}},function(t,e,n){t.exports=n(4)},function(t,e,n){var r=n(8),i=n(208);r(r.G+r.B,{setImmediate:i.set,clearImmediate:i.clear})},function(t,e,n){for(var r=n(193),i=n(18),o=n(4),u=n(10),a=n(129),s=n(25),c=s(\"iterator\"),f=s(\"toStringTag\"),l=a.Array,h=[\"NodeList\",\"DOMTokenList\",\"MediaList\",\"StyleSheetList\",\"CSSRuleList\"],d=0;d<5;d++){var p,v=h[d],g=o[v],y=g&&g.prototype;if(y){y[c]||u(y,c,l),y[f]||u(y,f,v),a[v]=l;for(p in r)y[p]||i(y,p,r[p],!0)}}},function(t,e,n){(function(e,n){!function(e){\"use strict\";function r(t,e,n,r){var i=e&&e.prototype instanceof o?e:o,u=Object.create(i.prototype),a=new p(r||[]);return u._invoke=f(t,n,a),u}function i(t,e,n){try{return{type:\"normal\",arg:t.call(e,n)}}catch(t){return{type:\"throw\",arg:t}}}function o(){}function u(){}function a(){}function s(t){[\"next\",\"throw\",\"return\"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function c(t){function e(n,r,o,u){var a=i(t[n],t,r);if(\"throw\"!==a.type){var s=a.arg,c=s.value;return c&&\"object\"==typeof c&&m.call(c,\"__await\")?Promise.resolve(c.__await).then(function(t){e(\"next\",t,o,u)},function(t){e(\"throw\",t,o,u)}):Promise.resolve(c).then(function(t){s.value=t,o(s)},u)}u(a.arg)}function r(t,n){function r(){return new Promise(function(r,i){e(t,n,r,i)})}return o=o?o.then(r,r):r()}\"object\"==typeof n&&n.domain&&(e=n.domain.bind(e));var o;this._invoke=r}function f(t,e,n){var r=S;return function(o,u){if(r===A)throw new Error(\"Generator is already running\");if(r===T){if(\"throw\"===o)throw u;return g()}for(n.method=o,n.arg=u;;){var a=n.delegate;if(a){var s=l(a,n);if(s){if(s===$)continue;return s}}if(\"next\"===n.method)n.sent=n._sent=n.arg;else if(\"throw\"===n.method){if(r===S)throw r=T,n.arg;n.dispatchException(n.arg)}else\"return\"===n.method&&n.abrupt(\"return\",n.arg);r=A;var c=i(t,e,n);if(\"normal\"===c.type){if(r=n.done?T:O,c.arg===$)continue;return{value:c.arg,done:n.done}}\"throw\"===c.type&&(r=T,n.method=\"throw\",n.arg=c.arg)}}}function l(t,e){var n=t.iterator[e.method];if(n===y){if(e.delegate=null,\"throw\"===e.method){if(t.iterator.return&&(e.method=\"return\",e.arg=y,l(t,e),\"throw\"===e.method))return $;e.method=\"throw\",e.arg=new TypeError(\"The iterator does not provide a 'throw' method\")}return $}var r=i(n,t.iterator,e.arg);if(\"throw\"===r.type)return e.method=\"throw\",e.arg=r.arg,e.delegate=null,$;var o=r.arg;return o?o.done?(e[t.resultName]=o.value,e.next=t.nextLoc,\"return\"!==e.method&&(e.method=\"next\",e.arg=y),e.delegate=null,$):o:(e.method=\"throw\",e.arg=new TypeError(\"iterator result is not an object\"),e.delegate=null,$)}function h(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function d(t){var e=t.completion||{};e.type=\"normal\",delete e.arg,t.completion=e}function p(t){this.tryEntries=[{tryLoc:\"root\"}],t.forEach(h,this),this.reset(!0)}function v(t){if(t){var e=t[w];if(e)return e.call(t);if(\"function\"==typeof t.next)return t;if(!isNaN(t.length)){var n=-1,r=function e(){for(;++n<t.length;)if(m.call(t,n))return e.value=t[n],e.done=!1,e;return e.value=y,e.done=!0,e};return r.next=r}}return{next:g}}function g(){return{value:y,done:!0}}var y,_=Object.prototype,m=_.hasOwnProperty,b=\"function\"==typeof Symbol?Symbol:{},w=b.iterator||\"@@iterator\",x=b.toStringTag||\"@@toStringTag\",E=\"object\"==typeof t,P=e.regeneratorRuntime;if(P)return void(E&&(t.exports=P));P=e.regeneratorRuntime=E?t.exports:{},P.wrap=r;var S=\"suspendedStart\",O=\"suspendedYield\",A=\"executing\",T=\"completed\",$={},C={};C[w]=function(){return this};var R=Object.getPrototypeOf,j=R&&R(R(v([])));j&&j!==_&&m.call(j,w)&&(C=j);var D=a.prototype=o.prototype=Object.create(C);u.prototype=D.constructor=a,a.constructor=u,a[x]=u.displayName=\"GeneratorFunction\",P.isGeneratorFunction=function(t){var e=\"function\"==typeof t&&t.constructor;return!!e&&(e===u||\"GeneratorFunction\"===(e.displayName||e.name))},P.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,a):(t.__proto__=a,x in t||(t[x]=\"GeneratorFunction\")),t.prototype=Object.create(D),t},P.awrap=function(t){return{__await:t}},s(c.prototype),P.AsyncIterator=c,P.async=function(t,e,n,i){var o=new c(r(t,e,n,i));return P.isGeneratorFunction(e)?o:o.next().then(function(t){return t.done?t.value:o.next()})},s(D),D[x]=\"Generator\",D.toString=function(){return\"[object Generator]\"},P.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var r=e.pop();if(r in t)return n.value=r,n.done=!1,n}return n.done=!0,n}},P.values=v,p.prototype={constructor:p,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=y,this.done=!1,this.delegate=null,this.method=\"next\",this.arg=y,this.tryEntries.forEach(d),!t)for(var e in this)\"t\"===e.charAt(0)&&m.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=y)},stop:function(){this.done=!0;var t=this.tryEntries[0],e=t.completion;if(\"throw\"===e.type)throw e.arg;return this.rval},dispatchException:function(t){function e(e,r){return o.type=\"throw\",o.arg=t,n.next=e,r&&(n.method=\"next\",n.arg=y),!!r}if(this.done)throw t;for(var n=this,r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r],o=i.completion;if(\"root\"===i.tryLoc)return e(\"end\");if(i.tryLoc<=this.prev){var u=m.call(i,\"catchLoc\"),a=m.call(i,\"finallyLoc\");if(u&&a){if(this.prev<i.catchLoc)return e(i.catchLoc,!0);if(this.prev<i.finallyLoc)return e(i.finallyLoc)}else if(u){if(this.prev<i.catchLoc)return e(i.catchLoc,!0)}else{if(!a)throw new Error(\"try statement without catch or finally\");if(this.prev<i.finallyLoc)return e(i.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&m.call(r,\"finallyLoc\")&&this.prev<r.finallyLoc){var i=r;break}}i&&(\"break\"===t||\"continue\"===t)&&i.tryLoc<=e&&e<=i.finallyLoc&&(i=null);var o=i?i.completion:{};return o.type=t,o.arg=e,i?(this.method=\"next\",this.next=i.finallyLoc,$):this.complete(o)},complete:function(t,e){if(\"throw\"===t.type)throw t.arg;return\"break\"===t.type||\"continue\"===t.type?this.next=t.arg:\"return\"===t.type?(this.rval=this.arg=t.arg,this.method=\"return\",this.next=\"end\"):\"normal\"===t.type&&e&&(this.next=e),$},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),d(n),$}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if(\"throw\"===r.type){var i=r.arg;d(n)}return i}}throw new Error(\"illegal catch attempt\")},delegateYield:function(t,e,n){return this.delegate={iterator:v(t),resultName:e,nextLoc:n},\"next\"===this.method&&(this.arg=y),$}}}(\"object\"==typeof e?e:\"object\"==typeof window?window:\"object\"==typeof self?self:this)}).call(e,function(){return this}(),n(294))},function(t,e){function n(){throw new Error(\"setTimeout has not been defined\")}function r(){throw new Error(\"clearTimeout has not been defined\")}function i(t){if(f===setTimeout)return setTimeout(t,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(t,0);try{return f(t,0)}catch(e){try{return f.call(null,t,0)}catch(e){return f.call(this,t,0)}}}function o(t){if(l===clearTimeout)return clearTimeout(t);if((l===r||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(t);try{return l(t)}catch(e){try{return l.call(null,t)}catch(e){return l.call(this,t)}}}function u(){v&&d&&(v=!1,d.length?p=d.concat(p):g=-1,p.length&&a())}function a(){if(!v){var t=i(u);v=!0;for(var e=p.length;e;){for(d=p,p=[];++g<e;)d&&d[g].run();g=-1,e=p.length}d=null,v=!1,o(t)}}function s(t,e){this.fun=t,this.array=e}function c(){}var f,l,h=t.exports={};!function(){try{f=\"function\"==typeof setTimeout?setTimeout:n}catch(t){f=n}try{l=\"function\"==typeof clearTimeout?clearTimeout:r}catch(t){l=r}}();var d,p=[],v=!1,g=-1;h.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];p.push(new s(t,e)),1!==p.length||v||i(a)},s.prototype.run=function(){this.fun.apply(null,this.array)},h.title=\"browser\",h.browser=!0,h.env={},h.argv=[],h.version=\"\",h.versions={},h.on=c,h.addListener=c,h.once=c,h.off=c,h.removeListener=c,h.removeAllListeners=c,h.emit=c,h.binding=function(t){throw new Error(\"process.binding is not supported\")},h.cwd=function(){return\"/\"},h.chdir=function(t){throw new Error(\"process.chdir is not supported\")},h.umask=function(){return 0}},function(t,e,n){n(296),t.exports=n(9).RegExp.escape},function(t,e,n){var r=n(8),i=n(297)(/[\\\\^$*+?.()|[\\]{}]/g,\"\\\\$&\");r(r.S,\"RegExp\",{escape:function(t){return i(t)}})},function(t,e){t.exports=function(t,e){var n=e===Object(e)?function(t){return e[t]}:e;return function(e){return String(e).replace(t,n)}}},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){var n=t||\"body\";if(\"object\"===(\"undefined\"==typeof n?\"undefined\":o(n))&&\"nodeType\"in n&&\"ownerDocument\"in n||(n=document.querySelector(t)),!n)throw new Error(\"Element for selector not found\");return new a.default(n,f.default.recursive({},h.default,e))}Object.defineProperty(e,\"__esModule\",{value:!0});var o=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t},u=n(299),a=r(u),s=n(304),c=n(317),f=r(c),l=n(319),h=r(l);i.isSafari=s.isSafari,i.isWindowsBrowser=s.isWindowsBrowser,e.default=i},function(t,e,n){\"use strict\";function r(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}function i(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=void 0;var u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=n(300),s=n(301),c=i(s),f=n(303),l=r(f),h=n(304),d=r(h),p=n(305),v=i(p),g=n(309),y=i(g),_=n(314),m=i(_),b=n(315),w=i(b),x=n(316),E=i(x),P=void 0,S=function(){function t(e,n){o(this,t),c.default.removeAllListeners(),this.components=[],this.previosPosiotion=null,this._drawing=!1,this._queue=null,this._isExt=!1;var r=n.canvas,i=r.width,u=r.height,s=r.styles,f=(0,a.createCanvas)(i,u,s);n.ctx=f,n.container=e,n.root=this,this.options=n,this.init()}return u(t,[{key:\"init\",value:function(){this.options.container.appendChild(this.options.ctx.canvas),this._initListeners(),this._registerExtCallbacks();var t=new m.default(this.options),e=new E.default(this.options);P=t.data,this.components.push(e),this.components.push(new v.default(this.options)),this.components.push(new y.default(this.options)),this.components.push(t),this._extActionsProcessor=new w.default(this.options),e.render(),this._initData()}},{key:\"render\",value:function(){var t=this,e=function(){return Promise.resolve(!0)},n=this.options.ctx;if(this._drawing)return e();n.save(),n.clearRect(0,0,this.options.canvas.width,this.options.canvas.height),this._drawing=!0;var r=this.components.reduce(function(t,e){var n=e.render;return t instanceof Promise?t.then(function(){return n.call(e)}):n.call(e)},e());return n.restore(),r.then(function(){t._drawing=!1,c.default.emit(l.APP_E_AFTER_RENDER)})}},{key:\"getData\",value:function(){return P}},{key:\"setData\",value:function(t){var e=this;if(null!==this._queue)return this._queue.then(function(){return e._queue=null,e.setData(t)});var n=t.image,r=t.timeLength,i=Promise.resolve(!0);return n&&(i=i.then(function(){return d.loadImage(d.createImage(),n).then(function(t){return d.cutTimeline(t,e.options)}).then(function(t){c.default.emit(l.APP_E_SET_IMG,{url:t})})})),r&&(i=i.then(function(){return c.default.emit(l.APP_E_SET_LENGTH,{timeLength:r})})),this._queue=i,this._queue.then(function(){e.render()})}},{key:\"callMethod\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};this._isExt=!0;var n=this._extActionsProcessor[t].bind(this._extActionsProcessor);return\"function\"==typeof n&&n(e)}},{key:\"_initData\",value:function(){var t=this.options.data,e=t.image,n=void 0!==e&&e,r=t.timeLength,i=void 0!==r&&r;return n&&i?(this.setData({image:n,timeLength:i}),this):this}},{key:\"_initListeners\",value:function(){var t=this,e=this.options.ctx.canvas,n=function(n){var r=(0,a.getCanvasCordinates)(e),i=r.s,o=r.t;return n.diffX=t.previosPosiotion?Math.abs(t.previosPosiotion-n.pageX):n.pageX,n.actualX=n.pageX-i,n.actualY=n.pageY-o,n},r=function(e){var r=e.clientX;return null===t.previosPosiotion?t.previosPosiotion=r:(t.previosPosiotion<r&&c.default.emit(l.APP_E_DRAG_RIGHT,n(e)),t.previosPosiotion>r&&c.default.emit(l.APP_E_DRAG_LEFT,n(e)),void(t.previosPosiotion=r))};e.addEventListener(l.APP_E_MOUSEMOVE,function(t){c.default.emit(l.APP_E_DRAG,n(t))}),e.addEventListener(l.APP_E_MOUSEDOWN,function(t){c.default.emit(l.APP_E_DRAG_START,n(t)),c.default.on(l.APP_E_DRAG,r)}),e.addEventListener(l.APP_E_MOUSEDBCLICK,function(t){c.default.emit(l.APP_E_MOUSEDBCLICK,n(t))}),document.addEventListener(l.APP_E_MOUSEUP,function(){t.previosPosiotion=null,c.default.off(l.APP_E_DRAG,r),c.default.emit(l.APP_E_DRAG_END)})}},{key:\"_registerExtCallbacks\",value:function(){var t=this,e=this.options.callbacks,n=function(t){return\"function\"==typeof t},r=function(t,e){return!!n(t)&&t(e)};c.default.on(l.APP_E_DATA_PROCESSED,function(){return r(e.onChanged,t.getData())}),c.default.on(l.APP_E_CURRENT_END_REACHED,function(){return r(e.onCurrentEndReached)}),c.default.on(l.APP_E_EXTCB_CURRENT_CHANGED,function(t){return r(e.onCurrentChanged,t)}),c.default.on(l.APP_E_AFTER_RENDER,function(){return r(e.afterRender)})}},{key:\"destroy\",value:function(){var t=this.options.ctx.canvas;return t.parentNode&&t.parentNode.removeChild(t)}}]),t}();e.default=S},function(t,e){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.createCanvas=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=document.createElement(\"canvas\");r.width=t,r.height=e;for(var i in n)r.style[i]=n[i];return r.getContext(\"2d\")},e.getCanvasCordinates=function(t){var e=t.getBoundingClientRect();return{s:e.left,e:e.right,t:e.top}}},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,\"__esModule\",{value:!0});var i=n(302),o=r(i),u=new o.default;e.default=u},function(t,e,n){var r;!function(e){\"use strict\";function i(){}function o(t,e){for(var n=t.length;n--;)if(t[n].listener===e)return n;return-1}function u(t){return function(){return this[t].apply(this,arguments)}}function a(t){return\"function\"==typeof t||t instanceof RegExp||!(!t||\"object\"!=typeof t)&&a(t.listener)}var s=i.prototype,c=e.EventEmitter;s.getListeners=function(t){var e,n,r=this._getEvents();if(t instanceof RegExp){e={};for(n in r)r.hasOwnProperty(n)&&t.test(n)&&(e[n]=r[n])}else e=r[t]||(r[t]=[]);return e},s.flattenListeners=function(t){var e,n=[];for(e=0;e<t.length;e+=1)n.push(t[e].listener);return n},s.getListenersAsObject=function(t){var e,n=this.getListeners(t);return n instanceof Array&&(e={},e[t]=n),e||n},s.addListener=function(t,e){if(!a(e))throw new TypeError(\"listener must be a function\");var n,r=this.getListenersAsObject(t),i=\"object\"==typeof e;for(n in r)r.hasOwnProperty(n)&&o(r[n],e)===-1&&r[n].push(i?e:{listener:e,once:!1});return this},s.on=u(\"addListener\"),s.addOnceListener=function(t,e){return this.addListener(t,{listener:e,once:!0})},s.once=u(\"addOnceListener\"),s.defineEvent=function(t){return this.getListeners(t),this},s.defineEvents=function(t){for(var e=0;e<t.length;e+=1)this.defineEvent(t[e]);return this},s.removeListener=function(t,e){var n,r,i=this.getListenersAsObject(t);for(r in i)i.hasOwnProperty(r)&&(n=o(i[r],e),n!==-1&&i[r].splice(n,1));return this},s.off=u(\"removeListener\"),s.addListeners=function(t,e){return this.manipulateListeners(!1,t,e)},s.removeListeners=function(t,e){return this.manipulateListeners(!0,t,e)},s.manipulateListeners=function(t,e,n){var r,i,o=t?this.removeListener:this.addListener,u=t?this.removeListeners:this.addListeners;if(\"object\"!=typeof e||e instanceof RegExp)for(r=n.length;r--;)o.call(this,e,n[r]);else for(r in e)e.hasOwnProperty(r)&&(i=e[r])&&(\"function\"==typeof i?o.call(this,r,i):u.call(this,r,i));return this},s.removeEvent=function(t){var e,n=typeof t,r=this._getEvents();if(\"string\"===n)delete r[t];else if(t instanceof RegExp)for(e in r)r.hasOwnProperty(e)&&t.test(e)&&delete r[e];else delete this._events;return this},s.removeAllListeners=u(\"removeEvent\"),s.emitEvent=function(t,e){var n,r,i,o,u,a=this.getListenersAsObject(t);for(o in a)if(a.hasOwnProperty(o))for(n=a[o].slice(0),i=0;i<n.length;i++)r=n[i],r.once===!0&&this.removeListener(t,r.listener),u=r.listener.apply(this,e||[]),u===this._getOnceReturnValue()&&this.removeListener(t,r.listener);return this},s.trigger=u(\"emitEvent\"),s.emit=function(t){var e=Array.prototype.slice.call(arguments,1);return this.emitEvent(t,e)},s.setOnceReturnValue=function(t){return this._onceReturnValue=t,this},s._getOnceReturnValue=function(){return!this.hasOwnProperty(\"_onceReturnValue\")||this._onceReturnValue},s._getEvents=function(){return this._events||(this._events={})},i.noConflict=function(){return e.EventEmitter=c,i},r=function(){return i}.call(e,n,e,t),!(void 0!==r&&(t.exports=r))}(this||{})},function(t,e){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.C_STYLE_MOVE=\"move\",e.C_STYLE_DEF=\"default\",e.C_STYLE_EWR=\"ew-resize\",e.KEY_CODE_RIGHT=39,e.KEY_CODE_LEFT=37,e.APP_E_SET_IMG=\"app_set_img\",e.APP_E_SET_LENGTH=\"app_set_length\",e.APP_E_MOUSEUP=\"mouseup\",e.APP_E_MOUSEDOWN=\"mousedown\",e.APP_E_MOUSEMOVE=\"mousemove\",e.APP_E_MOUSEDBCLICK=\"dblclick\",e.APP_E_DRAG_START=\"drag_start\",e.APP_E_DRAG_END=\"drag_end\",e.APP_E_DRAG=\"mouse_move\",e.APP_E_DRAG_LEFT=\"drag_left\",e.APP_E_DRAG_RIGHT=\"drag_right\",e.APP_E_SLIDER_CHANGED=\"app_slider_changed\",e.APP_E_DATA_PROCESSED=\"app_data_processed\",e.APP_E_DATA_CHANGED=\"app_data_changed\",e.APP_E_CURRENT_CHANGED=\"app_current_changed\",e.APP_E_CURRENT_CHANGED_EXT=\"app_current_changed_ext\",e.APP_E_CURRENT_REMOVED=\"app_current_removed\",e.APP_E_CURRENT_END_REACHED=\"app_current_end_reached\",e.APP_E_EXTCB_CURRENT_CHANGED=\"app_extcb_current_changed\",e.APP_E_SLIDER_START_CHANGED=\"app_slider_start_changed\",e.APP_E_AFTER_RENDER=\"app_after_render\",e.APP_E_EXT_START_ADD=\"app_ext_start_add\",e.APP_E_EXT_START_SUB=\"app_ext_start_sub\",e.APP_E_EXT_END_ADD=\"app_ext_end_add\",e.APP_E_EXT_END_SUB=\"app_ext_end_sub\",e.APP_E_EXT_DURATION_ADD=\"app_ext_duration_add\",e.APP_E_EXT_DURATION_SUB=\"app_ext_duration_sub\",e.APP_E_EXT_DURATION_FREEZE=\"app_ext_duration_freeze\",e.APP_E_EXT_DURATION_UNFREEZE=\"app_ext_duration_unfreeze\",e.APP_E_EXT_DATA_CHANGED=\"app_ext_data_changed\"},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.cutTimeline=e.loadImage=e.isWindowsBrowser=e.isSafari=e.createImage=void 0;var r=n(300),i=e.createImage=function(){return new Image},o=e.isSafari=function(){return navigator.vendor.length&&navigator.vendor.indexOf(\"Apple\")!==-1},u=e.isWindowsBrowser=function(){var t=!!document.documentMode;return t||!!window.StyleMedia},a=e.loadImage=function(t,e){var n=new Promise(function(e,n){t.onload=function(){return e(t)},t.onerror=function(){return n(t)}});return null!==e.match(/^https?:\\/\\//)&&(t.crossOrigin=\"anonymous\"),t.src=e,n};e.cutTimeline=function(t,e){var n=e.timeline,s=n.thumbWidth,c=n.maxAmount,f=e.canvas,l=f.width,h=f.height,d=e.slider.borderWidth,p=t.width,v=h-2*d,g=Math.ceil(p/s),y=new Array(g).join().split(\",\").map(function(t,e){return p/g*(e+1)-s}),_=Math.floor(y.length/(c-2)),m=y.filter(function(t,e){return 0===e||e===y.length-1||(e+1)%_===0}),b=(0,r.createCanvas)(m.length*s,v);o()||u()?b.drawImage(t,0,0):m.forEach(function(e,n){b.drawImage(t,e,0,s,v,s*n,0,s,v)});var w=(0,r.createCanvas)(l,v),x=i();return a(x,b.canvas.toDataURL()).then(function(t){return w.drawImage(t,0,0,t.width,v,0,0,l,v),w.canvas.toDataURL()})}},function(t,e,n){\"use strict\";function r(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}function i(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function u(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function a(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=void 0;var s,c=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),f=n(306),l=i(f),h=n(303),d=r(h),p=n(307),v=i(p),g=n(301),y=i(g),_=(0,v.default)(s=function(t){\nfunction e(t){o(this,e);var n=u(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.drawYPos=n.options.canvas.height-n.options.slider.height,n._initListeners(),n}return a(e,t),c(e,[{key:\"_initListeners\",value:function(){y.default.on(d.APP_E_SET_IMG,this.setImage.bind(this))}},{key:\"_drawOverlay\",value:function(){var t=this.ctx,e=this.options.slider,n=e.height,r=e.borderWidth;return t.beginPath(),t.globalAlpha=this.options.canvas.overlayOpacity,t.fillStyle=this.options.canvas.overlayColor,t.fillRect(0,this.drawYPos+r/2,this.options.canvas.width,n-2*r),t.globalAlpha=1,!0}},{key:\"render\",value:function(){var t=this;return this.drawImage().then(function(){return t._drawOverlay()})}}]),e}(l.default))||s;e.default=_},function(t,e,n){\"use strict\";function r(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}function i(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=void 0;var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(303),a=(r(u),function(){function t(e){i(this,t),this.options=e,this.ctx=e.ctx,this.canvas=e.ctx.canvas,this.root=e.root}return o(t,[{key:\"setCursorStyle\",value:function(t){this.canvas.style.cursor=t}},{key:\"getCanvasCordinates\",value:function(){return{s:this.canvas.offsetLeft}}},{key:\"resetExt\",value:function(){return this.root._isExt&&(this.root._isExt=!1)}},{key:\"isExt\",get:function(){return this.root._isExt}}]),t}());e.default=a},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,\"__esModule\",{value:!0});var i=n(308),o=r(i),u=n(304);e.default=(0,o.default)({getImage:function(){return this._image||(this._image=(0,u.createImage)()),this._image},resetImagePos:function(){return this.dx=0,this},setImage:function(t){return this.resetImagePos(),this._imageSrc=t.url,this._image&&delete this._image._cutted},drawImage:function t(){var e=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=this.ctx,i=this.getImage(),o=this.options.slider,a=o.borderWidth,s=o.height,c=n.width,f=n.height,l=n.xPos,h=n.imgWidth,d=c||this.options.canvas.width,p=f||s-2*a,v=h||d,t=function(){return e.dx+d>i.width&&(e.dx=0),r.drawImage(i,e.dx||0,0,v,p,l||0,e.drawYPos+a/2,d,p),!0};return i.src!==this._imageSrc?(0,u.loadImage)(i,this._imageSrc).then(function(){return t()}):Promise.resolve(t())}})},function(t,e){\"use strict\";function n(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=Object.keys(t),r=Object.keys(e),i=Symbol(\"isa\"),o=function(e){var r=!0,o=!1,u=void 0;try{for(var a,s=n[Symbol.iterator]();!(r=(a=s.next()).done);r=!0){var c=a.value;e.prototype.hasOwnProperty(c)||Object.defineProperty(e.prototype,c,{value:t[c]})}}catch(t){o=!0,u=t}finally{try{!r&&s.return&&s.return()}finally{if(o)throw u}}return Object.defineProperty(e.prototype,i,{value:!0}),e},u=!0,a=!1,s=void 0;try{for(var c,f=r[Symbol.iterator]();!(u=(c=f.next()).done);u=!0){var l=c.value;Object.defineProperty(o,l,{value:e[l],enumerable:e.propertyIsEnumerable(l)})}}catch(t){a=!0,s=t}finally{try{!u&&f.return&&f.return()}finally{if(a)throw s}}return Object.defineProperty(o,Symbol.hasInstance,{value:function(t){return!!t[i]}}),o}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=n},function(t,e,n){\"use strict\";function r(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}function i(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function u(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function a(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=void 0;var s,c=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),f=n(306),l=i(f),h=n(303),d=r(h),p=n(307),v=i(p),g=n(310),y=i(g),_=n(311),m=i(_),b=n(312),w=i(b),x=n(301),E=i(x),P=(0,v.default)(s=(0,m.default)(s=(0,w.default)(s=function(t){function e(t){o(this,e);var n=u(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t)),r=n.options.canvas.height,i=n.options.slider,a=i.borderWidth,s=i.earWidth,c=i.width,f=i.height,l=i.enableCurrentOnStart;return n.cpx=null,n.slx=0,n.sly=a,n.slw=c,n.ew=s,n.current=l?1:null,n.drawYPos=r-f,n._railDragged=!1,n._leDragged=!1,n._reDragged=!1,n._freezed=!1,n._tooltips=new y.default(n.options),n._initListeners(),n}return a(e,t),c(e,[{key:\"resetImagePos\",value:function(){return this.dx=this._getImageXPos(),this}},{key:\"render\",value:function(){var t=this,e=this.slx,n=this.current;return E.default.emit(d.APP_E_SLIDER_CHANGED,{startPosX:e,endPosX:this.slx+this.slw,current:n}),this._drawImage().then(function(){t._drawRect(),t._drawEar(\"left\"),t._drawEar(\"right\"),t._tooltips.render()})}},{key:\"_isOnRail\",value:function(t,e){return\"undefined\"==typeof e&&(e=this.drawYPos+1),t>this.slx+this.ew&&t<this.slx+this.slw-this.ew&&e>this.drawYPos}},{key:\"_isBetweenSlider\",value:function(t){return t>this.slx&&t<this.slx+this.slw}},{key:\"_isOnEar\",value:function(t,e){return this._isOnLeftEar(t,e)||this._isOnRightEar(t,e)}},{key:\"_isOnLeftEar\",value:function(t,e){return t>this.slx&&t<this.slx+this.ew&&e>this.drawYPos}},{key:\"_isOnRightEar\",value:function(t,e){return t>this.slx+this.slw-this.ew&&t<this.slx+this.slw&&e>this.drawYPos}},{key:\"_initListeners\",value:function(){var t=this,e=function(){return t.root.render()},n=function(){return E.default.emit(d.APP_E_SLIDER_START_CHANGED,{startPosX:t.slx})};E.default.on(d.APP_E_EXT_DURATION_FREEZE,function(){return t._freezed=!0,t}),E.default.on(d.APP_E_EXT_DURATION_UNFREEZE,function(){return t._freezed=!1,t}),E.default.on(d.APP_E_SET_IMG,this.setImage.bind(this)),E.default.on(d.APP_E_DRAG,function(e){var n=e.actualX,r=e.actualY;switch(!0){case t._freezed:return(t._isOnRail(n,r)||t._isOnEar(n,r))&&t.setCursorStyle(d.C_STYLE_MOVE);case t._isOnRail(n,r):t.setCursorStyle(d.C_STYLE_MOVE);break;case t._isOnEar(n,r):t.setCursorStyle(d.C_STYLE_EWR);break;case!t._isBetweenSlider(n,r):t.setCursorStyle(d.C_STYLE_DEF)}}),E.default.on(d.APP_E_DRAG_START,function(e){var n=e.actualX,r=e.actualY;switch(!0){case t._freezed&&(t._isOnRail(n,r)||t._isOnEar(n,r)):case t._isOnRail(n,r):t._railDragged=!0;break;case t._isOnLeftEar(n,r):t._leDragged=!0;break;case t._isOnRightEar(n,r):t._reDragged=!0}E.default.once(d.APP_E_DRAG_END,function(){t._railDragged=!1,t._leDragged=!1,t._reDragged=!1})}),E.default.on(d.APP_E_DRAG_LEFT,function(r){var i=r.diffX,o=t.slx+2*t.ew+t.options.slider.minWidth;switch(!0){case t._railDragged&&t.slx>0:t.slx-=i,t.slx<0&&(t.slx=0),null!==t.current&&(t.current-=i,t.current<0&&(t.current=0)),t.dx=t._getImageXPos(),n(),e();break;case t._leDragged&&t.slx-i>=0:t.slx-=i,t.slx<0?t.slx=0:t.slw+=i,t.dx=t._getImageXPos(),n(),e();break;case t._reDragged&&t.slx+t.slw-i>o:t.slw-=i,null!==t.current&&t.slx+t.slw<=t.current&&(t.current=t.slx+t.slw),e()}}),E.default.on(d.APP_E_DRAG_RIGHT,function(r){var i=r.diffX,o=t.slx+t.slw,u=t.slx+t.slw-2*t.ew-t.options.slider.minWidth;switch(!0){case t._railDragged&&o<t.canvas.width:t.slx+=i,null!==t.current&&(t.current+=i,t.current>t.canvas.width&&(t.current=t.canvas.width)),t.slx+t.slw>t.canvas.width&&(t.slx=t.canvas.width-t.slw),t.dx=t._getImageXPos(),n(),e();break;case t._leDragged&&t.slx+i<=u:t.slw-=i,t.slx+=i,null!==t.current&&t.slx>=t.current&&(t.current=t.slx),t.dx=t._getImageXPos(),n(),e();break;case t._reDragged&&t.slx+t.slw<t.canvas.width:t.slw+=i,t.slx+t.slw>t.canvas.width&&(t.slw=t.canvas.width-t.slx),e()}}),E.default.on(d.APP_E_MOUSEDBCLICK,function(n){var r=n.actualX;t._isBetweenSlider(r)&&(t.current=r,e())}),E.default.on(d.APP_E_CURRENT_CHANGED,function(n){var r=n.diffX,i=n.current,o=t.current,u=function(t){o!==t&&(E.default.emit(d.APP_E_CURRENT_END_REACHED),o=t)};\"undefined\"!=typeof r&&(t.current+=r),\"undefined\"!=typeof i&&(t.current=i),t.current<t.slx&&(t.current=t.slx),t.current>=t.slx+t.slw&&(t.current=t.slx+t.slw+.1,u(t.current)),e()});var r=function(e){t._reDragged=!0,E.default.emit(d.APP_E_DRAG_RIGHT,{diffX:e}),t._reDragged=!1},i=function(e){t._reDragged=!0,E.default.emit(d.APP_E_DRAG_LEFT,{diffX:e}),t._reDragged=!1},o=function(e){t._leDragged=!0,E.default.emit(d.APP_E_DRAG_LEFT,{diffX:e}),t._leDragged=!1},u=function(e){t._leDragged=!0,E.default.emit(d.APP_E_DRAG_RIGHT,{diffX:e}),t._leDragged=!1};E.default.on(d.APP_E_EXT_END_ADD,function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return r(t)}),E.default.on(d.APP_E_EXT_END_SUB,function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return i(t)}),E.default.on(d.APP_E_EXT_START_SUB,function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return o(t)}),E.default.on(d.APP_E_EXT_START_ADD,function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return u(t)}),E.default.on(d.APP_E_EXT_DURATION_SUB,function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return i(t)}),E.default.on(d.APP_E_EXT_DURATION_ADD,function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,n=t.options.canvas.width,i=e;return t.slx+t.slw>=n?o(i):r(i)}),E.default.on(d.APP_E_DATA_CHANGED,function(n){var r=n.start,i=void 0===r?t.slx:r,o=n.end,u=void 0===o?t.slx+t.slw:o;t.slx=t.current=i,t.slw=u-t.slx,t.dx=t._getImageXPos(),e()})}},{key:\"_drawRect\",value:function(){var t=this.options.slider,e=t.borderWidth,n=t.height,r=t.color,i=t.earWidth;this.drawHorizontalLine({x:this.slx+i,y:this.drawYPos,l:this.slw-2*i,w:e,c:r}),this.drawHorizontalLine({x:this.slx+i,y:this.drawYPos+n-e,l:this.slw-2*i,w:e,c:r})}},{key:\"_drawImage\",value:function(){var t=this.options.slider,e=t.borderWidth,n=t.earWidth,r=t.height,i={width:this.slw-n,height:r-2*e,xPos:this._getImageXPos()};return this.drawImage(i)}},{key:\"_drawEar\",value:function(t){var e=this,n=this.ctx,r=this.ew,i=this.options.slider,o=i.height,u=i.borderWidth,a=i.borderRadius,s=this.drawYPos+o/3,c=this.drawYPos-u/2,f=function(t,n,r){e.drawVerticalLine({x:t,y:n,l:r,c:e.options.slider.earDragColor})};switch(n.beginPath(),n.fillStyle=this.options.slider.color,t){case\"left\":this.drawArcRectangle(this.slx,c,r,o,{topLeft:a,bottomLeft:a},!0),f(this.slx+r/2-2,s,o/3),f(this.slx+r/2+1,s,o/3);break;case\"right\":this.drawArcRectangle(this.slx+this.slw-r,c,r,o,{topRight:a,bottomRight:a},!0),f(this.slx+this.slw-r/2+2,s,o/3),f(this.slx+this.slw-r/2-1,s,o/3)}}},{key:\"_getImageXPos\",value:function(){return this.slx+this.options.slider.earWidth}}]),e}(l.default))||s)||s)||s;e.default=P},function(t,e,n){\"use strict\";function r(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}function i(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function u(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function a(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=void 0;var s,c=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),f=n(306),l=i(f),h=n(303),d=r(h),p=n(311),v=i(p),g=n(312),y=i(g),_=n(301),m=i(_),b=n(313),w=i(b),x=(0,w.default)(s=(0,y.default)(s=(0,v.default)(s=function(t){function e(t){o(this,e);var n=u(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n._positionNames=[\"start\",\"end\",\"current\"],n._positions={start:0,end:n.options.slider.width,current:null},n._originals={start:0,end:n.options.slider.width,current:null},n._initListeners(),n}return a(e,t),c(e,[{key:\"render\",value:function(){var t=this;return this._positionNames.forEach(function(e){if(null!==t._positions[e])return t._drawTooltip(e)._drawLength(e)._drawTriangle(e)},this)}},{key:\"_isStart\",value:function(t){return null!==t&&t<=0}},{key:\"_isEnd\",value:function(t){return null!==t&&t+this.options.tooltip.width>=this.options.canvas.width}},{key:\"_isOnCurrentTooltip\",value:function(t,e){var n=this._positions.current,r=this.options.tooltip,i=r.width,o=r.height;return null!==n&&t>n&&t<n+i&&e>0&&e<o}},{key:\"_initListeners\",value:function(){var t=this,e=this.options.slider.earWidth,n=this.options.tooltip.width;m.default.on(d.APP_E_SLIDER_CHANGED,function(r){t._originals.start=r.startPosX,t._originals.end=r.endPosX,t._positions.start=r.startPosX+e/2-n/2,t._positions.end=r.endPosX-e/2-n/2,r.current&&(t._positions.current=r.current-n/2,t._originals.current=r.current)}),m.default.on(d.APP_E_DATA_PROCESSED,function(e){return t._lengthValues=e}),m.default.on(d.APP_E_DRAG,function(e){var n=e.actualX,r=e.actualY;return t._isOnCurrentTooltip(n,r)?t.setCursorStyle(d.C_STYLE_MOVE):t.setCursorStyle(d.C_STYLE_DEF)}),m.default.on(d.APP_E_DRAG_START,function(e){var n=e.actualX,r=e.actualY;t._isOnCurrentTooltip(n,r)&&(t._currentDragged=!0),m.default.once(d.APP_E_DRAG_END,function(){return t._currentDragged=!1})}),[d.APP_E_DRAG_LEFT,d.APP_E_DRAG_RIGHT].forEach(function(e){m.default.on(e,function(n){var r=n.diffX;if(t._currentDragged)return m.default.emit(d.APP_E_CURRENT_CHANGED,{diffX:e===d.APP_E_DRAG_LEFT?r*-1:r})})})}},{key:\"_drawTooltip\",value:function(t){var e=this._positions[t],n=this.ctx,r=this.options.tooltip,i=r.width,o=r.height,u=r.bgColor,a=r.curBgColor,s=this.options.tooltip.borderRadius;return this._isStart(e)&&(e=0),this._isEnd(e)&&(e=this.options.canvas.width-i),null!==this._originals.current&&this._originals.current<=1&&(s={topLeft:s,topRight:s,bottomRight:s,bottomLeft:0}),null!==this._originals.current&&this._originals.current>=this.options.canvas.width&&(s={topLeft:s,topRight:s,bottomRight:0,bottomLeft:s}),n.fillStyle=\"current\"===t?a:u,this._positions[t]=e,this.setShadow(\"0 0 3 rgba(0,0,0, .2)\"),this.drawArcRectangle(e,0,i,o,s,!0),this.resetShadow(),this}},{key:\"_drawLength\",value:function(t){var e=this.ctx,n=this._lengthValues[t],r=this.options.tooltip,i=r.fontColor,o=r.fontSize,u=r.height,a=r.width,s=r.fontFamily,c=this._positions[t],f=this.options.callbacks.lengthFormater;e.font=[o,s].join(\"px \"),e.fillStyle=i;var l=\"function\"==typeof f?f(n):n+\"sec\",h=e.measureText(l).width;return e.fillText(l,c+a/2-h/2,u/2+parseFloat((o/3).toFixed())),this}},{key:\"_drawTriangle\",value:function(t){var e=this._positions[t],n=this._originals[t],r=this.options.tooltip,i=r.height,o=r.width,u=r.bgColor,a=r.curBgColor,s=this.options.slider.earWidth,c=e+o/2,f={a:{x:c-5,y:i},b:{x:c+5,y:i},c:{x:c,y:i+5}};return this._isStart(e)&&(f.c.x=\"current\"===t?n:n+s/2,f.a.x=f.c.x-5,f.b.x=f.c.x+5),this._isEnd(e)&&(f.c.x=\"current\"===t?n:n-s/2,f.a.x=f.c.x+5,f.b.x=f.c.x-5),this.drawTriangle(f.a,f.b,f.c,\"current\"===t?a:u),\"current\"===t&&this._drawCurrentLine(n),this}},{key:\"_drawCurrentLine\",value:function(t){var e=this.options,n=e.tooltip,r=n.height,i=n.curBgColor,o=e.canvas.height,u=e.slider.borderWidth;this.drawVerticalLine({x:t,y:r+6,l:o-2*u-r-5,c:i,w:1})}}]),e}(l.default))||s)||s)||s;e.default=x},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e,n){var r=t.x,i=t.y,o=t.l,u=t.w,a=t.c;switch(n.lineWidth=u||1,n.beginPath(),n.moveTo(r,i),n.strokeStyle=a||\"black\",e){case\"horizontal\":n.lineTo(r+o,i);break;case\"vertical\":n.lineTo(r,o+i)}n.stroke()}Object.defineProperty(e,\"__esModule\",{value:!0});var o=n(308),u=r(o);e.default=(0,u.default)({drawVerticalLine:function(t){return i(t,\"vertical\",this.ctx)},drawHorizontalLine:function(t){return i(t,\"horizontal\",this.ctx)}})},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,\"__esModule\",{value:!0});var i=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t},o=n(308),u=r(o);e.default=(0,u.default)({drawArcRectangle:function(t,e,n,r,o,u,a){var s=this.ctx,c=void 0,f=void 0,l=void 0,h=void 0;return c=f=l=h=0,\"object\"===(\"undefined\"==typeof o?\"undefined\":i(o))?(\"topLeft\"in o&&(c=o.topLeft),\"topRight\"in o&&(f=o.topRight),\"bottomRight\"in o&&(l=o.bottomRight),\"bottomLeft\"in o&&(h=o.bottomLeft)):c=f=l=h=o,a=!u&&\"undefined\"==typeof a&&!0,s.beginPath(),s.moveTo(t+c,e),s.lineTo(t+n-f,e),s.quadraticCurveTo(t+n,e,t+n,e+f),s.lineTo(t+n,e+r-l),s.quadraticCurveTo(t+n,e+r,t+n-l,e+r),s.lineTo(t+h,e+r),s.quadraticCurveTo(t,e+r,t,e+r-h),s.lineTo(t,e+c),s.quadraticCurveTo(t,e,t+c,e),s.closePath(),u?s.fill():a?s.stroke():void 0},drawTriangle:function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:\"black\",i=arguments[4],o=this.ctx,u=t.x,a=t.y,s=e.x,c=e.y,f=n.x,l=n.y;i=i||r,o.beginPath(),o.moveTo(u,a),o.lineTo(s,c),o.lineTo(f,l),o.closePath(),o.strokeStyle=i,o.stroke(),o.fillStyle=r,o.fill()}})},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,\"__esModule\",{value:!0});var i=function(){function t(t,e){var n=[],r=!0,i=!1,o=void 0;try{for(var u,a=t[Symbol.iterator]();!(r=(u=a.next()).done)&&(n.push(u.value),!e||n.length!==e);r=!0);}catch(t){i=!0,o=t}finally{try{!r&&a.return&&a.return()}finally{if(i)throw o}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),o=n(308),u=r(o),a=/^(\\d+)\\s{1}(\\d+)\\s{1}(\\d+)\\s{1}([\\s\\S]+)$/;e.default=(0,u.default)({setShadow:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:\"\",e=this.ctx,n=t.match(a);if(null===n)return!1;var r=i(n,5),o=(r[0],r[1]),u=r[2],s=r[3],c=r[4];return e.shadowOffsetX=o,e.shadowOffsetY=u,e.shadowBlur=s,e.shadowColor=c,!0},resetShadow:function(){var t=this.ctx;t.shadowOffsetX=0,t.shadowOffsetY=0,t.shadowBlur=0}})},function(t,e,n){\"use strict\";function r(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}function i(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function u(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function a(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=void 0;var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(306),f=i(c),l=n(303),h=r(l),d=n(301),p=i(d),v=function(t){function e(t){o(this,e);var n=u(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.data={start:null,current:null,end:null,duration:null},n._initListeners(),n}return a(e,t),s(e,[{key:\"render\",value:function(){return this}},{key:\"_initListeners\",value:function(){var t=this,e=function(e){var n=t.data.current;p.default.emit(h.APP_E_DATA_PROCESSED,t._process(e));var r=t.data.current;t.isExt||null===n||n===r||p.default.emit(h.APP_E_EXTCB_CURRENT_CHANGED,{current:r}),t.resetExt()};p.default.on(h.APP_E_SLIDER_CHANGED,function(t){return e(t)}),p.default.on(h.APP_E_SET_LENGTH,function(n){var r=t.options.canvas.width;t._setLength(n.timeLength);var i={startPosX:r*t.data.start/t._length,endPosX:r*t.data.end/t._length};return null!==t.data.current&&(i.current=r*t.data.current/t._length),e(i)}),p.default.on(h.APP_E_CURRENT_CHANGED_EXT,function(e){var n=t.options.canvas.width*e/t._length;p.default.emit(h.APP_E_CURRENT_CHANGED,{current:n})}),p.default.on(h.APP_E_EXT_DATA_CHANGED,function(e){var n=t.options.canvas.width,r=e.start,i=e.end,o={};\"undefined\"!=typeof r&&(o.start=n*r/t._length),\"undefined\"!=typeof i&&(o.end=n*i/t._length),p.default.emit(h.APP_E_DATA_CHANGED,o)})}},{key:\"_process\",value:function(t){var e=t.startPosX,n=t.endPosX,r=t.current,i=this.options.canvas.width,o=this._length||0,u=Math.ceil(e*o/i),a=Math.floor(n*o/i);if(this.data.start=u,this.data.end=a,this.data.duration=a-u,\"undefined\"!=typeof r){var s=Math.floor(r*o/i);this.data.current=s}return this.data}},{key:\"_setLength\",value:function(t){return this._length=t,this}}]),e}(f.default);e.default=v},function(t,e,n){\"use strict\";function r(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}function i(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function u(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function a(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=void 0;var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(306),f=i(c),l=n(301),h=i(l),d=n(303),p=r(d),v=void 0,g=function(t){function e(t){o(this,e);var n=u(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return v=n.root.components[2],n._initListeners(),n}return a(e,t),s(e,[{key:\"_initListeners\",value:function(){var t=this;document.addEventListener(\"keydown\",function(e){switch(e.keyCode){case p.KEY_CODE_RIGHT:t.updateRange();break;case p.KEY_CODE_LEFT:t.updateRange({type:\"start\",operation:\"sub\"})}})}},{key:\"isDurationFreezed\",value:function(){return v._freezed}},{key:\"freezeDuration\",value:function(){return h.default.emit(p.APP_E_EXT_DURATION_FREEZE)&&!0}},{key:\"unfreezeDuration\",value:function(){return h.default.emit(p.APP_E_EXT_DURATION_UNFREEZE)&&!0}},{key:\"updateRange\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.type,n=void 0===e?\"end\":e,r=t.operation,i=void 0===r?\"add\":r,o=t.value,u=void 0===o?1:o;if(this.isDurationFreezed())return!1;switch([n,i].join(\"_\")){case\"end_add\":h.default.emit(p.APP_E_EXT_END_ADD,u);break;case\"end_sub\":h.default.emit(p.APP_E_EXT_END_SUB,u);break;case\"start_add\":h.default.emit(p.APP_E_EXT_START_ADD,u);break;case\"start_sub\":h.default.emit(p.APP_E_EXT_START_SUB,u);break;case\"duration_add\":h.default.emit(p.APP_E_EXT_DURATION_ADD,u);break;case\"duration_sub\":h.default.emit(p.APP_E_EXT_DURATION_SUB,u)}}},{key:\"updateCurrent\",value:function(t){var e=t.length;return\"number\"==typeof parseInt(e)&&h.default.emit(p.APP_E_CURRENT_CHANGED_EXT,e)&&!0}},{key:\"updateData\",value:function(t){return h.default.emit(p.APP_E_EXT_DATA_CHANGED,t)&&!0}}]),e}(f.default);e.default=g},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function u(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=void 0;var a,s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(306),f=r(c),l=n(313),h=r(l),d=(0,h.default)(a=function(t){function e(){return i(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return u(e,t),s(e,[{key:\"_drawLoader\",value:function(){var t=this.ctx,e=this.options,n=e.canvas,r=n.width,i=n.height,o=e.slider.height,u=e.loader,a=u.fontSize,s=u.fontFamily,c=u.fontColor,f=u.text;t.font=[a,s].join(\"px \"),t.fillStyle=c;var l=t.measureText(f).width;this.setShadow(\"0 3 3 rgba(0,0,0, .3)\"),t.fillText(f,r/2-l/2,i-o/2),this.resetShadow()}},{key:\"render\",value:function(){return this._drawLoader()}}]),e}(f.default))||a;e.default=d},function(t,e,n){(function(t){!function(e){function n(t,e){if(\"object\"!==i(t))return e;for(var r in e)\"object\"===i(t[r])&&\"object\"===i(e[r])?t[r]=n(t[r],e[r]):t[r]=e[r];return t}function r(t,e,r){var u=r[0],a=r.length;(t||\"object\"!==i(u))&&(u={});for(var s=0;s<a;++s){var c=r[s],f=i(c);if(\"object\"===f)for(var l in c){var h=t?o.clone(c[l]):c[l];e?u[l]=n(u[l],h):u[l]=h}}return u}function i(t){return{}.toString.call(t).slice(8,-1).toLowerCase()}var o=function(t){return r(t===!0,!1,arguments)},u=\"merge\";o.recursive=function(t){return r(t===!0,!0,arguments)},o.clone=function(t){var e,n,r=t,u=i(t);if(\"array\"===u)for(r=[],n=t.length,e=0;e<n;++e)r[e]=o.clone(t[e]);else if(\"object\"===u){r={};for(e in t)r[e]=o.clone(t[e])}return r},e?t.exports=o:window[u]=o}(\"object\"==typeof t&&t&&\"object\"==typeof t.exports&&t.exports)}).call(e,n(318)(t))},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children=[],t.webpackPolyfill=1),t}},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var r=\"#899199\",i={canvas:{width:620,height:110,overlayColor:\"rgba(137, 145, 153, 0.7)\",overlayOpacity:.7},slider:{width:300,height:70,color:r,earDragColor:\"white\",borderWidth:4,borderRadius:3,earWidth:15,minWidth:2,enableCurrentOnStart:!0},tooltip:{width:40,height:20,bgColor:r,curBgColor:\"#6DB65B\",fontSize:12,fontColor:\"white\",fontFamily:\"Arial\",borderRadius:3},data:{},timeline:{thumbWidth:135,maxAmount:6},loader:{text:\"Loading timeline...\",fontSize:18,fontColor:\"rgba(0,0,0, .8)\",fontFamily:\"Arial\"},callbacks:{onChanged:function(t){return console.log(\"m: onChange\",t)},onCurrentEndReached:function(t){return console.log(\"m: onCurrentEndReached\",t)},onCurrentChanged:function(t){return console.log(\"m: onCurrentChanged\",t)},lengthFormater:function(t){return t+\" s\"}}};e.default=i}])})}]);"

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/* Html5Player Widget */
(function (fox, $) {
	"use strict";

	__webpack_require__(32)(fox);

	fox.registerWidget('Html5Player_StartBanner', {
		setBanner: function() {
			var img = this.rwom1('@parent @parent').getOption('onStartPlayerImage');

			if (img) {
				
				this.setOption('manualRender', false);

				this.setTemplateOptions({
					startBanner: img
				});
				this.render();
			}
		}

	}, 'Html5Player_Banner');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/* Html5Player Widget */
(function (fox, $) {
	"use strict";

	__webpack_require__(32)(fox);

	fox.registerWidget('Html5Player_StopBanner', {
		setBanner: function() {
			var img = this.rwom1('@parent @parent').getOption('onPausePlayerImage');

			if (img && !fox.site.member) {
				
				this.setOption('manualRender', false);

				this.setTemplateOptions({
					stopBanner: img,
					stopBannerUrl: fox.getEnv('siteProps.ubs.joinUrl') || '/join'
				});
				this.render();
			}
		}

	}, 'Html5Player_Banner');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/* Html5Player Widget */
(function (fox, $) {
	"use strict";

	__webpack_require__(32)(fox);

	fox.registerWidget('Html5Player_EndBanner', {
		setBanner: function() {
			var img = this.rwom1('@parent @parent').getOption('onFinishPlayerImage') || this.rwom1('@parent @parent').getOption('onPausePlayerImage');

			if (img && !fox.site.member) {

				this.setOption('manualRender', false);
				
				this.setTemplateOptions({
					endBanner: img,
					endBannerUrl: fox.getEnv('siteProps.ubs.joinUrl') || '/join'
				});
				this.render();
			}
		}

	}, 'Html5Player_Banner');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("html5player_controls", [["div",{"class":"ac-p-video-container"},[["div",{"id":"ac-p-play"}],["div",{"id":"ac-p-error"}],["div",{"id":"ac-p-spinner"}],["div",{"id":"ac-p-start-banner"}],["div",{"id":"ac-p-stop-banner"}],["div",{"id":"ac-p-end-banner"}]]],["div",{"class":"ac-p-controls","data-component":"controls"},[["div",{"class":"ac-p-action ac-p-progressbar","data-component":"progressbar"}],["div",{"data-component":"toggleplay"},[["span",{"class":"ac-p-icon ac-p-play ac-p-action"}],["textNode",{"text":" "}],["span",{"class":"ac-p-icon ac-p-pause ac-p-action"}]]],["div",{"class":"ac-p-time-display"},[["span",{"data-component":"time"},[["textNode",{"text":"00:00"}]]],["textNode",{"text":" / "}],["span",{"data-component":"duration"},[["textNode",{"text":"00:00"}]]]]],["div",{"class":"ac-p-wide"}],["div",{"data-component":"togglemute"},[["span",{"class":"ac-p-action ac-p-icon ac-p-mute"}],["textNode",{"text":" "}],["span",{"class":"ac-p-action ac-p-icon ac-p-unmute"}]]],["div",{"class":"ac-p-action ac-p-volume","data-component":"volume"}],["div",{"class":"ac-p-action ac-p-formats","data-component":"formats"},[["span",{"class":"ac-p-icon ac-p-settings"}]]],["div",{"class":"ac-p-fullscreen","data-component":"togglefullscreen"},[["span",{"class":"ac-p-action ac-p-icon ac-p-maximize"}],["textNode",{"text":" "}],["span",{"class":"ac-p-action ac-p-icon ac-p-minimize"}]]]]]]);
fox.registerTemplate("html5player_play", [["div",{"class":"ac-p-toggle-box ac-p-play-box animated fadeIn","data-component":"toggleplay"},[["div",{"class":"ac-p-play-btn","data-component":"toggleplay"},[["span",{"class":"ac-p-icon ac-p-play ac-p-action"}]]]]]]);
fox.registerTemplate("html5player_error", [["div",{"class":"ac-p-error","data-component":"error"},[["div",{"class":"ac-p-error-inner"},[["div",{"class":"ac-p-error-text"},[["div",{},[["img",{"class":"ac-p-error-title","src":""},[],[["url","src",true]]],["div",{"class":"ac-p-color"},[["textNode",{"text":"The site is undergoing temporary maintenance"}]]],["div",{"class":"ac-p-simple"},[["textNode",{"text":"please come back in a few minutes"}]]]]],["div",{},[["div",{"class":"ac-p-refresh"},[["textNode",{"text":"The page will refresh automatically in "}],["span",{"class":"ac-p-error-counter","data-component":"timer"}],["textNode",{"text":" second(s). "}],["a",{"class":"ac-p-link","data-component":"refresh"},[["textNode",{"text":"Refresh Now!"}]]]]]]]]]]]]]]);
fox.registerTemplate("html5player_spinner", [["div",{"class":"ac-p-spinner","data-component":"spinner"}]]);
fox.registerTemplate("html5player_startbanner", [["div",{"class":"ac-p-toggle-box ac-p-start-banner animated fadeIn","data-component":"startbanner"},[["if",{"empty":""},[["div",{"class":"ac-p-banner-link"},[["img",{"class":"ac-p-banner-img","src":"","alt":""},[],[["startBanner","src",true]]]]],["else",{},[["a",{"href":"","class":"ac-p-banner-link"},[["img",{"class":"ac-p-banner-img","src":"","alt":""},[],[["startBanner","src",true]]]],[["startBannerUrl","href",true]]]]]],[["startBannerUrl","empty",true]]]]]]);
fox.registerTemplate("html5player_stopbanner", [["div",{"class":"ac-p-toggle-box ac-p-stop-banner animated fadeIn","data-component":"stopbanner"},[["if",{"empty":""},[["div",{"class":"ac-p-banner-link"},[["img",{"class":"ac-p-banner-img","src":"","alt":""},[],[["stopBanner","src",true]]]]],["else",{},[["a",{"href":"","class":"ac-p-banner-link"},[["img",{"class":"ac-p-banner-img","src":"","alt":""},[],[["stopBanner","src",true]]]],[["stopBannerUrl","href",true]]]]]],[["stopBannerUrl","empty",true]]]]]]);
fox.registerTemplate("html5player_endbanner", [["div",{"class":"ac-p-toggle-box ac-p-end-banner animated fadeIn","data-component":"endbanner"},[["if",{"empty":""},[["div",{"class":"ac-p-banner-link"},[["img",{"class":"ac-p-banner-img","src":"","alt":""},[],[["endBanner","src",true]]]]],["else",{},[["a",{"href":"","class":"ac-p-banner-link"},[["img",{"class":"ac-p-banner-img","src":"","alt":""},[],[["endBanner","src",true]]]],[["endBannerUrl","href",true]]]]]],[["endBannerUrl","empty",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(524);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./acplayer-icons.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./acplayer-icons.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:acplayer;src:url(" + __webpack_require__(525) + ") format(\"truetype\"),url(" + __webpack_require__(526) + ") format(\"woff\"),url(" + __webpack_require__(527) + "#acplayer) format(\"svg\");font-weight:400;font-style:normal}.ac-p-icon{font-family:acplayer!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ac-p-4k_19:before{content:\"\\E900\"}.ac-p-uhd:before{content:\"\\E901\"}.ac-p-hd:before{content:\"\\E902\"}.ac-p-sd:before{content:\"\\E903\"}.ac-p-maximize:before{content:\"\\E904\"}.ac-p-minimize:before{content:\"\\E905\"}.ac-p-next:before{content:\"\\E906\"}.ac-p-prew:before{content:\"\\E907\"}.ac-p-pause:before{content:\"\\E908\"}.ac-p-play:before{content:\"\\E909\"}.ac-p-stop:before{content:\"\\E90A\"}.ac-p-settings:before{content:\"\\E90B\"}.ac-p-mute:before{content:\"\\E90C\"}.ac-p-unmute:before{content:\"\\E90D\"}", ""]);

// exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("htmlplayer/fonts/acplayer.ttf?9g9mys", __webpack_require__.p + "_/_/_/_/common-components/htmlplayer/fonts/3uQdS7F.ttf");

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("htmlplayer/fonts/acplayer.woff?9g9mys", __webpack_require__.p + "_/_/_/_/common-components/htmlplayer/fonts/2NYhB3v.woff");

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("htmlplayer/fonts/acplayer.svg?9g9mys", __webpack_require__.p + "_/_/_/_/common-components/htmlplayer/fonts/acplayer.svg");

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(529);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!./acplayer.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!./acplayer.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:pt-sans-regular;src:url(data:application/font-woff2;charset=utf-8;base64,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) format(\"woff2\"),url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\");font-weight:400;font-style:normal}.ac-p *{padding:0;margin:0;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-focus-ring-color:transparent}.ac-p{font-family:pt-sans-regular,Helvetica,sans-serif;overflow:hidden;background-size:cover;background-repeat:no-repeat;position:relative}.ac-p-video-wrapper{content:\"\";position:relative;width:100%;height:0;display:block;padding-bottom:56.25%}.ac-p-video-container{max-height:700px}.ac-p li,.ac-p ul{list-style:none}.ac-p-video{max-height:700px;height:100%;top:0;left:0;z-index:1;display:block}.ac-p-controls,.ac-p-video{width:100%;position:absolute}.ac-p-controls{display:-ms-flexbox;display:flex;font-size:12px;z-index:-1;padding:0 13px;bottom:0;opacity:0;height:43px;transition:all .5s ease}.ac-p-icon{font-size:14px;text-align:center;position:relative}.ac-p-is-hover .ac-p-controls,.ac-p-is-paused:not(.ac-p-is-poster) .ac-p-controls,.ac-p-is-touched .ac-p-controls{z-index:11;opacity:1}.ac-p-time-display{padding-left:10px}.ac-p-controls>div{-ms-flex-item-align:center;align-self:center}.ac-p-action.ac-p-icon:before,.ac-p-settings.ac-p-icon:before{padding:5px;min-width:20px;min-height:20px;line-height:30px}.ac-p-action{cursor:pointer;transition:color .5s ease}.ac-p-wide{-ms-flex:1 1 auto;flex:1 1 auto}.ac-p-is-paused .ac-p-play,.ac-p-pause{display:inline-block}.ac-p-is-paused .ac-p-pause,.ac-p-play{display:none}.ac-p-maximize{font-size:17px}.ac-p-settings{font-size:16px}.ac-p-is-fullscreen .ac-p-minimize,.ac-p-maximize{display:inline-block}.ac-p-is-fullscreen .ac-p-maximize,.ac-p-minimize{display:none}.ac-p-is-muted .ac-p-unmute,.ac-p-mute{display:inline-block}.ac-p-is-muted .ac-p-mute,.ac-p-unmute{display:none}.ac-p-fullscreen{margin-left:3%}.ac-p[max-width~=\"500\"] .ac-p-formats-current,.ac-p[max-width~=\"500\"] .ac-p-volume{display:none}.ac-p-progressbar,.ac-p-progressbar.ac-p-action{position:absolute;top:-8px;left:0;height:8px;width:100%}.ac-p-progressbar:before{width:100%;height:250%;content:\"\";position:absolute;bottom:0;left:0}.ac-p-buffered{z-index:1}.ac-p-buffered,.ac-p-progress{position:absolute;left:0;top:0;height:100%}.ac-p-progress{z-index:2;transition:background .5s ease}.ac-p-volume{position:relative;height:8px;width:40px;border-radius:1px}.ac-p-level:before{content:\"\";position:absolute;top:-6px;left:0;width:100%;height:20px}.ac-p-level{z-index:1;position:absolute;left:0;top:0;height:100%;border-radius:1px}.ac-p-mute,.ac-p-unmute{font-size:16px}.ac-p-timeline{display:none;position:absolute;padding:3px;bottom:15px;left:0;border-radius:3px;text-align:center}.ac-p-timeline-time{padding:0 5px}.ac-p-timeline-thumb{width:135px;height:76px;background-repeat:no-repeat;margin-bottom:3px}.ac-p-formats{position:relative;margin-left:3%}.ac-p .ac-p-settings{min-width:auto}.ac-p-formats-box{display:none;position:absolute;bottom:50px;left:-35px;border-radius:3px;padding:6px;z-index:2}.ac-p-show-formats .ac-p-formats-box{display:block}.ac-p-show-controls .ac-p-controls,.ac-p-show-formats .ac-p-controls{opacity:1;z-index:10}.ac-p-show-controls .ac-p-controls{position:relative}.ac-p-formats-box:after{content:\"\";width:0;height:0;border-width:9px;border-style:solid;position:absolute;top:100%;right:41px}.ac-p-formats-item{padding:3px;width:83px;margin:1px}.ac-p-formats-item .ac-p-icon{font-size:19px;margin-right:7px;vertical-align:-4px}.ac-p-formats-item:first-child{margin-top:0}.ac-p-formats-current-item,.ac-p:not(.ac-p-is-touch) .ac-p-formats-item:hover{border-radius:3px}.ac-p-formats-current{vertical-align:2px}.ac-p[max-width~=\"500\"] .ac-p-formats-box{max-width:192px;margin-left:-92px;column-count:2}.ac-p[max-width~=\"500\"] .ac-p-formats-item{display:inline-block}.ac-p-toggle-box{display:none;position:absolute;z-index:9;width:100%;height:100%;top:0;left:0}.ac-p-toggle-box .ac-p-banner-link{height:100%;width:100%;display:-ms-flexbox;display:flex;padding-bottom:43px;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:stretch;align-content:stretch;-ms-flex-align:center;align-items:center}.ac-p-banner-img{max-width:100%;max-height:100%;min-height:inherit}.ac-p-full-banner{position:absolute;top:0;left:0;z-index:2;width:100%;height:100%;background-repeat:no-repeat;background-position:50%;background-size:cover}.ac-p-is-endbanner .ac-p-end-banner,.ac-p-is-startbanner .ac-p-start-banner,.ac-p-is-stopbanner .ac-p-stop-banner{display:block}.ac-p-limit-banner{position:absolute;top:0;left:0;z-index:200;width:100%;height:100%;font-size:15px;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:stretch;align-content:stretch;-ms-flex-align:center;align-items:center;padding-right:20px}.ac-p-is-limit .ac-p-limit-banner,.ac-p-is-limited .ac-p-limit-banner{display:-ms-flexbox;display:flex}.ac-p-is-limit .ac-p-banner-link{position:relative;height:100%;width:100%;max-width:592px;max-height:445px;background-size:contain}.ac-p-limit-text{width:16%;height:8.5%;position:absolute;top:5%;left:36.2%;line-height:1em;font-size:23px;text-align:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center}.ac-p[max-width~=\"500\"] .ac-p-limit-text{font-size:13px}.ac-p-poster{display:none;position:absolute;top:0;left:0;z-index:2;opacity:1;width:100%;height:100%;background-repeat:no-repeat;background-position:50%;background-size:cover}.ac-p-is-poster .ac-p-poster{display:block}.ac-p-error{display:none;position:absolute;top:0;left:0;z-index:9;width:100%;height:100%;font-size:15px;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:stretch;align-content:stretch;-ms-flex-align:center;align-items:center;padding-right:20px}.ac-p-is-error .ac-p-error{display:-ms-flexbox;display:flex}.ac-p-error-inner{position:relative;height:100%;width:100%;max-width:824px;max-height:541px;background:url(" + __webpack_require__(530) + ") no-repeat 0;background-size:contain}.ac-p-error .ac-p-simple{font-size:18px;line-height:1em;margin-top:1%}.ac-p-error-text{position:absolute;top:33%;left:30%;bottom:5%;right:0;text-align:right;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-line-pack:stretch;align-content:stretch;-ms-flex-align:stretch;align-items:stretch}.ac-p-error-title{-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-item-align:auto;align-self:auto;width:100%;max-width:584px}.ac-p-error .ac-p-color{margin-top:2%;line-height:1em;font-size:28px;letter-spacing:-1px}.ac-p-error-counter{font-size:50px}.ac-p-error .ac-p-refresh{margin-left:12%;font-size:15px}.ac-p-error .ac-p-link,.ac-p-error .ac-p-link:active,.ac-p-error .ac-p-link:hover{cursor:pointer;text-decoration:underline;font-size:13px;white-space:nowrap}.ac-p[max-width~=\"500\"] .ac-p-error{padding:20px}.ac-p[max-width~=\"500\"] .ac-p-error-inner{background-image:none}.ac-p[max-width~=\"500\"] .ac-p-error-text{position:relative;top:auto;left:auto;bottom:auto;text-align:center;height:100%}.ac-p[max-width~=\"500\"] .ac-p-error .ac-p-color{font-size:17px}.ac-p[max-width~=\"500\"] .ac-p-error .ac-p-simple{font-size:14px}.ac-p[max-width~=\"500\"] .ac-p-error .ac-p-refresh{font-size:12px;margin-left:0}.ac-p[max-width~=\"500\"] .ac-p-error-counter{font-size:17px}.ac-p-video::-webkit-media-controls,.ac-p-video::-webkit-media-controls-enclosure{display:none!important}.ac-p-parent-fullscreen{z-index:100000!important;overflow:visible!important}.ac-p-is-fullscreen{position:fixed;top:0;left:0;width:100%!important;height:100%!important;max-width:100%!important;max-height:100%!important;min-width:100%!important;min-height:100%!important;padding:0!important;margin:0!important;z-index:100000;cursor:none}.ac-p-is-fullscreen.ac-p-is-hover{cursor:default}.ac-p-is-fullscreen .ac-p-video,.ac-p-is-fullscreen .ac-p-video-container,.ac-p-is-fullscreen .ac-p-video-wrapper{top:0;left:0;position:absolute;width:100%!important;height:100%!important;max-width:100%!important;max-height:100%!important;min-width:100%!important;min-height:100%!important}.ac-p-is-fullscreen.ac-p-show-controls .ac-p-video-container{padding-bottom:23px}.ac-p-is-fullscreen .ac-p-video-wrapper{padding-bottom:0!important}.ac-p-is-fullscreen.ac-p-show-controls .ac-p-controls{position:absolute;left:0;bottom:0}.ac-p-play-btn{display:block;width:80px;position:absolute;top:50%;left:50%;z-index:102;margin-left:-40px}.ac-p-show-controls .ac-p-play-btn{top:50%}.ac-p-play-btn .ac-p-play{width:100%;height:0;padding-bottom:100%;z-index:103;display:block;border-radius:50%;margin-top:-50%}.ac-p-play-btn .ac-p-play:before{position:absolute;top:50%;left:50%;font-size:28px;line-height:1em;margin-top:-20px;margin-left:-15px}.ac-p-is-paused:not(.ac-p-is-poster) .ac-p-play-box{display:block}.ac-p-is-paused.ac-p-is-endbanner .ac-p-play-box,.ac-p-is-paused.ac-p-is-error .ac-p-play-box,.ac-p-is-paused.ac-p-is-startbanner .ac-p-play-box,.ac-p-is-paused.ac-p-is-stopbanner .ac-p-play-box{display:none}.ac-p-is-paused.ac-p-is-poster .ac-p-play-box{display:block}.ac-p-is-poster .ac-p-toggle-box.ac-p-play-box{box-shadow:none;background-color:transparent}.ac-p-spinner{display:none;width:10%;position:absolute;top:47.39%;left:45%;z-index:100}.ac-p-spinner:before{content:\"\";width:100%;padding-bottom:100%;z-index:101;display:block}.ac-p-spinner:after{content:\"\";position:absolute;margin-left:-5px;margin-top:-5px;top:-50%;height:100%;width:100%;display:inline-block;animation:playerSpinner 1.1s infinite linear;border-radius:50%}.ac-p-is-spinner .ac-p-spinner{display:block}.ac-p-is-spinner.ac-p-is-paused .ac-p-spinner,.ac-p-is-spinner.ac-p-is-startbanner .ac-p-spinner,.ac-p-is-spinner.ac-p-is-stopbanner .ac-p-spinner{display:none}.animated{animation-duration:1s;animation-fill-mode:both}.fadeIn{animation-name:fadeIn}html:-moz-full-screen{overflow:hidden}html:fullscreen{overflow:hidden}@keyframes playerSpinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", ""]);

// exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("htmlplayer/images/acplayer-robot.png", __webpack_require__.p + "_/_/_/_/common-components/htmlplayer/images/acplayer-robot.png");

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("htmlplayer/images/acplayer-robot-title.png", __webpack_require__.p + "_/_/_/_/common-components/htmlplayer/images/acplayer-robot-title.png");

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(533))

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = "/*\n * Author: Alex Gibson\n * https://github.com/alexgibson/notify.js\n * License: MIT license\n */\n\n(function(global, factory) {\n    'use strict';\n\n    if (typeof define === 'function' && define.amd) {\n        // AMD environment\n        define(function() {\n            return factory(global, global.document);\n        });\n    } else if (typeof module !== 'undefined' && module.exports) {\n        // CommonJS environment\n        module.exports = factory(global, global.document);\n    } else {\n        // Browser environment\n        global.Notify = factory(global, global.document);\n    }\n} (typeof window !== 'undefined' ? window : this, function (w, d) {\n    'use strict';\n\n    var N = w.Notification;\n\n    function isFunction(item) {\n        return typeof item === 'function';\n    }\n\n    function Notify(title, options) {\n\n        if (typeof title !== 'string') {\n            throw new Error('Notify(): first arg (title) must be a string.');\n        }\n\n        this.title = title;\n\n        this.options = {\n            icon: '',\n            body: '',\n            tag: '',\n            lang: 'en',\n            notifyShow: null,\n            notifyClose: null,\n            notifyClick: null,\n            notifyError: null,\n            timeout: null,\n            requireInteraction: false,\n            closeOnClick: false,\n            silent: false\n        };\n\n        this.permission = null;\n\n        //User defined options for notification content\n        if (typeof options === 'object') {\n\n            for (var i in options) {\n                if (options.hasOwnProperty(i)) {\n                    this.options[i] = options[i];\n                }\n            }\n\n            //callback when notification is displayed\n            if (isFunction(this.options.notifyShow)) {\n                this.onShowCallback = this.options.notifyShow;\n            }\n\n            //callback when notification is closed\n            if (isFunction(this.options.notifyClose)) {\n                this.onCloseCallback = this.options.notifyClose;\n            }\n\n            //callback when notification is clicked\n            if (isFunction(this.options.notifyClick)) {\n                this.onClickCallback = this.options.notifyClick;\n            }\n\n            //callback when notification throws error\n            if (isFunction(this.options.notifyError)) {\n                this.onErrorCallback = this.options.notifyError;\n            }\n        }\n    }\n\n    // returns true if the browser supports Web Notifications\n    // https://developers.google.com/web/updates/2015/05/Notifying-you-of-notificiation-changes\n    // @param {perm} for test purposes only\n    Notify.isSupported = function(perm) {\n        if (!N || !N.requestPermission) {\n            return false;\n        }\n\n        if (perm === 'granted' || N.permission === 'granted') {\n            throw new Error('You must only call this before calling Notification.requestPermission(), otherwise this feature detect would trigger an actual notification!');\n        }\n\n        try {\n            new N('');\n        } catch (e) {\n            if (e.name === 'TypeError') {\n                return false;\n            }\n        }\n        return true;\n    };\n\n    // true if the permission is not granted\n    Notify.needsPermission = (N && N.permission && N.permission === 'granted') ? false : true;\n\n    // asks the user for permission to display notifications.  Then calls the callback functions is supplied.\n    Notify.requestPermission = function(onPermissionGrantedCallback, onPermissionDeniedCallback) {\n        N.requestPermission(function(perm) {\n            switch (perm) {\n                case 'granted':\n                    Notify.needsPermission = false;\n                    if (isFunction(onPermissionGrantedCallback)) {\n                        onPermissionGrantedCallback();\n                    }\n                    break;\n                case 'denied':\n                    Notify.needsPermission = true;\n                    if (isFunction(onPermissionDeniedCallback)) {\n                        onPermissionDeniedCallback();\n                    }\n                    break;\n            }\n        });\n    };\n\n\n    Notify.prototype.show = function() {\n        this.myNotify = new N(this.title, {\n            'body': this.options.body,\n            'tag': this.options.tag,\n            'icon': this.options.icon,\n            'lang': this.options.lang,\n            'requireInteraction': this.options.requireInteraction,\n            'silent': this.options.silent,\n            'closeOnClick': this.options.closeOnClick\n        });\n\n        if (!this.options.requireInteraction && this.options.timeout && !isNaN(this.options.timeout)) {\n            setTimeout(this.close.bind(this), this.options.timeout * 1000);\n        }\n\n        this.myNotify.addEventListener('show', this, false);\n        this.myNotify.addEventListener('error', this, false);\n        this.myNotify.addEventListener('close', this, false);\n        this.myNotify.addEventListener('click', this, false);\n    };\n\n    Notify.prototype.onShowNotification = function(e) {\n        if (this.onShowCallback) {\n            this.onShowCallback(e);\n        }\n    };\n\n    Notify.prototype.onCloseNotification = function(e) {\n        if (this.onCloseCallback) {\n            this.onCloseCallback(e);\n        }\n        this.destroy();\n    };\n\n    Notify.prototype.onClickNotification = function(e) {\n        if (this.onClickCallback) {\n            this.onClickCallback(e);\n        }\n\n        if (this.options.closeOnClick) {\n            this.close();\n        }\n    };\n\n    Notify.prototype.onErrorNotification = function(e) {\n        if (this.onErrorCallback) {\n            this.onErrorCallback(e);\n        }\n        this.destroy();\n    };\n\n    Notify.prototype.destroy = function() {\n        this.myNotify.removeEventListener('show', this, false);\n        this.myNotify.removeEventListener('error', this, false);\n        this.myNotify.removeEventListener('close', this, false);\n        this.myNotify.removeEventListener('click', this, false);\n    };\n\n    Notify.prototype.close = function() {\n        this.myNotify.close();\n    };\n\n    Notify.prototype.handleEvent = function(e) {\n        switch (e.type) {\n        case 'show':\n            this.onShowNotification(e);\n            break;\n        case 'close':\n            this.onCloseNotification(e);\n            break;\n        case 'click':\n            this.onClickNotification(e);\n            break;\n        case 'error':\n            this.onErrorNotification(e);\n            break;\n        }\n    };\n\n    return Notify;\n}));\n"

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(535))

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = "var _mpevt=_mpevt||[];\n(function(m,x,C){if(!(\"undefined\"!=typeof EtappTracker&&EtappTracker)){_mpevt=m._mpevt||[];var n={},q,B=this,r,p,v,s=function(a,g){\"mp_\"!=a.substring(0,3)&&(a=void 0!=g?\"mp_\"+g+\"_\"+a:\"mp_\"+a);var d=document.cookie,f=0;if(d)for(d=d.split(\"; \");f<d.length;f++)if(d[f]=d[f].split(\"=\",2),unescape(d[f][0])==a)return unescape(d[f][1]);return null},y=function(a,g,d){var f,b=[\"expires\",\"path\",\"domain\",\"secure\"],c=b.length,e;d=\"object\"==typeof d&&null!=d?d:{};f=escape(a)+\"=\"+escape(g);\"undefined\"==typeof d.domain&&\n(d.domain=\".\"+location.hostname.match(/([a-zA-Z0-9_-]+\\.[a-zA-Z0-9_-]+)[:0-9]*$/)[1]);\"undefined\"==typeof d.path&&(d.path=\"/\");if(d)for(;--c;)if(\"undefined\"!=typeof(e=d[b[c]])){if(\"secure\"==b[c])e=b[c];else if(\"expires\"==b[c]){if(!isNaN(e)){var u=new Date;u.setTime(u.getTime()+864E5*e);e=u.toGMTString()}}else e=b[c]+\"=\"+e;f+=\"; \"+e}document.cookie=f;return s(a)==g},z=function(a,g){var d,f,b,c,e;d=a.length&3;f=a.length-d;b=g;for(e=0;e<f;)c=a.charCodeAt(e)&255|(a.charCodeAt(++e)&255)<<8|(a.charCodeAt(++e)&\n255)<<16|(a.charCodeAt(++e)&255)<<24,++e,c=3432918353*(c&65535)+((3432918353*(c>>>16)&65535)<<16)&4294967295,c=c<<15|c>>>17,c=461845907*(c&65535)+((461845907*(c>>>16)&65535)<<16)&4294967295,b^=c,b=b<<13|b>>>19,b=5*(b&65535)+((5*(b>>>16)&65535)<<16)&4294967295,b=(b&65535)+27492+(((b>>>16)+58964&65535)<<16);c=0;switch(d){case 3:c^=(a.charCodeAt(e+2)&255)<<16;case 2:c^=(a.charCodeAt(e+1)&255)<<8;case 1:c^=a.charCodeAt(e)&255,c=3432918353*(c&65535)+((3432918353*(c>>>16)&65535)<<16)&4294967295,c=c<<15|\nc>>>17,b^=461845907*(c&65535)+((461845907*(c>>>16)&65535)<<16)&4294967295}b^=a.length;b^=b>>>16;b=2246822507*(b&65535)+((2246822507*(b>>>16)&65535)<<16)&4294967295;b^=b>>>13;b=3266489909*(b&65535)+((3266489909*(b>>>16)&65535)<<16)&4294967295;return(b^b>>>16)>>>0},k=function(a){var g=_mpevt.shift();if(\"function\"==typeof g)_mpevt.length&&(\"boolean\"!=typeof a||!a)&&p(k,0),g();else if(g){var d=g.shift(),f=d.indexOf(\".\"),b=-1<f?d.substr(0,f):\"\",c=n[b],c=c?c.methods:{};try{(c.methods||mpAnalytics(b))[d.substr(f+\n1)].apply(B,g)}catch(e){}_mpevt.length&&(\"boolean\"!=typeof a||!a)&&p(k,0)}},t=function(a,g,d,f,b,c,e){this.action=a;this.type=g;this.cookiename=d;this.maxcookiecount=b;this.id=f;this.context=c};t.prototype={constructor:t,rdata:function(){var a=\"\";this.action&&(a+=\"&action=\"+this.action);this.type&&(a+=\"&type=\"+this.type);this.id&&(a+=\"&id=\"+this.id);this.context&&\"\"!=this.context&&(a+=\"&context=\"+this.context);this.cookiename&&(a+=\"&cookiename=\"+this.cookiename);this.maxcookiecount&&(a+=\"&maxcookiecount=\"+\nthis.maxcookiecount);this.data&&(a+=\"&data=\"+this.data);return\"&\"===a.charAt(0)?a.slice(1):a}};m.addEventListener?(r=function(){for(;_mpevt.length;)k();removeEventListener(\"beforeunload\",r,!1);removeEventListener(\"message\",k,!1)},addEventListener(\"beforeunload\",r,!1),addEventListener(\"message\",k,!1)):m.attachEvent?(r=function(){for(;_mpevt.length;)k();detachEvent(\"onbeforeunload\",r);detachEvent(\"onmessage\",k,!1)},attachEvent(\"onbeforeunload\",r),attachEvent(\"onmessage\",k,!1)):q=!0;!q&&m.postMessage&&\n(!m.VBArray||x.querySelector||x.dMode)?p=function(){postMessage(\"_mpevt\",\"*\")}:q=!0;_mpevt.push.toString&&-1==_mpevt.push.toString().indexOf(\"_mpevt\")&&(_mpevt._mpevtpush=_mpevt.push,_mpevt.push=function(){_mpevt._mpevtpush.apply(_mpevt,arguments);p(k,0)});if(!p||q||!_mpevt.push.toString||-1==_mpevt.push.toString().indexOf(\"_mpevt\"))q=!0,p=setTimeout,v=function(){_mpevt.length&&k(!0);setTimeout(v,_mpevt.length?10:150)};EtappTracker=mpAnalytics=function(a){var g=0;a||(a=\"\",g=1);if(!n[a]){var d=0,f=\n0,b=g,c=\"https:\"==document.location.protocol?\"https://ctrack.trafficjunky.net/ctrack\":\"http://ctrack.trafficjunky.net/ctrack\",e={myhttpReqCreate:function(a){function b(){try{return new XMLHttpRequest}catch(a){}try{return new ActiveXObject(\"Msxml3.XMLHTTP\")}catch(u){}try{return new ActiveXObject(\"Msxml2.XMLHTTP.6.0\")}catch(c){}try{return new ActiveXObject(\"Msxml2.XMLHTTP.3.0\")}catch(D){}try{return new ActiveXObject(\"Msxml2.XMLHTTP\")}catch(d){}try{return new ActiveXObject(\"Microsoft.XMLHTTP\")}catch(e){}return null}\nreturn a.XDomainRequest?new XDomainRequest:b()},_http_send_request:function(a,b,c,h,d,e){if(\"GET\"===a){if(h&&\"function\"!==typeof h)throw\"callback shall be a function\";d=b+\"?\";d+=c;(new Image(1,1)).src=d;h&&h()}else{var f;if(\"undefined\"===e||null===e||\"boolean\"!==typeof e)e=!0;f=myhttpReqCreate(window);if(\"string\"!==typeof a&&(\"POST\"!==a||\"GET\"!==a))throw\"method request shall be 'POST' or 'GET'\";if(h&&\"function\"!==typeof h)throw\"callback shall be a function\";h&&(f.onreadystatechange=h);\"GET\"===a&&\n(b=b+\"?\"+c,c=null);f.open(a,b,e);if(void 0!=f.setRequestHeader&&d)for(h=0;h<d.length;h++)f.setRequestHeader(d[h].name,d[h].value);f.send(c)}},_getURL:function(){return c},_setURL:function(a){c=a},_getSiteID:function(){return d},_setSiteID:function(a){d=a},_setContext:function(a){_CONTEXT_ID=a},_getContext:function(){return _CONTEXT_ID},_setUID:function(a){f=a},_setSUID:function(a){},_seTenantID:function(a){},_setAppProductID:function(a,b){_APP_ID=a;_PRODUCT_ID=b},_eventSetIfLower:function(b,c){var d=\ns(b,a),h=!0;if(void 0==d||\"undefined\"==d||null==d)h=!0,d=c;else try{var f=parseInt(d);parseInt(c)>f?(d=c,h=!0):h=!1}catch(g){h=!0}h&&(e._setCookie(b,d,{duration:63072E6},a),e._sendevent(\"list\",\"add\",b,d))},_event:function(a,b,c){null==c?e._sendevent(\"list\",\"add\",a,b,10):e._sendevent(\"list\",\"add\",a,b,c)},_sendevent:function(d,f,A,h,g){try{var w;w=b?(new t(d,f,A,h,g,null,1,{})).rdata():(new t(d,f,A,h,g,a,1,{})).rdata();e._http_send_request(512>w.length?\"GET\":\"POST\",c,w,null,[{name:\"Content-Type\",value:\"application/x-www-form-urlencoded\"}],\n!1)}catch(l){}},_eventSample:function(b){if(b&&100*Math.random()<=b)return n[a].methods._event.apply(this,[].splice.call(arguments,1))},_setCookie:function(a,b,c,d,f){a=void 0!=d?\"mp_\"+d+\"_\"+a:\"mp_\"+a;void 0!=c&&(void 0!=c.duration&&void 0==c.expires)&&(c.expires=new Date((new Date).getTime()+parseInt(c.duration)));return y(a,b,\"object\"==typeof c&&c?c:{})},_startGoal:function(c,b,d,h,f,e){d||(d=1);var g=s(c);if(g)b=g;else if(n[a].methods._setCookie(c,b,{duration:d},f),h)return n[a].methods._event(c,\nb,h,1,null,null,5<arguments.length?e:null)},_trackGoal:function(c,b,d,h,e,g){var l=s(c);if(\"object\"==typeof h&&h){if(s(c+\"_\"+b+\"_once\"+(h.uid?\"_\"+f:\"\")))return;y(c+\"_\"+b+\"_once\"+(h.uid?\"_\"+f:\"\"),1,{duration:isNaN(h.duration)?0:h.duration})}if(\"function\"==typeof e&&e(c,l)||\"function\"!=typeof e&&l)return n[a].methods._event(c,l,b,\"object\"!=typeof arguments[2]||null!==arguments[2]?d:1,null,null,5<arguments.length?g:null)},_setGoalAction:function(c,b,d,e){d||(d=1);var f=s(c);f&&b!=f&&n[a].methods._setCookie(c,\nb,{duration:d},e)},_getOrTrackUser:function(){var c=z(\"\"+document.domain),b=parseInt((new Date).getTime()/1E3),d=s(\"u\"),e=\"\",f=!0;if(d){var g=d.split(\".\"),f=!1;try{if(g=d.split(\".\"),!(7>g.length)){var c=g[0],l=g[1],k=g[2],p=g[3],m=g[4],r=g[5],q=g[6],e=d;if(void 0==l||\"undefined\"==l||null==l||0==l)throw Error(\"Undefined visitorID\");1800<b-r?(e=c+\".\"+l+\".\"+k+\".\"+m+\".\"+b+\".\"+b+\".\"+(q+1),m=b):e=c+\".\"+l+\".\"+k+\".\"+p+\".\"+m+\".\"+b+\".\"+q}}catch(t){}}f&&(l=z(\"\"+Math.random()),e=c+\".\"+l+\".\"+b+\".\"+b+\".\"+b+\".\"+\nb+\".1\",m=b);n[a].methods._setCookie(\"u\",e,{duration:63072E6});n[a].methods._setSUID(m)}};n[a]={methods:e};n[a].methods._getOrTrackUser()}return n[a].methods};m.mpAnalytics=mpAnalytics;p(v||k,0)}})(window,document);"

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/** @param {Fox} fox */
module.exports = function (fox) {
	var $ = fox.jQuery;

	//@ts-ignore
	__webpack_require__(537);
	//@ts-ignore
	__webpack_require__(542)(fox);

	var NOT_VERIFIED_CLASS = 'not-verified';
	var VERIFIED_CLASS = 'verified';
	var VERIFICATION_SENT_CLASS = 'verification-sent';
	var VERIFICATION_FAILED_CLASS = 'verification-failed';
	var TIMEOUT = 10000;

	var storage = new fox.LocalStorageObjectService({
		lsLabel: '_evs_',
		cleanCheckInterval: null
	});

	var STATES = {
		NOT_VERIFIED: 0,
		VERIFIED: 1,
		SENT: 2,
		SENDING: 3,
		SEND_FAILED: 4,
		FAILED: 5,
		NONE: null
	};

	fox.registerWidget('EmailVerificationNotify', {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				autoRender: true,
				template: 'strip_notification',
				handleDom: {
					sendVerification: {
						target: '#send-verification',
						callback: 'sendEmailVerification'
					},
					scroll: {
						event: 'scroll',
						target: document,
						eventChecker: function eventChecker(_) {
							return _this.isEmbedded();
						},
						callback: function callback() {
							var bar = $(_this.dom1('.strip-notification-wrapper'));
							var barHeight = bar.height();
							var scrollTop = $(window).scrollTop();

							return scrollTop > barHeight + barHeight / 2 ? bar.addClass('sticky') : bar.removeClass('sticky');
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		init: function init() {
			this.userEmail = this.requireOption('getUserEmailCb');
			this.verified = this.requireOption('getVerificationStateCb');

			this.callParent('init', arguments);
		},
		prepareEmbeddedWidgets: function prepareEmbeddedWidgets() {
			this._bindData = {
				status: STATES.NOE,
				stripClass: '',
				opened: false
			};

			this.bindTemplateVariables(this._bindData, ['status', 'stripClass', 'opened']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},
		beforeRender: function beforeRender() {
			var stripClass = void 0;
			var status = void 0;

			switch (this.verified()) {
				case true:
					status = STATES.VERIFIED;
					stripClass = VERIFIED_CLASS;
					break;
				case null:
					status = STATES.FAILED;
					stripClass = VERIFICATION_FAILED_CLASS;
					break;
				default:
					status = STATES.NOT_VERIFIED;
					stripClass = NOT_VERIFIED_CLASS;
			}

			if (this.sendStatus) {
				if (this.sendStatus === STATES.SENDING) {
					stripClass = NOT_VERIFIED_CLASS;
					status = STATES.SENDING;
				} else if (this.sendStatus === STATES.SENT) {
					stripClass = VERIFICATION_SENT_CLASS;
					status = STATES.SENT;
				} else if (this.sendStatus === STATES.SEND_FAILED) {
					stripClass = VERIFICATION_FAILED_CLASS;
					status = STATES.SEND_FAILED;
				}
			}

			this._bindData.status = status;
			this._bindData.stripClass = stripClass;

			return this.callParent('beforeRender', arguments);
		},
		showStripIdNeeded: function showStripIdNeeded() {
			var _this2 = this;

			var show = function show(_) {
				_this2.wait('@root .Site_Layout', 'addedToDom').then(function (_) {
					return setTimeout(function (_) {
						return _this2.show();
					}, 1000);
				});
			};

			if (this._afterSendTimeout) return false;

			if (this.verified() === true) {
				var emailId = fox.getStringSimpleHash(this.userEmail(), 16);
				var availableInStorage = storage.getItem(emailId);

				if (!availableInStorage) {
					storage.setItem(emailId, {
						value: true
					});

					show();

					setTimeout(function (_) {
						_this2.hide().then(function (_) {
							return _this2.destroy();
						});
					}, TIMEOUT);
				} else {
					this.unmount();
					this.destroy();
				}
			} else if ([null, false].indexOf(this.verified()) !== -1) {
				show();

				if (this.verified() === null) {
					setTimeout(function (_) {
						return _this2.hide();
					}, TIMEOUT);
				}
			}
		},
		sendEmailVerification: function sendEmailVerification() {
			var _this3 = this;

			this._bindData.status = this.sendStatus = STATES.SENDING;

			var api = this.getApi('emailVerificationApi', {
				method: 'User_Verification.sendEmailConfirmation'
			});

			return api.psend().then(function (_) {
				return new fox.Promise(function (resolve) {
					_this3._bindData.status = _this3.sendStatus = STATES.SENT;

					setTimeout(resolve, TIMEOUT);
				});
			}).then(function (_) {
				_this3._bindData.status = _this3.sendStatus = STATES.NONE;
				_this3.verified = function () {
					return false;
				};
				_this3.hide();

				_this3._afterSendTimeout = setTimeout(function (_) {
					clearTimeout(_this3._afterSendTimeout);
					delete _this3._afterSendTimeout;

					_this3.show();
				}, TIMEOUT * 2);
			}).catch(function (e) {
				_this3._bindData.status = _this3.sendStatus = STATES.SEND_FAILED;
				_this3.verified = function () {
					return false;
				};

				setTimeout(function (_) {
					return _this3.hide();
				}, TIMEOUT);
			});
		},
		unmount: function unmount() {
			var myNode = fox.dom.selectFirst('#email-verification');

			if (myNode) {
				myNode.parentNode.removeChild(myNode);
			}
		},
		removeFromDom: function removeFromDom() {
			var _this4 = this;

			var args = fox.clone(arguments);

			return new fox.Promise(function (resolve) {
				setTimeout(function (_) {
					_this4.unmount();
					return resolve(true);
				}, 410);
			});
		},
		hide: function hide() {
			this._bindData.opened = false;
			return this.removeFromDom();
		},
		show: function show() {
			var _this5 = this;

			if (this.isEmbedded()) {
				return this._bindData.opened = true;
			}

			this.wait('addedToDom').then(function (_) {
				return _this5._bindData.opened = true;
			});
		},
		beforeEmbed: function beforeEmbed() {
			if (this.rwom1('@root #permissionManager').hasAccess('guestActual')) {
				return false;
			}

			return this.callParent('beforeEmbed', arguments);
		}
	});
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(538);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_index.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_index.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:strip-notification;src:url(" + __webpack_require__(539) + ") format(\"truetype\"),url(" + __webpack_require__(540) + ") format(\"woff\"),url(" + __webpack_require__(541) + "#strip-notification) format(\"svg\");font-weight:400;font-style:normal}[class*=\" strip-notification-icon\"],[class^=strip-notification-icon]{font-family:strip-notification!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;font-size:21px;vertical-align:middle;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.strip-notification-icon-email_sent{font-size:19px}.strip-notification-icon-email_sent:before{bottom:1px;position:relative;content:\"\\E900\"}.strip-notification-icon-email_search:before{content:\"\\E901\"}.strip-notification-icon-thumb_up:before{bottom:3px;position:relative;content:\"\\E902\"}.strip-notification-wrapper{position:relative;width:100%;box-shadow:0 1px 2px 1px rgba(0,0,0,.5);padding:15px 20px;min-height:54px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;transition:transform .4s;transform:translateY(-100%);z-index:15;box-sizing:border-box}.strip-notification-wrapper.sticky{position:fixed;left:0;right:0}.strip-notification-wrapper.opened{transform:translate(0)}.strip-notification-wrapper.verified{background-color:#6cb758}.strip-notification-wrapper.not-verified{background-color:#f3c045}.strip-notification-wrapper.verification-sent{background-color:#516dbd}.strip-notification-wrapper.verification-failed{background-color:#ee4949}.strip-notification-wrapper .strip-notification-icon-wrapper{display:inline-block}.strip-notification-wrapper .strip-notification-content{max-width:960px;margin:0 auto;min-height:100%;color:#fff;font-size:12px;line-height:14px;font-family:Arial,Helvetica,sans-serif}.strip-notification-wrapper .strip-notification-content,.strip-notification-wrapper .strip-notification-content .email-verification-item{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row;flex-flow:row;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}@media screen and (max-width:768px){.strip-notification-wrapper .strip-notification-content{font-size:11px}}.strip-notification-wrapper .strip-notification-content a{text-decoration:underline;cursor:pointer;color:#fff}.strip-notification-wrapper .strip-notification-content p{text-shadow:0 1px 1px rgba(0,0,0,.2);margin:0}.strip-notification-wrapper .strip-notification-content i{margin-right:15px}", ""]);

// exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/strip-notification/fonts/strip-notification.ttf?2a2d6v", __webpack_require__.p + "_/_/_/root/components/strip-notification/fonts/Lb-ytW7.ttf");

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/strip-notification/fonts/strip-notification.woff?2a2d6v", __webpack_require__.p + "_/_/_/root/components/strip-notification/fonts/3lUWgNL.woff");

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/strip-notification/fonts/strip-notification.svg?2a2d6v", __webpack_require__.p + "_/_/_/root/components/strip-notification/fonts/strip-notification.svg");

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("strip_notification", [["div",{"id":"email-verification","class":"&&0&& &&1&& strip-notification-wrapper"},[["div",{"class":"strip-notification-content"},[["div",{"class":"&&0&& email-verification-item"},[["div",{"class":"strip-notification-icon-wrapper"},[["i",{"class":"strip-notification-icon-email_search"}]]],["p",{},[["textNode",{"text":" You haven’t verified your email address yet. Please "}],["a",{"id":"send-verification"},[["textNode",{"text":"verify"}]]],["textNode",{"text":" your email address to get the best user experience. "}]]]],[["status","class",false,[{"name":"eq","params":["0"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":"&&0&& email-verification-item"},[["div",{"class":"strip-notification-icon-wrapper"},[["i",{"class":"strip-notification-icon-thumb_up"}]]],["p",{},[["textNode",{"text":" Congratulations, your email address has been successfully confirmed. "}]]]],[["status","class",false,[{"name":"eq","params":["1"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":"&&0&& email-verification-item"},[["div",{"class":"strip-notification-icon-wrapper"},[["i",{"class":"strip-notification-icon-email_sent"}]]],["p",{},[["textNode",{"text":" Thank you! A verification email has been sent. Please proceed through the link specified in the verification email. "}]]]],[["status","class",false,[{"name":"eq","params":["2"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":"&&0&& email-verification-item"},[["div",{"class":"strip-notification-icon-wrapper"},[["i",{"class":"strip-notification-icon-email_search"}]]],["p",{},[["textNode",{"text":" Sending verification link to email ... "}]]]],[["status","class",false,[{"name":"eq","params":["3"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":"&&0&& email-verification-item"},[["div",{"class":"strip-notification-icon-wrapper"},[["i",{"class":"strip-notification-icon-email_search"}]]],["p",{},[["textNode",{"text":" Error while sending. Current user is already verified. "}]]]],[["status","class",false,[{"name":"eq","params":["4"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":"&&0&& email-verification-item"},[["div",{"class":"strip-notification-icon-wrapper"},[["i",{"class":"strip-notification-icon-email_search"}]]],["if",{"notempty":""},[["p",{},[["textNode",{"text":" Oops. It seems that your verification link has expired. Please "}],["a",{"id":"send-verification"},[["textNode",{"text":"click here"}]]],["textNode",{"text":" to request a new verification link. "}]]],["else",{},[["p",{},[["textNode",{"text":" The link that you are trying to use has already expired. Please log in to request a new verification link. "}]]]]]],[["id","notempty",true,[],"member"]]]],[["status","class",false,[{"name":"eq","params":["5"]},{"name":"hideIfFalse","params":[]}],"bind"]]]]]],[["opened","class",false,[{"name":"empty","params":[]},{"name":"classIfFalse","params":["opened "]}],"bind"],["stripClass","class",false,[],"bind"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	"use strict";

	__webpack_require__(544)(fox);
	__webpack_require__(545)(fox);
};

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_notifications_manager_input", [["span",{"class":"site-checkbox"},[["if",{"empty":""},[["input",{"type":"checkbox","name":"","id":""},[],[["name","name",true],["name","id",true]]],["else",{},[["if",{"notempty":""},[["input",{"type":"checkbox","name":"","id":"","checked":""},[],[["name","name",true],["name","id",true]]]],[["state","notempty",true,[{"name":"eq","params":["checked"]}]]]],["if",{"notempty":"","addclass":"disabled"},[["input",{"type":"checkbox","name":"","id":"","checked":"","disabled":""},[],[["name","name",true],["name","id",true]]]],[["state","notempty",true,[{"name":"eq","params":["checked_disabled"]}]]]],["if",{"notempty":"","addclass":"disabled"},[["input",{"type":"checkbox","name":"","id":"","disabled":""},[],[["name","name",true],["name","id",true]]]],[["state","notempty",true,[{"name":"eq","params":["disabled"]}]]]]]]],[["state","empty",true]]],["span",{"class":"checkbox"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('UserNotificationsManager', {

		configure: function (options) {
			/*
				newVideo
				newPhotoset
				startLiveshow
				newPost
			*/
			this.registerOptions('', {
				autoRender: false,
				'embed.container': '#user-notitfications',
				template: 'user_notifications_manager',
				widgets: {
					getSettingsApi: {
						widget: 'Api',
						method: 'notification.getSettings'
					},
					setSettingsApi: {
						widget: 'Api',
						method: 'notification.setSettings'
					}
				},

				handleDom: {
					change: {
						target: 'input[type="checkbox"]',
						event: 'change',
						callback: '_setSettings'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.getSettings().then(function(params) {
				var pm = this.rwom1('@root #permissionManager');
				var data = params.params.answer.response;
				/*var data = {
					publishVideoEmail: 1,
					publishPhotosetEmail: 0,
					startLiveshowEmail: 0,
					publishBlogPostEmail: 0
				};*/

				fox.each(data, function(value, key) {
					if (value === 1) {
						return;
					}

					data[key] = 0;
				});

				if (!fox.isEmpty(pm.getMemberInfo('emailVerified'))) {
					data.emailVefied = true;
				}

				this.setTemplateOptions(data);
				this.render();
			}.bind(this))
			.catch(console.error);
			
			this.callParent('running', arguments);
		},

		getSettings: function() {
			return this.wom1('#getSettingsApi').psend({});
		},

		_setSettings: function() {
			var elms = this.dom('input[type="checkbox"]');
			var data = {};

			fox.each(elms, function(input) {
				data[input.name] = Number(input.checked);
			});

			this.setSettings(data);
		},

		setSettings: function(data) {

			this.wom1('#setSettingsApi').psend({events: data})
				.then(function() {
					this.dispatchEvent('saved');
				}.bind(this))
				.catch(function(err) {
					console.error(err);
				});
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	"use strict";

	__webpack_require__(547);
	__webpack_require__(549)(fox);
	__webpack_require__(550)(fox);
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(548);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_userProfile.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_userProfile.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".user-profile .user-profile-table table{line-height:25px;width:100%;border-collapse:collapse}.user-profile .user-profile-table table td{padding-top:12px;padding-bottom:12px;font-size:15px;border-bottom-width:1px;border-bottom-style:solid}@media screen and (min-width:768px){.user-profile .user-profile-table{margin-bottom:44px}.user-profile .user-profile-table table{width:500px}.user-profile .user-profile-table table tr td:first-child{width:190px}}", ""]);

// exports


/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_profile", [["table",{},[["tr",{},[["td",{},[["textNode",{"text":"Username"}]]],["td",{},[["span",{},[],[["login","__text",true]]]]]]],["tr",{},[["td",{},[["textNode",{"text":"Email"}]]],["td",{},[["span",{},[],[["email","__text",true]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('UserProfile', {

		configure: function (options) {
            var userData = fox.wom.selectFirst('~.PermissionManager').getMemberInfo();
			
			this.registerOptions('', {
				autoRender: true,
				'embed.container': '#user-profile',
                template: 'user_profile',
                templateOptions: userData
			});

			this.callParent('configure', arguments);
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	"use strict";

	__webpack_require__(552);
	__webpack_require__(554)(fox);
	__webpack_require__(555)(fox);
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(553);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_userPersonalData.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_userPersonalData.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".user-personal-data .personal-data-processing .data-row{-ms-flex-flow:row wrap;flex-flow:row wrap;margin-bottom:10px}.user-personal-data .personal-data-processing .data-row .date{margin-top:5px;margin-left:40px;width:100%;text-align:right;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.user-personal-data .user-communication>div{margin-bottom:10px}@media screen and (min-width:1024px){.user-personal-data .personal-data-processing .data-row{-ms-flex-flow:row nowrap;flex-flow:row nowrap}.user-personal-data .personal-data-processing .data-row label{width:730px}.user-personal-data .personal-data-processing .data-row .date{width:auto;margin-top:0}}", ""]);

// exports


/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_personal_data", [["div",{},[["import",{"name":"user_personal_data_tos"}],["span",{},[["span",{},[],[["tosDate","__text",true,[{"name":"dateFormat","params":["%H"]}]]]],["textNode",{"text":":"}],["span",{},[],[["personalDataProcessingAgreementsDate","__text",true,[{"name":"dateFormat","params":["%M, %d %b %Y"]}]]]]]]]],["div",{},[["import",{"name":"user_personal_data_notifications"}]]],["div",{},[["import",{"name":"user_personal_data_marketing"}]]]]);
fox.registerTemplate("user_personal_data_tos", [["label",{"for":"tos","class":"_flex"},[["span",{"class":"site-checkbox"},[["span",{"class":"r-sign"},[["textNode",{"text":"*"}]]],["if",{"notempty":""},[["input",{"class":"required-checkbox","type":"checkbox","name":"tos","id":"tos","checked":""}],["else",{},[["input",{"class":"required-checkbox","type":"checkbox","name":"tos","id":"tos"}]]]],[["tos","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"checkbox"}]]],["span",{"class":"label"},[["textNode",{"text":" By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}],["a",{"href":"/terms","target":"_blank"},[["textNode",{"text":"Terms of Use"}]]],["textNode",{"text":". "}]]]]]]);
fox.registerTemplate("user_personal_data_notifications", [["label",{"for":"notifications","class":"_flex"},[["span",{"class":"site-checkbox"},[["if",{"notempty":""},[["input",{"class":"communication-checkbox","type":"checkbox","name":"notifications","id":"notifications","checked":""}],["else",{},[["input",{"class":"communication-checkbox","type":"checkbox","name":"notifications","id":"notifications"}]]]],[["notifications","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"checkbox"}]]],["span",{"class":"label"},[["textNode",{"text":"I would like to receive content notifications and related emails from this site"}]]]]]]);
fox.registerTemplate("user_personal_data_marketing", [["label",{"for":"marketing","class":"_flex"},[["span",{"class":"site-checkbox"},[["if",{"notempty":""},[["input",{"class":"communication-checkbox","type":"checkbox","name":"marketing","id":"marketing","checked":""}],["else",{},[["input",{"class":"communication-checkbox","type":"checkbox","name":"marketing","id":"marketing"}]]]],[["marketing","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"checkbox"}]]],["span",{"class":"label"},[["textNode",{"text":"I agree to receive e-mails with special offers, news and updates from ModelCentro family of products"}]]]]]]);
fox.registerTemplate("user_personal_data_rows", [["div",{"class":"personal-data-processing"},[["div",{"class":"data-row _flex"},[["import",{"name":"user_personal_data_tos"}],["span",{"class":"date"},[["span",{},[],[["timestamp","__text",true,[{"name":"dateFormat","params":["%H"]}]]]],["textNode",{"text":":"}],["span",{},[],[["timestamp","__text",true,[{"name":"dateFormat","params":["%M,%d %b %Y"]}]]]]]]]]]]]);
fox.registerTemplate("user_communications_rows", [["div",{},[["import",{"name":"user_personal_data_marketing"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('UserPersonalData', {

		configure: function (options) {
			
			this.registerOptions('', {
				autoRender: false,
				'embed.container': '#user-personal-data',
                template: 'user_personal_data',
                widgets: {
                    updateApi: {
                        widget: 'Api',
                        method: 'consent.provideBulk',
                        httpMethod: 'post'
                    },
                    getSettingsApi: {
                        widget: 'Api',
                        method: 'consent.list'
                    }
                },
                handleDom: {
                    required: {
                        target: '.required-checkbox',
                        callback: '_showAttentionPopup'
                    },
                    change: {
                        target: '.communication-checkbox',
                        callback: '_change'
                    }
                }
			});

			this.callParent('configure', arguments);
		},

		running: function() {
            this.getSettings().then(this._renderData.bind(this));
            this.callParent('running', arguments);
		},

		getSettings: function() {
            return this.wom1('#getSettingsApi').psend({});
            // return fox.Promise.resolve({params: {answer: {response: {
            //     tos: 1,
            //     tosDate: new Date().getTime(),
            //     sestaFosta: 0,
            //     sestaFostaDate: new Date().getTime(),
            //     notifications: 1,
            //     marketing: 0
            // }}}});
        },
        
        _renderData: function(resp) {
            var data = resp.params.answer.response;

            data.timestamp *= 1000;
            
            this.setTemplateOptions(fox.merge(data, {modelName: fox.site.getEnv('screenName')})).render();
        },

        _showAttentionPopup: function(elm) {           
            fox.dom[(!elm.checked ? 'addClass' : 'removeClass')]('common-error-text-color', elm.parentNode.parentNode);
            
            if (!elm.checked) {

                this.showAttentionPopup().then(function(result) {
                    if (result === true) {
                        return;
                    }

                    fox.dom.removeClass('common-error-text-color', elm.parentNode.parentNode);
                    elm.checked = true;
                });

                return;
            }
        },

        showAttentionPopup: function() {
            return fox.site.rwom1('#gdprDeleteAccount').show()
        },

        _change: function(elm) {
            var elms = this.dom('input[type="checkbox"]');
            var data = {};

            fox.each(elms, function(elm) {
                data[elm.name] = Number(elm.checked);
            });

            return this.wom1('#updateApi')
                .psend({aliases: data});
        }

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	__webpack_require__(557);

	__webpack_require__(559)(fox);

	var require__js = __webpack_require__(560);
	require__js.keys().forEach(function (md) {
		return require__js(md)(fox);
	});

	fox.registerOptions('@root', {
		'widgets.liveshowNotificationBanner.widget': 'LiveshowNotificationBanner'
	}, true, {});

	fox.registerOptions('~.Layout_Home #notification', {
		externalHandler: function externalHandler(resp) {
			if ((resp.message || '').match(/Live\sShow/) !== null) {
				fox.site.rwom1('#liveshowNotificationBanner').show();

				return false;
			}

			return true;
		}
	}, true, {});
};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(558);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "[class*=\" ls-icon\"],[class^=ls-icon]{font-family:mc-icons-liveshow!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ls-iconsummer_20:before{content:\"\\E906\"}.ls-iconlove_18:before{content:\"\\E907\"}.ls-iconedit:before{content:\"\\E905\"}.ls-iconoff:before{content:\"\\E904\"}.ls-iconprivate-show:before{content:\"\\E901\"}.ls-iconpaid-show:before{content:\"\\E902\"}.ls-iconfree-show:before{content:\"\\E903\"}.ls-iconcrone:before{content:\"\\E900\"}.ls-iconconnectionlost:before{content:\"\\E800\"}.ls-iconsorryerror:before{content:\"\\E801\"}.ls-icongift:before{content:\"\\E614\"}.ls-iconthankyou:before{content:\"\\E60D\"}.ls-icontakesnapshot:before{content:\"\\E60E\"}.ls-iconshowpaused:before{content:\"\\E60F\"}.ls-iconls_mention:before{content:\"\\E610\"}.ls-iconclosegift:before{content:\"\\E611\"}.ls-iconimonline:before{content:\"\\E612\"}.ls-icontip:before{content:\"\\E613\"}.ls-iconblock:before{content:\"\\E600\"}.ls-iconcopy:before{content:\"\\E601\"}.ls-iconfscreen:before{content:\"\\E602\"}.ls-iconlsize:before{content:\"\\E603\"}.ls-iconmention:before{content:\"\\E604\"}.ls-iconmscreen:before{content:\"\\E605\"}.ls-iconpause:before{content:\"\\E606\"}.ls-iconplay:before{content:\"\\E607\"}.ls-iconsend:before{content:\"\\E608\"}.ls-iconssize:before{content:\"\\E609\"}.ls-iconstop:before{content:\"\\E60A\"}.ls-iconvol:before{content:\"\\E60B\"}.ls-iconvolmin:before{content:\"\\E60C\"}.ls-btn{display:inline-block;vertical-align:middle;position:relative;background-color:hsla(0,0%,100%,.15);cursor:pointer;padding:10px 11px;border-radius:2px;transition:background-color .2s;color:#fff;max-height:35px;font-size:11px;font-weight:700;text-transform:uppercase;box-sizing:border-box;height:35px;max-width:35px;min-width:39px;text-align:center;font-family:pt_sansbold,Arial;line-height:17px}.ls-btn:hover:not(:disabled):not(.disabled){background-color:hsla(0,0%,100%,.3)}button.ls-btn,input[type=submit].ls-btn{border:none}a.ls-btn{text-decoration:none}.ls-btn [class*=\" ls-icon\"],.ls-btn [class^=ls-icon]{position:relative;left:-7px;font-size:32px;line-height:14px}.ls-btn .ls-iconoff{font-size:21px;left:-1px}.ls-btn.btn-spinner{transition:margin .2s}.ls-btn.btn-spinner #spin-wrap{top:7px}.ls-btn.btn-spinner.spin #spin-wrap{margin-left:5px}.ls-btn.disabled,.ls-btn:disabled{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.ls-btn.toggle-fullscreen span{position:absolute;transition:transform .4s}.ls-btn.toggle-fullscreen .arr-1{transform:rotate(-180deg);left:11px}.ls-btn.toggle-fullscreen .arr-1,.ls-btn.toggle-fullscreen .arr-2{display:inline-block;width:6px;height:6px;border-style:solid;border-color:#e5e5e5;border-width:0 2px 2px 0;top:9px}.ls-btn.toggle-fullscreen .arr-2{transform:rotate(-90deg);right:11px}.ls-btn.toggle-fullscreen .arr-3{transform:rotate(0);right:11px}.ls-btn.toggle-fullscreen .arr-3,.ls-btn.toggle-fullscreen .arr-4{display:inline-block;width:6px;height:6px;border-style:solid;border-color:#e5e5e5;border-width:0 2px 2px 0;bottom:9px}.ls-btn.toggle-fullscreen .arr-4{transform:rotate(90deg);left:11px}.ls-btn.toggle-fullscreen:hover:not(.exit-f) .arr-1{transform:rotate(180deg) translate(1px,1px)}.ls-btn.toggle-fullscreen:hover:not(.exit-f) .arr-2{transform:rotate(-90deg) translate(1px,1px)}.ls-btn.toggle-fullscreen:hover:not(.exit-f) .arr-3{transform:rotate(0) translate(1px,1px)}.ls-btn.toggle-fullscreen:hover:not(.exit-f) .arr-4{transform:rotate(90deg) translate(1px,1px)}.ls-btn.toggle-fullscreen.exit-f .arr-1{transform:rotate(180deg) rotateX(180deg) translateX(-11px)}.ls-btn.toggle-fullscreen.exit-f .arr-2{transform:rotate(-90deg) rotateY(-180deg) translateY(-11px)}.ls-btn.toggle-fullscreen.exit-f .arr-3{transform:rotate(0) rotateX(-180deg) translateX(-11px)}.ls-btn.toggle-fullscreen.exit-f .arr-4{transform:rotate(90deg) rotateY(180deg) translateY(-11px)}.ls-btn.t-1{transition:min-width .2s,padding .2s,background-color .2s}.ls-btn.t-1:hover:not(:disabled):not(.disabled):not(.muted){min-width:85px;background-color:hsla(0,0%,100%,.15)}.ls-btn.t-2{font-size:14px;font-weight:700}.ls-btn.t-4{max-width:none}.ls-btn.volume{text-align:left;overflow:hidden}.ls-btn.volume .ls-iconvol{left:-8px;z-index:1}.ls-btn.volume .volume-slider{background-color:hsla(0,0%,100%,.3);width:40px;height:8px;display:inline-block;position:absolute;top:14px;left:40px}.ls-btn.volume .volume-slider .volume-progress{position:absolute;top:0;left:0;bottom:0;width:0;height:100%;transition:width .1s;background-color:#fff}.ls-input{display:inline-block;vertical-align:middle;position:relative;background-color:rgba(0,0,0,.15);border-radius:2px;border:1px solid hsla(0,0%,100%,.15);color:hsla(0,0%,100%,.3);padding:9px 11px;max-height:35px;font-size:12px}.ls-input.error{border-color:#d35853}.ls-tabs{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.ls-tabs .ls-tab-item{display:inline-block;vertical-align:middle;position:relative;background-color:rgba(0,0,0,.15);border-radius:2px;border:1px solid hsla(0,0%,100%,.15);color:hsla(0,0%,100%,.3);padding:9px 11px;max-height:35px;font-size:12px;padding-left:0;padding-right:0;background-color:transparent;transition:background-color .2s;text-transform:uppercase;cursor:pointer;color:#fff;-moz-flex:1 1;-ms-flex:1 1;flex:1 1;text-align:center;font-family:pt_sansbold;line-height:normal}.ls-tabs .ls-tab-item.error{border-color:#d35853}.ls-tabs .ls-tab-item:last-child{border-top-left-radius:0;border-bottom-left-radius:0;left:-1px}.ls-tabs .ls-tab-item.active{background-color:hsla(0,0%,100%,.15)}.ls-tabs .ls-tab-item .ls-tab-counter{font-size:9px;padding:5px;border-radius:2px;background-color:hsla(0,0%,100%,.15);position:relative;top:-1px}.ls-radiobutton{overflow:hidden;padding:3px 0}.ls-radiobutton,.ls-radiobutton .radio-btn-wrap{position:relative;display:inline-block;vertical-align:middle}.ls-radiobutton .radio-btn-wrap{width:20px;height:20px;border-radius:50%;background-color:transparent;border:2px solid hsla(0,0%,100%,.4);text-align:center;z-index:1;transition:background-color .2s}.ls-radiobutton .radio-btn-wrap .radio-btn-dot{border-radius:50%;background-color:#fff;position:absolute;display:inline-block;top:3px;right:3px;bottom:3px;left:3px;margin:auto;transition:transform .15s,background-color .2s;transform:scale(0)}.ls-radiobutton input[type=radio]{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;z-index:2;cursor:pointer}.ls-radiobutton input[type=radio]:checked+.radio-btn-wrap .radio-btn-dot{transform:scale(1)}.ls-radiobutton input[type=radio]:hover+.radio-btn-wrap{background-color:#7f7f7f}.ls-radiobutton input[type=radio]:disabled+.radio-btn-wrap{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.gift-btn i{font-size:16px;position:relative;top:-2px;margin-right:-10px;vertical-align:middle}.ls-btn.paid-request{font-size:11px;padding-left:20px;padding-right:20px}.ls-btn .ls-iconcrone{font-size:15px;vertical-align:middle;left:0;top:-1px;margin-right:5px}#liveshow-goal-container,#liveshow-goal-container *{box-sizing:border-box}#flash-player-liveshow+.content-report{display:none}#flash-player-liveshow[data-widget-alias=lsTranslator]+.content-report{display:block}.liveshow-goal-wrapper{text-align:center;font-family:pt_sansbold;padding:20px;margin-bottom:25px;border-radius:2px;position:relative;line-height:normal;word-wrap:break-word}.liveshow-goal-wrapper:before{content:\"\";position:absolute;width:0;height:0;border-style:solid;border-width:6px 6px 0;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;right:30px;bottom:-6px}.liveshow-overlay-wrapper{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,7%,.85);z-index:1}.liveshow-overlay-wrapper.liveshow-entry .model-status-wrapper{max-height:68%}.liveshow-overlay-wrapper.liveshow-entry .ls-btn{width:100%;max-width:100px}.liveshow-overlay-wrapper .model-status-wrapper{margin-top:8%}.liveshow-overlay-wrapper .model-status-wrapper .status-icon{width:104px;height:104px}.liveshow-overlay-wrapper .model-status-wrapper .status-icon img{border-radius:50%;max-width:100%;height:auto;vertical-align:top;display:block}.liveshow-overlay-wrapper .model-status-wrapper .status-title{line-height:32px;text-align:center}.liveshow-overlay-wrapper .model-status-wrapper .status-title ._tc-yellow{color:#e7eb35}.liveshow-overlay-wrapper .model-status-wrapper .status-desc{text-align:center}.liveshow-overlay-wrapper .model-status-wrapper .ls-btn{margin-top:25px;-moz-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto}.liveshow-overlay-wrapper.filled{background-color:#121212}[data-widget-alias=error]~.brc-main,[data-widget-alias=error]~.brc-side,[data-widget-alias=paidEntry]~.brc-main,[data-widget-alias=paidEntry]~.brc-side{filter:blur(3px)}.model-status-wrapper{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;z-index:5;max-width:85%;max-height:60%}.model-status-wrapper .status-icon{position:relative;width:82px;height:82px;border-radius:50%;margin-bottom:30px}.model-status-wrapper .status-icon i{font-size:82px}.model-status-wrapper .status-icon .line-1,.model-status-wrapper .status-icon .line-2{position:absolute;bottom:25px;width:60px;background-color:#fff;height:1px;display:block}.model-status-wrapper .status-icon .line-1{left:-70px}.model-status-wrapper .status-icon .line-2{right:-70px}.model-status-wrapper .status-title{text-transform:uppercase;text-align:center;font-weight:700;font-family:pt_sansbold,Arial;margin-bottom:15px;line-height:16px;filter:drop-shadow(2px 2px 1px rgba(0,0,0,.5))}.model-status-wrapper .status-desc{font-size:12px;font-family:pt_sansregular,Arial}.model-status-wrapper .status-desc.period-amount{font-size:14px;margin-top:50px}.model-status-wrapper.status-paused .status-title{margin-top:10px}.model-status-wrapper.status-donestatus-done .status-title,.model-status-wrapper.status-donestatus-done .status-title+.status-desc{margin-bottom:10px}.allowed-text{top:250px;position:absolute;margin:auto;max-width:85%;max-height:60%;z-index:2}.allowed-text .status-title a{text-decoration:underline}.brc-wrapper{position:relative;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row nowrap;flex-flow:row nowrap;font-family:pt_sansregular;max-height:553px}.brc-wrapper,.brc-wrapper *{box-sizing:border-box}.brc-wrapper.brc-fullscreen{position:fixed;width:100%;height:100%;top:0;right:0;bottom:0;left:0;margin:auto;z-index:13;max-height:none}.brc-wrapper.brc-fullscreen .brc-side .chat-list-scroll-wrapper,.brc-wrapper.brc-fullscreen .brc-side .fan-list-scroll-wrapper{max-height:100%}.brc-wrapper .brc-main{background-color:#000;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-moz-flex:2 0 auto;-ms-flex:2 0 auto;flex:2 0 auto}.brc-wrapper .brc-main .brc-player{position:relative;width:100%;min-height:478px;-moz-flex:1 auto;-ms-flex:1 auto;flex:1 auto}.brc-wrapper .brc-main .brc-player #splash-container{z-index:1}.brc-wrapper .brc-main .brc-player #splash-container .loading-ls{height:30px;padding-top:5px;padding-right:20px;color:#fff;position:absolute;bottom:0;right:0}.brc-wrapper .brc-main .brc-player .lst-container{position:absolute;width:100%;height:100%;top:0;left:0;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;z-index:1}.brc-wrapper .brc-main .brc-player .lst-container video{background:transparent!important}.brc-wrapper .brc-main .brc-control{position:relative;padding:20px;background-color:#262626;border-bottom-left-radius:2px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-align:center;-moz-align-items:center;align-items:center;max-height:75px}.brc-wrapper .brc-main .brc-control .tipme-container{overflow:hidden;transition:padding .2s;max-height:none}.brc-wrapper .brc-main .brc-control .tipme-container #tip-model,.brc-wrapper .brc-main .brc-control .tipme-container #toggle-gift-box,.brc-wrapper .brc-main .brc-control .tipme-container .ls-input{transition:opacity .2s}.brc-wrapper .brc-main .brc-control .tipme-container .ls-icongift,.brc-wrapper .brc-main .brc-control .tipme-container .ls-icontip{position:absolute;top:9px;left:4px}.brc-wrapper .brc-main .brc-control .tipme-container .ls-input{max-width:76px}.brc-wrapper .brc-main .brc-control .tipme-container .success-block{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;transition:transform .2s;transform:translateY(-100%)}.brc-wrapper .brc-main .brc-control .tipme-container .success-block .ls-btn{width:100%;max-width:100%;margin-left:0;-ms-filter:none;filter:none;opacity:1;padding-left:inherit}.brc-wrapper .brc-main .brc-control .tipme-container .success-block .ls-btn:before{content:\"\";position:absolute;width:0;height:0;border-style:solid;border-width:0 6px 6px;border-top-color:transparent;border-right-color:transparent;border-left-color:transparent;border-bottom-color:#6789b7;right:30px;top:-6px;transition:border-color .2s}.brc-wrapper .brc-main .brc-control .tipme-container.error .ls-input{border-color:#d35853}.brc-wrapper .brc-main .brc-control .tipme-container.tip-success{padding-top:6px;padding-bottom:6px}.brc-wrapper .brc-main .brc-control .tipme-container.tip-success #tip-model,.brc-wrapper .brc-main .brc-control .tipme-container.tip-success #toggle-gift-box,.brc-wrapper .brc-main .brc-control .tipme-container.tip-success .ls-input{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.brc-wrapper .brc-main .brc-control .tipme-container.tip-success .success-block{transform:translateY(6px)}.brc-wrapper .brc-main .brc-control .control-center,.brc-wrapper .brc-main .brc-control .control-left,.brc-wrapper .brc-main .brc-control .control-right{-moz-flex:1 auto;-ms-flex:1 auto;flex:1 auto}.brc-wrapper .brc-main .brc-control .control-right{text-align:right;min-width:100px}.brc-wrapper .brc-main .brc-control .control-right .gift-btn{width:100%;max-width:137px}.brc-wrapper .brc-main .brc-control .control-right .gift-btn span:nth-child(2),.brc-wrapper .brc-main .brc-control .control-right .gift-btn span:nth-child(3){display:none}.brc-wrapper .brc-main .brc-control .control-right .gift-btn.gift-box-opened{position:absolute;right:0;top:0;bottom:0;height:100%;max-height:none;background-color:#2d2d2d;border-top-right-radius:0;border-bottom-right-radius:0}.brc-wrapper .brc-main .brc-control .control-right .gift-btn.gift-box-opened span:first-child{display:none}.brc-wrapper .brc-main .brc-control .control-right .gift-btn.gift-box-opened span:nth-child(2){display:inline}.brc-wrapper .brc-main .brc-control .control-right .gift-btn.gift-box-paid-success:before{content:\"\";position:absolute;width:0;height:0;border-style:solid;border-width:0 6px 6px;border-top-color:transparent;border-right-color:transparent;border-left-color:transparent;right:30px;top:-6px;transition:border-color .2s}.brc-wrapper .brc-main .brc-control .control-right .gift-btn.gift-box-paid-success span:first-child{display:none}.brc-wrapper .brc-main .brc-control .control-right .gift-btn.gift-box-paid-success span:nth-child(3){display:inline}.brc-wrapper .brc-main .brc-control .control-right .gift-btn.gift-box-paid-success:disabled{-ms-filter:none;filter:none;opacity:1}.brc-wrapper .brc-main .brc-control .control-center{text-align:center;width:100%;max-width:40%;position:relative;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.brc-wrapper .brc-main .brc-control .control-center .ls-btn{width:40px;max-width:137px;margin-left:1px;padding-left:30px}.brc-wrapper .brc-main .brc-control .control-center #toggle-gift-box{margin-left:20px}.brc-wrapper .brc-main .brc-control .ls-btn.paid-leave{width:40px}.brc-wrapper .brc-main .brc-control .ls-btn.volume{margin:0 6px}.brc-wrapper .brc-main .brc-control .ls-btn.volume .ls-iconvolmin{position:absolute;top:10px;left:12px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:opacity .2s}.brc-wrapper .brc-main .brc-control .ls-btn.volume.muted{padding-left:6px}.brc-wrapper .brc-main .brc-control .ls-btn.volume.muted .ls-iconvolmin{-ms-filter:none;filter:none;opacity:1}.brc-wrapper .brc-side{position:relative;background-color:#2d2d2d;max-width:300px;min-width:300px;border-top-right-radius:2px;border-bottom-right-radius:2px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto}.brc-wrapper .brc-side[data-widget-alias=paidShowConfirmBody],.brc-wrapper .brc-side[data-widget-alias=tipsConfirmBody]{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.brc-wrapper .brc-side[data-widget-alias=paidShowConfirmBody] .confirm-tip-wrapper,.brc-wrapper .brc-side[data-widget-alias=tipsConfirmBody] .confirm-tip-wrapper{text-align:center;padding:20px}.brc-wrapper .brc-side[data-widget-alias=paidShowConfirmBody] .confirm-tip-wrapper .ls-btn,.brc-wrapper .brc-side[data-widget-alias=tipsConfirmBody] .confirm-tip-wrapper .ls-btn{font-size:11px;margin:0 5px}.brc-wrapper .brc-side[data-widget-alias=paidShowConfirmBody] .confirm-tip-wrapper .confirm-message-body,.brc-wrapper .brc-side[data-widget-alias=tipsConfirmBody] .confirm-tip-wrapper .confirm-message-body{margin:10px 0}.brc-wrapper .brc-side[data-widget-alias=paidShowConfirmBody] .ls-rates-list,.brc-wrapper .brc-side[data-widget-alias=tipsConfirmBody] .ls-rates-list{margin:0 0 10px;font-size:12px;text-align:left}.brc-wrapper .brc-side[data-widget-alias=paidShowConfirmBody] .ls-rates-list .ls-title,.brc-wrapper .brc-side[data-widget-alias=tipsConfirmBody] .ls-rates-list .ls-title{text-align:center}.brc-wrapper .brc-side[data-widget-alias=paidShowConfirmBody] .ls-rates-list .rate-item-desc,.brc-wrapper .brc-side[data-widget-alias=tipsConfirmBody] .ls-rates-list .rate-item-desc{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.brc-wrapper .brc-side[data-widget-alias=paidShowConfirmBody] .ls-rates-list .rate-item,.brc-wrapper .brc-side[data-widget-alias=tipsConfirmBody] .ls-rates-list .rate-item{margin:20px 0}.brc-wrapper .brc-side[data-widget-alias=paidShowConfirmBody] .ls-rates-list .rate-item-desc-row,.brc-wrapper .brc-side[data-widget-alias=tipsConfirmBody] .ls-rates-list .rate-item-desc-row{display:inline-block;vertical-align:top;margin-left:15px}.brc-wrapper .brc-side .sidebar-main-wrapper{position:relative;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start}.brc-wrapper .brc-side .brc-sections{padding:20px;padding-bottom:0;-moz-flex:1 1;-ms-flex:1 1;flex:1 1}.brc-wrapper .brc-side .brc-message{padding:20px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row nowrap;flex-flow:row nowrap;min-height:75px}.brc-wrapper .brc-side .brc-message .ls-input{-moz-flex:1 auto;-ms-flex:1 auto;flex:1 auto;margin-right:5px}.brc-wrapper .brc-side #sidebar-main-container{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;position:absolute;top:0;right:0;bottom:0;left:0;padding:20px 20px 0;margin-top:50px}.brc-wrapper .brc-side #sidebar-main-container[data-widget-alias=tabChat]{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}.brc-wrapper .brc-side #sidebar-main-container[data-widget-alias=tabFans]{-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start}.brc-wrapper .brc-side .fan-list-scroll-wrapper{max-height:423px}.brc-wrapper .brc-side .fan-list-scroll-wrapper .user-item{font-size:12px;height:24px;margin-bottom:5px;padding:4px 0;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.brc-wrapper .brc-side .fan-list-scroll-wrapper .user-item .ls-btn{max-height:24px;max-width:30px;min-width:inherit}.brc-wrapper .brc-side .fan-list-scroll-wrapper .user-item .ls-btn i{top:-6px;left:-12px}.brc-wrapper .brc-side .fan-list-scroll-wrapper .user-item.model,.brc-wrapper .brc-side .fan-list-scroll-wrapper .user-item.model .ls-btn i{color:#6789b7}.brc-wrapper .brc-side .fan-list-scroll-wrapper .user-item:first-child{margin-top:5px}.brc-wrapper .brc-side .fan-list-scroll-wrapper .user-item:last-child{margin-bottom:0}.brc-wrapper .brc-side .fan-list-scroll-wrapper .user-item .user-name{font-weight:700}.brc-wrapper .brc-side .chat-list-scroll-wrapper{max-height:405px}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row{margin-bottom:5px}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row .msg-content{word-break:break-word}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.from-model{margin-left:20px}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.from-model .user-name{color:#6789b7}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-1{position:relative;margin:25px 0}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-1:first-child{margin-top:25px}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-1:last-child{margin-bottom:25px}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-1 .msg-bubble{padding:20px 50px 20px 25px;max-width:80%;border-radius:2px}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-1 .msg-bubble .gift-amount{font-size:16px;margin-bottom:5px}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-1 .msg-bubble .gift-amount strong{font-family:pt_sansbold,Arial}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-1 .msg-bubble .gift-amount i{position:relative;top:-3px;margin-right:5px;vertical-align:middle;line-height:14px;font-size:32px;margin-left:-8px}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-1 .gift{width:100px;height:100px;border-radius:50%;border-width:3px;border-style:solid;background-repeat:no-repeat;background-position:50%;position:absolute;bottom:50%;margin-bottom:-50px;right:0;z-index:1;background-color:#2d2d2d}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-2{border-radius:2px;text-align:center;padding:2px 0;min-height:35px;margin:10px 0}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-2 i{font-size:32px;vertical-align:middle;position:relative;top:-1px}.brc-wrapper .brc-side .chat-list-scroll-wrapper .msg-row.type-4{border-radius:2px;text-align:center;background-color:hsla(0,0%,100%,.15);padding:8px 15px;margin:15px 0}.ls-title{font-size:16px;font-family:pt_sansbold,Arial;text-transform:uppercase}.brc-wrapper .brc-side .brc-sections.giftbox-wrapper{padding-top:35px;padding-bottom:35px;text-align:center}.brc-wrapper .brc-side .brc-sections.giftbox-wrapper .gift-btn{font-size:11px;max-width:137px;width:100%}.brc-wrapper .brc-side .brc-sections.giftbox-wrapper .loading-gifts{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3;text-align:center;-moz-flex:1 1;-ms-flex:1 1;flex:1 1}#ls-send-message:hover .ls-iconsend{animation:send-icon-hover 1s}@media screen and (max-width:768px){.brc-wrapper:not(.brc-fullscreen){-ms-flex-flow:column nowrap;flex-flow:column nowrap;display:block;max-height:973px}.brc-wrapper:not(.brc-fullscreen) .brc-main .control-right{min-width:auto}.brc-wrapper:not(.brc-fullscreen) .brc-main .control-center{max-width:50%}.brc-wrapper:not(.brc-fullscreen) .brc-side{max-width:none}.brc-wrapper:not(.brc-fullscreen) .brc-side .chat-list-scroll-wrapper,.brc-wrapper:not(.brc-fullscreen) .brc-side .fan-list-scroll-wrapper{height:270px;max-height:270px}.brc-wrapper:not(.brc-fullscreen) .brc-side .chat-list-scroll-wrapper{max-width:97%}.brc-wrapper:not(.brc-fullscreen) .brc-side .chat-list-scroll-wrapper .msg-row.type-1{max-width:60%}.brc-wrapper:not(.brc-fullscreen) .brc-side[data-widget-alias=paidShowConfirmBody],.brc-wrapper:not(.brc-fullscreen) .brc-side[data-widget-alias=tipsConfirmBody]{min-height:370px}.brc-wrapper:not(.brc-fullscreen) .brc-side[data-widget-alias=paidShowConfirmBody] .confirm-tip-wrapper .confirm-message-body,.brc-wrapper:not(.brc-fullscreen) .brc-side[data-widget-alias=tipsConfirmBody] .confirm-tip-wrapper .confirm-message-body{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.brc-wrapper:not(.brc-fullscreen) .brc-side[data-widget-alias=giftBox]{min-height:470px}.brc-wrapper:not(.brc-fullscreen) .brc-side #sidebar-main-container{position:relative;padding:0;margin-top:20px}.brc-wrapper:not(.brc-fullscreen) .brc-side .ls-rates-list{margin-left:auto!important;margin-right:auto!important;max-width:80%}}@media screen and (max-width:520px){.brc-wrapper .brc-main .brc-player{min-height:380px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}.brc-wrapper .brc-main .brc-control .control-center #toggle-gift-box{margin-left:2px}.brc-wrapper .brc-main .brc-control .tipme-container .ls-input{max-width:50px}.toggle-fullscreen{display:none}.paid-request .ls-iconcrone{margin-right:0}.paid-request span{display:none}}.ls-chat-mention{background-color:rgba(231,235,53,.3);border-radius:3px;padding:1px 1px 0;display:inline-block}.ls-chat-mention .ls-chat-mention-name{color:#e7eb35;font-weight:700}.ls-in-progress-label{transition:font-size .6s}.volume:hover~.ls-in-progress-label{font-size:14px}@media screen and (max-width:580px){.ls-notification .upbs-content .ls-thumbnail,.ls-notification .upbs-content .upbs-model-avatar{display:none}}.chat-list-scroll-wrapper .msg-row.type-1 .msg-bubble,.chat-list-scroll-wrapper .msg-row.type-2,.control-right .gift-btn.gift-box-paid-success,.liveshow-goal-wrapper,.ls-btn.t-2,.ls-btn.t-3{background-color:#6789b7}.ls-btn.t-2:hover:not(:disabled):not(.disabled){background-color:rgba(103,137,183,.7)}.chat-list-scroll-wrapper .msg-row,.confirm-tip-wrapper .confirm-message-body,.fan-list-scroll-wrapper .user-item,.gift-list .gift-item,.liveshow-goal-wrapper,.ls-title,.model-status-wrapper{color:#fff}.brc-control .tipme-container .ls-input,.chat-list-scroll-wrapper .msg-row.type-1 .gift{border-color:#6789b7}.control-right .gift-btn.gift-box-paid-success:before{border-bottom-color:#6789b7}.liveshow-goal-wrapper:before{border-top-color:#6789b7}", ""]);

// exports


/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("liveshow_viewer_goal", [["div",{"class":"liveshow-goal-wrapper"},[["p",{},[["span",{},[],[["goalText","__text",true]]]]]]]]);
fox.registerTemplate("liveshow_player_overlayed_error", [["div",{"class":"liveshow-overlay-wrapper"},[["if",{"empty":"","addclass":"filled"},[["div",{"class":"model-status-wrapper _flex _col-n _c-v-center _c-h-center"},[["div",{"class":"status-icon"},[["i",{"class":"ls-iconsorryerror"}]]],["div",{"class":"status-title _fs-32"},[["textNode",{"text":"Sorry"}]]],["if",{"notempty":""},[["div",{"class":"status-desc"},[["textNode",{"text":" The action you are trying to perform requires "}],["strong",{},[["textNode",{"text":"Adobe Flash Player"}]]],["textNode",{"text":" technology, which is currently disabled or blocked in your browser. "}],["br"],["textNode",{"text":"Please activate Flash by following the step-by-step instructions for your browser on "}],["a",{"target":"_blank","rel":"nofollow","href":"https://helpx.adobe.com/flash-player.html"},[["textNode",{"text":"Adobe’s help resource"}]]],["textNode",{"text":". "}]]],["else",{},[["div",{"class":"status-desc"},[["textNode",{"text":" The attempt to start this Live Show resulted in an error. Please try to refresh the page. In case the error occurs again, please contact the customer support department. "}]]]]]],[["code","notempty",true,[{"name":"eq","params":["app.notsupport"]}]]]],["div",{"class":"status-desc"},[["strong",{},[["textNode",{"text":"Error code: "}],["span",{},[],[["code","__text",true]]]]]]],["button",{"id":"refresh-page","class":"ls-btn t-2 t-4"},[["textNode",{"text":"refresh page"}]]]]],["else",{},[["if",{"notempty":"","addclass":"filled"},[["div",{"class":"model-status-wrapper _flex _col-n _c-v-center _c-h-center"},[["div",{"class":"status-icon"},[["i",{"class":"ls-iconsorryerror"}]]],["div",{"class":"status-title _fs-32"},[["textNode",{"text":"Sorry"}]]],["div",{"class":"status-desc"},[["textNode",{"text":" I'm sorry, but it appears that you don't have enough funds on your credit card in order to join my show. Please make sure to contact billing support if you need more information. "}]]]]],["else",{},[["div",{"class":"model-status-wrapper _flex _col-n _c-v-center _c-h-center"},[["div",{"class":"status-icon"},[["i",{"class":"ls-iconconnectionlost"}]]],["div",{"class":"status-title _fs-32"},[["textNode",{"text":"You were disconnected"}]]],["div",{"class":"status-desc"},[["textNode",{"text":" Please check your internet connection and try to restart your show. In case the error occurs again, please contact the customer support department. "}]]],["div",{"class":"status-desc"},[["strong",{},[["textNode",{"text":"Error code: "}],["span",{},[],[["code","__text",true]]]]]]],["button",{"id":"restart-liveshow","class":"ls-btn t-2 t-4"},[["textNode",{"text":"restart live show"}]]]]]]]],[["code","notempty",true,[{"name":"inList","params":["5008,empty.balance"]}]]]]]]],[["code","empty",true,[{"name":"inList","params":["804,5002,5003,5004,5005,5006,5007,empty.balance"]}]]]]]]]);
fox.registerTemplate("liveshow_player_overlayed_paid_entry", [["div",{"class":"liveshow-overlay-wrapper liveshow-entry"},[["div",{"class":"model-status-wrapper _flex _col-n _c-v-center _c-h-center"},[["if",{"notempty":""},[["div",{"class":"status-icon"},[["img",{"src":"","alt":"avatar"},[],[["socialImage","src",true,[],"env"]]],["textNode",{"text":" "}],["span",{"class":"line-1"}],["textNode",{"text":" "}],["span",{"class":"line-2"}]]]],[["socialImage","notempty",true,[],"env"]]],["div",{"class":"status-title _fs-32"},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["else",{},[["if",{"notempty":""},[["textNode",{"text":" ENTER YOUR PRIVATE SHOW "}]],[["paidType","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":""},[["textNode",{"text":" MY GROUP SHOW HAS STARTED "}]],[["paidType","notempty",true,[{"name":"eq","params":["2"]}]]]]]]],[["title","notempty",true]]]]],["if",{"notempty":""},[["div",{"class":"status-desc"},[["textNode",{"text":" "}],["span",{},[],[["desc","__text",true]]],["textNode",{"text":" "}]]]],[["desc","notempty",true]]],["div",{"class":"status-desc period-amount"},[["if",{"notempty":""},[["strong",{},[["textNode",{"text":"Enjoy instant access to my private show for $"}],["span",{},[],[["amount","__text",true]]],["textNode",{"text":"/minute"}]]]],[["paidType","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":""},[["strong",{},[["textNode",{"text":"Enjoy instant access to my awesome personal group show for $"}],["span",{},[],[["amount","__text",true]]],["textNode",{"text":"/minute"}]]]],[["paidType","notempty",true,[{"name":"eq","params":["2"]}]]]],["p",{"class":"vat-eu"},[["textNode",{"text":"You may be charged VAT if you are in EU."}]]]]],["button",{"id":"entry-resume","class":"btn-spinner ls-btn t-2 t-4"},[["div",{"id":"spin-wrap","class":"small back-1"},[["div",{"id":"spin"}]]],["textNode",{"text":" enter "}]]]]]]]]);
fox.registerTemplate("liveshow_player_model_status", [["div",{"class":""},[["div",{"class":"liveshow-overlay-wrapper _ofl-hidden"},[["div",{"class":"_img-contain _abs-fill","style":"background-image:url(&&0&&);"},[],[["thumbnail","style",false,[],"bind"]]],["div",{"class":"_abs-fill","style":"\n\t\t\t\t\t\t\t\t\t\topacity: &&0&&;\n\t\t\t\t\t\t\t\t\t\tbackground: url(&&1&&) center no-repeat;\n\t\t\t\t\t\t\t\t\t\tz-index: 1;\n\t\t\t\t\t\t\t\t\t"},[],[["thumbnail","style",false,[{"name":"empty","params":[]},{"name":"and","params":["1"]},{"name":"or","params":["0.7"]}],"bind"],["defThumbnail","style",false,[],"bind"]]]]],["div",{"class":"model-status-wrapper _flex _col-n _c-v-end _c-h-center _p-b-50","style":"opacity: &&0&&;"},[["div",{"class":"status-title _fs-40"},[["textNode",{"text":"My Live Show"}]]],["div",{"class":"status-title _fs-32 _m-t-20"},[["textNode",{"text":"is in "}],["span",{"class":"_tc-green"},[["textNode",{"text":"progress"}]]]]],["div",{"class":"allowed-text _flex _col-n _c-v-end _c-h-center _p-b-50 &&0&&"},[["div",{"class":""},[["div",{"class":"status-title _fs-20 _m-t-20"},[["textNode",{"text":"for "}],["span",{"class":"_tc-green"},[["textNode",{"text":"Free "}]]],["textNode",{"text":" and "}],["span",{"class":"_tc-gold"},[["textNode",{"text":"Premium "}]]],["textNode",{"text":" Users"}]]]],[["allowedGroups","class",true,[{"name":"eq","params":["2"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":""},[["div",{"class":"status-title _fs-20 _m-t-20"},[["textNode",{"text":"only for "}],["span",{"class":"_tc-gold"},[["textNode",{"text":"Premium "}]]],["textNode",{"text":" Users"}]]]],[["allowedGroups","class",true,[{"name":"eq","params":["1"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":"status-title _fs-14"},[["textNode",{"text":"if you would like to watch this show - please subscribe "}],["a",{"class":"_tc-white","href":"/join"},[["textNode",{"text":" here"}]]]]]],[["allowedGroups","class",false,[{"name":"hideIfFalse","params":[]}],"bind"]]]],[["thumbnail","style",false,[{"name":"empty","params":[]},{"name":"and","params":["1"]},{"name":"or","params":["0.7"]}],"bind"]]]],[["status","class",true,[{"name":"eq","params":["progress"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":""},[["div",{"class":"liveshow-overlay-wrapper _ofl-hidden &&0&&"},[["div",{"class":"_img-contain _blur-10 _abs-fill","style":"background-image:url(&&0&&)"},[],[["thumbnail","style",false,[],"bind"]]]],[["thumbnail","class",false,[{"name":"empty","params":[]},{"name":"hideIfTrue","params":[]}],"bind"]]],["div",{"class":"model-status-wrapper status-paused _flex _col-n _c-v-center _c-h-center"},[["div",{"class":"status-icon"},[["i",{"class":"ls-iconprivate-show"}]]],["div",{"class":"status-title _fs-32"},[["span",{"class":""},[["textNode",{"text":" Starting your private show "}]],[["isRequester","class",true,[{"name":"hideIfFalse","params":[]}],"bind"]]],["textNode",{"text":" "}],["span",{"class":""},[["textNode",{"text":" I'm currently in a private show "}]],[["isRequester","class",true,[{"name":"hideIfTrue","params":[]}],"bind"]]]]]]]],[["status","class",true,[{"name":"eq","params":["private"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":""},[["div",{"class":"model-status-wrapper status-done _flex _col-n _c-v-center _c-h-center"},[["div",{"class":"status-icon"},[["i",{"class":"ls-iconthankyou"}]]],["div",{"class":"status-title _fs-32"},[["textNode",{"text":"thank you"}]]],["div",{"class":"status-desc"},[["textNode",{"text":"for taking time to view the show!"}]]],["div",{"class":"status-desc"},[["textNode",{"text":"Hope you enjoyed it!"}]]],["div",{"class":"status-desc"},[["textNode",{"text":"See you next time!"}]]]]]],[["status","class",true,[{"name":"eq","params":["done"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":""},[["div",{"class":"_flex loading-ls"},[["div",{"class":"status-title _fs-10"},[["textNode",{"text":"Loading..."}]]]]]],[["status","class",true,[{"name":"eq","params":["loading"]},{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":""},[["div",{"class":"liveshow-overlay-wrapper _ofl-hidden"},[["div",{"class":"_abs-fill","style":"background:url(&&0&&) center no-repeat;"},[],[["bannedImage","style",false,[],"bind"]]]]],["div",{"class":"model-status-wrapper _flex _col-n _c-v-end _c-h-center _p-b-50"},[["div",{"class":"status-title _fs-40"},[["span",{},[],[["site.alias","__text",true,[],"env"]]]]],["div",{"class":"status-title _fs-28 _m-t-20"},[["textNode",{"text":"has "}],["span",{"class":"_tc-err"},[["textNode",{"text":"blocked"}]]],["textNode",{"text":" you "}]]],["div",{"class":"status-title _fs-28 _m-t-10"},[["textNode",{"text":" from viewing this show "}]]]]]],[["status","class",true,[{"name":"eq","params":["banned"]},{"name":"hideIfFalse","params":[]}],"bind"]]]]);
fox.registerTemplate("liveshow_content_tipme", [["input",{"placeholder":"$2","id":"tip-amount","type":"text","class":"ls-input"}],["textNode",{"text":" "}],["button",{"class":"ls-btn t-2 t-4","id":"tip-model"},[["span",{"class":"ls-icontip"}]]]]);
fox.registerTemplate("ls_private_control", [["if",{"notempty":""},[["button",{"disabled":"","id":"paid-request","class":"ls-btn t-4 t-2 paid-request"},[["i",{"class":"ls-iconcrone"}],["span",{},[["textNode",{"text":"go private"}]]]]]],[["state","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":""},[["button",{"disabled":"","title":"Leave private","id":"paid-leave","class":"ls-btn t-4 paid-leave"},[["i",{"class":"ls-iconoff"}]]]],[["state","notempty",true,[{"name":"eq","params":["2"]}]]]]]);
fox.registerTemplate("ls_viewer_sidebar_main_fan_list_row", [["li",{"class":"user-item"},[["if",{"notempty":"","addclass":"model"},[],[["isBroadcaster","notempty",true]]],["strong",{"class":"user-name"},[["span",{},[],[["name","__text",true]]]]],["div",{"data-user-id":"","class":"user-actions"},[["button",{"id":"send-to-user","class":"ls-btn t-4"},[["i",{"class":"ls-iconmention"}]]]],[["uid","data-user-id",true]]]]]]);
fox.registerTemplate("ls_viewer_sidebar_main_fan_list_container", [["div",{"class":"fan-list-scroll-wrapper"},[["ul",{"id":"fan-list-container"}]]]]);
fox.registerTemplate("ls_viewer_sidebar_main_chat_list_row", [["div",{"class":"msg-row"},[["if",{"empty":""},[["if",{"notempty":"","addclass":"from-model"},[],[["isBroadcaster","notempty",true]]],["if",{"notempty":""},[["strong",{"class":"user-name"},[["span",{},[],[["name","__text",true]]],["textNode",{"text":": "}]]]],[["name","notempty",true]]],["span",{"class":"msg-content"},[["if",{"notempty":""},[["span",{"class":"ls-chat-mention"},[["span",{"class":"ls-chat-mention-name"},[["span",{},[],[["mention","__text",true]]],["textNode",{"text":": &nbsp;"}]]],["textNode",{"text":" Sorry honey, can't do the show right now. Please message me to arrange for a specific date/time. "}]]],["else",{},[["textNode",{"text":" "}],["span",{},[],[["text","__text",true,[{"name":"transformLinks","params":[]},{"name":"html","params":["iframe","frame","video","audio","img","image","picture","form","input","textarea","button","canvas","select","object","option","legend","progress","meter","keygen","embed","body","style","link"]}]]]],["textNode",{"text":" "}]]]],[["requestResponse","notempty",true]]]]]],[["type","empty",true]]],["if",{"notempty":"","addclass":"type-1"},[["div",{"class":"msg-bubble"},[["div",{"class":"gift-amount"},[["i",{"class":"ls-icongift"}],["textNode",{"text":" "}],["strong",{},[["textNode",{"text":"$"}],["span",{},[],[["price","__text",true]]]]]]],["span",{},[["textNode",{"text":"New gift from "}],["span",{},[],[["name","__text",true]]]]]]],["div",{"class":"gift &&0&&"},[],[["gift","class"]]]],[["type","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":"","addclass":"type-2"},[["div",{"class":"msg-bubble"},[["i",{"class":"ls-icontip"}],["textNode",{"text":" "}],["span",{},[["span",{},[],[["name","__text",true]]],["textNode",{"text":" has just tipped $"}],["span",{},[],[["price","__text",true]]]]]]]],[["type","notempty",true,[{"name":"eq","params":["2"]}]]]],["if",{"notempty":"","addclass":"type-4"},[["if",{"notempty":""},[["textNode",{"text":" Welcome to a private session! "}]],[["text","notempty",true,[{"name":"eq","params":["intro"]}]]]],["if",{"notempty":""},[["textNode",{"text":" Your private session has ended. "}]],[["text","notempty",true,[{"name":"eq","params":["outro"]}]]]]],[["type","notempty",true,[{"name":"eq","params":["4"]}]]]]]]]);
fox.registerTemplate("ls_viewer_sidebar_main_chat_list_container", [["div",{"class":"chat-list-scroll-wrapper"},[["div",{"id":"chat-list-container","class":"ls-chat-wrapper"}]]]]);
fox.registerTemplate("ls_viewer_sidebar_main", [["div",{"class":"_abs-fill _z-index-1 &&0&&"},[],[["isAllowed","class",false,[{"name":"hideIfTrue","params":[]}],"bind"]]],["div",{"class":"brc-sections sidebar-main-wrapper &&0&&"},[["div",{"class":"ls-tabs"},[["if",{"notempty":""},[["if",{"notempty":""},[["div",{"data-tab-id":"chat","class":"ls-tab-item active"},[["textNode",{"text":"private chat"}],["if",{"notempty":""},[["textNode",{"text":" with "}],["span",{},[],[["screenName","__text",true,[],"env"]]]],[["hideFans","notempty",true]]]]],["else",{},[["div",{"data-tab-id":"chat","class":"ls-tab-item active"},[["textNode",{"text":"chat"}]]]]]],[["private","notempty",true]]],["else",{},[["div",{"data-tab-id":"chat","class":"ls-tab-item active"},[["textNode",{"text":"chat"}]]]]]],[["public.ppmEnabled","notempty",true,[],"env"]]],["if",{"empty":""},[["div",{"data-tab-id":"fans","class":"ls-tab-item"},[["textNode",{"text":" users online "}],["span",{"class":"ls-tab-counter"},[["textNode",{"text":"0"}]]]]]],[["hideFans","empty",true]]]]],["div",{"id":"sidebar-main-container"}]],[["isAllowed","class",false,[{"name":"classIfFalse","params":["_blur-4 _ofl-hidden"]}],"bind"]]],["div",{"class":"brc-message &&0&&"},[["input",{"type":"text","id":"message-body","class":"ls-input"}],["textNode",{"text":" "}],["button",{"id":"ls-send-message","class":"ls-btn"},[["span",{"class":"ls-iconsend"}]]]],[["isAllowed","class",false,[{"name":"classIfFalse","params":["_blur-4 _ofl-hidden"]}],"bind"]]]]);
fox.registerTemplate("ls_viewer_sidebar_giftbox_list_row", [["if",{"empty":""},[["li",{"data-gid":"","class":"gift-item &&1&&"},[["textNode",{"text":" $"}],["span",{},[],[["price","__text",true]]],["textNode",{"text":" "}]],[["id","data-gid",true],["alias","class"]]],["else",{},[["li",{"class":"loading-gifts ls-title"},[["textNode",{"text":"loading gifts..."}]]]]]],[["loader","empty",true]]]]);
fox.registerTemplate("ls_viewer_sidebar_giftbox", [["div",{"class":"brc-sections giftbox-wrapper"},[["div",{"class":"ls-title"},[["textNode",{"text":"select a gift"}]]],["ul",{"id":"gift-list-container","class":"gift-list"}],["button",{"id":"send-gift","class":"btn-spinner ls-btn t-4 t-2 gift-btn"},[["div",{"id":"spin-wrap","class":"small back-1"},[["div",{"id":"spin"}]]],["i",{"class":"ls-icongift"}],["textNode",{"text":" SEND A GIFT "}]]]]]]);
fox.registerTemplate("ls_viewer_sidebar_tip_confirm", [["div",{"class":"confirm-tip-wrapper"},[["div",{"class":"ls-title"},[["textNode",{"text":"confirm"}]]],["p",{"class":"confirm-message-body"},[["textNode",{"text":"You are about to tip "}],["span",{},[],[["site.title","__text",true,[],"env"]]],["textNode",{"text":" "}],["strong",{},[["textNode",{"text":"$"}],["span",{},[],[["amount","__text",true]]]]]]],["p",{"class":"confirm-message-body"},[["textNode",{"text":"You may be charged VAT if you are in EU."}]]],["if",{"notempty":""},[["div",{"class":"_flex _col-n _c-h-center _m-b-10"},[["input",{"style":"min-width:200px;","type":"text","class":"ls-input _m-b-5","name":"email","placeholder":"Email"}],["textNode",{"text":" "}],["input",{"style":"min-width:200px;","type":"text","class":"ls-input","name":"login","placeholder":"Login"}]]]],[["member","notempty",true,[{"name":"hasAccess","params":["guestActual"]}]]]],["button",{"id":"cancel-tip","class":"ls-btn t-4"},[["textNode",{"text":"cancel"}]]],["textNode",{"text":" "}],["button",{"id":"confirm-tip","class":"btn-spinner ls-btn t-4 t-2"},[["div",{"id":"spin-wrap","class":"small back-1"},[["div",{"id":"spin"}]]],["textNode",{"text":" confirm "}]]]]]]);
fox.registerTemplate("ls_viewer_sidebar_paidrequest_confirm", [["div",{"class":"confirm-tip-wrapper"},[["if",{"notempty":""},[["div",{"class":"ls-title"},[["textNode",{"text":"ENTER FULL SHOW"}]]],["if",{"empty":""},[["p",{"class":"confirm-message-body"},[["textNode",{"text":"Your request was sent. Please wait while I review it."}]]],["else",{},[["p",{"class":"confirm-message-body"},[["textNode",{"text":" The attempt to send request resulted in an error. Please try to refresh the page. In case the error occurs again, please contact the customer support department. "}],["strong",{},[["textNode",{"text":"Error code: "}],["span",{},[],[["errorCode","__text",true]]]]]]]]]],[["errorCode","empty",true]]],["div",{"class":"ls-rates-list"}],["button",{"id":"cancel-paid","class":"ls-btn t-4"},[["textNode",{"text":"close"}]]],["else",{},[["div",{"class":"ls-title"},[["textNode",{"text":"ENTER FULL SHOW"}]]],["p",{"class":"confirm-message-body"},[["textNode",{"text":"Join my private, one-on-one show in one click!"}]]],["div",{"class":"ls-rates-list confirm-message-body"},[["if",{"notempty":""},[["div",{"class":"ls-title"},[["textNode",{"text":"loading rates..."}]]]],[["state","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":""},[["foreach",{"from":"","item":"rate"},[["div",{"class":"rate-item"},[["label",{"for":"mca-&&0&&","class":"ls-radiobutton"},[["if",{"notempty":""},[["input",{"checked":"checked","name":"paidShowType","type":"radio","id":"mca-&&0&&","value":"&&1&&:&&2&&:&&3&&"},[],[["rate._iteration","id"],["rate.typeAlias","value"],["rate.amount","__internal"],["rate.id","__internal"]]],["else",{},[["input",{"name":"paidShowType","type":"radio","id":"mca-&&0&&","value":"&&1&&:&&2&&:&&3&&"},[],[["rate._iteration","id"],["rate.typeAlias","value"],["rate.amount","__internal"],["rate.id","__internal"]]]]]],[["rate.typeAlias","notempty",true,[{"name":"eq","params":["private"]}]]]],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["div",{"class":"rate-item-desc-row"},[["if",{"notempty":""},[["strong",{},[["textNode",{"text":"Private show ($"}],["span",{},[],[["rate.amount","__text",true]]],["textNode",{"text":"/minute)"}]]],["p",{"class":"vat-eu"},[["textNode",{"text":"You may be charged VAT if you are in EU."}]]]],[["rate.typeAlias","notempty",true,[{"name":"eq","params":["private"]}]]]],["if",{"notempty":""},[["strong",{},[["textNode",{"text":"Group show ($"}],["span",{},[],[["rate.amount","__text",true]]],["textNode",{"text":"/minute)"}]]],["p",{"class":"vat-eu"},[["textNode",{"text":"You may be charged VAT if you are in EU."}]]]],[["rate.typeAlias","notempty",true,[{"name":"eq","params":["public"]}]]]],["div",{"class":"rate-item-desc"},[["if",{"notempty":""},[["textNode",{"text":" Personal session "}]],[["rate.typeAlias","notempty",true,[{"name":"eq","params":["private"]}]]]],["if",{"notempty":""},[["textNode",{"text":" Other fans may join and chat with me "}]],[["rate.typeAlias","notempty",true,[{"name":"eq","params":["public"]}]]]]]]]]],[["rate._iteration","for"]]]]]],[["rates","from",true]]]],[["state","notempty",true,[{"name":"eq","params":["2"]}]]]]]],["button",{"id":"cancel-paid","class":"ls-btn t-4"},[["textNode",{"text":"cancel"}]]],["textNode",{"text":" "}],["button",{"id":"confirm-paid","class":"btn-spinner ls-btn t-4 t-2"},[["if",{"empty":"","addattr":"disabled"},[],[["rates","empty",true]]],["div",{"id":"spin-wrap","class":"small back-1"},[["div",{"id":"spin"}]]],["textNode",{"text":" confirm "}]]]]]],[["state","notempty",true,[{"name":"eq","params":["3"]}]]]]]]]);
fox.registerTemplate("liveshow_palyer_container", [["div",{},[["div",{"id":"liveshow-goal-container"}],["div",{"class":"brc-wrapper"},[["div",{"id":"overlay-container"}],["div",{"class":"brc-main"},[["div",{"class":"brc-player"},[["div",{"id":"splash-container"}],["div",{"id":"lst-container","class":"lst-container"}]]],["div",{"class":"brc-control"},[["div",{"class":"control-left"},[["button",{"id":"toggle-fullscreen","class":"ls-btn toggle-fullscreen","disabled":""},[["span",{"class":"arr-1"}],["textNode",{"text":" "}],["span",{"class":"arr-2"}],["textNode",{"text":" "}],["span",{"class":"arr-3"}],["textNode",{"text":" "}],["span",{"class":"arr-4"}]]],["textNode",{"text":" "}],["span",{"id":"volume-change","class":"ls-btn t-1 volume disabled"},[["span",{"class":"ls-iconvol"}],["textNode",{"text":" "}],["span",{"class":"ls-iconvolmin"}],["textNode",{"text":" "}],["span",{"class":"volume-slider"},[["span",{"class":"volume-progress"}]]]]],["if",{"notempty":""},[["a",{"href":"/join","class":"ls-btn t-4 t-2 paid-request _m-l-10 &&0&&"},[["span",{},[["textNode",{"text":"join live show now"}]]]],[["showJoinBtn","class",false,[{"name":"hideIfFalse","params":[]}],"bind"]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]],["button",{"id":"request-private","class":"ls-btn t-4 paid-request _m-l-10 &&0&&"},[["i",{"class":"ls-iconcrone"}],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"go private"}]]]],[["showPrivateBtn","class",false,[{"name":"hideIfFalse","params":[]}],"bind"]]],["textNode",{"text":" "}],["span",{"class":"ls-in-progress-label _fs-16 _m-l-20 _tc-white &&0&&"},[["textNode",{"text":"Live show in progress"}]],[["showInProgressData","class",false,[{"name":"hideIfFalse","params":[]}],"bind"]]]]],["div",{"class":"tipme-container control-center &&0&&"},[["div",{"class":"success-block"},[["button",{"class":"ls-btn t-2 t-4"},[["span",{},[["textNode",{"text":"thank you"}]]]]]]],["div",{"id":"tipme-form"}],["if",{"empty":""},[["button",{"id":"toggle-gift-box","class":"ls-btn t-4"},[["i",{"class":"ls-icongift"}]]]],[["member","empty",true,[{"name":"hasAccess","params":["guestActual"]}]]]]],[["isAllowed","class",false,[{"name":"hideIfFalse","params":[]}],"bind"]]],["div",{"class":"control-right &&0&&"},[["div",{"id":"private-control-container"}],["div",{"id":"content-report","class":"item content-report-wrapper content-report"}]],[["isAllowed","class",false,[{"name":"hideIfFalse","params":[]}],"bind"]]]]]]],["div",{"id":"sidebar-container","class":"brc-side"}]]]]]]);
fox.registerTemplate("streamate_iframe", [["div",{"class":"popup_streamate"},[["iframe",{"width":"100%","height":"1200px","src":"","frameborder":"0"},[],[["link","src",true]]]]]]);
fox.registerTemplate("guest_private_request_popup_content", [["div",{},[["textNode",{"text":"Do you agree with the rate?"}]]]]);
fox.registerTemplate("liveshow_notification_banner", [["div",{"class":"upbs-wrapper opened ls-notification","style":"\n\t\t\ttransform:translate(0, &&0&&) !important;\n\t\t\ttransition-duration: &&1&&ms;\n\t\t"},[["div",{"class":"upbs-content _flex _row-n _r-h-start _r-v-center","style":"width: 100%;"},[["div",{"class":"upbs-model-avatar _m-r-20 &&0&&","style":"background-image:url(&&1&&)"},[],[["thumbnail","class",false,[{"name":"empty","params":[]},{"name":"hideIfFalse","params":[]}],"bind"],["socialImage","style",false,[],"env"]]],["div",{"class":"ls-thumbnail _m-r-20 &&0&&","style":"\n\t\t\t\t\twidth:200px;\n\t\t\t\t\theight:133px;\n\t\t\t\t\tposition:relative;\n\t\t\t\t"},[["div",{"class":"_abs-fill _img-cover","style":"background-image:url(&&0&&);"},[],[["thumbnail","style",false,[],"bind"]]]],[["thumbnail","class",false,[{"name":"empty","params":[]},{"name":"hideIfTrue","params":[]}],"bind"]]],["div",{"class":"_flex-1"},[["div",{"class":"_fs-28"},[["textNode",{"text":" MY LIVE SHOW IS IN PROGRESS NOW! "}]]],["div",{"class":"_m-t-10 _m-b-10"},[["textNode",{"text":"My Live Show just started! Don't miss it!"}]]],["div",{"class":"_flex _row-w _r-h-start"},[["a",{"href":"/&&0&&","class":"ls-btn t-4 t-2 paid-request _m-v-5 _m-r-10"},[["textNode",{"text":" join live show now "}]],[["showJoinButton","href",false,[{"name":"empty","params":[]},{"name":"and","params":["liveshow"]},{"name":"or","params":["join"]}],"bind"]]],["textNode",{"text":" "}],["button",{"id":"request-private","class":"ls-btn t-4 paid-request _m-v-5 &&0&&"},[["i",{"class":"ls-iconcrone"}],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"go private"}]]]],[["showPrivateRequestBtn","class",false,[{"name":"hideIfFalse","params":[]}],"bind"]]]]]]],["div",{"id":"goto-liveshow-link","class":"_flex _row-n _r-v-end _r-h-end","style":"height:100%;"},[["a",{"class":"_tc-white","href":"/liveshow"},[["textNode",{"text":"Go to the live show page"}]]]]],["i",{"id":"close-upgrade-banner","class":"ls-iconclosegift close-upgrade-banner"}],["textNode",{"text":" "}],["i",{"id":"pulldown-upgrade-banner","class":"icon-arrow-middle-left pulldown-upgrade-banner"}]]]],[["position","style",false,[],"bind"],["transitionDuration","style",false,[],"bind"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ClientLSGoal.js": 561,
	"./ClientLSTranslator.es.js": 562,
	"./FakeChat.es.js": 570,
	"./NotificationBanner.es.js": 571
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 560;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {

	fox.registerWidget('ClientLSGoal', {

		configure: function () {
			this.goalText = false;
			this.previosGoal = false;

			this.registerOptions('', {
				'embed.container': '#liveshow-goal-container',
				template: 'liveshow_viewer_goal',
				autoRender: true
			});

			this.callParent('configure', arguments);
		},

		setGoal: function (text) {
			this.previosGoal = this.goalText;
			this.goalText = text;

			this.render();
		},

		unsetGoal: function () {
			this.goalText = false;

			if (this.isEmbedded()) {
				this.removeFromDom();
			}
		},

		rendering: function() {
			this.setTemplateOptions('goalText', this.goalText);

			this.callParent('rendering', arguments);
		},

		beforeEmbed: function () {
			if (this.goalText) {
				this.callParent('beforeEmbed', arguments);
			} else if (!this.goalText && this.previosGoal) {
				this.removeFromDom();
			}
		},

		deactivate: function() {
			this.callParent('deactivate', arguments);

			this.unsetGoal();
		}
	}, 'Widget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

module.exports = function (fox) {
  var $ = fox.jQuery;
  var AutoLoginService = __webpack_require__(15)(fox);
  var _ = __webpack_require__(563);
  var configure = __webpack_require__(564)(fox, _);
  var callbacks = __webpack_require__(565)(fox, _);
  var chatMethods = __webpack_require__(566)(fox, _);
  var billingMethods = __webpack_require__(567)(fox, _);
  var isAllowedMethod = __webpack_require__(51)(fox);

  fox.registerWidget('ClientLSTranslator', fox.mixin({
    _prepareWebrtcTranslation: function _prepareWebrtcTranslation(params) {
      var _this = this;

      return new fox.Promise(function (resolve) {
        _this._prepareWebrtcTranslationResolve = resolve;
        _this.sendMessageToModel({
          text: _this.getPrepareWebrtcTranslationToken(),
          dataset: params
        });
      });
    },

    running: function running() {
      this.autoLoginService = new AutoLoginService(this);
      this.settings = {};
      this._chatConnectionStates = {};
      this._prepareWebrtcTranslationResolve = null;

      this.los = new fox.LocalStorageObjectService({
        lsLabel: '_lstrhs_',
        cleanCheckInterval: 1000 * 60 * 60 * 24
      });

      var forceWebrtc = !fox.isEmpty(localStorage.getItem('_forcewebrtc_'));
      this.controller = this.createController(forceWebrtc, false, {
        onEvent: this._onEvent.bind(this),
        onError: this.onError.bind(this),
        debug: true /* __DEV__ */
      });

      this.callParent('running', arguments);
    },
    prepareEmbeddedWidgets: function prepareEmbeddedWidgets() {
      this._bindData = {
        status: null,
        showJoinBtn: false,
        showInProgressData: false,
        showPrivateBtn: false,
        isAllowedThis: false,
        isAllowedSidebar: false,
        thumbnail: '',
        defThumbnail: __webpack_require__(568),
        bannedImage: __webpack_require__(569),
        isRequester: false,
        allowedGroups: false

      };

      this.bindTemplateVariables(this._bindData, ['isAllowedThis', 'showJoinBtn', 'showInProgressData', 'showPrivateBtn'], ['isAllowed']);
      this.rwom1('#status').bindTemplateVariables(this._bindData, ['status', 'thumbnail', 'isRequester', 'defThumbnail', 'bannedImage', 'allowedGroups']);
      this.rwom1('#sidebarMain').bindTemplateVariables(this._bindData, ['isAllowedSidebar'], ['isAllowed']);

      this.callParent('prepareEmbeddedWidgets', arguments);
    },
    beforeRender: function beforeRender() {
      this.setTemplateOptions('private', !!this.connectParams.private);

      this.callParent('beforeRender', arguments);
    },
    toggleGoPrivateBtn: function toggleGoPrivateBtn(disabled) {
      if (!this.rwom1('#privateControl').isEmbedded()) return false;

      return this.toggleButton(this.connectParams.private ? '#paid-leave' : '#paid-request', !!disabled);
    },
    setConnectParams: function setConnectParams(params) {
      this.callParent('setConnectParams', arguments);

      if (params.streamName) this.connectParams.streamName = params.streamName;

      if (params.stunServer) this.connectParams.stunServer = params.stunServer;

      if (params.paid) this.connectParams.paid = params.paid;

      if (params.private) this.connectParams.private = params.private;

      if (params.trustedHash) this.connectParams.trustedHash = params.trustedHash;

      if (params.host) this.connectParams.server = params.host;

      return this;
    },
    getConnectParams: function getConnectParams() {
      var params = this.callParent('getConnectParams', arguments);
      var pm = this.rwom1('@root #permissionManager');

      if (pm.hasAccess('free') || pm.hasAccess('member')) params.viewerId = this.getMemberInfo('id');

      return params;
    },
    initApp: function initApp() {
      if (this.callParent('initApp', arguments) !== false) {
        var $container = $(this.controller._view).parent();

        this.setOption('flashWidth', $container.width());
        this.setOption('flashHeight', $container.height());
      }
    },
    manageStatusBanners: function manageStatusBanners(banner) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this._bindData.status === 'banned' && !force) return false;

      this._bindData.status = banner;
    },
    checkTrustedHash: function checkTrustedHash() {
      if (this.connectParams.trustedHash) return fox.objectGet(this.los.getItem(this.connectParams.trustedHash), 'value') === this.getChatUserId();

      return false;
    },
    _getEventCallbacks: function _getEventCallbacks() {
      return ['stream_viewer_play_started', 'stream_viewer_play_stopped', 'stream_viewer_metadata'];
    },
    entryAccessGranted: function entryAccessGranted(btn) {
      var _this2 = this;

      $(btn).toggleClass(_.DOM_CLASS_SPIN);

      return this.checkPayer({ rateId: this.settings.rateId }, $(btn)).then(function () {
        var entry = _this2.rwom1('#paidEntry');

        entry.deactivate();
        entry.removeFromDom();

        return _this2.startPlay();
      }).catch(function (resp) {
        _this2.treatError({ id: resp.params.answer.code });
      });
    },
    startPlay: function startPlay() {
      var _this3 = this;

      var connectParams = this.getConnectParams();

      this.manageStatusBanners('loading');
      this._log("Manage Status banners loading", this.manageStatusBanners('loading'));
      this.switchTabs('chat');

      return this.connectToChat().then(function () {
        _this3.controller.play(_extends({}, connectParams, {
          prepareStreamCb: function prepareStreamCb() {
            return _this3._prepareWebrtcTranslation.apply(_this3, arguments);
          }
        }));
      });
    },
    volumeChange: function volumeChange(el, alias, scope, event) {
      var $progress = $(this.dom1('.volume-progress'));
      var fw = $(el).width();
      var ds = Math.abs($(el).offset().left - event.clientX);
      var diff = parseInt(ds / fw * 100);

      this.controller.setVolume(diff);
      this.setUiVolumeLevel(diff);
    },
    setUiVolumeLevel: function setUiVolumeLevel(level) {
      var $level = $(this.dom1('.volume-progress'));

      fox.utils.localStorage('setItem', '_lsvl_', level);

      $level.width(level + '%');

      if (level === 0) {
        $level.parents('.ls-btn').addClass('muted');
      } else {
        $level.parents('.ls-btn').removeClass('muted');
      }
    },
    toggleFullscreen: function toggleFullscreen(btn) {
      function getNotificationViewer() {
        return fox.wom.select('~.NotificationViewer').filter(function (w) {
          return w.isActive() === true;
        }).pop();
      }

      var $btn = $(btn),
          $c = $(this.dom1('.brc-wrapper')),
          ntfv = getNotificationViewer(),
          cl = this.rwom1('#sidebarMain #tabChat'),
          chat = fox.site.wom1('#throughChatWindow');

      if (this.fullscreen === false) {
        this.setFullscreen();

        if (ntfv) {
          ntfv.deleteAll();
        }

        if (chat && chat.isEmbedded()) {
          $(chat.element).hide();
        }
      } else {
        this.exitFullscreen();

        if (chat && chat.isEmbedded()) {
          $(chat.element).show();
        }
      }

      $btn.toggleClass('exit-f');
      $c.toggleClass('brc-fullscreen');

      if (cl.isActive()) {
        cl.updateScrollbar();
      }

      if (this.streamInfo !== undefined) {
        this.setFlashSize(this.streamInfo);
      }
    },
    switchTabs: function switchTabs(alias) {
      var _this4 = this;

      var sidebar = this.rwom1('#sidebarMain');
      var fullAlias = 'tab' + fox.ucfirst(alias);

      if (!sidebar.isActive()) {
        this.wait(sidebar, 'addedToDom').then(function () {
          return _this4.switchTabs(alias);
        });
        return this.switchEmbeddedWidget('sidebarMain');
      }

      sidebar.switchEmbeddedWidget(fullAlias);
    },
    _onPaidSuccessfully: function _onPaidSuccessfully() {
      var $c = $(this.dom1('.control-center'));

      $c.addClass(_.DOM_CLASS_TIPSUCCESS);

      setTimeout(function () {
        $c.removeClass(_.DOM_CLASS_TIPSUCCESS);
      }, _.TIMER_THANKYOU);
    },
    toggleGiftBox: function toggleGiftBox(el, alias) {
      function getBtn() {
        return $(this.dom1(_.DOM_SELECTOR_SENDGIFTBTN));
      }

      var gb = this.rwom1('#giftBox');

      if (!gb.isActive()) {
        if (alias !== 'giftPaidSuccess') {
          this.switchEmbeddedWidget('giftBox');
        }
      } else {
        this.switchEmbeddedWidget('sidebarMain');
        this.updateFansAmount(false, this.rwom1('.Widget #tabFans'));
      }

      if (alias === 'giftPaidSuccess') {
        this._onPaidSuccessfully();
      }
    },
    updateFansAmount: function updateFansAmount(params, performer) {
      function setAmount(a, performer) {
        var $c = $(performer.dom1('.ls-tab-counter'));

        $c.text(a);
      }

      var amount = performer.getUsersAmount();

      if (performer.getParent().isEmbedded()) {
        setAmount(amount, performer.getParent());
      } else {
        performer.getParent().wait('addedToDom').then(function (resp) {
          setAmount(amount, resp.performer);
        });
      }
    },
    giftSended: function giftSended() {
      this.toggleGiftBox(this.dom1('#toggle-gift-box'));
    },
    getFullscreenMargins: function getFullscreenMargins() {
      return _.fm;
    },
    setStreamInfo: function setStreamInfo(info) {
      this.streamInfo = {
        w: info.width,
        h: info.height
      };

      return this.streamInfo;
    },
    _resetStates: function _resetStates() {
      var sm = this.rwom1('#sidebarMain');
      var pe = this.rwom1('#paidEntry');
      var er = this.rwom1('#error');

      sm.rwom1('#tabChat').reset();
      sm.rwom1('#tabFans').reset();
      this.manageStatusBanners(false);
      this.togglePrivateControl(3);

      if (pe.isEmbedded()) pe.removeFromDom();

      if (er.isEmbedded()) er.removeFromDom();

      pe.deactivate();
      er.deactivate();

      if (sm.templateOptions.hideFans) {
        delete sm.templateOptions.hideFans;
        sm.rwom1('#tabs').setOption('switchOnEmbed', true);
      }
    },
    deactivate: function deactivate() {
      this.__privateRequestTimer = null;
      this.leaveLiveshow(true).cleanConnectParams()._resetStates();
      this.callParent('deactivate', arguments);
    },
    cleanConnectParams: function cleanConnectParams() {
      delete this.connectParams.private;
      delete this.connectParams.paid;
      delete this.connectParams.trustedHash;

      return this;
    },
    sendToUser: function sendToUser(user) {
      var $textArea = $(this.rwom1('#sidebarMain').dom1('#message-body'));
      var text = '@' + user.name + ': ';

      $textArea.val(text).focus();
    },
    treatError: function treatError() {
      var errorId = this.callParent('treatError', arguments);
      var w = this.rwom1('#error');

      w.setTemplateOptions('code', errorId);

      this.leaveChat();

      if (w.isActive()) return w.render();

      return this.switchEmbeddedWidget('error');
    },
    render: function render(forceRender) {
      if (this.isEmbedded() || forceRender === true) {
        delete this.inst;

        this._resetStates();
      }

      this.callParent('render', arguments);
    },
    setLiveshowSettings: function setLiveshowSettings() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (settings.answer) settings = settings.answer;

      var privateShow = this.connectParams.private;

      this.settings = _extends({}, this.settings, settings);
      this.rwom1('.ClientLSGoal').setGoal(settings.goal);
      this.toggleFans(parseInt(settings.showFanList) === 0 || privateShow ? false : true);
      this.togglePrivateControl( /*this.connectParams.paid || */privateShow ? 2 : 1);

      var allowed = this.isAllowed();
      this._bindData.isAllowedSidebar = this._bindData.isAllowedThis = allowed;
      this._bindData.showJoinBtn = !allowed && !this.rwom1('@root #permissionManager').hasAccess('member') && this._bindData.status !== 'done';
      this._bindData.showInProgressData = !allowed && this._bindData.status !== 'done';
      this._bindData.showPrivateBtn = !allowed && !privateShow && this._bindData.status !== 'done' && this.settings.privateShowRequest == 1;
      this._bindData.thumbnail = this.settings.thumbnail || '';
      var allowedGroups = this.settings.allowedGroups;
      this._bindData.allowedGroups = allowedGroups.filter(function (allowedGroups) {
        return allowedGroups.length > 0;
      }).length;

      return this;
    },
    togglePrivateControl: function togglePrivateControl(state) {
      var w = this.rwom1('#privateControl');
      var showRequest = fox.getEnv('public.ppmEnabled') && /*(this.settings.paidShowRequest == 1) ||*/this.settings.privateShowRequest == 1;
      var showLeave = fox.getEnv('public.ppmEnabled') && this.connectParams.private;

      function reset() {
        w.setTemplateOptions({});

        if (w.isEmbedded()) {
          w.deactivate();
          w.removeFromDom();
        }
      }

      switch (state) {
        case 3:
          reset();
          break;
        case 1:
          if (showRequest) {
            w.setTemplateOptions('state', state);
          } else {
            reset();
          }

          break;
        case 2:
          if (showLeave) {
            w.setTemplateOptions('state', state);
          }

          break;
      }

      if (w.isEmbedded()) {
        var btnState = $(w.dom1(this.connectParams.private ? '#paid-leave' : '#paid-request')).prop('disabled');

        w.wait('addedToDom').then(function () {
          this.toggleGoPrivateBtn(btnState);
        }.bind(this));
      }

      if (!w.isActive()) {
        w.activate();
      } else {
        w.render();
      }
    },
    toggleFans: function toggleFans(show) {
      var sm = this.rwom1('#sidebarMain');

      if (show === true) {
        if (sm.templateOptions.hideFans === true) {
          delete sm.templateOptions.hideFans;

          if (sm.isActive()) {
            sm.render();
          }

          this.updateFansAmount(false, sm.rwom1('#tabFans'));
        }

        return true;
      }

      sm.setTemplateOptions('hideFans', true);
      sm.rwom1('#tabs').setOption('switchOnEmbed', false);

      if (sm.rwom1('#tabFans').isActive()) {
        this.switchTabs('chat');

        sm.render();
      } else if (sm.isActive()) {
        sm.render();
      } else if (sm._reactivationPool.indexOf('tabFans') !== -1) {
        sm._reactivationPool.splice(sm._reactivationPool.indexOf('tabFans'), 1, 'tabChat');
      }
    },
    toggleButton: function toggleButton(selector) {
      var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var btn = this.dom1(selector);

      if (btn && btn.tagName.toLowerCase() === 'button') return btn.disabled = disabled;

      var $btn = $(btn);
      $btn[disabled ? 'addClass' : 'removeClass']('disabled');
    },
    errorIsActive: function errorIsActive() {
      return this.rwom1('#error').isActive();
    },
    toggleBtnLoader: function toggleBtnLoader(btn) {
      var $btn = $(btn);

      if ($btn.hasClass(_.DOM_CLASS_SPIN)) {
        $btn.removeClass(_.DOM_CLASS_SPIN);
        if ($btn.is('button')) $btn.prop('disabled', false);
      } else {
        $(btn).addClass(_.DOM_CLASS_SPIN);
        if ($btn.is('button')) $btn.prop('disabled', true);
      }
    },
    leaveLiveshow: function leaveLiveshow(skipFlashDisconnect, skipPlayStop) {
      if (skipFlashDisconnect !== true) {
        this.manualDisconnect = true;

        this.controller.stop();

        if (!skipPlayStop) this.stream_viewer_play_stopped();

        this.sendMessageToModel({ text: this.getLeavePrivateToken() });
      }

      this.leaveChat();

      return this;
    },
    isDisconnected: function isDisconnected() {
      return this.status === _.STATUS_DISCONNECTED;
    },
    getMemberInfo: function getMemberInfo(field) {
      var result = this.wom1('@root #permissionManager').getMemberInfo(field);
      var chatctrl = this.rwom1('@root #uchatctrl');

      if (fox.isEmpty(result)) {
        var obj = {
          id: chatctrl.userId,
          login: chatctrl.userId.replace(/^guest_/, 'Guest ')
        };

        if (field === 'id') return obj.id;

        if (field === 'login') return obj.login;

        return obj;
      }

      return result;
    },
    showPaidConfirm: function showPaidConfirm() {
      var _this5 = this;

      var api = this.getApi('rateList', { method: 'liveshow.ratesList' });
      var psc = this.rwom1('#paidShowConfirmBody');

      if (psc.templateOptions.rates) {
        psc.setTemplateOptions('state', 2);
        this.switchEmbeddedWidget('paidShowConfirmBody');
        return psc.wait('addedToDom');
      }

      psc.setTemplateOptions('state', 1);

      this.switchEmbeddedWidget('paidShowConfirmBody');

      return api.psend({}).then(function (resp) {
        var showPrivate = parseInt(_this5.settings.privateShowRequest) === 1 && !_this5.connectParams.private;
        var showPaid = false; //parseInt(this.settings.privateShowRequest) === 1 && !this.connectParams.paid;

        var rates = resp.params.answer.response.filter(function (v) {
          var res = v.typeAlias === 'private' ? showPrivate : v.typeAlias === 'public' ? showPaid : true;

          return v.primary === 1 && res;
        }).filter(function (v) {
          return v.typeAlias === 'private';
        });

        var promise = psc.wait('addedToDom');

        psc.setTemplateOptions({
          state: 2,
          rates: rates
        }).render();

        return promise;
      });
    },
    privateShowConfirmed: function privateShowConfirmed(el, alias, performer) {
      var _this6 = this;

      var pm = this.rwom1('@root #permissionManager');

      var _$$val$split = $(performer.dom1('[name="paidShowType"]:checked')).val().split(':'),
          _$$val$split2 = _slicedToArray(_$$val$split, 3),
          requestType = _$$val$split2[0],
          requestPrice = _$$val$split2[1],
          requestRateId = _$$val$split2[2];

      var params = {
        requestType: requestType,
        requestPrice: requestPrice,
        requestRateId: requestRateId,
        btn: el
      };

      if (params.requestType === 'public') params.requestType = 'paid';

      var isGuestUser = pm.hasAccess('guestActual');

      if (params.requestType) {
        var prepareUserPromise = fox.Promise.resolve([true]);

        if (isGuestUser) prepareUserPromise = this.showGuestPopup();

        return prepareUserPromise.then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
              result = _ref2[0];

          if (!result) return [false];

          _this6._log('sendPaidShowRequest');
          return _this6.sendPaidShowRequest(_extends({}, params, result));
        }).then(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              result = _ref4[0],
              success = _ref4[1];

          if (result === true) {
            _this6._log('privateShowConfirmed success');
            _this6.toggleGoPrivateBtn(true);

            _this6.__privateRequestTimer = setTimeout(function () {
              _this6.__privateRequestTimer = null;

              if (_this6.rwom1('#privateControl').isEmbedded()) _this6.toggleGoPrivateBtn();
            }, 150 * 1000);

            return success.then(function () {
              if (!isGuestUser) return result;

              _this6._log('renewing connect params');
              _this6.controller.release();
              return _this6.getParent().checkLiveShows();
            });
          }
        });
      }

      this.switchEmbeddedWidget('sidebarMain');
    },
    showGuestPopup: function showGuestPopup() {
      var _this7 = this;

      var popup = this.wom1('#guestPopup');

      if (!popup) {
        popup = this.embedWidget('guestPopup', 'Common_GuestPurchasePopup', {
          contentTemplate: 'guest_private_request_popup_content'
        });

        popup.run();
      }

      this._log('showGuestPopup');
      return popup.show().then(function (result) {
        if (result !== false) {
          return [_this7.autoLoginService.injectToken(result.result, new Date().getTime().toString())];
        }

        return [result];
      });
    },
    _log: function _log() {
      var _console;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_console = console).log.apply(_console, ['[ClientLSTranslator]: -> '].concat(_toConsumableArray(args)));
    }
  }, configure, callbacks, chatMethods, billingMethods, isAllowedMethod), 'LSTranslator');
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	DOM_CLASS_TIPSUCCESS: 'tip-success',
	DOM_CLASS_SPIN: 'spin',
	DOM_SELECTOR_SENDMESSAGEBTN: '#ls-send-message',
	DOM_SELECTOR_SENDGIFTBTN: '#toggle-gift-box',
	DOM_SELECTOR_VOLUMEBTN: '#volume-change',
	DOM_SELECTOR_FULLSCREEN: '#toggle-fullscreen',

	EVENT_LIVESHOWISOVER: 'liveshow_is_over',

	TIMER_THANKYOU: 5000,
	TIMER_WAIT_FOR_DONE: 1000 * 2,

	fm: {
		MARGIN_PLAYER_H: 75,
		MARGIN_PLAYER_W: 300
	},

	STATUS_CONNECTED: 'connected',
	STATUS_DISCONNECTED: 'disconnected',

	ERROR_EMPTY_BALANCE: 'empty.balance',

	MUTE_MESSAGE: 'muted you. You won\'t be able to chat during this show until you are unmuted.',
	UNMUTE_MESSAGE: 'has unmuted you. You can now use chat during the show.',

	BLOCK_MESSAGE: 'has blocked you from viewing this show.',
	UNBLOCK_MESSAGE: 'has unblocked you. You can now watch the show.'
};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox, _) {
	return {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				flashContainer: '#lst-container',
				template: 'liveshow_palyer_container',
				'embed.container': '#liveshow-container',
				flashParams: {
					bgcolor: '#000000'
				},
				widgets: {
					'cbPaymentPopup.widget': 'CBPaymentPopup',
					sidebarMain: {
						widget: 'Widget',
						group: 'sidebar',
						'embed.container': '#sidebar-container',
						template: 'ls_viewer_sidebar_main',
						autoRender: true,
						hooks: {
							onStartRendering: function onStartRendering() {
								fox.each(this.getParent().connectParams, function (param, name) {
									this.setTemplateOptions(name, param);
								}, this);

								var settings = this.getParent().settings || {};

								if (settings.showFanList === 0) {
									this.setTemplateOptions('hideFans', true);
								}

								this.wait('addedToDom').then(function () {
									this.setTemplateOptions({});
									this.getParent().updateFansAmount(false, this.rwom1('#tabFans'));
								}.bind(this));
							},
							onStopRendering: '@parent:toggleMessageBlock'
						},
						widgets: {
							tabs: {
								widget: 'Tools_TabsSwitcher',
								target: '.ls-tabs .ls-tab-item',
								name: 'tab-id',
								callback: '@parent @parent:switchTabs',
								switchOnEmbed: true
							},
							tabFans: {
								widget: 'LSFans',
								'embed.container': '#sidebar-main-container',
								template: 'ls_viewer_sidebar_main_fan_list_container',
								'widgets.fanList': {
									'embed.container': '#fan-list-container',
									'tpl.row': 'ls_viewer_sidebar_main_fan_list_row'
								},
								group: 'sidebarTabs',
								active: false
							},
							tabChat: {
								widget: 'LSChatList',
								'embed.container': '#sidebar-main-container',
								autoRender: true,
								template: 'ls_viewer_sidebar_main_chat_list_container',
								group: 'sidebarTabs',
								scrollContainer: '.chat-list-scroll-wrapper',
								scrollTheme: 'minimal',
								'widgets.chatList': {
									'tpl.row': 'ls_viewer_sidebar_main_chat_list_row',
									'embed.container': '#chat-list-container'
								}
							},
							tabFakeChat: {
								widget: 'FakeChatList',
								group: 'sidebarTabs',
								active: false,
								getMemberInfo: function getMemberInfo() {
									return _this.getMemberInfo.apply(_this, arguments);
								}
							}
						}
					},
					giftBox: {
						widget: 'Giftbox',
						group: 'sidebar',
						'embed.container': '#sidebar-container',
						active: false,
						giftType: 'liveshow',
						giftPaymentSuccess: 'inboxSocketEventLiveshow:giftUnlock',
						targetIdCb: function () {
							return this.connectParams.sessionId;
						}.bind(this)
					},
					status: {
						widget: 'Widget',
						'embed.container': '#splash-container',
						template: 'liveshow_player_model_status',
						active: true,
						group: 'playerSplash',
						autoRender: true
					},
					error: {
						widget: 'Widget',
						'embed.container': '#overlay-container',
						autoRender: true,
						template: 'liveshow_player_overlayed_error',
						group: 'playerOverlay',
						active: false,
						handleDom: {
							refreshPage: {
								event: 'click',
								target: '#refresh-page',
								callback: function callback() {
									window.location.reload();
								}
							},
							restartLiveshow: {
								event: 'click',
								target: '#restart-liveshow',
								callback: fox.bind(function () {
									delete this.inst;
									this.dispatchEvent('restartLiveshow');
								}, this)
							}
						}
					},
					paidEntry: {
						widget: 'Widget',
						'embed.container': '#overlay-container',
						autoRender: true,
						template: 'liveshow_player_overlayed_paid_entry',
						group: 'playerOverlay',
						active: false,
						handleDom: {
							acceccGranted: {
								event: 'click',
								target: '#entry-resume',
								callback: this.entryAccessGranted.bind(this)
							}
						}
					},
					tipme: {
						widget: 'Content_Tipme',
						'embed.container': '#tipme-form',
						template: 'liveshow_content_tipme',
						'hooks.onShowSuccessPopup': this.onTipSuccessfully,
						'wrapMethods.renderConfirmContent': true,
						'hooks.onRenderConfirmContent': function hooksOnRenderConfirmContent(to) {
							var tcb = _this.rwom1('#tipsConfirmBody');

							tcb.setTemplateOptions(to);

							if (tcb.isActive()) {
								tcb.render();
							} else {
								_this.switchEmbeddedWidget('tipsConfirmBody');
							}
						},
						'widgets.confirmPopup': {
							'wrapMethods.show': true,
							'hooks.onShow': function hooksOnShow() {
								return false;
							}
						},
						'widgets.form.container': '@parent @parent #tipsConfirmBody'
					},
					paidShowConfirmBody: {
						widget: 'Widget',
						autoRender: true,
						template: 'ls_viewer_sidebar_paidrequest_confirm',
						group: 'sidebar',
						active: false,
						'embed.container': '#sidebar-container',
						handleDom: {
							confirm: {
								event: 'click',
								target: '#confirm-paid',
								callback: function callback() {
									return _this.privateShowConfirmed.apply(_this, arguments);
								}
							},
							decline: {
								event: 'click',
								target: '#cancel-paid',
								callback: function callback() {
									return _this.switchEmbeddedWidget('sidebarMain');
								}
							}
						}
					},
					tipsConfirmBody: {
						widget: 'Widget',
						autoRender: true,
						template: 'ls_viewer_sidebar_tip_confirm',
						group: 'sidebar',
						active: false,
						'embed.container': '#sidebar-container',
						handleDom: {
							confirm: {
								target: '#confirm-tip',
								callback: function callback(btn) {
									new fox.Promise(function (resolve) {
										$(btn).addClass(_.DOM_CLASS_SPIN);
										_this.rwom1('#tipme').submit(resolve);
									}).then(function (result) {
										$(btn).removeClass(_.DOM_CLASS_SPIN);
										return result && _this.switchEmbeddedWidget('sidebarMain');
									});
								}
							},
							decline: {
								target: '#cancel-tip',
								callback: function callback() {
									_this.switchEmbeddedWidget('sidebarMain');
								}
							}
						}
					},
					privateControl: {
						widget: 'Widget',
						'embed.container': '#private-control-container',
						active: false,
						autoRender: true,
						template: 'ls_private_control'
					},
					'liveshowGoal.widget': 'ClientLSGoal',
					'authorizePopup.widget': 'Common_AutoLoginPopup'
				},
				handleDom: {
					toggleFullscreen: {
						target: '#toggle-fullscreen',
						callback: 'toggleFullscreen'
					},
					closeFullscreenOnEsc: {
						event: 'keydown',
						target: document,
						targetWidget: '@root',
						eventChecker: fox.bind(function (e) {
							return this.fullscreen === true && e.keyCode === 27;
						}, this),
						callback: function callback() {
							var el = this.dom1('#toggle-fullscreen');

							this.toggleFullscreen(el);
						}
					},
					volumeChange: {
						target: '.volume-slider',
						callback: 'volumeChange'
					},
					volumeOff: {
						target: '.ls-iconvol',
						callback: function callback(icon) {
							var $btn = $(icon).parent();
							var value = 0;

							if ($btn.hasClass('disabled')) return false;

							if (!$btn.hasClass('muted')) {
								this.previosVolumeValue = this.controller.getVolume() * 100;
							} else {
								value = this.previosVolumeValue || 50;
							}

							this.controller.setVolume(value);
							this.setUiVolumeLevel(value);
						}
					},
					toggleGiftBox: {
						target: '#toggle-gift-box',
						callback: 'toggleGiftBox'
					},
					sendMessageOnBtn: {
						target: _.DOM_SELECTOR_SENDMESSAGEBTN,
						targetWidget: '#sidebarMain',
						callback: 'sendMessageToChat'
					},
					sendMessageOnEnter: {
						event: 'keydown',
						target: '#message-body',
						targetWidget: '#sidebarMain',
						eventChecker: function eventChecker(e) {
							return e.keyCode === 13;
						},
						callback: 'sendMessageToChat'
					},
					paidRequest: {
						target: '#paid-request',
						targetWidget: '#privateControl',
						callback: function callback() {
							return _this.showPaidConfirm();
						}
					},
					paidLeave: {
						target: '#paid-leave',
						targetWidget: '#privateControl',
						callback: function callback() {
							return _this.leaveLiveshow();
						}
					},
					requestPrivateFromNotAllowed: {
						target: '#request-private',
						callback: function callback() {
							return _this.showPaidConfirm();
						}
					}
				},
				handleWom: {
					updateFansAmount: {
						event: 'fansAmountChanged',
						widget: '.Widget .LSFans',
						callback: 'updateFansAmount'
					},
					giftSended: {
						event: 'giftSended',
						widget: '#giftBox',
						callback: 'giftSended'
					},
					giftPaid: {
						event: 'giftPaid',
						widget: '#giftBox',
						callback: 'giftPaid'
					},
					sendToUser: {
						event: 'sendToUser',
						widget: '.Widget .LSFans',
						callback: 'sendToUser'
					},
					settingsChanged: {
						widget: '@root #socket',
						event: 'inboxSocketEventLiveshow:newSettings',
						callback: function callback(settings) {
							if (_this.isDisconnected()) return false;

							if (settings.answer) settings = settings.answer;

							if (settings.id !== _this.connectParams.sessionId) return false;

							if (_this.isAllowed(settings.allowedGroups) && _this.isAllowed()) return _this.setLiveshowSettings(settings);

							_this.controller.release();
							_this._resetStates();
							_this.setLiveshowSettings(settings);
							_this.app_initialized();
						}
					},
					publicMessageRecieve: {
						event: 'inbox_public',
						widget: '@root #uchatctrl',
						callback: 'setChatMessage'
					},
					privateMessageRecieve: {
						event: 'inbox_private',
						widget: '@root #uchatctrl',
						callback: 'onChatPrivateMessage'
					},
					onRoomLeave: {
						event: 'roomLeave',
						widget: '.Widget .LSFans',
						callback: function callback(user) {
							if (user.uid == fox.getEnv('site.clientId')) {
								this.dispatchEvent(_.EVENT_LIVESHOWISOVER);
							}
						}
					}
				}
			});

			['statusDone', 'statusPrivate', 'error', 'statusInprogress'].forEach(function (alias) {
				_this.registerOptions('#' + alias, {
					'wrapMethods.deactivate': true,
					'hooks.onStartDeactivate': function hooksOnStartDeactivate() {
						this.removeFromDom();

						return true;
					}
				});
			});

			this.callParent('configure', arguments);
		}
	};
};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox, _) {
	return {
		app_initialized: function app_initialized() {
			var _connectParams = this.connectParams,
			    paid = _connectParams.paid,
			    privateShow = _connectParams.private;

			var ppmEnabled = !!fox.getEnv('public.ppmEnabled');
			var _private = privateShow || paid;

			if (this.controller.type === 'webrtc') this.status = _.STATUS_CONNECTED;

			if (ppmEnabled && _private && this.checkTrustedHash()) return this.startPlay();

			if (!this.isAllowed()) {
				this._bindData.isRequester = false;
				if (!this.controller.isAppleBrowser) this.manageStatusBanners(_private ? 'private' : 'progress');

				this.switchTabs('fakeChat');

				if (!_private) this.connectToChat();

				return false;
			}

			if (ppmEnabled && _private && !this.checkTrustedHash()) {
				this.switchTabs('chat');
				this.rwom1('#paidEntry').setTemplateOptions({
					paidType: privateShow ? 1 : paid ? 2 : 0,
					amount: this.settings.amount,
					period: this.settings.period
				});

				this.switchEmbeddedWidget('paidEntry');

				return false;
			}

			return this.startPlay();
		},
		stream_connection_success: function stream_connection_success() {
			if (this.controller.type !== 'webrtc') this.status = _.STATUS_CONNECTED;

			this.connectSuccess();
			this.toggleMessageBlock();
		},
		stream_connection_closed: function stream_connection_closed() {
			var _this = this;

			if (this.isDisconnected()) return false;

			if (this.manualDisconnect) {
				delete this.manualDisconnect;
				this.status = _.STATUS_DISCONNECTED;

				return this.manageStatusBanners('done');
			}

			clearTimeout(this.waitForDone);
			this.waitForDone = setTimeout(function () {
				_this.leaveLiveshow(true);
				_this.treatError({ id: _this.getInterruptError() });
			}, _.TIMER_WAIT_FOR_DONE);
		},
		stream_viewer_play_started: function stream_viewer_play_started() {
			clearTimeout(this.waitForDone);
			this.manageStatusBanners(false);

			var savedLevel = fox.utils.localStorage('getItem', '_lsvl_');
			this.toggleButton(_.DOM_SELECTOR_VOLUMEBTN);
			this.toggleButton(_.DOM_SELECTOR_FULLSCREEN);

			if (!this.__privateRequestTimer) this.toggleGoPrivateBtn(false);

			if (savedLevel) this.controller.setVolume(Number(savedLevel));

			if (this.connectParams.private) {
				this.setChatMessage({
					type: 4,
					text: 'intro'
				});
			}

			this.setUiVolumeLevel(this.controller.getVolume() * 100);
		},
		stream_viewer_play_stopped: function stream_viewer_play_stopped() {
			this.toggleButton(_.DOM_SELECTOR_VOLUMEBTN, true);
			this.toggleGoPrivateBtn(true);
			this.toggleButton(_.DOM_SELECTOR_FULLSCREEN, true);
		},
		stream_viewer_metadata: function stream_viewer_metadata(args) {
			this.setFlashSize(this.setStreamInfo(args.desc));
		}
	};
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LiveshowChatTokens = __webpack_require__(40);

var CHARS_MESSAGE_LIMIT = 1000;

module.exports = function (fox, _) {
	return {
		getChatUserId: function getChatUserId() {
			return this.rwom1('@root #uchatctrl').userId;
		},
		connectToChat: function connectToChat() {
			var _this = this;

			var chatctrl = this.rwom1('@root #uchatctrl');
			var roomAlias = this.getRoomAlias();
			var ft = this.rwom1('#sidebarMain #tabFans');
			var chatUserId = this.getChatUserId();

			if (this._chatConnectionStates[roomAlias] === chatUserId) return fox.Promise.resolve(roomAlias);

			var joinPromise = chatctrl.joinRoom(roomAlias);

			return joinPromise.then(function () {
				_this._chatConnectionStates = _defineProperty({}, roomAlias, chatUserId);

				ft.addUser({
					uid: fox.getEnv('site.clientId'),
					name: fox.getEnv('site.alias'),
					isBroadcaster: true
				});

				ft.setCurrentRoom(roomAlias).getUsers();

				chatctrl.getRoomHistory(roomAlias).then(function (list) {
					var cl = _this.rwom1('#sidebarMain #tabChat');
					var mId = fox.getEnv('site.clientId');

					if (list.length > 0) cl.addMessage(cl.prepareList(list, mId));
				});

				return roomAlias;
			});
		},
		sendMessageToModel: function sendMessageToModel(msg) {
			var uctrl = this.rwom1('@root #uchatctrl');
			var to = [fox.getEnv('site.clientId'), 'web'].join('@');

			if (fox.isEmpty(msg)) return false;

			msg.name = this.getMemberInfo('login');

			return uctrl.sendMessage(msg, to);
		},


		/* duplacate modifier html */
		_escape: function _escape(obj, params) {
			var tags = ['script', 'html'];
			var attrs = ['onclick', 'onchange', 'onclose', 'oncontextmenu', 'ondblclick', 'ondrag', 'ondragend', 'ondragenter', 'ondragexit', 'ondragleave', 'ondragover', 'ondragstart', 'ondrop', 'onfocus', 'onblur', 'oninput', 'oninvalid', 'onload', 'onkeydown', 'onkeypress', 'onkeyup', 'onmousedown', 'onmouseenter', 'onmouseleave', 'onmousemove', 'onmouseout', 'onmouseover', 'onmouseup', 'onmousewheel', 'onscroll', 'onsubmit', 'onsuspend'].join('|');

			if (!fox.isString(obj)) return obj;

			var tagsJoined = (fox.isArray(params) && params || []).reduce(function (_tags, param) {
				return !fox.inArray(_tags, param) ? _tags.concat(param) : _tags;
			}, tags).join('|');

			var tagsRegexp = new RegExp('\<(' + tagsJoined + ')+[^>]*>([^<]*(\<\/(' + tagsJoined + '))?>)?', 'mgi');
			var attrsRegexp = new RegExp('\\s+(' + attrs + ')+="[^"]+"', 'mgi');

			return obj.replace(tagsRegexp, '').replace(attrsRegexp, '');
		},
		sendMessageToChat: function sendMessageToChat(el, alias, performer) {
			var text = this._escape(fox.trim($(performer.dom1('#message-body')).val()), 'iframe:frame:video:audio:img:image:picture:form:input:textarea:button:canvas:select:object:option:legend:progress:meter:keygen:embed:body:style:link'.split(':')).slice(0, CHARS_MESSAGE_LIMIT);
			var msg = {
				text: text,
				name: this.getMemberInfo('login'),
				own: this.getMemberInfo('id')
			};

			if (!text || this.blockedViewer === true) return false;

			this.setChatMessage(msg).rwom1('@root #uchatctrl').sendMessage(msg, this.getRoomAlias());

			$(performer.dom1('#message-body')).val('');

			if (this.rwom1('.Widget #tabFans').isActive()) {
				var tabs = this.rwom1('.Widget #tabs');
				var activeTab = tabs.getParent().dom1('[data-tab-id="chat"]');

				tabs.processEvent(activeTab);
			}
		},
		onChatPrivateMessage: function onChatPrivateMessage(messageObj) {
			var cl = this.rwom1('#sidebarMain #tabChat');

			var isBroadcaster = messageObj.isBroadcaster,
			    message = _objectWithoutProperties(messageObj, ['isBroadcaster']);

			var name = fox.getEnv('site.alias');

			switch (message.text) {
				case this.getUserBlockToken():
					message.text = this._wrapMention(_.BLOCK_MESSAGE);
					this.inst.pauseStream();
					this.manageStatusBanners('banned');
					cl.addMessage(_extends({}, message, { isBroadcaster: isBroadcaster, name: name }));
					break;
				case this.getUserUnblockToken():
					message.text = this._wrapMention(_.UNBLOCK_MESSAGE);
					this.inst.resumeStream();
					this.manageStatusBanners(false, true);
					cl.addMessage(_extends({}, message, { isBroadcaster: isBroadcaster, name: name }));
					break;
				case LiveshowChatTokens.muteUser:
					message.text = this._wrapMention(_.MUTE_MESSAGE);
					this.blockedViewer = true;
					cl.addMessage(_extends({}, message, { isBroadcaster: isBroadcaster, name: name }));
					break;
				case LiveshowChatTokens.unmuteUser:
					message.text = this._wrapMention(_.UNMUTE_MESSAGE);
					delete this.blockedViewer;
					cl.addMessage(_extends({}, message, { isBroadcaster: isBroadcaster, name: name }));
					break;
				case this.getPrepareWebrtcTranslationToken():
					if (this._prepareWebrtcTranslationResolve) {
						this._prepareWebrtcTranslationResolve(message.dataset);
						this._prepareWebrtcTranslationResolve = null;
					}
					break;
				default:
					if (message.requestResponse) {
						if (message.mention.slice(1) === this.getMemberInfo('login')) {
							this.toggleGoPrivateBtn();
							cl.addMessage(_extends({}, message, { isBroadcaster: isBroadcaster, name: name }));
						}
					} else {
						cl.addMessage(_extends({}, message, { isBroadcaster: isBroadcaster, name: name }));
					}
			}

			this.toggleMessageBlock();
		},
		setChatMessage: function setChatMessage(message, p, e) {
			var _this2 = this;

			if (e === 'inbox_public' && message.own === this.getMemberInfo('id')) return this;

			if (!fox.isEmpty(message.dataset)) message = _extends({}, message, message.dataset);

			if (message.isBroadcaster === true && message.text === this.getDisconnectToken()) {
				if (this.waitForDone) clearTimeout(this.waitForDone);

				this.wait(_.EVENT_LIVESHOWISOVER).then(function () {
					clearTimeout(_this2.waitForDone);

					if (_this2.fullscreen === true) _this2.toggleFullscreen();

					if (message.inPrivate && message.inPrivate === _this2.isRequester) {
						_this2.manageStatusBanners('private');
						_this2._bindData.isRequester = true;
					} else {
						_this2.manageStatusBanners('done');
					}

					if (_this2.connectParams.private) {
						_this2.setChatMessage({
							type: 4,
							text: 'outro'
						});
					}

					_this2.blockedViewer = true;
					_this2.toggleMessageBlock();
					_this2.blockedViewer = false;

					_this2.leaveChat();
					_this2.cleanConnectParams();

					_this2.status = _.STATUS_DISCONNECTED;
					_this2.controller.stop();
					_this2.setLiveshowSettings();
					_this2.settings = {};
					_this2.rwom1('#sidebarMain #tabFakeChat').dispose();
					_this2.__privateRequestTimer = null;
				});
			} else {
				var mentionRegexp = this._getMentionRegexp();

				if ('text' in message && mentionRegexp.test(message.text)) {
					message.text = this._wrapMention(message.text);
				}

				this.rwom1('#sidebarMain #tabChat').addMessage(message);
			}

			return this;
		},
		_getMentionRegexp: function _getMentionRegexp() {
			return new RegExp('(@' + this.getMemberInfo('login') + '|@all)');
		},
		_wrapMention: function _wrapMention() {
			var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			var mentionRegexp = this._getMentionRegexp();

			return '<span class="ls-chat-mention">\n\t\t\t' + text.replace(mentionRegexp, '<span class="ls-chat-mention-name">$1</span>') + '\n\t\t</span>';
		},
		toggleMessageBlock: function toggleMessageBlock() {
			var toggle = function toggle(state) {
				var nodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

				nodes.forEach(function (node) {
					return node && (node.disabled = !!state);
				});
			};
			var nodes = [this.rwom1('#sidebarMain').dom1('#message-body'), this.rwom1('#sidebarMain').dom1(_.DOM_SELECTOR_SENDMESSAGEBTN)];

			if (this.isDisconnected() && !this.blockedViewer) {
				toggle(true, nodes);
			} else {
				toggle(this.blockedViewer, nodes);
			}
		},
		leaveChat: function leaveChat() {
			var roomAlias = this.getRoomAlias();
			delete this._chatConnectionStates[roomAlias];
			this.rwom1('@root #uchatctrl').leaveRoom(roomAlias);
		}
	};
};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

module.exports = function (fox, _) {
	return {
		onEmptyBalance: function onEmptyBalance() {
			this.treatError({
				id: _.ERROR_EMPTY_BALANCE
			});

			return this.leaveLiveshow();
		},
		sendPaidShowRequest: function sendPaidShowRequest(params) {
			var _this = this;

			var rateId = params.requestRateId,
			    price = params.requestPrice,
			    type = params.requestType,
			    btn = params.btn,
			    rest = _objectWithoutProperties(params, ['requestRateId', 'requestPrice', 'requestType', 'btn']);

			var pcb = this.rwom1('#paidShowConfirmBody');

			this.toggleBtnLoader(btn);

			return this.checkPayer(_extends({ rateId: rateId }, rest), $(btn)).then(function (token) {
				_this._log('got token');
				if (_this.isDisconnected()) {
					var error = {
						msg: 'liveshow disconnected',
						params: { answer: { code: 'model.disconnected' } }
					};

					if (_this.isEmbedded()) {
						throw error;
					} else {
						return _this.dispatchEvent('paid_request_error', error);
					}
				}

				_this.los.setItem(token, _this.getChatUserId());

				var msg = {
					text: _this.getPaidShowRequestToken(),
					paidShowType: type,
					trustedHash: token,
					type: 3
				};

				if (price) msg.paidShowPrice = price;

				_this._log('sending private request');
				_this.sendMessageToModel(msg);

				pcb.setTemplateOptions('state', 3).render();
				_this.isRequester = token;

				return [true, new fox.Promise(function (resolve) {
					return setTimeout(function () {
						pcb.setTemplateOptions({});
						_this.switchEmbeddedWidget('sidebarMain');

						resolve(true);
					}, 3000);
				})];
			}).catch(function (resp) {
				if (resp.params) {
					switch (resp.params.answer.code) {
						case 12:
							var username = params.username,
							    email = params.email,
							    token = params.token,
							    _rest = _objectWithoutProperties(params, ['username', 'email', 'token']);

							_this.wait('@root #permissionManager', 'permissions_update').then(function () {
								setTimeout(function () {
									return _this.toggleBtnLoader(fox.dom.selectFirst('#' + _rest.btn.id, pcb.element));
								}, 100);
							});

							return _this.rwom1('#authorizePopup').show().then(function (result) {
								if (result !== false) {
									_this.controller.release();
									return _this.getParent().checkLiveShows().then(function () {
										var promise = _this.wait('#paidShowConfirmBody', 'addedToDom');
										_this.showPaidConfirm();

										return promise;
									}).then(function () {
										_rest.btn = fox.dom.selectFirst('#' + _rest.btn.id, pcb.fragment); /* avoid select from element */
									}).then(function () {
										return _this.sendPaidShowRequest(_rest);
									});
								}

								_this.toggleBtnLoader(fox.dom.selectFirst('#' + _rest.btn.id, pcb.element));

								return [result];
							});
						default:
							pcb.setTemplateOptions({
								state: 3,
								errorCode: resp.params.answer.code
							}).render();
					}

					return [false];
				}

				throw resp;
			});
		},
		checkPayer: function checkPayer(params, $btn) {
			var _this2 = this;

			var api = this.getApi('openSession', {
				method: 'liveshow.checkPayer',
				httpMethod: 'post'
			});
			var cbpopup = this.rwom1('#cbPaymentPopup');
			var sendingPromise = api.psend(_extends({
				id: this.connectParams.sessionId
			}, params)).then(function (_ref) {
				var response = _ref.params.answer.response;
				return response;
			});

			cbpopup.show(sendingPromise.then(function (_ref2) {
				var url = _ref2.redirect;

				return { url: url };
			}));

			return sendingPromise.then(function (answer) {
				if ($btn) $btn.toggleClass(_.DOM_CLASS_SPIN);

				if ($btn.is('button')) $btn.prop('disabled', false);

				if (answer === true) {
					cbpopup.hide();

					return true;
				}

				return _this2.wait('@root #socket', 'inboxSocketEventLiveshow:billing:payInfoSuccess');
			}).then(function (resp) {
				if (cbpopup.isOpen()) cbpopup.hide();

				_this2.wait('@root #socket', 'inboxSocketEventLiveshow:billing:emptyBalance').then(function () {
					return _this2.onEmptyBalance.apply(_this2, arguments);
				});

				var token = fox.objectGet(resp, 'params.answer.token');

				if (token) return _this2.autoLoginService.shouldAuthorize(token).then(function (result) {
					if (result === true) {
						_this2._log('shouldAuthorize success');
						return _this2.connectToChat().then(function (roomAlias) {
							return _this2._log('connected to the room ' + roomAlias);
						}).then(function () {
							_this2._log('tiny delay after connect to chat');
							return new fox.Promise(function (resolve) {
								return setTimeout(resolve, 1000);
							});
						}).then(function () {
							return token;
						});
					}

					throw {
						params: { answer: { code: 'auth.error' } }
					};
				});

				var _autoLoginService$inj = _this2.autoLoginService.injectToken({}, new Date().getTime().toString()),
				    trustedHash = _autoLoginService$inj.token;

				return trustedHash;
			}).catch(function (error) {
				cbpopup.hide();

				throw error;
			});
		},
		giftPaid: function giftPaid(gifts) {
			var _this3 = this;

			function sendGift(alias) {
				alias = alias.split(':');

				var m = {
					type: 1,
					gift: alias[0],
					price: alias[1]
				};

				var msg = {
					text: 'gift',
					name: this.getMemberInfo('login'),
					dataset: m,
					own: this.getMemberInfo('id')
				};

				this.setChatMessage(msg).rwom1('@root #uchatctrl').sendMessage(msg, this.getRoomAlias());
			}

			var btn = this.dom1('#toggle-gift-box');

			if (gifts.length) {
				this.toggleGiftBox(btn, 'giftPaidSuccess');
			}

			if (this.rwom1('.Widget #tabChat').isEmbedded()) {
				fox.each(gifts, sendGift, this);
			} else {
				this.wait('.Widget #tabChat', 'addedToDom').then(function () {
					fox.each(gifts, sendGift, _this3);
				});
			}
		},
		onTipSuccessfully: function onTipSuccessfully() {
			var translator = this.getParent();
			var $c = $(this.element[0]);
			var m = {
				type: 2,
				price: this.amount
			};

			var msg = {
				text: 'tip',
				own: translator.getMemberInfo('id'),
				name: translator.getMemberInfo('login'),
				dataset: m
			};

			translator.setChatMessage(msg).rwom1('@root #uchatctrl').sendMessage(msg, translator.getRoomAlias());

			translator._onPaidSuccessfully();
		}
	};
};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/liveshow/images/in-progress.png", __webpack_require__.p + "_/_/_/root/components/liveshow/images/in-progress.png");

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/liveshow/images/banned.png", __webpack_require__.p + "_/_/_/root/components/liveshow/images/banned.png");

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

module.exports = function (fox) {
	fox.registerWidget('FakeChatList', {
		configure: function configure() {
			this.registerOptions('', {
				'embed.container': '#sidebar-main-container',
				autoRender: true,
				template: 'ls_viewer_sidebar_main_chat_list_container',
				scrollContainer: '.chat-list-scroll-wrapper',
				scrollTheme: 'minimal',
				'widgets.chatList': {
					'tpl.row': 'ls_viewer_sidebar_main_chat_list_row',
					'embed.container': '#chat-list-container'
				}
			});

			this.callParent('configure', arguments);
		},
		genRandomString: function genRandomString(length) {
			var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789 ";
			var text = '';

			for (var i = 0; i < length; i++) {
				text += possible.charAt(Math.floor(Math.random() * possible.length));
			}

			return text;
		},
		getMemberInfo: function getMemberInfo() {
			return this.requireOption('getMemberInfo').apply(undefined, arguments);
		},
		deactivate: function deactivate() {
			this.reset();
			this.dispose();
			this.callParent('deactivate', arguments);
		},
		dispose: function dispose() {
			clearTimeout(this._timer);
			this._timer = null;
		},
		afterEmbed: function afterEmbed() {
			var _this = this;

			var addMessage = function addMessage() {
				var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

				var modelName = fox.getEnv('screenName');

				var messages = fox.range(0, fox.random(1, 5)).map(function (id) {
					var isBroadcaster = fox.random(1, 4) === 4;
					var message = {
						text: _this.genRandomString(fox.random(10, 80)),
						name: isBroadcaster ? modelName : _this.getMemberInfo('login'),
						isBroadcaster: isBroadcaster
					};

					if (!isBroadcaster && fox.random(1, 5) === 5 /* just random */) {
							return _extends({}, message, {
								text: 'gift',
								type: 1,
								gift: 'gift-' + fox.random(0, 11),
								price: fox.random(5, 20) + '$'
							});
						}

					return message;
				});

				if (!delay) return _this.addMessage(messages);

				return setTimeout(function () {
					_this.addMessage(messages);

					if (_this.isActive()) return _this._timer = addMessage(fox.random(5000, 10000));
				}, delay);
			};

			this.callParent('afterEmbed', arguments);

			addMessage();
			this._timer = addMessage(3000);
		}
	}, 'LSChatList');
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (fox) {
	var isAllowedMethod = __webpack_require__(51)(fox);

	fox.registerWidget('LiveshowNotificationBanner', fox.mixin({
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				template: 'liveshow_notification_banner',
				manualRender: true,
				embed: {
					container: '#liveshow-notification-container',
					widget: '@root'
				},
				handleDom: {
					close: {
						target: ['#close-upgrade-banner', '#pulldown-upgrade-banner'],
						callback: function callback() {
							return _this.hide();
						}
					},
					requestPrivate: {
						target: '#request-private',
						callback: function callback() {
							return _this._requestPrivate();
						}
					}
				},
				handleWom: {
					onLayoutChanged: {
						event: 'addedToDom',
						widget: '@root .Site_Layout',
						callback: function callback() {
							return _this.isEmbedded() && setTimeout(function () {
								_this._bindData.position = '-' + _this._getBannerYPos() + 'px';
							}, 1005);
						}
					},
					newSettingsRecieved: {
						widget: '@root #socket',
						event: 'inboxSocketEventLiveshow:newSettings',
						callback: function callback(settings) {
							if (!_this.isEmbedded()) return false;

							if (settings.answer) settings = settings.answer;

							var _settings = settings,
							    thumbnail = _settings.thumbnail,
							    privateShowRequest = _settings.privateShowRequest,
							    _settings$allowedGrou = _settings.allowedGroups,
							    allowedGroups = _settings$allowedGrou === undefined ? [] : _settings$allowedGrou;


							_this.setThumbnail(thumbnail);
							_this._bindData.showJoinButton = !_this._bindData.isPremiumMember && !_this.isAllowed(allowedGroups) && allowedGroups.length;
						}
					},
					liveshowPageInDom: {
						widget: '@root ~.SitePage_Liveshow',
						event: 'addedToDom',
						callback: function callback() {
							if (_this.__isPrivateRequest) return false;

							return _this.hide();
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		prepareEmbeddedWidgets: function prepareEmbeddedWidgets() {
			this._bindData = {
				position: '100%',
				transitionDuration: 400,

				thumbnail: '',
				showPrivateRequestBtn: false,
				showJoinButton: !this.rwom1('@root #permissionManager').hasAccess('member'),
				isPremiumMember: this.rwom1('@root #permissionManager').hasAccess('member')
			};

			this.bindTemplateVariables(this._bindData, ['position', 'transitionDuration', 'thumbnail', 'isPremiumMember', 'showPrivateRequestBtn', 'showJoinButton']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},
		_getBannerYPos: function _getBannerYPos() {
			var anotherBanners = fox.dom.select('.upbs-wrapper');
			var myNode = this.dom1('.upbs-wrapper');

			if (anotherBanners.length) return anotherBanners.reduce(function (acc, bannerNode) {
				if (bannerNode === myNode) return acc;

				return acc + bannerNode.clientHeight;
			}, 2);

			return 0;
		},
		_requestPrivate: function _requestPrivate() {
			var _this2 = this;

			this.__isPrivateRequest = true;

			fox.site.gotoPage('liveshow');

			var promise = fox.Promise.all([this.wait('@root ~.ClientLSTranslator', 'app_initialized'), this.wait('@root ~.ClientLSTranslator #sidebarMain', 'addedToDom').then(function (resp) {
				return new fox.Promise(function (resolve) {
					return setTimeout(function () {
						return resolve(resp);
					}, 400);
				});
			})]);

			return promise.then(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 1),
				    translator = _ref2[0].performer;

				_this2.hide();

				return translator.showPaidConfirm().then(function (_ref3) {
					var confirmWidget = _ref3.performer;
					return {
						translator: translator,
						confirmWidget: confirmWidget
					};
				});
			}).then(function (_ref4) {
				var translator = _ref4.translator,
				    confirmWidget = _ref4.confirmWidget;

				return translator.privateShowConfirmed(confirmWidget.rdom1('#confirm-paid'), 'alias', confirmWidget);
			});
		},
		_getLiveshowData: function _getLiveshowData() {
			var api = this.getApi('__getLiveshowDataApi', {
				method: 'Liveshow.getStarted',
				sendTimezone: true
			});

			return api.psend().then(function (_ref5) {
				var params = _ref5.params;

				var _fox$objectGet = fox.objectGet(params, 'answer.response'),
				    thumbnail = _fox$objectGet.thumbnail,
				    privateShowRequest = _fox$objectGet.privateShowRequest,
				    allowedGroups = _fox$objectGet.allowedGroups,
				    _fox$objectGet$addVar = _fox$objectGet.addVars;

				_fox$objectGet$addVar = _fox$objectGet$addVar === undefined ? {} : _fox$objectGet$addVar;
				var privateShow = _fox$objectGet$addVar.private,
				    paidShow = _fox$objectGet$addVar.paid;


				return {
					thumbnail: thumbnail,
					privateShowRequest: privateShowRequest,
					allowedGroups: allowedGroups,
					isPaidShow: !!privateShow || !!paidShow
				};
			});
		},
		setThumbnail: function setThumbnail() {
			var thumbnail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			if (fox.isEmpty(thumbnail)) return this._bindData.thumbnail = '';

			return this._bindData.thumbnail = thumbnail;
		},
		show: function show() {
			var _this3 = this;

			var page = fox.site.page.alias;


			if (this.isEmbedded() || page === 'liveshow') return false;

			var yPos = this._getBannerYPos();

			this.wait('addedToDom').then(function () {
				return setTimeout(function () {
					_this3._bindData.position = '-' + yPos + 'px';
				}, 100);
			});

			this.__shouldEmbed = true;
			this.render();

			this._getLiveshowData().then(function (_ref6) {
				var thumbnail = _ref6.thumbnail,
				    isPaidShow = _ref6.isPaidShow,
				    privateShowRequest = _ref6.privateShowRequest,
				    _ref6$allowedGroups = _ref6.allowedGroups,
				    allowedGroups = _ref6$allowedGroups === undefined ? [] : _ref6$allowedGroups;

				_this3.setThumbnail(thumbnail);
				_this3._bindData.showPrivateRequestBtn = !isPaidShow && !!privateShowRequest;
				_this3._bindData.isPremiumMember = _this3.rwom1('@root #permissionManager').hasAccess('member');
				_this3._bindData.showJoinButton = !_this3._bindData.isPremiumMember && !_this3.isAllowed(allowedGroups) && allowedGroups.length;
			});
		},
		hide: function hide() {
			var _this4 = this;

			delete this.__isPrivateRequest;

			this._bindData.position = '100%';

			setTimeout(function () {
				_this4.setThumbnail();
				_this4.removeFromDom();
			}, this._bindData.transitionDuration + 100);
		},
		beforeEmbed: function beforeEmbed() {
			if (this.__shouldEmbed) {
				this.__shouldEmbed = false;
				return this.callParent('beforeEmbed', arguments);
			}

			return false;
		}
	}, isAllowedMethod));
};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	__webpack_require__(573);
	__webpack_require__(575);
	__webpack_require__(577)(fox);
	__webpack_require__(578)(fox);

	__webpack_require__(579)(fox);
	__webpack_require__(580)(fox);
	__webpack_require__(581)(fox);

	__webpack_require__(52);
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(574);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_guest-purchase-popup.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_guest-purchase-popup.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".guest-confirm-popup .msg-block .row{margin-top:15px}.guest-confirm-popup .msg-block .reg-error{color:#d35853;border-style:solid;border-width:1px 0;margin:20px 0 10px;padding:10px 0;text-align:center;display:none}.guest-confirm-popup .msg-block .reg-error.show{display:block}", ""]);

// exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(576);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_discount-sicker.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_discount-sicker.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".discount-sticker{width:66px;height:66px;color:#fff;font-size:10px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;background:url(" + __webpack_require__(52) + ") 0 0 no-repeat;text-align:center;letter-spacing:normal;text-transform:none;font-weight:700}.discount-sticker .value{font-size:18px}.discount-sticker.btn-container{position:absolute;left:-45px;top:-10px}", ""]);

// exports


/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("common_guest_purchase_popup", [["div",{"class":"guest-confirm-popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Are you excited?"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["import",{"name":""},[],[["template","name",true]]],["div",{"class":"msg-block"},[["div",{"id":"store-reg-form"},[["div",{"id":"message","class":"reg-error"}],["div",{"class":"row"},[["div",{"class":"common-input simple"},[["input",{"type":"text","name":"username","autofocus":"","required":"","placeholder":"Enter your nickname"}],["div",{"class":"border"}]]],["div",{"class":"error-message _m-t-10 _tc-err"}]]],["div",{"class":"row"},[["div",{"class":"common-input simple"},[["input",{"type":"email","name":"email","required":"","placeholder":"Enter your email"}],["div",{"class":"border"}]]],["div",{"class":"error-message _m-t-10 _tc-err"}]]]]]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"purchase","class":"mc-common-button"},[["textNode",{"text":"Confirm"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	var $ = fox.jQuery;
	var formValidationMixin = __webpack_require__(53)(fox);

	fox.registerWidget('Common_GuestPurchasePopup', fox.mixin({
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				preventHideOnShadowClick: true,
				dialog: {
					closeOnEscape: false,
					width: '482px'
				},
				widgets: {
					content: {
						template: 'common_guest_purchase_popup',
						widgets: {
							form: {
								widget: 'DomForm',
								formSelector: '#store-reg-form',
								elements: {
									email: {
										validators: [{ validator: 'regexp', options: { type: 'email' }, message: 'Email address is invalid' }]
									}
								},
								'handleWom.formValid': {
									widget: '@this',
									event: ['form_valid', 'form_not_valid'],
									callback: function callback() {
										return _this.formInvalidate.apply(_this, arguments);
									}
								}
							}
						},
						'handleDom.focus': {
							target: 'input',
							event: 'focus',
							callback: function callback(el) {
								return $(el.parentNode).removeClass('error');
							}
						}
					}
				},
				handleDom: {
					purchase: {
						target: '#purchase',
						targetWidget: '#content',
						callback: function callback() {
							return _this.purchase.apply(_this, arguments);
						}
					},
					cancel: {
						target: ['#cancel', '.cross.close'],
						targetWidget: '#content',
						callback: function callback() {
							return _this.cancel.apply(_this, arguments);
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		init: function init() {
			this.registerOptions('#content', {
				'templateOptions.template': this.getOption('contentTemplate')
			});

			this.callParent('init', arguments);
		},
		show: function show() {
			var _this2 = this;

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return new fox.Promise(function (resolve) {
				_this2.__resolver = resolve;
				_this2.callParent('show', args);
			});
		},
		purchase: function purchase(button) {
			var _this3 = this;

			var form = this.rwom1('#content #form');
			return form.submit().then(function (result) {
				if (!result) return false;

				_this3.hide();
				form.reset();
				return _this3.__resolver({
					result: result,
					button: button
				});
			});
		},
		cancel: function cancel() {
			return this.__resolver(false);
		}
	}, formValidationMixin), 'Popup_Common');
};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

module.exports = function (fox) {
	var SHOW_CAPTCHA_ATTEMPTS = 5;
	var LS_LABEL = '_auth_fails_';

	var emptyValidator = function emptyValidator() {
		var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		return {
			result: value.length > 0,
			message: 'Cannot be empty'
		};
	};

	fox.registerWidget('Common_LoginForm', {
		configure: function configure() {
			this.registerOptions('', {
				autoRender: true,
				useCaptcha: false,
				captchaContainer: '#captcha',
				captchaAlias: 'autumnNew',
				widgets: {
					form: {
						widget: 'DomForm',
						valuePostProcessing: [function () {
							var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
							return encodeURIComponent(fox.trim(value));
						}],
						elements: {
							'login.validators': [emptyValidator],
							'password.validators': [emptyValidator]
						}
					}
				},
				handleDom: {
					reloadCapcha: {
						target: '#reload-captcha',
						callback: function callback(node, alias, captcha) {
							return captcha.loadCaptcha();
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		_requireCallbackFromOption: function _requireCallbackFromOption(optionName) {
			var callback = this.requireOption(optionName);

			if (typeof callback !== 'function') throw new TypeError('[' + optionName + '] must be an function');

			return callback;
		},
		init: function init() {
			var _this = this;

			var useCaptcha = this.getOption('useCaptcha');

			var failsCount = 0;
			Object.defineProperty(this, '_failsCount', {
				set: function set(value) {
					failsCount = value;

					localStorage.setItem(LS_LABEL, JSON.stringify({
						value: failsCount,
						timestamp: new Date().getTime()
					}));
				},
				get: function get() {
					if (failsCount === 0) {
						var fromStorage = localStorage.getItem(LS_LABEL);
						var now = new Date().getTime();

						if (fromStorage !== null) {
							fromStorage = JSON.parse(fromStorage);

							if (now - fromStorage.timestamp < 1000 * 60 * 30) failsCount = fromStorage.value;
						}
					}

					return failsCount;
				}
			});

			this.api = this._requireCallbackFromOption('configureApi')();
			this.prepareParams = this._requireCallbackFromOption('prepareParamsCallback');
			this.loginSuccess = this._requireCallbackFromOption('loginSuccessCallback');
			this.loginFailed = this._requireCallbackFromOption('loginFailedCallback');
			this.showCaptcha = useCaptcha && this._requireCallbackFromOption('showCaptchaCallback') || function () {
				return null;
			};

			if (useCaptcha) {
				this.embedWidget('captcha', 'Captcha', {
					'embed.container': this.getOption('captchaContainer'),
					captchaAlias: this.getOption('captchaAlias')
				});

				this.registerOptions('#form', {
					elements: {
						'captcha.validators': [function (value, validator) {
							setTimeout(function () {
								return validator.resetResultCache(value);
							}, 10);

							if (_this._failsCount > SHOW_CAPTCHA_ATTEMPTS) return emptyValidator(value);

							return { result: true };
						}]
					}
				});
			}

			this.callParent('init', arguments);
		},
		login: function login(rest) {
			var _this2 = this;

			var form = this.rwom1('#form');
			var captcha = this.wom1('#captcha');

			return form.submit().then(function (result) {
				if (!result) return false;

				if (_this2._failsCount > SHOW_CAPTCHA_ATTEMPTS) {
					result = _extends({}, result, { captchaId: captcha.captchaId });
				}

				return _this2.api.psend(_this2.prepareParams(result, rest)).then(function (_ref) {
					var params = _ref.params;

					_this2._failsCount = 0;
					return _this2.loginSuccess(params, rest);
				}).catch(function (error) {
					var data = error.params.answer.data;


					_this2._failsCount = data || _this2._failsCount;

					if (_this2._failsCount > SHOW_CAPTCHA_ATTEMPTS) {
						_this2.showCaptcha();
						captcha.loadCaptcha();
					}

					return _this2.loginFailed(error, rest);
				});
			});
		},
		addedToDom: function addedToDom() {
			if (this._failsCount > SHOW_CAPTCHA_ATTEMPTS) this.showCaptcha();
		}
	});
};

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("common_autologin_popup", [["div",{"class":"guest-confirm-popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"ALREADY A MEMBER?"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["form",{"id":"authorization-form","class":"auth-form","autocomplete":"off"},[["div",{"class":"popup-content-wrapper"},[["p",{},[["textNode",{"text":"The owner of this email already has access to this website."}]]],["p",{},[["textNode",{"text":"To locate your password, search your email for messages from "}],["a",{"onclick":"this.href=this.href.replace(/AT/,'@') .replace(/DOT/,'.')","href":"mailto:supportATmodelcentroDOTcom"},[["textNode",{"text":"support@modelcentro.com"}]]],["textNode",{"text":"."}]]],["p",{},[["textNode",{"text":"Please log in to complete the operation."}]]],["div",{"class":"msg-block"},[["div",{"id":"message","class":"reg-error"}],["div",{"class":"row"},[["div",{"class":"common-input simple"},[["input",{"type":"text","name":"login","required":"","placeholder":"Enter your login"}],["div",{"class":"border"}]]],["div",{"class":"error-message _m-t-10 _tc-err"}]]],["div",{"class":"row"},[["div",{"class":"common-input simple"},[["input",{"type":"password","name":"password","required":"","placeholder":"Enter your password"}],["div",{"class":"border"}]]],["div",{"class":"error-message _m-t-10 _tc-err"}]]],["import",{"name":"captchaBlock"}]]]]],["div",{"class":"popup-footer-wrapper _flex _row-n _r-v-center _r-h-justify"},[["div",{},[["div",{},[["input",{"type":"checkbox","id":"longPeriod","name":"longPeriod","value":"1"}],["textNode",{"text":" "}],["label",{"for":"longPeriod"},[["textNode",{"text":"Stay logged in"}]]]]]]],["button",{"id":"login","class":"mc-common-button"},[["textNode",{"text":"Login"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

module.exports = function (fox) {
	var $ = fox.jQuery;

	var formValidationMixin = __webpack_require__(53)(fox);
	var socketsReconnectMixin = __webpack_require__(39)(fox);

	fox.registerWidget('Common_AutoLoginPopup', fox.mixin({
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				preventHideOnShadowClick: true,
				dialog: {
					closeOnEscape: false,
					width: '482px'
				},
				widgets: {
					content: {
						widget: 'Common_LoginForm',
						template: 'common_autologin_popup',
						useCaptcha: true,
						configureApi: function configureApi() {
							return _this.configureApi();
						},
						prepareParamsCallback: function prepareParamsCallback(params) {
							return _this.prepareParams(params);
						},
						loginSuccessCallback: function loginSuccessCallback() {
							return _this.loginSuccess.apply(_this, arguments);
						},
						loginFailedCallback: function loginFailedCallback() {
							return _this.loginFailed.apply(_this, arguments);
						},
						showCaptchaCallback: function showCaptchaCallback() {
							return _this.showCaptcha();
						}
					}
				},
				'handleWom.formValid': {
					widget: '#content #form',
					event: ['form_valid', 'form_not_valid'],
					callback: function callback() {
						return _this.formInvalidate.apply(_this, arguments);
					}
				},
				handleDom: {
					submit: {
						target: '#login',
						targetWidget: '#content',
						callback: function callback(button, alias, widget, event) {
							event.preventDefault();

							$(widget.rdom1('.reg-error')).text('').hide();

							$(button).addClass('spin');
							button.disabled = true;

							widget.login({ button: button }).then(function (result) {
								if (!result) {
									$(button).removeClass('spin');
									button.disabled = false;
								}

								return result === true && _this.__resolver(result);
							});
						}
					},
					cancel: {
						target: ['#cancel', '.cross.close'],
						targetWidget: '#content',
						callback: function callback() {
							return _this.__resolver(false);
						}
					},
					focusElement: {
						event: 'focus',
						target: ['input[type=text]', 'input[type=password]'],
						targetWidget: '#content',
						callback: function callback(input, alias, widget) {
							$(widget.rdom1('.reg-error')).text('').hide();
						}
					}
				}
			});

			this.registerOptions('#content #form', {
				formSelector: '#authorization-form'
			});

			this.callParent('configure', arguments);
		},
		configureApi: function configureApi() {
			return this.getApi('__authorizeApi', {
				httpMethod: 'post',
				method: 'site.authorizer.auth',
				secure: fox.getEnv('ah') && [fox.getEnv('ah').split('').reverse().join(''), fox.getEnv('aet')]
			});
		},
		prepareParams: function prepareParams() {
			var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			var login = _ref.login,
			    rest = _objectWithoutProperties(_ref, ['login']);

			return _extends({}, rest, {
				le: login
			});
		},
		loginSuccess: function loginSuccess(resp, rest) {
			var _this2 = this;

			var member = fox.objectGet(resp, 'answer.response.member');

			if (!member) return this.loginFailed(false);

			var button = rest.button;


			$(button).removeClass('spin');
			button.disabled = false;

			if (this.isOpen()) this.hide();

			member.login = member.login || member.email;
			fox.setEnv('member', { collection: { 0: member } });

			var permissionManager = this.rwom1('@root #permissionManager');
			var isPremium = member.isPremium;

			var promise = this.wait(permissionManager, 'permissions_update').then(function (resp) {
				return _this2.reconnectSockets();
			});

			if (isPremium) {
				permissionManager.updatePermissions({
					guest: { enabled: false },
					member: { enabled: true }
				});
			} else {
				permissionManager.updatePermissions({ guest: { enabled: true } });
			}

			return promise.then(function (result) {
				_this2.dispatchEvent('login_succeed');
				return result;
			});
		},
		loginFailed: function loginFailed(_ref2, rest) {
			var reason = _ref2.params.answer.reason;

			$(this.rwom1('#content').rdom1('.reg-error')).text(reason).show();

			var button = rest.button;


			$(button).removeClass('spin');
			button.disabled = false;

			this.dispatchEvent('login_failed');

			return false;
		},
		show: function show() {
			var _this3 = this;

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return new fox.Promise(function (resolve) {
				_this3.__resolver = resolve;
				_this3.callParent('show', args);
			});
		},
		showCaptcha: function showCaptcha() {
			$(this.rwom1('#content').rdom1('#captchaBlock')).show();
		}
	}, formValidationMixin, socketsReconnectMixin), 'Popup_Common');
};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';

    __webpack_require__(583);
	__webpack_require__(585)(fox);

	//require('./stylus/_splash.styl');
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(584);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_requestPermissionPopup.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_requestPermissionPopup.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".push-notification-prompt{box-shadow:0 1px 2px rgba(0,0,0,.2);font-family:Segoe UI,Open Sans,Dejavu Sans,Helvetica,Helvetica Neue,Arial,sans-serif;color:#000;text-align:left;position:fixed;z-index:999999;background-color:#fff}.push-notification-prompt.push-notification-bar{position:relative;border-bottom:2px solid #ffd400;padding-top:10px;padding-bottom:10px}.push-notification-prompt .push-notification-prompt-close{right:8px;top:2px;width:20px;font-size:20px;font-weight:700;line-height:20px;color:#727272}.push-notification-prompt .push-notification-prompt-close:hover{color:#333}.push-notification-prompt-btn,.push-notification-prompt-close{font-family:Segoe UI,Open Sans,Dejavu Sans,Helvetica,Helvetica Neue,Arial,sans-serif}.push-notification-prompt-btn{font-size:13px;padding:2px 8px 3px;display:inline-block!important;outline:none!important;border:1px solid #aaa;border-radius:3px;background:#fff;text-shadow:none!important}.push-notification-prompt-btn:active{position:relative;top:1px;box-shadow:inset 0 1px 1px rgba(0,0,0,.1)}.push-notification-accept-btn{margin:2px 5px}.push-notification-accept-btn:hover{background:#f9f9f9}.push-notification-disallow-btn{background-color:#fff!important}.push-notification-bar .push-notification-prompt-message{width:90%;margin:auto;text-align:center}.push-notification-bell-icon{position:relative;margin-right:5px;vertical-align:middle;width:11px;height:11px;display:inline-block!important}.push-notification-bell-icon i{font-size:11px}.push-notification-popover .push-notification-bell-icon{float:left;width:5%}.push-notification-popover-bottom .push-notification-bell-icon,.push-notification-popover-top .push-notification-bell-icon{margin-right:10px}.push-notification-prompt-close{position:absolute;right:0;top:6px;width:5%;font-size:22px!important;text-align:center;border:none!important;background:none!important;outline:none!important;padding:0!important}@media (min-width:769px){.push-notification-prompt{padding:12px 15px;border-radius:2px;border:1px solid rgba(0,0,0,.2);box-shadow:0 3px 2px rgba(0,0,0,.15);color:#000!important}.push-notification-prompt .push-notification-prompt-btn{margin:0;border-radius:2px;padding:5px 10px!important;background-color:#f9f9f9;font-size:12px;border-color:#bababa;font-family:Segoe UI,Open Sans,Dejavu Sans,Helvetica,Helvetica Neue,Arial,sans-serif;color:#000!important;text-transform:none;font-weight:400;box-shadow:0 1px 1px rgba(0,0,0,.1)}.push-notification-prompt .push-notification-accept-btn{margin-left:5px}.push-notification-popover{width:300px;max-width:380px;left:90px;top:6px}.push-notification-popover:before{top:-6px;border-bottom:6px solid rgba(0,0,0,.25);z-index:999997}.push-notification-popover:after{top:-5px;border-bottom:6px solid #fff;z-index:999998}.push-notification-popover .push-notification-prompt-message-text{margin-bottom:13px;display:inline-block}.push-notification-popover .push-prompt-text{float:left;width:85%;margin-left:10px;line-height:16px}.push-notification-popover-top{max-width:100%;top:6px;left:5px;right:5px}.push-notification-popover-bottom{max-width:100%;bottom:6px;left:5px;right:5px}.push-notification-prompt-message-text{font-size:12px;display:block;color:#000!important;margin-right:20px}.push-notification-prompt-buttons{text-align:right;margin-bottom:2px}.push-notification-prompt-inline-buttons{text-align:right;margin-bottom:2px;padding-left:50px;display:inline-block}.push-notification-prompt-info{margin-bottom:0}.push-notification-prompt-info .push-notification-bell-icon{margin-left:-15px}}@media (min-width:769px){.push-notification-popover:after,.push-notification-popover:before{content:\"\";position:absolute;left:10px;width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff}}@media (min-width:769px){.push-notification-popover-bottom .push-notification-prompt-message-text,.push-notification-popover-top .push-notification-prompt-message-text{text-align:center}}@media (max-width:768px){.push-notification-prompt{width:80%;margin-left:10%;margin-right:10%;top:auto;bottom:0;padding:10px 15px;border:1px solid #cdcdcd;font-family:Roboto,Arial,Helvetica,Helvetica Neue,Dejavu Sans,sans-serif!important;box-shadow:0 1px 6px rgba(0,0,0,.2)!important}.push-notification-prompt .push-notification-prompt-message-text{font-size:14px;display:block;margin-bottom:10px;color:#000;display:inline-block}.push-notification-prompt .push-notification-prompt-message-text:first-child{margin-bottom:5px;margin-right:10px}.push-notification-prompt .push-notification-prompt-close{font-size:32px!important;font-weight:400;line-height:30px}.push-notification-prompt-btn{float:right;text-transform:uppercase;font-weight:700;font-family:Roboto,Arial,Helvetica,Helvetica Neue,Dejavu Sans,sans-serif!important;border:none;padding:6px 12px;color:#000!important;font-size:13px;margin-top:10px}.push-notification-accept-btn{margin:10px 0 0 2px;color:#000!important}.push-notification-accept-btn:active{background:#3872d4!important}.push-notification-disallow-btn:active{background:#ddd!important}}@media (max-width:768px){.push-notification-popover-bottom .push-notification-prompt-message,.push-notification-popover-top .push-notification-prompt-message{text-align:center}}@media (max-width:768px){.push-notification-popover-bottom .push-notification-prompt-message-text,.push-notification-popover-top .push-notification-prompt-message-text{display:inline-block}}@media (max-width:380px){.push-notification-prompt.push-notification-popover{width:100%;margin-left:0;margin-right:0;border-left:none;border-right:none;border-bottom:none}}.close-prompt{position:absolute;right:7px;top:7px;width:14px;height:14px;display:inline-block;background-size:14px;cursor:pointer}.close-prompt i{font-size:11px}", ""]);

// exports


/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("request_permissions_message", [["div",{"class":"push-notification-prompt push-notification-popover","style":"visibility: visible;"},[["div",{"class":"push-notification-prompt-message"},[["div",{"class":"push-notification-prompt-message-text"},[["span",{"class":"push-notification-bell-icon"},[["i",{"class":"icon-lib-bell_17"}]]],["div",{"class":"push-prompt-text"},[["p",{},[["span",{},[],[["location","__text",true]]],["textNode",{"text":" wants to show notifications"}]]]]]]],["div",{"class":"push-notification-prompt-buttons"},[["button",{"class":"push-notification-prompt-btn push-notification-disallow-btn","type":"button"},[["textNode",{"text":"Block"}]]],["button",{"class":"push-notification-prompt-btn push-notification-accept-btn","type":"button"},[["textNode",{"text":"Allow"}]]]]],["span",{"class":"close-prompt"},[["i",{"class":"icon-lib-cross_17"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';
	__webpack_require__(587)(fox);
	__webpack_require__(588)(fox);
	__webpack_require__(589)(fox);
	__webpack_require__(590);

};

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sestafosta_confirm_popup", [["div",{"class":"sesta-fosta-popup-wraper"},[["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Why are your reporting my site "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"id":"form-content","class":"auth-form"},[["div",{"class":"_fs-12","style":"text-align:left;"},[["if",{"empty":""},[["div",{"class":"nsl-form"},[["div",{"class":"common-input"},[["input",{"name":"email","type":"email","required":"","placeholder":"Enter your email (required)"}]]],["span",{"class":"inp-error _tc-err"},[["textNode",{"text":"This field is required"}]]]]]],[["id","empty",true,[],"member"]]],["div",{"class":"nsl-form"},[["div",{"class":"ui_select_2  _m-t-30 nsl-form"},[["select",{"name":"reportCategory","required":"","type":"text","value":""},[["option",{"class":"selection","selected":"","disabled":"","value":""},[["textNode",{"text":" Select report reason (required)"}]]],["option",{"value":"1"},[["textNode",{"text":"Infringes My Rights or Other Legal Concern"}]]],["option",{"value":"2"},[["textNode",{"text":"Copyright Concern"}]]],["option",{"value":"3"},[["textNode",{"text":"Potentially features a Minor"}]]],["option",{"value":"4"},[["textNode",{"text":"Violent or Harmful Acts"}]]],["option",{"value":"5"},[["textNode",{"text":"Hateful or Inflammatory"}]]],["option",{"value":"6"},[["textNode",{"text":"Spam or Misleading Content"}]]],["option",{"value":"7"},[["textNode",{"text":"Otherwise Inappropriate or Objectionable"}]]]]],["i",{"class":"root-ico_tags_arr arr"}]]],["span",{"class":"inp-error _tc-err"},[["textNode",{"text":"This field is required"}]]]]],["div",{"class":"nsl-form"},[["div",{"class":"common-input textarea message simple _m-t-30 "},[["textarea",{"id":"comment","name":"comment","required":"","placeholder":"Your report message (required)","minlength":"10","maxlength":"500","rows":"5"}]]],["span",{"class":"label-area"},[["span",{"id":"info-ch"},[["textNode",{"text":"500"}]]],["textNode",{"text":" characters left"}]]],["textNode",{"text":" "}],["span",{"class":"inp-error _tc-err"},[["textNode",{"text":"Please type your comment"}]]]]],["label",{"for":"consentAccepted","class":"form-label _flex _row-n _r-v-center _m-t-30"},[["span",{"class":"_fs-18"},[["textNode",{"text":"*"}]]],["div",{"class":"gdpr-checkbox _m-r-15 _m-l-5 _flex-1"},[["input",{"type":"checkbox","id":"consentAccepted","name":"consentAccepted","required":""}],["textNode",{"text":" "}],["span",{"class":"shape"}],["textNode",{"text":" "}],["span",{"class":"check"}]]],["span",{"class":"_fs-12"},[["textNode",{"text":"By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}],["a",{"target":"_blank","href":"/terms"},[["textNode",{"text":"Terms of Use"}]]]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","type":"submit","class":"mc-common-button primary"},[["textNode",{"text":"Submit"}]]]]]]]]]]]]]]);
fox.registerTemplate("sestafosta_error_popup", [["div",{"class":"sesta-fosta-popup-wraper"},[["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Error. "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center"},[["textNode",{"text":"Your have already reported this site."}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center _m-t-30"},[["button",{"id":"on-cancel","class":"mc-common-button primary"},[["textNode",{"text":"Ok"}]]]]]]]]);
fox.registerTemplate("sestafosta_succes_popup", [["div",{"class":"sesta-fosta-popup-wraper"},[["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Success! "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center"},[["textNode",{"text":"Your report has been sent."}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center _m-t-30"},[["button",{"id":"on-cancel","class":"mc-common-button primary"},[["textNode",{"text":"Ok"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox, $) {
	'use strict';

	fox.registerWidget('SestaFosta_Popup', {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				contentTemplate: 'sestafosta_confirm_popup',

				onOkPress: function onOkPress() {
					return _this.sumbitForm.apply(_this, arguments);
				},
				onCancelPress: function onCancelPress() {
					return _this.onCancel.apply(_this, arguments);
				},
				widgets: {
					form: {
						widget: 'DomForm',
						formSelector: '#form-content',
						validateOnFly: false
					},
					confirmPopup: {
						widget: 'SestaFosta_Confirmanion'
					},
					'content.handleDom': {
						chracterLeft: {
							target: '#comment',
							event: 'keyup',
							callback: '@parent:chracterLeft'
						}
					}
				},
				handleWom: {
					formValidation: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: function callback(infos, form) {
							return infos.forEach(function (_ref) {
								var field = _ref.field,
								    result = _ref.result;

								var element = form.getElement(field);

								element.nodes.forEach(function (node) {
									var label = node.parentNode.parentNode;

									if (label) {
										return !result ? label.classList.add('error') : label.classList.remove('error');
									}
								});
							});
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		activate: function activate() {
			this.rwom1('#content').setOption('template', 'sestafosta_confirm_popup');
			this.callParent('activate', arguments);
		},
		sumbitForm: function sumbitForm(button) {
			var _this2 = this;

			var confirmPopup = this.wom1('#confirmPopup');
			var sendApi = this.getApi('updateApi', {
				method: 'report.site',
				encodePost: true,
				httpMethod: 'post'
			});
			var form = this.rwom1('#form');

			return form.submit().then(function (values) {
				if (values === false) {
					return null;
				}
				return sendApi.psend(values).then(function (resp) {
					_this2.hide();
					return confirmPopup.show('sestafosta_succes_popup').then(function () {
						return true;
					});
				}).catch(function (err) {
					console.log(err);
					_this2.hide();
					return confirmPopup.show('sestafosta_error_popup').then(function () {
						return true;
					});
				});
			});
		},
		chracterLeft: function chracterLeft(value) {
			var text = value.value.length;
			var chLeft = 500 - text;
			$('#info-ch').text(chLeft);
		}
	}, 'GDPR_BasePopup');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

fox.registerWidget('SestaFosta_Confirmanion', {
    configure: function configure() {
        var _this = this;

        this.registerOptions('', {
            additionalClasses: 'gdpr-small',
            hideOnOkPressed: true,
            onOkPress: function onOkPress(button) {
                if (_this.getOption('hideOnOkPressed')) {
                    _this.hide();
                }

                return fox.Promise.resolve(button);
            }
        });

        this.callParent('configure', arguments);
    },
    show: function show(template) {
        var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var content = this.rwom1('#content');
        content.setOption('template', template);
        content.setTemplateOptions('text', text);

        content.render();

        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
        }

        return this.callParent('show', args);
    }
}, 'GDPR_BasePopup');
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(591);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!./_gui-elem.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!./_gui-elem.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".mc-site-common-popup .ui-dialog-content .sesta-fosta-popup-wraper .popup-content-wrapper .common-input{line-height:3.3em}.mc-site-common-popup .sesta-fosta-popup-wraper .auth-form{max-width:400px}.mc-site-common-popup .ui-dialog-content .sesta-fosta-popup-wraper .popup-content-wrapper .common-input input{width:100%;max-width:400px;position:relative;background-color:transparent;border:none;display:block;height:100%;z-index:5;color:inherit;padding:12px 15px;border-radius:2px;transition:color .2s;color:#ccc;font-size:13px;font-family:pt_sansregular}.nsl-form .inp-error{display:none}.sesta-fosta-popup-wraper{max-width:450px}.sesta-fosta-popup-wraper .common-input{border:1px solid hsla(0,1%,59%,.35)}.sesta-fosta-popup-wraper .common-input.textarea{height:80px;overflow:hidden}.mc-site-common-popup .sesta-fosta-popup-wraper .common-input textarea{height:80px;resize:none;width:100%;background:transparent;border:none;color:#999898;line-height:15px;padding:7px;font-family:pt_sansregular;font-size:13px}.nsl-form{position:relative}.nsl-form.error .inp-error{display:block}.sesta-fosta-popup-wraper .nsl-form.error .common-input,.sesta-fosta-popup-wraper .nsl-form.error .ui_select_2,.sesta-fosta-popup-wraper .nsl-form.error .ui_select_2 .arr{border-color:#bd4147;color:#bd4147}.sesta-fosta-popup-wraper .nsl-form.error .ui_select_2 select{color:#bd4147}.sesta-fosta-popup-wraper .label-area{color:#666;position:absolute;right:15px;top:85px}.sesta-fosta-popup-wraper .ui_select_2 .arr{position:absolute;right:12px;font-size:8px;top:17px;transform:rotate(90deg);z-index:1;height:12px;width:12px}.nsl-form.error #chevron:after,.nsl-form.error #chevron:before{background:#bd4147}.nsl-form.error select{color:#bd4147}.sesta-fosta-popup-wraper .ui_select_2{position:relative;display:inline-block;width:100%;z-index:2;border:1px solid hsla(0,1%,59%,.35)}.sesta-fosta-popup-wraper .ui_select_2 select{position:relative;border:none;width:100%;display:inline-block;cursor:pointer;padding:12px 15px;outline:0;background:transparent;appearance:none;-webkit-appearance:none;-moz-appearance:none;color:#7a7979;z-index:5;font-size:13px}.sesta-fosta-popup-wraper .ui_select_2 select::-ms-expand{display:none}.sesta-fosta-popup-wraper .ui_select_2 select option{color:#7a7979;background:transparent}.sesta-fosta-popup-wraper .ui_select_2 select:disabled{opacity:0;pointer-events:none}.sesta-fosta-popup-wraper .nsl-form .common-input input::-webkit-input-placeholder{color:#ccc}.sesta-fosta-popup-wraper .nsl-form .common-input input:-moz-placeholder,.sesta-fosta-popup-wraper .nsl-form .common-input input::-moz-placeholder{color:#ccc}.sesta-fosta-popup-wraper .nsl-form .common-input input:-ms-input-placeholder{color:#ccc!important}.sesta-fosta-popup-wraper .nsl-form .common-input textarea::-webkit-input-placeholder{color:#ccc}.sesta-fosta-popup-wraper .nsl-form .common-input textarea:-moz-placeholder,.sesta-fosta-popup-wraper .nsl-form .common-input textarea::-moz-placeholder{color:#ccc}.sesta-fosta-popup-wraper .nsl-form .common-input textarea:-ms-input-placeholder{color:#ccc!important}.nsl-form.error .common-input input::-webkit-input-placeholder{color:#bd4147}.nsl-form.error .common-input input:-moz-placeholder,.nsl-form.error .common-input input::-moz-placeholder{color:#bd4147}.nsl-form.error .common-input input:-ms-input-placeholder{color:#bd4147!important}.nsl-form.error .common-input textarea::-webkit-input-placeholder{color:#bd4147}.nsl-form.error .common-input textarea:-moz-placeholder,.nsl-form.error .common-input textarea::-moz-placeholder{color:#bd4147}.nsl-form.error .common-input textarea:-ms-input-placeholder{color:#bd4147!important}", ""]);

// exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	__webpack_require__(55)(fox);
	__webpack_require__(56);

	fox.registerWidget('ExpremiumUser_Popup', {
		configure: function configure() {
			this.registerOptions('', {
				dialog: {
					title: 'Attention!',
					width: '340px',
					'!dialogClass': 'dlg-amc dark-overlay mc-site-common-popup gdpr-popup'
				},
				widgets: {
					content: {
						template: 'ex_premium_user'
					}
				},
				handleDom: {
					close: {
						targetWidget: '#content',
						target: '.close',
						callback: 'hide'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function running() {
			var w = this.rwom1('#content');
			var exCookie = fox.cookie.get('exPrem') || false;
			var exPremium = fox.utils.localStorage('getItem', 'exPremiumUser') || false;
			var name = window.location.hostname;
			w.setTemplateOptions('siteName', name);
			w.render();
			if (exPremium && !exCookie) {
				setTimeout(function () {
					//this.showPopup();
					fox.cookie.set('exPrem', 'on');
					fox.utils.localStorage('setItem', 'exPremiumUser', 0);
				}, 3000);
			}
		},
		showPopup: function showPopup() {
			this.show();
		},
		hidePopup: function hidePopup() {
			this.hide();
		}
	}, 'Popup_Common');
};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".mc-site-common-popup .ui-dialog-content .sesta-fosta-popup-wraper .popup-content-wrapper .common-input{line-height:3.3em}.mc-site-common-popup .sesta-fosta-popup-wraper .auth-form{max-width:400px}.mc-site-common-popup .ui-dialog-content .sesta-fosta-popup-wraper .popup-content-wrapper .common-input input{width:100%;max-width:400px;position:relative;background-color:transparent;border:none;display:block;height:100%;z-index:5;color:inherit;padding:12px 15px;border-radius:2px;transition:color .2s;color:#ccc;font-size:13px;font-family:pt_sansregular}.nsl-form .inp-error{display:none}.sesta-fosta-popup-wraper{max-width:450px}.sesta-fosta-popup-wraper .common-input{border:1px solid hsla(0,1%,59%,.35)}.sesta-fosta-popup-wraper .common-input.textarea{height:80px;overflow:hidden}.mc-site-common-popup .sesta-fosta-popup-wraper .common-input textarea{height:80px;resize:none;width:100%;background:transparent;border:none;color:#999898;line-height:15px;padding:7px;font-family:pt_sansregular;font-size:13px}.nsl-form{position:relative}.nsl-form.error .inp-error{display:block}.sesta-fosta-popup-wraper .nsl-form.error .common-input,.sesta-fosta-popup-wraper .nsl-form.error .ui_select_2,.sesta-fosta-popup-wraper .nsl-form.error .ui_select_2 .arr{border-color:#bd4147;color:#bd4147}.sesta-fosta-popup-wraper .nsl-form.error .ui_select_2 select{color:#bd4147}.sesta-fosta-popup-wraper .label-area{color:#666;position:absolute;right:15px;top:85px}.sesta-fosta-popup-wraper .ui_select_2 .arr{position:absolute;right:12px;font-size:8px;top:17px;transform:rotate(90deg);z-index:1;height:12px;width:12px}.nsl-form.error #chevron:after,.nsl-form.error #chevron:before{background:#bd4147}.nsl-form.error select{color:#bd4147}.sesta-fosta-popup-wraper .ui_select_2{position:relative;display:inline-block;width:100%;z-index:2;border:1px solid hsla(0,1%,59%,.35)}.sesta-fosta-popup-wraper .ui_select_2 select{position:relative;border:none;width:100%;display:inline-block;cursor:pointer;padding:12px 15px;outline:0;background:transparent;appearance:none;-webkit-appearance:none;-moz-appearance:none;color:#7a7979;z-index:5;font-size:13px}.sesta-fosta-popup-wraper .ui_select_2 select::-ms-expand{display:none}.sesta-fosta-popup-wraper .ui_select_2 select option{color:#7a7979;background:transparent}.sesta-fosta-popup-wraper .ui_select_2 select:disabled{opacity:0;pointer-events:none}.sesta-fosta-popup-wraper .nsl-form .common-input input::-webkit-input-placeholder{color:#ccc}.sesta-fosta-popup-wraper .nsl-form .common-input input:-moz-placeholder,.sesta-fosta-popup-wraper .nsl-form .common-input input::-moz-placeholder{color:#ccc}.sesta-fosta-popup-wraper .nsl-form .common-input input:-ms-input-placeholder{color:#ccc!important}.sesta-fosta-popup-wraper .nsl-form .common-input textarea::-webkit-input-placeholder{color:#ccc}.sesta-fosta-popup-wraper .nsl-form .common-input textarea:-moz-placeholder,.sesta-fosta-popup-wraper .nsl-form .common-input textarea::-moz-placeholder{color:#ccc}.sesta-fosta-popup-wraper .nsl-form .common-input textarea:-ms-input-placeholder{color:#ccc!important}.nsl-form.error .common-input input::-webkit-input-placeholder{color:#bd4147}.nsl-form.error .common-input input:-moz-placeholder,.nsl-form.error .common-input input::-moz-placeholder{color:#bd4147}.nsl-form.error .common-input input:-ms-input-placeholder{color:#bd4147!important}.nsl-form.error .common-input textarea::-webkit-input-placeholder{color:#bd4147}.nsl-form.error .common-input textarea:-moz-placeholder,.nsl-form.error .common-input textarea::-moz-placeholder{color:#bd4147}.nsl-form.error .common-input textarea:-ms-input-placeholder{color:#bd4147!important}#userUpgrade{margin-right:7px}.text-content{margin-bottom:10px}", ""]);

// exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';
	__webpack_require__(595)(fox);
	__webpack_require__(596)(fox);
	__webpack_require__(597)(fox);
	__webpack_require__(598);
	__webpack_require__(600);

};

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("cancellation_offer_popup", [["div",{"class":"sesta-fosta-popup-wraper"},[["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" How About A Discount? "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center","id":"form-discount"},[["div",{"class":"_flex _row-n _r-h-justify discount"},[["input",{"type":"hidden","name":"retentionPolicyId","value":""},[],[["discounts.retentionPolicy.id","value",true]]],["textNode",{"text":" "}],["input",{"type":"hidden","name":"optionId","value":""},[],[["discounts.optionId","value",true]]],["div",{"class":"descr"},[["p",{"class":"_fs-14"},[["strong",{},[["span",{},[],[["discounts.title","__text",true]]]]]]],["if",{"notempty":""},[["div",{"class":"text _fs-11"},[["span",{},[],[["discounts.description","__text",true]]]]]],[["discounts.description","notempty",true,[{"name":"count","params":["gt","0"]}]]]]]],["div",{"class":"price-section _flex _row-n"},[["if",{"notempty":""},[["div",{"class":"_m-r-15 price-block"},[["div",{"class":"price _fs-12"},[["span",{},[],[["discounts.currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["discounts.discount.totalAmount","__text",true]]],["textNode",{"text":" /mo"}]]],["div",{"class":"dprice _fs-16"},[["span",{},[],[["discounts.currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["discounts.discount.discountAmount","__text",true]]],["textNode",{"text":"/mo"}]]]]],["div",{"class":"burst-1"},[["div",{"class":"burst-2"},[["textNode",{"text":"-"}],["span",{},[],[["discounts.discount.discount","__text",true,[{"name":"number_format","params":[" 0"]}]]]],["textNode",{"text":"%"}]]]]],["else",{},[["div",{"class":"_m-r-15 price-block"},[["div",{"class":"price _fs-12"},[["span",{},[],[["discounts.currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["discounts.discount.totalAmount","__text",true]]]]],["div",{"class":"dprice _fs-16"},[["span",{},[],[["discounts.currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["discounts.discount.discountAmount","__text",true]]]]]]],["div",{"class":"burst-1"},[["div",{"class":"burst-2"},[["textNode",{"text":"-"}],["span",{},[],[["discounts.discount.discount","__text",true,[{"name":"number_format","params":[" 0"]}]]]],["textNode",{"text":"%"}]]]]]]]],[["discounts.type","notempty",true,[{"name":"eq","params":["recurring"]}]]]]]]]],["div",{"class":"_fs-12 text-center"},[["p",{},[["textNode",{"text":" I hate to see you go! I'd love to offer you an exclusive "}],["span",{"class":"bold-text _fs-16"},[["span",{},[],[["discounts.discount.discount","__text",true,[{"name":"number_format","params":["0"]}]]]],["textNode",{"text":"%"}]]],["textNode",{"text":" discount to a monthly subscription. If you stay, you can enjoy my entire site at a special reduced rate and you still have the option to cancel at any time! "}]]],["p",{},[["textNode",{"text":" This "}],["span",{"class":"bold-text _fs-16"},[["span",{},[],[["discounts.discount.discount","__text",true,[{"name":"number_format","params":["0"]}]]]],["textNode",{"text":"%"}]]],["textNode",{"text":" discount is valid for as long as your current subscription is active. If you cancel your subscription and resubscribe later I won't be able to offer it again, so stay subscribed to receive the lowest rate! "}]]],["div",{"class":"popup-footer-wrapper _col-n"},[["button",{"id":"on-success","type":"submit","class":"mc-common-button primary"},[["textNode",{"text":"Yes! I want a discount"}]]],["p",{"class":"_p-t-15 _fs-11"},[["a",{"class":"cancel-link","id":"on-cancel"},[["textNode",{"text":"No, thanks. I don't want a discount."}]]]]]]]]]]]]]]);
fox.registerTemplate("cancellation_error_popup", [["div",{"class":"sesta-fosta-popup-wraper"},[["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Error "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center"},[["textNode",{"text":" You have already chosen this discount option."}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center _m-t-30"},[["button",{"id":"on-cancel","class":"mc-common-button primary"},[["textNode",{"text":"Ok"}]]]]]]]]);
fox.registerTemplate("cancellation_success_popup", [["div",{"class":"sesta-fosta-popup-wraper"},[["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Success! Your Discount is Active! "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center  text-center"},[["p",{},[["textNode",{"text":"Yay! Your subscription discount is in effect. You will continue to enjoy my site at a lower rate for as long as your subscription is active. You still have the option to cancel at any time, but at these rates why would you want to?"}]]]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center _m-t-30"},[["button",{"id":"on-cancel","class":"mc-common-button primary"},[["textNode",{"text":"Ok"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox, $) {
	'use strict';

	fox.registerWidget('Cancellation_Offer_Popup', {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				onOkPress: function onOkPress() {
					return _this.resubscribe.apply(_this, arguments);
				},
				onCancelPress: function onCancelPress() {
					return _this.onCancel.apply(_this, arguments);
				},
				contentTemplate: 'cancellation_offer_popup',
				widgets: {
					actionPopup: {
						widget: 'Cancellation_Action'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#form-discount'
					}
				}
			});
			this.callParent('configure', arguments);
		},
		resubscribe: function resubscribe(el, w, a, e) {
			var _this2 = this;

			var actionPopup = this.wom1('#actionPopup');
			var sendApi = this.getApi('etentionPolicy', {
				method: 'retentionPolicy.resubscribe'
			});
			var form = this.rwom1('#form');
			el.classList.add('spin');
			return form.submit().then(function (values) {
				if (values === false) {
					return null;
				}
				return sendApi.psend(values).then(function (resp) {
					_this2.hide();
					return actionPopup.show('cancellation_success_popup').then(function () {
						return true;
					});
				}).catch(function (err) {
					console.log(err);
					_this2.hide();
					return actionPopup.show('cancellation_error_popup').then(function () {
						return true;
					});
				});
			});
		}
	}, 'GDPR_BasePopup');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

fox.registerWidget('Cancellation_Action', {
    configure: function configure() {
        var _this = this;

        this.registerOptions('', {
            additionalClasses: 'gdpr-small',
            hideOnOkPressed: true,
            onOkPress: function onOkPress(button) {
                if (_this.getOption('hideOnOkPressed')) {
                    _this.hide();
                }

                return fox.Promise.resolve(button);
            }
        });

        this.callParent('configure', arguments);
    },
    show: function show(template) {
        var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var content = this.rwom1('#content');
        content.setOption('template', template);
        content.setTemplateOptions('text', text);

        content.render();

        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
        }

        return this.callParent('show', args);
    },
    hide: function hide() {
        fox.site.gotoPage('account');

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return this.callParent('hide', args);
    }
}, 'GDPR_BasePopup');
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(599);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_gui-elem.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_gui-elem.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".sesta-fosta-popup-wraper{max-width:450px}.sesta-fosta-popup-wraper .common-input{border:1px solid hsla(0,1%,59%,.35)}.sesta-fosta-popup-wraper .common-input input{color:#ccc}.sesta-fosta-popup-wraper .common-input textarea{color:#858585}.sesta-fosta-popup-wraper .nsl-form{position:relative}.sesta-fosta-popup-wraper .nsl-form .inp-error{display:none}.sesta-fosta-popup-wraper .nsl-form.error .inp-error{display:block}.sesta-fosta-popup-wraper .nsl-form.error .common-input{border-color:#bd4147}.sesta-fosta-popup-wraper .nsl-form.error .common-input input::-webkit-input-placeholder{color:#bd4147}.sesta-fosta-popup-wraper .nsl-form.error .common-input input:-moz-placeholder,.sesta-fosta-popup-wraper .nsl-form.error .common-input input::-moz-placeholder{color:#bd4147}.sesta-fosta-popup-wraper .nsl-form.error .common-input input:-ms-input-placeholder{color:#bd4147}.sesta-fosta-popup-wraper .nsl-form.error select{color:#bd4147}.sesta-fosta-popup-wraper .label-area{color:#666;position:absolute;right:15px;top:118px}.sesta-fosta-popup-wraper #chevron{position:absolute;text-align:center;padding:7px;margin-bottom:7px;height:5px;width:9px;top:50%;right:10px}.sesta-fosta-popup-wraper #chevron:before{content:\"\";position:absolute;top:0;left:0;height:4%;width:51%;background:#fff;transform:skew(0deg,45deg)}.sesta-fosta-popup-wraper #chevron:after{content:\"\";position:absolute;top:0;right:0;height:4%;width:50%;background:#fff;transform:skew(0deg,-45deg)}.sesta-fosta-popup-wraper .nsl-form.error #chevron:after,.sesta-fosta-popup-wraper .nsl-form.error #chevron:before{background:#bd4147}.sesta-fosta-popup-wraper .ui_select_2{position:relative;display:inline-block;width:100%}.sesta-fosta-popup-wraper .ui_select_2 select{border:none;width:100%;display:inline-block;cursor:pointer;padding:12px 15px;outline:0;background:transparent;color:#b2b2b2;appearance:none;-webkit-appearance:none;-moz-appearance:none}.sesta-fosta-popup-wraper .ui_select_2 select::-ms-expand{display:none}.sesta-fosta-popup-wraper .ui_select_2 select:disabled{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;pointer-events:none}.sesta-fosta-popup-wraper .cancel-link{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;font-family:pt_sanaregular,arial;text-decoration:underline;cursor:pointer;position:relative}.sesta-fosta-popup-wraper .cancel-link:before{content:\"\";top:50%;margin-top:-10px;display:block;width:19px;height:19px;position:absolute;background-repeat:no-repeat;background-position:0 0;left:10px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.sesta-fosta-popup-wraper .cancel-link.spin{padding-left:40px}.sesta-fosta-popup-wraper .cancel-link.spin:before{animation:play 1s steps(28) infinite;-ms-filter:none;filter:none;opacity:1}.sesta-fosta-popup-wraper .bold-text{font-family:pt_sansbold}.sesta-fosta-popup-wraper .text-center{text-align:center}.popup-content-wrapper,.popup-content-wrapper p,.text-center,.text-center p{width:100%}", ""]);

// exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(601);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_discountCustom.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_discountCustom.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".sesta-fosta-popup-wraper .discount{font-family:pt_sansbold,arial;width:calc(100% + 70px);padding:20px 35px;border-top:1px dotted hsla(0,0%,100%,.3);border-bottom:1px dotted hsla(0,0%,100%,.3);margin-bottom:20px}.sesta-fosta-popup-wraper .discount .burst-1:after,.sesta-fosta-popup-wraper .discount .burst-1:before,.sesta-fosta-popup-wraper .discount .burst-2:after,.sesta-fosta-popup-wraper .discount .burst-2:before{height:35px;width:35px}.sesta-fosta-popup-wraper .discount .text{font-family:pt_sanaregular,arial}.sesta-fosta-popup-wraper .discount .burst-1{z-index:5}.sesta-fosta-popup-wraper .discount .burst-1:before{transform:rotate(18deg)}.sesta-fosta-popup-wraper .discount .burst-1:after{transform:rotate(36deg)}.sesta-fosta-popup-wraper .discount .burst-2{font-size:14px;font-family:arial;padding-top:7px}.sesta-fosta-popup-wraper .discount .burst-1,.sesta-fosta-popup-wraper .discount .burst-2{width:35px;height:35px}.sesta-fosta-popup-wraper .discount .price-section .price{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;position:relative;text-align:center}.sesta-fosta-popup-wraper .discount .price-section .price:after{content:\"\";position:absolute;border-top-width:1px;border-top-style:solid;border-top-color:hsla(0,0%,100%,.7);width:100%;top:10px;transform:translateX(-90%);z-index:-1}.mc-site-common-popup.gdpr-popup .popup-footer-wrapper._col-n{-ms-flex-flow:column nowrap;-ms-flex-flow:column;flex-flow:column}", ""]);

// exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(603))

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = "(function(window, factory) {\n\tvar lazySizes = factory(window, window.document);\n\twindow.lazySizes = lazySizes;\n\tif(typeof module == 'object' && module.exports){\n\t\tmodule.exports = lazySizes;\n\t}\n}(window, function l(window, document) {\n\t'use strict';\n\t/*jshint eqnull:true */\n\tif(!document.getElementsByClassName){return;}\n\n\tvar lazysizes, lazySizesConfig;\n\n\tvar docElem = document.documentElement;\n\n\tvar Date = window.Date;\n\n\tvar supportPicture = window.HTMLPictureElement;\n\n\tvar _addEventListener = 'addEventListener';\n\n\tvar _getAttribute = 'getAttribute';\n\n\tvar addEventListener = window[_addEventListener];\n\n\tvar setTimeout = window.setTimeout;\n\n\tvar requestAnimationFrame = window.requestAnimationFrame || setTimeout;\n\n\tvar requestIdleCallback = window.requestIdleCallback;\n\n\tvar regPicture = /^picture$/i;\n\n\tvar loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];\n\n\tvar regClassCache = {};\n\n\tvar forEach = Array.prototype.forEach;\n\n\tvar hasClass = function(ele, cls) {\n\t\tif(!regClassCache[cls]){\n\t\t\tregClassCache[cls] = new RegExp('(\\\\s|^)'+cls+'(\\\\s|$)');\n\t\t}\n\t\treturn regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];\n\t};\n\n\tvar addClass = function(ele, cls) {\n\t\tif (!hasClass(ele, cls)){\n\t\t\tele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);\n\t\t}\n\t};\n\n\tvar removeClass = function(ele, cls) {\n\t\tvar reg;\n\t\tif ((reg = hasClass(ele,cls))) {\n\t\t\tele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));\n\t\t}\n\t};\n\n\tvar addRemoveLoadEvents = function(dom, fn, add){\n\t\tvar action = add ? _addEventListener : 'removeEventListener';\n\t\tif(add){\n\t\t\taddRemoveLoadEvents(dom, fn);\n\t\t}\n\t\tloadEvents.forEach(function(evt){\n\t\t\tdom[action](evt, fn);\n\t\t});\n\t};\n\n\tvar triggerEvent = function(elem, name, detail, noBubbles, noCancelable){\n\t\tvar event = document.createEvent('Event');\n\n\t\tif(!detail){\n\t\t\tdetail = {};\n\t\t}\n\n\t\tdetail.instance = lazysizes;\n\n\t\tevent.initEvent(name, !noBubbles, !noCancelable);\n\n\t\tevent.detail = detail;\n\n\t\telem.dispatchEvent(event);\n\t\treturn event;\n\t};\n\n\tvar updatePolyfill = function (el, full){\n\t\tvar polyfill;\n\t\tif( !supportPicture && ( polyfill = (window.picturefill || lazySizesConfig.pf) ) ){\n\t\t\tif(full && full.src && !el[_getAttribute]('srcset')){\n\t\t\t\tel.setAttribute('srcset', full.src);\n\t\t\t}\n\t\t\tpolyfill({reevaluate: true, elements: [el]});\n\t\t} else if(full && full.src){\n\t\t\tel.src = full.src;\n\t\t}\n\t};\n\n\tvar getCSS = function (elem, style){\n\t\treturn (getComputedStyle(elem, null) || {})[style];\n\t};\n\n\tvar getWidth = function(elem, parent, width){\n\t\twidth = width || elem.offsetWidth;\n\n\t\twhile(width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth){\n\t\t\twidth =  parent.offsetWidth;\n\t\t\tparent = parent.parentNode;\n\t\t}\n\n\t\treturn width;\n\t};\n\n\tvar rAF = (function(){\n\t\tvar running, waiting;\n\t\tvar firstFns = [];\n\t\tvar secondFns = [];\n\t\tvar fns = firstFns;\n\n\t\tvar run = function(){\n\t\t\tvar runFns = fns;\n\n\t\t\tfns = firstFns.length ? secondFns : firstFns;\n\n\t\t\trunning = true;\n\t\t\twaiting = false;\n\n\t\t\twhile(runFns.length){\n\t\t\t\trunFns.shift()();\n\t\t\t}\n\n\t\t\trunning = false;\n\t\t};\n\n\t\tvar rafBatch = function(fn, queue){\n\t\t\tif(running && !queue){\n\t\t\t\tfn.apply(this, arguments);\n\t\t\t} else {\n\t\t\t\tfns.push(fn);\n\n\t\t\t\tif(!waiting){\n\t\t\t\t\twaiting = true;\n\t\t\t\t\t(document.hidden ? setTimeout : requestAnimationFrame)(run);\n\t\t\t\t}\n\t\t\t}\n\t\t};\n\n\t\trafBatch._lsFlush = run;\n\n\t\treturn rafBatch;\n\t})();\n\n\tvar rAFIt = function(fn, simple){\n\t\treturn simple ?\n\t\t\tfunction() {\n\t\t\t\trAF(fn);\n\t\t\t} :\n\t\t\tfunction(){\n\t\t\t\tvar that = this;\n\t\t\t\tvar args = arguments;\n\t\t\t\trAF(function(){\n\t\t\t\t\tfn.apply(that, args);\n\t\t\t\t});\n\t\t\t}\n\t\t;\n\t};\n\n\tvar throttle = function(fn){\n\t\tvar running;\n\t\tvar lastTime = 0;\n\t\tvar gDelay = lazySizesConfig.throttleDelay;\n\t\tvar rICTimeout = lazySizesConfig.ricTimeout;\n\t\tvar run = function(){\n\t\t\trunning = false;\n\t\t\tlastTime = Date.now();\n\t\t\tfn();\n\t\t};\n\t\tvar idleCallback = requestIdleCallback && rICTimeout > 49 ?\n\t\t\tfunction(){\n\t\t\t\trequestIdleCallback(run, {timeout: rICTimeout});\n\n\t\t\t\tif(rICTimeout !== lazySizesConfig.ricTimeout){\n\t\t\t\t\trICTimeout = lazySizesConfig.ricTimeout;\n\t\t\t\t}\n\t\t\t} :\n\t\t\trAFIt(function(){\n\t\t\t\tsetTimeout(run);\n\t\t\t}, true)\n\t\t;\n\n\t\treturn function(isPriority){\n\t\t\tvar delay;\n\n\t\t\tif((isPriority = isPriority === true)){\n\t\t\t\trICTimeout = 33;\n\t\t\t}\n\n\t\t\tif(running){\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\trunning =  true;\n\n\t\t\tdelay = gDelay - (Date.now() - lastTime);\n\n\t\t\tif(delay < 0){\n\t\t\t\tdelay = 0;\n\t\t\t}\n\n\t\t\tif(isPriority || delay < 9){\n\t\t\t\tidleCallback();\n\t\t\t} else {\n\t\t\t\tsetTimeout(idleCallback, delay);\n\t\t\t}\n\t\t};\n\t};\n\n\t//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html\n\tvar debounce = function(func) {\n\t\tvar timeout, timestamp;\n\t\tvar wait = 99;\n\t\tvar run = function(){\n\t\t\ttimeout = null;\n\t\t\tfunc();\n\t\t};\n\t\tvar later = function() {\n\t\t\tvar last = Date.now() - timestamp;\n\n\t\t\tif (last < wait) {\n\t\t\t\tsetTimeout(later, wait - last);\n\t\t\t} else {\n\t\t\t\t(requestIdleCallback || run)(run);\n\t\t\t}\n\t\t};\n\n\t\treturn function() {\n\t\t\ttimestamp = Date.now();\n\n\t\t\tif (!timeout) {\n\t\t\t\ttimeout = setTimeout(later, wait);\n\t\t\t}\n\t\t};\n\t};\n\n\t(function(){\n\t\tvar prop;\n\n\t\tvar lazySizesDefaults = {\n\t\t\tlazyClass: 'lazyload',\n\t\t\tloadedClass: 'lazyloaded',\n\t\t\tloadingClass: 'lazyloading',\n\t\t\tpreloadClass: 'lazypreload',\n\t\t\terrorClass: 'lazyerror',\n\t\t\t//strictClass: 'lazystrict',\n\t\t\tautosizesClass: 'lazyautosizes',\n\t\t\tsrcAttr: 'data-src',\n\t\t\tsrcsetAttr: 'data-srcset',\n\t\t\tsizesAttr: 'data-sizes',\n\t\t\t//preloadAfterLoad: false,\n\t\t\tminSize: 40,\n\t\t\tcustomMedia: {},\n\t\t\tinit: true,\n\t\t\texpFactor: 1.5,\n\t\t\thFac: 0.8,\n\t\t\tloadMode: 2,\n\t\t\tloadHidden: true,\n\t\t\tricTimeout: 0,\n\t\t\tthrottleDelay: 125,\n\t\t};\n\n\t\tlazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};\n\n\t\tfor(prop in lazySizesDefaults){\n\t\t\tif(!(prop in lazySizesConfig)){\n\t\t\t\tlazySizesConfig[prop] = lazySizesDefaults[prop];\n\t\t\t}\n\t\t}\n\n\t\twindow.lazySizesConfig = lazySizesConfig;\n\n\t\tsetTimeout(function(){\n\t\t\tif(lazySizesConfig.init){\n\t\t\t\tinit();\n\t\t\t}\n\t\t});\n\t})();\n\n\tvar loader = (function(){\n\t\tvar preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;\n\n\t\tvar eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;\n\n\t\tvar regImg = /^img$/i;\n\t\tvar regIframe = /^iframe$/i;\n\n\t\tvar supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));\n\n\t\tvar shrinkExpand = 0;\n\t\tvar currentExpand = 0;\n\n\t\tvar isLoading = 0;\n\t\tvar lowRuns = -1;\n\n\t\tvar resetPreloading = function(e){\n\t\t\tisLoading--;\n\t\t\tif(!e || isLoading < 0 || !e.target){\n\t\t\t\tisLoading = 0;\n\t\t\t}\n\t\t};\n\n\t\tvar isVisible = function (elem) {\n\t\t\tif (isBodyHidden == null) {\n\t\t\t\tisBodyHidden = getCSS(document.body, 'visibility') == 'hidden';\n\t\t\t}\n\n\t\t\treturn isBodyHidden || (getCSS(elem.parentNode, 'visibility') != 'hidden' && getCSS(elem, 'visibility') != 'hidden');\n\t\t};\n\n\t\tvar isNestedVisible = function(elem, elemExpand){\n\t\t\tvar outerRect;\n\t\t\tvar parent = elem;\n\t\t\tvar visible = isVisible(elem);\n\n\t\t\teLtop -= elemExpand;\n\t\t\teLbottom += elemExpand;\n\t\t\teLleft -= elemExpand;\n\t\t\teLright += elemExpand;\n\n\t\t\twhile(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){\n\t\t\t\tvisible = ((getCSS(parent, 'opacity') || 1) > 0);\n\n\t\t\t\tif(visible && getCSS(parent, 'overflow') != 'visible'){\n\t\t\t\t\touterRect = parent.getBoundingClientRect();\n\t\t\t\t\tvisible = eLright > outerRect.left &&\n\t\t\t\t\t\teLleft < outerRect.right &&\n\t\t\t\t\t\teLbottom > outerRect.top - 1 &&\n\t\t\t\t\t\teLtop < outerRect.bottom + 1\n\t\t\t\t\t;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\treturn visible;\n\t\t};\n\n\t\tvar checkElements = function() {\n\t\t\tvar eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,\n\t\t\t\tbeforeExpandVal, defaultExpand, preloadExpand, hFac;\n\t\t\tvar lazyloadElems = lazysizes.elements;\n\n\t\t\tif((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){\n\n\t\t\t\ti = 0;\n\n\t\t\t\tlowRuns++;\n\n\t\t\t\tdefaultExpand = (!lazySizesConfig.expand || lazySizesConfig.expand < 1) ?\n\t\t\t\t\tdocElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :\n\t\t\t\t\tlazySizesConfig.expand;\n\n\t\t\t\tlazysizes._defEx = defaultExpand;\n\n\t\t\t\tpreloadExpand = defaultExpand * lazySizesConfig.expFactor;\n\t\t\t\thFac = lazySizesConfig.hFac;\n\t\t\t\tisBodyHidden = null;\n\n\t\t\t\tif(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){\n\t\t\t\t\tcurrentExpand = preloadExpand;\n\t\t\t\t\tlowRuns = 0;\n\t\t\t\t} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){\n\t\t\t\t\tcurrentExpand = defaultExpand;\n\t\t\t\t} else {\n\t\t\t\t\tcurrentExpand = shrinkExpand;\n\t\t\t\t}\n\n\t\t\t\tfor(; i < eLlen; i++){\n\n\t\t\t\t\tif(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}\n\n\t\t\t\t\tif(!supportScroll){unveilElement(lazyloadElems[i]);continue;}\n\n\t\t\t\t\tif(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){\n\t\t\t\t\t\telemExpand = currentExpand;\n\t\t\t\t\t}\n\n\t\t\t\t\tif(beforeExpandVal !== elemExpand){\n\t\t\t\t\t\teLvW = innerWidth + (elemExpand * hFac);\n\t\t\t\t\t\telvH = innerHeight + elemExpand;\n\t\t\t\t\t\telemNegativeExpand = elemExpand * -1;\n\t\t\t\t\t\tbeforeExpandVal = elemExpand;\n\t\t\t\t\t}\n\n\t\t\t\t\trect = lazyloadElems[i].getBoundingClientRect();\n\n\t\t\t\t\tif ((eLbottom = rect.bottom) >= elemNegativeExpand &&\n\t\t\t\t\t\t(eLtop = rect.top) <= elvH &&\n\t\t\t\t\t\t(eLright = rect.right) >= elemNegativeExpand * hFac &&\n\t\t\t\t\t\t(eLleft = rect.left) <= eLvW &&\n\t\t\t\t\t\t(eLbottom || eLright || eLleft || eLtop) &&\n\t\t\t\t\t\t(lazySizesConfig.loadHidden || isVisible(lazyloadElems[i])) &&\n\t\t\t\t\t\t((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){\n\t\t\t\t\t\tunveilElement(lazyloadElems[i]);\n\t\t\t\t\t\tloadedSomething = true;\n\t\t\t\t\t\tif(isLoading > 9){break;}\n\t\t\t\t\t} else if(!loadedSomething && isCompleted && !autoLoadElem &&\n\t\t\t\t\t\tisLoading < 4 && lowRuns < 4 && loadMode > 2 &&\n\t\t\t\t\t\t(preloadElems[0] || lazySizesConfig.preloadAfterLoad) &&\n\t\t\t\t\t\t(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto')))){\n\t\t\t\t\t\tautoLoadElem = preloadElems[0] || lazyloadElems[i];\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tif(autoLoadElem && !loadedSomething){\n\t\t\t\t\tunveilElement(autoLoadElem);\n\t\t\t\t}\n\t\t\t}\n\t\t};\n\n\t\tvar throttledCheckElements = throttle(checkElements);\n\n\t\tvar switchLoadingClass = function(e){\n\t\t\tvar elem = e.target;\n\n\t\t\tif (elem._lazyCache) {\n\t\t\t\tdelete elem._lazyCache;\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tresetPreloading(e);\n\t\t\taddClass(elem, lazySizesConfig.loadedClass);\n\t\t\tremoveClass(elem, lazySizesConfig.loadingClass);\n\t\t\taddRemoveLoadEvents(elem, rafSwitchLoadingClass);\n\t\t\ttriggerEvent(elem, 'lazyloaded');\n\t\t};\n\t\tvar rafedSwitchLoadingClass = rAFIt(switchLoadingClass);\n\t\tvar rafSwitchLoadingClass = function(e){\n\t\t\trafedSwitchLoadingClass({target: e.target});\n\t\t};\n\n\t\tvar changeIframeSrc = function(elem, src){\n\t\t\ttry {\n\t\t\t\telem.contentWindow.location.replace(src);\n\t\t\t} catch(e){\n\t\t\t\telem.src = src;\n\t\t\t}\n\t\t};\n\n\t\tvar handleSources = function(source){\n\t\t\tvar customMedia;\n\n\t\t\tvar sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);\n\n\t\t\tif( (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){\n\t\t\t\tsource.setAttribute('media', customMedia);\n\t\t\t}\n\n\t\t\tif(sourceSrcset){\n\t\t\t\tsource.setAttribute('srcset', sourceSrcset);\n\t\t\t}\n\t\t};\n\n\t\tvar lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){\n\t\t\tvar src, srcset, parent, isPicture, event, firesLoad;\n\n\t\t\tif(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){\n\n\t\t\t\tif(sizes){\n\t\t\t\t\tif(isAuto){\n\t\t\t\t\t\taddClass(elem, lazySizesConfig.autosizesClass);\n\t\t\t\t\t} else {\n\t\t\t\t\t\telem.setAttribute('sizes', sizes);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tsrcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);\n\t\t\t\tsrc = elem[_getAttribute](lazySizesConfig.srcAttr);\n\n\t\t\t\tif(isImg) {\n\t\t\t\t\tparent = elem.parentNode;\n\t\t\t\t\tisPicture = parent && regPicture.test(parent.nodeName || '');\n\t\t\t\t}\n\n\t\t\t\tfiresLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));\n\n\t\t\t\tevent = {target: elem};\n\n\t\t\t\taddClass(elem, lazySizesConfig.loadingClass);\n\n\t\t\t\tif(firesLoad){\n\t\t\t\t\tclearTimeout(resetPreloadingTimer);\n\t\t\t\t\tresetPreloadingTimer = setTimeout(resetPreloading, 2500);\n\t\t\t\t\taddRemoveLoadEvents(elem, rafSwitchLoadingClass, true);\n\t\t\t\t}\n\n\t\t\t\tif(isPicture){\n\t\t\t\t\tforEach.call(parent.getElementsByTagName('source'), handleSources);\n\t\t\t\t}\n\n\t\t\t\tif(srcset){\n\t\t\t\t\telem.setAttribute('srcset', srcset);\n\t\t\t\t} else if(src && !isPicture){\n\t\t\t\t\tif(regIframe.test(elem.nodeName)){\n\t\t\t\t\t\tchangeIframeSrc(elem, src);\n\t\t\t\t\t} else {\n\t\t\t\t\t\telem.src = src;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tif(isImg && (srcset || isPicture)){\n\t\t\t\t\tupdatePolyfill(elem, {src: src});\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tif(elem._lazyRace){\n\t\t\t\tdelete elem._lazyRace;\n\t\t\t}\n\t\t\tremoveClass(elem, lazySizesConfig.lazyClass);\n\n\t\t\trAF(function(){\n\t\t\t\t// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)\n\t\t\t\tvar isLoaded = elem.complete && elem.naturalWidth > 1;\n\n\t\t\t\tif( !firesLoad || isLoaded){\n\t\t\t\t\tif (isLoaded) {\n\t\t\t\t\t\taddClass(elem, 'ls-is-cached');\n\t\t\t\t\t}\n\t\t\t\t\tswitchLoadingClass(event);\n\t\t\t\t\telem._lazyCache = true;\n\t\t\t\t\tsetTimeout(function(){\n\t\t\t\t\t\tif ('_lazyCache' in elem) {\n\t\t\t\t\t\t\tdelete elem._lazyCache;\n\t\t\t\t\t\t}\n\t\t\t\t\t}, 9);\n\t\t\t\t}\n\t\t\t}, true);\n\t\t});\n\n\t\tvar unveilElement = function (elem){\n\t\t\tvar detail;\n\n\t\t\tvar isImg = regImg.test(elem.nodeName);\n\n\t\t\t//allow using sizes=\"auto\", but don't use. it's invalid. Use data-sizes=\"auto\" or a valid value for sizes instead (i.e.: sizes=\"80vw\")\n\t\t\tvar sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));\n\t\t\tvar isAuto = sizes == 'auto';\n\n\t\t\tif( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass) && hasClass(elem, lazySizesConfig.lazyClass)){return;}\n\n\t\t\tdetail = triggerEvent(elem, 'lazyunveilread').detail;\n\n\t\t\tif(isAuto){\n\t\t\t\t autoSizer.updateElem(elem, true, elem.offsetWidth);\n\t\t\t}\n\n\t\t\telem._lazyRace = true;\n\t\t\tisLoading++;\n\n\t\t\tlazyUnveil(elem, detail, isAuto, sizes, isImg);\n\t\t};\n\n\t\tvar onload = function(){\n\t\t\tif(isCompleted){return;}\n\t\t\tif(Date.now() - started < 999){\n\t\t\t\tsetTimeout(onload, 999);\n\t\t\t\treturn;\n\t\t\t}\n\t\t\tvar afterScroll = debounce(function(){\n\t\t\t\tlazySizesConfig.loadMode = 3;\n\t\t\t\tthrottledCheckElements();\n\t\t\t});\n\n\t\t\tisCompleted = true;\n\n\t\t\tlazySizesConfig.loadMode = 3;\n\n\t\t\tthrottledCheckElements();\n\n\t\t\taddEventListener('scroll', function(){\n\t\t\t\tif(lazySizesConfig.loadMode == 3){\n\t\t\t\t\tlazySizesConfig.loadMode = 2;\n\t\t\t\t}\n\t\t\t\tafterScroll();\n\t\t\t}, true);\n\t\t};\n\n\t\treturn {\n\t\t\t_: function(){\n\t\t\t\tstarted = Date.now();\n\n\t\t\t\tlazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);\n\t\t\t\tpreloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);\n\n\t\t\t\taddEventListener('scroll', throttledCheckElements, true);\n\n\t\t\t\taddEventListener('resize', throttledCheckElements, true);\n\n\t\t\t\tif(window.MutationObserver){\n\t\t\t\t\tnew MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );\n\t\t\t\t} else {\n\t\t\t\t\tdocElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);\n\t\t\t\t\tdocElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);\n\t\t\t\t\tsetInterval(throttledCheckElements, 999);\n\t\t\t\t}\n\n\t\t\t\taddEventListener('hashchange', throttledCheckElements, true);\n\n\t\t\t\t//, 'fullscreenchange'\n\t\t\t\t['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(name){\n\t\t\t\t\tdocument[_addEventListener](name, throttledCheckElements, true);\n\t\t\t\t});\n\n\t\t\t\tif((/d$|^c/.test(document.readyState))){\n\t\t\t\t\tonload();\n\t\t\t\t} else {\n\t\t\t\t\taddEventListener('load', onload);\n\t\t\t\t\tdocument[_addEventListener]('DOMContentLoaded', throttledCheckElements);\n\t\t\t\t\tsetTimeout(onload, 20000);\n\t\t\t\t}\n\n\t\t\t\tif(lazysizes.elements.length){\n\t\t\t\t\tcheckElements();\n\t\t\t\t\trAF._lsFlush();\n\t\t\t\t} else {\n\t\t\t\t\tthrottledCheckElements();\n\t\t\t\t}\n\t\t\t},\n\t\t\tcheckElems: throttledCheckElements,\n\t\t\tunveil: unveilElement\n\t\t};\n\t})();\n\n\n\tvar autoSizer = (function(){\n\t\tvar autosizesElems;\n\n\t\tvar sizeElement = rAFIt(function(elem, parent, event, width){\n\t\t\tvar sources, i, len;\n\t\t\telem._lazysizesWidth = width;\n\t\t\twidth += 'px';\n\n\t\t\telem.setAttribute('sizes', width);\n\n\t\t\tif(regPicture.test(parent.nodeName || '')){\n\t\t\t\tsources = parent.getElementsByTagName('source');\n\t\t\t\tfor(i = 0, len = sources.length; i < len; i++){\n\t\t\t\t\tsources[i].setAttribute('sizes', width);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tif(!event.detail.dataAttr){\n\t\t\t\tupdatePolyfill(elem, event.detail);\n\t\t\t}\n\t\t});\n\t\tvar getSizeElement = function (elem, dataAttr, width){\n\t\t\tvar event;\n\t\t\tvar parent = elem.parentNode;\n\n\t\t\tif(parent){\n\t\t\t\twidth = getWidth(elem, parent, width);\n\t\t\t\tevent = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});\n\n\t\t\t\tif(!event.defaultPrevented){\n\t\t\t\t\twidth = event.detail.width;\n\n\t\t\t\t\tif(width && width !== elem._lazysizesWidth){\n\t\t\t\t\t\tsizeElement(elem, parent, event, width);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t};\n\n\t\tvar updateElementsSizes = function(){\n\t\t\tvar i;\n\t\t\tvar len = autosizesElems.length;\n\t\t\tif(len){\n\t\t\t\ti = 0;\n\n\t\t\t\tfor(; i < len; i++){\n\t\t\t\t\tgetSizeElement(autosizesElems[i]);\n\t\t\t\t}\n\t\t\t}\n\t\t};\n\n\t\tvar debouncedUpdateElementsSizes = debounce(updateElementsSizes);\n\n\t\treturn {\n\t\t\t_: function(){\n\t\t\t\tautosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);\n\t\t\t\taddEventListener('resize', debouncedUpdateElementsSizes);\n\t\t\t},\n\t\t\tcheckElems: debouncedUpdateElementsSizes,\n\t\t\tupdateElem: getSizeElement\n\t\t};\n\t})();\n\n\tvar init = function(){\n\t\tif(!init.i){\n\t\t\tinit.i = true;\n\t\t\tautoSizer._();\n\t\t\tloader._();\n\t\t}\n\t};\n\n\tlazysizes = {\n\t\tcfg: lazySizesConfig,\n\t\tautoSizer: autoSizer,\n\t\tloader: loader,\n\t\tinit: init,\n\t\tuP: updatePolyfill,\n\t\taC: addClass,\n\t\trC: removeClass,\n\t\thC: hasClass,\n\t\tfire: triggerEvent,\n\t\tgW: getWidth,\n\t\trAF: rAF,\n\t};\n\n\treturn lazysizes;\n}\n));\n"

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/**
 * 
 * @param {Fox} fox
 */
module.exports = function (fox, undefined) {
	//@ts-ignore
	__webpack_require__(605);
	//@ts-ignore
	__webpack_require__(607)(fox);

	fox.registerWidget('Control_Select', {
		configure: function configure() {
			this.registerOptions('', {
				autoRender: true,
				template: 'control_select',
				currentValuePlace: '.current-value',
				select: {
					container: '.common-widget-control-select',

					//object of attributes for <select> element
					//{id, name, 'class', etc...}
					attributes: null,

					//array of objects like
					//[{title:'title', value:'value', [selected: true, hidden: true]},{title:'title2', value:'value2']

					options: null
				},

				//generate years options limited by array
				//[startYear, endYear]
				yearsLimit: false,

				//generate months select
				months: false,

				//genearate dates select
				days: false,

				handleDom: {
					change: {
						target: '[name]',
						event: 'change',
						callback: '_change'
					}
				},

				handleWom: {
					mounted: {
						event: 'addedToDom',
						widget: '@this',
						callback: 'change',
						params: {
							prefix: 'control_select',
							sync: true
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},


		running: function running() {
			this._prepareOptions();
			this.callParent('running', arguments);
		},

		createSelect: function createSelect() {
			var select = document.createElement('select');
			var container = this.getOption('select.container');
			//hack for translations
			if (this.getOption('months')) {
				this._prepareOptions();
			}

			fox.each(this.selectAttributes, function (value, attr) {
				select[attr] = value;
			}, this);

			fox.each(this.selectOptions, function (opts, i) {
				var option = document.createElement('option');

				option.innerText = fox.isFunction(opts.title) ? opts.title.call(null) : opts.title;
				option.value = opts.value;

				if (opts.selected && this.value === undefined) {
					option.selected = true;
					this.value = option.value;
				}

				if (this.value !== undefined && this.value === option.value) {
					option.selected = true;
				}

				if (opts.hidden) {
					option.style.display = 'none';
				}

				if (opts.disabled) {
					option.disabled = true;
				}

				if (opts.alterText) {
					option.setAttribute('data-alter-text', opts.alterText);
				}

				select.appendChild(option);
			}, this);

			if (!select.name) {
				select.name = this.alias;
			}

			if (container) {
				this.rdom1(container).appendChild(select);

				return;
			}

			this.fragment.appendChild(select);
		},

		rendering: function rendering() {
			var addClass = this.getOption('addClass');

			if (addClass) {
				this.setTemplateOptions({ addClass: addClass });
			}

			this.callParent('rendering', arguments);

			if (!this.selectOptions || !fox.count(this.selectOptions)) {
				//console.warn('No options defined');
				return;
			}

			this.hookWrapper('createSelect');
		},

		_change: function _change(el) {
			this.selectedOption = el.options[el.selectedIndex];

			this._setValue(this.selectedOption.value);
		},

		_setValue: function _setValue(value, skipEvent) {
			skipEvent = fox.isEmpty(skipEvent) ? false : skipEvent;

			if (value === this.value) {
				return;
			}

			this.value = value;
			this.hookWrapper('change');

			if (!skipEvent) {
				this.dispatchEvent('change', value);

				if (this.api) {
					this.hookWrapper('send', { value: value });
				}
			}

			this.dispatchEvent('setValue', value);
		},

		_markOption: function _markOption(value) {
			fox.each(this.getSelectOptions(), function (option) {
				option.selected = false;

				if (option.value === value) {
					option.selected = true;
				}
			}, this);
		},

		_prepareOptions: function _prepareOptions(value) {
			var options = this.getOption('select.options');
			var yearsLimit = this.getOption('yearsLimit');
			var months = this.getOption('months');
			var days = this.getOption('days');

			this.selectAttributes = this.getOption('select.attributes');

			if (yearsLimit) {
				options = this._generateYears(yearsLimit);
			}

			if (months) {
				options = this._generateMonths();
			}

			if (days) {
				options = this._generateDays();
			}

			this.selectOptions = options;
		},

		change: function change() {
			if (!this.isEmbedded()) {
				return;
			}

			if (this.isEmbedded() && !this.element.length) {
				console.warn('no element for select with name="' + this.alias + '"');

				return;
			}

			var place = this.dom1(this.getOption('currentValuePlace'));
			var selected = this.getSelectedOption();
			var txt = selected.innerText || selected.innerHTML;
			var alterText = selected.getAttribute('data-alter-text');

			if (alterText) {
				txt = alterText;
			}

			place.innerText = txt;

			fox.dom.removeClass('default', place.parentNode);

			if (selected.value < 0 || selected.value === '0') {
				fox.dom.addClass('default', place.parentNode);
			}
		},

		getSelectElement: function getSelectElement() {
			return this.dom1('[name="' + (this.getOption('select.attributes.name') || this.alias) + '"]');
		},

		getSelectOptions: function getSelectOptions() {
			return fox.dom.select('option', this.getSelectElement());
		},

		getSelectedOption: function getSelectedOption() {
			var el = false;

			fox.each(this.getSelectOptions(), function (option) {
				if (option.selected) {
					el = option;
				}
			}, this);

			return el;
		},

		getValue: function getValue() {
			return this.value;
		},

		setValue: function setValue(value, skipEvent) {
			value = value.toString && value.toString() || value;
			this._markOption(value);
			this._setValue(value, skipEvent);
		},

		insertOptions: function insertOptions(options, skipEvent) {
			var select = this.getSelectElement();

			if (!select) {
				console.warn('no select element');
				return;
			}

			fox.each(options, function (opts, i) {
				var option = document.createElement('option');

				option.innerText = fox.isFunction(opts.title) ? opts.title.call(null) : opts.title;
				option.value = opts.value;

				if (opts.selected) {
					option.selected = true;
					this.value = option.value;
				}

				if (opts.disabled) {
					option.disabled = true;
				}

				select.appendChild(option);
			}, this);

			this._setValue(this.value, skipEvent);
		},

		rebuildSelect: function rebuildSelect(options) {
			if (fox.isEmpty(options)) {
				return;
			}

			this.selectOptions = options;
			this.render();
		},

		_generateYears: function _generateYears(arr) {
			var years = [];

			years.push({ title: 'Year', value: '', selected: true, hidden: true });

			for (var i = arr[1]; i >= arr[0]; i--) {
				years.unshift({ title: i, value: i });
			}

			return years;
		},

		_generateMonths: function _generateMonths() {
			var months = [];
			var monthNames = fox.utils.getMonthsArray();

			months.push({ title: 'Month', value: '', selected: true, hidden: true });

			for (var i = 12; i > 0; i--) {
				months.unshift({ title: monthNames[i - 1], value: i < 10 ? '0' + i : i });
			}

			return months;
		},

		_generateDays: function _generateDays() {
			var days = [];

			days.push({ title: 'Day', value: '', selected: true, hidden: true });

			for (var i = 31; i > 0; i--) {
				days.unshift({ title: i, value: i < 10 ? '0' + i : i });
			}

			return days;
		},

		_toggleDisabling: function _toggleDisabling(state) {
			var select;

			if (this.isEmbedded()) {
				select = this.getSelectElement();
				select.disabled = state;

				return this.dispatchEvent(state && 'disabled' || 'enabled');
			}

			return this.wait('addedToDom').then(function () {
				return this._toggleDisabling(state);
			}.bind(this));
		},

		disable: function disable() {
			return this._toggleDisabling(true);
		},

		enable: function enable() {
			return this._toggleDisabling(false);
		},

		reset: function reset() {
			this.value = undefined;
			this.render();
		}
	}, 'Widget');
};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(606);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?minimize!../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../node_modules/stylus-loader/index.js??ref--6-3!./_select.styl", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?minimize!../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../node_modules/stylus-loader/index.js??ref--6-3!./_select.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".common-widget-control-select{position:relative;width:100%;background-color:#262528;border-radius:3px;min-height:58px;height:58px;cursor:pointer;padding-left:20px;padding-right:40px;display:-moz-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-flow:row wrap;flex-flow:row wrap}.common-widget-control-select.error{border:1px solid #ff666d}.common-widget-control-select select{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;z-index:1;cursor:pointer;-webkit-appearance:none}.common-widget-control-select .drop-arrow{position:relative;display:inline-block;width:5px;height:5px;border-style:solid;border-color:#e5e5e5;border-width:0 2px 2px 0;transform:rotate(45deg);position:absolute;top:50%;right:20px;margin-top:-3px}", ""]);

// exports


/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("control_select", [["div",{"class":"common-widget-control-select"},[["span",{"class":"current-value"},[["textNode",{"text":"Select item"}]]],["textNode",{"text":" "}],["span",{"class":"drop-arrow"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/**
 * 
 * @param {Fox} fox 
 */
module.exports = function (fox, parentPopupName) {
	//@ts-ignore
	__webpack_require__(609);
	//@ts-ignore
	__webpack_require__(611)(fox);
	//@ts-ignore
	__webpack_require__(612)(fox);
	//@ts-ignore
	__webpack_require__(613)(fox, parentPopupName);

	var _require = __webpack_require__(615),
	    popupsFactory = _require.factory,
	    SettingsCancelTypes = _require.SettingsCancelTypes,
	    PopupWidgetClasses = _require.PopupWidgetClasses;

	var _require2 = __webpack_require__(616),
	    bannerFactory = _require2.factory,
	    BannerClassName = _require2.BannerClassName;

	popupsFactory(fox);
	bannerFactory(fox);

	fox.registerOptions('@root', {
		widgets: {
			gdprMainPopup: {
				widget: PopupWidgetClasses.settings
			},
			gdprDeleteAccount: {
				widget: PopupWidgetClasses.deleteAccount
			},
			gdprRulesActions: {
				widget: PopupWidgetClasses.rulesActions
			},
			gdprCookieBanner: {
				widget: BannerClassName
			},
			gdprAttentionActions: {
				widget: PopupWidgetClasses.attentionActions
			}
		}
	}, true, {});
};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(610);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_index.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_index.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".mc-site-common-popup.gdpr-popup{background-color:#212023;max-width:655px}.mc-site-common-popup.gdpr-popup a{color:#fff;text-decoration:underline}.mc-site-common-popup.gdpr-popup~.ui-widget-overlay{background-color:rgba(0,0,0,.8)}.mc-site-common-popup.gdpr-popup.gdpr-small{max-width:460px;min-width:300px}.mc-site-common-popup.gdpr-popup .popup-content-wrapper{width:100%}.mc-site-common-popup.gdpr-popup .popup-content-wrapper ._fs-12{line-height:20px}.mc-site-common-popup.gdpr-popup .popup-footer-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}@media (max-width:425px){.mc-site-common-popup.gdpr-popup.gdpr-small{max-width:90%}.mc-site-common-popup.gdpr-popup .popup-content-wrapper ._fs-12{line-height:16px}.mc-site-common-popup.gdpr-popup .mc-common-button .secondary{margin-top:20px;margin-left:0}}@media (max-height:800px){.mc-site-common-popup.gdpr-popup{position:absolute}}.mc-site-common-popup.gdpr-popup .ui-dialog-content{padding:35px;color:#fff;max-width:none}.mc-site-common-popup.gdpr-popup .ui-dialog-content .cancel-close{padding:10px;font-size:16px;position:absolute;top:10px;right:10px;cursor:pointer}.mc-site-common-popup.gdpr-popup .ui-dialog-content .cancel-close:before{content:\"N\"}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-content-wrapper{font-family:pt_sansregular;text-align:left;background-color:inherit;color:#fff;margin-bottom:0}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-content-wrapper a{color:#fff;text-decoration:underline}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-content-wrapper label{max-width:550px}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-title-wrapper{background-color:inherit;text-align:center;margin:0;margin-bottom:20px;padding:0;border:none}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-title-wrapper .popup-title{font-size:16px;line-height:24px;font-family:pt_sansbold;text-transform:uppercase;color:#fff}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-footer-wrapper{border:none;text-align:center;background-color:inherit;padding:0;margin:0;margin-top:30px}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-footer-wrapper:after,.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-footer-wrapper:before{display:none}.gdpr-popup .upbs-content a{color:#fff;text-decoration:underline}.gdpr-popup .mc-common-button{color:#fff;height:auto;min-height:35px;font-size:11px;font-weight:700;line-height:14px;padding:9px;font-family:pt_sansbold;transition:transform .2s,background-color .2s,border-color .2s}.gdpr-popup .mc-common-button.spin{padding-left:40px}.gdpr-popup .mc-common-button.spin:before{animation:play 1s steps(28) infinite;-ms-filter:none;filter:none;opacity:1}.gdpr-popup .mc-common-button:active{transform:translateY(1px)}.gdpr-popup .mc-common-button.primary{background-color:#414041;border-color:#414041}.gdpr-popup .mc-common-button.primary:hover{background-color:rgba(65,64,65,.6)}.gdpr-popup .mc-common-button.secondary{background-color:transparent;border:1px solid #fff}.gdpr-popup .mc-common-button.secondary:hover{border-color:hsla(0,0%,100%,.6)}.gdpr-popup .mc-common-button.simple{background-color:transparent;border:1px solid #fff;color:#fff}.gdpr-popup .mc-common-button.simple:hover{color:hsla(0,0%,100%,.6);border-color:hsla(0,0%,100%,.6)}.gdpr-popup .form-label.error span:first-child{color:#ff666d}.gdpr-popup .form-label.error .gdpr-checkbox .shape{border-color:#ff666d}.upbs-wrapper.gdpr-popup .upbs-content .upbs-message{text-align:left}@media (max-width:580px){.upbs-wrapper.gdpr-popup .upbs-content .upbs-message{margin-top:0}.upbs-wrapper.gdpr-popup #form{-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}.upbs-wrapper.gdpr-popup .cookie-button-block,.upbs-wrapper.gdpr-popup .cookie-button-block .mc-common-button{width:100%}.upbs-wrapper.gdpr-popup .cookie-checkboxes{-ms-flex-flow:column nowrap;flex-flow:column nowrap;margin-bottom:20px}.upbs-wrapper.gdpr-popup .cookie-checkboxes label{margin-bottom:15px}}.gdpr-checkbox{position:relative;cursor:pointer;display:-moz-inline-flex;display:-ms-inline-flexbox;display:inline-flex}.gdpr-checkbox [type=checkbox]{position:absolute;top:0;right:0;bottom:0;left:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;z-index:2;width:100%;height:100%;cursor:pointer}.gdpr-checkbox .shape{width:18px;height:18px;border:1px solid #fff}.gdpr-checkbox .check{height:7px;width:18px;border:1px solid #fff;border-width:0 0 2px 2px;position:absolute;top:0;left:4px;border-radius:2px;transition:transform .2s,opacity .2s;z-index:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transform:rotate(-35deg)}.gdpr-checkbox [type=checkbox]:checked~.check{-ms-filter:none;filter:none;opacity:1;transform:rotate(-45deg)}.gdpr-checkbox [type=checkbox]:disabled~.shape{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";filter:alpha(opacity=40);opacity:.4}.gdpr-checkbox [type=checkbox]:disabled~.check{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}.gdpr-textarea{position:relative;background-color:#1a1a1c;border:1px solid #404042;border-radius:3px;padding:20px;outline:none;resize:none;width:100%;color:#fff;box-sizing:border-box}.gdpr-gookie-banner-button{border:none;border-radius:3px;color:#fff;height:auto;min-height:35px;font-size:11px;font-weight:700;line-height:14px;padding:9px;font-family:pt_sansbold;text-transform:uppercase;background-color:hsla(0,0%,100%,.15);cursor:pointer}", ""]);

// exports


/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("gdpr_account_delete_confirm_after_login_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title _tc-err"},[["textNode",{"text":" Attention "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12 _flex-1","style":"text-align:center;"},[["textNode",{"text":" Under the GDPR law we are obligated to have your consent in order to process your data (username, email, etc). Your account cannot properly function without data processing, therefore by revoking your consent your account will be terminated and all your data will be erased. "}],["span",{"class":"_tc-err"},[["textNode",{"text":"All your purchases will be gone forever"}]]],["textNode",{"text":" Are you sure you wish to revoke your consent and delete your account? "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary","style":"background-color: #bd4147;"},[["textNode",{"text":"yes, delete my account"}]]],["textNode",{"text":" "}],["button",{"id":"on-cancel","class":"mc-common-button secondary _m-l-10"},[["textNode",{"text":"cancel"}]]]]]]);
fox.registerTemplate("gdpr_account_request_success_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Success "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12","style":"text-align:center;"},[["textNode",{"text":" Your request has been sent. "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"ok"}]]]]]]);
fox.registerTemplate("gdpr_account_rules_action_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Exercise Your Rights Under GDPR "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12 _m-b-20","style":"text-align:center;"},[["textNode",{"text":" What would you like to do? "}]]],["div",{"id":"actions-select","style":"width:100%;"}],["div",{"class":"_m-t-20 &&0&&","style":"width:100%;"},[["textarea",{"class":"gdpr-textarea","placeholder":"Comment","name":"comment","cols":"30","rows":"5"}]],[["emptyValue","class",false,[{"name":"empty","params":[]},{"name":"hideIfFalse","params":[]}],"bind"]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"Submit request"}]]]]]]);
fox.registerTemplate("gdpr_account_action_error_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Sorry "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12","style":"text-align:center;"},[["textNode",{"text":" "}],["span",{},[],[["text","__text",true]]],["textNode",{"text":" "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"ok"}]]]]]]);
fox.registerTemplate("gdpr_account_delete_success_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Success "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12","style":"text-align:center;"},[["textNode",{"text":" Your account and all your personal data has been deleted. "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"ok"}]]]]]]);
fox.registerTemplate("gdpr_account_delete_confirm_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title _tc-err"},[["textNode",{"text":" Warning "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12","style":"text-align:center; width:100%"},[["textNode",{"text":" You are attempting to delete your account and all your personal data, but you still have an active subscription. I hate to see you go, but if you would like to cancel your subscription, please visit centrobill.com. If you still want to delete your account, please be aware that this action can't be undone. "}]]],["div",{"class":"_fs-12 _tc-err _m-t-20"},[["textNode",{"text":" All your purchases will be gone forever "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary","style":"background-color: #bd4147;"},[["textNode",{"text":"delete"}]]],["textNode",{"text":" "}],["button",{"id":"on-cancel","class":"mc-common-button secondary _m-l-10"},[["textNode",{"text":"cancel"}]]]]]]);
fox.registerTemplate("gdpr_account_delete_final_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title _tc-err"},[["textNode",{"text":" Deleting Account - Final Step "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center","style":"text-align:center;"},[["div",{"class":"_fs-12","style":"width:100%"},[["textNode",{"text":" This is the final step of deleting your account. Please be aware that this action cannot be undone "}]]],["div",{"class":"_fs-14 _tc-err _m-t-20","style":"width:100%"},[["textNode",{"text":"All your data (paid content, subscriptions, message history) will be deleted."}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary","style":"background-color: #bd4147;"},[["textNode",{"text":"I understand, delete my account"}]]],["textNode",{"text":" "}],["button",{"id":"on-cancel","class":"mc-common-button secondary _m-l-10"},[["textNode",{"text":"cancel"}]]]]]]);
fox.registerTemplate("gdpr_settings_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" In order to provide you with the best possible experience and get the technical elements up and running, I need your consent to process your personal data. "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-start data-processing"},[["div",{"class":"_fs-14 _m-b-20"},[["textNode",{"text":"Personal Data Processing"}]]],["label",{"for":"checkbox1","class":"form-label _flex _row-n _r-v-center"},[["span",{"class":"_fs-18"},[["textNode",{"text":"*"}]]],["div",{"class":"gdpr-checkbox _m-r-15 _m-l-5 _flex-1"},[["input",{"type":"checkbox","name":"consent_tos","id":"checkbox1","required":""}],["textNode",{"text":" "}],["span",{"class":"shape"}],["textNode",{"text":" "}],["span",{"class":"check"}]]],["span",{"class":"_fs-12"},[["textNode",{"text":"By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}],["a",{"target":"_blank","href":"/terms"},[["textNode",{"text":"Terms of Use"}]]]]]]],["textNode",{"text":" "}],["label",{"for":"checkbox2","class":"form-label _flex _row-n _r-v-center _m-t-15"},[["span",{"class":"_fs-18","style":"visibility: hidden;"},[["textNode",{"text":"*"}]]],["div",{"class":"gdpr-checkbox _m-r-15 _m-l-5"},[["if",{"notempty":""},[["input",{"type":"checkbox","name":"consent_marketing","id":"checkbox2","checked":""}],["else",{},[["input",{"type":"checkbox","name":"consent_marketing","id":"checkbox2"}]]]],[["defaultMarketingConsentValue","notempty",true,[{"name":"eq","params":["true"]}],"env"]]],["span",{"class":"shape"}],["textNode",{"text":" "}],["span",{"class":"check"}]]],["span",{"class":"_fs-12"},[["textNode",{"text":"I agree to receive e-mails with special offers, news and updates from ModelCentro family of products"}]]]]],["div",{"class":"_m-t-20 _fs-12","style":"width:100%"},[["strong",{},[["textNode",{"text":" Please note: "}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":" You will be able to request your personal data deletion at any time by clicking Delete my account in the account settings. "}]]]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"proceed"}]]],["textNode",{"text":" "}],["button",{"id":"on-cancel","class":"mc-common-button secondary _m-l-10"},[["textNode",{"text":"cancel"}]]]]]]);
fox.registerTemplate("gdpr_account_attention_popup", [["div"]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("gdpr_cookie_banner", [["div",{"id":"gdpr-cookie-accept","class":"strip-notification-wrapper verification-sent","style":"-webkit-transform: translateY(0px); -ms-transform: translateY(0px); transform: translateY(0px);"},[["div",{"class":"strip-notification-content"},[["p",{},[["textNode",{"text":"Hey there! Cookies are required to use this site. Feel free to check out our Cookie Policy at any time."}]]],["div",{"class":"_flex _row-n _r-h-end _m-l-20 _flex-1"},[["button",{"id":"accept-cookies","class":"gdpr-gookie-banner-button"},[["textNode",{"text":"I don’t mind Cookies"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/**
 * 
 * @param {Fox} fox
 */
module.exports = function (fox, parentPopupName) {
	__webpack_require__(614)(fox, parentPopupName);

	return fox.registerWidget('GDPR_BasePopup', {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				preventHideOnShadowClick: true,
				dialog: {
					closeOnEscape: false
				},
				onCancelPress: function onCancelPress() {
					_this.hide();

					return fox.Promise.resolve(false);
				},
				handleWom: {
					blurOnShow: {
						event: 'show',
						widget: '@this',
						callback: function callback() {
							return fox.wom.getRoot().rdom1('.wrapper').classList.add('_opacity-40');
						},
						params: {
							prefix: 'gdpr_popups'
						}
					},
					blurOnHide: {
						event: 'hide',
						widget: '@this',
						callback: function callback() {
							return fox.wom.getRoot().rdom1('.wrapper').classList.remove('_opacity-40');
						},
						params: {
							prefix: 'gdpr_popups'
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		init: function init() {
			var _this2 = this;

			var onOkPress = this.requireOption('onOkPress');
			var onCancelPress = this.getOption('onCancelPress');

			this.registerOptions('#content', {
				template: this.getOption('contentTemplate'),
				handleDom: {
					close: {
						target: '.cancel-close'
					},
					onSuccess: {
						target: '#on-success',
						callback: function callback(button, alias, context) {
							return onOkPress(button, context).then(function (resp) {
								return resp !== null && _this2.resolve(resp);
							}, function (error) {
								return _this2.reject(error);
							});
						}
					},
					onCancel: {
						target: '#on-cancel',
						callback: function callback(button, alias, context) {
							return onCancelPress(button, context).then(function (resp) {
								return resp !== null && _this2.resolve(resp);
							}, function (error) {
								return _this2.reject(error);
							});
						}
					}
				}
			});

			window.addEventListener(fox.utils.isTouchDevice() ? 'orientationchange' : 'resize', function () {
				_this2._center();
			});

			this.setOption('dialog.dialogClass', this.getOption('dialog.dialogClass') + ' gdpr-popup');

			this.callParent('init', arguments);
		},
		hide: function hide(mbEl, mbAlias) {
			if (mbAlias === 'close' && fox.dom.isDomNode(mbEl)) {
				this.resolve(false);
			}

			this.callParent('hide', arguments);
		}
	}, 'Popup_PromiseCommon');
};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check

//@ts-ignore
var _require = __webpack_require__(16)(fox),
    delay = _require.delay;

/**
 * 
 * @param {Fox} fox 
 */


module.exports = function (fox) {
	var parentPopupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Popup_Common';

	return fox.registerWidget('Popup_PromiseCommon', {
		_center: function _center() {
			var _this = this;

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			var count = 3;
			var promise = fox.Promise.resolve();

			while (count--) {
				promise = promise.then(function () {
					return delay(50);
				}).then(function () {
					return _this.callParent('_center', args);
				});
			}
		},
		show: function show() {
			var _this2 = this;

			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}

			return new fox.Promise(function (resolver, reject) {
				_this2.__resolver = resolver;
				_this2.__rejecter = reject;
				_this2.callParent('show', args);
				_this2._center();
			});
		},
		resolve: function resolve(params) {
			return this.__resolver(params);
		},
		reject: function reject(error) {
			return this.__rejecter(error);
		}
	}, parentPopupName);
};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//@ts-check

var ResponseTemplates = {
	deleteSuccess: 'gdpr_account_delete_success_popup',
	actionError: 'gdpr_account_action_error_popup',
	requestSuccess: 'gdpr_account_request_success_popup'
};

var SettingsCancelTypes = {
	guest: 0,
	member: 1
};

var OptionValues = ['Select an option', 'I want to transfer my data to me or a third-party', 'I want to rectify incorrect data this site has about me', 'I want to object to the way this site is using my personal information'];

var PopupWidgetClasses = {
	settings: 'GDPR_SettingsPopup',
	actionResponse: 'GDPR_AccountActionResponse',
	deleteAccount: 'GDPR_AccountDeleteConfirm',
	deleteAccountFinal: 'GDPR_AccountDeleteFinal',
	rulesActions: 'GDPR_AccountRulesActions',
	attentionActions: 'GDPR_AccountAttentionActions'

	/**
  * 
  * @param {HTMLButtonElement} button 
  */
};var changeButtonState = function changeButtonState(button, newText) {
	var text = button.innerText;
	button.innerText = newText;
	button.disabled = true;

	return function () {
		button.disabled = false;
		button.innerText = text;
	};
};

exports.SettingsCancelTypes = SettingsCancelTypes;
exports.PopupWidgetClasses = PopupWidgetClasses;

/**
 * 
 * @param {Fox} fox 
 */
exports.factory = function (fox) {
	// settings popup
	fox.registerWidget(PopupWidgetClasses.settings, {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_settings_popup',
				onOkPress: function onOkPress() {
					return _this.sumbitForm.apply(_this, arguments);
				},
				onCancelPress: function onCancelPress() {
					return _this.onCancel.apply(_this, arguments);
				},
				dialog: {
					close: function close(event) {
						if (event.currentTarget !== undefined && event.currentTarget.id != 'on-success') _this.resolve(false);
					}
				},
				widgets: {
					actionPopup: {
						widget: PopupWidgetClasses.actionResponse
					},
					deletePopup: {
						widget: PopupWidgetClasses.deleteAccount,
						contentTemplate: 'gdpr_account_delete_confirm_after_login_popup'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#form-content',
						validateOnFly: true,
						valuePostProcessing: [function (value) {
							return value === 'on' ? 1 : 0;
						}]
					}
				},
				handleWom: {
					formValidation: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: function callback(infos, form) {
							return infos.forEach(function (_ref) {
								var field = _ref.field,
								    result = _ref.result;

								var element = form.getElement(field);

								element.nodes.forEach(function (node) {
									var label = node.parentNode.parentNode;

									if (label) {
										return !result ? label.classList.add('error') : label.classList.remove('error');
									}
								});
							});
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		showForMember: function showForMember() {
			var _this2 = this;

			return this.show(SettingsCancelTypes.member).then(function (result) {
				if (result) {
					var api = _this2.getApi('saveConsentFlags', {
						method: 'consent.provideBulk',
						httpMethod: 'post'
					});

					api.psend({
						aliases: Object.keys(result).reduce(function (obj, key) {
							obj['' + key.replace('consent_', '')] = result[key];

							return obj;
						}, {})
					});
				}

				return result;
			});
		},
		show: function show() {
			var _this3 = this;

			var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SettingsCancelTypes.guest;

			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}

			return this.callParent('show', args).then(function (result) {
				if (!result) {
					if (type === SettingsCancelTypes.guest) {
						return _this3.rwom1('#actionPopup').show(ResponseTemplates.actionError, 'Your request cannot be completed until you approve the Personal Data processing rules.').then(function () {
							return false;
						});
					} else if (type === SettingsCancelTypes.member) {
						return _this3.rwom1('#deletePopup').show().then(function (result) {
							if (result === false) {
								return _this3.showForMember();
							}

							return result;
						});
					}
				}

				return result;
			});
		},
		sumbitForm: function sumbitForm(button) {
			var _this4 = this;

			return this.rwom1('#form').submit().then(function (values) {
				if (values !== false) {
					_this4.hide();
					return values;
				}

				return null;
			});
		},
		onCancel: function onCancel() {
			this.hide();

			return fox.Promise.resolve(false);
		}
	}, 'GDPR_BasePopup');

	// account action response popup
	fox.registerWidget(PopupWidgetClasses.actionResponse, {
		configure: function configure() {
			var _this5 = this;

			this.registerOptions('', {
				additionalClasses: 'gdpr-small',
				hideOnOkPressed: true,
				onOkPress: function onOkPress(button) {
					if (_this5.getOption('hideOnOkPressed')) {
						_this5.hide();
					}

					return fox.Promise.resolve(button);
				}
			});

			this.callParent('configure', arguments);
		},
		show: function show(template) {
			var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

			var content = this.rwom1('#content');
			content.setOption('template', template);
			content.setTemplateOptions('text', text);

			content.render();

			for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
				args[_key2 - 2] = arguments[_key2];
			}

			return this.callParent('show', args);
		}
	}, 'GDPR_BasePopup');

	// account delete final popup
	fox.registerWidget(PopupWidgetClasses.deleteAccountFinal, {
		configure: function configure() {
			var _this6 = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_account_delete_final_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: function onOkPress() {
					return _this6.removeAccount.apply(_this6, arguments);
				},
				widgets: {
					actionPopup: {
						widget: PopupWidgetClasses.actionResponse,
						hideOnOkPressed: false
					}
				}
			});

			this.callParent('configure', arguments);
		},
		removeAccount: function removeAccount(button) {
			var _this7 = this;

			var deleteApi = this.getApi('deleteApi', {
				method: !!fox.getEnv('site.id') ? 'user.deleteAccount' : 'client.delete',
				httpMethod: !!fox.getEnv('site.id') ? 'get' : 'post'
			});
			var actionPopup = this.rwom1('#actionPopup');

			var restoreButtonState = changeButtonState(button, 'deleting...');
			return deleteApi.psend().then(function (resp) {
				restoreButtonState();
				_this7.hide();

				return actionPopup.show(ResponseTemplates.deleteSuccess).then(
				/** @param {HTMLButtonElement} button */
				function (button) {
					var restoreButtonState = changeButtonState(button, 'please wait...');
					return _this7.getWom().getRoot().logout().then(function () {
						return restoreButtonState;
					});
				}).then(function (restoreButtonState) {
					return restoreButtonState();
				});
			}).catch(function (err) {
				restoreButtonState();
				_this7.hide();
				return actionPopup.show(ResponseTemplates.actionError, err.params.answer.message).then(function () {
					return false;
				});
			});
		}
	}, 'GDPR_BasePopup');

	// account delete confirm popup
	fox.registerWidget(PopupWidgetClasses.deleteAccount, {
		configure: function configure() {
			var _this8 = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_account_delete_confirm_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: function onOkPress() {
					var _rwom;

					return (_rwom = _this8.rwom1('#deleteAccount')).show.apply(_rwom, arguments);
				},
				widgets: {
					deleteAccount: {
						widget: PopupWidgetClasses.deleteAccountFinal
					}
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'GDPR_BasePopup');

	// account rules manipulation popup
	fox.registerWidget(PopupWidgetClasses.rulesActions, {
		configure: function configure() {
			var _this9 = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_account_rules_action_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: function onOkPress() {
					return _this9.sumbitForm.apply(_this9, arguments);
				},
				widgets: {
					actionPopup: {
						widget: PopupWidgetClasses.actionResponse
					},
					actions: {
						widget: 'Control_Select',
						embed: {
							widget: '@parent #content'
						},
						'!embed.container': '#actions-select',
						autoRender: true,
						select: {
							options: OptionValues.map(function (value, idx) {
								return {
									title: value,
									selected: idx === 0,
									disabled: idx === 0,
									value: idx
								};
							}),
							attributes: {
								name: 'actions'
							}
						}
					},
					form: {
						widget: 'DomForm',
						formSelector: '#form-content',
						validateOnFly: true,
						elements: {
							actions: {
								womContainer: '@parent #actions',
								validators: [function (value) {
									return { result: Number(value) !== 0 };
								}]
							}
						}
					}
				},
				handleWom: {
					changed: {
						widget: '#form',
						event: 'change',
						callback: function callback(_ref2) {
							var field = _ref2.field,
							    value = _ref2.value;

							if (field === 'actions') {
								_this9._bindData.emptyValue = value === OptionValues[0];

								_this9._center();
							}
						}
					},
					validation: {
						widget: '#form',
						event: ['form_not_valid', 'form_valid'],
						callback: function callback(infos, form) {
							return infos.forEach(function (_ref3) {
								var field = _ref3.field,
								    result = _ref3.result;

								if (field === 'actions') {
									var _form$getElement$getN = form.getElement(field).getNodes(),
									    _form$getElement$getN2 = _slicedToArray(_form$getElement$getN, 1),
									    select = _form$getElement$getN2[0];

									var container = select.parentNode;

									if (!result) {
										return container.classList.add('error');
									}

									return container.classList.remove('error');
								}
							});
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		prepareEmbeddedWidgets: function prepareEmbeddedWidgets() {
			this._bindData = {
				emptyValue: true
			};

			this.rwom1('#content').bindTemplateVariables(this._bindData, ['emptyValue']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},
		sumbitForm: function sumbitForm(button) {
			var _this10 = this;

			var sendApi = this.getApi('sendApi', {
				method: 'site.gdprRequest',
				encodePost: true,
				httpMethod: 'post'
			});
			var actionPopup = this.rwom1('#actionPopup');
			var form = this.rwom1('#form');

			return form.submit().then(function (values) {
				if (values === false) {
					return null;
				}

				var restoreButtonState = changeButtonState(button, 'submiting...');

				return sendApi.psend({
					subject: OptionValues[values.actions],
					comment: values.comment,
					optionAlias: values.actions === '1' ? 'transferData' : false
				}).then(function (resp) {
					restoreButtonState();
					_this10._resetForm();
					_this10.hide();
					return actionPopup.show(ResponseTemplates.requestSuccess).then(function () {
						return true;
					});
				}).catch(function (err) {
					restoreButtonState();
					_this10._resetForm();
					_this10.hide();
					return actionPopup.show(ResponseTemplates.actionError, err.params.answer.message).then(function () {
						return false;
					});
				});
			});
		},
		_resetForm: function _resetForm() {
			var form = this.rwom1('#form');

			form.setValue('actions', '0');
			form.setValue('comment', '');

			form.getElement('actions').womContainer.change();
		}
	}, 'GDPR_BasePopup');

	fox.registerWidget(PopupWidgetClasses.attentionActions, {
		configure: function configure() {
			var _this11 = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_account_attention_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: function onOkPress() {
					return _this11.onCancel();
				},
				dialog: {
					close: function close() {
						return _this11.onCancel();
					}
				}
			}), this.callParent('configure', arguments);
		},
		onCancel: function onCancel() {
			this.hide();

			return fox.Promise.resolve(false);
		}
	}, 'GDPR_BasePopup');
};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check

var _require = __webpack_require__(17),
    ENV_VAR_NAME_COOKIE = _require.ENV_VAR_NAME_COOKIE,
    SESSION_VAR_NAME_COOKIE = _require.SESSION_VAR_NAME_COOKIE;

var ENV_VAR_NAME = ENV_VAR_NAME_COOKIE;
var SESSION_VAR_NAME = SESSION_VAR_NAME_COOKIE;

var BannerClassName = exports.BannerClassName = 'GDPR_CookieBanner';

var BannerSelector = '#gdpr-cookie-accept';
var COOKIE_BANNER_TEMPLATE = 'gdpr_cookie_banner';
var FUNCTIONNAL_COOKIES_DISABLED_BANNER_TEMPLATE = 'gdpr_functional_cookies_disabled_banner';

/** @param {Fox} fox */
exports.factory = function (fox) {
	//@ts-ignore
	var _require2 = __webpack_require__(16)(fox),
	    delay = _require2.delay;

	var $ = fox.jQuery;

	fox.registerWidget(BannerClassName, {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				autoRender: true,
				dontReuseSn: true,
				embed: {
					container: '#notification-container'
				},
				template: COOKIE_BANNER_TEMPLATE,
				showBannerPredicat: function showBannerPredicat() {
					if (fox.site.getClass() === "FanApp") return false;
					var sessionFlag = localStorage.getItem(SESSION_VAR_NAME);

					if (!_this.userAccess) {
						return !sessionFlag;
					}

					return !fox.getEnv(ENV_VAR_NAME + '.cookiesStrict') || !fox.getEnv(ENV_VAR_NAME + '.cookiesFunctional');
				},
				bannerType: 'accept',
				handleDom: {
					accept: {
						target: '#accept-cookies',
						callback: function callback() {
							return _this.acceptCookies();
						}
					},
					scroll: {
						event: 'scroll',
						target: document,
						eventChecker: function eventChecker(_) {
							return _this.isEmbedded();
						},
						callback: function callback() {
							var bar = $(fox.dom.selectFirst(BannerSelector));
							var barHeight = bar.height();
							var scrollTop = $(window).scrollTop();

							if (scrollTop > 30) {
								bar.css('top', _this._getBannerYPos(false) - 2);
								bar.addClass('sticky');
							} else {
								bar.css('top', '0');
								bar.removeClass('sticky');
							}
						}
					},
					preferences: {
						target: '#show-cookies-popup-button',
						callback: 'showPreferences'
					}
				},
				handleWom: {
					onLayoutChanged: {
						event: 'addedToDom',
						widget: '@root .Site_Layout',
						callback: function callback() {
							return !_this.isEmbedded() && _this.render();
						}
					}
				}
			});
			this.callParent('configure', arguments);
		},
		init: function init() {
			this.showBannerPredicat = this.requireOption('showBannerPredicat');
			this.userAccess = this.wom1('@root #permissionManager') ? !this.rwom1('@root #permissionManager').hasAccess('guestActual') : fox.isObject(fox.site.member);
		},
		activate: function activate() {
			var _this2 = this,
			    _arguments = arguments;

			if (this.showBannerPredicat()) {
				return delay(2000).then(function () {
					return _this2.callParent('activate', _arguments);
				});
			}
		},
		prepareEmbeddedWidgets: function prepareEmbeddedWidgets() {
			this._bindData = {
				position: '-300%'
			};

			this.bindTemplateVariables(this._bindData, ['position']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},
		_getBannerYPos: function _getBannerYPos() {
			var skipNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			var anotherBanners = fox.dom.select('.strip-notification-wrapper');
			var myNode = fox.dom.selectFirst(BannerSelector);

			if (anotherBanners.length > 1) {
				return anotherBanners.reduce(function (acc, bannerNode) {
					if (bannerNode === myNode) return acc;

					return acc + (skipNodes ? 0 : bannerNode.clientHeight);
				}, 2);
			}

			return 0;
		},
		addedToDom: function addedToDom() {
			var _this3 = this;

			this.callParent('addedToDom', arguments);

			delay(100).then(function () {
				_this3._bindData.position = _this3._getBannerYPos() + 'px';
			});
		},
		acceptCookies: function acceptCookies() {
			var api = this.getApi('_cookieConsent', {
				method: 'consent.provideBulk',
				httpMethod: 'post'
			});

			this.closeBanner();

			if (this.userAccess) {
				api.psend({
					aliases: {
						cookiesFunctional: 1,
						cookiesPerformance: 1,
						cookiesStrict: 1
					}
				});
			} else {
				this.saveToStorage();
			}
		},
		closeBanner: function closeBanner() {
			this._bindData.position = '-300%';
			this.removeFromDom();
		},
		beforeEmbed: function beforeEmbed() {
			var _this4 = this,
			    _arguments2 = arguments;

			if (this.showBannerPredicat()) {
				return delay(2000).then(function () {
					return _this4.callParent('beforeEmbed', _arguments2);
				});
			}
		},
		removeFromDom: function removeFromDom() {
			delay(410).then(function () {
				var myNode = fox.dom.selectFirst(BannerSelector);

				if (myNode) {
					myNode.parentNode.removeChild(myNode);
				}
			});
		},
		embedToDom: function embedToDom(container) {
			if (!this.isEmbedded()) {
				container.appendChild(this.fragment);
			}
		},
		isEmbedded: function isEmbedded() {
			return !fox.isEmpty(fox.dom.selectFirst(BannerSelector));
		},
		beforeRender: function beforeRender() {
			this.callParent('beforeRender', arguments);

			if (fox.site.getClass() === "FanApp") return false;

			this.setOption('template', this.getOption('bannerType') === 'functionalCookiesWarning' ? FUNCTIONNAL_COOKIES_DISABLED_BANNER_TEMPLATE : COOKIE_BANNER_TEMPLATE);
		},
		clearStorage: function clearStorage() {
			localStorage.removeItem(SESSION_VAR_NAME);
		},
		saveToStorage: function saveToStorage() {
			localStorage.setItem(SESSION_VAR_NAME, new Date().getTime().toString());
		},
		showPreferences: function showPreferences() {
			this.dispatchEvent('showCookiesPreferences');
		}
	});
};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	__webpack_require__(618);

	var require__template = __webpack_require__(620);

	require__template.keys().forEach(function (module) {
		require__template(module)(fox);
	});

	// var require__js = require.context('./widget', true, /\.js$/);

	// require__js.keys().forEach(function (module) {
	// 	require__js(module)(fox);
	// });
};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(619);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".ccpa-form{text-align:left}.ccpa-form .title{border-top:1px solid hsla(0,0%,85%,.4);font-size:14px;line-height:20px;font-weight:700;padding-top:20px;text-align:left;margin-bottom:15px}.ccpa-form .ls-radiobutton{display:-ms-flexbox;display:flex;margin-bottom:20px;line-height:24px;font-size:12px;line-height:20px;text-align:left}.ccpa-form .ls-radiobutton *{line-height:inherit}.ccpa-form .ls-radiobutton .radio-btn-wrap{min-width:20px;margin-right:12px}.ccpa-form ._row{margin-bottom:25px}.ccpa-form ._row .row-label{font-size:16px;line-height:30px}.ccpa-form ._row .row-label.textsuccess{text-align:center}.ccpa-form ._row .mc-form-field{width:100%;min-height:50px;background-color:#fbfafa;font-size:16px;padding-left:20px;padding-right:20px}.ccpa-form ._row textarea.mc-form-field{line-height:19px}.ccpa-form ._row ._error-text{margin-top:5px;color:#d35855}.ccpa-form .sub-button{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;margin-bottom:0}.ccpa-form .sub-button .mc-btn{width:170px}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-titlebar{font-size:25px;padding:25px 0;height:auto;display:block;color:#fff;text-align:center}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-titlebar .ui-dialog-titlebar-close{color:#fff}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-content{padding:0 25px 15px}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-content .textsuccess{text-align:center;padding:10px 0 25px}#ccpa-form .mc-radiobutton.row{padding:10px 0;margin-bottom:0;display:-ms-flexbox;display:flex;text-align:left}#ccpa-form .mc-radiobutton.row.lastrow{margin-bottom:15px}#ccpa-form ._row textarea.mc-form-field{font:400 16px system-ui}.ui-dialog.dlg-amc.ccpa-form .ui-dialog-titlebar{padding:20px 30px}.cookie-consent.ccpa-form ._row ._error-text{height:8px}.sp-title .title-text,.sp-title>span{display:none}.sp-title .title{padding:10px 0}@media (max-width:768px){.mc-site-common-popup.gdpr-popup.ccpa-form{max-width:320px}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-titlebar{font-size:18px;padding:20px 0 0}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-content{padding:0 10px 10px!important}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-content .popup-title-wrapper{margin:10px 0 15px!important}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-content .popup-title-wrapper.success{margin:0}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-content .textsuccess{padding:0 0 25px}}", ""]);

// exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ccpa-form.a.tpl": 621
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 620;

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("ccpa_form_site", [["div",{"class":"popup-title-wrapper ccpa-popup-title"},[["strong",{"class":"popup-title"},[["textNode",{"text":" California Consumer Privacy form "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["form",{"id":"ccpa-form","class":"ccpa-form"},[["div",{"class":"ui-dialog-content cookie-consent ccpa-form p-l p-r p-b nsl-form"},[["div",{"class":"row-label title"},[["textNode",{"text":"I would like"}]]],["label",{"for":"knowInformation","class":"ls-radiobutton"},[["input",{"id":"knowInformation","type":"radio","name":"optionAlias","value":"knowInformation","checked":""}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"text"},[["textNode",{"text":"to know what information is collected about me by ModelCentro."}]]]]],["label",{"for":"transferData","class":"ls-radiobutton"},[["input",{"id":"transferData","type":"radio","name":"optionAlias","value":"transferData"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"text"},[["textNode",{"text":"to receive a copy of the information collected about me by ModelCentro."}]]]]],["label",{"for":"deleteInformation","class":"ls-radiobutton"},[["input",{"id":"deleteInformation","type":"radio","name":"optionAlias","value":"deleteInformation"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"text"},[["textNode",{"text":"ModelCentro to delete the information collected about me."}]]]]],["label",{"for":"prohibitInformation","class":"ls-radiobutton"},[["input",{"id":"prohibitInformation","type":"radio","name":"optionAlias","value":"prohibitInformation"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"text"},[["textNode",{"text":"to prohibit ModelCentro to share information collected about me with third parties."}]]]]],["if",{"empty":""},[["div",{"class":"_row email"},[["label",{"class":"row-label"},[["textNode",{"text":"Email:"}]]],["div",{"class":"_base-input-wrapper"},[["input",{"type":"text","class":"_base-input mc-form-field","name":"email","placeholder":"Your email"}],["p",{"class":"_error-text"}]]]]]],[["nomail","empty",true,[{"name":"eq","params":["1"]}]]]],["div",{"class":"_row"},[["label",{"class":"row-label"},[["span",{},[["textNode",{"text":"Text message:"}]]]]],["div",{"class":"_base-input-wrapper"},[["input",{"type":"text","class":"_base-input mc-form-field","name":"comment","placeholder":"Your message"}],["p",{"class":"_error-text"}]]]]],["div",{"class":"_row _flex sub-button"},[["button",{"type":"submit","id":"form-submit","class":"mc-common-button primary"},[["textNode",{"text":"Submit Request"}]]]]]]]]]]);
fox.registerTemplate("ccpa_success_site", [["div",{"class":"popup-title-wrapper success ccpa-popup-title"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Success "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"ui-dialog-content cookie-consent ccpa-form  p-l p-r p-b"},[["if",{"notempty":""},[["div",{"class":"row-label textsuccess"},[["textNode",{"text":"Thank you! "}],["br"],["textNode",{"text":" Your request has been submitted."}],["br"],["textNode",{"text":" An account manager will contact you to confirm and finalize it."}]]],["else",{},[["div",{"class":"row-label textsuccess"},[["textNode",{"text":"Thank you!"}],["br"],["textNode",{"text":" Your request has been submitted."}],["br"],["textNode",{"text":" The response will be sent to your email."}]]]]]],[["deleteInformation","notempty",true,[{"name":"","params":[]}]]]],["div",{"class":"_row _flex _r-h-justify sub-button"},[["button",{"type":"button","id":"success","class":"successccpa mc-common-button primary"},[["textNode",{"text":"Okay"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    'use strict';

    fox.registerWidget('Page_CCPA', {
        configure: function configure() {
            this.registerOptions('', {
                template: 'page_ccpa',
                autoRender: true,
                handleDom: {
                    showPopup: {
                        event: 'click',
                        target: '[show-popup]',
                        callback: 'showPopup'
                    }
                }
            });

            this.callParent('configure', arguments);
        },
        showPopup: function showPopup() {
            // 
        }
    });
};

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function (fox, $) {
	// const UA_PARSER = require('ua-parser-js');

	// var _ = {
	// 	getTranslation: function(alias) {
	// 		var translation = {
	// 			'emailNotValid': function() {return fox.i18n.getTranslation('emailNotValid', 'Email is not valid', 'tooltip');},
	// 			'fieldIsRequired': function() {return fox.i18n.getTranslation('fieldNotEmpty', 'Fields shouldn\'t be empty', 'tooltip');}
	// 		};

	// 		return translation[alias] || '';
	// 	}
	// };

	fox.registerWidget('CCPR_Form', {
		configure: function configure() {

			this.registerOptions('', {
				template: 'page_ccpa_login_form',
				widgets: {
					snManager: {
						widget: 'Widget',
						autoRender: false,
						active: false
					},
					authApi: {
						widget: 'Api',
						method: 'ccpa.request',
						httpMethod: 'post'

					},
					form: {
						widget: 'DomForm',
						formSelector: '#ccpa-form'

					}
				},
				handleWom: {
					formInvaliadate: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: this._handleFormValidation.bind(this)
					}
				},
				handleDom: {
					onFocus: {
						target: '[name="email"]',
						event: 'focus',
						callback: '_clearErrors'
					},

					formButtonSubmit: {
						target: '#ccpa-form',
						event: 'submit',
						callback: '_submit'
					},
					closePopup: {
						event: 'click',
						target: '.cancel-close',
						callback: 'closePopup'
					}
				}
			});

			this.callParent('configure', arguments);
		},
		running: function running() {
			this.callParent('running', arguments);

			this.notices = fox.wom.selectFirst('~#throughNotifications');
		},
		activate: function activate() {
			this.form = this.rwom1('#form');

			this.checkMember();
			this.callParent('activate', arguments);
		},
		rendering: function rendering() {
			this.callParent('rendering', arguments);

			this.errorBox = $(this.dom('#errors'));
			this.errorsContainer = $(this.dom('#errors .txt'));
		},
		checkMember: function checkMember() {
			if (fox.isEmpty(fox.site.member)) {
				this.form.setOption('elements.email', {
					//validateOnFly: true,
					// type: 'input',
					validators: [{ validator: 'mandatory', message: this.getTextMessage('fieldIsRequired') }, { validator: 'regexp', options: { type: 'email' }, message: this.getTextMessage('emailNotValid') }]
				});
				this.setTemplateOptions('member', false);
				this.isMember = false;

				return;
			}

			this.setTemplateOptions('member', true);
			this.isMember = true;
		},
		formSubmitError: function formSubmitError(err) {
			//this.showErrorMessage(err.answer.reason);
			//this.togglePreloader(false);

			this.notices.pushNotification({
				noticeTemplate: 'new_notice',
				noticeType: 'error',
				noticeMessage: 'Oops! There is no such user in our system',
				//noticeAlias: 'loginError',
				delayClose: 3000
			});

			this.togglePreloader(false);
		},
		getTextMessage: function getTextMessage(alias) {
			var msg = '';

			switch (alias) {
				case 'emailNotValid':
					msg = 'Email is not valid';
					break;
				case 'fieldIsRequired':
					msg = 'This field is required';
					break;
			}

			return msg;
		},
		showErrorMessage: function showErrorMessage(msg, fieldName) {
			//console.log(msg, fieldName)
			var $elm = $(this.dom1('[name="' + fieldName + '"]'));

			$elm.addClass('error');
			$elm.parent().find('._error-text').text(msg);
		},
		_submit: function _submit(el, w, alias, e) {
			var _this = this;

			fox.jQuery.Event(e).preventDefault();

			this.wom1('#form').submit().then(function (result) {
				if (result === false) {
					return;
				}

				_this.togglePreloader(true);

				_this.submit().then(function (resp) {
					var response = resp.params.answer.response;

					_this.togglePreloader(false);

					_this.onSuccessSubmit();
				}).catch(function (err) {
					var answer = err.params.answer;

					switch (answer.code) {
						default:
							_this.showErrorMessage('Oops! There is no such user in our system', 'email');
					}
					_this.togglePreloader(false);
				});
			});
		},
		submit: function submit() {
			var data = this.wom1('#form').getValues();

			Object.keys(data).forEach(function (key) {
				data[key] = window.encodeURIComponent(data[key]);
			});

			return this.wom1('#authApi').psend(data);
		},
		togglePreloader: function togglePreloader(state) {
			var btn = this.dom1('#form-submit');

			if (!btn) {
				return;
			}

			fox.dom[state ? 'addClass' : 'removeClass']('spin', btn);
		},
		_handleFormValidation: function _handleFormValidation(formData, form) {
			var _this2 = this;

			var msg = '';

			formData.forEach(function (resp) {
				var $elm = $(_this2.dom1(''.concat('[name="', resp.field, '"]'))).parent();

				if (resp.result === false) {
					_this2.showErrorMessage(resp.message, resp.field);
					$elm.addClass('error');

					return;
				}

				$elm.removeClass('error');
			});
		},
		onSuccessSubmit: function onSuccessSubmit() {
			var values = _extends({}, this.form.getValues());

			var w = this.wom1('@parent @parent #popupSuccess #content');
			values.optionAlias === 'deleteInformation' ? w.setTemplateOptions('deleteInformation', true) : w.setTemplateOptions('deleteInformation', false);
			w.render();
			this.resetForm();
			this.dispatchEvent('form_submit_success', values);
		},
		_clearErrors: function _clearErrors(elm) {
			var $elm = $(elm);
			var $p = $elm.parent();

			$elm.removeClass('error');
			$p.removeClass('error');

			$p.find('._error-text').text('');
		},
		resetForm: function resetForm() {
			var values = {
				optionAlias: 'knowInformation',
				comment: ''
			};

			if (!this.member) {
				values.email = '';
			}

			this.form.setValues(values);
		},
		getSuccessMessage: function getSuccessMessage(values) {
			if (values.optionAlias === 'deleteInformation') {
				return 'Thank you! Your request has been submitted. An account manager will contact you to confirm and finalize it.';
			}
			return 'Thank you! Your request has been submitted. The response will be sent to your email.';
		},
		closePopup: function closePopup() {
			this.getParent().hide();
		}
	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_ccpa_header", [["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"ModelCentro.com"}]]],["div",{"class":"title-text"},[["textNode",{"text":"Privacy Notice for California Residents"}]]],["div",{"class":"sp-up-time title"},[["textNode",{"text":"Effective Date: January 1, 2020"}]]],["div",{"class":"sp-up-time title"},[["textNode",{"text":"Last Revised: December 6, 2019"}]]]]]]);
fox.registerTemplate("promo_ccpa_body", [["div",{"class":"col sp-left"},[["div",{"class":"sp-part","id":"part_0"},[["div",{"class":"padd-left"},[["p",{},[["textNode",{"text":"This privacy notice for California residents supplements the information contained in ModelCentro's "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":"privacy policy"}]]],["textNode",{"text":" and applies solely to all visitors, users, and others who reside in California (“consumers” or “you”). We adopt this notice to comply with the California Consumer Privacy Act of 2018 (CCPA) and any terms defined in the CCPA have the same meaning when used in this Notice. "}]]]]]]],["div",{"class":"sp-part","id":"part_1"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Information We Collect"}]]],["p",{},[["textNode",{"text":"Our Website collects information that identifies, relates to, describes, references, is reasonably capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer, household, or device (“personal information”). Personal information does not include: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Publicly available information from government records. "}]]],["li",{},[["textNode",{"text":" Deidentified or aggregated consumer information. "}]]],["li",{},[["textNode",{"text":" Information excluded from the CCPA’s scope, like: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["textNode",{"text":" health or medical information covered by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and the California Confidentiality of Medical Information Act (CMIA) or clinical trial data; "}]]],["li",{},[["textNode",{"text":" personal information covered by certain sector-specific privacy laws, including the Fair Credit Reporting Act (FCRA), the Gramm-Leach-Bliley Act (GLBA) or California Financial Information Privacy Act (FIPA), and the Driver’s Privacy Protection Act of 1994. "}]]]]],["p"]]]]],["p",{},[["textNode",{"text":"In particular, our Website has collected the following categories of personal information from its consumers within the last 12 months: "}]]],["div",{"class":"wrapper-cookie-table"},[["table",{"border":"1","cellpadding":"7","cellspacing":"0"},[["tr",{},[["th",{},[["textNode",{"text":"Category"}]]],["th",{},[["textNode",{"text":"Examples"}]]],["th",{},[["textNode",{"text":"Collected"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"A. Identifiers."}]]],["td",{},[["textNode",{"text":" A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, Social Security number, driver’s license number, passport number, or other similar identifiers. "}]]],["td",{},[["textNode",{"text":"YES "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" B. Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)). "}]]],["td",{},[["textNode",{"text":" A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver’s license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information, medical information, or health insurance information.Some personal information included in this category may overlap with other categories. "}]]],["td",{},[["textNode",{"text":" YES"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" C. Protected classification characteristics under California or federal law. "}]]],["td",{},[["textNode",{"text":" Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth and related medical conditions), sexual orientation, veteran or military status, genetic information (including familial genetic information). "}]]],["td",{},[["textNode",{"text":" YES "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" D. Commercial information. "}]]],["td",{},[["textNode",{"text":" Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies. "}]]],["td",{},[["textNode",{"text":"YES "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" E. Biometric information. "}]]],["td",{},[["textNode",{"text":" Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" F. Internet or other similar network activity. "}]]],["td",{},[["textNode",{"text":" Browsing history, search history, information on a consumer’s interaction with a website, application, or advertisement. "}]]],["td",{},[["textNode",{"text":" YES"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" G. Geolocation data. "}]]],["td",{},[["textNode",{"text":" Physical location or movements. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" H. Sensory data. "}]]],["td",{},[["textNode",{"text":" Audio, electronic, visual, thermal, olfactory, or similar information. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" I. Professional or employment-related information. "}]]],["td",{},[["textNode",{"text":" Current or past job history or performance evaluations. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" J. Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)). "}]]],["td",{},[["textNode",{"text":" Education records directly related to a student maintained by an educational institution or party acting on its behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, or student disciplinary records. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" K. Inferences drawn from other personal information. "}]]],["td",{},[["textNode",{"text":" Profile reflecting a person’s preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]]]]]],["p",{},[["textNode",{"text":"Our Website obtains the categories of personal information listed above from the following categories of sources: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Directly from you. For example, from forms you complete or products and services you purchase. "}]]],["li",{},[["textNode",{"text":" Indirectly from you. For example, from observing your actions on our Website. "}]]],["li",{},[["textNode",{"text":" From third parties, for example, our business partners. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Use of Personal Information "}]]]]],["p",{},[["textNode",{"text":"We may use or disclose the personal information we collect for one or more of the following purposes: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" To fulfill or meet the reason you provided the information. For example, if you share your name and contact information to ask a question about our products or services, we will use that personal information to respond to your inquiry. If you provide your personal information to purchase a product or service, we will use that information to process your payment. We may also save your information to facilitate new product orders. "}]]],["li",{},[["textNode",{"text":" To provide, support, personalize, and develop our Website, products, and services. "}]]],["li",{},[["textNode",{"text":" To create, maintain, customize, and secure your account with us. "}]]],["li",{},[["textNode",{"text":" To process your requests, purchases, transactions, and payments and prevent transactional fraud. "}]]],["li",{},[["textNode",{"text":" To provide you with support and to respond to your inquiries, including to investigate and address your concerns and monitor and improve our responses. "}]]],["li",{},[["textNode",{"text":" To personalize your Website experience and to deliver content and product and service offerings relevant to your interests, including targeted offers and ads through our Website, third-party sites, and via email or text message (with your consent, where required by law). "}]]],["li",{},[["textNode",{"text":" To help maintain the safety, security, and integrity of our Website, products and services, databases and other technology assets, and business. "}]]],["li",{},[["textNode",{"text":" For testing, research, analysis, and product development, including to develop and improve our Website, products, and services. "}]]],["li",{},[["textNode",{"text":"To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations. "}]]],["li",{},[["textNode",{"text":" As described to you when collecting your personal information or as otherwise stated in the CCPA. "}]]],["li",{},[["textNode",{"text":" To evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by us about our Website users is among the assets transferred. "}]]]]],["p",{},[["textNode",{"text":"We will not collect additional categories of personal information or use the personal information we collected for materially different, unrelated, or incompatible purposes without providing you notice. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Sharing Personal Information "}]]]]],["p",{},[["textNode",{"text":"We may disclose your personal information to a third party for a business purpose. When we disclose personal information for a business purpose, we enter a contract that describes the purpose and requires the recipient to both keep that personal information confidential and not use it for any purpose except performing the contract."}]]],["p",{},[["textNode",{"text":"We share your personal information with the following categories of third parties:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Service providers. "}]]],["li",{},[["textNode",{"text":" Internet cookie data recipients, like Google Analytics. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Disclosures of Personal Information for a Business Purpose "}]]]]],["p",{},[["textNode",{"text":"In the preceding 12 months, Company has disclosed the following categories of personal information for a business purpose: "}]]],["p",{"class":"pl-20"}],["p",{},[["textNode",{"text":" Category A: Identifiers."}]]],["p",{},[["textNode",{"text":" Category B: California Customer Records personal information categories. "}]]],["p",{},[["textNode",{"text":" Category F: Internet or other similar network activity. "}]]],["p"],["p",{},[["textNode",{"text":"We disclose your personal information for a business purpose to the following categories of third parties: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Service providers. "}]]],["li",{},[["textNode",{"text":" Internet cookie data recipients, like Google Analytics. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Sales of Personal Information "}]]]]],["p",{},[["textNode",{"text":"In the preceding 12 months, Company had not sold personal information. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Your Rights and Choices "}]]]]],["p",{},[["textNode",{"text":"The CCPA provides consumers (California residents) with specific rights regarding their personal information. This section describes your CCPA rights and explains how to exercise those rights. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Access to Specific Information and Data Portability Rights "}]]]]],["p",{},[["textNode",{"text":"You have the right to request that we disclose certain information to you about our collection and use of your personal information over the past 12 months. Once we receive and confirm your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will disclose to you: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" The categories of personal information we collected about you. "}]]],["li",{},[["textNode",{"text":" The categories of sources for the personal information we collected about you. "}]]],["li",{},[["textNode",{"text":" Our business or commercial purpose for collecting or selling that personal information. "}]]],["li",{},[["textNode",{"text":" The categories of third parties with whom we share that personal information. "}]]],["li",{},[["textNode",{"text":" The specific pieces of personal information we collected about you (also called a data portability request). "}]]],["li",{},[["textNode",{"text":" If we sold or disclosed your personal information for a business purpose, two separate lists disclosing: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["textNode",{"text":" sales, identifying the personal information categories that each category of recipient purchased; "}]]],["li",{},[["textNode",{"text":" disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained. "}]]]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Deletion Request Rights "}]]]]],["p",{},[["textNode",{"text":"You have the right to request that we delete any of your personal information that we collected from you and retained, subject to certain exceptions. Once we receive and confirm your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will delete (and direct our service providers to delete) your personal information from our records, unless an exception applies. "}]]],["p",{},[["textNode",{"text":"We may deny your deletion request if retaining the information is necessary for us or our service providers to: "}]]],["ul",{"class":"nextlevel"},[["li",{},[["textNode",{"text":" 1. Complete the transaction for which we collected the personal information, provide a good or service that you requested, take actions reasonably anticipated within the context of our ongoing business relationship with you, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, or otherwise perform our contract with you. "}]]],["li",{},[["textNode",{"text":" 2 Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities. "}]]],["li",{},[["textNode",{"text":" 3. Debug products to identify and repair errors that impair existing intended functionality. "}]]],["li",{},[["textNode",{"text":" 4. Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or exercise another right provided for by law. "}]]],["li",{},[["textNode",{"text":" 5. Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 et. seq.). "}]]],["li",{},[["textNode",{"text":" 6. Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when the information’s deletion may likely render impossible or seriously impair the research’s achievement, if you previously provided informed consent. "}]]],["li",{},[["textNode",{"text":" 7. Enable solely internal uses that are reasonably aligned with consumer expectations based on your relationship with us. "}]]],["li",{},[["textNode",{"text":" 8. Comply with a legal obligation. "}]]],["li",{},[["textNode",{"text":" 9. Make other internal and lawful uses of that information that are compatible with the context in which you provided it. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Exercising Access, Data Portability, and Deletion Rights"}]]]]],["p",{},[["textNode",{"text":"To exercise the access, data portability, and deletion rights described above, please submit a verifiable consumer request to us by either: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]]]],["li",{},[["textNode",{"text":" Visiting "}],["a",{"show-popup":"","class":"show-popup"},[["textNode",{"text":"modelcentro.com/ccpa"}]]]]]]],["p",{},[["textNode",{"text":"Only you, or someone legally authorized to act on your behalf, may make a verifiable consumer request related to your personal information. You may also make a verifiable consumer request on behalf of your minor child. "}]]],["p",{},[["textNode",{"text":"You may only make a verifiable consumer request for access or data portability twice within a 12-month period. The verifiable consumer request must: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Provide sufficient information that allows us to reasonably verify you are the person about whom we collected personal information or an authorized representative. "}]]],["li",{},[["textNode",{"text":" Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it. "}]]]]],["p",{},[["textNode",{"text":"We cannot respond to your request or provide you with personal information if we cannot verify your identity or authority to make the request and confirm the personal information relates to you. "}]]],["p",{},[["textNode",{"text":"Making a verifiable consumer request does not require you to create an account with us. "}]]],["p",{},[["textNode",{"text":"We will only use personal information provided in a verifiable consumer request to verify the requestor’s identity or authority to make the request. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Response Timing and Format "}]]]]],["p",{},[["textNode",{"text":"We endeavor to respond to a verifiable consumer request within 45 days of its receipt. If we require more time (up to 45 days), we will inform you of the reason and extension period in writing."}]]],["p",{},[["textNode",{"text":"If you have an account with us, we will deliver our written response to that account. If you do not have an account with us, we will deliver our written response by mail or electronically, at your option."}]]],["p",{},[["textNode",{"text":"Any disclosures we provide will only cover the 12-month period preceding the verifiable consumer request’s receipt. The response we provide will also explain the reasons we cannot comply with a request, if applicable. For data portability requests, we will select a format to provide your personal information that is readily useable and should allow you to transmit the information from one entity to another entity without hindrance."}]]],["p",{},[["textNode",{"text":"We do not charge a fee to process or respond to your verifiable consumer request unless it is excessive, repetitive, or manifestly unfounded. If we determine that the request warrants a fee, we will tell you why we made that decision and provide you with a cost estimate before completing your request."}]]],["p",{},[["strong",{},[["textNode",{"text":"Non-Discrimination "}]]]]],["p",{},[["textNode",{"text":"We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Deny you goods or services. "}]]],["li",{},[["textNode",{"text":" Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties. "}]]],["li",{},[["textNode",{"text":" Provide you a different level or quality of goods or services. "}]]],["li",{},[["textNode",{"text":" Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services. "}]]]]],["p",{},[["textNode",{"text":"However, we may offer you certain financial incentives permitted by the CCPA that can result in different prices, rates, or quality levels. Any CCPA-permitted financial incentive we offer will reasonably relate to your personal information’s value and contain written terms that describe the program’s material aspects. Participation in a financial incentive program requires your prior opt in consent, which you may revoke at any time. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Other California Privacy Rights"}]]]]],["p",{},[["textNode",{"text":"California’s “Shine the Light” law (Civil Code Section § 1798.83) permits users of our Website that are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make that request, please send an email to "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":". "}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to Our Privacy Notice"}]]]]],["p",{},[["textNode",{"text":"We reserve the right to amend this privacy notice at our discretion and at any time. When we make changes to this privacy notice, we will post the updated notice on the Website and update the notice’s effective date. "}],["strong",{},[["textNode",{"text":"Your continued use of our Website following the posting of changes constitutes your acceptance of such changes"}]]],["textNode",{"text":". "}]]],["p",{},[["strong",{},[["textNode",{"text":"Contact Information "}]]]]],["p",{},[["textNode",{"text":"If you have any questions or comments about this notice, the ways in which Centro Publisher Limited collects and uses your information described below and in the "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":", your choices and rights regarding that use, or wish to exercise your rights under California law, please do not hesitate to contact us at: "}]]],["p",{"class":"pl-20"}],["p",{},[["strong",{},[["textNode",{"text":"Website:"}]]],["textNode",{"text":" "}],["a",{"target":"_blank","href":"https://support.modelcentro.com/hc/en-us/requests/new"},[["textNode",{"text":" support.modelcentro.com "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Email:"}]]],["textNode",{"text":" "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":"privacy@modelcentro.com"}]]]]],["p"]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("page_ccpa", [["div",{"class":"layout-width single-page"},[["import",{"name":"promo_ccpa_header"}],["div",{"class":"sp-main-content-wrapp"},[["import",{"name":"promo_ccpa_body"}],["div",{"class":"col sp-right"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	__webpack_require__(627)(fox);
};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
	var registerTemplateModifier = _ref.registerTemplateModifier,
	    isString = _ref.isString,
	    isNull = _ref.isNull;

	var classIfTrue = function classIfTrue(obj) {
		var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [],
		    _ref3 = _slicedToArray(_ref2, 1),
		    className = _ref3[0];

		return obj === true && className || '';
	};
	var classIfFalse = function classIfFalse(obj) {
		var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [],
		    _ref5 = _slicedToArray(_ref4, 1),
		    className = _ref5[0];

		return obj === false && className || '';
	};

	registerTemplateModifier('strToInt', function (obj) {
		return isString(obj) ? parseInt(obj) : 0;
	});

	registerTemplateModifier('isNull', function (obj) {
		return isNull(obj);
	});
	registerTemplateModifier('isNotNull', function (obj) {
		return !isNull(obj);
	});

	registerTemplateModifier('hideIfTrue', function (obj) {
		return classIfTrue(obj, ['_hidden']);
	});
	registerTemplateModifier('hideIfFalse', function (obj) {
		return classIfFalse(obj, ['_hidden']);
	});

	registerTemplateModifier('classIfTrue', classIfTrue);
	registerTemplateModifier('classIfFalse', classIfFalse);

	registerTemplateModifier('testString', function () {
		var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var params = arguments[1];

		return obj.match(params[0]) !== null;
	});
};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./LiveShow_user.swf": 629,
	"./expressInstall.swf": 630,
	"./flowplayer-3.2.14.swf": 631,
	"./flowplayer.banner-3.2.14.swf": 632,
	"./flowplayer.commercial-3.2.16.swf": 57,
	"./flowplayer.controls-3.2.14.swf": 633,
	"./flowplayer.pseudostreaming-3.2.11.swf": 634,
	"./flowplayer.pseudostreaming-3.2.16.swf": 635,
	"./flowplayer.relateds-3.2.14.swf": 636,
	"./flowplayer.splash-3.2.14.swf": 637,
	"./player.swf": 638
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 628;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/LiveShow_user.swf", __webpack_require__.p + "_/_/_/root/flash/LiveShow_user.swf");

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/expressInstall.swf", __webpack_require__.p + "_/_/_/root/flash/expressInstall.swf");

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/flowplayer-3.2.14.swf", __webpack_require__.p + "_/_/_/root/flash/flowplayer-3.2.14.swf");

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/flowplayer.banner-3.2.14.swf", __webpack_require__.p + "_/_/_/root/flash/flowplayer.banner-3.2.14.swf");

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/flowplayer.controls-3.2.14.swf", __webpack_require__.p + "_/_/_/root/flash/flowplayer.controls-3.2.14.swf");

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/flowplayer.pseudostreaming-3.2.11.swf", __webpack_require__.p + "_/_/_/root/flash/flowplayer.pseudostreaming-3.2.11.swf");

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/flowplayer.pseudostreaming-3.2.16.swf", __webpack_require__.p + "_/_/_/root/flash/flowplayer.pseudostreaming-3.2.16.swf");

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/flowplayer.relateds-3.2.14.swf", __webpack_require__.p + "_/_/_/root/flash/flowplayer.relateds-3.2.14.swf");

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/flowplayer.splash-3.2.14.swf", __webpack_require__.p + "_/_/_/root/flash/flowplayer.splash-3.2.14.swf");

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("flash/player.swf", __webpack_require__.p + "_/_/_/root/flash/player.swf");

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./accessibility.js": 640,
	"./comments.js": 641,
	"./common.js": 642,
	"./content/browser.js": 643,
	"./content/sceneViewer.js": 644,
	"./content/tagsfilter.js": 645,
	"./conversationGiftsPopup.js": 646,
	"./desktopNotifications.js": 647,
	"./disableRightClick.js": 648,
	"./downloadLinks.js": 649,
	"./favico.js": 650,
	"./fhg.opt": 651,
	"./fullscreenGalleryTipme.js": 652,
	"./joinForm.js": 653,
	"./maps/guest.js": 654,
	"./maps/member.js": 655,
	"./menu.js": 656,
	"./messageCountService.js": 657,
	"./messageRecieveHandler.js": 658,
	"./modelBacklinks.js": 659,
	"./newsletter/newsletter.js": 660,
	"./offer.js": 661,
	"./pageTitle.js": 662,
	"./passRetrive.js": 663,
	"./player.js": 664,
	"./rating.js": 665,
	"./requireResources.js": 666,
	"./routeToSpecPages.js": 667,
	"./router.js": 668,
	"./sitepage/about.js": 669,
	"./sitepage/account.js": 670,
	"./sitepage/account/values.js": 671,
	"./sitepage/conversation.js": 672,
	"./sitepage/liveshow/tipme.js": 673,
	"./sitepage/login.js": 674,
	"./sitepage/myfriends.js": 675,
	"./sitepage/restrictedContent.js": 676,
	"./sitepage/scene/logger.js": 677,
	"./sitepage/siteUnderConstruction.js": 678,
	"./sitepage/successfulRegistration.js": 679,
	"./socilaRating.js": 680,
	"./splash.opt": 681,
	"./store.js": 696,
	"./stripNotification.opt": 697,
	"./throughChatWindow.js": 698,
	"./tipsForm.js": 699,
	"./tipsPaymentInPopup.js": 700,
	"./tracking.js": 701,
	"./trimLoginFields.js": 702,
	"./verifiedcall.js": 703
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 639;

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Content_PhotosetViewer #photosetDl":{"hooks.onLoaded":[{"value":function () {
var preview = this.getObject().get('accessibility.previewsForGuests');
if (preview === 0 && !fox.site.member) {
fox.site.gotoPage('');
return;
};
this.dispatchEvent('loaded');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"~.Content_PhotosetViewer #photosetDl","_fox_":1}]},"~.MC_Photoset_Gallery #photoset #dl":{"hooks.onLoaded":[{"value":function () {
var count = this.getObject().getCount();
var preview = this.getObject().get('accessibility.previewsForGuests');
if (!fox.site.member && preview !== 2) {
fox.site.gotoPage('');
return;
}
if (count === 0) {
fox.site._gotoPage('upgrade');
return;
}
this.dispatchEvent('loaded');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101028},"path":"~.MC_Photoset_Gallery #photoset #dl","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Social_Comments .Grid #list":{"handleDom.toggleComment.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Social_Comments .Grid #list","_fox_":1}],"handleDom.toggleComment.target":[{"value":".toggle-comment","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Social_Comments .Grid #list","_fox_":1}],"handleDom.toggleComment.callback":[{"value":function (el) {
$(this.dom('.toggle-comment')).parent().toggle();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101008},"path":"~.Social_Comments .Grid #list","_fox_":1}]},"~.BlogSidebar #latestComments #list":{"handleDom.toggleComment.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101012},"path":"~.BlogSidebar #latestComments #list","_fox_":1}],"handleDom.toggleComment.target":[{"value":".toggle-comment","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"~.BlogSidebar #latestComments #list","_fox_":1}],"handleDom.toggleComment.callback":[{"value":function (el) {
$(this.dom('.toggle-comment')).parent().toggle();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101016},"path":"~.BlogSidebar #latestComments #list","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Widget":{"handlerDom.titleMove":[{"value":function (elem) {
var delta;
var time;
var velo = 80;
var title = $(elem).find('a');
var layoutBox = $(elem).width();
var layoutTitle = title.width();
if(layoutTitle > layoutBox){
delta	= layoutBox - layoutTitle;
time	= delta/velo*(-1000);
delta/velo*(-1) > 1 ? time : time = 500;
$(title).animate({"left": delta + "px"}, time);
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101016},"path":"~.Widget","_fox_":1}],"handlerDom.titleMoveBack":[{"value":function (elem) {
var title = $(elem).find('a');
time = 500;
$(title).stop(true).animate({"left": "0px"}, time);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":"~.Widget","_fox_":1}]},"~.AdvancedList":{"dontReuseSn":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101023},"path":"~.AdvancedList","_fox_":1}]},"@root":{"widgets.sestaFosta.widget":[{"value":"SestaFosta_Popup","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101027},"path":"@root","_fox_":1}]},"@root .Layout_Home":{"widgets.expremiumUser.widget":[{"value":"ExpremiumUser_Popup","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101031},"path":"@root .Layout_Home","_fox_":1}]},"~#textPersonal":{"hooks.onStartInit":[{"value":function () {
var siteName = document.location.host;
this.setTemplateOptions({ siteName: siteName });
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101037},"path":"~#textPersonal","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Content_Browser #dl":{"hooks.onStopLoaded":[{"value":function () {
var parent = this.getParent();
if (!parent.getOption('useGeneratedContentLink')) {
return;
};
parent.generateContentLink();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101008},"path":"~.Content_Browser #dl","_fox_":1}]},"~.Content_Scenes":{"preset":[{"value":"videos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101010},"path":"~.Content_Scenes","_fox_":1}]},"~.Content_Photosets":{"preset":[{"value":"photosets","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"~.Content_Photosets","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Content_SceneViewer":{"widgets.currentScene.preset":[{"value":"scene","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.Content_SceneViewer","_fox_":1}],"handleWom.scrollToPlayer.callback":[{"value":function() {},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Content_SceneViewer","_fox_":1}],"widgets.flashPlayer.handleWom.added.event":[{"value":"addedToDom","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Content_SceneViewer","_fox_":1}],"widgets.flashPlayer.handleWom.added.widget":[{"value":"@this","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Content_SceneViewer","_fox_":1}],"widgets.flashPlayer.handleWom.added.callback":[{"value":function() {
this.getParent().scrollToPlayer();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101009},"path":"~.Content_SceneViewer","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Content_TagsFilter":{"handleWom.changeNavi.widget":[{"value":"@this","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Content_TagsFilter","_fox_":1}],"handleWom.changeNavi.event":[{"value":"activate","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Content_TagsFilter","_fox_":1}],"handleWom.changeNavi.callback":[{"value":function () {
var
tags = fox.Navigator.get('tags'),
parent = this.getParent(),
pager = parent.wom1('#pager'),
navPrefix
;
if (pager && pager.navPrefix && fox.Navigator.get(pager.navPrefix)) {
return false;
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101022},"path":"~.Content_TagsFilter","_fox_":1}],"hooks.onStopInit":[{"value":function (argument) {
var parent = this.getParent();
var dl = parent.wom1('#dl');
var pager = parent.wom1('#pager');
var tagsFilter = parent.wom1('#tagsFilter');
this.handleEvent(fox.site.wom1('#navi'), 'modified_tags', function (val, navi, ev) {
var pagerPrefix = pager.navPrefix;
if (pagerPrefix && fox.Navigator.get(pagerPrefix)) {
var hash = fox.Navigator.getAll();
delete hash[pagerPrefix];
fox.Navigator.update(hash, true);
}
parent.applyTagsFilter(tagsFilter.getTagsFromNavigator());
if (dl._loadStatus == 'loading') {
dl.abort();
}
dl.load();
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101042},"path":"~.Content_TagsFilter","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.conversationGiftsPopup.widget":[{"value":"ConversationGiftsPopup","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root","_fox_":1}],"widgets.conversationGiftsPopup.widgets.giftBoxBody.giftType":[{"value":"conversation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"@root","_fox_":1}],"widgets.conversationGiftsPopup.widgets.giftBoxBody.giftPaymentSuccess":[{"value":"inboxSocketEventConversation:giftUnlock","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101015},"path":"@root","_fox_":1}],"widgets.conversationGiftsPopup.widgets.giftBoxBody.targetIdCb":[{"value":function () {
return fox.getEnv('site.conversationId');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.desktopNotifications.widget":[{"value":"DesktopNotifications","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"handlerDom.disableRightClickOnImg":[{"value":function (img, alias, list, event) {
img.contextmenuDisabled = true;
event.stopPropagation();
event.preventDefault();
return false;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"@root","_fox_":1}]},"~.LazyDataList":{"handleDom.forDisableRightClickOnImg.event":[{"value":"contextmenu","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101010},"path":"~.LazyDataList","_fox_":1}],"handleDom.forDisableRightClickOnImg.target":[{"value":"img","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101011},"path":"~.LazyDataList","_fox_":1}],"handleDom.forDisableRightClickOnImg.callback":[{"value":"handlerDom:disableRightClickOnImg","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101012},"path":"~.LazyDataList","_fox_":1}]},"~.Activity_Event_MainEvent .Widget":{"handleDom.forDisableRightClickOnImg.event":[{"value":"contextmenu","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101015},"path":"~.Activity_Event_MainEvent .Widget","_fox_":1}],"handleDom.forDisableRightClickOnImg.target":[{"value":"img","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101016},"path":"~.Activity_Event_MainEvent .Widget","_fox_":1}],"handleDom.forDisableRightClickOnImg.callback":[{"value":"handlerDom:disableRightClickOnImg","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"~.Activity_Event_MainEvent .Widget","_fox_":1}]},"~.FullscreenView":{"handleDom.forDisableRightClickOnImg.event":[{"value":"contextmenu","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101020},"path":"~.FullscreenView","_fox_":1}],"handleDom.forDisableRightClickOnImg.target":[{"value":"img","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":"~.FullscreenView","_fox_":1}],"handleDom.forDisableRightClickOnImg.callback":[{"value":"handlerDom:disableRightClickOnImg","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101022},"path":"~.FullscreenView","_fox_":1}]},"~.FullscreenView #body":{"handleDom.forDisableRightClickOnImg.event":[{"value":"contextmenu","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101025},"path":"~.FullscreenView #body","_fox_":1}],"handleDom.forDisableRightClickOnImg.target":[{"value":"img","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101026},"path":"~.FullscreenView #body","_fox_":1}],"handleDom.forDisableRightClickOnImg.callback":[{"value":"handlerDom:disableRightClickOnImg","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101027},"path":"~.FullscreenView #body","_fox_":1}]},"~.List":{"handleDom.forDisableRightClickOnImg.event":[{"value":"contextmenu","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101030},"path":"~.List","_fox_":1}],"handleDom.forDisableRightClickOnImg.target":[{"value":"img","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101031},"path":"~.List","_fox_":1}],"handleDom.forDisableRightClickOnImg.callback":[{"value":"handlerDom:disableRightClickOnImg","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101032},"path":"~.List","_fox_":1}]},"~.List .Widget":{"handleDom.forDisableRightClickOnImg.event":[{"value":"contextmenu","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101035},"path":"~.List .Widget","_fox_":1}],"handleDom.forDisableRightClickOnImg.target":[{"value":"img","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101036},"path":"~.List .Widget","_fox_":1}],"handleDom.forDisableRightClickOnImg.callback":[{"value":"handlerDom:disableRightClickOnImg","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101038},"path":"~.List .Widget","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Scene":{"widgets.sceneViewer.widgets.currentScene.list.handleDom.downloadLinks.eventChecker":[{"value":function (e, elm, w) {
return window.parseInt(w.dl.getObjectValue('accessibility.downloadable'));
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101009},"path":"~.SitePage_Scene","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.favico.widget":[{"value":"Favico","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root","_fox_":1}],"widgets.favico.handleWom.messageReceived.widget":[{"value":"@root #newMessageCount","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"@root","_fox_":1}],"widgets.favico.handleWom.messageReceived.event":[{"value":"cameNewMessages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"@root","_fox_":1}],"widgets.favico.handleWom.messageReceived.callback":[{"value":function (data) {
if (data.total > 0) {
this.insertNumber(data.total);
return;
}
this.reset();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #freeHostedGallery .Site_Page":{"requireResources":[{"value":function () {
return new fox.RSVP.Promise(function (resolve) {
__webpack_require__.e/* require.ensure */(2).then((function () {
return resolve(__webpack_require__(1284)(fox));
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101010},"path":"@root #freeHostedGallery .Site_Page","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_Home #gallery #fullscreenView":{"widgets.tipme.widget":[{"value":"Content_Tipme","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Layout_Home #gallery #fullscreenView","_fox_":1}],"widgets.tipme.embed.container":[{"value":".gallery-sidebar-tipme-form","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Layout_Home #gallery #fullscreenView","_fox_":1}],"widgets.tipme.template":[{"value":"content_gallery_fullscreen_view","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Layout_Home #gallery #fullscreenView","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Join_Form":{"wrapMethods.prepareTransaction":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.Join_Form","_fox_":1}],"hooks.onStartPrepareTransaction":[{"value":function (formData) {
var fields = ['username', 'password', 'email'];
fox.each(formData, function (v, key) {
formData[key] = (fields.indexOf(key) !== -1) ? fox.trim(v) : v;
});
var linkerParam = this.rwom1('@root #googleAnalytics').getLinkerParam();
if (linkerParam) {
formData['transitParams[_ga]'] = linkerParam;
}
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"~.Join_Form","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"mapGuest.widgets.home.widget":[{"value":"Layout_Home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.404.widget":[{"value":"SitePage_404","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.404.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.404.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.404.title":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.404.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.2257.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.2257.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.2257.title":[{"value":"18 U.S.C. § 2257 Statement","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.2257.template":[{"value":"sitepage_2257","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.2257.widgets.text2257.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.2257.widgets.text2257.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.2257.widgets.text2257.template":[{"value":"legaldocs_2257","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.2257.widgets.text2257.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.2257.widgets.text2257.hooks.onStartRendering":[{"value":function() {
this.setTemplateOptions({siteUrl: document.location.host})
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.home.widget":[{"value":"SitePage_Home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.home.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.home.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.home.title":[{"value":"Home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.home.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.videos.widget":[{"value":"SitePage_Videos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.videos.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.videos.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.videos.title":[{"value":"Videos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.videos.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.photosets.widget":[{"value":"SitePage_Photosets","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.photosets.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.photosets.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.photosets.title":[{"value":"Photosets","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.photosets.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.scene.widget":[{"value":"SitePage_Scene","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.scene.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.scene.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.scene.title":[{"value":"Scene","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.scene.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.scene.dynamicTitle":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.gallery.widget":[{"value":"MC_Photoset_Gallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.gallery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.gallery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.gallery.title":[{"value":"Gallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.gallery.access":[{"value":2,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.gallery.dynamicTitle":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.about.widget":[{"value":"SitePage_About","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.about.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.about.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.about.title":[{"value":"About","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.about.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.login.widget":[{"value":"SitePage_Login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.login.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.login.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.login.title":[{"value":"Login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.login.access":[{"value":1,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.splash.widget":[{"value":"Splash","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.splash.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.terms.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.terms.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.terms.title":[{"value":"Website Terms-of-Use Agreement","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.terms.template":[{"value":"sitepage_terms","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.terms.widgets.textTerms.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.terms.widgets.textTerms.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.terms.widgets.textTerms.template":[{"value":"legaldocs_terms","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.terms.widgets.textTerms.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.ccpa.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.ccpa.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.ccpa.title":[{"value":"California Consumer Privacy Act","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.ccpa.template":[{"value":"sitepage_ccpa","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.ccpa.widgets.ccpa.widget":[{"value":"Page_CCPA_Site","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.ccpa.widgets.ccpa.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.ccpa.widgets.ccpa.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.ccpa.widgets.ccpa.template":[{"value":"legal_ccpa_doc","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.privacy.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.privacy.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.privacy.title":[{"value":"Website Privacy Policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.privacy.template":[{"value":"sitepage_privacy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.privacy.widgets.textPrivacy.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.privacy.widgets.textPrivacy.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.privacy.widgets.textPrivacy.template":[{"value":"legaldocs_privacy_policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.privacy.widgets.textPrivacy.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshow.widget":[{"value":"SitePage_Liveshow","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshow.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshow.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshow.title":[{"value":"Liveshow","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshow.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.blog.widget":[{"value":"SitePage_Blog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.blog.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.blog.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.blog.title":[{"value":"Blog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.blog.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.post.widget":[{"value":"SitePage_Post","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.post.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.post.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.post.dynamicTitle":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.post.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.tips.widget":[{"value":"SitePage_Tips","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.tips.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.tips.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.tips.title":[{"value":"Tips","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.tips.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.activity.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.activity.template":[{"value":"SitePage_Activity","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.activity.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.activity.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.activity.title":[{"value":"Events calendar","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.activity.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.activity.widgets.activityViewer.widget":[{"value":"Activity_EventCalendarViewer","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.callme.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.callme.template":[{"value":"SitePage_Callme","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.callme.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.callme.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.callme.title":[{"value":"Call me","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.callme.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.passwordRecovery.widget":[{"value":"SitePage_Passwordrecovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.passwordRecovery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.passwordRecovery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.passwordRecovery.title":[{"value":"Password Recovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshowNew.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshowNew.template":[{"value":"sitepage_liveshowNew","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshowNew.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshowNew.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshowNew.title":[{"value":"Liveshow New","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.liveshowNew.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.sponsor.widget":[{"value":"SitePage_Sponsor","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.sponsor.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.sponsor.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.sponsor.title":[{"value":"Sponsor page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.myfriends.widget":[{"value":"SitePage_MyFriends","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.myfriends.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.myfriends.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.myfriends.title":[{"value":"My Friends","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.myfriends.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widget":[{"value":"Layout_Affiliate","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliates.widget":[{"value":"SitePage_Affiliates","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliates.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliates.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliates.title":[{"value":"Affiliates","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliates.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliateAgreement.widget":[{"value":"SitePage_Affiliate","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliateAgreement.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliateAgreement.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliateAgreement.title":[{"value":"Affiliate Agreement","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.affiliate.widgets.affiliateAgreement.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widget":[{"value":"Layout_Stateoff","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.siteUnderConstruction.widget":[{"value":"SitePage_SiteUnderConstruction","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.siteUnderConstruction.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.siteUnderConstruction.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.siteUnderConstruction.title":[{"value":"Site Under Construction","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.siteClosed.widget":[{"value":"SitePage_SiteClosed","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.siteClosed.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.siteClosed.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.siteClosed.title":[{"value":"Site Closed","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.passwordRecovery.widget":[{"value":"SitePage_Passwordrecovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.passwordRecovery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.passwordRecovery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.passwordRecovery.title":[{"value":"Password Recovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.passwordRecovery.template":[{"value":"sitepage_stateoff_passwordRecovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.template":[{"value":"stateoff_passwordRecovery_form","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.container":[{"value":".loginform_container.forgotform_container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.stateoff.widgets.passwordRecovery.widgets.socialAppsBlock.widget":[{"value":"Stateoff_SocialApps_Block","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widget":[{"value":"Layout_FreeHostedGallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedGallery.widget":[{"value":"SitePage_FreeHostedGallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedGallery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedGallery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedGallery.title":[{"value":"Free Hosted Gallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedGallery.widgets.fhg.widget":[{"value":"FreeHostedGallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedVideos.widget":[{"value":"SitePage_FreeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedVideos.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedVideos.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedVideos.title":[{"value":"Free Hosted Videos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedVideos.widgets.fhv.widget":[{"value":"FreeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedMixed.widget":[{"value":"SitePage_FreeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedMixed.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedMixed.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedMixed.title":[{"value":"Free Hosted Content","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.widgets.freeHostedGallery.widgets.freeHostedMixed.widgets.fhv.widget":[{"value":"FreeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.denied.restricted":[{"value":"directContentAccess","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.denied.favorites":[{"value":"membersOnly","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.denied.conversation":[{"value":"membersOnly","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.denied.account":[{"value":"login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.denied.cancellation":[{"value":"login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.denied.billing-contact":[{"value":"login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.denied.purchases":[{"value":"login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.@":[{"value":"#home #home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.gallery\u002F:id(\u002F*tail)":[{"value":"#home #gallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.scene\u002F:id(\u002F*tail)":[{"value":"#home #scene","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.callme":[{"value":"#home #callme","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.liveshow-new":[{"value":"#home #liveshowNew","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.sponsor":[{"value":"#home #sponsor","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.site-under-construction":[{"value":"#stateoff #siteUnderConstruction","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.site-closed":[{"value":"#stateoff #siteClosed","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.affiliate-agreement":[{"value":"#affiliate #affiliateAgreement","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.successful-registration":[{"value":"#home #login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.free-gallery\u002F:id\u002F:title(\u002Fphotos)":[{"value":"#freeHostedGallery #freeHostedGallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.free-gallery\u002F:id\u002F:title\u002Fvideos":[{"value":"#freeHostedGallery #freeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.free-gallery\u002F:id\u002F:title\u002Fmixed":[{"value":"#freeHostedGallery #freeHostedMixed","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.splash":[{"value":"#home #splash","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.affiliates":[{"value":"#affiliate #affiliates","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.affiliates(\u002F*tail)":[{"value":"#affiliate #affiliates","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.california-privacy-rights":[{"value":"#home #ccpa","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.routes.myfriends":[{"value":"#home #myfriends","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.404":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.2257":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.home":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.videos":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.photosets":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.about":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.bonus":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.login":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.terms":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.privacy-policy":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.affiliateAgreement":[{"value":"affiliate","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.forgot":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.liveshow":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.blog":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.post":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.affiliates":[{"value":"affiliate","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.tips":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.activity":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.splash":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.pages.myfriends":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.special.404":[{"value":"404","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.special.home":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.special.guestsOnly":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.special.membersOnly":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.special.splash":[{"value":"splash","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.special.directContentAccess":[{"value":"join","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}],"mapGuest.special.login":[{"value":"login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101348},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"mapMember.widgets.home.widget":[{"value":"Layout_Home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.404.widget":[{"value":"SitePage_404","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.404.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.404.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.404.title":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.404.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.2257.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.2257.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.2257.title":[{"value":"18 U.S.C. § 2257 Statement","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.2257.template":[{"value":"sitepage_2257","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.2257.widgets.text2257.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.2257.widgets.text2257.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.2257.widgets.text2257.template":[{"value":"legaldocs_2257","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.2257.widgets.text2257.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.2257.widgets.text2257.hooks.onStartRendering":[{"value":function() {
this.setTemplateOptions({siteUrl: document.location.host})
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.home.widget":[{"value":"SitePage_Home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.home.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.home.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.home.title":[{"value":"Home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.home.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.videos.widget":[{"value":"SitePage_Videos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.videos.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.videos.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.videos.title":[{"value":"Videos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.videos.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.photosets.widget":[{"value":"SitePage_Photosets","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.photosets.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.photosets.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.photosets.title":[{"value":"Photosets","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.photosets.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.scene.widget":[{"value":"SitePage_Scene","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.scene.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.scene.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.scene.title":[{"value":"Scene","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.scene.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.scene.dynamicTitle":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.about.widget":[{"value":"SitePage_About","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.about.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.about.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.about.title":[{"value":"About","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.about.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.title":[{"value":"Website Terms-of-Use Agreement","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.template":[{"value":"sitepage_terms","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.widgets.textTerms.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.widgets.textTerms.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.widgets.textTerms.template":[{"value":"legaldocs_terms","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.widgets.textTerms.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.widgets.textTerms.hooks.onStartRendering":[{"value":function() {
this.setTemplateOptions({siteUrl: document.location.host})
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.widgets.textTerms.widgets.anchorNavigator.widget":[{"value":"AnchorNavigator","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.widgets.textTerms.widgets.anchorNavigator.targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.terms.widgets.textTerms.widgets.anchorNavigator.clickTarget":[{"value":".anchorlink","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.title":[{"value":"Website Privacy Policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.template":[{"value":"sitepage_privacy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.widgets.textPrivacy.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.widgets.textPrivacy.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.widgets.textPrivacy.template":[{"value":"legaldocs_privacy_policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.widgets.textPrivacy.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.widgets.textPrivacy.widgets.anchorNavigator.widget":[{"value":"AnchorNavigator","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.widgets.textPrivacy.widgets.anchorNavigator.targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.privacy.widgets.textPrivacy.widgets.anchorNavigator.clickTarget":[{"value":".anchorlink","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.ccpa.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.ccpa.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.ccpa.title":[{"value":"California Consumer Privacy Act","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.ccpa.template":[{"value":"sitepage_ccpa","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.ccpa.widgets.ccpa.widget":[{"value":"Page_CCPA_Site","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.ccpa.widgets.ccpa.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.ccpa.widgets.ccpa.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.ccpa.widgets.ccpa.template":[{"value":"legal_ccpa_doc","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.personal.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.personal.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.personal.title":[{"value":"Personal Data Policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.personal.template":[{"value":"sitepage_personal_policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.personal.widgets.textPersonal.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.personal.widgets.textPersonal.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.personal.widgets.textPersonal.template":[{"value":"legaldocs_personal_policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.personal.widgets.textPersonal.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-policy.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-policy.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-policy.title":[{"value":"Cookie Use Policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-policy.template":[{"value":"sitepage_cookie_policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-policy.widgets.textPersonal.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-policy.widgets.textPersonal.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-policy.widgets.textPersonal.template":[{"value":"legaldocs_cookie_policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-policy.widgets.textPersonal.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-table.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-table.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-table.title":[{"value":"Cookie Table","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-table.template":[{"value":"sitepage_cookie_table","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-table.widgets.textPersonal.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-table.widgets.textPersonal.container":[{"value":".static-page-docs","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-table.widgets.textPersonal.template":[{"value":"legaldocs_cookie_table","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cookie-table.widgets.textPersonal.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.gallery.widget":[{"value":"MC_Photoset_Gallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.gallery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.gallery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.gallery.title":[{"value":"Gallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.gallery.access":[{"value":2,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.gallery.dynamicTitle":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.favorites.widget":[{"value":"SitePage_Favorites","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.favorites.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.favorites.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.favorites.title":[{"value":"Favorites","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.favorites.access":[{"value":2,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.conversation.widget":[{"value":"SitePage_Conversation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.conversation.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.conversation.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.conversation.title":[{"value":"Conversation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.conversation.access":[{"value":2,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.liveshow.widget":[{"value":"SitePage_Liveshow","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.liveshow.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.liveshow.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.liveshow.title":[{"value":"Liveshow","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.liveshow.access":[{"value":2,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.account.widget":[{"value":"SitePage_Account","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.account.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.account.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.account.title":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.account.access":[{"value":2,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.blog.widget":[{"value":"SitePage_Blog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.blog.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.blog.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.blog.title":[{"value":"Blog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.blog.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.post.widget":[{"value":"SitePage_Post","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.post.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.post.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.post.dynamicTitle":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.post.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.tips.widget":[{"value":"SitePage_Tips","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.tips.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.tips.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.tips.title":[{"value":"Tips","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.tips.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.activity.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.activity.template":[{"value":"SitePage_Activity","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.activity.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.activity.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.activity.title":[{"value":"Events calendar","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.activity.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.activity.widgets.activityViewer.widget":[{"value":"Activity_EventCalendarViewer","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.callme.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.callme.template":[{"value":"SitePage_Callme","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.callme.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.callme.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.callme.title":[{"value":"Call me","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.callme.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cancellation.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cancellation.template":[{"value":"SitePage_Cancellation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cancellation.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cancellation.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cancellation.title":[{"value":"Cancel membership","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.cancellation.widgets.cancellationForm.widget":[{"value":"BillingSupport_Cancellation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.billingContact.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.billingContact.template":[{"value":"SitePage_BillingContact","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.billingContact.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.billingContact.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.billingContact.title":[{"value":"Contact billing support","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.billingContact.widgets.billingContactForm.widget":[{"value":"BillingSupport_BillingContact","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.sponsor.widget":[{"value":"SitePage_Sponsor","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.sponsor.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.sponsor.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.sponsor.title":[{"value":"Sponsor page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.afterCancel.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.afterCancel.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.afterCancel.template":[{"value":"SitePage_afterCancel","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.afterCancel.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.afterCancel.title":[{"value":"Membership canceled","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.afterCancel.widgets.offer.widget":[{"value":"UserOfferModelRelated_List","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.afterCancel.access":[{"value":1,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.title":[{"value":"Store","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.template":[{"value":"sitepage_storelist","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.widgets.storeList.widget":[{"value":"Store_List","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.widgets.storeCategories.widget":[{"value":"Store_Categories_Select","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.widgets.liveShowViewerHome.widget":[{"value":"LiveshowCounterBanner","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.widgets.liveShowViewerHome.embed.container":[{"value":".next-liveshow","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.widgets.liveShowViewerHome.embed.widget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.widgets.liveShowViewerHome.template":[{"value":"liveShowCounter","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeList.widgets.liveShowViewerHome.widgets.timer.embed.container":[{"value":".show-start-time","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.purchasesList.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.purchasesList.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.purchasesList.title":[{"value":"Store","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.purchasesList.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.purchasesList.template":[{"value":"sitepage_purchases","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.purchasesList.widgets.purchasesList.widget":[{"value":"Store_PurchasesList","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeItem.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeItem.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeItem.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeItem.title":[{"value":"Store","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeItem.template":[{"value":"div#store-content-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeItem.widgets.storeItem.widget":[{"value":"Store_Content","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.storeItem.dynamicTitle":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.login.widget":[{"value":"SitePage_Login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.login.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.login.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.login.title":[{"value":"Login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.login.access":[{"value":1,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.passwordRecovery.widget":[{"value":"SitePage_Passwordrecovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.passwordRecovery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.passwordRecovery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.passwordRecovery.title":[{"value":"Password Recovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.myfriends.widget":[{"value":"SitePage_MyFriends","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.myfriends.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.myfriends.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.myfriends.title":[{"value":"My Friends","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.myfriends.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widget":[{"value":"Layout_Affiliate","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliates.widget":[{"value":"SitePage_Affiliates","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliates.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliates.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliates.title":[{"value":"Affiliates","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliates.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliateAgreement.widget":[{"value":"SitePage_Affiliate","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliateAgreement.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliateAgreement.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliateAgreement.title":[{"value":"Affiliate Agreement","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.affiliate.widgets.affiliateAgreement.access":[{"value":3,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widget":[{"value":"Layout_Stateoff","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.siteUnderConstruction.widget":[{"value":"SitePage_SiteUnderConstruction","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.siteUnderConstruction.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.siteUnderConstruction.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.siteUnderConstruction.title":[{"value":"Site Under Construction","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.siteClosed.widget":[{"value":"SitePage_SiteClosed","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.siteClosed.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.siteClosed.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.siteClosed.title":[{"value":"Site Closed","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widget":[{"value":"SitePage_Passwordrecovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.title":[{"value":"Password Recovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.template":[{"value":"sitepage_stateoff_passwordRecovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.widget":[{"value":"User_PasswordRecovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.template":[{"value":"stateoff_passwordRecovery_form","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.container":[{"value":".loginform_container.forgotform_container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.widgets.emailForm.template":[{"value":"stateoff_passwordRecovery_form","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.widgets.emailForm.widgets.successPopup.widget":[{"value":"Dialog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.widgets.emailForm.widgets.successPopup.widgets.tipsPopupContainer.widgets.content.template":[{"value":"stateoff_popup_user_passwordRecoverySuccess","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.widgets.confirmationForm.template":[{"value":"stateoff_passwordRecovery_form_confirmation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.widgets.confirmationForm.widgets.successPopup.widget":[{"value":"Dialog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.passwordRecovery.widgets.confirmationForm.widgets.successPopup.widgets.tipsPopupContainer.widgets.content.template":[{"value":"stateoff_popup_user_passwordChangeSuccess","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.stateoff.widgets.passwordRecovery.widgets.socialAppsBlock.widget":[{"value":"Stateoff_SocialApps_Block","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widget":[{"value":"Layout_FreeHostedGallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedGallery.widget":[{"value":"SitePage_FreeHostedGallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedGallery.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedGallery.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedGallery.title":[{"value":"Free Hosted Gallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedGallery.widgets.fhg.widget":[{"value":"FreeHostedGallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedVideos.widget":[{"value":"SitePage_FreeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedVideos.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedVideos.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedVideos.title":[{"value":"Free Hosted Videos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedVideos.widgets.fhv.widget":[{"value":"FreeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedMixed.widget":[{"value":"SitePage_FreeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedMixed.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedMixed.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedMixed.title":[{"value":"Free Hosted Content","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.freeHostedGallery.widgets.freeHostedMixed.widgets.fhv.widget":[{"value":"FreeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.splash.widget":[{"value":"Splash","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.splash.group":[{"value":"pages","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.splash.active":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.widgets.splash.embed.container":[{"value":".wrapper","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.denied.passwordRecovery":[{"value":"guestsOnly","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.404":[{"value":"#home #404","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.2257":[{"value":"#home #2257","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.gallery\u002F:id(\u002F*tail)":[{"value":"#home #gallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.scene\u002F:id(\u002F*tail)":[{"value":"#home #scene","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.callme":[{"value":"#home #callme","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.cancellation":[{"value":"#home #cancellation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.success-canceled":[{"value":"#home #successCanceled","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.billing-contact":[{"value":"#home #billingContact","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.billingContact":[{"value":"\u003Ebilling-contact","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.sponsor":[{"value":"#home #sponsor","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.affiliate-agreement":[{"value":"#affiliate #affiliateAgreement","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.site-under-construction":[{"value":"#stateoff #siteUnderConstruction","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.after-cancel":[{"value":"\u003Eaccount","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.free-gallery\u002F:id\u002F:title(\u002Fphotos)":[{"value":"#freeHostedGallery #freeHostedGallery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.free-gallery\u002F:id\u002F:title\u002Fvideos":[{"value":"#freeHostedGallery #freeHostedVideos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.free-gallery\u002F:id\u002F:title\u002Fmixed":[{"value":"#freeHostedGallery #freeHostedMixed","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.successful-registration":[{"value":"#home #login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.home":[{"value":"#home #home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.videos":[{"value":"#home #videos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.about":[{"value":"#home #about","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.photosets":[{"value":"#home #photosets","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.bonus":[{"value":"#home #bonus","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.terms":[{"value":"#home #terms","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.privacy-policy":[{"value":"#home #privacy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.personal":[{"value":"#home #personal","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.cookie-policy":[{"value":"#home #cookie-policy","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.cookie-table":[{"value":"#home #cookie-table","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.forgot":[{"value":"#home #forgot","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.favorites":[{"value":"#home #favorites","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.conversation":[{"value":"#home #conversation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.liveshow":[{"value":"#home #liveshow","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.account":[{"value":"#home #account","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.blog":[{"value":"#home #blog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.post\u002F:id(\u002F:title)":[{"value":"#home #post","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.tips":[{"value":"#home #tips","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.affiliates":[{"value":"#affiliate #affiliates","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.affiliates(\u002F*tail)":[{"value":"#affiliate #affiliates","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.affiliateAgreement":[{"value":"#affiliate #affiliateAgreement","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.activity":[{"value":"#home #activity","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.login":[{"value":"#home #login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.password-recovery":[{"value":"#home #passwordRecovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.site-closed":[{"value":"#stateoff #siteClosed","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.splash":[{"value":"#splash","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.california-privacy-rights":[{"value":"#home #ccpa","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.routes.myfriends":[{"value":"#home #myfriends","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.special.404":[{"value":"404","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.special.home":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.special.guestsOnly":[{"value":"home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}],"mapMember.special.membersOnly":[{"value":"login","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101506},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Menu_Main":{"pattern.snapMe.position":[{"value":69,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Menu_Main","_fox_":1}],"pattern.snapMe.title":[{"value":"My FanCentro","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Menu_Main","_fox_":1}],"pattern.snapMe.target":[{"value":"_blank","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Menu_Main","_fox_":1}],"pattern.snapMe.checkers.snapMe.callback":[{"value":function (menuItem) {
var refCode = fox.getEnv('refCode');
if(!!refCode) {
menuItem.url = ['https://fancentro.com', 'r', refCode, fox.getEnv('scAlias')].join('/');
} else {
menuItem.url = ['https://fancentro.com', fox.getEnv('scAlias')].join('/');
}
return !fox.isEmpty(fox.getEnv('scAlias'));
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"~.Menu_Main","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.newMessageCount.widget":[{"value":"newMessageCountService","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"handleWom.newInboxMessage.widget":[{"value":"#newMessageCount","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root","_fox_":1}],"handleWom.newInboxMessage.event":[{"value":"newInboxMessage","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"@root","_fox_":1}],"handleWom.newInboxMessage.callback":[{"value":function (data) {
var dsn = this.wom1('#desktopNotifications');
var title = ['New message from', fox.getEnv('screenName')].join(' ');
if (!fox.isEmpty(fox.objectGet(data, 'data.attachments.collection'))) {
title = ['New message with private content from', fox.getEnv('screenName')].join(' ');
};
dsn.push(title, {
body: data.message,
icon: fox.getEnv('socialImage'),
notifyClick: function(){
fox.site.gotoPage('conversation');
}
}, true);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Scene #sceneViewer #currentScene #list":{"widgets.st.widget":[{"value":"Model_Backlinks","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Scene #sceneViewer #currentScene #list","_fox_":1}],"widgets.st.fireEventWidget":[{"value":"@parent @parent @parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"~.SitePage_Scene #sceneViewer #currentScene #list","_fox_":1}]},"~.MC_Photoset_Gallery #photoset #list":{"widgets.st.widget":[{"value":"Model_Backlinks","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101011},"path":"~.MC_Photoset_Gallery #photoset #list","_fox_":1}],"widgets.st.fireEventWidget":[{"value":"@parent @parent #dl","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101012},"path":"~.MC_Photoset_Gallery #photoset #list","_fox_":1}],"widgets.st.handleWom.traverseContentId.widget":[{"value":"@parent @parent #dl","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"~.MC_Photoset_Gallery #photoset #list","_fox_":1}],"widgets.st.handleWom.traverseContentId.event":[{"value":"loaded","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101015},"path":"~.MC_Photoset_Gallery #photoset #list","_fox_":1}],"widgets.st.handleWom.traverseContentId.callback":[{"value":function (params, dl) {
var contentId = dl.getObjectValue('id');
if (contentId) {
dl.dispatchEvent('setContentId', contentId);
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":"~.MC_Photoset_Gallery #photoset #list","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.NewsLetterSubscriber":{"removeDelay":[{"value":500,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.NewsLetterSubscriber","_fox_":1}],"hooks.onBeforeBlockRemove":[{"value":function () {
var $wrp = $(this.dom1('.nsl-wrapper'));
$wrp.addClass('removed');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"~.NewsLetterSubscriber","_fox_":1}]},"~.SitePage_Home":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101011},"path":"~.SitePage_Home","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101012},"path":"~.SitePage_Home","_fox_":1}]},"~.SitePage_Videos":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101016},"path":"~.SitePage_Videos","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"~.SitePage_Videos","_fox_":1}]},"~.SitePage_Photosets":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101022},"path":"~.SitePage_Photosets","_fox_":1}]},"~.SitePage_About":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101026},"path":"~.SitePage_About","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101027},"path":"~.SitePage_About","_fox_":1}]},"~.Site_Page#activity":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101031},"path":"~.Site_Page#activity","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101032},"path":"~.Site_Page#activity","_fox_":1}]},"~.SitePage_Blog":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101036},"path":"~.SitePage_Blog","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101037},"path":"~.SitePage_Blog","_fox_":1}]},"~.SitePage_Tips":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":"~.SitePage_Tips","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101042},"path":"~.SitePage_Tips","_fox_":1}]},"~.SitePage_Scene":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101046},"path":"~.SitePage_Scene","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101047},"path":"~.SitePage_Scene","_fox_":1}]},"~.Layout_Home #gallery":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101051},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101052},"path":"~.Layout_Home #gallery","_fox_":1}]},"~.SitePage_Post":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":"~.SitePage_Post","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101057},"path":"~.SitePage_Post","_fox_":1}]},"~.SitePage_Liveshow":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101061},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101062},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.widget":[{"value":"Content_Report","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101064},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.template":[{"value":"content_report","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101065},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.additionalPopupClass":[{"value":"dlg-amc dark-overlay mc-site-popup content-report-popup mc-site-common-popup mc-site-popup-bg","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101066},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.widgets.reportPopup.dialog.width":[{"value":"525px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101069},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.widgets.reportPopup.dialog.buttons":[{"value":[],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101070},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.handleDom.submitReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101072},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.handleDom.cancelReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101073},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.handleDom.close.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101075},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.handleDom.close.target":[{"value":".close","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101076},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.handleDom.close.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101077},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.reportContent.handleDom.close.callback":[{"value":"cancelReportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101079},"path":"~.SitePage_Liveshow","_fox_":1}]},"~.SitePage_SiteUnderConstruction":{"widgets.newsletter.widget":[{"value":"NewsLetterSubscriber","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101083},"path":"~.SitePage_SiteUnderConstruction","_fox_":1}],"widgets.newsletter.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101084},"path":"~.SitePage_SiteUnderConstruction","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.userOffer.widget":[{"value":"UserOffer","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Site_Page":{"hooks.onSetPageOptions":[{"value":function (argument) {
var st, pt, description, keywords, title,
excludeTitlePrefix = this.getOption('excludeTitlePrefix');
if (!this.getOption('dynamicTitle') && !!fox.site.dl) {
st = fox.site.dl.getObjectValue('title') || 'MC';
pt = this.getOption('title');
document.title = ((excludeTitlePrefix === true) ? pt : (st + (pt ? ' | ' + pt : '')));
(description = document.querySelector('meta[name="description"]')) &&
description.setAttribute('content', this.getOption('description'));
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"~.Site_Page","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_Home":{"widgets.passRetrievSuccess.widget":[{"value":"Popup_Common","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Layout_Home","_fox_":1}],"widgets.passRetrievSuccess.dialog.width":[{"value":"345px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Layout_Home","_fox_":1}],"widgets.passRetrievSuccess.widgets.content.template":[{"value":"popup_user_passwordRecoverySuccess","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Layout_Home","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Content_Html5Player":{"widgets.controls.widgets.startBanner.widget":[{"value":"Html5Player_MC_Banner","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.Content_Html5Player","_fox_":1}],"widgets.controls.widgets.stopBanner.widget":[{"value":"Html5Player_MC_Banner","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Content_Html5Player","_fox_":1}],"widgets.controls.widgets.stopBanner.component":[{"value":"stopbanner","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Content_Html5Player","_fox_":1}],"widgets.controls.widgets.stopBanner.cName":[{"value":"ac-p-stop-banner","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Content_Html5Player","_fox_":1}],"widgets.controls.widgets.endBanner.widget":[{"value":"Html5Player_MC_Banner","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Content_Html5Player","_fox_":1}],"widgets.controls.widgets.endBanner.component":[{"value":"endbanner","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"~.Content_Html5Player","_fox_":1}],"widgets.controls.widgets.endBanner.cName":[{"value":"ac-p-end-banner","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101008},"path":"~.Content_Html5Player","_fox_":1}]},"~.WelcomeBanner #video ~.Html5Player_MC_Banner":{"useSimpleBanner":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101012},"path":"~.WelcomeBanner #video ~.Html5Player_MC_Banner","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Scene":{"widgets.sceneViewer.widgets.currentRating.handleDom.rate.eventChecker":[{"value":function (argument) {
return fox.site.member ? true : false;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101008},"path":"~.SitePage_Scene","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #home":{"storeLoader":[{"value":function () {
return new fox.RSVP.Promise(function (resolve) {
var pm = fox.site.wom1('@root .PermissionManager');
if (fox.getEnv('store.enabled') || !fox.isEmpty(pm.getMemberInfo('hasPurchasedProducts'))) {
return __webpack_require__.e/* require.ensure */(1).then((function () {
return resolve(__webpack_require__(1285)(fox));
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}
return resolve(true);
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101012},"path":"@root #home","_fox_":1}]},"~.Site_Page#storeList":{"$requireResources":[{"value":"@root #home:storeLoader","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"~.Site_Page#storeList","_fox_":1}]},"~.Site_Page#purchasesList":{"$requireResources":[{"value":"@root #home:storeLoader","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101016},"path":"~.Site_Page#purchasesList","_fox_":1}]},"~.Site_Page#storeItem":{"$requireResources":[{"value":"@root #home:storeLoader","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"~.Site_Page#storeItem","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #router":{"hooks.onStartExecute":[{"value":function() {
var siteState = fox.getEnv('siteProps.stateAlias');
var member = fox.site.wom1('.PermissionManager').getMemberInfo();
var previewMode = __webpack_require__(33)();
if (siteState && !previewMode) {
if (!fox.isEmpty(member)) {
return true;
}
switch(siteState) {
case 'closed':
if (fox.isEmpty(member) && this._passedRoute.path != 'site-closed') {
if (this._passedRoute.path.match('password-recovery')) {
return true;
} else {
fox.Router.navigate('site-closed');
return false;
}
}
break;
case 'underConstruction':
if (this._passedRoute.path != 'site-under-construction') {
fox.Router.navigate('site-under-construction');
return false;
}
break;
}
}
if (!fox.isSet(fox.site.showSplash)) {
fox.site.showSplash = window.parseInt(fox.getEnv('siteProps.splashEnabled'))
&& !fox.site.member
&& !fox.cookie.get('splash');
}
if (fox.site.showSplash && previewMode) {
fox.cookie.set('splash', 'off');
fox.site.showSplash = false;
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101039},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Router":{"routes.@":[{"value":"#home #home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Router","_fox_":1}],"routes.@miss":[{"value":"#home #404","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Router","_fox_":1}],"routes.@join":[{"value":"#join #join","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_About":{"widgets.aboutMe.widgets.socialApps.widget":[{"value":"SocialApps","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_About","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Account":{"widgets.support.widget":[{"value":"BillingSupport_Support","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.SitePage_Account","_fox_":1}],"widgets.userNotificationsManager.widget":[{"value":"UserNotificationsManager","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.SitePage_Account","_fox_":1}],"widgets.userProfile.widget":[{"value":"UserProfile","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"~.SitePage_Account","_fox_":1}],"widgets.userPersonalData.widget":[{"value":"UserPersonalData","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101009},"path":"~.SitePage_Account","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Account #settingsForm":{"hooks.onPrepareValues":[{"value":function () {
fox.each(this._values, function (v, k) {
this._preparedValues[k] = fox.trim(v);
}, this);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Account #settingsForm","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Conversation":{"dontReuseSn":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.conversationViewer.widget":[{"value":"ConversationViewer","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.widget":[{"value":"Content_Report","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.template":[{"value":"content_report_icon","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.additionalPopupClass":[{"value":"dlg-amc dark-overlay mc-site-popup content-report-popup mc-site-common-popup mc-site-popup-bg","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101008},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.prefixPopup":[{"value":"con","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101009},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.widgets.reportPopup.dialog.width":[{"value":"525px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101012},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.widgets.reportPopup.dialog.buttons":[{"value":[],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101013},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.handleDom.submitReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101015},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.handleDom.cancelReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101016},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.handleDom.close.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.handleDom.close.target":[{"value":".close","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101019},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.handleDom.close.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101020},"path":"~.SitePage_Conversation","_fox_":1}],"widgets.reportContent.handleDom.close.callback":[{"value":"cancelReportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":"~.SitePage_Conversation","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Liveshow":{"widgets.tipme.widget":[{"value":"Content_Tipme","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.tipme.embed.container":[{"value":"#tipme-form","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Liveshow","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Login":{"widgets.loginForm.hooks.onReport":[{"value":function (response) {
fox.wom.selectFirst('~.Site_Footer').reportProblem();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Login","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_MyFriends":{"widgets.myFriends.widget":[{"value":"BlogViewer","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.template":[{"value":"myfriends_container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.embed.container":[{"value":"#myfriends-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.widgets.dl.limit":[{"value":50,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101009},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.widgets.dl.filter.tags.fields":[{"value":["~tags.title"],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101011},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.widgets.dl.filter.tags.values":[{"value":["%myfriends%"],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101012},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.list.tpl.row":[{"value":"myfriends_list_item","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.list.embed.container":[{"value":"#myfriends-list","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101015},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.pager.widget":[{"value":"Pager_Simple","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.pager.container":[{"value":".pager-wrapper","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.pager.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101019},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.pager.pagesCount":[{"value":4,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101020},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.pager.logged.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.pager.logged.pagesCount":[{"value":5,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101022},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.pager.noScroll":[{"value":false,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101023},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.pager.addHrefAttribute":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101024},"path":"~.SitePage_MyFriends","_fox_":1}],"widgets.myFriends.pager.navigatorPrefix":[{"value":"blog_page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101026},"path":"~.SitePage_MyFriends","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.PostViewer #dl":{"hooks.onStartPrepareResponse":[{"value":function (res) {
if (fox.isArray(res) && res.length === 0) {
fox.Router.navigate('restricted');
return false;
}
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101008},"path":"~.PostViewer #dl","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Scene #sceneViewer #downloadLinks":{"handleDom.logDownload.target":[{"value":"li","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.SitePage_Scene #sceneViewer #downloadLinks","_fox_":1}],"handleDom.logDownload.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Scene #sceneViewer #downloadLinks","_fox_":1}],"handleDom.logDownload.callback":[{"value":function (el, alias, scope) {
var api = this.getApi('loggerApi', {
method: 'logger.log'
});
api.send({
index: 'McUserActivity',
path: fox.Navigator.getAll(),
info: {event: 'download'}
}, false);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"~.SitePage_Scene #sceneViewer #downloadLinks","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme .Dialog #tipsPopupContainer":{"template":[{"value":"stateoff_tips_popup_container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101006},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme .Dialog #tipsPopupContainer","_fox_":1}]},"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #confirmPopup":{"dialog.dialogClass":[{"value":"stateoff-dialog mc-site-common-popup","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101008},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #confirmPopup","_fox_":1}],"dialog.width":[{"value":"320px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101009},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #confirmPopup","_fox_":1}]},"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #confirmPopup #tipsPopupContainer #content":{"template":[{"value":"stateoff_content_tipme_confirm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101012},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #confirmPopup #tipsPopupContainer #content","_fox_":1}]},"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #successPopup":{"dialog.dialogClass":[{"value":"stateoff-dialog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101014},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #successPopup","_fox_":1}],"dialog.width":[{"value":"320px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101015},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #successPopup","_fox_":1}]},"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #successPopup #tipsPopupContainer #content":{"template":[{"value":"stateoff_tips_popup_thanks","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101018},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #successPopup #tipsPopupContainer #content","_fox_":1}]},"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #errorPopup":{"dialog.dialogClass":[{"value":"stateoff-dialog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101020},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #errorPopup","_fox_":1}],"dialog.width":[{"value":"320px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101021},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #errorPopup","_fox_":1}]},"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #errorPopup #tipsPopupContainer #content":{"template":[{"value":"stateoff_tips_popup_wrong","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101024},"path":"~.SitePage_SiteUnderConstruction #tipmeBlock #tipme #errorPopup #tipsPopupContainer #content","_fox_":1}]},"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog":{"template":[{"value":"","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101028},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"dialog.closeText":[{"value":"","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101030},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"dialog.dialogClass":[{"value":"stateoff-dialog","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101031},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"dialog.width":[{"value":"320px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101032},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101034},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101035},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.template":[{"value":"popup_container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101036},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.handleDom.close.target":[{"value":".close","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101038},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.handleDom.close.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101039},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.handleDom.close.callback":[{"value":"@parent:hide","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101040},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.widgets.content.widget":[{"value":"Widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101042},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.widgets.content.container":[{"value":"#popup-widget-container","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101043},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.widgets.content.autoRender":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101044},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.widgets.content.handleDom.close.target":[{"value":".close","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101046},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.widgets.content.handleDom.close.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101047},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}],"widgets.tipsPopupContainer.widgets.content.handleDom.close.callback":[{"value":"@parent @parent:hide","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101048},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~.Dialog","_fox_":1}]},"~.Layout_Stateoff .SitePage_Passwordrecovery ~#confirmationForm #successPopup #tipsPopupContainer #content":{"handleDom.close.target":[{"value":".close","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101052},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~#confirmationForm #successPopup #tipsPopupContainer #content","_fox_":1}],"handleDom.close.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101053},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~#confirmationForm #successPopup #tipsPopupContainer #content","_fox_":1}],"handleDom.close.callback":[{"value":function () {
fox.Navigator.update({ 0: '' }, true);
window.location.reload();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101057},"path":"~.Layout_Stateoff .SitePage_Passwordrecovery ~#confirmationForm #successPopup #tipsPopupContainer #content","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Login ~#loginForm":{"hooks.onStartRendering":[{"value":function () {
if (fox.Navigator.get(0) === 'successful-registration') {
this.setTemplateOptions('successfulRegistration', true);
}
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"~.SitePage_Login ~#loginForm","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Social_Rating":{"handleDom.rate.callback":[{"value":function (elt) {
if (fox.site.member) return this.rateDomHandler(elt);
if (!isNaN(parseInt(elt.getAttribute('data-target-id')))) return this.rateDomHandler(elt);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Social_Rating","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #home":{"hooks.onAddedToDom":[{"value":function() {
if (fox.site.showSplash) {
var splash = fox.site.embedWidget('splash', 'Splash');
splash.activate();
splash.run();
var players = fox.site.wom('~.Content_Html5Player');
players.forEach(function (player, i) {
player.setOption('html5PlayerConfig.movie.autoplay', false);
})
}
__webpack_require__(682)(fox);
this.embedWidget('valentinesGiftsPopup', 'ValentinesGiftsPopup').run();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"@root #home","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	"use strict";
	__webpack_require__(683);
	//require('./stylus/_valentines.styl');
	__webpack_require__(691)(fox);

	__webpack_require__(695)(fox);
};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(684);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize!../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../node_modules/stylus-loader/index.js??ref--6-3!./_valentines-popup.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize!../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../node_modules/stylus-loader/index.js??ref--6-3!./_valentines-popup.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:Arvo;src:url(" + __webpack_require__(58) + ");src:url(" + __webpack_require__(58) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(685) + ") format(\"woff2\"),url(" + __webpack_require__(686) + ") format(\"woff\"),url(" + __webpack_require__(687) + ") format(\"truetype\");font-weight:400;font-style:normal}#valentines-gifts-popup{position:relative;z-index:15}#valentines-gifts-popup .valentines-gift-popup{background-color:#212023!important}#valentines-gifts-popup .valentines-gift-popup .giftbox-wrapper{margin:0}#valentines-gifts-popup .valentines-gift-popup .gift-list .gift-item{box-sizing:border-box}#valentines-gifts-popup .valentines-gift-popup .gift-list .gift-item.active .gift-item-price,#valentines-gifts-popup .valentines-gift-popup .gift-list .gift-item :active .gift-item-price,#valentines-gifts-popup .valentines-gift-popup .gift-list .gift-item:hover .gift-item-price{border-color:#fff!important;color:#fff}#valentines-gifts-popup .valentines-gift-popup .gift-list .gift-item:before{background-color:#252428;top:11px;left:11px;width:64px;height:64px}#valentines-gifts-popup .valentines-gift-popup .gift-list .gift-item .gift-icon{width:82px}#valentines-gifts-popup .valentines-gift-popup .popup-footer-wrapper{margin:0 20px}#valentines-gifts-popup .valentines-gift-popup .popup-footer-wrapper textarea{border-radius:2px;font-size:12px;height:16px;resize:none;width:100%;box-sizing:content-box;font-family:arial;border:1px solid hsla(0,0%,100%,.149);color:#fff;padding:9px 5px 8px;background-color:transparent}#valentines-gifts-popup .valentines-gift-popup ._flex{display:-moz-flex;display:-ms-flexbox;display:flex}#valentines-gifts-popup .valentines-gift-popup .gift-billing-hint{color:#fff;font-size:10px;line-height:10px;text-align:left;padding:6px 0}#valentines-gifts-popup .valentines-gift-popup .gift-billing-hint strong{font-style:normal}#valentines-gifts-popup .gift-list-container.blur .giftbox-wrapper,#valentines-gifts-popup .gift-list-container.blur .popup-footer-wrapper{filter:blur(4px)}#valentines-gifts-popup ._mCS_2 .mCSB_dragger .mCSB_dragger_bar,#valentines-gifts-popup .mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,#valentines-gifts-popup .mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:hsla(0,0%,100%,.25)}#valentines-gifts-popup .mCSB_scrollTools .mCSB_draggerRail{background-color:hsla(0,0%,100%,.05)}#valentines-gifts-popup .gift-comment{color:hsla(0,0%,100%,.3);font-size:10px}#valentines-gifts-popup .mc-common-button{font-family:Arial;border-radius:4px;text-transform:uppercase;min-width:60px;font-size:12px;margin:0 0 0 10px;display:block;padding:0!important;font-weight:700;width:60px;letter-spacing:normal;background-color:#fff!important;height:34px!important;color:#262428!important}#valentines-gifts-popup .mc-common-button.spin{width:100px;padding-left:20px!important}#valentines-gifts-popup .mc-common-button:before{background-image:url(" + __webpack_require__(59) + ")}#valentines-gifts-popup .blurred,#valentines-gifts-popup .gift_purchase_guest{position:absolute;z-index:10;background:rgba(0,0,0,.65);height:100%;width:100%}#valentines-gifts-popup .blurred{display:none}#valentines-gifts-popup .blurred .congrats{font-size:0;transition:font-size .4s;padding:20px;text-align:center;color:#fff;padding-top:70px}#valentines-gifts-popup .blurred .congrats a{color:#9133ac;text-decoration:none;cursor:pointer}#valentines-gifts-popup .blurred .congrats.show{font-size:16px}#valentines-gifts-popup .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#9a9a9a}#valentines-gifts-popup .mCSB_scrollTools.mCSB_scrollTools_horizontal{height:10px}#valentines-gifts-popup ._mCS_2 .mCSB_dragger .mCSB_dragger_bar,#valentines-gifts-popup .mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,#valentines-gifts-popup .mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#c4c4c4}#valentines-gifts-popup .mCSB_scrollTools.mCSB_scrollTools_vertical .mCSB_draggerRail{width:3px}#valentines-gifts-popup .mCSB_horizontal.mCSB_inside>.mCSB_container{margin-bottom:15px}#valentines-gifts-popup .mCSB_inside>.mCSB_container{margin-right:18px}.rabbit{display:none}.rabbit_m{display:block}.gift_purchase_guest{height:100%}.gift_purchase_guest .title{font-family:Arvo;font-size:16px;color:#fff;font-weight:700;text-align:center;padding-top:50px;padding-bottom:30px;text-transform:uppercase}.gift_purchase_guest .gift-input{border:1px solid #d2d2d2;margin-bottom:25px;max-width:290px;height:30px;color:#000;margin:0 auto;border-radius:4px;overflow:hidden;transition:border-color .2s;position:relative}.gift_purchase_guest .gift-input input{width:100%;height:100%;color:rgba(0,0,0,.502);background-color:#fff;font-size:12px;font-family:arial;font-style:italic;position:relative;border:none;display:block;z-index:2;padding:0 5px 0 10px;transition:color .2s}.gift_purchase_guest .msg-block{max-width:300px;margin:0 auto}.gift_purchase_guest .error-message{font-family:arial;font-size:10px;color:#ab5252;margin:5px 5px 9px;height:12px;line-height:12px;visibility:hidden}.gift_purchase_guest .blurred+.giftbox-wrapper,.gift_purchase_guest .blurred+.giftbox-wrapper+.popup-footer-wrapper{filter:blur(3px)}.gift_purchase_guest .button{float:right;margin-right:5px;background-color:transparent}.gift_purchase_guest .row{margin:0}.gift_purchase_guest .row.error .common-input{border:1px solid #ab5252}.gift_purchase_guest .row.error .common-input input{color:#ab5252}.gift_purchase_guest .row.error .error-message{visibility:visible}@media (max-width:767px){.valentines-gift-popup{-webkit-text-size-adjust:none;max-width:100%;width:100vw;position:fixed;top:100%;right:0;height:245px;width:100%;margin-top:-245px;background-color:#fff;z-index:20;transform:translateY(245px);transition:transform .5s;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row}.valentines-gift-popup .popup-title-wrapper{background-image:url(" + __webpack_require__(689) + ");background-color:#9133ac}.valentines-gift-popup .popup-title-wrapper .giftbox-wrapper{display:none}.valentines-gift-popup .popup-title-wrapper .title-text{height:38px;margin:0}.valentines-gift-popup.opened{transform:translateY(0)}.valentines-gift-popup.opened .popup-title-wrapper .giftbox-wrapper,.valentines-gift-popup.opened .popup-title-wrapper .popup-title-wrapper .text-img{display:block}.valentines-gift-popup.opened .popup-title-wrapper{background-color:#9133ac}.valentines-gift-popup.opened .popup-title-wrapper img.text{width:185px;height:22px;top:5px;left:calc(50% - 92px)}.valentines-gift-popup.opened .popup-title-wrapper .cupid{transform:scale(1) rotateY(0);left:calc(50% - 42px)}.valentines-gift-popup.opened .popup-title-wrapper .cupid:before{content:\"+\";border:1px solid #fff;height:17px;width:17px;display:-ms-flexbox;display:flex;border-radius:50%;right:-8px;top:-15px;line-height:16px;font-size:28px;transform:rotate(45deg);-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;position:absolute;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;box-shadow:0 0 1px 0 rgba(0,0,0,.75);text-shadow:0 0 1px rgba(0,0,0,.75)}.valentines-gift-popup .popup-title-wrapper{width:100%;cursor:pointer;height:40px}.valentines-gift-popup .popup-title-wrapper .text-img{width:133px;height:22px;top:10px;left:calc(50% - 66px);position:absolute;min-height:inherit}.valentines-gift-popup .popup-title-wrapper:after{right:10px}.valentines-gift-popup .popup-title-wrapper:before{left:10px;transform:rotateY(180deg)}.valentines-gift-popup .popup-title-wrapper .cupid{width:84px;position:absolute;left:4px;top:-50px;transform:scale(.78) rotateY(180deg);transition:all .5s;z-index:20}.valentines-gift-popup .giftbox-wrapper{margin:15px 20px 5px}.valentines-gift-popup .gift-list-container{width:100vw}.valentines-gift-popup .gift-list-container .gift-list{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;height:90px;width:1104px;margin:10px 0 0}.valentines-gift-popup .gift-list-container .gift-list .gift-item{display:block}.gift_purchase_guest .title{padding-top:16px;padding-bottom:20px}}@media (min-width:767px){.valentines-gift-popup{position:fixed;top:50%;right:0;height:316px;width:399px;margin-top:-158px;background-color:#fff;z-index:20;transform:translateX(399px);transition:transform .5s;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.valentines-gift-popup.opened{transform:translatex(0);box-shadow:1px 0 1px 0 rgba(0,0,0,.2)}.valentines-gift-popup.opened .popup-title-wrapper{left:-40px}.valentines-gift-popup.opened .popup-title-wrapper .cupid{left:-16px}.valentines-gift-popup .popup-title-wrapper{position:absolute;left:-3px;top:0;bottom:0;width:43px;background-repeat:no-repeat;cursor:pointer;background-image:url(" + __webpack_require__(690) + ");background-size:contain}.valentines-gift-popup .popup-title-wrapper .title-text{transform:rotate(-90deg);white-space:nowrap;height:316px;margin:0}.valentines-gift-popup .popup-title-wrapper .cupid{width:74px;height:54px;position:absolute;left:-50px;bottom:-20px;z-index:20}.valentines-gift-popup .popup-title-wrapper .cupid img{max-width:100%}.valentines-gift-popup .popup-title-wrapper .text-img{display:none}.valentines-gift-popup .giftbox-wrapper{height:205px}.valentines-gift-popup .gift-list-container .gift-list{width:385px}.valentines-gift-popup .gift-billing-hint{border-top:1px solid hsla(0,0%,100%,.149)}.valentines-gift-popup .blurred{height:calc(100% - 15px)}.valentines-gift-popup .blurred .congrats{padding-top:100px}.valentines-gift-popup .blurred .congrats.show{font-size:20px}.rabbit_m{display:none}.rabbit{display:block}}@media (min-width:1025px){.valentines-gift-popup .popup-title-wrapper{left:-40px}.valentines-gift-popup .popup-title-wrapper .cupid{left:-16px}.valentines-gift-popup.opened .popup-title-wrapper{left:-40px}}", ""]);

// exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/valentines-gifts-popup/fonts/arvo-bold-webfont.woff2", __webpack_require__.p + "_/_/_/root/components/valentines-gifts-popup/fonts/3p73Hh6.woff2");

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/valentines-gifts-popup/fonts/arvo-bold-webfont.woff", __webpack_require__.p + "_/_/_/root/components/valentines-gifts-popup/fonts/3SgqS77.woff");

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/valentines-gifts-popup/fonts/arvo-bold-webfont.ttf", __webpack_require__.p + "_/_/_/root/components/valentines-gifts-popup/fonts/1ndb6ip.ttf");

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/sprite-small-preloader-blue.png", __webpack_require__.p + "images/sprite-small-preloader-blue.png");

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/valentines-gifts-popup/images/gifts-bg.png", __webpack_require__.p + "_/_/_/root/components/valentines-gifts-popup/images/gifts-bg.png");

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/valentines-gifts-popup/images/title-bg-v.png", __webpack_require__.p + "_/_/_/root/components/valentines-gifts-popup/images/title-bg-v.png");

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_gifts_popup", [["div",{"class":"valentines-gift-popup"},[["div",{"class":"gift-list-container"}]]]]);
fox.registerTemplate("gifts__list_row", [["if",{"empty":""},[["span",{"data-gid":"","class":"gift-item"},[["span",{"class":"gift-icon &&0&&"},[],[["alias","class"]]],["textNode",{"text":" "}],["strong",{"class":"gift-item-price"},[["textNode",{"text":"$"}],["span",{},[],[["price","__text",true]]]]]],[["id","data-gid",true]]],["else",{},[["span",{"class":"loading-gifts ls-title"},[["textNode",{"text":"loading gifts..."}]]]]]],[["loader","empty",true]]]]);
fox.registerTemplate("layout_gifts_container", [["div",{"class":"popup-title-wrapper"},[["img",{"src":"" + __webpack_require__(692) + "","class":"text-img","alt":"Spoil me"}],["textNode",{"text":" "}],["span",{"class":"cupid"},[["img",{"src":"" + __webpack_require__(693) + "","class":"rabbit","alt":"Spoil me"}],["textNode",{"text":" "}],["img",{"src":"" + __webpack_require__(694) + "","class":"rabbit_m","alt":"Spoil me"}]]]]],["div",{},[["div",{"class":"giftbox-guest-form"}],["div",{"class":"blurred"},[["div",{"class":"congrats"},[["if",{"notempty":""},[["textNode",{"text":" Your gift was successfully sent. You can view it in the chat with the model "}],["a",{"href":"/conversation"},[["textNode",{"text":"here"}]]],["else",{},[["textNode",{"text":" Your gift was successfully sent. "}]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]]]]]],["div",{"class":"giftbox-wrapper popup-content-wrapper"},[["div",{"id":"gift-list-container","class":"gift-list"}]]],["div",{"class":"popup-footer-wrapper"},[["div",{"class":"gift-billing-hint"},[["strong",{},[["textNode",{"text":"Attention!"}]]],["textNode",{"text":" Gifts are billed individually to your credit card. "}]]],["span",{"class":"gift-comment"},[["textNode",{"text":"You can add a comment to your gift"}]]],["div",{"class":"_flex"},[["textarea",{"name":"gift_message","placeholder":"I admire you!"},[["textNode",{"text":"I admire you!"}]]],["textNode",{"text":" "}],["button",{"id":"send-gift","class":"mc-common-button"},[["textNode",{"text":"Send"}]]]]]]]]]]);
fox.registerTemplate("gift_purchase_guest", [["div",{"class":"gift_purchase_guest"},[["div",{"class":"msg-block"},[["div",{"class":"title"},[["textNode",{"text":" You are just one step away! "}]]],["form",{"id":"gift-reg-form"},[["div",{"id":"message","class":"reg-error"}],["div",{"class":"row"},[["div",{"class":"gift-input"},[["input",{"type":"text","name":"login","placeholder":"Choose username","autofocus":"","required":""}]]],["div",{"class":"error-message"}]]],["div",{"class":"row"},[["div",{"class":"gift-input"},[["input",{"type":"email","name":"email","placeholder":"Your email","required":""}]]],["div",{"class":"error-message"}]]],["div",{"class":"button"},[["button",{"id":"gift-login","class":"mc-common-button"},[["textNode",{"text":"Send"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/valentines-gifts-popup/images/default/text.png", __webpack_require__.p + "_/_/_/root/components/valentines-gifts-popup/images/default/text.png");

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/valentines-gifts-popup/images/default/gifts.png", __webpack_require__.p + "_/_/_/root/components/valentines-gifts-popup/images/default/gifts.png");

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/valentines-gifts-popup/images/default/gifts-m.png", __webpack_require__.p + "_/_/_/root/components/valentines-gifts-popup/images/default/gifts-m.png");

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = function (fox) {
	'use strict';

	var $ = fox.jQuery;

	fox.registerWidget('ValentinesGiftsPopup', {
		configure: function () {
			this.registerOptions('', {
				autoRender: false,
				manualRende: true,
				'embed.container': '#valentines-gifts-popup',
				template: 'layout_gifts_popup',
				widgets: {
					giftBoxBody: {
						widget: 'Giftbox',
						autoRender: true,
						giftType: 'default',
						giftPaymentSuccess: 'inboxSocketEventConversation:giftUnlock',
						'embed.container': '.gift-list-container',
						template: 'layout_gifts_container',
						targetIdCb: function () {
							return fox.getEnv('site.conversationId');
						},
						userRegistration: function () {
							var giftBox = this.wom1('#giftBoxBody');
							var purchaseGuest = giftBox.wom1('#purchaseGuest');
							var guestForm = purchaseGuest.wom1('#regForm');

							purchaseGuest.render();
							$(purchaseGuest.getOption('embed.container')).show();

							var elt = fox.dom.selectFirst('.gift-list-container');
							fox.dom.addClass('blur', elt);

							return new fox.Promise(function (resolve) {
								this.__resolver = resolve;
							}.bind(this)).then(function (result) {
								this.__resolver = null;
								return result;
							}.bind(this)).catch(function (error) {
								this.__resolver = null;
								throw error;
							}.bind(this));
						}.bind(this),

						showUnchecked: function() {
							var button = document.querySelector('#send-gift');
							var giftBoxBody = fox.site.wom1('~.ValentinesGiftsPopup #giftBoxBody');
							var toggleButton = function () {
								button.disabled = !button.disabled;
							};
							toggleButton();
							setTimeout(toggleButton, 450)

							document.querySelectorAll('[data-gid]').forEach(function (el, i) {
								var togglePrice = function() {
									giftBoxBody = fox.site.wom1('~.ValentinesGiftsPopup #giftBoxBody');
									giftBoxBody.checkGiftMultiple(el);
								}
								togglePrice();
								setTimeout(togglePrice, 400)
							}.bind(this))
						},

						widgets: {
							giftboxList: {
								'tpl.row': 'gifts__list_row',
							},
							purchaseGuest: {
								widget: 'Widget',
								template: 'gift_purchase_guest',
								'embed.container': '.giftbox-guest-form',
								autoRender: false,
								widgets: {
									regForm: {
										widget: 'DomForm',
										formSelector: '#gift-reg-form'
									}
								},
								'handleWom.formInvalidate': {
									event: ['form_not_valid', 'form_valid'],
									widget: '#regForm',
									callback: function (info) {
										info.forEach(function (inf) {
											if (inf.result === false) {
												this.showError(inf.field);
											} else {
												this.hideError(inf.field);
											}
										}.bind(this))

									}.bind(this)
								},
								'handleDom.submit': {
									event: 'click',
									target: '#gift-login',
									callback: this.onSubmit.bind(this)
								},

								'handleDom.focus': {
									target: 'input',
									event: 'focus',
									callback: function (el, alias, scope, event) {
										event.preventDefault();
										event.stopPropagation();
										var errorEl = el.closest('.error');
										fox.dom.removeClass('error', errorEl);
									}
								}
							}
						},
						'hooks.onPrepareParams': function (params) {
							var elt = this.wom1('#giftBoxBody').dom1('[name="gift_message"]');
							var msg = elt.value;
							var blurred = $('#valentines-gifts-popup .blurred');
							blurred.show();
							if (msg) {
								params.message = msg;
							} else {
								params.message = elt.getAttributeNode('placeholder').value
							}
						}.bind(this)
					}
				},
				handleDom: {
					toggle: {
						targetWidget: '#giftBoxBody',
						target: '.popup-title-wrapper',
						callback: 'toggle'
					}
				},

				handleWom: {
					giftsAvailable: {
						widget: '#giftBoxBody',
						event: 'giftsAvailable',
						callback: 'render'
					},
					giftSended: {
						event: 'giftPaid',
						widget: '#giftBoxBody',
						callback: 'giftPaid'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.isOpened = false;
			this.ga = fox.wom.selectFirst('@root #googleAnalytics');
			this.callParent('init', arguments);
		},
		toggle: function () {
			this[(this.isOpened ? 'hide' : 'show')]();
		},

		hide: function () {
			var elm = this.dom1('.valentines-gift-popup');
			this.isOpened = false;
			fox.dom.removeClass('opened', elm);
			fox.dom.removeClass('open', elm.parentNode);
			
			$('#valentines-gifts-popup .blurred').hide();
		},

		show: function () {
			var wrapper = $('#valentines-gifts-popup .giftbox-wrapper');
			var asix = (window.innerWidth < 768) ? 'x' : 'y';
			wrapper.mCustomScrollbar('destroy');
			wrapper.mCustomScrollbar({
				axis: asix
			});
			
			this.guestFormRemove();

			var giftBoxBody = this.wom1('#giftBoxBody');
			var elm = this.dom1('.valentines-gift-popup');

			var checkedGift = giftBoxBody.checkedGifts;
			if (!fox.isEmpty(checkedGift)) {
				var checkedElt = document.querySelector('[data-gid="' + checkedGift[0]+'"]');
				giftBoxBody.checkGiftSingle(checkedElt);
			}

			this.isOpened = true;
			var eventCategory = this.isGuest() ? 'RevenueGuest' : 'RevenueMember';
			this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: eventCategory, eventAction: 'OpenWidget' });
			
			fox.dom.addClass('opened', elm);
			fox.dom.addClass('open', elm.parentNode);
		},

		giftPaid: function () {
			var eventCategory = this.isGuest() ? 'RevenueGuest' : 'RevenueMember';
			this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: eventCategory, eventAction: 'SuccessfulPurchase' });
			var congrats = $('#valentines-gifts-popup .congrats');
			var blurred = $('#valentines-gifts-popup .blurred');
			congrats.addClass('show');
			var t = setTimeout(this.render.bind(this), 5000);
		},

		isGuest: function(){
			var pm = fox.site.wom1('.PermissionManager');
			return (pm.hasAccess('guest') && fox.isEmpty(pm.getMemberInfo())) ? true : false;
		},

		onSubmit: function (button, alias, scope, event) {
			var purchaseGuest = this.wom1('#giftBoxBody #purchaseGuest');
			var guestForm = purchaseGuest.wom1('#regForm');
			event.preventDefault();
			event.stopPropagation();
			$(button).toggleClass('spin')
			guestForm.submit().then(function (values) {
				if (values !== false) {
					this.guestFormRemove();
					if (this.__resolver)
						this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: 'RevenueGuest', eventAction: 'SecondSendClick' });	
						this.__resolver(this.wom1('#giftBoxBody').autoLoginService.injectToken(values, fox.values(values).join(':')));
				} else {
					$(button).toggleClass('spin')
				}
			}.bind(this));
		},

		guestFormRemove: function() {
			var purchaseGuest = this.wom1('#giftBoxBody #purchaseGuest');
			purchaseGuest.removeFromDom();
			var elt = fox.dom.selectFirst('.gift-list-container');
			fox.dom.removeClass('blur', elt);
		},

		showError: function (name, msg) {
			var el = this.dom1('[name="' + name + '"]');
			var field = el.closest('.row');

			if (!field) {
				return;
			};

			fox.dom.addClass('error', field);
			fox.dom.removeClass('success', field);
			fox.dom.selectFirst('.error-message', field).innerHTML = (el.validationMessage || '&nbsp;');
		},

		hideError: function (name) {
			var field = this.dom1('[name="' + name + '"]');
			if (!field || !field.closest('.error')) 
				return false;
			var errorField = field.closest('.error');
			
			fox.dom.removeClass('error', errorField);
			fox.dom.selectFirst('.error-message', errorField).innerHTML = ('&nbsp;');
		}
	});
};

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Menu_Main":{"pattern.store.position":[{"value":60,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Menu_Main","_fox_":1}],"pattern.store.title":[{"value":"Store","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Menu_Main","_fox_":1}],"pattern.store.url":[{"value":"\u002Fstore","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Menu_Main","_fox_":1}],"pattern.store.checkers.store.callback":[{"value":function () {				
return !fox.isEmpty(fox.getEnv('store.enabled'));
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101009},"path":"~.Menu_Main","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root .Site_Layout":{"hooks.onStopRendering":[{"value":function () {
var pm = this.rwom1('@root #permissionManager');
var root = this._wom.getRoot();
var widget = root.wom1('#emailVerificationStatus');
if (!widget) {
widget = root.embedWidget('emailVerificationStatus', 'EmailVerificationNotify', {
'embed.container': '#notification-container',
getVerificationStateCb: function () {
if (fox.site.getEnv('userTokenExpired') === true)
return null;
if (!fox.isEmpty(pm.getMemberInfo()))
return !fox.isEmpty(pm.getMemberInfo('emailVerified'));
},
getUserEmailCb: function () {
return pm.getMemberInfo('email');
}
});
widget.run();
}
widget.showStripIdNeeded();
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101023},"path":"@root .Site_Layout","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.throughChatWindow.widget":[{"value":"ThroughChatWindow","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root","_fox_":1}],"widgets.throughChatWindow.embed.widget":[{"value":"@parent ~.Site_Layout#home","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"@root","_fox_":1}],"widgets.throughChatWindow.embed.container":[{"value":".througth-chat-widget-wrapper","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"@root","_fox_":1}],"widgets.throughChatWindow.embed.location":[{"value":"inside","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.widget":[{"value":"Content_Report","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101010},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.template":[{"value":"content_report_icon","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101011},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.prefixPopup":[{"value":"mess","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101012},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.embed.widget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.additionalPopupClass":[{"value":"dlg-amc dark-overlay mc-site-popup content-report-popup mc-site-common-popup mc-site-popup-bg","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101014},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.widgets.reportPopup.dialog.width":[{"value":"525px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101017},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.widgets.reportPopup.dialog.buttons":[{"value":[],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":1101018},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.handleDom.submitReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101020},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.handleDom.cancelReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.handleDom.close.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101023},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.handleDom.close.target":[{"value":".close","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101024},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.handleDom.close.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101025},"path":"@root","_fox_":1}],"widgets.throughChatWindow.widgets.reportContent.handleDom.close.callback":[{"value":"cancelReportForm","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101026},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Tips_Form":{"hooks.onStartAddedToDom":[{"value":function() {
var counterCalls = 0;
var tipsForm = this;
var callback = function() {
counterCalls++;
if (typeof _gaLinkerLoaded === 'undefined' || !_gaLinkerLoaded && counterCalls < 5) {
setTimeout(arguments.callee, 2000);
return;
}
var linkerParam = fox.wom.selectFirst('@root #googleAnalytics').getLinkerParam();
if (linkerParam) {
tipsForm.setOption('preparedTransactionParams', { 'transitParams[_ga]': linkerParam});
}
}();
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"~.Tips_Form","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Tips_Form":{"wrapMethods.submit":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.Tips_Form","_fox_":1}],"hooks.onStartSubmit":[{"value":function () {
var AutoLoginService = __webpack_require__(15)(fox);
var pm = this.rwom1('@root #permissionManager');
if (!pm.hasAccess('guestActual'))
return true;
if (!this.autoLoginService) {
this.autoLoginService = new AutoLoginService(this);
}
var autoLoginService = this.autoLoginService;
var objWithToken = autoLoginService.injectToken({});
var transactionParams = fox.merge({}, this.getOption('preparedTransactionParams'), {
'transitParams[token]': objWithToken.token
});
this.setOption('preparedTransactionParams', transactionParams);
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"~.Tips_Form","_fox_":1}],"showCbInPopup":[{"value":function (promise) {
var autoLoginService = this.autoLoginService;
var cbPopup = this.wom1('#cbPaymentPopup');
if (!cbPopup) {
cbPopup = this.embedWidget('cbPaymentPopup', 'CBPaymentPopup', {
matchTokenFunction: function (token) {
return autoLoginService ? autoLoginService.matchToken(token) : false;
}
});
cbPopup.run();
}
return cbPopup.show(promise.then(function (data) {
if (data === true) {
cbPopup.hide();
return data;
}
var url = data.submit_url + '?' + fox.toQueryString(data.added_fields);
return { url: url };
}));
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101039},"path":"~.Tips_Form","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.googleAnalytics.widget":[{"value":"mcGoogleAnalytics","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"@root","_fox_":1}]},"@root #router":{"hooks.onStopExecute":[{"value":function() {
var counterCalls = 0;
var currentPage = this._passedRoute.path;
var self = this;
var tj = fox.getEnv('siteProps.trafficJunky');
var callback = function() {
counterCalls++;
if (!_gaScriptLoaded && counterCalls < 5) {
setTimeout(arguments.callee, 2000);
return;
}
var ga = self.rwom1('@root #googleAnalytics');
if (self.rwom1('@root').getOption('gaCodes')) {
ga.trackPageview(currentPage, true);
ga.addLinker();
}
}();
if (currentPage !== 'join' || !tj) {
return;
}
try {
tj = JSON.parse(tj);
} catch(e) {
console.error('TrafficJunky json parse error');
return;
}
_mpevt.push([[tj.context.replace('\.', '_'), '_event'].join('.'), tj.name, tj.value]);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101037},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.User_Login .Form":{"hooks.onStartInit":[{"value":function () {
this.handleEvent(this.rwom1(this.getOption('container')), 'addedToDom', function (o, scope) {
scope.addDomHandler({
event: 'paste',
target: ['input[type=text]', 'input[type=password]'],
callback: function (el) {
setTimeout(function () {
el.value = fox.trim(el.value);
}, 1);
}
}, 'trimInputs');
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"~.User_Login .Form","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~#callme.Site_Page":{"widgets.verifiedcallWidget.widget":[{"value":"VerifiedCall","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~#callme.Site_Page","_fox_":1}],"widgets.verifiedcallWidget.embed.container":[{"value":".verifiedcall-widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~#callme.Site_Page","_fox_":1}],"widgets.verifiedcallWidget.style":[{"value":"page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~#callme.Site_Page","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./appMenuTemplatesRoot.tpl": 705,
	"./billingSupport/contactForm.tpl": 706,
	"./billingSupport/support.tpl": 707,
	"./blog/blogSidebarMainTemplate.tpl": 708,
	"./blog/commonImport.tpl": 709,
	"./cbPaymentPopup.tpl": 710,
	"./contentActions.tpl": 711,
	"./contentActionsIcons.tpl": 60,
	"./contentreport.tpl": 61,
	"./conversation/attachTransaction.tpl": 712,
	"./conversation/previewUploadContent.tpl": 713,
	"./crowdFunding/banner.tpl": 714,
	"./defaultPlayer.tpl": 716,
	"./footer.tpl": 62,
	"./footer/bWrapper.tpl": 717,
	"./footer/powered.tpl": 718,
	"./guestpreview.tpl": 719,
	"./headerSwipeSlider.tpl": 720,
	"./layout/stateoff.tpl": 721,
	"./menuTemplatesRoot.tpl": 722,
	"./modelBacklinks.tpl": 723,
	"./myfriends/myfriendsContent.tpl": 724,
	"./newsletterBlock.tpl": 63,
	"./notification.tpl": 64,
	"./offer/acp/freeacp/bbw.tpl": 726,
	"./oldBrowsers.tpl": 732,
	"./player/banners.tpl": 733,
	"./player/fakeButton.tpl": 65,
	"./player/mobileFormatSwitcher.tpl": 734,
	"./popup/billingInfo/cancellation.tpl": 735,
	"./popup/billingInfo/contact.tpl": 736,
	"./popup/billingInfo/renew.tpl": 737,
	"./popup/ccpa.tpl": 738,
	"./popup/crowdfunding/confirm.tpl": 739,
	"./popup/crowdfunding/payment.tpl": 740,
	"./popup/gifts/templates.tpl": 741,
	"./popup/joinFormError.tpl": 742,
	"./popup/liveshow/paidRequest.tpl": 743,
	"./popup/user/passwordrecovery.tpl": 744,
	"./site.tpl": 745,
	"./sitepage/callme/callmeTemplates.tpl": 746,
	"./sitepage/freeHostedGalleryTemplates.tpl": 747,
	"./sitepage/freehostedgallery.tpl": 748,
	"./sitepage/freehostedvideos.tpl": 749,
	"./sitepage/gallery/fullscreenView.tpl": 750,
	"./sitepage/gallery/tipme.tpl": 751,
	"./sitepage/legaldocs/2257.tpl": 752,
	"./sitepage/legaldocs/ccpa.tpl": 753,
	"./sitepage/legaldocs/cookie-table.tpl": 754,
	"./sitepage/legaldocs/cookie.tpl": 755,
	"./sitepage/legaldocs/personal.tpl": 756,
	"./sitepage/legaldocs/privacy.tpl": 757,
	"./sitepage/legaldocs/terms.tpl": 758,
	"./sitepage/liveshowNew.tpl": 759,
	"./sitepage/myfriends.tpl": 760,
	"./sitepage/stateoff/footer.tpl": 761,
	"./sitepage/stateoff/header.tpl": 762,
	"./sitepage/stateoff/login.tpl": 763,
	"./sitepage/stateoff/newsletterBlock.tpl": 764,
	"./sitepage/stateoff/passwordRecovery.tpl": 765,
	"./sitepage/stateoff/siteClosed.tpl": 766,
	"./sitepage/stateoff/siteUnderConstruction.tpl": 767,
	"./sitepage/stateoff/socialapps.tpl": 768,
	"./sitepage/stateoff/tipme.tpl": 769,
	"./social/favorite-default.tpl": 770,
	"./social/rating-default.tpl": 771,
	"./socialapps.tpl": 772,
	"./storeCategories.tpl": 773,
	"./tagsfilter.tpl": 774,
	"./throughChatWindow.tpl": 775,
	"./user/login.tpl": 776,
	"./user/notificationsManager.tpl": 777,
	"./user/passwordrecovery.tpl": 778,
	"./vrPlayer.tpl": 779
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 704;

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("app_menu_more", [["ul",{"fox-main-menu-more-list":"","class":"more"},[["foreach",{"from":"","item":"additionalLink"},[["li",{"class":"menu-item &&0&&","fox-main-menu-list-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["additionalLink.display","notempty",true],["additionalLink.display","__internal"]]]],[["additionalLink.alias","class"],["additionalLink.alias","fox-main-menu-list-item",true]]]],[["additionalLinks","from",true]]]]]]);
fox.registerTemplate("app_menu", [["div",{"class":"menu-container base","id":"main-menu-wrapper"},[["ul",{"class":"main-menu-container","fox-main-menu-container":""},[["foreach",{"from":"","item":"link"},[["li",{"class":"menu-item &&0&&","fox-main-menu-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["link.display","notempty",true],["link.display","__internal"]]]],[["link.alias","class"],["link.alias","fox-main-menu-item",true]]]],[["baseLinks","from",true]]],["li",{"class":"menu-item more-list-item","fox-main-menu-item":"list-container"},[["span",{"class":"more-link"},[["textNode",{"text":" More "}],["i",{"class":"icon-menu-list"}],["textNode",{"text":" "}],["i",{"class":"arr icon-arrow-middle-left"}]]]]],["li",{"class":"menu-item mobile-menu"},[["a",{"class":"mobile-m-switcher","draggable":"true"},[["i",{"class":"icon-menu-list"}]]]]]]]]],["div",{"class":"menu-container action"},[["ul",{"class":"main-menu-container"},[["if",{"empty":""},[["li",{"class":"join-link mobile-login-btn"},[["a",{"id":"login-button","class":"background-color-2 text-color-4"},[["span",{},[],[["userAction.login.title","__text",true]]]]]]],["li",{"class":"join-link"},[["a",{"id":"join-button","class":"background-color-2 text-color-4","href":""},[["span",{},[],[["userAction.join.title","__text",true]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]]],["else",{},[["li",{"class":"icon fright favorites"},[["a",{"href":"/favorites"},[["i",{"class":"icon-star"}]]]]],["li",{"class":"icon fright messages"},[["a",{"href":"/conversation","class":"link-color"},[["i",{"class":"icon-text-bubble"}],["textNode",{"text":" "}],["span",{"id":"messages-number","class":"link-color"}]]]]],["li",{"class":"icon fright settings"},[["a",{"href":"/account"},[["i",{"class":"icon-setting"}]]]]],["li",{"class":"fright icon logged logout last"},[["a",{"class":"","onclick":"fox.site.logout();"},[["i",{"class":"icon-logout"}]]]]]]]],[["id","empty",true,[],"member"]]]]]]]]);
fox.registerTemplate("main_menu_item2", [["li",{"class":"menu-item &&0&&","fox-main-menu-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["display","notempty",true],["display","__internal"]]],["a",{"href":""},[["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]],[["alias","class"],["alias","fox-main-menu-item",true]]]]);
fox.registerTemplate("main_menu_item_default", [["a",{"href":""},[["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_more_item", [["li",{"class":"menu-item &&0&&","fox-main-menu-list-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["display","notempty",true],["display","__internal"]]],["a",{"href":""},[["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]],[["alias","class"],["alias","fox-main-menu-list-item",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("billingsupport_contact_form", [["form",{"class":"billing-contact-form","id":"billing-contact-form"},[["div",{"class":"row"},[["div",{"class":"form-block"},[["label",{},[["textNode",{"text":"First name:"}]]],["div",{"class":"mc-common-input"},[["input",{"type":"text","name":"firstname"}]]],["div",{"class":"error-message"},[["textNode",{"text":"This field is required"}]]]]],["div",{"class":"form-block"},[["label",{},[["textNode",{"text":"Last name:"}]]],["div",{"class":"mc-common-input"},[["input",{"type":"text","name":"lastname"}]]],["div",{"class":"error-message"},[["textNode",{"text":"This field is required"}]]]]]]],["div",{"class":"row wide"},[["div",{"class":"form-block"},[["label",{},[["textNode",{"text":"Description of problem:"}]]],["div",{"class":"mc-common-input "},[["textarea",{"name":"description","rows":"10"}]]],["div",{"class":"error-message"},[["textNode",{"text":"This field is required"}]]]]]]],["div",{"class":"row wide"},[["div",{"class":"form-block"},[["input",{"type":"submit","class":"mc-common-button send","value":"Submit"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("billing_support", [["div",{"class":"pad-tb content-page auth-form account-form border-color-3-trans-20"},[["div",{"class":"global-title"},[["textNode",{"text":"Billing Support "}],["span",{},[],[["biller","__text",true]]]]],["div",{"class":"links"},[["if",{"notempty":""},[["if",{"notempty":""},[["a",{"href":"","class":"text-color-4","target":"_blank"},[["textNode",{"text":" Cancel Membership "}]],[["link","href",true]]],["span",{},[["textNode",{"text":" | "}]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]],["a",{"href":"","class":"text-color-4","target":"_blank","rel":"nofollow"},[["textNode",{"text":" Contact Support "}]],[["link","href",true]]],["else",{},[["if",{"empty":""},[["if",{"notempty":""},[["a",{"href":"/cancellation","class":"text-color-4"},[["textNode",{"text":"Cancel Membership"}]]],["span",{},[["textNode",{"text":" | "}]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]],["else",{},[["p",{},[["textNode",{"text":"You have requested to cancel your subscription. Your access to the site will be terminated on "}],["span",{},[],[["expireDate","__text",true,[{"name":"dateFormat","params":["%Y-%m-%d"]}]]]],["textNode",{"text":"."}]]],["a",{"class":"text-color-4 renew"},[["textNode",{"text":"Restore Membership"}]]],["span",{},[["textNode",{"text":" | "}]]]]]],[["canceled","empty",true]]],["a",{"href":"/billing-contact","class":"text-color-4"},[["textNode",{"text":" Contact Support "}]]]]]],[["biller","notempty",true]]],["span",{},[["textNode",{"text":" | "}]]],["a",{"class":"text-color-4 delete-account"},[["textNode",{"text":" Delete my account "}]]],["span",{},[["textNode",{"text":" | "}]]],["a",{"class":"text-color-4 exersise-rights"},[["textNode",{"text":" Exercise my rights under GDPR "}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("blog_sidebar_main_template", [["div",{"id":"last-post-comments"}],["div",{"id":"most-popular-post"}]]);
fox.registerTemplate("blog_last_comments_container", [["div",{"class":"sb-title"},[["textNode",{"text":"Latest comments"}]]],["div",{"class":"list"}]]);
fox.registerTemplate("blog_last_popular_posts_container", [["div",{"class":"sb-title"},[["textNode",{"text":"Most popular posts"}]]],["div",{"class":"list blog"}]]);
fox.registerTemplate("latest_comm_row", [["div",{"class":"lc-comment-item"},[["div",{"class":"lc-post"},[["strong",{},[["textNode",{"text":"Post:"}]]],["textNode",{"text":" "}],["a",{"href":"/#!/post/&&0&&"},[["if",{"notempty":"","addattr":"href:/post/&&1&&/&&2&&"},[],[["post.title","notempty",true],["post.id","addattr"],["post.title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["textNode",{"text":" "}],["span",{},[],[["post.title","__text",true]]],["textNode",{"text":" "}]],[["post.id","href"]]]]],["div",{"class":"lc-date"},[["span",{},[["span",{},[],[["date","__text",true,[{"name":"dateFormat","params":["%B %e, %Y"]}]]]],["textNode",{"text":"."}]]],["textNode",{"text":" "}],["span",{},[["span",{},[],[["name","__text",true]]]]]]],["div",{},[["if",{"notempty":""},[["div",{},[["span",{},[],[["comment","__text",true,[{"name":"truncate","params":["160","..."]}]]]],["textNode",{"text":" "}],["a",{"class":"toggle-comment pointer"},[["textNode",{"text":"more"}]]]]],["div",{"style":"display: none;"},[["span",{},[],[["comment","__text",true]]],["textNode",{"text":" "}],["a",{"class":"toggle-comment pointer"},[["textNode",{"text":"less"}]]]]],["else",{},[["span",{},[["span",{},[],[["comment","__text",true]]]]]]]],[["comment","notempty",true,[{"name":"count","params":[]},{"name":"gt","params":["160"]}]]]]]]]]]);
fox.registerTemplate("latest_posts_row", [["div",{"class":"post-item"},[["a",{"href":"#!/post/&&0&&"},[["if",{"notempty":"","addattr":"href:/post/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["strong",{},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["if",{"empty":""},[["textNode",{"text":" Untitled "}]],[["title","empty",true]]]]]],[["id","href"]]],["ul",{"class":"lc-date"},[["if",{"notempty":""},[["li",{},[["span",{},[],[["rating.voters","__text",true]]],["textNode",{"text":" likes"}]]],["else",{},[["li",{},[["textNode",{"text":"0 likes"}]]]]]],[["rating.voters","notempty",true]]],["if",{"notempty":""},[["li",{},[["span",{},[],[["commentsSum.total","__text",true]]],["textNode",{"text":" comments"}]]],["else",{},[["li",{},[["textNode",{"text":"0 comments"}]]]]]],[["commentsSum.total","notempty",true]]],["if",{"notempty":""},[["li",{},[["span",{},[],[["views","__text",true]]],["textNode",{"text":" views"}]]],["else",{},[["li",{},[["textNode",{"text":"0 views"}]]]]]],[["views","notempty",true]]]]],["foreach",{"from":"","item":"shItem"},[["if",{"notempty":""},[["div",{"class":"thumb"},[["div",{"class":"img-content"},[["img",{"src":"","alt":"&&1&&-&&2&&-&&3&&"},[],[["shItem.content","src",true],["id","alt"],["title","alt"],["name","alt",false,[],"client"]]]]]]]],[["shItem.type","notempty",true,[{"name":"eq","params":["3"]}]]]]],[["_shortContent.collection","from",true]]],["div",{"class":"lc-date in-sidebar"},[["textNode",{"text":" "}],["span",{},[],[["publishDate","__text",true,[{"name":"dateFormat","params":["%B %e, %Y"]}]]]],["textNode",{"text":" "}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("blog_post_link_with_title", [["if",{"notempty":"","addattr":"href:/post/&&1&&/&&2&&"},[["else",{"addattr":"href:/post/&&0&&"},[],[["id","addattr"]]]],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("cb_payment_popup_content", [["iframe",{"src":""},[],[["url","src",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_actions", [["div",{"class":"content-actions new-wrap"},[["div",{"class":"rating","data-target-id":""},[],[["extender.contentId","data-target-id",true]]],["div",{"class":"tipme-container"}],["div",{"class":"more-actions-container"},[["if",{"notempty":""},[["div",{"class":"item related"},[["a",{"href":"","title":"Watch photos","class":"related-link"},[["if",{"notempty":"","addattr":"href:/gallery/&&1&&/&&2&&"},[],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]],["related.relatedContentId.id","addattr"],["related.relatedContentId.title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["import",{"name":"content_actions_related_icon"}],["span",{"class":"action-link-text"},[["textNode",{"text":"Watch photos"}]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]]]],[["related.relatedContentId.id","notempty",true]]],["div",{"class":"download-block"}],["import",{"name":"favorite_block"}],["import",{"name":"report"}]]]]]]);
fox.registerTemplate("photo_download", [["div",{"class":"photoset-download"},[["a",{"class":"p-zip-download download toggleDownloads","title":"Download zip","href":"","download":""},[["i",{"class":""},[],[["iconDownload","class",true]]],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"Download"}]]]],[["_zip","href",true]]]]]]);
fox.registerTemplate("video_download", [["div",{"class":"video-download"},[["a",{"class":"download toggleDownloads","title":"Download"},[["if",{"notempty":"","addattr":"href:&&1&&"},[],[["url","notempty",true],["url","__internal"]]],["i",{"class":""},[],[["iconDownload","class",true]]],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"Download"}]]]]],["ul",{"class":"download-links"}]]]]);
fox.registerTemplate("favorite_block", [["div",{"class":"bookmark"}]]);
fox.registerTemplate("report", [["div",{"id":"content-report","class":"item content-report-wrapper content-report"}]]);
fox.registerTemplate("sitepage_scene_links", [["foreach",{"from":"","item":"format"},[["li",{},[["if",{"notempty":"","addclass":"vr"},[],[["format.vr","notempty",true,[{"name":"eq","params":["1"]}]]]],["a",{"href":"","class":"link","data-format":"","download":""},[["div",{"class":"format-icon"},[["if",{"notempty":""},[["i",{"class":"icon-lib-vr_hq_19"}],["else",{},[["i",{},[["if",{"notempty":"","addclass":"icon-format-sd"},[["else",{},[["if",{"notempty":"","addclass":"icon-format-hd"},[["else",{"addclass":"icon-lib-4k_19"}]],[["format.height","notempty",true,[{"name":"lt","params":["2160"]}]]]]]]],[["format.hd","notempty",true,[{"name":"eq","params":["0"]}]]]]]]]]],[["format.vr","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"format-label"},[["if",{"notempty":""},[["if",{"notempty":""},[["textNode",{"text":" Vive/Oculus "}]],[["format._key","notempty",true,[{"name":"eq","params":["hd1920_vr_oculus"]}]]]],["if",{"notempty":""},[["textNode",{"text":" Gear VR "}]],[["format._key","notempty",true,[{"name":"eq","params":["hd1440_vr_samsung"]}]]]],["if",{"notempty":""},[["textNode",{"text":" PlayStation VR "}]],[["format._key","notempty",true,[{"name":"eq","params":["hd960_vr_psp"]}]]]],["if",{"notempty":""},[["textNode",{"text":" Smart phone "}]],[["format._key","notempty",true,[{"name":"eq","params":["hd960_vr_mobile"]}]]]],["if",{"notempty":""},[["textNode",{"text":" Smart phone "}]],[["format._key","notempty",true,[{"name":"eq","params":["sd960_vr_mobile"]}]]]],["else",{},[["span",{},[],[["format.height","__text",true]]],["textNode",{"text":"p"}]]]],[["format.vr","notempty",true,[{"name":"eq","params":["1"]}]]]]]]]],["div",{"class":"format-size"},[["textNode",{"text":" "}],["span",{},[],[["format.size","__text",true,[{"name":"fileSize","params":[]}]]]],["textNode",{"text":" MB "}]]]],[["format.link","href",true],["format._key","data-format",true]]]]]],[["download","from",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("transaction_biller_form", [["form",{"action":"","method":""},[["foreach",{"from":"","item":"field"},[["input",{"type":"hidden","name":"","value":""},[],[["field._key","name",true],["field","value",true]]]],[["added_fields","from",true]]]],[["submit_url","action",true],["form_method","method",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("preview_attached_content_video", [["div",{},[["div",{"class":"uploaded-video flash-player-container"},[["div",{"id":"flash-player","class":"player"}]]],["div",{"class":"content-actions new-wrap"},[["span",{"class":"attach-title"},[["textNode",{"text":" "}],["span",{},[],[["attachTitle","__text",true]]],["textNode",{"text":" "}]]],["div",{"class":"more-actions-container"},[["div",{"class":"item video-download attach-download"}],["div",{"class":"bookmark","data-target-id":""},[],[["targetId","data-target-id",true]]]]]]]]]]);
fox.registerTemplate("preview_attached_content_image", [["div",{},[["div",{"class":"uploaded-image","style":"background-image: url(&&0&&);"},[],[["imageSrc","style"]]],["div",{"class":"content-actions new-wrap"},[["span",{"class":"attach-title"},[["textNode",{"text":" "}],["span",{},[],[["attachTitle","__text",true]]],["textNode",{"text":" "}]]],["div",{"class":"more-actions-container"},[["div",{"class":"item video-download attach-download"},[["a",{"class":"download toggleDownloads","title":"Download","href":"","download":""},[["i",{"class":""},[],[["iconDownload","class",true]]],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"Download"}]]]],[["imageSrc","href",true]]]]],["div",{"class":"bookmark","data-target-id":""},[],[["resourceId","data-target-id",true]]]]]]]]]]);
fox.registerTemplate("attached_video_download_links", [["if",{"notempty":""},[["a",{"class":"download toggleDownloads","title":"Download","href":""},[["i",{"class":""},[],[["iconDownload","class",true]]],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"Download"}]]]],[["downloadLink","href",true]]]],[["downloadLink","notempty",true,[{"name":"notEmpty","params":[]}]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("crowdfunding_banner", [["div",{"class":"pad-lr pad-b"},[["div",{"class":"cf-widget"},[["div",{"class":"img-wrapper","data-fox-alias":"sfBg"},[["img",{"src":"" + __webpack_require__(715) + "","alt":"crowdfunding"}],["div",{"class":"cf-bg"}]]],["div",{"class":"cf-data"},[["span",{"class":"corner t l"}],["textNode",{"text":" "}],["span",{"class":"corner t r"}],["textNode",{"text":" "}],["span",{"class":"corner b l"}],["textNode",{"text":" "}],["span",{"class":"corner b r"}],["p",{"class":"cf-title"},[["textNode",{"text":"Want to meet me at CamCon? Sponsor me!"}]]],["div",{"class":"read-more"},[["a",{"href":"http://camcon.com/","target":"_blank","rel":"nofollow"},[["i",{"class":"i_cf-info_8"}],["textNode",{"text":" Read more about this event "}]]]]],["div",{"class":"cf-progress-data"},[["div",{"class":"icons-wrapper"},[["div",{"class":"money"},[["div",{"class":"ico"},[["i",{"class":"i_cf-raised_27"}]]],["div",{"class":"info"},[["strong",{},[["span",{},[],[["currentAmount","__text",true,[{"name":"toInt","params":[]}]]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"/ $ "}],["span",{},[],[["goalAmount","__text",true,[{"name":"toInt","params":[]}]]]]]]]]]],["div",{"class":"sponsors"},[["div",{"class":"ico"},[["i",{"class":"i_cf-sponsors_24"}]]],["div",{"class":"info"},[["strong",{},[["span",{},[],[["sponsors","__text",true]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Sponsors"}]]]]]]],["if",{"notempty":""},[["div",{"class":"remaining-time"},[["div",{"class":"ico"},[["i",{"class":"i_cf-timeLeft_29"}]]],["div",{"class":"info"},[["if",{"notempty":""},[["strong",{},[["span",{},[],[["expirationDate","__text",true,[{"name":"timeLeft","params":["hours"]}]]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Hours left"}]]],["else",{},[["strong",{},[["span",{},[],[["expirationDate","__text",true,[{"name":"timeLeft","params":["days"]}]]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Days left"}]]]]]],[["expirationDate","notempty",true,[{"name":"timeLeftChecker","params":[]},{"name":"eq","params":["hours"]}]]]]]]]]],[["expirationDate","notempty",true,[{"name":"timeLeftChecker","params":[]}]]]]]],["div",{"class":"progress-wrapper"},[["div",{"class":"progress-bar"},[["div",{"class":"progress","style":"width: &&0&&%"},[],[["progress","style"]]],["span",{},[["span",{},[],[["progress","__text",true]]],["textNode",{"text":"% raised"}]]]]],["div",{"class":"btn-wrapper"},[["a",{"class":"mc-common-button donate","data-fund-id":""},[["textNode",{"text":"Sponsor me!"}]],[["id","data-fund-id",true]]]]]]]]],["div",{"class":"share-wrapper"},[["p",{"class":"cf-title"},[["textNode",{"text":"Can't donate? Want to help?"}]]],["div",{"class":"networks"},[["p",{"class":"cf-title"},[["textNode",{"text":"Spread the word on"}]]],["div",{"class":"list"},[["a",{"data-share":"","data-app-name":"thumbler"},[["i",{"class":"icon-au_thumbler"}]]],["textNode",{"text":" "}],["a",{"data-share":"","data-app-name":"twitter"},[["i",{"class":"icon-au_twitter"}]]],["textNode",{"text":" "}],["a",{"data-share":"","data-app-name":"facebook"},[["i",{"class":"icon-au_facebook"}]]]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/cf-placeholder.gif", __webpack_require__.p + "_/_/_/root/images/cf-placeholder.gif");

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("defaultplayer", [["div",{"class":"form-container"},[["div",{"id":""},[],[["playerContainerId","id",true]]],["div",{"style":"display: none;text-align: center;"},[["div",{"id":"tipme-form","class":"tipme-container","style":"display:inline-block;"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("footer_b_wrapper", [["div",{"class":"footer-b-wrapper"},[["div",{"class":"b-list"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("footer_powered", [["p",{"class":"powered"},[["textNode",{"text":" Powered by "}],["a",{"href":"https://modelcentro.com?acode=&&0&&","rel":"nofollow"},[["textNode",{"text":"ModelCentro"}]],[["client.acode","href",false,[],"env"]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("guest_preview", [["div",{"class":"disable-player-block","id":"flash-player"},[["div",{"class":"permition-wrapper"},[["div",{"class":"disable-banner-link"}],["div",{"class":"disable-player-scene-img"},[["img",{"src":""},[],[["_resources.primary.url","src",true]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("swipe_header", [["div",{"class":"header-images-slider","id":"swipe-wrapper"},[["div",{"class":"items"},[["foreach",{"from":"","item":"item"},[["div",{"class":"slide-item item-&&0&&"},[["img",{"src":"","alt":"&&1&&-&&2&&","class":"placeholder","style":"visibility: hidden;"},[],[["item.src","src",true],["item.ind","alt"],["screenName","alt",false,[],"env"]]]],[["item.ind","class"]]]],[["paths","from",true]]]]]]],["if",{"notempty":""},[["div",{"class":"slider-pager"},[["foreach",{"from":"","item":"item"},[["span",{"class":"slide","data-index":""},[["if",{"notempty":"","addclass":"active"},[],[["item._key","notempty",true,[{"name":"eq","params":["0"]}]]]]],[["item._key","data-index",true]]]],[["paths","from",true]]]]]],[["paths","notempty",true,[{"name":"count","params":[]},{"name":"gt","params":["1"]}]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_stateoff", [["div",{"id":"container","class":"stateoff-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("main_menu2", [["div",{"class":"menu-container","id":"main-menu-wrapper"},[["ul",{"class":"main-menu-container ","fox-main-menu-container":""}],["if",{"notempty":""},[["ul",{"class":"main-menu-container main-menu-more-container","fox-main-menu-more-container":""},[["li",{"class":"menu-item more-list-item","fox-main-menu-item":"list-container"},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["display","notempty",true],["display","__internal"]]],["span",{"class":"more-link"},[["textNode",{"text":"More..."}]]],["ul",{"fox-main-menu-more-list":"","class":"more","style":"background-color: #aa235e;"}]]]]]],[["additionalLinks","notempty",true]]]]],["div",{"class":"menu-container action"},[["ul",{"class":"main-menu-container"},[["if",{"empty":""},[["li",{"class":"join-link"},[["a",{"class":"background-color-2 text-color-4","href":""},[["span",{},[],[["userAction.join","__text",true]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]]],["li",{"class":"join-link mobile-login-btn"},[["a",{"id":"login-button","class":"background-color-2 text-color-4"},[["span",{},[],[["userAction.login","__text",true]]]]]]],["else",{},[["li",{"class":"fright icon logged logout last"},[["a",{"class":"","onclick":"fox.site.logout();"},[["i",{"class":"icon-logout"}]]]]],["li",{"class":"icon fright settings"},[["a",{"href":"/account"},[["i",{"class":"icon-setting"}]]]]],["li",{"class":"icon fright messages"},[["a",{"href":"/conversation","class":"link-color"},[["i",{"class":"icon-text-bubble"}],["textNode",{"text":" "}],["span",{"id":"messages-number","class":"link-color"}]]]]],["li",{"class":"icon fright favorites"},[["a",{"href":"/favorites"},[["i",{"class":"icon-star"}]]]]]]]],[["id","empty",true,[],"member"]]]]]]]]);
fox.registerTemplate("main_menu", [["div",{"class":"menu-container base","id":"top-menu"},[["ul",{"class":"main-menu-container hidden","fox-main-menu-container":""},[["foreach",{"from":"","item":"link"},[["li",{"class":"menu-item &&0&&","fox-main-menu-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["link.display","notempty",true],["link.display","__internal"]]]],[["link.alias","class"],["link.alias","fox-main-menu-item",true]]]],[["baseLinks","from",true]]],["if",{"notempty":""},[["li",{"class":"menu-item more-list-item","fox-main-menu-item":"list-container"},[["span",{"class":"more-link"},[["textNode",{"text":" More "}],["i",{"class":"icon-menu-list"}],["textNode",{"text":" "}],["i",{"class":"arr icon-arrow-middle-left"}]]],["ul",{"fox-main-menu-more-list":"","class":"more"},[["foreach",{"from":"","item":"additionalLink"},[["li",{"class":"menu-item &&0&&","fox-main-menu-list-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["additionalLink.display","notempty",true],["additionalLink.display","__internal"]]]],[["additionalLink.alias","class"],["additionalLink.alias","fox-main-menu-list-item",true]]]],[["additionalLinks","from",true]]]]]]]],[["additionalLinks","notempty",true]]],["li",{"class":"menu-item mobile-menu"},[["a",{"class":"mobile-m-switcher","draggable":"true"},[["i",{"class":"icon-menu-list"}]]]]]]]]],["div",{"class":"menu-container action"},[["ul",{"class":"main-menu-container"},[["if",{"empty":""},[["li",{"class":"join-link mobile-login-btn"},[["a",{"id":"login-button","class":"background-color-2 text-color-4"},[["span",{},[],[["userAction.login","__text",true]]]]]]],["li",{"class":"join-link"},[["a",{"id":"join-button","class":"background-color-2 text-color-4","href":""},[["span",{},[],[["userAction.join","__text",true]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]]],["else",{},[["li",{"class":"icon fright favorites"},[["a",{"href":"/favorites"},[["i",{"class":"icon-star"}]]]]],["li",{"class":"icon fright messages"},[["a",{"href":"/conversation","class":"link-color"},[["i",{"class":"icon-text-bubble"}],["textNode",{"text":" "}],["span",{"id":"messages-number","class":"link-color"}]]]]],["li",{"class":"icon fright settings"},[["a",{"href":"/account"},[["i",{"class":"icon-setting"}]]]]],["li",{"class":"fright icon logged logout last"},[["a",{"class":"","onclick":"fox.site.logout();"},[["i",{"class":"icon-logout"}]]]]]]]],[["id","empty",true,[],"member"]]]]]]]]);
fox.registerTemplate("main_menu_item2", [["li",{"class":"menu-item &&0&&","fox-main-menu-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["display","notempty",true],["display","__internal"]]],["a",{"href":""},[["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"ref:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]],[["alias","class"],["alias","fox-main-menu-item",true]]]]);
fox.registerTemplate("main_menu_item", [["a",{"href":""},[["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"ref:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_more_item", [["li",{"class":"menu-item &&0&&","fox-main-menu-list-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["display","notempty",true],["display","__internal"]]],["a",{"href":""},[["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"ref:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]],[["alias","class"],["alias","fox-main-menu-list-item",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("model_backlinks_container", [["div",{"id":"starring"},[["span",{},[["span",{},[],[["starringTitle","__text",true]]],["textNode",{"text":":&nbsp; "}],["span",{"id":"st-list"}]]]]],["if",{"notempty":""},[["div",{"style":"margin: 10px 0;","id":"back-links"}]],[["id","notempty",true,[],"member"]]]]);
fox.registerTemplate("model_starring", [["a",{},[["span",{},[],[["modelId.stageName","__text",true]]]]],["if",{"empty":""},[["textNode",{"text":",&nbsp;"}]],[["_last","empty",true]]]]);
fox.registerTemplate("model_back_links", [["if",{"notempty":""},[["a",{"target":"_blank","rel":"nofollow","href":""},[["span",{},[],[["modelId.upsellText","__text",true]]]],[["modelId.upsellLink","href",true]]],["if",{"empty":""},[["textNode",{"text":",&nbsp;"}]],[["_last","empty",true]]]],[["modelId.upsellLink","notempty",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("myfriends_container", [["div",{"class":"site-page"},[["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title"},[["p",{},[["textNode",{"text":"My friends"}]]]]]]]]],["section",{"class":"content-grid photos-grid myfriends-list","id":"myfriends-list"}],["div",{"class":"pager-wrapper"}]]],["div",{"id":"join_continue","class":"tour-buttons"}]]);
fox.registerTemplate("myfriends_list_item", [["div",{"class":"grid-item custom1","style":"background-image: url(&&0&&);"},[["img",{"src":"" + __webpack_require__(725) + "","class":"empty-img"}],["div",{"class":"grid-item-shadow"}],["div",{"class":"grid-item-data"},[["p",{"class":"title"},[["span",{},[],[["title","__text",true]]]]]]],["div",{"class":"link-tags"},[["a",{"class":"round-photosets","href":"/photosets/tags=&&0&&"},[["textNode",{"text":"Photosets"}]],[["title","href"]]],["a",{"class":"round-videos","href":"/videos/tags=&&0&&"},[["textNode",{"text":"Videos"}]],[["title","href"]]]]]],[["_shortContent.collection.content","style"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/photo-placeholder.gif", __webpack_require__.p + "_/_/_/root/images/photo-placeholder.gif");

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("offer_overlay_freeacp_precancel", [["div",{"id":"cancellation-overlay","style":"display: none;"},[["div",{"class":"overlay-content"},[["div",{"class":"cancellation-main"},[["div",{"class":"main-text"},[["textNode",{"text":"WAIT! DON'T LEAVE YET!"}]]],["div",{"class":"general-text"},[["textNode",{"text":"HERE'S THE OFFER"}],["br"],["textNode",{"text":" YOU CAN'T REFUSE!"}]]],["div",{},[["textNode",{"text":"FREE ACCESS TO MY FAVORITE COLLECTION OF BBW VIDEOS AT "}],["a",{"href":"http://&&0&&/","target":"_blank","rel":"nofollow"},[["span",{},[],[["siteDomain","__text",true,[{"name":"upperCase","params":[]}]]]]],[["siteDomain","href"]]],["textNode",{"text":" 1000’s of BBW MOVIES AND IT'S 100% FREE TODAY!"}]]],["div",{},[["textNode",{"text":"Of course You'll Still Receive All Of My Updates and Site Benefits!"}]]],["div",{"class":"submit-box"},[["div",{"class":"line-decor"}],["div",{"class":"submit-btn-box"},[["a",{"class":"submit-btn","href":"","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Yes! I want this OFFER!"}]],[["confirmApiAddress","href",true]]]]],["div",{"class":"line-decor"}]]]]],["div",{"class":"cancellation-content"},[["div",{"class":"cancellation-main"},[["div",{"class":"cancellation-info"},[["div",{"class":"inner"},[["a",{"class":"site-logo-box","href":"http://&&0&&/","target":"_blank","rel":"nofollow"},[["img",{"class":"site-logo","src":"" + __webpack_require__(727) + "","alt":"logo"}]],[["siteDomain","href"]]],["div",{"class":"bigger-text"},[["textNode",{"text":"5000+ HD videos & Every day updates"}]]]]],["div",{"class":"price"},[["div",{"class":"old-price"},[["span",{},[],[["oldPrice","__text",true]]],["textNode",{"text":" $"}]]],["div",{"class":"new-price"},[["textNode",{"text":"100% free!"}]]]]],["div",{"class":"inner"},[["textNode",{"text":"Only now and only for you!"}]]]]],["div",{"class":"cancellation-thumbs"},[["div",{"class":"thumb-item"},[["div",{"class":"thumb","style":"background-image: url(" + __webpack_require__(728) + ")"}]]],["div",{"class":"thumb-item"},[["div",{"class":"thumb","style":"background-image: url(" + __webpack_require__(729) + ")"}]]],["div",{"class":"thumb-item"},[["div",{"class":"thumb","style":"background-image: url(" + __webpack_require__(730) + ")"}]]],["div",{"class":"thumb-item"},[["div",{"class":"thumb","style":"background-image: url(" + __webpack_require__(731) + ")"}]]]]]]]]],["div",{"class":"cancellation-main cancellation-footer"},[["div",{},[["textNode",{"text":"* As long as you're a member of my site, you will receive this free site offer completely FREE."}]]],["div",{"class":"exit-box"},[["a",{"class":"cancellation-exit"},[["span",{"class":"icon ico-calendar_close_event"}],["textNode",{"text":" NO CANCEL MY MEMBERSHIP! "}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/offer/acp/freeacp/bbw/logo.png", __webpack_require__.p + "_/_/_/root/images/offer/acp/freeacp/bbw/logo.png");

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/offer/acp/freeacp/bbw/thumb-1.jpg", __webpack_require__.p + "_/_/_/root/images/offer/acp/freeacp/bbw/thumb-1.jpg");

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/offer/acp/freeacp/bbw/thumb-2.jpg", __webpack_require__.p + "_/_/_/root/images/offer/acp/freeacp/bbw/thumb-2.jpg");

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/offer/acp/freeacp/bbw/thumb-3.jpg", __webpack_require__.p + "_/_/_/root/images/offer/acp/freeacp/bbw/thumb-3.jpg");

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/offer/acp/freeacp/bbw/thumb-4.jpg", __webpack_require__.p + "_/_/_/root/images/offer/acp/freeacp/bbw/thumb-4.jpg");

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("oldbrowsers", [["html",{},[["head",{},[["title",{},[["textNode",{"text":"Old Browser"}]]],["meta",{"http-equiv":"Content-Type","content":"text/html; charset=UTF-8"}],["meta",{"name":"viewport","content":"width=device-width, initial-scale=1.0"}],["link",{"rel":"stylesheet","type":"text/css","href":"http://static-a.mc.centrofiles.com/static/mc-frame/1235/css/old-browser.css"}],["script",{},[["textNode",{"text":" (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){ (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o), m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m) })(window,document,'script','https://www.google-analytics.com/analytics.js','ga'); ga('create', '"}],["span",{},[],[["gaCode","__text",true]]],["textNode",{"text":"', 'auto'); ga('send', 'pageview', {page: 'old-browser'}); "}]]]]],["body",{},[["div",{"id":"cc-flap"},[["table",{"class":"cc-f-layout"},[["tr",{},[["td",{},[["textNode",{"text":"&nbsp;"}]]],["td",{"class":"layout-inner"},[["div",{"class":"cc-warning"}],["table",{"class":"cc-f-unit"},[["tr",{},[["td",{},[["textNode",{"text":"&nbsp;"}]]],["td",{"class":"cc-f-content platform-&&0&&"},[["h1",{"class":"cc-f-title"},[["textNode",{"text":"Oops... Your browser version is not fully supported."}]]],["div",{"class":"cc-text"},[["textNode",{"text":"Don&#39;t worry, there&#39;s an easy fix. All you have to do is click one of the icons below and follow the"}],["br"],["textNode",{"text":" instructions. You&#39;ll be enjoying the site before you know it."}]]],["div",{"class":"cc-browsers desktop"},[["div",{"class":"cc-browser-item cc-chrome"},[["a",{"class":"cc-browser-link","target":"_blank","rel":"nofollow","href":"http://www.google.com/chrome/"},[["textNode",{"text":"Chrome"}]]]]],["div",{"class":"cc-browser-item cc-ie"},[["a",{"class":"cc-browser-link ","target":"_blank","rel":"nofollow","href":"http://windows.microsoft.com/en-us/internet-explorer/download-ie"},[["textNode",{"text":"Internet explorer"}]]]]],["div",{"class":"cc-browser-item cc-safari"},[["a",{"class":"cc-browser-link","target":"_blank","rel":"nofollow","href":"https://www.apple.com/safari/"},[["textNode",{"text":"Safari"}]]]]],["div",{"class":"cc-browser-item cc-ff"},[["a",{"class":"cc-browser-link","target":"_blank","rel":"nofollow","href":"http://www.mozilla.org/firefox/"},[["textNode",{"text":"Firefox"}]]]]]]],["div",{"class":"cc-browsers ios"},[["div",{"class":"cc-browser-item cc-chrome"},[["a",{"class":"cc-browser-link","target":"_blank","rel":"nofollow","href":"https://itunes.apple.com/us/app/chrome-web-browser-by-google/id535886823"},[["textNode",{"text":"Chrome"}]]]]]]],["div",{"class":"cc-browsers android"},[["div",{"class":"cc-browser-item cc-chrome"},[["a",{"class":"cc-browser-link","target":"_blank","rel":"nofollow","href":"https://play.google.com/store/apps/details?id=com.android.chrome"},[["textNode",{"text":"Chrome"}]]]]],["div",{"class":"cc-browser-item cc-ff"},[["a",{"class":"cc-browser-link","target":"_blank","rel":"nofollow","href":"https://play.google.com/store/apps/details?id=org.mozilla.firefox"},[["textNode",{"text":"Firefox"}]]]]]]]],[["platform","class"]]],["td",{},[["textNode",{"text":"&nbsp;"}]]]]]]]]],["td",{},[["textNode",{"text":"&nbsp;"}]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("html5player_mc_banners", [["div",{"class":"ac-p-toggle-box &&0&& animated fadeIn user-state","data-component":""},[["a",{"href":"","class":"ac-p-banner-link"},[["img",{"class":"ac-p-banner-img large","src":"","alt":""},[],[["largeImg","src",true]]],["textNode",{"text":" "}],["img",{"class":"ac-p-banner-img small","src":"","alt":""},[],[["smallImg","src",true]]]],[["url","href",true]]]],[["cName","class"],["component","data-component",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("player_mobile_format_switcher", [["div",{"class":"mc-mobile-format-switcher"},[["div",{"class":"current"},[["i",{"class":"icon-setting"}],["textNode",{"text":" "}],["span",{},[["span",{},[],[["formatsData.current.height","__text",true]]],["textNode",{"text":"p"}]]],["textNode",{"text":" "}],["i",{"class":"arr icon-arrow-middle-left"}]]],["div",{"class":"list"},[["foreach",{"from":"","item":"format"},[["a",{"class":"item &&0&&","data-format-alias":""},[["span",{},[],[["format.height","__text",true]]],["textNode",{"text":"p"}]],[["format.alias","class"],["format.alias","data-format-alias",true]]]],[["formatsData.list","from",true]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_billinginfo_cancellation_success", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Thank you for being honest with me! "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center"},[["if",{"notempty":""},[["p",{},[["textNode",{"text":"Your subscription has been already cancelled and it is active up until "}],["span",{},[],[["user.expDate","__text",true,[{"name":"dateFormat","params":["%Y-%m-%d"]}],"env"]]],["textNode",{"text":"."}]]],["else",{},[["p",{},[["textNode",{"text":"I'm really gonna miss you! My billing team is going to process your request right away and you'll get a confirmation letter from CentroBill once your membership is cancelled."}]]]]]],[["isUserAlreadyCanceled","notempty",true,[{"name":"eq","params":["1"]}]]]],["p",{},[["textNode",{"text":"Hope to see you as my fan again some day, so please make sure to check back on my site and follow me on social networks to stay connected (you can find links on the home page of my site, even when not logged in)."}]]],["p",{},[["textNode",{"text":"Mwah!"}]]],["p",{},[["strong",{},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]]]]]]);
fox.registerTemplate("popup_billinginfo_cancellation_error", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Sorry, there was an error. "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center"},[["p",{},[["textNode",{"text":"Your request can not be processed at the moment. Please contact customer support."}]]]]]]);
fox.registerTemplate("popup_billinginfo_cancellation_confirm", [["div",{"class":"cancellation-confirm-popup"},[["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Please confirm membership cancellation. "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"class":"popup-content-wrapper _flex _col-n _c-h-center"},[["p",{},[["textNode",{"text":"Do you really want to stop being my fan? After your membership expires, you will lose all the upcoming updates in my fan zone. Won't you miss having access to your favorites and the content I've sent you via private messages?"}]]]]],["div",{"class":"popup-footer-wrapper _m-t-20"},[["button",{"class":"mc-common-button simple close _m-a-10","id":"on-cancel"},[["textNode",{"text":"Never mind, I'll stay"}]]],["textNode",{"text":" "}],["button",{"class":"mc-common-button submit primary _m-a-10"},[["textNode",{"text":"Cancel my subscription anyway"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_billinginfo_contact_success", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Your message was sent successfully!"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{},[["textNode",{"text":"The billing team will respond to your questions, comments and concerns as soon as possible. Talk to you soon!"}]]],["p",{},[["textNode",{"text":"CentroBill's office open hours are Monday to Friday from 8AM to 12AM and 1PM to 5PM CET."}]]],["p",{},[["textNode",{"text":"Thanks for being my fan,"}]]],["p",{},[["strong",{},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_billinginfo_renew_confirm", [["div",{"class":"renewal-confirm-popup popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Please confirm membership restore"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{},[["textNode",{"text":"I’m so happy that you changed your mind! Please confirm that you want to prolong your membership with the same subscription plan in order to retain access to my fan zone."}]]]]],["div",{"class":"popup-footer-wrapper multiple-btns"},[["button",{"class":"mc-common-button simple close","id":"cancel1"},[["textNode",{"text":"Cancel"}]]],["button",{"class":"mc-common-button ok","id":"ok"},[["textNode",{"text":"Restore my subscription"}]]]]]]]]);
fox.registerTemplate("popup_billinginfo_renew_success", [["div",{"class":"renewal-confirm-popup popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Subscription restored successfully"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{},[["textNode",{"text":"It's done! Your subscription is now active again, no subscription costs or rebill dates where changed. Let's pick up where we left off and spend some time together."}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"class":"mc-common-button simple close","id":"cancel1"},[["textNode",{"text":"Close"}]]]]]]]]);
fox.registerTemplate("popup_billinginfo_renew_error", [["div",{"class":"renewal-confirm-popup popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Subscription Renewal Error"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["if",{"notempty":""},[["p",{},[["textNode",{"text":"Please excuse us, but your subscription has already expired and can't be renewed. Please logout and create a new subscription via join page."}]]],["else",{},[["p",{},[["textNode",{"text":"Please excuse us, but the renewal request cannot be processed right now. Please try again in a few hours."}]]]]]],[["code","notempty",true,[{"name":"eq","params":["5008"]}]]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"class":"mc-common-button simple close","id":"cancel1"},[["textNode",{"text":"Cancel"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("ccpa_form", [["form",{"id":"ccpa-form"},[["div",{"class":"popup-content p-t p-b p-l p-r popup-ccpa-form"},[["div",{"class":"_auth-form-content"},[["div",{"class":"row-label _title"},[["textNode",{"text":"I would like"}]]],["label",{"for":"type","class":"mc-radiobutton _flex _row-n row"},[["input",{"checked":"","type":"radio","name":"optionAlias","value":"knowInformation","id":"knowInformation"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"label"},[["textNode",{"text":"to know what information is collected about me by ModelCentro. "}]]]]],["label",{"for":"transferData","class":"mc-radiobutton _flex _row-n row"},[["input",{"type":"radio","name":"optionAlias","value":"transferData","id":"transferData"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"rlabel"},[["textNode",{"text":"to receive a copy of the information collected about me by ModelCentro. "}]]]]],["label",{"for":"deleteInformation","class":"mc-radiobutton _flex _row-n row"},[["input",{"type":"radio","name":"optionAlias","value":"deleteInformation","id":"deleteInformation"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"rlabel"},[["textNode",{"text":"ModelCentro to delete the information collected about me. "}]]]]],["label",{"for":"prohibitInformation","class":"mc-radiobutton _flex _row-n row lastrow"},[["input",{"type":"radio","name":"optionAlias","value":"prohibitInformation","id":"prohibitInformation"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"rlabel"},[["textNode",{"text":"to prohibit ModelCentro to share information collected about me with third parties. "}]]]]],["if",{"empty":""},[["div",{"class":"_row email"},[["label",{"class":"row-label"},[["textNode",{"text":"Your email:"}]]],["div",{"class":"_base-input-wrapper"},[["input",{"type":"text","class":"_base-input mc-form-field","name":"email","placeholder":"Your message"}],["p",{"class":"_error-text"}]]]]]],[["member","empty",true]]],["div",{"class":"_row"},[["label",{"class":"row-label"},[["span",{},[["textNode",{"text":"Text message:"}]]]]],["div",{"class":"_base-input-wrapper"},[["input",{"type":"text","class":"_base-input mc-form-field","name":"comment","placeholder":"Your message"}],["p",{"class":"_error-text"}]]]]]]]]],["div",{"class":"popup-footer"},[["div",{"class":"buttons clearfix"},[["div",{"class":"fright"},[["a",{"class":"mc-btn btn-small btn-minor close"},[["span",{"data-fox-alias":"2"},[["textNode",{"text":"Cancel"}]]]]]]],["div",{"class":"fright"},[["button",{"type":"submit","id":"form-submit","class":"mc-btn btn-small btn-casual button-with-spinner with-loader white-spin"},[["span",{"data-fox-alias":"2"},[["textNode",{"text":"Submit Request"}]]]]]]]]]]]]]]);
fox.registerTemplate("ccpa_success_mc", [["div",{"class":"ui-dialog-content cookie-consent ccpa-form  p-l p-r p-b"},[["if",{"notempty":""},[["div",{"class":"textsuccess"},[["textNode",{"text":"Thank you! "}],["br"],["textNode",{"text":" Your request has been submitted."}],["br"],["textNode",{"text":" An account manager will contact you to confirm and finalize it."}]]],["else",{},[["div",{"class":"textsuccess"},[["textNode",{"text":"Thank you!"}],["br"],["textNode",{"text":" Your request has been submitted."}],["br"],["textNode",{"text":" The response will be sent to your email."}]]]]]],[["deleteInformation","notempty",true]]],["div",{"class":"_row _flex _r-h-justify sub-button"},[["button",{"type":"button","id":"success","class":"mc-btn btn-small btn-casual member"},[["textNode",{"text":"Okay"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_crowdfunding_confirm", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Donate"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper tip-me-confirm cf-confirm"},[["div",{"class":"msg-block"},[["div",{"class":"row"},[["div",{"class":"rowamount"},[["p",{},[["textNode",{"text":"Amount*"}]]],["div",{"class":"common-input"},[["input",{"type":"text","placeholder":"Amount*","name":"amount","class":"guiInput width100pr inputColor inputBgColor inputBorderColor"}],["div",{"class":"border"}]]]]],["div",{"class":"error-message"}]]]]],["if",{"empty":""},[["div",{"class":"msg-block"},[["div",{"class":"row"},[["div",{"class":"common-input"},[["input",{"type":"text","name":"login","placeholder":"Enter your nickname*","class":"guiInput width100pr inputColor inputBgColor inputBorderColor"}],["div",{"class":"border"}]]],["div",{"class":"error-message"}]]]]],["div",{"class":"msg-block"},[["div",{"class":"row"},[["div",{"class":"common-input"},[["input",{"type":"text","name":"email","placeholder":"Enter your Email*","class":"guiInput width100pr inputColor inputBgColor inputBorderColor"}],["div",{"class":"border"}]]],["div",{"class":"error-message"}]]]]]],[["id","empty",true,[],"member"]]],["div",{"class":"msg-block"},[["div",{"class":"common-input txtarea"},[["textarea",{"placeholder":"Add a personal message to me","class":"guiInput width100pr inputColor inputBgColor inputBorderColor","name":"message"}],["div",{"class":"border"}]]]]]]],["div",{"style":"display: none;","id":"biller-form-container"}],["div",{"class":"popup-footer-wrapper"},[["span",{"class":"mc-common-button confirm"},[["textNode",{"text":"Confirm"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_crowdfunding_payment_error", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Oops, something went wrong"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper tip-me-confirm"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"Your donation wasn't sent. Please try to re-load the page and try again or contact the customer support if the problem persists."}]]]]],["div",{"class":"popup-footer-wrapper"},[["span",{"class":"mc-common-button close"},[["textNode",{"text":"Ok"}]]]]]]);
fox.registerTemplate("popup_crowdfunding_payment_success", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Thank you "}],["span",{},[],[["name","__text",true]]],["textNode",{"text":"!"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper tip-me-confirm"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"I really appreciate your support, it makes me so inspired!"}]]]]],["div",{"class":"popup-footer-wrapper"},[["span",{"class":"mc-common-button close"},[["textNode",{"text":"Ok"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("gift_set_title", [["if",{"notempty":""},[["strong",{},[["textNode",{"text":"Summer set"}]]]],[["set","notempty",true,[{"name":"eq","params":["summer"]}]]]],["if",{"notempty":""},[["strong",{},[["textNode",{"text":"Love set"}]]]],[["set","notempty",true,[{"name":"eq","params":["love"]}]]]]]);
fox.registerTemplate("gifts_popup_list_row", [["if",{"empty":""},[["li",{"data-gid":"","class":"gift-item"},[["span",{"class":"gift-icon &&0&&"},[],[["alias","class"]]],["textNode",{"text":" "}],["strong",{"class":"gift-item-price"},[["textNode",{"text":"$"}],["span",{},[],[["price","__text",true]]]]]],[["id","data-gid",true]]],["else",{},[["li",{"class":"loading-gifts ls-title"},[["textNode",{"text":"loading gifts..."}]]]]]],[["loader","empty",true]]]]);
fox.registerTemplate("gifts_popup_container", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["strong",{},[["textNode",{"text":"SELECT A GIFT"}]]]]],["span",{"class":"icon-au_close-delete cross close"}],["ul",{"class":"gift-set-list"},[["if",{"empty":""},[["li",{"title":"Summer set","data-set-id":"summer","class":"gift-set active"},[["i",{"class":"ls-iconsummer_20"}]]]],[["valentineDay","empty",true]]],["li",{"title":"Love set","data-set-id":"love","class":"gift-set"},[["if",{"notempty":"","addclass":"active"},[],[["valentineDay","notempty",true]]],["i",{"class":"ls-iconlove_18"}]]]]]]],["div",{"class":"giftbox-wrapper popup-content-wrapper"},[["div",{"id":"gift-set-title","class":"gift-set-title"}],["ul",{"id":"gift-list-container","class":"gift-list"}]]],["div",{"class":"popup-footer-wrapper"},[["div",{"class":"gift-billing-hint"},[["strong",{},[["textNode",{"text":"Attention!"}]]],["textNode",{"text":" Gifts are billed individually to your credit card. "}]]],["button",{"id":"send-gift","class":"mc-common-button"},[["textNode",{"text":"Send a gift"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("upgrade_form_oneclick_error", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Upgrade error"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["textNode",{"text":" Can't upgrade already upgraded user. Please try to reload page. "}]]],["div",{"class":"popup-footer-wrapper"},[["button",{"class":"mc-common-button simple close"},[["textNode",{"text":"Close"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("paid_request_error", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Paid request error"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["textNode",{"text":" The attempt to send request resulted in an error. "}],["strong",{},[["textNode",{"text":"Error code: "}],["span",{},[],[["error","__text",true]]]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"close","class":"mc-common-button"},[["textNode",{"text":"Close"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_user_passwordrecoverysuccess", [["div",{"class":"cancellation-confirm-popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Password Retrieval"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{},[["textNode",{"text":"We`ve sent new password to your mail!"}]]]]],["div",{"class":"popup-footer-wrapper"},[["a",{"href":"/login","id":"password-recovery-login","class":"mc-common-button close"},[["textNode",{"text":"Ok"}]]]]]]]]);
fox.registerTemplate("popup_user_passwordchangesuccess", [["div",{"class":"cancellation-confirm-popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Password Change"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{},[["textNode",{"text":"Password has been successfuly changed!"}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"class":"mc-common-button close"},[["textNode",{"text":"Ok"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("site", [["html",{},[["head",{},[["title",{},[["span",{},[],[["site.title","__text",true,[],"env"]]]]],["meta",{"name":"description","content":""},[],[["site.description","content",true,[],"env"]]],["meta",{"name":"keywords","content":""}],["meta",{"http-equiv":"Content-Type","content":"text/html; charset=UTF-8"}],["meta",{"content":"utf-8","http-equiv":"encoding"}],["meta",{"name":"viewport","content":"width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"}],["link",{"rel":"icon","href":"require('../images/favicon.ico?skip-fox')","type":"image/x-icon"}],["script",{},[["textNode",{"text":" (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-TVLMBX7'); "}]]],["script",{"async":"","src":"https://www.googletagmanager.com/gtag/js?id=&&0&&"},[],[["seo.gaTags.0","src",false,[],"env"]]],["textNode",{"text":" "}],["script",{},[["textNode",{"text":" window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '"}],["span",{},[],[["seo.gaTags.0","__text",true,[],"env"]]],["textNode",{"text":"'); "}]]]]],["body",{},[["div",{"id":"notification-container"}],["div",{"class":"wrapper"}],["div",{"id":"liveshow-notification-container"}],["div",{"id":"cookie-banner-container"}],["script",{},[["textNode",{"text":" var timer; window.__blankPage = sendNotify; document.addEventListener('DOMContentLoaded', function () { timer = setTimeout(function () { if ('fox' in window && 'site' in fox) return false; sendNotify(); }, 30000); }); window.addEventListener('message', function(message) { if (message.data == 'fox_ready') { clearTimeout(timer); } }, false); function sendNotify(params) { clearTimeout(timer); params = typeof params === 'object' ? params : {}; if (params instanceof Error) { showMessageInHtml(params); params = { errorType: params.name, message: params.message, stack: params.stack }; } params.userAgent = navigator.userAgent; params.platform = navigator.platform; var xhr = new XMLHttpRequest(); var formData = new FormData(); formData.append('params', JSON.stringify(params)); xhr.open('POST', '/api/Site.NotifyAboutBlankPage', true); xhr.send(formData); } function showMessageInHtml(error) { var container = document.createElement('div'); container.style.color = 'red'; container.style.position = 'fixed'; container.style.padding = '30px'; container.style.left = '0'; container.style.top = '0'; var msg = document.createElement('pre'); msg.innerText = [ 'User agent: ' + window.navigator.userAgent, 'Message: ' + error.message, 'Stack: ' + error.stack ].join('\\n'); container.appendChild(msg); document.body.appendChild(container); } "}]]]]],["noscript",{},[["iframe",{"src":"https://www.googletagmanager.com/ns.html?id=GTM-TVLMBX7","height":"0","width":"0","style":"display:none;visibility:hidden"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("callme_widget_full", [["p",{"class":"text-color-1 custom-text","data-fox-alias":"callmeText"},[["textNode",{"text":"Want to hear my sexy voice? If the sign is green, give me a call! If its red, give me your number and I'll let you know once I'm available. "}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("free_gallery_photolist_item", [["div",{"data-id":"","id":"photo-&&1&&","class":"photo-item animated"},[["img",{"src":"","alt":"fhg - &&1&&- &&2&&"},[],[["url","src",true],["resource","alt"],["screenName","alt",false,[],"env"]]]],[["resource","data-id",true],["resource","id"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_freehostedgallery", [["div",{"id":"free-hosted-photos-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_freehostedvideos", [["div",{"id":"free-hosted-videos-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_gallery_fullscreenview", [["div",{"id":"gallery-fullscreen"},[["div",{"class":"gallery-fullscreen-hide","title":"Exit from fullscreen mode"}],["div",{"class":"gallery-fullscreen-stop-slide-show","style":"display: none;"},[["button",{"class":"gallery-btn"},[["span",{"class":"gallery-fullscreen-icon-stop"}],["textNode",{"text":"Stop slide show"}]]]]],["div",{"class":"gallery-fullscreen"}],["if",{"empty":""},[["div",{"class":"gallery-sidebar"},[["div",{"class":"gallery-toggle-arrow"},[["i",{"class":"icon-arrow-middle-left"}],["textNode",{"text":" "}],["i",{"class":"icon-arrow-middle-right"}]]],["div",{"class":"gallery-sidebar-content"},[["div",{"class":"gallery-sidebar-action-buttons"},[["div",{"class":"button-row clearfix slideshow-section"},[["div",{"class":"gallery-fullscreen-view-photo-counter"},[["span",{"class":"number count"},[["textNode",{"text":"10"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"of"}]]],["textNode",{"text":" "}],["span",{"class":"number all"},[["textNode",{"text":"210"}]]]]],["button",{"id":"start-slide-show","class":"gallery-btn"},[["span",{"class":"gallery-fullscreen-icon-play"}],["textNode",{"text":"Start slide show"}]]]]],["div",{"class":"button-row clearfix"},[["a",{"id":"download-photo","download":"","class":"gallery-btn","title":"Download photo","target":"_blank","rel":"nofollow"},[["span",{"class":"gallery-fullscreen-icon download"}]]],["textNode",{"text":" "}],["button",{"id":"show-real-pixel","class":"gallery-btn"},[["span",{"class":"photo-scale"},[["textNode",{"text":"1:1"}]]],["textNode",{"text":" Show original size"}]]]]],["div",{"class":"button-row clearfix"},[["div",{"id":"gallery-favorite","class":"bookmark social-row","data-target-id":""},[],[["id","data-target-id",true]]],["div",{"id":"gallery-rating","class":"rating social-row","data-target-id":""},[],[["id","data-target-id",true]]]]]]],["div",{"class":"gallery-sidebar-tipme-form clearfix"}],["div",{"id":"gallery-comments","class":"gallery-sidebar-comments-container comments-block reviews social-row","data-target-id":""},[],[["id","data-target-id",true]]],["div",{"class":"gallery-sidebar-key-control"},[["div",{"class":"gallery-key-control"},[["span",{"class":"key-hint-text"},[["textNode",{"text":"Prev photo"}]]],["div",{"data-keycode":"37","class":"key normal"},[["textNode",{"text":"&larr;"}]]],["div",{"class":"inactive"},[["div",{"class":"key"},[["textNode",{"text":"&uarr;"}]]],["div",{"class":"key"},[["textNode",{"text":"&darr;"}]]]]],["div",{"data-keycode":"39","class":"key normal"},[["textNode",{"text":"&rarr;"}]]],["span",{"class":"key-hint-text"},[["textNode",{"text":"Next photo"}]]]]]]]]]]]],[["hideSidebar","empty",true]]],["div",{"class":"gallery-hint-controll"},[["div",{"class":"gallery-key-control"},[["span",{"class":"key-hint-text"},[["textNode",{"text":"Prev photo"}]]],["div",{"data-keycode":"37","class":"key normal"},[["textNode",{"text":"&larr;"}]]],["div",{"class":"inactive"},[["div",{"class":"key"},[["textNode",{"text":"&uarr;"}]]],["div",{"class":"key"},[["textNode",{"text":"&darr;"}]]]]],["div",{"data-keycode":"39","class":"key normal"},[["textNode",{"text":"&rarr;"}]]],["span",{"class":"key-hint-text"},[["textNode",{"text":"Next photo"}]]]]]]],["div",{"style":"display: none;","class":"gallery-real-pixels-view"}]]]]);
fox.registerTemplate("sitepage_gallery_fullscreenview_image", [["div",{"class":"gallery-full-image animated"}],["div",{"style":"display:none;","class":"gallery-preloader"},[["div",{"class":"spin-wrap back-2"},[["span",{"class":"loading-text","data-fox-alias":"1"},[["textNode",{"text":"Loading"}]]],["div",{"class":"spinner"}]]]]],["div",{"style":"display: none;","class":"gallery-img-load-error"}]]);
fox.registerTemplate("sitepage_gallery_fullscreenview_rating", [["button",{"class":"gallery-btn half"},[["span",{"class":"part-1 social-row rate","title":"I like this!","data-value":"5","data-target-id":""},[["if",{"empty":"","addattr":"href:&&1&&"},[["else",{"addattr":"data-target-id:&&0&&"},[],[["targetId","__internal"]]]],[["id","empty",true,[],"member"],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["span",{"class":"gallery-fullscreen-icon photo-rate-good"}],["textNode",{"text":" "}],["span",{},[],[["good","__text",true,[{"name":"toInt","params":[]}]]]],["textNode",{"text":" "}]],[["targetId","data-target-id",true]]],["textNode",{"text":" "}],["span",{"class":"part-2 social-row rate","title":"I dislike this!","data-value":"0","data-target-id":""},[["textNode",{"text":" "}],["span",{},[],[["bad","__text",true,[{"name":"toInt","params":[]}]]]],["textNode",{"text":" "}],["if",{"empty":"","addattr":"href:&&1&&"},[["else",{"addattr":"data-target-id:&&0&&"},[],[["targetId","__internal"]]]],[["id","empty",true,[],"member"],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["span",{"class":"gallery-fullscreen-icon photo-rate-bad"}]],[["targetId","data-target-id",true]]]]]]);
fox.registerTemplate("sitepage_gallery_fullscreenview_favorite", [["button",{"class":"btn-favorite fav-link bookmark gallery-btn social-row","title":"Add to favorite","data-target-id":""},[["if",{"notempty":"","addclass":"checked"},[],[["isFavorite","notempty",true]]],["if",{"empty":"","addattr":"href:&&1&&"},[],[["id","empty",true,[],"member"],["siteProps.joinUrl","__internal",false,[],"env"]]],["span",{"class":"gallery-fullscreen-icon favorite"}]],[["targetId","data-target-id",true]]]]);
fox.registerTemplate("sitepage_gallery_fullscreenview_social_comments_addform", [["if",{"notempty":""},[["form",{"class":"add-review","action":"#","method":"post"},[["div",{"class":"gallery-comments-form"},[["div",{"class":"gallery-input"},[["textarea",{"type":"text","name":"comment","placeholder":"Write a comment...","rows":"10"}]]],["button",{"id":"addpost-button","class":"gallery-btn filled post-comment"},[["textNode",{"text":"post"}]]]]]]]],[["id","notempty",true,[],"member"]]]]);
fox.registerTemplate("sitepage_gallery_fullscreenview_social_comment", [["div",{"class":"comment-item"},[["div",{"class":"comment-info"},[["span",{},[],[["name","__text",true]]],["textNode",{"text":" wrote on "}],["span",{},[],[["date","__text",true,[{"name":"dateFormat","params":["%d %b %Y at %I-%M %P"]}]]]]]],["div",{"class":"comment-body"},[["span",{},[],[["comment","__text",true]]]]]]]]);
fox.registerTemplate("sitepage_gallery_fullscreenview_social_comments_grid", [["div",{"class":"reviews-list gallery-comments-view"}],["div",{"id":"comments-pager"}]]);
fox.registerTemplate("sitepage_gallery_fullscreenview_social_comment_scene", [["div",{"class":"reviews-actions"},[["div",{"class":"gallery-comments-total"},[["textNode",{"text":"COMMENTS"}],["sup",{"class":"count"},[["span",{},[],[["total","__text",true]]]]]]]]],["div",{"class":"reviews-actions-block"},[["if",{"notempty":"","addclass":"show-reviews"},[],[["show","notempty",true]]],["div",{"class":"addreview-container social-row","data-target-id":""},[],[["targetId","data-target-id",true]]],["div",{"class":"_reviews"}]]]]);
fox.registerTemplate("sitepage_gallery_fullscreenview_cutted", [["div",{"id":"gallery-fullscreen"},[["div",{"class":"gallery-fullscreen-hide","title":"Exit from fullscreen mode"}],["div",{"class":"gallery-fullscreen-stop-slide-show","style":"display: none;"},[["button",{"class":"gallery-btn"},[["span",{"class":"gallery-fullscreen-icon-stop"}],["textNode",{"text":"Stop slide show"}]]]]],["div",{"class":"gallery-fullscreen"}],["div",{"style":"display:none;","class":"gallery-preloader"},[["div",{"class":"big-preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]],["div",{"style":"display: none;","class":"gallery-real-pixels-view"}]]]]);
fox.registerTemplate("sitepage_gallery_fullscreenview_cutted_for_blogpost", [["div",{"id":"gallery-fullscreen"},[["div",{"class":"gallery-fullscreen-hide","title":"Exit from fullscreen mode"}],["div",{"class":"gallery-fullscreen-stop-slide-show","style":"display: none;"},[["button",{"class":"gallery-btn"},[["span",{"class":"gallery-fullscreen-icon-stop"}],["textNode",{"text":"Stop slide show"}]]]]],["div",{"class":"gallery-fullscreen gallery-fullscreen-blog"}],["div",{"style":"display:none;","class":"gallery-preloader"},[["div",{"class":"big-preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]],["div",{"style":"display: none;","class":"gallery-real-pixels-view"}]]]]);
fox.registerTemplate("sitepage_gallery_photolist_item", [["div",{"data-id":"","id":"photo-&&1&&","class":"photo-item animated"},[["if",{"notempty":""},[["img",{"data-src":"","alt":"","class":"lazyload"},[],[["url","data-src",true],["altTag","alt",true]]],["else",{},[["img",{"data-src":"","alt":"photo-&&1&&-&&2&&","class":"lazyload"},[],[["url","data-src",true],["id","alt"],["screenName","alt",false,[],"env"]]]]]],[["altTag","notempty",true]]]],[["id","data-id",true],["id","id"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_gallery_fullscreen_view", [["div",{"class":"gallery-input"},[["i",{"class":"icon-gift"}],["textNode",{"text":" "}],["input",{"id":"tip-amount","type":"text","placeholder":"$2"}]]],["button",{"id":"tip-model","class":"gallery-btn filled tipme"},[["textNode",{"text":"tip"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("legaldocs_2257", [["div",{"data-fox-alias":"2257Text"},[["textNode",{"text":" "}],["span",{},[],[["siteUrl","__text",true]]],["br"],["textNode",{"text":" 18 U.S.C. § 2257 Statement "}],["p",{},[["textNode",{"text":"Any actual human beings depicted in images or videos appearing on the website located at "}],["span",{},[],[["siteUrl","__text",true]]],["textNode",{"text":" (the \""}],["strong",{},[["textNode",{"text":"Website"}]]],["textNode",{"text":"\") were at least 18-years old at the time those images or videos were produced. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Exemption: Content Produced by Third Parties"}]]]]],["p",{},[["textNode",{"text":"The operator of the Website is not the \"producer\" of any depictions of actual or simulated sexually explicit conduct that may appear on the Website. The operator of the Website limits its handling of this content, and only performs the activities of transmission, storage, retrieval, hosting, or formatting of material that may depict sexually explicit conduct, all of which material appears on the Website as the result of actions taken by third-party users of the Website. All parts of the Website that contain user-generated material are under the control of the relevant user, for whom the Website is provided as an online service by the operator. In accordance with 18 U.S.C. § 2257(h)(2)(B)(v) and 47 U.S.C. § 230(c), the operator of the Website may delete materials appearing on the Website as the result of actions taken by the Website’s users, which materials are considered, in the operator’s sole discretion, to be indecent, obscene, defamatory, or inconsistent with the polices and terms of use for the Website. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Exemption: Content Produced by Website Operator"}]]]]],["p",{},[["textNode",{"text":"To the extent that any images or videos appear on the Website, for which the operator of the Website may be considered the \"producer,\" those images and videos are exempt from the requirements of 18 U.S.C. § 2257 and 28 C.F.R. Part 75 for one or more of the following reasons: (1) the produced images or videos do not portray any sexually explicit conduct defined in 18 U.S.C. § 2256(2)(A); (2) the produced images or videos do not portray depictions of the genitals or pubic area created after July 27, 2006; (3) the produced images or videos do not portray simulated sexually explicit activity occurring after the effective date of 18 U.S.C. § 2257A; or (4) the produced images or videos were created before July 3, 1995."}]]],["p",{},[["strong",{},[["textNode",{"text":"Designated Records Custodian"}]]]]],["p",{},[["textNode",{"text":"Without limiting in any way the applicability of the above-stated exemptions, the operator of the Website has designated the custodian, whose address appears below, to be the keeper of original records described in 18 U.S.C. § 2257 and 28 C.F.R. Part 75 for all materials appearing on the Website that fall in the following categories: (1) marketing and advertising materials that contain visual depictions of actual or simulated sexually explicit conduct, which materials have been acquired or created by the Website’s operator to promote the Website; or (2) materials that are not exempt, as described above."}]]],["p",{},[["textNode",{"text":"The named earlier records and their custodian can be found at the following location:"}]]],["p",{},[["strong",{},[["textNode",{"text":"Custodian of Records"}]]],["textNode",{"text":": "}],["br"],["textNode",{"text":" 31 Evagorou Street"}],["br"],["textNode",{"text":" Evagoras Complex, Office 54,"}],["br"],["textNode",{"text":" 1066, Nicosia. Cyprus"}],["br"]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("legal_ccpa_doc", [["div",{"class":"col sp-left"},[["p",{"class":"title"},[["textNode",{"text":"Effective Date: February 18, 2020 "}]]],["p",{"class":"title"},[["textNode",{"text":"Last Revised: February 18, 2020 "}]]],["div",{"class":"sp-part","id":"part_0"},[["div",{"class":"padd-left"},[["p",{},[["textNode",{"text":"This privacy notice for California residents supplements the information contained in "}],["span",{},[],[["siteName","__text",true]]],["textNode",{"text":" "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":" privacy policy"}]]],["textNode",{"text":" and applies solely to all visitors, users, and others who reside in California (“consumers” or “you”). We adopt this notice to comply with the California Consumer Privacy Act of 2018 (CCPA) and any terms defined in the CCPA have the same meaning when used in this Notice. "}]]]]]]],["div",{"class":"sp-part","id":"part_1"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Information We Collect"}]]],["p",{},[["textNode",{"text":"Our Website collects information that identifies, relates to, describes, references, is reasonably capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer, household, or device (“personal information”). Personal information does not include: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Publicly available information from government records. "}]]],["li",{},[["textNode",{"text":" Deidentified or aggregated consumer information. "}]]],["li",{},[["textNode",{"text":" Information excluded from the CCPA’s scope, like: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["textNode",{"text":" health or medical information covered by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and the California Confidentiality of Medical Information Act (CMIA) or clinical trial data; and "}]]],["li",{},[["textNode",{"text":" personal information covered by certain sector-specific privacy laws, including the Fair Credit Reporting Act (FCRA), the Gramm-Leach-Bliley Act (GLBA) or California Financial Information Privacy Act (FIPA), and the Driver’s Privacy Protection Act of 1994. "}]]]]],["p"]]]]],["p",{},[["textNode",{"text":"In particular, our Website has collected the following categories of personal information from its consumers within the last 12 months: "}]]],["div",{"class":"wrapper-cookie-table"},[["table",{"class":"list cookie-table"},[["tr",{},[["th",{},[["textNode",{"text":"Category"}]]],["th",{},[["textNode",{"text":"Examples"}]]],["th",{},[["textNode",{"text":"Collected"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"A. Identifiers."}]]],["td",{},[["textNode",{"text":" A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, Social Security number, driver’s license number, passport number, or other similar identifiers. "}]]],["td",{},[["textNode",{"text":"YES "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" B. Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)). "}]]],["td",{},[["textNode",{"text":" A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver’s license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information, medical information, or health insurance information."}],["br"],["textNode",{"text":" Some personal information included in this category may overlap with other categories. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" C. Protected classification characteristics under California or federal law. "}]]],["td",{},[["textNode",{"text":" Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth and related medical conditions), sexual orientation, veteran or military status, genetic information (including familial genetic information). "}]]],["td",{},[["textNode",{"text":" NO "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" D. Commercial information. "}]]],["td",{},[["textNode",{"text":" Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies. "}]]],["td",{},[["textNode",{"text":"YES "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" E. Biometric information. "}]]],["td",{},[["textNode",{"text":" Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other identifier or identifying information, such as fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" F. Internet or other similar network activity. "}]]],["td",{},[["textNode",{"text":" Browsing history, search history, information on a consumer’s interaction with a website, application, or advertisement. "}]]],["td",{},[["textNode",{"text":" YES"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" G. Geolocation data. "}]]],["td",{},[["textNode",{"text":" Physical location or movements. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" H. Sensory data. "}]]],["td",{},[["textNode",{"text":" Audio, electronic, visual, thermal, olfactory, or similar information. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" I. Professional or employment-related information. "}]]],["td",{},[["textNode",{"text":" Current or past job history or performance evaluations. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" J. Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)). "}]]],["td",{},[["textNode",{"text":" Education records directly related to a student maintained by an educational institution or party acting on its behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, or student disciplinary records. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" K. Inferences drawn from other personal information. "}]]],["td",{},[["textNode",{"text":" Profile reflecting a person’s preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes. "}]]],["td",{},[["textNode",{"text":" NO"}]]]]]]]]],["p",{},[["textNode",{"text":"Our Website obtains the categories of personal information listed above from the following categories of sources: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Directly from you. For example, from forms you complete or products and services you purchase. "}]]],["li",{},[["textNode",{"text":" Indirectly from you. For example, from observing your actions on our Website. "}]]],["li",{},[["textNode",{"text":" From third parties. For example, from our business partners. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Use of Personal Information "}]]]]],["p",{},[["textNode",{"text":"We may use or disclose the personal information we collect for one or more of the following purposes: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" To fulfill or meet the reason you provided the information. For example, if you share your name and contact information to ask a question about our products or services, we will use that personal information to respond to your inquiry. If you provide your personal information to purchase a product or service, we will use that information to process your payment. We may also save your information to facilitate new product orders. "}]]],["li",{},[["textNode",{"text":" To provide, support, personalize, and develop our Website, products, and services. "}]]],["li",{},[["textNode",{"text":" To create, maintain, customize, and secure your account with us. "}]]],["li",{},[["textNode",{"text":" To process your requests, purchases, transactions, and payments and prevent transactional fraud. "}]]],["li",{},[["textNode",{"text":" To provide you with support and to respond to your inquiries, including to investigate and address your concerns and monitor and improve our responses. "}]]],["li",{},[["textNode",{"text":" To personalize your Website experience and to deliver content and product and service offerings relevant to your interests, including targeted offers and ads through our Website, third-party sites, and via email or text message (with your consent, where required by law). "}]]],["li",{},[["textNode",{"text":" To help maintain the safety, security, and integrity of our Website, products and services, databases and other technology assets, and business. "}]]],["li",{},[["textNode",{"text":" For testing, research, analysis, and product development, including to develop and improve our Website, products, and services. "}]]],["li",{},[["textNode",{"text":"To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations. "}]]],["li",{},[["textNode",{"text":" As described to you when collecting your personal information or as otherwise stated in the CCPA. "}]]],["li",{},[["textNode",{"text":" To evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by us about our Website users is among the assets transferred. "}]]]]],["p",{},[["textNode",{"text":"We will not collect additional categories of personal information or use the personal information we collected for materially different, unrelated, or incompatible purposes without providing you notice. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Sharing Personal Information "}]]]]],["p",{},[["textNode",{"text":"We may disclose your personal information to a third party for a business purpose. When we disclose personal information for a business purpose, we enter a contract that describes the purpose and requires the recipient to both keep that personal information confidential and not use it for any purpose except performing the contract."}]]],["p",{},[["textNode",{"text":"We share your personal information with the following categories of third parties:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Service providers. "}]]],["li",{},[["textNode",{"text":" Internet cookie data recipients, like Google Analytics. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Disclosures of Personal Information for a Business Purpose "}]]]]],["p",{},[["textNode",{"text":"In the preceding 12 months, Company has disclosed the following categories of personal information for a business purpose: "}]]],["p",{"class":"pl-20"}],["p",{},[["textNode",{"text":" Category A: Identifiers."}]]],["p",{},[["textNode",{"text":" Category F: Internet or other similar network activity. "}]]],["p"],["p",{},[["textNode",{"text":"We disclose your personal information for a business purpose to the following categories of third parties: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Service providers. "}]]],["li",{},[["textNode",{"text":" Internet cookie data recipients, like Google Analytics. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Sales of Personal Information "}]]]]],["p",{},[["textNode",{"text":"In the preceding 12 months, Company had not sold personal information. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Your Rights and Choices "}]]]]],["p",{},[["textNode",{"text":"The CCPA provides consumers (California residents) with specific rights regarding their personal information. This section describes your CCPA rights and explains how to exercise those rights. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Access to Specific Information and Data Portability Rights "}]]]]],["p",{},[["textNode",{"text":"You have the right to request that we disclose certain information to you about our collection and use of your personal information over the past 12 months. Once we receive and confirm your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will disclose to you: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" The categories of personal information we collected about you. "}]]],["li",{},[["textNode",{"text":" The categories of sources for the personal information we collected about you. "}]]],["li",{},[["textNode",{"text":" Our business or commercial purpose for collecting or selling that personal information. "}]]],["li",{},[["textNode",{"text":" The categories of third parties with whom we share that personal information. "}]]],["li",{},[["textNode",{"text":" The specific pieces of personal information we collected about you (also called a data portability request). "}]]],["li",{},[["textNode",{"text":" If we sold or disclosed your personal information for a business purpose, two separate lists disclosing: "}],["ul",{"class":"dotted-list nextlevel"},[["li",{},[["textNode",{"text":" sales, identifying the personal information categories that each category of recipient purchased; "}]]],["li",{},[["textNode",{"text":" disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained. "}]]]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Deletion Request Rights "}]]]]],["p",{},[["textNode",{"text":"You have the right to request that we delete any of your personal information that we collected from you and retained, subject to certain exceptions. Once we receive and confirm your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will delete (and direct our service providers to delete) your personal information from our records, unless an exception applies. "}]]],["p",{},[["textNode",{"text":"We may deny your deletion request if retaining the information is necessary for us or our service providers to: "}]]],["ul",{"class":"nextlevel numeric"},[["li",{},[["textNode",{"text":" 1. Complete the transaction for which we collected the personal information, provide a good or service that you requested, take actions reasonably anticipated within the context of our ongoing business relationship with you, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, or otherwise perform our contract with you. "}]]],["li",{},[["textNode",{"text":" 2. Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities. "}]]],["li",{},[["textNode",{"text":" 3. Debug products to identify and repair errors that impair existing intended functionality. "}]]],["li",{},[["textNode",{"text":" 4. Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or exercise another right provided for by law. "}]]],["li",{},[["textNode",{"text":" 5. Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 et. seq.). "}]]],["li",{},[["textNode",{"text":" 6. Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when the information’s deletion may likely render impossible or seriously impair the research’s achievement, if you previously provided informed consent. "}]]],["li",{},[["textNode",{"text":" 7. Enable solely internal uses that are reasonably aligned with consumer expectations based on your relationship with us. "}]]],["li",{},[["textNode",{"text":" 8. Comply with a legal obligation. "}]]],["li",{},[["textNode",{"text":" 9. Make other internal and lawful uses of that information that are compatible with the context in which you provided it. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Exercising Access, Data Portability, and Deletion Rights"}]]]]],["p",{},[["textNode",{"text":"To exercise the access, data portability, and deletion rights described above, please submit a verifiable consumer request to us by either: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Emailing us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]]]],["li",{},[["textNode",{"text":" Visiting "}],["a",{"show-popup":"","class":"show-popup"},[["textNode",{"text":" CCPA"}]]]]]]],["p",{},[["textNode",{"text":"Only you, or someone legally authorized to act on your behalf, may make a verifiable consumer request related to your personal information. You may also make a verifiable consumer request on behalf of your minor child. "}]]],["p",{},[["textNode",{"text":"You may only make a verifiable consumer request for access or data portability twice within a 12-month period. The verifiable consumer request must: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Provide sufficient information that allows us to reasonably verify you are the person about whom we collected personal information or an authorized representative. "}]]],["li",{},[["textNode",{"text":" Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it. "}]]]]],["p",{},[["textNode",{"text":"We cannot respond to your request or provide you with personal information if we cannot verify your identity or authority to make the request and confirm the personal information relates to you. "}]]],["p",{},[["textNode",{"text":"Making a verifiable consumer request does not require you to create an account with us. "}]]],["p",{},[["textNode",{"text":"We will only use personal information provided in a verifiable consumer request to verify the requestor’s identity or authority to make the request. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Response Timing and Format "}]]]]],["p",{},[["textNode",{"text":"We endeavor to respond to a verifiable consumer request within 45 days of its receipt. If we require more time (up to 45 days), we will inform you of the reason and extension period in writing."}]]],["p",{},[["textNode",{"text":"If you have an account with us, we will deliver our written response to that account. If you do not have an account with us, we will deliver our written response by mail or electronically, at your option."}]]],["p",{},[["textNode",{"text":"Any disclosures we provide will only cover the 12-month period preceding the verifiable consumer request’s receipt. The response we provide will also explain the reasons we cannot comply with a request, if applicable. For data portability requests, we will select a format to provide your personal information that is readily useable and should allow you to transmit the information from one entity to another entity without hindrance."}]]],["p",{},[["textNode",{"text":"We do not charge a fee to process or respond to your verifiable consumer request unless it is excessive, repetitive, or manifestly unfounded. If we determine that the request warrants a fee, we will tell you why we made that decision and provide you with a cost estimate before completing your request."}]]],["p",{},[["strong",{},[["textNode",{"text":"Non-Discrimination "}]]]]],["p",{},[["textNode",{"text":"We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":" Deny you goods or services. "}]]],["li",{},[["textNode",{"text":" Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties. "}]]],["li",{},[["textNode",{"text":" Provide you a different level or quality of goods or services. "}]]],["li",{},[["textNode",{"text":" Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services. "}]]]]],["p",{},[["textNode",{"text":"However, we may offer you certain financial incentives permitted by the CCPA that can result in different prices, rates, or quality levels. Any CCPA-permitted financial incentive we offer will reasonably relate to your personal information’s value and contain written terms that describe the program’s material aspects. Participation in a financial incentive program requires your prior opt in consent, which you may revoke at any time. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Other California Privacy Rights"}]]]]],["p",{},[["textNode",{"text":"California’s “Shine the Light” law (Civil Code Section § 1798.83) permits users of our Website that are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make that request, please send an email to "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":". "}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to Our Privacy Notice"}]]]]],["p",{},[["textNode",{"text":"We reserve the right to amend this privacy notice at our discretion and at any time. When we make changes to this privacy notice, we will post the updated notice on the Website and update the notice’s effective date. "}],["strong",{},[["textNode",{"text":"Your continued use of our Website following the posting of changes constitutes your acceptance of such changes"}]]],["textNode",{"text":". "}]]],["p",{},[["strong",{},[["textNode",{"text":"Contact Information "}]]]]],["p",{},[["textNode",{"text":"If you have any questions or comments about this notice, the ways in which Centro Publisher Limited collects and uses your information described below and in the "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":", your choices and rights regarding that use, or wish to exercise your rights under California law, please do not hesitate to contact us at: "}]]],["p",{"class":"pl-20"}],["p",{},[["strong",{},[["textNode",{"text":"Website:"}]]],["textNode",{"text":" "}],["a",{"target":"_blank","href":"https://support.modelcentro.com/hc/en-us/requests/new"},[["textNode",{"text":" support.modelcentro.com "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Email:"}]]],["textNode",{"text":" "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":"privacy@modelcentro.com"}]]]]],["p"]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("legaldocs_cookie_table", [["p",{"class":"title"},[["textNode",{"text":"Last Modified: July 9, 2018"}]]],["p",{},[["strong",{},[["textNode",{"text":"Cookies Used on "}],["span",{},[],[["siteName","__text",true]]],["strong"]]]]],["p",{},[["textNode",{"text":" The following table lists all cookies potentially in use on the "}],["span",{},[],[["siteName","__text",true]]],["textNode",{"text":" website. We will update this table as our website changes and evolves, so please check back frequently to review any new cookie uses. Visit our "}],["a",{"href":"/cookie-policy"},[["textNode",{"text":"Cookie Policy"}]]],["textNode",{"text":" for more information and choices about our cookie use, including our contact information and complaint procedures. "}]]],["p",{"class":"wrapper-cookie-table"},[["table",{"class":"list cookie-table"},[["thead",{},[["tr",{},[["th",{},[["textNode",{"text":"Cookie Category"}]]],["th",{},[["textNode",{"text":"Cookie Name and Owner"}]]],["th",{},[["textNode",{"text":"Purpose"}]]],["th",{},[["textNode",{"text":"Expiry"}]]],["th",{},[["textNode",{"text":"Type"}]]]]]]],["tbody",{},[["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":"exo_uid "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Security cookie used to prevent unauthorized access or disclosure of the user account. In all cases, these cookies do not store any information that makes you personally identifiable to us."}]]],["td",{},[["textNode",{"text":"Session"}]]],["td",{},[["textNode",{"text":"HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":"__ax "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Security cookie used to prevent unauthorized access or disclosure of the user account. In all cases, these cookies do not store any information that makes you personally identifiable to us."}]]],["td",{},[["textNode",{"text":"1 year"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":"foxref "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Identifies an affiliate account that referred you to the website."}]]],["td",{},[["textNode",{"text":"3 days"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":"foxrefurl "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Identifies a website that referred you to the web page."}]]],["td",{},[["textNode",{"text":"3 days"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":"foxTrack "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Used to store information about what time your current visit occurred."}]]],["td",{},[["textNode",{"text":"1 day"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":"foxVisitor "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Used to store information about what time your current visit occurred."}]]],["td",{},[["textNode",{"text":"30 minutes"}]]],["td",{},[["textNode",{"text":"HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":"user_auth "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Identifies the user and allows authentication to the server."}]]],["td",{},[["textNode",{"text":"24 hours"}]]],["td",{},[["textNode",{"text":"HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":"io "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Allows the provision of enhancing functionality and personalization, such as file uploading."}]]],["td",{},[["textNode",{"text":"Session"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":"referers "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Used to store information, such as what time your current visit occurred, whether you have been to the website before, and what website referred you to the web page."}]]],["td",{},[["textNode",{"text":"1 year"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":"RNLBSERVERID "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Used to make sure visitor page requests are routed to the same server."}]]],["td",{},[["textNode",{"text":"Session"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":"splash "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Age verification confirmation cookie"}]]],["td",{},[["textNode",{"text":"Session"}]]],["td",{},[["textNode",{"text":"HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":"notifyFrom "}],["br"],["textNode",{"text":" ModelCentro"}]]],["td",{},[["textNode",{"text":"Used for new content and related events on-site notifications."}]]],["td",{},[["textNode",{"text":"Session"}]]],["td",{},[["textNode",{"text":"HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":"_gat "}],["br"],["textNode",{"text":" _gat_tracker0"}],["br"],["textNode",{"text":"_gat_tracker1"}],["br"],["textNode",{"text":"Google Analytics"}]]],["td",{},[["textNode",{"text":"Used by Google Analytics to throttle request rate."}]]],["td",{},[["textNode",{"text":"Session"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":"_gid "}],["br"],["textNode",{"text":" Google Analytics"}]]],["td",{},[["textNode",{"text":"Registers a unique ID that is used to generate statistical data on how the visitor uses the website."}]]],["td",{},[["textNode",{"text":"1 day"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":"_ga "}],["br"],["textNode",{"text":" Google Analytics"}]]],["td",{},[["textNode",{"text":"Registers a unique ID that is used to generate statistical data on how the visitor uses the website."}]]],["td",{},[["textNode",{"text":"2 years"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":"RNLBSERVERID"}],["br"],["textNode",{"text":" ec-small.centrofiles.com "}],["br"],["textNode",{"text":"ec-large.centrofiles.com "}],["br"],["textNode",{"text":"ec-st.centrofiles.com "}]]],["td",{},[["textNode",{"text":"Content Delivery Network cookie which is required in order to provide visitor with the best content delivery speed and quality."}]]],["td",{},[["textNode",{"text":"Session"}]]],["td",{},[["textNode",{"text":"HTTP Cookie"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("legaldocs_cookie_policy", [["p",{"class":"title"},[["textNode",{"text":"Last Modified: July 9, 2018"}]]],["p",{},[["textNode",{"text":"Cookies are small files of letters and numbers stored on your browser or device that enable the cookie owner to recognize the device when it visits websites or uses online services. The website you visit may set cookies directly, known as first-party cookies, or may trigger cookies set by other domain names, known as third-party cookies. While we may automatically use some cookies that are strictly necessary to provide the services you request or enable communications, we request your consent for all our other cookie uses."}]]],["p",{},[["strong",{},[["textNode",{"text":"Types of Cookies We Use"}],["strong"]]]]],["p",{},[["textNode",{"text":"We may use the following types of cookies: "}],["ul",{},[["li",{},[["strong",{},[["textNode",{"text":" Strictly necessary cookies"}]]],["textNode",{"text":". Our website requires the use of these cookies to properly operate or provide necessary functions relating to the services you request. They include, for example, cookies enabling you to securely log into our website, use a shopping cart, or purchase products or a VIP membership. You can set your browser to block or alert you about these cookies, but some parts of our website may not work then. "}]]],["li",{},[["strong",{},[["textNode",{"text":"Analytical/performance cookies"}]]],["textNode",{"text":". These cookies allow us and our third-party service providers to recognize and count the number of visitors and to see how visitors move around our website when they are using it. This helps us improve how our website works by, for example, ensuring that users can easily find what they need on our website. These cookies generate aggregate statistics that are not associated with an individualized profile. If you do not allow these cookies, we will not know when you have visited our website. "}]]],["li",{},[["strong",{},[["textNode",{"text":"Functionality cookies"}]]],["textNode",{"text":". These cookies enable helpful but non-essential website functions that improve your website experience. By recognizing you when you return to our website, they may, for example, allow us to personalize our content for you, greet you by name, or remember your preferences (for example, your choice of language or region). These cookies may enable visitor identification over time, but not across different websites. If you do not allow these cookies, some or all our website’s functionalities may not function properly. "}]]],["li",{},[["strong",{},[["textNode",{"text":"Advertising, tracking, or targeting cookies"}]]],["textNode",{"text":". These cookies enable different advertising related functions. They may allow us to record information about your visit to our website, such as pages visited, links followed, and videos viewed so we can make our website and the advertising displayed on it more relevant to your interests. These cookies may enable visitor identification over time, but not across different websites. "}]]],["li",{},[["strong",{},[["textNode",{"text":"Third-party cookies"}]]],["textNode",{"text":". Our website may contain helpful but non-essential features or plug-ins enabling third-party services that use cookies, such as social network connectors, advertising networks, or web traffic analysis services. These cookies may enable visitor identification across websites and over time. We do not control the third party’s use of those cookies. Please review each party’s cookie disclosure before consenting to this use category. "}]]]]]]],["p",{},[["textNode",{"text":" Our "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":" describes our practices for any personal data that our first-party cookies collect, store, or use. "}]]],["p",{},[["textNode",{"text":"Except for strictly necessary cookies, all first-party cookies set by this site will expire no later than two years after your last website visit. Third-party cookie expiration periods are set by their respective owners."}]]],["p",{},[["textNode",{"text":"Please see our "}],["a",{"href":"/cookie-table"},[["textNode",{"text":"Cookie Table"}]]],["textNode",{"text":" for a list of the individual first-party and third-party cookies potentially used on this site and their specific purposes."}]]],["p",{},[["strong",{},[["textNode",{"text":"Cross-Border Data Transfers"}]]]]],["p",{},[["textNode",{"text":"The cookies we use may process, store, or transfer personal data in and to a country outside your own, with privacy laws that provide different, possibly lower, protections. You consent to this transfer, storing, or processing when you consent to our cookie use. Our servers are located in the Netherlands. Please review the third-party cookie provider’s policy to learn more about its location."}]]],["p",{},[["strong",{},[["textNode",{"text":"Your Cookie Choices"}]]]]],["p",{},[["textNode",{"text":"You consent to our use of cookies when you continue using our site."}]]],["p",{},[["textNode",{"text":"You may withdraw your consent for our cookie uses that are not strictly necessary at any time by engaging the consent "}],["a",{"href":"/cookie-table"},[["textNode",{"text":"manager tool"}]]]]],["p",{},[["textNode",{"text":" Most web browsers allow you to directly block all cookies, or just third-party cookies, through your browser settings. Using your browser settings to block all cookies, including strictly necessary ones, may interfere with proper site operation."}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to Our Cookie Uses"}]]]]],["p",{},[["textNode",{"text":"We will post any changes to the way we use cookies on this page and indicate on our website that we updated this cookie notice. If the changes materially alter how we use cookies, we will post a notice on our website and request your consent for the materially different use. Please check back frequently to see any updates or changes to our cookie use notice. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Contact Information"}]]]]],["p",{},[["textNode",{"text":"Please submit any questions, comments, or requests regarding this cookie use notice using the process described in our "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":", located at "}],["span",{},[],[["siteName","__text",true]]],["textNode",{"text":"."}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("legaldocs_personal_policy", [["div",{"data-fox-alias":"privacyText"},[["p",{},[["strong",{},[["textNode",{"text":"What does this Personal Data Policy cover?"}]]]]],["p",{},[["textNode",{"text":"This Personal Data Policy covers our treatment of information that we gather when you are accessing or using our Websites or Services or when you contact us in any manner. We gather various types of information, including information that identifies you as an individual (“Personal Information\") from our users, as explained in more detail below."}]]],["p",{},[["strong",{},[["textNode",{"text":"What information does ModelCentro Collect?"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Information You Provide to Us:"}]]]]],["p",{},[["i",{},[["textNode",{"text":"When you use the Websites: We may collect any Personal Information that you choose to send to us or provide to us, for example, on our “Technical Support\" page online form we may request your Username and your Email in order to assist you in solving technical issues with the site, we will keep a record of our correspondence."}]]]]],["p",{},[["i",{},[["textNode",{"text":"When you use the Services: We receive and store information you provide directly to us. For example, when subscribing to the site, we collect Personal Information, such as username and e-mail address, to provide you with the Services. The types of information we may collect directly from the users include: usernames, email addresses, social accounts usernames, location region, browser and operating system versions."}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Information We Automatically Collect:"}]]]]],["p",{},[["i",{},[["textNode",{"text":"When you use the Websites:"}]]],["textNode",{"text":"When you visit the Websites, we collect certain information related to your device, such as your device’s IP address, referring website, what pages your device visited, and the time that your device visited our Website."}]]],["p",{},[["textNode",{"text":"We log information about our customers and their users when you use one of the Services including Internet Protocol (“IP\") address. Information collected by cookies and other similar technologies – we use various technologies to collect information which may include saving cookies to users’ computers."}]]],["p",{},[["textNode",{"text":"For further information, please see the section below headed “Cookies and other Tracking Technologies\"."}]]],["table",{"border":"1","cellpadding":"7","cellspacing":"0"},[["thead",{},[["tr",{},[["th",{"style":"white-space: nowrap;"},[["textNode",{"text":"Data collected"}]]],["th",{},[["textNode",{"text":"What is this"}]]],["th",{},[["textNode",{"text":"What it is needed for"}]]]]]]],["tbody",{},[["tr",{},[["td",{},[["textNode",{"text":"Username"}]]],["td",{},[["textNode",{"text":"Unique identification parameter (aka Nickname) that you choose when interact with the site"}]]],["td",{},[["textNode",{"text":"It is required in order to be able to identify and authorize you on the site. Also so performer can know how to address you"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Email Address"}]]],["td",{},[["textNode",{"text":"Your Email address"}]]],["td",{},[["textNode",{"text":"It is required in order to be able to identify and authorize you on the site. Also required for technical and marketing communication and communication with the performer"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Ip address"}]]],["td",{},[["textNode",{"text":"Internet Protocol address, see reference in "}],["a",{"href":"https://en.wikipedia.org/wiki/IP_address","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Wikipedia"}]]]]],["td",{},[["textNode",{"text":"It is required in order to display offers and languages most appropriate for your region. Also used in as one of the account security measures and a billing security measure"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Geolocation"}]]],["td",{},[["textNode",{"text":"Country you are located in"}]]],["td",{},[["textNode",{"text":"Determined by the IP. It is required in order to display offers and languages most appropriate for your region"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Referring URL"}]]],["td",{},[["textNode",{"text":"Site that you came from to this site"}]]],["td",{},[["textNode",{"text":"Used for marketing and analytical purposes. Also used in Acquisition section of the Google Analytics and related sections"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Browser's agent"}]]],["td",{},[["textNode",{"text":"Version of your browser (example: Google Chrome v49.0)"}]]],["td",{},[["textNode",{"text":"Used in order to display technical version of the site fully functional and compatible with your browser's version and in order to be able to assist with any possible technical issues"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Plugins"}]]],["td",{},[["textNode",{"text":"Plugins available in your browser"}]]],["td",{},[["textNode",{"text":"One of the 'Account Security' measures. In combination with all other parameters it creates a single unique secure identifier so we can know that it is actually you and your account has not been compromised"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Fonts"}]]],["td",{},[["textNode",{"text":"Fonts package used in your browser"}]]],["td",{},[["textNode",{"text":"One of the 'Account Security' measures. In combination with all other parameters it creates a single unique secure identifier so we can know that it is actually you and your account has not been compromised"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Canvas"}]]],["td",{},[["textNode",{"text":"Hash of the footprint of the browser"}]]],["td",{},[["textNode",{"text":"One of the 'Account Security' measures. In combination with all other parameters it creates a single unique secure identifier so we can know that it is actually you and your account has not been compromised"}]]]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"How do we use the information?"}]]]]],["p",{},[["i",{},[["textNode",{"text":"Websites:"}]]],["textNode",{"text":" We will use the information we collect via our Websites:"}]]],["ul",{},[["li",{},[["textNode",{"text":"To administer our Website, our events and for internal operations, including troubleshooting, data analysis, testing, statistical and survey purposes;"}]]],["li",{},[["textNode",{"text":"To improve our Website to ensure that content is presented in the most effective manner for you and for your computer;"}]]],["li",{},[["textNode",{"text":"Analyze customers’ use of the Websites for trend monitoring, marketing and advertising purposes;"}]]],["li",{},[["textNode",{"text":"For purposes made clear to you at the time you submit your information – for example, to fulfill your request to Subscribe to the newsletters, to provide you with access to the site."}]]],["li",{},[["textNode",{"text":"As part of our efforts to keep the Website safe and secure."}]]]]],["p",{},[["i",{},[["textNode",{"text":"Services:"}]]],["textNode",{"text":" We may use the information we collect from our customers and their users in connection with the Services we provide for a range of reasons, including to:"}]]],["ul",{},[["li",{},[["textNode",{"text":"To set up a user account;"}]]],["li",{},[["textNode",{"text":"Provide, operate and maintain the Services;"}]]],["li",{},[["textNode",{"text":"Manage our customers’ use of the Services, respond to enquiries and comments and provide customer service and support;"}]]],["li",{},[["textNode",{"text":"Send customers technical alerts, updates, security notifications, and administrative communications;"}]]],["li",{},[["textNode",{"text":"Investigate and prevent fraudulent activities, unauthorized access to the Services, and other illegal activities; and"}]]],["li",{},[["textNode",{"text":"For any other purposes about which we notify customers and users."}]]]]],["p",{},[["textNode",{"text":"We may also use the information you send to us via the Websites and/or Services, to communicate with you via email and, possibly, other means, regarding products, services, offers, promotions and events we think may be of interest to you or to send you our newsletter, if this is in accordance with your marketing preferences. However, you will always be able to opt-out of such communications at any time (see the “Your Choices\" section below)."}]]],["p",{},[["strong",{},[["textNode",{"text":"How do we share and disclose information to third parties?"}]]]]],["p",{},[["textNode",{"text":"We do not rent or sell your Personal Information to anyone. We may share and disclose information (including Personal Information) about our customers in the following limited circumstances:"}]]],["p",{},[["i",{},[["textNode",{"text":"Vendors, consultants and other service providers:"}]]],["textNode",{"text":" We may share your information with third party vendors, consultants\tand other service providers who we employ to perform tasks on our behalf. These companies include our payment processing providers ("}],["a",{"href":"https://centrobill.com/en/consumer/privacy.html","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Centrobill"}]]],["textNode",{"text":"), website analytics companies ("}],["a",{"href":"https://www.google.com/policies/privacy/partners/ ","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Google Analytics"}]]],["textNode",{"text":", "}],["a",{"href":"https://www.hotjar.com/legal/policies/privacy","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Hotjar"}]]],["textNode",{"text":"), product feedback or help desk software providers (Kayako, Intercom), email service providers (Sendgrid), Account security provide(Exodentity), and others."}]]],["p",{},[["textNode",{"text":"If ModelCentro has received your Personal Information in the United States and subsequently transfers that information to a third party agent or service provider for processing, ModelCentro shall remain responsible for ensuring that such third party agent or service provider processes your Personal Information to the standard required by our Privacy Shield commitments (see the sections below headed “Additional Information for Users in the European Economic Area (\"EEA\") and \"International Data Transfers\"). Unless we tell you differently and you consent, our agents do not have any right to use the Personal Information we share with them beyond what is necessary to assist us."}]]],["p",{},[["i",{},[["textNode",{"text":"Performers: ModelCentro also shares your Personal information such as Username, Email address, IP(Internet Protocol) address with the owner of the site/profile you are subscribed to or interacted with. This is required in order for the site owner to be able to interact and communicate with the site’s subscribers."}]]]]],["p",{},[["i",{},[["textNode",{"text":"Protection of ModelCentro and Others:"}]]],["textNode",{"text":" We reserve the right to access, read, preserve, and disclose any information as necessary to comply with law or court order; enforce or apply our agreements with you and other agreements; or protect the rights, property, or safety of ModelCentro, our employees, our users, or others."}]]],["p",{},[["i",{},[["textNode",{"text":"Disclosures for National Security or Law Enforcement:"}]]],["textNode",{"text":" Under certain circumstances, we may be required to disclose your Personal Information in response to valid requests by public authorities, including to meet national security or law enforcement requirements."}]]],["p",{},[["strong",{},[["textNode",{"text":"Is Personal Information about me secure?"}]]]]],["p",{},[["textNode",{"text":"We use appropriate technical, organizational and administrative security measures to protect any information we hold in our records from loss, misuse, and unauthorized access, disclosure, alteration and destruction. Unfortunately, no company or service can guarantee complete security. Unauthorized entry or use, hardware or software failure, and other factors, may compromise the security of user information at any time. Among other practices, your account is protected by a password for your privacy and security. You must prevent unauthorized access to your account and Personal Information by selecting and protecting your password appropriately and limiting access to your computer or device and browser by signing off after you have finished accessing your account."}]]],["p",{},[["strong",{},[["textNode",{"text":"Cookies and other tracking technologies"}]]]]],["p",{},[["textNode",{"text":"Our Websites and some of our Services use cookies (small text files containing a string of alphanumeric characters that we put on your computer) and other similar tracking technologies (like web beacons, tags and scripts) to uniquely identify your browser and to gather information about how you interact with the Websites and Services. We use this information for the following purposes:"}]]],["ul",{},[["li",{},[["textNode",{"text":"Assisting you in navigation;"}]]],["li",{},[["textNode",{"text":"Assisting in registration, login, and your ability to provide feedback;"}]]],["li",{},[["textNode",{"text":"Analyzing your use of our products, services or applications; and"}]]],["li",{},[["textNode",{"text":"Assisting with our promotional and marketing efforts (including behavioral advertising)."}]]]]],["p",{},[["textNode",{"text":"Please consult our "}],["a",{"href":"/cookie-policy"},[["textNode",{"text":"Cookie Policy"}]]],["textNode",{"text":" for more information about the type of cookies and tracking technologies that we use on this Website and why, and how to accept and reject them."}]]],["p",{},[["textNode",{"text":"We also may use clear gifs in HTML-based emails sent to our users to track which emails are opened by recipients. This information is used to enable more accurate reporting, improve the effectiveness of our marketing, and make our Services and Websites better for our users."}]]],["p",{},[["textNode",{"text":"We also utilize Google Analytics, a web analysis service provided by Google, to better understand your use of our Websites and Services. Google Analytics collects information such as how often users visit the Websites, what pages they visit and what other sites they used prior to visiting. Google uses the data collected to track and examine the use of the Websites, to prepare reports on its activities and share them with other Google services. Google may use the data collected on the Websites to contextualize and personalize the ads of its own advertising network. Google’s ability to use and share information collected by Google Analytics about your visits to the Websites is restricted by the "}],["a",{"href":"https://www.google.com/analytics/terms/us.html","rel":"nofollow","target":"_blank"},[["textNode",{"text":"Google Analytics Terms of Use"}]]],["textNode",{"text":" and the "}],["a",{"href":"http://www.google.com/policies/privacy/","rel":"nofollow","target":"_blank"},[["textNode",{"text":"Google Privacy Policy"}]]],["textNode",{"text":". Google offers an opt-out mechanism for the web available "}],["a",{"href":"https://tools.google.com/dlpage/gaoptout/","rel":"nofollow","target":"_blank"},[["textNode",{"text":"here"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["textNode",{"text":"Your Privacy Rights"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"What choices do I have?"}]]]]],["p",{},[["textNode",{"text":"You can always opt not to disclose information to us, but keep in mind some information may be needed to register with us or to take advantage of some of our features."}]]],["p",{},[["strong",{},[["textNode",{"text":"Cookies"}]]]]],["p",{},[["textNode",{"text":"You can accept or reject cookies through our Cookies Preferences Center, accessible by clicking the “cookie settings\" button in our "}],["a",{"href":"/cookie-policy"},[["textNode",{"text":"Cookie Policy"}]]],["textNode",{"text":". You can also do so by adjusting your web browser controls. Please consult our "}],["a",{"href":"/cookie-policy"},[["textNode",{"text":"Cookie Policy"}]]],["textNode",{"text":" for more information about our use of cookies and how to accept and reject them."}]]],["p",{},[["strong",{},[["textNode",{"text":"Marketing Communications"}]]]]],["p",{},[["textNode",{"text":"You can opt-out of receiving certain promotional or marketing communications from us at any time, by using the unsubscribe link in the emails communications we send, we also not sending any promotional or marketing communication materials without having your consent for it."}]]],["p",{},[["strong",{},[["textNode",{"text":"How can I update and access my information (Exercise my Data Subject Rights)?"}]]]]],["p",{},[["textNode",{"text":"If you would like to access, review, update, rectify, and delete any Personal Information we hold about you, or exercise any other data subject right available to you under the EU General Data Protection Regulation (GDPR), you can either click the “Account Settings\"(Settings) link available in the site menu, or email us at "}],["a",{"data-name":"usersupport","data-domain":"modelcentro","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld"}]]],["p",{},[["textNode",{"text":"Our Privacy team will examine your request and respond to you as quickly as possible!"}]]],["p",{},[["textNode",{"text":"Please note that we may still use any aggregated and de-identified Personal Information that does not identify any individual, and may also retain and use your information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements."}]]],["p",{},[["strong",{},[["textNode",{"text":"California residents"}]]],["textNode",{"text":" are entitled to ask us for a notice identifying the categories of Personal Information which we share with our affiliates and/or third parties for marketing purposes, and providing contact information for such affiliates and/or third parties. If you are a California resident and would like a copy of this notice, please submit a written request to: "}],["a",{"data-name":"usersupport","data-domain":"modelcentro","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld"}]]],["p",{},[["textNode",{"text":"If you are a "}],["strong",{},[["textNode",{"text":"resident of the European Economic Area"}]]],["textNode",{"text":", please see the section below headed “Additional Information for users in the European Economic Area\" for further information about your privacy rights."}]]],["p",{},[["strong",{},[["textNode",{"text":"International Data Transfers"}]]]]],["p",{},[["textNode",{"text":"Personal Information you submit on the Websites or through the Services is sent to the United States and will be primarily processed by us in the United States and potentially in other countries, on our servers or on our hosted service providers’ cloud servers on our behalf. These countries may not have similar data protection laws to those in your country of residence. However, we will always protect your information in accordance with this Privacy Policy wherever it is processed. Some of our product offerings include the ability to host your data in servers located in the EU or other countries. To request this capability, contact "}],["a",{"data-name":"usersupport","data-domain":"modelcentro","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld"}]]],["p",{},[["strong",{},[["textNode",{"text":"Linked Websites"}]]]]],["p",{},[["textNode",{"text":"For your convenience, hyperlinks may be posted on the Websites that link to other websites (the “Linked Sites\"). We are not responsible for, and this Privacy Policy does not apply to, the privacy practices of any Linked Sites or of any companies that we do not own or control. Linked Sites may collect information in addition to that which we collect on the Websites. We do not endorse any of these Linked Sites, the services or products described or offered on such Linked Sites, or any of the content contained on the Linked Sites. We encourage you to seek out and read the privacy policy of each Linked Site that you visit to understand how the information that is collected about you is used and protected."}]]],["p",{},[["strong",{},[["textNode",{"text":"Will ModelCentro ever change this Personal Data Policy?"}]]]]],["p",{},[["textNode",{"text":"We’re constantly trying to improve our Websites and Services, so we may need to change this Personal Data Policy from time to time as well. We will alert you to material changes by, for example, placing a notice on our Websites and/or by sending you an email (if you have registered your e-mail details with us) when we are required to do so by applicable law. You can see when this Personal Data Policy was last updated by checking the date at the top of this page. You are responsible for periodically reviewing this Personal Data Policy."}]]],["p",{},[["strong",{},[["textNode",{"text":"What if I have questions about this policy?"}]]]]],["p",{},[["textNode",{"text":"If you have any questions or concerns regarding our privacy policies, please send us a detailed message to "}],["a",{"data-name":"support","data-domain":"modelcentro","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld"}],["textNode",{"text":", and we will try to resolve your concerns."}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("legaldocs_privacy_policy", [["div",{"data-fox-alias":"privacyText"},[["p",{"class":"title"},[["textNode",{"text":"Last Updated: February 20, 2020 "}]]],["p",{},[["strong",{},[["textNode",{"text":"Introduction"}]]]]],["p",{},[["textNode",{"text":"Welcome to our privacy policy."}]]],["p",{},[["textNode",{"text":" We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you. "}]]],["p",{},[["textNode",{"text":"This privacy policy is provided in a layered format so you can click through to the specific areas set out below. Please also use the "}],["a",{"class":"anchorlink","data-target":"part_12"},[["textNode",{"text":"Glossary"}]]],["textNode",{"text":" to understand the meaning of some of the terms used in this privacy policy. "}]]],["ol",{},[["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_1"},[["textNode",{"text":"Important Information and Who We Are"}]]],["strong"]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_2"},[["textNode",{"text":"The Data We Collect About You"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_3"},[["textNode",{"text":"How Is Your Personal Data Collected"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_4"},[["textNode",{"text":"How We Use Your Personal Data"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_5"},[["textNode",{"text":"Disclosures of Your Personal Data"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_6"},[["textNode",{"text":"International Transfers"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_7"},[["textNode",{"text":"Data Security"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_8"},[["textNode",{"text":"Data Retention"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_9"},[["textNode",{"text":"Your EEA/UK Legal Rights"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_10"},[["textNode",{"text":"Your California Privacy Rights"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_11"},[["textNode",{"text":"Your Nevada Privacy Rights"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_12"},[["textNode",{"text":"Your Canadian Privacy Rights"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_13"},[["textNode",{"text":"Do Not Track Policy"}]]]]]]],["li",{},[["strong",{},[["a",{"class":"anchorlink","data-target":"part_14"},[["textNode",{"text":"Glossary"}]]]]]]]]],["p",{"id":"part_1"},[["strong",{},[["textNode",{"text":"1. Important information and who we are"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Purpose of this privacy policy"}]]]]],["p",{},[["textNode",{"text":"This privacy policy aims to give you information on how we collect and process your personal data through your use of this website, including any data you may provide through this website when you purchase a VIP membership, individual digital content, or a model product. "}]]],["p",{},[["textNode",{"text":"This website is not intended for children and we do not knowingly collect data relating to children. It is important that you read this privacy policy together with any other privacy policy or fair processing policy we may provide on specific occasions when we are collecting or processing personal data about you so that you are fully aware of how and why we are using your data. This privacy policy supplements other notices and privacy policies and is not intended to override them. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Controller"}]]]]],["p",{},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" is the controller and responsible for your personal data (collectively referred to as “Model”, “we”, “us”, or “our” in this privacy policy)."}]]],["p",{},[["textNode",{"text":" We have appointed a data privacy manager who is responsible for overseeing questions in relation to this privacy policy. If you have any questions about this privacy policy, including any requests to exercise "}],["a",{"class":"anchorlink","data-target":"part_9"},[["textNode",{"text":" your EEA/UK legal rights"}]]],["textNode",{"text":", please contact the data privacy manager using the details set out below. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Contact details"}]]]]],["p",{},[["textNode",{"text":"If you have any questions about this privacy policy or our privacy practices, please contact our data privacy manager in the following ways: "}]]],["p",{},[["textNode",{"text":"Full name of legal entity: Centro Publisher Limited"}]]],["p",{},[["textNode",{"text":"Email address: "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]]]],["p",{},[["textNode",{"text":"Postal address: Trust Company Complex, Ajeltaki Road, Ajeltaki Island, Majuro, Marshal Islands MH96960."}]]],["p",{},[["textNode",{"text":"If you reside in the United Kingdom (UK), you have the right to make a complaint at any time to the Information Commissioner’s Office (ICO), the UK supervisory authority for data protection issues ("}],["a",{"href":"https://www.ico.org.uk","target":"_blank"},[["textNode",{"text":"www.ico.org.uk"}]]],["textNode",{"text":"). If you reside within the European Economic Area (EEA), you have the right to make a complaint at any time to the appropriate supervisory authority for your country of residence. See "}],["a",{"href":"https://ec.europa.eu","target":"_blank"},[["textNode",{"text":"ec.europa.eu"}]]],["textNode",{"text":" for these details. If you reside outside the EEA or the UK, we will apply your legal rights as applicable to the data laws in the jurisdiction you are in. We would, however, appreciate the chance to deal with your concerns before you approach your supervisory authority so please contact us in the first instance. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to the privacy policy and your duty to inform us of changes"}]]]]],["p",{},[["textNode",{"text":"We keep our privacy policy under regular review. This version was last updated on February 20, 2020. Historic versions can be obtained by contacting us. "}]]],["p",{},[["textNode",{"text":"It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes during your relationship with us. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Third-party links"}]]]]],["p",{},[["textNode",{"text":"This website may include links to third-party websites, plug-ins, and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements. When you leave our website, we encourage you to read the privacy policy of every website you visit. "}]]],["p",{"id":"part_2"},[["strong",{},[["textNode",{"text":"2. The data we collect about you"}]]]]],["p",{},[["textNode",{"text":"Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data). "}]]],["p",{},[["textNode",{"text":"We may collect, use, store, and transfer different kinds of personal data about you which we have grouped together as follows: "}]]],["ul",{},[["li",{},[["strong",{},[["textNode",{"text":"Identity Data "}]]],["textNode",{"text":"includes username or similar identifier."}]]],["li",{},[["strong",{},[["textNode",{"text":"Contact Data "}]]],["textNode",{"text":"includes email address."}]]],["li",{},[["strong",{},[["textNode",{"text":"Financial Data "}]]],["textNode",{"text":"includes payment card details. All payment data is stored by our payment processor and you should review its privacy policies and contact the payment processor directly to respond to your questions."}]]],["li",{},[["strong",{},[["textNode",{"text":"Transaction Data "}]]],["textNode",{"text":"includes details about payments from you and other details of products and services you have purchased from us."}]]],["li",{},[["strong",{},[["textNode",{"text":"Technical Data "}]]],["textNode",{"text":"includes internet protocol (IP) address, cookie ID, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website."}]]],["li",{},[["strong",{},[["textNode",{"text":"Profile Data "}]]],["textNode",{"text":"includes your username and password, purchases or orders made by you, your interests, preferences, feedback, and survey responses."}]]],["li",{},[["strong",{},[["textNode",{"text":"Usage Data "}]]],["textNode",{"text":"includes information about how you use our website, products, and services, including the full Uniform Resource Locators (URLs); clickstream to, through, and from our website (including date and time); content you viewed or searched for; page response times; download errors; length of visits to certain pages; page interaction information (such as scrolling, clicks, and mouse-overs); and methods used to browse away from the page."}]]],["li",{},[["strong",{},[["textNode",{"text":"Marketing and Communications Data "}]]],["textNode",{"text":" includes your preferences in receiving marketing from us and our third parties and your communication preferences."}]]]]],["p",{},[["textNode",{"text":"We also collect, use, and share "}],["strong",{},[["textNode",{"text":"Aggregated Data "}]]],["textNode",{"text":"such as statistical or demographic data for any purpose. Aggregated Data could be derived from your personal data but is not considered personal data in law as this data will not directly or indirectly reveal your identity. For example, we may aggregate your Usage Data to calculate the percentage of users accessing a specific website feature. However, if we combine or connect Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy policy. "}]]],["p",{},[["textNode",{"text":"We do not collect any "}],["strong",{},[["textNode",{"text":" Special Categories of Personal Data"}]]],["textNode",{"text":" about you (this includes details about your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about your health, and genetic and biometric data). Nor do we collect any information about criminal convictions and offenses. "}]]],["p",{},[["strong",{},[["textNode",{"text":"If you fail to provide personal data"}]]]]],["p",{},[["textNode",{"text":"Where we need to collect personal data by law, or under the terms of a contract we have with you and you fail to provide that data when requested, we may not be able to perform the contract we have or are trying to enter into with you (for example, to provide you with goods or services). In this case, we may have to cancel a product or service you have with us, but we will notify you if this is the case at the time. "}]]],["p",{"id":"part_3"},[["strong",{},[["textNode",{"text":"3. How is your personal data collected?"}]]]]],["p",{},[["textNode",{"text":"We use different methods to collect data from and about you, including through: "}]]],["ul",{},[["li",{},[["strong",{},[["textNode",{"text":"Direct interactions. "}]]],["textNode",{"text":" You may give us your Identity, Contact, and Financial Data by filling in forms or by corresponding with us by email or otherwise. This includes personal data you provide when you: "}],["ul",{},[["li",{},[["textNode",{"text":"apply for our products or services;"}]]],["li",{},[["textNode",{"text":"create an account on our website;"}]]],["li",{},[["textNode",{"text":"subscribe to our service;"}]]],["li",{},[["textNode",{"text":"request marketing to be sent to you;"}]]],["li",{},[["textNode",{"text":"enter a competition, promotion, or survey; or"}]]],["li",{},[["textNode",{"text":"give us feedback or contact us."}]]]]]]],["li",{},[["strong",{},[["textNode",{"text":"Automated technologies or interactions. "}]]],["textNode",{"text":"As you interact with our website, we will automatically collect Technical and Usage Data about your equipment, browsing actions, and patterns. We collect this personal data by using cookies, server logs, and other similar technologies. We may also receive Technical and Usage Data about you if you visit other websites employing our cookies. Please see our "}],["a",{"href":"/cookie-policy"},[["textNode",{"text":" cookie policy"}]]],["textNode",{"text":" for further details."}]]],["li",{},[["strong",{},[["textNode",{"text":"Third parties or publicly available sources."}]]],["textNode",{"text":" We will receive personal data about you from various third parties as set out below: "}],["ul",{"type":"circle"},[["li",{},[["textNode",{"text":"Technical Data from the following parties: "}],["ul",{},[["li",{},[["textNode",{"text":"analytics providers such as Google based outside the EU;"}]]],["li",{},[["textNode",{"text":"affiliates participating in our affiliate marketing program based inside and outside the EU; and"}]]],["li",{},[["textNode",{"text":"search information providers such as Google based outside the EU."}]]]]]]],["li",{},[["textNode",{"text":"Identity, Contact, and Transaction Data from providers of technical, payment, and delivery services such as Centro Publisher Limited based outside the EU and CentroBill based inside the EU. "}]]],["li",{},[["textNode",{"text":"Identity, Contact, and Technical Data from providers of customer support services such as Centro Publisher Limited based outside the EU. "}]]]]]]]]],["p",{"id":"part_4"},[["strong",{},[["textNode",{"text":"4. How we use your personal data"}]]]]],["p",{},[["textNode",{"text":"We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances: "}],["ul",{"type":"sqwere"},[["li",{},[["textNode",{"text":"Where we need to perform the contract we are about to enter into or have entered into with you."}]]],["li",{},[["textNode",{"text":"Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests."}]]],["li",{},[["textNode",{"text":"Where we need to comply with a legal obligation."}]]]]]]],["p",{},[["textNode",{"text":"Click "}],["a",{"class":"anchorlink","data-target":"part_12"},[["textNode",{"text":" here"}]]],["textNode",{"text":" to find out more about the types of lawful basis that we will rely on to process your personal data."}]]],["p",{},[["textNode",{"text":"Generally, we do not rely on consent as a legal basis for processing your personal data although we will get your consent before sending third-party direct marketing communications to you via email or text message. You have the right to withdraw consent to marketing at any time by contacting us."}]]],["p",{},[["strong",{},[["textNode",{"text":"Purposes for which we will use your personal data"}]]]]],["p",{},[["textNode",{"text":"We have set out below, in a table format, a description of all the ways we plan to use your personal data, and which of the legal bases we rely on to do so. We have also identified what our legitimate interests are where appropriate. "}]]],["p",{},[["textNode",{"text":"Note that we may process your personal data for more than one lawful ground depending on the specific purpose for which we are using your data. Please contact us if you need details about the specific legal ground we are relying on to process your personal data where more than one ground has been set out in the table below. "}]]],["p",{"class":"wrapper-cookie-table"},[["table",{"class":"list cookie-table"},[["tr",{},[["th",{},[["textNode",{"text":"Purpose/Activity "}]]],["th",{},[["textNode",{"text":"Type of data "}]]],["th",{},[["textNode",{"text":"Lawful basis for processing including basis of legitimate interest "}]]]]],["tr",{},[["td",{},[["textNode",{"text":"To register you as a new customer"}]]],["td",{},[["p",{},[["textNode",{"text":"(a) Identity "}]]],["p",{},[["textNode",{"text":"(b) Contact"}]]]]],["td",{},[["textNode",{"text":"Performance of a contract with you"}]]]]],["tr",{},[["td",{},[["p",{},[["textNode",{"text":"To process and deliver your order including:"}]]],["p",{},[["textNode",{"text":"(a) Manage payments, fees, and charges "}]]],["p",{},[["textNode",{"text":"(b) Collect and recover money owed to us "}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Identity"}]]],["p",{},[["textNode",{"text":"(b) Contact"}]]],["p",{},[["textNode",{"text":"(c) Financial "}]]],["p",{},[["textNode",{"text":"(d) Transaction"}]]],["p",{},[["textNode",{"text":"(e) Marketing and Communications"}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Performance of a contract with you"}]]],["p",{},[["textNode",{"text":"(b) Necessary for our legitimate interests (to recover debts due to us)"}]]]]]]],["tr",{},[["td",{},[["p",{},[["textNode",{"text":"To manage our relationship with you which will include:"}]]],["p",{},[["textNode",{"text":"(a) Notifying you about changes to our terms or privacy policy"}]]],["p",{},[["textNode",{"text":"(b) Asking you to leave a review or take a survey "}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Identity"}]]],["p",{},[["textNode",{"text":"(b) Contact"}]]],["p",{},[["textNode",{"text":"(c) Profile"}]]],["p",{},[["textNode",{"text":"(d) Marketing and Communications"}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Performance of a contract with you"}]]],["p",{},[["textNode",{"text":"(b) Necessary to comply with a legal obligation"}]]],["p",{},[["textNode",{"text":"(c) Necessary for our legitimate interests (to keep our records updated and to study how customers use our products/services)"}]]]]]]],["tr",{},[["td",{},[["p",{},[["textNode",{"text":"To enable you to partake in a prize draw, competition, or complete a survey"}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Identity"}]]],["p",{},[["textNode",{"text":"(b) Contact"}]]],["p",{},[["textNode",{"text":"(c) Profile"}]]],["p",{},[["textNode",{"text":"(d) Usage"}]]],["p",{},[["textNode",{"text":"(e) Marketing and Communications"}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Performance of a contract with you"}]]],["p",{},[["textNode",{"text":"(b) Necessary for our legitimate interests (to study how customers use our products/services, to develop them and grow our business)"}]]]]]]],["tr",{},[["td",{},[["p",{},[["textNode",{"text":"To administer and protect our business and this website (including troubleshooting, data analysis, testing, system maintenance, support, reporting, and hosting of data)"}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Identity"}]]],["p",{},[["textNode",{"text":"(b) Contact"}]]],["p",{},[["textNode",{"text":"(c) Technical "}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Necessary for our legitimate interests (for running our business, provision of administration and IT services, network security, to prevent fraud, and in the context of a business reorganization or group restructuring exercise) "}]]],["p",{},[["textNode",{"text":"(b) Necessary to comply with a legal obligation"}]]]]]]],["tr",{},[["td",{},[["p",{},[["textNode",{"text":"To deliver relevant website content and advertisements to you and measure or understand the effectiveness of the advertising we serve to you"}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Identity"}]]],["p",{},[["textNode",{"text":"(b) Contact"}]]],["p",{},[["textNode",{"text":"(c) Profile"}]]],["p",{},[["textNode",{"text":"(d) Usage"}]]],["p",{},[["textNode",{"text":"(e) Marketing and Communications"}]]],["p",{},[["textNode",{"text":"(f) Technical"}]]]]],["td",{},[["p",{},[["textNode",{"text":"Necessary for our legitimate interests (to study how customers use our products/services, to develop them, to grow our business, and to inform our marketing strategy)"}]]]]]]],["tr",{},[["td",{},[["p",{},[["textNode",{"text":"To use data analytics to improve our website, products/services, marketing, customer relationships, and experiences"}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Technical"}]]],["p",{},[["textNode",{"text":"(b) Usage"}]]]]],["td",{},[["p",{},[["textNode",{"text":"Necessary for our legitimate interests (to define types of customers for our products and services, to keep our website updated and relevant, to develop our business, and to inform our marketing strategy)"}]]]]]]],["tr",{},[["td",{},[["p",{},[["textNode",{"text":"To make suggestions and recommendations to you about goods or services that may be of interest to you"}]]]]],["td",{},[["p",{},[["textNode",{"text":"(a) Identity"}]]],["p",{},[["textNode",{"text":"(b) Contact"}]]],["p",{},[["textNode",{"text":"(c) Technical"}]]],["p",{},[["textNode",{"text":"(d) Usage"}]]],["p",{},[["textNode",{"text":"(e) Profile"}]]],["p",{},[["textNode",{"text":"(f) Marketing and Communications"}]]]]],["td",{},[["p",{},[["textNode",{"text":"Necessary for our legitimate interests (to develop our products/services and grow our business)"}]]]]]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Marketing"}]]]]],["p",{},[["textNode",{"text":"We strive to provide you with choices regarding certain personal data uses, particularly around marketing and advertising. We have established the following personal data control mechanisms:"}]]],["p",{},[["strong",{},[["textNode",{"text":"Promotional offers from us"}]]]]],["p",{},[["textNode",{"text":"We may use your Identity, Contact, Technical, Usage, and Profile Data to form a view on what we think you may want or need, or what may be of interest to you. This is how we decide which products, services, and offers may be relevant for you (we call this marketing). "}]]],["p",{},[["textNode",{"text":"You will receive marketing communications from us if you have requested information from us or purchased goods or services from us and you have not opted out of receiving that marketing. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Third-party marketing"}]]]]],["p",{},[["textNode",{"text":"We will get your express opt-in consent before we share your personal data with any third party for marketing purposes. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Opting out"}]]]]],["p",{},[["textNode",{"text":"You can ask us or third parties to stop sending you marketing messages at any time by logging into the website and checking or unchecking relevant boxes to adjust your marketing preferences, by following the opt-out links on any marketing messages sent to you, or by contacting us at any time. "}]]],["p",{},[["textNode",{"text":"Where you opt out of receiving these marketing messages, this will not apply to personal data provided to us as a result of a product/service purchase, product/service experience, or other transactions. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Cookies"}]]]]],["p",{},[["textNode",{"text":"You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly. For more information about the cookies we use, please see our "}],["a",{"href":"/cookie_policy"},[["textNode",{"text":"cookie policy."}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Change of purpose"}]]]]],["p",{},[["textNode",{"text":"We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to get an explanation as to how the processing for the new purpose is compatible with the original purpose, please contact us. "}]]],["p",{},[["textNode",{"text":"If we need to use your personal data for an unrelated purpose, we will notify you and we will explain the legal basis which allows us to do so. "}]]],["p",{},[["textNode",{"text":"Please note that we may process your personal data without your knowledge or consent, in compliance with the above rules, where this is required or permitted by law. "}]]],["p",{"id":"part_5"},[["strong",{},[["textNode",{"text":"5. Disclosures of your personal data"}]]]]],["p",{},[["textNode",{"text":"We may share your personal data with the parties set out below for the purposes stated in the table ("}],["a",{"class":"anchorlink","data-target":"part_1"},[["textNode",{"text":" Purposes for which we will use your personal data"}]]],["textNode",{"text":") above. "}],["ul",{},[["li",{},[["textNode",{"text":"External Third Parties as set out in the "}],["a",{"class":"anchorlink","data-target":"part_12"},[["textNode",{"text":" Glossary"}]]],["textNode",{"text":"."}]]],["li",{},[["textNode",{"text":"Third parties to whom we may choose to sell, transfer, or merge parts of our business or our assets. Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our business, then the new owners may use your personal data in the same way as set out in this privacy policy. "}]]]]]]],["p",{},[["textNode",{"text":"We require all third parties to respect the security of your personal data and to treat it in accordance with the law. We do not allow our third-party service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions. "}]]],["p",{"id":"part_6"},[["strong",{},[["textNode",{"text":"6. International transfers"}]]]]],["p",{},[["textNode",{"text":"We are based in the Marshal Islands, but our servers are located in the Netherlands. We may process, store, and transfer personal data we collect, in and to a country outside your own, with different privacy laws that may or may not be comprehensive as your own. Where we do so, and where we are required to under local law, we will put in place appropriate mechanisms to ensure that your personal data receives an adequate level of protection where it is processed. "}]]],["p",{},[["textNode",{"text":"Unless you are located in the EEA or the UK, by submitting your personal data or engaging with the website or our application, you consent to this transfer, storing, or processing. "}]]],["p",{},[["textNode",{"text":"If you reside in the EEA or the UK, your personal data may be processed outside of the EEA or UK, including, for example, in the United States, so processing of your personal data will involve a transfer of data outside the EEA or UK."}]]],["p",{},[["textNode",{"text":"Whenever we transfer your personal data out of the EEA, we ensure a similar degree of protection is afforded to it by ensuring that the recipient third party agrees to contractual clauses. "}]]],["p",{},[["textNode",{"text":"Please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":" privacy@modelcentro.com"}]]],["textNode",{"text":" if you want further information on the specific mechanism used by us when transferring your personal data out of the EEA or UK."}]]],["p",{"id":"part_7"},[["strong",{},[["textNode",{"text":"7. Data security"}]]]]],["p",{},[["textNode",{"text":"We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors, and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality. "}]]],["p",{},[["textNode",{"text":"We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so. "}]]],["p",{"id":"part_8"},[["strong",{},[["textNode",{"text":"8. Data retention"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"How long will you use my personal data for?"}]]]]],["p",{},[["textNode",{"text":" We will only retain your personal data for as long as reasonably necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, regulatory, tax, accounting, or reporting requirements. We may retain your personal data for a longer period in the event of a complaint or if we reasonably believe there is a prospect of litigation in respect to our relationship with you. "}]]],["p",{},[["textNode",{"text":"To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal, regulatory, tax, accounting, or other requirements. "}]]],["p",{},[["textNode",{"text":"By law we have to keep basic information about our customers (including Contact, Identity, and Transaction Data) for seven years after they cease being customers for tax purposes. "}]]],["p",{},[["textNode",{"text":"In some circumstances you can ask us to delete your data: see "}],["a",{"class":"anchorlink","data-target":"part_9"},[["textNode",{"text":" your EEA/UK legal rights"}]]],["textNode",{"text":" below for further information. "}]]],["p",{},[["textNode",{"text":"In some circumstances we will anonymize your personal data (so that it can no longer be associated with you) for research or statistical purposes in which case we may use this information indefinitely without further notice to you. "}]]],["p",{"id":"part_9"},[["strong",{},[["textNode",{"text":"9. Your EEA/UK Legal Rights"}]]]]],["p",{},[["textNode",{"text":"Under certain circumstances, you have rights under data protection laws in relation to your personal data. Please click on the links below to find out more about these rights: "}],["ul",{},[["li",{},[["a",{"class":"anchorlink","data-target":"part_16"},[["textNode",{"text":"Request access to your personal data."}]]]]],["li",{},[["a",{"class":"anchorlink","data-target":"part_17"},[["textNode",{"text":"Request correction of your personal data."}]]]]],["li",{},[["a",{"class":"anchorlink","data-target":"part_18"},[["textNode",{"text":"Request erasure of your personal data."}]]]]],["li",{},[["a",{"class":"anchorlink","data-target":"part_19"},[["textNode",{"text":"Object to processing of your personal data."}]]]]],["li",{},[["a",{"class":"anchorlink","data-target":"part_20"},[["textNode",{"text":"Request restriction of processing your personal data."}]]]]],["li",{},[["a",{"class":"anchorlink","data-target":"part_21"},[["textNode",{"text":"Request transfer of your personal data."}]]]]],["li",{},[["a",{"class":"anchorlink","data-target":"part_22"},[["textNode",{"text":"Right to withdraw consent."}]]]]]]]]],["p",{},[["textNode",{"text":"If you wish to exercise any of the rights set out above, please contact us."}]]],["p",{},[["strong",{},[["textNode",{"text":"No fee usually required"}]]]]],["p",{},[["textNode",{"text":"You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive, or excessive. Alternatively, we could refuse to comply with your request in these circumstances. "}]]],["p",{},[["strong",{},[["textNode",{"text":"What we may need from you"}]]]]],["p",{},[["textNode",{"text":"We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Time limit to respond"}]]]]],["p",{},[["textNode",{"text":"We try to respond to all legitimate requests within one month. Occasionally it could take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated. "}]]],["p",{"id":"part_10"},[["strong",{},[["textNode",{"text":"10. Your California privacy rights"}]]]]],["p",{},[["textNode",{"text":"If you are a California resident, California law may provide you with additional rights regarding our use of your personal data. To learn more about your California privacy rights, visit "}],["a",{"href":"/california-privacy-rights"},[["textNode",{"text":" CCPA"}]]],["textNode",{"text":". "}]]],["p",{},[["textNode",{"text":"California’s “Shine the Light” law (Civil Code Section 1798.83) permits our users who are California residents to request certain information regarding our disclosure of personal data to third parties for their direct marketing purposes. To make that request, please send an email to "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":"privacy@modelcentro.com"}]]],["textNode",{"text":". "}]]],["p",{},[["textNode",{"text":"Further, if you are a California resident and would like to opt out from the disclosure of your personal data to any third party for direct marketing purposes, please send an email to "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":"privacy@modelcentro.com"}]]],["textNode",{"text":". If you opt out from permitting your personal data to be shared, you may still receive selected offers directly from us in accordance with California law"}]]],["p",{"id":"part_11"},[["strong",{},[["textNode",{"text":" 11. Your Nevada Privacy Rights"}]]]]],["p",{},[["textNode",{"text":"Nevada residents who wish to exercise their sale opt-out rights under Nevada Revised Statutes Chapter 603A may submit a request to this designated address: "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":"privacy@modelcentro.com"}]]],["textNode",{"text":". However, please know we do not currently sell data triggering that statute’s opt-out requirements. "}]]],["p",{"id":"part_12"},[["strong",{},[["textNode",{"text":" 12. Your Canadian Privacy Rights"}]]]]],["p",{},[["textNode",{"text":"We comply with Canadian Federal and Provincial privacy laws and regulations, including the Personal Information Protection and Electronic Documents Act. "}]]],["p",{},[["textNode",{"text":"We will only use your personal information for the purposes intended and as detailed in this policy unless we have obtained your consent to use it for other purposes. "}]]],["p",{},[["textNode",{"text":"Residents of Canada are notified that the personal data they provide to us is stored in our databases outside of Canada, including in the Netherlands, and may be subject to disclosure to authorized law enforcement or government agencies in response to lawful demand under the laws of that country."}]]],["p",{},[["textNode",{"text":"You may withdraw your consent to our personal data collection, use, or disclosure, subject to legal and contractual restrictions."}]]],["p",{},[["textNode",{"text":"You have the right to complain about our personal data handling practices."}]]],["p",{},[["textNode",{"text":"If you need to contact us about your personal data or believe that we have violated your privacy rights, please contact us at "}],["a",{"href":"mailto:privacy@modelcentro.com"},[["textNode",{"text":"privacy@modelcentro.com"}]]],["textNode",{"text":". You may visit "}],["a",{"target":"_blank","href":"https://www.priv.gc.ca/"},[["textNode",{"text":" www.priv.gc.ca"}]]],["textNode",{"text":" for more information about your privacy rights. "}]]],["p",{"id":"part_13"},[["strong",{},[["textNode",{"text":"13. Do Not Track policy"}]]]]],["p",{},[["textNode",{"text":"Do Not Track (“DNT”) is a privacy preference that you can set in your browser. DNT is a way for you to inform websites and services that you do not want certain information about your webpage visits collected over time and across websites or online services. We are committed to providing you with meaningful choices about the information we collect and that is why we provide you the ability to opt out. But we do not recognize or respond to any DNT signals as the Internet industry works toward defining exactly what DNT means, what it means to comply with DNT, and a common approach to responding to DNT. For more information, visit "}],["a",{"href":"https://www.allaboutdnt.com","target":"_blank"},[["textNode",{"text":"www.allaboutdnt.com"}]]],["textNode",{"text":". "}]]],["p",{"id":"part_14"},[["strong",{},[["textNode",{"text":"14. Glossary"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Lawful Basis"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Consent "}]]],["textNode",{"text":" means processing your personal data where you have signified your agreement by a statement or clear opt-in to processing for a specific purpose. Consent will only be valid if it is a freely given, specific, informed, and unambiguous indication of what you want. You can withdraw your consent at any time by contacting us."}]]],["p",{},[["strong",{},[["textNode",{"text":" Legitimate Interest"}]]],["textNode",{"text":" means the interest of our business in conducting and managing our business to enable us to give you the best service and the best and most secure experience. We make sure we consider and balance any potential impact on you (both positive and negative) and your rights before we process your personal data for our legitimate interests. We do not use your personal data for activities where our interests are overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by law). You can obtain further information about how we assess our legitimate interests against any potential impact on you in respect of specific activities by contacting us. "}]]],["p",{},[["strong",{},[["textNode",{"text":" Performance of Contract"}]]],["textNode",{"text":" means processing your data where it is necessary for the performance of a contract to which you are a party or to take steps at your request before entering into such a contract. "}]]],["p",{},[["strong",{},[["textNode",{"text":" Comply with a legal obligation"}]]],["textNode",{"text":" means processing your personal data where it is necessary for compliance with a legal obligation that we are subject to. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Third Parties"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"External Third Parties"}]]]]],["ul",{},[["li",{},[["strong",{},[["textNode",{"text":"Compliance with Laws"}]]],["textNode",{"text":". We may disclose your information where we are legally required to do so to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements). "}]]],["li",{},[["strong",{},[["textNode",{"text":"Vital Interests and Legal Rights"}]]],["textNode",{"text":". We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved. "}]]],["li",{},[["strong",{},[["textNode",{"text":"Vendors, Consultants, and Other Third-Party Service Providers"}]]],["textNode",{"text":". We may share your data with third-party vendors, service providers, contractors, or agents who perform services for us or on our behalf and require access to that information to do that work. Examples include: payment processing, data analysis, email delivery, hosting services, customer service, and marketing efforts. We may allow selected third parties to use tracking technology on the Website, which will enable them to collect data about how you interact with the Website over time. This information may be used to, among other things, analyze and track data, determine the popularity of certain content and better understand online activity. For example, we use Google Analytics to help us understand how our customers use the website (you can read more about how Google uses your personal data here: "}],["a",{"href":"https://policies.google.com/privacy?fg=1","target":"_blank"},[["textNode",{"text":" https://www.google.com/intl/en/policies/privacy/)"}]]],["textNode",{"text":". You can also optout of Google Analytics here: "}],["a",{"href":"https://tools.google.com/dlpage/gaoptout","target":"_blank"},[["textNode",{"text":" https://tools.google.com/dlpage/gaoptout"}]]],["textNode",{"text":". "}]]],["li",{},[["strong",{},[["textNode",{"text":"Affiliates"}]]],["textNode",{"text":". We may share your information with our affiliates, in which case we will require those affiliates to honor this privacy policy. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Your Legal Rights"}]]]]],["p",{},[["textNode",{"text":" You have the right to: "}]]],["p",{"id":"part_15"},[["strong",{},[["textNode",{"text":"Request access"}]]],["textNode",{"text":" to your personal data (commonly known as a “data subject access request”). This enables you to receive a copy of the personal data we hold about you and to check that we are lawfully processing it. "}]]],["p",{"id":"part_16"},[["strong",{},[["textNode",{"text":"Request correction"}]]],["textNode",{"text":" of the personal data that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us."}]]],["p",{"id":"part_17"},[["strong",{},[["textNode",{"text":"Request erasure"}]]],["textNode",{"text":" of your personal data. This enables you to ask us to delete or remove personal data where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your personal data where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully, or where we are required to erase your personal data to comply with local law. Note, however, that we may not always be able to comply with your request of erasure for specific legal reasons which will be notified to you, if applicable, at the time of your request."}]]],["p",{"id":"part_18"},[["strong",{},[["textNode",{"text":"Object to processing "}]]],["textNode",{"text":"of your personal data where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation which makes you want to object to processing on this ground as you feel it impacts on your fundamental rights and freedoms. You also have the right to object where we are processing your personal data for direct marketing purposes. In some cases, we may demonstrate that we have compelling legitimate grounds to process your information which override your rights and freedoms."}]]],["p",{"id":"part_19"},[["strong",{},[["textNode",{"text":"Request restriction of processing"}]]],["textNode",{"text":" of your personal data. This enables you to ask us to suspend the processing of your personal data in the following scenarios: "}],["ul",{},[["li",{},[["textNode",{"text":"If you want us to establish the data’s accuracy."}]]],["li",{},[["textNode",{"text":"Where our use of the data is unlawful but you do not want us to erase it."}]]],["li",{},[["textNode",{"text":"Where you need us to hold the data even if we no longer require it as you need it to establish, exercise, or defend legal claims."}]]],["li",{},[["textNode",{"text":"You have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it."}]]]]]]],["p",{"id":"part_20"},[["strong",{},[["textNode",{"text":"Request the transfer "}]]],["textNode",{"text":"of your personal data to you or to a third party. We will provide to you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you."}]]],["p",{"id":"part_21"},[["strong",{},[["textNode",{"text":"Withdraw consent at any time"}]]],["textNode",{"text":" where we are relying on consent to process your personal data. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain products or services to you. We will advise you if this is the case at the time you withdraw your consent. "}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("legaldocs_terms", [["div",{"data-fox-alias":"termsText"},[["p",{"class":"title"},[["textNode",{"text":"Last updated: September 21, 2018"}]]],["p",{},[["strong",{},[["textNode",{"text":"Acceptance of the Agreement"}]]]]],["p",{},[["textNode",{"text":" These terms of use are entered into between you and the individual or entity featured on the Website (“"}],["strong",{},[["textNode",{"text":"Model"}]]],["textNode",{"text":" ,” “"}],["strong",{},[["textNode",{"text":"we"}]]],["textNode",{"text":",” or “"}],["strong",{},[["textNode",{"text":"us"}]]],["textNode",{"text":"”). The following terms, together with any documents they expressly incorporate by reference (collectively, this “"}],["strong",{},[["textNode",{"text":"agreement"}]]],["textNode",{"text":"”), govern your access to and use of "}],["span",{},[],[["siteUrl","__text",true]]],["textNode",{"text":", including any content, functionality, and services offered on or through "}],["span",{},[],[["siteUrl","__text",true]]],["textNode",{"text":" (the “"}],["strong",{},[["textNode",{"text":"Website"}]]],["textNode",{"text":"”), whether as a guest or a registered user. "}]]],["p",{},[["textNode",{"text":" Please read this agreement carefully before you start to use the Website. "}],["strong",{},[["textNode",{"text":" By using the Website or by clicking to accept or agree to this agreement when this option is made available to you, you agree to be bound and abide by this agreement and our Privacy Policy, found at "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":" "}],["span",{},[],[["siteUrl","__text",true]]],["textNode",{"text":"/privacy"}]]]]],["textNode",{"text":", incorporated by reference. If you do not want to agree to this agreement or the Privacy Policy, you must not access or use the Website. "}]]],["p",{},[["textNode",{"text":" This Website is offered and available to users who are 18-years old or older. By using this Website, you state that you are of legal age to form a binding contract with the Model, you have the legal capacity and you agree to comply with this agreement, you are not a minor in the jurisdiction in which you reside, and your use of the Website will not violate any applicable law or regulation. If you do not meet all these requirements, you must not access or use the Website. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to the Agreement"}]]]]],["p",{},[["textNode",{"text":" We may revise and update this agreement from time to time in our sole discretion. All changes are effective immediately when we post them and apply to all access to and use of the Website from then on. But any changes to the dispute resolution provisions set out in "}],["a",{"class":"anchorlink","data-target":"gover"},[["textNode",{"text":" Governing Law and Jurisdiction"}]]],["textNode",{"text":" will not apply to any disputes for which the parties have actual notice on or before the date the change is posted on the Website. "}]]],["p",{},[["textNode",{"text":" Your continued use of the Website after the posting of the revised agreement means that you agree to the changes. You are expected to check this page frequently, so you are aware of any changes, as they are binding on you. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Accessing the Website and Account Security"}]]]]],["p",{},[["textNode",{"text":" We may withdraw or amend this Website, and any service or material we provide on the Website, in our sole discretion without notice. We will not be liable if for any reason any part of the Website is unavailable at any time or for any period. From time to time, we may restrict access to some parts of the Website, or the entire Website, to users, including registered users. "}]]],["p",{},[["textNode",{"text":" You are responsible for: "}],["ul",{},[["li",{},[["textNode",{"text":"Making all arrangements necessary for you to have access to the Website."}]]],["li",{},[["textNode",{"text":"Ensuring that all persons who access the Website through your Internet connection are aware of this agreement and comply with it."}]]]]]]],["p",{},[["textNode",{"text":" To access the Website or some of the resources it offers, you may be asked to provide certain registration details or other information. It is a condition of your use of the Website that all the information you provide on the Website is correct, current, and complete. You acknowledge that all information you provide to register with this Website or otherwise, including through the use of any interactive features on the Website, is governed by our "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":", and you consent to all actions we take with respect to your information consistent with our Privacy Policy. "}]]],["p",{},[["textNode",{"text":" If you choose, or are provided with, a username, password, or any other piece of information as part of our security procedures, you must treat that information as confidential, and you must not disclose it to any other person or entity. You also acknowledge that your account is personal to you and you will not provide any other person with access to this Website or parts of it using your username, password, or other security information. You will promptly notify us of any unauthorized access to or use of your username or password or any other breach of security. You also will ensure that you exit from your account at the end of each session. You should use particular caution when accessing your account from a public or shared computer so that others are not able to view or record your password or other personal information. "}]]],["p",{},[["textNode",{"text":" We may disable any username, password, or other identifier, whether chosen by you or provided by us, at any time in our sole discretion for any or no reason, including if, in our opinion, you have violated any part of this agreement. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Intellectual-Property Rights"}]]]]],["p",{},[["textNode",{"text":" The Website and its entire contents, features, and functionality (including all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement of it) are owned by the Model, the Model’s licensors, or other providers of that material and are protected by copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws. "}]]],["p",{},[["textNode",{"text":" This agreement permits you to use the Website for your personal, noncommercial use only. You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on the Website, except as follows: "}],["ul",{},[["li",{},[["textNode",{"text":"Your computer may temporarily store copies of those materials in RAM incidental to your accessing and viewing those materials."}]]],["li",{},[["textNode",{"text":"You may store files that are automatically cached by your Web browser for display enhancement purposes."}]]],["li",{},[["textNode",{"text":"You may print or download one copy of a reasonable number of pages of the Website for your own personal, noncommercial use and not for further reproduction, publication, or distribution."}]]],["li",{},[["textNode",{"text":"You may download or print a copy of any part of the premium content to which you have properly gained access solely for your personal, noncommercial use and not for further reproduction, publication, or distribution."}]]],["li",{},[["textNode",{"text":"If we provide desktop, mobile, or other applications for download, you may download a single copy to your computer or mobile device solely for your own personal, noncommercial use, on condition that you agree to be bound by the Company’s end user license agreement for those applications."}]]],["li",{},[["textNode",{"text":"If we provide "}],["a",{"class":"anchorlink","data-target":"buying"},[["textNode",{"text":"social media features"}]]],["textNode",{"text":" with certain content, you may take those actions as are enabled by those features."}]]],["p",{},[["textNode",{"text":"You must not:"}]]],["li",{},[["textNode",{"text":"Modify copies of any materials from this Website."}]]],["li",{},[["textNode",{"text":"Use any illustrations, photographs, video or audio sequences, or any graphics separately from the accompanying text."}]]],["li",{},[["textNode",{"text":"Delete or alter any copyright, trademark, or other proprietary rights notices from copies of materials from this Website."}]]]]]]],["p",{},[["textNode",{"text":"You must not access or use for any commercial purposes any part of the Website or any services or materials available through the Website."}]]],["p",{},[["textNode",{"text":" If you print, copy, modify, download, or otherwise use or provide any other person with access to any part of the Website in breach of this agreement, your right to use the Website will stop immediately and you must, at our option, return or destroy any copies of the materials you have made. No interest in or to the Website or any content on the Website is transferred to you, and all rights not expressly granted are reserved by the Model. Any use of the Website not expressly permitted by this agreement is a breach of this agreement and may violate copyright, trademark, and other laws. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Trademarks"}]]]]],["p",{},[["textNode",{"text":" The Model’s name, the Model’s logo, the Website’s domain name, and all related names, logos, product and service names, designs, and slogans are the Model’s service marks, trademarks, and trade names. You must not use those marks without the Model’s written permission. All other names, logos, product and service names, designs, and slogans on this Website are the service marks, trademarks, or trade names of their respective owners. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Prohibited Uses"}]]]]],["p",{},[["textNode",{"text":" You may use the Website only for lawful purposes and in accordance with this agreement. You must not use the Website: "}],["ul",{},[["li",{},[["textNode",{"text":" In any way that violates any applicable federal, state, local, or international law or regulation (including any laws regarding the export of data or software to and from the U.S. or other countries). "}]]],["li",{},[["textNode",{"text":" For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing them to inappropriate content, asking for personally identifiable information, or otherwise. "}]]],["li",{},[["textNode",{"text":" To send, knowingly receive, upload, download, use, or re-use any material that does not comply with the "}],["a",{"class":"anchorlink","data-target":"standarts"},[["textNode",{"text":" Content Standards"}]]],["textNode",{"text":" set out in this agreement. "}]]],["li",{},[["textNode",{"text":" To transmit, or procure the sending of, any advertising or promotional material our written consent, including any “junk mail,” “chain letter,” “spam,” or any other similar solicitation. "}]]],["li",{},[["textNode",{"text":"To impersonate or attempt to impersonate the Model, another user, or any other person or entity (including by using email addresses or usernames associated with any of the foregoing). "}]]],["li",{},[["textNode",{"text":"To engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of the Website, or which, as determined by us, may harm the Model or users of the Website or expose them to liability. "}]]],["p",{},[["textNode",{"text":"Additionally, you must not:"}]]],["li",{},[["textNode",{"text":"Use the Website in any manner that could disable, overburden, damage, or impair the Website or interfere with any other party’s use of the Website, including their ability to engage in real time activities through the Website. "}]]],["li",{},[["textNode",{"text":"Use any robot, spider, or other automatic device, process, or means to access the Website for any purpose, including monitoring or copying any of the material on the Website. "}]]],["li",{},[["textNode",{"text":"Use any manual process to monitor or copy any of the material on the Website or for any other unauthorized purpose without our written consent. "}]]],["li",{},[["textNode",{"text":"Use any device, software, or routine that interferes with the proper working of the Website. "}]]],["li",{},[["textNode",{"text":"Introduce any viruses, trojan horses, worms, logic bombs, or other material that is malicious or technologically harmful. "}]]],["li",{},[["textNode",{"text":"Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the Website, the server on which the Website is stored, or any server, computer, or database connected to the Website. "}]]],["li",{},[["textNode",{"text":"Attack the Website via a denial-of-service attack or a distributed denial-of-service attack. "}]]],["li",{},[["textNode",{"text":"Otherwise try to interfere with the proper working of the Website. "}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"User Contributions"}]]]]],["p",{},[["textNode",{"text":" The Website may contain message boards, chat rooms, profiles, forums, bulletin boards, and other interactive features (collectively, “Interactive Services”) that allow users to post, submit, publish, display, or transmit to the Model, other users, or other persons (“post”) content or materials (collectively, “User Contributions”) on or through the Website. "}]]],["p",{},[["textNode",{"text":"All User Contributions must comply with the "}],["a",{"class":"anchorlink","data-target":"standarts"},[["textNode",{"text":" Content Standards"}]]],["textNode",{"text":" stated in this agreement."}]]],["p",{},[["textNode",{"text":" Any User Contribution you post to the Website will be considered nonconfidential and nonproprietary. By providing any User Contribution on the Website, you hereby grant us and our affiliates and service providers, and each of their and our respective licensees, successors, and assigns a license to use, reproduce, modify, perform, display, distribute, and otherwise disclose to third parties any User Contribution for any purpose unless otherwise provided in our Privacy Policy. "}]]],["p",{},[["textNode",{"text":" You state that: "}],["ol",{},[["li",{},[["textNode",{"text":"You own or control all rights in and to the User Contributions and have the right to grant the license granted above to us and our affiliates and service providers, and each of their and our respective licensees, successors, and assigns. "}]]],["li",{},[["textNode",{"text":"All your User Contributions do and will comply with this agreement. "}]]]]]]],["p",{},[["textNode",{"text":" You acknowledge that you are responsible for any User Contributions you submit or contribute, and you, not the Model, have full responsibility for that content, including its legality, reliability, accuracy, and appropriateness. "}]]],["p",{},[["textNode",{"text":" We are not responsible, or liable to any third party, for the content or accuracy of any User Contributions posted by you or any other Website user. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Monitoring and Enforcement; Termination"}]]]]],["p",{},[["textNode",{"text":" We may: "}],["ul",{},[["li",{},[["textNode",{"text":"Remove or refuse to post any User Contributions for any or no reason in our sole discretion. "}]]],["li",{},[["textNode",{"text":"Take any action with respect to any User Contribution that we consider necessary or appropriate in our sole discretion, including if we believe that that User Contribution violates this agreement, including the "}],["a",{"class":"anchorlink","data-target":"standarts"},[["textNode",{"text":" Content Standards"}]]],["textNode",{"text":", infringes any intellectual-property right or other right of any person or entity, threatens the personal safety of users of the Website or the public, or could create liability for the Model. "}]]],["li",{},[["textNode",{"text":"Disclose your identity or other information about you to any third party who claims that material posted by you violates their rights, including their intellectual-property rights or their right to privacy. "}]]],["li",{},[["textNode",{"text":"Take appropriate legal action, including referral to law enforcement, for any illegal or unauthorized use of the Website. "}]]],["li",{},[["textNode",{"text":"Terminate or suspend your access to all or part of the Website for any reason, including any violation of this agreement. "}]]]]]]],["p",{},[["textNode",{"text":" We will fully cooperate with any law enforcement authorities or court order requesting or directing us to disclose the identity or other information of anyone posting any materials on or through the Website. "}],["strong",{},[["textNode",{"text":" You waive and hold harmless the Model and the Model’s affiliates, licensees, and service providers from any claims resulting from any action taken by any of the foregoing parties during, or taken as a consequence of, investigations by either those parties or law enforcement authorities"}]]],["textNode",{"text":". "}]]],["p",{},[["textNode",{"text":" However, we do not undertake to review material before it is posted on the Website and cannot ensure prompt removal of objectionable material after it has been posted. Accordingly, we assume no liability for any action or inaction regarding transmissions, communications, or content provided by any user or third party. We have no liability or responsibility to anyone for performance or nonperformance of the activities described in this section. "}]]],["p",{"id":"standarts"},[["strong",{},[["textNode",{"text":"Content Standards"}]]]]],["p",{},[["textNode",{"text":"These content standards apply to all User Contributions and use of Interactive Services. User Contributions must in their entirety comply with all applicable federal, state, local, and international laws and regulations. User Contributions must not: "}],["ul",{},[["li",{},[["textNode",{"text":"Contain any material which is defamatory, obscene, indecent, abusive, offensive, harassing, violent, hateful, inflammatory, or otherwise objectionable. "}]]],["li",{},[["textNode",{"text":"Promote sexually explicit or pornographic material, violence, or discrimination based on race, sex, religion, nationality, disability, sexual orientation, or age. "}]]],["li",{},[["textNode",{"text":"Infringe any patent, trademark, trade secret, copyright, or other intellectual property or other rights of any other person. "}]]],["li",{},[["textNode",{"text":"Violate the legal rights (including the rights of publicity and privacy) of others or contain any material that could give rise to any civil or criminal liability under applicable laws or regulations or that otherwise may be in conflict with this agreement and our "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":" Privacy Policy"}]]],["textNode",{"text":". "}]]],["li",{},[["textNode",{"text":"Be likely to deceive any person. "}]]],["li",{},[["textNode",{"text":"Promote any illegal activity, or advocate, promote, or assist any unlawful act. "}]]],["li",{},[["textNode",{"text":"Cause annoyance, inconvenience, or needless anxiety or be likely to upset, embarrass, alarm, or annoy any other person. "}]]],["li",{},[["textNode",{"text":"Impersonate any person, or misrepresent your identity or affiliation with any person or organization. "}]]],["li",{},[["textNode",{"text":"Involve commercial activities or sales, such as contests, sweepstakes, and other sales promotions, barter, or advertising. "}]]],["li",{},[["textNode",{"text":"Give the impression that they emanate from or are endorsed by us or any other person or entity, if this is not the case. "}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Copyright Infringement"}]]]]],["p",{},[["textNode",{"text":"If you believe that any User Contributions violate your copyright, please provide us with the following information in accordance with the Digital Millennium Copyright Act: (1) a physical or electronic signature of the copyright owner or a person authorized to act on their behalf; (2) identification of the copyrighted work claimed to have been infringed; (3) identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate the material; (4) your contact information, including your address, telephone number, and an email address; (5) a statement by you that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law; and (6) a statement that the information in the notification is accurate, and, under penalty of perjury, that you are authorized to act on behalf of the copyright owner. It is the Model’s policy to terminate the user accounts of repeat infringers. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Reliance on Information Posted"}]]]]],["p",{},[["textNode",{"text":"The information presented on or through the Website is made available solely for general information purposes. We are not making any warranty about the accuracy, completeness, or usefulness of this information. Any reliance you place on that information is strictly at your own risk. We disclaim all liability and responsibility arising from any reliance placed on those materials by you or any other visitor to the Website, or by anyone who may be informed of any of its contents."}]]],["p",{},[["textNode",{"text":" This Website may include content provided by third parties, including materials provided by other users, bloggers, and third-party licensors, syndicators, aggregators, or reporting services. All statements or opinions expressed in these materials, and all articles and responses to questions and other content, other than the content provided by the Model, are solely the opinions and the responsibility of the person or entity providing those materials. These materials do not necessarily reflect the Model’s opinion. We are not responsible, or liable to you or any third party, for the content or accuracy of any materials provided by any third parties. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to the Website"}]]]]],["p",{},[["textNode",{"text":"We may update the content on this Website from time to time, but its content is not necessarily complete or up-to-date. Any of the material on the Website may be out of date at any given time, and we are not required to update that material."}]]],["p",{},[["strong",{},[["textNode",{"text":"Information About You and Your Visits to the Website"}]]]]],["p",{},[["textNode",{"text":"All information we collect on this Website is subject to our "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":" Privacy Policy"}]]],["textNode",{"text":". By using the Website, you consent to all actions taken by us with respect to your information in compliance with the Privacy Policy."}]]],["p",{},[["strong",{},[["textNode",{"text":"VIP Memberships"}]]]]],["div",{"class":"border"},[["p",{},[["strong",{},[["textNode",{"text":"Recurring Billing. "}]]],["textNode",{"text":"By starting a VIP membership and providing or designating a payment method, you authorize our third-party payment process to charge you a monthly membership fee at the then current rate, and any other charges you may incur in connection with your use of the Website."}]]],["p",{},[["strong",{},[["textNode",{"text":"Price Changes. "}]]],["textNode",{"text":"We may adjust pricing for our service or any components of it in any manner and at any time as we may determine in our sole discretion."}]]],["p",{},[["strong",{},[["textNode",{"text":"Billing Cycle. "}]]],["textNode",{"text":"The VIP membership fee for our service will be billed at the beginning of the paying part of your membership and each billing cycle afterwards, as indicated on the payment page at the time of initial purchase, until you cancel your membership"}]]],["p",{},[["strong",{},[["textNode",{"text":"No Refunds. "}]]],["span",{"x":""},[["textNode",{"text":"Payments are nonrefundable and there are no refunds or credits for partially used periods."}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Cancellation. "}]]],["textNode",{"text":"You may cancel your VIP membership at any time, and you will continue to have access to the VIP membership area through the end of your monthly billing period. "}]]]]],["p",{"id":"buying"},[["strong",{},[["textNode",{"text":"Buying Digital Content Individually"}]]]]],["p",{},[["textNode",{"text":" The Website may offer you the ability to buy digital content on an individual basis. If it does, you may buy digital content individually without purchasing a VIP membership. The price of the digital content will be the price indicated on the order pages when you placed your order. It is your responsibility to check the price before buying digital content. Unless the payment page indicates otherwise (for example, VAT taxes are collected from EU users), pricing excludes any taxes or currency transmission charges, which are extra costs charged to you. We may adjust pricing for individual digital content at any time as we may determine in our sole discretion. "}]]],["p",{},[["textNode",{"text":"We accept payment through our third-party payment processor. You must pay for the digital content before you download it."}]]],["p",{},[["textNode",{"text":"If you think an invoice is wrong, please contact us promptly to let us know. If you fail to notify us within 30 days of receiving the invoice, you waive any disputed charges. We will correct any mistakes in an invoice and credit them against your future purchases."}]]],["div",{"class":"border"},[["span",{"class":"red-message"},[["textNode",{"text":"All sales and transactions are final. Once you pay for digital content, it is nonrefundable."}]]],["textNode",{"text":" But we may approve a refund in the form of a credit on request if exceptional circumstances exist. The amount and form of a refund, and the decision to provide it, is at our sole discretion. The provision of a refund in one instance does not entitle you to a refund in the future for similar instances; nor does it obligate us to provide refunds in the future, under any circumstance. "}]]],["p",{},[["strong",{},[["textNode",{"text":" Terms of Sale for Model Products"}]]]]],["p",{},[["textNode",{"text":" The Model may sell various goods through the Website. The images of the products on our Website are for illustrative purposes only. Although we have made every effort to display the colors accurately, we cannot guarantee that a device’s display of the colors accurately reflects the color of the products. Your product may vary slightly from those images. "}]]],["p",{},[["textNode",{"text":" You acknowledge that your order is an offer to buy, under these terms, all products listed in your order. All orders must be accepted by us or we will not be required to sell the products to you. We may choose not to accept any orders in our sole discretion. After having received your order, we will send you a confirmation email with the details of the products you have ordered. Acceptance of your order will not take place until you have received your order confirmation email. You have the option to cancel your order at any time before we have sent your order confirmation email by emailing us at "}],["a",{"href":"mailto:support@modelcentro.com"},[["textNode",{"text":"support@modelcentro.com"}]]],["textNode",{"text":". "}]]],["p",{},[["textNode",{"text":" All prices posted on this Website are subject to change without notice. The price charged for a product will be the price in effect at the time the order is placed and will be stated in your order confirmation email. Price increases will only apply to orders placed after those changes. Unless the payment page indicates otherwise (for example, VAT taxes are collected from EU users), posted prices do not include taxes or charges for shipping and handling. All those taxes and charges will be added to your merchandise total and will be itemized in your shopping cart and in your order confirmation email. We are not responsible for pricing, typographical, or other errors in any offer by us and we reserve the right to cancel any orders arising from those errors. "}]]],["p",{},[["textNode",{"text":" Terms of payment are within our sole discretion and, unless otherwise agreed by us in writing, payment must be received by us before our acceptance of an order. All payments are processed by Eurobill Tech. Ltd, 9 Karpenisiou, 2021 Nicosia, Strovolos, Cyprus and Centrobill Ltd, 253 Main Street, Suite 222, Matawan NJ 07747, USA. You state that (i) the credit card information you supply to our third-party payment processor is accurate; (ii) you are duly authorized to use that credit card for the purchase; (iii) charges incurred by you will be honored by your credit card company; and (iv) you will pay charges incurred by you at the posted prices, including all applicable taxes, if any. "}]]],["p",{},[["textNode",{"text":" We will arrange for shipment of the products to you. Please check the individual product page for specific delivery options. You will pay all shipping and handling charges specified during the ordering process. "}]]],["p",{},[["textNode",{"text":" Title and risk of loss pass to you on delivery. Shipping and delivery dates are estimates only and cannot be guaranteed. We are not liable for any delays in shipments. "}]]],["p",{},[["span",{"class":"red-message"},[["textNode",{"text":"All sales and transactions are final. Once you pay for a product, it is nonrefundable."}]]],["textNode",{"text":" But we may approve a refund in the form of a credit on request if exceptional circumstances exist. The amount and form of a refund, and the decision to provide it, is at our sole discretion. The provision of a refund in one instance does not entitle you to a refund in the future for similar instances; nor does it obligate us to provide refunds in the future, under any circumstance. "}]]],["div",{"class":"border"},[["p",{"class":"red-message"},[["textNode",{"text":" We do not provide any warranties with respect to the products offered on our Website. All products offered on this Website are provided “as is” without any warranty, including any (a) warranty of merchantability; (b) warranty of fitness for a particular purpose; or (c) warranty against infringement of intellectual property rights of a third party; whether express or implied by law, course of dealing, course of performance, usage of trade, or otherwise. "}]]],["p",{"class":"red-message"},[["textNode",{"text":" Some jurisdictions limit or do not allow the disclaimer of implied or other warranties so the above disclaimer may not apply to you. "}]]],["p",{"class":"red-message"},[["textNode",{"text":" In no event will we be liable to you or any third party for consequential, indirect, incidental, special, exemplary, punitive or enhanced damages, or lost profits arising out of, or relating to, or in connection with any breach of this agreement, regardless of (a) whether those damages were foreseeable, (b) whether or not you advised us of the possibility of those damages, and (c) the legal or equitable theory (contract, tort, or otherwise) on which the claim is based. "}]]],["p",{"class":"red-message"},[["textNode",{"text":" Our sole maximum liability, for any reason, and your sole remedy for any cause, will be limited to the actual amount paid by you for the products and services you have ordered through our Site. "}]]],["p",{"class":"red-message"},[["textNode",{"text":" The limitation of liability stated above will: (i) only apply to the extent permitted by law and (ii) not apply to (A) liability resulting from our gross negligence or willful misconduct and (B) death or bodily injury resulting from our acts or omissions. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Linking to the Website and Social Media Features"}]]]]],["p",{},[["textNode",{"text":"You may link to our homepage, on condition that you do so in a way that is fair and legal and does not damage our reputation or take advantage of it, but you must not establish a link in a way that suggests any form of association, approval, or endorsement on our part without our express written consent."}]]],["p",{},[["textNode",{"text":" This Website may provide certain social media features that enable you to: "}],["ul",{},[["li",{},[["textNode",{"text":"Link from your own or certain third-party websites to certain content on this Website. "}]]],["li",{},[["textNode",{"text":"Send emails or other communications with certain content, or links to certain content, on this Website. "}]]],["li",{},[["textNode",{"text":"Cause limited parts of content on this Website to be displayed or appear to be displayed on your own or certain third-party websites. "}]]],["p",{},[["textNode",{"text":"You may use these features solely as they are provided by us and solely with respect to the content they are displayed with and otherwise in accordance with any additional terms we provide with respect to those features. Subject to the foregoing, you must not:"}]]],["li",{},[["textNode",{"text":"Establish a link from any website that is not owned by you. "}]]],["li",{},[["textNode",{"text":"Cause the Website or parts of it to be displayed, or appear to be displayed by, for example, framing, deep linking, or in-line linking, on any other site. "}]]],["li",{},[["textNode",{"text":"Link to any part of the Website other than the homepage. "}]]],["li",{},[["textNode",{"text":"Otherwise take any action with respect to the materials on this Website that is inconsistent with any other part of this agreement. "}]]]]]]],["p",{},[["textNode",{"text":" The website from which you are linking, or on which you make certain content accessible, must comply in all respects with the "}],["a",{"class":"anchorlink","data-target":"standarts"},[["textNode",{"text":"Content Standards"}]]],["textNode",{"text":" set out in this agreement. "}]]],["p",{},[["textNode",{"text":" You will cooperate with us in causing any unauthorized framing or linking immediately to stop. We reserve the right to withdraw linking permission without notice. "}]]],["p",{},[["textNode",{"text":" We may disable any social media features and any links at any time without notice in our discretion. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Links from the Website"}]]]]],["p",{},[["textNode",{"text":" If the Website contains links to other sites and resources provided by third parties, these links are provided for your convenience only. This includes links contained in advertisements, including banner advertisements and sponsored links. We have no control over the contents of those sites or resources and accept no responsibility for them or for any loss or damage that may arise from your use of them. If you decide to access any of the third-party websites linked to this Website, you do so entirely at your own risk and subject to the terms of use for those websites. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Geographic Restrictions"}]]]]],["p",{},[["textNode",{"text":" We make no claims that the Website or any of its content is accessible or appropriate in your country. Access to the Website may not be legal by certain persons or in certain countries. If you access the Website from countries that prohibit adult-oriented content, you do so on your own initiative and are responsible for compliance with local laws. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Disclaimer of Warranties"}]]]]],["div",{"class":"border"},[["p",{},[["textNode",{"text":" You understand that we cannot and do not guarantee or warrant that files available for downloading from the Internet or the Website will be free of viruses or other destructive code. You are responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements for anti-virus protection and accuracy of data input and output, and for maintaining a means external to the Website for any reconstruction of any lost data. "}],["strong",{},[["textNode",{"text":"We will not be liable for any loss or damage caused by a distributed denial-of-service attack, viruses, or other technologically harmful material that may infect your computer equipment, computer programs, data, or other proprietary material due to your use of the Website or any services or items obtained through the Website or to your downloading of any material posted on it, or on any website linked to it"}]]],["textNode",{"text":". "}]]],["p",{},[["strong",{},[["textNode",{"text":" Your use of the Website, its content, and any services or items obtained through the Website is at your own risk. The Website, its content, and any services or items obtained through the Website are provided “as is” and “as available,” without any warranties of any kind, either express or implied. Neither the Model nor any person associated with the Model is making any warranty or representation with respect to the completeness, security, reliability, quality, accuracy, or availability of the Website. Neither the Model nor anyone associated with the Model represents or warrants that the Website, its content, or any services or items obtained through the Website will be accurate, reliable, error-free, or uninterrupted, that defects will be corrected, that the Website or the server that makes it available are free of viruses or other harmful components, or that the Website or any services or items obtained through the Website will otherwise meet your needs or expectations. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":" We hereby disclaim all warranties of any kind, whether express or implied, statutory, or otherwise, including any warranties of merchantability, noninfringement, and fitness for particular purpose. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":" The foregoing does not affect any warranties that cannot be excluded or limited under applicable law. "}]]]]]]],["p",{},[["textNode",{"text":" Limitation on Liability "}]]],["div",{"class":"border"},[["p",{},[["textNode",{"text":" To the fullest extent provided by law, in no event will the collective liability of the Model, the Model’s affiliates, or their licensors, service providers, employees, agents, officers, or directors to any party (regardless of the form of action, whether in contract, tort, or otherwise) exceed the greater of $250 or the amount you have paid to the Model for the applicable content, product, or service in the last three months out of which liability arose. Nor will the Model, the Model’s affiliates, or their licensors, service providers, employees, agents, officers, or directors be liable for damages of any kind, under any legal theory, arising out of or in connection with your use, or inability to use, the Website, any websites linked to it, any content on the Website or those other websites or any services or items obtained through the Website or those other websites, including any direct, indirect, special, incidental, consequential, or punitive damages, including personal injury, pain and suffering, emotional distress, loss of revenue, loss of profits, loss of business or anticipated savings, loss of use, loss of goodwill, loss of data, and whether caused by tort (including negligence), breach of contract, or otherwise, even if foreseeable. "}]]],["p",{},[["textNode",{"text":" The foregoing does not affect any liability that cannot be excluded or limited under applicable law, including liability resulting from our gross negligence or willful misconduct or death or bodily injury caused by products you purchase through the Website. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Indemnification"}]]]]],["p",{},[["textNode",{"text":"You will defend, indemnify, and hold harmless the Model, the Model’s affiliates, licensors, and service providers, and the Model’s and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys’ fees) arising out of or relating to your violation of this agreement or your use of the Website, including your User Contributions, any use of the Website’s content, services, and products other than as expressly authorized in this agreement or your use of any information obtained from the Website."}]]],["p",{},[["strong",{"id":"gover"},[["textNode",{"text":"Governing Law and Jurisdiction"}]]]]],["p",{},[["textNode",{"text":"New York law governs all matters relating to the Website and this agreement and any dispute or claim arising from or related to it (in each case, including non-contractual disputes or claims) without giving effect to any choice or conflict of law provision or rule (whether of New York or any other jurisdiction)."}]]],["p",{},[["textNode",{"text":"Any legal suit, action, or proceeding arising out of, or related to, this agreement or the Website not subject to arbitration will be instituted exclusively in the federal courts of the United States or the courts of the state of New York, although we may bring any suit, action, or proceeding against you for breach of this agreement in your country of residence or any other relevant country. You waive all objections to the exercise of jurisdiction over you by those courts and to venue in those courts."}]]],["p",{},[["strong",{},[["textNode",{"text":"Binding Arbitration"}]]]]],["div",{"class":"border"},[["p",{},[["strong",{},[["textNode",{"text":" All claims and disputes arising under or relating to this agreement or this Website are to be settled by binding arbitration. The arbitration will be conducted by Arbitration Resolution Services, Inc. (ARS) and the parties will be bound by all rules of ARS and any award/decision rendered. ARS rules can be found at www.arbresolutions.com. Any decision or award as a result of any such arbitration will be in writing and will provide an explanation for all decisions. Any such arbitration will be conducted by an arbitrator experienced in electronic commerce and will include a written record of the arbitration hearing. Any award of arbitration may be confirmed in a court of competent jurisdiction. "}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Class Action Waiver"}]]]]],["div",{"class":"border"},[["p",{},[["strong",{},[["textNode",{"text":" All claims arising out of or relating to this agreement or the Website must be brought in the parties’ individual capacity, and not as a plaintiff or class member in any purported class or representative proceeding, and, unless the Model agrees otherwise, the arbitrator must not consolidate more than one person’s claims. "}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Limitation on Time to File Claims"}]]]]],["div",{"class":"border"},[["p",{},[["strong",{},[["textNode",{"text":" Any cause of action or claim you may have arising out of or relating to this agreement or the Website must be commenced within one year after the cause of action accrues, otherwise, that cause of action or claim is permanently barred. "}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Waiver and Severability"}]]]]],["p",{},[["textNode",{"text":" No waiver by the Model of any term stated in this agreement will be deemed a further or continuing waiver of that term or a waiver of any other term, and any failure of the Model to assert a right or provision under this agreement will not constitute a waiver of that right or provision. "}]]],["p",{},[["textNode",{"text":" If any provision of this agreement is held by a court or other tribunal of competent jurisdiction to be invalid, illegal, or unenforceable for any reason, that provision will be eliminated or limited to the minimum extent so that the remaining provisions of this agreement will continue in full effect. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Entire Agreement"}]]]]],["p",{},[["textNode",{"text":" This agreement and our "}],["a",{"href":"/privacy-policy"},[["textNode",{"text":" Privacy Policy"}]]],["textNode",{"text":" constitute the entire agreement between you and the Model regarding the Website and supersede all earlier and contemporaneous understandings, agreements, representations, and warranties, both written and oral, regarding the Website. Additional terms may also apply to specific portions, services, or features of the Website. Any additional terms are incorporated by this reference into this agreement. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Electronic Communications, Transactions, and Signatures"}]]]]],["p",{},[["textNode",{"text":" Visiting the Website, sending us emails, and completing online forums constitute electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the Website, satisfy any legal requirement that that communication be in writing. "}],["strong",{},[["textNode",{"text":" You hereby agree to the use of electronic signatures, contracts, orders, and other records, and to electronic delivery of notices, policies, and records of transactions initiated or completed by us or via the Website"}]]],["textNode",{"text":". You hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means. "}]]],["p",{},[["strong",{},[["textNode",{"text":"California Users and Residents"}]]]]],["p",{},[["textNode",{"text":" If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Feedback"}]]]]],["p",{},[["textNode",{"text":" We encourage you to give feedback about the Website. But we will not treat as confidential any suggestion or idea you give, and nothing in this agreement will restrict our right to use, profit from, disclose, publish, or otherwise exploit any feedback, without payment to you. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Your Comments and Concerns"}]]]]],["p",{},[["textNode",{"text":" All feedback, comments, requests for technical support, and other communications relating to the Website should be directed to: "}],["a",{"href":"mailto:support@modelcentro.com"},[["textNode",{"text":"support@modelcentro.com"}]]],["textNode",{"text":". "}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_liveshownew", [["div",{"id":"liveshow-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_myfriends", [["div",{"id":"myfriends-container","class":"blog cols recipes"}],["div",{"id":"newsletter-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("stateoff_siteclosed_footer", [["div",{"class":"contact","data-fox-alias":"siteClosedContactText"},[["textNode",{"text":" On any questions about your membership "}],["a",{"href":"https://support.modelcentro.com/hc/en-us/requests/new","target":"_blank","rel":"nofollow"},[["textNode",{"text":"contact us"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("stateoff_siteclosed_header", [["div",{"class":"avatar"},[["div",{"class":"avatar-wrap"},[["div",{"class":"avatar-left-line avatar-line"}],["a",{"class":"avatar-img","href":"/"},[["if",{"notempty":""},[["img",{"src":"","alt":"avatar"},[],[["socialImage","src",true,[],"env"]]],["else",{},[["img",{"src":"" + __webpack_require__(10) + "","alt":"avatar"}]]]],[["socialImage","notempty",true,[],"env"]]]]],["div",{"class":"avatar-right-line avatar-line"}]]],["div",{"class":"avatar-name"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]],["div",{"class":"info-text","data-fox-alias":"siteClosedTitleText"},[["textNode",{"text":" We are sorry. The website of "}],["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" no longer accepts new customers. "}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("stateoff_user_login", [["form",{"id":"login_form","class":"auth-form","autocomplete":"off"},[["div",{"id":"message","class":"login-form-error-message error"}],["div",{"class":"login-form-error-message default"},[["div",{"class":"default-message"},[["p",{},[["textNode",{"text":"Sign in failed, your account is inactive."}]]],["p",{},[["textNode",{"text":"This could happen because either your membership has expired or there was a problem processing your payment."}]]],["p",{},[["textNode",{"text":"Please contact "}],["a",{"id":"_reportProblem"},[["textNode",{"text":"customer support"}]]],["textNode",{"text":" for more information."}]]]]]]],["div",{"class":"row"},[["div",{},[["div",{"class":"mc-common-input login"},[["input",{"type":"text","name":"le","autocomplete":"off","placeholder":"User name or email"}]]],["div",{"class":"error-message"}]]]]],["div",{"class":"row"},[["div",{},[["div",{"class":"mc-common-input pass"},[["input",{"type":"password","name":"password","placeholder":"Password"}]]],["div",{"class":"error-message"}]]]]],["div",{"class":"row capcha","id":"captchaBlock","style":"display: none"},[["div",{"class":"capcha-block-wrapper"},[["div",{"class":"capcha-wrapper"},[["div",{"id":"captcha","class":"capcha-img-wrap"}],["div",{"class":"reload-captcha stateoff-icon-captchaRefresh_17","id":"reload_captcha"}]]],["div",{"class":"mc-common-input capcha-input"},[["input",{"type":"text","name":"captcha","placeholder":"Type symbols from the image"}]]]]],["div",{"class":"error-message"}]]],["div",{"class":"row forgot-row caption"},[["a",{"href":"/password-recovery","class":"forgot"},[["textNode",{"text":"I forgot my password"}]]]]],["div",{"class":"row btns clearfix"},[["div",{},[["div",{"class":"mc-common-button"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["div",{"data-fox-alias":"stateoffLoginSubmitText"},[["textNode",{"text":"login"}]]],["input",{"type":"submit","name":"submit","value":"submit"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("stateoff_newsletterblock", [["div",{"class":"caption","data-fox-alias":"siteUnderConstrSubscribeTitleText"},[["textNode",{"text":"If you would like to be notified when it launches please subscribe to my newsletter below:"}]]],["div",{"class":"nsl-wrapper"},[["div",{"class":"nsl-form"},[["div",{"class":"field-set field-name"},[["div",{"class":"mc-common-input"},[["input",{"name":"name","type":"text","placeholder":"Your name"}]]],["div",{"class":"error-message"}]]],["div",{"class":"field-set field-email"},[["div",{"class":"mc-common-input"},[["input",{"name":"email","type":"text","placeholder":"Your email"}]]],["div",{"class":"error-message"}]]],["div",{"class":"field-set btns"},[["button",{"class":"mc-common-button subscribe-btn","id":"subscribe-to-site"},[["div",{"data-fox-alias":"stateoffSubscribeBtnText"},[["textNode",{"text":"subscribe"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_stateoff_passwordrecovery", [["div",{"class":"site-closed stateoff-page"},[["div",{"class":"stateoff-page-wrap"},[["import",{"name":"stateoff_siteClosed_header"}],["div",{"id":"find-me","class":"find-me"}],["div",{"class":"h-separator"}],["div",{"class":"authorization"},[["div",{"class":"loginform_container forgotform_container autorization-container","id":"password-recovery-form"}]]],["import",{"name":"stateoff_siteClosed_footer"}]]]]],["div",{"class":"stateoff-page-bg"},[["div",{"class":"stateoff-page-bg-overlay"}]]]]);
fox.registerTemplate("stateoff_passwordrecovery_form", [["div",{"class":"auth-form"},[["div",{"data-fox-alias":"loginWelcomeText","class":"caption"},[["textNode",{"text":"Password recovery"}]]],["div",{"class":"errors-block login-form-error-message default common-error-text-color","id":"recovery-message"}],["form",{"id":"email-form","class":"form_block","action":"#","method":"post","style":"display: block","autocomplete":"off"},[["div",{"class":"row"},[["div",{"class":"mc-common-input email"},[["input",{"type":"text","name":"email","id":"forgot-input","placeholder":"Your email"}]]],["div",{"class":"error-message"}]]],["div",{"class":"row btns clearfix"},[["button",{"id":"submit-btn","class":"mc-common-button"},[["textNode",{"text":"Submit"}]]]]]]]]]]);
fox.registerTemplate("stateoff_passwordrecovery_form_confirmation", [["div",{"class":"auth-form"},[["div",{"data-fox-alias":"loginWelcomeText","class":"caption"},[["textNode",{"text":"Password recovery"}]]],["div",{"class":"messages errors-block error","id":"recovery-message"}],["if",{"empty":""},[["form",{"id":"confirmation-form","name":"confirmation_form","class":"form_block","style":"display: block","autocomplete":"off"},[["div",{"class":"row"},[["p",{},[["textNode",{"text":"Please enter your new password and confirm new password."}]]]]],["div",{"class":"row"},[["div",{"class":"mc-common-input email"},[["input",{"type":"password","name":"password","placeholder":"New password","autocomplete":"off"}]]],["div",{"class":"error-message"}]]],["div",{"class":"row"},[["div",{"class":"mc-common-input email"},[["input",{"type":"password","name":"confirm","placeholder":"Confirm password","autocomplete":"off"}]]],["div",{"class":"error-message"}]]],["div",{"class":"row btns clearfix"},[["button",{"class":"mc-common-button","id":"submit-btn"},[["textNode",{"text":" Send "}]]]]]]],["else",{},[["p",{},[["textNode",{"text":"The password reset request has expired, please click "}],["a",{"href":"/login"},[["textNode",{"text":"here"}]]],["textNode",{"text":" to make another request."}]]]]]],[["isError","empty",true]]]]]]);
fox.registerTemplate("stateoff_popup_user_passwordrecoverysuccess", [["div",{"class":"stateoff-tips-popup"},[["span",{"class":"stateoff-icon-close_9 close"}],["div",{"class":"widgetContainer","id":"popup-widget-container"},[["div",{"class":"popup-title"},[["textNode",{"text":"Password Retrieval"}]]],["div",{"class":"popup-content"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"We`ve sent new password to your mail!"}]]]]],["div",{"class":"popup-footer"},[["button",{"class":"mc-common-button confirm close"},[["div",{},[["textNode",{"text":"Ok"}]]]]]]]]]]]]);
fox.registerTemplate("stateoff_popup_user_passwordchangesuccess", [["div",{"class":"stateoff-tips-popup"},[["span",{"class":"stateoff-icon-close_9 close"}],["div",{"class":"widgetContainer","id":"popup-widget-container"},[["div",{"class":"popup-title"},[["textNode",{"text":"Password Change"}]]],["div",{"class":"popup-content"},[["p",{},[["textNode",{"text":"Password has been successfuly changed!"}]]]]],["div",{"class":"popup-footer"},[["button",{"class":"mc-common-button confirm close"},[["div",{},[["textNode",{"text":"Ok"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_siteclosed", [["div",{"class":"site-closed stateoff-page"},[["div",{"class":"stateoff-page-wrap"},[["import",{"name":"stateoff_siteClosed_header"}],["div",{"id":"find-me","class":"find-me"}],["div",{"class":"h-separator"}],["div",{"class":"authorization"},[["div",{"class":"caption","data-fox-alias":"siteClosedAuthTitleText"},[["textNode",{"text":"Current members, please login here:"}]]],["div",{"id":"autorization-container","class":"autorization-container"}]]],["import",{"name":"stateoff_siteClosed_footer"}]]]]],["div",{"class":"stateoff-page-bg"},[["div",{"class":"stateoff-page-bg-overlay"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_siteunderconstruction", [["div",{"class":"site-under-construction stateoff-page"},[["div",{"class":"stateoff-page-wrap"},[["div",{"class":"avatar"},[["div",{"class":"avatar-wrap"},[["div",{"class":"avatar-left-line avatar-line"}],["div",{"class":"avatar-img"},[["if",{"notempty":""},[["img",{"src":"","alt":"avatar"},[],[["socialImage","src",true,[],"env"]]],["else",{},[["img",{"src":"" + __webpack_require__(10) + "","alt":"avatar"}]]]],[["socialImage","notempty",true,[],"env"]]]]],["div",{"class":"avatar-right-line avatar-line"}]]],["div",{"class":"avatar-name"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]]],["div",{"class":"info-text","data-fox-alias":"siteUnderConstrTitleText"},[["textNode",{"text":" My brand-new website is currently under construction. Stay tuned! "}]]],["div",{"id":"newsletter-container","class":"subscribe"}],["div",{"class":"h-separator"}],["div",{"id":"tipme","class":"tipme"}],["div",{"id":"find-me","class":"find-me"}]]]]],["div",{"class":"stateoff-page-bg"},[["div",{"class":"stateoff-page-bg-overlay"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("stateoff_social_apps_row", [["a",{"class":"","href":"","title":"","rel":"nofollow"},[["if",{"notempty":"","addattr":"target:_blank"},[],[["newTarget","notempty",true]]]],[["elementClass","class",true],["pageUrl","href",true],["title","title",true]]]]);
fox.registerTemplate("stateoff_social_appsblock", [["div",{"class":"caption"},[["textNode",{"text":"Find "}],["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" here:"}]]],["div",{"id":"find-me-container","class":"find-me-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("stateoff_content_tipmeblock", [["div",{"class":"caption","data-fox-alias":"siteUnderConstrTipTitleText"},[["textNode",{"text":"Want to help me launch sooner? Donations are appreciated:"}]]],["div",{"id":"tipme-container","class":"tipme-container"}]]);
fox.registerTemplate("stateoff_tips_popup_container", [["div",{"class":"stateoff-tips-popup"},[["span",{"class":"stateoff-icon-close_9 close"}],["div",{"class":"widgetContainer","id":"popup-widget-container"}]]]]);
fox.registerTemplate("stateoff_content_tipme", [["div",{"class":"mc-common-input simple tip"},[["span",{"class":"icon stateoff-icon-gift_18"}],["textNode",{"text":" "}],["input",{"type":"text","name":"password","id":"tip-amount","placeholder":"$5"}]]],["button",{"class":"mc-common-button tip-me tip-btn","id":"tip-model"},[["div",{"data-fox-alias":"stateoffTipBtnText"},[["textNode",{"text":"Tip"}]]]]]]);
fox.registerTemplate("stateoff_content_tipme_confirm", [["div",{"class":"popup-title"},[["textNode",{"text":"Attention"}]]],["div",{"class":"popup-content"},[["div",{"class":"tips-popup-notice small-notice"},[["textNode",{"text":"You are about to tip "}],["span",{},[],[["site.title","__text",true,[],"env"]]],["textNode",{"text":" "}],["strong",{},[["textNode",{"text":"$"}],["span",{},[],[["amount","__text",true]]]]]]],["p",{"class":"vat-eu"},[["textNode",{"text":"You may be charged VAT if you are in EU."}]]],["div",{"class":"msg-block"},[["div",{"class":"mc-common-input textarea simple"},[["textarea",{"placeholder":"Add a personal message to me","name":"tipsMessage"}]]]]],["if",{"empty":""},[["div",{"class":"msg-block"},[["div",{"class":"row"},[["div",{"class":"mc-common-input simple"},[["input",{"type":"text","name":"login","class":"","placeholder":"Enter your nickname"}]]],["div",{"class":"error-message"},[["textNode",{"text":"please enter your nickname"}]]]]],["div",{"class":"row"},[["div",{"class":"mc-common-input simple"},[["input",{"type":"text","name":"email","class":"","placeholder":"Enter your email"}]]],["div",{"class":"error-message"},[["textNode",{"text":"please enter your email"}]]]]]]]],[["id","empty",true,[],"member"]]]]],["div",{"class":"popup-footer"},[["button",{"class":"mc-common-button confirm"},[["div",{},[["textNode",{"text":"Confirm"}]]]]]]]]);
fox.registerTemplate("stateoff_tips_popup_thanks", [["div",{"class":"popup-title"},[["textNode",{"text":"Thank you "}],["span",{},[],[["name","__text",true]]],["textNode",{"text":"!"}]]],["div",{"class":"popup-content"},[["div",{"class":"tips-popup-notice"},[["textNode",{"text":"I really appreciate your support, it makes me so inspired!"}]]]]],["div",{"class":"popup-footer"},[["span",{"class":"mc-common-button close"},[["textNode",{"text":"Ok"}]]]]]]);
fox.registerTemplate("stateoff_tips_popup_wrong", [["div",{"class":"popup-title"},[["textNode",{"text":"Oops, something went wrong"}]]],["div",{"class":"popup-content"},[["div",{"class":"tips-popup-notice"},[["textNode",{"text":"Your tip wasn't sent. Please try to reload the page and try again or contact customer support if the problem persists."}]]]]],["div",{"class":"popup-footer"},[["span",{"class":"mc-common-button close"},[["textNode",{"text":"Ok"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("social_favorite", [["a",{"class":"fav-link bookmark","data-target-id":""},[["if",{"notempty":"","addclass":"checked"},[],[["isFavorite","notempty",true]]],["if",{"notempty":"","addattr":"href:&&1&&"},[],[["member","notempty",true,[{"name":"hasAccess","params":["guest"]}]],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["i",{},[["if",{"notempty":"","addclass":""},[["else",{"addclass":""},[],[["iconAddFavorite","addclass",true]]]],[["isFavorite","notempty",true],["iconRemoveFavorite","addclass",true]]]]],["textNode",{"text":" "}],["span",{"class":"action-link-text fav-add"},[["textNode",{"text":"Add to favorites"}]]],["textNode",{"text":" "}],["span",{"class":"action-link-text fav-remove"},[["textNode",{"text":"Remove from favorites"}]]]],[["targetId","data-target-id",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("social_rating", [["span",{"class":"rating-new"},[["a",{"title":"I like this content!","class":"rate good","data-value":"5","data-target-id":""},[["if",{"notempty":"","addclass":"active"},[],[["currentMemberRating","notempty",true,[{"name":"eq","params":["5"]}]]]],["if",{"notempty":"","addattr":"href:&&1&&"},[["else",{"addattr":"data-target-id:&&0&&"},[],[["targetId","__internal"]]]],[["member","notempty",true,[{"name":"hasAccess","params":["guest"]}]],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["span",{"class":"num"},[["span",{},[],[["good","__text",true]]]]],["textNode",{"text":" "}],["i",{"class":"rating-icon &&0&&"},[],[["iconLike","class"]]]],[["targetId","data-target-id",true]]],["textNode",{"text":" "}],["span",{"class":"total rating-separate"},[["span",{},[],[["total","__text",true]]]]],["textNode",{"text":" "}],["a",{"title":"I dislike this content!","class":"rate bad","data-value":"0","data-target-id":""},[["if",{"notempty":"","addclass":"active"},[],[["currentMemberRating","notempty",true,[{"name":"eq","params":["0"]}]]]],["if",{"notempty":"","addattr":"href:&&1&&"},[["else",{"addattr":"data-target-id:&&0&&"},[],[["targetId","__internal"]]]],[["member","notempty",true,[{"name":"hasAccess","params":["guest"]}]],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["i",{"class":"rating-icon &&0&&"},[],[["iconDislike","class"]]],["textNode",{"text":" "}],["span",{"class":"num"},[["span",{},[],[["bad","__text",true]]]]]],[["targetId","data-target-id",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("social_apps_row", [["a",{"class":"","href":"","title":"","rel":"nofollow"},[["if",{"notempty":"","addattr":"target:_blank"},[],[["newTarget","notempty",true]]],["if",{"notempty":""},[["img",{"src":"","alt":""},[],[["socImage","src",true],["title","alt",true,[{"name":"replace_text","params":["Twitter","Twitter "]}]]]]],[["socImage","notempty",true]]]],[["elementClass","class",true],["pageUrl","href",true],["title","title",true,[{"name":"replace_text","params":["Twitter","Twitter "]}]]]]]);
fox.registerTemplate("twitter_view_more", [["a",{"href":"","target":"_blank","rel":"nofollow"},[["textNode",{"text":"View More"}]],[["pageUrl","href",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_storecategories", [["div",{"class":"site-page store-list no-pb"},[["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title","data-fox-alias":"storeTitle"},[["p",{},[["textNode",{"text":"Shop"}]]]]]]]]],["section",{"class":"store-categories-wrapper"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("tags_filter_current", [["i",{"class":"root-ico_tags"}],["textNode",{"text":" "}],["span",{"title":""},[["span",{},[],[["alias","__text",true,[{"name":"truncate","params":["20","..."]}]]]]],[["alias","title",true]]],["textNode",{"text":" "}],["i",{"class":"root-ico_tags_arr arr"}]]);
fox.registerTemplate("tags_filter", [["section",{"class":"tags-filter-wrapper click-to-open"},[["div",{"class":"current bg-color-2 text-color-1"}],["div",{"class":"tags-list-wrapper bg-color-2"},[["div",{"class":"tags-search"}],["div",{"class":"tag-list-wrapper","style":"max-height: 200px"},[["div",{"class":"tags-scroll"},[["ul",{"class":"tags-list"}]]]]]]]]]]);
fox.registerTemplate("tags_filter_row", [["if",{"notempty":""},[["div",{"class":"loading"}],["else",{},[["li",{"data-tagid":"","class":"tag action"},[["if",{"notempty":"","addclass":"selected"},[],[["selected","notempty",true]]],["a",{"title":""},[["span",{},[],[["alias","__text",true,[{"name":"truncate","params":["20","..."]}]]]]],[["alias","title",true]]]],[["id","data-tagid",true]]]]]],[["alias","notempty",true,[{"name":"eq","params":["loading"]}]]]]]);
fox.registerTemplate("tags_filter_row_empty", [["li",{"class":"tag empty"},[["textNode",{"text":" Tag was not found. "}]]]]);
fox.registerTemplate("tags_filter_search", [["div",{"class":"tag-search-container"},[["input",{"type":"text","name":"tag-search","placeholder":"Filter by tag"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("throughtchatwindow", [["div",{"class":"througth-chat"},[["div",{"class":"througth-chat-wrapper"},[["if",{"notempty":"","addclass":"hidden"},[],[["chatWindowHidden","notempty",true]]],["div",{"class":"ui-resizable-n resize resize-n"}],["div",{"class":"chat-window"},[["div",{"class":"chat-title"},[["span",{"class":"name"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]],["div",{},[["div",{"id":"content-report","class":"content-report"}],["a",{"href":"/conversation","class":"open-conversation"},[["i",{"class":"chat-icon-root_chat_openConversation"}]]],["span",{"class":"close"},[["i",{"class":"ico-calendar_close_event"}]]]]]]],["div",{"class":"chat-wrapper"}]]],["div",{"class":"ui-resizable-s resize resize-s"}]]],["div",{"class":"througth-chat-notifications"},[["div",{"class":"model-image"},[["if",{"notempty":""},[["img",{"src":"","alt":"avatar"},[],[["socialImage","src",true,[],"env"]]],["else",{},[["img",{"src":"" + __webpack_require__(10) + "","alt":"avatar"}]]]],[["socialImage","notempty",true,[],"env"]]],["span",{"class":"status"}]]],["div",{"class":"counter"},[["i",{"class":"ico chat-icon-root_chat_newMessage"}],["span",{"class":"num"},[["textNode",{"text":"1"}]]]]]]]]]]);
fox.registerTemplate("throughtchatwindow_messages_container", [["div",{"class":"conversation-container"},[["div",{"id":"messages-list-scroll-wrapper","style":"overflow: hidden; max-height: 100%; position: relative;"},[["div",{"class":"messages-list messages"}]]]]],["div",{"class":"chat-send-message-block"},[["div",{},[["textarea",{"id":"textarea","placeholder":"Type your message here"}]]],["a",{"id":"send-message","class":"send-message"},[["i",{"class":"chat-icon-root_chat_send"}]]],["a",{"id":"open-gift-popup","class":"send-message"},[["i",{"class":"ls-icongift"}]]]]]]);
fox.registerTemplate("throughtchatwindow_messages_item", [["if",{"empty":""},[["if",{"notempty":""},[["div",{"class":"message-date-separator"},[["span",{"class":"messages-group-date"},[["span",{},[],[["timestamp","__text",true,[{"name":"dateFormat","params":[" %e %b, %Y"]}]]]]]]]]],[["diffDay","notempty",true,[{"name":"eq","params":["1"]}]]]],["div",{"id":"message-&&0&&","class":"message-row"},[["if",{"notempty":"","addclass":"not-my"},[],[["my","notempty",true,[{"name":"eq","params":["0"]}]]]],["if",{"notempty":"","addclass":"message-gift"},[["div",{"class":"message-bubble"},[["div",{"class":"gift-amount"},[["i",{"class":"icon-au_m_tips"}],["strong",{},[["textNode",{"text":"$"}],["span",{},[],[["price","__text",true]]]]]]],["span",{},[["textNode",{"text":"New gift from "}],["span",{},[],[["login","__text",true,[],"member"]]]]],["div",{"class":"gift &&0&&"},[],[["gift","class"]]]]],["else",{},[["div",{"class":"message-item"},[["div",{"class":"avatar-wrapper"},[["div",{"class":"avatar"},[["if",{"notempty":""},[["img",{"src":"" + __webpack_require__(10) + "","alt":"avatar"}],["span",{"class":"status online"}],["else",{},[["if",{"notempty":""},[["img",{"src":"","alt":"avatar"},[],[["socialImage","src",true,[],"env"]]],["else",{},[["img",{"src":"" + __webpack_require__(10) + "","alt":"avatar"}]]]],[["socialImage","notempty",true,[],"env"]]],["span",{"class":"status"}]]]],[["my","notempty",true,[{"name":"eq","params":["1"]}]]]]]]]],["div",{"class":"message-data-wrapper"},[["div",{"class":"message-content"},[["span",{},[],[["content","__text",true,[{"name":"transformLinks","params":[]},{"name":"html","params":[]}]]]]]],["if",{"notempty":""},[["if",{"notempty":""},[["div",{"class":"processing-placeholder"},[["textNode",{"text":"Your content in processing!!!"}]]]],[["notProcessed","notempty",true,[{"name":"eq","params":["1"]}]]]],["ul",{"class":"attachment-list"},[["if",{"notempty":"","addattr":"style:display:none;"},[],[["notProcessed","notempty",true,[{"name":"eq","params":["1"]}]]]],["foreach",{"from":"","item":"attach"},[["li",{"id":"at-&&0&&_&&1&&"},[],[["attach.clientUploadUserAccessId.uploadId.id","id"],["attach.messageId","id"]]]],[["attachments","from",true]]]]]],[["attachments","notempty",true,[{"name":"notEmptyDl","params":[]}]]]],["span",{"class":"message-time"},[["span",{},[],[["_ownerUser.time","__text",true]]]]]]]]]]]],[["serviceTypeAlias","notempty",true,[{"name":"eq","params":["gift"]}]]]]],[["id","id"]]]],[["hidden","empty",true,[{"name":"eq","params":["1"]}]]]]]);
fox.registerTemplate("content_report_icon", [["a",{"class":"content-report-link","data-subject":"message"},[["i",{"class":"icon-au_report"}]]]]);
fox.registerTemplate("content_report", [["a",{"class":"content-report-link"},[["i",{"class":"icon-au_report"}],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"REPORT"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_login", [["form",{"id":"login_form","class":"auth-form","autocomplete":"off"},[["if",{"notempty":""},[["div",{"class":"success-registration-message"},[["p",{},[["textNode",{"text":"Your account was successfully created!"}]]],["p",{},[["textNode",{"text":"Your password was e-mailed to you from "}],["a",{"href":"mailto:support@modelcentro.com"},[["textNode",{"text":"support@modelcentro.com"}]]],["textNode",{"text":"."}]]]]]],[["successfulRegistration","notempty",true]]],["div",{"id":"message","class":"login-form-error-message error"}],["div",{"class":"login-form-error-message default"},[["div",{"class":"default-message"},[["p",{},[["textNode",{"text":"Sign in failed, your account is inactive."}]]],["p",{},[["textNode",{"text":"This could happen because either your membership has expired or there was a problem processing your payment."}]]],["p",{},[["textNode",{"text":"Please contact "}],["a",{"id":"_reportProblem"},[["textNode",{"text":"customer support"}]]],["textNode",{"text":" for more information."}]]]]]]],["div",{"class":"row"},[["label",{"for":"login"},[["textNode",{"text":"Login:"}]]],["div",{},[["div",{"class":"mc-common-input icon login"},[["input",{"type":"text","name":"le","class":"text-color-2","autocomplete":"off"}]]],["div",{"class":"error-message"}]]]]],["div",{"class":"row"},[["label",{"for":"login"},[["textNode",{"text":"Password:"}]]],["div",{},[["div",{"class":"mc-common-input icon pass"},[["input",{"type":"password","name":"password","class":"text-color-2"}]]],["div",{"class":"error-message"}]]]]],["div",{"class":"row capcha","id":"captchaBlock","style":"display: none"},[["label"],["div",{},[["span",{"id":"captcha","class":"capcha-img"}],["div",{"class":"mc-common-input icon captcha-wrapper"},[["span",{"class":"reload-captcha","id":"reload_captcha"}],["textNode",{"text":" "}],["input",{"type":"text","name":"captcha"}]]],["div",{"class":"error-message"}]]]]],["div",{"class":"row forgot-row"},[["label"],["div",{},[["a",{"href":"/password-recovery","class":"forgot"},[["textNode",{"text":"Forgot password?"}]]]]]]],["div",{"class":"row btns clearfix"},[["label"],["div",{},[["a",{"href":"","class":"mc-common-button simple reg"},[["textNode",{"text":"register"}]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]],["div",{"class":"mc-common-button no-hover"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["div",{"data-fox-alias":"loginSubmitText"},[["textNode",{"text":"login"}]]],["input",{"type":"submit","name":"submit","value":"submit"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_notifications_manager", [["div",{"class":"page-width user-notifications-wrapper"},[["div",{"class":"row"},[["label",{"for":"publishVideoEmail"},[["span",{"class":"site-checkbox"},[["if",{"notempty":""},[["input",{"type":"checkbox","name":"publishVideoEmail","id":"publishVideoEmail","checked":""}],["else",{},[["input",{"type":"checkbox","name":"publishVideoEmail","id":"publishVideoEmail"}]]]],[["publishVideoEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"checkbox"}]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" publishes a new video"}]]]]]]],["div",{"class":"row"},[["label",{"for":"publishPhotosetEmail"},[["span",{"class":"site-checkbox"},[["if",{"notempty":""},[["input",{"type":"checkbox","name":"publishPhotosetEmail","id":"publishPhotosetEmail","checked":""}],["else",{},[["input",{"type":"checkbox","name":"publishPhotosetEmail","id":"publishPhotosetEmail"}]]]],[["publishPhotosetEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"checkbox"}]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" publishes a new photoset"}]]]]]]],["div",{"class":"row"},[["label",{"for":"startLiveshowEmail"},[["span",{"class":"site-checkbox"},[["if",{"notempty":""},[["input",{"type":"checkbox","name":"startLiveshowEmail","id":"startLiveshowEmail","checked":""}],["else",{},[["input",{"type":"checkbox","name":"startLiveshowEmail","id":"startLiveshowEmail"}]]]],[["startLiveshowEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"checkbox"}]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" starts a live show"}]]]]]]],["div",{"class":"row"},[["label",{"for":"publishBlogPostEmail"},[["span",{"class":"site-checkbox"},[["if",{"notempty":""},[["input",{"type":"checkbox","name":"publishBlogPostEmail","id":"publishBlogPostEmail","checked":""}],["else",{},[["input",{"type":"checkbox","name":"publishBlogPostEmail","id":"publishBlogPostEmail"}]]]],[["publishBlogPostEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"checkbox"}]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" publishes a new blog post"}]]]]]]],["div",{"class":"row"},[["label",{"for":"sentModelMessageByEmail"},[["span",{"class":"site-checkbox"},[["if",{"notempty":""},[["input",{"type":"checkbox","name":"sentModelMessageByEmail","id":"sentModelMessageByEmail","checked":""}],["else",{},[["input",{"type":"checkbox","name":"sentModelMessageByEmail","id":"sentModelMessageByEmail"}]]]],[["sentModelMessageByEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"checkbox"}]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" sent a new Private message"}]]]]]]],["div",{"class":"row"},[["label",{"for":"sentModelMessageByEmail"},[["span",{"class":"site-checkbox"},[["if",{"notempty":""},[["input",{"type":"checkbox","name":"sentModelMessageByEmail","id":"sentModelMessageByEmail","checked":""}],["else",{},[["input",{"type":"checkbox","name":"sentModelMessageByEmail","id":"sentModelMessageByEmail"}]]]],[["sentModelMessageByEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["span",{"class":"checkbox"}]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" sent a new Private message"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_passwordrecovery_email", [["div",{"class":"auth-form"},[["div",{"class":"messages errors-block error","id":"recovery-message"}],["form",{"id":"email-form","class":"form_block","method":"post","style":"display: block","autocomplete":"off"},[["div",{"class":"row"},[["p",{},[["textNode",{"text":"Please enter email that you used to log on to the site."}]]]]],["div",{"class":"row"},[["div",{"class":"mc-common-input email"},[["input",{"id":"forgot-input","type":"text","name":"email","autocomplete":"off"}]]],["div",{"class":"error-message"}]]],["div",{"class":"row btns clearfix"},[["button",{"class":"mc-common-button with-spinner","id":"submit-btn"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["textNode",{"text":" submit "}]]]]]]]]]]);
fox.registerTemplate("user_passwordrecovery_confirmation", [["div",{"class":"auth-form"},[["div",{"class":"messages errors-block error","id":"recovery-message"}],["if",{"empty":""},[["form",{"id":"confirmation-form","name":"confirmation_form","class":"form_block","style":"display: block","autocomplete":"off"},[["div",{"class":"row"},[["p",{},[["textNode",{"text":"Please enter your new password and confirm new password."}]]]]],["div",{"class":"row"},[["label",{},[["textNode",{"text":"New password:"}]]],["div",{"class":"mc-common-input email"},[["input",{"type":"password","name":"password","autocomplete":"off","placeholder":""}]]],["div",{"class":"error-message"}]]],["div",{"class":"row"},[["label",{},[["textNode",{"text":"Confirm password:"}]]],["div",{"class":"mc-common-input email"},[["input",{"type":"password","name":"confirm","autocomplete":"off","placeholder":""}]]],["div",{"class":"error-message"}]]],["div",{"class":"row btns clearfix"},[["button",{"class":"mc-common-button with-spinner","id":"submit-btn"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["textNode",{"text":" Send "}]]]]]]],["else",{},[["p",{},[["textNode",{"text":"The password reset request has expired, please click "}],["a",{"href":"/login"},[["textNode",{"text":"here"}]]],["textNode",{"text":" to make another request."}]]]]]],[["isError","empty",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("vrvideo", [["dl8-video",{"fps":"60","class":"vr-player","poster":"","format":"","display-mode":"inline","cors-fallback-url":""},[["foreach",{"from":"","item":"source"},[["if",{"notempty":""},[["source",{"src":"","type":"","quality":"SD Mobile"},[],[["source.src","src",true],["source.type","type",true]]],["else",{},[["if",{"notempty":""},[["source",{"src":"","type":"","quality":"HD Mobile"},[],[["source.src","src",true],["source.type","type",true]]],["else",{},[["if",{"motempty":""},[["source",{"src":"","type":"","quality":"HD VR Oculus"},[],[["source.src","src",true],["source.type","type",true]]],["else",{},[["source",{"src":"","type":"","quality":""},[],[["source.src","src",true],["source.type","type",true],["source.name","quality",true]]]]]],[["source.name","motempty",true,[{"name":"eq","params":["hd1920_vr_oculus"]}]]]]]]],[["source.name","notempty",true,[{"name":"eq","params":["hd960_vr_mobile"]}]]]]]]],[["source.name","notempty",true,[{"name":"eq","params":["sd960_vr_mobile"]}]]]]],[["sources","from",true]]]],[["poster","poster",true],["vrType","format",true],["fallbackUrl","cors-fallback-url",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./aboutme.js": 781,
	"./account/settings.js": 782,
	"./activity/event/blogPostEvent.js": 783,
	"./activity/event/customEvent.js": 784,
	"./activity/event/filter.js": 785,
	"./activity/event/filterNew.js": 786,
	"./activity/event/joinBanner.js": 787,
	"./activity/event/list.js": 788,
	"./activity/event/liveshowEvent.js": 789,
	"./activity/event/locationEvent.js": 790,
	"./activity/event/mainEvent.js": 791,
	"./activity/event/mainEventNew.js": 792,
	"./activity/event/photosetEvent.js": 793,
	"./activity/event/videoEvent.js": 794,
	"./activity/eventCalendarViewer.js": 795,
	"./activity/eventCalendarViewerNew.js": 796,
	"./amcSceneViewer.js": 797,
	"./app/SiteApp.js": 798,
	"./banner.js": 813,
	"./billingSupport/billingContact.js": 814,
	"./billingSupport/cancellation.es.js": 815,
	"./billingSupport/cancellationForm.es.js": 816,
	"./billingSupport/support.js": 817,
	"./blog/blogSidebar.js": 818,
	"./blog/blogViewer.js": 819,
	"./blog/postViewer.js": 820,
	"./cbPaymentPopup.es.js": 821,
	"./ccpa.es.js": 822,
	"./content/backLink.js": 823,
	"./content/related.js": 824,
	"./content/tagsfilter.es.js": 825,
	"./content/tipme.es.js": 826,
	"./contentreport.js": 827,
	"./conversation/attachItem.js": 828,
	"./conversation/attachUnlocker.js": 829,
	"./conversation/conversationViewer.js": 830,
	"./conversation/giftsPopup.js": 831,
	"./conversation/previewContent.js": 832,
	"./crowdFunding.js": 833,
	"./crowdfunding/confirm.es.js": 834,
	"./flashplayer.js": 835,
	"./footer.js": 836,
	"./gridStub.js": 837,
	"./headerSwipeSlider.js": 838,
	"./join.es.js": 839,
	"./layout/freeHostedGallery.js": 840,
	"./layout/home.es.js": 841,
	"./layout/splash.js": 842,
	"./layout/stateoff.js": 843,
	"./lazyDataList.js": 844,
	"./lazyload.js": 845,
	"./liveShowChecker.js": 846,
	"./liveshowViewer.es.js": 847,
	"./lsCounterBanner.js": 849,
	"./menu/checkers/blog.js": 850,
	"./menu/checkers/liveshow.js": 851,
	"./menu/checkers/tips.js": 852,
	"./menu/main.es.js": 853,
	"./mobileWelcome.js": 854,
	"./modelBacklinks.js": 855,
	"./newsLetterSubscriber.es.js": 856,
	"./notification/notificationUpdater.js": 857,
	"./notification/notificationViewer.es.js": 858,
	"./offer/modelRelated/UserOfferNewLogin.js": 859,
	"./playerBanners.js": 860,
	"./popup/commonPopup.js": 867,
	"./promisePreloader.js": 868,
	"./pushNotifications.js": 869,
	"./sceneViewer.js": 871,
	"./sitepage/2257.js": 872,
	"./sitepage/404.js": 873,
	"./sitepage/about.js": 874,
	"./sitepage/account.js": 875,
	"./sitepage/affiliate.js": 876,
	"./sitepage/anchorNavigator.js": 877,
	"./sitepage/billingContact.js": 878,
	"./sitepage/blog.js": 879,
	"./sitepage/cancellation.js": 880,
	"./sitepage/ccpa.js": 881,
	"./sitepage/conversation.js": 882,
	"./sitepage/favorites.js": 883,
	"./sitepage/freeHostedGallery.js": 884,
	"./sitepage/freeHostedVideos.js": 885,
	"./sitepage/gallery.js": 886,
	"./sitepage/gallery/fullscreenView.js": 887,
	"./sitepage/home.js": 888,
	"./sitepage/login.js": 889,
	"./sitepage/mcPhotosetGallery.js": 890,
	"./sitepage/mcPhotosetGallery_c.js": 891,
	"./sitepage/myfriends.js": 892,
	"./sitepage/passwordrecovery.js": 893,
	"./sitepage/photosets.js": 894,
	"./sitepage/post.js": 895,
	"./sitepage/privacy.js": 896,
	"./sitepage/scene.js": 897,
	"./sitepage/scene/guestDisablePreview.js": 898,
	"./sitepage/settings.js": 899,
	"./sitepage/siteClosed.js": 900,
	"./sitepage/siteUnderConstruction.js": 901,
	"./sitepage/sponsor.js": 902,
	"./sitepage/stateoff/socialAppsBlock.js": 903,
	"./sitepage/terms.js": 904,
	"./sitepage/videos.js": 905,
	"./socialapps.js": 906,
	"./terms.js": 917,
	"./throughChatWindow.js": 918,
	"./tipsChecker.js": 919,
	"./twitter.js": 920,
	"./verifiedcall.js": 921,
	"./vrplayer.js": 922,
	"./welcomebanner.js": 923
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 780;

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** AboutMe Widget must be moved to other folder */

(function(fox) {
	var Promise = fox.RSVP.Promise;

	fox.registerWidget('AboutMe', {
		configure: function () {
			this.registerOptions('', {
				fetchOnRunning: true,
				widgets: {
					dataApi: {
						widget: 'Api',
						method: 'Client_Aboutme.getData',
						cacheChannel: 'site'
					},
					totalApi: {
						widget: 'Api',
						method: 'site.totalPublished',
						cacheChannel: 'content'						
					}
				},
				container: '#block_top.detail',
				'autoRender': false,
				'template': 'sitepage_aboutme_data'
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			if (this.getOption('fetchOnRunning')) {
				this.fetchData();
			}

			this.callParent('running', arguments);
		},

		activate: function () {
			this.fetchTotal();
			this.callParent('activate', arguments);
		},

		fetchAllData: function () {
			return Promise.all([
				this.fetchData(),
				this.fetchTotal()
			]).catch(console.error.bind(console));
		},

		fetchData: function () {
			return this.rwom1('#dataApi').psend({}).then(this.apiSuccessHandler.bind(this));
		},

		fetchTotal: function () {
			return this.rwom1('#totalApi').psend({});
		},

		apiSuccessHandler: function (resp) {
			var success = fox.objectGet(resp, 'params.answer.response.success');
			var stats = success.stats;
			
			if (fox.isSet(success.publicActivity)) {
				this.sortingPublicActivityByYear(success.publicActivity);
			}

			if (fox.isSet(stats.data)) {
				this.checkDataForStats(stats);
			}

			this.renderData(success);

			return resp;
		},

		sortingPublicActivityByYear: function(obj) {
			var movies = obj.movie,
				awards = obj.award;

			obj.movie = (fox.isSet(movies)) ? fox.toArray(movies).sort(this.sortingMoviesByYear) : '';
			obj.award = (fox.isSet(awards)) ? fox.toArray(awards).sort(this.sortingAwardsByYear) : '';			
		},

		sortingMoviesByYear: function(obj1, obj2) {
			var yearObj1 = +obj1['yearMovie'],
				yearObj2 = +obj2['yearMovie'];

			return yearObj2 - yearObj1;
		},

		sortingAwardsByYear: function(obj1, obj2) {
			var yearObj1 = +obj1['yearAward'],
				yearObj2 = +obj2['yearAward'];

			return yearObj2 - yearObj1;
		},

		renderData: function (data) {
			this
				.setTemplateOptions(data)
				.render();
		},

		checkDataForStats: function (stats) {
			var state = false;

			fox.each(stats.data, function (row, i) {
				if (fox.isEmpty(row.value)) {
					return;
				};

				state = true;
			});

			stats.statsDataExists = state;
		}
	
	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	'use strict';

	fox.registerWidget('Account_Settings', {
		configure: function (options) {
			this.registerOptions('', {
				widgets: {
					dataApi: {
						widget: 'Api',
						method: 'site.authorizer.changePassword'
					}
				},

				fieldsSelector: '.field2send',
				messageBlockSelector: '#notice-success',
				phrases: {
					empty: 'Field shouldn\'t be empty',
					oldPassEmpty: 'Old Password can\'t be empty',
					newPassEmpty: 'New Password can\'t be empty',
					cNewPassEmpty: 'Confirm New Password can\'t be empty',
					notMatch: 'New and confirmed passwords do not match',
					oldPassIncorrect: 'Incorrect Password',
					success: 'Password was successfully changed'
				},

				template: 'account_settings',
				container: '.general-settings',
				autoRender: true,

				'handleWom.onResponse': {
					widget: '#dataApi',
					event: 'success',
					callback: '@this:onResponse'
				},

				handlers: {
					submit: {
						target: '#submit',
						event: 'click',
						callback: 'submit'
					},
					blurHandler: {
						target: '.field2send',
						event: 'blur',
						callback: '_check'
					}
				}
			});

			this.validationStates = {
				oldPassword: false,
				newPassword: false,
				confirmNewPassword: false
			};

			this.callParent('configure', arguments);
		},

		rendering: function () {
			this.callParent('rendering', arguments);

			this.fields = fox.dom.select(this.getOption('fieldsSelector'), this.fragment);
			this.messageBlock = fox.dom.select(this.getOption('messageBlockSelector'), this.fragment);
		},

		_check: function (field) {
			switch (field.name) {
				case 'oldPassword': 
					this.validationStates[field.name] = !this._isEmpty(field, this.getOption('phrases.oldPassEmpty'));
				break;

				case 'newPassword': 
					var isEmpty = this._isEmpty(field, this.getOption('phrases.newPassEmpty'));
					if (!isEmpty) {
						var confirm = fox.dom.selectFirst('[name="confirmNewPassword"]', this.element);

						if (confirm.value !== '') {
							this.validationStates[field.name] = this._isMatch(field, confirm, this.getOption('phrases.notMatch'))
						}
					} else {
						this.validationStates[field.name] = !isEmpty;
					}
				break;

				case 'confirmNewPassword': 
					var isEmpty = this._isEmpty(field, this.getOption('phrases.cNewPassEmpty'));
					if (!isEmpty) {
						var newPassword = fox.dom.selectFirst('[name="newPassword"]', this.element);

						if (newPassword.value !== '') {
							this.validationStates[field.name] = this._isMatch(newPassword, field, this.getOption('phrases.notMatch'))
						}
					} else {
						this.validationStates[field.name] = !isEmpty;
					}
				break;
			}
		},

		checkFields: function () {
			var result = true;

			fox.each(this.fields, function (field) {
				this._check(field);
			}, this);

			for (var key in this.validationStates) {

				if (!this.validationStates[key]) {
					result = false;
				} 
			}

			return result;
		},

		_isEmpty: function (elem, phrase) {
			var notice = fox.dom.selectFirst('#notice-' + elem.name, this.element);
			if (!elem.value.length) {
				notice.style.display = 'block';
				notice.innerHTML = phrase;
				return true;
			} else {
				notice.style.display = 'none';
				notice.innerHTML = '';
				return false;
			}
		},

		_isMatch: function(elem1, elem2, phrase) {
			var notice = fox.dom.selectFirst('#notice-' + elem1.name, this.element),
				string1 = new String(fox.trim(elem1.value)),
				string2 = new String(fox.trim(elem2.value));

			if (string1.toString() != string2.toString()) {
				notice.style.display = 'block';
				notice.innerHTML = phrase;
				return false;
			} else {
				notice.style.display = 'none';
				notice.innerHTML = '';
				return true;
			}
		},

		submit: function (el, alias, e) {
			this.toggleSuccessBlock(false);
			
			var arr = {};
			if (this.checkFields()) {
				fox.each(this.fields, function (field) {
					arr[field.name] = fox.trim(field.value);
				}, this);
				this.rwom1('#dataApi').send(arr);
			};
		},

		onResponse: function (response) {
			if (response.answer.response.success) {
				this.hookWrapper('changeSuccess', response);
			} else {
				this.hookWrapper('changeFailure', response);
			}
		},

		toggleSuccessBlock: function (flag, message) {
			if (!this.messageBlock) {
				return;
			}

			if (flag) {
				$(this.messageBlock).css('display', 'inline-block');
			} else {
				$(this.messageBlock).css('display', 'none');
			}

			this.messageBlock.innerHTML = message || '';
		},

		changeSuccess: function () {
			this.toggleSuccessBlock(true, this.getOption('phrases.success'));
		},

		changeFailure: function (data) {
			var error = data.answer.response.error;

			switch (error) {
				case 'oldPassword':
					var notice = fox.dom.selectFirst('#notice-oldPassword', this.element);
					notice.style.display = 'block';
					notice.innerHTML = this.getOption('phrases.oldPassIncorrect');
				break;
				case 'match':
					var notice = fox.dom.selectFirst('#notice-newPassword', this.element);
					notice.style.display = 'block';
					notice.innerHTML = this.getOption('phrases.notMatch');
				break;
			}
		}
		
	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_BlogPostEvent Widget

(function (fox, $) {
	'use strict';
	fox.registerWidget('Activity_Event_BlogPostEvent', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_card_blogpost'
			});
			fox.registerTemplateModifier('isWide', function (obj) {
				if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return (w / h > .84); 
			});
			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
		
			this.callParent('init', arguments);
		},

		rendering: function () {
			fox.each(this.templateOptions.eventTypedParams.contents, function (val, key) {
				if (val.type === 1) {
					var $img = $(val.content).find('img');
					if ($img.length) {
						val.content = $img[0].src;
						this.templateOptions.eventTypedParams.contents[key].content = val.content;
			
					}
					else {
						this.templateOptions.eventTypedParams.contents[key].text = val.content;
						this.templateOptions.eventTypedParams.contents[key].content = '';
					}
					
				}
				if (val.type === 3 && new RegExp(/(;base64,)/gi).test(val.content)) {
					this.templateOptions.eventTypedParams.contents[key].content = JSON.parse(val.content);
				}

			}, this);
		
			this.callParent('rendering', arguments);
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_BlogPostEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_CustomEvent', {

		configure: function () {
			this.fullEventDescriptionAvailable = false;

			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_card_customevent',
				'widgets.fullDescription': {
					widget: 'Widget',
					template: 'activity_event_card_customevent_description',
					autoRender: false,
					embed: {
						widget: '@parent @parent',
						container: '.full-description-wrapper'
					},
					'hooks.onAddedToDom': fox.bind(function () {
						this.applyScrollBar();
					}, this)
				},
				'handleDom.showFullText': {
					target: '.show-more-text',
					event: 'click',
					callback: '_showFullText'
				},
				'handleDom.hideFullText': {
					target: '.close',
					targetWidget: '#fullDescription',
					event: 'click',
					callback: 'hideFullText'
				},
				'!hooks.onStartRendering': function () {
					var props = this.p.getMainProperties();

					if (fox.isString(props.eventDescription)) {
						if (props.eventDescription.length > 101) {
							props.fullEventDescriptionAvailable = true;
							this.fullEventDescriptionAvailable = true;
						}
					};
					
					this.setTemplateOptions(props);

					if (props.fullEventDescriptionAvailable) {
						this.wom1('#fullDescription').setTemplateOptions(props).render();
					}

					return true;
				},
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
		
			this.callParent('init', arguments);
		},

		_showFullText: function (argument) {
			if (this.fullEventDescriptionAvailable) {
				this.showFullText();
			}
		},

		showFullText: function () {
			fox.dom.addClass('show-full-description', this.getParent().element[0]);
		},

		hideFullText: function () {
			fox.dom.removeClass('show-full-description', this.getParent().element[0]);
		},

		applyScrollBar: function () {
			$(this.rwom1('#fullDescription').element[0])
				.find('.event-description.full')
				.mCustomScrollbar({
					theme: 'light-thin',
					scrollButtons: false,
					scrollbarPosition: 'inside',
					scrollInertia: 0,
					mouseWheel: {preventDefault: true}
				});
		}
	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_Filter Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_Filter', {

		configure: function () {
			this.MONTHS = [
				'January', 'February', 'March',
				'April', 'May', 'June',
				'July', 'August', 'September',
				'October', 'November', 'December'
			];

			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_filter',
				widgets: {
					periodTypeSelector: {
						widget: 'Tools_TabsSwitcher',
						target: '.activity-period-type .type',
						name: 'period-type',
						callback: '@parent:switchPeriodFilter',
						switchOnEmbed: true
					},
					periodNavigator: {
						widget: 'Widget',
						autoRender: false,
						'embed.container': '.activity-period-date',
						template: 'activity_event_period_navigator',
						'hooks.onStartRendering': '@parent:onNavRender'
					},
					viewSettingList: {
						widget: 'List',
						autoRender: false,
						'embed.container': '.setup-list',
						'tpl.row': 'activity_event_view_settings_row'
					}
				},
				handleDom: {
					toogleSettings: {
						event: 'click',
						target: '.activity-view-settings .type',
						callback: 'toogleSettings'
					},
					toogleOption: {
						event: 'click',
						target: '.switch-wrapper',
						targetWidget: '#viewSettingList',
						callback: 'toogleOption'
					},
					navigatePeriod: {
						event: 'click',
						target: '.period-direction',
						targetWidget: '#periodNavigator',
						callback: 'navigatePeriod'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.activePeriodType = 'month';
			this.viewSettings = {
				1: {visible: 1, name: 'liveshow', status: 1},
				2: {visible: 1, name: 'blogPost', status: 1},
				3: {visible: 0, name: 'message', status: 0},
				4: {visible: 0, name: 'trip', status: 0},
				5: {visible: 1, name: 'custom', status: 1},
				6: {visible: 1, name: 'photoset', status: 1},
				7: {visible: 1, name: 'video', status: 1}
			};	
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.pNav = this.rwom1('#periodNavigator');

			this.setPeriod(this.getPeriodRange(this.activePeriodType, 'next'));

			// temp
			this.rwom1('#viewSettingList').setCollection(this.viewSettings, true);
		
			this.callParent('running', arguments);
		},

		activate: function (argument) {
			this.dispatchData();
			this.callParent('activate', arguments);
		},

		setPeriod: function (period) {
			this.activePeriod = period;

			this.dispatchData();

			return this.pNav && this.pNav.render();
		},

		dispatchData: function () {
			var data, cacheNext, cachePrev;

			cacheNext = this.getPeriodRange(this.activePeriodType, 'next',  this.activePeriod.finish.parts.day, this.activePeriod.finish.parts.month, this.activePeriod.finish.parts.year);
			cachePrev = this.getPeriodRange(this.activePeriodType, 'prev',  this.activePeriod.start.parts.day, this.activePeriod.start.parts.month, this.activePeriod.start.parts.year);

			data = {
				current: {
					durationFrom: this.activePeriod.start.timestamp,
					durationTo: this.activePeriod.finish.timestamp,
					types: this.getViewSettings(),
				},
				next: {
					durationFrom: cacheNext.start.timestamp,
					durationTo: cacheNext.finish.timestamp,
					types: this.getViewSettings()
				},
				prev: {
					durationFrom: cachePrev.start.timestamp,
					durationTo: cachePrev.finish.timestamp,
					types: this.getViewSettings()
				}
			}

			this.dispatchEvent('filterChanged', data);

			return data;
		},

		getPeriodRange: function (periodType, direction, day, month, year) {
			var todayObj, day, month, year, period, startPeriod, finishPeriod;

			todayObj = new Date();
			day = day || todayObj.getDate();
			month = month === 0 ? 0 : month || todayObj.getMonth();
			year = year || todayObj.getFullYear();

			period = periodType === 'day'
				? 1
				: periodType === 'week'
				 	? 7
				 	: periodType === 'month'
				 		? fox.utils.daysInMonth(month)
				 		: 7;

			switch (direction) {
				case 'next':
					startPeriod = [year, month, day];

					if ((day = fox.utils.daysInMonth(month) - day - period) < 0) {
						day *= -1;

						if (month !== 11) {
							month += 1;
						} else {
							month = 0;
							year += 1;
						}
					} else {
						day = fox.utils.daysInMonth(month) - day;
					}

					finishPeriod = [year, month, day];
					break;
				case 'prev':
					finishPeriod = [year, month, day];

					if ((day = day - period) <= 0) {
						if (month !== 0) {
							month -= 1;
						} else {
							month = 11;
							year -= 1;
						}
						
						day = Math.abs(fox.utils.daysInMonth(month) + day);
					}

					startPeriod = [year, month, day];
					break;
			}
			
			return {
				start: {
					timestamp: new Date(startPeriod[0], startPeriod[1], startPeriod[2]).getTime(),
					parts: {
						year: startPeriod[0],
						month: startPeriod[1],
						day: startPeriod[2]
					}
				},
				finish: {
					timestamp: new Date(finishPeriod[0], finishPeriod[1], finishPeriod[2]).getTime(),
					parts: {
						year: finishPeriod[0],
						month: finishPeriod[1],
						day: finishPeriod[2]
					}
				},
				result: this.getHRD(startPeriod, finishPeriod, period)
			}
		},

		getHRD: function (startPeriod, finishPeriod, period) {
			var result;

			if (period === 1) {
				result = [[this.MONTHS[startPeriod[1]], startPeriod[2]].join(' - '), startPeriod[1] === 11 ? startPeriod[0] : finishPeriod[0]].join(', ');
			} else if (startPeriod[1] !== finishPeriod[1]){
				result = [[this.MONTHS[startPeriod[1]], startPeriod[2]].join(' - '), [this.MONTHS[finishPeriod[1]], finishPeriod[2]].join(' - '), finishPeriod[0]].join(', ');
			} else if (startPeriod[1] === finishPeriod[1]) {
				result = [this.MONTHS[startPeriod[1]], [startPeriod[2], finishPeriod[2]].join(' - '), finishPeriod[0]].join(', ');
			}
			return result;
		},

		toogleSettings: function (el) {
			if ($(el.parentNode).hasClass('opened')) {
				$(el.parentNode).removeClass('opened');
			} else {
				$(el.parentNode).addClass('opened');
			}
		},

		toogleOption: function (el) {
			var $el;

			$el = $(el);

			if ($el.hasClass('on')) {
				$el.removeClass('on').addClass('off');
				this.viewSettings[$el.data('card-type')].status = 0;
			} else if ($el.hasClass('off')) {
				$el.removeClass('off').addClass('on');
				this.viewSettings[$el.data('card-type')].status = 1;
			}

			this.dispatchData();
		},

		switchPeriodFilter: function (periodType) {
			this.activePeriodType = periodType;

			this.setPeriod(
				this.getPeriodRange(this.activePeriodType, 'next',
					this.activePeriod.start.parts.day,
					this.activePeriod.start.parts.month,
					this.activePeriod.start.parts.year
				)
			);
		},

		onNavRender: function () {
			this.pNav.setTemplateOptions('result', this.activePeriod.result);

			return true;
		},

		navigatePeriod: function (el) {
			var $el, direction, dayFrom, monthFrom, yearFrom;

			$el = $(el);
			direction = $el.data('direction');

			dayFrom = this.activePeriod[direction === 'next' ? 'finish' : 'start'].parts.day;
			monthFrom = this.activePeriod[direction === 'next' ? 'finish' : 'start'].parts.month;
			yearFrom = this.activePeriod[direction === 'next' ? 'finish' : 'start'].parts.year;

			this.setPeriod(this.getPeriodRange(this.activePeriodType, direction, dayFrom, monthFrom, yearFrom));
		},

		getViewSettings: function () {
			var settings = {};

			fox.each(this.viewSettings, function (val, key) {
				settings[key] = val.status;
			});

			return settings;
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_Filter Widget

(function (fox, $) {
	'use strict';
	fox.registerWidget('Activity_Event_FilterNew', {

		configure: function () {
			this.viewSettings = {
				1: {visible: 1, name: 'liveshow', status: 1},
				2: {visible: 1, name: 'blogPost', status: 1},
				3: {visible: 0, name: 'message', status: 0},
				4: {visible: 0, name: 'trip', status: 0},
				5: {visible: 1, name: 'custom', status: 1},
				6: {visible: 1, name: 'photoset', status: 1},
				7: {visible: 1, name: 'video', status: 1}
			};

			/*this.viewSettings = {
				1: {visible: 1, name: 'liveshow', status: 0},
				2: {visible: 1, name: 'blogPost', status: 0},
				3: {visible: 0, name: 'message', status: 0},
				4: {visible: 0, name: 'trip', status: 1},
				5: {visible: 1, name: 'custom', status: 1},
				6: {visible: 1, name: 'photoset', status: 0},
				7: {visible: 1, name: 'video', status: 0}
			};*/



			this.filterTplOptions = {
				nextAvailable: true,
				prevAvailable: true,
				starDate: false,
				endDate: false
			};

			this.allEventsDates = [];

			this.registerOptions('', {
				autoRender: false,
				
				widgets: {
					filter1: {
						widget: 'Widget',
						template: 'activity_event_filter',
						autoRender: false
					},

					filter2: {
						widget: 'Widget',
						template: 'activity_event_filter',
						autoRender: false
					},

					settings: {
						widget: 'Widget',
						autoRender: true,
						template: 'activity_event_view_settings',
						embed: {
							widget: '@parent @parent @parent',
							container: '.activity-action.types'
						},
						widgets: {
							list: {
								widget: 'List',
								autoRender: true,
								container: '.setup-list',
								'tpl.row': 'activity_event_view_settings_row'
							}
						}
					},

					calendar: {
						widget: 'Widget',
						autoRender: false,
						dontReuseSn: true,
						template: 'activity_event_view_calendar',
						embed: {
							widget: '@parent @parent @parent',
							container: '.activity-action.calendar'
						},
						'hooks.onAddedToDom': fox.bind(this.applyDatePicker, this)
					},

					availableDatesApi: {
						widget: 'Api',
						method: 'Activity_Event.getCountsByDay',
						cacheChannel: 'event',
						sendTimezone: true
					}
				},
				handleDom: {
					nextEvents1: {
						target: '.arr.next',
						targetWidget: '#filter1',
						event: 'click',
						callback: 'getNextEvents'
					},

					prevEvents1: {
						target: '.arr.prev',
						targetWidget: '#filter1',
						event: 'click',
						callback: 'getPrevEvents'
					},

					nextEvents2: {
						target: '.arr.next',
						targetWidget: '#filter2',
						event: 'click',
						callback: 'getNextEvents'
					},

					prevEvents2: {
						target: '.arr.prev',
						targetWidget: '#filter2',
						event: 'click',
						callback: 'getPrevEvents'
					},

					toggleSettings: {
						event: 'click',
						targetWidget: '#settings',
						target: '.settings-button',
						callback: '_toggleDropdown'
					},

					toggleCalendar: {
						event: 'click',
						targetWidget: '#calendar',
						target: '.settings-button',
						callback: '_toggleDropdown'
					},

					toggleOption: {
						event: 'click',
						targetWidget: '#settings #list',
						target: '.view-settings-list-item',
						callback: 'toggleOption'
					},

					preventDropDownClose: {
						targetWidget: '#calendar',
						target: '.setup-list.calendar',
						event: 'click',
						callback: function (el, alias, w, e) {
							fox.dom.event.stop(e);
						}
					}
				},

				handleWom: {
					eventsApiSuccess: {
						widget: '@parent',
						event: ['eventsApiSuccess', 'getDataFromCache'],
						callback: '_handleEventsApiSuccess'
					},

					availableDates: {
						widget: '#availableDatesApi',
						event: 'success',
						callback: '_availableDatesApiLoad'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.direction = 'next';

			this.limit = this.getOption('limit');

			this.callParent('init', arguments);
		},

		running: function () {
			this.filterData = {
				date: fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', new Date()),
				direction: 'next',
				types: this.getViewSettings(),
				limit: this.limit
			};

			// temp
			this.rwom1('#settings #list').setCollection(this.viewSettings, true);
			this.dispatchData();
			this._addWindowClickEvents();
			this.getAvailableDates();
		
			this.callParent('running', arguments);
		},

		activate: function (argument) {
			this._addWindowClickEvents();
			this.dispatchData();
			this.getAvailableDates();
			this.callParent('activate', arguments);
		},

		deactivate: function (argument) {
			this._removeWindowClickEvents();
			this.callParent('deactivate', arguments);
		},

		_addWindowClickEvents: function (argument) {
			$(window).on('click', {widget: this}, this._closeAllDropdowns);
		},

		_removeWindowClickEvents: function (argument) {
			$(window).off('click', this._closeAllDropdowns);
		},

		_closeAllDropdowns: function (e) {
			e.data.widget.closeAllDropdowns();
		},

		closeAllDropdowns: function () {
			var paths = ['#settings', '#calendar'];

			fox.each(paths, function (path) {
				this._hideDropdown(this.wom1(path).dom1('.settings-button')); 
			}, this);
		},

		dispatchData: function () {
			// console.group('filterChanged')
			// 	console.table([this.filterData], ['date', 'direction'/*, 'limit'*/]);
			// console.groupEnd()
			
			this.dispatchEvent('filterChanged', this.filterData);

			return this.filterData;
		},

		_toggleDropdown: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			if ($(el).hasClass('opened')) {
				this._hideDropdown(el);

				return;
			}

			this._showDropdown(el);
		},

		_showDropdown: function (el) {
			this.closeAllDropdowns();
			$(el).addClass('opened');
		},

		_hideDropdown: function (el) {
			$(el).removeClass('opened');
		},

		toggleOption: function (el, alias, w, e) {
			fox.dom.event.stop(e);
			var $el;

			$el = $(el).find('[data-card-type]');

			if ($el.hasClass('on')) {
				$el.removeClass('on').addClass('off');
				this.viewSettings[$el.data('card-type')].status = 0;
			} else if ($el.hasClass('off')) {
				$el.removeClass('off').addClass('on');
				this.viewSettings[$el.data('card-type')].status = 1;
			}

			 this.filterData.types = this.getViewSettings();

			this.dispatchData();
		},

		getViewSettings: function () {
			var settings = {};

			fox.each(this.viewSettings, function (val, key) {
				settings[key] = val.status;
			});

			return settings;
		},

		getNextEvents: function () {
			//console.log('next');
			this.direction = this.filterData.direction = 'next';
			this.filterData.date = this.getPeriodFromCards().endDate;
			this.dispatchData();
		},

		getPrevEvents: function () {
			//console.log('prev');
			this.direction = this.filterData.direction = 'prev';
			this.filterData.date = this.getPeriodFromCards().startDate;
			this.dispatchData();
		},

		_handleEventsApiSuccess: function (result) {
			// console.group('_handleEventsApiSuccess')
			// 	console.table(result.collection, ['startDate', 'title', 'type', 'typedParams.id']);
			// console.groupEnd()

			if (!result.collection) {
				return;
			}

			if (result.collection.length) {
				this.setCurrentCards(result.collection);
				this.setCurrentDates(result.meta);
				this.setLimitation(result.meta);
				this.renderFilters();
			}
		},

		setCurrentCards: function (collection) {
			this.currentCards = collection;	
		},

		setCurrentDates: function (dates) {
			this.currentDates = dates;
		},

		setLimitation: function (meta) {
			this.filterTplOptions.nextAvailable = meta.hasNext;
			this.filterTplOptions.prevAvailable = meta.hasPrev;
		},

		getPeriodFromCards: function () {
			return {startDate: this.currentDates.minDate, endDate: this.currentDates.maxDate};
		},

		renderFilters: function () {
			var opts = fox.clone(this.filterTplOptions);
			var dates = this.getPeriodFromCards();

			fox.each(dates, function (date, key) {
				opts[key] = date;
			}, this);

			this.wom1('#filter1').setTemplateOptions(opts).render();
			this.wom1('#filter2').setTemplateOptions(opts).render();
		},

		applyDatePicker: function () {
			if (this.allEventsDates.length) {
				return;
			}

			$(this.wom1('#calendar').element[0])
				.find('.events-datepicker')
				.datepicker({
					dateFormat: "yy-mm-dd",//2015-01-30
					showWeek: false,
					nextText: '',
					prevText: '',
					appendText: 'a',
					beforeShowDay: fox.bind(function (cDate) {
						var clickable = false;
						var cName = '';
						var tooltip = '';
						cDate = fox.utils.dateFormat('%Y-%m-%d', cDate);

						fox.each(this.availableDates, function (data) {
							var eDate = fox.utils.dateFormat('%Y-%m-%d', data.date);

							if (cDate === eDate) {
								clickable = true;
								cName = 'clickable-date';
								tooltip = data.length + ' events on this date';
							}
						});

						return [clickable, cName, tooltip];
					}, this),

					onSelect: fox.bind(function (date) {
						this.closeAllDropdowns();
						var current = [date, '00:00:00'].join(' ');
						var nextDay = [date, '23:59:59'].join(' ');
						
						this.dispatchEvent('filterChanged', {
							durationFrom: current,
							durationTo: nextDay,
							types: this.getViewSettings()
						});
						
						this.currentDates.minDate = fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', current);
						this.currentDates.maxDate = fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', nextDay);
					}, this)
				});
		},

		getAvailableDates: function (argument) {
			this.rwom1('#availableDatesApi').send();
		},

		_availableDatesApiLoad: function (response) {
			this.availableDates = response.answer.response;

			this.rwom1('#calendar').render();
		}

	}, 'Controller');

})(fox, window.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_JoinBanner Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_JoinBanner', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
		
			this.callParent('init', arguments);
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_List Widget

(function (fox, $) {
	'use strict';

	fox.registerWidget('Activity_Event_List', {

		configure: function () {
			this.collection = [];
			this.inDomCounter = 0;

			this.registerOptions('', {
				columns: [
					'#firts-column', '#second-column', '#third-column'
				],
				'widgetGroupInfo.widgetViewList.manualActivation': true
			});
			
			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('.Widget', {
				'hooks.onStopRendering': fox.isFunction(this.getOption('onStopRendering')) ? this.getOption('onStopRendering') : function () {},
				'hooks.onAddedToDom': fox.isFunction(this.getOption('onAddedToDom')) ? this.getOption('onAddedToDom') : function () {},
				'hooks.onStopAddedToDom': function () {
					setTimeout(fox.bind(function () {
						$(this.element).removeClass('fadeIn');
					}, this), 2005);
				}
			});

			if (this.getOption('collection')) {
				this.setCollection(this.getOption('collection'));
			}

			this.def = {
				autoRender: true,
				group: 'widgetViewList',
				dontReuseSn: true,
				embed: {
					location: 'lastChild',
					container: this.getOption('container') || this.getOption('embed.container')
				}
			};

			this.callParent('init', arguments);
		},

		setCollection: function (collection, notRender) {
			this.collection = collection;

			if (this.isRun()) {
				this.render();
			}
		},

		getCollection: function () {
			return this.collection;
		},

		running: function () {
			this.render();

			this.callParent('running', arguments);
		},

		activate: function () {
			this.render();	
		
			this.callParent('activate', arguments);
		},

		deactivate: function () {
			this.cleanMemo();
		
			this.callParent('deactivate', arguments);
		},

		render: function () {
			this.cleanMemo();

			fox.each(this.getCollection(), this._treatRow, this);
		},

		_treatRow: function (val, key) {
			this.hookWrapper('treatRow', {val: val, key: key});
		},

		treatRow: function (data) {
			var wClass, w, wAlias, cols;

			if ((cols = fox.clone(this.getOption('columns')))) {
				cols.unshift(cols.pop());

				this.def.embed.container = cols[(data.key + 1) % cols.length];
			}

			wClass = data.val.widget || this.getOption('wClass') || 'Widget';
			wAlias = ['activity', data.key].join('_');
			w = this.getEmbeddedWidget(wAlias);

			if (!w) {
				if (fox.isObject(data.val.typedParams) && ('length' in data.val.typedParams)) {
					data.val.typedParams._length = data.val.typedParams.length;
					delete data.val.typedParams.length;
				}

				w = this.embedWidget(wAlias, wClass, fox.merge(data.val, this.def));
				w.run();
			} else {
				w.activate();
			}
		},

		cleanMemo: function () {
			fox.each(this.getWidgetsByGroup('widgetViewList'), function (w) {
				w.removeSelf();
			});

			this._reactivationPool = [];
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_LiveshowEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_LiveshowEvent', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_card_liveshow',
				widgets: {
					timer: {
						widget: 'JQTimer',
						'embed.container': '.counter-wrapper',
						autoRender: false,
						counterWrapperId: '.counter',
						// 'handleWom.timerStopHandler': {
						// 	callback: '@parent:checkLiveShows'
						// },
						'handleWom.addedToDom': {
							widget: '@this',
							event: 'addedToDom',
							callback: '@parent:customizeCounter'
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
			this.liveshowData = this.p.eventTypedParams;

			this.statusAliases = {
				0: 'scheduled',
				1: 'inProgress',
				2: 'inProgress',
				3: 'finished',
				4: 'error'
			}

			var status = this.liveshowData.status;

			if (new Date(this.liveshowData.startDate) > new Date() && status === 0) {
				this.setOption('scheduled', true);
			}

			this.liveshowData.statusAlias = this.statusAliases[status];
		
			this.callParent('init', arguments);
		},

		addedToDom: function () {
			this.initCounter();
		},

		customizeCounter: function (obj, scope) {
			obj = {
				0: 'days',
				2: 'hrs',
				4: 'mins',
				6: 'secs'
			};

			fox.each(obj, fox.bind(function (val, key) {
				$(this.dom1('.counter')).find('.part' + key).append('<div>' + val + '</div>');
			}, this));
		},

		initCounter: function () {
			if (this.getOption('scheduled')) {
				this.startCounter();
			}
		},

		startCounter: function () {
			this.rwom1('#timer').counterStart(fox.utils.getRemainingTime(this.liveshowData.startDate));
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_BlogPostEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_CustomEventLocation', {

		configure: function () {

			this.registerOptions('#fullDescription', {
				'template': 'activity_event_card_customevent_location_description'
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.setOption('template', 'activity_event_card_customevent_location');
			//this.wom1('#fullDescription').setOption('template', 'activity_event_card_customevent_location_description');

			this.callParent('init', arguments);

			var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
			var props = this.p.getMainProperties();
			var url = props.eventTypedParams.url;

			if (!fox.isSet(url)) {
				return;
			};

			if (!!url.match(regex)) {

				if (!url.match(/^http/)) {
					props.eventTypedParams.url = ['http://', url].join('');
				}

				this.p.setOption('eventUrl', true);	
			}

		}

	}, 'Activity_Event_CustomEvent');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_MainEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_MainEvent', {

		configure: function () {
			this.EVENTTYPEREFERENCE = {
				1: {name: 'liveshow', wClass: 'Activity_Event_LiveshowEvent'},
				2: {name: 'blogPost', wClass: 'Activity_Event_BlogPostEvent'},
				3: {name: 'message', wClass: ''},
				4: {name: 'trip', wClass: ''},
				5: {name: 'custom', wClass: 'Activity_Event_CustomEvent'},
				6: {name: 'photoset', wClass: 'Activity_Event_PhotosetEvent'},
				7: {name: 'video', wClass: 'Activity_Event_VideoEvent'}
			};

			this.registerOptions('', {
				autoRender: true,
				handleDom: {
					googleCaledar: {
						event: 'click',
						target: '.google-calendar',
						callback: 'handleGoogleCalendar'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.eventId = this.getOption('eventId');
			this.eventType = this.getOption('type');
			this.eventTitle = this.getOption('title');
			this.eventDescription = this.getOption('description');
			this.eventTypedParams = this.getOption('typedParams') || {};
			this.eventOptionsAddToGoogleCalendar = this.getOption('googleLink');
			this.eventOptionsRemindMe = null;
			this.externalEvent = null;
			this.eventStartDate = this.getPrimaryStartDate();
			this.eventStopDate = this.getOption('finishDate');
			this.eventImage = this.getOption('image');

			if (fox.isObject(this.eventTypedParams) && ('_length' in this.eventTypedParams)) {
				this.eventTypedParams.length = this.eventTypedParams._length;
				delete this.eventTypedParams._length;
			}

			if (this.EVENTTYPEREFERENCE.hasOwnProperty(this.eventType)) {
				this.embedWidget(
					this.EVENTTYPEREFERENCE[this.eventType]['name'],
					this.EVENTTYPEREFERENCE[this.eventType]['wClass'],
					{'embed.container': this.requireOption('childContainer')});
			}

			this.registerOptions('.Widget', {
				'hooks.onStartRendering': function () {
					this.setTemplateOptions(this.getParent().getMainProperties());

					return true;
				},
				handleDom: {
					errorImg: {
						target: '.event-image',
						event: 'error',
						callback: function(elt) {
							$(elt).remove();
						}
					}
				}
			})
		
			this.callParent('init', arguments);
		},

		getMainProperties: function () {
			return {
				eventId: this.eventId,
				eventStartDate: this.eventStartDate,
				eventStopDate: this.eventStopDate,
				eventType: this.EVENTTYPEREFERENCE[this.eventType]['name'],
				eventTitle: this.eventTitle,
				eventImage: this.eventImage,
				eventDescription: this.eventDescription,
				eventOptionsAddToGoogleCalendar: this.eventOptionsAddToGoogleCalendar,
				eventOptionsRemindMe: this.eventOptionsRemindMe,
				externalEvent:this.externalEvent,
				eventTypedParams: this.eventTypedParams
			}
		},

		render: function () {
			this.setTemplateOptions(this.getMainProperties());
		
			this.callParent('render', arguments);
		},

		getPrimaryStartDate: function () {
			var primaryStartDate, startDate;

			primaryStartDate = ['video', 'photoset'];

			if (fox.inArray(primaryStartDate, this.EVENTTYPEREFERENCE[this.eventType]['name'])
				&& this.eventTypedParams.hasOwnProperty('startDate')) {
				startDate = this.eventTypedParams.startDate;
			} else {
				startDate = this.getOption('startDate');
			}

			// return startDate;
			return this.getOption('startDate');
		},

		handleGoogleCalendar: function (el) {
			var api = new fox.Api(null, this._wom).method('logger.log');
			api.send({
				index: 'McUserActivity',
				info: {
					type : 5,					
					data: {
						event: 11,
						title: this.eventTitle
					}
				}
			}, false);	
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_MainEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_MainEventNew', {

		configure: function () {
			this.EVENTTYPEREFERENCE = {
				1: {name: 'liveshow', wClass: 'Activity_Event_LiveshowEvent'},
				2: {name: 'blogPost', wClass: 'Activity_Event_BlogPostEvent'},
				3: {name: 'message', wClass: ''},
				4: {name: 'location', wClass: 'Activity_Event_CustomEventLocation'},
				5: {name: 'custom', wClass: 'Activity_Event_CustomEvent'},
				6: {name: 'photoset', wClass: 'Activity_Event_PhotosetEvent'},
				7: {name: 'video', wClass: 'Activity_Event_VideoEvent'}
			};

			this.registerOptions('', {
				autoRender: true,
				handleDom: {
					googleCaledar: {
						event: 'click',
						target: '.google-calendar',
						callback: 'handleGoogleCalendar'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.eventId = this.getOption('eventId');
			this.eventType = this.getOption('type');
			this.eventTitle = this.getOption('title');
			this.eventDescription = this.getOption('description');
			this.eventTypedParams = this.getOption('typedParams') || {};
			this.eventOptionsAddToGoogleCalendar = this.getOption('googleLink');
			this.eventOptionsRemindMe = null;
			this.externalEvent = null;
			this.eventStartDate = this.getPrimaryStartDate();
			this.eventStopDate = this.getOption('finishDate');
			this.eventImage = this.getOption('image');

			if (fox.isObject(this.eventTypedParams) && ('_length' in this.eventTypedParams)) {
				this.eventTypedParams.length = this.eventTypedParams._length;
				delete this.eventTypedParams._length;
			}

			if (this.eventType === 5 && !fox.isEmpty(this.eventTypedParams.url)) {
				this.eventType = 4;
			}

			if (this.EVENTTYPEREFERENCE.hasOwnProperty(this.eventType)) {
				this.embedWidget(
					this.EVENTTYPEREFERENCE[this.eventType].name,
					this.EVENTTYPEREFERENCE[this.eventType].wClass,
					{'embed.container': this.requireOption('childContainer')});
			}

			this.registerOptions('.Widget', {
				'hooks.onStartRendering': function () {
					this.setTemplateOptions(this.getParent().getMainProperties());

					return true;
				},
				handleDom: {
					errorImg: {
						target: '.event-image',
						event: 'error',
						callback: function(elt) {
							$(elt).remove();
						}
					}
				}
			});
		
			this.callParent('init', arguments);
		},

		getMainProperties: function () {
			return {
				eventId: this.eventId,
				eventStartDate: this.eventStartDate,
				eventStopDate: this.eventStopDate,
				eventType: this.EVENTTYPEREFERENCE[this.eventType].name,
				eventTitle: this.eventTitle,
				eventImage: this.eventImage,
				eventDescription: this.eventDescription,
				eventOptionsAddToGoogleCalendar: this.eventOptionsAddToGoogleCalendar,
				eventOptionsRemindMe: this.eventOptionsRemindMe,
				externalEvent:this.externalEvent,
				eventTypedParams: this.eventTypedParams,
				eventUrl: this.getOption('eventUrl'),
				isEventScheduled: this.isEventScheduled()
			};
		},

		render: function () {
			this.setTemplateOptions(this.getMainProperties());
		
			this.callParent('render', arguments);
		},

		getPrimaryStartDate: function () {
			var primaryStartDate, startDate;

			primaryStartDate = ['video', 'photoset'];

			if (fox.inArray(primaryStartDate, this.EVENTTYPEREFERENCE[this.eventType]['name'])
				&& this.eventTypedParams.hasOwnProperty('startDate')) {
				startDate = this.eventTypedParams.startDate;
			} else {
				startDate = this.getOption('startDate');
			}

			// return startDate;
			return this.getOption('startDate');
		},

		handleGoogleCalendar: function (el) {
			var api = new fox.Api(null, this._wom).method('logger.log');
			api.send({
				index: 'McUserActivity',
				info: {
					type : 5,					
					data: {
						event: 11,
						title: this.eventTitle
					}
				}
			}, false);	
		},

		isEventScheduled: function (argument) {
			var result = false;

			if (!fox.isEmpty(this.eventStopDate)) {
				result = (new Date() < new Date(this.eventStopDate));
			} else {
				result = (new Date() < new Date(this.eventStartDate));
			}

			return result;
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_PhotosetEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_PhotosetEvent', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_card_photoset'
			});

			fox.registerTemplateModifier('isWide', function (obj) {
							if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return (w / h > .84); 
			});
			
			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
		
			this.callParent('init', arguments);
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_LiveshowEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_VideoEvent', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_card_video'
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
		
			this.callParent('init', arguments);
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// EventCalendarViewer Widget

(function (fox, $) {
	'use strict';
	
	fox.registerWidget('Activity_EventCalendarViewer', {

		configure: function () {
			this.defApiConf = {
				widget: 'Api',
				method: 'Activity_Event.get',
				sendTimezone: true,
				cacheChannel: 'event'
			};

			this.registerOptions('', {
				cacheRecordLimit: 500,
				additionalApiParams: {
					transitParameters: {
						v1: 'a3NPKt70Ku'
					}
				},
				widgets: {
					eventFilter: {
						widget: 'Activity_Event_Filter'
					},
					eventList: {
						widget: 'Activity_Event_List',
						wClass: 'Activity_Event_MainEvent'
					},
					getDataApi: this.defApiConf
				},
				handleWom: {
					filterChanged: {
						event: 'filterChanged',
						widget: '#eventFilter',
						callback: 'filterChanged',
						params: {
							alwaysActive: true,
							listenHistory: true
						}
					},
					getDataApiSuccess: {
						event: 'success',
						widget: '#getDataApi',
						callback: 'getDataApiSuccess'
					},
					prepareApi: {
						event: 'prepare',
						widget: '.Api',
						callback: function (obj, performer) {
							// console.time(performer.getAlias());
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.CACHE = {};

			this.registerOptions('#eventFilter', this.getOption('filter'));
			this.registerOptions('#eventList', this.getOption('list'));
		
			this.callParent('init', arguments);
		},

		getCachedApi: function () {
			return this.embedWidget(['api', fox.uniqid()].join('_'), 'Api', fox.merge({
				handleWom: {
					apiSuccess: {
						event: 'success',
						widget: '@this',
						callback: '@parent:cachedApiSuccess'
					},
					apiFail: {
						event: ['error', 'failure'],
						widget: '@this',
						callback: function (o, api) {
							api.removeSelf();
						}
					}
				}
			}, this.defApiConf)).run();
		},

		running: function () {
			this.list = this.rwom1('#eventList');
			this.filter = this.rwom1('#eventFilter');

			this.callParent('running', arguments);
		},

		getCacheHash: function (params) {
			var cl;

			cl = fox.clone(params);

			cl.types = JSON.stringify(cl.types);

			return window.btoa(fox.toArray(cl).join(':'));
		},

		getEvents: function (params) {
			var api = this.rwom1('#getDataApi');
			var additionalParams = this.getOption('additionalApiParams');

			if (!fox.isEmpty(additionalParams)) {

				fox.each(['current', 'next', 'prev'], function(p) {
					if (params[p]) {
						params[p] = fox.merge(params[p], additionalParams);
					}
				}, this);
				
			}

			api.sendHash = this.getCacheHash(params.current);
			api.send(params.current);
		},

		getDataApiSuccess: function (res, api) {
			// console.timeEnd(api.getAlias());
			res = res.answer.response;
			this.addCache(res, api.sendHash).renderList(res);
		},

		renderList: function (collection) {
			this.list.setCollection(collection);
		},

		cachedApiSuccess: function (res, api) {
			// console.timeEnd(api.getAlias());
			res = res.answer.response;
			this.addCache(res, api.sendHash);

			api.removeSelf();
		},

		filterChanged: function (data) {
			var cp, np, pp;

			cp = this.getCacheHash(data.current);
			// np = this.getCacheHash(data.next);
			// pp = this.getCacheHash(data.prev);

			if (this.CACHE.hasOwnProperty(cp)) {
				this.renderList(this.CACHE[cp]);
			}

			// if (!this.CACHE.hasOwnProperty(np)) {this.getCacheData(data, 'next');}
			// if (!this.CACHE.hasOwnProperty(pp)) {this.getCacheData(data, 'prev');}
			if (!this.CACHE.hasOwnProperty(cp)) {this.getEvents(data);}
		},

		getCacheData: function (params, cp) {
			var nApi, pApi;

			switch (cp) {
				case 'next':
					nApi = this.getCachedApi();
					nApi.sendHash = this.getCacheHash(params.next);
					nApi.send(params.next);
					break;
				case 'prev':
					pApi = this.getCachedApi();
					pApi.sendHash = this.getCacheHash(params.prev);
					pApi.send(params.prev);
					break;
				default:
					nApi = this.getCachedApi();
					pApi = this.getCachedApi();

					nApi.sendHash = this.getCacheHash(params.next);
					pApi.sendHash = this.getCacheHash(params.prev);

					nApi.send(params.next);
					pApi.send(params.prev);
			}
		},

		addCache: function (collection, cHash) {
			if (!fox.site.member) {
				collection.unshift({
					widget: 'Activity_Event_JoinBanner',
					template: 'activity_event_card_join'
				});
			}

			if (fox.count(this.CACHE) > this.getOption('cacheRecordLimit')) {this.clearCache();}

			this.CACHE[cHash] = collection;

			return this;
		},

		clearCache: function () {
			var cacheRecords, deadLine;

			cacheRecords = fox.count(this.CACHE);
			deadLine = parseInt(cacheRecords * 0.1);

			fox.each(this.CACHE, function (val, key) {
				if ((cacheRecords--) > deadLine) {
					delete this.CACHE[key];
				}
			}, this);
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// EventCalendarViewer Widget

(function (fox, $) {
	'use strict';
	
	fox.registerWidget('Activity_EventCalendarViewerNew', {

		configure: function () {
			this.defApiConf = {
				widget: 'Api',
				method: 'Activity_Event.get',
				sendTimezone: true,
				cacheChannel: 'event'
			};

			this.registerOptions('', {
				cacheRecordLimit: 500,
				returnNewFormat: true,
				additionalApiParams: {
					transitParameters: {
						v1: 'a3NPKt70Ku'
					}
				},
				list: {
					columns: ['#firts-column']
				},
				widgets: {
					eventFilter: {
						widget: 'Activity_Event_FilterNew',
						limit: 9
					},
					eventList: {
						widget: 'Activity_Event_List',
						wClass: 'Activity_Event_MainEventNew'
					},
					getDataApi: this.defApiConf
				},
				handleWom: {
					filterChanged: {
						event: 'filterChanged',
						widget: '#eventFilter',
						callback: 'filterChanged',
						params: {
							alwaysActive: true,
							listenHistory: true
						}
					},
					getDataApiSuccess: {
						event: 'success',
						widget: '#getDataApi',
						callback: 'getDataApiSuccess'
					},
					prepareApi: {
						event: 'prepare',
						widget: '.Api',
						callback: function (obj, performer) {
							// console.time(performer.getAlias());
						}
					},
					liveshowSocketInbox: {
						event: 'inboxSocketEventLiveshow:connect',
						widget: '@root #socket',
						callback: '#eventFilter:dispatchData'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.CACHE = {};

			this.registerOptions('#eventFilter #filter1', this.getOption('filter1'));
			this.registerOptions('#eventFilter #filter2', this.getOption('filter2'));
			this.registerOptions('#eventList', this.getOption('list'));
		
			this.callParent('init', arguments);
		},

		getCachedApi: function () {
			return this.embedWidget(['api', fox.uniqid()].join('_'), 'Api', fox.merge({
				handleWom: {
					apiSuccess: {
						event: 'success',
						widget: '@this',
						callback: '@parent:cachedApiSuccess'
					},
					apiFail: {
						event: ['error', 'failure'],
						widget: '@this',
						callback: function (o, api) {
							api.removeSelf();
						}
					}
				}
			}, this.defApiConf)).run();
		},

		running: function () {
			this.list = this.rwom1('#eventList');
			this.filter = this.rwom1('#eventFilter');
			this.api = this.rwom1('#getDataApi');

			this.callParent('running', arguments);
		},

		getCacheHash: function (params) {
			var cl;

			cl = fox.clone(params);

			cl.types = JSON.stringify(cl.types);

			return window.btoa(fox.toArray(cl).join(':'));
		},

		getEvents: function (params) {
			var additionalParams = this.getOption('additionalApiParams');

			if (!fox.isEmpty(additionalParams)) {
				params = fox.merge(params, additionalParams);
			}

			this.api.sendHash = this.getCacheHash(params);
			this.api.send(params);
		},

		getDataApiSuccess: function (resp, api) {
			var res = resp.answer.response;

			this.hookWrapper('prepareResponse', {response: res});
			
			this.renderList(res);
			this.dispatchEvent('eventsApiSuccess', res);
		},

		prepareResponse: function (data) {}, 

		renderList: function (collection) {
			if(!this.dontFirstRender) {
				var c = this.list.getOption('container') || this.list.getOption('embed.container');
				fox.each(this.list.getOption('columns'), function (val, i) {
					$(c).find(val).empty();
				});

				this.dontFirstRender = true;
			}

			this.list.setCollection(collection.collection);
		},

		cachedApiSuccess: function (res, api) {
			res = res.answer.response;
			this.addCache(res, api.sendHash);

			api.removeSelf();
		},

		filterChanged: function (params) {
			var cp = this.getCacheHash(params);

			if (this.CACHE.hasOwnProperty(cp)) {
				this.renderList(this.CACHE[cp]);
				this.dispatchEvent('getDataFromCache', this.CACHE[cp]);
				return;
			}

			if (this.getOption('returnNewFormat')) {
				params.returnNewFormat = true;
			}

			this.getEvents(params);

			return;
		},

		
		addCache: function (collection, cHash) {
			if (fox.count(this.CACHE) > this.getOption('cacheRecordLimit')) {this.clearCache();}

			this.CACHE[cHash] = collection;

			return this;
		},

		clearCache: function () {
			var cacheRecords, deadLine;

			cacheRecords = fox.count(this.CACHE);
			deadLine = parseInt(cacheRecords * 0.1);

			fox.each(this.CACHE, function (val, key) {
				if ((cacheRecords--) > deadLine) {
					delete this.CACHE[key];
				}
			}, this);
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	fox.registerWidget('AmcSceneViewer', {
		getBannerSrc: function () {
			return fox._isNewFe ? __webpack_require__(29) : (fox.getEnv('design.url') + '/images/player_banner.png');
		}
	}, 'Content_VrSceneViewer');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	/* load instantly exodentity */
	var __exodentityPromise = fox.exodentity.include().then(function () {
		__exodentityPromise = null;
	}).catch(function (e) {
		__exodentityPromise = null;

		console.error('Error while downloading exodentity script:', e);

		return true;
	});

	__webpack_require__(799)(fox);

	var _ = {
		injectGA: function () {
			var gaCodes = this.getOption('gaCodes');

			if (gaCodes) {
				fox.googleAnalytics.include();
				fox.googleAnalytics.setAccounts(gaCodes);
			}
		}
	};

	fox.registerWidget('SiteApp', {
		requireResources: function () {
			if (!__exodentityPromise)
				return fox.Promise.resolve(true);
			
			return __exodentityPromise;
		},

		configure: function () {
			var applyScripts = __webpack_require__(812);
			
			this.registerOptions('', {
				'handleWom.ready': {
					'widget': '@this',
					'event': 'fox_ready',
					'callback': function() {
						setTimeout(applyScripts, 4000);
					}
				}
			});

			this.registerOptions('', {
				widgets: {
					permissionManager: {
						widget: 'PermissionManager',
						womPriority: 10
					}
				},
				handleWom: {
					onPermissionsUpdate: {
						widget: '#permissionManager',
						event: 'permissions_update',
						'params.checker': function (params) {
							return fox.intersection(['guest', 'member'], params).length;
						},
						callback: function (params) {
							var router = this.rwom1('#router');
							router.addRoutes(this.getOption('map.routes'));
							router.navigate(location.pathname.slice(1));
							this.wom('.Widget').forEach(function (widget) {
								return widget.render();
							});	
						}.bind(this)
					}
				}
			});

			if (true) {
				fox.each(document.querySelectorAll('img[_src]'), function(img) {
					img.setAttribute('src', fox._r(img.getAttribute('_src'), null, true));
					img.removeAttribute('_src');
				});
			}

			this.callParent('configure', arguments);
		},

		customInit: function () {
			this.callParent('customInit', arguments);

			var meta = fox.site.getEnv('public.metaData');

			if (this.getOption('widgets.permissionManager')) {
				this.setOption('$map', '@this:mapMember');
			}

			if (fox.isEmpty(meta)) {
				return;
			}

			fox.each(meta, function(data, page) {
				var page = page.replace('/', '');

				if (!page.length) {
					page = 'home';
				}

				if (page === 'store') {
					page = 'storeList';
				}

				var opts = this.getPageOptions(page);

				opts.title = data.title;
				opts.description = data.description;
				opts.excludeTitlePrefix = true;
			}.bind(this));

		},

		init: function () {
			_.injectGA.call(this);

			var res = fox.dictionary && fox.dictionary._commit();

			this.callParent('init', arguments);
			this.registerOptions('~.Api', {
				'secure': fox.getEnv('ah') && [fox.getEnv('ah').split('').reverse().join(''), fox.getEnv('aet')]
			});
			this.registerOptions('~.Captcha', {
				'secure': fox.getEnv('ah') && [fox.getEnv('ah').split('').reverse().join(''), fox.getEnv('aet')]
			});

			if ('client' in this) {
				this.registerOptions('~.Widget', {
					'templateEnv.client': this.client
				});
			}

      this.registerOptions('.Socket', {
        'path': '',
      });
		},

		logout: function() {
			return this.rwom1('#logoutApi').psend().then(function(){
				fox.cookie.remove('user_auth');
			});
		},

		getPageOptions: function(page, map) {
			var currentMap = this.getOption('$map').split(':')[1];
			var widgets = this.getOption(currentMap.concat('.', 'widgets'));
			var result;

			fox.each(widgets, function(lauoytOptions, layout) {

				fox.each(lauoytOptions.widgets, function(pageOptions, pageAlias) {
					if (page === pageAlias) {
						result = pageOptions;
					}
				}.bind(this));

			}.bind(this));

			return result;
		}

	}, 'App');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	"use strict";

	__webpack_require__(800);
	__webpack_require__(802)(fox);
	__webpack_require__(803)(fox);

	var require__options = __webpack_require__(804);
	var option__files = require__options.keys();

	option__files.forEach(function (file) {
		require__options(file)(fox);
	});

	__webpack_require__(808)(fox);
	__webpack_require__(810)(fox);
};

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(801);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_user-access-index.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_user-access-index.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".upbs-wrapper{position:fixed;right:0;bottom:0;left:0;z-index:12;background-color:#201f22;min-height:105px;color:#fff;display:-moz-flex;display:-ms-flexbox;display:flex;box-shadow:0 -2px 5px 0 rgba(0,0,0,.3);transform:translateY(100%);transition:transform .4s}.upbs-wrapper.opened{transform:translate(0)}.upbs-wrapper .upbs-mobile-update-open{display:none}.upbs-wrapper .pulldown-upgrade-banner{transform:rotate(-90deg);display:none;position:absolute;top:5px;right:5px;cursor:pointer}.upbs-wrapper .pulldown-upgrade-banner,.upbs-wrapper .pullup-upgrade-banner{width:14px;height:14px;text-align:center;font-size:16px}.upbs-wrapper .pullup-upgrade-banner:before{transform:rotate(90deg)}.upbs-wrapper .upbs-model-avatar{width:64px;height:64px;border-radius:50%;background-repeat:no-repeat;background-size:cover;background-position:50%;border:3px solid #414043}.upbs-wrapper .upbs-content{position:relative;padding:20px;margin:0 auto;max-width:960px}.upbs-wrapper .upbs-content .upbs-message{max-width:70%;line-height:24px;font-size:14px}@media (max-width:820px){.upbs-wrapper .upbs-content .upbs-message{max-width:60%}}@media (max-width:650px){.upbs-wrapper .upbs-content .upbs-message{max-width:50%}}.upbs-wrapper .upbs-content .close-upgrade-banner{font-size:16px;position:absolute;top:5px;right:5px;cursor:pointer}.upbs-wrapper:not(.gdpr-popup) .mc-common-button{padding:13px 30px;height:44px;font-size:14px;line-height:normal;color:#201f22;background-color:#fff;box-sizing:border-box;margin-left:60px;white-space:nowrap}.upbs-wrapper:not(.gdpr-popup) .mc-common-button i{margin-right:5px}@media screen and (max-width:580px){.upbs-wrapper{transform:translateY(90%)}.upbs-wrapper .upbs-mobile-update-open{display:block;position:absolute;font-size:12px;text-transform:uppercase;top:10px}.upbs-wrapper .upbs-mobile-update-open i{margin:0 5px}.upbs-wrapper .mc-common-button,.upbs-wrapper .upbs-message,.upbs-wrapper .upbs-model-avatar{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.upbs-wrapper.opened .mc-common-button,.upbs-wrapper.opened .upbs-message,.upbs-wrapper.opened .upbs-model-avatar{-ms-filter:none;filter:none;opacity:1}.upbs-wrapper.opened .close-upgrade-banner,.upbs-wrapper.opened .upbs-mobile-update-open{display:none}.upbs-wrapper.opened .pulldown-upgrade-banner{display:block}.upbs-wrapper .upbs-content{padding:30px;-ms-flex-flow:column nowrap;flex-flow:column nowrap}.upbs-wrapper .upbs-content .upbs-message{max-width:100%;text-align:center;margin:30px 0}.upbs-wrapper .upbs-model-avatar{position:relative}.upbs-wrapper .upbs-model-avatar:after,.upbs-wrapper .upbs-model-avatar:before{content:\"\";height:1px;width:100%;background-color:hsla(0,0%,100%,.2)}.upbs-wrapper .upbs-model-avatar:before{position:absolute;top:50%;left:-80px}.upbs-wrapper .upbs-model-avatar:after{position:absolute;top:50%;right:-80px}}.upbc-wrapper{position:absolute;top:0;right:0;bottom:0;left:0;z-index:15;color:#fff;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-pack:space-around;-moz-justify-content:space-around;justify-content:space-around}.upbc-wrapper .upbc-img-layer{background-size:cover;background-repeat:no-repeat;background-position:50%;position:absolute;top:0;right:0;bottom:0;left:0;z-index:0;border-radius:2px}.upbc-wrapper .upbc-img-layer:after{content:\"\";border-radius:2px;background-color:rgba(0,0,0,.9);position:absolute;top:0;right:0;bottom:0;left:0;z-index:1}.upbc-wrapper .upbs-content{position:relative;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-align:center;-moz-align-items:center;align-items:center}.account-type-upgrade-menu-block{background-color:rgba(0,0,0,.8);padding:30px;text-align:center;text-transform:none;font-weight:400;line-height:16px}.account-type-upgrade-menu-block .atu-current-type strong{display:block;font-size:16px;margin-top:5px}.account-type-upgrade-menu-block .atu-quote{font-size:14px;margin:20px 0}.account-type-upgrade-menu-block .mc-common-button{margin-top:20px;display:inline-block!important;padding-left:30px!important;padding-right:30px!important}", ""]);

// exports


/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("upgrade_promo_banner_strip", [["if",{"empty":""},[["if",{"empty":""},[["div",{"class":"upbs-wrapper _flex"},[["div",{"class":"upbs-content _flex _row-n _r-h-justify _r-v-center"},[["div",{"id":"upbs-mobile-update-open","class":"upbs-mobile-update-open"},[["i",{"class":"ls-iconcrone"}],["textNode",{"text":" "}],["strong",{},[["textNode",{"text":"update your account"}]]],["textNode",{"text":" "}],["i",{"class":"icon-arrow-middle-left pullup-upgrade-banner"}]]],["div",{"class":"upbs-model-avatar"},[["if",{"notempty":"","addattr":"style:background-image:url(&&1&&)"},[],[["socialImage","notempty",true,[],"env"],["socialImage","addattr",false,[],"env"]]]]],["div",{"class":"upbs-message","data-fox-alias":"BottomUpgradeText","data-fox-context":"upgradeTextBottom"},[["textNode",{"text":" I invite you to my VIP Fan area, which you can access after purchasing a subscription. You can explore all perks and benefits of my VIP club by clicking the Upgrade button below. "}]]],["a",{"href":"/upgrade","class":"mc-common-button"},[["if",{"notempty":""},[["span",{"class":"discount-sticker btn-container"},[["textNode",{"text":" discount "}],["span",{"class":"value"},[["span",{},[],[["maxDiscount","__text",true]]],["textNode",{"text":"%"}]]]]]],[["maxDiscount","notempty",true,[{"name":"gt","params":["0"]}]]]],["i",{"class":"ls-iconcrone"}],["div",{"class":"label","style":"display: inline-block","data-fox-alias":"BottomUpgradeButton","data-fox-context":"bottomUpgradeButton"},[["textNode",{"text":"upgrade"}]]]]],["textNode",{"text":" "}],["i",{"id":"close-upgrade-banner","class":"ls-iconclosegift close-upgrade-banner"}],["textNode",{"text":" "}],["i",{"id":"pulldown-upgrade-banner","class":"icon-arrow-middle-left pulldown-upgrade-banner"}]]]]]],[["site.state","empty",true,[{"name":"eq","params":["4"]}],"env"]]]],[["data","empty",true]]]]);
fox.registerTemplate("account_type_upgrade_menu_block", [["div",{"class":"account-type-upgrade-menu-block"},[["div",{"class":"atu-current-type","data-fox-alias":"AccountTypeText"},[["textNode",{"text":" Account type: "}],["strong",{},[["textNode",{"text":"BASIC"}]]]]],["p",{"class":"atu-quote","data-fox-alias":"MenuUpgradeText"},[["textNode",{"text":"I love to keep connected with my fans in this special place and will do my best to please every admirer."}]]],["p",{"data-fox-alias":"MenuUpgradeText2"},[["textNode",{"text":"However, if you want to try a full fan experience, I personally invite you to my VIP Fan area, access to which is granted on a paid subscription basis. You can explore all perks and benefits of my VIP options by clicking on \"Upgrade\" button below."}]]],["a",{"href":"/upgrade","class":"mc-common-button"},[["if",{"notempty":""},[["span",{"class":"discount-sticker btn-container"},[["textNode",{"text":" discount "}],["span",{"class":"value"},[["span",{},[],[["maxDiscount","__text",true]]],["textNode",{"text":"%"}]]]]]],[["maxDiscount","notempty",true,[{"name":"gt","params":["0"]}]]]],["span",{},[["i",{"class":"ls-iconcrone"}]]],["div",{"class":"label","style":"display: inline-block","data-fox-alias":"menuUpgradeButton","data-fox-context":"menuUpgradeButton"},[["textNode",{"text":"upgrade "}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("member_oneclick_upgrade", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Thank you"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["textNode",{"text":" THE UPGRADE WAS SUCCESSFUL, ENJOY! "}]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"close","class":"mc-common-button close"},[["textNode",{"text":"Close"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./rules/guest.opt": 805,
	"./rules/member.opt": 806,
	"./upgrade-success-action.opt": 807
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 804;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{".PermissionManager":{"hooks.onStartInit":[{"value":function(argument) {
var siteState = fox.getEnv('siteProps.state');
if (siteState === 'closed') {
this.setOption('permissions.guest.map.guest.routes.password-recovery(/:hash)', '#stateoff #passwordRecovery');
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.upgrade.action":[{"value":"#join #join","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.upgrade.checker":[{"value":function () {
if (fox.getEnv('site.state') === 4) {
return '>>'
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.join":[{"value":"\u003E\u003Eupgrade","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.successful-registration":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.conversation":[{"value":"\u003E\u003Eupgrade","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.favorites":[{"value":"\u003E\u003Eupgrade","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.login":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.cancellation":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.store(\u002F:id).action":[{"value":"#home #storeList","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.store(\u002F:id).checker":[{"value":function () {
if (!fox.getEnv('store.enabled')) {
return '>>';
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.product\u002F:id(\u002F*tail).action":[{"value":"#home #storeItem","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.product\u002F:id(\u002F*tail).checker":[{"value":function () {
var pm = fox.site.wom1('.PermissionManager');
if (fox.getEnv('store.enabled') || !fox.isEmpty(pm.getMemberInfo('hasPurchasedProducts'))) {
return false
} else {
return '>>'
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.purchases.action":[{"value":"#home #purchasesList","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.purchases.checker":[{"value":function () {
var pm = fox.site.wom1('.PermissionManager');
if (fox.getEnv('store.enabled') || !fox.isEmpty(pm.getMemberInfo('hasPurchasedProducts'))) {
return false
} else {
return '>>'
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101056},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.favorites":[{"value":"\u003E\u003Elogin","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.conversation":[{"value":"\u003E\u003Elogin","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.account":[{"value":"\u003E\u003Elogin","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.cancellation.action":[{"value":"#home #cancellation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.cancellation.checker":[{"value":function () {
var isPreviewMode = __webpack_require__(33);
if (!isPreviewMode())
return '>>';
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.password-recovery(\u002F:hash)":[{"value":"#home #passwordRecovery","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.store(\u002F:id).action":[{"value":"#home #storeList","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.store(\u002F:id).checker":[{"value":function () {
if (!fox.getEnv('store.enabled')) {
return '>>';
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.product\u002F:id(\u002F*tail).action":[{"value":"#home #storeItem","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.product\u002F:id(\u002F*tail).checker":[{"value":function () {
if (!fox.getEnv('store.enabled')) {
return '>>';
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.guest.routes.purchases":[{"value":"\u003E\u003Elogin","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":".PermissionManager","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{".PermissionManager":{"permissions.member.map.routes.login":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.password-recovery":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.join":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.successful-registration":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.upgrade":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.splash":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.store(\u002F:id).action":[{"value":"#home #storeList","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.store(\u002F:id).checker":[{"value":function () {
if (!fox.getEnv('store.enabled')) {
return '>>';
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.product\u002F:id(\u002F*tail).action":[{"value":"#home #storeItem","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.product\u002F:id(\u002F*tail).checker":[{"value":function () {
var pm = fox.site.wom1('.PermissionManager');
if (fox.getEnv('store.enabled') || !fox.isEmpty(pm.getMemberInfo('hasPurchasedProducts'))) {
return false
} else {
return '>>'
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.purchases.action":[{"value":"#home #purchasesList","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}],"permissions.member.map.routes.purchases.checker":[{"value":function () {
var pm = fox.site.wom1('.PermissionManager');
if (fox.getEnv('store.enabled') || !fox.isEmpty(pm.getMemberInfo('hasPurchasedProducts'))) {
return false
} else {
return '>>'
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":".PermissionManager","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{".PermissionManager":{"handleWom.upgradeOneclickSuccess.widget":[{"value":"@parent ~.SitePage_Join","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":".PermissionManager","_fox_":1}],"handleWom.upgradeOneclickSuccess.event":[{"value":"user_upgrage_oneclick","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":".PermissionManager","_fox_":1}],"handleWom.upgradeOneclickSuccess.callback":[{"value":function (params, performer) {
var app = performer.rwom1('@root');
var popup = app.embedWidget('memberOneclickUpgradeSuccess', 'Popup_Common', {
preventHideOnShadowClick: true,
'dialog.width': '300px',
'widgets.content': {
template: 'member_oneclick_upgrade'
}
});
popup.run();
return popup.show().wait('hide').then(function () {
popup.destroy();
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":".PermissionManager","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// PermissionManager Widget

module.exports = function (fox) {
	'use strict';

	fox.registerWidget('PermissionManager', {
		__constructor: function __constructor() {
			this.callParent('__constructor', arguments);

			fox.registerTemplateModifier('hasAccess', function (obj, params) {
				var ruleName = params[0];

				return this.hasAccess(ruleName);
			}.bind(this));
		},

		configure: function configure() {
			this.registerOptions('', {
				handleWom: {
					permissionsUpdate: {
						event: 'inboxSocketEventPermissions:update',
						widget: '@root #socket',
						callback: 'onPermissionsUpdateCallback'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			this.rules = {};

			this._defineProperty('member', null, {
				get: function get() {
					return fox.getEnv('member');
				}
			});

			this.callParent('init', arguments);

			this.applyRules(this.getOption('permissions'));

			/* shortcuts rules */
			this.applyRules({
				guestActual: {},
				free: {}
			});
		},

		applyRules: function applyRules() {
			var _this = this;

			var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			var keys = fox.getObjectKeys(rules).sort(function (a, b) {
				if (!(a in _this.rules)) return 1;

				return _this.hasAccess(a) ? -1 : 1;
			});

			keys.map(function (key) {
				var RuleConstructor = __webpack_require__(809)("./" + key)(fox);
				var rule = _this.rules[key];

				if (!rule) {
					rule = _this.rules[key] = new RuleConstructor(_this, rules[key]);
				} else {
					rule.setParams(rules[key]);
				}

				return rule;
			}).map(function (rule) {
				return rule.execute();
			});

			return keys;
		},

		getRuleParam: function getRuleParam(ruleName) {
			var rule = this.rules[ruleName];

			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}

			return rule && rule.getParams.apply(rule, args);
		},

		hasAccess: function hasAccess(ruleName) {
			var rule = this.rules[ruleName];

			return rule && rule.hasAccess();
		},

		onPermissionsUpdateCallback: function onPermissionsUpdateCallback(data) {
			return this.updatePermissions(data.answer);
		},

		updatePermissions: function updatePermissions(data) {
			this.dispatchEvent('permissions_update', this.applyRules(data));
		},

		getMemberInfo: function getMemberInfo(path) {
			if (fox.isArray(path)) {
				path.unshift(0);
			}

			if (fox.isString(path)) {
				path = [0, path].join('.');
			}

			return this.member && fox.objectGet(fox.toArray(this.member.collection), path || '0') || {};
		}

	}, 'Controller');
};

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./common/patch-giftbox": 18,
	"./common/patch-giftbox.es": 18,
	"./common/patch-giftbox.es.js": 18,
	"./common/patch-join-form": 19,
	"./common/patch-join-form.es": 19,
	"./common/patch-join-form.es.js": 19,
	"./common/patch-liveshow-translator": 20,
	"./common/patch-liveshow-translator.es": 20,
	"./common/patch-liveshow-translator.es.js": 20,
	"./common/patch-newsletter-subscribe": 21,
	"./common/patch-newsletter-subscribe.es": 21,
	"./common/patch-newsletter-subscribe.es.js": 21,
	"./common/patch-store-buy": 22,
	"./common/patch-store-buy.es": 22,
	"./common/patch-store-buy.es.js": 22,
	"./common/patch-tips-form": 23,
	"./common/patch-tips-form.es": 23,
	"./common/patch-tips-form.es.js": 23,
	"./common/register-member-tplenv": 11,
	"./common/register-member-tplenv.es": 11,
	"./common/register-member-tplenv.es.js": 11,
	"./common/register-pager-simple-tpls": 12,
	"./common/register-pager-simple-tpls.es": 12,
	"./common/register-pager-simple-tpls.es.js": 12,
	"./common/show-gdpr-popup": 13,
	"./common/show-gdpr-popup.es": 13,
	"./common/show-gdpr-popup.es.js": 13,
	"./free": 34,
	"./free.es": 34,
	"./free.es.js": 34,
	"./guest": 35,
	"./guest.es": 35,
	"./guest.es.js": 35,
	"./guest/register-joinform-prepareapi": 24,
	"./guest/register-joinform-prepareapi.es": 24,
	"./guest/register-joinform-prepareapi.es.js": 24,
	"./guest/register-joinform-upgrade-oneclick": 25,
	"./guest/register-joinform-upgrade-oneclick.es": 25,
	"./guest/register-joinform-upgrade-oneclick.es.js": 25,
	"./guestActual": 36,
	"./guestActual.es": 36,
	"./guestActual.es.js": 36,
	"./liveshow": 66,
	"./liveshow.js": 66,
	"./member": 37,
	"./member.es": 37,
	"./member.es.js": 37
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 809;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/** @param {Fox} fox */
module.exports = function (fox) {
	__webpack_require__(811)(fox);

	var $ = fox.jQuery;
	var getMaxDiscount = __webpack_require__(26)(fox);

	fox.registerWidget('UserAccess_UpgradeBanner', {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				template: 'upgrade_promo_banner_strip',
				'templateOptions.maxDiscount': getMaxDiscount(),
				showBannerPredicat: function showBannerPredicat() {
					return fox.isEmpty(_this.storage.getItem(_this.memberId)) && fox.getEnv('site.state') !== 4;
				}
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			this.storage = new fox.LocalStorageObjectService({
				lsLabel: '_uaub_',
				cleanCheckInterval: 1000 * 60 * 2 * 24
			});

			this.memberId = this.rwom1('@root .PermissionManager').getMemberInfo('id');

			this.setTemplateOptions('data', this.storage.getItem(this.memberId));

			this.callParent('init', arguments);
		},

		rendering: function rendering() {
			this.setTemplateOptions('data', this.storage.getItem(this.memberId));

			this.callParent('rendering', arguments);
		},

		closeBanner: function closeBanner() {
			this.storage.setItem(this.memberId, { value: 1 });

			this.callParent('closeBanner', arguments);
		}
	}, 'Common_BottomBanner');
};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/** @param {Fox} fox */
module.exports = function (fox) {
	var $ = fox.jQuery;

	fox.registerWidget('Common_BottomBanner', {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				autoRender: true,
				'embed.container': '#upgrade-promo-banner-container',
				handleDom: {
					closeBanner: {
						target: '#close-upgrade-banner',
						callback: 'closeBanner'
					},
					openMobileVersion: {
						target: '#upbs-mobile-update-open',
						callback: function callback() {
							return $(_this.dom1('.upbs-wrapper')).addClass('opened');
						}
					},
					hideMobileVersion: {
						target: '#pulldown-upgrade-banner',
						callback: function callback() {
							return $(_this.dom1('.upbs-wrapper')).removeClass('opened');
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			this.showBannerPredicat = this.requireOption('showBannerPredicat');

			this.callParent('init', arguments);
		},


		addedToDom: function addedToDom() {
			var _this2 = this;

			var shouldShow = this.showBannerPredicat();

			if (shouldShow) {
				// for smooth
				setTimeout(function () {
					if (!_this2.isMobile()) $(_this2.dom1('.upbs-wrapper')).addClass('opened');
				}, 1000);
			}
		},

		closeBanner: function closeBanner() {
			$(this.dom1('.upbs-wrapper')).removeClass('opened');

			return this.render();
		},

		isMobile: function isMobile() {
			return document.body.clientWidth <= 580;
		}
	});
};

/***/ }),
/* 812 */
/***/ (function(module, exports) {

var append = Node.prototype.appendChild;
var insertBefore = Node.prototype.insertBefore;
var wrapped = [];

function wrap(element) {
    'use strict';
    if (element.tagName && element.tagName.toLowerCase() === 'script' && element.src && !element.src.match(/chunks/)) {
        return wrapped.push(element);
    }
}

Node.prototype.appendChild = function (element) {
    'use strict';
    return wrap(element) || append.apply(this, arguments);
};

Node.prototype.insertBefore = function (element) {
    'use strict';
    return wrap(element) || insertBefore.apply(this, arguments);
};

module.exports = function() {
	'use strict';
	Node.prototype.appendChild = append;
	Node.prototype.insertBefore = insertBefore;
	wrapped.forEach(function(el) {document.head.appendChild(el);});
};


/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// AMC_Banner Widget

(function (fox, $) {
	
	fox.registerWidget('AMC_Banner', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				'embed.location': 'under'
			});

			this.callParent('configure', arguments);
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('BillingSupport_BillingContact', {

		configure: function () {

			this.data = {};

			this.registerOptions('', {
				autoRender: true,
				container: '.contact-form-wrapper',
				template: 'billingSupport_contact_form',

				widgets: {
					api: {
						widget: 'Api',
						method: 'User.supportContact'
					},

					successPopup: {
						widget: 'Popup_Common',
						'widgets.content.template': 'popup_billingInfo_contact_success'
					},
				},

				handleWom: {
					handleApiResponse: {
						widget: '#api',
						event: ['success', 'error', 'failure'],
						callback: '_handleApiResponse'
					},

					// redirect: {
					// 	widget: '#successPopup',
					// 	event: 'hide',
					// 	callback: '_redirect'
					// }
				},

				handleDom: {
					formSubmit: {
						target: 'form#billing-contact-form',
						event: 'submit',
						callback: '_submit'
					},
					// select: {
					// 	target: 'select[name="problem"]',
					// 	event: 'change',
					// 	callback: '_change'
					// },
					input: {
						target: 'input[name], textarea[name]',
						event: 'input',
						callback: '_handleInput'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		_submit: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			this.data.firstname = this.dom1('[name="firstname"]').value;
			this.data.lastname = this.dom1('[name="lastname"]').value;
			this.data.description = this.dom1('[name="description"]').value;
			this.data.problem = 'General questions';
			
			if (this.isValid()) {
				this.submit();
			}
		},

		isValid: function (argument) {
			var result = true;

			fox.each(['firstname', 'lastname', 'description'], function (alias) {
				this.toggleField(alias, false);

				if (fox.isEmpty(this.data[alias])) {
					this.toggleField(alias, true);
					result = false;
				}
			}, this);

			return result;
		},

		toggleField: function (alias, state) {
			var action = (state === true ? 'addClass' : 'removeClass');
			var field = this.dom1('[name="' + alias + '"]');
			var parent = field.parentNode;
			var sibling = parent.nextSibling;
			if (alias == 'problem') {
				parent = field.parentNode.parentNode;
			};

			fox.dom[action]('error', parent);
			sibling.innerHTML = (field.validationMessage || '&nbsp;');
		},

		submit: function (argument) {
			this.wom1('#api').send(this.data)
		},

		_handleInput: function (el) {
			if (el.value.length > 0) {
				this.toggleField(el.name, false);
			}
		},

		_handleApiResponse: function (response, w, e) {
			this.data = {};

			if (fox.inArray(['failure', 'error'], e)) {
				console.error("error", response)

				return;
			};

			this.showPopup();
		},

		_change: function (el) {
			var option = el.options[el.selectedIndex];

			fox.dom.selectFirst('.selected', el.parentNode.parentNode).innerHTML = option.innerHTML

			this.toggleField(el.name, false);

			this.data[el.name] = option.value;
		},

		insertSelectTitle: function (txt) {
			this.dom1('.selected').innerHTML = txt;
		},

		showPopup: function (argument) {
			this.wom1('#successPopup').show();

			this.handleEvent(this.wom1('#successPopup'), 'hide', this._redirect, {once: true});
		},

		_redirect: function (argument) {
			fox.site.gotoPage('account')
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox, $) {

	fox.registerWidget('BillingSupport_Cancellation', {

		configure: function configure() {

			this.registerOptions('', {
				widgets: {
					modelText: {
						widget: 'Widget',
						container: '.cite',
						autoRender: true,
						template: 'billingSupport_cancellation_cite'
					},

					cancellationForm: {
						widget: 'BillingSupport_CancellationForm'
					}

					// overlay: {
					// 	widget: 'Widget',
					// 	embed: {
					// 		widget: '@parent @parent @parent @parent',
					// 		location: 'lastChild',
					// 		container: '.wrapper'
					// 	},
					// 	autoRender: true,
					// 	template: 'billingSupport_cancellation_overlay'
					// }
				},
				'handleWom.showOffer': {
					widget: '#modelText',
					event: 'addedToDom',
					listenHistory: true,
					callback: function callback() {
						fox.UserOffer.checkAction('preCancel');
					}
				}
			});

			this.callParent('configure', arguments);
		},

		activating: function activating() {
			this.setDiscount();
			this.callParent('running', arguments);
		},

		setDiscount: function setDiscount() {
			var _this = this;

			var sendApi = this.getApi('retentionPolicy', {
				method: 'retentionPolicy.get'
			});
			return sendApi.psend().then(function (resp) {
				_this.cancellationDiscount = fox.isEmpty(resp.params.answer.response) ? false : resp.params.answer.response;
				return true;
			}).catch(function (error) {
				_this.cancellationDiscount = false;
				console.error(error);
			});
		}

	}, 'Controller');
})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox, $) {
	"use strict";

	fox.registerWidget('BillingSupport_CancellationForm', {

		configure: function configure() {
			var _this = this;

			this.data = {};

			this.registerOptions('', {
				container: '.cancellation-form-wrapper',
				template: 'billingSupport_cancellation_form',
				autoRender: true,
				widgets: {
					reasonsApi: {
						widget: 'Api',
						method: 'User_Cancelation.cancelReasonsList'
					},
					cancelApi: {
						widget: 'Api',
						method: 'User.cancel'
					},
					reasonsList: {
						widget: 'Widget',
						autoRender: false,
						container: '.select',
						template: 'billingSupport_cancellation_form_select'
					},
					billingContactApi: {
						widget: 'Api',
						method: 'User.supportContact'
					},
					discountPopup: {
						widget: 'Cancellation_Offer_Popup',
						onCancelPress: function onCancelPress() {
							return _this.submit.apply(_this, arguments);
						}
					},
					confirmationPopup: {
						widget: 'GDPR_BasePopup',
						onOkPress: function onOkPress() {
							return _this.submit.apply(_this, arguments);
						},
						contentTemplate: 'popup_billingInfo_cancellation_confirm'
					},
					successPopup: {
						widget: 'GDPR_BasePopup',
						onOkPress: function onOkPress() {
							return _this.hide();
						},
						contentTemplate: 'popup_billingInfo_cancellation_success'
					},
					errorPopup: {
						widget: 'GDPR_BasePopup',
						onOkPress: function onOkPress() {
							return _this.hide();
						},
						contentTemplate: 'popup_billingInfo_cancellation_error'
					}
				},

				handleDom: {
					select: {
						targetWidget: '#reasonsList',
						target: 'select[name="reason"]',
						event: 'change',
						callback: '_change'
					},

					input: {
						target: '[name="message"]',
						event: 'input',
						callback: '_handleInput'
					},

					focus: {
						target: '[name="message"]',
						event: 'focus',
						callback: function callback() {
							this.dom1('[name="message"]').placeholder = '';
						}
					},

					send: {
						target: '.send-message',
						event: 'click',
						callback: '_send'
					},

					confirm: {
						targetWidget: '#confirmationPopup #content',
						target: '.submit',
						event: 'click',
						callback: 'submit'
					}
				},

				handleWom: {
					handleReasonsApiResponse: {
						widget: '#reasonsApi',
						event: ['success', 'failure'],
						callback: '_handleReasonsApiResponse'
					},
					handleCancelApiResponse: {
						widget: '#cancelApi',
						event: ['success', 'failure', 'error'],
						callback: '_handleCancelApiResponse'
					},

					handleSupportApiResponse: {
						widget: '#billingContactApi',
						event: ['success', 'failure', 'error'],
						callback: '_handleBillingContactApiResponse'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function running(argument) {
			this.getReasons();
			this.callParent('running', arguments);
		},

		deactivate: function deactivate(argument) {
			this.resetData();
			this.callParent('deactivate', arguments);
		},

		getReasons: function getReasons(argument) {
			this.wom1('#reasonsApi').send();
		},

		_handleReasonsApiResponse: function _handleReasonsApiResponse(response, api, e) {
			if (e === 'failure') {
				console.error(e);

				return;
			}

			var list = [{ title: 'Select', value: 0 }];

			fox.each(response.answer.response, function (obj, alias) {
				obj.value = obj.id;
				obj.title = obj.title.ucfirst();

				list.push(obj);
			});

			this.renderReasonsList(list);
		},

		_handleCancelApiResponse: function _handleCancelApiResponse(response, api, e) {
			if (response.answer.status === false) {
				console.warn('cancellation api failure, try to send billing contact form');
				this.sendMessageToBillingSupport();

				return;
			}

			fox.UserOffer.checkAction('userCanceled');

			fox.setEnv('user.canceled', 1);
			fox.setEnv('user.expDate', fox.utils.dateFormat('%Y-%m-%d', response.answer.response.expDate));
			console.log(response.answer.response);
			var resp = response.answer.response;
			if (resp.isUserAlreadyCanceled === true) {
				this.wom1('#successPopup #content').setTemplateOptions({ isUserAlreadyCanceled: 1, expireDate: resp.expDate });
				this.wom1('#successPopup #content').render();
			}
			if (!fox.UserOffer.checkAction('afterCancel', { 'callback': fox.bind(this.showSuccessPopup, this) })) {
				this.showSuccessPopup();
			}
		},

		renderReasonsList: function renderReasonsList(list) {
			this.wom1('#reasonsList').setTemplateOptions('list', list);
			this.wom1('#reasonsList').render();
		},

		_change: function _change(el) {
			var option = el.options[el.selectedIndex];

			this.insertSelectTitle(option.innerHTML);
			this.toggleField('reason', false);

			this.data.reason = option.value;
		},

		insertSelectTitle: function insertSelectTitle(txt) {
			this.dom1('.selected').innerHTML = txt;
		},

		resetData: function resetData() {
			this.data = {};
		},

		_send: function _send() {
			var cancellation = fox.site.wom1('~.BillingSupport_Cancellation');
			this.discount = cancellation.cancellationDiscount;
			this.data.message = this.dom1('[name="message"]').value;

			if (this.data.message === '') {
				this.dom1('[name="message"]').placeholder = 'Cannot be empty';
			}

			if (this.isValid()) {
				if (this.discount) {

					this.showDiscountPopup();
				} else {
					this.showConfirmationPopup();
				}
			}
		},

		submit: function submit(btn) {
			$(btn).prop('disabled', true);
			$(btn).addClass('spin');
			return this.wom1('#cancelApi').psend(this.data).then(function (resp) {
				return true;
			}.bind(this)).catch(function (e) {
				return e;
			}.bind(this));
		},

		showDiscountPopup: function showDiscountPopup() {
			var discountPopup = this.wom1('#discountPopup');
			discountPopup.wom1('#content').setTemplateOptions({
				'discounts': this.discount
			}).render();
			discountPopup.show();
		},

		onCancel: function onCancel() {},

		isValid: function isValid() {
			if (!fox.isEmpty(this.data.reason) && !fox.isEmpty(this.data.message)) {
				return true;
			}

			fox.each(['reason', 'message'], function (alias) {
				this.toggleField(alias, false);
				if (fox.isEmpty(this.data[alias])) {
					this.toggleField(alias, true);
				}
			}, this);
			return false;
		},

		toggleField: function toggleField(alias, state) {
			var action = state === true ? 'addClass' : 'removeClass';
			var field = this.dom1('[name="' + alias + '"]');
			var parent = field.parentNode;

			if (alias === 'reason') {
				field = this.wom1('#reasonsList').dom1('[name="' + alias + '"]');
				parent = field.parentNode.parentNode;
			}

			fox.dom[action]('error', parent);
		},

		_handleInput: function _handleInput(el) {
			if (el.value.length > 0) {
				this.toggleField(el.name, false);
			}
		},

		showConfirmationPopup: function showConfirmationPopup(argument) {
			this.wom1('#confirmationPopup').show();
		},

		showSuccessPopup: function showSuccessPopup(argument) {
			this.wom1('#successPopup').show();

			this.handleEvent(this.wom1('#successPopup'), 'hide', this._redirect, { once: true });
		},

		showErrorPopup: function showErrorPopup(argument) {
			this.wom1('#errorPopup').show();
		},

		_redirect: function _redirect(argument) {
			fox.site.gotoPage('account');
			window.location.reload();
		},

		sendMessageToBillingSupport: function sendMessageToBillingSupport(argument) {
			var api = this.wom1('#billingContactApi');

			this.wom1('#billingContactApi').send({
				firstname: 'ModelCentro',
				lastname: 'Forward',
				description: 'user tried to cancel membership from model\'s site, but cancellation attempt resulted in an error. Please cancel membership and notify user asap.',
				problem: 'Subscription Cancellation'
			});
		},

		_handleBillingContactApiResponse: function _handleBillingContactApiResponse(response, api, e) {
			if (e === 'failure' || e === 'error') {
				this.showErrorPopup();
				console.warn(arguments);
				return;
			}

			this.showSuccessPopup();
		}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	fox.registerWidget('BillingSupport_Support', {

		configure: function () {

			this.registerOptions('', {
				widgets: {
					renewApi: {
						widget: 'Api',
						method: 'User_Cancelation.renew'
					},
					renewConfirmationPopup: {
						widget:'Popup_Common',
						'dialog.width': '600px',
						'widgets.content.template': 'popup_billingInfo_renew_confirm'
					},
					renewSuccessPopup: {
						widget:'Popup_Common',
						'dialog.width': '400px',
						'widgets.content.template': 'popup_billingInfo_renew_success'
					},
					renewErrorPopup: {
						widget:'Popup_Common',
						'dialog.width': '600px',
						'widgets.content.template': 'popup_billingInfo_renew_error'
					},
					
					support: {
						widget: 'Widget',
						embed: {
							widget: '@parent @parent',
							container: '.billing-support-wrapper'
						},
						template: 'billing_support',
						autoRender: true,
						'hooks.onStartRendering': fox.bind(function (argument) {
							this._handleSupportWidgetRendering();
						}, this)
					}
				},

				handleDom: {
					showConfirmationPopup: {
						targetWidget: '#support',
						target: '.renew',
						event: 'click',
						callback: '_showConfirmationPopup'
					},

					renew: {
						targetWidget: '#renewConfirmationPopup #content',
						target: '#ok',
						event: 'click',
						callback: 'renew'
					},

					deleteAccount: {
						targetWidget: '#support',
						target: '.delete-account',
						callback: 'deleteAccount'
					},

					exersizeRights: {
						targetWidget: '#support',
						target: '.exersise-rights',
						callback: 'exersizeRights'
					}
				},
				handleWom: {
					handleApiSuccess: {
						widget: '#renewApi',
						event: ['success', 'failure', 'error'],
						callback: '_handleApiResponse'
					}
				}
				// 'hooks.onStartInit': function () {
				// 	var links = {
				// 		ccbill: 'https://support.ccbill.com/',
				// 		epoch: 'https://epoch.com/ru/billing_support/contact',
				// 		streamate: 'http://www.streamate.com/customer-service/'
				// 	}

				// 	var biller = fox.getEnv('user.biller');
				// 	var link = links[biller];

				//
				// 	if (!biller || !link) {
				// 		return;
				// 	};

				// 	this.setTemplateOptions({
				// 		biller: biller,
				// 		link: link
				// 	});

				//
				// }
			});

			this.callParent('configure', arguments);
		},

		// _handleStartInit: function (argument) {
		// 	var links = {
		// 		ccbill: 'https://support.ccbill.com/',
		// 		epoch: 'https://epoch.com/ru/billing_support/contact',
		// 		streamate: 'http://www.streamate.com/customer-service/'
		// 	}

		// 	var biller = fox.getEnv('user.biller');
		// 	var link = links[biller];

		//
		// 	if (!biller || !link) {
		// 		if (fox.getEnv('user.canceled') === 1) {
		// 			this.registerOptions('#support', {
		// 				templateOptions: {
		// 					canceled: true,
		// 					expireDate: '2015-02-17'
		// 				}
		// 			})
		// 		}

		// 		return;
		// 	};

		// 	this.registerOptions('#support', {
		// 		templateOptions: {
		// 			biller: biller,
		// 			link: link
		// 		}
		// 	})

		// 	//this.wom1('#support').setTemplateOptions();
		// },
		_handleSupportWidgetRendering: function (argument) {
			var links = {
				ccbill: 'https://support.ccbill.com/',
				epoch: 'https://epoch.com/ru/billing_support/contact',
				streamate: 'http://www.streamate.com/customer-service/'
			};

			var biller = fox.getEnv('user.biller');
			var link = links[biller];
			var cancelState = fox.getEnv('user.canceled');


			if (!biller || !link) {
				if (fox.inArray([1, 7], cancelState)) {
					this.setSupportTemplateOptions({
						canceled: true,
						expireDate: fox.getEnv('user.expDate')
					});

					return;
				}

				this.setSupportTemplateOptions({canceled: false});

				return;
			}

			this.setSupportTemplateOptions({
				biller: biller,
				link: link
			});

			// this.registerOptions('#support', {
			// 	templateOptions: {
			// 		biller: biller,
			// 		link: link
			// 	}
			// })
		},
		_showConfirmationPopup: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			this.showConfirmationPopup();
		},

		showConfirmationPopup: function () {
			this.wom1('#renewConfirmationPopup').show();
		},

		showErrorPopup: function (tplOpts) {
			var popup = this.wom1('#renewErrorPopup');

			popup.wom1('#content').setTemplateOptions((tplOpts || {})).render();

			popup.show();
		},

		showSuccessPopup: function () {
			this.wom1('#renewSuccessPopup').show();
		},

		renew: function (btn, alias, w, e) {
			$(btn).prop('disabled', true);
			$(btn).addClass('spin');
			return this.wom1('#renewApi').psend(this.data).then(function (resp) {
				$(btn).prop('disabled', false);
				$(btn).removeClass('spin');
				return true;
			}.bind(this)).catch(function (e) {
				$(btn).prop('disabled', false);
				$(btn).removeClass('spin');
				return e;
			}.bind(this));
		},

		_handleApiResponse: function (obj, w, e) {
			if (e === 'failure' || e === 'error') {
				this.showErrorPopup(obj.answer);

				return;
			}

			this.showSuccessPopup();
			fox.setEnv('user.canceled', 0);
			fox.UserOffer.checkAction('userRenewed');
			this.wom1('#support').render();
		},

		setSupportTemplateOptions: function (opts) {
			this.wom1('#support').setOption('templateOptions', opts);
		},

		deleteAccount: function() {
			console.log('deleteAccount');

			fox.site.rwom1('#gdprDeleteAccount').show().then(function(result) {
				console.log(result);
			}.bind(this));
		},

		exersizeRights: function() {
			console.log('exersizeRights');
			fox.site.rwom1('#gdprRulesActions').show().then(function(result) {
				console.log(result);
			}.bind(this));
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// BlogSidebar

(function (fox, $) {
	'use strict';

	fox.registerWidget('BlogSidebar', {

		/**
		*	required options
		*
		*	'latestCommentsRowTemplate'
		*	'mostPopularPostRowTemplate'
		*/

		configure: function () {
			this.registerOptions('', {
				'embed.container': '#right-blog-info',
				template: 'blog_sidebar_main_template',
				autoRender: true,
				widgets: {
					latestComments: {
						widget: 'Grid',
						template: 'blog_last_comments_container',
						'embed.container': '#last-post-comments',
						autoRender: true,
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'blog.GetBlogLastComments'
						},
						'list.embed.container': '.list'
					},
					latestPopularPosts: {
						widget: 'BlogViewer',
						template: 'blog_last_popular_posts_container',
						'embed.container': '#most-popular-post',
						autoRender: true,
						'widgets.dl': {
							method: 'blog.GetPopularPosts',
						},
						'list.embed.container': '.list'
					}
				},
				handleWom: {
					latestCommentsAddToDom: {
						event: 'addedToDom',
						widget: '#latestComments',
						callback: 'checkDlCollection',
						'params.prefix': 'blogSidebarEvent'
					},
					latestPopularPostsAddToDom: {
						event: 'addedToDom',
						widget: '#latestPopularPosts',
						callback: 'checkDlCollection',
						'params.prefix': 'blogSidebarEvent'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#latestComments', {
				'list.tpl.row': this.requireOption('latestCommentsRowTemplate'),
				'widgets.dl.limit': this.getOption('lastestCommentLimit') || 3
			});

			this.registerOptions('#latestPopularPosts', {
				'list.tpl.row': this.requireOption('mostPopularPostRowTemplate'),
				'widgets.dl.limit': this.getOption('mostPopularPostLimit') || 3
			});
		
			this.callParent('init', arguments);
		},

		activate: function () {
			fox.each(this.wom('.Grid .Datalayer'), function (dl) {
				dl.load();
			});
		
			this.callParent('activate', arguments);
		},

		checkDlCollection: function (obj, performer) {
			var hideShowBlock = function (hide) {
				if (hide === true) {
					if (this._indom === true) {
						$(this.element).hide();
					}
				} else {
					if (this._indom === true && !$(this.element).is(':visible')) {
						$(this.element).show();
					}
				}
			}

			if (!performer.rwom1('#dl').getCount()) {
				hideShowBlock.call(performer, true);
			} else {
				hideShowBlock.call(performer);
			}
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// BlogViewer Widget

(function (fox, $) {
	'use strict';

	fox.registerWidget('BlogViewer', {
		
		configure: function () {
			this.registerOptions('', {
				'embed.container': '#blog-container',
				menuSelector: false,
				autoRender: true,
				externalLoad: true,
				loadOnRun: true,
				getImageFromHTML: false,
				widgets: {
					dl: {
						widget: 'Datalayer',
						cacheChannel: 'content',
						method: 'blog.get',
						limit: 5,
						metaFields: ['shortContent', 'totalCount'],
						fields: ['tags.title'],
						jsonize: false,
					}
				},
				'list.hooks.onStartRendering': '@parent:sortShortData',
				'list.hooks.onAddedToDom': function () {
					var
						grid = this.getParent();

					if (grid.dl.getCount() === 0) {
						if (grid._indom) {
							$(grid.element[0]).hide();
						}
					}
				}
			});
			fox.registerTemplateModifier('isWide', function (obj) {
				if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return (w / h > .84); 
			});
			this.callParent('configure', arguments);
		},

		running: function () {
			if (this.getOption('loadOnRun') === true) {
				this.loadPosts();
			}
		
			this.callParent('running', arguments);
		},

		loadPosts: function () {
			if (!fox.site.member) {
				this.dl.setTransitParameter('notMember', 1);
			}

			this.dl.load();
		},

		sortShortData: function () {
			var temp, sortedShortContent, menu, IMG_TYPE = 3;

			temp = [];

			this.visual = (this.dl.getCount() > 0);

			fox.each(this.dl.getCollection(), function (val, key) {
				var type3Exists = false;
				
				if (val._shortContent) {
					sortedShortContent = 
						fox.toArray(val._shortContent.collection).sort(function (f, s) {
							if (f.type === IMG_TYPE) {
								type3Exists = true;
							}
							return f.type > s.type ? -1 : 1;
						});

					if (sortedShortContent.length) {
						val._shortContent.collection = type3Exists ? sortedShortContent : this.getImageFromShortContent(sortedShortContent);
					}
				}

				temp.push(val);
			}, this);

			this.dl.setCollection(temp);
		},

		getImageFromShortContent: function (sortedShortContent) {
			var regExp = /<img[\s\w=\-;:\"\'\.]*src=\"([\S]+)\"[\s\w=\-;:\"\'\.]*\/>/;
			var content = sortedShortContent[0].content;
			var IMG_TYPE = 3;
			var matches;

			while ((matches = content.match(regExp)) !== null) {
				content = content.replace(matches[0], '');

				sortedShortContent.push({
					type: IMG_TYPE,
					content: matches[1]
				});
			}

			sortedShortContent[0].content = content;

			return sortedShortContent.reverse();
		}

	}, 'Grid');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('PostViewer', {
		configure: function () {
			this.registerOptions('', {
				'embed.container': '#post-container',
				manualRender: true,
				autoRender: true,
				externalLoad: true,
				contentIdPrefix: 'content-container-',
				textNodeTemplate: false,
				quoteNodeTemplate: false,
				photoNodeTemplate: false,
				videoNodeTemplate: false,
				videoContainer: 'flash-player-',
				widgets: {
					loader: {
						widget: 'PromisePreloader',
					},
					dl: {
						widget: 'Datalayer',
						method: 'blog.getPost',
						limit: 1,
						cacheChannel: 'content'
					},
					currentRating: {
						widget: 'Social_Rating',
						targetDl: '@parent #dl',
						'embed.widget': '@parent #list',
						template: 'social_rating_blog',
						subject: 'blog'
					},
					fullscreenView: {
						widget: 'FullscreenView',
						template: 'sitepage_gallery_fullscreenview_cutted_for_blogpost'
					},
					postComments: {
						widget: 'Social_Comments',
						showComments: true,
						targetDl: '@parent #dl',
						template: 'social_comment_scene',
						'embed.widget': '@parent #list',
						dlLimit: 5,
						'handleDom.toggleForm': {
							targetWidget: '@parent #list'
						},
						formOptions: {
							'hooks.onStopRendering': function () {
								if (this.getParent().getParent().getPd().allowComment === 0) {
									this.dom1('form').style.display = 'none';
								}
							}
						},
						subject: 'blog'
					}
				},
				'list.hooks.onStopRendering': '@parent:_listRender',
				handleDom: {
					openFullscreen: {
						target: '.pl-text img, .content-img img',
						event: 'click',
						targetWidget: '@this #list .Widget',
						callback: 'openFullscreen'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#postComments .Grid', {
				pager: this.getOption('commentsPager')
			});

			this.registerOptions('#loader', {
				'embed.container': this.getOption('list.container') || this.getOption('list.embed.container')
			});

			this._pid = null;
			this._postData = null;
			this._postResources = [];
		
			this.callParent('init', arguments);
		},

		running: function () {
			this._list = this.rwom1('#list');
			this.saveOldMeta();
		
			this.callParent('running', arguments);
		},

		activate: function () {	
			this.callParent('activate', arguments);

			this.saveOldMeta();
			this.dispatchEvent('postActivated');
		},

		deactivate: function () {
			this.callParent('activate', arguments);

			this.restoreOldMeta();
		},

		setPd: function () {
			var pd;

			pd = this.dl.getCollection();

			if (pd.length) {
				this._postData = pd[0];
				this._postResources = this._postData.resources;
			}
			
			return this;
		},

		getPd: function () {
			return this._postData;
		},

		fetch: function (id) {
			this._postData = null;
			this._pid = id;

			return this._loadPost().then(this.setMetaData.bind(this));
		},

		getPid: function () {
			return this._pid;
		},

		_loadPost: function () {
			var loader = this.rwom1('#loader');

			return loader.show(this.dl.setTransitParameter('id', this._pid).load());
		},

		_listRender: function () {
			this.setPd();

			this.fillPostContent();
		},

		fillPostContent: function () {
			if (!this.getPd()) {
				fox.site.gotoPage('join');
				return;
			}
			fox.each(this.getPd().contents, function (val, key) {
				if (val.type === 4) {
					this._embedVideo(val);
				} else {
					this._embedSimpleW(val);	
				}
				
			}, this);
		},

		_embedSimpleW: function (contentData) {
			var wOpt;

			wOpt = {
				autoRender: true,
				'embed.container': '#' + this.getOption('contentIdPrefix') + contentData.id,
				'templateOptions.content': contentData.content
			};

			switch (contentData.type) {
				case 1: 
					wOpt = fox.merge(wOpt, {
						template: this.getOption('textNodeTemplate') || 'div.pl-text{$[content]}'
					});
					break;
				case 2:
					wOpt = fox.merge(wOpt, {
						template: this.getOption('quoteNodeTemplate') || 'div.pl-text.quote{$[content]}'
					});
					break;
				case 3:
					wOpt['templateOptions.postId'] = contentData.postId;
					
					if (contentData.description) {
						wOpt['templateOptions.description'] = contentData.description;
					}

					wOpt = fox.merge(wOpt, {
						template: this.getOption('photoNodeTemplate') || 'div.content-img>img[src="$[content]"]'
					});
					break;
			}

			return this
					._list
					.embedWidget('cw_' + fox.uniqid(), 'Widget', wOpt)
					.run();
		}, 

		_embedVideo: function (contentData) {
			var wOpt;

			wOpt = {
				container: '#' + this.getOption('contentIdPrefix') + contentData.id,
				template: this.getOption('videoNodeTemplate'),
				'templateOptions.videoContainer': [this.getOption('videoContainer'), contentData.id].join(''),
				autoRender: true,
				'widgets.player': {
					widget: 'FlashPlayer2',
					container: ['#', this.getOption('videoContainer'), contentData.id].join(''),
					standAloneMode: true,
					videoUrl: JSON.parse(decodeURIComponent(contentData.content)).path,
					'playerConfig.plugins.controls': {
						rates: false,
						'autoHide.enabled': true,
					},
					'playerConfig.clip.autoPlay': false
				},
				'handleWom.addedToDom': {
					event: 'addedToDom',
					widget: '@this',
					callback: '#player:runPlayer'
				}
			};

			if (contentData.description) {
				wOpt['templateOptions.description'] = contentData.description;
			}

			return this
					._list
					.embedWidget('cw_' + fox.uniqid(), 'Widget', wOpt)
					.run();
		},

		openFullscreen: function (e) {	
			var src = $(e).attr('src'),
				alt = $(e).attr('alt'),
				photoData = {},
				rid = null;

			rid = this.getUrlParam(src, 'rid');

			photoData = {
				id: 1,
				altTag: alt,
				url: !fox.isEmpty(this._postResources[rid]) ? this._postResources[rid].path : src
			};

			if (photoData) {
				this.rwom1('#fullscreenView').setPhotoCollection([photoData]).setCurrentPhoto(photoData).show();
			}
		},

		getUrlParam: function (src, paramName) {
			var reParam = new RegExp( '(?:[\?&]|&)' + paramName + '=([^&]+)', 'i' ),
				match = src.match(reParam);

			return ( match && match.length > 1 ) ? match[ 1 ] : null ;
		},

		saveOldMeta: function () {
			this.metaTitle = fox.dom.selectFirst('title', document).innerHTML;
			var descrTag = fox.dom.selectFirst('meta[name="description"]', document);
			if (descrTag) {
				this.metaDescription = fox.dom.wrap(descrTag).attr('content');
			}
		},

		restoreOldMeta: function () {
			fox.dom.selectFirst('title', document).innerHTML = this.metaTitle;
			var descrTag = fox.dom.selectFirst('meta[name="description"]', document);
			if (descrTag) {
				fox.dom.wrap(descrTag).attr('content', this.metaDescription);
			}
		},

		setMetaData: function () {
			var data = this.rwom1('#dl').getCollection()[0];
			var metaTitle = fox.objectGet(data, 'metaTitle');
			var description = fox.objectGet(data, 'metaDescription');
			var title = fox.objectGet(data, 'title');
			/*var titleTag = fox.dom.selectFirst('title', document);
			var descrTag = fox.dom.selectFirst('meta[name="description"]', document);

			if (!descrTag) {
				descrTag = document.createElement('meta');
				descrTag.setAttribute('name', 'description');
				this.window.document.head.appendChild(descrTag);
			}

			titleTag.innerHTML = metaTitle ? metaTitle : title;

			descrTag.setAttribute('content', description || ''); */
			var metaDescription = fox.dom.selectFirst('meta[name="description"]');
			metaTitle = metaTitle !== '' ? metaTitle : title;
			document.title = metaTitle + " - " + fox.getEnv('screenName')  + "'s blog";
			var defaultDescription  = "Check out my latest blog post! " + metaTitle + " - " + fox.getEnv('screenName') + "'s blog."
			description !== '' ? metaDescription.setAttribute('content', description) : metaDescription.setAttribute("content", defaultDescription);

			if($(this.element).length){
				$('body, html').animate({
					scrollTop: $(this.element).offset().top - 50
				}, 500);
			}
			
		},

		getContentId: function () {
			return this._pid;
		}

	}, 'Grid');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	var TITLE = 'Please fill in your credit card details below to proceed with the payment';
	var argumentError = new Error('[CBPaymentPopup widget]: -> show method requires promise argument.');
	var windowId = 'cb_payment_window';

	fox.registerWidget('CBPaymentPopup', {
		configure: function configure() {
			this.registerOptions('', {
				handleWom: {
					closeCallback: {
						event: 'inboxSocketEventBilling:popup:close',
						widget: '@root #socket',
						callback: 'closeCallback'
					}
				}
			});

			this.callParent('configure', arguments);
		},
		init: function init() {
			this._isSupportPopup = /(Chrom(e|ium)|Firefox|AppleWebKit)/.test(navigator.userAgent);

			this._window = null;
			this.matchToken = this.getOption('matchTokenFunction') || null;

			this.callParent('init', arguments);
		},
		hide: function hide() {
			if (this._window) {
				this._window.close();
				this._window = null;

				return true;
			}

			return false;
		},
		_createPopup: function _createPopup() {
			var id = windowId + '_' + new Date().getTime();
			var _window = window.open('', id, !this._isSupportPopup ? '' : 'width=120,height=120,resizable=yes,location=no,scrollbars=yes,status=no');

			_window.document.write('\n\t\t\t\t<div style="text-align:center;">\n\t\t\t\t\t<img src="https://purchase.centrobill.com/template/paypage/sps_ajx_en/img/loading.gif" />\n\t\t\t\t</div>\n\t\t\t');

			return _window;
		},
		show: function show(promise) {
			var _this = this;

			if (!fox.isPromise(promise)) throw argumentError;

			if (this.isOpen()) this.hide();

			var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

			this._window = iOS ? window : this._createPopup();

			return promise.then(function (resp) {
				var url = resp.url;


				if (!_this._window) return resp;

				_this._window.location.href = url;

				if (_this._isSupportPopup) _this._window.resizeTo(700, 850);

				return resp;
			});
		},
		isOpen: function isOpen() {
			return this._window ? !this._window.closed : false;
		},
		closeCallback: function closeCallback(resp) {
			var parent = this.getParent();

			if (this.isOpen()) {
				var memberInfo = fox.site.rwom1('.PermissionManager').getMemberInfo();
				var useToken = fox.isFunction(this.matchToken) && this.matchToken(resp.answer.token);

				if (!fox.isEmpty(memberInfo) || useToken) {
					this.hide();

					if (useToken && fox.isFunction(parent.showSuccessPopup)) parent.hookWrapper('showSuccessPopup');
				}
			}
		}
	}, 'Controller');
};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	fox.registerWidget('Page_CCPA_Site', {
		configure: function configure() {
			this.registerOptions('', {
				widgets: {
					popup: {
						widget: 'Popup_Common',
						useUiPosition: true,
						dialog: {
							title: 'California Consumer Privacy form',
							width: '550px',
							'!dialogClass': 'ccpa-form mc-site-common-popup gdpr-popup'
						},
						widgets: {
							content: {
								template: 'ccpa_form_site',
								widget: 'CCPR_Form'
							}
						}
					},
					popupSuccess: {
						widget: 'Popup_Common',
						useUiPosition: true,
						dialog: {
							title: 'Success',
							width: '320px',
							'!dialogClass': 'ccpa-form mc-site-common-popup gdpr-popup'
						},
						widgets: {
							content: {
								widget: 'Widget',
								template: 'ccpa_success_site',
								handleDom: {
									closePopup: {
										target: '.cancel-close, #success',
										event: 'click',
										callback: '@parent @parent:successHide'

									}
								}
							}
						}
					}
				},
				handleWom: {
					success: {
						widget: '#popup #content',
						event: 'form_submit_success',
						callback: 'hidePopup'
					},
					getMember: {
						widget: '@this',
						event: 'addedToDom',
						callback: 'getAutorized'
					}
				}
			});
			this.callParent('configure', arguments);
		},

		activating: function activating() {
			var name = window.location.hostname;
			this.setTemplateOptions('siteName', name);
			this.run();
		},
		successHide: function successHide() {
			this.wom1('#popupSuccess').hide();
		},
		showPopup: function showPopup() {
			this.wom1('#popup').show();
		},
		hidePopup: function hidePopup() {
			this.wom1('#popup').hide();
			this.wom1('#popupSuccess').show();
		},
		getAutorized: function getAutorized() {
			var pm = this.rwom1('@root #permissionManager');
			var w = this.rwom1('#popup #content');
			if (pm.hasAccess('free') || pm.hasAccess('member')) {
				w.setTemplateOptions('nomail', 1);
				w.render();
			}
		}
	}, 'Page_CCPA');
};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Content_BackLink', {
		requiredFields: ['backLinkProp.value', 'backLinkProp.public'],

		configure: function(options) {
			this.registerOptions('', {
				template: 'sitepage_scene_content_backlink',
				autoRender: false,
				manualRender: true,
				handleWom: {
					render: {
						widget: '@parent',
						event: 'addedToDom',
						callback: fox.bind(function() {
							this.render();
						}, this)
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.callParent('running', arguments);

			var dlPath = this.requireOption('dl');
			if (fox.isString(dlPath)) {
				this.dl = this.rwom1(dlPath);
			} else {
				this.dl = dlPath;
			}
			
			this.dl.addFields(this.requiredFields);
			this.handleEvent(this.dl, 'loaded', this.renderBackLink);
		},

		getBackLink: function() {
			var prop = this.dl.getObjectRelation('backLinkProp'),
				backLink = JSON.parse(prop.getObjectValue('value'));

			if (backLink) {
				backLink.public = prop.getObjectValue('public');
				if (fox.cookie.get('foxref')) {
					backLink.url = backLink.url + '?foxref=' + fox.cookie.get('foxref');
				}
				return backLink;
			}

			return false;
		},

		renderBackLink: function() {
			var pm = this.rwom1('@root #permissionManager');
			var backLink = this.getBackLink();
			var hasAccess = pm.hasAccess('member') || (pm.hasAccess('guest') && !fox.isEmpty(pm.getMemberInfo()));
			if (backLink && (backLink.public || hasAccess)) {
				this.setTemplateOptions(backLink);
			}else{
				this.setTemplateOptions({url:''});
			}
			var self = this;
			setTimeout(function () {
				self.render();
			}, 2000);
		}
	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Related Widget

(function (fox){
	'use strict';

	fox.registerWidget('Content_Related', {
		configure: function (options) {
			this.callParent('configure', arguments);

			this.registerOptions('', {
				widgets: {
					contentList: {
						widget: 'Content_Browser'
					}
				},
				handleWom: {
					contentIdSetting: {
						widget: '@parent',
						event: 'setContentId',
						callback: '_handleContentIdSetting'
					},
					activatingSceneViewer: {
						widget: '@parent',
						event: 'activateSceneViewer',
						callback: '_handleContentIdSetting'
					}
				}
			});
		},

		running: function (argument) {
			this.contentList = this.wom1('#contentList');

			this.callParent('running', arguments);
		},

		_handleContentIdSetting: function (id, w, e) {
			this.loadRelatedContent(id);
		},

		loadRelatedContent: function (excludedId) {
			this.contentList.dl.dropFilter('exclude');
			
			this.contentList.dl.addFilter('exclude', {
				fields: ['!id'],
				values: [[excludedId]]
			}).load();
		}

	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox, $, undefined) {
	'use strict';

	fox.registerWidget('Content_TagsFilter', {
		configure: function configure() {
			var _this = this;

			this.tagsList = [];
			this.currentTag = null;
			this.tagListLoaded = false;
			this._isOpened = false;
			this.pagination = {
				limit: 5,
				offset: 0
			}, this.registerOptions('', {
				preset: false,
				closeOnClick: true,

				widgets: {
					tagsApi: {
						widget: 'Api',
						method: 'Content_Tag.getAllTags',
						cacheChannel: 'content'
					},

					searchApi: {
						widget: 'Api',
						method: 'Content_Tag.searchTags',
						cacheChannel: 'content'
					},

					selectGrid: {
						widget: 'Widget',
						embed: {
							widget: '@parent @parent',
							container: '.tags-filter'
						},

						template: 'tags_filter',
						autoRender: true,

						widgets: {
							current: {
								widget: 'Widget',
								container: '.current',
								template: 'tags_filter_current',
								templateOptions: { alias: fox.Navigator.get('tags') || 'all tags' },
								autoRender: true
							},
							search: {
								widget: 'Widget',
								container: '.tags-search',
								template: 'tags_filter_search',
								autoRender: true
							},
							list: {
								widget: 'AdvancedList',
								notOverrideListBehavior: 1,
								container: '.tags-list',
								tpl: {
									row: 'tags_filter_row'
								},
								'handleDom.onclick': {
									target: '.tag',
									event: 'click',
									callback: function callback() {
										return _this._handleTagClick.apply(_this, arguments);
									}
								},
								'hooks.onAddedToDom': function hooksOnAddedToDom() {
									return _this.applyScrollbar();
								}
							}
						}
					}
				},

				handleWom: {
					tagsLoaded: {
						widget: '#tagsApi',
						event: 'success',
						callback: '_handleTagsLoad'
					},
					searchLoaded: {
						widget: '#searchApi',
						event: 'success',
						callback: '_handleSearchLoad'
					}
				},

				handleDom: {

					search: {
						targetWidget: '#selectGrid #search',
						target: '[name="tag-search"]',
						event: 'input',
						callback: '_search'
					},

					focus: {
						targetWidget: '#selectGrid #search',
						target: '[name="tag-search"]',
						event: 'click',
						callback: function callback(el, alias, w, e) {
							fox.dom.event.stop(e);
						}
					},

					openList: {
						targetWidget: '#selectGrid',
						target: '.click-to-open',
						event: 'click',
						callback: function callback() {
							return _this.toggleList.apply(_this, arguments);
						}
					},

					preventClick: {
						targetWidget: '#selectGrid',
						target: '.tags-list-wrapper',
						event: 'touchstart',
						callback: function callback(el, alias, w, e) {
							var res = e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function running(argument) {
			this.tagsApi = this.rwom1('#tagsApi');
			this.searchApi = this.rwom1('#searchApi');
			this.grid = this.rwom1('#selectGrid');
			this.list = this.grid.rwom1('#list');
			this.current = this.grid.rwom1('#current');
			$(document).on('click touchstart', { widget: this }, this._close);

			this.getTags();

			this.callParent('running', arguments);
		},

		activate: function activate() {
			this.getTags();

			$(document).on('click touchstart', { widget: this }, this._close);

			this.pagination.offset = 0;
			this.callParent('activate', arguments);
		},

		deactivate: function deactivate() {
			this.grid._readyToRender = false;
			this.grid.removeFromDom();

			$(window).off('click touchstart', this._close);

			this.callParent('deactivate', arguments);
		},

		getTags: function getTags() {
			this.setPaginationMethod('getTags');
			var params = {
				preset: this.getOption('preset'),
				limit: this.pagination.limit,
				offset: this.pagination.offset
			};
			this.tagsApi.send(params);
		},

		_handleTagsLoad: function _handleTagsLoad(resp, api, e) {
			var response = resp.answer.response.success;
			this.nextData ? this.nextData = false : this.list.resetCollection();
			if (!fox.isEmpty(response)) {

				this.setTagsList(response);
			}
		},

		_handleSearchLoad: function _handleSearchLoad(resp, api, e) {
			var response = resp.answer.response.success;
			this.nextData ? this.nextData = false : this.list.resetCollection();
			if (!fox.isEmpty(response)) {
				this.setTagsList(response);
			}
		},

		setTagsList: function setTagsList(tags) {
			var _this2 = this;

			var all = { value: {
					alias: 'all tags',
					id: 'all'
				} };

			var fromNavi = tags.filter(function (tag) {
				return tag.alias == _this2.getTagsFromNavigator();
			});
			if (this.list.dataModel.length === 0) {
				tags.unshift(all.value);
			}
			if (!this.currentTag) {
				this.currentTag = fox.isEmpty(fromNavi) ? all : { value: fromNavi[0] };
			}

			this.renderList(tags);
			this.markSelectedTag();
		},

		renderList: function renderList(list) {
			this.list.appendItem(list);
		},

		markSelectedTag: function markSelectedTag() {
			var _this3 = this;

			this.list.dataModel.filter(function (tag) {
				return tag.value.selected = tag.value.id == _this3.currentTag.value.id;
			});
			this.current.setTemplateOptions({ alias: this.currentTag.value.alias }).render();
			this.list.render();
		},

		changeURI: function changeURI() {
			var navi = fox.Navigator;

			if (navi.get('tags') === this.currentTag.value.alias) {
				return;
			};

			if (this.currentTag.value.alias === 'all tags') {
				var hash = navi.getAll();

				if (hash['tags']) {
					delete hash['tags'];
				}

				navi.update(hash, false);

				return;
			};

			navi.set('tags', window.encodeURIComponent(this.currentTag.value.alias), false);
		},

		renderSelectGrid: function renderSelectGrid() {
			this.grid._readyToRender = false;

			this.grid.removeFromDom();
			this.currentTag = null;
		},

		applyScrollbar: function applyScrollbar() {
			var el = this.rwom1('#selectGrid');
			if (!el) return;
			$(el.element[0]).find('.tags-scroll').mCustomScrollbar({
				theme: 'light-thin',
				scrollButtons: false,
				scrollbarPosition: 'inside',
				scrollInertia: 0,
				mouseWheel: { preventDefault: true },
				callbacks: {
					onTotalScroll: function () {
						this.getNextData();
					}.bind(this)
				}
			});
		},

		_handleTagClick: function _handleTagClick(elt) {
			var id = elt.dataset.tagid;
			fox.each(this.list.dataModel, function (tagData) {
				tagData.value.selected = false;
				if (tagData.value.id == id) {
					this.currentTag = tagData;
					throw fox.break;
				};
			}, this);

			this.selectTag(this.currentTag);
			this.hookWrapper('selectTag', this.currentTag.value);
			this.dispatchEvent('selectTag', this.currentTag.value);
		},

		selectTag: function selectTag() {
			this.markSelectedTag();
			this.changeURI();

			if (this.getOption('closeOnClick')) {
				this.renderSelectGrid();
			};
		},

		_setTag: function _setTag(tags) {
			this.hookWrapper('setTag', tags);
			this.dispatchEvent('setTag', tags);
		},

		setTag: function setTag(tags) {
			var tagAlias = tags.length ? tags[0] : 'all tags';

			if (!this.tagListLoaded) {
				this.currentTag = { value: { alias: tagAlias } };

				return;
			}

			fox.each(this.list.dataModel, function (tagData) {
				if (tagData.alias == tagAlias) {
					this.currentTag.value = tagData;
					fox.break;
				};
			}, this);
			console.log('setTag');
			this.markSelectedTag();
			//	this.renderSelectGrid();
		},

		setPaginationMethod: function setPaginationMethod(method) {
			if (!!this.paginationMethod && this.paginationMethod != method) {
				this.pagination = {
					limit: 5,
					offset: 0
				};
			}
			this.paginationMethod = method;
		},

		isMobileDevice: function isMobileDevice(argument) {
			//from Swipe.js library
			return true;
			//return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		},

		toggleList: function toggleList(el, alias, w, e) {
			fox.dom.event.stop(e);
			if (this._isOpened) {
				this.close();

				return;
			};

			this.open();
		},

		open: function open() {
			fox.dom.addClass('opened', this.grid.dom1('.tags-filter-wrapper'));
			this._isOpened = true;
		},

		close: function close() {
			if (this.isOpened === false) {
				return;
			}

			fox.dom.removeClass('opened', this.grid.dom1('.tags-filter-wrapper'));
			this._isOpened = false;
		},

		_search: function _search(el) {
			var value = fox.trim(el.value);
			if (!value.length) {
				this.getTags();
				return;
			};
			if (value.length > 2) {
				this.filterByKey(value);
			}
		},

		filterByKey: function filterByKey(key) {
			this.setPaginationMethod('filterByKey');
			var params = {
				preset: this.getOption('preset'),
				limit: this.pagination.limit,
				offset: this.pagination.offset,
				tagsLike: key
			};
			this.searchApi.send(params);
		},

		getTagsFromNavigator: function getTagsFromNavigator(argument) {
			var tags = fox.Navigator.get('tags') || [];

			return tags.length ? window.decodeURIComponent(tags).split(',') : false;
		},
		getNextData: function getNextData() {
			this.pagination.offset = this.pagination.offset + this.pagination.limit;
			this[this.paginationMethod]();
			this.nextData = true;
		}

	}, 'Controller');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox, $, undefined) {
	"use strict";

	var _ = {
		getContentInfo: function getContentInfo() {
			var parent = this.getParent(),
			    data = { subject: 'content' };

			switch (parent.getClass()) {
				case 'FullscreenView':
					data = {
						targetId: parent.currentPhoto.id,
						subject: 'resource'
					};
					break;
				case 'SitePage_Post':
					data = {
						targetId: parent.rwom1('.PostViewer')._pid,
						subject: 'blog'
					};
					break;
				case 'MC_Photoset_Gallery':
					data.targetId = parent.pid;
					break;
				case 'SitePage_Scene':
					data.targetId = parent.rwom1('.Content_SceneViewer').contentId;
					break;
				case 'Store_Content':
					data = {
						targetId: parent.productId,
						subject: 'store'
					};
					break;
			}

			return data;
		}
	};

	fox.registerWidget('Content_Tipme', {
		configure: function configure() {
			this.registerOptions('', {
				autoRender: false,
				'embed.container': '#content-tipme',
				template: 'content_tipme',
				handleWom: {
					tipsLoaded: {
						event: 'loaded',
						widget: '#tipsDl',
						callback: 'tipsLoaded'
					}
				},
				handleDom: {
					onInput: {
						event: 'input',
						target: '#tip-amount',
						callback: 'onInput'
					},
					tipModel: {
						event: 'click',
						target: '#tip-model',
						callback: 'tipModel'
					}
				},
				widgets: {
					tipItems: {
						widget: 'Widget',
						active: false,
						autoRender: false
					},
					form: {
						container: '@parent #confirmPopup #tipsPopupContainer #content'
					},
					'confirmPopup.widgets.tipsPopupContainer.widgets.content.template': 'content_tipme_confirm'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			this.amount = this.recomendedCustomPriceAmount;

			this.handleEvent(this.getParent(), 'addedToDom', function (params, scope) {
				$('<div></div>').attr('id', 'biller-form-container').hide().appendTo(scope.element[0]);
			});

			this.callParent('init', arguments);
		},

		running: function running() {
			this.loadTips();
			this._readyToRender = false;
			this.rwom1('#confirmPopup #tipsPopupContainer #content')._readyToRender = false;

			this.callParent('running', arguments);
		},

		renderInput: function renderInput() {
			this._readyToRender = true;

			this.render();

			this.waitEvent(this, 'addedToDom', function (p, _this) {
				_this._readyToRender = false;
			});

			return this;
		},

		loadTips: function loadTips() {
			this.rwom1('#tipsDl').load();

			return this;
		},

		tipsLoaded: function tipsLoaded(p, dl) {
			this.tipOption = dl.getCollection().filter(function (v) {
				return Number(v.type) === 1;
			}).pop();

			if (this.tipOption) {
				this.renderInput();
			}
		},

		activate: function activate() {
			if (this.tipOption) {
				this.renderInput();
			}

			this.callParent('activate', arguments);
		},

		addedToDom: function addedToDom() {
			var $i = $(this.dom1('#tip-amount'));

			$i.parent().addClass('in-dom');
			$i.attr('placeholder', ['$', this.amount].join(''));
		},

		onInput: function onInput(el) {
			el.value = el.value.replace(/[\$\.,]+/, '');

			var v = el.value;

			if (this.validateAmount(v)) {
				this.amount = Number(v);
			}
		},

		tipModel: function tipModel() {
			var f = this.rwom1('#form'),
			    confirm = this.rwom1('#confirmPopup');

			f.setValue('amount', this.amount);

			this.renderConfirmContent({ amount: this.amount });

			confirm.show();
		},

		renderConfirmContent: function renderConfirmContent(templateOptions) {
			var w = this.rwom1('#confirmPopup #tipsPopupContainer #content');

			w._readyToRender = true;
			w.setTemplateOptions(templateOptions);
			w.render();

			this.waitEvent(w, 'addedToDom', function (p, _w) {
				_w._readyToRender = false;
			});
		},

		validateAmount: function validateAmount(value) {
			var $el = $(this.dom1('#tip-amount')).parent(),
			    $btn = $(this.dom1('#tip-model'));

			if (Number(value) > this.minCustomPriceAmount - 1 && Number(value) < 99999) {
				var errorEl = $el.hasClass('error') && $el.removeClass('error');
				$btn.prop('disabled', false);

				return true;
			} else if (!value) {
				this.amount = this.recomendedCustomPriceAmount;
				var errorElt = $el.hasClass('error') && $el.removeClass('error');
				$btn.prop('disabled', false);

				return false;
			} else {
				$el.addClass('error');
				$btn.prop('disabled', true);

				return false;
			}
		},
		onSubmit: function onSubmit() {},
		_validateCustomValue: function _validateCustomValue() {
			return true;
		},
		submit: function submit() {
			var resolver = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

			var form = this.rwom1('#form');

			this.validateData();

			if (!this._isValid) return fox.isFunction(resolver) && resolver(false);

			this.userData = form.collectData();
			this.userData.amount = this.amount;
			this.userData.tips = this.tipOption.id;

			fox.merge(this.userData, _.getContentInfo.call(this));

			return this.callParent('submit', arguments).then(function () {
				form.resetForm();

				if (fox.isFunction(resolver)) resolver(true);
			}).catch(function () {
				if (fox.isFunction(resolver)) return resolver(false);
			});
		}
	}, 'Tips_Form');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Report

(function (fox, $) {
	'use strict';

var subjectItem = {
	photosets: "photoset",
	gallery: "photoset",
	scene: "video",
	product: "store",
	liveshow: "liveshow",
	post: "blog"
}

	fox.registerWidget('Content_Report', {
		configure: function () {
			this.registerOptions('', {
				template: 'a.content-report-link{Report content}',
				'embed.container': '.content-report',
				autoRender: true,
				additionalPopupClass: 'black-diamond-skin',
				widgets: {
					api: {
						widget: 'Api',
						method: 'report.send',
						handleWom: {
							apiSuccessHandler: {
								widget: '@this',
								event: 'success',
								callback: '@parent:apiSuccessHandler'
							},
							apiFailureHandler: {
								widget: '@this',
								event: ['error', 'failure'],
								callback: '@parent:apiFailureHandler'
							}
						}
					},
					reportPopup:{
						widget: 'Dialog',
						template: '',
						useUiPosition: true,
						dialog: {
							autoOpen: false,
							title: 'Report Content',
							closeText: '',
							width: '535px',
							buttons: [
								{text: 'Cancel', class: 'cancel-report'},
								{text: 'Submit', class: 'submit-report'}
							]
						},
						widgets: {
							reportForm: {
								widget: 'Widget',
								template: 'report_content_form',
								templateOptions: {prefix: this.getOption('prefixPopup')},
								autoRender: true,
								'widgets.form': {
									widget: 'Form',
									loadValuesOnRun: false,
									formElements: {
										type: {element: '[name="type"]'},
										comment: {element: '[name="comment"]'}
									}
								}
							}
						},
						'handleWom.showButtons': {
							widget: '@this',
							event: 'show',
							callback: '@parent:_showHideButtons'
						}
					}
				},
				handleDom: {
					clickOnReportLink: {
						event: 'click',
						target: '.content-report-link',
						callback: 'showPopup'
					},
					submitReportForm: {
						targetWidget: '#reportPopup',
						event: 'click',
						target: '.submit-report',
						callback: 'submitForm'
					},
					cancelReportForm: {
						targetWidget: '#reportPopup',
						event: 'click',
						target: '.cancel-report',
						callback: 'cancelReportForm'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#reportPopup', {
				dialog: {
					dialogClass: 'dlg-amc dark-overlay ' + this.getOption('additionalPopupClass')
				}
			});
			
			if (!fox.site.member) {
				this.registerOptions('~#form', {
					formElements: {
						email: {element: '[name="email"]'},
						captcha: {element: '[name="captcha"]'}
					}
				});

				this.registerOptions('~#reportForm', {
					'widgets.captcha': {
						widget: 'Captcha',
						'embed.container': '#captcha'
					},
					'handleDom.reloadCaptcha': {
						event: 'click',
						target: '.reload-captcha',
						callback: '#captcha:loadCaptcha'
					},
				});

				if (this.getOption('captchaAlias')) {
					this.registerOptions('~#reportForm', {
						'widgets.captcha.captchaAlias': this.getOption('captchaAlias')
					});
				}
			}

			this.callParent('init', arguments);
		},

		running: function () {
			this._form = this.rwom1('~#form');
			this.rwom1('~#reportForm').setTemplateOptions({prefix:this.getOption('prefixPopup')}).render();
			this.callParent('running', arguments);
		},

		cancelReportForm: function () {
			this._form.resetForm();
			this.rwom1('#reportPopup').hide();
		},

		showPopup: function (el) {
			var popup = this.rwom1('#reportPopup');
			if(el.getAttribute('data-subject')){
				var conversId = fox.wom.selectFirst('~.ConversationViewer').dl._collection[0].conversationId;
				popup.wom1('#reportForm').setTemplateOptions({reportId:conversId, subj:'message'}).render();
			}
			popup.show();
		},

		submitForm: function (el) {
			var formData = this._form.collectData(),
			subject,
			contentId;
			if(el.getAttribute('data-id')){
				subject='messages';
				contentId = el.getAttribute('data-id');
			}else{
				subject = subjectItem[fox.Navigator.get(0)];
				contentId = fox.Navigator.get(1);
			}
		
			formData.subject = subject;
			formData.contentId = contentId;
			if (!fox.site.member) {
				formData.captchaId =  this.rwom1('~.Captcha#captcha').captchaId;
			}

			this._submitForm(formData);
		},

		_submitForm: function (formData) {
			this.rwom1('#api').send(formData, false);
		},

		apiSuccessHandler: function () {
			this._showHideButtons(true);
		},

		apiFailureHandler: function (data) {
			$('#error-container')
				.text(data.answer.reason)
				.fadeIn(400, function () {
					setTimeout(fox.bind(function () {
						$(this).fadeOut();
					}, this), 5000);
				});
		},

		setContentId: function (data) {
			this._contentId = data;
		},

		_showHideButtons: function (action) {
			this.hookWrapper('showHideButtons', action);
		},

		showHideButtons: function (action) {
			var buttons = $(this.rwom1('#reportPopup').element[0])
				.find('.ui-dialog-buttonpane, .popup-footer, .popup-footer-wrapper');

			$(this.rwom1('~#reportForm').element[0])
				.find('form')[action === true ? 'hide' : 'show']()
				.next()[action === true ? 'show' : 'hide']();
			
			var res = action === true ?
				buttons.hide() : 
				buttons.show();
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';

	var _ = {
		loadAttachData: function () {
			this.loadSmallThumbs();

			if (!this.paid) {
				this.loadMainContent();
			}
		},

		trackAttach: function () {
			var api = this.rwom1('#trackDataApi');

			api.psend({id: this.contentId})
				.then(_.trackAttachResponse.bind(this))
				.catch(_.trackAttachResponse.bind(this));
		},

		trackAttachResponse: function (res) {
			res = res.params;

			if (res.answer.status !== true) {
				return false;
			}

			if (res.answer.response.alias === 'ready') {
				this.dispatchEvent('attachProcessingSuccess');
					
				$(this.dom1('.attach-item')).removeClass('processing');
				this.processingStatus = false;
				
				_.loadAttachData.call(this);
			} else if (['error', 'missing_source'].indexOf(res.answer.response.alias) === -1) {
				setTimeout(fox.bind(_.trackAttach, this), 10000);
			}
		}
	};
	
	fox.registerWidget('Conversation_AttachItem', {

		configure: function () {
			this.mainData = null;

			this.registerOptions('', {
				autoRender: true,
				template: 'conversation_attach_row',
				handleDom: {
					onAttachClick: {
						event: 'click',
						target: '.attach-preview',
						eventChecker: fox.bind(function () {return !this.paid;}, this),
						callback: 'onAttachClick'
					},
					unlockAttach: {
						event: 'click',
						target: '.unlock-btn',
						callback: 'unlockAttachHandler'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.messageId = this.getOption('messageId');
			this.contentId = this.getOption('contentId');
			this.price = Number(this.getOption('price'));
			this.paid = (this.getOption('paid') === 0 && this.price > 0) ? true : false; //значение свойства поменялось бэкэндом после имплементации фронтэнда, поэтому решил малой кровью.
			this.type = this.getOption('type');
			this.attachTitle = this.getOption('attachTitle') || 'Untitled';
			this.attachId = this.getOption('attachId');

			this.getApi('smallThumb', {method: 'Client_Upload.get'});

			if (this.type === 1) {
				this.getApi('mainDataApi', {method: 'Client_Upload.getMap'});
			} else if (this.type === 2) {
				this.getApi('mainDataApi', {method: 'Client_Upload.get'});
			}

			if (this.getOption('processing') === true) {
				this.processingStatus = true;

				this.getApi('trackDataApi', {method: 'Client_Upload.track'});
			}
		
			this.callParent('init', arguments);
		},

		running: function () {
			if (this.processingStatus === true) {
				_.trackAttach.call(this);
			} else {
				_.loadAttachData.call(this);
			}

			this.callParent('running', arguments);
		},

		rendering: function () {
			this._onStartRendering();
			this.callParent('rendering', arguments);
			this._onStopRendering();
		},

		_onStartRendering: function () {
			this.setTemplateOptions({
				cid: this.contentId,
				mid: this.messageId,
				paid: this.paid,
				price: this.price,
				type: this.type,
				attachTitle: this.attachTitle
			});

			if (this.processingStatus === true) {
				this.setTemplateOptions('processing', 1);
			}
		},

		_onStopRendering: function () {
			if (this.smallThumb) {
				this.setAttachSmallThumb(this.smallThumb);
			} else if (this.contentError === true) {
				this.showContentError();
			}
		},

		loadSmallThumbs: function () {
			var api = this.rwom1('#smallThumb');
			var _this = this;

			function cb (resp) {
				var res = resp.params;
				var _api = resp.performer;

				if (fox.objectGet(res, 'answer.status') === true && !fox.isEmpty(res.answer.response)) {
					_this.smallThumb = fox.toArray(res.answer.response).pop();

					_this.contentError = false;

					_this.setAttachSmallThumb(_this.smallThumb);
				} else {
					_this.contentError = true;

					_this.showContentError();
				}
			}

			api.psend({
				id: this.contentId,
				alias: !this.paid ? 'w600i' : 'w29i',
				random: Math.random().toString(),
				messageId: this.messageId
			}).then(cb).catch(cb);

			return this;
		},

		loadMainContent: function () {
			var transport = this.rwom1('#mainDataApi');
			var _this = this;

			function cb1 (resp) {
				var res = resp.params;
				var _api = resp.performer;

				if (res.answer.status === true && !fox.isEmpty(res.answer.response)) {
					_this.mainData = fox.toArray(res.answer.response).pop();
				}
			}

			function cb2 (res) {
				res = res.params;

				if (res.answer && res.answer.response) {
					_this.mainData = res.answer.response;
				}
			}

			switch (this.type) {
				case 2:
					transport.psend({
						id: this.contentId,
						alias: 'h1360i',
						messageId: this.messageId
					}).then(cb1).catch(cb1);

					break;
				case 1:
					transport.psend({
						clientUploadId: this.contentId,
						mode: 'format',
						messageId: this.messageId
					}, true).then(cb2).catch(cb2);

					break;
			}

			return this;
		},

		setAttachSmallThumb: function (thumbUrl) {
			var $tNode = $(this.dom1('.attach-preview'));

			$tNode.css('backgroundImage', ['url(', thumbUrl, ')'].join('')).addClass('success');

			this.hideAttachPreload();
		},

		onAttachClick: function (el) {
			this.dispatchEvent('showAttachment', this.getPublicData());
		},

		getPublicData: function () {
			var publicData = {};
			
			if (!this.paid && this.mainData) {
				publicData = {
					id: this.contentId,
					type: this.type,
					messageId: this.messageId,
					attachTitle: this.attachTitle,
					resId: this.getOption('resId'),
					paid: this.getOption('price'),
				};

				publicData[this.type === 1 ? 'videoData' : 'bigThumb'] = this.mainData;
				if (this.type === 1) {
					publicData.posterUrl = this.smallThumb;
				}
			}

			return publicData;
		},

		unlockAttachHandler: function (el) {
			if (this.contentError === true) {
				console.warn('Content not found!');

				return;
			}

			if (this.contentError === undefined) {
				console.warn('Please wait for the content to load');

				return;
			}

			this.unlockAttach({id: this.contentId, messageId: this.messageId});
		},

		unlockAttach: function (params) {
			this.dispatchEvent('unlockThisContent');
		},

		unlockSuccessfully: function (p, performer) {
			var $atn = $(this.dom1('.attach-item'));

			if (p.id === this.attachId) {
				if ($atn.length) {
					$atn.removeClass('locked');
				}

				this.paid = false;
				this.loadSmallThumbs().loadMainContent();
			}
		},

		hideAttachPreload: function () {
			var $ap = $(this.dom1('.preload'));

			if ($ap.length) {
				setTimeout(function () {
					$ap.hide();
				}, 2000);
			}
		},

		showContentError: function () {
			var $ate = $(this.dom1('.attach-error'));

			if ($ate.length) {
				$ate.addClass('content-error');

				this.hideAttachPreload();
			}
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	"use strict";

	fox.registerWidget('Conversation_AttachUnlocker', {
		_validator: null,

		configure: function () {
			this.errors = {
				'01': 'Required parameters missing',
				'2004': 'Entry params content is empty',
				'2005': 'Entry params attach is empty'
			};

			this.payData = {};

			this.registerOptions('', {
				dataValidators: {
					price: [
						{validator: 'mandatory'},
						{validator: 'range', options: {min: 1}},
						{validator: 'regexp', options: {type: 'decimal'}}
					],
					messageAttachmentId: [
						{validator: 'mandatory'},
						{validator: 'range', options: {min: 1}},
						{validator: 'regexp', options: {type: 'int'}}
					],
					title: [
						{validator: 'mandatory'}
					]
				},
				widgets: {
					prepareTransactionApi: {
						widget: 'Api',
						method: 'Client_Upload.payPrivate'
					},
					popup: {
						widget: 'Dialog',
						useUiPosition: true,
						preventHideOnShadowClick: true,
						template: '',
						'dialog.autoOpen': false,
						'dialog.closeText': '',
						'dialog.width': '100%',
						widgets: {
							confirm: {
								widget: 'Widget',
								template: 'transaction_confirmation'
							},
							success: {
								widget: 'Widget',
								template: 'transaction_success'
							},
							error: {
								widget: 'Widget',
								template: 'transaction_error'
							}
						}
					},
					billerForm: {
						widget: 'Widget',
						autoRender: false,
						embed: {
							container: 'body',
							widget: '@root',
							location: 'firstChild'
						},
						template: 'transaction_biller_form'
					}
				},
				handleWom: {
					successTransacrionsApi: {
						event: 'success',
						widget: '#prepareTransactionApi',
						callback: 'successPrepareTransaction'
					},
					errorTransacrionsApi: {
						event: ['error', 'failure'],
						widget: '#prepareTransactionApi',
						callback: function (res, p, evalias) {
							res = res.answer;

							this._cleanPayObjectData()._throwError(res.code, res.reason);
						}
					}
				},
				handleDom: {
					confirmUnlock: {
						event: 'click',
						target: '#confirm-unlock',
						targetWidget: '#popup #confirm',
						callback: function (el, alias, scope) {
							var
								api = this.rwom1('#prepareTransactionApi');

							$(el).prop('disabled', true);
							
							this._prepareTransaction();
						}
					},
					closeFromError: {
						event: 'click',
						target: '#close-tr-popup',
						targetWidget: '#popup #error',
						callback: '#popup:hide'
					},
					closeFromSuccess: {
						event: 'click',
						target: '#close-tr-popup',
						targetWidget: '#popup #success',
						callback: '#popup:hide'
					},
					commonClose: {
						event: 'click',
						target: '.close',
						targetWidget: '#popup .Widget',
						callback: '#popup:hide'	
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.transactionInProgress = false;

			this.registerOptions('#popup .Widget', {
				autoRender: false,
				active: false,
				group: 'popupStates',
				'embed.container': '.ui-dialog-content'
			});

			this._cleanPayObjectData();
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.setupValidators();
			this.rwom1('#billerForm')._readyToRender = false;
		
			this.callParent('running', arguments);
		},

		setupValidators: function () {
			this._validator = new fox.Validator();
			this._validator.setRules(this.getOption('dataValidators'));
		},

		pay: function (params) {
			if (this.transactionInProgress === false) {
				if (this._setPayObjectData(params)) {
					this._showConfirm();
				}
			}
		},

		_prepareTransaction: function () {
			var
				api = this.rwom1('#prepareTransactionApi'),
				linkerParam = this.rwom1('@root #googleAnalytics').getLinkerParam()
			;

			if (linkerParam) {
				this.payData['transitParams[_ga]'] = linkerParam;
			}

			this.transactionInProgress = true;
			api.send(this.payData);
		},

		_setPayObjectData: function (data) {
			var
				dataValidators = this.getOption('dataValidators'),
				infoStatus = true;

			fox.each(dataValidators, function(opt, field) {
				if (fox.isSet(data[field]) && this._validator.validate(field, data[field])) {
					this.payData[field] = data[field];
				} else {
					this._throwError('01');
					infoStatus = false;

					throw fox.break;
				}
			}, this);

			// fox.each(data, function (val, key) {
			// 	if (fox.isSet(dataValidators[key]) && this._validator.validate(key, val)) {
			// 		this.payData[key] = val;
			// 	} else {
			// 		this._throwError('01');
			// 		infoStatus = false;
			//
			// 		throw fox.break;
			// 	}
			// }, this);

			return infoStatus;
		},

		_throwError: function (errorCode, msg) {
			var
				p = this.rwom1('#popup'),
				error = p.rwom1('#error');

			p.switchEmbeddedWidget(error.alias);
			error.setTemplateOptions('reason', this.errors[errorCode] || msg).render();
			p.setTitle('Oops, something went wrong').show();
		},

		_cleanPayObjectData: function () {
			this.payData = {};

			return this;
		},

		_showConfirm: function () {
			var
				p = this.rwom1('#popup'),
				confirm = p.rwom1('#confirm');

			p.switchEmbeddedWidget(confirm.alias);
			confirm.setTemplateOptions('price', this.payData.price).render();
			p.setTitle('Attention').show();

			return this;
		},

		_showSuccess: function () {
			var
				p = this.rwom1('#popup'),
				success = p.rwom1('#success');

			p.switchEmbeddedWidget(success.alias);
			success.setTemplateOptions('name', fox.site.member.getObjectValue('login'));
			success.render();
			p.setTitle(['Thank you', fox.site.member.getObjectValue('login')].join(' ')).show();

			return this;
		},

		_transactionSuccessfully: function () {
			var data = {
				id: this.payData.messageAttachmentId,
				price: this.payData.price,
				title: this.payData.title
			};

			this.dispatchEvent('transactionSuccessfully', data);
			fox.wom.selectFirst('@root').dispatchEvent('unlockTransactionSuccessfully', data);

			this._cleanPayObjectData();
		},

		sendBillerForm: function (formData) {
			var
				f = this.rwom1('#billerForm'),
				fElement;

			f._readyToRender = true;
			f.setTemplateOptions(formData).render();

			this.waitEvent(f, 'addedToDom', function () {
				f._readyToRender = false;
				fElement = f.element[0];

				if (fElement.tagName && fElement.tagName.toLowerCase() === 'form') {
					fElement.submit();
				}
			});
		},

		successPrepareTransaction: function (res) {
			this.transactionInProgress = false;
			res = res.answer.response;

			if (res === true) {
				this._transactionSuccessfully();
				this._showSuccess();

			} else if (res.ubs_transaction_id) {
				this.sendBillerForm(res);
			}
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';

	var _ = {
		MARKREADDELAY: 1000,
		getMyNewMessage: function (params) {
			var now = new Date();

			var message = fox.merge({
				_ownerUser: {
					date: fox.utils.dateFormat('%B %e', now),
					datetime: fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', now),
					name: fox.site.member.getObjectValue('login'),
					time: fox.utils.dateFormat('%l:%M%P', now)
				},
				content: '',
				id: fox.uniqid(),
				my: 1,
				timestamp: fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', now),
				transferState: 1
			}, params);

			return message;
		},

		fillProcessingAttachments: function (messageId, uploadId) {
			if (messageId !== undefined && uploadId !== undefined) {
				if (!this.processingAttachments[messageId]) {
					this.processingAttachments[messageId] = [];
				}

				if (this.processingAttachments[messageId].indexOf(uploadId) === -1) {
					this.processingAttachments[messageId].push(uploadId);
				}
			}
		},

		prepareCollection: function (collection, fromModel, getFDay) {
			var
				day,
				_this = this.getClass() === 'ConversationViewer' ? this : this.getParent(),
				aa = _this.allAttachments,
				splitToken = _this.splitToken
			;

			if (getFDay === true) {
				day = fox.utils.dateFormat('%e', collection[0].timestamp);
			}

			if (fromModel === true) {
				fox.each(collection, function (v) {
					var
						dl = fox.createDl(),
						buff = [],
						obj
					;

					if (v.attachments !== undefined) {
						dl.setCollection(v.attachments.collection);
					}

					if (dl.getCount() > 0) {
						while ((obj = dl.iterateObject())) {
							var
								uploadId = obj.get('clientUploadUserAccessId.uploadId.id'),
								messageId = obj.get('messageId'),
								options
							;

							options = {
								messageId: messageId,
								contentId: uploadId,
								type: obj.get('clientUploadUserAccessId.uploadId.type'),
								price: obj.get('clientUploadUserAccessId.price'),
								paid: obj.get('clientUploadUserAccessId.paid'),
								attachTitle: obj.get('clientUploadUserAccessId.uploadId.title'),
								attachId: obj.get('id'),
								resId: obj.get('clientUploadUserAccessId.uploadId.resource.resourceId')
							};

							if (obj.get('clientUploadUserAccessId.uploadId.status') !== 3) {
								options.processing = true;

								_.fillProcessingAttachments.call(_this, messageId, uploadId);
							}

							aa.push(options);

							buff.push({id: uploadId, type: obj.get('clientUploadUserAccessId.uploadId.type')});
						}
					}

					if ((v.content && v.content.split(splitToken).length === 2) || v.type === 1) {
						v.hidden = 1;
					}

					if (dl.getCount() !== 0 && dl.getCount() !== buff.length) {
						v.hidden = 1;
					}
				}, this);
			}

			fox.each(collection, function (v, indx) {
				var curDay;
				var next = collection[indx + 1];

				if (v.serviceTypeAlias === 'gift') {
					var parts = v.content.split(':');

					v.gift = parts[0];
					v.price = parts[1];
				}

				if (v.timestamp === undefined) {
					v.timestamp = new Date().getTime();
				}

				curDay = fox.utils.dateFormat('%e', v.timestamp);

				if (day === undefined || day !== curDay) {
					v.diffDay = 1;
					day = curDay;
				}

				if (next !== undefined) {
					if (next.timestamp === undefined) {
						next.timestamp = new Date().getTime();
					}

					if (v.my === next.my &&
						fox.utils.dateFormat('%e', v.timestamp) === fox.utils.dateFormat('%e', next.timestamp)) {
						v.hideArrow = 1;
					}
				}
			});

			return collection;
		},

		attachProcessingSuccess: function (params, attach) {
			var indx;
			var showHidenMessage;

			function showHidenAttachments (messageId) {
				var
					list = this.rwom1('#list'),
					$attachmentsNode;

				$attachmentsNode = $(list.dom1(['#message-', messageId, ' .attachment-list'].join('')));

				if ($attachmentsNode.length) {
					this.scrollDown($attachmentsNode.parents('.message-row'), {});
				}
			}

			if (this.processingAttachments[attach.messageId]) {
				if ((indx = this.processingAttachments[attach.messageId].indexOf(attach.contentId)) !== -1) {
					this.processingAttachments[attach.messageId].splice(indx, 1);
				}

				if (this.processingAttachments[attach.messageId].length === 0) {
					this.processingAttachments[attach.messageId] = null;
					delete this.processingAttachments[attach.messageId];

					showHidenAttachments.call(this, attach.messageId);
				}
			}
		},

		cacheMessages: function () {
			var preloader = this.wom1('~.Preloader');

			if (preloader && preloader.skipDrawing !== false ) {
				preloader.skipDrawing = true;
			}

			this.waitEvent(this.dl, 'loaded', fox.bind(function (params, dl) {
				var c = dl.getCollection();

				if (c.length) {
					this.buffData.push(c);
				}
			}, this), {prefix: 'chachedData'});

			this.dl.setOffset(this.dl.getOffset() + this.dl.getLimit()).load();
		},

		resetScrollState: function () {
			var l = this.rwom1('#list');

			this.preventScrollDown = false;
			l.prevPrcV = 0;
			l.scrollTo = false;
		}
	};

	fox.registerWidget('ConversationViewer', {

		configure: function () {
			this.seenMessage = false;
			this.buffData = [];
			this.allAttachments = [];
			this.processingAttachments = {};
			this.splitToken = '%mediapaysuccess%';
			this._queue = [];

			this.registerOptions('', {
				autoRender: true,
				externalLoad: true,
				markAsReadOnAir: true,
				markAsReadOnWindowFocus: true,
				dontReuseSn: true,
				scrollbar:{
					theme: 'minimal-dark',
					position: 'outside'
				},
				'embed.container': '#messages-container',
				template: 'sitepage_conversation_messages_container',
				'widgets.dl': {
					widget: 'Datalayer',
					method: 'conversation.get',
					limit: 15,
					'metaFields.ownerUser': 1,
					'sorting.idSort': ['id', 'desc'],
					fields: ['_ownerUser.datetime', 'type'],
					'hooks.onPrepareResponse': this.onDlPrepareResponse
				},
				list: {
					widget: 'AdvancedList',
					notOverrideListBehavior: true,
					dontReuseSn: true,
					'tpl.row': 'sitepage_conversation_messages_row',
					'embed.container': '#messages-list',
					'hooks.onStartRendering': fox.bind(function () {
						if (this.seenMessage !== false) {
							var mes = this.rwom1('#list').filter('id', Number(this.seenMessage));

							if (mes.length) {
								mes[0].value.transferState = 2;

								this.seenMessage = false;
							}
						}
					}, this),
					'hooks.onStopRendering': fox.bind(function () {
						fox.each(this.allAttachments, this.embedAttachment, this);
					}, this),
					'hooks.onAddedToDom': function () {
						var parent = this.getParent();
						if (this.getParent().dontReloadAllList === true) {
							this.getParent().dontReloadAllList = false;

							return false;
						}

						if (this.getParent().getOption('markAsReadOnAir')) {
							this.getParent().delayedAsReadMarking(_.MARKREADDELAY);
						}

						var
							_this = this,
							$el = $(this.element[0]).parents('#messages-list-scroll-wrapper')
						;

						if (this.getParent().preventScrollDown !== true) {
							var scrollbarOptions = this.getParent().getOption('scrollbar');

							$el.mCustomScrollbar({
								theme: scrollbarOptions.theme,
								scrollbarPosition: scrollbarOptions.position,
								autoExpandScrollbar: true,
								callbacks: {
									onTotalScrollBack: function () {
										var
											drawCache,
											dl = _this.getParent().dl,
											bf = _this.getParent().buffData
										;

										drawCache = function () {
											var buffAmount = bf.length && bf[0].length;

											if (buffAmount) {
												var lastNode = document.getElementById('message-' + this.dataModel[0].value.id);

												$el.mCustomScrollbar('disable');

												this.scrollTo = function () {
													return lastNode ? lastNode.offsetTop + 100 : 300;
												};

												this.getParent().preventScrollDown = true;

												this.prependItem(bf.pop());

												if (buffAmount === dl._limit) {
													_.cacheMessages.call(this.getParent());
												}
											}
										};

										if (dl._loadStatus === 'loading') {
											_this.waitEvent(dl, 'loaded', fox.bind(function () {
												setTimeout(fox.bind(drawCache, this), 50);
											}, _this), {prefix: 'forDrawCache'});
										} else {
											drawCache.call(_this);
										}
									}
								}
							});

							this.getParent().scrollDown();
						}

						if (this.scrollTo) {
							this.getParent().scrollDown(this.scrollTo, {scrollInertia: 200});

							_.resetScrollState.call(this.getParent());
						}
					}
				},
				'widgets.sendMessageApi': {
					widget: 'Api',
					method: 'conversation.send',
					sendTimezone: true,
					httpMethod: 'post'
				},
				'widgets.previewContent': {
					widget: 'PreviewUploadedContent'
				},
				'widgets.attachUnlocker': {
					widget: 'Conversation_AttachUnlocker'
				},
				handleWom: {
					messageInbox: {
						event: 'inboxSocketEventChat',
						widget: '@root #socket',
						callback: 'inboxSocketCallback',
						'params.alwaysActive': true
					},
					messageReadStatus: {
						event: 'inboxSocketEventMessageNotification',
						widget: '@root .Socket',
						'params.alwaysActive': true,
						callback: 'showMessageReadStatus'
					},
					showAttachment: {
						event: 'showAttachment',
						widget: '#list .Conversation_AttachItem',
						callback: function (p) {
							var
								pc = this.rwom1('#previewContent'),
								messageAttachments = this.rwom1('#list').getWidgetsByGroup(p.messageId),
								collection = [];

							if (fox.count(messageAttachments) > 1) {
								fox.each(messageAttachments, function (w) {
									var
										pd = w.getPublicData();

									if (!fox.isEmpty(pd)) {
										collection.push(pd);
									}
								});
							}

							pc.show({
								collection: collection,
								data: p
							});
						}
					},
					unlockAttachment: {
						event: 'unlockThisContent',
						widget: '#list .Conversation_AttachItem',
						callback: 'unlockAttachment'
					},
					attachProcessingSuccess: {
						event: 'attachProcessingSuccess',
						widget: '#list .Conversation_AttachItem',
						callback: fox.bind(_.attachProcessingSuccess, this)
					},
					globalUnlockEvent: {
						widget: '@root',
						event: 'unlockTransactionSuccessfully',
						callback: '_handleGlobalUnlockEvent',
						'params.alwaysActive': true
					}
				},
				handleDom: {
					openGiftPopup: {
						event: 'click',
						target: '#open-gift-popup',
						callback: function () {
							var popup = this.wom1('@root #conversationGiftsPopup');

							if (popup) {
								popup.show();
							}
						}
					},
					sendMessage: {
						event: 'click',
						target: '#send-message',
						callback: function () {
							this.sendMessageHandler();
						}.bind(this)
					},
					sendByEnter: {
						event: 'keydown',
						target: '#textarea',
						callback: function (el, alias, scope, e) {
							if (e.ctrlKey === true && e.keyCode === 13) {
								setTimeout(function () {
									this.sendMessageHandler();
								}.bind(this), 10);
							}

							if ([13, 46, 8].indexOf(e.keyCode) !== -1) {
								setTimeout(function () {
									el.style.height = [15 * el.value.split('\n').length, 'px'].join('');
								}, 10);
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			var pm = this.wom1('@root .PermissionManager');
			if ((pm && pm.hasAccess('guest')) || fox.site.member) {
				this.loadMessages();
			}

			if (this.getOption('markAsReadOnWindowFocus')) {
				this._addWindowFocusEvent();
			}
		
			this.callParent('running', arguments);
		},

		loadMessages: function () {
			this.waitEvent(this.dl, 'loaded', fox.bind(function (p, dl) {
				this.rwom1('#list').resetCollection(dl.getCollection());

				if (dl._collection.length === dl._limit) {
					setTimeout(fox.bind(_.cacheMessages, this), 10);
				}
			}, this));

			this.dl.load();

			return this;
		},

		activate: function () {
			this._addWindowFocusEvent();

			this.callParent('activate', arguments);
		},

		scrollDown: function (position, options) {
			var
				$listEl = $(this.rwom1('#list').element[0]).parents('#messages-list-scroll-wrapper');

			setTimeout(function () {
				try {
					$listEl.mCustomScrollbar('scrollTo', position || 'bottom', options || {
						scrollInertia: 0
					});
				} catch (e) {}

				if (position) {
					$listEl.mCustomScrollbar('update');

					return position;
				}
			}, 10);
		},

		sendMessageHandler: function (args) {
			var
				api = this.rwom1('#sendMessageApi'),
				$txtArea = $(this.dom1('#textarea')),
				list = this.rwom1('#list'),
				messageBody = $txtArea.val(),
				params = fox.merge({}, args || {}),
				lastId
			;

			function apiResponse (resp) {
				var _api = resp.performer;
				var res = resp.params;
				var lastMessageData = list.getDataById(lastId);

				lastId = null;

				if (res.answer.status === true && !fox.isEmpty(res.answer.response)) {
					lastMessageData.data.id = res.answer.response.messageId;
					lastMessageData.data.transferState = 0;

					this.dontReloadAllList = true;

					if (list.isEmbedded()) {
						list.updateItem(lastMessageData.data, lastMessageData.indx);
					} else {
						this.wait(list, 'addedToDom', {prefix: 'waitForChangeTransferState'}).then(function () {
							list.updateItem(lastMessageData.data, lastMessageData.indx);
						});
					}
				}

				_api.transferState = false;
			}

			if (messageBody.length || params.content) {
				if (!params.content) {
					params.content = this.changeInalidValue(messageBody);
				}

				if (!api.transferState) {
					lastId = this.addMessage(_.getMyNewMessage.call(this, params));
					params.content = this.window.encodeURIComponent(params.content);

					api.transferState = true;
					api.psend(params)
						.then(apiResponse.bind(this))
						.catch(apiResponse.bind(this));
					
					$txtArea.val('');
				}
			}
		},
		changeInalidValue: function (params) {
			var regExps = /<\s*[^>]*>/g;
			var entities = {'<': '', '>': ''};
			if(regExps.test(params)){
				params = params.replace(/[<>]/g, function (s) {return entities[s];});
			}
			return 	params;
		},
		_sendPaySuccessMessage: function (contentData) {
			//If ccbill postback recieved on oneclick transaction!;
			return false;
			//---------------------------------------------------
		},

		onDlPrepareResponse: function (response) {
			response.collection = _.prepareCollection.call(this, response.collection.reverse(), true);
			this._apiResponse = response;
		},

		getMessageById: function (id) {
			return this.dl._collection.filter(function (v) {
				return Number(v.id) === Number(id);
			}).pop();
		},

		embedAttachment: function (params) {
			var
				alias = [params.contentId, params.messageId].join('_'),
				l = this.rwom1('#list'),
				attach = l.getEmbeddedWidget(alias);

			if (!attach) {
				attach = l.embedWidget(alias, 'Conversation_AttachItem', {
					'embed.container': ['#at', alias].join('-'),
					price: params.price,
					type: params.type,
					contentId: params.contentId,
					messageId: params.messageId,
					group: params.messageId,
					paid: params.paid,
					attachTitle: params.attachTitle,
					attachId: params.attachId,
					processing: params.processing || false,
					resId: params.resId
				});

				attach.run();
			}
		},

		unlockAttachment: function (p, attach) {
			var attachUnlocker = this.rwom1('#attachUnlocker');

			attachUnlocker.pay({
				messageAttachmentId: attach.attachId,
				price: attach.price,
				title: attach.attachTitle
			});
		},

		inboxSocketCallback: function (response) {
			var dl = fox.createDl();
			var respClone = fox.clone(response, true);

			dl.setCollection(respClone.answer.attachments.collection);
			respClone.answer.attachments = dl.getObjectValue('attachments');

			this.addMessage(respClone.answer, true);
		},

		deactivate: function () {
			_.resetScrollState.call(this);
			this._removeWindowFocusEvent();

			this.callParent('deactivate', arguments);
		},

		_onWindowFocus: function (e) {
			e.data.widget.delayedAsReadMarking(e.data.delay);
		},

		_addWindowFocusEvent: function (argument) {
			$(window).on('focus', {widget: this, delay: _.MARKREADDELAY}, this._onWindowFocus);
		},

		_removeWindowFocusEvent: function (argument) {
			$(window).off('focus', this._onWindowFocus);
		},

		delayedAsReadMarking: function (delay) {
			if (this._active === false) {
				return false;
			}

			this.readTimer = setTimeout(function () {
				if (fox.dom.documentHasFocus()) {
					fox.site.dispatchEvent('readNewMessage', fox.getEnv('site.conversationId'));
				}
			}, delay);
		},

		showMessageReadStatus: function (params) {
			var
				list = this.rwom1('#list'),
				mes, $mes;

			params = params.answer;

			if (this._active) {
				mes = list.filter('id', Number(params.id));

				if (mes.length) {
					if (list._indom) {
						mes[0].value.transferState = 2;

						$mes = $(list.dom1('#message-' + params.id + ' .message-read-status'));

						$mes.text('Seen');
					}
				}
			} else {
				this.seenMessage = params.id;
			}
		},

		_handleGlobalUnlockEvent: function (data, w, e) {
			fox.each(this.wom('~.Conversation_AttachItem'), function (w) {
				w.unlockSuccessfully(data);
			}, this);

			this._sendPaySuccessMessage(data);
		},

		addMessage: function (message, fromModel) {
			var list = this.rwom1('#list');

			function render (message) {
				this._addInProgress = true;

				var c = _.prepareCollection.call(
					this,
					list.dataModel.slice(-3).map(function (v) {return v.value;}).concat([message]),
					fromModel,
					true
				);

				if (list.getLength()) {
					if (!list._active) {
						list.updateItem(c[c.length - 2], list.getLength(), !list._active);
						list.appendItem(c[c.length - 1], !list._active);
					} else {
						this.waitEvent(list, 'addedToDom', function () {
							list.appendItem(c[c.length - 1]);
						}, {prefix: 'ifExist'});

						list.updateItem(c[c.length - 2], list.getLength());
					}

				} else {
					list.appendItem(c[c.length - 1], !list._active);

					return list.idStart - 1;
				}

				return list.idStart;
			}

			this.handleEvent(list, 'addedToDom', function () {
				this._addInProgress = false;

				if (!this._waitForQueue) return false;

				if (this._queue.length) {
					render.call(this, this._queue.pop());
				} else {
					this._waitForQueue = false;
				}
			}.bind(this), {
				alwaysActive: true,
				prefix: 'waitQueue'
			});

			if (this._addInProgress) {
				this._waitForQueue = true;
				return this._queue.push(message);
			}

			return render.call(this, message);
		}

	}, 'Grid');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	
	fox.registerWidget('ConversationGiftsPopup', {
		configure: function () {
			this.registerOptions('', {
				useUiPosition: true,
				preventHideOnShadowClick: true,
				template: '',
				dialog: {
					'dialogClass': 'mc-site-common-popup conversation-gifts-popup',
					title: 'Select a gift',
					autoOpen: false,
					closeText: '',
					'!width': '100%',
					minHeight: 300,
					closeOnEscape: true,
					draggable: true
				},
				widgets: {
					giftBoxBody: {
						widget: 'Giftbox',
						autoRender: true,
						'embed.container': '.ui-dialog-content',
						template: 'gifts_popup_container',
						widgets: {
							tabs: {
								widget: 'Tools_TabsSwitcher',
								target: '.gift-set-list .gift-set',
								name: 'set-id',
								callback: '@parent @parent:switchSet',
								switchOnEmbed: true
							},
							summerSet: {
								widget: 'AdvancedList',
								'embed.container': '#gift-list-container',
								'tpl.row': 'gifts_popup_list_row',
								autoRender: true,
								active: false,
								collection: [{loader: true}],
								group: 'gift-sets',
								handleDom: {
									checkGift: {
										event: 'click',
										target: '.gift-item-price',
										callback: '@parent:checkGiftSingle'
									}
								}
							},
							setTitle: {
								widget: 'Widget',
								autoRender: true,
								template: 'gift_set_title',
								'embed.container': '#gift-set-title',
								'templateOptions.set': 'love'
							}
						}
					}
				},
				handleWom: {
					centerOnListAddedToDom: {
						event: 'addedToDom',
						widget: '#giftBoxBody .AdvancedList',
						callback: this.onListAddedToDom.bind(this)
					},
					giftPaySuccess: {
						event: 'giftSended',
						widget: '#giftBoxBody',
						callback: function () {
							if (this.isOpen()) {
								this.hide();
							}
						}.bind(this)
					}
				},
				handleDom: {
					closePopup: {
						event: 'click',
						target: '.close',
						callback: 'hide',
						targetWidget: '#giftBoxBody'
					}
				}
			});

			this.registerOptions('#giftBoxBody #giftboxList', {
				'tpl.row': 'gifts_popup_list_row',
				group: 'gift-sets',
				active: true,
				'wrapMethods.resetCollection': true,
				'hooks.onStartResetCollection': function (c) {
					var bodyWidget = this.rwom1('#giftBoxBody');

					if (c.length <= 12) {

						if (bodyWidget.typeAlias === 'valentines_18') {
							fox.dom.addClass('hidden', bodyWidget.dom1('.gift-set-list'));
						}

						return;
					}

					this.rwom1('#giftBoxBody #summerSet').resetCollection(c.splice(12));

					this.wait('#giftBoxBody #summerSet', 'addedToDom').then(function () {
						this.rwom1('#giftBoxBody #giftboxList').setOption('embed.location', 'inside');
					}.bind(this));

					this.switchSet('summer');

					return true;
				}.bind(this)
			});

			this.registerOptions('#giftBoxBody #cbPaymentPopup', {
				preventHideOtherPopups: true
			});

			var date = new Date();

			if (date.getMonth() === 1 && [13, 14, 15].indexOf(date.getDate()) !== -1) {
				this.registerOptions('#giftBoxBody', {
					'templateOptions.valentineDay': 1
				});
			}

			this.callParent('configure', arguments);
		},

		show: function () {
			this.callParent('show', arguments);

			var gb = this.rwom1('#giftBoxBody');

			gb.rwom1('.AdvancedList').render();

			gb.checkedGifts = [];

			this.wait('#giftBoxBody #cbPaymentPopup', 'show').then(this.hide.bind(this));

			fox.dom.addClass('blured', fox.dom.selectFirst('.wrapper'));
		},

		hide: function () {
			this.callParent('hide', arguments);

			fox.dom.removeClass('blured', fox.dom.selectFirst('.wrapper'));

			this.wom('#giftBoxBody .AdvancedList').forEach(function (w) {
				w.render();
			});
		},

		onListAddedToDom: function () {
			this._center();

			this.rwom1('#giftBoxBody').checkedGifts = [];

			$(this.dom1('.popup-content-wrapper')).mCustomScrollbar({
				autoHideScrollbar: false,
				alwaysShowScrollbar: 2,
				theme: 'light-2',
				scrollbarPosition: 'outside'
			});
		},

		switchSet: function (alias) {
			var gb = this.rwom1('.Giftbox');
			var st = this.rwom1('.Giftbox #setTitle');

			switch (alias) {
				case 'summer':
					gb.switchEmbeddedWidget('summerSet');
					st.setTemplateOptions('set', 'summer').render();
				break;
				default:
					gb.switchEmbeddedWidget('giftboxList');
					st.setTemplateOptions('set', 'love').render();
			}
		}

	}, 'Dialog');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';
	fox.registerWidget('PreviewUploadedContent', {

		configure: function () {
			this.STORE = {};

			this.registerOptions('', {
				useUiPosition: true,
				preventHideOnShadowClick: false,
				template: '',
				'dialog.dialogClass': 'preview-content',
				'dialog.autoOpen': false,
				'dialog.closeText': '',
				'dialog.width': '100%',
				'dialog.minHeight': 300,
				'dialog.open': fox.bind(function () {
					var
						navBtn = $('<span></span>').addClass('nav-arrows').on('click', fox.bind(this.navigate, this)),
						$dialog = this.dialogMethod('widget'),
						$btns = $dialog.find('.nav-arrows');

					if (!$btns.length) {
						$dialog
							.append(navBtn.clone(true).addClass(this.getOption('leftNavArrow')).data('direction', 'prev'))
							.append(navBtn.clone(true).addClass(this.getOption('rightNavArrow')).data('direction', 'next'));		
					
						$btns = $dialog.find('.nav-arrows');
					}
					
					$btns.each(fox.bind(function (indx, el) {
						$(el)[this.collection.length > 1 ? 'show' : 'hide']();
					}, this));

					// add blur to wrapper
					$(fox.dom.selectFirst('.wrapper')).addClass('blured');
				}, this),
				'dialog.close': fox.bind(function () {
					var player = this.rwom1('#videoPreview')._player; 
					if (!!player) {
						this.rwom1('#videoPreview')._player.pause();
					}
					$(fox.dom.selectFirst('.wrapper')).removeClass('blured');
					
				}, this),
				widgets: {
					videoPreview: {
						widget: 'Content_Html5Player',
						container: '.flash-player-container',
						getMapMethod: 'Client_Upload.getMap',
						disableTimeline: true,
						template: 'preview_attached_content_video',
						renderPlayer: true,
						renderTo: '#flash-player',
						resourceIdParamName: 'clientUploadId',
						jsonizeMapRequest: false,
						'hooks.onStartRendering': function() {
							var
								parent = this.getParent(),
								id = parent.currentId;
							this.setTemplateOptions({
								contentId: id,
								targetId: parent.currentResId,
								attachTitle: parent.currentData.attachTitle
							});
						},
						'widgets.downloadLinks': {
							widget: 'Widget',
							autoRender: true,
							template: 'attached_video_download_links',
							
							'embed.container': '.attach-download',
							'hooks.onStartRendering': function () {
								var
									parent = this.getParent().getParent(),
									id = parent.currentId,
									vData = parent.STORE[id];

								this.setTemplateOptions({
									downloadLink: vData.download[fox.getObjectKeys(vData.download)].link
								});
							},
							handleDom: {
								// showDownList: {
								// 	event: 'click',
								// 	target: '.download',
								// 	callback: function (elem) {
								// 		var container = this.getOption('container');
								// 		var activeClass = this.getOption('activeClass');
								// 		var activeItems = this.getOption('activeItems');

								// 		$(elem).toggleClass('active');
								// 		$('.download-links').toggleClass('active');

								// 		if (activeItems) {
								// 			$('.download-links').find('li').toggleClass('active');
								// 		}
								// 	}
								// },
								handleDownload: {
									event: 'click',
									target: '.download',
									callback: function (el) {
										var api = this.getApi('log', {method: 'logger.log'});
										api.send({
											index: 'McUserActivity',
											path: fox.Navigator.getAll(),
											info: {event: 'download'}
										}, false);
									}
								}
							}
						}
					},
					imagePreview: {
						widget: 'Widget',
						template: 'preview_attached_content_image',
						handleDom: {
							downloadPhoto: {
								target: '.download',
								callback: '@parent:downloadPhoto'
							}
						},
						'hooks.onStartRendering': function () {
							var
								parent = this.getParent();

							this.setTemplateOptions({
								imageSrc: parent.currentData.bigThumb,
								attachTitle: parent.currentData.attachTitle,
								contentId: parent.currentId,
								resourceId: parent.currentResId
							});

							return true;
						}
					}
				},
				handleWom: {
					playerStart: {
						event: 'playerRunning',
						widget: '#videoPreview',
						callback: function (params, player, alias) {
							this._center();
						}
					}
				}
			});

			this.registerOptions('.Widget', {
				'embed.container': '.ui-dialog-content',
				autoRender: false,
				active: false,
				group: 'contentPreview',
				'widgets.favorite': {
					widget: 'Social_Favorite',
					subject: 'resource',
					'embed.widget': '@parent'

				},
				'hooks.onStopRendering': this.contentOnStopRendering
			});
		
			this.callParent('configure', arguments);
		},

		running: function () {
			var vp = this.rwom1('#videoPreview'), _this = this;

			// vp._readyToRender = false;
			// this.rwom1('#imagePreview')._readyToRender = false;

			var spm = vp.setPlayerSize;

			vp.setPlayerSize = function () {
				spm.apply(vp, arguments);

				_this._center();
			};
		
			this.callParent('running', arguments);
		},

		show: function (params) {
			this.collection = function () {return params.collection;}.call(this);

			if (!fox.isEmpty(params.data)) {
				this.showPopupContent(params.data);

				if (!this.isOpen()) {
					this.callParent('show', arguments);
				}
			}
		},

		showPopupContent: function (params) {
			if (this.currentId !== params.id) {
				this.currentData = params;
				this.setCurrentId(params.id);
				this.currentResId = params.resId;

				if (this.currentData.type === 1 && !this.STORE[this.currentId]) {
					this.fillStore(this.currentId, this.currentData.videoData);
				}

				this.switchType(params.type).then(function () {
					this.renderContentPreview();
				}.bind(this));
			}
		},

		getActivePreview: function () {
			var 
				aw;

			fox.each(this.getWidgetsByGroup('contentPreview'), function (w, alias) {
				if (w.isActive()) {
					aw = w;

					throw fox.break;
				}
			});

			return aw;
		},

		renderContentPreview: function () {
			var w = this.getActivePreview();
			var promise = w.wait('addedToDom').then(function () {
				// w._readyToEmbed = false;

				var vData = this.STORE[this.currentId];
				if (!!vData) {
					w.preparePlayerData(vData);
				}

				w.setPoster(this.currentData.posterUrl);
			}.bind(this));

			// w._readyToEmbed = true;

			w.render();

			this.loadFavoriteStatus(w);

			return promise;
		},

		loadFavoriteStatus: function (preview) {
			var f = preview.rwom1('.Social_Favorite');

			f.targetIds = [this.currentResId];

			f.loadData();

			return this;
		},

		setCurrentId: function (id) {
			if (id !== undefined && this.currentId !== id) {
				this.currentId = id;
			}

			return this;
		},

		fillStore: function (id, data) {
			if (!this.STORE.hasOwnProperty(id) && data !== undefined) {
				this.STORE[id] = data;
			}

			return this.STORE[id];
		},

		switchType: function (type) {
			var targetAlias = type === 1 ? 'videoPreview' : type === 2 ? 'imagePreview' : '';
			var promise = this.wait('switchedEmbeddedWidget');

			return this.switchEmbeddedWidget(targetAlias) && promise || fox.Promise.resolve(true);
		},

		getMapResponse: function (res) {
			var 
				map = this.fillStore(this.currentId, res.answer.response),
				p = this.rwom1('#videoPreview');

			p.preparePlayerData(map);
		},

		navigate: function (e) {
			var
				d = $(e.target).data('direction'),
				collection = this.collection,
				indx = collection.indexOf(collection.filter(function (v) {
					return v.id === this.currentId && v.messageId === this.currentData.messageId;
				}, this).pop());

			if (indx !== -1) {
				indx = (d === 'prev') ? indx - 1 : (d === 'next') ? indx + 1 : indx;

				if (collection[indx] !== undefined) {
					this.showPopupContent(collection[indx]);
				} else if (indx === -1) {
					this.showPopupContent(collection[collection.length - 1]);
				} else if (indx === collection.length) {
					this.showPopupContent(collection[0]);
				}
			}
		},

		contentOnStopRendering: function () {
			this.getParent().toggleDownload(this);
		},

		toggleDownload: function (w) {
			var
				attachType = this.currentData.type,
				attachPaid = Number(this.currentData.paid) > 0,
				showStatus,
				$el
			;

			switch (attachType) {
				case 1:
					showStatus = fox.getEnv(attachPaid === true ? 'contentAccessCommon.attachVideosPaidDownloadable' : 'contentAccessCommon.attachVideosDownloadable' );
				break;
				case 2:
					showStatus = fox.getEnv(attachPaid === true ? 'contentAccessCommon.attachPhotosPaidDownloadable' : 'contentAccessCommon.attachPhotosDownloadable');
				break;
			}

			if (showStatus === 0) {
				$el = $(w.dom1('.attach-download'));

				return $el.length && $el.remove();
			}
		},

		downloadPhoto: function (el, alias, w, e) {
			e.preventDefault();

			var _this = this;
			var transport = new XMLHttpRequest();

			transport.open('GET', el.href);
			transport.responseType = 'blob';
			
			transport.onload = function () {
				var a = document.createElement('a');
				var fname = _this.currentData.attachTitle.replace(/(\s-\s|\s|\.)/g, '_') + '.jpg';

				if (navigator.msSaveBlob) {
					return navigator.msSaveBlob(transport.response, fname);
				}

				if (window.URL || typeof safari !== 'undefined') {
					a.href = window.URL.createObjectURL(transport.response);
					a.setAttribute('download', fname);
					document.body.appendChild(a);

					setTimeout(function () {
						a.click();

						document.body.removeChild(a);
					}, 100);

					return true;
				}
			};

			transport.send();
		},

	}, 'Dialog');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {

	'use strict';
	
	fox.registerWidget('CrowdFunding', {
		
		configure: function () {

			this.registerOptions('', {
				widgets: {
					programsDl: {
						widget: 'Datalayer',
						method: 'funds.list',
						cacheChannel: 'funds'
					},
					banner: {
						widget: 'Widget',
						manualRender: true,
						template: 'crowdfunding_banner',
						embed: {
							widget: '@parent @parent',
							container: '.crowdfunding-wrapper'
						}
					},

					confirmPopup: {
						widget: 'Popup_Common',
						additionalClasses: 'mc-site-popup',
						'dialog.width': 385,
						'widgets.content.widget': 'CrowdFunding_Confirm'
					},
					errorPopup: {
						widget: 'Popup_Common',
						'dialog.width': 385,
						'widgets.content.template': 'popup_crowdfunding_payment_error'
					},
					successPopup: {
						widget: 'Popup_Common',
						'dialog.width': 385,
						'widgets.content.template': 'popup_crowdfunding_payment_success'
					},
				},

				handleWom: {
					dlLoaded: {
						widget: '#programsDl',
						event: 'loaded',
						callback: '_handleProgramsDlLoad'
					},
					inboxPaymentSelf: {
						widget: '@root #socket',
						event: [
							'inboxSocketEventFunds:billing:sale',
							'inboxSocketEventFunds:billing:action'
						],
						callback: '_handleSocketMessage'
					},
					paymentError: {
						widget: '#confirmPopup #content',
						event: 'prepareFailed',
						callback: '_handlePaymentError'
					},
					scroll: {
						widget: '#banner',
						event: 'addedToDom',
						callback: '_scrollToBlock'
					}
				},

				handleDom: {
					showConfirmationPopup: {
						targetWidget: '#banner',
						target: '.donate',
						event: 'click',
						callback: '_showConfirmationPopup'
					},
					share: {
						targetWidget: '#banner',
						target: 'a[data-share]',
						event: 'click',
						callback: '_share'
					}
				}
				
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.banner = this.wom1('#banner');

			this.dl = this.wom1('#programsDl');
			this.confirmPopup = this.wom1('#confirmPopup');
			this.confirmForm = this.confirmPopup.wom1('.CrowdFunding_Confirm');
			this.errorPopup = this.wom1('#errorPopup');
			this.successPopup = this.wom1('#successPopup');

			this.getPrograms();

			this.callParent('running', arguments);
		},

		activate: function () {
			this.getPrograms();
			this.callParent('activate', arguments);
		},

		getPrograms: function () {
			this.dl.load();
		},

        CrowdFunding: function (obj, dl, e) {
			var data = dl.getCollection()[0];
			if (data) {
				var progress = Math.ceil(fox.utils.getPercent(data.goalAmount, data.currentAmount));
				data.progress = progress > 100 ? 100 : progress;

				this.setData(data);
				this.bannerOptions(data);
				this.renderBanner();
				return;
			} else {
				this.banner._readyToRender = false;
			}
		},

		setData: function (data) {
			this.programData = data;
		},

		getData: function () {
			return this.programData;
		},

		bannerOptions: function (opts) {
			this.banner.setTemplateOptions(opts);
		},

		renderBanner: function () {
			this.banner.render();
		},

		_showConfirmationPopup: function (el) {
			var fundId = $(el).attr('data-fund-id');
			this.confirmForm.setFundId(fundId);
			this.showConfirmationPopup();
		},

		showConfirmationPopup: function () {
			this.confirmPopup.show();
		},

		showErrorPopup: function () {
			this.errorPopup.show();
		},

		showSuccessPopup: function () {
			if (!fox.site.member) {
				return;
			}

			this.successPopup.render();
			this.successPopup.wom1('#content')
				.setTemplateOptions({name: fox.site.member.getObjectValue('login')})
				.render();

			this.successPopup.show();
			this.dispatchEvent('showedSuccessPopup');
		},

		_handleSocketMessage: function (obj, s, e) {
			if (e.match('action')) {
				this.getPrograms();

				return;
			}
			if (obj.answer.amount > 0) {
				this.showSuccessPopup();
				console.warn('_handleSocketMessage', 'success', obj.amount);
			} else {
				console.warn('_handleSocketMessage', 'refund', obj.amount);
			}

			this.getPrograms();
		},

		_share: function (el) {
			var alias = $(el).attr('data-app-name');

			this.postToSocialNetwork(alias);
		},

		postToSocialNetwork: function (alias) {
			var params = {};

			switch(alias) {	
				case 'twitter':
					this.postToTwitter();
				break;

				case 'thumbler':
					this.postToTumblr();
				break;

				case 'email':
					this.showEmailDialog();
				break;
				case 'facebook':
					this.postToFB();
				return;
			}

			return;
		},

		postToFB: function () {
			var text = this.getPostContent();
			var shareLink = "https://www.facebook.com/dialog/feed?%20app_id=416606395129423%20&display=popup&link=" +
							this._getSignupUrl() +
							"&redirect_uri=http://facebook.com&description=" +
							text;
				//+ "&caption=Crowdfunding widget";

			window.open(shareLink, '', 'width=626,height=436');
		},

		postToTwitter: function () {
			var text = this.getPostContent();
			var shareLink = 'http://twitter.com/share?url=' +  this._getSignupUrl() + '&text=' + text;

			window.open(shareLink, '', 'width=626,height=436');
		},

		postToTumblr: function () {
			var text = this.getPostContent();
			var shareLink = 'http://tumblr.com/widgets/share/tool?canonicalUrl=' + this._getSignupUrl() + '&name=Nightwolf&caption=' + this.getPostContent();// + '&tags=modelcentro,model+centro,professional,website,model'
			
			window.open(shareLink, '', 'width=626,height=436');	
		},

		_getSignupUrl: function () {
			return [window.location.origin, 'sponsor'].join('/');//encodeURIComponent(fox.getEnv('design.domain') + '/sponsor');
		},

		getPostContent: function () {
			return 'Let\'s help send ' + fox.getEnv('screenName') + ' to Miami CamCon!';
		},

		_handlePaymentError: function (err) {
			this.showErrorPopup();
		},

		_scrollToBlock: function () {}

	}, 'Controller');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox, $) {
	"use strict";

	fox.registerWidget('CrowdFunding_Confirm', {

		configure: function configure() {
			this.paymentPending = [];
			this.minCustomPriceAmount = 2; //$
			this.recomendedCustomPriceAmount = 30; //$
			this.defErrors = {
				amount: 'Please enter amount',
				email: 'Please enter your email',
				login: 'Please enter your nickname'
			};

			this.registerOptions('', {
				'!template': 'popup_crowdfunding_confirm',
				widgets: {
					form: {
						widget: 'Form',
						loadValuesOnRun: true,
						autoApply: true,
						formElements: {
							message: { element: '[name=cf_message]' },
							amount: { element: '[name=amount]', defaultValue: this.recomendedCustomPriceAmount }
						},
						'hooks.onSubmit': '@parent:validateData'
					},
					prepareApi: {
						widget: 'Api',
						method: 'funds.prepare'
					}
				},

				handleWom: {
					inboxPayment: {
						widget: '@root #socket',
						event: ['inboxSocketEventFunds:billing:sale', 'inboxSocketEventFunds:billing:cancel', 'inboxSocketEventFunds:billing:action'],
						callback: '_handleSocketMessage'
					}
				},

				handleDom: {
					submit: {
						target: '.confirm',
						event: 'click',
						callback: '_submit'
					},
					focus: {
						target: 'input[type="text"]',
						event: 'focus',
						callback: function callback(el) {
							this.handleErrorToggle({ state: true, el: el });
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			this.userData = {};
			this.api = null;

			var pm = fox.site.wom1('.PermissionManager');
			if (fox.isEmpty(pm.getMemberInfo())) {
				this.registerOptions('#form', {
					formElements: {
						'login.element': '[name=login]',
						'login.autoApply': true,
						'email.element': '[name=email]',
						'email.autoApply': true
					}
				});
			}
			this.callParent('init', arguments);
		},

		running: function running() {
			this.prepareApi = this.rwom1('#prepareApi');

			this.handleEvent('#form', 'submit', fox.bind(this.onSubmit, this));
			this.callParent('running', arguments);
		},

		setFundId: function setFundId(id) {
			this.fundId = id;
		},

		_submit: function _submit() {
			var _this = this;

			this.showCbWindow(new fox.Promise(function (resolve) {
				_this.__prepareResolver = resolve;

				_this.wom1('#form')._submit();
			}));
		},

		onSubmit: function onSubmit(userData) {
			if (!this._isValid) {
				if (this.__prepareResolver) this.__prepareResolver(false);

				return false;
			}

			this.userData = userData;

			this.submit();
		},

		validateData: function validateData() {
			this._isValid = false;
			var result = {
				email: false,
				login: false,
				amount: false
			};

			var pm = fox.site.wom1('.PermissionManager');
			if (fox.isEmpty(pm.getMemberInfo())) {
				result.email = this._validateEmail();
				result.name = this._validateName();
			} else {
				result.email = true;
				result.name = true;
			}

			result.amount = this._validateAmount();
			if (result.name && result.email && result.amount) {
				this._isValid = true;
				this.wom1('#form').dispatchEvent('submit', this.wom1('#form')._preparedValues);
				return;
			}
		},

		_validateAmount: function _validateAmount() {
			if (!this.wom1('#form #amount')) {
				return true;
			}

			var amount = this.wom1('#form').getValue('amount'),
			    input = this.dom1('[name="amount"]'),
			    regExp = /^[0-9]+(\.?[0-9]+)?$/;

			if (!input) {
				this.toggleError('amount', false);
				return false;
			}

			if (!amount || !amount.length || !amount.match(regExp)) {
				this.toggleError('amount', false);
				return false;
			}

			if (amount.match(regExp)) {
				amount = this.window.parseInt(amount);

				if (amount >= this.minCustomPriceAmount && amount <= 99999) {
					this.toggleError('amount', true);
					return true;
				}

				if (amount < this.minCustomPriceAmount) {
					this.toggleError('amount', false, 'Min donation amount is $2');
				}

				if (amount > 99999) {
					this.toggleError('amount', false, 'Max donation amount is $99,999');
				}

				return false;
			}

			return true;
		},

		_validateEmail: function _validateEmail() {
			var regExp = new RegExp('^[a-zA-Z0-9#\!\$%&\'\*\+\/=\?\^_`\{\}\|~-]+(?:\.[a-z0-9#\!\$%&\'\*\+\/=\?\^_`\{\}\|~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$'),
			    el = this.dom1('[name="email"]', this.rwom1('#form').getContainer());

			if (!el) {
				return false;
			}

			if (this.isNotEmpty('email') && fox.trim(el.value).match(regExp)) {
				this.toggleError('email', true);
				return true;
			}

			this.toggleError('email', false);
			return false;
		},

		_validateName: function _validateName() {
			if (this.isNotEmpty('login')) {
				this.toggleError('login', true);
				return true;
			}

			this.toggleError('login', false);
			return false;
		},

		toggleError: function toggleError(name, state, msg) {
			var el = this.dom1('[name="' + name + '"]', this.rwom1('#form').getContainer());

			if (!el) {
				return;
			}

			fox.dom[!state ? 'addClass' : 'removeClass']('error', el);

			this.hookWrapper('handleErrorToggle', { state: state, el: el, msg: msg });
		},

		isNotEmpty: function isNotEmpty(name) {
			return fox.trim(this.dom1('[name="' + name + '"]', this.rwom1('#form').getContainer()).value).length;
		},

		handleErrorToggle: function handleErrorToggle(data) {
			var msgContainer = $(data.el.parentNode).next();
			var state = data.state;
			fox.dom[!state ? 'addClass' : 'removeClass']('error', data.el);
			fox.dom[!state ? 'addClass' : 'removeClass']('error', data.el.parentNode);

			if (!state) {
				msgContainer.text(data.msg || this.defErrors[data.el.name]);

				return;
			}

			msgContainer.text('');
		},

		submit: function submit() {
			this.requireEmbeddedWidget('form').ignoreSubmit(true);

			var transactionParams = {
				fundId: this.fundId,
				amount: this.userData.amount
			};

			if (this.userData.login && this.userData.email) {
				transactionParams.login = fox.trim(this.userData.login);
				transactionParams.email = fox.trim(this.userData.email);
			}

			if (this.userData.message) {
				transactionParams.message = this.userData.message;
			}

			transactionParams = fox.mixin(transactionParams, this.getOption('preparedTransactionParams'));

			this.prepareTransaction(transactionParams).then(fox.bind(function (res) {
				this.onPrepareSuccess(res, transactionParams.tipId);
			}, this)).catch(fox.bind(this.onPrepareFailed, this));
		},

		prepareTransaction: function prepareTransaction(formData) {
			this.wom1('@parent').hide();

			this.prepareTransactionInProgress = true;

			return this.prepareApi.psend(formData);
		},

		onPrepareFailed: function onPrepareFailed(err, api, e) {
			this.prepareTransactionInProgress = false;
			this.dispatchEvent('prepareFailed', err);

			console.error('onPrepareFailed', err);
		},

		onPrepareSuccess: function onPrepareSuccess(r, tipId) {
			this.prepareTransactionInProgress = false;

			function pendingPayment(tipId) {
				this.rwom1('#form').enableAllElements().ignoreSubmit(false);

				this.paymentPending.push(Number(tipId));
			}

			r = r.params.answer.response;

			if (r.submit_url) {
				if (this.__prepareResolver) this.__prepareResolver(r);

				return pendingPayment.call(this, tipId);
			} else if (r === true || r === 'Event successfully processed') {
				return pendingPayment.call(this, tipId);
			}

			throw new Error('Payment error');
		},

		showCbWindow: function showCbWindow(promise) {
			var _this2 = this;

			var cbPopup = this.wom1('#cbPaymentPopup');

			if (!cbPopup) {
				cbPopup = this.embedWidget('cbPaymentPopup', 'CBPaymentPopup', {});

				cbPopup.run();
			}

			cbPopup.show(promise.then(function (data) {
				_this2.__prepareResolver = null;

				if (data === false) cbPopup.hide();

				var url = data.submit_url + '?' + fox.toQueryString(data.added_fields);

				return { url: url };
			}));
		},

		_handleSocketMessage: function _handleSocketMessage(obj) {}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	fox.registerWidget('AMCFlashPlayer', {
		createFlashPlayer: function () {
			var flashSrc;

			if (fox._isNewfe) {
				flashSrc = __webpack_require__(57);
			} else {
				flashSrc = fox.getEnv('design.url') + "/flash/flowplayer.commercial-3.2.16.swf";
			}

			this.window.flowplayer(
				this.getOption('domNodeContainerLink') === true ? this.getPlayerContainer() : this.getPlayerContainer().getAttribute('id'),
				{
					src: flashSrc,
					wmode: this.getOption('wmode')
				},
				this.getOption('playerConfig')
			);
		}
	}, 'Content_FlashPlayer');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Site_Footer Widget

(function (fox, $) {
  "use strict";
  var _ = {
    RABBIT_ACTIVE_STATE: 1,
    RABBIT_PENDING_STATE: 2,
  };

  fox.registerWidget(
    "Site_Footer",
    {
      configure: function (options) {
        this.counter = 0;

        this.registerOptions("", {
          aliases: [
            "2257",
            "editable",
            "billing",
            "copyright",
            "powered",
            "smallBannersContainer",
          ],
          "2257.template": "footer_2257",
          "editable.template": "footer_editable",
          "billing.template": "footer_billing",
          "powered.template": "footer_powered",
          "smallBannersContainer.template": "footer_b_wrapper",

          rabbitsReviewsBanner: {
            widget: "Widget",
            autoRender: true,
            embed: {
              container: ".b-list",
              location: "lastChild",
              widget: "@parent #smallBannersContainer",
            },
            template:
              'a[href="https://www.rabbitsreviews.com/$[link]" target="_blank" rel="nofollow"]>img[src="https://www.rabbitsreviews.com/images/banners/rabbitsreview_120x60.gif" alt="Rabbits Reviews" border=0]+br+span{Rabbits Porn Reviews}',
          },
          copyright: {
            template: "footer_copyright",
            widgets: {
              copyrightYears: {
                widget: "Copyright",
                template: "copyright",
              },
            },
          },

          handleDom: {
            goAccountPage: {
              targetWidget: "#editable",
              target: "#go-account-page",
              event: "click",
              callback: "_goToAccountPage",
            },
            reportSite: {
              targetWidget: "#editable",
              event: "click",
              target: "#_sesta",
              callback: function () {
                this.rwom1("@root .SestaFosta_Popup").show();
              },
            },
          },
        });
        this.registerOptions("#editable", {
          handleDom: {
            reportProblem: {
              event: "click",
              target: "#_reportProblem",
              callback: "@parent:reportProblem",
            },
            reportSite: {
              event: "click",
              target: "#_sesta",
              callback: function () {
                this.rwom1("@root .SestaFosta_Popup").show();
              },
            },

            // ,

            // goAccountPage: {
            // 	target: '#go-account-page',
            // 	event: 'click',
            // 	callback: "@parent:goToAccountPage"
            //					}
          },
        });

        if (options.infinityFooter) {
          this.registerOptions(".Widget", {
            "handleWom.addedToDom": {
              widget: "@this",
              event: "addedToDom",
              callback: "@parent:_handleWidgetsRenderring",
            },
          });
        }

        this.callParent("configure", arguments);
      },

      init: function () {
        var container;
        var copyright = {};
        var rabbitOpts = this.getOption("rabbitsReviewsBanner");
        var rabbitState = Number(fox.getEnv("rabbitsReviewsStatus"));

        this._aliases = this.getOption("aliases");

        container = this.requireOption("container");

        fox.each(
          this._aliases,
          function (alias) {
            var cont = this.getOption(alias + ".container");

            this.embedWidget(
              alias,
              "Widget",
              fox.mergeRecursive(
                {
                  autoRender: true,
                  embed: {
                    location: "lastChild",
                    container: cont || container,
                  },
                  "templateOptions.affiliateLink": this.generateAffiliateLink(),
                },
                this.getOption(alias)
              )
            );
          },
          this
        );

        if (
          fox.inArray(
            [_.RABBIT_ACTIVE_STATE, _.RABBIT_PENDING_STATE],
            rabbitState
          )
        ) {
          var link =
            fox.getEnv("rabbitsReviewsCategory") !== "21"
              ? "Default.aspx"
              : "c21/Gay.html";

          if (fox._isNewfe) {
            rabbitOpts.template = rabbitOpts.template.replace("$[link]", link);
          } //else {
          // rabbitOpts.templateOptions = {
          // 	link
          // };
          //}

          this.embedWidget(
            "rabbitsReviewsBanner",
            rabbitOpts.widget,
            rabbitOpts
          );
        }

        this.callParent("init", arguments);
      },

      deactivate: function (argument) {
        this.counter = 0;

        this.callParent("deactivate", arguments);
      },

      reportProblem: function () {
        var user, form;

        user = fox.site.member ? fox.site.member.getObjectValue("id") : "";
        form = $("<form>").attr({
          target: "_blank",
          method: "GET",
          action: "https://support.modelcentro.com/hc/en-us/requests/new",
        });

        $("<input>")
          .attr({
            type: "hidden",
            name: "ticket_form_id",
            value: "10328880669981",
          })
          .appendTo(form);

        form.appendTo("body").submit();
      },

      _goToAccountPage: function () {
        this.hookWrapper("goToAccountPage");
      },

      _getWidgetsCount: function (argument) {
        return this.wom(".Widget").length;
      },

      _handleWidgetsRenderring: function (obj, w, e) {
        this.counter++;

        if (this.counter === this._getWidgetsCount()) {
          this.dispatchEvent("allWidgetsInDom");
          return;
        }
      },

      generateAffiliateLink: function () {
        var url = "";
        var whiteLabelDomain = fox.getEnv("wlDomain");

        if (fox.getEnv("affiliateArea")) {
          url = "https://centroprofits.com";
        }

        if (whiteLabelDomain) {
          url = "http://" + whiteLabelDomain;
        }

        return url;
      },
    },
    "Controller"
  );
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('GridStub', {
		
		configure: function(options) {
			var date = new Date();
			this.registerOptions('', {
				skipPreloader: true,
				'item': {
					id: 1,
					'sites.publishDate': date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + ' 00:00:00',
				},
				autoRender: true,
				'widgets.list': {
					widget: 'List',
					autoRender: true
				}
			});
			return this.callParent('configure', arguments);
		},

		init: function() {
			
			var listOptions = this.getOption('list'), collection = [];
			console.log(listOptions);
			if (listOptions) {
				if (listOptions.count) {
					for (var i = 1, l = listOptions.count; i <= l; i++) {
						collection.push(this.getOption('item'));
					}
				}
				listOptions.collection = collection;
				this.registerOptions('#list', this.getOption('list'));
			}
		}

	});

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	var Promise = fox.RSVP.Promise;

	fox.registerWidget('HeaderSwipeSlider', {

		configure: function (options) {

			this.registerOptions('', {
				container: '.header-block-wrapper',
				template: 'swipe_header',
				manualRender: true,
				imagesPaths: [],
				handleDom: {
					gotoSlide: {
						target: '.slider-pager [data-index]',
						event: 'click',
						callback: '_handlePagerClick'
					}
				}
			});

			this.callParent('configure', arguments);

		},

		activating: function(params) {
			this.callParent('activating', arguments);

			if (this._readyToRender) {
				this.render();
			}
		},

		init: function () {
			this._images = this.getOption('imagesPaths');

			if (fox.isFunction(this._images)) {
				this._images = this._images();
			}

			this.fakeImages = null;

			this.handleEvent('@root ~.Layout_Home', 'windowResize', function () {
				this.rebuild();
			}.bind(this));

			this.callParent('init', arguments);
		},

		render: function () {
			if (this.checkLoadedImagesCount()) return this.callParent('render', arguments);

			return this.prepareImages()
				.then(this.renderSlider.bind(this))
				.then(this.callParent.bind(this, 'render', arguments));
		},

		renderSlider: function (paths) {
			paths = paths.filter(Boolean);
			var arr = paths || [];
			this.imagesCounter = paths.length;

			if (fox.isArray(this.fakeImages)) {
				arr = this.fakeImages;
			}

			arr.sort(function (a, b) {
				return a.ind - b.ind;
			});

			if (fox.count(arr) > 0) {
				this.setTemplateOptions('paths', arr);
			}

			return this;
		},

		addedToDom: function () {
			this.rebuild();
		},

		build: function () {
			if ((this.fakeImages && this.fakeImages.length) || this.imagesCounter) {
				this.applySwipe();

				return this;
			}

			this.show();
		},

		applySwipe: function (argument) {
			this.swipe = window.Swipe(this.dom1('#swipe-wrapper'), {
				startSlide: 0,
				speed: 1000,
				auto: 5000,
				continuous: true,
				callback: function (ind, el) {
					this.markSlide(ind);
				}.bind(this)
			});
		},

		rebuild: function () {
			if (this.swipe) {
				this.swipe.kill();
			}

			this.build();
		},

		prepareImages: function () {

			if (!this._images.length) return false;

			return Promise.all(this._images.map(function (imgName, idx) {
				var url = imgName;

				return fox.image.create({url: url}).get().then(function (img) {
					if (img.width > 1 && img.height > 1) {
						return {ind: idx, src: url};
					}
					return false;
				});
			}).filter(function (url) { return url}) );
		},

		markSlide: function (ind) {
			var slide = this.dom1('.slider-pager [data-index="' + (ind-1) + '"]');

			fox.each(this.dom('.slider-pager [data-index]'), function (elm) {
				var elmInd = fox.dom.wrap(elm).attr('data-index');

				if (+elmInd === ind) {
					fox.dom.addClass('active', elm);

					return;
				}

				fox.dom.removeClass('active', elm);
			}, this);
		},

		next: function () {
			this.swipe.next();
		},

		prev: function () {
			this.swipe.prev();
		},

		slide: function (ind) {
			this.swipe.slide(ind);
		},

		_handlePagerClick: function (elm, alias, w, e) {
			e.stopPropagation();
			e.preventDefault();

			var ind  = window.parseInt(fox.dom.wrap(elm).attr('data-index'));

			this.slide(ind++);
		},

		checkLoadedImagesCount: function () {
			return this.imagesCounter === this._images.length;
		},

		show: function () {
			var elm = this.dom1('.header-images-slider');

			if (!elm) return;

			elm.style.visibility = 'visible';
		}

	}, 'Widget');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

// SitePage_Join Widget
(function (fox) {
	var AutoLoginService = __webpack_require__(15)(fox);
	var emptyValidator = function emptyValidator(message) {
		return function () {
			var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
			return {
				result: value.length > 0,
				message: message
			};
		};
	};
	var getMaxDiscount = __webpack_require__(26)(fox);

	fox.registerWidget('SitePage_Join', {
		configure: function configure(options) {
			var _this2 = this;

			this.registerOptions('', {
				widgets: {
					cbPaymentPopup: {
						widget: 'CBPaymentPopup'
					},
					clientInfo: {
						widget: 'Api',
						method: 'Client_Aboutme.getData',
						cacheChannel: 'site'
					},
					customJoin: {
						optionsBy: 'optionId',
						widget: 'Join_Form',
						container: '#join-form-container',
						template: 'sitepage_join_form',
						'wrapMethods.onSubmit': true,
						'wrapMethods.onPrepareTransaction': true,
						'wrapMethods.prepareTransaction': true,
						'hooks.onStartOnSubmit': this.onStartOnSubmit.bind(this),
						'hooks.onStartOnPrepareTransaction': function hooksOnStartOnPrepareTransaction() {
							return this.getParent().onPrepareTransaction.apply(this, arguments);
						},
						'hooks.onJoinOptionsPrepare': this.formatData.bind(this),
						'hooks.onStopPrepareTransactionParams': function hooksOnStopPrepareTransactionParams(params) {
							var _autoLoginService$inj = _this2.autoLoginService.injectToken(params),
							    token = _autoLoginService$inj.token;

							params.token = token;
						},
						'hooks.onPrepareTransaction': function hooksOnPrepareTransaction(formData) {
							var joinForm = _this2.rwom1('#customJoin');
							var method = joinForm.prepareTransactionApi.method();

							if (!fox.isEmpty(fox.getEnv('siteProps.freeJoin')) && method !== 'user.upgrade') return joinForm.__wrapped__prepareTransaction(formData);

							_this2.showCbPopup(new fox.Promise(function (resolve, reject) {
								return joinForm.__wrapped__prepareTransaction(formData, resolve, reject);
							}));
						},

						widgets: {
							'errors.container': '#errors.errors',
							form: {
								formContainer: '#join-form',
								submit: {
									target: '#join-form',
									event: 'submit'
								}
							},
							prepareTransactionApi: {
								project: 'modelcloud',
								method: 'user.join',
								httpMethod: 'post'
							},
							joinOptions: {
								container: '.join-options',
								'tpl.row': 'sitepage_join_form_option',
								maxDiscount: getMaxDiscount(),
								handlers: {
									changeOption: {
										'event': 'click',
										target: '.checkbox-handler',
										callback: fox.bind(this.changeOption, this)
									}
								}
							},
							billerOptionsForm: {
								'embed.widget': '@parent @parent',
								'embed.container': '#biller-form-container',
								template: 'sitepage_join_form_billing',
								billerFormSelector: '#biller-form',
								widgets: {
									optionsList: {
										container: '#biller-form',
										tpl: {
											row: 'sitepage_join_form_billing_row'
										}
									}
								}
							}
						},
						'handleWom.onPrepareTransaction.callback': '@parent:onPrepareTransaction'
					}
				},
				'handleWom.joinOptionsPrepared': {
					widget: '#customJoin',
					event: 'joinOptionsPrepared',
					callback: 'formatData',
					params: {
						alwaysActive: true,
						listenHistory: true
					}
				},

				'handleWom.clientInfo': {
					widget: '#clientInfo',
					event: 'success',
					callback: '@this:insertName'
				},

				'handleWom.onPrepareFailed': {
					widget: '#customJoin',
					event: 'onPrepareFailed',
					callback: 'onPrepareFailed'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			var _this3 = this;

			this.autoLoginService = new AutoLoginService(this);

			this.registerOptions('#cbPaymentPopup', {
				matchTokenFunction: function matchTokenFunction(token) {
					return _this3.autoLoginService.matchToken(token);
				}
			});

			var path = '#customJoin #form';

			if (fox.isEmpty(this.wom1('@root #permissionManager').getMemberInfo())) {
				var options = {
					email: {
						validators: [emptyValidator('email field cannot be empty'), { validator: 'regexp', options: { type: 'email' }, message: 'wrong email format' }]
					},
					login: {
						validators: [emptyValidator('login field cannot be empty'), { validator: 'length', options: { min: 1 }, message: 'login field cannot be empty' }, { validator: 'regexp', options: { regexp: /^[^\#]+$/i }, message: 'A username cannot contain special characters "#".' }]
					}
				};

				if (!fox.getEnv('siteProps.freeJoin')) {
					options.password = {
						validators: [{ validator: 'length', options: { min: 1 }, message: 'password field cannot be empty' }]
					};
				}

				this.registerOptions(path, {
					elements: options
				});
			}

			this.callParent('init', arguments);
		},

		running: function running() {
			this.rwom1('#clientInfo').send({});
			this.callParent('running', arguments);
		},

		insertName: function insertName(response) {
			var block = fox.dom.selectFirst('#cite-author');
			if (block) {
				block.innerHTML = response.answer.response.success.stats.name;
			}
		},

		changeOption: function changeOption(el) {
			var chkbx = fox.dom.selectFirst('.chkbx', el),
			    current = fox.dom.selectFirst('.checkbox', el),
			    group = fox.dom.select('.checkbox', this.element);

			fox.each(group, function (elem) {
				fox.dom.removeClass('checked', elem);
			});

			this.rwom1('#customJoin #form').setValue(chkbx.name, chkbx.value);
			chkbx.checked = true;
			fox.dom.addClass('checked', current);
		},

		formatData: function formatData() {
			var listWidget = this.rwom1('#customJoin #joinOptions'),
			    optionsList = fox.getEnv('siteProps.ubs.joinOptions.options'),
			    defaultOptionExists = false;

			fox.each(optionsList, function (opt) {
				if (opt.type === 'recurring') {
					opt.settings.viewData = (opt.settings.recurringAmount / (opt.settings.recurringPeriod / (opt.settings.recurringPeriodType === 'm' ? 1 : 30))).toFixed(2);
				}

				if (opt['default']) {
					defaultOptionExists = true;
				}

				if (!fox.isEmpty(opt.discountParams)) {
					if (!!opt.settings.viewData) {
						opt.discountParams.discountPrice = (opt.settings.viewData - opt.settings.viewData * (opt.discountParams.discount / 100)).toFixed(2);
					} else {
						opt.discountParams.discountPrice = (opt.settings.initialAmount - opt.settings.initialAmount * (opt.discountParams.discount / 100)).toFixed(2);
					}
					if (!!opt.discountParams.discountOptionId) {
						opt.settings.id = opt.id = opt.discountParams.discountOptionId;
					}
				}
			});

			if (!defaultOptionExists && optionsList.length) {
				optionsList[0]['default'] = 1;
			}

			listWidget.setCollection(optionsList);
		},

		onStartOnSubmit: function onStartOnSubmit(userData) {
			var linkerParam = this.rwom1('@root #googleAnalytics').getLinkerParam();
			var formData = {};

			if (linkerParam) {
				formData['transitParams[_ga]'] = linkerParam;
			}

			return true;
		},

		showCbPopup: function showCbPopup(promise) {
			var cbPaymentPopup = this.rwom1('#cbPaymentPopup');

			return cbPaymentPopup.show(promise.then(function (_ref) {
				var params = _ref.params.answer.response;
				var submit_url = params.submit_url,
				    added_fields = params.added_fields;

				var url = submit_url + '?' + fox.toQueryString(added_fields);

				return { url: url };
			}));
		},

		onPrepareTransaction: function onPrepareTransaction(data) {
			this.__inProgress = false;
			var _this = this.getParent();
			var form = this.rwom1('#form');

			form.enable();

			if (data.freeJoinResult) {
				_this.rwom1('#cbPaymentPopup').hide();
				var layout = fox.site.wom1('#home');
				fox.site.wait(layout, 'addedToDom').then(function () {
					fox.site.wom1('#home #home').activate();
				}).catch(console.error);
				fox.site.rwom1('#navi').update({ 0: 'home' }, true);
				fox.site.wom1('#home #home').deactivate();
				var token = _this.autoLoginService.tokens.slice().pop();

				_this.autoLoginService.shouldAuthorize(token).then(function (result) {
					return result && Object.keys(form.getOption('elements')).filter(function (field) {
						return field !== 'joinOptions';
					}).forEach(function (field) {
						form.removeElement(field);
						form.removeOption('elements.' + field);
					});
				});
				return false;
			}

			_this.wait('@root #socket', 'inboxSocketEventUser:join:success').then(function (_ref2) {
				var params = _ref2.params;

				var token = fox.objectGet(params, 'answer.token');

				return _this.autoLoginService.shouldAuthorize(token);
			}).then(function (result) {
				return result && fox.site.gotoPage('home');
			});

			return false;
		},

		onPrepareFailed: function onPrepareFailed(err) {
			this.rwom1('#cbPaymentPopup').hide();

			if (err.type === 5) {
				var popup = this.wom1('#errorPopup');

				if (!popup) {
					popup = this.embedWidget('errorPopup', 'Popup_Common', {
						'widgets.content.template': 'upgrade_form_oneclick_error'
					});

					popup.run();
				}

				popup.show();
			}
		}

	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Free Hosted Gallery */
(function(fox) {
	'use strict';
	fox.registerWidget('Layout_FreeHostedGallery', {}, 'Site_Layout');
	
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
"use strict";

/** Layout Home */
(function (fox, $) {
  "use strict";

  var getMaxDiscount = __webpack_require__(26)(fox);

  fox.registerWidget("Layout_Home", {
    configure: function configure() {
      this.registerOptions("", {
        widgets: {
          "mainMenu.widget": "Menu_Main",
          "footer.widget": "Site_Footer"
        },
        newMessageSelector: "#messages-number",
        "templateOptions.maxDiscount": getMaxDiscount(),
        handleWom: {
          newMessagesCount: {
            event: "cameNewMessages",
            widget: "@root #newMessageCount",
            "params.prefix": "formessagecounter",
            callback: function callback(data) {
              var mn = this.dom(this.getOption("newMessageSelector"));

              fox.each(mn, function (n) {
                if (fox.dom.isDomNode(n)) {
                  n.innerHTML = data.total > 0 ? data.total : "";

                  if (data.total > 0 && $(n).css("display") === "none") {
                    $(n).css("display", "inherit");
                  }
                }
              });
            }
          },
          firstLoad: {
            widget: "@this",
            event: "addedToDom",
            callback: "_goToPageAnalytics"
          },
          goToPageAnalytics: {
            widget: fox.Navigator,
            event: "modified_0",
            callback: "_goToPageAnalytics"
          }
        }
      });

      this.callParent("configure", arguments);
    },

    running: function running() {
      this._resizeTimer = null;
      this._addResizeHandler();

      this.callParent("running", arguments);
    },

    activate: function activate() {
      this._addResizeHandler();

      this.callParent("activate", arguments);
    },

    deactivate: function deactivate(argument) {
      this._removeResizeHandler();

      this.callParent("deactivate", arguments);
    },

    _addResizeHandler: function _addResizeHandler(argument) {
      $(window).on("resize", { widget: this }, this._handleResize);
    },

    _removeResizeHandler: function _removeResizeHandler(argument) {
      $(window).off("resize", this._handleResize);
    },

    _handleResize: function _handleResize(e) {
      var _this = e.data.widget;

      if (_this._resizeTimer) {
        return;
      }

      _this._resizeTimer = window.setTimeout(function () {
        _this.dispatchEvent("windowResize");
        _this._resizeTimer = false;
      }, 1000);
    },

    _goToPageAnalytics: function _goToPageAnalytics() {
      var api = this.getApi("trckApi", { method: "trck-v1" }),
          data = {},
          page = fox.Navigator.get(0) === false ? "/home" : "/" + fox.Navigator.get(0);
      data.added = new Date().getTime();
      data.event = "pageview";
      data.b64message = btoa(JSON.stringify({ page: encodeURIComponent(page) }));
      api.psend(data);
    }
  }, "Site_Layout");
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Splash */
(function(fox) {
	'use strict';
	
	fox.registerWidget('Layout_Splash', {
		configure: function () {
			this.registerOptions('', {
				'widgets.footer.widget': 'Site_Footer'
			})
		
			this.callParent('configure', arguments);
		}

	}, 'Site_Layout');
	
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Layout_Stateoff', {
		configure: function () {
			this.registerOptions('', {
				
			})
		
			this.callParent('configure', arguments);
		}

	}, 'Site_Layout');
	
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {
	
	var	_;

	_ = {
		cleanUnusedData: function () {
			this.unusedDataLabelTimer = setTimeout(fox.bind(function () {
				this.resetCollection();
			}, this), this.getOption('cleanUnusedDataTime'));
		},

		initDatalayer: function () {
			var
				dl;

			this.embedWidgetsFromOptions();

			dl = this.wom1('.Datalayer');

			if (dl) {
				this.dl = dl;
			} else if (this.getParent().dl) {
				this.dl = this.getParent().dl;
			}

			if (!this.dl.isRun()) {
				this.dl.run();
			}

			if (!fox._isNewfe) {
				this.dl.addFields(fox.Zen(this.requireOption('tpl.row'), 'prepare').plainVariables);
			} else {
				this.dl.addFields(this.getTemplater(this.getOption('tpl.row')).getPlainVariables());
			}
			this.dl.initPagerMode();
		},

		loadData: function (pageNumber) {
			this.waitEvent(this.dl, 'loaded', fox.bind(function (p, dl) {
				this.resetCollection(dl.getCollection());

				if (dl.getPagerData().next !== 0) {
					_.loadNext.call(this);
				}
			}, this));

			if (pageNumber === undefined) {
				this.dl.load();
			} else {
				this.dl.changePage(pageNumber);
			}
		},

		loadNext: function () {
			var
				pagerData = this.dl.getPagerData();

			if (pagerData.cp !== pagerData.total) {
				this.waitEvent(this.dl, 'loaded', fox.bind(function (p, dl) {
					this.bufData = dl.getCollection();
				}, this));

				this.dl.nextPage();
			}
		}
	};

	fox.registerWidget('LazyDataList', {

		configure: function () {
			this.originalData = [];

			this.registerOptions('', {
				cleanUnusedDataTime: 1000 * 60 * 10,
				notOverrideListBehavior: true
			});

			this.callParent('configure', arguments);
		},

		preparing: function () {
			this.callParent('preparing', arguments);

			_.initDatalayer.call(this);
		},

		init: function () {
			this.callParent('init', arguments);

			this.bufData = [];
		},

		running: function () {
			this.callParent('running', arguments);

			_.loadData.call(this);
		},

		activate: function () {
			this.callParent('activate', arguments);

			if (this.getLength() === 0) {
				_.loadData.call(this, 1);
			}

			clearTimeout(this.unusedDataLabelTimer);
		},

		deactivate: function () {
			this.callParent('deactivate', arguments);

			this.originalData = this.getOriginalData();
			_.cleanUnusedData.call(this);
		},

		loadMoreData: function () {
			this.appendItem(this.bufData);
			this.bufData = [];

			if (this.dl._loadStatus == 'loading') {
				this.waitEvent(this.dl, 'loaded', fox.bind(function () {
					this.loadMoreData();
				}, this));
			} else {
				_.loadNext.call(this);
			}
		},

		loadData: function () {
			_.loadData.apply(this, arguments);

			return this;
		},

		setTags: function (tags) {
			this.dispatchEvent('tagsApplied', tags);

			if (tags.length) {
				this.dl.setTransitParameter('tags', tags.join(','));

				return;
			}

			this.dl.clearTransitParameters('tags');
		},

		applyTagsFilter: function (tags) {
			this.dl.setOffset(0);
			this.dl.setCp(1);

			this.setTags(tags);
		},

		filterByTags: function (tags) {
			this.applyTagsFilter(tags);
			this.originalData = this.getOriginalData();

			_.loadData.call(this);
		},

		generateContentLink: function () {
			var contentTypes = {
				3: 'scene',
				20: 'scene', //liveshow
				11: 'gallery'
			};

			fox.each(this.dl.getCollection(), function (data) {
				var accessibility = fox.objectGet(data.accessibility, ['collection', data.id].join('.'))
				var arr = [];

				if (!contentTypes[data.contentType]) {
					console.warn('no such content type for direct link')
				}

				arr = ['/', contentTypes[data.contentType], '/', data.id];

				if (fox.isSet(data.title)) {
					arr.push('/')
					arr.push(fox.utils.toNavigatorAlias(data.title));
				};

				if (!fox.site.member && accessibility.previewsForGuests === 0) {
					arr = [fox.getEnv('siteProps.ubs.joinUrl')];
				};

				data.generatedContentLink = arr.join('');
			}, this);
		}

	}, 'AdvancedList');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// LazyLoad Widget

(function (fox, $) {
	
	fox.registerWidget('LazyLoad', {

		configure: function () {
			this.registerOptions('', {
				checkScrollingStatusTime: 500,
				handleWom: {
					scrollStop: {
						event: 'scrollStop',
						widget: '@this',
						callback: 'scrollStopHandler'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this._window = window;
			this._currentWindowPosition = this._window.scrollY;
			this._dinamycValues = [];
			this._scrollStatus = false;

			this.addDomHandler({
				event: 'scroll',
				target: document,
				callback: 'scrollingHandler'
			}, 'scrolling')
		
			this.callParent('init', arguments);
		},

		scrollingHandler: function (el, alias, performer, event) {;

			if (!this._dinamycValues.length) {

			}

			this._dinamycValues.push(this._window.scrollY);
		},

		scrollStopHandler: function () {
			
			this._clearDinamyc();
		},

		_clearDinamyc: function () {
			this._dinamycValues = [];
		},


	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// LiveshowChecker Widget

(function (fox, $) {
	'use strict';
	
	fox.registerWidget('LiveshowChecker', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					api1: {
						widget: 'Api',
						method: 'Liveshow.getStarted',
						sendTimezone: true,
						handleWom: {
							success: {
								event: ['success', 'error', 'failure'],
								widget: '@this',
								callback: '@parent:apiSuccess'
							}
						}
					},
					api2: {
						widget: 'Api',
						method: 'content.load',
						cacheChannel: 'content',
						sendTimezone: true,
						handleWom: {
							success: {
								event: ['success', 'error', 'failure'],
								widget: '@this',
								callback: '@parent:apiSuccess'
							}
						}
					}
				},
				handleWom: {
					liveshowModelConnected: {
						event: 'inboxSocketEventLiveshow:connect',
						widget: '@root #socket',
						callback: 'checkLiveshowGetStarted'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.api1Status = false;
			this.api2Status = false;

			this.embedMenuLink();
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.ml = this.rwom1('#menuLink');
			this.ml._readyToRender = false;

			this.checkLiveshowGetStarted();
		
			this.callParent('running', arguments);
		},

		activate: function () {
			this.renderMenuLink();
			
			this.callParent('activate', arguments);
		},

		embedMenuLink: function () {
			this.ml = this.embedWidget('menuLink', 'Widget', fox.merge({
				autoRender: false,
				'embed.location': 'under'
			}, this.getOption('menuLink')));

			return this;
		},

		checkLiveshowGetStarted: function () {
			var api;

			this.api1Status = false;

			if ((api = this.wom1('#api1'))) {
				api.send();
			}
		},

		checkLiveshowRecorded: function () {
			var api;

			this.api2Status = false;

			if ((api = this.wom1('#api2'))) {
				api.send({
					transitParameters: {preset: 'recordedLiveshows'}
				});
			}
		},

		apiSuccess: function (res, p, eventName) {
			if (fox.inArray(['error', 'failure'], eventName)) {
				res = res.answer;
			} else {
				res = res.answer.response;
			}

			switch (p.getAlias()) {
				case 'api1': 
					if (res.success &&
						fox.inArray(['inited', 'next_liveshow'], res.success.status) ||
						res.id && res.sign) {
						this.api1Status = true;
					} else {
						this.checkLiveshowRecorded();
					}

					break;
				case 'api2':
					this.api2Status = fox.objectGet(res, 'isExists');
					break;
			}

			this.renderMenuLink();
		},

		isLiveshowAvailable: function () {
			return (this.api1Status || this.api2Status) && !this.ml.isEmbedded();
		},

		renderMenuLink: function () {
			if (this.isLiveshowAvailable() === true) {
				this.ml.render();
			}
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

module.exports = function (fox) {
  var _require = __webpack_require__(16)(fox),
      delay = _require.delay;

  __webpack_require__(848)(fox);

  fox.registerWidget('LiveShowViewer', {
    requireResources: function requireResources() {
      return new fox.Promise(function (resolve) {
        return __webpack_require__.e/* require.ensure */(0).then((function () {
          resolve(fox._liveshowController = __webpack_require__(1286));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    configure: function configure(options) {
      this.registerOptions('', {
        playerWidget: '#banner',
        playerContainerId: 'flash-player-liveshow',
        streamatePopup: false,
        popupAddClass: false,
        widgets: {
          banner: {
            widget: 'Widget',
            manualRender: true,
            'embed.container': '#liveshow-banner-container',
            template: 'liveshowBanner',
            'hooks.onStartRendering': function hooksOnStartRendering() {
              if (this.getParent().mDeviceDetect()) {
                this.templateOptions.mobile = 'mobile-detect';
              }
            }
          },
          timer: {
            widget: 'JQTimer',
            'embed.widget': '@parent #banner',
            'embed.container': '.show-start-time',
            autoRender: false,
            'handleWom.timerStopHandler': {
              callback: '@parent:checkLiveShows'
            },
            'handleWom.addedToDom': {
              widget: '@this',
              event: 'addedToDom',
              callback: '@parent:customizeCounter'
            }
          }
        },
        handleWom: {
          modelConnected: {
            event: 'inboxSocketEventLiveshow:connect',
            widget: '@root #socket',
            callback: 'modelConnected'
          },
          failureStartApiResponse: {
            widget: '#getStartedLiveshowApi',
            event: ['failure', 'false'],
            callback: 'failureStartApiHandler'
          },
          playerRendered: {
            event: 'playerRendered',
            widget: '@this',
            callback: function callback() {
              var tipmeContainer = fox.dom.selectFirst('#tipme-form');
              if (!!tipmeContainer) {
                tipmeContainer.parentElement.style.display = '';
              }
            },
            'params.alwaysActive': true
          },
          restartLiveshow: {
            event: 'restartLiveshow',
            widget: '#lsTranslator',
            callback: 'checkLiveShows'
          },
          requestError: {
            event: 'paid_request_error',
            widget: '#lsTranslator',
            callback: 'onRequestError'
          }
        }

      });

      this.callParent('configure', arguments);
    },


    init: function init() {
      this.embedWidget('liveshowPopup', 'Dialog', {
        template: '',
        useUiPosition: false,
        preventHideOnShadowClick: true,
        dialog: {
          title: 'Live Show',
          width: 985,
          dialogClass: this.getOption('popupAddClass'),
          closeText: ''
        },
        'widgets.player': {
          widget: 'Widget',
          autoRender: true,
          template: this.getOption('player.template') || 'defaultPlayer',
          'templateOptions.playerContainerId': this.getOption('playerContainerId')
        }
      });

      this.callParent('init', arguments);
    },

    running: function running() {
      this.callParent('running', arguments);
      this.checkLiveShows();
    },

    activate: function activate() {
      this.callParent('activate', arguments);
      this.checkLiveShows();
    },

    checkLiveShows: function checkLiveShows(sessionId, waitResp) {
      var _this = this;

      var params = sessionId ? { id: sessionId } : {};
      var promise = this.getApi('getStartedLiveshowApi', {
        method: 'Liveshow.getStartedConfiguration',
        sendTimezone: true
      }).psend(params);

      if (waitResp !== true) return promise.then(function () {
        return _this.successStartApiHandler.apply(_this, arguments);
      }).catch(function (e) {
        return fox.exception(e);
      });

      return promise;
    },
    getLsTranslator: function getLsTranslator() {
      return this.wom1('#lsTranslator');
    },
    removeLSTranslator: function removeLSTranslator() {
      var t = this.getLsTranslator();

      if (t && t.isEmbedded()) {
        t.removeFromDom();
      }

      return this;
    },
    successStartApiHandler: function successStartApiHandler(_ref) {
      var data = _ref.params;
      var response = data.answer.response;

      var banner = this.wom1('#banner');
      /**
       * Еретик, @Kratos -янчик, что это за ересь написана? :-)
       */
      // const banner = this.wait('#banner', 'addedToDom').then(function() {
      // 	this.wom1('#banner')
      // }.bind(this));
      var tplOptions = {
        addVars: { 'private': 0 },
        success: {},
        liveShowAllowed: false,
        isStreamateUser: this.isStreamateUser()
      };

      if (response === false) {
        tplOptions.success.status = 'no_liveshow';
        this.renderBanner(tplOptions);

        return this.removeLSTranslator();
      }

      tplOptions.addVars = { private: response.addVars.private };

      var sign = response.sign,
          host = response.host,
          id = response.id,
          streamName = response.streamName,
          stunServer = response.stunServer;


      if (sign) {
        if (banner && banner.isEmbedded()) banner.removeFromDom();

        tplOptions.success.status = 'inited';
        tplOptions.liveShowAllowed = true;

        if (!response.addVars.streamate && this.isStreamateUser()) {
          tplOptions.liveShowAllowed = false;
        }

        this.setOption('connectParams', {
          id: id,
          sign: sign,
          host: host,
          streamName: streamName,
          stunServer: stunServer
        });

        if (response.addVars.private) {
          this.setOption('connectParams.private', true);
        } else if (response.addVars.paid) {
          this.setOption('connectParams.paid', true);
        }

        if (response.addVars.trustedHash) {
          this.setOption('connectParams.trustedHash', response.addVars.trustedHash);
        }

        var settings = _extends({}, response);

        if (response.addVars.amount && response.addVars.period) {
          settings = fox.mixin(settings, {
            amount: response.addVars.amount,
            period: response.addVars.period,
            rateId: response.addVars.rateId
          });
        }

        this.setOption('liveshowSettings', settings);

        return this.renderNewPlayer(1);
      }

      tplOptions.success.status = response.success.status;

      //streamate
      if (fox.site.member && response.success.status == "inited") {
        if (!response.addVars) {
          this.renderBanner(tplOptions);

          return this.removeLSTranslator();
        }

        //online
        if (fox.objectGet(response, 'addVars.streamate.status') === "online") {
          if (this.getOption('streamatePopup') === true) {

            if (!this.isStreamateUser()) {
              var w = this.rwom1('#liveshowPopup #player');

              w.setOption('template', 'streamate_iframe');
              w.setTemplateOptions('link', response.addVars.streamate.link);
              w.render();

              this.rwom1('#liveshowPopup').show();
            }
          } else {
            var w = this.rwom1('#banner');

            w.setOption('template', 'streamate_iframe');
            this.renderBanner({ link: fox.objectGet(response, 'addVars.streamate.link') });
          }
        }

        return this.removeLSTranslator();
      }

      //private liveshow not allowed
      if (fox.site.member && response.success.status == 'private') {
        tplOptions.success.status = 'inited';
        tplOptions.addVars.private = 1;
      }

      if (response.success && response.success.status == 'next_liveshow') {
        var startDate = this.parseDate(response.addVars.startDate);
        var difference = fox.utils.getRemainingTime(startDate);
        var formatedDate = this.formatDate(startDate);
        this.rwom1('#timer').counterStart(difference);

        tplOptions.addVars = fox.clone(response.addVars);

        if (this.getOption('dontFormatStartData') !== true) {
          tplOptions.addVars.startDate = formatedDate;
        }

        if (startDate < new Date()) {
          tplOptions.success.status = 'delay';
        }

        tplOptions.googleCalendarLink = this.generateGoogleLink(response);
      }

      this.renderBanner(tplOptions);

      return this.removeLSTranslator();
    },
    renderBanner: function renderBanner(opts) {
      return this.rwom1('#banner').setTemplateOptions(opts).render();
    },
    failureStartApiHandler: function failureStartApiHandler() {
      var result = { success: { status: 'no_liveshow' } };

      this.rwom1('#banner').setTemplateOptions(result).render();
    },
    renderNewPlayer: function renderNewPlayer(render) {
      var _this2 = this;

      var renderPlayer = void 0;

      if (fox.getEnv('restrictNotStreamate') == 1) return;

      if (fox.isObject(render)) return;

      renderPlayer = render;

      if (this.getOption('streamatePopup') === true && renderPlayer != 1) return;

      var fv = _extends({}, this.getOption('connectParams'));

      delete this.options.connectParams.paid;
      delete this.options.connectParams.private;
      delete this.options.connectParams.trustedHash;

      var embedFlash = function embedFlash(connectParams) {
        var lsTranslator = _this2.getLsTranslator();

        var promise = _this2.wait('#lsTranslator', 'addedToDom');

        if (!lsTranslator) {
          lsTranslator = _this2.embedWidget('lsTranslator', 'ClientLSTranslator', {
            'embed.container': '#' + _this2.getOption('playerContainerId')
          });

          lsTranslator.setConnectParams(connectParams).run();
        } else if (!lsTranslator.isActive()) {
          lsTranslator.cleanConnectParams().setConnectParams(connectParams).activate();
        } else {
          lsTranslator.cleanConnectParams().setConnectParams(connectParams).render(true);
        }

        lsTranslator.setLiveshowSettings(_this2.getOption('liveshowSettings'));

        _this2.playerStarted = true;

        return promise;
      };

      return embedFlash(fv).then(function (resp) {
        return resp !== false && _this2.dispatchEvent('playerRendered');
      });
    },


    customizeCounter: function customizeCounter(obj, scope) {
      obj = {
        0: 'days',
        2: 'hours',
        4: 'minutes',
        6: 'seconds'
      };
      fox.each(obj, function (val, key) {
        scope._counter.find('.part' + key).append('<div>' + val + '</div>');
      });
    },

    formatDate: function formatDate(d) {
      var date = new Date(d);

      var hours = date.getHours(),
          minutes = date.getMinutes(),
          half = 'AM',
          locales = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },
          result = '';

      if (hours >= 12) {
        hours -= 12;
        half = 'PM';
      }

      if (minutes < 10) {
        minutes = '0' + minutes;
      }

      result = locales.days[date.getDay()] + ', ' + locales.month[date.getMonth()] + ' ' + date.getDate() + ', ' + hours + ':' + minutes + ' ' + half;

      return result;
    },
    parseDate: function parseDate(time) {
      var d = fox.utils.dateFormat('%Y,%m,%e,%H,%M,%S', time).split(',');

      return new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5]);
    },
    mDeviceDetect: function mDeviceDetect() {
      var platform = window.navigator.userAgent;
      var mDevices = [{ device: 'Android', platform: /Android/ }, { device: 'iPhone', platform: /iPhone/ }, { device: 'iPad', platform: /iPad/ }, { device: 'Symbian', platform: /Symbian/ }, { device: 'Windows Phone', platform: /Windows Phone/ }, { device: 'Tablet OS', platform: /Tablet OS/ }];

      return mDevices.some(function (_ref2) {
        var itemPlatform = _ref2.platform;
        return itemPlatform.test(platform);
      });
    },


    deactivate: function deactivate() {
      this.callParent('deactivate', arguments);

      var indx = this._reactivationPool.indexOf('lsTranslator');

      if (indx !== -1) {
        this._reactivationPool.splice(indx, 1);
      }
    },

    isStreamateUser: function isStreamateUser() {
      return fox.getEnv('restrictNotStreamate') === true;
    },

    modelConnected: function modelConnected() {
      var _this3 = this;

      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          sessionId = _ref3.answer.message;

      return delay(2000).then(function () {
        return _this3.checkLiveShows(null, true);
      }).then(function (resp) {
        var data = resp.params.answer.response;

        if (data.id !== sessionId) return _this3.checkLiveShows(sessionId);

        _this3.successStartApiHandler(resp);

        return true;
      }).catch(function () {
        var translator = _this3.getLsTranslator();

        if (translator.isEmbedded()) {
          translator.removeFromDom();
        }
      });
    },
    generateGoogleLink: function generateGoogleLink(resp) {
      var data = {};
      var startDate = void 0,
          finishDate = void 0,
          description = void 0,
          title = void 0;

      finishDate = fox.objectGet(resp, 'addVars.finishDate');

      if (!finishDate || finishDate === '0000-00-00' || finishDate === '0000-00-00 00:00:00') {
        finishDate = null;
      }

      if (startDate = fox.objectGet(resp, 'addVars.startDate')) {
        data['dates'] = fox.utils.dateFormat('%Y%m%dT%H%M%SZ', startDate);
      }

      data['dates'] = [data['dates'], fox.utils.dateFormat('%Y%m%dT%H%M%SZ', finishDate || startDate)].join('/');

      if (title = fox.objectGet(resp, 'addVars.title')) {
        data['text'] = title + ': liveshow by ' + fox.getEnv('screenName');
      }

      if (description = fox.objectGet(resp, 'addVars.description')) {
        data['details'] = description;
      }

      data['location'] = [window.location.origin, 'liveshow'].join('/');

      return fox.utils.generateGoogleCalendarLink(data);
    },


    onRequestError: function onRequestError(params) {
      var popup = this.wom1('#errorPopup');

      if (!popup) {
        popup = this.embedWidget('errorPopup', 'Popup_Common', {
          'widgets.content': {
            template: 'paid_request_error',
            templateOptions: { error: params.answer.code },
            'handleDom.close': {
              target: '#close'
            }
          }
        });
        popup.run();
      }

      return popup.show();
    }
  }, 'Controller');
};

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("defaultplayer", [["div",{"class":"form-container"},[["div",{"id":""},[],[["playerContainerId","id",true]]],["div",{"style":"display: none;text-align: center;"},[["div",{"id":"tipme-form","class":"tipme-container","style":"display:inline-block;"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	
	fox.registerWidget('LiveshowCounterBanner', {

		configure: function () {
			this.registerOptions('', {
				autoRender: false,
				customizeCounter: true,
				customizeCounterShort: false,
				dontReuseSn: true,
				widgets: {
					timer: {
						widget: 'JQTimer',
						autoRender: false,
						'handleWom.timerStopHandler.callback': '@parent:checkLsStatus',
						'handleWom.addedToDom': {
							widget: '@this',
							event: 'addedToDom',
							callback: '@parent:customizeCounter'
						}
					},
					checkLsApi: {
						widget: 'Api',
						method: 'Liveshow.getStarted',
						sendTimezone: true,
						'handleWom.checkLsApiRes': {
							event: ['success', 'error', 'failure', 'false'],
							widget: '@this',
							callback: '@parent:checkLsApiRes'
						}
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this._readyToRender = false;
			this.ls = fox.utils.localStorage;
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.checkLsStatus();
			this.callParent('running', arguments);
		},

		checkLsStatus: function () {
			this.rwom1('#checkLsApi').send({}, false);
			return this;
		},

		rendering: function () {
			this.setTemplateOptions(this.tplOptions);
			this.callParent('rendering', arguments);
		},

		addedToDom: function () {
			return this.renderCounter();
		},

		activate: function () {
			this.checkLsStatus();
			this.callParent('activate', arguments);
		},

		isActualStartDate: function () {
			return new Date(this.tplOptions.addVars.startDate).getTime() - new Date().getTime() > 0;
		},

		renderCounter: function () {
			return this.rwom1('#timer').counterStart(fox.utils.getRemainingTime(this.tplOptions.addVars.startDate));
		},

		checkLsApiRes: function (res) {
			res = res.answer;
			
			if (res.response == false || !res.response.addVars.startDate || res.response.success.status == 'no_liveshow') {
				this.removeFromDom();
				return;
			}

			if (res.status === true
				&& res.response.success
				&& res.response.success.status === 'next_liveshow') {
				this.ls('setItem', '_lls_', [res.response.addVars.id, new Date(res.response.addVars.startDate).getTime() + 1000 * 60 * 30].join('_'));

				this.tplOptions = res.response;
				this.tplOptions.googleCalendarLink = this.generateGoogleLink(res.response);
				this.render();
			}
		},

		generateGoogleLink: function (resp) {
			var data = {};
			var startDate, finishDate, description;

			finishDate = fox.objectGet(resp, 'addVars.finishDate');

			if (!finishDate || (finishDate === '0000-00-00' || finishDate === '0000-00-00 00:00:00')) {
				finishDate = null;
			}

			if (startDate = fox.objectGet(resp, 'addVars.startDate')) {
				data['dates'] = fox.utils.dateFormat('%Y%m%dT%H%M%SZ', startDate);
			}

			data['dates'] = [data['dates'], fox.utils.dateFormat('%Y%m%dT%H%M%SZ', (finishDate || startDate))].join('/');

			if (title = fox.objectGet(resp, 'addVars.title')) {
				data['text'] = title + ': liveshow by ' + fox.getEnv('screenName');
			}

			if (description = fox.objectGet(resp, 'addVars.description')) {
				data['details'] = description;
			}

			data['location'] = [window.location.origin, 'liveshow'].join('/');

			return fox.utils.generateGoogleCalendarLink(data);
		},

		customizeCounter: function (obj, scope) {
			if (!this.getOption('customizeCounter')) {
				return;
			}

			var customizeCounterClass = this.getOption('customizeCounterClass') || '';
			var customizeCounterShort = this.getOption('customizeCounterShort');

			if (customizeCounterClass.length) {
				customizeCounterClass = ' class=' + customizeCounterClass;
			}

			obj = [
			{
				0: 'days',
				2: 'hours',
				4: 'minutes',
				6: 'seconds'
			},
			{
				0: 'days',
				2: 'hours',
				4: 'mins',
				6: 'secs'
			}];

			fox.each((customizeCounterShort ? obj[1] : obj[0]), function (val, key) {
				scope._counter.find('.part' + key).append('<div' + customizeCounterClass + '>' + val + '</div>');
			});
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';
	var Promise = fox.RSVP.Promise;

	var storage = new fox.LocalStorageObjectService({
		lsLabel: '_smas_',
		cleanCheckInterval: 1000 * 60 * 60 * 24 * 15
	});

	var result = null;

	function checker (menuItem, key, _this) {
		var storageValue = fox.objectGet(storage.getItem(fox.site.member ? 'blog_member' : 'blog_guest'), 'value');

		if (fox.isUndefined(storageValue)) {
			var dl = fox.createDataLayer().setMethod('blog.get').addFields(['id']).setMetaFields(['totalCount']);
		
			dl._wrappedMethods = {};
			dl.wrapMethod('load');
			dl.setOption('cacheChannel', 'content');

			_this.getEm().handleHook(dl, 'onStartLoad', function () {
				if (!fox.site.member) dl.setTransitParameter('notMember', 1);

				return true;
			}.bind(this));
		} else {
			result = storageValue;
		}
		
		return result === null && new Promise(function (resolve) {
			this.wait(dl, 'loaded').then(function () {
				result = dl.getCount() !== 0;

				storage.setItem(fox.site.member ? 'blog_member' : 'blog_guest', {value: result});

				return resolve(result);
			});

			dl.load();
		}.bind(_this)) || result;
	}

	fox.registerOptions('~.Menu_Main', {
		'pattern.blogChecker.checkers.hasBlogs': {
			callback: checker,
			async: true
		}
	}, 1, {});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	var Promise = fox.Promise;
	var result = null;

	function checker (ctx) {
		var _this = ctx;

		return function () {
			var api1 = _this.getApi('checkGetStarted', {
				method: 'Liveshow.getStarted',
				sendTimezone: true
			});
			var api2 = _this.getApi('content.get', {
				method: 'content.load',
				cacheChannel: 'content'
			});

			function checkLiveshowGetStarted () {
				return new Promise(function (resolve) {
					api1.psend({
						random: Math.random()
					}).then(function (resp) {
						var res = fox.objectGet(resp, 'params.answer.response') || {};

						return resolve(fox.inArray(['inited', 'next_liveshow'], fox.objectGet(res, 'success.status')) ||
							!!(res.id && res.sign));
					}).catch(function () {resolve(false);});
				});
			}

			function checkLiveshowRecorded () {
				return new Promise(function (resolve) {
					api2.psend({
						transitParameters: {preset: 'recordedLiveshows'}
					}).then(function (resp) {
						return resolve(fox.objectGet(resp, 'params.answer.response.isExists'));
					}).catch(function () {resolve(false);});
				});
			}
			
			return result === null && Promise.all([
				checkLiveshowGetStarted(),
				checkLiveshowRecorded()
			]).then(function (results) {
				result = results.some(function (res) {
					return res;
				});

				return result;
			}) || result;
		};
	}

	var id = fox.uniqid();
	var handlerAlias = 'handleWom.onInited' + id;
	var options = {};

	options[handlerAlias] = {
		event: 'running',
		widget: '@this',
		'params.prefix': 'menuChecker' + id,
		callback: function () {
			this.addChecker('liveshowChecker', checker(this), true);

			this.handleEvent('@root #socket', 'inboxSocketEventLiveshow:connect', function () {
				result = null;

				return this.runAsyncCheckers()
					.then(this._rebuildMenu.bind(this));
			}.bind(this), {prefix: 'invalidateResult'});
		}
	};

	fox.registerOptions('~.Menu_Main', options, 1, {});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	var Promise = fox.RSVP.Promise;
	var storage = new fox.LocalStorageObjectService({
		lsLabel: '_smas_',
		cleanCheckInterval: 1000 * 60 * 60 * 24 * 15
	});

	var storageValue = fox.objectGet(storage.getItem('tips'), 'value');

	var result = fox.isUndefined(storageValue) ? null : storageValue;

	function checker (menuItem, key, _this) {
		var api = _this.getApi('checkTips', {
			method: 'tips.getTipsCount',
			cacheChannel: 'site',
			sendTimezone: true
		});
		
		return result === null && new Promise(function (resolve) {
			return api.psend().then(function (resp) {
				result = fox.objectGet(resp, 'params.answer.response') > 0;

				if (fox._isNewfe) api.destroy();

				storage.setItem('tips', {value: result});

				return resolve(result);
			}).catch(function () {resolve(false);});
		}.bind(_this)) || result;
	}

	fox.registerOptions('~.Menu_Main', {
		'pattern.tipsChecker.checkers.hasTipOptions': {
			callback: checker,
			async: true
		}
	}, 1, {});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox, $) {
	'use strict';

	var Promise = fox.Promise;

	function wrapChecker(checker) {
		return function () {
			var res = checker.apply(this, arguments);

			return res instanceof Promise && res || Promise.resolve(res);
		};
	}

	var getMaxDiscount = __webpack_require__(26)(fox);

	fox.registerWidget('Menu_Main', {
		configure: function configure() {
			this.registerOptions('', {
				autoRender: true,
				template: 'app_menu',
				menuMoreTemplate: 'app_menu_more',
				'embed.container': '#main-menu-wrapper',
				disableMore: false,
				dontReuseSn: true,
				'templateOptions.maxDiscount': getMaxDiscount(),
				pattern: {
					home: {
						position: 10,
						title: 'Home',
						url: '/'
					},
					about: {
						position: 80,
						title: 'About me',
						url: '/about'
					},
					activity: {
						position: 20,
						title: 'Calendar',
						url: '/activity'
					},
					videos: {
						position: 30,
						title: 'Videos',
						url: '/videos'
					},
					photos: {
						position: 40,
						title: 'Photos',
						url: '/photosets'
					},
					liveshowChecker: {
						position: 50,
						title: 'Live shows',
						url: '/liveshow'
					},
					tipsChecker: {
						position: 70,
						title: 'Tip Me',
						url: '/tips'
					},
					wishList: {
						position: 100,
						title: 'Wish List',
						url: fox.getEnv('wishlistUrl'),
						target: '_blank',
						'checkers.wishList': {
							callback: function (menuItem, key) {
								var url = menuItem.url;

								if (url) {
									if (!/^https?:\/\//.test(url)) {
										url = 'http://' + url;

										if (menuItem.url !== url) {
											var node = this._getMenuItem(key);
											var link = node && node.querySelector('a');

											if (link) {
												link.setAttribute('href', url);
											}
										}

										menuItem.url = url;
									}
								}

								return !fox.isEmpty(url);
							}.bind(this)
						}
					},
					blogChecker: {
						position: 110,
						title: 'Blog',
						url: '/blog'
					},
					skypeMe: {
						position: 80,
						title: 'Skype me',
						target: '_blank',
						url: fox.getEnv('modelProps.skyprivateLink'),
						'checkers.skypeMe': {
							callback: function callback() {
								return fox.getEnv('modelProps.skyprivateLink') && !fox.getEnv('restrictNotStreamate');
							}
						}
					},
					callme: {
						position: 90,
						title: 'Call me',
						url: '/callme',
						'checkers.callme': {
							callback: function callback() {
								return !fox.isEmpty(fox.getEnv('modelProps.verifyProfile'));
							}
						}
					}
				},
				userAction: {
					login: {
						position: 0,
						title: 'Login',
						url: '/login'
					},
					join: {
						position: 10,
						title: 'Join me',
						url: '/join'
					}
				},
				limits: {
					minWidth: 768
				},
				enableResize: true,
				onResizeTimeout: 300
			});

			this.callParent('configure', arguments);
		},

		init: function init() {
			this._checkers = {};
			this._moreMenu = {};
			this._menu = this.getOption('pattern');
			this._userAction = this.getOption('userAction');
			this._refsToNodes = {};

			this._registerCheckersFromOptions();

			if (this.getOption('enableResize')) {
				$(this.window).on('resize', { ctx: this }, this._onResize);
			}

			this.callParent('init', arguments);
		},

		activate: function activate() {
			if (this.getOption('enableResize')) {
				$(this.window).on('resize', { ctx: this }, this._onResize);
			}

			this.callParent('activate', arguments);
		},

		deactivate: function deactivate() {
			if (this.getOption('enableResize')) {
				$(this.window).off('resize', this._onResize);
			}

			this.callParent('deactivate', arguments);
		},

		/**
   * [addChecker description]
   * @param {string} menuAlias [description]
   * @param {function} checker   [description]
   * @param {boolean} _async
   * @return {object} this
   */
		addChecker: function addChecker(menuAlias, checker, _async) {
			if (!(menuAlias in this._checkers)) {
				this._checkers[menuAlias] = {};
			}

			if (_async === true) {
				if ('async' in this._checkers[menuAlias]) {
					this._checkers[menuAlias].async.push(wrapChecker(checker));
				} else {
					this._checkers[menuAlias].async = [wrapChecker(checker)];
				}
			} else {
				if ('sync' in this._checkers[menuAlias]) {
					this._checkers[menuAlias].sync.push(checker);
				} else {
					this._checkers[menuAlias].sync = [checker];
				}
			}

			this._menu[menuAlias].waiting = true;

			return this;
		},

		clearChecker: function clearChecker(menuAlias, _async) {
			if (menuAlias in this._checkers) {
				if (_async === true) {
					if ('async' in this._checkers[menuAlias]) {
						this._checkers[menuAlias].async = [];
					}
				} else {
					if ('sync' in this._checkers[menuAlias]) {
						this._checkers[menuAlias].sync = [];
					}
				}
			}

			return this;
		},

		rendering: function rendering() {
			this._runCheckers();

			var sorted = this._sortMenu(this._menu);

			this.setTemplateOptions('baseLinks', sorted);
			this.setTemplateOptions('userAction', this._userAction);

			this.callParent('rendering', arguments);

			this._renderLinks(sorted, this._getMenuItem.bind(this));
		},

		embedToDom: function embedToDom() {
			var _this = this;

			this.callParent('embedToDom', arguments);

			this._rebuildMenu();

			this._getMenus().forEach(function (menu) {
				fox.getObjectKeys(menu).forEach(function (key) {
					if ('waiting' in menu[key]) {
						var item = _this._getMenuItem(key);

						item.style.opacity = 0.5;
					}
				});
			});

			this.runAsyncCheckers().then(this._rebuildMenu.bind(this));
		},

		runAsyncCheckers: function runAsyncCheckers() {
			return Promise.all(this._runCheckers(true));
		},

		addMenuItem: function addMenuItem(alias, data, refresh) {
			this._menu[alias] = data;

			return refresh && this.render();
		},

		_onResize: function _onResize(e) {
			var _this = e.data.ctx;

			clearTimeout(_this.resizeTimeout);
			_this.resizeTimeout = setTimeout(function () {
				if (this._getViewPortWidth() < this.getOption('limits.minWidth')) {
					this._reset();
				}

				this.render();
			}.bind(_this), _this.getOption('onResizeTimeout'));
		},

		_registerCheckersFromOptions: function _registerCheckersFromOptions() {
			fox.mapObject(this.getOption('pattern'), function (value, key) {
				var checkers = value.checkers;

				if (checkers) {
					delete value.checkers;

					fox.each(checkers, function (checker) {
						this.addChecker(key, checker.callback, checker.async);
					}, this);
				}
			}, this);
		},

		_reset: function _reset() {
			this._menu = fox.merge({}, this._menu, this._moreMenu);
			this._moreMenu = {};
			this._refsToNodes = {};

			return this;
		},

		_renderLinks: function _renderLinks(menu, getItemContainer) {
			menu.forEach(function (item) {
				var key = item.alias;
				var container = getItemContainer(key);
				var templater;

				[item.template, 'main_menu_item_' + key, 'main_menu_item_default'].some(function (value, idx) {
					var exist = fox.checkTemplate(value);

					if (exist || !fox.isEmpty(value) && idx === 0) {
						if (fox._isNewfe) {
							templater = this.getTemplater(value);
						} else {
							templater = fox.Zen(value, [item]);
						}

						return true;
					}
				}, this);

				if (!fox._isNewfe) {
					return container.appendChild(templater);
				}

				return templater && container.appendChild(templater.setData(item).compile());
			}, this);
		},

		_rebuildMenu: function _rebuildMenu() {
			var _this = this;

			function getMenuWidth(menuKeys) {
				var moreItem = _this._getMenuItem('list-container');

				return menuKeys.reduce(function (prev, key) {
					var item = _this._getMenuItem(key);

					return $(item).is(':visible') ? prev + $(item).width() : prev;
				}, $(moreItem).width() + _this._getScrollWidth());
			}

			if (this.getOption('disableMore') || this._getViewPortWidth() < this.getOption('limits.minWidth')) {
				return this._moveToMoreLinks();
			}

			var moreLinksNode = this._getMenuItem('list-container');
			var container = this.rdom1('[fox-main-menu-container]');
			var cWidth = $(container).width();
			var menuKeys = this._sortMenu(this._menu).map(function (value) {
				return value.alias;
			});
			var maxLoopAmount = menuKeys.length;
			var moreMenuKeys = this._sortMenu(this._moreMenu).map(function (value) {
				return value.alias;
			});

			var menuWidth = getMenuWidth(menuKeys) + 10;

			if (menuWidth > cWidth) {
				while (menuWidth > cWidth && maxLoopAmount--) {
					var key = menuKeys.pop();
					var node = this._getMenuItem(key);
					var width = $(node).is(':visible') ? $(node).width() : 0;

					this._moreMenu[key] = fox.clone(this._menu[key]);

					delete this._menu[key];

					if (node.parentNode) {
						this._refsToNodes[key] = node.parentNode.removeChild(node);
					}

					menuWidth -= width;
				}
			} else {
				moreMenuKeys.some(function (key, idx, arr) {
					var insertedNode = container.insertBefore(this._refsToNodes[key], moreLinksNode);
					var menuWidth = getMenuWidth(menuKeys.concat(key));
					var itemWidth = $(insertedNode).width();
					var moreKeys = fox.getObjectKeys(this._moreMenu);

					function moveToMain(key) {
						this._menu[key] = fox.clone(this._moreMenu[key]);

						delete this._moreMenu[key];

						return true;
					}

					if (menuWidth < cWidth) {
						menuKeys.push(key);

						moveToMain.call(this, key);
					} else {
						if (this._getVisibleItemsAmount(this._moreMenu) === 1 && itemWidth < $(moreLinksNode).width()) {
							return moveToMain.call(this, key);
						}

						container.removeChild(insertedNode);

						return true;
					}
				}, this);
			}

			this._moveToMoreLinks();
		},

		_getVisibleItemsAmount: function _getVisibleItemsAmount(menu) {
			return fox.getObjectKeys(menu).filter(function (key) {
				return menu[key].display !== 'none';
			}).length;
		},

		_moveToMoreLinks: function _moveToMoreLinks() {
			var sorted = this._sortMenu(this._moreMenu);
			var container = this._getMenuItem('list-container');
			var templateName = this.getOption('menuMoreTemplate');
			var fragment;

			if (this._getVisibleItemsAmount(this._moreMenu) === 0) {
				if (container.parentNode) container.parentNode.removeChild(container);

				return false;
			}

			var moreLinksNode = this.dom1('[fox-main-menu-more-list]');

			if (moreLinksNode) {
				container.removeChild(moreLinksNode);
			}

			if (fox._isNewfe) {
				fragment = this.getTemplater(templateName).setData({
					additionalLinks: sorted
				}).compile();
			} else {
				fragment = fox.Zen(templateName, [{ additionalLinks: sorted }]);
			}

			this._renderLinks(sorted, function (key) {
				return fragment.querySelector('[fox-main-menu-list-item="' + key + '"]');
			}.bind(this));

			this.rwom1('@root #navi').addClickHandler(fragment, {
				draggable: !this.getOption('previewMode')
			});

			container.appendChild(fragment);
		},

		_getMenuItem: function _getMenuItem(alias) {
			return this.dom1('[fox-main-menu-item="' + alias + '"]') || this._refsToNodes[alias] || document.createElement('div');
		},

		_sortMenu: function _sortMenu(menu) {
			return fox.getObjectKeys(menu).map(function (key) {
				return fox.merge({ alias: key }, this._processAccess(menu[key]));
			}, this).sort(function (a, b) {
				return a.position > b.position ? 1 : a.position < b.position ? -1 : 0;
			});
		},

		_runCheckers: function _runCheckers(_async) {
			var _this = this;

			function resolve(results, key) {
				var res = results.every(function (res) {
					return res === true;
				});

				_this._toggleMenuItem(key, res);

				return res;
			}

			return fox.getObjectKeys(this._checkers).map(function (key) {
				var checkers = _this._checkers[key][_async === true ? 'async' : 'sync'];
				var menuItem;

				_this._getMenus().some(function (menu) {
					if (key in menu) {
						menuItem = menu[key];

						return true;
					}
				});

				if (fox.isArray(checkers)) {
					if (_async === true) {
						return Promise.all(checkers.map(function (checker) {
							return checker(menuItem, key, _this);
						})).then(function (results) {
							return resolve(results, key);
						});
					} else {
						return resolve(checkers.map(function (checker) {
							return checker(menuItem, key, _this);
						}), key);
					}
				}

				return false;
			});
		},

		_toggleMenuItem: function _toggleMenuItem(alias, show) {
			var item;
			var condition = this.getOption('hideOnLimit') && this._getViewPortWidth() < this.getOption('limits.minWidth');

			if (condition) {
				show = false;
			}

			if (this.isEmbedded() || this.fragment) {
				item = this._getMenuItem(alias);

				item.style.display = show ? 'inherit' : 'none';

				if (show) item.style.opacity = 1;
				if (condition) return false;
			}

			this._getMenus().some(function (menu) {
				if (alias in menu) {
					menu[alias].display = show ? 'inherit' : 'none';

					if (show) delete menu[alias].waiting;

					return true;
				}
			}, this);
		},

		_getMenus: function _getMenus() {
			return [this._menu, this._moreMenu];
		},

		_getViewPortWidth: function _getViewPortWidth() {
			return window.innerWidth || document.documentElement.clientWidth;
		},

		_getScrollWidth: function _getScrollWidth() {
			var scrollDiv = document.createElement('div');

			document.body.appendChild(scrollDiv);

			$(scrollDiv).css({
				width: '100px',
				height: '100px',
				overflow: 'scroll',
				position: 'absolute',
				top: '-10000px'
			});

			var scrollWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

			document.body.removeChild(scrollDiv);

			return scrollWidth;
		},

		_processAccess: function _processAccess(menuItem) {
			var app = this.rwom1('@root');

			if ('access' in menuItem) {
				switch (true) {
					case menuItem.access === 'member' && fox.isEmpty(app.member):
					case menuItem.access === 'guest' && !fox.isEmpty(app.member):
						menuItem.display = 'none';
						break;
				}
			}

			return menuItem;
		}
	});
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// MobileWelcome

(function (fox, $) {
	
	fox.registerWidget('MobileWelcome', {

		configure: function () {
			this.registerOptions('', {
				template: 'sitepage_home_welcome_video',
				'embed.container': '.welcome-block',
				autoRender: false,
				'widgets.api': {
					widget: 'Api',
					method: 'site.welcome.get',
					cacheChannel: 'site'
				},
				handleWom: {
					apiSuccessHandler: {
						event: 'success',
						widget: '#api',
						callback: 'apiSuccessHandler'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this
				.rwom1('#api')
				.send();
		
			this.callParent('running', arguments);
		},

		apiSuccessHandler: function (response) {
			if (response.answer.status === true && 
				!fox.isEmpty(response.answer.response)) {
				this
					.setTemplateOptions(response.answer.response)
					.render();
			}
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Model_Backlinks Widget

(function (fox, $) {

	var _ = {
		toggleElement: function (hide) {
			if (hide === true) {
				if (this._indom) {
					$(this.element).hide();
				} else {
					this.waitEvent(this, 'addedToDom', fox.bind(function () {
						_.toggleElement.call(this, true);
					}, this));
				}
			} else {
				if (this._indom) {
					if (!$(this.element).is(':visible')) {
						$(this.element).show();
					}
				} else {
					this.waitEvent(this, 'addedToDom', fox.bind(function () {
						_.toggleElement.call(this);
					}, this));
				}
			}
		}
	}
	
	fox.registerWidget('Model_Backlinks', {

		configure: function () {
			this.registerOptions('', {
				'embed.container': '#model-backlinks',
				template: 'model_backlinks_container',				
				autoRender: true,
				externalLoad: true,
				templateOptions: {
					starringTitle: 'Starring'
				},
				widgets: {
					dl: {
						widget: 'Datalayer',
						method: 'model.getModelContent'
					},
					modelStNames: {
						widget: 'Grid_List',
						'tpl.row': 'model_starring',
						'embed.container': '#st-list'
					},
					modelBacklinks: {
						widget: 'Grid_List',
						'tpl.row': 'model_back_links',
						'embed.container': '#back-links'
					}
				},
				fireEventWidget: '@parent',
				listenEventName: 'setContentId',
				'handleWom.addToDom': {
					event: 'addedToDom',
					widget: '@this',
					callback: '_hideTemplate'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.callParent('init', arguments);

			fox.each(this.rwom('.Grid_List'), function (w) {
				this.registerOptions('#' + w.getAlias(), {
					dataLayer: this.dl
				})
			}, this);

			this.handleEvent(
				this.getOption('fireEventWidget'), 
				this.getOption('listenEventName'), 
				'_loadCollection'
			);

			this.handleEvent(this.dl, 'loaded', '_hideTemplate');
		},

		_loadCollection: function (contentId) {
			this
				.dl
				.setTransitParameter('contentId', contentId)
				.load();
		},

		_hideTemplate: function () {
			if (!this.dl.getCount()) {
				_.toggleElement.call(this, true);
			} else {
				_.toggleElement.call(this);
			}
		}

	}, 'Grid');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	var _ = {
		STLABEL: '_nsls_',
		USECONFIRM: false,

		subscribeResponse: function subscribeResponse(res) {
			var now = new Date().getTime();

			fox.utils.localStorage('setItem', _.STLABEL, now);
			this.hideNewsletterBlock();

			if (_.USECONFIRM === true) {
				this.rwom1('#confirmSubscription').show();
			}
		},

		visibility: function visibility() {
			var m = fox.isEmpty(fox.site.member);
			var nsw = fox.getEnv('siteProps.newsLetterWidget');
			var lstl = fox.utils.localStorage('getItem', _.STLABEL);

			var pm = this.wom1('@root .PermissionManager');

			if (pm) {
				m = pm.hasAccess('guest') && fox.isEmpty(pm.getMemberInfo());
			}

			return m === true && nsw === '1' && !lstl;
		}
	};

	fox.registerWidget('NewsLetterSubscriber', {
		configure: function configure() {
			var _this2 = this;

			this.registerOptions('', {
				template: 'newsletterBlock',
				autoRender: true,
				widgets: {
					form: {
						widget: 'Form',
						loadValuesOnRun: false,
						formElements: {
							name: { element: '[name="name"]', autoApply: true },
							email: {
								element: '[name="email"]',
								autoApply: true,
								validate: [{ validator: 'regexp', options: { type: 'emailCaseInsensitive' }, message: 'Wrong email format' }]
							}
						},
						'methods.send': 'site.subscribeToNewsletter',
						submit: {
							target: '#subscribe-to-site',
							event: 'click'
						},
						'hooks.onSubmit': function hooksOnSubmit() {
							return _this2.submitForm.apply(_this2, arguments);
						},
						'hooks.onResponse': function hooksOnResponse() {},
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['name', 'email'],
							defaultValidator: [{
								validator: 'length',
								options: { min: 1 },
								message: 'Cannot be empty'
							}]
						}
					}
				},
				'handleWom.submited': {
					event: 'submit',
					widget: '#form',
					callback: function callback(values) {
						this.sbem = values.email;
					}
				},
				handleDom: {
					subscribeByEnter: {
						event: 'keyup',
						target: 'input',
						eventChecker: function eventChecker(e) {
							return e.keyCode === 13;
						},
						callback: function callback() {
							this.rwom1('#form')._submit();
						}
					}
				}
			});

			if (_.USECONFIRM === true) {
				this.registerOptions('', {
					'widgets.confirmSubscription': {
						widget: 'Dialog',
						template: '',
						dialog: {
							closeText: ''
						},
						'widgets.body': {
							widget: 'Widget',
							autoRender: true,
							template: 'subscriptionConfirm'
						},
						'handleDom.close': {
							event: 'click',
							callback: 'hide',
							targetWidget: '#body'
						}
					}
				});
			}

			this.callParent('configure', arguments);
		},

		beforeEmbed: function beforeEmbed() {
			if (_.visibility.call(this) === false) {
				return false;
			}

			return this.callParent('beforeEmbed', arguments);
		},

		hideNewsletterBlock: function hideNewsletterBlock() {
			var removeDelay = this.getOption('removeDelay');

			this.hookWrapper('beforeBlockRemove');

			if (removeDelay) {
				return setTimeout(fox.bind(this.removeFromDom, this), removeDelay);
			}

			return this.removeFromDom();
		},

		beforeBlockRemove: function beforeBlockRemove() {},

		removeFromDom: function removeFromDom() {
			this.callParent('removeFromDom', arguments);

			this.dispatchEvent('removedFromDom');
		},

		submitForm: function submitForm(values) {
			var _this = this.rwom1('#form');
			var api = _this._getFormSendApi();

			api.psend(values).then(fox.bind(_.subscribeResponse, _this.getParent())).catch(fox.bind(function (res) {
				var fv = this.rwom1('#validator');

				fv.dispatchEvent('formNotValid', {
					errorStack: {
						email: [{ message: 'Arleady subscribed' }]
					}
				});

				fv.hangStyle('email');
			}, _this));

			_this.dispatchEvent('submit', values);
		}
	});
};

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Notification_PeriodicalUpdater', {
		configure: function(options) {
			this.registerOptions('', {
				enable: true
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.setOption('enable', !fox.cookie.get('disableNotifying'));

			this.callParent('init', arguments);
		},

		running: function() {
			// debugger;
			if (this.getOption('enable')) {
				this.startUpdate();
			};
		},

		todo: function() {
			var lastId = fox.cookie.get('notifyFrom');

			this.rwom1('@parent #notificationListData').setTransitParameter('notifyFrom', lastId).load();				
		}

	}, 'PeriodicalUpdater');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox, $) {
	"use strict";

	fox.registerWidget('NotificationViewer', {
		currentCollection: {},

		configure: function configure(options) {
			var _this = this;

			this.desktopLimit = 10;
			this.mobileLimit = 3;

			this.registerOptions('', {
				updateTime: 60000,
				widgets: {
					notificationListData: {
						widget: 'Datalayer',
						method: 'Activity_Notification.get',
						transitParameters: {
							notifyFrom: this.getNotifyCookie()
						},
						limit: this.getLimit(),
						'handleWom.loadDl': {
							event: 'loaded',
							widget: '@this',
							callback: '@parent:_setNotifyCookie'
						}
					}
				},

				handleDom: {
					clickToDel: {
						targetWidget: '#notificationGrid #list',
						event: 'click',
						target: '.delete',
						callback: 'submitDelete'
					}
				},
				handleWom: {
					socketInbox: {
						widget: '@root #socket',
						event: 'inboxSocketEventActivity:notification',
						callback: function callback(resp) {
							var externalHandler = _this.getOption('externalHandler');

							if (fox.isFunction(externalHandler)) {
								var message = resp.answer;
								var result = externalHandler(message);

								return result && _this._handleSocketMessage(resp);
							}

							return _this._handleSocketMessage(resp);
						}
					},
					socketConnection: {
						widget: '@root #socket',
						event: ['socketReady', 'socketDisconnected'],
						callback: '_handleSocketConnection'
					}
				}
			});

			if (!this.notificationsIsDisabled()) {
				this.registerOptions('', {
					handleWom: {
						socketInbox: {
							widget: '@root #socket',
							event: 'inboxSocketEventActivity:notification',
							callback: '_handleSocketMessage'
						},
						socketConnection: {
							widget: '@root #socket',
							event: ['socketReady', 'socketDisconnected'],
							callback: '_handleSocketConnection'
						}
					}
				});
			}

			this.callParent('configure', arguments);
		},

		init: function init() {
			this.callParent('init', arguments);

			if (fox.cookie.get('disableNotifying') || this.notificationsIsDisabled()) {
				return;
			}

			this.embedWidget('notificationGrid', 'Grid', {
				dataLayer: '@parent #notificationListData',
				template: 'notificationBlock',
				container: '#notificationList',
				externalLoad: true,
				list: {
					autoRender: true,
					container: '#notifications',
					'tpl.row': 'notification_row'
				}
			});
		},

		running: function running(argument) {
			if (this.notificationsIsDisabled() || this.isPreviewMode()) return;

			this.startPolling();

			this.callParent('running', arguments);
		},

		isPreviewMode: function isPreviewMode() {
			return fox.site.getOption('previewMode') === 1;
		},

		notificationsIsDisabled: function notificationsIsDisabled() {
			return this.isPreviewMode() || fox.site.getEnv('siteProps.onSiteNotificationsDisabled') === '1';
		},

		submitDelete: function submitDelete(elem, alias, scope, event) {
			var currentRow = $(elem).parents('.notify');
			var id = currentRow.find('.notif_id').val();
			this.deleteRow(id);
			return false;
		},

		deleteAll: function deleteAll() {
			var timer = 1000,
			    c = fox.toArray(this.currentCollection);

			fox.each(c, function (item, i) {
				if (i === 0) {
					this.deleteRow(item.id);
				} else {
					setTimeout(fox.bind(function () {
						this.deleteRow(item.id);
					}, this), timer);

					timer *= 2;
				}
			}, this);
		},

		deleteRow: function deleteRow(id) {
			delete this.currentCollection[id];
			this.hookWrapper('deleteItem', id);
		},

		deleteItem: function deleteItem(id) {
			$('input[value="' + id + '"]').parent('.notify').animate({ height: "hide" }, 1000);
		},

		getNotifyCookie: function getNotifyCookie() {
			return fox.cookie.get('notifyFrom');
		},

		_setNotifyCookie: function _setNotifyCookie(obj, w, e) {
			this.currentCollection = w.getCollection();
			var _collection = fox.toArray(this.currentCollection);

			if (!fox.isEmpty(_collection)) {
				fox.cookie.set('notifyFrom', _collection.pop().id);
			}
		},

		isTouchDevice: function isTouchDevice() {
			//from Swipe.js library
			return 'ontouchstart' in window || typeof window.DocumentTouch !== 'undefined' && document instanceof DocumentTouch;
		},

		getLimit: function getLimit() {
			return this.isTouchDevice() ? this.mobileLimit : this.desktopLimit;
		},

		_handleSocketMessage: function _handleSocketMessage(response) {
			var msg = response.answer;
			var dl = this.wom1('#notificationListData');
			var id = msg.id;

			if (!this.currentCollection[id]) {
				this.currentCollection[id] = msg;
			}

			dl.setCollection(this.currentCollection);

			dl.dispatchEvent('loaded');
		},

		_handleSocketConnection: function _handleSocketConnection(obj, socket, e) {
			if (e === 'socketReady') {
				this.stopPolling();

				return;
			}

			this.startPolling();
		},

		getNotifications: function getNotifications(argument) {
			this.wom1('#notificationListData').load();
		},

		startPolling: function startPolling() {
			this.stopPolling();

			this.timer = window.setInterval(fox.bind(this.getNotifications, this), this.getOption('updateTime'));
		},

		stopPolling: function stopPolling(argument) {
			if (this.timer) {
				window.clearInterval(this.timer);
				this.timer = null;
			}
		}

	}, 'Controller');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";

	fox.registerWidget('UserOfferNewLogin', {
		configure: function () {
			this.registerOptions('', {
				widgets: {
					form: {
						widget: 'Form',
						formElements: {
							login: {
								element: '[name=login]'
							}
						}
					},
					validator: {
						widget: 'Easy_Form_Validator',
						formWidget: '@parent #form',
						hangClassLocation: 'parentNode',
						requiredFields: ['login'],
						defaultValidator: [{
							validator: 'length',
							options: {min: 1},
							message: 'Cannot be empty'
						}]
					}
				},
				handleWom: {
					setErrorMessage: {
						event: 'formNotValid',
						widget: '#validator',
						callback: 'showError'
					},
					openPopup: {
						event: 'show',
						widget: '@parent',
						callback: 'resetForm',
						params: {
							listenHistory: true
						}
					}
				},
				handleDom: {
					focus: {
						target: 'input[name="login"]',
						event: 'focus',
						callback: 'removeError'
					},
					join: {
						target: '#join',
						event: 'click',
						callback: 'join'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.form = this.wom1('#form');
			this.validator = this.wom1('#validator');
		},

		showError: function(data) {
			this
				.dom1('.error-message')
				.innerText = data.msg;
		},

		removeError: function(el) {
			fox.dom.removeClass('error', el.parentNode);
			this.dom1('.error-message').innerHTML = '';
		},

		join: function() {
			var clientId = this.getOption('clientId');

			if (this.validator.validate() && clientId) {
				var data = this.form.collectData();

				fox.UserOffer.checkAction('purchaseOffer', {
					login: data.login,
					clientId: clientId
				});

				this.setOption('clientId', null);
				this.getParent().hide();
			}
		},

		resetForm: function() {
			this.form.resetForm();
			this.removeError(this.dom1('input[name="login"]'));
		}

	}, 'Widget');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/* Html5Player Banner */
(function (fox, $) {
	"use strict";

	fox.registerWidget('Html5Player_MC_Banner', {
		configure: function (options) {
			this.registerOptions('', {
				'!template': 'Html5Player_MC_Banners',
				useSimpleBanner: false,
				onPausePlayerImage: __webpack_require__(861),
				onPausePlayerSmallImage: __webpack_require__(862)
			});

			this.pm = fox.wom.selectFirst('~.PermissionManager');

			this.callParent('configure', arguments);
		},

		init: function() {
			this.prepareBanners();

			this.callParent('init', arguments);
		},

		prepareBanners: function() {
			var isFreeRegEnabled = (fox.getEnv('siteProps.freeJoin') === '1');
			var guestAccess = this.pm.hasAccess('guest');
			var isFreeMember = (guestAccess && !fox.isEmpty(this.pm.getMemberInfo()));

			this.largeImg = this.getOption('onPausePlayerImage');
			this.smallImg = this.getOption('onPausePlayerSmallImage');

			if (this.getOption('useSimpleBanner') === true) {
				return;	
			}

			if (isFreeMember) {
				this.largeImg = __webpack_require__(863);
				this.smallImg = __webpack_require__(864);

				return;
			}

			if (guestAccess && isFreeRegEnabled) {
				this.largeImg = __webpack_require__(865);
				this.smallImg = __webpack_require__(866);

				return;
			}

		},

		setBanner: function() {
			if (this.pm.hasAccess('member')) {
				return;
			}

			this.setOption('manualRender', false);

			this.setTemplateOptions({
				largeImg: this.largeImg,
				smallImg: this.smallImg,
				url: fox.getEnv('siteProps.ubs.joinUrl') || '/join',
				component: this.getOption('component'),
				cName: this.getOption('cName')
			});

			this.render();

		}

	}, 'Html5Player_Banner');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/player/banners/guest_large.png", __webpack_require__.p + "_/_/_/root/images/player/banners/guest_large.png");

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/player/banners/guest_small.png", __webpack_require__.p + "_/_/_/root/images/player/banners/guest_small.png");

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/player/banners/freeMember_large.png", __webpack_require__.p + "_/_/_/root/images/player/banners/freeMember_large.png");

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/player/banners/freeMember_small.png", __webpack_require__.p + "_/_/_/root/images/player/banners/freeMember_small.png");

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/player/banners/guest_freeReg_large.png", __webpack_require__.p + "_/_/_/root/images/player/banners/guest_freeReg_large.png");

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/player/banners/guest_freeReg_small.png", __webpack_require__.p + "_/_/_/root/images/player/banners/guest_freeReg_small.png");

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	"use strict";

	fox.registerWidget('Popup_Common', {

		configure: function () {
			this.registerOptions('', {
				widget: 'Dialog',
				template: '',
				additionalClasses: '',
				useUiPosition: true,
				dialog: {
					dialogClass: 'mc-site-common-popup',
					autoOpen: false,
					closeText: '',
					closeOnEscape: false,
					draggable: true,
					width: 'auto'
				},
				widgets: {
					content: {
						widget: 'Widget',
						template: 'div.popup-content',
						autoRender: true,
						container: '#popup-widget-container',
						'handleDom.close': {
							target: '.close',
							callback: '@parent:hide'
						},
						'handleDom.cloneOnParent' :{
							target: '.close',
							targetWidget: '@parent',
							callback: '@parent:hide'
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.setOption('dialog.dialogClass', [this.getOption('dialog.dialogClass'), this.getOption('additionalClasses')].join(' '));

			this.callParent('init', arguments);
		}
	}, 'Dialog');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox) {
	var _Promise = fox.RSVP.Promise;

	fox.registerWidget('PromisePreloader', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'big_preloader'
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this._readyToEmbed = false;

			this.callParent('running', arguments);
		},

		show: function (promise) {
			if (!(promise instanceof _Promise)) return _Promise.resolve(false);

			function retPromise (promise) {
				this.render();

				return promise;
			}

			this._readyToEmbed = true;

			var resPromise = this.wait('addedToDom').then(function () {
				this._readyToEmbed = false;

				return promise;
			}.bind(this)).then(function (resp) {
				if (this.isEmbedded()) this.removeFromDom();

				this.visualParent.render();

				return resp;
			}.bind(this));

			if (!this.isActive()) return this.wait('activate').then(retPromise.bind(this, resPromise));

			return retPromise.call(this, resPromise);
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, localStorage) {
	"use strict";
	
	var _pnm = __webpack_require__(870)(fox);
	var _isPreviewMode = __webpack_require__(33);

	fox.registerWidget('PushNotifications', {
		_lut: [],
		configure: function(options) {
			this.registerOptions('', {
				notificationsSite: fox.cookie.get('notifSite') ? fox.cookie.get('notifSite') : 'https://notifications.models.xxx',
				widgets: {
					checkSubscriptionStep1: {
						widget: 'Api',
						method: 'Notifications.checkSubscriptionStage1'
					},
					setupApi: {
						widget: 'Api',
						method: 'Notifications.setup'
					},
					allowApi: {
						widget: 'Api',
						method: 'Notifications.allow'
					},
					blockApi: {
						widget: 'Api',
						method: 'Notifications.block'
					},
					updateSubscriptionUserApi: {
						widget: 'Api',
						method: 'Notifications.updateSubscriptionUser'
					},
                    prompt: {
						widget: 'Widget',
						disabled: this.isDisabledRequest(),
                        autoRender: false,
                        manualRender: true,
                        template: 'request_permissions_message',
                        'embed.container': '#offline-notifications-message'
                    }
				},
				handleDom: {
					notificationPopupOpen: {
						targetWidget: '#prompt',
						target: '.push-notification-accept-btn',
						callback: 'openNotificationsCenterPopup'
                    },
                    disableRequest: {
						targetWidget: '#prompt',
						target: '.push-notification-disallow-btn',
						callback: 'disableRequest'
					},
					closeRequest: {
						targetWidget: '#prompt',
						target: '.close-prompt',
						callback: 'closeRequest'
					}
				},
				userIdentifier: null,
				windowParams: {
					width: 580,
					height: 580
				}
			});

			this.callParent('configure', arguments);
		},
		
		init: function () {
			// required for uuid generation
			for (var i=0; i < 256; i++) { 
				this._lut[i] = (i < 16 ? '0' : '')+(i).toString(16); 
			}

			this.callParent('init', arguments);
		},

		running: function () {
			this.callParent('running', arguments);

			this.notificationsRequestWidget = this.wom1('#prompt');
			
			this.blockApiInProgress = false;
			this.allowApiInProgress = false;

			if (_isPreviewMode()) {
				return;
			}

			window.setTimeout(function() {
				this.start();
			}.bind(this), 60000);
		},

		start: function() {
			var ident = this.getIdentifier();

			if (!ident) {
				ident = this._generateIdentifier();
				this.setIdentifier(ident);
			}

			this.setOption('userIdentifier', ident);
			
			return this.runCheckSubscriptionStep1().then(this.handleSubscriptionStep1.bind(this));
		},

		_requestPushNotifications: function(data) {
			if (this.notificationsRequestWidget._disabled === true || data.state === false) {
				return;
			}

			var userData = this.getUserData();
			var isMember = (userData !== null);
			var _promise = fox.Promise.resolve(true);
			var uid = this.getOption('userIdentifier');

			if (isMember && !this._subscriptionWasUpdated()) {
				_promise = this.wom1('#updateSubscriptionUserApi').psend({uid: uid}).then(function(resp) {
					localStorage.setItem('userSubscriptionUpdated', '1');

					return true;
				}.bind(this));
			}

			_promise.then(function() {
				this.notificationsRequestWidget.setTemplateOptions('location', window.location.origin);
				this.notificationsRequestWidget.render();
			}.bind(this));
		},

		openNotificationsCenterPopup: function(el, a, s, ev) {
			ev.preventDefault();

			if (this.allowApiInProgress === true) {
				return;
			}

			this.runAllowApi();
			this.openNewWindow();
			this.closeRequest();
		},

		_generateIdentifier: function() {
			var lut = this._lut;
			var d0 = Math.random() * 0xffffffff|0;
			var d1 = Math.random() * 0xffffffff|0;
			var d2 = Math.random() * 0xffffffff|0;
			var d3 = Math.random() * 0xffffffff|0;
			return lut[d0&0xff] + lut[d0>>8&0xff] + lut[d0>>16&0xff] + lut[d0>>24&0xff] + '-' +
				lut[d1&0xff] + lut[d1>>8&0xff] + '-' + lut[d1>>16&0x0f|0x40] + lut[d1>>24&0xff] + '-' +
				lut[d2&0x3f|0x80] + lut[d2>>8&0xff] + '-' + lut[d2>>16&0xff] + lut[d2>>24&0xff] +
				lut[d3&0xff] + lut[d3>>8&0xff] + lut[d3>>16&0xff] + lut[d3>>24&0xff];
		},

		_getCenterCoords: function() {
			var h = this.getOption('windowParams.height');
			var w = this.getOption('windowParams.width');
			
			var left = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
			var top = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
			return [left > 0 ? left : 0, top > 0 ? top : 0];
        },
        
        disableRequest: function() {

			if (this.blockApiInProgress === true) {
				return;
			}
			
			this.runBlockApi().then(function() {
				localStorage.setItem('notificationsRequestDisabled', 1);
				this.closeRequest();
			}.bind(this));
		},

		closeRequest: function() {
			this.notificationsRequestWidget._disabled = true;
			this.notificationsRequestWidget.removeFromDom();
		},
		
		isDisabledRequest: function() {
			return localStorage.getItem('notificationsRequestDisabled') === '1';
		},

		getIdentifier: function() {
			return localStorage.getItem('uid');
		},

		setIdentifier: function(ident) {
			return localStorage.setItem('uid', ident);
		},

		getUserData: function() {
			var memberInfo = fox.site.rwom1('.PermissionManager').getMemberInfo();

			return fox.isEmpty(memberInfo) ? null : memberInfo;
		},

		_subscriptionWasUpdated: function() {
			return localStorage.getItem('userSubscriptionUpdated') === '1';
		},

		runCheckSubscriptionStep1: function() {
			return this.wom1('#checkSubscriptionStep1').psend({uid: this.getOption('userIdentifier'), siteId: this.getSiteId()});
		},

		runSetupApi: function() {
			var api = this.wom1('#setupApi');
			var uid = this.getOption('userIdentifier');

			return _pnm.checkBrowser().then(function(data) {
				return api.psend({uid: uid, siteId: this.getSiteId(), browserSupport: data.state}).then(function() {
					return data;
				}.bind(this));
			}.bind(this));
		},

		runBlockApi: function() {
			this.blockApiInProgress = true;

			return this.wom1('#blockApi')
				.psend({uid: this.getOption('userIdentifier'), siteId: this.getSiteId()}).then(function() {
					this.blockApiInProgress = false;
				}.bind(this))
				.catch(function() {
					this.blockApiInProgress = false;
				}.bind(this));
		},

		runAllowApi: function() {
			this.allowApiInProgress = true;

			return this.wom1('#allowApi')
				.psend({uid: this.getOption('userIdentifier'), siteId: this.getSiteId()})
				.then(function() {
					this.allowApiInProgress = false;
				}.bind(this))
				.catch(function() {
					this.allowApiInProgress = false;
				}.bind(this));
		},

		handleSubscriptionStep1: function(resp) {
			var status = fox.objectGet(resp, 'params.answer.response');

			//any of actions done
			if (status === true) {
				return;
			}

			this.runSetupApi().then(this._requestPushNotifications.bind(this));
		},

		openNewWindow: function() {
			var newWin;
			var timer;
			var coords = this._getCenterCoords();
			var winOptsArray = [
				'scrollbars=yes',
				'width=' + this.getOption('windowParams.width'),
				'height=' + this.getOption('windowParams.height'),
				'left=' + coords[0],
				'top=' + coords[1]
			];
			var qpArray = [this.getSiteId()];

			qpArray.push(this.getIdentifier());
			
			newWin = window.open(
				this.getOption('notificationsSite') + '/subscribe/' + qpArray.join('/'), '_blank', winOptsArray.join(',')
			);

			timer = setInterval(function() { 
				if(newWin.closed) {
					window.clearInterval(timer);
				}
			}, 1000);
		},

		getSiteId: function() {
			return fox.site.dl.getObjectValue('id');
		}

	}, 'Controller');

})(fox, localStorage);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function (fox) {
	'use strict';

	var PushNotificationsManager = function () {
		function PushNotificationsManager() {
			_classCallCheck(this, PushNotificationsManager);
		}

		_createClass(PushNotificationsManager, [{
			key: 'checkBrowser',
			value: function checkBrowser() {
				return fox.Promise.resolve({ state: !!('Notification' in window) });
			}
		}, {
			key: 'requestPermission',
			value: function requestPermission() {
				return Notification.requestPermission();
			}
		}, {
			key: 'getPermission',
			value: function getPermission() {
				return Notification.permission;
			}
		}, {
			key: 'isDefaultPermission',
			value: function isDefaultPermission() {
				return this.getPermission() === 'default';
			}
		}, {
			key: 'isGrantedPermission',
			value: function isGrantedPermission() {
				return this.getPermission() === 'granted';
			}
		}, {
			key: 'isDeniedPermission',
			value: function isDeniedPermission() {
				return this.getPermission() === 'denied';
			}
		}]);

		return PushNotificationsManager;
	}();

	return new PushNotificationsManager();
};

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Content_VrSceneViewer', {
		configure: function(options) {
			this.TYPE_VR_VIDEO = 4;
			this.registerOptions('', {
				widgets: {
					sceneDl: {
						fields: ['type'],
						'transitParameters.v1': 'ykYa8ALmUD'
					},
					downloadButton: {
						widget: 'Widget',
						'embed.container': '.download-block',
						'embed.widget': '@parent #currentScene #list',
						autoRender: false,
						templateOptions: {
							iconDownload: 'icon-download'
						},
						'hooks.onStartRendering': function () {
							var dl = this.getParent().wom1('#sceneDl');
							var downloadAccess = window.Number(dl.getObjectValue('accessibility.downloadable'));
							var permitionsGuest = !this.wom1('@root .PermissionManager').hasAccess('member') || !fox.site.member;

							if (!dl.isLoaded()) {
								this.wait(dl, 'loaded').then(this.render.bind(this));
								return;
							}
							if (permitionsGuest ){
								this.setTemplateOptions({url: fox.getEnv('siteProps.ubs.joinUrl') || '/join',});
							}
							if (!downloadAccess) {
								this.fragment = document.createDocumentFragment();
								return false;
							} else {
								this.setOption('template', 'video_download');
							}
						},
						'handleDom.downloadLinks': {
							target: '.download',
							event: 'click',
							callback: function (elem) {
								var dLinks = this.rwom1('@parent #downloadLinks');
								var container = dLinks.getOption('container');
								var activeClass = dLinks.getOption('activeClass');
								var activeItems = dLinks.getOption('activeItems');

								if (!$(elem).hasClass(activeClass)) {
									var w = ($(container).outerWidth() / 2) - ($(elem).outerWidth() / 2);

									$(container).css({ 'margin-left': '-' + w + 'px' });
								}

								$(elem).toggleClass(activeClass);
								$(container).toggleClass('active');

								if (activeItems) {
									$(container).find('li').toggleClass(activeClass);
								}
							}
						}
					},
					downloadLinks: {
						widget: 'Widget',
						'container': '.download-links',
						template: 'sitepage_scene_links',
						autoRender: false,
						handleWom: {
							getFormat: {
								widget: '@parent #flashPlayer',
								event: '_changeFormat',
								callback: '@parent: setDownloadLinks'
							},
							getVrFormat: {
								widget: '@parent #vrPlayer',
								event: '_changeFormat',
								callback: '@parent:setDownloadLinks'
							}
						}
					},
					flashPlayer: {
						widget: 'Content_Html5Player',
						container: '.player-block-wrapper',
						template: 'sitepage_scene_video',
						renderPlayer: true,
						renderTo: '.player',
						autoRender: true,
						active: false,
						group: 'player',
						'embed.widget': '@parent #currentScene #list',
						'html5PlayerConfig.movie.autoplay': true
					},
					vrPlayer: {
						widget: 'VrPlayer',
						container: '.player-block-wrapper',
						template: 'vrVideo',
						autoRender: true,
						active: false,
						group: 'player',
						'embed.widget': '@parent #currentScene #list'
					},
					guestDisablePreview: {
						widget: 'guestDisablePreview',
						autoRender: true,
						dl: '@parent #sceneDl',
						container: '.player-block-wrapper',
						active: false,
						group: 'player',
						'embed.widget': '@parent #currentScene #list',
						
					}
				}
			});
			this.callParent('configure', arguments);
		},

		runScene: function () {
			this.sceneDl = this.requireEmbeddedWidget('sceneDl');

			this.sceneDl.addFilter('id', ['id'], [this.contentId]).load();

			if (!this.sceneDl.isLoaded()) {
				this.handleEvent(this.sceneDl, 'loaded', fox.bind(function () {
					this.setTitle();
					this.switchPlayer();
				}, this));
			} else {
				this.switchPlayer();
			}
		},

		switchPlayer: function() {
			var scene = this.sceneDl.getCollection();
			var showPreview = this.sceneDl.getObjectValue('accessibility.previewsForGuests');
			var permitionsGuest = !this.wom1('@root .PermissionManager').hasAccess('member') || !fox.site.member;

			if (!showPreview && permitionsGuest) {
		
				this.switchEmbeddedWidget('guestDisablePreview');
			} else {
				if (scene.length === 1) {
					if (scene[0].type === this.TYPE_VR_VIDEO) {
						this.switchEmbeddedWidget('vrPlayer');
					} else {
						this.switchEmbeddedWidget('flashPlayer');
					}
				}
			}
			

			this.dispatchEvent('setContentId', this.contentId);
		},

		rebuildFormatMap:function(map) {
			map.total = 0;
			for(var key in map.download) {
				++ map.total;
				if (key.indexOf('_vr_') !== -1) {
					map.download[key].vr = 1;
				}
			}
			return map;
		},

		setDownloadLinks: function(obj, player) {
			var formatMap = player.getFormatMap();
		
			if (!$.isEmptyObject(formatMap.download)) {
				$('.toggleDownloads').removeClass('hidden');

				var map = this.rebuildFormatMap(formatMap);
				this.rwom1('#downloadLinks').setTemplateOptions({
					download: map.download,
					total: map.total
				}).render();
			}
		},

		openDownloadBlock: function () {
			var $container = $(this.rwom1('#downloadLinks').getOption('container'));
			var $elt = $('.toggleDownloads');
			var $list = $container.find('.download-links');

			$elt.addClass('active');
			$list.addClass('active');
		},

		closeDownloadBlock: function () {
			var $container = $(this.rwom1('#downloadLinks').getOption('container'));
			var $elt = $('.toggleDownloads');
			var $list = $container.find('.download-links');

			$elt.removeClass('active');
			$list.removeClass('active');
		},

		_setDownloadBlockWidth: function (elt, w) {
			var $container = $(w.getOption('container')),
				togglerW = $(elt).innerWidth(),
				$links = $container.find('.download-links'),
				width = 0;

			$links.find('li').each(function(i, el){
				width += $(el).outerWidth(true);
			});

			if (togglerW > width) {
				width = togglerW;
			}

			$links.width(width);
		},
		setTitle: function () {
			var data = this.sceneDl.getCollection()[0];
			var metaDescription = fox.dom.selectFirst('meta[name="description"]');
			var parseTitle = fox.Navigator.get(2) ? decodeURIComponent(fox.Navigator.get(2).replace(/-/g, ' ')) : '';

			document.title = parseTitle + ' - Sex Movies Featuring ' + fox.getEnv('screenName');
			data.description != '' ? metaDescription.setAttribute('content', data.description) : metaDescription.setAttribute('content', 'Watch ' + fox.getEnv('screenName') + ' Best Porn Videos in HD. Free movies ' + parseTitle + '.');
		}


	}, 'Content_SceneViewer');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_2257', {

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) {
	fox.registerWidget('SitePage_404', {

		// running: function() {
		// 	// this.handleEvent(, 'addedToDom', fox.bind(function() {
		// 		$('p.p3').text('The requested URL ' + location.hash + ' was not found on this server.');	
		// 	// }, this));
		// }
	
	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) { fox.registerWidget('SitePage_About', {}, 'Site_Page'); })(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_Account', {

	}, 'Site_Page');


})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('SitePage_Terms', {

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// AnchorNavigator Widget

(function (fox, $) {
	"use strict";
	fox.registerWidget('AnchorNavigator', {

		init: function () {
			this.addDomHandler({
				event: 'click',
				target: this.requireOption('clickTarget'),
				targetWidget: this.requireOption('targetWidget'),
				callback: 'navigate'
			}, 'navigate');
		
			this.callParent('init', arguments);
		},

		navigate: function (el, evAlias, performer) {
			var id, $el, $target;

			$el = $(el);
			id = $el.data('target');
			$target = $(performer.dom1(['#', id].join('')));

			$el.parent()
				.find('.active')
				.removeClass('active');

			$el.addClass('active');

			if ($target) {
				$('body, html').animate({
					scrollTop: $(document).width() > 1194 ? $target.offset().top - 155 : $target.offset().top
				}, 500);
			}
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('SitePage_BillingContact', {}, 'Site_Page');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('SitePage_Blog', {}, 'Site_Page');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('SitePage_Cancellation', {}, 'Site_Page');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_CCPA', {
	
	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Conversation */
(function(fox) {
	fox.registerWidget('SitePage_Conversation', {}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Favorities */

(function(fox) {
	
	fox.registerWidget('SitePage_Favorites', {
		activate: function() {
			this.callParent('activate', arguments);
			this.requireEmbeddedWidget('favorites').dl.load();
		}
	}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('SitePage_FreeHostedGallery', {
		activate: function (params) {
			this.callParent('activate', arguments);

			if (this.isRun()) {
				return this.rwom1('#fhg').loadPhotos(params.id);
			}

			return this.wait('running').then(function () {
				this.rwom1('#fhg').loadPhotos(params.id);
			}.bind(this));
		}
	}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	fox.registerWidget('SitePage_FreeHostedVideos', {
		activate: function (params) {
			this.callParent('activate', arguments);

			var isMixed = this.getAlias() === 'freeHostedMixed';

			if (this.isRun()) {
				if (isMixed) {
					this.rwom1('#fhv #photoList').load(params.id);
				}

				return this.rwom1('#fhv').setFreeHostedContentId(params.id);
			}

			return this.wait('running').then(function () {
				if (isMixed) {
					this.rwom1('#fhv #photoList').load(params.id);
				}

				return this.rwom1('#fhv').setFreeHostedContentId(params.id);
			}.bind(this));
		}
	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SitePage_Gallery

(function (fox, $) {
	
	fox.registerWidget('SitePage_Gallery', {}, 'Site_Page');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {

	var _ = {
		bindToImgJquery: function (w, $img) {
			fox.each(w.getOption('handleDom'), function (v, alias) {
				if (v.target === 'img' || (fox.isArray(v.target) && v.target.indexOf('img') !== -1)) {
					$img.on(v.event, fox.bind(function (e) {
						if (fox.isFunction(v.callback.subj)) {
							v.callback.subj.call(this, e.target, alias, this, e);
						} else if (fox.isString(v.callback.subj)) {
							fox.oop.getRealCallback(v.callback)(e.target, alias, this, e);
						}
					}, v.callback.scope));
				}
			}, w);

			return $img;
		},

		mixBigThumb: function (bt, ot) {
			var 
				w = window.screen.width,
				h = window.screen.height;

			return bt.map(function (v, indx){
				var
					iw = Number(v.info.width),
					ih = Number(v.info.height);

				if ((iw <= w && ih <= h) || (ih <= h && iw <= w)) {
					return ot[indx];
				}

				return v;
			});
		}
	};
	
	fox.registerWidget('FullscreenView', {

		mixBigThumb: function () {
			return _.mixBigThumb.apply(this, arguments);
		},

		configure: function () {
			this.curEffect = 'fadeInDown';
			this.IMGCACHE = {};
			this.targetsIds = [];

			this.registerOptions('', {
				slideSwitchInterval: 5000,
				embed: {
					container: 'body',
					widget: '@root',
					location: 'firstChild'
				},
				template: 'sitepage_gallery_fullscreenview',
				autoRender: false,
				widgets: {
					body: {
						widget: 'Widget',
						'embed.container': '.gallery-fullscreen',
						autoRender: false,
						template: 'sitepage_gallery_fullscreenview_image',
						'hooks.onStartAddedToDom': '@parent:bodyOnStartAddedToDom'
					},
					currentRating: {
						widget: 'Social_Rating',
						'embed.container': '.gallery-sidebar-content #gallery-rating',
						template: 'sitepage_gallery_fullscreenview_rating',
						subject: 'resource'
					},
					imageFavorite: {
						widget: 'Social_Favorite',
						'embed.container': '.gallery-sidebar-content #gallery-favorite',
						template: 'sitepage_gallery_fullscreenview_favorite',
						subject: 'resource'
					},
					imageComments: {
						showComments: true,
						widget: 'Social_Comments',
						template: 'sitepage_gallery_fullscreenview_social_comment_scene',
						'embed.container': '.gallery-sidebar-content #gallery-comments',
						subject: 'resource',
						skipParentId: true,
						form: {
							template: 'sitepage_gallery_fullscreenview_social_comments_addform'
						}
					}
				},
				handleWom: {
					doubleTap: {
						event: 'doubleTap',
						widget: '@this',
						callback: 'showRealPixel'
					}
				},
				handleDom: {
					toogleSidebar: {
						target: '.gallery-toggle-arrow',
						callback: fox.bind(function (el) {
							if (!this.slideshowStarted) {
								$(el).parent().toggleClass('opened');
							}
						}, this)
					},

					handleControlClick: {
						target: '.key.normal',
						callback: 'handleKeydown'
					},
					showRealPixel: {
						target: '#show-real-pixel',
						callback: function (el) {
							if (!$(el).hasClass('real-px')) {
								this.showRealPixel();
								$(el).addClass('real-px');
							} else {
								$(el).removeClass('real-px');
								this.hideRealPixels(el);
							}
						}
					},
					exitFullscreen: {
						target: '.gallery-fullscreen-hide',
						callback: 'hide'
					},
					downloadPhoto: {
						target: '#download-photo',
						callback: 'downloadPhoto'
					},
					startSlideshow: {
						target: '#start-slide-show',
						callback: 'startSlideshow'
					},
					stopSlideshowHandler: {
						target: '.gallery-fullscreen-stop-slide-show',
						callback: 'stopSlideshowHandler'
					},
					touchStartOnSidebar: {
						event: 'touchstart',
						target: '.gallery-sidebar',
						callback: fox.bind(function (el, alias, scope, event) {
							// console.log('START>>>', event);
						}, this)
					},
					touchMoveOnSidebar: {
						event: 'touchmove',
						target: '.gallery-sidebar',
						callback: fox.bind(function (el, alias, scope, event) {
							// console.log('MOVE>>>', event);
						}, this)
					},
					touchEnd1: {
						event: 'touchend',
						target: '.gallery-real-pixels-view',
						callback: fox.bind(function () {
							if (this.doubleTapTime &&
								new Date().getTime() - this.doubleTapTime <= 200) {
								this.hideRealPixels();
								this.doubleTapTime = null;
							} else {
								this.doubleTapTime = new Date().getTime();
							}

							event.preventDefault();
						}, this)
					},
					touchStart: {
						event: 'touchstart',
						target: '.gallery-full-image',
						targetWidget: '#body',
						callback: fox.bind(function (el, alias, scope, event) {
							this._tes = {
								x: event.changedTouches[0].pageX,
								y: event.changedTouches[0].pageY,
								time: new Date().getTime()
							};

							event.preventDefault();
						}, this)
					},
					touchMove: {
						event: 'touchmove',
						target: '.gallery-full-image',
						targetWidget: '#body',
						callback: function (el, alias, scope, event) {
							event.preventDefault();
						}
					},
					touchEnd: {
						event: 'touchend',
						target: '.gallery-full-image',
						targetWidget: '#body',
						callback: fox.bind(function (el, alias, scope, event) {
							var endTouchObj = event.changedTouches[0],
								diffX, direction;
							
							if (this.doubleTapTime
								&& new Date().getTime() - this.doubleTapTime <= 200) {
								this.dispatchEvent('doubleTap');
								this.doubleTapTime = null;

								event.preventDefault();
								return;
							} else {
								this.doubleTapTime = new Date().getTime();
							}

							diffX = this._tes.x - endTouchObj.pageX;

							if ((new Date().getTime() - this._tes.time) <= 400 
								&& Math.abs(diffX) > 100) {
								if (diffX < 0) {
									direction = 'prev';
								} else {
									direction = 'next';
								}
							}

							if (direction !== undefined) {
								this.loadPhoto(direction);
							}

							event.preventDefault();
						}, this)
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.addDocumentListener();
			this.OPENED = false;
		
			this.callParent('init', arguments);

			this._readyToRender = false;
			this._readyToEmbed = false;

			// add templates for comments forms
			this.registerOptions('#imageComments .Social_Comments_Form', fox.mergeRecursive({
				'template': 'sitepage_gallery_fullscreenview_social_comments_addform',
				'embed.container': '.addreview-container',
			}, this.getOption('formOptions')), false, 'fullscreenView.js');

			this.registerOptions('#imageComments .Grid', {
				'list.tpl.row': 'sitepage_gallery_fullscreenview_social_comment',
				'template': 'sitepage_gallery_fullscreenview_social_comments_grid',
			}, false, 'fullscreenView.js');
		},

		addDocumentListener: function () {
			this.addDomHandler({
				event: 'keydown',
				target: document,
				eventChecker: fox.bind(function (event) {
					return this.isEmbedded() && (event.keyCode === 39 || event.keyCode === 37);
				}, this),
				callback: 'handleKeydown'
			}, 'onKeyPress');

			this.addDomHandler({
				event: 'keydown',
				target: document,
				eventChecker: fox.bind(function (event) {
					return this.isEmbedded() && event.keyCode === 27;
				}, this),
				callback: 'hide'
			}, 'onKeyPress');

			return this;
		},

		handleKeydown: function (el, alias, root, event) {
			var direction, keyCode;

			keyCode = ($(el).data('keycode')) ? 
				parseInt($(el).data('keycode')) :
				event.keyCode;

			if (keyCode === 39) {
				direction = 'next';
			} else if (keyCode === 37) {
				direction = 'prev';
			}

			this.loadPhoto(direction);
		},

		loadPhoto: function (direction) {
			var nextIndx, curIndx;

			if ((curIndx = this.collectionSet.indexOf(this.currentPhoto)) !== -1) {
				if (direction === 'next') {
					nextIndx = ++curIndx;
					this.curEffect = 'fadeInRight';
				} else if (direction === 'prev') {
					nextIndx = --curIndx;
					this.curEffect = 'fadeInLeft';
				}

				if (this.collectionSet[nextIndx] !== undefined) {
					this.setCurrentPhoto(this.collectionSet[nextIndx]);

					this.rwom1('#body').render();
					this.hideRealPixels();
				}
			}
		},

		_getImg: function (data) {
			return new fox.RSVP.Promise(function (resolve, reject) {
				var maxFails = 5;

				function load () {
					return $('<img>').attr({
						src: data.url,
						alt: data.altTag
					}).on('load', function () {
						$(this).css('visibility', 'visible');
						return resolve({img: this, id: data.id, status: 'loaded'});
					}).on('error', function () {
						if (!maxFails) return resolve({img: this, id: data.id, status: 'failed'});

						maxFails--;

						return setTimeout(load, 10000);
					}).css('visibility', 'hidden');
				}

				return load();
			}.bind(this));
		},

		setCurrentPhoto: function (data) {
			var curIndx;
			var cacheImg;
			
			this.currentPhoto = data;

			cacheImg = function (data, indx) {
				var _this = this;
				var getImg;
				var timeoutCount = 0;
				var body = this.rwom1('#body');

				var url = data.url;

				if (this.previewThumb && this.previewThumb.length && this.previewThumb[indx]) {
					url = this.previewThumb[indx].url;
				}

				getImg = function () {
					var $img;

					$img = $('<img>').attr({
						src: url,
						alt: 'fullphoto - ' + data.id  + ' - ' + fox.site.environment.screenName
					}).height('100%');

					_this._getImg(data).then(function (resp) {
						var img = resp.img;
						var $img = _this.IMGCACHE[resp.id];

						if (_this.currentPhoto.id === resp.id) {
							$(body.dom1('.gallery-preloader')).hide();
						}

						switch (resp.status) {
							case 'loaded':
								$img.get(0).loadStatus = true;

								$img.attr({src: $(img).attr('src')}).height('auto');
							break;
							case 'failed':
								$img.get(0).loadStatus = undefined;
							break;
						}
					});

					return _.bindToImgJquery(_this.rwom1('#body'), $img);
				};

				return getImg();
			};

			curIndx = this.collectionSet.indexOf(this.currentPhoto);

			this.currentOriginPhoto = this.originThumb && this.originThumb[curIndx] !== undefined ? this.originThumb[curIndx] : this.currentPhoto;

			var cacheLimit = 8;
			var length = this.collectionSet.length;

			if (curIndx !== -1) {
				var i = curIndx < cacheLimit ? 0 : curIndx - cacheLimit;

				for (i; i <= curIndx + cacheLimit && i < length; i++) {
					if (this.collectionSet[i] !== undefined &&
						!this.IMGCACHE.hasOwnProperty(this.collectionSet[i].id)) {
						this.IMGCACHE[this.collectionSet[i].id] = cacheImg.call(this, this.collectionSet[i], i);
					} else {
						continue;
					}
				}
			}

			if (this.IMGCACHE.hasOwnProperty(this.currentPhoto.id)) {
				this.$currentImg = this.IMGCACHE[this.currentPhoto.id];

				if (this.$currentImg.loadStatus === undefined) {
					this.$currentImg = cacheImg.call(this, this.currentPhoto, curIndx);

					this.IMGCACHE[this.currentPhoto.id] = this.$currentImg;
				}
			}

			this.setTemplateOptions({id: this.currentPhoto.id});

			// if already in dom
			if (this._indom) {
				fox.each(fox.dom.select('.social-row'), function(val) { 
					val.setAttribute('data-target-id', this.currentPhoto.id); 
				}, this);		
				this.rwom1('#currentRating').embedding();
				this.rwom1('#imageFavorite').embedding();
			}

			var c = this.rwom1('#imageComments');
			c.setTargetIds([this.currentPhoto.id]);

			var f = this.rwom1('#imageFavorite');
			f.setTargetIds([this.currentPhoto.id]);

			return this;
		},

		render: function () {
			this.callParent('render', arguments);

			this.rwom1('#body').render();
		},

		setPhotoCollection: function (collection, original, preview) {
			collection = this.sortPosition(collection);
			if (collection !== this.collectionSet) {
				this.collectionSet = collection;

				if (original) {
					this.originThumb = this.sortPosition(original);
				}

				if (preview) {
					this.previewThumb = this.sortPosition(preview)
				}
			}

			this.setSocialTargetIds(this.collectionSet);

			return this;
		},

		setSocialTargetIds: function(c) {
			fox.each(c, function (val) {
				this.targetsIds.push(val.id);				
			}, this);			
			
			this.rwom1('#currentRating').setTargetIds(this.targetsIds);
			this.rwom1('#imageFavorite').setTargetIds(this.targetsIds);
		},

		show: function (params) {
			if (this.OPENED === true) {
				return this;
			}

			if (params !== undefined) {
				this.allowDownload = params.allowDownload;
			}

			this.curEffect = 'fadeInDown';

			this._readyToRender = true;
			this._readyToEmbed = true;

			!this.isEmbedded() && this.render();

			this.waitEvent(this, 'addedToDom', function (o, _this) {
				_this._readyToRender = false;
				_this._readyToEmbed = false;
				_this.OPENED = true;
			});

			return this;
		},

		hide: function () {
			if (this.OPENED === true) {
				this.OPENED = false;

				return this.stopSlideshow().cleanMem().removeFromDom();
			}
		},

		cleanMem: function () {
			this.IMGCACHE = null;
			this.IMGCACHE = {};
			this.collectionSet = null;
			this.originThumb = null;
			this.previewThumb = null;
			this.$currentImg = null;

			return this;
		},

		bodyOnStartAddedToDom: function () {
			if (this._readyToRender === false && this.OPENED === false) return false;

			var $imgContainer = $(this.dom1('.gallery-full-image'));

			if (this.$currentImg !== undefined && this.$currentImg[0].loadStatus === undefined) {
				$(this.dom1('.gallery-preloader')).show();
			}

			$imgContainer.html(this.$currentImg).addClass(this.curEffect);
			$(this.dom1('.gallery-fullscreen-view-photo-counter .count')).text(this.collectionSet.indexOf(this.currentPhoto) + 1);
		},

		addedToDom: function () {
			var hintCloseTime = parseInt(fox.utils.localStorage('getItem', '_gchintpanel_'));
			var $controll = $(this.dom1('.gallery-hint-controll'));

			$(this.dom1('.gallery-fullscreen-view-photo-counter .all')).text(this.collectionSet.length);

			if ((!hintCloseTime || (hintCloseTime && (new Date().getTime() > (hintCloseTime + 1000 * 60 * 60)))) && !this.mDeviceDetected()) {
				$controll.show();

				setTimeout(fox.bind(function () {
					$controll.fadeOut('slow');
					fox.utils.localStorage('setItem', '_gchintpanel_', new Date().getTime());
				}, this), 10000);	
			}

			if (this.allowDownload === 0) {
				$(this.dom1('#download-photo')).remove();
			}
		},

		showRealPixel: function () {
			if (!this.currentOriginPhoto) {
				return false;
			}

			var $container = $(this.dom1('.gallery-real-pixels-view')),
				$img = _.bindToImgJquery(this, $('<img>').attr('src', this.currentOriginPhoto.url));

			$container.html($img).show().css('overflow', 'auto');
		},

		hideRealPixels: function () {
			var $container = $(this.dom1('.gallery-real-pixels-view')),
				$el = $(this.dom1('#show-real-pixel'));

			if ($container.is(':visible')) {
				$container.hide('slow');
			}

			if ($el.hasClass('real-px')) {
				$el.removeClass('real-px');
			}

			return this;
		},

		downloadPhoto: function (el) {
			var _this = this;
			var transport = new XMLHttpRequest();
			transport.open('GET', this.currentOriginPhoto.url);
			transport.responseType = 'blob';

			transport.onload = function () {
				var a = document.createElement('a');
				var fname = _this.currentOriginPhoto.altTag.replace(/(\s-\s|\s|\.)/g, '_') + '.jpg';

				if (navigator.msSaveBlob) {
					return navigator.msSaveBlob(transport.response, fname);
				}

				if (window.URL || typeof safari !== 'undefined') {
					//if ('download' in a) {
						a.href = window.URL.createObjectURL(transport.response);
						a.setAttribute('download', fname);
						document.body.appendChild(a);

						setTimeout(function () {
							a.click();

							document.body.removeChild(a);
						}, 100);
					//}

					return true;
				}
			};

			transport.send();
		},

		startSlideshow: function () {
			var switchInt = parseInt(this.getOption('slideSwitchInterval'));
			$(this.dom1('.gallery-sidebar')).toggleClass('opened');
			$(this.dom1('.gallery-fullscreen-stop-slide-show')).show();

			this.slideshowStarted = setInterval(fox.bind(function () {
				var nextIndx = this.collectionSet.indexOf(this.currentPhoto);

				if (this.collectionSet[++nextIndx] !== undefined) {
					this.loadPhoto('next');
				}

				if (nextIndx === this.collectionSet.length) {
					this.setCurrentPhoto(this.collectionSet[0]);

					this.rwom1('#body').render();
				}
			}, this), switchInt);
		},

		stopSlideshow: function () {
			if (this.slideshowStarted) {
				clearInterval(this.slideshowStarted);
				this.slideshowStarted = null;
			};

			return this;
		},

		stopSlideshowHandler: function (el) {
			$(el).hide();
			$(this.dom1('.gallery-sidebar')).toggleClass('opened');

			return this.stopSlideshow();
		},

		mDeviceDetected: function () {
			var 
				platform = window.navigator.userAgent,
				mDevices = [
				    {device: 'Android', platform: /Android/},
				    {device: 'iPhone', platform: /iPhone/},
				    {device: 'iPad', platform: /iPad/},
				    {device: 'Symbian', platform: /Symbian/},
				    {device: 'Windows Phone', platform: /Windows Phone/},
				    {device: 'Tablet OS', platform: /Tablet OS/}
				];

			for (var i = mDevices.length; i--;) {
				if (mDevices[i]['platform'].test(platform)) {
					return true;
				}
			}

			return false;
		},
		sortPosition: function (sortObj) {
			return sortObj.sort(function (a, b) {
				return a.position < b.position ? -1 : a.position > b.position ? 1 : 0;
			});
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) { fox.registerWidget('SitePage_Home', {
	// configure: function () {

	// 	this.registerOptions('', {
	// 		widgets: {
	// 			crowdFunding: {
	// 				widget: 'CrowdFunding'
	// 			}
	// 		}
			
	// 	});

	// 	this.callParent('configure', arguments);
	// }
}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SitePage_Gallery

(function (fox, $) {
	
	fox.registerWidget('SitePage_Login', {

		configure: function () {

			this.registerOptions('', {
				widgets: {
					loginForm: {
						widget: 'User_Login',
						useCaptcha: true,
						reloadCaptchaOnError: true,
						captchaAlias: 'autumnNew',
						container: '.login-page-wrapper',
						template: 'user_login',
						autoRender: true,
						handleDom: {
							handleFocus: {
								event: 'focus',
								target: '[name]',
								callback: function (el) {
									var el = $(el);

									el.parent().removeClass('error').next().text('').removeClass('show');
									$('#loginFormError').hide();
									this.hideDefaultErrorBlock();
								}
							},
							reloadCapcha: {
								targetWidget: '#captcha',
								target: '.capcha-img img',
								event: 'click',
								callback: function () {
									this.wom1('#captcha').loadCaptcha()
								}
							}		
						},
						handleWom: {
							loginError: {
								event: 'loginError',
								widget: '@root',
								callback: function(response) {
									//$('#loginFormError').show();
									var alias = null;
									var txt = response.reason;
									var code = response.code;
									var container = $(this.element[0]);
									var inp;
									var erase = false;
									if (code == 2001 || code == 43) {
										alias = 'le';
									}

									if (code == 3) {
										alias = 'captcha';
										erase = true;
									}

									if (code == 4 || code == 44) {
										alias = 'password';
										erase = true;
									}

									if (code == 2 || code ==6) {
										//$('#loginFormError').show()
										this.showDefaultErrorBlock();
										this.hideErrorBlock();

										return;
									}

									input = container.find('[name="le"]')

									/* if (erase) {
										input.val('')
									}  */
									
									input.parent().addClass('error').next().text(txt).addClass('show');
									this.hideDefaultErrorBlock();

								}
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		}

	}, 'Site_Page');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';

	var _ = {
		mixBigThumb: function () {
			var fsv = this.rwom1('#fullscreenView');

			return fsv.mixBigThumb.apply(fsv, arguments);
		}
	};
	
	fox.registerWidget('MC_Photoset_Gallery', {
		configure: function () {
			this.bigThumb = [];
			this.previewThumb = [];

			this.registerOptions('', {
				template: 'sitepage_Gallery',
				autoRender: true,
				amountInRow: 4,
				itemRightMargin: 4,
				minItemInRow: 2,
				widthsConfig: [
					{dWidth: 1050, amountInRow: 4},
					{dWidth: 770, amountInRow: 3},
					{dWidth: 600, amountInRow: 2},
					{dWidth: 380, amountInRow: 1}
				],
				widgets: {
					fullscreenView: {
						widget: 'FullscreenView'
					},
					photoset: {
						widget: 'Content_Browser',
						container: '.main-block',
						externalLoad: true,
						preset: 'gallery',
						list: {
							manualRender: true,
							'tpl.row': 'sitepage_gallery_container'
						},
						'widgets.dl': {
							widget: 'Datalayer',
							limit: 1,
							metaFields: {
								zip: 1
							},
							fields: ['id', '_resources.timeline.url', '_resources.current.url', 'contentType', '_zip']

						}
					},
					photoList: {
						widget: 'List',
						group: 'photolist',
						'embed.container': '#gallery-cut',
						'embed.widget': '@parent #photoset #list',
						'tpl.row': 'sitepage_gallery_photolist_item',
						autoRender: false,
						'hooks.onStopRendering': this.photoListOnStopRendering,
						handleWom: {
							parentAddToDom: {
								event: 'addedToDom',
								widget: '@parent #photoset #list',
								callback: fox.bind(function (p, scope) {
									if (this.previewThumb.length <= this.amountInRow * 3) {
										$(this.dom1('#show-all-photos')).hide();

										return this.renderPhotoList(this.previewThumb);
									}

									this.renderPhotoList(this.previewThumb.slice(0, this.amountInRow * 3));
								}, this)
							}
						}
					},
					photosetListAll: {
						widget: 'List',
						group: 'photolist',
						'embed.container': '#gallery-all',
						'embed.widget': '@parent #photoset #list',
						'tpl.row': 'sitepage_gallery_photolist_item',
						autoRender: false,
						'hooks.onStopRendering': this.photoListOnStopRendering,
					},
					currentRating: {
						widget: 'Social_Rating',
						targetDl: '@parent #photoset #dl',
						targetField: 'id',
						'embed.widget': '@parent #photoset #list'
					},
					galleryComments: {
						showComments: true,
						widget: 'Social_Comments',
						targetDl: '@parent #photoset #dl',
						template: 'social_comment_scene',
						'embed.widget': '@parent #photoset #list',
						'handleDom.toggleForm': {
							targetWidget: '@parent #photoset #list'
						}
					},
					downloadButton: {
						widget: 'Widget',
						'embed.container': '.download-block',
						'embed.widget': '@parent #photoset #list',
						autoRender: false,
						'hooks.onStartRendering': function() {
							var embedWidget = this.wom1(this.getOption('embed.widget'));
							var dl = this.wom1('@parent #photoset #dl');
							var downloadAccess = window.parseInt(dl.getObjectValue('accessibility.downloadable'));
							var contentType = dl.getObjectValue('contentType');

							if (!downloadAccess) {
								return false;
							} else {
								var zip = dl.getObjectValue('_zip');
								if (!fox.isEmpty(zip) && zip !== '[error]'){
									this.setTemplateOptions({_zip: zip});
									this.setOption('template', 'photo_download'); 
								} else {
									this.setOption('template', '');
								}
							}
						},
						
					}
					
				},
				handleWom: {
					photosetLoaded: {
						event: 'loaded',
						widget: '#photoset #dl',
						callback: 'photosetLoaded'
					},
					listenNavi: {
						event: 'modified_1',
						widget: '@root #navi',
						callback: 'photosetChanged',
						'params.listenHistory': true,
						'params.alwaysActive': true
					}
				},
				handleDom: {
					showAllPhotos: {
						event: 'click',
						target: '#show-all-photos',
						targetWidget: '#photoset #list',
						callback: 'showAllPhotos'
					},
					handlePrevClick: {
						event: 'click',
						target: '.photo-item',
						targetWidget: '.List',
						callback: 'showFullscreen'
					},
					handleDownload: {
						event: 'click',
						target: '.photoset-download',
						targetWidget: '#photoset #list',
						callback: 'logDownloadEvent'
					}					
				}
			});

			if (fox.site.member) {
				this.registerOptions('', {
					widgets: {
						favorite: {
							widget: 'Social_Favorite',
							targetDl: '@parent #photoset #dl',
							targetField: 'id',
							'embed.widget': '@parent #photoset #list'
						}
					} 
				});
			}
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.setListConfig();
			this.callParent('init', arguments);
		},

		activate: function (params) {
			$(window).bind('orientationchange', fox.bind(this.onResize, this));

			this.callParent('activate', arguments);

			this.setPid(params.id);
			this.setPageAlias(fox.Navigator.get(0));
		},

		setPageAlias: function (alias) {
			this.pageAlias = alias;
		},

		getPageAlias: function () {
			return this.pageAlias;
		},

		photosetChanged: function (id, nav) {
			if (this.getPageAlias() !== nav.get(0)) {
				return;
			}
			if (!fox.isEmpty(id) && this.isActive() && this.isEmbedded()) {
				this.setPid(parseInt(id));
			}

		},

		setPid: function (id) {
			this.pid = id;

			this.getPhotoset(this.pid);

			return this;
		},

		onResize: function (e) {
			clearTimeout(this.resizeTimeout);

			this.resizeTimeout = setTimeout(fox.bind(function () {
				fox.each(this.getWidgetsByGroup('photolist'), function (w, alias) {
					if (w.isEmbedded()) {
						if (alias === 'photosetListAll') {
							w._readyToRender = true;
							w._readyToEmbed = true;

							w.wait('addedToDom').then(function () {
								w._readyToRender = false;
								w._readyToEmbed = false;
							});
						}

						w.render();
					}
				}, this);
			}, this), 300);
		},

		deactivate: function () {
			$(window).unbind('onorientationchange', fox.bind(this.onResize, this));
			this.rwom1('#fullscreenView').hide();
			return this.callParent('deactivate', arguments);
		},

		getPhotoset: function (id) {
			var dl = this.rwom1('#photoset #dl');

			if (this.rwom1('#photoset #list').getOption('manualRender') === true ||
				dl.getObjectValue('id') !== parseInt(id)) {
				dl.addFilter('id', ['id'], [id]).load();
			}
		},

		photosetLoaded: function (o, dl) {
			
			var r = dl.getCollection()[0]._resources;
			this.setTitle(dl);
			$('body, html').animate({
				scrollTop: $(this.element).offset().top - 50
			}, 500);

			this.originThumb = r.originThumb.filter(function (item) { return !!item.url; });
			this.bigThumb = _.mixBigThumb.call(this, r.bigThumb, r.originThumb).filter(function (item) { return !!item.url; });
			this.previewThumb = dl.getCollection()[0]._resources.previewThumb
				.filter(function (item) { return !!item.url; })
				.sort(function (a, b) {
					return a.position < b.position ? -1 : a.position > b.position ? 1 : 0;
				});
			this.allowDonwload = window.parseInt(dl.getObjectValue('accessibility.downloadable'));
		},

		renderMainContainer: function () {
			var w = this.rwom1('#photoset #list');

			w._readyToRender = true;
			w._readyToEmbed = true;

			w.render();

			this.waitEvent(w, 'addedToDom', function () {
				w._readyToRender = false;
				w._readyToEmbed = false;
			});
		},

		renderPhotoList: function (c) {
			this.rwom1('#photoList').setCollection(c, true);
			var downloadButton = this.wom1('#downloadButton');
			downloadButton.render();
		},

		setListConfig: function () {
			var config = {},
				docW = $(document).width(),
				maxWidth;

			fox.each(this.getOption('widthsConfig'), function (v) {
				if (maxWidth === undefined || maxWidth < v.dWidth) {
					maxWidth = v.dWidth;
				}

				if (v.hasOwnProperty('dWidth') && v.hasOwnProperty('amountInRow')) {
					if (docW < v.dWidth) {
						this.amountInRow = v.amountInRow;

						if (v.hasOwnProperty('itemRightMargin')) {
							this.itemMargin = v.itemRightMargin;
						} else {
							this.itemMargin = this.getOption('itemRightMargin');
						}
					}
				}
			}, this);

			if (docW > maxWidth) {
				this.amountInRow = this.getOption('amountInRow');
				this.itemMargin = this.getOption('itemRightMargin');
			}
		},

		photoListOnStopRendering: function () {
			var 
				l = this,
				parent = l.getParent(),
				mir = parent.getOption('minItemInRow'),
				cw,
				tempC = [],
				air,
				docW = $(document).width(),
				buildImagesRow,
				getContainerWidth,
				itemMargin
			;

			parent.setListConfig();

			air = parent.amountInRow;
			itemMargin = parent.itemMargin;

			getContainerWidth = function () {
				var width,
					$body = $(document.body);

				$body.css('overflow', 'scroll');
				width = $(l.getOption('embed.container')).width();
				$body.css('overflow', 'inherit');

				return width;
			};

			cw = getContainerWidth();

			buildImagesRow = function (row, air, containerWidth) {
				// TIME TO WUDOO MAGIC )))

				var tempH = 0,
					tempW = 0,
					averageH,
					getImgAspectRatio;

				getImgAspectRatio = function (o) {
					return parseInt(o.info.width) / parseInt(o.info.height);
				};

				averageH = containerWidth / row.reduce(function (a, v, indx, array) {
					if (indx === 1) {
						a = getImgAspectRatio(a);
					}

					return a + getImgAspectRatio(v);
				});

				if (row.length === 1 && air === 1) {
					averageH = containerWidth / getImgAspectRatio(row[0]);
				}

				fox.each(row, function (v, indx) {
					var itemW = averageH * getImgAspectRatio(v),
						$img = $(l.dom1(['#photo-', v.id, ' img'].join(''))).css('visibility', 'hidden'),
						handleImage;

					handleImage = function (event) {
						var showImg,
							imgDiffLine,
							imgLoadError;

						if (event.type === 'error') {
							imgLoadError = true;	
						}

						imgDiffLine = function () {
							if ($img.parent().offset().top < ($(window).height() + $(document).scrollTop())) {
								return true;
							} else {
								return false;
							}
						};

						showImg = function (delay) {
							var f, delayInterval;

							f = function () {
								//console.log($img, imgLoadError);
								if (imgLoadError === true) {
									$img.parent().addClass('img-load-error');
								} else {
									$img.css('visibility', 'visible');	
								}

								$img.parent().addClass('fadeInDown');

								setTimeout(function () {
									$img.parent().removeClass('fadeInDown');
								}, 1010);
							};
							
							if (!delay) {
								f();
							} else if (delay === true) {
								delayInterval = Math.floor(Math.random() * (400 - 200)) + 200;

								setTimeout(f, delayInterval);
							}
						};

						if (imgDiffLine()) {
							showImg();
						} else {
							fox.dom.on('scroll', document, function () {
								if (!$img.data('noMoreScroll') && imgDiffLine()) {
									showImg(true);

									$img.data('noMoreScroll', true);
								}
							});
							fox.dom.on('touchmove', document, function () {
								if (!$img.data('noMoreScroll') && imgDiffLine()) {
									showImg(true);

									$img.data('noMoreScroll', true);
								}
							});
						}
					};

					fox.dom.on('load', $img.get(0), handleImage);
					fox.dom.on('error', $img.get(0), handleImage);

					$img.parent().width((indx === row.length - 1) ? Math.floor(itemW) : itemW);
					$img.parent().height(averageH);

					if (indx !== row.length - 1) {
						$img.parent().css('marginRight', itemMargin);
					}
				});
			};

			for (var j = 0, i = 0; i < Math.ceil(l.collection.length/air); i++, j += air) {
				tempC.push(l.collection.slice(j, j + air));
			}

			if (tempC.length > 2 && tempC[tempC.length - 1].length < mir) {
				tempC[tempC.length - 2] = tempC[tempC.length - 2].concat(tempC.pop());
			}

			fox.each(tempC, function (val, indx) {
				var diffMargin = 0;

				if (val.length > 1) {
					diffMargin = itemMargin * (val.length - 1);
				}

				buildImagesRow(val, air, cw - diffMargin);
			}, this);
		},

		showAllPhotos: function (el) {
			var l = this.rwom1('#photosetListAll');

			l._readyToRender = true;
			l._readyToEmbed = true;
			l.setCollection(this.previewThumb.slice(this.amountInRow * 3));
			this.waitEvent(l, 'addedToDom', function () {
				l._readyToRender = false;
				l._readyToEmbed = false;
			});

			$(el).hide();
		},

		getImgById: function (id, c) {
			if (fox.isArray(c)) {
				return c.filter(function (value, index) {
					return Number(value.id) === Number(id);
				}).pop();
			}

			return false;
		},

		showFullscreen: function (e) {
			var id = $(e).data('id'),
				photoData = this.getImgById(id, this.bigThumb);

			if (photoData) {
				this.rwom1('#fullscreenView')
				.setPhotoCollection(this.bigThumb, this.originThumb, this.previewThumb)
				.setCurrentPhoto(photoData).show({
					allowDownload: this.allowDonwload
				});
			}
		},

		logDownloadEvent: function (e) {
			var api = new fox.Api(null, this._wom).method('logger.log');
			api.send({
				index: 'McUserActivity',
				path: fox.Navigator.getAll(),
				info: {event: 'download'}
			}, false);
		},

		getContentId: function () {
			return this.pid;
		},

		setTitle: function (data) {
			var collection = data.getCollection()[0];
			var metaDescription = fox.dom.selectFirst('meta[name="description"]');
			var nav = decodeURIComponent(fox.Navigator.get(2));
			var parseTitle = nav === 'false' ? collection.title : nav
			parseTitle = parseTitle.replace(/-/g, ' ');
			document.title = parseTitle + ' - Top Photos of ' + fox.getEnv('screenName');
			collection.description !== '' ? metaDescription.setAttribute('content', collection.description) : metaDescription.setAttribute('content', fox.getEnv('screenName') + ' High-quality Photo Gallery Images ' + parseTitle + '. Download photos or share to Facebook, Twitter, Tumblr, and Blogger.');
		}

	}, 'Site_Page');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';
	var _ = {
		mixBigThumb: function () {
			var fsv = this.rwom1('#fullscreenView');

			return fsv.mixBigThumb.apply(fsv, arguments);
		}
	};

	fox.registerWidget('MC_Photoset_GalleryS', {

		configure: function () {
			this.bigThumb = [];
			this.previewThumb = [];

			this.registerOptions('', {
				template: 'store_gallery_container',
				autoRender: true,
				amountInRow: 4,
				itemRightMargin: 4,
				minItemInRow: 2,
				widthsConfig: [
					{dWidth: 1050, amountInRow: 4},
					{dWidth: 770, amountInRow: 3},
					{dWidth: 600, amountInRow: 2},
					{dWidth: 380, amountInRow: 1}
				],
				widgets: {
					fullscreenView: {
						widget: 'FullscreenView'
					},
					
					photoList: {
						widget: 'List',
						group: 'photolist',
						'embed.container': '#gallery-cut',
						'embed.widget': '@parent',
						'tpl.row': 'sitepage_gallery_photolist_item',
						autoRender: false,
						'hooks.onStopRendering': this.photoListOnStopRendering,
						handleWom: {
							parentAddToDom: {
								event: 'addedToDom',
								widget: '@parent',
								callback: fox.bind(function (p, scope) {
									if (this.previewThumb.length <= this.amountInRow * 3) {
										$(this.dom1('#show-all-photos')).hide();
										return this.renderPhotoList(this.previewThumb);
									}
									this.renderPhotoList(this.previewThumb.slice(0, this.amountInRow * 3));
								}, this)
							}
						}
					},
					photosetListAll: {
						widget: 'List',
						group: 'photolist',
						'embed.container': '#gallery-all',
						'embed.widget': '@parent',
						'tpl.row': 'sitepage_gallery_photolist_item',
						autoRender: false,
						'hooks.onStopRendering': this.photoListOnStopRendering,
					}
				},
				handleDom: {
					showAllPhotos: {
						event: 'click',
						target: '#show-all-photos',
						callback: 'showAllPhotos'
					},
					handlePrevClick: {
						event: 'click',
						target: '.photo-item',
						targetWidget: '.List',
						callback: 'showFullscreen'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.setListConfig();
			this.callParent('init', arguments);
		},

		activate: function (params) {
			$(window).bind('onorientationchange', fox.bind(this.onResize, this));

			this.callParent('activate', arguments);
		},

		onResize: function (e) {
			clearTimeout(this.resizeTimeout);

			this.resizeTimeout = setTimeout(fox.bind(function () {
				fox.each(this.getWidgetsByGroup('photolist'), function (w, alias) {
					if (w.isEmbedded()) {
						if (alias === 'photosetListAll') {
							w._readyToRender = true;
							w._readyToEmbed = true;

							this.waitEvent(w, 'addedToDom', function () {
								w._readyToRender = false;
								w._readyToEmbed = false;
							});
						}

						w.render();
					}
				});
			}, this), 300);
		},

		deactivate: function () {
			$(window).unbind('onorientationchange', fox.bind(this.onResize, this));
			this.rwom1('#fullscreenView').hide();
			return this.callParent('deactivate', arguments);
		},

		photosetLoaded: function (collection) {
			var r = collection._resources;

			// $('body, html').animate({
			// 	scrollTop: $(this.element).offset().top - 50
			// }, 500);

			this.originThumb = r.originThumb;
			this.bigThumb = _.mixBigThumb.call(this, r.bigThumb, r.originThumb);
			this.previewThumb = r.previewThumb.sort(function (a, b) {
				return a.position < b.position ? -1 : a.position > b.position ? 1 : 0;
			});
		//	this.allowDonwload = dl.getObjectValue('accessibility.downloadable');
		},

		renderMainContainer: function () {
			var w = this.rwom1('@parent @parent #productList #list');

			w._readyToRender = true;
			w._readyToEmbed = true;

			w.render();

			this.waitEvent(w, 'addedToDom', function () {
				w._readyToRender = false;
				w._readyToEmbed = false;
			});
		},

		renderPhotoList: function (c) {
			this.rwom1('#photoList').setCollection(c, true);
		},

		setListConfig: function () {
			var config = {},
				docW = $(document).width(),
				maxWidth;

			fox.each(this.getOption('widthsConfig'), function (v) {
				if (maxWidth === undefined || maxWidth < v.dWidth) {
					maxWidth = v.dWidth;
				}

				if (v.hasOwnProperty('dWidth') && v.hasOwnProperty('amountInRow')) {
					if (docW < v.dWidth) {
						this.amountInRow = v.amountInRow;

						if (v.hasOwnProperty('itemRightMargin')) {
							this.itemMargin = v.itemRightMargin;
						} else {
							this.itemMargin = this.getOption('itemRightMargin');
						}
					}
				}
			}, this);

			if (docW > maxWidth) {
				this.amountInRow = this.getOption('amountInRow');
				this.itemMargin = this.getOption('itemRightMargin');
			}
		},

		photoListOnStopRendering: function () {
			var 
				l = this,
				parent = l.getParent(),
				mir = parent.getOption('minItemInRow'),
				cw,
				tempC = [],
				air,
				docW = $(document).width(),
				buildImagesRow,
				getContainerWidth,
				itemMargin
			;

			parent.setListConfig();

			air = parent.amountInRow;
			itemMargin = parent.itemMargin;

			getContainerWidth = function () {
				var width,
					$body = $(document.body);

				$body.css('overflow', 'scroll');
				width = $(l.getOption('embed.container')).width();
				$body.css('overflow', 'inherit');

				return width;
			};

			cw = getContainerWidth();

			buildImagesRow = function (row, air, containerWidth) {
				// TIME TO WUDOO MAGIC )))

				var tempH = 0,
					tempW = 0,
					averageH,
					getImgAspectRatio;

				getImgAspectRatio = function (o) {
					return parseInt(o.info.width) / parseInt(o.info.height);
				};

				averageH = containerWidth / row.reduce(function (a, v, indx, array) {
					if (indx === 1) {
						a = getImgAspectRatio(a);
					}

					return a + getImgAspectRatio(v);
				});

				if (row.length === 1 && air === 1) {
					averageH = containerWidth / getImgAspectRatio(row[0]);
				}

				fox.each(row, function (v, indx) {
					var itemW = averageH * getImgAspectRatio(v),
						$img = $(l.dom1(['#photo-', v.id, ' img'].join(''))).css('visibility', 'hidden'),
						handleImage;

					handleImage = function (event) {
						var showImg,
							imgDiffLine,
							imgLoadError;

						if (event.type === 'error') {
							imgLoadError = true;	
						}

						imgDiffLine = function () {
							if ($img.parent().offset().top < ($(window).height() + $(document).scrollTop())) {
								return true;
							} else {
								return false;
							}
						};

						showImg = function (delay) {
							var f, delayInterval;

							f = function () {
								if (imgLoadError === true) {
									$img.parent().addClass('img-load-error');
								} else {
									$img.css('visibility', 'visible');	
								}

								$img.parent().addClass('fadeInDown');

								setTimeout(function () {
									$img.parent().removeClass('fadeInDown');
								}, 1010);
							};
							
							if (!delay) {
								f();
							} else if (delay === true) {
								delayInterval = Math.floor(Math.random() * (400 - 200)) + 200;

								setTimeout(f, delayInterval);
							}
						};

						if (imgDiffLine()) {
							showImg();
						} else {
							fox.dom.on('scroll', document, function () {
								if (!$img.data('noMoreScroll') && imgDiffLine()) {
									showImg(true);

									$img.data('noMoreScroll', true);
								}
							});
							fox.dom.on('touchmove', document, function () {
								if (!$img.data('noMoreScroll') && imgDiffLine()) {
									showImg(true);

									$img.data('noMoreScroll', true);
								}
							});
						}
					};

					fox.dom.on('load', $img.get(0), handleImage);
					fox.dom.on('error', $img.get(0), handleImage);

					$img.parent().width((indx === row.length - 1) ? Math.floor(itemW) : itemW);
					$img.parent().height(averageH);

					if (indx !== row.length - 1) {
						$img.parent().css('marginRight', itemMargin);
					}
				});
			};

			for (var j = 0, i = 0; i < Math.ceil(l.collection.length/air); i++, j += air) {
				tempC.push(l.collection.slice(j, j + air));
			}

			if (tempC.length > 2 && tempC[tempC.length - 1].length < mir) {
				tempC[tempC.length - 2] = tempC[tempC.length - 2].concat(tempC.pop());
			}

			fox.each(tempC, function (val, indx) {
				var diffMargin = 0;

				if (val.length > 1) {
					diffMargin = itemMargin * (val.length - 1);
				}

				buildImagesRow(val, air, cw - diffMargin);
			}, this);
		},

		showAllPhotos: function (el) {
			var l = this.rwom1('#photosetListAll');

			l._readyToRender = true;
			l._readyToEmbed = true;
			l.setCollection(this.previewThumb.slice(this.amountInRow * 3));
			this.waitEvent(l, 'addedToDom', function () {
				l._readyToRender = false;
				l._readyToEmbed = false;
			});

			$(el).hide();
		},

		getImgById: function (id, c) {
			if (fox.isArray(c)) {
				return c.filter(function (value, index) {
					return Number(value.id) === Number(id);
				}).pop();
			}

			return false;
		},

		showFullscreen: function (e) {
			var id = $(e).data('id'),
				photoData = this.getImgById(id, this.bigThumb);

			if (photoData) {
				this.rwom1('#fullscreenView')
				.setPhotoCollection(this.bigThumb, this.originThumb, this.previewThumb)
				.setCurrentPhoto(photoData).show({
					allowDownload: this.allowDonwload
				});
			}
		},

		logDownloadEvent: function (e) {
			var api = new fox.Api().method('logger.log');
			api.send({
				index: 'McUserActivity',
				path: fox.Navigator.getAll(),
				info: {event: 'download'}
			}, false);
		},

		getContentId: function () {
			return this.pid;
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('SitePage_MyFriends', {}, 'Site_Page');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('SitePage_Passwordrecovery', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					passwordRecovery: {
						widget: 'User_PasswordRecovery'
					}
				}
			});

			this.callParent('configure', arguments);
		}

	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page photosets */

(function(fox) {

	fox.registerWidget('SitePage_Photosets', {}, 'Site_Page');
	
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	fox.registerWidget('SitePage_Post', {
		activate: function (params) {
			this.callParent('activate', arguments);
			this.postviewer = this.rwom1('.PostViewer');
			this.handleEvent(fox.Navigator, 'modified_1', function () {
				if (fox.Navigator.get(1)) {
					return this.postviewer.fetch(fox.Navigator.get(1));
				}
			}, this);
			return this.postviewer.fetch(params.id);
			
		},
		

	}, 'Site_Page');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_Privacy', {

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/**SitePage Scene */

(function(fox) { fox.registerWidget('SitePage_Scene', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = function(fox) {
	'use strict';
	fox.registerWidget('guestDisablePreview', {
		configure: function(options) {
			this.registerOptions('', {
				template: 'guest_preview',
				'widgets.banner': {
					widget: 'Html5Player_MC_Banner',
					'embed.container': '.disable-banner-link'
				}
			});

			this.callParent('configure', arguments);
		},

		beforeRender: function () {
			var dl = this.wom1(this.getOption('dl'));
			var collection = dl.getCollection();
			this.setTemplateOptions(collection[0]);
			this.callParent('beforeRender', arguments);
		}

	}, 'Widget');
}


/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('SitePage_Settings', {}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/*Site page site closed */
(function(fox) {

	fox.registerWidget('SitePage_SiteClosed', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					loginForm: {
						widget: 'User_Login',
						useCaptcha: true,
						reloadCaptchaOnError: true,
						captchaAlias: 'autumnNew',
						container: '#autorization-container',
						template: 'stateoff_user_login',
						autoRender: true,
						active: true,
						group: 'form',
						handleDom: {
							handleFocus: {
								event: 'focus',
								target: '[name]',
								callback: function (el) {
									var el = $(el);

									el.parent().removeClass('error').next().text('').removeClass('show');
									$('#loginFormError').hide();
									this.hideDefaultErrorBlock();
								}
							},
							reloadCapcha: {
								targetWidget: '#captcha',
								target: '#reload_captcha',
								event: 'click',
								callback: function () {
									this.wom1('#captcha').loadCaptcha()
								}
							}
						},
						handleWom: {
							loginError: {
								event: 'loginError',
								widget: '@root',
								callback: function(response) {
									//$('#loginFormError').show();
									var alias = null;
									var txt = response.reason;
									var code = response.code;
									var container = $(this.element[0]);
									var inp;
									var erase = false;

									if (code == 2001 || code == 43) {
										alias = 'le';
									}

									if (code == 3) {
										alias = 'captcha';
										erase = true;
									}

									if (code == 4 || code == 44) {
										alias = 'password';
										erase = true;
									}

									if (code == 2 || code == 6) {
										//$('#loginFormError').show();
										this.showDefaultErrorBlock();
										this.hideErrorBlock();

										return;
									}

									input = container.find('[name="le"]')

									if (erase) {
										input.val('')
									} 
									
									input.parent().addClass('error').next().text(txt).addClass('show');
									this.hideDefaultErrorBlock();
								}
							}
						}
					},
					socialAppsBlock: {
						widget: 'Stateoff_SocialApps_Block'
					}
				}
			})
		
			this.callParent('configure', arguments);
		}

	}, 'Site_Page');
	
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site page site under constraction */
(function(fox) {

	fox.registerWidget('SitePage_SiteUnderConstruction', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					newsletter: {
						template: 'stateoff_newsletterBlock',
						handleWom: {
							subscribeNotValidForm: {
								event: 'formNotValid',
								widget: '#form #validator',
								callback: '@parent:formNotValid'
							}
						},
						handleDom: {
							focus: {
								target: 'input',
								event: 'focus',
								callback: '@parent:inputHasFocus'
							}
						}
					},
					socialAppsBlock: {
						widget: 'Stateoff_SocialApps_Block'
					},
					tipmeBlock: {
						widget: 'Widget',
						manualRender: true,
						template: 'stateoff_content_tipmeblock',
						container: '#tipme',
						widgets: {
							tipme: {
								widget: 'Content_Tipme',
								'embed.container': '#tipme-container',
								template: 'stateoff_content_tipme',
								widgets: {
									'tipsDl.hooks.onLoaded': function() {
										var tipOption = this.getCollection().filter(function (v) {
											return Number(v.type) === 1;
										}).pop();
										
										if (tipOption) {
											var tipmeBlock = fox.wom.selectFirst('~#tipmeBlock');
											tipmeBlock.render();
											tipmeBlock.setOption('manualRender', false);
											this.dispatchEvent('loaded');
										}
									},
									'confirmPopup.widgets.tipsPopupContainer.widgets.content': {
										handleDom: {
											handleFocusInput: {
												event: 'focus',
												target: 'input[type="text"]',
												callback: function (el) {
													var el = $(el);
													el.removeClass('error').parent().removeClass('error');
												}
											}
										}
									}
								},
								'hooks.onHandleErrorToggle': function (data) {
									var state = data.state;
									fox.dom[state ? 'removeClass' : 'addClass']('error', data.el.parentNode)
								}
							}
						}
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		inputHasFocus: function(el) {
			var $el = $(el);
				
			if ($el.length) {
				$el.parent().removeClass('error').next().text('').removeClass('show');
			}
		},

		formNotValid: function(data) {
			fox.each(data.errorStack, function (v, field) {
				var $el = $(this.dom1('[name="' + field + '"]'));

				if ($el.length) {
					$el.parent().next().text(v[0].message);
				}
			}, this);
		}

	}, 'Site_Page');
	
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) { fox.registerWidget('SitePage_Sponsor', {
	configure: function () {

		this.registerOptions('', {
			widgets: {
				crowdFunding: {
					widget: 'CrowdFunding',
					'widgets.banner.embed.container': '.sponsor-page'
				}
			}
			
		});

		this.callParent('configure', arguments);
	}
}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Stateoff  Social Block */
(function(fox) {

	fox.registerWidget('Stateoff_SocialApps_Block', {

		configure: function () {
			this.registerOptions('', {
				manualRender: true,
				template: 'stateoff_social_appsblock',
				container: '#find-me',
				widgets: {
					socialApps: {
						'embed.container': '#find-me-container',
						widget: 'SocialApps',
						drawImage: false,
						'list.tpl.row': 'stateoff_social_apps_row',
						appDomElementOptions: {
							'twitter.linkClass': 'stateoff-icon-socialTwitter_44',
							'facebook.linkClass': 'stateoff-icon-socaialFacebook_44',
							'instagram.linkClass': 'stateoff-icon-socialInstagram_44',
							'tumblr.linkClass': 'stateoff-icon-socialThumblr_44'
						},
						'widgets.appsDatalayer.hooks.onLoaded': function() {
							if (!fox.isEmpty(this.getCollection())) {
								var socialAppsBlock = fox.wom.selectFirst('~#socialAppsBlock');
								socialAppsBlock.render();
								socialAppsBlock.setOption('manualRender', false);
								this.dispatchEvent('loaded');
							}
						}
					}
				}
			})
		
			this.callParent('configure', arguments);
		}

	}, 'Widget');
	
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_Terms', {

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) { fox.registerWidget('SitePage_Videos', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SocialApps

(function (fox, $) {
	
	fox.registerWidget('SocialApps', {

		configure: function () {
			this.registerOptions('', {
				skipPreloader: true,
				appDomElementOptions: {},
				targetInNewWindow: true,
				drawImage: true,
				imageLocation: 'social_icons',
				'embed.container': '.social',
				dataLayer: '#appsDatalayer',
				list: {
					'tpl.row': 'social_apps_row',
					'hooks.onStartRendering': '@parent:prepareCollection'
				},
				widgets: {
					appsDatalayer: {
						widget: 'Datalayer',
						method: 'SocialNetwork.getActiveList',
						cacheChannel: 'site'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this._appDomElementOptions = {
				twitter: {
					linkClass: this.getOption('appDomElementOptions.twitter.linkClass') || 'twitter',
					imageName: this.getOption('appDomElementOptions.twitter.imageName') || 'ico-tw.png'
				},
				facebook: {
					linkClass: this.getOption('appDomElementOptions.facebook.linkClass') || 'facebook',
					imageName: this.getOption('appDomElementOptions.facebook.imageName') || 'ico-fb.png'
				},
				instagram: {
					linkClass: this.getOption('appDomElementOptions.instagram.linkClass') || 'instagram',
					imageName: this.getOption('appDomElementOptions.instagram.imageName') || 'ico-insta.png'
				},
				tumblr: {
					linkClass: this.getOption('appDomElementOptions.tumblr.linkClass') || 'tumblr',
					imageName: this.getOption('appDomElementOptions.tumblr.imageName') || 'ico-t.png'
				},
				googlePlus: {
					linkClass: this.getOption('appDomElementOptions.googlePlus.linkClass') || 'google-plus',
					imageName: this.getOption('appDomElementOptions.googlePlus.imageName') || 'ico-gp.png'
				},
				youtube: {
					linkClass: this.getOption('appDomElementOptions.youtube.linkClass') || 'youtube',
					imageName: this.getOption('appDomElementOptions.youtube.imageName') || 'ico-yt.png'
				}
			}
		
			this.callParent('init', arguments);
		},

		prepareCollection: function () {
			var _res, _appName, performer, checkInsta;


			performer = this.rwom1('#appsDatalayer');
			checkInsta = fox.getEnv('instagramUrl') || false
			_res = performer.getCollection();
			this.getInstaforKey(_res)
			_res.inst = {}
			_res.inst = checkInsta ? {alias: "instagram", pageUrl: checkInsta, title: "Instagram"} : false
			
			fox.each(_res, function (_val, _key) {
				_appName = _val.alias;

				if (this._appDomElementOptions.hasOwnProperty(_appName)) {
					_val.elementClass = this._appDomElementOptions[_appName]['linkClass'];

					if (this.getOption('drawImage') === true) {
						_val.socImage = 
							fox._isNewFe ? 
								__webpack_require__(907)("./" + this._appDomElementOptions[_appName]['imageName']) : 
									fox.getEnv('design.url') + '/images/' + this.getOption('imageLocation') + '/' + this._appDomElementOptions[_appName]['imageName'];
					}

					if (this.getOption('targetInNewWindow') === true) {
						_val.newTarget = true;
					}
				}
			}, this);
			
			performer.setCollection(_res);
		},
		getInstaforKey: function (obj) {
			var _key = fox.getObjectKeys(obj);
			fox.each(_key, function (item) {
				if (obj[item].title === "Instagram"){
					delete obj[item]
				}
			})
			return obj;
		}
	}, 'Grid');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ico-bz.png": 908,
	"./ico-fb.png": 909,
	"./ico-gp.png": 910,
	"./ico-insta.png": 911,
	"./ico-pi.png": 912,
	"./ico-snapchat.png": 913,
	"./ico-t.png": 914,
	"./ico-tw.png": 915,
	"./ico-yt.png": 916
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social_icons/ico-bz.png", __webpack_require__.p + "_/_/_/root/images/social_icons/ico-bz.png");

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social_icons/ico-fb.png", __webpack_require__.p + "_/_/_/root/images/social_icons/ico-fb.png");

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social_icons/ico-gp.png", __webpack_require__.p + "_/_/_/root/images/social_icons/ico-gp.png");

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social_icons/ico-insta.png", __webpack_require__.p + "_/_/_/root/images/social_icons/ico-insta.png");

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social_icons/ico-pi.png", __webpack_require__.p + "_/_/_/root/images/social_icons/ico-pi.png");

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social_icons/ico-snapchat.png", __webpack_require__.p + "_/_/_/root/images/social_icons/ico-snapchat.png");

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social_icons/ico-t.png", __webpack_require__.p + "_/_/_/root/images/social_icons/ico-t.png");

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social_icons/ico-tw.png", __webpack_require__.p + "_/_/_/root/images/social_icons/ico-tw.png");

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social_icons/ico-yt.png", __webpack_require__.p + "_/_/_/root/images/social_icons/ico-yt.png");

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_Affiliate', {
		configure: function () {
			this.registerOptions('', {
				container: '#container',
				template: 'affiliateAgreement'
			});
		
			this.callParent('configure', arguments);
		},
	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
    
    fox.registerWidget('ThroughChatWindow', {

        configure: function () {
            this.registerOptions('', {
                autoRender: true,
                template: 'throughtChatWindow',
                defaultHeight: 440,
                staticWidth: 335,
                embed: {
                    container: '.wrapper',
                    location: 'lastChild'
                },

                templateOptions: {
                    chatWindowHidden: true,//fox.utils.localStorage('getItem', 'chatWindowHidden')
                },

                widgets: {
                    conversationViewer: {
                        widget: 'ConversationViewer',
                        markAsReadOnAir: false,
                        markAsReadOnWindowFocus: false,
                        template: 'throughtChatWindow_messages_container',
                        'scrollbar.position': 'inside',
                        'scrollbar.theme': 'minimal',
                        'embed.container': '.chat-wrapper',
                        'list.embed.container': '.messages-list',
                        'list.tpl.row': 'throughtChatWindow_messages_item',
                        'handleDom.sendByEnter.callback': function (el, alias, scope, e) {
                            if (e.ctrlKey === true && e.keyCode === 13) {
                                setTimeout(fox.bind(function () {
                                    this.sendMessageHandler();
                                }, this), 10);
                            }

                            if ([13, 46, 8].indexOf(e.keyCode) !== -1) {
                                setTimeout(function () {
                                    el.style.height = [20 * el.value.split('\n').length, 'px'].join('');
                                }, 10);
                            }
                        }
                    }
                },

                handleWom: {
                    messageReceived: {
                        widget: '@root #newMessageCount',
                        event: 'cameNewMessages',
                        callback: '_handleIncomingMessage'	
                    }
                },

                handleDom: {
                    hide: {
                        target: '.close',
                        event: 'click',
                        callback: 'hideWindow'
                    },

                    show: {
                        target: '.througth-chat-notifications',
                        event: 'click',
                        callback: 'showWindow'
                    },
                }
            });

            this.callParent('configure', arguments);
        },

        beforeEmbed: function () {
            if (fox.utils.isTouchDevice() || !this._wom.getRoot().member) {
                return false;
            }

            return this.callParent('beforeEmbed', arguments);
        },

        running: function (argument) {
            if (this._disabled) return false;

            this.convViewer = this.wom1('#conversationViewer');

            $(window).on('resize', {w: this}, this._handleWindowResize);

            this.handleEvent(fox.Navigator, 'modified_0', this._handleNaviChange);

            this.callParent('running', arguments);
        },

        addedToDom: function () {
            window.setTimeout(fox.bind(function () {
                this.applyHeight(this.getHeight());
                this.makeDraggable();
            }, this), 500);
        },

        makeDraggable: function (argument) {
            this.getChatContainer().draggable({
                handle: '.chat-title',
                containment: 'window',
                stop: fox.bind(function(ev, ui) {
                    this.savePosition(ui.offset);
                }, this)
            }).resizable({
                maxWidth: this.getOption('staticWidth'),
                minWidth: this.getOption('staticWidth'),
                minHeight: this.getOption('defaultHeight'),
                containment: 'document',
                handles: {
                    n: '.resize.resize-n',
                    s: '.resize.resize-s'
                },
                resize: fox.bind(function (ev, ui) {
                    this.updateScrollBar();
                }, this),
                stop: fox.bind(this._handleResizeStop, this)
            });

            var position = this.getPosition();

            if (position) {
                this.applyOffset(position);
            }

            this.makeVisible();
        },

        makeVisible: function (argument) {
            this.getChatContainer().css('visibility', 'visible');
        },

        getHeight: function () {
            var h = fox.utils.localStorage('getItem', 'chatWindowHeight');

            if (!h) {
                return false;
            }

            return h;
        },

        applyHeight: function (h) {
            h = (h > window.innerHeight ? h = window.innerHeight : h);
            this.getChatContainer().height((h || this.getOption('defaultHeight')) + 'px');
        },

        saveHeight: function (h) {
            fox.utils.localStorage('setItem', 'chatWindowHeight', h);
        },

        savePosition: function (offset) {
            fox.utils.localStorage('setItem', 'chatWindowPosition', [(offset.top - window.scrollY) , offset.left].join(':'));
        },

        getPosition: function (argument) {
            var offset = fox.utils.localStorage('getItem', 'chatWindowPosition');

            if (!offset) {
                return false;
            }

            offset = offset.split(':');
            
            return {top: offset[0], left: offset[1]};
        },

        getChatContainer: function (argument) {
            return this.element && $(this.element[0]).find('.througth-chat-wrapper');
        },

        applyOffset: function (offset) {
            fox.each(offset, function (val, prop) {
                this.getChatContainer().css(prop, val + 'px');
            }, this);
        },

        updateScrollBar: function (argument) {
            $(this.convViewer.element[0])
                .find('#messages-list-scroll-wrapper')
                .mCustomScrollbar("update");
        },

        _handleResizeStop: function (ev, ui) {
            this.saveHeight(ui.size.height);
            this.updateScrollBar();
        },

        hideWindow: function (argument) {
            this.getChatContainer().addClass('hidden');
            fox.utils.localStorage('setItem', 'chatWindowHidden', 1);
        },

        showWindow: function (argument) {
            this.getChatContainer().removeClass('hidden');
            fox.utils.localStorage('removeItem', 'chatWindowHidden');
            this.convViewer.delayedAsReadMarking(1000);
        },

        _handleIncomingMessage: function (data) {
            this.insertNumber(data.total);
        },

        insertNumber: function (num) {
            var elm = this.dom1('.counter .num');
            var cont = this.dom1('.througth-chat-notifications');
            var newIncoming = fox.dom.hasClass('exists', cont);

            this.count = num;

            if (num === 0) {
                elm.innerHTML = '';
                fox.dom.removeClass('exists', cont);
                fox.dom.removeClass('new', cont);
                return;
            }

            var txt = (num > 1 ? 'new messages' : 'new message');

            elm.innerHTML = [num, txt].join(' ');
            fox.dom.addClass('exists', cont);
            fox.dom.addClass('new', cont);

            if (newIncoming) {
                fox.dom.removeClass('new', cont);
                this.window.setTimeout(fox.bind(function (argument) {
                    fox.dom.addClass('new', cont);
                }, this), 100);
            }
        },

        _handleWindowResize: function (e) {
            var w = e.data.w;

            if (w.timer) {
                w.window.clearTimeout(w.timer);
            }

            w.timer = w.window.setTimeout(fox.bind(function (argument) {
                this.checkDimmensionsOnResize();
            }, w), 1000);
        },

        checkDimmensionsOnResize: function (argument) {
            var elm  = this.getChatContainer();
            var top = this.getPosition().top;
            var left = this.getPosition().left;
            var height = this.getHeight();
            var wWidth = $(window).width();
            
            if (!elm)
                return false;

            if ((elm.width() + elm.offset().left) > wWidth) {
                left = wWidth - elm.width();
            }

            if ((elm.height() + elm.offset().top) > window.innerHeight) {
                top = window.innerHeight - elm.height();
            }

            if (elm.height() > window.innerHeight) {
                height = this.getOption('defaultHeight');
                top = window.innerHeight - elm.height();
            }

            if (top < 0) {
                top = 0;
            }

            if (left < 0) {
                left = 0;
            }

            this.savePosition({top: top, left: left});
            this.saveHeight(height);

            this.getChatContainer().css({
                left: left + 'px',
                top: top + 'px',
                height: height + 'px'
            });

            this.updateScrollBar();
            
        },

        _handleNaviChange: function (page) {
            if (page == 'conversation') {
                this.toggle('hide');

                return;
            }

            this.toggle('show');
        },

        toggle: function (state) {
            if (this._indom && this.element[0]) {
                this.element[0].style.display = (state == 'hide' ? 'none' : '');

                return;
            }

            this.waitEvent(this, 'addedToDom', fox.bind(function (argument) {
                this.toggle(state);
            }, this));
        },

        isVisible: function () {
            if (this.isEmbedded()) {
                return $(this.element).is(':visible');
            }

            return false;
        }

    }, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// TipsMenuChecker Widget

(function (fox, $) {
	
	fox.registerWidget('TipsMenuChecker', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					api: {
						widget: 'Api',
						method: 'tips.getTipsCount',
						cacheChannel: 'site',
						sendTimezone: true
					}
				},
				handleWom: {
					apiSuccess: {
						event: ['success', 'failure', 'error'],
						widget: '#api',
						callback: 'apiSuccess'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		apiSuccess: function (res) {
			res = res.answer.response;

			if (res > 0) {
				this.ml.render();
			}
		},

		init: function () {
			this.embedMenuLink();		
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.ml = this.rwom1('#menuLink');
			this.ml._readyToRender = false;

			this.rwom1('#api').send();
		
			this.callParent('running', arguments);
		},

		embedMenuLink: function () {
			this.embedWidget('menuLink', 'Widget', fox.merge({
				autoRender: false,
				template: 'layout_tips_menu',
				'embed.location': 'under'
			}, this.getOption('menuLink')));

			return this;
		}

	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Twitter List Widget */

(function(fox) {

	fox.registerWidget('Twitter', {

		configure: function (options) {
			this.registerOptions('', {
				widgets: {
					dl: {
						widget: 'Datalayer',
						method: 'SocialNetwork.getPosts',
						cacheChannel: 'snLocal',
						transitParameters: {
							alias: 'twitter'
						},	
					},
					viewMore: {
						widget: 'Widget',
						'widgets.socialNetworkApi': {
							widget: 'Api',
							method: 'SocialNetwork.getByAlias',
							cacheChannel: 'site'
						},
						'handleWom.socialNetworkApi': {
							widget: '#socialNetworkApi',
							event: 'ready',
							callback: function(response) {
								this.setTemplateOptions(response);
								this.render();
							}
						},
						'hooks.onRunning': function() {
							this.rwom1('#socialNetworkApi').send({
								alias: 'twitter'
							});
						},
						embed: {
							widget: '@parent',
							container: '.view'
						},
						autoRender: false,
						template: 'twitter_view_more'

					}
				},
				container: '#twit_block',
				template: 'twitter_grid',
				list: {
					container: '#twits.twits-list',
					'tpl.row': 'twitter_list',
					'handleWom.addedToDom': {
						widget: '@this',
						event: 'addedToDom',
						callback: '@parent:addedToDomList'
					}
				},

			});
			fox.registerTemplateModifier('nofollow', function (obj) {
				if (fox.isEmpty(obj)) return;
				var obj1 = obj.replace(/<a href/g, '<a rel="nofollow" href');
				return obj1;
			});
			this.callParent('configure', arguments);
		},

		addedToDomList: function() {
			fox.each(this.dl.getCollection(), function(obj, id) {
				var elm = fox.dom.selectFirst('[data-id="' + id + '"]', this.element[0]);
				if (!fox.isEmpty(elm)) {
					elm.innerHTML = obj.postText;
				}
			}, this);
		},

		init: function() {
			this.handleEvent(this, 'updated', fox.bind(this.render, this));
			this.callParent('init', arguments);
		},

		rendering: function () {
			this.callParent('rendering', arguments);
			
			if (!this.dl.getCount()) {
				//clean fragment if no twits
				this.fragment = document.createDocumentFragment();
			}
		}

	}, 'Grid');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	
	fox.registerWidget('VerifiedCall', {

		configure: function () {
			this.trefs = {
				page: {
					template: 'callme_widget_full',
					wStyle: 'i',
					width: 272,
					height: 265
				},
				banner: {
					template: 'callme_widget_banner',
					wStyle: 'j',
					width: 189,
					height: 41
				}
			};

			this.registerOptions('', {
				widgets: {
					verifiedCall: {
						widget: 'Widget',
						'hooks.onStopRendering': this.onStopRendering
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.verifiedCallProfile = fox.getEnv('modelProps.verifyProfile');

			this.registerOptions('.Widget', {
				autoRender: true,
				embed: this.getOption('embed'),
				template: this.trefs[this.getOption('style') || 'page'].template,
				templateOptions: {
					vfcProfile: this.verifiedCallProfile
				}
			});
		
			this.callParent('init', arguments);
		},

		getIframeWidget: function () {
			var
				style = this.trefs[this.getOption('style')];

			if (this.iframe === undefined) {
				this.iframe = $('<iframe>').attr({
					src: ['https://verifiedcall.com/module/?talent=', this.verifiedCallProfile, '&style=', style.wStyle, '&aff=modelcentro'].join(''),
					frameborder: '0',
					scrolling: 'no',
					width: style.width,
					height: style.height,
					allowTransparency: true,
					aff: 'modelcentro'
				});
			}

			return this.iframe;
		},

		onStopRendering: function () {
			var
				$iframe = this.getParent().getIframeWidget();

			$iframe.prependTo(this.fragment);
		}

	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	fox.registerWidget('VrPlayer', {
		configure: function () {
			
			/* !!! IMPORTANT !!! */
			/* FALLBACK_URL will work if there is a parameter (dl8-start-from-cors-fallback=true) */
			/* The player adds this option now */

			this.FALLBACK_URL = 'http://ec-large.centrofiles.com/h3/CoH9Id9aghI3BoqpwR7hX4pnbaO-Ot-IJN4lZgme-zutMxsDIyn7cd1svpNI6hTr4CYAnocH2jelY0-Mt3ZW35Ix3JE0Pir5/vrplayer.html';
			this.SUPPORT_CROSSORIGIN = true;
			this.registerOptions('', {
				/* Player Options */
				vrPlayerLoaded: false,
				//LICENSEKEY: '4e3b16dad1d80ce0b663ae27911acfb3a7a8f2d0' /* free license key */,
				//LICENSEKEY: '2e68b0611e00422a1671c172c0e02efdb5adaab8', /* free license key */,
				LICENSEKEY: 'd56e7d4505e6950eac9b8bea589db2be04de18c8' /* badoink license key */,
				path: '//cdn.delight-vr.com/latest/dl8-',
				playerLogoUrl: false,
				playerPrimaryColor: '#ffffff',
				playerSecondaryColor: '#000000',

				/* Widget Options */
				container: '.player-wrapper',
				template: 'vrVideo',
				mode: 'format',
				jsonizeMapRequest: true,
				manualRender: true,
				widgets: {
					mapApi:{
						widget: 'Api',
						method: 'site.format.getMap'
					},
					getCdnFormatLinkApi:{
						widget: 'Api',
						method: 'site.format.get'
					}
				},
				handleWom: {
					recieveContentId: {
						widget: '@parent',
						event: 'setContentId',
						callback: 'recieveContentId'
					},
					added: {
						widget: '@this',
						event: 'addedToDom',
						callback: 'scrollToWrapper'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this._included = false;

			this.include();
			
			this.callParent('init', arguments);
		},

		activate: function() {
			this.resetData();
			this.callParent('activate', arguments);
		},

		deactivate: function() {
			this.resetData();
			this.callParent('deactivate', arguments);
		},

		include: function() {
			if (this._included) {
				return;
			}
			
			this.addPlayerLogo();

			this.createMetaTag('dl8-customization-no-content-badge');
			this.createMetaTag('dl8-customization-no-brand-watermark-logo');
			this.createMetaTag('dl8-customization-primary-color', this.getOption('playerPrimaryColor'));
			this.createMetaTag('dl8-customization-secondary-color', this.getOption('playerSecondaryColor'));

			this.addVrScript();

			this._included = true;
		},

		addPlayerLogo: function() {
			var logo = this.getOption('playerLogoUrl');
			if (logo) {
				this.createMetaTag('dl8-customization-brand-logo', logo);
			} else {
				this.createMetaTag('dl8-customization-no-brand-logo');
			}
		},

		createMetaTag: function(name, content) {
			var meta = window.document.createElement('meta');

			meta.name = name;

			if (content) {
				meta.content = content;
			}

			window.document.head.appendChild(meta);
		},

		addVrScript: function() {
			var script = window.document.createElement('script');

			script.onload = fox.bind(this.vrPlayerLoaded, this);
			script.src = this.getOption('path') + this.getOption('LICENSEKEY') + '.js';
				
			window.document.body.appendChild(script);
		},

		vrPlayerLoaded: function() {
			this.vrPlayerLoaded = true;
			this.dispatchEvent('vrPlayerLoaded');
		},

		resetData: function() {
			this.vrType = 'STEREO_180_LR';
			this.setContentId('');
			this.setPoster('');
			this.setFormatMap([]);
			this.setBitrates([]);
		},

		recieveContentId: function(id) {
			this.formatGetMap(id);
		},

		formatGetMap: function(id, resCallback, callbackParams) {
			var 
				api = this.wom1('#mapApi'),
				apiParams = {};
			
			this.checkSupportCrossOrigin();

			this.setContentId(id);

			this.waitEvent(api, 'success', resCallback || 'formatGetMapApiSuccessHandler', callbackParams || {});

			apiParams = {
				contentId: this.getContentId(),
				mode: this.getOption('mode')
			};

			if (!this.SUPPORT_CROSSORIGIN) {
				apiParams.get = 'link';
			}

			api.send(apiParams, this.getOption('jsonizeMapRequest'));
		},

		getCdnFormatLinkApi: function(format, resCallback) {
			var 
				api = this.wom1('#getCdnFormatLinkApi'),
				apiParams = {};


			apiParams = {
				params: this.getContentId() + '/' + format + '/stream',
				video: 1,
				get: 'link'
			};

			api.psend(apiParams).then(function(response){
				var res = response.params.answer.response;
				if (resCallback) {
					resCallback(res);
				}
			});
		},

		formatGetMapApiSuccessHandler: function(data) {
			this.preparePlayerData(data.answer.response);
		},

		preparePlayerData: function (map) {
			this.setFormatMap(map);
			this.buildBitrates();
			this.setPoster(this.getPrimaryThumb());

			var bitrates = this.getBitrates();

			this.setTemplateOptions({
				poster: this.getPoster(),
				sources: bitrates,
				vrType: this.vrType
			});



			if (this.SUPPORT_CROSSORIGIN) {
				this.renderPlayer();
			} else {
				this.getCdnFormatLinkApi(this.startFormat, function(response) {
					var cdnLinks = [];
					for(var i = 0; i < bitrates.length; i++) {
						if (bitrates[i].name === this.startFormat) {
							bitrates[i].src = response;
							cdnLinks.push(bitrates[i]);
						}
					}

					this.setTemplateOptions('sources', cdnLinks);
					this.renderPlayer();
					
				}.bind(this));
			}
		},

		renderPlayer: function () {
			this.setFallbackUrl();

			if (this.vrPlayerLoaded) {
				this.render();
			} else {
				this.waitEvent('@this', 'vrPlayerLoaded', fox.bind(function () {
					this.render();
				}));
			}
		},

		setFallbackUrl: function() {
			var data = this.getTemplateOptions(),
				url = this.FALLBACK_URL;

			data.LICENSEKEY = this.getOption('LICENSEKEY');
			data.playerPrimaryColor = this.getOption('playerPrimaryColor');
			data.playerSecondaryColor = this.getOption('playerSecondaryColor');
			data.playerLogoUrl = this.getOption('playerLogoUrl');
			data.brandName = fox.site.getEnv('site.title');
			data.brandUrl = fox.site.getEnv('curUrl');
				
			url += '?start=' + window.btoa(JSON.stringify(data));

			this.setTemplateOptions('fallbackUrl', url);
		},

		buildBitrates: function() {
			var bitrates = [];
			var startFormatHeight =0;
			fox.each(this.getFormatMap().view, function(val, name) {

				//if (name !== 'hd960_vr_mobile' && name !== 'sd960_vr_mobile') {
				//	return;
				//}

				if (val.roles && !fox.inArray(val.roles, this.mode)) {
					return; // means 'continue'
				}
				
				var clip = window.location.protocol + '//' + this.window.location.host + val.link,
					params = ['video=1'];

				if (fox.site.member && fox.cookie.get('user_auth')) {
						params.push('auth_hash=' + fox.cookie.get('user_auth'));
				} else {
					params.push('auth_hash=empty');
				}

				if(fox.getEnv('siteProps.settingId')){
					params.push('settingId=' + fox.getEnv('siteProps.settingId'));
				}

				clip += (clip.indexOf('?') === -1 ? '?' : '&') + params.join('&');
				
				var bitrate = {
					name: name,
					type: 'video/' + val.type,
					src: clip
				};

				if (startFormatHeight < val.height) {
					this.startFormat = name;
				}

				if (val.vrType) {
					this.vrType = val.vrType;
				}
				
				bitrates.push(bitrate);

			}, this);

			if (bitrates.length) {
				bitrates.sort(function (a, b) {
					var aH = parseInt(a.height),
						bH = parseInt(b.height);
					if (aH > bH) {
						return -1;
					}
					if (aH < bH) {
						return 1;
					}
					return 0;
				});
			}
			this.setBitrates(bitrates);
			return this;
		},

		getPrimaryThumb: function(size) {
			/* Needs refactoring */

			var hSize = size,
				formats = this.getFormatMap(),
				alias,
				format;

			if (!hSize) {
				format = formats.view[this.startFormat];
				if (format) {
					hSize = format.height;
				} else {
					hSize = 480;
				}
			}

			if (hSize > 1080) {
				alias = 'h1360i';
			} else if (hSize > 720) {
				alias = 'h720i'; /* becouse h1080i doesn't exist */
			} else if (hSize > 480) {
				alias = 'h720i';
			} else {
				alias = 'h480i';
			}
			return 'http://cdn-small.nl.storage.adultcentro.com/' + this.getContentId() + '/thumb/primary/'+ alias;
		},

		setContentId: function(id) {
			this._contentId = id;
		},

		getContentId: function(value) {
			return this._contentId;
		},

		setFormatMap: function(map) {
			this.dispatchEvent('_changeFormat', {contentId: this.contentId});
			this._formatMap = map;
			return this;
		},

		getFormatMap: function() {
			return this._formatMap;
		},

		setBitrates: function(value) {
			this._bitrates = value;
		},

		getBitrates: function() {
			return this._bitrates;
		},

		setPoster: function(url) {
			this._poster = url;
		},

		getPoster: function() {
			return this._poster;
		},

		scrollToWrapper: function() {
			var pos = $(this.getOption('container')).parent().offset().top;
			$('html, body').animate({
				scrollTop: pos
			}, 300);
		},

		checkSupportCrossOrigin: function() {
			if (typeof window.safari === 'object' || /iPad|iPhone|iPod/.test(navigator.platform) || /(MSIE|Trident\/|Edge\/)/i.test(navigator.userAgent)) {
				this.SUPPORT_CROSSORIGIN = false;
			}
		}

	}, 'Widget');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	fox.registerWidget('WelcomeBanner', {
		configure: function (options) {
			this.registerOptions('', {
				fakePlayerButton: 'fake_player_button',
				widgets: {
					api: {
						widget: 'Api',
						method: 'site.welcome.get',
						cacheChannel: 'site',
						group: 'api'
					},
					video: {
						widget: 'Content_Html5Player',
						container: '.player-wrapper',
						template: 'sitepage_home_welcome_video',
						active: false,
						autoRender: true,
						renderPlayer: true,
						renderTo: '.player',
						onPausePlayerImage: fox._isNewFe ? __webpack_require__(29) : (fox.getEnv('design.url') + '/images/player_banner.png'),
						'html5PlayerConfig.plugins.controls.togglefullscreen': false,
						//'html5PlayerConfig.movie.autoplay': !!Number(fox.getEnv('siteProps.welcomeVideoAutoplay')) && !!Number(fox.cookie.get('splash')),
						'html5PlayerConfig.movie.autoplay': !!Number(fox.getEnv('siteProps.welcomeVideoAutoplay')),
						'html5PlayerConfig.plugins.controls.autoHide': true,
						'hooks.onBannerLoadError': fox.bind(this._handleWBLoadError, this)
					},
					banner: {
						active: false,
						autoRender: true,
						widget: 'Widget',
						template: 'sitepage_home_welcome_banner'
					},
					none: {
						active: false,
						autoRender: true,
						widget: 'Widget',
						template: 'sitepage_home_welcome_none'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.registerOptions('.Widget', {
				active: false,
				'container': this.getOption('container')
			});
			this.callParent('init', arguments);
		},

		deactivate: function (argument) {
			this.callParent('deactivate', arguments);
			this.dispatchEvent('deactivate');
		},

		sendApi: function () {
			var api = this.wom1('#api');

			if (api) {
				api.send();
			}
		},

		initWithChildren: function() {
			if (this.getOption('video.url')) {
				this.showHanlder({
					welcomeVideo: this.getOption('video.url')
				});
			} else {
				this.handleEvent('#api', 'ready', 'showHanlder');
				this.sendApi();
			}

			return this.callParent('init', arguments);
		},

		showHanlder: function(params) {
			this.welcomeData = params;
			this.hookWrapper('renderWelcomeData', params);
		},

		renderWelcomeData: function (params) {
			var alias = 'none';
			var v;
			if (!fox.isEmpty(params.welcomeVideo) &&
				!fox.inArray(['error', 'encoding'], params.welcomeVideo.split(':').shift())) {

				v = this.rwom1('#video');
				alias = 'video';
				v.setOption('videoUrl', params.welcomeVideo);

				if (!fox.isEmpty(params.welcomeBanner)) {
					v.setPoster(params.welcomeBanner);
				}

			} else if (!fox.isEmpty(params.welcomeBanner)) {
				v = this.rwom1('#banner');
				alias = 'banner';
				v.templateOptions.src = params.welcomeBanner;
			}
			
			if (!this.switchEmbeddedWidget(alias)) {
				this.rwom1('#' + alias).render();
			}
		},

		renderBanner: function (tplOpts) {
			var alias = 'banner';
			var w = this.rwom1('#' + alias);

			if (tplOpts) {
				w.templateOptions = tplOpts;
			}

			if (!this.switchEmbeddedWidget(alias)) {
				w.render();
			}
		},

		renderPlayer: function (params) {
			var alias = 'video';
			var w = this.rwom1('#' + alias);

			w.setOption('videoUrl', params.welcomeVideo);
			
			if (!this.switchEmbeddedWidget(alias)) {
				w.render();
			}
		},

		renderEmptyPlaceholder: function () {
			var alias = 'none';
			var w = this.rwom1('#' + alias);

			if (!this.switchEmbeddedWidget(alias)) {
				w.render();
			}
		},

		_handleWBLoadError: function (data) {
			var ev = data.e;
			var img = ev.srcElement || ev.target;
			var parent = img.parentNode;

			if (ev.type === 'error') {
				fox.dom.addClass('error', parent);
				parent.innerHTML = '';
				parent.appendChild(
					fox._isNewfe ?
						this.getTemplater('fakePlayerButton') :
						fox.Zen(this.getOption('fakePlayerButton'))
				);
			}
		}

	},  'Controller');
}) (fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(925);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_autumn-new-index.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_autumn-new-index.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "@font-face{font-family:simplifica;src:url(" + __webpack_require__(67) + ");src:url(" + __webpack_require__(67) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(926) + ") format(\"woff2\"),url(" + __webpack_require__(44) + ") format(\"woff\"),url(" + __webpack_require__(45) + ") format(\"truetype\"),url(" + __webpack_require__(46) + "#simplificasimplifica) format(\"svg\");font-weight:400;font-style:normal}.bg-color-1,.bg-color-2,.bg-color-3,.bg-color-5,.wrapper{transition:background-color .2s}.edited .logo-img{display:inline-block!important}.logotype-edit{position:relative;top:50%;margin-top:-29px;padding:10px 0}span.logo~a{display:none}.edited-text{min-width:380px}.header-block-wrapper .logo .edited-text .logo-img{display:inline-block;height:150px}.header-block-wrapper .logo .logo-text{padding:0!important}.header-block-wrapper .logo .inline-container{width:auto!important;right:0}.editor-wrapper.logoText2{min-width:150px;height:147px}.logo-text.fox-dictionary.cke_editable{background-color:transparent!important}.logo-text.foxEditor{min-width:85px}.header.foxEditor:hover{min-height:130px}.join-btn{display:block;font-family:simplifica;border-radius:2px;text-decoration:none;text-align:center;font-size:30px}.join-btn.foxEditor:hover{min-height:36px}.join-btn.foxEditor:hover:after{min-height:36px;top:5px}.logo-img.foxEditor:hover{min-width:80px}.welcome-block .wellcome-container{height:auto;position:relative;border-radius:2px;overflow:hidden}.welcome-block .wellcome-container>.editor-wrapper{width:60%;float:left}.welcome-block .wellcome-container .editor-wrapper.video-exists{width:100%;float:none}.welcome-block .wellcome-container .editor-wrapper.video-exists+.welcome-text{display:none}.welcome-block .wellcome-container .sc-welcome-banner-wrapp img{width:100%;max-height:none}.welcome-block .img{overflow:hidden;position:relative}.welcome-block .img .play{position:absolute;border-radius:3px;display:block;margin-top:-37px;line-height:50px;height:auto;font-size:30px;font-family:simplifica;cursor:pointer;top:0;right:0;bottom:0;left:0;margin:auto;white-space:nowrap;width:auto;text-align:center;max-width:145px;max-height:53px;padding:0 15px}.welcome-block .img .play i{font-size:22px;display:inline-block;padding-right:10px}.welcome-block .img img:not(\".small\"){min-width:100%}.welcome-block .welcome-text{position:static;padding:20px 15px;font-size:12px}.welcome-block .welcome-text .nice-scroll-viewport{height:120px;overflow:hidden;margin-bottom:20px;padding-left:1px}.welcome-block .welcome-text .nice-scroll-viewport.show-all{height:auto;overflow:auto;margin-bottom:0}.welcome-block .welcome-text .nice-scroll-viewport.show-all+.show-more{display:none}.welcome-block .welcome-text .show-more{margin-bottom:20px}.welcome-block .welcome-text h1,.welcome-block .welcome-text h2{font-family:simplifica;font-size:26px;line-height:45px;margin-bottom:15px}.welcome-block .welcome-text p{margin-bottom:20px;line-height:normal}.welcome-block .player{min-height:93px}div[data-fox-editor-type=image]{background-image:url(" + __webpack_require__(68) + ")}.player-wrapper .editor-wrapper{height:100%}.left-back,.right-back{height:100%;width:50%;position:fixed;top:0;z-index:1}.join-back,.left-back{background-position:100% 0;background-repeat:no-repeat;right:50%;margin-right:480px}.right-back{background-position:0 0;background-repeat:no-repeat;left:50%;margin-left:480px}.left-back:after,.right-back:after:after{content:\"\";position:absolute;left:0;bottom:0;right:0;height:500px;display:none;background-image:linear-gradient(180deg,hsla(0,0%,100%,0) 0,#000)}*{box-sizing:border-box}a,body,button,form,h1,h2,h3,h4,h5,html,img,input,li,p,textarea,ul{border:0;margin:0;padding:0;list-style:none;font-weight:400}a{text-decoration:none;cursor:pointer}h2,h3,h4{font-size:inherit}button,input[type=submit]{border:none;outline:none;cursor:pointer}input,textarea{resize:none;background:transparent;border-width:0;outline:none;padding:0}img{max-width:100%;height:auto;vertical-align:top;display:block}body,html{font-size:14px;line-height:22px;cursor:default;background-repeat:no-repeat;background-position:top;background-attachment:fixed;height:100%;min-height:100%;font-family:Arial,Helvetica,sans-serif}body.loading{cursor:wait}body:last-child:not(:root:root) .main-menu-wrapper .right-part.menu-wrapper .btn{padding:0 38px 0 18px}.nicescroll-rails{z-index:4!important;width:10px!important;right:5px!important}#ascrail2001>div{border-width:0!important}.wrapper{min-height:100%;overflow:hidden}.wrapper.menu-opened .page-width{transform:translateX(200px);position:relative;z-index:1}.wrapper.menu-opened #valentines-gifts-popup{display:none}.page-width{margin:0 auto;max-width:1000px;z-index:3;min-height:100vh;position:relative;transition:all .3s}.pad-lr{padding-left:20px;padding-right:20px}.pad-tb{padding-top:20px}.pad-b,.pad-tb{padding-bottom:20px}.pad-t{padding-top:20px}.global-title{font-family:simplifica;font-size:30px;line-height:30px;margin-bottom:15px;font-weight:400}.global-title *{font-size:inherit}.global-title,.global-title *{font-weight:400}.mobile-menu-icon{display:block;width:34px;height:26px;position:absolute;top:24px;left:20px;z-index:2;font-size:26px}.mobile-menu-icon.opened{display:none}.mobile-menu-icon.opened+.layout-overlay{display:block}.mobile-menu-icon.opened~.main-menu-wrapper .main-menu{box-shadow:4px 0 5px 0 rgba(0,0,0,.2)}.mobile-menu-icon.opened~.static-wrapper{transform:translateX(132px)}.layout-overlay{position:fixed;left:0;right:0;top:0;bottom:0;background-color:#000;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";filter:alpha(opacity=40);opacity:.4;display:none;z-index:2}.static-wrapper{position:relative;z-index:1}.small-loader{top:50%;margin-top:-9px;display:block;width:19px;height:19px;position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;visibility:hidden;background-repeat:no-repeat;background-position:0 0;transform:scale(1.5)}.small-loader.type-1{background-image:url(" + __webpack_require__(5) + ")}.small-loader.spin{visibility:visible;-ms-filter:none;filter:none;opacity:1;animation:play 1s steps(28) infinite;transform:scale(1)}.join-btn:hover,a:hover:hover{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}.preloader-block{min-height:300px;position:relative;width:100%}.wrapper .mCS-autoHide>.mCustomScrollBox>.mCSB_scrollTools,.wrapper .mCS-autoHide>.mCustomScrollBox~.mCSB_scrollTools{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.footer{text-align:center;font-size:12px}.footer .bottom{border-top-width:3px;border-top-style:solid;margin-top:25px;padding-top:25px}.footer .bill-cb{height:46px;background-image:url(" + __webpack_require__(50) + ");background-repeat:no-repeat;background-position:50%;margin:10px -15px;background-size:contain}.footer .powered_wrapper{width:100%}.footer .powered_wrapper .feedback_cb{height:30px;background-image:url(" + __webpack_require__(928) + ");background-repeat:no-repeat;background-position:50%;margin:10px!important;background-size:contain;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.footer .links{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:space-around;-moz-justify-content:space-around;justify-content:space-around;width:80%;margin:0 auto 10px}.footer .links span{display:none}.footer .links a{white-space:nowrap;display:inline-block;width:50%;text-align:center;margin-bottom:10px;cursor:pointer;text-decoration:underline}.footer .links a:hover{text-decoration:none}.mc-site-popup{position:fixed!important;max-width:100%}.ui-dialog{z-index:1000}.ui-dialog.mc-site-popup .ui-dialog-titlebar{height:0;overflow:hidden}.ui-dialog.mc-site-popup.with-ui-dialog-titlebar{padding:15px 20px 20px}.ui-dialog.mc-site-popup.with-ui-dialog-titlebar .ui-dialog-titlebar{height:auto;font-size:18px;line-height:normal;font-weight:700;padding-bottom:15px;margin-bottom:25px;border-bottom-width:1px;border-bottom-style:solid;line-height:30px;font-style:normal;margin-top:0}.ui-dialog.mc-site-popup.with-ui-dialog-titlebar .ui-dialog-titlebar-close{position:absolute;cursor:pointer;right:20px;top:22px;font-family:iconfont;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;font-size:14px}.ui-dialog.mc-site-popup.with-ui-dialog-titlebar .ui-dialog-titlebar-close:before{content:\"\\E601\"}.ui-dialog.mc-site-popup.with-ui-dialog-titlebar .popup-content{margin-bottom:20px}.ui-dialog.mc-site-popup.with-ui-dialog-titlebar .popup-footer{text-align:right}.ui-dialog.dark-overlay~.ui-widget-overlay{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";filter:alpha(opacity=80);opacity:.8;width:100%!important;height:100%!important;z-index:999!important;position:fixed!important;top:0!important;left:0!important;background-color:#000}.ui-dialog .ui-dialog-buttonpane{padding:0 20px}.ui-dialog.preview-content .content-actions{margin-bottom:0;padding-top:10px;padding-bottom:10px}.ui-dialog.preview-content .content-actions .attach-title{-moz-flex:2 0px;-ms-flex:2 0px;flex:2 0px}.ui-dialog.preview-content.mc-site-popup .nav-arrows{font-size:30px}.ui-dialog.preview-content.mc-site-popup .nav-arrows:before{margin-left:-19px}.ui-dialog.preview-content .additional-attach-info{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.ui-dialog.preview-content .nav-arrows{top:55px;bottom:115px}.ui-dialog.attach-unlock{max-width:350px}.popup{padding:15px 20px 20px}.popup .cross.close{position:absolute;cursor:pointer;right:20px;top:22px}.popup .title{font-size:18px;line-height:normal;font-weight:700;padding-bottom:15px;margin-bottom:25px;border-bottom-width:1px;border-bottom-style:solid;line-height:30px;font-style:normal;margin-top:0}.popup .popup-content{margin-bottom:20px}.popup .popup-footer{text-align:right}.tip-me-confirm .msg-block{margin:20px 0 10px}.tip-me-confirm .msg-block .row{margin-bottom:10px;display:block;position:relative}.mc-site-common-popup input,.mc-site-common-popup textarea{color:#000}.top-menu{z-index:10;height:70px;position:relative;line-height:42px;display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}.top-menu>div.left-part{display:block;position:absolute;left:0;top:100%;background-color:inherit}.top-menu>div.right-part{float:right;display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;font-size:12px}.top-menu>div .btn{height:42px;margin:0;padding:0 20px;border-radius:3px;display:block}.top-menu>div .btn:active{padding-top:1px}.top-menu>div .btn:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.top-menu>div .btn:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.top-menu>div .btn:hover{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}.top-menu>div .btn i{position:relative;top:3px;font-size:18px;margin-right:3px}.top-menu .action.logged>div.right-part{font-size:22px}.top-menu .action.logged>div.right-part>.ico{padding:0 19px;white-space:nowrap}.top-menu .action.logged>div.right-part>.ico i{position:relative;z-index:2;display:inline-block;vertical-align:middle}.top-menu .action.logged>div.right-part>.ico:first-child{padding-left:0}.top-menu .action.logged .num{font-size:12px}.top-menu .action.logged .settings-dd ul{border-radius:4px 0 4px 4px;visibility:hidden;position:absolute;top:100%;right:-1px;font-size:12px;line-height:30px;padding:14px 17px;text-transform:uppercase}.top-menu .action.logged .settings-dd ul li{position:relative}.top-menu .action.logged .settings-dd ul li:before{transform:scale(1.3);transition:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;visibility:hidden;display:block;content:\"\";border-radius:4px}.top-menu .action.logged .settings-dd ul li a{position:relative;z-index:2;padding:0 15px}.top-menu .action.logged .settings-dd ul li:hover:before{transform:scale(1);visibility:visible;transition:all .3s}.top-menu .action.logged .settings-dd:before{position:absolute;z-index:1;content:\"\";display:block;left:-1px;right:-1px;top:0;bottom:0;visibility:hidden;border-radius:4px 4px 0 0}.top-menu .action.logged .settings-dd:hover{border-color:transparent}.top-menu .action.logged .settings-dd:hover:before,.top-menu .action.logged .settings-dd:hover ul{visibility:visible}.main-menu{display:block;position:fixed;left:0;top:0;bottom:0;padding-top:30px;padding-left:40px;padding-right:30px;width:202px;box-shadow:0 0 0 0;z-index:0;transform:translateX(-100%)}.main-menu .link{display:inline-block;line-height:25px;margin-bottom:25px}.main-menu .link>a{display:block;position:relative;padding-left:35px}.main-menu .link>a .ico{transition:opacity .2s;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3;font-size:15px;position:absolute;top:4px;left:0}.main-menu .link>a:hover .ico{-ms-filter:none;filter:none;opacity:1}.welcome-block .welcome-text .mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical,.welcome-block .welcome-text .mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical{right:-20px}.welcome-block .wellcome-container.video-plaing,.welcome-block .wellcome-container.video-plaing .img.video,.welcome-block .wellcome-container.video-plaing .player,.welcome-block .wellcome-container.video-plaing .player-wrapper{height:auto}.social{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex}.social li{width:60px;height:39px;border-right-style:solid;border-right-width:1px;display:block;text-align:center}.social li a{transition:font-size .2s;display:block;height:inherit;font-size:20px;line-height:39px}.social li a i{vertical-align:middle}.social li a:hover{font-size:24px}.social li a:active{margin-top:2px}.social li:first-child{width:40px;text-align:left}.social li:last-child{border-right-width:0}.content-list.grid>div{width:49%}.content-list.grid>div:first-child{float:left}.content-list.grid>div:last-child{float:right}.content-list.grid>div.preloader-block{float:none!important;width:100%!important}.content-list.grid .item{width:100%}.content-list .item{border-radius:2px;margin-bottom:20px;position:relative;overflow:hidden}.content-list .item .info{padding:20px;text-align:center}.content-list .item .info .data .content{margin-top:20px}.content-list .item .info .data .content .post-content [data-font-size$=px]{font-size:inherit}.content-list .item .title{font-size:20px;line-height:30px;font-family:simplifica}.content-list .item .img{display:block;overflow:hidden;max-width:100%}.content-list .item .img img{min-width:100%}.content-list .item .num{font-size:32px;display:block;margin-bottom:5px}.content-list .item .added{font-size:12px;margin-top:5px}.content-list .item .socials{font-size:14px;line-height:22px}.content-list .item .socials span{display:inline-block;vertical-align:top;position:relative}.content-list .item .socials span .ico{position:absolute;font-size:18px;top:0}.content-list .item .socials span.sep{width:1px;height:22px;margin:0 20px}.content-list .item .socials .likes{padding-right:30px}.content-list .item .socials .likes .ico{right:0}.content-list .item .socials .comments{padding-left:30px}.content-list .item .socials .comments .ico{left:0;top:2px}.content-list .item.scene .img{position:relative;padding-top:56%}.content-list .item.scene .img .play,.content-list .item.scene .img video{display:none}.content-list .item.scene .img img,.content-list .item.scene .img video{top:0;position:absolute;left:50%;min-height:100%;width:auto;transform:translate(-50%)}.content-list .item.scene .total{font-size:12px}.content-list .item.scene .added{margin-top:0}.content-list .item.scene .over-timeline{cursor:pointer;width:100%;position:absolute;top:0;padding-top:80%;z-index:10}.content-list .item.scene .over-timeline .progressbar{position:absolute;top:0;display:-ms-flexbox;display:flex;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;width:100%;height:3px}.content-list .item.scene .over-timeline .progressbar .filling{height:3px}.content-list .item.loaderhover .filling{animation:bar .8s linear}.content-list .item.previewVideo .img video{display:block}.content-list .item.photoset .img img{min-width:100%}.content-list .item .fullscreen img{transform:scale(1);transition:transform .2s ease-in}.content-list .item .remove{z-index:2;cursor:pointer;border-radius:0 3px 3px 0;top:10px;padding:10px 15px;transition:all .3s ease-out}.content-list .item .remove,.content-list .item .watch-full{display:block;position:absolute;left:0;text-transform:uppercase;font-size:12px}.content-list .item .watch-full{right:0;bottom:0;padding:10px 0;text-align:center;line-height:20px}.content-list .item:hover .remove{transform:translateX(0)}.content-list .item:hover .fullscreen img{transform:scale(1)}.content-list .item.blog .data .post-content img{display:none}.content-list .item.blog .img img{position:relative;min-width:100%}.content-list .post-content img{height:auto!important}.play{transition:all .3s;position:absolute;width:52px;height:52px;border-radius:3px;display:block;left:50%;top:50%;margin:-26px 0 0 -26px}.play i{font-size:24px;line-height:52px;display:block;text-align:center}.vr-label{font-size:15px;position:absolute;right:0;top:3%;padding:12px 11px 11px;border-radius:2px 0 0 2px;z-index:3}.content-list .item .socials,.content-list .item .total{display:none}.tour-buttons .unlogged-buttons{display:block;margin-bottom:10px;line-height:55px;position:relative;cursor:pointer;border-radius:2px}.tour-buttons .unlogged-buttons:last-child{margin-bottom:0}.tour-buttons .unlogged-buttons .line{content:\"\";display:none;height:3px;border-radius:1px;position:absolute;top:50%;margin-top:-1.5px}.tour-buttons .unlogged-buttons .line.lt{left:30px}.tour-buttons .unlogged-buttons .line.rt{right:30px}.tour-buttons .unlogged-buttons .join-btn{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;line-height:56px;white-space:nowrap;max-height:97px}.tour-buttons .unlogged-buttons .join-btn span.icon:before{vertical-align:middle}.tour-buttons .unlogged-buttons .join-btn>div>p{font-family:simplifica!important;position:relative;line-height:inherit!important}.pager{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;border-top-width:2px;border-top-style:solid;line-height:52px;text-align:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.pager .pager-wrapp{display:inherit;border-bottom-width:2px;border-bottom-style:solid}.pager .pager-wrapp .pager-list{display:inherit}.pager .pager-wrapp .pager-num{width:40px;text-align:center;border-width:0 1px 0 0;border-style:solid;display:block;font-weight:700}.pager .pager-wrapp .arr.pager-num{width:65px;display:block}.pager .pager-wrapp .arr.pager-num:last-child{border-width:0}.pager .pager-wrapp .arr.disabled i{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.twit-block .twits-list li{display:block;margin-bottom:15px}.twit-block .view{text-align:right}.recorded-liveshows{margin-top:25px}.recorded-liveshows .over-timeline{display:none}.liveshow-banner{border-width:3px 0;border-style:solid;margin-bottom:25px}.liveshow-banner .title-block{font-size:16px;line-height:16px;padding:20px 0;text-transform:uppercase;text-align:center;position:relative}.liveshow-banner .title-block:after{content:\"\";display:block;position:absolute;bottom:-3px;border-width:3px 0 0;border-style:solid;height:3px;width:100%}.liveshow-banner .title-block.no-title{display:none}.liveshow-banner .banner-cam{margin-left:-20px;margin-right:-20px;margin-top:20px}.liveshow-banner .banner-cam .cam-wrapper{display:none;position:relative;height:92px;width:auto;margin:0 auto;padding:0;text-transform:uppercase;font-size:10px;font-weight:700;line-height:30px}.liveshow-banner .banner-cam .cam-wrapper .txt-2{font-weight:400;font-size:22px;line-height:25px}.liveshow-banner .banner-cam .cam-wrapper .stripe{position:absolute;top:0;height:100%;width:50%}.liveshow-banner .banner-cam .cam-wrapper .stripe.lt{left:0;padding-left:20px;padding-right:110px;padding-top:10px;text-align:right}.liveshow-banner .banner-cam .cam-wrapper .stripe.lt .txt-1,.liveshow-banner .banner-cam .cam-wrapper .stripe.lt .txt-2{letter-spacing:0}.liveshow-banner .banner-cam .cam-wrapper .stripe.rt{right:0;padding-right:20px;padding-left:110px;padding-top:20px}.liveshow-banner .banner-cam .cam-wrapper .stripe.rt .txt-1{letter-spacing:2px}.liveshow-banner .banner-cam .cam-wrapper .stripe.rt .txt-2{letter-spacing:0}.liveshow-banner .banner-cam .cam-wrapper .box{position:absolute;width:164px;height:100%;left:50%;margin-left:-82px;top:24px}.liveshow-banner .banner-cam .cam-wrapper .box .side{top:0;position:absolute;width:92px;height:83px}.liveshow-banner .banner-cam .cam-wrapper .box .side.lt{z-index:3;left:-5px;transform:rotate(25deg) skewX(25deg)}.liveshow-banner .banner-cam .cam-wrapper .box .side.rt{z-index:3;right:-6px;transform:rotate(-25deg) skewX(-25deg)}.liveshow-banner .banner-cam .cam-wrapper .box .side.top{z-index:1;width:91px;height:72px;top:-59px;left:50%;margin-left:-44px;transform:rotate(25deg) skewX(-40deg)}.liveshow-banner .banner-cam .cam-wrapper .box .cam{position:absolute;z-index:2;background:url(" + __webpack_require__(69) + ") 0 0 no-repeat;width:181px;height:144px;bottom:100%;margin-bottom:-30px;left:5px}.liveshow-banner .banner-cam .private{z-index:4;text-transform:none;border-radius:4px;font-size:21px;font-weight:700;line-height:36px;width:118px;text-align:center;position:static;top:30px;left:50%;margin:0 auto}.liveshow-banner .ban-content{padding-bottom:35px;margin-top:30px}.liveshow-banner .ban-content .date-cont{text-align:center;font-size:21px;font-weight:700;line-height:33px;margin-top:25px}.liveshow-banner .ban-content .date-cont i{font-size:13px;position:relative;top:-2px}.liveshow-banner .ban-content .time-cont{white-space:nowrap;text-align:center}.liveshow-banner .ban-content .time-cont .part div{margin-top:0;line-height:13px;font-size:11px;text-align:center}.liveshow-banner .ban-content .time-cont .digit{font-size:30px;font-weight:700;line-height:25px}.liveshow-banner .ban-content .time-cont .separator{margin:0 10px;line-height:25px;vertical-align:top;font-size:30px;position:relative;width:9px;text-indent:-10000px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.liveshow-banner .ban-content .time-cont .separator:before{top:5px}.liveshow-banner .ban-content .time-cont .separator:after{bottom:5px}.liveshow-banner .ban-content .guest-msg{display:none;text-align:center}.liveshow-banner .ban-content .guest-msg strong{font-size:21px;display:inline-block;margin-bottom:7px}.liveshow-banner .ban-content .mobile{display:none}.liveshow-banner .action-wrapper{margin-bottom:35px;text-align:center}.liveshow-banner .action-wrapper .mc-common-button{font-size:12px}.liveshow-banner .action-wrapper .mc-common-button i{font-size:20px;margin-right:5px;position:relative;top:-1px}.liveshow-banner .action-wrapper .mc-common-button>*{display:inline-block;vertical-align:middle;line-height:20px}.liveshow-banner.no_liveshow .ban-head{display:block}.liveshow-banner.no_liveshow .ban-content,.liveshow-banner.no_liveshow .liveshow-title{display:none}.liveshow-banner.next_liveshow .ban-head{display:block}.liveshow-banner.next_liveshow .noliveshow-block{display:none}.liveshow-banner.inited.private,.liveshow-banner.inited.private .ban-content,.liveshow-banner.next_liveshow .ban-content{display:block}.liveshow-banner.inited.private .noliveshow-block{display:none}.liveshow-banner.inited.private .guest-msg{display:block}.liveshow-banner.inited.private .scheduled-date{display:none}.liveshow-banner.inited.mobile-detect{display:block}.liveshow-banner.inited.mobile-detect .ban-head{display:none}.liveshow-banner.inited.mobile-detect .ban-content{margin-top:30px}.liveshow-banner.inited.mobile-detect .ban-content .scheduled-date{display:none}.liveshow-banner.inited.mobile-detect .ban-content .guest-msg{display:block}.liveshow-banner.inited.mobile-detect .ban-content .mobile{display:block;margin-top:20px}.liveshow-banner.inited.streamate{display:block}.liveshow-banner.inited.streamate .scheduled-date{display:none}.liveshow-banner.delay,.liveshow-banner.inited.streamate .guest-msg.show-streamate{display:block}.liveshow-banner.delay .noliveshow-block{display:none}.liveshow-banner.delay .guest-msg{display:block}.liveshow-banner.delay .scheduled-date,.liveshow-banner .show-streamate{display:none}.liveshow-banner .banner-cam .cam-wrapper .stripe:after,.liveshow-banner .banner-cam .cam-wrapper .stripe:before{position:absolute;content:\"\";display:none}.liveshow-banner .banner-cam .cam-wrapper .stripe.lt:after,.liveshow-banner .banner-cam .cam-wrapper .stripe.rt:after{width:0;height:0;border-style:solid;border-width:0 11px 46px;bottom:0}.liveshow-banner .banner-cam .cam-wrapper .stripe.lt:before,.liveshow-banner .banner-cam .cam-wrapper .stripe.rt:before{width:0;height:0;border-style:solid;border-width:46px 11px 0;top:0}.liveshow-banner .banner-cam .cam-wrapper .stripe.lt:after,.liveshow-banner .banner-cam .cam-wrapper .stripe.lt:before{left:-11px}.liveshow-banner .banner-cam .cam-wrapper .stripe.rt:after,.liveshow-banner .banner-cam .cam-wrapper .stripe.rt:before{right:-11px}.liveshow-banner .ban-content .time-cont .part,.liveshow-banner .ban-content .time-cont .separator{display:inline-block;text-align:center}.liveshow-banner .ban-content .time-cont .separator:after,.liveshow-banner .ban-content .time-cont .separator:before{content:\"\";display:block;border-radius:50%;width:5px;height:5px;position:absolute;left:0}.liveshow-banner.inited,.liveshow-banner.inited.private.private-ls-allowed.inited{display:none}.liveshow-banner-container .popup_streamate{height:448px;overflow:hidden}.common-input{position:relative;line-height:45px;font-family:Arial,Helvetica Neue,Helvetica,sans-serif}.common-input.type-2{line-height:30px}.common-input.type-2 input{height:30px;line-height:inherit}.common-input .border{transition:all .3s;z-index:1;position:absolute;top:0;left:0;right:0;bottom:0;border-width:1px;border-style:solid;border-radius:3px}.common-input.icon input{padding-left:55px;font-size:14px}.common-input.icon .ico{position:absolute;left:0;width:42px;z-index:3;top:inherit;bottom:inherit;text-align:center;vertical-align:middle;line-height:inherit;border-right-width:1px;border-right-style:solid;border-right-color:inherit;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}.common-input.icon+.error-message{left:55px;right:13px;text-align:left}.common-input.icon.captcha+.error-message{left:128px}.common-input textarea{padding:10px 13px;line-height:normal;height:62px}.common-input.txtarea{line-height:normal}.common-input+.err-msg{display:none;color:red;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:transform .2s ease-in,opacity .2s ease-out;transform:translateX(-10px)}.common-input.error+.err-msg{display:block;-ms-filter:none;filter:none;opacity:1;transform:translateX(0)}.common-input.error+.error-message{display:block}.common-input.error:not(.type-2):not(.tip):not(.size-1) input{background-color:transparent;position:relative;z-index:2;color:intherit}.common-input.error:not(.type-2):not(.tip) input::-webkit-input-placeholder{color:transparent}.common-input.error:not(.type-2):not(.tip) input:-moz-placeholder{color:transparent}.common-input.error:not(.type-2):not(.tip) input:-ms-input-placeholder{color:transparent}.common-input.error:not(.type-2):not(.tip) input::-moz-placeholder{color:transparent}.common-input+.error-message{position:absolute;left:0;right:0;top:-40px;bottom:0;line-height:45px;display:none;text-align:center}.common-input.captcha input{padding-left:128px}.common-input input,.common-input textarea{padding:0 13px;width:100%;height:45px;line-height:45px;position:relative;z-index:2;vertical-align:top;font-family:inherit}.common-input input+.err-msg,.common-input textarea+.err-msg{display:none;color:red;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:transform .2s ease-in,opacity .2s ease-out;transform:translateX(-10px)}.common-input input.error+.err-msg,.common-input textarea.error+.err-msg{display:block;-ms-filter:none;filter:none;opacity:1;transform:translateX(0)}.common-input input.error+.error-message,.common-input textarea.error+.error-message{display:block}#login_form .common-input.icon+.error-message{right:6px;font-size:13px}@media (max-width:400px){#login_form .common-input.icon+.error-message{font-size:12px}}.common-btn{display:inline-block}.auth-form{max-width:310px;margin:0 auto}.auth-form.account-form{max-width:none;border-width:3px 0 0;border-style:solid}.auth-form.account-form .errors-block .error{margin:15px 0}.auth-form .row{margin-bottom:10px;position:relative}.auth-form .row.capcha{margin-top:25px;position:relative}.auth-form .row.capcha .reload-captcha{position:absolute;right:100%;margin-right:10px;font-size:18px;margin-top:-9px;top:50%;cursor:pointer}.auth-form .row.btns{margin-top:20px}.auth-form .forgot{font-size:11px}.auth-form .captcha .ico{width:115px;border-right-width:1px;border-right-style:solid;border-right-color:inherit}.auth-form .btns .login{float:right;position:relative}.auth-form .btns .login.spin{width:120px}.auth-form .btns .login input[type=submit]{width:100%;position:absolute;left:0;top:0;right:0;bottom:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;z-index:1}.auth-form .btns .reg{float:left}.auth-form .form_block p{font-size:12px}.login-form-wrapper .errors-block{margin-bottom:15px;display:none}.login-form-wrapper .errors-block.show{display:block}.login-form-error-message{margin-bottom:15px}.login-form-error-message p{margin-bottom:5px}.about-me .about-info .img img{margin:0 auto;border-radius:2px}.about-me .about-info .cite{border-radius:2px;padding:15px;font-style:italic;font-size:13px;line-height:20px;position:relative;margin-bottom:20px;z-index:5}.about-me .about-info .cite:before{position:absolute;left:10px;top:-10px;width:0;display:block;content:\"\";height:0;border-style:solid;border-width:0 12.5px 10px}.about-me .about-info .txt{padding-right:30px}.about-me .about-info .intro{height:70px;margin-bottom:7px;overflow:hidden}.about-me .about-info .intro.show-all{height:auto}.about-me .about-info .intro p{margin-bottom:15px}.about-me .stats-block{font-size:12px}.about-me .stats-block .row{padding-top:15px;padding-bottom:15px;line-height:20px;font-size:12px}.about-me .stats-block .row .name{width:100px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;float:left}.about-me .stats-block .row .value{margin-left:100px}.about-me .awards-block .list{font-size:12px;line-height:12px}.about-me .awards-block .list>div{padding-top:9px;padding-bottom:9px}.about-me .awards-block .list>div:first-child{padding-top:0}.about-me+.next-liveshow .liveshow-timer{margin-bottom:0}.show-more{border-width:0;display:block;height:44px}.show-more:active{line-height:45px}.about-me .about-info .txt .mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical,.about-me .about-info .txt .mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical{right:-30px}.content-page .title-block{margin-bottom:15px}.content-page .title-block .added,.content-page .title-block .global-title{margin-bottom:0}.content-page .content-description{margin-bottom:20px;line-height:24px;margin-top:10px}.content-page .show-more{display:block;margin-top:10px;width:100%}.content-page .short-desc{display:block}.content-page .full-desc{display:none}.content-page .photos-list .photo-item{border-radius:2px;overflow:hidden}.content-page .more-photos{display:block;width:100%}.content-page .global-title{font-size:30px;line-height:33px}.content-page .comments-block{margin-bottom:25px}.content-page .comments-block .global-title .count{font-weight:700;line-height:26px;border-width:3px;border-style:solid;padding:0 10px;font-size:14px;border-radius:2px;display:inline-block;vertical-align:middle;margin-left:12px;font-family:Arial}.content-page .comments-block .common-input.txtarea{margin-bottom:10px}.content-page .comments-block .post-comment{line-height:32px}.content-page .comments-block .add-review{border-width:3px 0 0;border-style:solid;padding-top:20px;margin-top:25px}.content-page .reviews-list{margin-bottom:25px}.content-page .reviews-list .reply-wrapper{padding-left:40px;margin-bottom:25px}.content-page .reviews-list .item{margin-bottom:25px;line-height:20px}.content-page .reviews-list .item:last-child{margin-bottom:0}.content-page .reviews-list .item .post-info{line-height:18px;font-size:12px;margin-top:5px}.content-page .reviews-list .item .post-info>span{border-width:0 3px 0 0;border-style:solid;padding-right:15px;margin-right:15px}.content-page .reviews-list .item .post-info>span:last-child{margin-right:0;border-width:0}.content-page .reviews-list .content-page .comments-block{margin-bottom:25px}.content-page .tags .coma:last-child{display:none}.content-page .title-with-filter.content-info{display:block}.content-page .title-with-filter.content-info .added{line-height:20px;margin-bottom:0;white-space:nowrap;min-width:150px;text-align:left}.content-page .content-info{font-size:13px;line-height:20px;margin-top:16px}.content-page .content-info.cast a{cursor:default}.content-page .content-info .date,.content-page .content-info .model-name,.content-page .content-info a{font-style:italic}.post-page .pl-text{margin-bottom:20px}.post-page .pl-text [data-font-size$=px]{line-height:normal}.post-page .post-container{margin-right:0}.post-page .post-container>.global-title{margin-bottom:0}.post-page .date{font-size:12px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;margin-bottom:25px}.post-page .tipme-container{-moz-order:3;-ms-flex-order:3;order:3;-moz-flex:1 0;-ms-flex:1 0;flex:1 0;margin-top:0;max-width:220px;margin-right:0}.post-page .content-actions{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.post-page .post-content .content-img{border-radius:3px;overflow:hidden;margin-bottom:20px}.post-page .blog-post-sidebar{float:right;width:245px;display:none}.post-page .blog-post-sidebar .global-title{margin-bottom:25px;font-size:30px;line-height:33px}.post-page .blog-post-sidebar .last-comments{margin-bottom:35px}.post-page .blog-post-sidebar .lc-comment-item .lc-date{font-size:11px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;margin-bottom:5px}.post-page .blog-post-sidebar .post-item>a{margin-bottom:5px}.post-page .blog-post-sidebar .img-content{border-radius:2px;overflow:hidden;margin-bottom:5px;display:block}.post-page .blog-post-sidebar .stats{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.post-page .blog-post-sidebar .stats li{display:inline-block;font-size:13px;font-weight:700}.post-page .blog-post-sidebar .stats li:before{content:\"\";display:inline-block;width:4px;height:4px;border-radius:50%;vertical-align:middle;margin-right:11px}.post-page .blog-post-sidebar .stats li:first-child:before{display:none}.post-page .blog-post-sidebar .lc-comment-item,.post-page .blog-post-sidebar .post-item{padding-bottom:20px;margin-bottom:19px;border-width:0 0 1px;border-style:solid;font-size:12px}.post-page .blog-post-sidebar .lc-comment-item .lc-post,.post-page .blog-post-sidebar .post-item>a{font-size:13px;display:block}.post-page .blog-post-sidebar .lc-comment-item:last-child,.post-page .blog-post-sidebar .post-item:last-child{border-width:0;margin-bottom:0;padding-bottom:0}#blog-container img,#event-body-container img,#latest-posts img,#post-list-container img,.latest-post img{z-index:1}.tips-page .global-title{display:none}.tips-page .global-title.mobile{display:block}.tips-page .icon{display:none;position:absolute}.tips-page .icon.heart-1{left:-30px;top:-15px;font-size:62px}.tips-page .icon.heart-2{left:-30px;text-align:-8px}.tips-page .icon.heart-3{bottom:0;right:-9px}.tips-page .tips-promo{max-width:600px}.tips-page .tips-promo .global-title{padding-left:45px;position:relative}.tips-page .tips-promo .global-title.mobile{padding-left:0}.tips-page .img-block{position:relative;margin-bottom:20px}.tips-page .img-block>div{border-radius:2px 2px 64px 2px;overflow:hidden}.tips-page .img-block>div img{width:100%}.tips-page .tips-txt p{line-height:26px;margin-bottom:15px}.tips-page .tips-txt .p2{font-weight:700;font-size:16px}.tips-page .tips-block .tips-title{margin-bottom:25px;text-align:center;font-size:30px;line-height:30px;padding:15px 10px;border-radius:2px 2px 2px 16px;white-space:nowrap}.tips-page .tips-block .tips-title *{display:inline-block}.tips-page .tips-block .tips-title span{font-size:17px;position:relative;top:-3px;margin-right:10px}.tips-page .tips-block .row{margin-bottom:15px}.tips-page .tips-block .join-submit{display:block;text-align:center;font-size:15px}.tips-page .tips-list-container .item{margin-bottom:20px;overflow:hidden}.tips-page .tips-list-container .item .ico{font-size:24px;float:left;margin-top:1px}.tips-page .tips-list-container .item.item-1 .ico{font-size:18px;margin-top:5px}.tips-page .tips-list-container .item.item-2 .ico{font-size:19px;margin-top:4px}.tips-page .tips-list-container label{display:block;margin-left:25px}.tips-page .tips-list-container .radio{float:left;margin-right:7px;top:7px;vertical-align:top;display:inline-block;border-radius:50%;width:15px;height:15px;border-width:1px;border-style:solid;position:relative;margin-left:1px}.tips-page .tips-list-container .radio input{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;position:relative;z-index:2;display:block}.tips-page .tips-list-container .radio input:checked+.dot{-ms-filter:none;filter:none;opacity:1;transform:scale(1)}.tips-page .tips-list-container .radio .dot{position:absolute;z-index:1;transition:all .3s;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;left:2px;right:2px;top:2px;bottom:2px;transform:scale(.5);border-radius:50%}.tips-page .tips-list-container .price{font-size:25px;line-height:30px;font-weight:700}.tips-page .tips-list-container .err-msg{display:none}.tips-page .tips-list-container .custom-price .common-input{max-width:80px}.tips-page .icon.heart-2,.tips-page .icon.heart-3{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.tips-page .tips-list-container .err-msg,.tips-page .tips-list-container .tip-option-title{font-size:12px}.tips-page .tips-list-container .price,.tips-page .tips-list-container .tip-option-title{margin-left:30px;display:block}.verifiedcall-wrapper{padding:30px 0;border-width:3px 0;border-style:solid}.verifiedcall-wrapper .global-title{font-size:30px;margin-bottom:20px}.verifiedcall-wrapper .verifiedcall-widget{margin:0 auto;text-align:center}.verifiedcall-wrapper .verifiedcall-widget iframe{width:272px;margin:0 auto;display:block}.verifiedcall-wrapper .verifiedcall-widget .txt{display:block;text-align:center;margin-top:40px;line-height:24px}.banner.verified-call{margin-top:0}.banner.verified-call .banner-container{font-size:28px;line-height:41px;padding-top:13px;padding-bottom:13px;border-radius:2px}.banner.verified-call .banner-container span{display:inline-block;vertical-align:middle}.banner.verified-call .banner-container span iframe{display:block}.banner.verified-call a:hover{text-decoration:none}.banner .banner-container{display:block;text-align:center;line-height:35px;font-size:30px;font-family:simplifica}.banner .banner-container u{text-decoration:none;border-bottom-width:1px;border-bottom-style:solid}#verifiedcall-container{margin-left:20px}.page-404-wrapper .header{display:block;padding:35px 0;border-width:0 0 1px;border-style:solid;max-width:250px;margin:0 auto;margin-bottom:35px;background-image:none}.page-404-wrapper .header .logo.text p.logo-main{font-size:40px;line-height:40px}.page-404-wrapper .page-404-container{text-align:center}.page-404-wrapper .page-404-container p{font-size:30px;line-height:30px;margin-bottom:20px;font-family:simplifica}.page-404-wrapper .page-404-container .p1{font-size:200px;line-height:160px;margin-bottom:0}.conversation-block{margin:0 auto}.conversation-block .messages-container .messages-list-scroll-wrapper{margin-right:20px;padding-left:5px}.conversation-block .conversation-container{height:680px;overflow:auto;border-width:3px 0;border-style:solid;margin-bottom:20px}.conversation-block .send-message-block{margin-top:20px}.conversation-block .send-message-block .common-input{margin-bottom:10px}.conversation-block .message-date-separator .messages-group-date>span{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.conversation-block .message-row .message-bubble{border-radius:2px;padding:5px 15px}.conversation-block .message-row .message-bubble .bubble-arrow{left:6px;border-width:0 1px 1px 0;width:16px;height:16px;bottom:-9px}.conversation-block .message-row.not-my .bubble-arrow{right:6px;left:auto}.conversation-block .message-row .attachment-list>li{margin-left:0}.conversation-block .message-row .attachment-list .attach-lock{line-height:normal}.conversation-block .message-row .attachment-list .attach-lock .content-name{margin-bottom:5px}.conversation-block .message-row .attachment-list .unlock-btn{line-height:15px}.conversation-block .message-row .message-content{line-height:20px}.conversation-block .message-row .message-time{margin-top:0}.conversation-block .message-row .message-from-who,.conversation-block .message-row .message-time{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.conversation-block .message-row .attach-preview .play-video-bth{font-size:25px;line-height:63px;text-align:center}.conversation-block .message-row .attach-preview .play-video-bth i{vertical-align:middle}.conversation-block .message-row .attach-preview .play-video-bth:after{display:none}.conversation-block .txtarea textarea{font-style:italic}.conversation-block .message-row .attachment-list .attach-item .attach-lock .content-name,.conversation-block .message-row .attachment-list .attach-item .attach-processing .content-name{font-weight:700}.wrapper[data-widget-class=Layout_Affiliate] .aff-wrap .page-width{min-height:0}.content-report-popup .cancel-report{background-color:transparent}.content-report-popup .ui-dialog-buttonpane{text-align:right}.content-report-popup .ui-dialog-buttonpane .common-btn{margin-left:15px}.content-report-popup .form-container .select-category-block{margin-top:0}.content-report-popup .radio-btn-wrapp input[type=radio]:checked+label{-ms-filter:none;filter:none;opacity:1}.form-container input[type=text],.form-container textarea{border:none;margin:0;color:#000}.form-container .capcha-wrap{margin-top:5px}.form-container .capcha-wrap input{height:33px}@media screen and (min-width:600px){.content-list .item,.tour-buttons .unlogged-buttons{width:49%}.content-list .item .socials,.content-list .item .total{display:block}.content-list .item .added,.content-list .item .img{font-size:12px}.content-list .item.photoset .img{width:50%;float:left;min-height:100%;position:relative;height:66vw;max-height:346px}.content-list .item.photoset.wide img{min-height:100%;max-width:none;position:absolute;left:50%;transform:translate(-50%);top:0;max-height:100%}.content-list .item.photoset .info{float:right;padding:10px 30px 155px;width:50%;text-align:center}.content-list .item.photoset .info .data{position:absolute;left:50%;right:0;bottom:25px}.content-list .item .img img{position:absolute;max-width:100%;left:50%;top:0;transform:translate(-50%)}.content-list .item .img video{min-height:100%;position:absolute;top:0}.content-list .item.scene .img{padding-top:56%}.content-list .item.scene img,.content-list .item.scene video{position:absolute;left:50%;min-height:100%;width:auto;transform:translate(-50%)}.welcome-block .player,.welcome-block .player-wrapper,.welcome-block .welcome-text,.welcome-block .wellcome-container .img{height:380px}.tour-buttons{overflow:hidden}.tour-buttons .unlogged-buttons{margin-bottom:0}.tour-buttons .unlogged-buttons:first-child{float:left}.tour-buttons .unlogged-buttons:last-child{float:right}.tour-buttons .unlogged-buttons .line{display:block;z-index:2;width:11%}.auth-form .btns .reg{width:54%}.auth-form .btns .login{width:39%}.auth-form.account-form .btns .login{width:auto;margin-left:170px}.verifiedcall-wrapper .verifiedcall-widget{min-width:272px;height:265px;display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;width:auto}.verifiedcall-wrapper .verifiedcall-widget iframe{width:auto;min-width:272px}.verifiedcall-wrapper .verifiedcall-widget .txt{padding-left:20px;margin-top:0;-moz-flex:1 300%;-ms-flex:1 300%;flex:1 300%;display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.liveshow-banner .title-block{font-size:20px;line-height:20px}.liveshow-banner .title-block:after{width:80%;margin-left:10%;display:block}.liveshow-banner .banner-cam{margin-top:120px;margin-bottom:55px;position:relative}.liveshow-banner .banner-cam .private{position:absolute;margin-left:-59px;top:55px}.liveshow-banner .banner-cam .cam-wrapper{display:block}.liveshow-banner .ban-content{margin-top:0}.liveshow-banner .ban-content .cont{width:50%}.liveshow-banner .ban-content .date-cont{float:left;margin-top:0;padding-right:25px;text-align:right}.liveshow-banner .ban-content .time-cont{float:right;padding-left:25px;text-align:left}.feedback-cb{background-position:50%}.banner_wrap.banners_{margin-top:50px}}@media screen and (max-width:768px){.welcome-block .img .play.fake-button{position:relative;top:0;margin-top:20px;left:0;margin-left:auto;margin-right:auto;max-width:200px}}@media screen and (min-width:768px){.top-menu{display:block}.top-menu>.menu-wrapper,.top-menu>div.right-part{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex}.top-menu>div.right-part{float:right;font-size:14px}.main-menu{position:static;text-transform:none;bottom:auto;width:auto;padding:0;line-height:42px;transform:translateX(0);display:-moz-flex;display:-ms-flexbox;display:flex;float:left}.main-menu .link{display:inline-block;line-height:inherit;margin-bottom:0;padding-right:0;padding-left:0}.main-menu .link>a{padding-left:7px;padding-right:7px}.main-menu .link>a .ico{display:none}.main-menu .link.home>a{padding-left:0}.mobile-menu-icon{top:24px;display:none}.mobile-menu-icon.opened+.layout-overlay{display:none}.mobile-menu-icon.opened~.main-menu{box-shadow:none}.mobile-menu-icon.opened~.static-wrapper{transform:translateX(0)}.wrapper.menu-opened .page-width{transform:none}.global-title{font-size:45px;line-height:45px;margin-bottom:20px}.header{display:block;max-height:none}.header .logo .logo-text{font-size:65px}.welcome-block .wellcome-container .img{float:left;width:60%;position:relative;height:380px}.welcome-block .wellcome-container .img.video{float:none;width:100%;height:auto}.welcome-block .wellcome-container .img.video+.welcome-text{display:none}.welcome-block .welcome-text{position:relative;width:40%;padding:40px 40px 80px;font-size:14px;float:right;z-index:2}.welcome-block .welcome-text h1{font-size:35px;font-size:26px}.welcome-block .welcome-text .nice-scroll-viewport{height:auto;overflow:auto;margin-bottom:0}.welcome-block .welcome-text>div{max-height:260px;overflow:auto}.welcome-block .img img{max-height:100%;max-width:none;min-width:0}.welcome-block .img .play{padding:0 30px;max-height:62px;max-width:180px}.social{position:absolute;left:40px;right:40px;bottom:25px}.twit-block .twits-list{display:-moz-flex;display:-ms-flexbox;display:flex;margin-bottom:15px;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.twit-block .twits-list li{width:32%;margin-bottom:0}.play{width:62px;height:62px;margin-left:-31px;margin-top:-31px}.play i{font-size:26px;line-height:62px}.content-list .item.photoset .info{padding-top:10px}.content-list .item .socials span.sep{margin-left:10px;margin-right:10px}.content-page .title-block{margin-bottom:20px}.content-page .title-block .global-title{float:left}.content-page .title-block .added{float:right}.content-page .title-with-filter.content-info{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex}.content-page .title-with-filter.content-info .added{margin-bottom:20px;line-height:33px;font-size:13px;text-align:right}.content-page .comments-block .add-review{border-width:0;padding-top:0}.tour-buttons .unlogged-buttons{font-size:45px;line-height:98px}.footer{overflow:hidden;bottom:0;left:0;right:0}.footer .links{float:right;width:49%;display:block;text-align:left}.footer .links a{display:inline;width:auto;margin-bottom:5px;margin-right:30px}.footer .f-2257{clear:right}.footer .f-text{clear:left}.footer .bill-cb{margin:0;margin-top:0;position:absolute;right:20px;left:49%}.footer .footer-bottom-wrapper{width:100%}.footer .footer-bottom-wrapper .powered_wrapper{width:50%;text-align:center}.footer .bottom{clear:both;margin-top:135px}.footer .f-2257,.footer .f-text{float:left;width:49%}.about-me .photo-block{position:relative}.about-me .about-info .img{float:left;max-width:340px;max-height:340px;overflow:hidden}.about-me .about-info .img img{max-width:none;max-height:none}.about-me .about-info .txt{margin-left:370px}.about-me .about-info .intro{height:auto;max-height:240px}.about-me .about-info .cite{bottom:-10px;left:277px;right:30px;position:absolute;margin-bottom:0;font-size:15px}.about-me .stats-block{float:left;width:54%}.about-me .stats-block .row:nth-child(odd){border-radius:0 3px 3px 0}.about-me .awards-block{float:right;width:37.5%;padding-top:30px}.show-more{display:none}.content-page .full-desc .show-more,.content-page .short-desc{display:block}.content-page .full-desc{display:none}.content-page.store-product-page .full-desc .show-more,.content-page.store-product-page .short-desc{display:block}.content-page.store-product-page .full-desc{display:none}.content-actions-wrapper.liveshow .content-actions{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.content-actions-wrapper.liveshow .content-actions .tipme-container{margin-left:0;margin-right:20px;max-width:160px}.post-page .post-container{margin-right:285px}.post-page .post-container .pl-text{display:-ms-flexbox;display:flex}.post-page .blog-post-sidebar{display:block}.post-page .tipme-container{margin-right:0}.tips-page{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.tips-page .global-title{display:block;position:relative}.tips-page .global-title.mobile,.tips-page .icon{display:none}.tips-page .tips-promo{padding-left:20px;margin-right:45px}.tips-page .tips-block{min-width:295px}.tips-page .tips-list-container{padding-left:20px}.liveshow-banner .title-block:after{width:40%;margin-left:30%}.liveshow-banner .banner-cam .cam-wrapper{font-size:11px}.liveshow-banner .banner-cam .cam-wrapper .txt-2{font-size:32px}.liveshow-banner .banner-cam .cam-wrapper .stripe.lt{padding-left:30px}.liveshow-banner .banner-cam .cam-wrapper .stripe.lt .txt-1{letter-spacing:1px}.liveshow-banner .banner-cam .cam-wrapper .stripe.lt .txt-2{letter-spacing:3px}.liveshow-banner .banner-cam .cam-wrapper .stripe.rt{padding-right:30px}.liveshow-banner .banner-cam .cam-wrapper .stripe.rt .txt-1{letter-spacing:5px}.liveshow-banner .banner-cam .cam-wrapper .stripe.rt .txt-2{letter-spacing:0}.liveshow-banner .ban-content .date-cont{padding-right:35px}.liveshow-banner .ban-content .time-cont{padding-left:35px}.liveshow-banner .ban-content .time-cont .separator{margin:0 15px}.page-404-wrapper{height:100vh;display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center}.page-404-wrapper .header{height:auto;margin-bottom:0;min-width:250px;min-height:0}.page-404-wrapper .page-404-container{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-moz-flex:1 100%;-ms-flex:1 100%;flex:1 100%;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.page-404-wrapper .page-404-container .p1{font-size:300px;line-height:250px;margin-bottom:35px}.auth-form.account-form .row{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-ms-flexbox;display:flex}.auth-form.account-form .row label{min-width:170px;line-height:45px;display:block}.auth-form.account-form .row .common-input-holder{min-width:250px;position:relative}.auth-form.account-form .row .err-msg{line-height:45px;margin-left:25px}.scene .over-timeline:hover .filling{animation:bar .8s linear}}@media screen and (min-width:960px){.pad-lr{padding-left:30px;padding-right:30px}.pad-tb{padding-top:30px}.pad-b,.pad-tb{padding-bottom:30px}.page-width{position:relative}.mobile-menu-icon{display:none}.welcome-block .wellcome-container{height:528px}.welcome-block .img img{max-height:100%;max-width:none}.welcome-block .img .play{max-height:82px}.welcome-block .welcome-text{padding:40px 40px 80px}.welcome-block .welcome-text h1{font-size:36px}.welcome-block .welcome-text>div{max-height:385px}.welcome-block .player,.welcome-block .player-wrapper,.welcome-block .welcome-text,.welcome-block .wellcome-container .img,.welcome-block .wellcome-container .img.video{height:528px}.social{position:absolute;left:40px;right:40px;bottom:25px}.content-list .item .title{font-size:30px}.content-list .item.photoset .title{font-size:24px}.content-list .item.photoset .info{padding-top:30px}.play{width:82px;height:82px;margin-left:-41px;margin-top:-41px}.play i{font-size:28px;line-height:82px}.tour-buttons .unlogged-buttons .join-btn{line-height:97px;font-size:45px}.tour-buttons .unlogged-buttons .join-btn>p .icon{font-size:39px}.banner .banner-container{font-size:40px;line-height:40px}.footer .links{width:50%;text-align:right}.footer .links a{margin-right:0;min-width:120px;display:inline-block;text-align:right}.about-me .about-info .img{max-width:455px;max-height:437px}.about-me .about-info .txt{margin-left:490px}.about-me .about-info .intro{max-height:355px}.about-me .about-info .cite{left:415px;font-size:16px}.content-actions .action-link-text{display:inline}.liveshow-banner .banner-cam .cam-wrapper{width:86%;margin:0 auto;padding:0 13px}.liveshow-banner .banner-cam .cam-wrapper .stripe.lt{padding-left:40px;padding-right:110px}.liveshow-banner .banner-cam .cam-wrapper .stripe.rt{padding-right:40px;padding-left:110px}.liveshow-banner .banner-cam .cam-wrapper .stripe:after,.liveshow-banner .banner-cam .cam-wrapper .stripe:before{display:block}}@media screen and (min-width:1280px){.content-list .item .remove{transform:translateX(-100%)}.content-list .item .fullscreen img{transform:scale(1.1)}}.tags-filter .tags-filter-wrapper{display:block!important}@keyframes play{0%{background-position:0 0}to{background-position:0 -560px}}@keyframes bar{0%{width:0}to{width:100%}}.sp-part-title{font-size:16px;line-height:45px;margin-bottom:0}.sp-title{font-size:45px;line-height:45px}.sp-part-title{font-size:25px}.sp-part-title,.sp-title{font-family:simplifica}.rating-new .rate .num{display:inline-block}.rating-new .rate.good .num{padding-right:5px}.rating-new .rate.bad .num{padding-left:5px}.content-actions .tipme-container .common-input{width:135px}.content-actions .tipme-container .common-input i{padding-top:1px}.attach-title{color:#000}.content-actions.new-wrap .content-report{-moz-order:3;-ms-flex-order:3;order:3;padding-left:15px;display:-ms-flexbox;display:flex;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-pack:end;-moz-justify-content:end;justify-content:end}.content-actions.new-wrap .content-report .content-report-link{display:-ms-flexbox;display:flex}.cf-confirm .rowamount{border:none}.header-block-wrapper{position:relative;text-align:center;padding:0;min-height:60px}.header-block-wrapper .header-placeholder img{max-height:187px}.header-block-wrapper .header-images-slider{position:absolute;z-index:1;left:0;right:0;top:0;bottom:0}.header-block-wrapper .header-images-slider .items{height:100%;max-height:187px}.header-block-wrapper .header-images-slider .items .slide-item{background-size:contain;background-position:0}.header-block-wrapper .header-images-slider .items .slide-item img{max-height:187px}.header-block-wrapper .slider-pager{left:auto;z-index:3}.header-block-wrapper .overlay{position:absolute;left:0;top:0;right:0;bottom:0;z-index:1}.header-block-wrapper .logo-container{position:absolute;top:0;left:0;right:0;bottom:0;max-height:100%}.logo-wrapper{font-family:simplifica;font-size:40px;letter-spacing:2px;line-height:normal}.logo-wrapper .logo{display:-ms-inline-flexbox;display:inline-flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;height:100%;margin:0 auto;position:relative;z-index:2}.logo-wrapper .logo,.logo-wrapper .logo-img{-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.logo-wrapper .logo-img{display:none;max-width:100%}.logo-wrapper .logo-img img{max-height:100%}.logo-wrapper .logo-text{display:inline-block}.logo-wrapper .logo-text-long .desk-logo{display:none}.logo-wrapper .logo-text-long .mobile-logo{display:inline-block}.logo-wrapper{text-align:center}.logo-wrapper .logo-img img{max-height:80px}@media (min-width:600px){.logo-wrapper .logo-text-long .desk-logo{display:inline-block}.logo-wrapper .logo-text-long .mobile-logo{display:none}.logo-wrapper .logo-img img{max-height:120px}}@media (min-width:768px){.logo-wrapper{font-size:65px}.logo-wrapper .logo-img img{max-height:150px}}@media (min-width:960px){.logo-wrapper{font-size:90px}.logo-wrapper .logo-img img{max-height:170px}}.header-block-wrapper .header-images-slider .slide-item.item-0{background-image:url(" + __webpack_require__(70) + ")}.header-block-wrapper .header-images-slider .slide-item.item-1{background-image:url(" + __webpack_require__(71) + ")}.header-block-wrapper .header-images-slider .slide-item.item-2{background-image:url(" + __webpack_require__(72) + ")}.header-block-wrapper .header-images-slider .slide-item.item-3{background-image:url(" + __webpack_require__(73) + ")}@font-face{font-family:iconfont;src:url(" + __webpack_require__(74) + ");src:url(" + __webpack_require__(74) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(934) + ") format(\"truetype\"),url(" + __webpack_require__(935) + ") format(\"woff\"),url(" + __webpack_require__(936) + "#iconfont) format(\"svg\");font-weight:400;font-style:normal}[class*=\" icon-au_\"],[class^=icon-au_]{font-family:iconfont!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-au_SnapCentro:before{content:\"\\E900\"}.icon-au_check:before{content:\"\\E600\"}.icon-au_close-delete:before{content:\"\\E601\"}.icon-au_comments:before{content:\"\\E602\"}.icon-au_datapicker:before{content:\"\\E603\"}.icon-au_dislike:before{content:\"\\E604\"}.icon-au_download:before{content:\"\\E605\"}.icon-au_drop:before{content:\"\\E606\"}.icon-au_error:before{content:\"\\E607\"}.icon-au_event:before{content:\"\\E608\"}.icon-au_facebook:before{content:\"\\E609\"}.icon-au_favorites:before{content:\"\\E60A\"}.icon-au_heart:before{content:\"\\E60B\"}.icon-au_instagram:before{content:\"\\E60C\"}.icon-au_join_btn:before{content:\"\\E60D\"}.icon-au_join_left_arw:before{content:\"\\E60E\"}.icon-au_join_right_arw:before{content:\"\\E60F\"}.icon-au_like:before{content:\"\\E610\"}.icon-au_location:before{content:\"\\E611\"}.icon-au_login:before{content:\"\\E612\"}.icon-au_login_btn:before{content:\"\\E613\"}.icon-au_logout:before{content:\"\\E614\"}.icon-au_m_about:before{content:\"\\E615\"}.icon-au_m_blog:before{content:\"\\E616\"}.icon-au_m_calendar:before{content:\"\\E617\"}.icon-au_m_callme:before{content:\"\\E618\"}.icon-au_m_home:before{content:\"\\E619\"}.icon-au_m_images:before{content:\"\\E61A\"}.icon-au_m_liveshows:before{content:\"\\E61B\"}.icon-au_m_tips:before{content:\"\\E61C\"}.icon-au_m_videos:before{content:\"\\E61D\"}.icon-au_menu:before{content:\"\\E61E\"}.icon-au_messages:before{content:\"\\E61F\"}.icon-au_pager_left_arw:before{content:\"\\E620\"}.icon-au_pager_right_arw:before{content:\"\\E621\"}.icon-au_password:before{content:\"\\E622\"}.icon-au_play:before{content:\"\\E623\"}.icon-au_popup_left_arw:before{content:\"\\E624\"}.icon-au_popup_right_arw:before{content:\"\\E625\"}.icon-au_related:before{content:\"\\E626\"}.icon-au_settings:before{content:\"\\E627\"}.icon-au_site-captcha_update:before{content:\"\\E628\"}.icon-au_tags:before{content:\"\\E629\"}.icon-au_thumbler:before{content:\"\\E62A\"}.icon-au_tour_btn:before{content:\"\\E62B\"}.icon-au_twitter:before{content:\"\\E62C\"}.icon-au_hd:before{content:\"\\E62D\"}.icon-au_sd:before{content:\"\\E62E\"}.icon-au_ls_:before{content:\"\\E62F\"}.icon-au_ls_calendar:before{content:\"\\E630\"}.icon-au_ls_sadsmile:before{content:\"\\E631\"}.icon-au_ls_time:before{content:\"\\E632\"}.icon-au_m_skypeMe:before{content:\"\\E633\"}.icon-au_report:before{content:\"\\E634\"}.icon-au_poweredByMC:before{content:\"\\E901\"}.icon-au_addToCalendar_20:before{content:\"\\E902\"}.icon-au_bonus_15:before{content:\"\\E903\"}.icon-au_uhd:before{content:\"\\E904\"}.icon-au_4k_19:before{content:\"\\E905\"}.icon-au_vr-video_15:before{content:\"\\E906\"}.icon-au_vr_lq_19:before{content:\"\\E907\"}.icon-au_vr_hq_19:before{content:\"\\E908\"}.icon-au_question-mark_24:before{content:\"\\E909\"}.icon-au_categories_16:before{content:\"\\E90A\"}.icon-au_menuPurchased_22:before{content:\"\\E90B\"}.icon-au_purchased_10:before{content:\"\\E90C\"}.icon-au_drop_6:before{content:\"\\E90D\"}.icon-au_backToStore_7:before{content:\"\\E90E\"}.icon-au_m_store:before{content:\"\\E90F\"}.liveshow-timer{text-align:center;margin-bottom:30px}.liveshow-timer .ls-title,.liveshow-timer .next-date{font-size:12px;font-weight:700}.liveshow-timer .ls-title{margin-bottom:2px}.liveshow-timer .mc-common-button{font-weight:700;text-transform:none}.liveshow-timer .show-start-time{margin-bottom:30px}.liveshow-timer .show-start-time>span{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.liveshow-timer .show-start-time .part{display:block;width:50px;height:50px;text-align:center;position:relative;border-radius:3px;margin:0 4px}.liveshow-timer .show-start-time .part div{position:absolute;bottom:-18px;font-size:10px;line-height:18px;width:100%;text-align:center}.liveshow-timer .show-start-time .part .digit{line-height:50px;font-size:30px;font-weight:700}.liveshow-timer .show-start-time .separator{display:block;line-height:50px;font-size:28px}.liveshow-timer .ls-info{margin-bottom:15px}.liveshow-timer .ls-info .sep{display:none}@media (min-width:736px){.liveshow-timer{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.liveshow-timer .ls-info{-moz-order:1;-ms-flex-order:1;order:1;width:100%;margin-bottom:15px}.liveshow-timer .ls-info .ls-title,.liveshow-timer .ls-info .next-date,.liveshow-timer .ls-info .sep{display:inline-block;margin-bottom:0}.liveshow-timer .show-start-time{-moz-order:2;-ms-flex-order:2;order:2;margin-right:2%}.liveshow-timer .show-start-time>span{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}.liveshow-timer .action-wrapper{-moz-order:3;-ms-flex-order:3;order:3;margin-left:2%}.liveshow-timer .action-wrapper,.liveshow-timer .show-start-time{width:48%;text-align:left;margin-bottom:0}.liveshow-timer .global-title{margin-bottom:0}.liveshow-timer .sep{margin:0 15px}.liveshow-timer .mc-common-button{height:50px;line-height:48px;display:inline-block;min-width:180px}}@media (min-width:1024px){.liveshow-timer{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-bottom:15px;text-align:left}.liveshow-timer .ls-info{-moz-order:2;-ms-flex-order:2;order:2}.liveshow-timer .show-start-time{-moz-order:1;-ms-flex-order:1;order:1}.liveshow-timer .action-wrapper{-moz-order:3;-ms-flex-order:3;order:3}.liveshow-timer.pad-tb{padding-top:12px;padding-bottom:20px}.liveshow-timer .global-title{margin-bottom:0;line-height:35px;margin-top:0;font-size:35px}.liveshow-timer .ls-info{display:block;margin-right:25px;margin-left:25px;padding-top:15px;margin-bottom:0;text-align:center}.liveshow-timer .ls-info .global-title{width:100%}.liveshow-timer .next-date{padding-bottom:0}.liveshow-timer .show-start-time{margin-top:0;margin-bottom:0;padding-top:18px}.liveshow-timer .action-wrapper{padding-top:18px}}.brc-wrapper:not(.brc-fullscreen) .brc-main{max-width:640px}.content-page .content-links{position:relative;font-size:14px}.content-page .content-links .link{-ms-flex-align:center;-moz-align-items:center;align-items:center;display:-ms-flexbox;display:flex;border-width:0 0 3px;border-style:solid;width:100%}.content-page .content-links .icon{display:inline-block;margin-right:5px;font-size:20px}.content-page .faq-link .icon{vertical-align:-3px;font-size:24px}@media screen and (max-width:600px){.content-page .content-links .content-actions{padding:17px 0;margin:0}}@media screen and (min-width:601px){.content-page .content-links{-ms-flex-align:stretch}.content-page .content-links,.content-page .content-links .item{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-align-items:stretch;align-items:stretch}.content-page .content-links .item{-moz-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-align:stretch}.content-page .content-links .faq-link{padding-left:20px;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}}.page-width{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.page-width,.page-width .static-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}#conversation-block .txtarea{min-height:60px;overflow:hidden;transition:height .1s}#conversation-block .global-title{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}#conversation-block .global-title .content-report{font-size:18px}.ui-dialog.attach-unlock .btn{padding:0 17px;float:right}.ui-dialog.attach-unlock .btn:disabled{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.ui-dialog.attach-unlock .popup-content{padding:20px 0}.ui-dialog.preview-content{padding:0!important;position:absolute!important}.ui-dialog.preview-content .ui-dialog-titlebar{border:none;margin:0;padding:0}.ui-dialog.preview-content .ui-dialog-titlebar .ui-dialog-titlebar-close{background:none;width:auto;height:auto;margin:0;position:relative;text-decoration:none;font-size:22px;top:10px;right:10px;color:inherit}.ui-dialog.preview-content .ui-dialog-titlebar .ui-dialog-titlebar-close:before{content:\"u004e\";font-family:iconfont;font-weight:400;font-style:normal;text-decoration:inherit;-webkit-font-smoothing:antialiased;display:inline-block;speak:none}.ui-dialog.preview-content .ui-dialog-content{padding:40px 50px 20px}.attach-actions{position:relative;top:6px}.attach-favorites .bookmark{display:inline-block;vertical-align:middle;padding-left:8px;text-decoration:none}.attach-favorites .bookmark .icon-star{font-size:22px;vertical-align:middle}.attach-download .download-button{display:inline-block;vertical-align:middle;margin-right:10px;position:relative;cursor:pointer;text-decoration:none;color:inherit}.attach-download .download-button .icon-download-box{vertical-align:middle;font-size:20px}.attach-download .download-button .download-links{position:absolute;left:-21%;right:-21%;background-color:#fff;box-shadow:0 0 10px 0 rgba(0,0,0,.75)}.attach-download .download-button .download-links a{border:none}.play-video-bth{position:absolute;display:block;border-radius:2px;min-width:63px;height:63px;top:50%;left:50%;margin:-31px 0 0 -31px}.play-video-bth:after{content:\"\";position:absolute;width:0;height:0;border-style:solid;border-width:12.5px 0 12.5px 23px;border-color:transparent transparent transparent #fff;top:50%;left:50%;margin:-11px 0 0 -10px;border-radius:3px}.messages-group-date{top:-8px!important}.messages{font-size:12px}.message-row .message-time{font-size:11px}.message-row .message-content{white-space:pre-wrap}.message-row .message-bubble .bubble-arrow{width:12px;height:12px;position:absolute;bottom:-7px;left:5px;border:1px solid;transform:rotate(45deg);box-shadow:1px 1px 3px -1px rgba(0,0,0,.1)}.message-row.not-my .bubble-arrow{left:auto;right:5px}.message-row .attach-lock{background-color:rgba(0,0,0,.75)}.message-row .unlock-btn{text-decoration:none}.mc-common-button{line-height:42px;height:44px}.mc-common-button.spin:before{background-image:url(" + __webpack_require__(5) + ")}.header .logo-container,.header .logo-container .logo{-moz-flex:1 0 100%;-ms-flex:1 0 100%;flex:1 0 100%}.header .logo-container .logo{display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.footer-b-wrapper{margin-top:25px;clear:both}.footer-b-wrapper .b-list>a{display:inline-block}.footer-b-wrapper .b-list>a br{display:none}.post-content .pl-text .embeddedContent{float:none!important}.main-menu-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;position:relative;height:70px}.main-menu-wrapper .main-menu{-ms-flex-wrap:wrap;flex-wrap:wrap}.main-menu-wrapper .main-menu.hidden{visibility:hidden}.main-menu-wrapper .main-menu .link .more-link,.main-menu-wrapper .main-menu .link a{line-height:25px}.main-menu-wrapper .main-menu .link ul.more{position:absolute;top:100%;left:-20px;display:none;border-radius:0 0 4px 4px;padding-bottom:6px}.main-menu-wrapper .main-menu .link ul.more li{display:block;float:none;padding-left:15px;padding-right:15px;margin-bottom:8px}.main-menu-wrapper .main-menu .link ul.more li a{padding:0 10px 5px;height:auto;white-space:nowrap;line-height:normal}.main-menu-wrapper .main-menu .link .more-link{padding-right:19px}.main-menu-wrapper .main-menu .link.more-list-item{position:relative}.main-menu-wrapper .main-menu .link.more-list-item .more-link>i{font-size:12px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6;display:block;transition:all .2s;position:absolute;top:30px;right:0}.main-menu-wrapper .main-menu .link.more-list-item .more-link>i.arr{transform:rotate(90deg) translateX(-15px);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;right:0;font-size:11px}.main-menu-wrapper .main-menu .link.more-list-item:hover .more-link>i{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transform:translateY(15px)}.main-menu-wrapper .main-menu .link.more-list-item:hover .more-link>i.arr{transform:rotate(90deg) translateX(-1px);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6}.main-menu-wrapper .main-menu .link.more-list-item:hover ul.more{display:block}.main-menu-wrapper .btn,.main-menu-wrapper .link{white-space:nowrap}.main-menu-wrapper .right-part.menu-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex}.main-menu-wrapper .more-link{padding-left:7px;padding-right:7px;display:block}.main-menu-wrapper .menu-container.action{padding-left:15px;padding-top:14px;padding-bottom:14px}.play{cursor:pointer}.play .popup-content-wrapper.popup{padding:0}body:last-child:not(:root) .main-menu-wrapper .right-part.menu-wrapper .btn{padding:0 18px}.top-menu .action.logged .ico{border-left-width:1px;border-left-style:solid}.top-menu .action.logged .ico:first-child{border-left-width:0}.top-menu .action.logged .user{position:relative;border-style:solid;border-radius:3px 3px 0 0;border-width:1px 1px 0}.top-menu .action.logged .user:hover{-ms-filter:none;filter:none;opacity:1}.top-menu .action.logged .user:hover>i{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}.top-menu .action.logged .user.open .user-settings{display:-moz-flex;display:-ms-flexbox;display:flex}.top-menu .action.logged .user.open:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;border-radius:3px 3px 0 0}.top-menu .action.logged .user .user-settings{position:absolute;top:100%;right:-1px;min-width:160px;border-width:1px;border-style:solid;display:none;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;padding:20px;line-height:normal;border-radius:3px 0 3px 3px;margin-top:-1px}.top-menu .action.logged .user .user-settings .user-name{font-size:14px;font-weight:700;white-space:nowrap;padding-bottom:10px}.top-menu .action.logged .user .user-actions ul{display:-moz-flex;display:-ms-flexbox;display:flex;font-size:12px}.top-menu .action.logged .user .user-actions ul li{padding-right:10px;margin-right:10px;border-right:1px;border-right-style:solid}.top-menu .action.logged .user .user-actions ul li:last-child{border-right:0}.top-menu .action.logged .user .user-actions .action{white-space:nowrap;-ms-flex-align:center;-moz-align-items:center;align-items:center;display:-moz-flex;display:-ms-flexbox;display:flex}.top-menu .action.logged .user .user-actions .action i{padding-right:5px}.powered{font-size:16px}.mc-site-common-popup .ui-dialog-content .popup-title-wrapper{border:none;text-align:center}.mc-site-common-popup .ui-dialog-content .popup-title-wrapper .popup-title{font-weight:400;font-size:45px;font-family:simplifica}.mc-site-common-popup .ui-dialog-content .popup-content-wrapper{font-size:18px;text-align:center;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";filter:alpha(opacity=80);opacity:.8}.mc-site-common-popup .ui-dialog-content .popup-footer-wrapper{text-align:center}.account-type-upgrade-menu-block{padding:20px 0 0;background-color:transparent;line-height:normal;white-space:normal;font-size:14px}.account-type-upgrade-menu-block .mc-common-button{box-shadow:0 0 5px 3px hsla(0,0%,100%,.6);padding:0 20px}.account-type-upgrade-menu-block .mc-common-button .discount-sticker{line-height:normal}.account-type-upgrade-menu-block .mc-common-button:hover{-ms-filter:none;filter:none;opacity:1}.logo-model-screenname{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;top:-10000px;display:none}.cancellation-form .message{padding:10px 0}.activity-event-viewer .activity-card .card-body-wrapper .cover:before{top:-1px}#last-added-flex{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.site-checkbox .checkbox{border-radius:2px}.site-checkbox+.label{font-size:12px}@media screen and (min-width:600px){#last-added-flex .item{width:calc(50% - 8px);margin:4px}#last-added-flex .item.wide .empty-img{min-height:100%;max-width:none;position:absolute;min-width:100%;left:50%;transform:translate(-50%)}}.content-links a span{vertical-align:top}.vat-eu{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";filter:alpha(opacity=40);opacity:.4;font-size:12px;font-weight:700;padding-bottom:20px}.radio-btn-wrapp label{font-size:14px}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-titlebar{padding:15px 0}.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-titlebar .ui-dialog-title,.mc-site-common-popup.gdpr-popup.ccpa-form .ui-dialog-titlebar .ui-dialog-titlebar-close{display:none}.static-page-docs a{cursor:pointer}.mc-common-input+.err-msg{display:none;color:red;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:transform .2s ease-in,opacity .2s ease-out;transform:translateX(-10px)}.mc-common-input.error+.err-msg{display:block;-ms-filter:none;filter:none;opacity:1;transform:translateX(0)}@media screen and (min-width:768px){.main-menu-wrapper .base .link .more-link,.main-menu-wrapper .base .link a{line-height:70px}.main-menu-container.main-menu.menu-wrapper,.menu-container.base{width:100%}.top-menu .action.logged .user:hover:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;border-radius:3px 3px 0 0}.top-menu .action.logged .user:hover .user-settings{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;max-width:400px}}@media screen and (min-width:960px){.footer-b-wrapper{margin-top:65px}.main-menu-container.main-menu.menu-wrapper,.menu-container.base{width:100%}}.common-btn{cursor:pointer;padding:0 20px;text-transform:uppercase;line-height:44px;text-align:center;border:1px solid transparent;font-size:13px;border-radius:3px}.common-btn.no-border{border-color:transparent}.common-btn:hover{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";filter:alpha(opacity=80);opacity:.8}.common-btn:hover.no-hover{-ms-filter:none;filter:none;opacity:1}.common-btn.show-more i{font-size:7px;position:relative;margin-left:5px}.common-btn .small-loader,.common-btn .small-loader.spin{left:10px}.common-btn.button-with-spinner{position:relative;transition:padding .4s}.common-btn.button-with-spinner:after{content:\"\";top:50%;left:10px;margin-top:-10px;display:block;width:19px;height:19px;position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;visibility:hidden;background-repeat:no-repeat;background-position:0 0;transform:scale(1.5);transition:all .3s ease;background-image:url(" + __webpack_require__(5) + ")}.common-btn.button-with-spinner.spin{padding-left:35px!important}.common-btn.button-with-spinner.spin:after{visibility:visible;-ms-filter:none;filter:none;opacity:1;animation:play 1s steps(28) infinite;transform:scale(1)}.common-btn.disabled,.common-btn:disabled{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;cursor:default}.common-btn.size-1{line-height:34px;padding:0 50px}@media screen and (max-width:999px){.common-btn.size-1{padding:0 25px}}.common-input.size-1{line-height:34px;border:1px solid hsla(0,0%,100%,.35);border-radius:2px;transition:border-color .2s;overflow:hidden}.common-input.size-1 .inp-error{display:block;position:absolute;z-index:1;top:0;left:0;right:0;bottom:0;font-size:12px;padding-left:10px;background-color:transparent;transform:translateY(-100%);transition:transform .2s}.common-input.size-1.error{border-color:#bd4147}.common-input.size-1.error .inp-error{transform:translate(0);color:#bd4147}.common-input.size-1.error input{color:transparent!important}.common-input.size-1.error input:focus{color:inherit!important}.common-input.size-1.error input:focus+.inp-error{transform:translateY(-100%)}.common-input.size-1 input{height:34px;line-height:34px;width:100%;transition:color .2s}@media screen and (min-width:1000px){.common-input.size-1 input{width:210px}}.nsl-content .nsl-editable{font-family:simplifica;font-size:36px;line-height:normal;text-align:center}.nsl-content .nsl-editable-2{font-size:11px;line-height:16px;margin-top:15px;margin-bottom:5px}.nsl-content .consent-text{font-size:11px;margin-top:10px;margin-bottom:10px;text-align:center;line-height:16px}.nsl-content .nsl-form{max-width:590px;margin:0 auto}.nsl-content .nsl-form .common-btn{display:inline-block;max-width:176px}@media screen and (max-width:540px){.nsl-content .nsl-form .common-btn{max-width:none;margin-top:10px}.nsl-content .nsl-form .common-input,.nsl-content .nsl-form .common-input:nth-child(3){margin:10px 0 5px}}@media screen and (min-width:541px){.nsl-content{padding-left:20px;padding-right:20px}.nsl-content .nsl-form{-ms-flex-flow:row wrap;flex-flow:row wrap}.nsl-content .nsl-form .common-input{max-width:195px}.nsl-content .nsl-form .common-input:nth-child(2){margin:0}.nsl-content .nsl-form .common-input:nth-child(3){margin:0 10px}.nsl-content .nsl-form .consent-text{margin-top:15px}.nsl-content .nsl-editable-2{margin-bottom:15px}.nsl-content .consent-text,.nsl-content .nsl-editable-2{width:100%}}.auth-form.account-form .user-notifications-wrapper{border-bottom-width:3px;border-bottom-style:solid;margin-bottom:28px}.auth-form.account-form .user-notitfications .row label{min-width:auto;line-height:normal}.auth-form.account-form .email-verification-notice{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;margin-bottom:20px}.user-profile{border-bottom-width:3px;border-bottom-style:solid;margin-bottom:28px}.user-profile .user-profile-table{margin-bottom:0}.user-profile .user-profile-table table td{border-bottom-color:rgba(0,0,0,.1);font-size:12px}.user-profile .user-profile-table table tr:first-child td{padding-top:0}.user-profile .user-profile-table table tr:last-child td{border-color:transparent}.user-profile .user-profile-table table tr td:last-child{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.user-personal-data{border-bottom-width:3px;border-bottom-style:solid;margin-bottom:28px;padding-bottom:28px}.user-personal-data .user-communication{margin-top:20px}.user-personal-data .personal-data-processing .data-row .date{font-size:12px;margin-top:5px}@media screen and (min-width:1024px){.user-personal-data .personal-data-processing .data-row label{width:520px}.user-profile{padding-bottom:16px}}@media screen and (max-width:960px){.left-back,.right-back{background-image:none!important}}div[data-widget-alias=join] .left-back{margin-right:0;left:30px;right:340px}div[data-widget-alias=join] .left-back,div[data-widget-alias=join] .right-back{display:none;height:auto;bottom:30px;top:30px;width:auto}.join-back{position:absolute;left:0;right:0;top:0;bottom:0;margin:0;z-index:1;background-position:center 0}.join-bg-shader{position:relative;z-index:2}.join-wrapper{text-align:center;margin:0 auto;position:relative}.join-wrapper .page-width{max-width:320px}.join-wrapper .header{padding-bottom:26px;padding-top:6px;border-bottom-width:1px;border-bottom-style:solid;margin-bottom:25px;display:block;background-image:none;min-height:0}.join-wrapper .header .logo{max-width:100%;word-wrap:break-word}.join-wrapper .header .logo *{font-family:simplifica!important;font-size:40px!important;line-height:40px;max-width:100%}.join-wrapper .fields{margin-bottom:35px}.join-wrapper .row{margin-bottom:8px;position:relative}.join-wrapper .row:last-child{margin-bottom:0}.join-wrapper .row .error-message{display:none;margin-top:10px;line-height:normal}.join-wrapper .row .error-message.show{display:block}.join-wrapper .row input.error{background-color:transparent;position:relative;z-index:2}.join-wrapper .row input.error:-moz-placeholder{color:transparent}.join-wrapper .row input.error:-ms-input-placeholder{color:transparent}.join-wrapper .row input.error .common-input.error .border{border-color:#bd4147!important;color:transparent}.join-wrapper .row input::-webkit-input-placeholder.error{color:transparent}.join-wrapper .row input::-moz-placeholder.error{color:transparent}.join-wrapper .join-options-container{position:relative;margin-bottom:40px}.join-wrapper .join-options-container .arr{position:absolute;top:calc(50% - 12px);font-size:24px;z-index:2}.join-wrapper .join-options-container .arr.lt{left:-10px}.join-wrapper .join-options-container .arr.rt{right:-10px}.join-wrapper .join-options-swipe-wrapper{overflow:hidden;visibility:hidden;border-width:1px 0 0;border-style:solid}.join-wrapper .join-options{padding:15px 0 20px;overflow:hidden;position:relative;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}.join-wrapper .join-options .item{float:left;width:100%;position:relative;padding:0 20px;max-width:346px}.join-wrapper .join-options-pager{position:absolute;bottom:-3px;left:0;right:0;text-align:center;line-height:7px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.join-wrapper .join-options-pager .line{display:block;height:0;border-top-width:1px;border-top-style:solid;margin-top:4px;-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto}.join-wrapper .join-options-pager .bullets{display:inline-block;padding:0 7px;background-color:transparent}.join-wrapper .join-options-pager .bullets span{display:inline-block;border-radius:50%;width:7px;height:7px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3;margin:0 1.5px}.join-wrapper .join-options-pager .bullets span.active{-ms-filter:none;filter:none;opacity:1}.join-wrapper .join-form .submit{font-size:21px;margin-bottom:30px;width:220px;position:relative;height:46px}.join-wrapper .join-form .submit input{font-size:inherit;color:inherit;text-transform:inherit;height:inherit;width:100%}.join-input{border-width:1px;border-style:solid;line-height:40px;height:40px;text-align:inherit;font-size:12px;width:100%;border-radius:3px}.discount{padding:0 20px 0 35px}.join-options input{display:none}.join-options .price-block{font-size:40px;line-height:45px;padding-top:20px}.join-options .title{font-size:16px;margin-bottom:10px}.join-options .text{font-size:12px}.join-options .discount-price .price-block{padding-top:20px}.join-options .discount-price .price-block .price{font-size:14px;line-height:18px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=36)\";filter:alpha(opacity=36);opacity:.36}.join-options .discount-price .price-block .dprice{font-size:25px;line-height:25px}@media screen and (min-width:768px){div[data-widget-alias=join] .left-back{display:block}.join-wrapper{float:right;width:340px;max-width:340px}.join-wrapper .global-title{font-size:30px}.join-wrapper .page-width{max-width:none}.join-wrapper .join-back{display:none}.join-wrapper .header{padding-bottom:30px;padding-top:10px}.join-input{background-color:transparent}}@media screen and (min-width:960px){div[data-widget-alias=join] .left-back{right:50%;margin-right:160px;left:30px}div[data-widget-alias=join] .right-back{display:block;margin-left:160px;right:30px;left:50%}.join-wrapper{float:none;margin:0 auto;width:406px;position:relative;z-index:2;max-width:none}.join-wrapper .global-title{font-size:30px}.join-wrapper .header{height:auto}}.discount .heart{display:none}.valentines.wo_descr .heart{margin-right:0}.valentines .heart{left:0;margin-right:-50px;z-index:1;margin-top:20px;position:relative;min-width:99px!important}.valentines .heart p{text-align:center;position:absolute;white-space:nowrap;width:100%;color:#fff;font-size:22px;font-weight:700;padding-top:24px;text-shadow:0 3px 0 rgba(0,0,0,.09)}.valentines .burst-1,.valentines .burst-2{display:none}.valentines.discount .discount-description{padding:5px 18px 5px 42px;background-image:none;background-color:#ed1c24}", ""]);

// exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/simplifica.woff2", __webpack_require__.p + "fonts/3YNRuwd.woff2");

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/data-fox-editor-type-image.png", __webpack_require__.p + "images/data-fox-editor-type-image.png");

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/cb-feedback-white.png", __webpack_require__.p + "_/_/_/root/images/cb-feedback-white.png");

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/banner-cam.png", __webpack_require__.p + "images/banner-cam.png");

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/header.png", __webpack_require__.p + "images/header.png");

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/slide-image-2.jpg", __webpack_require__.p + "images/slide-image-2.jpg");

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/slide-image-3.jpg", __webpack_require__.p + "images/slide-image-3.jpg");

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/slide-image-4.jpg", __webpack_require__.p + "images/slide-image-4.jpg");

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/iconfont.ttf?ldnvmv", __webpack_require__.p + "fonts/3PGntxB.ttf");

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/iconfont.woff?ldnvmv", __webpack_require__.p + "fonts/1JlKSi3.woff");

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/iconfont.svg?ldnvmv", __webpack_require__.p + "fonts/iconfont.svg");

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dependecies.js": 938
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 937;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	__webpack_require__(939);
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3)(__webpack_require__(940))

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports = "/*!\n * Swipe 2.2.18\n *\n * Brad Birdsall\n * Copyright 2013, MIT License\n *\n*/\n\n// if the module has no dependencies, the above pattern can be simplified to\n// eslint-disable-next-line no-extra-semi\n;(function (root, factory) {\n  root = root || {};\n  // eslint-disable-next-line no-undef\n  if (typeof define === 'function' && define.amd) {\n    // AMD. Register as an anonymous module.\n    // eslint-disable-next-line no-undef\n    define([], function(){\n      root.Swipe = factory();\n      return root.Swipe;\n    });\n  } else if (typeof module === 'object' && module.exports) {\n    // Node. Does not work with strict CommonJS, but\n    // only CommonJS-like environments that support module.exports,\n    // like Node.\n    module.exports = factory();\n  } else {\n    // Browser globals\n    root.Swipe = factory();\n  }\n}(this, function () {\n  // Establish the root object, `window` (`self`) in the browser, `global`\n  // on the server, or `this` in some virtual machines. We use `self`\n  // instead of `window` for `WebWorker` support.\n  var root = typeof self == 'object' && self.self === self && self ||\n             typeof global == 'object' && global.global === global && global ||\n             this;\n\n  var _document = root.document;\n\n  function Swipe(container, options) {\n\n    'use strict';\n\n    options = options || {};\n\n    // setup initial vars\n    var start = {};\n    var delta = {};\n    var isScrolling;\n\n    // setup auto slideshow\n    var delay = options.auto || 0;\n    var interval;\n\n    var disabled = false;\n\n    // utilities\n    // simple no operation function\n    var noop = function() {};\n    // offload a functions execution\n    var offloadFn = function(fn) { setTimeout(fn || noop, 0); };\n    // Returns a function, that, as long as it continues to be invoked, will not\n    // be triggered.\n    var throttle = function (fn, threshhold) {\n      threshhold = threshhold || 100;\n      var timeout = null;\n\n      function cancel() {\n        if (timeout) clearTimeout(timeout);\n      }\n\n      function throttledFn() {\n        var context = this;\n        var args = arguments;\n        cancel();\n        timeout = setTimeout(function() {\n          timeout = null;\n          fn.apply(context, args);\n        }, threshhold);\n      }\n\n      // allow remove throttled timeout\n      throttledFn.cancel = cancel;\n\n      return throttledFn;\n    };\n\n    // check whether event is cancelable\n    var isCancelable = function (event) {\n      if (!event) return false;\n      return typeof event.cancelable !== 'boolean' || event.cancelable;\n    };\n\n    // polyfill for browsers that do not support Element.matches()\n    if (!Element.prototype.matches) {\n      Element.prototype.matches =\n        Element.prototype.matchesSelector ||\n        Element.prototype.mozMatchesSelector ||\n        Element.prototype.msMatchesSelector ||\n        Element.prototype.oMatchesSelector ||\n        Element.prototype.webkitMatchesSelector ||\n        function (s) {\n          var matches = (this.document || this.ownerDocument).querySelectorAll(s),\n            i = matches.length;\n          while (--i >= 0 && matches.item(i) !== this)\n            ;\n          return i > -1;\n        };\n    }\n\n    // check browser capabilities\n    var browser = {\n      addEventListener: !!root.addEventListener,\n      passiveEvents: (function () {\n        // Test via a getter in the options object to see if the passive property is accessed\n        var supportsPassive = false;\n        try {\n          var opts = Object.defineProperty({}, 'passive', {\n            // eslint-disable-next-line getter-return\n            get: function () {\n              supportsPassive = true;\n            }\n          });\n          root.addEventListener('testEvent', null, opts);\n          root.removeEventListener('testEvent', null, opts);\n        }\n        catch (e) {\n          supportsPassive = false;\n        }\n        return supportsPassive;\n      })(),\n      // eslint-disable-next-line no-undef\n      touch: ('ontouchstart' in root) || root.DocumentTouch && _document instanceof DocumentTouch,\n      transitions: (function(temp) {\n        var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];\n        for ( var i in props ) {\n          if (temp.style[ props[i] ] !== undefined){\n            return true;\n          }\n        }\n        return false;\n      })(_document.createElement('swipe'))\n    };\n\n    // quit if no root element\n    if (!container) return;\n\n    var element = container.children[0];\n    var slides, slidePos, width, length;\n    var index = parseInt(options.startSlide, 10) || 0;\n    var speed = options.speed || 300;\n    options.continuous = options.continuous !== undefined ? options.continuous : true;\n\n    // check text direction\n    var slideDir = (function(el, prop, dir) {\n      if (el.currentStyle) {\n        dir = el.currentStyle[prop];\n      } else if (root.getComputedStyle) {\n        dir = root.getComputedStyle(el, null).getPropertyValue(prop);\n      }\n      return 'rtl' === dir ? 'right' : 'left';\n    })(container, 'direction');\n\n    // AutoRestart option: auto restart slideshow after user's touch event\n    options.autoRestart = options.autoRestart !== undefined ? options.autoRestart : false;\n\n    // throttled setup\n    var throttledSetup = throttle(setup);\n\n    // setup event capturing\n    var events = {\n\n      handleEvent: function(event) {\n        if (disabled) return;\n\n        switch (event.type) {\n          case 'mousedown':\n          case 'touchstart': this.start(event); break;\n          case 'mousemove':\n          case 'touchmove': this.move(event); break;\n          case 'mouseup':\n          case 'mouseleave':\n          case 'touchend': this.end(event); break;\n          case 'webkitTransitionEnd':\n          case 'msTransitionEnd':\n          case 'oTransitionEnd':\n          case 'otransitionend':\n          case 'transitionend': this.transitionEnd(event); break;\n          case 'resize': throttledSetup(); break;\n        }\n\n        if (options.stopPropagation) {\n          event.stopPropagation();\n        }\n      },\n\n      start: function(event) {\n        var touches;\n\n        if (isMouseEvent(event)) {\n          touches = event;\n          event.preventDefault(); // For desktop Safari drag\n        } else {\n          touches = event.touches[0];\n        }\n\n        // check if the user is swiping on an element that the options say to ignore (for example, a scrolling area)\n        if (options.ignore && touches.target.matches(options.ignore)) {\n          return;\n        }\n\n        // measure start values\n        start = {\n\n          // get initial touch coords\n          x: touches.pageX,\n          y: touches.pageY,\n\n          // store time to determine touch duration\n          time: +new Date()\n\n        };\n\n        // used for testing first move event\n        isScrolling = undefined;\n\n        // reset delta and end measurements\n        delta = {};\n\n        // attach touchmove and touchend listeners\n        if (isMouseEvent(event)) {\n          element.addEventListener('mousemove', this, false);\n          element.addEventListener('mouseup', this, false);\n          element.addEventListener('mouseleave', this, false);\n        } else {\n          element.addEventListener('touchmove', this, browser.passiveEvents ? { passive: false } : false);\n          element.addEventListener('touchend', this, false);\n        }\n        runDragStart(getPos(), slides[index]);\n      },\n\n      move: function(event) {\n        var touches;\n\n        if (isMouseEvent(event)) {\n          touches = event;\n        } else {\n          // ensure swiping with one touch and not pinching\n          if ( event.touches.length > 1 || event.scale && event.scale !== 1) {\n            return;\n          }\n\n          // we can disable scrolling unless it is already in progress\n          if (options.disableScroll && isCancelable(event)) {\n            event.preventDefault();\n          }\n\n          touches = event.touches[0];\n        }\n\n        // measure change in x and y\n        delta = {\n          x: touches.pageX - start.x,\n          y: touches.pageY - start.y\n        };\n\n        // determine if scrolling test has run - one time test\n        if ( typeof isScrolling === 'undefined') {\n          isScrolling = !!( isScrolling || Math.abs(delta.x) < Math.abs(delta.y) );\n        }\n\n        // if user is not trying to scroll vertically\n        if (!isScrolling) {\n\n          // if it is not already scrolling\n          if (isCancelable(event)) {\n            // prevent native scrolling\n            event.preventDefault();\n          }\n\n          // stop slideshow\n          stop();\n\n          // increase resistance if first or last slide\n          if (options.continuous) { // we don't add resistance at the end\n\n            translate(circle(index-1), delta.x + slidePos[circle(index-1)], 0);\n            translate(index, delta.x + slidePos[index], 0);\n            translate(circle(index+1), delta.x + slidePos[circle(index+1)], 0);\n\n          } else {\n\n            delta.x =\n              delta.x /\n              ( (!index && delta.x > 0 ||             // if first slide and sliding left\n                 index === slides.length - 1 &&        // or if last slide and sliding right\n                 delta.x < 0                           // and if sliding at all\n              ) ?\n                ( Math.abs(delta.x) / width + 1 )      // determine resistance level\n                : 1 );                                 // no resistance if false\n\n            // translate 1:1\n            translate(index-1, delta.x + slidePos[index-1], 0);\n            translate(index, delta.x + slidePos[index], 0);\n            translate(index+1, delta.x + slidePos[index+1], 0);\n          }\n        }\n      },\n\n      end: function(event) {\n\n        // measure duration\n        var duration = +new Date() - start.time;\n\n        // determine if slide attempt triggers next/prev slide\n        var isValidSlide =\n            Number(duration) < 250 &&         // if slide duration is less than 250ms\n            Math.abs(delta.x) > 20 ||         // and if slide amt is greater than 20px\n            Math.abs(delta.x) > width/2;      // or if slide amt is greater than half the width\n\n        // determine if slide attempt is past start and end\n        var isPastBounds =\n            !index && delta.x > 0 ||                      // if first slide and slide amt is greater than 0\n            index === slides.length - 1 && delta.x < 0;   // or if last slide and slide amt is less than 0\n\n        if (options.continuous) {\n          isPastBounds = false;\n        }\n\n        // OLD determine direction of swipe (true:right, false:left)\n        // determine direction of swipe (1: backward, -1: forward)\n        var direction = Math.abs(delta.x) / delta.x;\n\n        // if not scrolling vertically\n        if (!isScrolling) {\n\n          if (isValidSlide && !isPastBounds) {\n\n            // if we're moving right\n            if (direction < 0) {\n\n              if (options.continuous) { // we need to get the next in this direction in place\n\n                move(circle(index-1), -width, 0);\n                move(circle(index+2), width, 0);\n\n              } else {\n                move(index-1, -width, 0);\n              }\n\n              move(index, slidePos[index]-width, speed);\n              move(circle(index+1), slidePos[circle(index+1)]-width, speed);\n              index = circle(index+1);\n\n            } else {\n              if (options.continuous) { // we need to get the next in this direction in place\n\n                move(circle(index+1), width, 0);\n                move(circle(index-2), -width, 0);\n\n              } else {\n                move(index+1, width, 0);\n              }\n\n              move(index, slidePos[index]+width, speed);\n              move(circle(index-1), slidePos[circle(index-1)]+width, speed);\n              index = circle(index-1);\n            }\n\n            runCallback(getPos(), slides[index], direction);\n\n          } else {\n\n            if (options.continuous) {\n\n              move(circle(index-1), -width, speed);\n              move(index, 0, speed);\n              move(circle(index+1), width, speed);\n\n            } else {\n\n              move(index-1, -width, speed);\n              move(index, 0, speed);\n              move(index+1, width, speed);\n            }\n          }\n        }\n\n        // kill touchmove and touchend event listeners until touchstart called again\n        if (isMouseEvent(event)) {\n          element.removeEventListener('mousemove', events, false);\n          element.removeEventListener('mouseup', events, false);\n          element.removeEventListener('mouseleave', events, false);\n        } else {\n          element.removeEventListener('touchmove', events, browser.passiveEvents ? { passive: false } : false);\n          element.removeEventListener('touchend', events, false);\n        }\n        runDragEnd(getPos(), slides[index]);\n      },\n\n      transitionEnd: function(event) {\n        var currentIndex = parseInt(event.target.getAttribute('data-index'), 10);\n        if (currentIndex === index) {\n          if (delay || options.autoRestart) restart();\n\n          runTransitionEnd(getPos(), slides[index]);\n        }\n      }\n    };\n\n    // trigger setup\n    setup();\n\n    // start auto slideshow if applicable\n    begin();\n\n    // Expose the Swipe API\n    return {\n      // initialize\n      setup: setup,\n\n      // go to slide\n      slide: function(to, speed) {\n        stop();\n        slide(to, speed);\n      },\n\n      // move to previous\n      prev: function() {\n        stop();\n        prev();\n      },\n\n      // move to next\n      next: function() {\n        stop();\n        next();\n      },\n\n      // Restart slideshow\n      restart: restart,\n\n      // cancel slideshow\n      stop: stop,\n\n      // return current index position\n      getPos: getPos,\n\n      // disable slideshow\n      disable: disable,\n\n      // enable slideshow\n      enable: enable,\n\n      // return total number of slides\n      getNumSlides: function() { return length; },\n\n      // completely remove swipe\n      kill: kill\n    };\n\n    // remove all event listeners\n    function detachEvents() {\n      if (browser.addEventListener) {\n        // remove current event listeners\n        element.removeEventListener('touchstart', events, browser.passiveEvents ? { passive: true } : false);\n        element.removeEventListener('mousedown', events, false);\n        element.removeEventListener('webkitTransitionEnd', events, false);\n        element.removeEventListener('msTransitionEnd', events, false);\n        element.removeEventListener('oTransitionEnd', events, false);\n        element.removeEventListener('otransitionend', events, false);\n        element.removeEventListener('transitionend', events, false);\n        root.removeEventListener('resize', events, false);\n      } else {\n        root.onresize = null;\n      }\n    }\n\n    // add event listeners\n    function attachEvents() {\n      if (browser.addEventListener) {\n\n        // set touchstart event on element\n        if (browser.touch) {\n          element.addEventListener('touchstart', events, browser.passiveEvents ? { passive: true } : false);\n        }\n\n        if (options.draggable) {\n          element.addEventListener('mousedown', events, false);\n        }\n\n        if (browser.transitions) {\n          element.addEventListener('webkitTransitionEnd', events, false);\n          element.addEventListener('msTransitionEnd', events, false);\n          element.addEventListener('oTransitionEnd', events, false);\n          element.addEventListener('otransitionend', events, false);\n          element.addEventListener('transitionend', events, false);\n        }\n\n        // set resize event on window\n        root.addEventListener('resize', events, false);\n\n      } else {\n        root.onresize = throttledSetup; // to play nice with old IE\n      }\n    }\n\n    // clone nodes when there is only two slides\n    function cloneNode(el) {\n      var clone = el.cloneNode(true);\n      element.appendChild(clone);\n\n      // tag these slides as clones (to remove them on kill)\n      clone.setAttribute('data-cloned', true);\n\n      // Remove id from element\n      clone.removeAttribute('id');\n    }\n\n    function setup(opts) {\n      // Overwrite options if necessary\n      if (opts != null) {\n        for (var prop in opts) {\n          options[prop] = opts[prop];\n        }\n      }\n\n      // cache slides\n      slides = element.children;\n      length = slides.length;\n\n      // slides length correction, minus cloned slides\n      for (var i = 0; i < slides.length; i++) {\n        if (slides[i].getAttribute('data-cloned')) length--;\n      }\n\n      // set continuous to false if only one slide\n      if (slides.length < 2) {\n        options.continuous = false;\n      }\n\n      // special case if two slides\n      if (browser.transitions && options.continuous && slides.length < 3) {\n        cloneNode(slides[0]);\n        cloneNode(slides[1]);\n\n        slides = element.children;\n      }\n\n      // adjust style on rtl\n      if ('right' === slideDir) {\n        for (var j = 0; j < slides.length; j++) {\n          slides[j].style.float = 'right';\n        }\n      }\n\n      // create an array to store current positions of each slide\n      slidePos = new Array(slides.length);\n\n      // determine width of each slide\n      width = container.getBoundingClientRect().width || container.offsetWidth;\n\n      element.style.width = (slides.length * width * 2) + 'px';\n\n      // stack elements\n      var pos = slides.length;\n      while(pos--) {\n        var slide = slides[pos];\n\n        slide.style.width = width + 'px';\n        slide.setAttribute('data-index', pos);\n\n        if (browser.transitions) {\n          slide.style[slideDir] = (pos * -width) + 'px';\n          move(pos, index > pos ? -width : (index < pos ? width : 0), 0);\n        }\n      }\n\n      // reposition elements before and after index\n      if (options.continuous && browser.transitions) {\n        move(circle(index-1), -width, 0);\n        move(circle(index+1), width, 0);\n      }\n\n      if (!browser.transitions) {\n        element.style[slideDir] = (index * -width) + 'px';\n      }\n\n      container.style.visibility = 'visible';\n\n      // reinitialize events\n      detachEvents();\n      attachEvents();\n    }\n\n    function prev() {\n      if (disabled) return;\n\n      if (options.continuous) {\n        slide(index-1);\n      } else if (index) {\n        slide(index-1);\n      }\n    }\n\n    function next() {\n      if (disabled) return;\n\n      if (options.continuous) {\n        slide(index+1);\n      } else if (index < slides.length - 1) {\n        slide(index+1);\n      }\n    }\n\n    function runCallback(pos, index, dir) {\n      if (options.callback) {\n        options.callback(pos, index, dir);\n      }\n    }\n\n    function runTransitionEnd(pos, index) {\n      if (options.transitionEnd) {\n        options.transitionEnd(pos, index);\n      }\n    }\n\n    function runDragStart(pos, index) {\n      if (options.dragStart) {\n        options.dragStart(pos, index);\n      }\n    }\n\n    function runDragEnd(pos, index) {\n      if (options.dragEnd) {\n        options.dragEnd(pos, index);\n      }\n    }\n\n    function circle(index) {\n\n      // a simple positive modulo using slides.length\n      return (slides.length + (index % slides.length)) % slides.length;\n    }\n\n    function getPos() {\n      // Fix for the clone issue in the event of 2 slides\n      var currentIndex = index;\n\n      if (currentIndex >= length) {\n        currentIndex = currentIndex - length;\n      }\n\n      return currentIndex;\n    }\n\n    function slide(to, slideSpeed) {\n\n      // ensure to is of type 'number'\n      to = typeof to !== 'number' ? parseInt(to, 10) : to;\n\n      // do nothing if already on requested slide\n      if (index === to) return;\n\n      if (browser.transitions) {\n\n        var direction = Math.abs(index-to) / (index-to); // 1: backward, -1: forward\n\n        // get the actual position of the slide\n        if (options.continuous) {\n          var natural_direction = direction;\n          direction = -slidePos[circle(to)] / width;\n\n          // if going forward but to < index, use to = slides.length + to\n          // if going backward but to > index, use to = -slides.length + to\n          if (direction !== natural_direction) {\n            to = -direction * slides.length + to;\n          }\n\n        }\n\n        var diff = Math.abs(index-to) - 1;\n\n        // move all the slides between index and to in the right direction\n        while (diff--) {\n          move( circle((to > index ? to : index) - diff - 1), width * direction, 0);\n        }\n\n        to = circle(to);\n\n        move(index, width * direction, slideSpeed || speed);\n        move(to, 0, slideSpeed || speed);\n\n        if (options.continuous) { // we need to get the next in place\n          move(circle(to - direction), -(width * direction), 0);\n        }\n\n      } else {\n\n        to = circle(to);\n        animate(index * -width, to * -width, slideSpeed || speed);\n        // no fallback for a circular continuous if the browser does not accept transitions\n      }\n\n      index = to;\n      offloadFn(function() {\n        runCallback(getPos(), slides[index], direction);\n      });\n    }\n\n    function move(index, dist, speed) {\n      translate(index, dist, speed);\n      slidePos[index] = dist;\n    }\n\n    function translate(index, dist, speed) {\n\n      var slide = slides[index];\n      var style = slide && slide.style;\n\n      if (!style) return;\n\n      style.webkitTransitionDuration =\n        style.MozTransitionDuration =\n        style.msTransitionDuration =\n        style.OTransitionDuration =\n        style.transitionDuration = speed + 'ms';\n\n      style.webkitTransform =\n        style.msTransform =\n        style.MozTransform =\n        style.OTransform =\n        style.transform = 'translateX(' + dist + 'px)';\n    }\n\n    function animate(from, to, speed) {\n\n      // if not an animation, just reposition\n      if (!speed) {\n        element.style[slideDir] = to + 'px';\n        return;\n      }\n\n      var start = +new Date();\n\n      var timer = setInterval(function() {\n        var timeElap = +new Date() - start;\n\n        if (timeElap > speed) {\n\n          element.style[slideDir] = to + 'px';\n\n          if (delay || options.autoRestart) restart();\n\n          runTransitionEnd(getPos(), slides[index]);\n\n          clearInterval(timer);\n\n          return;\n        }\n\n        element.style[slideDir] = (( (to - from) * (Math.floor((timeElap / speed) * 100) / 100) ) + from) + 'px';\n      }, 4);\n\n    }\n\n    function begin() {\n      delay = options.auto || 0;\n      if (delay) interval = setTimeout(next, delay);\n    }\n\n    function stop() {\n      delay = 0;\n      clearTimeout(interval);\n    }\n\n    function restart() {\n      stop();\n      begin();\n    }\n\n    function disable() {\n      stop();\n      disabled = true;\n    }\n\n    function enable() {\n      disabled = false;\n      restart();\n    }\n\n    function isMouseEvent(e) {\n      return /^mouse/.test(e.type);\n    }\n\n    function kill() {\n      // cancel slideshow\n      stop();\n\n      // remove inline styles\n      container.style.visibility = '';\n\n      // reset element\n      element.style.width = '';\n      element.style[slideDir] = '';\n\n      // reset slides\n      var pos = slides.length;\n      while (pos--) {\n\n        if (browser.transitions) {\n          translate(pos, 0, 0);\n        }\n\n        var slide = slides[pos];\n\n        // if the slide is tagged as clone, remove it\n        if (slide.getAttribute('data-cloned')) {\n          var _parent = slide.parentElement;\n          _parent.removeChild(slide);\n        }\n\n        // remove styles\n        slide.style.width = '';\n        slide.style[slideDir] = '';\n\n        slide.style.webkitTransitionDuration =\n          slide.style.MozTransitionDuration =\n          slide.style.msTransitionDuration =\n          slide.style.OTransitionDuration =\n          slide.style.transitionDuration = '';\n\n        slide.style.webkitTransform =\n          slide.style.msTransform =\n          slide.style.MozTransform =\n          slide.style.OTransform = '';\n\n        // remove custom attributes (?)\n        // slide.removeAttribute('data-index');\n      }\n\n      // remove all events\n      detachEvents();\n\n      // remove throttled function timeout\n      throttledSetup.cancel();\n    }\n  }\n\n  if ( root.jQuery || root.Zepto ) {\n    (function($) {\n      $.fn.Swipe = function(params) {\n        return this.each(function() {\n          $(this).data('Swipe', new Swipe($(this)[0], params));\n        });\n      };\n    })( root.jQuery || root.Zepto );\n  }\n\n  return Swipe;\n}));\n"

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./conversationAttachedContent.js": 942,
	"./inactive/stubs.js": 943,
	"./layout/404.js": 944,
	"./layout/freeHostedGallery.js": 945,
	"./layout/home.js": 1127,
	"./lsCounter.js": 1128,
	"./maps/guestCustom.js": 1129,
	"./maps/memberCustom.js": 1130,
	"./newsLetterSubscriber.js": 1131,
	"./sitepage/about.js": 1132,
	"./sitepage/account.js": 1133,
	"./sitepage/activity.js": 1134,
	"./sitepage/blog.js": 1135,
	"./sitepage/cancellation.js": 1136,
	"./sitepage/contentactions.opt": 1137,
	"./sitepage/favorites.js": 1138,
	"./sitepage/gallery.js": 1139,
	"./sitepage/home.js": 1140,
	"./sitepage/join.js": 1141,
	"./sitepage/liveshow.js": 1142,
	"./sitepage/login.js": 1143,
	"./sitepage/passwordRecovery.js": 1144,
	"./sitepage/photosets.js": 1145,
	"./sitepage/post.js": 1146,
	"./sitepage/scene.js": 1147,
	"./sitepage/tips.js": 1148,
	"./sitepage/videos.js": 1149
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 941;

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~#conversationViewer #previewContent":{"template":[{"value":"popup_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~#conversationViewer #previewContent","_fox_":1}],"dialog.dialogClass":[{"value":"preview-content mc-site-common-popup mc-site-popup-bg","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~#conversationViewer #previewContent","_fox_":1}],"leftNavArrow":[{"value":"icon-au_popup_left_arw a-left text-color-3","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~#conversationViewer #previewContent","_fox_":1}],"rightNavArrow":[{"value":"icon-au_popup_right_arw a-right text-color-3","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~#conversationViewer #previewContent","_fox_":1}],"handleDom.hide.target":[{"value":".cross.close","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~#conversationViewer #previewContent","_fox_":1}],"handleDom.hide.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~#conversationViewer #previewContent","_fox_":1}],"handleDom.hide.callback":[{"value":"hide","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~#conversationViewer #previewContent","_fox_":1}]},"~#conversationViewer #previewContent #videoPreview #downloadLinks":{"templateOptions.iconDownload":[{"value":"icon-au_download","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~#conversationViewer #previewContent #videoPreview #downloadLinks","_fox_":1}]},"~#conversationViewer #previewContent #imagePreview":{"templateOptions.iconDownload":[{"value":"icon-au_download","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~#conversationViewer #previewContent #imagePreview","_fox_":1}]},"~#conversationViewer #previewContent .Widget":{"embed.container":[{"value":".widgetContainer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~#conversationViewer #previewContent .Widget","_fox_":1}]},"~#conversationViewer #attachUnlocker .Dialog":{"dialog.dialogClass":[{"value":"dark-overlay attach-unlock mc-site-common-popup with-ui-dialog-titlebar mc-site-popup-bg","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"~#conversationViewer #attachUnlocker .Dialog","_fox_":1}]},"~#conversationViewer":{"widgets.preloader.widget":[{"value":"Preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~#conversationViewer","_fox_":1}],"widgets.preloader.template":[{"value":"big_preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107023},"path":"~#conversationViewer","_fox_":1}],"widgets.preloader.listen":[{"value":["#list"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~#conversationViewer","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root[inactiveClient=1] ~.SitePage_Home":{"-widgets.mixedContent":[{"value":1,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widget":[{"value":"GridStub","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}],"widgets.mixedContent.container":[{"value":"#mixed_content","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}],"widgets.mixedContent.template":[{"value":"sitepage_home_lastadded_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}],"widgets.mixedContent.item.title":[{"value":"My Scene","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}],"widgets.mixedContent.item._resources.primaryScene.url":[{"value":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw550i","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}],"widgets.mixedContent.item._resources.base":[{"value":[{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"}],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.tpl.row":[{"value":"sitepage_home_lastAdded_video","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.container":[{"value":"#last_added","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.count":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"@root[inactiveClient=1] ~.SitePage_Home","_fox_":1}]},"@root[inactiveClient=1] ~.SitePage_Videos":{"-widgets.contentScenes":[{"value":1,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widget":[{"value":"GridStub","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.container":[{"value":"#last_added_videos","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.template":[{"value":"sitepage_videos_lastAddedVideos_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.item.title":[{"value":"My Scene","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.item._resources.primary.url":[{"value":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw550i","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.item._resources.base":[{"value":[{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw170i"}],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.list.tpl.row":[{"value":"sitepage_videos_lastAddedVideos","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.list.container":[{"value":"#last_added","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.list.count":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"@root[inactiveClient=1] ~.SitePage_Videos","_fox_":1}]},"@root[inactiveClient=1] ~.SitePage_Photosets":{"-widgets.photoSets":[{"value":1,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107045},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widget":[{"value":"GridStub","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107047},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.container":[{"value":"#mixed_content","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107048},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.template":[{"value":"sitepage_photoSets_photoSet_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107049},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.item.title":[{"value":"My Photoset","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107051},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.item._resources.primary.url":[{"value":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fw376i","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107052},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.item._resources.base":[{"value":[{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"},{"url":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_photo.jpg\u002Fh183i"}],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107066},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.list.tpl.row":[{"value":"sitepage_photoSets_photoSet_simple","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107068},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.list.container":[{"value":"#last_added","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107069},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.list.count":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107070},"path":"@root[inactiveClient=1] ~.SitePage_Photosets","_fox_":1}]},"@root[inactiveClient=1] ~.SitePage_Liveshow":{"-widgets.liveShowViewer":[{"value":1,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107072},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.liveShowViewer.widget":[{"value":"Widget","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107074},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.liveShowViewer.template":[{"value":"liveshowBanner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107075},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.liveShowViewer.embed.container":[{"value":"#liveshow-banner-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107076},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.liveShowViewer.autoRender":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107077},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.liveShowViewer.templateOptions.success.status":[{"value":"no_liveshow","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107078},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.widget":[{"value":"GridStub","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107080},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.embed.container":[{"value":"#recorded-liveshows","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107081},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.template":[{"value":"sitepage_liveshow_recorded_liveshows_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107082},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.item.title":[{"value":"My Live Show","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107084},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.item._resources.primary.url":[{"value":"$env[design.url]\u002Fimages\u002Finactive\u002Fph_video.jpg\u002Fw293i","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107085},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.list.tpl.row":[{"value":"sitepage_liveshow_recorded_liveshows_row","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107087},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.list.embed.container":[{"value":"#list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107088},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.list.count":[{"value":6,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107090},"path":"@root[inactiveClient=1] ~.SitePage_Liveshow","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_404":{"hooks.onStartRendering":[{"value":function () {
var txtLogo = fox.objectGet(fox.dictionary, 'phrases.logoText.default');
if (txtLogo) {
var length = fox.trim(txtLogo.replace(new RegExp('&nbsp;', "g"), String.fromCharCode(160))).length;
if (length > 20) {
this.setTemplateOptions({
showDefaultMobileLogo: true
})
}
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.Layout_404","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_FreeHostedGallery":{"template":[{"value":"Layout_Home","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107002},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"pageContainer":[{"value":"#container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"templateOptions.hideLeftBack":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"templateOptions.hideRightBack":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"templateOptions.hideMainMenu":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.slider.widget":[{"value":"HeaderSwipeSlider","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.slider.container":[{"value":".header-slider-wrapper","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.slider.imagesPaths":[{"value":function () {
var names = [
'header.png',
'slide-image-2.jpg',
'slide-image-3.jpg',
'slide-image-4.jpg'
];
if (fox._isNewfe) {
return names.map(function (name) {
return __webpack_require__(75)("./" + name);
});
}
return names.map(function (name) {
return [fox.getEnv('design.url'), 'images', name].join('/');
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.footer.widget":[{"value":"Site_Footer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"~.Layout_FreeHostedGallery","_fox_":1}],"widgets.footer.container":[{"value":".footer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.Layout_FreeHostedGallery","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(947);
var dir = previousRequest.replace("_banner-cam.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "_banner-cam.png",
	name: "_banner-cam",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/_banner-cam.png", __webpack_require__.p + "images/_banner-cam.png");

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(949);
var dir = previousRequest.replace("_tips-img.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "_tips-img.jpg",
	name: "_tips-img",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/_tips-img.jpg", __webpack_require__.p + "images/_tips-img.jpg");

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(951);
var dir = previousRequest.replace("ad-favorites.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "ad-favorites.png",
	name: "ad-favorites",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/ad-favorites.png", __webpack_require__.p + "images/ad-favorites.png");

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(953);
var dir = previousRequest.replace("ad-favorites_hover.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "ad-favorites_hover.png",
	name: "ad-favorites_hover",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/ad-favorites_hover.png", __webpack_require__.p + "images/ad-favorites_hover.png");

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(955);
var dir = previousRequest.replace("ad_next.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "ad_next.png",
	name: "ad_next",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/ad_next.png", __webpack_require__.p + "images/ad_next.png");

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(957);
var dir = previousRequest.replace("ad_prev.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "ad_prev.png",
	name: "ad_prev",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/ad_prev.png", __webpack_require__.p + "images/ad_prev.png");

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(959);
var dir = previousRequest.replace("ad_scroll_back.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "ad_scroll_back.png",
	name: "ad_scroll_back",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/ad_scroll_back.png", __webpack_require__.p + "images/ad_scroll_back.png");

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(961);
var dir = previousRequest.replace("ad_scroll_forward.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "ad_scroll_forward.png",
	name: "ad_scroll_forward",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/ad_scroll_forward.png", __webpack_require__.p + "images/ad_scroll_forward.png");

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(963);
var dir = previousRequest.replace("address_info_000000.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "address_info_000000.png",
	name: "address_info_000000",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/address_info_000000.png", __webpack_require__.p + "images/address_info_000000.png");

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/ajax-loader.gif", __webpack_require__.p + "images/ajax-loader.gif");

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/avatar.gif", __webpack_require__.p + "images/avatar.gif");

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(967);
var dir = previousRequest.replace("avatar.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "avatar.jpg",
	name: "avatar",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/avatar.jpg", __webpack_require__.p + "images/avatar.jpg");

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(969);
var dir = previousRequest.replace("join-left.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "join-left.jpg",
	name: "join-left",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/background/join-left.jpg", __webpack_require__.p + "images/background/join-left.jpg");

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(971);
var dir = previousRequest.replace("join-right.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "join-right.jpg",
	name: "join-right",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/background/join-right.jpg", __webpack_require__.p + "images/background/join-right.jpg");

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(973);
var dir = previousRequest.replace("banner-cam-shadow.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "banner-cam-shadow.png",
	name: "banner-cam-shadow",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/banner-cam-shadow.png", __webpack_require__.p + "images/banner-cam-shadow.png");

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(975);
var dir = previousRequest.replace("bg-img-2.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "bg-img-2.jpg",
	name: "bg-img-2",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg-img-2.jpg", __webpack_require__.p + "images/bg-img-2.jpg");

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(977);
var dir = previousRequest.replace("arrow_view.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "arrow_view.png",
	name: "arrow_view",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/arrow_view.png", __webpack_require__.p + "images/bg/arrow_view.png");

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(979);
var dir = previousRequest.replace("bg_body.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "bg_body.jpg",
	name: "bg_body",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/bg_body.jpg", __webpack_require__.p + "images/bg/bg_body.jpg");

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(981);
var dir = previousRequest.replace("bg_body_1024.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "bg_body_1024.jpg",
	name: "bg_body_1024",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/bg_body_1024.jpg", __webpack_require__.p + "images/bg/bg_body_1024.jpg");

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(983);
var dir = previousRequest.replace("bg_enter_no.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "bg_enter_no.png",
	name: "bg_enter_no",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/bg_enter_no.png", __webpack_require__.p + "images/bg/bg_enter_no.png");

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(985);
var dir = previousRequest.replace("bg_menu.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "bg_menu.jpg",
	name: "bg_menu",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/bg_menu.jpg", __webpack_require__.p + "images/bg/bg_menu.jpg");

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(987);
var dir = previousRequest.replace("bg_menu.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "bg_menu.png",
	name: "bg_menu",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/bg_menu.png", __webpack_require__.p + "images/bg/bg_menu.png");

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(989);
var dir = previousRequest.replace("bg_title_block.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "bg_title_block.png",
	name: "bg_title_block",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/bg_title_block.png", __webpack_require__.p + "images/bg/bg_title_block.png");

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(991);
var dir = previousRequest.replace("bi-join-banner.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "bi-join-banner.jpg",
	name: "bi-join-banner",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/bi-join-banner.jpg", __webpack_require__.p + "images/bg/bi-join-banner.jpg");

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/btn_blue.gif", __webpack_require__.p + "images/bg/btn_blue.gif");

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(994);
var dir = previousRequest.replace("btn_blue.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "btn_blue.png",
	name: "btn_blue",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/btn_blue.png", __webpack_require__.p + "images/bg/btn_blue.png");

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/btn_pink.gif", __webpack_require__.p + "images/bg/btn_pink.gif");

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(997);
var dir = previousRequest.replace("btn_yellow.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "btn_yellow.png",
	name: "btn_yellow",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/btn_yellow.png", __webpack_require__.p + "images/bg/btn_yellow.png");

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(999);
var dir = previousRequest.replace("head_text_bg.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "head_text_bg.png",
	name: "head_text_bg",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/head_text_bg.png", __webpack_require__.p + "images/bg/head_text_bg.png");

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1001);
var dir = previousRequest.replace("play.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "play.png",
	name: "play",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/play.png", __webpack_require__.p + "images/bg/play.png");

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1003);
var dir = previousRequest.replace("style_list_menu.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "style_list_menu.png",
	name: "style_list_menu",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/style_list_menu.png", __webpack_require__.p + "images/bg/style_list_menu.png");

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg_player.gif", __webpack_require__.p + "images/bg_player.gif");

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1006);
var dir = previousRequest.replace("bg_player.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "bg_player.png",
	name: "bg_player",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg_player.png", __webpack_require__.p + "images/bg_player.png");

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/blank.gif", __webpack_require__.p + "images/blank.gif");

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1009);
var dir = previousRequest.replace("btn_continue.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "btn_continue.png",
	name: "btn_continue",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/btn_continue.png", __webpack_require__.p + "images/btn_continue.png");

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1011);
var dir = previousRequest.replace("btn_continue_wb.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "btn_continue_wb.png",
	name: "btn_continue_wb",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/btn_continue_wb.png", __webpack_require__.p + "images/btn_continue_wb.png");

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1013);
var dir = previousRequest.replace("btn_join.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "btn_join.png",
	name: "btn_join",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/btn_join.png", __webpack_require__.p + "images/btn_join.png");

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1015);
var dir = previousRequest.replace("btn_join_wb.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "btn_join_wb.png",
	name: "btn_join_wb",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/btn_join_wb.png", __webpack_require__.p + "images/btn_join_wb.png");

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1017);
var dir = previousRequest.replace("captcha.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "captcha.png",
	name: "captcha",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/captcha.png", __webpack_require__.p + "images/captcha.png");

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/clean-thumb-tall.gif", __webpack_require__.p + "images/clean-thumb-tall.gif");

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/clean-thumb-wide.gif", __webpack_require__.p + "images/clean-thumb-wide.gif");

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1021);
var dir = previousRequest.replace("close.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "close.png",
	name: "close",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/close.png", __webpack_require__.p + "images/close.png");

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/comments.gif", __webpack_require__.p + "images/comments.gif");

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1024);
var dir = previousRequest.replace("dislike.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "dislike.png",
	name: "dislike",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/dislike.png", __webpack_require__.p + "images/dislike.png");

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/download.gif", __webpack_require__.p + "images/download.gif");

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1027);
var dir = previousRequest.replace("fancybox.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "fancybox.png",
	name: "fancybox",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/fancybox.png", __webpack_require__.p + "images/fancybox.png");

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/favorite.gif", __webpack_require__.p + "images/favorite.gif");

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1030);
var dir = previousRequest.replace("favorites-hover.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "favorites-hover.png",
	name: "favorites-hover",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/favorites-hover.png", __webpack_require__.p + "images/favorites-hover.png");

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1032);
var dir = previousRequest.replace("favorites.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "favorites.png",
	name: "favorites",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/favorites.png", __webpack_require__.p + "images/favorites.png");

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/fs_off.gif", __webpack_require__.p + "images/fs_off.gif");

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/fs_on.gif", __webpack_require__.p + "images/fs_on.gif");

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1036);
var dir = previousRequest.replace("fullscr.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "fullscr.png",
	name: "fullscr",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/fullscr.png", __webpack_require__.p + "images/fullscr.png");

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1038);
var dir = previousRequest.replace("h1360i.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "h1360i.jpg",
	name: "h1360i",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/h1360i.jpg", __webpack_require__.p + "images/h1360i.jpg");

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1040);
var dir = previousRequest.replace("hd.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "hd.png",
	name: "hd",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/hd.png", __webpack_require__.p + "images/hd.png");

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/header-placeholder.png", __webpack_require__.p + "images/header-placeholder.png");

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1043);
var dir = previousRequest.replace("home-hover.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "home-hover.png",
	name: "home-hover",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/home-hover.png", __webpack_require__.p + "images/home-hover.png");

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1045);
var dir = previousRequest.replace("home.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "home.png",
	name: "home",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/home.png", __webpack_require__.p + "images/home.png");

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1047);
var dir = previousRequest.replace("ico-bl.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "ico-bl.png",
	name: "ico-bl",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/ico-bl.png", __webpack_require__.p + "images/ico-bl.png");

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1049);
var dir = previousRequest.replace("chbox.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "chbox.png",
	name: "chbox",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/join/chbox.png", __webpack_require__.p + "images/join/chbox.png");

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1051);
var dir = previousRequest.replace("li_style.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "li_style.png",
	name: "li_style",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/join/li_style.png", __webpack_require__.p + "images/join/li_style.png");

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1053);
var dir = previousRequest.replace("promotion_bg.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "promotion_bg.png",
	name: "promotion_bg",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/join/promotion_bg.png", __webpack_require__.p + "images/join/promotion_bg.png");

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1055);
var dir = previousRequest.replace("radio.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "radio.png",
	name: "radio",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/join/radio.png", __webpack_require__.p + "images/join/radio.png");

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/like.gif", __webpack_require__.p + "images/like.gif");

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1058);
var dir = previousRequest.replace("like.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "like.png",
	name: "like",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/like.png", __webpack_require__.p + "images/like.png");

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1060);
var dir = previousRequest.replace("lock.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "lock.png",
	name: "lock",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/lock.png", __webpack_require__.p + "images/lock.png");

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1062);
var dir = previousRequest.replace("logo.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "logo.png",
	name: "logo",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/logo.png", __webpack_require__.p + "images/logo.png");

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1064);
var dir = previousRequest.replace("logout-hover.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "logout-hover.png",
	name: "logout-hover",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/logout-hover.png", __webpack_require__.p + "images/logout-hover.png");

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1066);
var dir = previousRequest.replace("logout.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "logout.png",
	name: "logout",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/logout.png", __webpack_require__.p + "images/logout.png");

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1068);
var dir = previousRequest.replace("messages-hover.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "messages-hover.png",
	name: "messages-hover",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/messages-hover.png", __webpack_require__.p + "images/messages-hover.png");

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1070);
var dir = previousRequest.replace("messages.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "messages.png",
	name: "messages",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/messages.png", __webpack_require__.p + "images/messages.png");

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1072);
var dir = previousRequest.replace("mobile.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "mobile.png",
	name: "mobile",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/mobile.png", __webpack_require__.p + "images/mobile.png");

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1074);
var dir = previousRequest.replace("opa75.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "opa75.png",
	name: "opa75",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/opa75.png", __webpack_require__.p + "images/opa75.png");

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1076);
var dir = previousRequest.replace("pc.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "pc.png",
	name: "pc",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pc.png", __webpack_require__.p + "images/pc.png");

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pictures.gif", __webpack_require__.p + "images/pictures.gif");

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/preloader.gif", __webpack_require__.p + "images/preloader.gif");

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1080);
var dir = previousRequest.replace("preloader.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "preloader.png",
	name: "preloader",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/preloader.png", __webpack_require__.p + "images/preloader.png");

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1082);
var dir = previousRequest.replace("refresh_icon.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "refresh_icon.png",
	name: "refresh_icon",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/refresh_icon.png", __webpack_require__.p + "images/refresh_icon.png");

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/relate_bad.gif", __webpack_require__.p + "images/relate_bad.gif");

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/relate_good.gif", __webpack_require__.p + "images/relate_good.gif");

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1086);
var dir = previousRequest.replace("sd.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "sd.png",
	name: "sd",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/sd.png", __webpack_require__.p + "images/sd.png");

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1088);
var dir = previousRequest.replace("search-hover.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "search-hover.png",
	name: "search-hover",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/search-hover.png", __webpack_require__.p + "images/search-hover.png");

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1090);
var dir = previousRequest.replace("search.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "search.png",
	name: "search",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/search.png", __webpack_require__.p + "images/search.png");

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1092);
var dir = previousRequest.replace("settings-hover.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "settings-hover.png",
	name: "settings-hover",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/settings-hover.png", __webpack_require__.p + "images/settings-hover.png");

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1094);
var dir = previousRequest.replace("settings.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "settings.png",
	name: "settings",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/settings.png", __webpack_require__.p + "images/settings.png");

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1096);
var dir = previousRequest.replace("slider_open.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "slider_open.png",
	name: "slider_open",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/slider_open.png", __webpack_require__.p + "images/slider_open.png");

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1098);
var dir = previousRequest.replace("slideshow_blue.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "slideshow_blue.png",
	name: "slideshow_blue",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/slideshow_blue.png", __webpack_require__.p + "images/slideshow_blue.png");

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1100);
var dir = previousRequest.replace("slideshow_gray.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "slideshow_gray.png",
	name: "slideshow_gray",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/slideshow_gray.png", __webpack_require__.p + "images/slideshow_gray.png");

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1102);
var dir = previousRequest.replace("slideshow_start.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "slideshow_start.png",
	name: "slideshow_start",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/slideshow_start.png", __webpack_require__.p + "images/slideshow_start.png");

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1104);
var dir = previousRequest.replace("slideshow_stop.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "slideshow_stop.png",
	name: "slideshow_stop",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/slideshow_stop.png", __webpack_require__.p + "images/slideshow_stop.png");

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1106);
var dir = previousRequest.replace("small-logo.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "small-logo.png",
	name: "small-logo",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/small-logo.png", __webpack_require__.p + "images/small-logo.png");

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1108);
var dir = previousRequest.replace("social1.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "social1.png",
	name: "social1",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social1.png", __webpack_require__.p + "images/social1.png");

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1110);
var dir = previousRequest.replace("social2.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "social2.png",
	name: "social2",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social2.png", __webpack_require__.p + "images/social2.png");

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1112);
var dir = previousRequest.replace("social3.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "social3.png",
	name: "social3",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/social3.png", __webpack_require__.p + "images/social3.png");

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1114);
var dir = previousRequest.replace("sprite-2.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "sprite-2.png",
	name: "sprite-2",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/sprite-2.png", __webpack_require__.p + "images/sprite-2.png");

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1116);
var dir = previousRequest.replace("sprite.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "sprite.png",
	name: "sprite",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/sprite.png", __webpack_require__.p + "images/sprite.png");

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/tips-img.jpg", __webpack_require__.p + "images/tips-img.jpg");

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/trans.gif", __webpack_require__.p + "images/trans.gif");

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1120);
var dir = previousRequest.replace("twistys.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "twistys.png",
	name: "twistys",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/twistys.png", __webpack_require__.p + "images/twistys.png");

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/unlike.gif", __webpack_require__.p + "images/unlike.gif");

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/views_eye.gif", __webpack_require__.p + "images/views_eye.gif");

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1124);
var dir = previousRequest.replace("welcome-img.jpg", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "welcome-img.jpg",
	name: "welcome-img",
	ext: ".jpg",
	query: ""
}, previousRequest);

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/welcome-img.jpg", __webpack_require__.p + "images/welcome-img.jpg");

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

// image-processing-loader
var previousRequest = __webpack_require__(1126);
var dir = previousRequest.replace("welcome.png", "")
module.exports = __webpack_require__(0)({
	dir: dir,
	base: "welcome.png",
	name: "welcome",
	ext: ".png",
	query: ""
}, previousRequest);

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/welcome.png", __webpack_require__.p + "images/welcome.png");

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_Home":{"pageContainer":[{"value":"#container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107002},"path":"~.Layout_Home","_fox_":1}],"widgets.notification.widget":[{"value":"NotificationViewer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"~.Layout_Home","_fox_":1}],"widgets.pushNotification.widget":[{"value":"PushNotifications","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.Layout_Home","_fox_":1}],"widgets.slider.widget":[{"value":"HeaderSwipeSlider","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"~.Layout_Home","_fox_":1}],"widgets.slider.container":[{"value":".header-slider-wrapper","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.Layout_Home","_fox_":1}],"widgets.slider.imagesPaths":[{"value":function () {
var names = [
'header.png',
'slide-image-2.jpg',
'slide-image-3.jpg',
'slide-image-4.jpg'
];
if (fox._isNewfe) {
return names.map(function (name) {
return __webpack_require__(75)("./" + name);
});
}
return names.map(function (name) {
return [fox.getEnv('design.url'), 'images', name].join('/');
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107060},"path":"~.Layout_Home","_fox_":1}],"handleWom.messageReceived.widget":[{"value":"@root","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107123},"path":"~.Layout_Home","_fox_":1}],"handleWom.messageReceived.event":[{"value":"newChatMessageReceived","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107124},"path":"~.Layout_Home","_fox_":1}],"handleWom.messageReceived.callback":[{"value":function (conversation) {
var num = fox.dom.selectFirst('#messages-link .num', this.element);
if (num) {
conversation.resp.totalCount ? num.innerHTML = conversation.resp.totalCount :  num.innerHTML = '';
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107130},"path":"~.Layout_Home","_fox_":1}],"handleDom.toggleMenu.target":[{"value":".mobile-menu-icon","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107133},"path":"~.Layout_Home","_fox_":1}],"handleDom.toggleMenu.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107134},"path":"~.Layout_Home","_fox_":1}],"handleDom.toggleMenu.callback":[{"value":function (el) {
var el = fox.dom.wrap(el);
var wrapper = el.up(3);
if (el.hasClass('opened')) {
el.removeClass('opened');
wrapper.removeClass('menu-opened');
return;
};
el.addClass('opened');
wrapper.addClass('menu-opened');
fox.wom.selectFirst('~.ValentinesGiftsPopup').hide()
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107146},"path":"~.Layout_Home","_fox_":1}],"handleDom.closeMenu.target":[{"value":".layout-overlay","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107148},"path":"~.Layout_Home","_fox_":1}],"handleDom.closeMenu.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107149},"path":"~.Layout_Home","_fox_":1}],"handleDom.closeMenu.callback":[{"value":function (el) {
var el = fox.dom.wrap(this.dom1('.mobile-menu-icon'));
var wrapper = el.up(3);
el.removeClass('opened');
wrapper.removeClass('menu-opened');
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107155},"path":"~.Layout_Home","_fox_":1}],"handleDom.closeMenu2.targetWidget":[{"value":".Menu_Main","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107157},"path":"~.Layout_Home","_fox_":1}],"handleDom.closeMenu2.target":[{"value":".main-menu .link","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107158},"path":"~.Layout_Home","_fox_":1}],"handleDom.closeMenu2.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107159},"path":"~.Layout_Home","_fox_":1}],"handleDom.closeMenu2.callback":[{"value":function (el, alias, w, e) {
e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
var el = fox.dom.wrap(this.dom1('.mobile-menu-icon'));
var wrapper = el.up(3);
el.removeClass('opened');
wrapper.removeClass('menu-opened');
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107167},"path":"~.Layout_Home","_fox_":1}],"handleDom.preventbubbling.target":[{"value":".logo-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107169},"path":"~.Layout_Home","_fox_":1}],"handleDom.preventbubbling.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107170},"path":"~.Layout_Home","_fox_":1}],"handleDom.preventbubbling.callback":[{"value":function (el, alias, w, e) {
e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107173},"path":"~.Layout_Home","_fox_":1}],"hooks.onStartRendering":[{"value":function () {
var txtLogo = fox.objectGet(fox.dictionary, 'phrases.logoText.default');
if (txtLogo) {
var length = fox.trim(txtLogo.replace(new RegExp('&nbsp;', "g"), String.fromCharCode(160))).length;
this.setTemplateOptions({
showDefaultMobileLogo: !!length
})
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107183},"path":"~.Layout_Home","_fox_":1}]},"~.Layout_Home .Menu_Main":{"pattern.home.template":[{"value":"main_menu_item_home","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.about.template":[{"value":"main_menu_item_about","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.activity.template":[{"value":"main_menu_item_activity","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.videos.template":[{"value":"main_menu_item_videos","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.photos.template":[{"value":"main_menu_item_photos","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.liveshowChecker.template":[{"value":"main_menu_item_liveshowChecker","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.tipsChecker.template":[{"value":"main_menu_item_tipsChecker","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.blogChecker.template":[{"value":"main_menu_item_blogChecker","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.callme.template":[{"value":"main_menu_item_callme","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.skypeMe.template":[{"value":"main_menu_item_skypeMe","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.wishList.template":[{"value":"main_menu_item_wishList","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"pattern.snapMe.template":[{"value":"main_menu_item_snapMe","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"handleDom.switchUserActionMenu.target":[{"value":".action.logged .user","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"handleDom.switchUserActionMenu.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"~.Layout_Home .Menu_Main","_fox_":1}],"handleDom.switchUserActionMenu.callback":[{"value":function(elem) {
if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch) || $(window).outerWidth() < 768) {
$(elem).toggleClass('open');
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107036},"path":"~.Layout_Home .Menu_Main","_fox_":1}]},"~.Layout_Home .Menu_Main #mainMenuContainer":{"handleDom.closeMenu.target":[{"value":".main-menu .link","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"~.Layout_Home .Menu_Main #mainMenuContainer","_fox_":1}],"handleDom.closeMenu.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"~.Layout_Home .Menu_Main #mainMenuContainer","_fox_":1}],"handleDom.closeMenu.callback":[{"value":function () {
if (!!fox.dom.selectFirst('.menu-opened')) {
fox.dom.selectFirst('.mobile-menu-icon').classList.remove('opened');
fox.dom.selectFirst('.menu-opened').classList.remove('menu-opened');
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"~.Layout_Home .Menu_Main #mainMenuContainer","_fox_":1}]},"~.Layout_Home #notification":{"hooks.onDeleteItem":[{"value":function (id) {
var item = fox.dom.selectFirst('input[value="'+ id +'"]', this.element).parentNode;
if (item) {
fox.dom.addClass('deleted', item);
window.setTimeout(function () {
item.remove()
}, 500)
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107072},"path":"~.Layout_Home #notification","_fox_":1}]},"~.Layout_Home #notification .Grid #list":{"hooks.onAddedToDom":[{"value":function () {
var items = $('#notificationList .notify');
var current = items.length-1;
var interval;
if (!items.length) {
return;
}
interval = window.setInterval(function () {
if (current >= 0) {
var el = items.eq(current);
el.addClass('appearence');
window.setTimeout(function () {
el.removeClass('appearence').addClass('default');
}, 500)
current--;
} else {
interval ? window.clearInterval(interval) : '';
}
}, 300);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107098},"path":"~.Layout_Home #notification .Grid #list","_fox_":1}]},"~.Layout_Home ~.Site_Footer":{"container":[{"value":".footer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107100},"path":"~.Layout_Home ~.Site_Footer","_fox_":1}]},"~.Layout_Home ~.Site_Footer #rabbitsReviewsBanner":{"hooks.onAddedToDom":[{"value":function (argument) {
$('.static-wrapper').addClass('with-thirdparty-banners')
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107104},"path":"~.Layout_Home ~.Site_Footer #rabbitsReviewsBanner","_fox_":1}]},"~.Layout_Home ~.Site_Footer #copyright":{"handleDom.reportProblem.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107119},"path":"~.Layout_Home ~.Site_Footer #copyright","_fox_":1}],"handleDom.reportProblem.target":[{"value":"#_reportProblem","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107119},"path":"~.Layout_Home ~.Site_Footer #copyright","_fox_":1}],"handleDom.reportProblem.callback":[{"value":"@parent:reportProblem","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107119},"path":"~.Layout_Home ~.Site_Footer #copyright","_fox_":1}],"handleDom.reportSite.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107119},"path":"~.Layout_Home ~.Site_Footer #copyright","_fox_":1}],"handleDom.reportSite.target":[{"value":"#_sesta","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107119},"path":"~.Layout_Home ~.Site_Footer #copyright","_fox_":1}],"handleDom.reportSite.callback":[{"value":function () {
this.rwom1('@root .SestaFosta_Popup').show()
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107119},"path":"~.Layout_Home ~.Site_Footer #copyright","_fox_":1}]},"~.Layout_Home ~#mixedContent #list":{"hooks.onRendering":[{"value":function () {
var render = __webpack_require__(38)(fox);
var args = fox.clone(arguments);
args[0] = {
1: 'liveshow',
2: 'blog',
3: 'message',
4: 'trip',
5: 'custom',
6: 'photoset',
7: 'scene'
};
if (fox._isNewfe) {
return render.apply(this, args);
}
var contentRow = args[0];
var wide = $(window).width() > 600;
var leftCol = document.createElement('div');
var rightCol = document.createElement('div');
this.fragment = this.createFragment();
while (obj = this.dl.iterateObject('mix')) {
var contentType = obj.get('type');
var rowTpl = this.getOption('tpl.' + contentRow[contentType]);
var row = fox.Zen(rowTpl, [obj]);
if (wide) {
obj._pointer%2 == 0 ? leftCol.appendChild(row) : rightCol.appendChild(row);
} else {
this.fragment.appendChild(row);
}
};
if (wide) {
this.fragment.appendChild(leftCol);
this.fragment.appendChild(rightCol);
return true;
}
return true;
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107223},"path":"~.Layout_Home ~#mixedContent #list","_fox_":1}]},"~.Layout_Home ~.Content_Favorites #list":{"hooks.onRendering":[{"value":function () {
var render = __webpack_require__(38)(fox);
return fox._isNewfe ?
render.apply(this, arguments) :
window.__tmpOldListRender.apply(this, arguments);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107230},"path":"~.Layout_Home ~.Content_Favorites #list","_fox_":1}]},"~.Layout_Home ~.BlogViewer #list":{"hooks.onRendering":[{"value":function () {
var render = __webpack_require__(38)(fox);
return fox._isNewfe ?
render.apply(this, arguments) :
window.__tmpOldListRender.apply(this, arguments);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107237},"path":"~.Layout_Home ~.BlogViewer #list","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.LiveshowCounterBanner":{"template":[{"value":"liveShowCounter","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107002},"path":"~.LiveshowCounterBanner","_fox_":1}],"embed.container":[{"value":"#liveshow-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.LiveshowCounterBanner","_fox_":1}],"widgets.timer.embed.container":[{"value":".show-start-time","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.LiveshowCounterBanner","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"mapGuest.pages.join":[{"value":"join","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"@root","_fox_":1}],"mapGuest.pages.404":[{"value":"404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"@root","_fox_":1}],"mapGuest.routes.@miss":[{"value":"#404 #404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"@root","_fox_":1}],"mapGuest.widgets.join.widget":[{"value":"Layout_Join","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"@root","_fox_":1}],"mapGuest.widgets.join.group":[{"value":"pages","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"@root","_fox_":1}],"mapGuest.widgets.join.active":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"@root","_fox_":1}],"mapGuest.widgets.join.widgets.join.widget":[{"value":"SitePage_Join","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"@root","_fox_":1}],"mapGuest.widgets.join.widgets.join.group":[{"value":"pages","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"@root","_fox_":1}],"mapGuest.widgets.join.widgets.join.active":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107017},"path":"@root","_fox_":1}],"mapGuest.widgets.join.widgets.join.title":[{"value":"Join Now!","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"@root","_fox_":1}],"mapGuest.widgets.join.widgets.join.access":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"@root","_fox_":1}],"mapGuest.widgets.404.widget":[{"value":"Layout_404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"@root","_fox_":1}],"mapGuest.widgets.404.group":[{"value":"pages","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"@root","_fox_":1}],"mapGuest.widgets.404.active":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107023},"path":"@root","_fox_":1}],"mapGuest.widgets.404.widgets.404.widget":[{"value":"SitePage_404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"@root","_fox_":1}],"mapGuest.widgets.404.widgets.404.group":[{"value":"pages","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"@root","_fox_":1}],"mapGuest.widgets.404.widgets.404.active":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"@root","_fox_":1}],"mapGuest.widgets.404.widgets.404.title":[{"value":"404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107029},"path":"@root","_fox_":1}],"mapGuest.widgets.404.widgets.404.access":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"@root","_fox_":1}],"mapGuest.widgets.home.widgets.activity.widgets.activityViewer.widget":[{"value":"Activity_EventCalendarViewerNew","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107036},"path":"@root","_fox_":1}],"mapGuest.routes.join.action":[{"value":"#join #join","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"@root","_fox_":1}],"mapGuest.routes.join.checker":[{"value":function () {
if (fox.getEnv('siteProps.ubs.joinUrl').match('http://')) {
return '>' + fox.getEnv('siteProps.ubs.joinUrl');
} else {
return false;
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107046},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{".PermissionManager":{"permissions.guest.map.free.routes.upgrade.action":[{"value":"#join #join","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":".PermissionManager","_fox_":1}],"permissions.guest.map.free.routes.upgrade.checker":[{"value":function () {
if (fox.getEnv('site.state') === 4) {
return '>>'
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":".PermissionManager","_fox_":1}]},"@root":{"mapMember.pages.404":[{"value":"404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107017},"path":"@root","_fox_":1}],"mapMember.routes.@miss":[{"value":"#404 #404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"@root","_fox_":1}],"mapMember.widgets.join.widget":[{"value":"Layout_Join","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107023},"path":"@root","_fox_":1}],"mapMember.widgets.join.group":[{"value":"pages","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"@root","_fox_":1}],"mapMember.widgets.join.active":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"@root","_fox_":1}],"mapMember.widgets.join.widgets.join.widget":[{"value":"SitePage_Join","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"@root","_fox_":1}],"mapMember.widgets.join.widgets.join.group":[{"value":"pages","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107029},"path":"@root","_fox_":1}],"mapMember.widgets.join.widgets.join.active":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"@root","_fox_":1}],"mapMember.widgets.join.widgets.join.title":[{"value":"Join Now!","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"@root","_fox_":1}],"mapMember.widgets.join.widgets.join.access":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107032},"path":"@root","_fox_":1}],"mapMember.widgets.404.widget":[{"value":"Layout_404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"@root","_fox_":1}],"mapMember.widgets.404.group":[{"value":"pages","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107035},"path":"@root","_fox_":1}],"mapMember.widgets.404.active":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107036},"path":"@root","_fox_":1}],"mapMember.widgets.404.widgets.404.widget":[{"value":"SitePage_404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"@root","_fox_":1}],"mapMember.widgets.404.widgets.404.group":[{"value":"pages","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":"@root","_fox_":1}],"mapMember.widgets.404.widgets.404.active":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"@root","_fox_":1}],"mapMember.widgets.404.widgets.404.title":[{"value":"404","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"@root","_fox_":1}],"mapMember.widgets.404.widgets.404.access":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"@root","_fox_":1}],"mapMember.widgets.home.widgets.activity.widgets.activityViewer.widget":[{"value":"Activity_EventCalendarViewerNew","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107050},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.NewsLetterSubscriber .Dialog":{"dialog.dialogClass":[{"value":"dark-overlay mc-site-common-popup mc-site-popup-bg","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.NewsLetterSubscriber .Dialog","_fox_":1}],"dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.NewsLetterSubscriber .Dialog","_fox_":1}]},"~.NewsLetterSubscriber":{"handleWom.notValidForm.event":[{"value":"formNotValid","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.NewsLetterSubscriber","_fox_":1}],"handleWom.notValidForm.widget":[{"value":"#form #validator","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.NewsLetterSubscriber","_fox_":1}],"handleWom.notValidForm.callback":[{"value":function (data) {
fox.each(data.errorStack, function (v, field) {
var $el = $(this.dom1('[name="' + field + '"]'));
if ($el.length) {
$el.next().text(v[0].message);
}
}, this);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.NewsLetterSubscriber","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_About":{"widgets.aboutMe.widget":[{"value":"AboutMe","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_About","_fox_":1}],"widgets.aboutMe.container":[{"value":".about-me","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.SitePage_About","_fox_":1}],"widgets.aboutMe.hooks.onAddedToDom":[{"value":function () {
if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
return;
}
$('.nice-scroll').mCustomScrollbar({
theme: 'minimal'
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.SitePage_About","_fox_":1}],"widgets.aboutMe.handleDom.showMore.target":[{"value":".show-more","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.SitePage_About","_fox_":1}],"widgets.aboutMe.handleDom.showMore.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107017},"path":"~.SitePage_About","_fox_":1}],"widgets.aboutMe.handleDom.showMore.callback":[{"value":function (el) {
el.style.display = 'none';
fox.dom.addClass('show-all', fox.dom.selectFirst('.intro', el.parentNode));
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"~.SitePage_About","_fox_":1}],"widgets.lsCounter.widget":[{"value":"LiveshowCounterBanner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107023},"path":"~.SitePage_About","_fox_":1}],"widgets.lsCounter.embed.container":[{"value":".next-liveshow","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.SitePage_About","_fox_":1}],"widgets.lsCounter.template":[{"value":"liveShowCounter","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~.SitePage_About","_fox_":1}],"widgets.lsCounter.widgets.timer.embed.container":[{"value":".show-start-time","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"~.SitePage_About","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Account":{"widgets.settingsForm.widget":[{"value":"Form","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.formElements.oldPassword.element":[{"value":"[name=password]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.formElements.newPassword.element":[{"value":"[name=newPassword]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.formElements.newPasswordCheck.element":[{"value":"[name=newPasswordCheck]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.submit.target":[{"value":"#settings-form","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.submit.event":[{"value":"submit","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.hooks.onResponse":[{"value":function(response) {
var answer = response.answer.answer;
if (answer.status) {
$('#message').show().text('Your password was successfully changed.');
return;
};
var code = answer.code;
var name = null;
var parent = this.getParent();
switch (code) {
case 1:
name = 'newPassword';
break;
case 2:
name = 'newPasswordCheck';
break;
case 3:
name = 'password';
break;
}
if (!name) {
console.warn('no name for code -> ', code, 'reason -> ', answer.reason)
}
fox.dom.addClass('error', parent.dom1('[name="' + name + '"]').parentNode);
parent.dom1('[error-alias="' + name + '"]').innerHTML = answer.reason;
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107038},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.methods.send":[{"value":"user.changePassword","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"~.SitePage_Account","_fox_":1}],"handleDom.focus.target":[{"value":"input[type=\"password\"]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.SitePage_Account","_fox_":1}],"handleDom.focus.event":[{"value":"focus","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"~.SitePage_Account","_fox_":1}],"handleDom.focus.callback":[{"value":function (el) {
fox.dom.removeClass('error', el.parentNode);
this.dom1('[error-alias="' + el.name + '"]').innerHTML = '';
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107047},"path":"~.SitePage_Account","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Site_Page#activity":{"widgets.joinBanner.widget":[{"value":"AMC_Banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Site_Page#activity","_fox_":1}],"widgets.joinBanner.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.Site_Page#activity","_fox_":1}],"widgets.joinBanner.template":[{"value":"banners_banner_1","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.Site_Page#activity","_fox_":1}]},"~.Activity_EventCalendarViewerNew":{"filter1.embed.container":[{"value":"#filter-container-1","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"filter2.embed.container":[{"value":"#filter-container-2","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"list.embed.container":[{"value":"#eventlist-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"list.onAddedToDom":[{"value":function () {
$(this.element[0]).addClass('fadeIn animated');
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}]},"~.Activity_Event_MainEventNew":{"template":[{"value":"activity_event_card_main","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.Activity_Event_MainEventNew","_fox_":1}],"childContainer":[{"value":"#event-body-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.Activity_Event_MainEventNew","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Blog":{"widgets.preloader.widget":[{"value":"Preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Blog","_fox_":1}],"widgets.preloader.template":[{"value":"big_preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.SitePage_Blog","_fox_":1}],"widgets.preloader.renderOnStop":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Blog","_fox_":1}],"widgets.preloader.container":[{"value":"#last-added","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Blog","_fox_":1}],"widgets.preloader.listen":[{"value":["#photoSets #list"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Blog","_fox_":1}],"widgets.joinBanner.widget":[{"value":"AMC_Banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Blog","_fox_":1}],"widgets.joinBanner.embed.container":[{"value":".join-banner-wrpper","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.SitePage_Blog","_fox_":1}],"widgets.joinBanner.template":[{"value":"banners_banner_4","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.widget":[{"value":"BlogViewer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.template":[{"value":"lastAdded_container_posts","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.widgets.dl.limit":[{"value":6,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.list.tpl.row":[{"value":"blog_post_item","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.list.embed.container":[{"value":"#last-added","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.list.hooks.onAddedToDom":[{"value":function() {
$(window).on('resize', {widget: this}, function (e) {
if ($(window).width() != w) {
w = $(window).width();
if (e.data.widget.timeoutId) {
clearInterval(e.data.widget.timeoutId);
};
e.data.widget.timeoutId = this.window.setTimeout(function () {
e.data.widget.render();
}, 1000)
}
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107035},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.pager.widget":[{"value":"Pager_Simple","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107037},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.pager.embed.widget":[{"value":"@parent @parent","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107038},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.pager.container":[{"value":"#join_continue","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.pager.tpl.container":[{"value":"pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.pager.pagesCount":[{"value":1,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.pager.logged.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.pager.logged.pagesCount":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.pager.noScroll":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.pager.navigatorPrefix":[{"value":"blog_page","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107045},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.widgets.blogSidebar.widget":[{"value":"BlogSidebar","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107047},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.widgets.blogSidebar.latestCommentsRowTemplate":[{"value":"latest_comm_row","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.SitePage_Blog","_fox_":1}],"widgets.blogViewer.widgets.blogSidebar.mostPopularPostRowTemplate":[{"value":"latest_posts_row","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107049},"path":"~.SitePage_Blog","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~#currentRating":{"templateOptions.iconLike":[{"value":"icon-au_like","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~#currentRating","_fox_":1}],"templateOptions.iconDislike":[{"value":"icon-au_dislike","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~#currentRating","_fox_":1}]},"~#downloadButton":{"templateOptions.iconDownload":[{"value":"icon-au_download","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~#downloadButton","_fox_":1}]},"~#downloadLinks":{"activeClass":[{"value":"active","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107010},"path":"~#downloadLinks","_fox_":1}],"activeItems":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":1107011},"path":"~#downloadLinks","_fox_":1}]},"~#tipme ~.Dialog":{"dialog.dialogClass":[{"value":"dark-overlay mc-site-common-popup mc-site-popup-bg content-report-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~#tipme ~.Dialog","_fox_":1}],"dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~#tipme ~.Dialog","_fox_":1}]},"~#tipme #confirmPopup":{"dialog.title":[{"value":"Attention","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107017},"path":"~#tipme #confirmPopup","_fox_":1}]},"~#tipme #successPopup":{"dialog.title":[{"value":"Thank you","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~#tipme #successPopup","_fox_":1}]},"~#tipme #errorPopup":{"dialog.title":[{"value":"Oops, something went wrong","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"~#tipme #errorPopup","_fox_":1}],"dialog.width":[{"value":"420","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~#tipme #errorPopup","_fox_":1}]},"~#favorite":{"templateOptions.iconRemoveFavorite":[{"value":"icon-au_favorites","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~#favorite","_fox_":1}],"templateOptions.iconAddFavorite":[{"value":"icon-au_favorites","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"~#favorite","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Content_Favorites #previewContent":{"template":[{"value":"popup_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.Content_Favorites #previewContent","_fox_":1}],"dialog.dialogClass":[{"value":"preview-content mc-site-common-popup mc-site-popup-bg","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Content_Favorites #previewContent","_fox_":1}],"leftNavArrow":[{"value":"icon-au_popup_left_arw a-left text-color-3","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.Content_Favorites #previewContent","_fox_":1}],"rightNavArrow":[{"value":"icon-au_popup_right_arw a-right text-color-3","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.Content_Favorites #previewContent","_fox_":1}],"handleDom.hide.target":[{"value":".cross.close","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.Content_Favorites #previewContent","_fox_":1}],"handleDom.hide.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.Content_Favorites #previewContent","_fox_":1}],"handleDom.hide.callback":[{"value":"hide","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.Content_Favorites #previewContent","_fox_":1}]},"~.Content_Favorites #previewContent .Widget":{"embed.container":[{"value":".widgetContainer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.Content_Favorites #previewContent .Widget","_fox_":1}]},"~.SitePage_Favorites":{"widgets.favorites.widget":[{"value":"Content_Favorites","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107017},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.container":[{"value":"#favorites","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.template":[{"value":"lastAdded_container_favorites","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.preset":[{"value":"favorites","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.widgets.dl.limit":[{"value":50,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.widgets.dl.metaFields.resources.primary":[{"value":"primary..w550i","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.widgets.dl.metaFields.resources.photoSet":[{"value":"primary..w550i","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.widgets.dl.metaFields.resources.photoSetCount":[{"value":"sources..w550i","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.widgets.dl.metaFields.resources.bigThumb":[{"value":"primary..h1360i","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.widgets.dl.metaFields.socialParams":[{"value":"likes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.container":[{"value":"#last-added","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.tpl.row":[{"value":"sitepage_favorites_row","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleDom.showCross.target":[{"value":".favitem","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleDom.showCross.event":[{"value":"mouseover","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107035},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleDom.showCross.callback":[{"value":function(elt) {
$(elt).find('.remove').show();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107038},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleDom.hideCross.target":[{"value":".favitem","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleDom.hideCross.event":[{"value":"mouseout","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleDom.hideCross.callback":[{"value":function(elt) {
$(elt).find('.remove').hide();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleDom.remove.target":[{"value":".remove","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107046},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleDom.remove.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107047},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleDom.remove.callback":[{"value":"handlerDom:remove","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleWom.imageLoaded.widget":[{"value":"@this","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107051},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleWom.imageLoaded.event":[{"value":"addedToDom","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107052},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handleWom.imageLoaded.callback":[{"value":"handlerDom:initFavorites","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107053},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handlerDom.imageLoaded":[{"value":function() {
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107078},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handlerDom.initFavorites":[{"value":function(elt) {
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107081},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handlerDom.remove":[{"value":function(elt) {
this.favoriteElt = $(elt).parent();
if (elt.id) {
var data = {
'targetId': elt.id
}, subject = $(elt).attr('subject');
if (!fox.isEmpty(subject)) {
data.subject = subject;
};
var api = new fox.Api(null, this._wom).method('social.favorite.save');
this.handleEvent(api, ['success'], 'handlerDom:response');
api.send(data, false);
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107095},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.handlerDom.response":[{"value":function(data) {
if (data.answer.response) {
var response = (function () {
for (var i in this) {
return this[i];
break;
}
}).call(data.answer.response);
if (!response.isFavorite) {
this.rwom1('@parent #dl').load();
}
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107110},"path":"~.SitePage_Favorites","_fox_":1}],"widgets.favorites.list.hooks.onAddedToDom":[{"value":function(obj) {
$(window).on('resize', {widget: this}, function (e) {
if ($(window).width() != w) {
w = $(window).width();
if (e.data.widget.timeoutId) {
clearInterval(e.data.widget.timeoutId);
};
e.data.widget.timeoutId = this.window.setTimeout(function () {
e.data.widget.render();
}, 1000)
}
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107126},"path":"~.SitePage_Favorites","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_Home #gallery":{"widgets.tipme.widget":[{"value":"Content_Tipme","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.tipme.embed.container":[{"value":".tipme-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.tipme.embed.widget":[{"value":"@parent #photoset #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.widget":[{"value":"Content_Report","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.template":[{"value":"content_report","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.additionalPopupClass":[{"value":"mc-site-common-popup mc-site-popup-bg content-report-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.embed.widget":[{"value":"@parent #photoset #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.prefixPopup":[{"value":"gall","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.widgets.reportPopup.dialog.width":[{"value":"525px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.widgets.reportPopup.dialog.buttons":[{"value":[],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107017},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.handleDom.submitReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.handleDom.cancelReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.handleDom.close.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.handleDom.close.target":[{"value":".close","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107023},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.handleDom.close.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.reportContent.handleDom.close.callback":[{"value":"cancelReportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.widget":[{"value":"Content_Photosets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.embed.widget":[{"value":"@parent #photoset #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.embed.container":[{"value":"#last_added_photosets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.template":[{"value":"lastAdded_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107032},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.preset":[{"value":"photosets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107033},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.useGeneratedContentLink":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.widgets.dl.limit":[{"value":2,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107036},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.widgets.dl.transitParameters.v1":[{"value":"pSpOZnHUDD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107038},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.widgets.dl.metaFields.socialParams":[{"value":"likes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.list.tpl.row":[{"value":"item_photoset","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.othersPhotosets.list.container":[{"value":"#last-added-flex","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.backLink.widget":[{"value":"Content_BackLink","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.backLink.dl":[{"value":"@parent #photoset #dl","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107045},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.backLink.container":[{"value":".content-backlink","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107046},"path":"~.Layout_Home #gallery","_fox_":1}],"widgets.backLink.embed.widget":[{"value":"@parent #photoset #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.Layout_Home #gallery","_fox_":1}],"amountInRow":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107049},"path":"~.Layout_Home #gallery","_fox_":1}],"minItemInRow":[{"value":3,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107050},"path":"~.Layout_Home #gallery","_fox_":1}]},"~.Layout_Home #gallery #photoset":{"embed.container":[{"value":"#gallery-block","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107052},"path":"~.Layout_Home #gallery #photoset","_fox_":1}],"widgets.dl.transitParameters.v4":[{"value":"AgZ4mIATPd","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107054},"path":"~.Layout_Home #gallery #photoset","_fox_":1}],"widgets.dl.transitParameters.v5":[{"value":"q300pQINUd","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107055},"path":"~.Layout_Home #gallery #photoset","_fox_":1}],"widgets.dl.transitParameters.v3":[{"value":"YXzBYG3nUH","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107056},"path":"~.Layout_Home #gallery #photoset","_fox_":1}]},"~.Layout_Home #gallery #photoset #list":{"widgets.preloader.widget":[{"value":"Preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107059},"path":"~.Layout_Home #gallery #photoset #list","_fox_":1}],"widgets.preloader.template":[{"value":"big_preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107060},"path":"~.Layout_Home #gallery #photoset #list","_fox_":1}],"widgets.preloader.listen":[{"value":["@parent"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107061},"path":"~.Layout_Home #gallery #photoset #list","_fox_":1}],"widgets.preloader.renderOnStop":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107062},"path":"~.Layout_Home #gallery #photoset #list","_fox_":1}],"handleDom.toggleDesc.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107065},"path":"~.Layout_Home #gallery #photoset #list","_fox_":1}],"handleDom.toggleDesc.target":[{"value":".desc-toggle","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107066},"path":"~.Layout_Home #gallery #photoset #list","_fox_":1}],"handleDom.toggleDesc.callback":[{"value":function (el) {
$(this.dom('.desc-toggle')).parent().fadeToggle(1);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107070},"path":"~.Layout_Home #gallery #photoset #list","_fox_":1}]},"~.Layout_Home #gallery #galleryComments":{"showComments":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107072},"path":"~.Layout_Home #gallery #galleryComments","_fox_":1}]},"~.Layout_Home #gallery #galleryComments .Grid":{"pager.widget":[{"value":"Pager_Simple","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107075},"path":"~.Layout_Home #gallery #galleryComments .Grid","_fox_":1}],"pager.container":[{"value":"#comments-pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107076},"path":"~.Layout_Home #gallery #galleryComments .Grid","_fox_":1}],"pager.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107077},"path":"~.Layout_Home #gallery #galleryComments .Grid","_fox_":1}],"pager.logged.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107078},"path":"~.Layout_Home #gallery #galleryComments .Grid","_fox_":1}],"pager.pagesCount":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107079},"path":"~.Layout_Home #gallery #galleryComments .Grid","_fox_":1}],"pager.logged.pagesCount":[{"value":7,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107080},"path":"~.Layout_Home #gallery #galleryComments .Grid","_fox_":1}],"pager.navigatorPrefix":[{"value":"comments_page","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107081},"path":"~.Layout_Home #gallery #galleryComments .Grid","_fox_":1}]},"~.Layout_Home #gallery #currentRating":{"template":[{"value":"social_rating","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107083},"path":"~.Layout_Home #gallery #currentRating","_fox_":1}]},"~.Layout_Home #gallery #photoFavorite":{"embed.container":[{"value":".bookmark-wrapper","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107085},"path":"~.Layout_Home #gallery #photoFavorite","_fox_":1}]},"~.Layout_Home #gallery ~#tipme ~.Dialog":{"dialog.dialogClass":[{"value":"dark-overlay mc-site-common-popup mc-site-popup-bg content-report-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107090},"path":"~.Layout_Home #gallery ~#tipme ~.Dialog","_fox_":1}],"dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107091},"path":"~.Layout_Home #gallery ~#tipme ~.Dialog","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Home":{"widgets.verifiedCallBanner.widget":[{"value":"Widget","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Home","_fox_":1}],"widgets.verifiedCallBanner.embed.container":[{"value":".content-block","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.SitePage_Home","_fox_":1}],"widgets.verifiedCallBanner.embed.location":[{"value":"under","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Home","_fox_":1}],"widgets.verifiedCallBanner.autoRender":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Home","_fox_":1}],"widgets.verifiedCallBanner.template":[{"value":"callme_widget_banner_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Home","_fox_":1}],"widgets.verifiedCallBanner.widgets.vfcall.widget":[{"value":"VerifiedCall","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Home","_fox_":1}],"widgets.verifiedCallBanner.widgets.vfcall.embed.container":[{"value":"#verifiedcall-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.SitePage_Home","_fox_":1}],"widgets.verifiedCallBanner.widgets.vfcall.style":[{"value":"banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.SitePage_Home","_fox_":1}],"widgets.socialApps.widget":[{"value":"SocialApps","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.SitePage_Home","_fox_":1}],"widgets.socialApps.appDomElementOptions.tumblr.linkClass":[{"value":"thumbler","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.widget":[{"value":"WelcomeBanner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107017},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.container":[{"value":"#welcome-banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.handleDom.play.targetWidget":[{"value":"#banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.handleDom.play.target":[{"value":".play","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.handleDom.play.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.handleDom.play.callback":[{"value":function (el) {
if (fox.isEmpty(this.welcomeData.welcomeVideo)) {
return;
}
if (fox.dom.wrap(el).attr('href')) {
return;
}
this.rwom1('#video').setOption('html5PlayerConfig.movie.autoplay', true);
this.renderPlayer({welcomeVideo: this.welcomeData.welcomeVideo});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.widgets.video.manualActivation":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107037},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.widgets.video.playerConfig.clip.autoPlay":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107038},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.widgets.video.hooks.onAddedToDom":[{"value":function () {
fox.dom.addClass('video', this.element[0].parentNode.parentNode);
$(this.element[0]).parents('.wellcome-container').addClass('video-plaing')
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.widgets.banner.manualActivation":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.widgets.banner.hooks.onAddedToDom":[{"value":function () {
fox.dom.removeClass('video', this.element[0].parentNode.parentNode);
$(this.element[0]).parents('.wellcome-container').removeClass('video-plaing')
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.SitePage_Home","_fox_":1}],"widgets.welcome.hooks.onRenderWelcomeData":[{"value":function (data) {
var params = {};
if (!fox.isEmpty(data.welcomeBanner)) {
params.src = data.welcomeBanner;
};
if (!fox.isEmpty(data.welcomeVideo)
&& !fox.inArray(['error', 'encoding'], data.welcomeVideo.split(':').shift())) {
params.welcomeVideo = data.welcomeVideo;
this.rwom1('#video').setOption('html5PlayerConfig.onEnded', fox.bind(function () {
this.renderBanner(params);
}, this));
};
if (!fox.isEmpty(params.welcomeVideo) && !!Number(fox.getEnv('siteProps.welcomeVideoAutoplay'))) {
this.renderPlayer({welcomeVideo: params.welcomeVideo});
} else {
this.renderBanner(params);
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107066},"path":"~.SitePage_Home","_fox_":1}],"widgets.twitter.widget":[{"value":"Twitter","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107068},"path":"~.SitePage_Home","_fox_":1}],"widgets.twitter.container":[{"value":".twit-block","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107069},"path":"~.SitePage_Home","_fox_":1}],"widgets.liveShowViewerHome.widget":[{"value":"LiveshowCounterBanner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107071},"path":"~.SitePage_Home","_fox_":1}],"widgets.liveShowViewerHome.embed.container":[{"value":".next-liveshow","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107072},"path":"~.SitePage_Home","_fox_":1}],"widgets.liveShowViewerHome.template":[{"value":"liveShowCounter","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107073},"path":"~.SitePage_Home","_fox_":1}],"widgets.liveShowViewerHome.customizeCounter":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107074},"path":"~.SitePage_Home","_fox_":1}],"widgets.liveShowViewerHome.widgets.timer.embed.container":[{"value":".show-start-time","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107075},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widget":[{"value":"Grid","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107077},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.container":[{"value":".content-block","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107078},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.template":[{"value":"lastAdded_container_mixed","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107079},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widgets.dl.widget":[{"value":"Datalayer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107082},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widgets.dl.method":[{"value":"event.last","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107083},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widgets.dl.cacheChannel":[{"value":"event","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107084},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widgets.dl.transitParameters.v1":[{"value":"ykYa8ALmUD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107086},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widgets.dl.transitParameters.v2":[{"value":"ykYa8ALmUD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107087},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widgets.dl.limit":[{"value":8,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107088},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widgets.dl.hooks.onStopLoaded":[{"value":function () {
var obj = fox.clone(this.getCollection());
var contentTypes = {
3: 'scene',
20: 'scene',
11: 'gallery'
};
fox.each(obj, function(data, key){
data.itemType = 'scene';
if (data._typedParams.contentType == '11') {
data.itemType = 'gallery';
}
if (!data._typedParams.contentType) {
data.itemType = 'post';
for (key in data._typedParams.contents) {
var item = data._typedParams.contents[key];
if (item.type === 1) {
var $img = $(item.content).find('img');
if ($img.length) {
item.content = $img[0].src;
data._typedParams.contents[key].content = item.content;
return;
}
else {
data._typedParams.contents[key].text = item.content;
data._typedParams.contents[key].content = '';
}
}
if (item.type === 3) {
data._typedParams.contents[key].content = item.content;
}
};
return;
}
var accessibility = fox.objectGet(data._typedParams, 'accessibility.previewsForGuests')
var arr = [];
arr = ['/', contentTypes[data._typedParams.contentType], '/', data._typedParams.id];
if (fox.isSet(data.title)) {
arr.push('/')
arr.push(fox.utils.toNavigatorAlias(data.title));
};
if (!fox.site.member && accessibility == 0 && data._typedParams.contentType == 11 ) {
arr = [fox.getEnv('siteProps.ubs.joinUrl')];
};
data.generatedContentLink = arr.join('');
}, this);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107138},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.widgets.dl.transitParameters.showOnHome":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107139},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.container":[{"value":".content-list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107141},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.tpl.row":[{"value":"lastAdded_item_scene","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107143},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.tpl.scene":[{"value":"lastAdded_item_scene","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107144},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.tpl.liveshow":[{"value":"lastAdded_item_scene","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107145},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.tpl.photoset":[{"value":"lastAdded_item_photoset","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107146},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.tpl.blog":[{"value":"lastAdded_item_blog","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107147},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.widgets.preloader.widget":[{"value":"Preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107149},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.widgets.preloader.template":[{"value":"big_preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107150},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.widgets.preloader.renderOnStop":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107151},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.widgets.preloader.container":[{"value":"#last-added","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107152},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.widgets.preloader.listen":[{"value":["@this"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107153},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.hooks.onStartInit":[{"value":function() {
this.hoverVideo = __webpack_require__(27)(fox);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107156},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.hooks.onAddedToDom":[{"value":function(obj) {
var w = $(window).width();
$(window).on('resize', {widget: this}, function (e) {
if ($(window).width() != w) {
w = $(window).width();
if (e.data.widget.timeoutId) {
clearInterval(e.data.widget.timeoutId);
};
e.data.widget.timeoutId = this.window.setTimeout(function () {
e.data.widget.render();
}, 1000)
}
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107171},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.hooks.onStopRendering":[{"value":function() {
var elmArr = this.dom('.over-timeline');
this.hoverVideo.handleTouch(elmArr, this)
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107175},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.handleDom.addPrevVideo.event":[{"value":"mouseover","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107178},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.handleDom.addPrevVideo.target":[{"value":".over-timeline","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107179},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.handleDom.addPrevVideo.callback":[{"value":function (elt) {
if (fox.utils.isTouchDevice()) return;
this.hoverVideo.hoverPreviewVideo(elt, this);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107183},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.handleDom.removePrevVideo.event":[{"value":"mouseleave","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107187},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.handleDom.removePrevVideo.target":[{"value":".over-timeline","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107188},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.handleDom.removePrevVideo.callback":[{"value":function (elt) {
this.hoverVideo.stopHoverPreviewVideo(elt, this)
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107191},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.handleDom.following.target":[{"value":".over-timeline","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107194},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.handleDom.following.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107195},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.list.handleDom.following.callback":[{"value":function (elt) {
this.hoverVideo.followingLink(elt)
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107198},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.pager.widget":[{"value":"Pager_Simple","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107201},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.pager.container":[{"value":"#join_continue","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107202},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.pager.tpl.container":[{"value":"pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107203},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.pager.pagesCount":[{"value":1,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107204},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.pager.logged.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107205},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.pager.logged.pagesCount":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107206},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.pager.noScroll":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107207},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.pager.navigatorPrefix":[{"value":"home_page","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107208},"path":"~.SitePage_Home","_fox_":1}],"widgets.mixedContent.pager.resetPageOnActivate":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107209},"path":"~.SitePage_Home","_fox_":1}],"handleDom.showMoreWelcomeText.target":[{"value":".show-more","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107211},"path":"~.SitePage_Home","_fox_":1}],"handleDom.showMoreWelcomeText.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107212},"path":"~.SitePage_Home","_fox_":1}],"handleDom.showMoreWelcomeText.callback":[{"value":function (el) {
fox.dom.addClass('show-all', this.dom1('.nice-scroll-viewport', el.parentNode));
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107215},"path":"~.SitePage_Home","_fox_":1}],"handleDom.showMoreWelcomeText.reloadList.widget":[{"value":"#mixedContent","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107217},"path":"~.SitePage_Home","_fox_":1}],"handleDom.showMoreWelcomeText.reloadList.event":[{"value":"activate","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107218},"path":"~.SitePage_Home","_fox_":1}],"handleDom.showMoreWelcomeText.reloadList.callback":[{"value":function (obj, grid, e) {
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107221},"path":"~.SitePage_Home","_fox_":1}],"hooks.onAddedToDom":[{"value":function () {
if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
return;
}
$(this.element[0]).find('.nice-scroll-viewport').mCustomScrollbar({
theme: 'minimal'
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107230},"path":"~.SitePage_Home","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Join":{"widgets.customJoin.handleWom.togglePreloader.widget":[{"value":"#prepareTransactionApi","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleWom.togglePreloader.event":[{"value":["prepare","success","failure"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleWom.togglePreloader.callback":[{"value":function (obj, api, e) {
var el = $('.submit .small-loader')
if (e == 'prepare') {
el.addClass('spin');
return
}
el.removeClass('spin')
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.nextPrev.target":[{"value":".arr","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.nextPrev.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.nextPrev.callback":[{"value":function (el) {
var slider = this.wom1('#joinOptions').swipe;
var dir = fox.dom.wrap(el).attr('data-direction');
if (dir == 'next') {
slider.next()
return;
}
slider.prev();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.widget":[{"value":"Widget","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.container":[{"value":".bullets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107032},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.autoRender":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107033},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.template":[{"value":"sitepage_join_form_pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.joinOptions.hooks.onStopAddedToDom":[{"value":function () {
var options = fox.getEnv('siteProps.ubs.joinOptions.options');
var pager = this.getParent().rwom1('#pager')
var arr = [];
var w = this;
var i;
var maxDiscount = this.getOption('maxDiscount');
var discountPosition = false;
fox.each(options, function (opt, n) {
data = {i: n};
if (fox.Navigator.get(0) == 'upgrade' && !!(opt.discountParams.length > 0)){
var curDiscount = Math.trunc(opt.discountParams.discount);
if (curDiscount == maxDiscount){
discountPosition = n;
i = n;
data.active = true;
var form = w.rwom1('@parent #form');
var chkbx = fox.dom.selectFirst('#joinOption_' + opt.id);
if (!form.ready) {
arr.push(data);
return w.getParent().wait(form, 'form_ready').then(function () {
form.setValue(chkbx.name, chkbx.value);
});
} else {
form.setValue(chkbx.name, chkbx.value);
}
}
} else {
if (opt['default']) {
i = n;
data.active = true
}
}
arr.push(data);
});
this.swipe = (Swipe)(w.getParent().dom1('#swipe'), {
startSlide: i,
callback: function (ind, el) {
var arr = [];
var chkbx = fox.dom.selectFirst('input[type="radio"]', el);
w.rwom1('@parent #form').setValue(chkbx.name, chkbx.value);
fox.each(options, function (opt, n) {
var data = {i: n};
if (opt.settings.id == chkbx.value) {
data.active = true
}
arr.push(data)
});
pager.setTemplateOptions({bullets: arr}).render()
}
});
if (!!discountPosition){
this.swipe.slide(discountPosition, 0)
}
pager.setTemplateOptions({bullets: arr}).render()
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107093},"path":"~.SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.event":[{"value":"onPrepareFailed","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107097},"path":"~.SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.widget":[{"value":"#customJoin","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107098},"path":"~.SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.params.prefix":[{"value":"new_autumn","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107099},"path":"~.SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.callback":[{"value":function (params, performer) {
var form, fEl, lError, code;
form = performer.rwom1('#form');
code = params.code;
if (fox.isEmpty(params.data) && !fox.isSet(code)) {
params.data = {
username: [
{message: params.reason}
]
}
}
switch(code) {
case 12:
case 101:
params.data = {
email: [
{message: params.reason}
]
}
break;
case 2:
params.data = {
username: [
{message: 'User with such login already exists'}
]
}
break;
}
fox.each(params.data, function (val, key) {
if (key === 'username') {
key = 'login';
}
fEl = form.getElement(key).nodes[0];
lError = jQuery(fEl).next();
lError.text(val[0].message).addClass('show');
if (fEl) {
fox.dom.addClass('error', fEl);
fox.dom.on('focus', fEl, function () {
fox.dom.removeClass('error', this);
$(this).next().text('').removeClass('show')
});
}
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107143},"path":"~.SitePage_Join","_fox_":1}],"hooks.onStartRendering":[{"value":function () {
var txtLogo = fox.objectGet(fox.dictionary, 'phrases.logoText.default');
if (txtLogo) {
var length = fox.trim(txtLogo.replace(new RegExp('&nbsp;', "g"), String.fromCharCode(160))).length;
if (length > 20) {
this.setTemplateOptions({
showDefaultMobileLogo: true
})
}
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107156},"path":"~.SitePage_Join","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Liveshow":{"handleWom.lsf.event":[{"value":"fullscreen","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Liveshow","_fox_":1}],"handleWom.lsf.widget":[{"value":"#liveShowViewer .LSTranslator","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.SitePage_Liveshow","_fox_":1}],"handleWom.lsf.callback":[{"value":function () {
var $wrp = $(this.element).parents('.static-wrapper');
this._lsf = $wrp.css('zIndex');
$wrp.css('zIndex', 3);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Liveshow","_fox_":1}],"handleWom.lsn.event":[{"value":"normalscreen","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.SitePage_Liveshow","_fox_":1}],"handleWom.lsn.widget":[{"value":"#liveShowViewer .LSTranslator","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.SitePage_Liveshow","_fox_":1}],"handleWom.lsn.callback":[{"value":function () {
var $wrp = $(this.element).parents('.static-wrapper');
$wrp.css('zIndex', this._lsf);
delete this._lsf;
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.liveShowViewer.widget":[{"value":"LiveShowViewer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.joinBanner.widget":[{"value":"AMC_Banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107023},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.joinBanner.embed.container":[{"value":".join-banner-wrpper","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.joinBanner.template":[{"value":"banners_banner_0","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.widget":[{"value":"Content_Liveshows","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.embed.container":[{"value":"#recorded-liveshows","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.template":[{"value":"lastAdded_container_liveshows","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107029},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.preset":[{"value":"liveshow","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.useGeneratedContentLink":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.widgets.dl.transitParameters.v1":[{"value":"ykYa8ALmUD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.widgets.dl.metaFields.socialParams":[{"value":"likes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107035},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.list.tpl.row":[{"value":"item_scene","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107037},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.list.container":[{"value":"#last-added-flex","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107038},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.pager.widget":[{"value":"Pager_Simple","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.pager.container":[{"value":"#join_continue","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.pager.tpl.container":[{"value":"pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.pager.pagesCount":[{"value":1,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.pager.logged.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.pager.logged.pagesCount":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107045},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.pager.noScroll":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107046},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.recorderLiveshows.pager.navigatorPrefix":[{"value":"liveshows_page","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107047},"path":"~.SitePage_Liveshow","_fox_":1}]},"~.SitePage_Liveshow ~#tipme ~.Dialog":{"dialog.dialogClass":[{"value":"dark-overlay mc-site-common-popup mc-site-popup-bg","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107049},"path":"~.SitePage_Liveshow ~#tipme ~.Dialog","_fox_":1}],"dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107051},"path":"~.SitePage_Liveshow ~#tipme ~.Dialog","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Login":{"widgets.loginForm.widget":[{"value":"User_Login","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.useCaptcha":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.reloadCaptchaOnError":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.captchaAlias":[{"value":"autumnNew","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.container":[{"value":".loginform_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.template":[{"value":"user_login","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.autoRender":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleDom.handleFocus.event":[{"value":"focus","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleDom.handleFocus.target":[{"value":"[name]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleDom.handleFocus.callback":[{"value":function (el) {
var el = $(el);
el.parent().removeClass('error').next().text('').removeClass('show');
$('#loginFormError').hide();
this.hideDefaultErrorBlock();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleWom.loginError.event":[{"value":"loginError","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleWom.loginError.widget":[{"value":"@root","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107023},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleWom.loginError.callback":[{"value":function(response) {
var alias = null;
var txt = response.reason;
var code = response.code;
var container = $(fox.wom.selectFirst('~#loginForm').element[0]);
var inp;
var erase = false;
if (code == 2001 || code == 43) {
alias = 'le';
}
if (code == 3) {
alias = 'captcha';
erase = true;
}
if (code == 4 || code == 44) {
alias = 'password';
erase = true;
}
if (code == 2 || code == 6) {
this.showDefaultErrorBlock();
this.hideErrorBlock();
return;
}
input = container.find('[name="le"]')
input.parent().addClass('error').next().text(txt).addClass('show');
this.hideDefaultErrorBlock();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107054},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleWom.hidePreloader.event":[{"value":["loginError","loginSuccess"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107056},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleWom.hidePreloader.widget":[{"value":"@root","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107057},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleWom.hidePreloader.callback":[{"value":function() {
$('#login_form .login .small-loader').removeClass('spin');
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107060},"path":"~.SitePage_Login","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Passwordrecovery":{"widgets.passwordRecovery.container":[{"value":".forgotform_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Passwordrecovery","_fox_":1}]},"~.SitePage_Passwordrecovery #passwordRecovery ~.Dialog":{"dialog.dialogClass":[{"value":"mc-site-common-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Passwordrecovery #passwordRecovery ~.Dialog","_fox_":1}],"dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Passwordrecovery #passwordRecovery ~.Dialog","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Photosets":{"widgets.joinBanner0.widget":[{"value":"AMC_Banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.joinBanner0.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.joinBanner0.template":[{"value":"banners_banner_2","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.verifiedCallBanner.widget":[{"value":"Widget","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.verifiedCallBanner.embed.container":[{"value":"#mixed_content","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.verifiedCallBanner.embed.location":[{"value":"under","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.verifiedCallBanner.autoRender":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.verifiedCallBanner.template":[{"value":"callme_widget_banner_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.verifiedCallBanner.widgets.vfcall.widget":[{"value":"VerifiedCall","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.verifiedCallBanner.widgets.vfcall.embed.container":[{"value":"#verifiedcall-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.verifiedCallBanner.widgets.vfcall.style":[{"value":"banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.preloader.widget":[{"value":"Preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.preloader.template":[{"value":"big_preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.preloader.renderOnStop":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.preloader.container":[{"value":"#last_added_photosets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.preloader.listen":[{"value":["#photoSets #list"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widget":[{"value":"Content_Photosets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.container":[{"value":"#last_added_photosets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.template":[{"value":"lastAdded_container_photosets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.preset":[{"value":"photosets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.useGeneratedContentLink":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.dl.limit":[{"value":10,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.dl.transitParameters.v1":[{"value":"pSpOZnHUDD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107033},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.dl.metaFields.socialParams":[{"value":"likes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.dl.hooks.onStartLoading":[{"value":function (argument) {
var grid = this.getParent()
grid.setTags(grid.wom1('#tagsFilter').getTagsFromNavigator());
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.tagsFilter.widget":[{"value":"Content_TagsFilter","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.tagsFilter.preset":[{"value":"photosets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.tagsFilter.closeOnClick":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.tagsFilter.widgets.selectGrid.embed.widget":[{"value":"@parent","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107046},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.tagsFilter.handleWom.tagsApplied.widget":[{"value":"@parent","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.tagsFilter.handleWom.tagsApplied.event":[{"value":"tagsApplied","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107049},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.tagsFilter.handleWom.tagsApplied.callback":[{"value":"_setTag","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107050},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.widgets.tagsFilter.handleWom.tagsApplied.params.alwaysActive":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107051},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.list.tpl.row":[{"value":"item_photoset","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107053},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.list.container":[{"value":"#last-added-flex","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107054},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.pager.widget":[{"value":"Pager_Simple","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107056},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.pager.container":[{"value":"#join_continue","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107057},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.pager.tpl.container":[{"value":"pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107058},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.pager.pagesCount":[{"value":1,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107059},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.pager.logged.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107060},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.pager.logged.pagesCount":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107061},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.pager.noScroll":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107062},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.pager.navigatorPrefix":[{"value":"photosets_page","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107064},"path":"~.SitePage_Photosets","_fox_":1}],"widgets.photoSets.hooks.onRunning":[{"value":function (argument) {
if (fox.Navigator.get(this.rwom1('#pager').options.navigatorPrefix)) {
return;
}
if (!this.getOption('externalLoad')) {
this.dl.load();
};
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107073},"path":"~.SitePage_Photosets","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Post":{"widgets.tipme.widget":[{"value":"Content_Tipme","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Post","_fox_":1}],"widgets.tipme.embed.container":[{"value":".tipme-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Post","_fox_":1}],"widgets.tipme.embed.widget":[{"value":"@parent #postViewer #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.widget":[{"value":"Content_Report","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.template":[{"value":"content_report","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.prefixPopup":[{"value":"post","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.additionalPopupClass":[{"value":"mc-site-common-popup mc-site-popup-bg content-report-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.embed.widget":[{"value":"@parent #postViewer #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.widgets.reportPopup.dialog.width":[{"value":"525px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.widgets.reportPopup.dialog.buttons":[{"value":[],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107017},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.handleDom.submitReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.handleDom.cancelReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.handleDom.close.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.handleDom.close.target":[{"value":".close","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107023},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.handleDom.close.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.SitePage_Post","_fox_":1}],"widgets.reportContent.handleDom.close.callback":[{"value":"cancelReportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.widget":[{"value":"PostViewer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.template":[{"value":"sitepage_post_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.commentsPager.widget":[{"value":"Pager_Simple","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107030},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.commentsPager.container":[{"value":"#comments-pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.commentsPager.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107032},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.commentsPager.logged.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107033},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.commentsPager.pagesCount":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.commentsPager.logged.pagesCount":[{"value":7,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107035},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.commentsPager.navigatorPrefix":[{"value":"comments_page","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107037},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.photoNodeTemplate":[{"value":"sitepage_post_content_itemphoto","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107038},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.textNodeTemplate":[{"value":"sitepage_post_content_html","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.videoNodeTemplate":[{"value":"sitepage_post_content_itemvideo","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.quoteNodeTemplate":[{"value":"sitepage_post_content_html","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.widgets.preloader.widget":[{"value":"Preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"~.SitePage_Post","_fox_":1},{"value":"Preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107057},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.widgets.preloader.template":[{"value":"big_preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.SitePage_Post","_fox_":1},{"value":"big_preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107058},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.widgets.preloader.renderOnStop":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107045},"path":"~.SitePage_Post","_fox_":1},{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107060},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.widgets.preloader.container":[{"value":"#post-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107046},"path":"~.SitePage_Post","_fox_":1},{"value":"#post-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107059},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.list.tpl.row":[{"value":"sitepage_post_selected_post","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.list.embed.container":[{"value":"#post-list-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107049},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.widgets.blogSidebar.widget":[{"value":"BlogSidebar","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107051},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.widgets.blogSidebar.latestCommentsRowTemplate":[{"value":"latest_comm_row","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107052},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.widgets.blogSidebar.mostPopularPostRowTemplate":[{"value":"latest_posts_row","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107053},"path":"~.SitePage_Post","_fox_":1}],"widgets.postViewer.widgets.currentRating.template":[{"value":"social_rating","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107055},"path":"~.SitePage_Post","_fox_":1}]},"~.SitePage_Post ~.Dialog":{"dialog.dialogClass":[{"value":"dark-overlay mc-site-common-popup mc-site-popup-bg content-report-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107062},"path":"~.SitePage_Post ~.Dialog","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Scene":{"widgets.joinBanner0.widget":[{"value":"AMC_Banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Scene","_fox_":1}],"widgets.joinBanner0.embed.container":[{"value":"#related","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.SitePage_Scene","_fox_":1}],"widgets.joinBanner0.template":[{"value":"banners_banner_1","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Scene","_fox_":1}],"widgets.tipme.widget":[{"value":"Content_Tipme","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Scene","_fox_":1}],"widgets.tipme.embed.container":[{"value":".tipme-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Scene","_fox_":1}],"widgets.tipme.embed.widget":[{"value":"@parent #sceneViewer #currentScene #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widget":[{"value":"Content_VrSceneViewer","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.useCollectionId":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.sceneComments.showComments":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.sceneComments.dlLimit":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.currentScene.list.widgets.st.widget":[{"value":"Model_Backlinks","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.currentScene.list.widgets.st.fireEventWidget":[{"value":"@parent @parent @parent","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.currentScene.list.handleDom.decriptionToggle.target":[{"value":".desc-toggle","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.currentScene.list.handleDom.decriptionToggle.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107029},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.currentScene.list.handleDom.decriptionToggle.callback":[{"value":function() {
$('.short-desc').toggle();
$('.full-desc').toggle();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.currentScene.list.handleDom.downloadLinks.target":[{"value":".download.open","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107035},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.widget":[{"value":"Content_Report","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107037},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.template":[{"value":"content_report","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107038},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.additionalPopupClass":[{"value":"mc-site-common-popup mc-site-popup-bg content-report-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.embed.widget":[{"value":"@parent #currentScene #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.prefixPopup":[{"value":"vid","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.widgets.reportPopup.dialog.width":[{"value":"525px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.widgets.reportPopup.dialog.buttons":[{"value":[],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107045},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.handleDom.submitReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107047},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.handleDom.cancelReportForm.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.handleDom.close.targetWidget":[{"value":"#reportPopup #reportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107050},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.handleDom.close.target":[{"value":".close","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107051},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.handleDom.close.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107052},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.reportContent.handleDom.close.callback":[{"value":"cancelReportForm","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107053},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.currentRating.template":[{"value":"social_rating","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107055},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.sceneFavorite.embed.container":[{"value":".bookmark-wrapper","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107057},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.sceneFavorite.template":[{"value":"sitepage_gallery_addto_favorite","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107058},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.backLink.widget":[{"value":"Content_BackLink","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107060},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.backLink.dl":[{"value":"@parent #sceneDl","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107061},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.backLink.container":[{"value":".content-backlink","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107062},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.backLink.embed.widget":[{"value":"@parent #currentScene #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107063},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.widget":[{"value":"Content_Scenes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107066},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.embed.widget":[{"value":"@parent @parent #currentScene #list","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107068},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.embed.container":[{"value":"#last_added_videos","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107069},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.template":[{"value":"lastAdded_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107070},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.preset":[{"value":"scenes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107071},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.useGeneratedContentLink":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107072},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.widgets.dl.limit":[{"value":2,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107074},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.widgets.dl.transitParameters.v1":[{"value":"ykYa8ALmUD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107076},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.widgets.dl.transitParameters.v2":[{"value":"ykYa8ALmUD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107077},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.widgets.dl.metaFields.socialParams":[{"value":"likes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107079},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.list.tpl.row":[{"value":"item_scene","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107081},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.list.container":[{"value":"#last-added-flex","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107082},"path":"~.SitePage_Scene","_fox_":1}],"widgets.sceneViewer.widgets.relatedContent.widgets.contentList.list.hooks.onAddedToDom":[{"value":function(obj) {
$(window).on('resize', {widget: this}, function (e) {
if ($(window).width() != w) {
w = $(window).width();
if (e.data.widget.timeoutId) {
clearInterval(e.data.widget.timeoutId);
};
e.data.widget.timeoutId = this.window.setTimeout(function () {
e.data.widget.render();
}, 1000)
}
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107097},"path":"~.SitePage_Scene","_fox_":1}]},"~.SitePage_Scene #sceneViewer #sceneComments .Grid":{"pager.widget":[{"value":"Pager_Simple","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107103},"path":"~.SitePage_Scene #sceneViewer #sceneComments .Grid","_fox_":1}],"pager.container":[{"value":"#comments-pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107104},"path":"~.SitePage_Scene #sceneViewer #sceneComments .Grid","_fox_":1}],"pager.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107105},"path":"~.SitePage_Scene #sceneViewer #sceneComments .Grid","_fox_":1}],"pager.logged.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107106},"path":"~.SitePage_Scene #sceneViewer #sceneComments .Grid","_fox_":1}],"pager.pagesCount":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107107},"path":"~.SitePage_Scene #sceneViewer #sceneComments .Grid","_fox_":1}],"pager.logged.pagesCount":[{"value":7,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107108},"path":"~.SitePage_Scene #sceneViewer #sceneComments .Grid","_fox_":1}],"pager.navigatorPrefix":[{"value":"comments_page","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107109},"path":"~.SitePage_Scene #sceneViewer #sceneComments .Grid","_fox_":1}]},"~.SitePage_Scene ~#tipme ~.Dialog":{"dialog.dialogClass":[{"value":"dark-overlay mc-site-common-popup mc-site-popup-bg content-report-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107112},"path":"~.SitePage_Scene ~#tipme ~.Dialog","_fox_":1}],"dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107113},"path":"~.SitePage_Scene ~#tipme ~.Dialog","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Tips ~.Dialog":{"dialog.dialogClass":[{"value":"dark-overlay mc-site-common-popup mc-site-popup-bg","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.SitePage_Tips ~.Dialog","_fox_":1}],"dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Tips ~.Dialog","_fox_":1}]},"~.Tips_Form":{"hooks.onHandleErrorToggle":[{"value":function (data) {
fox.dom[(!data.state ? 'addClass' : 'removeClass')]('error', data.el.parentNode);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.Tips_Form","_fox_":1}]},"~.Tips_Form #confirmPopup #tipsPopupContainer #content":{"handleDom.focus.target":[{"value":"input[type=text]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.Tips_Form #confirmPopup #tipsPopupContainer #content","_fox_":1}],"handleDom.focus.event":[{"value":"focus","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.Tips_Form #confirmPopup #tipsPopupContainer #content","_fox_":1}],"handleDom.focus.callback":[{"value":function (el) {
fox.dom.removeClass('error', el);
fox.dom.removeClass('error', el.parentNode);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.Tips_Form #confirmPopup #tipsPopupContainer #content","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Videos":{"widgets.joinBanner.widget":[{"value":"AMC_Banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Videos","_fox_":1}],"widgets.joinBanner.embed.container":[{"value":"#newsletter-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.SitePage_Videos","_fox_":1}],"widgets.joinBanner.template":[{"value":"banners_banner_3","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Videos","_fox_":1}],"widgets.verifiedCallBanner.widget":[{"value":"Widget","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Videos","_fox_":1}],"widgets.verifiedCallBanner.embed.container":[{"value":"#last_added_videos","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.SitePage_Videos","_fox_":1}],"widgets.verifiedCallBanner.embed.location":[{"value":"under","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Videos","_fox_":1}],"widgets.verifiedCallBanner.autoRender":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.SitePage_Videos","_fox_":1}],"widgets.verifiedCallBanner.template":[{"value":"callme_widget_banner_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107012},"path":"~.SitePage_Videos","_fox_":1}],"widgets.verifiedCallBanner.widgets.vfcall.widget":[{"value":"VerifiedCall","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.SitePage_Videos","_fox_":1}],"widgets.verifiedCallBanner.widgets.vfcall.embed.container":[{"value":"#verifiedcall-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.SitePage_Videos","_fox_":1}],"widgets.verifiedCallBanner.widgets.vfcall.style":[{"value":"banner","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107016},"path":"~.SitePage_Videos","_fox_":1}],"widgets.preloader.widget":[{"value":"Preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.SitePage_Videos","_fox_":1}],"widgets.preloader.template":[{"value":"big_preloader","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.SitePage_Videos","_fox_":1}],"widgets.preloader.renderOnStop":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107020},"path":"~.SitePage_Videos","_fox_":1}],"widgets.preloader.container":[{"value":"#last-added-flex","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107021},"path":"~.SitePage_Videos","_fox_":1}],"widgets.preloader.listen":[{"value":["#contentScenes #list"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widget":[{"value":"Content_Scenes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107024},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.container":[{"value":"#last_added_videos","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107025},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.template":[{"value":"lastAdded_container_videos","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.preset":[{"value":"scenes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107027},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.useGeneratedContentLink":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.dl.limit":[{"value":10,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.dl.transitParameters.v1":[{"value":"ykYa8ALmUD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107033},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.dl.transitParameters.v2":[{"value":"ykYa8ALmUD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.dl.metaFields.socialParams":[{"value":"likes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107035},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.dl.hooks.onStartLoading":[{"value":function (argument) {
var grid = this.getParent()
grid.setTags(grid.wom1('#tagsFilter').getTagsFromNavigator());
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.dl.useGeneratedContentLink":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.tagsFilter.widget":[{"value":"Content_TagsFilter","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.tagsFilter.preset":[{"value":"scenes","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107044},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.tagsFilter.closeOnClick":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107045},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.tagsFilter.widgets.selectGrid.embed.widget":[{"value":"@parent","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.tagsFilter.handleWom.tagsApplied.widget":[{"value":"@parent","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107050},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.tagsFilter.handleWom.tagsApplied.event":[{"value":"tagsApplied","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107051},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.tagsFilter.handleWom.tagsApplied.callback":[{"value":"_setTag","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107052},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.widgets.tagsFilter.handleWom.tagsApplied.params.alwaysActive":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107054},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.list.tpl.row":[{"value":"item_scene","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107056},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.list.container":[{"value":"#last-added-flex","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107058},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.pager.widget":[{"value":"Pager_Simple","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107060},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.pager.container":[{"value":"#join_continue","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107061},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.pager.tpl.container":[{"value":"pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107062},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.pager.pagesCount":[{"value":1,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107063},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.pager.logged.tpl.container":[{"value":"pagerLogged","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107064},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.pager.logged.pagesCount":[{"value":5,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107065},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.pager.noScroll":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107066},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.pager.navigatorPrefix":[{"value":"videos_page","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107068},"path":"~.SitePage_Videos","_fox_":1}],"widgets.contentScenes.hooks.onRunning":[{"value":function (argument) {
if (fox.Navigator.get(this.rwom1('#pager').options.navigatorPrefix)) {
return;
}
if (!this.getOption('externalLoad')) {
this.dl.load();
};
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107076},"path":"~.SitePage_Videos","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./appMenuTemplates.tpl": 1151,
	"./banners/banners.tpl": 1152,
	"./billingSupport/cancellation.tpl": 1153,
	"./callmeTemplates.tpl": 1154,
	"./captcha.tpl": 1155,
	"./contentActionsIcons.tpl": 60,
	"./contentreport.tpl": 61,
	"./footer.tpl": 62,
	"./layout/404.tpl": 1156,
	"./layout/freeHostedGallery/fhg-footer.tpl": 1157,
	"./layout/home.tpl": 1158,
	"./layout/home/liveshowLink.tpl": 1159,
	"./layout/home/member.tpl": 1160,
	"./layout/home/socialapps.tpl": 1161,
	"./layout/home/tipsMenu.tpl": 1162,
	"./layout/join.tpl": 1163,
	"./listTitles.tpl": 1164,
	"./menuTemplates.tpl": 1165,
	"./newsletterBlock.tpl": 63,
	"./notification.tpl": 64,
	"./offer/modelRelated/afterCancel.tpl": 1166,
	"./offer/modelRelated/cancellationOffers.tpl": 1167,
	"./offer/modelRelated/popup.tpl": 1168,
	"./player/fakeButton.tpl": 65,
	"./popup.tpl": 1169,
	"./popup/contentreport.tpl": 1170,
	"./popup/tipsPopups.tpl": 1171,
	"./sitepage/2257.tpl": 1172,
	"./sitepage/404.tpl": 1173,
	"./sitepage/about.tpl": 1174,
	"./sitepage/aboutme/aboutme.tpl": 1175,
	"./sitepage/account.tpl": 1176,
	"./sitepage/account/account.tpl": 1177,
	"./sitepage/activity.tpl": 1178,
	"./sitepage/activity/eventCardBlogpost.tpl": 1179,
	"./sitepage/activity/eventCardCustomEvent.tpl": 1180,
	"./sitepage/activity/eventCardCustomEventLocation.tpl": 1181,
	"./sitepage/activity/eventCardJoin.tpl": 1182,
	"./sitepage/activity/eventCardLiveshow.tpl": 1184,
	"./sitepage/activity/eventCardMain.tpl": 1185,
	"./sitepage/activity/eventCardPhotoset.tpl": 1186,
	"./sitepage/activity/eventCardVideo.tpl": 1187,
	"./sitepage/activity/eventFilter.tpl": 1188,
	"./sitepage/billingContact.tpl": 1189,
	"./sitepage/blog.tpl": 1190,
	"./sitepage/blog/blogTemplates.tpl": 1191,
	"./sitepage/callme.tpl": 1192,
	"./sitepage/cancellation.tpl": 1193,
	"./sitepage/ccpa.tpl": 1194,
	"./sitepage/comments/currentcomment.tpl": 1195,
	"./sitepage/content/tipme.tpl": 1196,
	"./sitepage/conversation.tpl": 1197,
	"./sitepage/conversation/attachUnlockerTemplates.tpl": 1198,
	"./sitepage/conversation/attachedContentPreview.tpl": 1199,
	"./sitepage/conversation/currentconversation.tpl": 1200,
	"./sitepage/conversation/messagesTemplates.tpl": 1201,
	"./sitepage/cookie.tpl": 1202,
	"./sitepage/cookietable.tpl": 1203,
	"./sitepage/favorites.tpl": 1204,
	"./sitepage/favorites/favorites.tpl": 1205,
	"./sitepage/freeHostedGallery.tpl": 1206,
	"./sitepage/gallery.tpl": 1207,
	"./sitepage/gallery/galleryTemplates.tpl": 1208,
	"./sitepage/home.tpl": 1209,
	"./sitepage/home/lastadded.tpl": 1210,
	"./sitepage/home/liveshow.tpl": 1211,
	"./sitepage/home/pagerlogged.tpl": 1212,
	"./sitepage/home/welcomevideo.tpl": 1213,
	"./sitepage/join.tpl": 1214,
	"./sitepage/join/form.tpl": 1215,
	"./sitepage/liveshow.tpl": 1217,
	"./sitepage/liveshow/liveshowbanner.tpl": 1218,
	"./sitepage/liveshow/recordedLiveshows.tpl": 1219,
	"./sitepage/login.tpl": 1220,
	"./sitepage/pager/pager.tpl": 1221,
	"./sitepage/pager/pagerlogged.tpl": 1222,
	"./sitepage/passwordrecovery.tpl": 1223,
	"./sitepage/personal.tpl": 1224,
	"./sitepage/photosets.tpl": 1225,
	"./sitepage/photosets/photosets.tpl": 1226,
	"./sitepage/post.tpl": 1227,
	"./sitepage/post/postTemplates.tpl": 1228,
	"./sitepage/preload/preloaders.tpl": 1229,
	"./sitepage/privacy.tpl": 1231,
	"./sitepage/purchases/grid.tpl": 1232,
	"./sitepage/scene.tpl": 1233,
	"./sitepage/scene/backlinks.tpl": 1234,
	"./sitepage/scene/currentrelatedvideo.tpl": 1235,
	"./sitepage/scene/playerBlock.tpl": 1236,
	"./sitepage/sponsor.tpl": 1237,
	"./sitepage/terms.tpl": 1238,
	"./sitepage/tips.tpl": 1239,
	"./sitepage/user/login.tpl": 1240,
	"./sitepage/user/notificationsManager.tpl": 1241,
	"./sitepage/user/passwordrecovery.tpl": 1242,
	"./sitepage/user/personal-data.tpl": 1243,
	"./sitepage/user/profile.tpl": 1244,
	"./sitepage/videos.tpl": 1245,
	"./sitepage/videos/videos.tpl": 1246,
	"./social/comments.tpl": 1247,
	"./social/favorite.tpl": 1248,
	"./social/rating.tpl": 1249,
	"./social/twitter.tpl": 1250
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1150;

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("main_menu_item_default", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_&&0&&"},[],[["alias","class"]]],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("app_menu_more", [["ul",{"fox-main-menu-more-list":"","class":"more"},[["foreach",{"from":"","item":"item"},[["li",{"class":"link &&0&&","fox-main-menu-list-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["item.display","notempty",true],["item.display","__internal"]]]],[["item.alias","class"],["item.alias","fox-main-menu-list-item",true]]]],[["additionalLinks","from",true]]]]]]);
fox.registerTemplate("app_menu", [["nav",{"class":"menu-container base"},[["div",{"class":"main-menu-container main-menu menu-wrapper","fox-main-menu-container":""},[["foreach",{"from":"","item":"link"},[["div",{"class":"link &&0&&","fox-main-menu-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["link.display","notempty",true],["link.display","__internal"]]]],[["link.alias","class"],["link.alias","fox-main-menu-item",true]]]],[["baseLinks","from",true]]],["div",{"class":"link more-list-item","fox-main-menu-item":"list-container"},[["span",{"class":"more-link text-color-1"},[["textNode",{"text":" More "}],["i",{"class":"icon-au_menu"}],["textNode",{"text":" "}],["i",{"class":"arr icon-au_join_left_arw"}]]]]]]]]],["div",{"class":"menu-container action"},[["if",{"empty":"","addclass":"unlogged"},[["div",{"class":"right-part menu-wrapper"},[["a",{"href":"/login","id":"login-button","class":"btn bg-color-3-trans-15 text-color-1 login"},[["i",{"class":"icon-au_login_btn"}],["textNode",{"text":" "}],["span",{},[],[["userAction.login.title","__text",true]]],["textNode",{"text":" "}]]],["textNode",{"text":" "}],["a",{"href":"","id":"join-button","class":"btn bg-color-1 text-color-3 join-me"},[["i",{"class":"icon-au_join_btn"}],["textNode",{"text":" "}],["span",{},[],[["userAction.join.title","__text",true]]],["textNode",{"text":" "}]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]]],["else",{"addclass":"logged"},[["div",{"class":"right-part menu-wrapper"},[["if",{"notempty":""},[["a",{"href":"/favorites","title":"Favorites","class":"ico text-color-1 border-color-1-trans-30"},[["i",{"class":"icon-au_heart"}]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]],["if",{"notempty":""},[["a",{"href":"/purchases","title":"My Purchases","class":"ico text-color-1 border-color-1-trans-30 purchases"},[["i",{"class":"icon-au_menuPurchased_22"}]]],["else",{},[["if",{"notempty":""},[["a",{"href":"/purchases","title":"My Purchases","class":"ico text-color-1 border-color-1-trans-30 purchases"},[["i",{"class":"icon-au_menuPurchased_22"}]]]],[["member.hasPurchasedProducts","notempty",true,[],"env"]]],["else"]]]],[["store.enabled","notempty",true,[],"env"]]],["if",{"notempty":""},[["a",{"href":"/conversation","title":"Messages","id":"messages-link","class":"ico text-color-1 border-color-1-trans-30"},[["i",{"class":"icon-au_messages"}],["textNode",{"text":" "}],["span",{"class":"num","id":"messages-number"}]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]],["div",{"class":"ico text-color-1 border-color-1-trans-30 user"},[["a",{"href":"/account","title":"Account","class":"ico text-color-1 border-color-1-trans-30 user"},[["i",{"class":"icon-au_login"}]]],["div",{"class":"user-settings bg-color-2"},[["div",{"class":"user-avatar"}],["div",{"class":"user-actions"},[["p",{"class":"user-name"},[["textNode",{"text":"Hi, "}],["if",{"notempty":""},[["textNode",{"text":"Free member,"}]],[["member","notempty",true,[{"name":"hasAccess","params":["guest"]}]]]],["textNode",{"text":" "}],["span",{},[],[["login","__text",true,[],"member"]]]]],["ul",{},[["li",{},[["a",{"href":"/account","rel":"nofollow","class":"ico border-color-1-trans-30 settings action"},[["i",{"class":"icon-au_settings"}],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Settings"}]]]]]]],["li",{},[["a",{"onclick":"fox.site.logout();","class":"ico border-color-1-trans-30 logout action"},[["i",{"class":"icon-au_logout"}],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Log Out"}]]]]]]]]]]],["if",{"notempty":""},[["if",{"notempty":""},[["if",{"empty":""},[["import",{"name":"account_type_upgrade_menu_block"}]],[["site.state","empty",true,[{"name":"eq","params":["4"]}],"env"]]]],[["member","notempty",true,[{"name":"hasAccess","params":["guest"]}]]]]],[["id","notempty",true,[],"member"]]]]]]]]]]]],[["id","empty",true,[],"member"]]]]]]);
fox.registerTemplate("main_menu_item_home", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_home"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_about", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_about"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_activity", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_calendar"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_videos", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_videos"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_freeacpauth", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_bonus_15"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_photos", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_images"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_liveshowchecker", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_liveshows"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_tipschecker", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_tips"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_blogchecker", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_blog"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_skypeme", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_login_btn"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["modelProps.skyprivateLink","href",true,[],"env"]]]]);
fox.registerTemplate("main_menu_item_callme", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_callme"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_wishlist", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_favorites"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["wishlistUrl","href",true,[],"env"]]]]);
fox.registerTemplate("main_menu_item_snapme", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_SnapCentro"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("banners_banner_0", [["div",{"class":"banner"},[["if",{"empty":""},[["a",{"class":"banner-container banner-1 bg-color-2 text-color-1 pad-lr pad-tb","href":""},[["p",{"data-fox-alias":"atmnBan0","data-fox-context":"home","class":"ban border-color-3"},[["u",{"class":"color-1"},[["textNode",{"text":"Click here"}]]],["textNode",{"text":" "}],["span",{"class":"color-2"},[["textNode",{"text":"join my naughty club!"}]]]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]],[["id","empty",true,[],"member"]]]]]]);
fox.registerTemplate("banners_banner_1", [["div",{"class":"banner"},[["if",{"empty":""},[["a",{"class":"banner-container banner-2 bg-color-2 text-color-1 pad-lr pad-tb","href":""},[["p",{"data-fox-alias":"atmnBan1","data-fox-context":"activity","class":"ban border-color-3"},[["u",{"class":""},[["textNode",{"text":"Get a key"}]]],["textNode",{"text":" "}],["span",{"class":""},[["textNode",{"text":"to pics and videos"}]]],["textNode",{"text":" "}],["span",{"class":""},[["textNode",{"text":"from my bedroom now!"}]]]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]],[["id","empty",true,[],"member"]]]]]]);
fox.registerTemplate("banners_banner_2", [["div",{"class":"banner"},[["if",{"empty":""},[["a",{"class":"banner-container banner-2 bg-color-2 text-color-1 pad-lr pad-tb","href":""},[["p",{"data-fox-alias":"atmnBan2","data-fox-context":"photosets","class":"ban border-color-3"},[["u",{"class":""},[["textNode",{"text":"Get a key"}]]],["textNode",{"text":" "}],["span",{"class":""},[["textNode",{"text":"to pics and videos"}]]],["textNode",{"text":" "}],["span",{"class":""},[["textNode",{"text":"from my bedroom now!"}]]]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]],[["id","empty",true,[],"member"]]]]]]);
fox.registerTemplate("banners_banner_3", [["div",{"class":"banner"},[["if",{"empty":""},[["a",{"class":"banner-container banner-2 bg-color-2 text-color-1 pad-lr pad-tb","href":""},[["p",{"data-fox-alias":"atmnBan3","data-fox-context":"videos","class":"ban border-color-3"},[["u",{"class":""},[["textNode",{"text":"Get a key"}]]],["textNode",{"text":" "}],["span",{"class":""},[["textNode",{"text":"to pics and videos"}]]],["textNode",{"text":" "}],["span",{"class":""},[["textNode",{"text":"from my bedroom now!"}]]]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]],[["id","empty",true,[],"member"]]]]]]);
fox.registerTemplate("banners_banner_4", [["div",{"class":"banner"},[["if",{"empty":""},[["a",{"class":"banner-container banner-2 bg-color-2 text-color-1 pad-lr pad-tb","href":""},[["p",{"data-fox-alias":"atmnBan4","data-fox-context":"blog","class":"ban border-color-3"},[["u",{"class":""},[["textNode",{"text":"Get a key"}]]],["textNode",{"text":" "}],["span",{"class":""},[["textNode",{"text":"to pics and videos"}]]],["textNode",{"text":" "}],["span",{"class":""},[["textNode",{"text":"from my bedroom now!"}]]]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]],[["id","empty",true,[],"member"]]]]]]);
fox.registerTemplate("callme_widget_banner_container", [["div",{"class":"banner verified-call"},[["if",{"notempty":""},[["if",{"notempty":""},[["div",{"class":"pad-b pad-lr"},[["a",{"class":"banner-container banner-2 bg-color-3 text-color-1 pad-lr pad-tb"},[["p",{"class":"ban","data-fox-alias":"atmnBanVC"},[["span",{"class":"color-2"},[["textNode",{"text":"Want to hear my sexy voice? Call me right now!"}]]],["textNode",{"text":" "}],["span",{"id":"verifiedcall-container"}]]]]]]]],[["id","notempty",true,[],"member"]]]],[["modelProps.verifyProfile","notempty",true,[],"env"]]]]]]);
fox.registerTemplate("callme_widget_banner", []);
fox.registerTemplate("banners_banner_5", [["div",{"class":"banner"},[["if",{"empty":""},[["a",{"class":"banner-container banner-2","href":""},[["p",{"data-fox-alias":"atmnBlogJoinBanner","class":"ban border-color-3"},[["span",{"class":"color-1"},[["textNode",{"text":"get a key"}]]],["textNode",{"text":" "}],["span",{"class":"color-2"},[["textNode",{"text":"to pics and videos"}]]],["textNode",{"text":" "}],["span",{"class":"color-1"},[["textNode",{"text":"from my bedroom now!"}]]]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]],[["id","empty",true,[],"member"]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("billingsupport_cancellation_cite", [["div",{"class":"messages cancellation-model-text"},[["div",{"class":"message-row"},[["div",{"class":"message-bubble border-color-2-trans-20"},[["span",{"class":"bubble-arrow border-color-2-trans-20 bg-color-1"}],["div",{"class":"avatar"},[["img",{"src":"","alt":"avatar"},[],[["socialImage","src",true,[],"env"]]]]],["div",{"class":"message-content text-color-2"},[["div",{"class":"title"},[["p",{},[["textNode",{"text":"Hi, "}],["strong",{},[["span",{},[],[["login","__text",true,[],"member"]]]]]]]]],["div",{"class":"model-message","data-fox-alias":"cancellationModelText"},[["p",{},[["textNode",{"text":" I’m really sorry to see you go. Please fill in the fields below and send your request to me so I could discontinue your subscription. Also, it would be sweet if you could let me know why would you like to do.. did I do something wrong? If there is anything I could do to make you stay, please send me a message so we could chat about it. "}]]]]]]]]],["div",{"class":"message-from-who text-color-3"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]]]]]]);
fox.registerTemplate("billingsupport_cancellation_form", [["div",{"class":"cancellation-form"},[["div",{"class":"cancellation-reason-wrapper"},[["div",{"class":"label"},[["textNode",{"text":"Cancellation reason:"}]]],["div",{"class":"select-wrapper bg-color-2 text-color-1"},[["div",{"class":"selected"},[["textNode",{"text":"Select"}]]],["div",{"class":"select"}],["i",{"class":"root-ico_tags_arr arr"}]]]]],["div",{"class":"common-input txtarea message"},[["textarea",{"name":"message","class":"common-input txtarea"}],["div",{"class":"border"}]]],["div",{"class":"cancellation-submit"},[["a",{"id":"send-message","class":"common-btn text-color-1 bg-color-2 send-message","draggable":"true"},[["textNode",{"text":"Send request"}]]]]]]]]);
fox.registerTemplate("billingsupport_cancellation_form_select", [["select",{"name":"reason"},[["foreach",{"from":"","item":"option"},[["option",{"value":""},[["span",{},[],[["option.title","__text",true]]]],[["option.value","value",true]]]],[["list","from",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("callme_widget_full", [["div",{"class":"txt"},[["h2",{"class":"global-title"},[["textNode",{"text":"Verified Call"}]]],["div",{"class":"custom-text","data-fox-alias":"callmeText"},[["p",{},[["textNode",{"text":" Want to hear my sexy voice? If the sign is green, give me a call! If its red, "}],["br"],["textNode",{"text":" give me your number and I'll let you know once I'm available. "}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("captchablock", [["div",{"class":"row capcha","id":"captchaBlock","style":"display: none"},[["span",{"class":"reload-captcha icon-au_site-captcha_update text-color-3","id":"reload_captcha"}],["div",{"class":"common-input icon captcha"},[["input",{"type":"text","name":"captcha"}],["div",{"class":"border"},[["div",{"id":"captcha","class":"ico"}]]]]],["div",{"class":"error-message"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_404", [["div",{"class":"page-404-wrapper pad-lr"},[["div",{"class":"header join-header logo-wrapper border-color-1-trans-50 text-color-1"},[["a",{"href":"/","class":"logo text-color-1 text"},[["div",{"class":"logo-img","data-fox-alias":"logoText2"},[["img",{"src":"" + __webpack_require__(7) + "","alt":"logo"}]]],["div",{"class":"logo-text"},[["div",{"class":"desk-logo","data-fox-alias":"logoText"},[["p",{"class":"logo-main"},[["span",{},[["textNode",{"text":"Autumn"}]]]]]]],["if",{"notempty":"","addclass":"logo-text-long"},[["p",{"class":"mobile-logo"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]],[["showDefaultMobileLogo","notempty",true]]]]]]]]],["div",{"id":"container","class":"page-404-container"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("fhg_footer_2257", [["div",{"class":"footer-2257"},[["textNode",{"text":" All models appearing on this website are 18 years or older. "}],["a",{"href":"#!/2257"},[["textNode",{"text":"Click here"}]]],["textNode",{"text":" for records required pursuant to "}],["a",{},[["textNode",{"text":"18 U.S.C. 2257 Record Keeping Requirements Compliance Statement"}]]],["textNode",{"text":". By entering this site you swear that you are of legal age in your area to view adult material and that you wish to view such material. "}]]]]);
fox.registerTemplate("fhg_footer_copyright", [["div",{"class":"footer-copyright"},[["p",{},[["textNode",{"text":"Copyright&nbsp;"}],["i",{"class":"icon-copyright"}],["span",{"class":"cp-container"},[["textNode",{"text":"2022"}]]],["textNode",{"text":"&nbsp;"}],["span",{},[],[["name","__text",true,[],"client"]]],["textNode",{"text":" all Rights Reserved."}]]],["p",{"class":"powered"},[["a",{"href":"https://modelcentro.com/?acode=&&0&&","target":"_blank","rel":"nofollow"},[["i",{"class":"icon-au_poweredByMC"}]],[["client.acode","href",false,[],"env"]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_home", [["if",{"empty":""},[["div",{"class":"left-back left-back-img bg-color-3"}]],[["hideLeftBack","empty",true]]],["if",{"empty":""},[["div",{"class":"right-back right-back-img bg-color-3"}]],[["hideRightBack","empty",true]]],["div",{"class":"page-width bg-color-1"},[["div",{"id":"preloader","style":"display: none;"},[["img",{"src":"" + __webpack_require__(77) + ""}],["span",{},[["textNode",{"text":"Loading..."}]]]]],["section",{"class":"static-wrapper"},[["header",{"id":"header","class":"clearfix header-block-wrapper","data-fox-alias":"headerSlider"},[["div",{"class":"header-placeholder"},[["img",{"src":"" + __webpack_require__(76) + ""}]]],["div",{"class":"header-slider-wrapper"}],["h1",{"class":"logo-container logo-wrapper"},[["a",{"href":"/","class":"logo text-color-1 text"},[["div",{"class":"logo-img","data-fox-alias":"logoText2"},[["img",{"src":"" + __webpack_require__(7) + "","alt":"logo"}],["textNode",{"text":" "}],["span",{"class":"logo-model-screenname"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]]],["div",{"class":"logo-text","data-fox-alias":"logoText"},[["p",{"class":"logo-main desk-logo"},[["span",{},[["textNode",{"text":"Autumn"}]]]]],["if",{"notempty":"","addclass":"logo-text-long"},[["p",{"class":"mobile-logo"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]],[["showDefaultMobileLogo","notempty",true]]]]]]]]]]],["if",{"empty":""},[["nav",{"class":"top-menu pad-lr bg-color-2"},[["a",{"class":"mobile-menu-icon icon-au_menu text-color-1"}],["div",{"class":"layout-overlay"}],["div",{"id":"main-menu-wrapper","class":"main-menu-wrapper"}]]]],[["hideMainMenu","empty",true]]],["section",{"id":"container","class":"container"}]]],["footer",{"class":"footer pad-tb pad-lr bg-color-5 text-color-1"}]]],["div",{"id":"notificationList"}],["div",{"class":"througth-chat-widget-wrapper"}],["div",{"id":"upgrade-promo-banner-container"}],["div",{"id":"valentines-gifts-popup"}],["div",{"id":"offline-notifications-message"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("liveshow_link", [["div",{"class":"link liveshows"},[["a",{"href":"/liveshow","class":"text-color-1"},[["i",{"class":"ico icon-au_m_liveshows"}],["textNode",{"text":" Live Shows"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_home_member", [["div",{"id":"welcome"},[["div",{"class":"fleft"},[["span",{},[["textNode",{"text":"Welcome back,"}]]],["textNode",{"text":" "}],["span",{"class":"username"},[["span",{},[],[["login","__text",true,[],"member"]]]]]]],["div",{"class":"fleft favorites"},[["a",{"href":"/favorites"},[["textNode",{"text":"Favorites"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("social_apps_row", [["li",{"class":"border-color-1"},[["a",{"href":"","title":"","rel":"nofollow"},[["if",{"notempty":"","addattr":"target:blank"},[],[["newTarget","notempty",true]]],["i",{"class":"icon-au_&&0&& text-color-1"},[],[["elementClass","class"]]]],[["pageUrl","href",true],["title","title",true,[{"name":"replace_text","params":["Twitter","Twitter "]}]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_tips_menu", [["div",{"class":"link tips"},[["a",{"href":"/tips","class":"text-color-1"},[["i",{"class":"ico icon-au_m_tips"}],["textNode",{"text":" Spoil Me"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_join", [["div",{"class":"left-back join-left-back-img bg-color-3"}],["div",{"class":"right-back join-right-back-img bg-color-3"}],["div",{"class":"join-wrapper"},[["div",{"class":"join-back join-left-back-img"}],["div",{"class":"join-bg-shader","id":"container"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("lastadded_container", [["div",{},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"latestUpdateText","data-fox-context":"home"},[["textNode",{"text":"Latest Updates"}]]]]],["div",{"id":"last-added-flex","class":"content-list clearfix grid"}]]],["div",{"id":"join_continue","class":"tour-buttons"}]]);
fox.registerTemplate("lastadded_container_mixed", [["div",{},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"latestUpdateText","data-fox-context":"home"},[["textNode",{"text":"Latest Updates"}]]]]],["div",{"id":"last-added","class":"content-list clearfix grid"}]]],["div",{"id":"join_continue","class":"tour-buttons"}]]);
fox.registerTemplate("lastadded_container_videos", [["div",{},[["div",{"class":"title-with-filter"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"myVideosText","data-fox-context":"videos"},[["textNode",{"text":"Latest Videos"}]]]]],["div",{"class":"tags-filter"}]]],["div",{"id":"last-added-flex","class":"content-list clearfix grid"}]]],["div",{"id":"join_continue","class":"tour-buttons"}]]);
fox.registerTemplate("lastadded_container_photosets", [["div",{},[["div",{"class":"title-with-filter"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"photosetsTitleText","data-fox-context":"photosets"},[["textNode",{"text":"Latest Photosets"}]]]]],["div",{"class":"tags-filter"}]]],["div",{"id":"last-added-flex","class":"content-list clearfix grid"}]]],["div",{"id":"join_continue","class":"tour-buttons"}]]);
fox.registerTemplate("lastadded_container_liveshows", [["div",{},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"latestLiveshowsTitleText","data-fox-context":"liveshow"},[["textNode",{"text":"Latest Liveshows"}]]]]],["div",{"id":"last-added-flex","class":"content-list clearfix grid"}]]],["div",{"id":"join_continue","class":"tour-buttons"}]]);
fox.registerTemplate("lastadded_container_posts", [["div",{},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"latestBlogPostsTitleText","data-fox-context":"blog"},[["textNode",{"text":"Latest Blog Posts"}]]]]],["div",{"id":"last-added","class":"content-list clearfix grid"}]]],["div",{"id":"join_continue","class":"tour-buttons"}]]);
fox.registerTemplate("lastadded_container_favorites", [["div",{},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"favoritesTitle","data-fox-context":"favorites"},[["textNode",{"text":"Favorites"}]]]]],["div",{"id":"last-added","class":"content-list clearfix grid"}]]],["div",{"id":"join_continue","class":"tour-buttons"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("main_menu", [["nav",{"class":"menu-container base"},[["div",{"class":"main-menu-container main-menu menu-wrapper","fox-main-menu-container":""},[["foreach",{"from":"","item":"link"},[["div",{"class":"link &&0&&","fox-main-menu-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["link.display","notempty",true],["link.display","__internal"]]]],[["link.alias","class"],["link.alias","fox-main-menu-item",true]]]],[["baseLinks","from",true]]],["if",{"notempty":""},[["div",{"class":"link more-list-item","fox-main-menu-item":"list-container"},[["span",{"class":"more-link text-color-1"},[["textNode",{"text":" More "}],["i",{"class":"icon-au_menu"}],["textNode",{"text":" "}],["i",{"class":"arr icon-au_join_left_arw"}]]],["ul",{"fox-main-menu-more-list":"","class":"more"},[["foreach",{"from":"","item":"additionalLink"},[["li",{"class":"link &&0&&","fox-main-menu-list-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["additionalLink.display","notempty",true],["additionalLink.display","__internal"]]]],[["additionalLink.alias","class"],["additionalLink.alias","fox-main-menu-list-item",true]]]],[["additionalLinks","from",true]]]]]]]],[["additionalLinks","notempty",true]]]]]]],["div",{"class":"menu-container action"},[["if",{"empty":"","addclass":"unlogged"},[["div",{"class":"right-part menu-wrapper"},[["a",{"href":"/login","id":"login-button","class":"btn bg-color-3-trans-15 text-color-1 login"},[["i",{"class":"icon-au_login_btn"}],["textNode",{"text":" "}],["span",{},[],[["userAction.login","__text",true]]],["textNode",{"text":" "}]]],["textNode",{"text":" "}],["a",{"href":"","id":"join-button","class":"btn bg-color-1 text-color-3 join-me"},[["i",{"class":"icon-au_join_btn"}],["textNode",{"text":" "}],["span",{},[],[["userAction.join","__text",true]]],["textNode",{"text":" "}]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]]],["else",{"addclass":"logged"},[["div",{"class":"right-part menu-wrapper"},[["a",{"href":"/favorites","class":"ico text-color-1 border-color-1-trans-30"},[["i",{"class":"icon-au_favorites"}]]],["textNode",{"text":" "}],["a",{"href":"/conversation","id":"messages-link","class":"ico text-color-1 border-color-1-trans-30"},[["i",{"class":"icon-au_messages"}],["textNode",{"text":" "}],["span",{"class":"num","id":"messages-number"}]]],["textNode",{"text":" "}],["a",{"href":"/account","rel":"nofollow","class":"ico text-color-1 border-color-1-trans-30 settings"},[["i",{"class":"icon-au_settings"}]]],["a",{"onclick":"fox.site.logout();","class":"ico text-color-1 border-color-1-trans-30"},[["i",{"class":"icon-au_logout"}]]]]]]]],[["id","empty",true,[],"member"]]]]]]);
fox.registerTemplate("main_menu_item2", [["li",{"class":"menu-item &&0&&","fox-main-menu-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["display","notempty",true],["display","__internal"]]],["a",{"href":""},[["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]],[["alias","class"],["alias","fox-main-menu-item",true]]]]);
fox.registerTemplate("main_menu_item", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_&&0&&"},[],[["alias","class"]]],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_more_item", [["li",{"class":"menu-item &&0&&","fox-main-menu-list-item":""},[["if",{"notempty":"","addattr":"style:display:&&1&&"},[],[["display","notempty",true],["display","__internal"]]],["a",{"href":""},[["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]],[["alias","class"],["alias","fox-main-menu-list-item",true]]]]);
fox.registerTemplate("main_menu_item_home", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_home"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_about", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_about"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_activity", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_calendar"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_videos", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_videos"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_freeacpauth", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_bonus_15"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_photos", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_images"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_liveshowchecker", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_liveshows"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_tipschecker", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_tips"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_blogchecker", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_blog"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_skypeme", [["a",{"href":"","rel":"nofollow","class":"text-color-1"},[["i",{"class":"ico icon-au_login_btn"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["modelProps.skyprivateLink","href",true,[],"env"]]]]);
fox.registerTemplate("main_menu_item_callme", [["a",{"href":"","class":"text-color-1"},[["i",{"class":"ico icon-au_m_callme"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["if",{"notempty":"","addattr":"rel:nofollow"},[],[["target","notempty",true]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["url","href",true]]]]);
fox.registerTemplate("main_menu_item_wishlist", [["a",{"href":"","class":"text-color-1","rel":"nofollow"},[["i",{"class":"ico icon-au_favorites"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["wishlistUrl","href",true,[],"env"]]]]);
fox.registerTemplate("main_menu_item_snapchat", [["a",{"href":"https://www.snapchat.com/add/&&0&&","rel":"nofollow","class":"text-color-1"},[["i",{"class":"ico icon-lib-m_snapchat"}],["if",{"notempty":"","addattr":"target:&&1&&"},[],[["target","notempty",true],["target","__internal"]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["modelProps.privateSnapchat","href",false,[],"env"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_aftercancel", [["div",{"class":"content-block pad-tb success-canceled"},[["div",{"class":"pad-lr"},[["div",{"class":"global-title"},[["textNode",{"text":"Your subscription has been canceled."}]]],["div",{"class":"content-page pad-tb success-canceled-page"},[["p",{"class":"content-description"},[["textNode",{"text":" Your cancelation request has been processed. If you do nothing else, your membership will terminate at the end of the prepaid billing period. You may continue usig "}],["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" site until that time. "}]]],["a",{"href":"/account","rel":"nofollow","class":"common-btn text-color-1 bg-color-2 btn-to-account"},[["textNode",{"text":"Update Subscription Preferences"}]]]]]]],["div",{"id":"related-models-offer","class":"offers-list"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("relatedmodelsoffer", [["div",{"class":"cancellation-offers bg-color-2"},[["div",{"class":"title-block pad-lr"},[["div",{"class":"text-color-1 text"},[["textNode",{"text":"Before you go! How about a deal? We found these models that you may like."}]]],["div",{"class":"title"},[["div",{"class":"line left-line"}],["div",{"class":"global-title text-color-1"},[["textNode",{"text":"Today only. Get a "}],["span",{"id":"discount"}],["textNode",{"text":" discount."}]]],["div",{"class":"line right-line"}]]]]],["div",{"class":"list-items-wrap"},[["div",{"class":"arrow arrow-prev"},[["i",{"class":"icon-au_pager_left_arw"}]]],["div",{"id":"list-items","class":"list-items"}],["div",{"class":"arrow arrow-next"},[["i",{"class":"icon-au_pager_right_arw"}]]]]],["div",{"class":"text-color-1 description pad-lr"},[["p",{},[["textNode",{"text":"This discount applies to the first month’s promotional period. Monthly subscription pricing after this promotional period are billed at full subscription pricing."}]]],["p",{},[["textNode",{"text":" Upon completion of your purchase you will receive an email with your login and password. "}]]]]]]]]);
fox.registerTemplate("relatedmodelsoffer_item", [["div",{"class":"item"},[["div",{"class":"item-wrap"},[["div",{"class":"photo"},[["a",{"href":"http://&&0&&","rel":"nofollow"},[["img",{"src":"","class":"avatar"},[],[["aboutme.modelAvatarPath()","src",true]]]],[["site.primaryDomain.domain","href"]]]]],["div",{"class":"info"},[["div",{"class":"name"},[["span",{},[],[["name","__text",true]]]]],["div",{"class":"price"},[["div",{"class":"old"},[["span",{"class":"amount"},[["span",{},[],[["billingOption.currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["billingOption.amount","__text",true]]]]]]],["div",{"class":"new"},[["span",{"class":"amount"},[["span",{},[],[["billingOption.currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["billingOption.newPrice","__text",true]]]]]]]]]]],["button",{"class":"common-btn text-color-4 bg-color-1 btn-join button-with-spinner white-spin","data-id":""},[["textNode",{"text":"Get this site now! "}],["if",{"notempty":"","addclass":"disabled"},[],[["purchased","notempty",true]]]],[["id","data-id",true]]]]]]]]);
fox.registerTemplate("relatedmodelsoffer_item_empty", [["div",{},[["textNode",{"text":"No offers"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("offer_modelrelated_success_popup", [["div",{"class":"offer-modelrelated-popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["span",{},[],[["title","__text",true]]]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{},[["span",{},[],[["text","__text",true,[{"name":"html","params":[]}]]]]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"class":"mc-common-button simple close"},[["textNode",{"text":"Close"}]]]]]]]]);
fox.registerTemplate("offer_modelrelated_newlogin_popup", [["div",{"class":"offer-modelrelated-popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Username already exists"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["div",{"class":"common-input-holder"},[["div",{"class":"common-input"},[["input",{"type":"text","name":"login","placeholder":"Please choose another username"}],["div",{"class":"border"}]]],["div",{"class":"error-message"}]]]]],["div",{"class":"popup-footer-wrapper multiple-btns"},[["button",{"class":"mc-common-button simple close","id":"cancel"},[["textNode",{"text":"Cancel"}]]],["textNode",{"text":" "}],["button",{"class":"mc-common-button join","id":"join"},[["textNode",{"text":"Join"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_container", [["div",{"class":"popup-title-wrapper"},[["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"widgetContainer popup","id":"popup-widget-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("report_content_form", [["div",{"class":"popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title","id":"popup-widget-title"},[["textNode",{"text":"Content Report"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["div",{"class":"form-container"},[["div",{"style":"display: none;","id":"error-container"}],["form",{"action":"#","method":"post"},[["div",{"class":"select-category-block"},[["p",{"class":"small-title"},[["textNode",{"text":"Select a category"}]]],["div",{"class":"radio-btn-wrapp"},[["input",{"id":"&&0&&-1","type":"radio","name":"type","value":"1","checked":""},[],[["prefix","id"]]],["textNode",{"text":" "}],["label",{"for":"&&0&&-1"},[["span",{"class":"icon"}],["textNode",{"text":" "}],["span",{"class":"text"},[["textNode",{"text":"Copyright violation"}]]]],[["prefix","for"]]]]],["div",{"class":"radio-btn-wrapp"},[["input",{"id":"&&0&&-2","type":"radio","name":"type","value":"2"},[],[["prefix","id"]]],["textNode",{"text":" "}],["label",{"for":"&&0&&-2"},[["span",{"class":"icon"}],["textNode",{"text":" "}],["span",{"class":"text"},[["textNode",{"text":"Illegal content"}]]]],[["prefix","for"]]]]],["div",{"class":"radio-btn-wrapp"},[["input",{"id":"&&0&&-3","type":"radio","name":"type","value":"3"},[],[["prefix","id"]]],["textNode",{"text":" "}],["label",{"for":"&&0&&-3"},[["span",{"class":"icon"}],["textNode",{"text":" "}],["span",{"class":"text"},[["textNode",{"text":"Otherwise Inappropriate or Objectionable"}]]]],[["prefix","for"]]]]],["div",{"class":"radio-btn-wrapp"},[["input",{"id":"&&0&&-4","type":"radio","name":"type","value":"4"},[],[["prefix","id"]]],["textNode",{"text":" "}],["label",{"for":"&&0&&-4"},[["span",{"class":"icon"}],["textNode",{"text":" "}],["span",{"class":"text"},[["textNode",{"text":"Violent or Harmful Acts"}]]]],[["prefix","for"]]]]],["div",{"class":"radio-btn-wrapp"},[["input",{"id":"&&0&&-5","type":"radio","name":"type","value":"5"},[],[["prefix","id"]]],["textNode",{"text":" "}],["label",{"for":"&&0&&-5"},[["span",{"class":"icon"}],["textNode",{"text":" "}],["span",{"class":"text"},[["textNode",{"text":"Hateful or Inflammatory"}]]]],[["prefix","for"]]]]],["div",{"class":"radio-btn-wrapp"},[["input",{"id":"&&0&&-6","type":"radio","name":"type","value":"6"},[],[["prefix","id"]]],["textNode",{"text":" "}],["label",{"for":"&&0&&-6"},[["span",{"class":"icon"}],["textNode",{"text":" "}],["span",{"class":"text"},[["textNode",{"text":"Spam or Misleading Content"}]]]],[["prefix","for"]]]]]]],["div",{"class":"tooltip"},[["p",{},[["textNode",{"text":"Identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled"}]]]]],["div",{"class":"comment-block"},[["p",{"class":"small-title"},[["textNode",{"text":"More information"}]]],["div",{"class":"common-input txtarea"},[["textarea",{"name":"comment","placeholder":"Leave a comment...","rows":"3"}],["div",{"class":"border"}]]]]],["if",{"empty":""},[["div",{"class":"not-logged-user-block"},[["p",{"class":"small-title"},[["textNode",{"text":"Your email"}]]],["div",{"class":"common-input type-2"},[["input",{"class":"w100","type":"text","name":"email"}],["div",{"class":"border"}]]],["div",{"class":"left"},[["p",{"class":"small-title"},[["textNode",{"text":"Access Key"}]]],["div",{"id":"captcha"}],["span",{"class":"reload-captcha"}]]],["div",{"class":"right"},[["p",{"class":"small-title"},[["textNode",{"text":"Enter Access Key"}]]],["div",{"class":"common-input type-2 capcha-wrap"},[["input",{"class":"w100","type":"text","name":"captcha"}],["div",{"class":"border"}]]]]]]]],[["id","empty",true,[],"member"]]]]],["div",{"style":"display: none;margin-top: 10px;","class":"succesfully-sent"},[["textNode",{"text":" Your violation report has been submitted successfully "}]]]]]]],["div",{"class":"popup-footer-wrapper"},[["a",{"class":"common-btn text-color-3 border-color-3 cancel-report"},[["textNode",{"text":"Cancel"}]]],["textNode",{"text":" "}],["a",{"class":"common-btn text-color-1 border-color-3 bg-color-2 submit-report","data-id":""},[["textNode",{"text":"Submit"}]],[["reportId","data-id",true]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_thanks", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title","id":"popup-widget-title"},[["textNode",{"text":"Thank you "}],["span",{},[],[["name","__text",true]]],["textNode",{"text":"!"}]]]]],["div",{"class":"popup-content-wrapper"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":" I really appreciate your support, it makes me so inspired! "}]]]]],["div",{"class":"popup-footer-wrapper"},[["span",{"class":"common-btn text-color-1 border-color-3 bg-color-2 close"},[["textNode",{"text":"Ok"}]]]]]]);
fox.registerTemplate("popup_wrong", [["if",{"empty":""},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title","id":"popup-widget-title"},[["textNode",{"text":"Oops, something went wrong"}]]]]],["div",{"class":"popup-content-wrapper"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"Your tip wasn't sent. Please try to reload the page and try again or contact customer support if the problem persists."}]]]]]],[["errorAlias","empty",true]]],["if",{"notempty":""},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"title title_block border-color-3","id":"popup-widget-title"},[["textNode",{"text":"Oops!"}]]]]],["div",{"class":"popup-content-wrapper"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"This email address is already taken and your tip wasn’t sent. Please "}],["a",{"href":"/login","class":"text-color-4"},[["textNode",{"text":"login to your account"}]]],["textNode",{"text":" or "}],["a",{"href":"/tips","class":"text-color-4"},[["textNode",{"text":"use another email address"}]]],["textNode",{"text":"."}]]]]]],[["errorAlias","notempty",true,[{"name":"eq","params":["userExists"]}]]]],["div",{"class":"popup-footer-wrapper"},[["span",{"class":"common-btn text-color-1 border-color-3 bg-color-2 close"},[["textNode",{"text":"Ok"}]]]]]]);
fox.registerTemplate("popup_attention", [["div",{"class":"cancellation-confirm-popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Attention"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"You are about to tip "}],["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" $"}],["span",{},[],[["amount","__text",true]]]]],["p",{"class":"vat-eu"},[["textNode",{"text":"You may be charged VAT if you are in EU."}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"purchase","class":"mc-common-button confirm"},[["textNode",{"text":"Confirm"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_2257", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"2257Title","data-fox-context":"2257"},[["textNode",{"text":"CUSTODIAN OF RECORDS U.S.C. TITLE 18, SECTION 2257 COMPLIANCE"}]]]]],["div",{"class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_404", [["div",{"class":"page-404 text-color-1"},[["p",{"class":"p1"},[["textNode",{"text":"404"}]]],["p",{"class":"p2"},[["textNode",{"text":"That’s an error."}]]],["p",{"class":"p2"},[["textNode",{"text":"The requested URL was not found on this server."}]]],["div",{},[["a",{"href":"/","class":"common-btn text-color-3"},[["textNode",{"text":"Go to Main page »"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_about", [["div",{"class":"about-me clearfix"}],["section",{"id":"newsletter-container"}],["section",{"class":"next-liveshow bg-color-2 text-color-1"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_aboutme_data", [["div",{"class":"bg-color-3 pad-lr pad-tb about-info text-color-1"},[["div",{"class":"global-title text-color-1"},[["h2",{"data-fox-alias":"aboutHeader","data-fox-context":"about"},[["textNode",{"text":"About Me"}]]]]],["div",{"class":"photo-block clearfix"},[["div",{"class":"img","data-fox-editor-type":"image"},[["div",{"class":"pl-about-image"},[["img",{"src":"" + __webpack_require__(30) + "","alt":"about me &&0&&"},[],[["screenName","alt",false,[],"env"]]]]]]],["div",{"class":"cite bg-color-2 border-color-3"},[["h2",{"data-fox-context":"about","data-fox-alias":"aboutMeText"},[["p",{},[["textNode",{"text":" \"I want to show you something very special... Don't keep me waiting. Come inside\" "}]]]]]]],["div",{"class":"txt"},[["if",{"notempty":""},[["div",{"class":"intro nice-scroll"},[["h3",{},[["span",{},[],[["stats.introduction","__text",true,[{"name":"html","params":[]},{"name":"transformNewLines","params":[]}]]]]]]]],["div",{"class":"bg-color-2 common-btn show-more"},[["textNode",{"text":" show more "}],["i",{"class":"icon-au_drop"}]]]],[["stats.introduction","notempty",true]]]]]]],["div",{"class":"clear"}]]],["if",{"notempty":""},[["div",{"class":"stats-block pad-tb bg-color-1 text-color-2"},[["div",{"class":"global-title pad-lr "},[["div",{"data-fox-alias":"aboutStatsHeader","data-fox-context":"about"},[["textNode",{"text":"Stats"}]]]]],["h4",{"class":"stats-table"},[["foreach",{"from":"","item":"item"},[["if",{"notempty":""},[["div",{"class":"row pad-lr text-color-5"},[["div",{"class":"name"},[["span",{},[],[["item.title","__text",true]]]]],["div",{"class":"value"},[["span",{},[],[["item.value","__text",true]]]]]]]],[["item.value","notempty",true,[{"name":"notEmpty","params":[]}]]]]],[["stats.data","from",true]]]]]]]],[["stats.statsDataExists","notempty",true]]],["if",{"notempty":""},[["div",{"class":"awards-block pad-lr pad-b bg-color-1 text-color-2"},[["ul",{},[["if",{"notempty":""},[["li",{"class":"clearfix"},[["div",{"class":"global-title"},[["h2",{"data-fox-alias":"aboutAwardsHeader","data-fox-context":"about"},[["textNode",{"text":"Awards"}]]]]],["div",{"class":"pad-b list"},[["foreach",{"from":"","item":"awardItem"},[["if",{"notempty":""},[["div",{},[["span",{},[],[["awardItem.yearAward","__text",true]]],["textNode",{"text":" "}],["span",{},[],[["awardItem.titleAward","__text",true]]],["textNode",{"text":" - "}],["span",{},[],[["awardItem.category","__text",true]]]]]],[["awardItem","notempty",true]]]],[["publicActivity.award","from",true]]]]]]]],[["publicActivity.award","notempty",true,[{"name":"notEmpty","params":[]}]]]],["if",{"notempty":""},[["li",{"class":"clearfix"},[["div",{"class":"global-title"},[["h2",{"data-fox-alias":"aboutFilmographyHeader","data-fox-context":"about"},[["textNode",{"text":"Filmography"}]]]]],["div",{"class":"list"},[["foreach",{"from":"","item":"filmItem"},[["if",{"notempty":""},[["div",{},[["span",{},[],[["filmItem.yearMovie","__text",true]]],["textNode",{"text":" &mdash; "}],["span",{},[],[["filmItem.titleMovie","__text",true]]],["textNode",{"text":" ("}],["span",{},[],[["filmItem.studio","__text",true]]],["textNode",{"text":")"}]]]],[["filmItem","notempty",true]]]],[["publicActivity.movie","from",true]]]]]]]],[["publicActivity.movie","notempty",true,[{"name":"notEmpty","params":[]}]]]]]]]]],[["publicActivity","notempty",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_account", [["div",{"class":"content-block pad-lr pad-b","id":"account-form"},[["div",{"id":"settings-form","class":"pad-tb content-page"},[["div",{"class":"user-notitfications user-profile","id":"user-profile"}],["div",{"class":"user-notitfications user-personal-data","id":"user-personal-data"}],["div",{"class":"user-notitfications","id":"user-notitfications"}],["div",{"class":"auth-form account-form pad-t"},[["div",{"class":"global-title"},[["textNode",{"text":"Change Password"}]]],["div",{"id":"settingsError","class":"errors-block"},[["span",{"id":"message","class":"error"}]]],["form",{"method":"post","id":"settings-form"},[["div",{"class":"row"},[["label",{"for":"password"},[["textNode",{"text":"Current Password:"}]]],["div",{"class":"common-input-holder"},[["div",{"class":"common-input"},[["input",{"class":"inp","type":"password","name":"password","value":""}],["div",{"class":"border"}]]],["div",{"class":"error-message","error-alias":"password"}]]]]],["div",{"class":"row"},[["label",{"for":"newPassword"},[["textNode",{"text":"New Password:"}]]],["div",{"class":"common-input-holder"},[["div",{"class":"common-input"},[["input",{"class":"inp","type":"password","name":"newPassword","value":""}],["div",{"class":"border"}]]],["div",{"class":"error-message","error-alias":"newPassword"}]]]]],["div",{"class":"row"},[["label",{"for":"newPasswordCheck"},[["textNode",{"text":"Re-type New Password:"}]]],["div",{"class":"common-input-holder"},[["div",{"class":"common-input"},[["input",{"class":"inp","type":"password","name":"newPasswordCheck","value":""}],["div",{"class":"border"}]]],["div",{"class":"error-message","error-alias":"newPasswordCheck"}]]]]],["div",{"class":"row btns clearfix"},[["div",{"class":"common-btn login text-color-1 border-color-3 bg-color-2"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["div",{},[["textNode",{"text":"Change"}]]],["input",{"id":"submit","class":"btn_send","type":"submit","value":"Change"}]]]]]]]]]]],["div",{"id":"related-models-offer"}],["div",{"class":"billing-support-wrapper"}]]],["div",{"class":"clear"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("account_settings", [["div",{"id":"settings-form","class":"form_block"},[["div",{"class":"title"},[["textNode",{"text":"Change Password"}]]],["div",{"id":"settingsError"}],["p",{},[["label",{"for":"pass"},[["textNode",{"text":"Current Password:"}]]],["textNode",{"text":" "}],["span",{"class":"input-container"},[["input",{"class":"inp","type":"password","name":"oldPassword","value":""}]]]]],["p",{},[["label",{"for":"newpass"},[["textNode",{"text":"New Password:"}]]],["textNode",{"text":" "}],["span",{"class":"input-container"},[["input",{"class":"inp","type":"password","name":"newPassword","value":""}]]]]],["p",{},[["label",{"for":"newpasscheck"},[["textNode",{"text":"Re-type New Password:"}]]],["textNode",{"text":" "}],["span",{"class":"input-container"},[["input",{"class":"inp","type":"password","name":"newPasswordCheck","value":""}]]]]],["input",{"id":"submit","class":"btn_send","type":"submit","value":"Save Changes"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_activity", [["div",{"class":"content-block pad-lr pad-tb","id":"last_added_videos"},[["div",{"class":"activity-event-viewer"},[["div",{"class":"title-with-filter"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"atmnActivityTitle","data-fox-context":"activity"},[["textNode",{"text":"Events Calendar"}]]]]],["div",{"class":"tags-filter activity-filter"},[["div",{"class":"activity-action calendar"}],["div",{"class":"activity-action types"}]]]]],["div",{"class":"border-box","id":"filter-container-1"}],["div",{"class":"border-box","id":"eventlist-container"},[["div",{"id":"firts-column","class":"activity-column"}]]],["div",{"class":"border-box","id":"filter-container-2"}]]]]],["div",{"id":"newsletter-container"}],["div",{"class":"clear"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("activity_event_card_blogpost", [["div",{"class":"card-body"},[["div",{"class":"event-title"},[["a",{"class":"event-title text-color-1"},[["if",{"notempty":"","addattr":"href:/post/&&1&&"},[],[["eventTypedParams.status","notempty",true,[{"name":"eq","params":["2"]}]],["eventTypedParams.id","addattr"]]],["i",{"class":"ico ico-calendar_blogpost"}],["textNode",{"text":" "}],["span",{"title":""},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["eventTitle","__text",true,[{"name":"truncate","params":["23","..."]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":"Untitled"}]]]],[["eventTitle","notempty",true]]]],[["eventTitle","title",true]]]]],["div",{"class":"event-type"},[["textNode",{"text":"Blog post"}]]]]],["if",{"notempty":""},[["a",{"class":"cover","title":""},[["if",{"notempty":"","addattr":"href:/post/&&1&&"},[],[["eventTypedParams.status","notempty",true,[{"name":"eq","params":["2"]}]],["eventTypedParams.id","addattr"]]],["if",{"notempty":""},[["img",{"data-src":"","alt":"","class":"event-image wide lazyload"},[],[["eventTypedParams.contents.content","data-src",true],["eventTitle","alt",true]]],["else",{},[["img",{"data-src":"","alt":"&&1&& - untitled - &&2&&","class":"event-image wide lazyload"},[],[["eventTypedParams.contents.content","data-src",true],["eventId","alt"],["screenName","alt",false,[],"env"]]]]]],[["eventTitle","notempty",true]]]],[["eventTitle","title",true]]]],[["eventTypedParams.contents.content","notempty",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("activity_event_card_customevent", [["div",{"class":"card-body"},[["div",{"class":"event-title"},[["a",{"class":"event-title text-color-1 show-more-text"},[["i",{"class":"ico ico-calendar_event"}],["textNode",{"text":" "}],["span",{"title":""},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["eventTitle","__text",true,[{"name":"truncate","params":["23","..."]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":"Untitled"}]]]],[["eventTitle","notempty",true]]]],[["eventTitle","title",true]]]]],["div",{"class":"event-type"},[["textNode",{"text":"Event"}]]]]],["if",{"notempty":""},[["div",{"class":"event-description"},[["textNode",{"text":" "}],["span",{},[],[["eventDescription","__text",true,[{"name":"truncate","params":["101","..."]}]]]],["textNode",{"text":" "}],["if",{"notempty":""},[["p",{"class":"more show-more-text"},[["a",{},[["textNode",{"text":"Read more"}]]],["textNode",{"text":" "}],["i",{"class":"ico ico-calendar_dp_right"}]]]],[["fullEventDescriptionAvailable","notempty",true]]]]]],[["eventDescription","notempty",true]]],["if",{"notempty":"","addclass":"image-exists"},[["div",{"class":"cover"},[["if",{"notempty":""},[["img",{"data-src":"","alt":"","class":"lazyload event-image"},[],[["eventImage.path","data-src",true],["eventTitle","alt",true]]],["else",{},[["img",{"data-src":"","alt":"&&1&& - untitled - &&2&&","class":"lazyload event-image"},[],[["eventImage.path","data-src",true],["eventId","alt"],["screenName","alt",false,[],"env"]]]]]],[["eventTitle","notempty",true]]]]]],[["eventImage","notempty",true]]]]]]);
fox.registerTemplate("activity_event_card_customevent_description", [["div",{"title":"","class":"event-title text-color-1"},[["i",{"class":"ico ico-calendar_event"}],["textNode",{"text":" "}],["span",{},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["eventTitle","__text",true,[{"name":"truncate","params":["23","..."]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":"Untitled"}]]]],[["eventTitle","notempty",true]]]]]],[["eventTitle","title",true]]],["a",{"class":"close text-color-1"},[["textNode",{"text":"+"}]]],["div",{"class":"event-description full"},[["span",{},[],[["eventDescription","__text",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("activity_event_card_customevent_location", [["div",{"class":"card-body"},[["if",{"notempty":"","addclass":"wide"},[],[["eventImage.info","notempty",true,[{"name":"isWide","params":[]}]]]],["div",{"class":"event-title"},[["a",{"class":"event-title text-color-1 show-more-text"},[["i",{"class":"ico ico-calendar_location"}],["textNode",{"text":" "}],["span",{"title":""},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["eventTitle","__text",true,[{"name":"truncate","params":["23","..."]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":"Untitled"}]]]],[["eventTitle","notempty",true]]]],[["eventTitle","title",true]]]]],["if",{"notempty":""},[["div",{"class":"event-type"},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["eventTypedParams.url","__text",true]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":" Location: "}],["a",{"href":"","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Visit website"}]],[["eventTypedParams.url","href",true]]]]]],[["eventUrl","notempty",true,[{"name":"empty","params":[]}]]]]]]],[["eventTypedParams.url","notempty",true]]]]],["if",{"notempty":""},[["div",{"class":"event-description"},[["textNode",{"text":" "}],["span",{},[],[["eventDescription","__text",true,[{"name":"truncate","params":["101","..."]}]]]],["textNode",{"text":" "}],["if",{"notempty":""},[["p",{"class":"more show-more-text"},[["a",{},[["textNode",{"text":"Read more"}]]],["textNode",{"text":" "}],["i",{"class":"ico ico-calendar_dp_right"}]]]],[["fullEventDescriptionAvailable","notempty",true]]]]]],[["eventDescription","notempty",true]]],["if",{"notempty":"","addclass":"image-exists"},[["div",{"class":"cover"},[["if",{"notempty":""},[["img",{"data-src":"","alt":"","class":"lazyload event-image"},[],[["eventImage.path","data-src",true],["eventTitle","alt",true]]],["else",{},[["img",{"data-src":"","alt":"&&1&& - untitled - &&2&&","class":"lazyload event-image"},[],[["eventImage.path","data-src",true],["eventId","alt"],["screenName","alt",false,[],"env"]]]]]],[["eventTitle","notempty",true]]]]]],[["eventImage.path","notempty",true]]]]]]);
fox.registerTemplate("activity_event_card_customevent_location_description", [["div",{"title":"","class":"event-title text-color-1"},[["i",{"class":"ico ico-calendar_event"}],["textNode",{"text":" "}],["span",{},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["eventTitle","__text",true,[{"name":"truncate","params":["23","..."]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":"Untitled"}]]]],[["eventTitle","notempty",true]]]]]],[["eventTitle","title",true]]],["a",{"class":"close text-color-1"},[["textNode",{"text":"+"}]]],["div",{"class":"event-description full"},[["span",{},[],[["eventDescription","__text",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("activity_event_card_join", [["a",{"style":"display: block;","class":"no-underline","href":""},[["div",{"class":"activity-card background-color-1"},[["div",{"data-fox-alias":"atmnActivityJoinImg","class":"activity-join-img"},[["img",{"class":"event-image","src":"" + __webpack_require__(1183) + "","alt":"join card - &&0&&"},[],[["screenName","alt",false,[],"env"]]]]],["div",{"data-fox-alias":"atmnActivityJoinText","class":"activity-join-text"},[["div",{"class":"join-text-first"},[["textNode",{"text":"Join me NOW!"}]]],["div",{"class":"join-text-second"},[["textNode",{"text":"to watch all my photos and videos"}]]]]]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/activity-card-join.png", __webpack_require__.p + "_/_/_/root/images/activity-card-join.png");

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("activity_event_card_liveshow", [["div",{"class":"card-body"},[["div",{"class":"event-title"},[["a",{"class":"event-title text-color-1"},[["i",{"class":"ico ico-calendar_liveshow"}],["textNode",{"text":" "}],["span",{"title":""},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["eventTitle","__text",true,[{"name":"truncate","params":["23","..."]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":"Untitled"}]]]],[["eventTitle","notempty",true]]]],[["eventTitle","title",true]]]]],["if",{"notempty":""},[["div",{"class":"event-type"},[["textNode",{"text":"Live show in progress!"}]]],["else",{},[["div",{"class":"event-type"},[["textNode",{"text":"Live show"}]]]]]],[["eventTypedParams.statusAlias","notempty",true,[{"name":"eq","params":["inProgress"]}]]]]]],["div",{"class":"counter-wrapper"}],["if",{"notempty":"","addclass":"image-exists"},[["div",{"class":"cover"},[["if",{"notempty":""},[["img",{"data-src":"","alt":"","class":"lazyload event-image"},[],[["eventImage.path","data-src",true],["eventTitle","alt",true]]],["else",{},[["img",{"data-src":"","alt":"&&1&& - untitled - &&2&&","class":"lazyload event-image"},[],[["eventImage.path","data-src",true],["eventId","alt"],["screenName","alt",false,[],"env"]]]]]],[["eventTitle","notempty",true]]]]]],[["eventImage","notempty",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("activity_event_card_main", [["div",{"class":"activity-card bg-color-3 text-color-1"},[["div",{"class":"card-header clearfix"},[["div",{"class":"date-wrapper start"},[["span",{"class":"date"},[["span",{},[],[["eventStartDate","__text",true,[{"name":"dateFormat","params":["%d"]}]]]]]],["textNode",{"text":" "}],["span",{"class":"month"},[["span",{},[],[["eventStartDate","__text",true,[{"name":"dateFormat","params":["%b"]}]]]],["textNode",{"text":","}]]],["textNode",{"text":" "}],["span",{"class":"time"},[["span",{},[],[["eventStartDate","__text",true,[{"name":"dateFormat","params":["%I %P"]}]]]]]]]],["if",{"notempty":""},[["div",{"class":"date-wrapper dash"},[["textNode",{"text":"-"}]]],["div",{"class":"date-wrapper end"},[["span",{"class":"date"},[["span",{},[],[["eventStopDate","__text",true,[{"name":"dateFormat","params":["%d"]}]]]]]],["textNode",{"text":" "}],["span",{"class":"month"},[["span",{},[],[["eventStopDate","__text",true,[{"name":"dateFormat","params":["%b"]}]]]],["textNode",{"text":","}]]],["textNode",{"text":" "}],["span",{"class":"time"},[["span",{},[],[["eventStopDate","__text",true,[{"name":"dateFormat","params":["%I %P"]}]]]]]]]]],[["eventStopDate","notempty",true]]]]],["div",{"class":"card-body-wrapper"},[["div",{"id":"event-body-container"}],["div",{"class":"card-footer clearfix"},[["if",{"notempty":"","addattr":"style:display:none;"},[],[["eventTypedParams.publishedStatus","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":"","addattr":"style:display:none;"},[],[["eventTypedParams.status","notempty",true,[{"name":"eq","params":["2"]}]]]],["if",{"empty":"","addattr":"style:display:none;"},[],[["eventOptionsAddToGoogleCalendar","empty",true]]],["a",{"href":"","target":"_blank","rel":"nofollow","class":"fleft text-color-1 google-calendar"},[["textNode",{"text":"Add to Google calendar"}]],[["eventOptionsAddToGoogleCalendar","href",true]]]]]]],["div",{"class":"full-description-wrapper"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("activity_event_card_photoset", [["div",{"class":"card-body"},[["div",{"class":"event-title"},[["a",{"class":"event-title text-color-1"},[["if",{"empty":"","addattr":"href:&&1&&"},[["else",{},[["if",{"notempty":"","addattr":"href:/gallery/&&1&&"},[],[["eventTypedParams.publishedStatus","notempty",true,[{"name":"eq","params":["1","2"]}]],["eventTypedParams.id","addattr"]]]]]],[["member","empty",true,[{"name":"hasAccess","params":["member"]}]],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["i",{"class":"ico ico-calendar_photoset"}],["textNode",{"text":" "}],["span",{"title":""},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["eventTitle","__text",true,[{"name":"truncate","params":["23","..."]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":"Untitled"}]]]],[["eventTitle","notempty",true]]]],[["eventTitle","title",true]]]]],["div",{"class":"event-type"},[["textNode",{"text":"Photoset"}]]]]],["if",{"notempty":"","addclass":"image-exists"},[["a",{"class":"cover"},[["if",{"empty":"","addattr":"href:&&1&&"},[["else",{},[["if",{"notempty":"","addattr":"href:/gallery/&&1&&/&&2&&"},[],[["eventTypedParams.publishedStatus","notempty",true,[{"name":"eq","params":["1","2"]}]],["eventTypedParams.id","addattr"],["eventTitle","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]]]]],[["member","empty",true,[{"name":"hasAccess","params":["guest"]}]],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["if",{"notempty":""},[["img",{"data-src":"","alt":"","class":"lazyload event-image"},[],[["eventTypedParams.thumb","data-src",true],["eventTitle","alt",true]]],["else",{},[["img",{"data-src":"","alt":"&&1&& - untitled - &&2&&","class":"lazyload event-image"},[],[["eventTypedParams.thumb","data-src",true],["eventId","alt"],["screenName","alt",false,[],"env"]]]]]],[["eventTitle","notempty",true]]]]]],[["eventTypedParams.thumb","notempty",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("activity_event_card_video", [["div",{"class":"card-body"},[["div",{"class":"event-title"},[["a",{"class":"event-title text-color-1"},[["if",{"notempty":""},[["if",{"notempty":"","addattr":"href:/scene/&&1&&/&&2&&"},[["else",{"addattr":"href:/scene/&&0&&"},[],[["eventTypedParams.id","addattr"]]]],[["eventTitle","notempty",true],["eventTypedParams.id","addattr"],["eventTitle","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]]],[["eventTypedParams.publishedStatus","notempty",true,[{"name":"eq","params":["1","2"]}]]]],["i",{"class":"ico ico-calendar_video"}],["textNode",{"text":" "}],["span",{"title":""},[["if",{"notempty":""},[["textNode",{"text":" "}],["span",{},[],[["eventTitle","__text",true,[{"name":"truncate","params":["23","..."]}]]]],["textNode",{"text":" "}],["else",{},[["textNode",{"text":"Untitled"}]]]],[["eventTitle","notempty",true]]]],[["eventTitle","title",true]]]]],["div",{"class":"event-type"},[["textNode",{"text":"Video"}]]]]],["if",{"notempty":"","addclass":"image-exists"},[["a",{"class":"cover","title":""},[["if",{"notempty":""},[["if",{"notempty":"","addattr":"href:/scene/&&1&&/&&2&&"},[["else",{"addattr":"href:/scene/&&0&&"},[],[["eventTypedParams.id","addattr"]]]],[["eventTitle","notempty",true],["eventTypedParams.id","addattr"],["eventTitle","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]]],[["eventTypedParams.publishedStatus","notempty",true,[{"name":"eq","params":["1","2"]}]]]],["if",{"notempty":""},[["img",{"data-src":"","alt":"","class":"lazyload event-image"},[],[["eventTypedParams.thumb","data-src",true],["eventTitle","alt",true]]],["else",{},[["img",{"data-src":"","alt":"&&1&& - untitled - &&2&&","class":"lazyload event-image"},[],[["eventTypedParams.thumb","data-src",true],["eventId","alt"],["screenName","alt",false,[],"env"]]]]]],[["eventTitle","notempty",true]]]],[["eventTitle","title",true]]]],[["eventTypedParams.thumb","notempty",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("activity_event_filter", [["div",{"class":"activity-filter-wrapper clearfix"},[["div",{"class":"prev-container"},[["if",{"notempty":"&&0&&|eq:true","addclass":"exists"},[["a",{"class":"arr prev"},[["i",{"class":"ico ico-calendar_earliar"}],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Show earlier events"}]]]]]],[["prevAvailable","notempty"]]]]],["div",{"class":"current-period-container"},[["textNode",{"text":" Showing events from "}],["span",{},[],[["startDate","__text",true,[{"name":"dateFormat","params":["%e %b %Y"]}]]]],["textNode",{"text":" till "}],["span",{},[],[["endDate","__text",true,[{"name":"dateFormat","params":["%e %b %Y"]}]]]],["textNode",{"text":" "}]]],["div",{"class":"next-container"},[["if",{"notempty":"&&0&&|eq:true","addclass":"exists"},[["a",{"class":"arr next"},[["span",{},[["textNode",{"text":"Show later events"}]]],["textNode",{"text":" "}],["i",{"class":"ico ico-calendar_later"}]]]],[["nextAvailable","notempty"]]]]]]]]);
fox.registerTemplate("activity_event_view_settings_row", [["if",{"notempty":""},[["div",{"class":"view-settings-list-item text-color-1"},[["span",{"data-card-type":"","class":"animated-el switch-wrapper"},[["if",{"notempty":"","addclass":"on"},[],[["status","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":"","addclass":"off"},[],[["status","notempty",true,[{"name":"eq","params":["0"]}]]]],["span",{"class":"slider animated-el"}]],[["_key","data-card-type",true]]],["if",{"notempty":""},[["textNode",{"text":"Live Shows"}]],[["_key","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":""},[["textNode",{"text":"Blog post"}]],[["_key","notempty",true,[{"name":"eq","params":["2"]}]]]],["if",{"notempty":""},[["textNode",{"text":"Message"}]],[["_key","notempty",true,[{"name":"eq","params":["3"]}]]]],["if",{"notempty":""},[["textNode",{"text":"Trip"}]],[["_key","notempty",true,[{"name":"eq","params":["4"]}]]]],["if",{"notempty":""},[["textNode",{"text":"Other Events"}]],[["_key","notempty",true,[{"name":"eq","params":["5"]}]]]],["if",{"notempty":""},[["textNode",{"text":"Photoset"}]],[["_key","notempty",true,[{"name":"eq","params":["6"]}]]]],["if",{"notempty":""},[["textNode",{"text":"Video"}]],[["_key","notempty",true,[{"name":"eq","params":["7"]}]]]]]]],[["visible","notempty",true,[{"name":"eq","params":["1"]}]]]]]);
fox.registerTemplate("activity_event_view_settings", [["div",{"class":"activity-view-settings"},[["div",{"class":"settings-button types"},[["i",{"class":"ico ico-calendar_view_settings"}]]],["div",{"class":"setup-list view-settings-list"}]]]]);
fox.registerTemplate("activity_event_view_calendar", [["div",{"class":"activity-view-calendar"},[["div",{"class":"settings-button types"},[["i",{"class":"ico ico-calendar_datapicker"}]]],["div",{"class":"setup-list calendar"},[["div",{"class":"events-datepicker"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_billingcontact", [["div",{"class":"content-block pad-lr pad-tb","id":"account-form"},[["div",{"class":"global-title"},[["textNode",{"text":"Contact billing support"}]]],["div",{"class":"verifiedcall-wrapper billing-support-page pad-tb"},[["p",{"class":"description"},[["textNode",{"text":"Address your questions to billing support team:"}]]],["div",{"class":"contact-form-wrapper"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_blog", [["div",{"id":"blog-container","class":"pad-lr pad-tb"}],["div",{"class":"clear"}],["div",{"id":"newsletter-container"}],["div",{"class":"join-banner-wrpper"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("blog_post_item", [["div",{"class":"bg-color-3 text-color-1 item blog","itemscope":"","itemtype":"http://schema.org/BlogPosting"},[["link",{"itemprop":"mainEntityOfPage","itemscope":"","href":"/&&0&&/&&1&&"},[],[["itemType","href"],["_typedParams.id","href"]]],["span",{"style":"display:none","itemprop":"author","itemscope":"","itemtype":"http://schema.org/Person"},[["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]],["div",{"style":"display:none","itemprop":"publisher","itemscope":"","itemtype":"https://schema.org/Organization"},[["div",{"itemprop":"logo","itemscope":"","itemtype":"https://schema.org/ImageObject"},[["img",{"alt":"","itemprop":"image url","src":"" + __webpack_require__(7) + ""}]]],["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]],["foreach",{"from":"","item":"cont"},[["if",{"notempty":""},[["a",{"href":"/#!/post/&&0&&","class":"img"},[["if",{"notempty":"","addattr":"href:/post/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["img",{"itemprop":"image","data-src":"","alt":"&&1&&-&&2&&-&&3&&","class":"lazyload"},[],[["cont.content","data-src",true],["id","alt"],["title","alt"],["name","alt",false,[],"client"]]]],[["id","href"]]]],[["cont.type","notempty",true,[{"name":"eq","params":["3"]}]]]]],[["_shortContent.collection","from",true]]],["div",{"class":"info"},[["a",{"href":"/#!/post/&&0&&","class":"title text-color-1","itemprop":"headline"},[["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addattr":"href:/post/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]]],[["id","href"]]],["div",{"class":"data"},[["div",{"class":"content"},[["foreach",{"from":"","item":"cont"},[["if",{"notempty":""},[["div",{"class":"post-content"},[["textNode",{"text":" "}],["span",{},[],[["cont.content","__text",true,[{"name":"html","params":[]}]]]],["textNode",{"text":" "}]]]],[["cont.type","notempty",true,[{"name":"eq","params":["1"]}]]]]],[["_shortContent.collection","from",true]]]]],["div",{"class":"added","itemprop":"datePublished","content":""},[["span",{},[],[["publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["publishDate","content",true]]],["meta",{"itemprop":"dateModified","content":""},[],[["publishDate","content",true]]],["div",{},[["span",{"class":"likes"},[["if",{"empty":""},[["textNode",{"text":" 0 "}],["else",{},[["span",{},[],[["rating.voters","__text",true]]]]]],[["rating.voters","empty",true]]],["i",{"class":"ico icon-au_like"}]]],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["if",{"empty":""},[["textNode",{"text":" 0 "}],["else",{},[["span",{},[],[["commentsSum.total","__text",true]]]]]],[["commentsSum.total","empty",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_callme", [["div",{"class":"pad-tb pad-lr call-me-page"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"callmeTitle","data-fox-context":"callme"},[["textNode",{"text":"Call me"}]]]]],["div",{"class":"verifiedcall-wrapper border-color-3-trans-20"},[["div",{"class":"verifiedcall-widget"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_cancellation", [["div",{"class":"content-block pad-lr pad-tb","id":"account-form"},[["div",{"class":"global-title"},[["textNode",{"text":"Cancellation"}]]],["div",{"class":"content-page cancellation-page pad-tb"},[["div",{"class":"cite"}],["div",{"class":"cancellation-form-wrapper"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_ccpa", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"PrivacyTitle","data-fox-context":"privacy"},[["textNode",{"text":"Privacy Notice for California Residents"}]]]]],["div",{"data-fox-alias":"privacyText","class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_comments_currentcomment", [["div",{"class":"item-comment"},[["div",{"class":"dotted"}],["div",{"class":"onepost"},[["span",{},[["span",{},[],[["comment","__text",true]]]]],["div",{"class":"post-info"},[["span",{"class":"post-user"},[["span",{},[],[["name","__text",true]]]]],["textNode",{"text":" "}],["span",{"class":"post-date"},[["span",{},[],[["date","__text",true,[{"name":"dateFormat","params":["%d %b %Y at %H-%M"]}]]]]]],["if",{"notempty":""},[["span",{},[["if",{"empty":""},[["span",{"class":"post-reply link-color border-color-1","data-comment-id":"","data-parent-id":""},[["textNode",{"text":"Reply"}]],[["id","data-comment-id",true],["id","data-parent-id",true]]]],[["children.id","empty",true]]]]]],[["id","__internal",false,[],"member"],["userId","notempty",true,[{"name":"eq","params":["&&0&&"]}]]]]]]]],["div",{"class":"item-comment-reply border-color-1 &&0&&","id":"item-comment-reply-&&1&&"},[["foreach",{"from":"","item":"child"},[["if",{"notempty":""},[["div",{"class":"item-comment child &&0&&","id":"item-comment-child[&&1&&]"},[["div",{"class":"onepost text-color-6 border-color-1"},[["span",{},[["span",{},[],[["child.comment","__text",true]]]]],["div",{"class":"post-info text-color-5 &&0&&"},[["span",{"class":"post-user border-color-1"},[["span",{},[],[["child.name","__text",true]]]]],["textNode",{"text":" "}],["span",{"class":"post-date border-color-1"},[["span",{},[],[["child.date","__text",true,[{"name":"dateFormat","params":["%d %b %Y at %H-%M"]}]]]]]],["if",{"notempty":""},[["span",{},[["if",{"notempty":""},[["span",{"class":"post-reply link-color border-color-1","data-comment-id":"","data-parent-id":""},[["textNode",{"text":"Reply"}]],[["child.id","data-comment-id",true],["id","data-parent-id",true]]]],[["child._last","notempty",true]]]]]],[["id","__internal",false,[],"member"],["userId","notempty",true,[{"name":"eq","params":["&&0&&"]}]]]]],[["child.id","class"]]]]],["div",{"id":"reply-box-&&0&&","style":"display:none"},[["div",{"class":"write-comment"},[["div",{"class":"txtarea"},[["textarea",{"class":"guiInput width100pr inputColor inputBgColor inputBorderColor","type":"text","name":"comment","placeholder":"write a comment ..."}]]],["a",{"style":"underline: none;","class":"post-comment guiButton ButtonColor ButtonBg ButtonBorder","id":"post-comment"},[["textNode",{"text":"Post"}]]]]]],[["child.id","id"]]]],[["child.id","class"],["child.id","id"]]]],[["child.deleted","notempty",true,[{"name":"eq","params":["0"]}]]]]],[["children","from",true]]]],[["id","class"],["id","id"]]],["if",{"empty":""},[["div",{"id":"reply-box-&&0&&","style":"display:none"},[["div",{"class":"write-comment"},[["div",{"class":"txtarea"},[["textarea",{"class":"guiInput width100pr inputColor inputBgColor inputBorderColor","type":"text","name":"comment","placeholder":"write a comment ..."}]]],["a",{"style":"underline: none;","class":"post-comment guiButton ButtonColor ButtonBg ButtonBorder","id":"post-comment"},[["textNode",{"text":"Post"}]]]]]],[["id","id"]]]],[["children.id","empty",true]]]]]]);
fox.registerTemplate("sitepage_comments_currentcomment_dialog", [["div",{"class":"write-comment"},[["div",{"class":"txtarea"},[["textarea",{"class":"guiInput width100pr inputColor inputBgColor inputBorderColor","type":"text","name":"comment","placeholder":"write a comment ..."}]]],["a",{"style":"underline: none;","class":"post-comment guiButton ButtonColor ButtonBg ButtonBorder","id":"post-comment"},[["textNode",{"text":"Post"}]]]]]]);
fox.registerTemplate("sitepage_comments_currentcomment_form", [["div",{"class":"write-comment"},[["div",{"class":"txtarea"},[["textarea",{"class":"guiInput width100pr inputColor inputBgColor inputBorderColor","type":"text","name":"comment","placeholder":"write a comment ..."}]]],["a",{"class":"post-comment guiButton ButtonColor ButtonBg ButtonBorder","id":"post-comment","style":"underline:none;"},[["textNode",{"text":"Post"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_tipme", [["div",{"class":"common-input icon tip"},[["input",{"type":"text","name":"password","id":"tip-amount","class":"text-color-2","placeholder":"$2"}],["div",{"class":"border"},[["i",{"class":"icon-au_m_tips text-color-2"}]]]]],["button",{"class":"common-btn text-color-1 border-color-3 bg-color-2 tip-me","id":"tip-model"},[["textNode",{"text":" Tip "}]]]]);
fox.registerTemplate("content_tipme_confirm", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title","id":"popup-widget-title"},[["textNode",{"text":"Attention"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper tip-me-confirm"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"You are about to tip "}],["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" "}],["strong",{},[["textNode",{"text":"$"}],["span",{},[],[["amount","__text",true]]]]]]],["p",{"class":"vat-eu"},[["textNode",{"text":"You may be charged VAT if you are in EU."}]]],["div",{"class":"write-comment msg-block"},[["div",{"class":"common-input txtarea"},[["textarea",{"placeholder":"Add a personal message to me","name":"tipsMessage"}],["div",{"class":"border"}]]]]],["if",{"empty":""},[["div",{"class":"msg-block"},[["div",{"class":"row"},[["div",{"class":"common-input"},[["input",{"type":"text","name":"login","class":"text-color-2","placeholder":"Enter your nickname"}],["div",{"class":"border"}]]],["div",{"class":"error-message"},[["textNode",{"text":"please enter your nickname"}]]]]],["div",{"class":"row"},[["div",{"class":"common-input"},[["input",{"type":"text","name":"email","class":"text-color-2","placeholder":"Enter your email"}],["div",{"class":"border"}]]],["div",{"class":"error-message"},[["textNode",{"text":"please enter your email"}]]]]]]]],[["id","empty",true,[],"member"]]]]],["div",{"class":"popup-footer-wrapper"},[["span",{"class":"common-btn text-color-1 border-color-3 bg-color-2 confirm"},[["textNode",{"text":"Confirm"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_conversation", [["div",{"class":"content-block pad-lr pad-tb conversation-block","id":"conversation-block"},[["div",{"class":"global-title"},[["span",{},[["textNode",{"text":"Conversation with "}],["span",{},[],[["name","__text",true,[],"client"]]]]],["div",{"class":"content-report"}]]],["div",{"class":"messages-container","id":"messages-container"},[["div",{"id":"conversation"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("transaction_confirmation", [["div",{"class":"popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title","id":"popup-widget-title"},[["textNode",{"text":"Attention"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"You are about to pay "}],["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" "}],["strong",{},[["textNode",{"text":"$"}],["span",{},[],[["price","__text",true]]]]]]],["p",{"class":"vat-eu"},[["textNode",{"text":"You may be charged VAT if you are in EU."}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"confirm-unlock","class":"common-btn text-color-1 border-color-3 bg-color-2"},[["textNode",{"text":"Confirm"}]]]]]]]]);
fox.registerTemplate("transaction_error", [["div",{"class":"popup"},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title","id":"popup-widget-title"},[["textNode",{"text":"Oops, something went wrong"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"Your payment was not processed. Please make sure that your card has a positive balance, reload the page and try again or contact our customer support team. "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"close-tr-popup","class":"common-btn text-color-1 border-color-3 bg-color-2"},[["textNode",{"text":"Close"}]]]]]]]]);
fox.registerTemplate("transaction_success", [["div",{},[["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title","id":"popup-widget-title"},[["textNode",{"text":"Thank you"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["p",{"class":"tips-popup-notice"},[["textNode",{"text":"I really appreciate your support, it makes me so inspired!"}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"close-tr-popup","class":"common-btn text-color-1 border-color-3 bg-color-2"},[["textNode",{"text":"Close"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("favorite_attach", [["a",{"class":"fav-link bookmark pointer","data-target-id":""},[["if",{"notempty":"","addclass":"active"},[],[["isFavorite","notempty",true]]],["i",{"class":"icon-au_favorites"}],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"ADD TO FAVORITE"}]]]],[["targetId","data-target-id",true]]]]);
fox.registerTemplate("attached_video_download_links", [["if",{"notempty":""},[["a",{"class":"download open text-color-3","title":"Download","href":""},[["if",{"empty":"","addattr":"href:&&1&&"},[],[["id","empty",true,[],"member"],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["i",{"class":"icon-au_download"}],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"DOWNLOAD"}]]]],[["downloadLink","href",true]]]],[["downloadLink","notempty",true,[{"name":"notEmpty","params":[]}]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_conversation_currentconversation_row_withdate", [["div",{},[["div",{"class":"date-separator"},[["span",{},[["span",{},[],[["_ownerUser.date","__text",true]]]]]]],["if",{"notempty":""},[["div",{"class":"message-item user"},[["span",{"class":"time"},[["span",{},[],[["_ownerUser.time","__text",true]]]]],["p",{"class":"name"},[["span",{},[],[["login","__text",true,[],"member"]]]]],["p",{"class":"txt"},[["span",{},[],[["content","__text",true]]]]]]],["else",{},[["div",{"class":"message-item admin"},[["span",{"class":"time"},[["span",{},[],[["_ownerUser.time","__text",true]]]]],["p",{"class":"name"},[["span",{},[],[["name","__text",true,[],"client"]]]]],["p",{"class":"txt"},[["span",{},[],[["content","__text",true]]]]]]]]]],[["my","notempty",true,[{"name":"notEmpty","params":[]}]]]]]]]);
fox.registerTemplate("sitepage_conversation_currentconversation_row_withotdate", [["div",{},[["if",{"notempty":""},[["div",{"class":"message-item user"},[["span",{"class":"time"},[["span",{},[],[["_ownerUser.time","__text",true]]]]],["p",{"class":"name"},[["span",{},[],[["login","__text",true,[],"member"]]]]],["p",{"class":"txt"},[["span",{},[],[["content","__text",true]]]]]]],["else",{},[["div",{"class":"message-item admin"},[["span",{"class":"time"},[["span",{},[],[["_ownerUser.time","__text",true]]]]],["p",{"class":"name"},[["span",{},[],[["name","__text",true,[],"client"]]]]],["p",{"class":"txt"},[["span",{},[],[["content","__text",true]]]]]]]]]],[["my","notempty",true,[{"name":"notEmpty","params":[]}]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_conversation_messages_container", [["div",{"class":"pad-b content-page border-color-3-trans-20 conversation-container","id":"conversation"},[["div",{"id":"messages-list-scroll-wrapper","style":"overflow: hidden; max-height: 100%; position: relative;","class":"messages-list-scroll-wrapper"},[["div",{"id":"messages-list","class":"messages"}]]]]],["div",{"class":"send-message-block"},[["div",{"class":"common-input txtarea"},[["textarea",{"id":"textarea","class":"commin-input txtarea","placeholder":"Start typing a message..."}],["div",{"class":"border"}]]],["a",{"id":"send-message","class":"mc-common-button send-message"},[["textNode",{"text":"Send Message"}]]],["button",{"style":"margin-left: 5px;","id":"open-gift-popup","class":"mc-common-button simple"},[["textNode",{"text":"Send a gift"}]]],["span",{"class":"send-hint text-color-2"},[["textNode",{"text":"Ctrl+Enter"}]]]]]]);
fox.registerTemplate("conversation_attach_row", [["div",{"class":"attach-item"},[["if",{"notempty":"","addclass":"locked"},[],[["paid","notempty",true]]],["if",{"notempty":"","addclass":"processing"},[],[["processing","notempty",true,[{"name":"eq","params":["1"]}]]]],["div",{"class":"attach-error"},[["span",{"class":"att-error-message"},[["textNode",{"text":"Content not found"}]]]]],["div",{"class":"preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]],["div",{"class":"attach-preview"},[["if",{"notempty":"","addattr":"data-type:image"},[["else",{"addattr":"data-type:video"},[["span",{"class":"play bg-color bg-color-2-trans-70"},[["i",{"class":"icon-au_play text-color-1"}]]]]]],[["type","notempty",true,[{"name":"eq","params":["2"]}]]]]]],["if",{"notempty":""},[["div",{"class":"attach-lock"},[["span",{"class":"content-name","title":""},[["span",{},[],[["attachTitle","__text",true]]]],[["attachTitle","title",true]]],["span",{"class":"content-price"},[["textNode",{"text":"$"}],["span",{},[],[["price","__text",true]]]]],["a",{"class":"common-btn text-color-1 bg-color-2 unlock-btn"},[["textNode",{"text":"unlock"}]]]]]],[["paid","notempty",true]]],["if",{"notempty":""},[["div",{"class":"attach-processing"},[["div",{"class":"preload processing-loader"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]]]],["div",{"class":"content-name"},[["if",{"notempty":""},[["textNode",{"text":" Photo will be available soon, please wait "}],["else",{},[["textNode",{"text":" Video will be available soon, please wait "}]]]],[["type","notempty",true,[{"name":"eq","params":["2"]}]]]]]]]]],[["processing","notempty",true,[{"name":"eq","params":["1"]}]]]]]]]);
fox.registerTemplate("sitepage_conversation_messages_row", [["if",{"empty":""},[["if",{"notempty":""},[["div",{"class":"message-date-separator bg-color-2-trans-20"},[["span",{"class":"messages-group-date border-color-3-trans-20 bg-color-1"},[["span",{},[["span",{},[],[["timestamp","__text",true,[{"name":"dateFormat","params":[" %e %b, %Y"]}]]]]]]]]]]],[["diffDay","notempty",true,[{"name":"eq","params":["1"]}]]]],["div",{"id":"message-&&0&&","class":"message-row"},[["if",{"notempty":"","addclass":"not-my"},[],[["my","notempty",true,[{"name":"eq","params":["0"]}]]]],["div",{"class":"message-buble-wrapper"},[["if",{"notempty":"","addclass":"message-gift"},[["div",{"class":"message-bubble"},[["div",{"class":"gift-amount"},[["i",{"class":"icon-au_m_tips"}],["strong",{},[["textNode",{"text":"$"}],["span",{},[],[["price","__text",true]]]]]]],["span",{},[["textNode",{"text":"New gift from "}],["span",{},[],[["login","__text",true,[],"member"]]]]],["div",{"class":"gift &&0&&"},[],[["gift","class"]]]]],["else",{},[["div",{"class":"message-bubble  border-color-2-trans-20"},[["if",{"empty":""},[["span",{"class":"bubble-arrow border-color-2-trans-20 bg-color-1"}]],[["hideArrow","empty",true,[{"name":"eq","params":["1"]}]]]],["div",{"class":"message-content text-color-2"},[["span",{},[],[["content","__text",true,[{"name":"transformLinks","params":[]},{"name":"html","params":[]}]]]]]],["span",{"class":"message-time text-color-2"},[["textNode",{"text":"at "}],["span",{},[],[["_ownerUser.time","__text",true]]]]],["if",{"notempty":""},[["ul",{"class":"attachment-list"},[["foreach",{"from":"","item":"attach"},[["li",{"id":"at-&&0&&_&&1&&"},[],[["attach.clientUploadUserAccessId.uploadId.id","id"],["attach.messageId","id"]]]],[["attachments","from",true]]]]]],[["attachments","notempty",true,[{"name":"notEmptyDl","params":[]}]]]]]],["if",{"empty":""},[["strong",{"class":"message-from-who"},[["if",{"notempty":"","addclass":"text-color-2"},[["textNode",{"text":" "}],["span",{},[],[["login","__text",true,[],"member"]]],["textNode",{"text":" "}],["else",{"addclass":"text-color-3"},[["textNode",{"text":" "}],["span",{},[],[["name","__text",true,[],"client"]]],["textNode",{"text":" "}]]]],[["my","notempty",true,[{"name":"eq","params":["1"]}]]]]]]],[["hideArrow","empty",true,[{"name":"eq","params":["1"]}]]]]]]],[["serviceTypeAlias","notempty",true,[{"name":"eq","params":["gift"]}]]]]]]],[["id","id"]]]],[["hidden","empty",true,[{"name":"eq","params":["1"]}]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_cookie_policy", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"cookieTitle","data-fox-context":"personal"},[["textNode",{"text":"Cookie Use Policy"}]]]]],["div",{"data-fox-alias":"cookieText","class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_cookie_table", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"cookieTitle","data-fox-context":"personal"},[["textNode",{"text":"Cookie Table"}]]]]],["div",{"data-fox-alias":"cookieText","class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_favorites", [["div",{"class":"content-block pad-lr pad-tb","id":"favorites"}],["div",{"class":"clear"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_favorites_row", [["if",{"notempty":""},[["div",{"class":"text-color-1 item photo wide"},[["span",{"class":"remove text-color-1 bg-color-2-trans-70","id":"","subject":"","title":"Remove from favorites"},[["i",{"class":"icon-au_close-delete"}],["textNode",{"text":" remove "}]],[["resourceId","id",true],["favoriteType","subject",true]]],["textNode",{"text":" "}],["a",{"class":"fullscreen","id":""},[["img",{"src":"","alt":""},[],[["_resources.photoSetCount.url","src",true],["_resources.photoSetCount.altTag","alt",true]]]],[["resourceId","id",true]]],["textNode",{"text":" "}],["a",{"href":"/gallery/&&0&&","class":"watch-full watch-full-bg text-color-1"},[["textNode",{"text":"Watch full photoset»"}]],[["_resources.photoSetCount.contentId","href"]]]]]],[["favoriteType","notempty",true,[{"name":"eq","params":["resource"]}]]]],["if",{"notempty":""},[["div",{"class":"bg-color-3 text-color-1 item scene"},[["span",{"class":"remove text-color-1 bg-color-2-trans-70","id":"","subject":"","title":"Remove from favorites"},[["i",{"class":"icon-au_close-delete"}],["textNode",{"text":" remove "}]],[["id","id",true],["favoriteType","subject",true]]],["textNode",{"text":" "}],["a",{"href":"/scene/&&0&&","class":"img","title":""},[["if",{"notempty":"","addattr":"href:/scene/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["span",{"class":"play bg-color bg-color-2-trans-70"},[["i",{"class":"icon-au_play text-color-1"}]]],["textNode",{"text":" "}],["img",{"src":"","alt":""},[],[["_resources.primary.url","src",true],["_resources.primary.altTag","alt",true]]]],[["id","href"],["_resources.primary.altTag","title",true]]],["div",{"class":"info"},[["a",{"href":"/scene/&&0&&","class":"title text-color-1"},[["if",{"notempty":"","addattr":"href:/scene/&&1&&/&&2&&"},[],[["title","notempty",true],["_typedParams.id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["_typedParams.id","href"]]],["div",{"class":"data"},[["div",{"class":"total"},[["span",{"class":"length"},[["textNode",{"text":"Length: "}],["span",{},[],[["length","__text",true,[{"name":"timeLength","params":["m"]}]]]]]]]],["div",{"class":"added"},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]]],["div",{"class":"socials"},[["span",{"class":"likes"},[["span",{},[],[["_socialParams.likes","__text",true]]],["i",{"class":"ico icon-au_like"}]]],["textNode",{"text":" "}],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["span",{},[],[["_socialParams.totalComments","__text",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]]]]],[["contentType","notempty",true,[{"name":"eq","params":["3"]}]]]],["if",{"notempty":""},[["div",{"class":"bg-color-3 text-color-1 item scene"},[["span",{"class":"remove text-color-1 bg-color-2-trans-70","id":"","subject":"","title":"Remove from favorites"},[["i",{"class":"icon-au_close-delete"}],["textNode",{"text":" remove "}]],[["id","id",true],["favoriteType","subject",true]]],["textNode",{"text":" "}],["a",{"href":"/scene/&&0&&","class":"img","title":""},[["if",{"notempty":"","addattr":"href:/scene/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["span",{"class":"play bg-color bg-color-2-trans-70"},[["i",{"class":"icon-au_play text-color-1"}]]],["textNode",{"text":" "}],["img",{"src":"","alt":""},[],[["_resources.primary.url","src",true],["_resources.primary.altTag","alt",true]]]],[["id","href"],["_resources.primary.altTag","title",true]]],["div",{"class":"info"},[["a",{"href":"/scene/&&0&&","class":"title text-color-1"},[["if",{"notempty":"","addattr":"href:/scene/&&1&&/&&2&&"},[],[["title","notempty",true],["_typedParams.id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["_typedParams.id","href"]]],["div",{"class":"data"},[["div",{"class":"total"},[["span",{"class":"length"},[["textNode",{"text":"Length: "}],["span",{},[],[["length","__text",true,[{"name":"timeLength","params":["m"]}]]]]]]]],["div",{"class":"added"},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]]],["div",{"class":"socials"},[["span",{"class":"likes"},[["span",{},[],[["_socialParams.likes","__text",true]]],["i",{"class":"ico icon-au_like"}]]],["textNode",{"text":" "}],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["span",{},[],[["_socialParams.totalComments","__text",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]]]]],[["contentType","notempty",true,[{"name":"eq","params":["20"]}]]]],["if",{"notempty":""},[["if",{"notempty":""},[["div",{"class":"bg-color-3 text-color-1 item scene"},[["span",{"class":"remove text-color-1 bg-color-2-trans-70","id":"","subject":"resource","title":"Remove from favorites"},[["i",{"class":"icon-au_close-delete"}],["textNode",{"text":" remove "}]],[["resourceId","id",true]]],["textNode",{"text":" "}],["a",{"class":"img attached-video","title":"[_resources.primary.altTag]","data-attached-content":""},[["span",{"class":"play bg-color bg-color-2-trans-70"},[["i",{"class":"icon-au_play text-color-1"}]]],["textNode",{"text":" "}],["img",{"src":"","alt":""},[],[["_resources.primary.url","src",true],["_resources.primary.altTag","alt",true]]]],[["clienUploadId","data-attached-content",true]]],["div",{"class":"info"},[["a",{"class":"title text-color-1 attached-video"},[["span",{},[],[["title","__text",true]]]]]]]]]],[["type","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":""},[["div",{"class":"text-color-1 item photo  wide"},[["span",{"class":"remove text-color-1 bg-color-2-trans-70","id":"","subject":"resource","title":"Remove from favorites"},[["i",{"class":"icon-au_close-delete"}],["textNode",{"text":" remove "}]],[["resourceId","id",true]]],["textNode",{"text":" "}],["a",{"class":"fullscreen","id":""},[["img",{"src":"","alt":""},[],[["_resources.photoSetCount.url","src",true],["_resources.photoSetCount.altTag","alt",true]]]],[["resourceId","id",true]]]]]],[["type","notempty",true,[{"name":"eq","params":["2"]}]]]]],[["favoriteType","notempty",true,[{"name":"eq","params":["clientUploadResource"]}]]]],["if",{"notempty":""},[["if",{"notempty":""},[["div",{"class":"bg-color-3 text-color-1 item scene"},[["span",{"class":"remove text-color-1 bg-color-2-trans-70","id":"","subject":"","title":"Remove from favorites"},[["i",{"class":"icon-au_close-delete"}],["textNode",{"text":" remove "}]],[["id","id",true],["favoriteType","subject",true]]],["textNode",{"text":" "}],["a",{"class":"img attached-video","title":""},[["span",{"class":"play bg-color bg-color-2-trans-70"},[["i",{"class":"icon-au_play text-color-1"}]]],["textNode",{"text":" "}],["img",{"src":"","alt":""},[],[["_resources.primary.url","src",true],["_resources.primary.altTag","alt",true]]]],[["_resources.primary.altTag","title",true]]],["div",{"class":"info"},[["a",{"class":"title text-color-1 attached-video"},[["span",{},[],[["title","__text",true]]]]],["div",{"class":"data"},[["div",{"class":"total"},[["span",{"class":"length"},[["textNode",{"text":"Length: "}],["span",{},[],[["length","__text",true,[{"name":"timeLength","params":["m"]}]]]]]]]],["div",{"class":"added"},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]]],["div",{"class":"socials"},[["span",{"class":"likes"},[["span",{},[],[["_socialParams.likes","__text",true]]],["i",{"class":"ico icon-au_like"}]]],["textNode",{"text":" "}],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["span",{},[],[["_socialParams.totalComments","__text",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]]]]],[["type","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":""},[["div",{"class":"text-color-1 item photo wide"},[["span",{"class":"remove text-color-1 bg-color-2-trans-70","id":"","subject":"","title":"Remove from favorites"},[["i",{"class":"icon-au_close-delete"}],["textNode",{"text":" remove "}]],[["id","id",true],["favoriteType","subject",true]]],["textNode",{"text":" "}],["a",{"class":"fullscreen","id":""},[["img",{"src":"","alt":""},[],[["_resources.photoSet.url","src",true],["_resources.photoSetCount.altTag","alt",true]]]],[["_resources.bigThumb.id","id",true]]]]]],[["type","notempty",true,[{"name":"eq","params":["2"]}]]]]],[["contentType","notempty",true,[{"name":"eq","params":["30"]}]]]],["if",{"notempty":""},[["div",{"class":"bg-color-3 text-color-1 item photoset wide"},[["span",{"class":"remove text-color-1 bg-color-2-trans-70","id":"","subject":"","title":"Remove from favorites"},[["i",{"class":"icon-au_close-delete"}],["textNode",{"text":" remove "}]],[["id","id",true],["favoriteType","subject",true]]],["a",{"href":"/gallery/&&0&&","class":"img","title":""},[["if",{"notempty":"","addattr":"href:/gallery/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["img",{"src":"","alt":""},[],[["_resources.photoSet.url","src",true],["title","alt",true]]]],[["id","href"],["title","title",true]]],["div",{"class":"info"},[["a",{"href":"/gallery/&&0&&","class":"title text-color-1"},[["if",{"notempty":"","addattr":"href:/gallery/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["id","href"]]],["div",{"class":"data"},[["div",{"class":"total"},[["span",{"class":"num"},[["span",{},[],[["length","__text",true]]]]],["textNode",{"text":" "}],["span",{"class":"pics"},[["textNode",{"text":"pics"}]]]]],["div",{"class":"added"},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]]],["div",{"class":"socials"},[["span",{"class":"likes"},[["span",{},[],[["_socialParams.likes","__text",true]]],["i",{"class":"ico icon-au_like"}]]],["textNode",{"text":" "}],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["span",{},[],[["_socialParams.totalComments","__text",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]]]]],[["contentType","notempty",true,[{"name":"eq","params":["11"]}]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("fhg_title_and_download", [["span",{"class":"title text-color-2"},[["span",{},[],[["title","__text",true]]]]],["if",{"notempty":""},[["div",{"class":"description"},[["span",{},[],[["description","__text",true]]]]]],[["description","notempty",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_gallery", [["div",{"class":"content_block","id":"mixed_content"},[["div",{"id":"gallery-block","class":"content-page gallery"}]]],["div",{"id":"newsletter-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_scene_content_backlink", [["if",{"notempty":""},[["div",{"class":"link scene-info"},[["a",{"href":"","target":"_blank","rel":"nofollow"},[["i",{"class":"icon icon-arrow-middle-right"}],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]]],[["url","href",true]]]]]],[["url","notempty",true]]]]);
fox.registerTemplate("sitepage_gallery_container", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"title-with-filter content-info"},[["div",{"class":"title-block clearfix"},[["h2",{"class":"left global-title text-color-2"},[["span",{},[],[["title","__text",true]]]]]]],["div",{"class":"right added"},[["span",{},[["textNode",{"text":"Added:"}]]],["textNode",{"text":" "}],["span",{"class":"text-color-3 date","itemprop":"datePublished","content":""},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["sites.publishDate","content",true]]]]]]],["div",{"class":"cast content-info","id":"model-backlinks"}],["if",{"notempty":""},[["h4",{"class":"tags content-info"},[["span",{"class":"label"},[["textNode",{"text":"Tags:&nbsp;"}]]],["foreach",{"from":"","item":"item"},[["a",{"href":"/photosets/tags=&&0&&","class":"item"},[["span",{},[],[["item.alias","__text",true]]]],[["item.alias","href"]]],["if",{"empty":""},[["span",{"class":"coma"},[["textNode",{"text":", "}]]]],[["item._last","empty",true]]]],[["tags","from",true]]]]]],[["tags","notempty",true,[{"name":"notEmptyDl","params":[]}]]]],["div",{"class":"content-description","itemprop":"description"},[["if",{"notempty":""},[["h3",{"class":"short-desc"},[["textNode",{"text":" "}],["span",{},[],[["description","__text",true,[{"name":"truncate","params":["320","..."]}]]]],["textNode",{"text":" "}],["a",{"class":"desc-toggle bg-color-2 text-color-1 common-btn show-more"},[["textNode",{"text":" show more "}],["i",{"class":"icon-au_drop"}]]]]],["h3",{"class":"full-desc"},[["textNode",{"text":" "}],["span",{},[],[["description","__text",true]]],["textNode",{"text":" "}],["a",{"class":"desc-toggle bg-color-2 text-color-1 common-btn show-more"},[["textNode",{"text":" less..."}]]]]],["else",{},[["h3",{},[["span",{},[],[["description","__text",true]]]]]]]],[["description","notempty",true,[{"name":"count","params":[]},{"name":"gt","params":["320"]}]]]]]],["div",{"id":"gallery-cut","class":"photos-list"}],["div",{"id":"gallery-all"}],["div",{"class":"more-photos"},[["button",{"id":"show-all-photos","class":"bg-color-2 text-color-1 common-btn show-more"},[["textNode",{"text":" Show all photos "}],["i",{"class":"icon-au_drop"}]]]]],["div",{"class":"content-links"},[["div",{"class":"content-backlink item"}],["if",{"notempty":""},[["div",{"class":"item"},[["div",{"class":"link faq-link scene-info"},[["a",{"href":"/","target":"_blank"},[["span",{"class":"icon bd-icon-question-mark_18"}],["textNode",{"text":" Virtual reality FAQ"}]]]]]]]],[["vr","notempty",true]]]]],["import",{"name":"content_actions"}],["if",{"notempty":""},[["div",{"id":"comment-form","class":"comments-block reviews","data-target-id":""},[],[["id","data-target-id",true]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]],["div",{"id":"last_added_photosets"}]]]]);
fox.registerTemplate("sitepage_gallery_photolist_item", [["div",{"data-id":"","id":"photo-&&1&&","class":"photo-item animated","itemscope":"","itemtype":"http://schema.org/ImageObject"},[["if",{"notempty":""},[["img",{"data-src":"","alt":"","class":"lazyload","itemprop":"thumbnail"},[],[["url","data-src",true],["altTag","alt",true]]],["else",{},[["img",{"data-src":"","alt":"photo-&&1&&-&&2&&","class":"lazyload","itemprop":"thumbnail"},[],[["url","data-src",true],["id","alt"],["screenName","alt",false,[],"env"]]]]]],[["altTag","notempty",true]]]],[["id","data-id",true],["id","id"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_home", [["section",{"class":"welcome-block pad-lr pad-tb"},[["div",{"class":"wellcome-container bg-color-3"},[["div",{"class":"img"},[["div",{"class":"player-wrapper","data-fox-alias":"welcomeBlock"},[["div",{"id":"welcome-banner"}]]]]],["div",{"class":"welcome-text bg-color-3 text-color-1 "},[["div",{"class":"nice-scroll-viewport"},[["div",{"data-fox-alias":"welcomeText","id":"welcomeText","data-fox-context":"home","class":"nice-scroll"},[["h2",{},[["textNode",{"text":"Welcome to my official site"}]]],["h3",{},[["p",{},[["textNode",{"text":" This website is the only place where i will post my most playful, secret, and exciting pics and videos. I built this especially for you guys, my fans, so if you want to be a part of the secret special moments of the fun i have, create an account now. "}]]],["p",{},[["textNode",{"text":"This VIP account will provide you all my updates for new shoots, trips i am planning, and performance dates, so if you wanna keep up with me, make sure you're keeping up with all of me I try and do a little something special for my new fans, so expect some exclusive live shows for when you get inside.. i like being real-time for all my fans, and i really like having fun and enjoying myself! Why not come inside, and have some fun with me?"}]]]]]]]]],["div",{"class":"bg-color-2 common-btn show-more"},[["textNode",{"text":" show more "}],["i",{"class":"icon-au_drop"}]]],["ul",{"class":"social"}]]],["div",{"class":"player-container"}]]]]],["section",{"id":"crowdfunding","class":"crowdfunding-wrapper"}],["section",{"id":"newsletter-container"}],["section",{"class":"twit-block"}],["section",{"id":"liveshow-container","class":"liveshow-container","itemscope":"","itemtype":"http://schema.org/Event"}],["section",{"class":"content-block pad-lr pad-b"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("lastadded_item_scene", [["div",{"class":"bg-color-3 text-color-1 item scene","itemscope":"","itemtype":"http://schema.org/VideoObject"},[["meta",{"itemprop":"description","content":""},[],[["title","content",true]]],["meta",{"itemprop":"uploadDate","content":""},[],[["startDate","content",true]]],["link",{"itemprop":"mainEntityOfPage","itemscope":"","href":""},[],[["generatedContentLink","href",true]]],["span",{"style":"display:none","itemprop":"author","itemscope":"","itemtype":"http://schema.org/Person"},[["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]],["textNode",{"text":" "}],["a",{"href":"","class":"img","title":""},[["span",{"class":"play bg-color bg-color-2-trans-70"},[["i",{"class":"icon-au_play text-color-1"}]]],["meta",{"itemprop":"thumbnailURL","content":""},[],[["_typedParams.metaValues.primary.url","content",true]]],["img",{"data-src":"","alt":"","class":"lazyload","itemprop":"thumbnail","content":""},[],[["_typedParams.metaValues.primary.url","data-src",true],["title","alt",true],["_typedParams.metaValues.primary.url","content",true]]],["if",{"notempty":""},[["video",{"class":"hov-video","playsinline":"","autoplay":"autoplay","muted":"true","loop":"loop","width":"100%","data-src":""},[],[["hoverPreview","data-src",true]]],["else",{},[["div",{"class":"baseline"},[["foreach",{"from":"","item":"thumb"},[["img",{"class":"loadImg _hidden","data-img":""},[],[["thumb.url","data-img",true]]]],[["_typedParams.metaValues.base","from",true]]]]]]]],[["hoverPreview","notempty",true]]],["if",{"notempty":""},[["span",{"class":"vr-label bg-color-2 text-color-1"},[["i",{"class":"icon-au_vr-video_15"}]]]],[["_typedParams.type","notempty",true,[{"name":"eq","params":["4"]}]]]]],[["generatedContentLink","href",true],["title","title",true]]],["div",{"class":"over-timeline"},[["div",{"class":"progressbar"},[["div",{"class":"filling"}]]]]],["div",{"class":"info"},[["a",{"href":"","class":"title text-color-1","itemprop":"name"},[["span",{},[],[["title","__text",true]]]],[["generatedContentLink","href",true]]],["div",{"class":"data"},[["div",{"class":"total"},[["if",{"notempty":""},[["span",{"class":"length"},[["textNode",{"text":"Length: "}],["span",{},[],[["_typedParams.length","__text",true,[{"name":"timeLength","params":["h m s"]}]]]],["textNode",{"text":" sec"}]]],["else",{},[["span",{"class":"length"},[["textNode",{"text":"Length: "}],["span",{},[],[["_typedParams.length","__text",true]]],["textNode",{"text":" sec"}]]]]]],[["_typedParams.length","notempty",true,[{"name":"gt","params":["60"]}]]]]]],["div",{"class":"added","itemprop":"datePublished","content":""},[["span",{},[],[["startDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["sites.publishDate","content",true]]],["div",{"class":"socials"},[["span",{"class":"likes"},[["span",{},[],[["_typedParams.likes","__text",true]]],["i",{"class":"ico icon-au_like"}]]],["textNode",{"text":" "}],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["span",{},[],[["_typedParams.totalComments","__text",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]]]]]);
fox.registerTemplate("lastadded_item_photoset", [["div",{"class":"bg-color-3 text-color-1 item photoset wide","itemscope":"","itemtype":"http://schema.org/ImageObject"},[["span",{"itemprop":"author","style":"display:none","itemscope":"","itemtype":"http://schema.org/Person"},[["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]],["textNode",{"text":" "}],["a",{"href":"","class":"img","title":""},[["img",{"data-src":"","alt":"","class":"lazyload","itemprop":"thumbnail","content":""},[],[["_typedParams.metaValues.primary.url","data-src",true],["title","alt",true],["_typedParams.metaValues.primary.url","content",true]]]],[["generatedContentLink","href",true],["title","title",true]]],["div",{"class":"info"},[["a",{"href":"","class":"title text-color-1","itemprop":"name"},[["span",{},[],[["title","__text",true]]]],[["generatedContentLink","href",true]]],["div",{"class":"data"},[["div",{"class":"total"},[["if",{"notempty":"&&0&&|eq:gallery"},[["span",{"class":"num"},[["span",{},[],[["_typedParams.length","__text",true]]]]],["textNode",{"text":" "}],["span",{"class":"pics"},[["textNode",{"text":"pics"}]]]],[["itemType","notempty"]]]]],["div",{"class":"added","itemprop":"datePublished","content":""},[["span",{},[],[["startDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["sites.publishDate","content",true]]],["div",{"class":"socials"},[["span",{"class":"likes"},[["span",{},[],[["_typedParams.likes","__text",true]]],["i",{"class":"ico icon-au_like"}]]],["textNode",{"text":" "}],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["span",{},[],[["_typedParams.totalComments","__text",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]]]]]);
fox.registerTemplate("lastadded_item_blog", [["div",{"class":"bg-color-3 text-color-1 item blog","itemscope":"","itemtype":"http://schema.org/BlogPosting"},[["link",{"itemprop":"mainEntityOfPage","itemscope":"","href":"/&&0&&/&&1&&"},[],[["itemType","href"],["_typedParams.id","href"]]],["span",{"style":"display:none","itemprop":"author","itemscope":"","itemtype":"http://schema.org/Person"},[["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]],["div",{"style":"display:none","itemprop":"publisher","itemscope":"","itemtype":"https://schema.org/Organization"},[["div",{"itemprop":"logo","itemscope":"","itemtype":"https://schema.org/ImageObject"},[["img",{"alt":"","itemprop":"image url","src":"" + __webpack_require__(7) + ""}]]],["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]],["meta",{"itemprop":"headline","content":""},[],[["title","content",true]]],["if",{"notempty":""},[["a",{"href":"/&&0&&/&&1&&","class":"img"},[["if",{"notempty":"","addattr":"href:/&&1&&/&&2&&/&&3&&"},[["img",{"itemprop":"image","data-src":"","alt":"","class":"lazyload"},[],[["_typedParams.contents.content","data-src",true],["title","alt",true]]],["else",{},[["img",{"itemprop":"image","data-src":"","alt":"&&1&&-untitled-&&2&&","class":"lazyload"},[],[["_typedParams.contents.content","data-src",true],["_typedParams.id","alt"],["name","alt",false,[],"client"]]]]]],[["title","notempty",true],["itemType","addattr"],["_typedParams.id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]]],[["itemType","href"],["_typedParams.id","href"]]]],[["_typedParams.contents.content","notempty",true]]],["div",{"class":"info"},[["a",{"href":"/&&0&&/&&1&&","class":"title text-color-1","itemprop":"name"},[["if",{"notempty":"","addattr":"href:/&&1&&/&&2&&/&&3&&"},[],[["title","notempty",true],["itemType","addattr"],["_typedParams.id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["itemType","href"],["_typedParams.id","href"]]],["div",{"class":"data"},[["div",{"class":"added","itemprop":"datePublished","content":""},[["span",{},[],[["startDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["startDate","content",true]]],["meta",{"itemprop":"dateModified","content":""},[],[["startDate","content",true]]],["if",{"notempty":""},[["else",{},[["if",{"notempty":""},[["div",{"class":"content"},[["div",{"class":"post-content","itemprop":"description"},[["textNode",{"text":" "}],["span",{},[],[["_typedParams.contents.text","__text",true,[{"name":"html","params":[]}]]]],["textNode",{"text":" "}]]]]]],[["_typedParams.contents.text","notempty",true]]]]]],[["_typedParams.contents.content","notempty",true]]],["div",{"class":"socials"},[["span",{"class":"likes"},[["span",{},[],[["_typedParams.likes","__text",true]]],["i",{"class":"ico icon-au_like"}]]],["textNode",{"text":" "}],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["span",{},[],[["_typedParams.totalComments","__text",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("liveshowcounter", [["div",{"class":"liveshow-timer &&0&& pad-lr pad-tb bg-color-2 text-color-1"},[["div",{"class":"show-start-time"}],["div",{"class":"ls-info"},[["div",{"class":"global-title"},[["textNode",{"text":"Next Live Show"}]]],["div",{"class":"info-wrapper"},[["if",{"notempty":""},[["div",{"class":"ls-title"},[["span",{},[],[["addVars.title","__text",true]]]]],["span",{"class":"sep"},[["textNode",{"text":"&nbsp;|&nbsp;"}]]]],[["addVars.title","notempty",true]]],["div",{"class":"next-date"},[["span",{},[],[["addVars.startDate","__text",true,[{"name":"dateFormat","params":["%B %e, %Y %I"]}]]]],["textNode",{"text":":"}],["span",{},[],[["addVars.startDate","__text",true,[{"name":"dateFormat","params":["%M %P"]}]]]]]]]]]],["div",{"class":"action-wrapper"},[["if",{"notempty":""},[["a",{"href":"","target":"_blank","rel":"nofollow","class":"mc-common-button inverse"},[["textNode",{"text":"Add to calendar"}]],[["googleCalendarLink","href",true]]],["else",{},[["a",{"href":"","class":"mc-common-button inverse"},[["textNode",{"text":"Reserve your seat"}]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]]]],[["id","notempty",true,[],"member"]]]]]],[["success.status","class"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_home_pagerlogged", [["div",{"class":"pager"},[["if",{"notempty":""},[["a",{"class":"prev-arr pager-click pager-num","data-page":""},[["if",{"notempty":"","addattr":"href:&&1&&=&&2&&/&&3&&"},[],[["link","notempty",true],["link","__internal"],["prev","addattr"],["tags","addattr"]]],["span",{"class":"arr"},[["textNode",{"text":"prev"}]]]],[["prev","data-page",true]]]],[["prev","notempty",true]]],["span",{"class":"pager-list"},[["if",{"notempty":""},[["span",{},[["a",{"class":"pager-click pager-num","data-page":""},[["span",{},[],[["first","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addattr":"href:&&1&&=&&2&&/&&3&&"},[],[["link","notempty",true],["link","__internal"],["first","addattr"],["tags","addattr"]]]],[["first","data-page",true]]],["textNode",{"text":" "}],["span",{"class":"bull"},[["textNode",{"text":"..."}]]]]]],[["startSpacer","notempty",true]]],["foreach",{"from":"","item":"page"},[["span",{},[["if",{"notempty":"","math":""},[["span",{"class":"current"},[["span",{},[],[["page.page","__text",true]]]]],["else",{},[["a",{"class":"pager-click pager-num","data-page":""},[["span",{},[],[["page.page","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addattr":"href:&&1&&=&&2&&/&&3&&"},[],[["link","notempty",true],["link","__internal"],["page.page","addattr"],["tags","addattr"]]]],[["page.page","data-page",true]]]]]],[["page.current","notempty",true]]]]]],[["pages","from",true]]],["if",{"notempty":""},[["span",{},[["span",{"class":"bull"},[["textNode",{"text":"..."}]]],["textNode",{"text":" "}],["a",{"class":"pager-click pager-num","data-page":""},[["span",{},[],[["total","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addattr":"href:&&1&&=&&2&&/&&3&&"},[],[["link","notempty",true],["link","__internal"],["total","addattr"],["tags","addattr"]]]],[["total","data-page",true]]]]]],[["endSpacer","notempty",true]]]]],["if",{"notempty":""},[["a",{"class":"next-arr pager-click pager-num","data-page":""},[["if",{"notempty":"","addattr":"href:&&1&&=&&2&&/&&3&&"},[],[["link","notempty",true],["link","__internal"],["next","addattr"],["tags","addattr"]]],["span",{"class":"arr"},[["textNode",{"text":"next"}]]]],[["next","data-page",true]]]],[["next","notempty",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_home_welcome_video", [["div",{"class":"player_container"},[["div",{"id":"flash-player","class":"player"}]]]]);
fox.registerTemplate("sitepage_home_welcome_banner", [["div",{"class":"img-banner-container"},[["if",{"notempty":""},[["a",{"class":"play bg-color-2-trans-70 text-color-1"},[["if",{"notempty":"","addattr":"href:&&1&&","addclass":"fake-button"},[],[["useFakePLayer","notempty",true],["welcomeVideo","__internal"]]],["i",{"class":"icon-au_play"}],["textNode",{"text":"Play video "}]]]],[["welcomeVideo","notempty",true]]],["div",{"class":"uploaded-welcome-banner"},[["if",{"notempty":""},[["img",{"src":"","id":"welcome_banner","alt":"Welcome"},[],[["src","src",true]]]],[["src","notempty",true]]]]]]]]);
fox.registerTemplate("sitepage_home_welcome_none", [["div",{"data-fox-editor-type":"image"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_join", [["div",{"class":"page-width"},[["div",{"class":"pad-lr pad-tb"},[["header",{"class":"header logo-wrapper join-header border-color-4 text-color-1","id":"header"},[["a",{"href":"/","class":"logo text-color-1 text"},[["h1",{},[["div",{"class":"logo-img","data-fox-alias":"logoText2"},[["img",{"src":"" + __webpack_require__(7) + "","alt":"logo"}],["textNode",{"text":" "}],["span",{"class":"logo-model-screenname"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]]],["div",{"class":"logo-text"},[["div",{"class":"desk-logo","data-fox-alias":"logoText"},[["p",{"class":"logo-main"},[["span",{},[["textNode",{"text":"Autumn"}]]]]]]],["if",{"notempty":"","addclass":"logo-text-long"},[["p",{"class":"mobile-logo"},[["span",{},[],[["screenName","__text",true,[],"env"]]]]]],[["showDefaultMobileLogo","notempty",true]]]]]]]]]]],["section",{"class":"join-form","id":"join-form-container"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_join_form", [["form",{"class":"join-form form","id":"join-form","action":"#","method":"post"},[["if",{"empty":""},[["h2",{"class":"global-title text-color-1"},[["textNode",{"text":"Create Account"}]]],["div",{"class":"fields"},[["div",{"class":"row"},[["input",{"type":"text","name":"login","class":"join-input border-color-4 text-color-1","placeholder":"Choose Name"}],["div",{"class":"error-message error"}]]],["div",{"class":"row"},[["input",{"type":"text","name":"email","class":"join-input border-color-4 text-color-1","placeholder":"Email Address"}],["div",{"class":"error-message error"}]]],["if",{"empty":""},[["div",{"class":"row"},[["input",{"type":"password","name":"password","class":"join-input border-color-4 text-color-1","placeholder":"Type your password"}],["div",{"class":"error-message error"}]]]],[["siteProps.freeJoin","empty",true,[],"env"]]]]]],[["id","empty",true,[],"member"]]],["if",{"notempty":""},[["import",{"name":"choice_membership_plan"}],["import",{"name":"sitepage_join_form_upgrade"}],["else",{},[["if",{"empty":""},[["import",{"name":"choice_membership_plan"}],["import",{"name":"sitepage_join_form_submit"}],["else",{},[["import",{"name":"sitepage_join_form_submit"}]]]],[["siteProps.freeJoin","empty",true,[],"env"]]]]]],[["id","notempty",true,[],"member"]]],["div",{"class":"global-title text-color-1 join-txt"},[["div",{"class":"","data-fox-alias":"joinContentText"},[["p",{},[["textNode",{"text":" I Want To Show You Something Special. Don't Keep Me Waiting,"}]]],["p",{},[["textNode",{"text":"Come Inside."}]]]]]]]]],["div",{"style":"display: none;","id":"biller-form-container"}]]);
fox.registerTemplate("sitepage_join_form_option", [["div",{"class":"item"},[["if",{"notempty":"","addclass":"discount-price"},[],[["discountParams","notempty",true]]],["if",{"notempty":"","addclass":"checked"},[],[["default","notempty",true]]],["input",{"name":"joinOptions","type":"radio","id":"joinOption_&&0&&","value":"","class":""},[],[["id","id"],["id","value",true]]],["div",{"class":"discount"},[["div",{"class":"heart"},[["p",{},[["textNode",{"text":"-"}],["span",{},[],[["discountParams.discount","__text",true,[{"name":"number_format","params":[" 0"]}]]]],["textNode",{"text":"%"}]]],["img",{"src":"" + __webpack_require__(1216) + "","alt":"logo"}]]],["div",{"class":"burst-1"},[["div",{"class":"burst-2"},[["textNode",{"text":"-"}],["span",{},[],[["discountParams.discount","__text",true,[{"name":"number_format","params":[" 0"]}]]]],["textNode",{"text":"%"}]]]]],["if",{"notempty":""},[["div",{"class":"discount-description"},[["div",{"class":"burst-1"},[["div",{"class":"burst-2"}]]],["textNode",{"text":" "}],["span",{},[],[["discountParams.title","__text",true]]],["textNode",{"text":" "}]]],["else",{"addclass":"wo_descr"}]],[["discountParams.title","notempty",true]]]]],["div",{"class":"price-block text-color-1 "},[["if",{"notempty":""},[["div",{"class":"price"},[["span",{},[],[["currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["settings.viewData","__text",true]]],["textNode",{"text":"/mo"}]]],["div",{"class":"dprice"},[["span",{},[],[["currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["discountParams.discountPrice","__text",true]]],["textNode",{"text":"/mo"}]]],["else",{},[["div",{"class":"price"},[["span",{},[],[["currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["settings.initialAmount","__text",true]]]]],["div",{"class":"dprice"},[["span",{},[],[["currency","__text",true,[{"name":"currencyFormat","params":[]}]]]],["span",{},[],[["discountParams.discountPrice","__text",true]]]]]]]],[["type","notempty",true,[{"name":"eq","params":["recurring"]}]]]]]],["div",{"class":"descr"},[["p",{"class":"title text-color-1"},[["span",{},[],[["title","__text",true]]]]],["if",{"notempty":""},[["p",{"class":"text"},[["span",{},[],[["description","__text",true]]]]],["else",{},[["p",{"class":"text"},[["textNode",{"text":"&nbsp;"}]]]]]],[["description","notempty",true,[{"name":"count","params":["gt","0"]}]]]]]]]]]);
fox.registerTemplate("sitepage_join_form_billing", [["form",{"id":"biller-form","action":"","method":""},[],[["billerUrl","action",true],["formMethod","method",true]]]]);
fox.registerTemplate("sitepage_join_form_billing_row", [["input",{"type":"hidden","value":"","name":""},[],[["val","value",true],["key","name",true]]]]);
fox.registerTemplate("sitepage_join_form_error_row", [["div",{},[["span",{},[],[["message","__text",true]]]]]]);
fox.registerTemplate("sitepage_join_form_pager", [["foreach",{"from":"","item":"item"},[["span",{"class":"bg-color-1"},[["if",{"notempty":"","addclass":"active"},[],[["item.active","notempty",true]]]]]],[["bullets","from",true]]]]);
fox.registerTemplate("choice_membership_plan", [["h2",{"class":"global-title text-color-1"},[["textNode",{"text":"Select Join Option"}]]],["div",{"class":"join-options-container"},[["a",{"class":"arr lt text-color-1","data-direction":"prev"},[["i",{"class":"icon-au_pager_left_arw"}]]],["a",{"class":"arr rt text-color-1","data-direction":"next"},[["i",{"class":"icon-au_pager_right_arw"}]]],["div",{"class":"border-color-4 join-options-swipe-wrapper","id":"swipe"},[["div",{"class":"items join-options"}]]],["div",{"class":"join-options-pager"},[["div",{"class":"line lt border-color-4"}],["div",{"class":"bullets"}],["div",{"class":"line rt border-color-4"}]]]]]]);
fox.registerTemplate("sitepage_join_form_submit", [["a",{"class":"common-btn text-color-1 border-color-3 bg-color-2 submit"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["input",{"type":"submit","class":"submit-btn","value":"Join now","id":"join-form-submit"}]]]]);
fox.registerTemplate("sitepage_join_form_upgrade", [["a",{"class":"common-btn text-color-1 border-color-3 bg-color-2 submit"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["input",{"type":"submit","class":"submit-btn","value":"Upgrade now","id":"join-form-submit"}]]],["div",{"class":"vat-eu"},[["textNode",{"text":"You may be charged VAT if you are in EU."}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/heart.svg", __webpack_require__.p + "_/_/_/root/images/heart.svg");

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_liveshow", [["div",{"class":"pad-lr pad-tb content-page"},[["div",{"id":"liveshow-banner-container","class":"liveshow-banner-container"}],["div",{"id":"flash-player-liveshow"}],["div",{"class":"content-report"}],["div",{"id":"conversation"}],["div",{"id":"recorded-liveshows","class":"recorded-liveshows "}],["div",{"id":"join-banner"}]]],["div",{"id":"newsletter-container"}],["div",{"class":"join-banner-wrpper"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("liveshowbanner", [["div",{"class":"global-title text-color-2","data-fox-alias":"liveshowsTitle","data-fox-context":"liveshows"},[["textNode",{"text":"Live Show"}]]],["div",{"class":"border-color-3-trans-20 liveshow-banner &&0&& &&1&& &&2&&"},[["if",{"notempty":"","addclass":""},[["if",{"notempty":"","addclass":"private"},[["if",{"notempty":"","addclass":"private-ls-allowed"},[],[["liveShowAllowed","notempty",true]]]],[["addVars.private","notempty",true,[{"name":"eq","params":["1"]}]]]],["else",{},[["if",{"notempty":"","addclass":"&&1&&_unlogged"},[["else",{"addclass":""},[],[["success.status","addclass",true]]]],[["success.status","notempty",true,[{"name":"eq","params":["inited"]}]],["success.status","addclass"]]]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]],["success.status","addclass",true]]],["if",{"notempty":"","addclass":"streamate"},[],[["restrictNotStreamate","notempty",true,[],"env"]]],["div",{"class":"ban-head"},[["div",{"class":"title-block"},[["div",{"class":"noliveshow-block text-color-3-trans-50"},[["h2",{},[["textNode",{"text":"NO LIVE SHOW SCHEDULED AT THE MOMENT"}]]]]],["if",{"notempty":""},[["div",{"class":"liveshow-title text-color-2"},[["textNode",{"text":" "}],["span",{},[],[["addVars.title","__text",true]]],["textNode",{"text":" "}]]],["else",{},[["if",{"empty":""},[["div",{"class":"liveshow-title text-color-2"},[["h2",{},[["textNode",{"text":"The next live show will take place on"}]]]]],["else",{"addclass":"no-title"}]],[["success.status","empty",true,[{"name":"eq","params":["inited"]}]]]]]]],[["addVars.title","notempty",true]]]]],["div",{"class":"banner-cam"},[["if",{"notempty":""},[["div",{"class":"private text-color-1"},[["textNode",{"text":"Private"}]]]],[["addVars.private","notempty",true,[{"name":"eq","params":["1"]}]]]],["div",{"class":"cam-wrapper"},[["div",{"class":"bg-color-2 text-color-1 stripe lt"},[["h3",{},[["p",{"class":"txt-1"},[["textNode",{"text":"Make your deepest fantasies"}]]],["p",{"class":"txt-2"},[["textNode",{"text":"come true"}]]]]]]],["div",{"class":"bg-color-2 text-color-1 stripe rt"},[["p",{"class":"txt-2"},[["textNode",{"text":"Watch me do"}]]],["p",{"class":"txt-1"},[["textNode",{"text":"whatever you desire"}]]]]],["div",{"class":"box"},[["div",{"class":"side lt"}],["div",{"class":"side rt"}],["div",{"class":"side top"}],["div",{"class":"cam"}]]]]]]]]],["div",{"class":"ban-content clearfix","id":"ban-content"},[["div",{"class":"scheduled-date"},[["div",{"class":"cont time-cont show-start-time"}],["p",{"class":"cont date-cont"},[["strong",{"class":"date"},[["span",{},[],[["addVars.startDate","__text",true]]]]],["textNode",{"text":" "}],["i",{"class":"icon-au_datapicker text-color-3"}]]]]],["div",{"class":"show-streamate"},[["p",{"class":"state text-color-2"},[["strong",{},[["textNode",{"text":"Private Live Show in Progress"}]]]]],["if",{"empty":""},[["if",{"notempty":""},[["if",{"notempty":""},[["a",{"target":"_blank","rel":"nofollow","href":"","class":"common-btn login text-color-1 border-color-3 bg-color-2"},[["textNode",{"text":"Request a Private Show"}]],[["siteProps.streamate_join_url","href",true,[],"env"]]]],[["siteProps.streamate_join_url","notempty",true,[],"env"]]]],[["id","notempty",true,[],"member"]]]],[["mobile","empty",true]]]]],["div",{"class":"guest-msg text-color-2"},[["if",{"empty":""},[["if",{"notempty":""},[["p",{},[["strong",{},[["textNode",{"text":"I'm in a private show right now"}]]]]],["p",{},[["textNode",{"text":"Message me and book yours today!"}]]],["else",{},[["p",{},[["strong",{},[["h2",{},[["textNode",{"text":"Live Show in progress"}]]]]]]]]]],[["addVars.private","notempty",true,[{"name":"eq","params":["1"]}]]]],["else",{},[["p",{},[["i",{"class":"icon-au_error text-color-3"}],["textNode",{"text":" "}],["strong",{},[["textNode",{"text":"Show is Delayed"}]]]]],["p",{},[["textNode",{"text":"Please wait just a little bit longer and get ready for action!"}]]]]]],[["success.status","empty",true,[{"name":"eq","params":["delayed"]}]]]],["div",{"class":"mobile"},[["p",{},[["strong",{},[["textNode",{"text":"Please note!"}]]]]],["p",{},[["textNode",{"text":"Live Show streaming requires Adobe Flash Player, which is not commonly supported by mobile devices. For best performance, watch Live Shows on a desktop computer."}]]]]]]]]],["if",{"notempty":""},[["div",{"class":"action-wrapper"},[["if",{"notempty":""},[["a",{"href":"","target":"_blank","rel":"nofollow","class":"mc-common-button"},[["i",{"class":"icon-au_addToCalendar_20"}],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Add to calendar"}]]]],[["googleCalendarLink","href",true]]],["else",{},[["a",{"href":"","class":"mc-common-button"},[["i",{"class":"icon-au_addToCalendar_20"}],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Reserve your seat"}]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]]]]],[["id","notempty",true,[],"member"]]]]]],[["success.status","notempty",true,[{"name":"eq","params":["next_liveshow"]}]]]]],[["success.status","class"],["mobile","class"],["addVars.streamate.status","class"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_liveshow_recorded_liveshows_container", [["h2",{"class":"title_block"},[["textNode",{"text":"Latest Shows"}]]],["div",{"id":"list","class":"liveshows-list"}],["div",{"id":"pager","class":"pagination"}]]);
fox.registerTemplate("sitepage_liveshow_recorded_liveshows_row", [["div",{"class":"item"},[["div",{"class":"thumb"},[["a",{"href":"#!/scene/&&0&&"},[["if",{"empty":"","addattr":"href:&&1&&"},[],[["id","empty",true,[],"member"],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["img",{"class":"time-line-sprite lazyload","data-src":"","alt":""},[],[["_resources.primary.url","data-src",true],["title","alt",true]]],["textNode",{"text":" "}],["span",{"class":"play"}]],[["id","href"]]]]],["a",{"class":"sc-title","href":"#!/scene/&&0&&"},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["if",{"empty":"","addattr":"href:&&1&&"},[],[["id","empty",true,[],"member"],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]]],[["id","href"]]],["div",{"class":"fright"},[["div",{},[["span",{},[["textNode",{"text":"Recorded:"}]]],["textNode",{"text":" "}],["span",{"class":"stats_content2"},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateFormat","params":["%b %d, %Y"]}]]]]]]]],["div",{"class":"fright"},[["span",{},[["textNode",{"text":"Length:"}]]],["textNode",{"text":" "}],["span",{"class":"stats_content2"},[["span",{},[],[["length","__text",true,[{"name":"timeLength","params":[]}]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_login", [["div",{"class":"login-form-wrapper pad-tb pad-lr"},[["div",{"class":"loginform_container"}],["div",{"class":"forgotform_container","style":"display: none;"}]]],["div",{"class":"clear"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("pager", [["div",{"class":"unlogged-buttons"},[["span",{"class":"line lt"}],["textNode",{"text":" "}],["a",{"class":"join-btn bg-color-2 text-color-1","href":""},[["div",{},[["p",{"data-fox-alias":"pagerJoinImg"},[["textNode",{"text":"Join Now!"}]]]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]],["textNode",{"text":" "}],["span",{"class":"line rt"}]]],["div",{"class":"unlogged-buttons"},[["span",{"class":"line lt"}],["if",{"empty":""},[["a",{"href":"","class":"join-btn bg-color-2 text-color-1"},[["div",{},[["p",{"data-fox-alias":"pagerContinueImg"},[["textNode",{"text":"Continue Tour"}]]]]]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]],["else",{},[["if",{"notempty":"","addattr":"data-page:&&1&&","addclass":"pager-click"},[],[["next","notempty",true,[{"name":"lte","params":["3"]}]],["next","__internal"]]],["a",{"class":"join-btn bg-color-2 text-color-1"},[["div",{},[["p",{"data-fox-alias":"pagerContinueImg"},[["textNode",{"text":"Continue Tour"}]]]]],["if",{"notempty":"","addattr":"href:&&1&&"},[],[["next","notempty",true,[{"name":"gte","params":["4"]}]],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]]]]]]],[["next","empty",true]]],["span",{"class":"line rt"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("pagerlogged", [["div",{"class":"pager border-color-3-trans-20"},[["div",{"class":"pager-wrapp border-color-3-trans-20"},[["a",{"class":"arr prev-arr pager-num border-color-3-trans-20 text-color-3","data-page":""},[["if",{"empty":"","addclass":"disabled"},[],[["prev","empty",true]]],["if",{"notempty":"","addclass":"pager-click"},[],[["prev","notempty",true]]],["i",{"class":"icon-au_pager_left_arw"}]],[["prev","data-page",true]]],["div",{"class":"pager-list"},[["if",{"notempty":""},[["a",{"class":"pager-click border-color-3-trans-20 pager-num text-color-4","data-page":""},[["span",{},[],[["first","__text",true]]]],[["first","data-page",true]]],["textNode",{"text":" "}],["span",{"class":"pager-num bull text-color-4"},[["textNode",{"text":"..."}]]]],[["startSpacer","notempty",true]]],["foreach",{"from":"","item":"page"},[["if",{"notempty":"","math":""},[["span",{"class":"current text-color-5 border-color-3-trans-20 pager-num"},[["span",{},[],[["page.page","__text",true]]]]],["else",{},[["a",{"class":"pager-click pager-num border-color-3-trans-20 text-color-3","data-page":""},[["span",{},[],[["page.page","__text",true]]]],[["page.page","data-page",true]]]]]],[["page.current","notempty",true]]]],[["pages","from",true]]],["if",{"notempty":""},[["span",{"class":"bull border-color-3-trans-20 pager-num text-color-3"},[["textNode",{"text":"..."}]]],["textNode",{"text":" "}],["a",{"class":"pager-click pager-num border-color-3-trans-20 text-color-3","data-page":""},[["span",{},[],[["total","__text",true]]]],[["total","data-page",true]]]],[["endSpacer","notempty",true]]]]],["a",{"class":"arr next-arr pager-num border-color-3-trans-20 text-color-3","data-page":""},[["if",{"empty":"","addclass":"disabled"},[],[["next","empty",true]]],["if",{"notempty":"","addclass":"pager-click"},[],[["next","notempty",true]]],["i",{"class":"icon-au_pager_right_arw"}]],[["next","data-page",true]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_passwordrecovery", [["div",{"class":"login-form-wrapper pad-tb pad-lr"},[["div",{"class":"forgotform_container","id":"password-recovery-form"}]]],["div",{"class":"clear"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_personal_policy", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"PersonalTitle","data-fox-context":"personal"},[["textNode",{"text":"Personal Data Policy"}]]]]],["div",{"data-fox-alias":"personalText","class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_photosets", [["div",{"class":"content-block pad-lr pad-tb","id":"last_added_photosets","itemscope":"","itemtype":"http://schema.org/ImageGallery"}],["div",{"class":"clear"}],["div",{"id":"newsletter-container"}],["div",{"class":"join-banner-wrpper"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("item_photoset", [["div",{"class":"bg-color-3 text-color-1 item photoset wide","itemscope":"","itemtype":"http://schema.org/ImageObject"},[["span",{"itemprop":"author","style":"display:none","itemscope":"","itemtype":"http://schema.org/Person"},[["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]],["textNode",{"text":" "}],["a",{"href":"","class":"img"},[["img",{"data-src":"","class":"empty-img lazyload","alt":"","itemprop":"thumbnail","content":""},[],[["_resources.primary.url","data-src",true],["title","alt",true],["_resources.primary.url","content",true]]]],[["generatedContentLink","href",true]]],["div",{"class":"info"},[["a",{"href":"","class":"title text-color-1","itemprop":"name"},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}]],[["generatedContentLink","href",true]]],["div",{"class":"data"},[["div",{"class":"total"},[["span",{"class":"num"},[["span",{},[],[["length","__text",true]]]]],["textNode",{"text":" "}],["span",{"class":"pics"},[["textNode",{"text":"pics"}]]]]],["div",{"class":"added","itemprop":"datePublished","content":""},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["sites.publishDate","content",true]]],["div",{"class":"socials"},[["span",{"class":"likes"},[["span",{},[],[["_socialParams.likes","__text",true]]],["i",{"class":"ico icon-au_like"}]]],["textNode",{"text":" "}],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["span",{},[],[["_socialParams.totalComments","__text",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]]]]]);
fox.registerTemplate("sitepage_photosets_photoset", [["div",{"class":"item item_video clearfix","itemscope":"","itemtype":"http://schema.org/ImageObject"},[["span",{"itemprop":"author","style":"display:none","itemscope":"","itemtype":"http://schema.org/Person"},[["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]],["div",{"class":"clearfix"},[["h2",{"class":"fleft"},[["a",{"itemprop":"name"},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addattr":"href:#!/gallery/&&1&&"},[["if",{"notempty":"","addattr":"href:/gallery/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["else",{"addattr":"href:&&0&&"},[],[["siteProps.ubs.joinUrl","__internal",false,[],"env"]]]],[["id","notempty",true,[],"member"],["id","addattr"]]]]]]],["div",{"class":"add fright clearfix"},[["textNode",{"text":" Added: "}],["span",{"itemprop":"datePublished","content":""},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["sites.publishDate","content",true]]]]]]],["div",{"class":"clearfix"},[["div",{"class":"fleft primesize"},[["a",{},[["img",{"class":"lazyload","data-src":"","alt":"","itemprop":"thumbnail","content":""},[],[["_resources.primary.url","data-src",true],["_resources.primary.altTag","alt",true],["_resources.primary.url","content",true]]],["if",{"notempty":"","addattr":"href:#!/gallery/&&1&&"},[["if",{"notempty":"","addattr":"href:/gallery/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["else",{"addattr":"href:&&0&&"},[],[["siteProps.ubs.joinUrl","__internal",false,[],"env"]]]],[["id","notempty",true,[],"member"],["id","addattr"]]]]]]],["div",{"class":"photo_thumb fright"},[["ul",{"class":"photoset_&&0&&"},[],[["id","class"]]]]]]],["p",{"itemprop":"description"},[["span",{},[],[["description","__text",true,[{"name":"truncate","params":["320","..."]}]]]]]],["div",{"class":"party fleft"},[["textNode",{"text":" Number of pictures: "}],["span",{"id":"pic_num"},[["span",{},[],[["_resources.base","__text",true,[{"name":"count","params":[]}]]]]]]]]]]]);
fox.registerTemplate("sitepage_photosets_photoitems", [["li",{"class":""},[["a",{"class":"fancy_thumb","href":""},[["img",{"itemprop":"image","class":"img","src":"","alt":""},[],[["url","src",true],["altTag","alt",true]]]],[["bigUrl","href",true]]]],[["style","class",true]]]]);
fox.registerTemplate("sitepage_photosets_photoset_simple", [["div",{"class":"item item_video clearfix","itemscope":"","itemtype":"http://schema.org/ImageObject"},[["span",{"itemprop":"author","style":"display:none","itemscope":"","itemtype":"http://schema.org/Person"},[["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]],["div",{"class":"clearfix"},[["h2",{"class":"fleft"},[["a",{"itemprop":"name"},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addattr":"href:#!/gallery/&&1&&"},[["if",{"notempty":"","addattr":"href:/gallery/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["else",{"addattr":"href:&&0&&"},[],[["siteProps.ubs.joinUrl","__internal",false,[],"env"]]]],[["id","notempty",true,[],"member"],["id","addattr"]]]]]]],["div",{"class":"add fright clearfix"},[["textNode",{"text":" Added: "}],["span",{"itemprop":"datePublished","content":""},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["sites.publishDate","content",true]]]]]]],["div",{"class":"clearfix"},[["div",{"class":"fleft primesize"},[["a",{},[["img",{"itemprop":"thumbnail","content":"","data-src":"","alt":"","class":"lazyload"},[],[["_resources.primary.url","content",true],["_resources.primary.url","data-src",true],["_resources.primary.altTag","alt",true]]],["if",{"notempty":"","addattr":"href:#!/gallery/&&1&&"},[["if",{"notempty":"","addattr":"href:/gallery/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["else",{"addattr":"href:&&0&&"},[],[["siteProps.ubs.joinUrl","__internal",false,[],"env"]]]],[["id","notempty",true,[],"member"],["id","addattr"]]]]]]],["div",{"class":"photo_thumb fright"},[["ul",{"class":"photoset_&&0&&"},[["foreach",{"from":"","item":"base"},[["li",{"class":"width1"},[["a",{},[["img",{"itemprop":"image","class":"img lazyload","data-src":"","alt":""},[],[["base.url","data-src",true],["base.altTag","alt",true]]]]]]]],[["_resources.base","from",true]]]],[["id","class"]]]]]]],["p",{"itemprop":"description"},[["span",{},[],[["description","__text",true,[{"name":"truncate","params":["320","..."]}]]]]]],["div",{"class":"party fleft"},[["textNode",{"text":" Number of pictures: "}],["span",{"id":"pic_num"},[["span",{},[],[["length","__text",true]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_post", [["div",{"class":"content-page post-page","id":"post-container"}],["div",{"id":"newsletter-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_post_container", [["div",{"class":"pad-lr pad-tb clearfix"},[["div",{"id":"right-blog-info","class":"blog-post-sidebar"}],["div",{"id":"post-list-container","class":"post-container","itemscope":"","itemtype":"https://schema.org/BlogPosting"}]]]]);
fox.registerTemplate("blog_sidebar_main_template", [["div",{"id":"last-post-comments","class":"last-comments"}],["div",{"id":"most-popular-post"}]]);
fox.registerTemplate("blog_last_comments_container", [["div",{"class":"global-title"},[["textNode",{"text":"Latest comments"}]]],["div",{"class":"list"}]]);
fox.registerTemplate("blog_last_popular_posts_container", [["div",{"class":"global-title"},[["textNode",{"text":"Most popular posts"}]]],["div",{"class":"list blog"}]]);
fox.registerTemplate("sitepage_post_selected_post", [["h2",{"class":"global-title","itemprop":"name"},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["if",{"empty":""},[["textNode",{"text":" Untitled "}]],[["title","empty",true]]]]],["div",{"class":"date","itemprop":"datePublished","content":""},[["span",{},[],[["publishDate","__text",true,[{"name":"dateFormat","params":["%B %e, %Y"]}]]]]],[["publishDate","content",true]]],["h3",{"class":"post-content"},[["foreach",{"from":"","item":"item"},[["div",{"id":"content-container-&&0&&"},[],[["item.id","id"]]]],[["contents","from",true]]]]],["div",{"class":"tags content-info"},[["if",{"empty":""},[["h4",{"class":"tags"},[["span",{"class":"label"},[["textNode",{"text":"Tags:&nbsp;"}]]],["foreach",{"from":"","item":"tag"},[["a",{"class":"text-link"},[["span",{},[],[["tag.title","__text",true]]]]],["if",{"empty":""},[["textNode",{"text":", "}]],[["tag._last","empty",true]]]],[["tags","from",true]]]]]],[["tags","empty",true,[{"name":"count","params":[]},{"name":"eq","params":["0"]}]]]]]],["div",{"class":"content-actions new-wrap"},[["div",{"class":"rating","data-target-id":""},[],[["id","data-target-id",true]]],["div",{"class":"tipme-container"}],["div",{"class":"content-report"}]]],["if",{"notempty":""},[["div",{"id":"comment-form","class":"comments-block fleft reviews","data-target-id":""},[],[["id","data-target-id",true]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]]]);
fox.registerTemplate("latest_comm_row", [["div",{"class":"lc-comment-item border-color-3-trans-20 text-color-2"},[["div",{"class":"lc-post"},[["strong",{},[["textNode",{"text":" Post: "}],["a",{"class":"text-color-3","href":"/#!/post/&&0&&","itemprop":"name"},[["span",{},[],[["post.title","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addattr":"href:/post/&&1&&/&&2&&"},[],[["post.title","notempty",true],["post.id","addattr"],["post.title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]]],[["post.id","href"]]]]]]],["div",{"class":"lc-date"},[["span",{"itemprop":"datePublished","content":""},[["span",{},[],[["date","__text",true,[{"name":"dateFormat","params":["%B %e, %Y"]}]]]],["textNode",{"text":"."}]],[["publishDate","content",true]]],["textNode",{"text":" "}],["span",{"itemprop":"name"},[["span",{},[],[["name","__text",true]]]]]]],["div",{},[["if",{"notempty":""},[["div",{},[["span",{},[],[["comment","__text",true,[{"name":"truncate","params":["160","..."]}]]]],["textNode",{"text":" "}],["a",{"class":"toggle-comment pointer"},[["textNode",{"text":"more"}]]]]],["div",{"style":"display: none;","itemprop":"description"},[["span",{},[],[["comment","__text",true]]],["textNode",{"text":" "}],["a",{"class":"toggle-comment pointer"},[["textNode",{"text":"less"}]]]]],["else",{},[["span",{"itemprop":"description"},[["span",{},[],[["comment","__text",true]]]]]]]],[["comment","notempty",true,[{"name":"count","params":[]},{"name":"gt","params":["160"]}]]]]]]]]]);
fox.registerTemplate("latest_posts_row", [["div",{"class":"post-item border-color-3-trans-20 text-color-2"},[["a",{"href":"#!/post/&&0&&"},[["if",{"notempty":"","addattr":"href:/post/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["strong",{"class":"text-color-4","itemprop":"name"},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["if",{"empty":""},[["textNode",{"text":" Untitled "}]],[["title","empty",true]]]]]],[["id","href"]]],["foreach",{"from":"","item":"shItem"},[["if",{"notempty":""},[["div",{"class":"thumb","itemscope":"","itemtype":"http://schema.org/Product"},[["a",{"class":"img-content","href":"/#!/post/&&0&&"},[["if",{"notempty":"","addattr":"href:/post/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["img",{"itemprop":"image","data-src":"","alt":"&&1&&-&&2&&-&&3&&","class":"lazyload"},[],[["shItem.content","data-src",true],["id","alt"],["title","alt"],["name","alt",false,[],"client"]]]],[["id","href"]]]]]],[["shItem.type","notempty",true,[{"name":"eq","params":["3"]}]]]]],[["_shortContent.collection","from",true]]],["ul",{"class":"stats","itemprop":"review","itemscope":"","itemtype":"http://schema.org/Review"},[["if",{"notempty":""},[["li",{"class":"background-color-3-after","itemprop":"reviewRating"},[["span",{},[],[["rating.voters","__text",true]]],["textNode",{"text":" likes"}]]],["else",{},[["li",{"class":"background-color-3-after","itemprop":"reviewRating"},[["textNode",{"text":"0 likes"}]]]]]],[["rating.voters","notempty",true]]],["if",{"notempty":""},[["li",{"class":"background-color-3-after","itemprop":"reviewRating"},[["span",{},[],[["comments.total","__text",true]]],["textNode",{"text":" comments"}]]],["else",{},[["li",{"class":"background-color-3-after","itemprop":"reviewRating"},[["textNode",{"text":"0 comments"}]]]]]],[["comments.total","notempty",true]]],["if",{"notempty":""},[["li",{"class":"background-color-3-after","itemprop":"reviewCount"},[["span",{},[],[["views","__text",true]]],["textNode",{"text":" views"}]]],["else",{},[["li",{"itemprop":"reviewCount"},[["textNode",{"text":"0 views"}]]]]]],[["views","notempty",true]]]]],["foreach",{"from":"","item":"shItem"},[["if",{"empty":""},[["div",{"class":"short-text pb","itemprop":"description"},[["textNode",{"text":" "}],["span",{},[],[["shItem.content","__text",true,[{"name":"truncate","params":["100","..."]},{"name":"html","params":[]}]]]],["textNode",{"text":" "}]]]],[["shItem.type","empty",true,[{"name":"eq","params":["3"]}]]]]],[["_shortContent.collection","from",true]]]]]]);
fox.registerTemplate("sitepage_post_selected_post_111", [["div",{"class":"title_block","itemprop":"name"},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["if",{"empty":""},[["textNode",{"text":" Untitled "}]],[["title","empty",true]]]]],["span",{"class":"date","itemprop":"datePublished","content":""},[["span",{},[],[["publishDate","__text",true,[{"name":"dateFormat","params":["%B %e, %Y"]}]]]]],[["publishDate","content",true]]],["div",{"class":"post-content"},[["foreach",{"from":"","item":"item"},[["div",{"id":"content-container-&&0&&"},[],[["item.id","id"]]]],[["contents","from",true]]]]],["div",{"class":"share clearfix"},[["div",{"class":"tipme-container fleft"}],["div",{"class":"rating likes-comments fright","data-target-id":""},[],[["id","data-target-id",true]]]]],["div",{"id":"comment-form","class":"comments-block fleft reviews","data-target-id":""},[],[["id","data-target-id",true]]]]);
fox.registerTemplate("sitepage_post_content_itemphoto", [["div",{"class":"content-img"},[["img",{"itemprop":"image","data-src":"","alt":"post-&&1&&-&&2&&","class":"lazyload"},[],[["content","data-src",true],["postId","alt"],["name","alt",false,[],"client"]]]]],["if",{"notempty":""},[["div",{"class":"content-description"},[["textNode",{"text":" "}],["span",{},[],[["description","__text",true]]],["textNode",{"text":" "}]]]],[["description","notempty",true]]]]);
fox.registerTemplate("sitepage_post_content_html", [["div",{"class":"pl-text","itemscope":"","itemtype":"https://schema.org/BlogPosting"},[["span",{},[],[["content","__text",true,[{"name":"html","params":[]}]]]]]]]);
fox.registerTemplate("sitepage_post_content_itemvideo", [["div",{"id":"","itemscope":"","itemtype":"http://schema.org/VideoObject"},[],[["videoContainer","id",true]]],["if",{"notempty":""},[["div",{"class":"content-description","itemprop":"description"},[["textNode",{"text":" "}],["span",{},[],[["description","__text",true]]],["textNode",{"text":" "}]]]],[["description","notempty",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("small_preloader", [["div",{"class":"item item_video clearfix"},[["div",{"class":"clearfix"},[["div",{"class":"fleft but_play"},[["img",{"src":"" + __webpack_require__(6) + "","class":"preload-thumb","style":"width:550px"}],["div",{"class":"preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]],["div",{"class":"video_thumb fright"},[["ul",{},[["li",{},[["img",{"src":"" + __webpack_require__(6) + "","class":"preload-thumb","style":"width:170px"}],["div",{"class":"preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]],["li",{},[["img",{"src":"" + __webpack_require__(6) + "","class":"preload-thumb","style":"width:170px"}],["div",{"class":"preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]],["li",{},[["img",{"src":"" + __webpack_require__(6) + "","class":"preload-thumb","style":"width:170px"}],["div",{"class":"preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]],["li",{},[["img",{"src":"" + __webpack_require__(6) + "","class":"preload-thumb","style":"width:170px"}],["div",{"class":"preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]],["li",{},[["img",{"src":"" + __webpack_require__(6) + "","class":"preload-thumb","style":"width:170px"}],["div",{"class":"preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]],["li",{},[["img",{"src":"" + __webpack_require__(6) + "","class":"preload-thumb","style":"width:170px"}],["div",{"class":"preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]]]]]]]]]]]);
fox.registerTemplate("photos_preloader", [["div",{"class":"item"},[["img",{"src":"" + __webpack_require__(1230) + "","class":"preload-thumb"}],["div",{"class":"preload"},[["div",{"id":"bg-spin","class":"pie"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie "}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie"}]]]]],["div",{"class":"loadtxt"},[["textNode",{"text":"Loading"}]]]]]]]]);
fox.registerTemplate("big_preloader", [["div",{"class":"preloader-block"},[["div",{"class":"big-preload"},[["div",{"id":"bg-spin","class":"pie border-color-3"}],["div",{"id":"left-spin"},[["div",{"class":"spin"},[["div",{"class":"pie border-color-2"}]]]]],["div",{"id":"right-spin"},[["div",{"class":"spin"},[["div",{"class":"pie border-color-2"}]]]]],["div",{"class":"loadtxt text-color-4"},[["textNode",{"text":"Loading"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/pic_preload.gif", __webpack_require__.p + "_/_/_/root/images/pic_preload.gif");

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_privacy", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"PrivacyTitle","data-fox-context":"privacy"},[["textNode",{"text":"Website Privacy Policy"}]]]]],["div",{"data-fox-alias":"privacyText","class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_purchases", [["div",{"class":"site-page favorites no-pb"},[["section",{"class":"purchases"}]]]]);
fox.registerTemplate("purchases_grid", [["div",{"class":"block background-color-1 purchases-list-page"},[["div",{"class":"pad-lr pad-tb"},[["div",{"class":"block-title global-title background-color-2 title-with-filter"},[["textNode",{"text":"My purchases"}]]],["div",{"class":"clearfix"},[["div",{"class":"items store-list-wrapper content-list clearfix grid"},[["div",{"class":"product-list"},[["div",{"class":"content-grid store-grid purchases-list"},[["div",{"class":"store-item"}]]],["div",{"class":"pager-wrapper pagination"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_scene", [["div",{"id":"scenes-player","class":"content-page scene"}],["div",{"id":"newsletter-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("model_backlinks_container", [["div",{"class":"","id":"starring"},[["span",{},[["span",{},[],[["starringTitle","__text",true]]],["textNode",{"text":":&nbsp; "}],["span",{"id":"st-list"}]]]]],["if",{"notempty":""},[["div",{"id":"back-links"}]],[["id","notempty",true,[],"member"]]]]);
fox.registerTemplate("model_starring", [["span",{"class":"model-name"},[["span",{},[],[["modelId.stageName","__text",true]]]]],["if",{"empty":""},[["textNode",{"text":",&nbsp;"}]],[["_last","empty",true]]]]);
fox.registerTemplate("model_back_links", [["if",{"notempty":""},[["a",{"target":"_blank","rel":"nofollow","class":"text-link","href":""},[["span",{},[],[["modelId.upsellText","__text",true]]]],[["modelId.upsellLink","href",true]]],["if",{"empty":""},[["textNode",{"text":",&nbsp;"}]],[["_last","empty",true]]]],[["modelId.upsellLink","notempty",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_scene_currentrelatedvideo", [["div",{"class":"related-item","itemscope":"","itemtype":"http://schema.org/VideoObject"},[["a",{"class":"related-img related-position","href":"/#!/scene/&&0&&"},[["if",{"notempty":"","addattr":"href:/scene/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]],["img",{"src":"","alt":"","class":"related-img-thumb","itemprop":"thumbnail","content":""},[],[["_resources.thumb.url","src",true],["_resources.thumb.altTag","alt",true],["_resources.thumb.url","content",true]]],["textNode",{"text":" "}],["span",{"itemprop":"duration","content":"&&0&&>&&1&&</span>\n\t\t</a>\n\t\t<a class=","related-title\"":"","href":"/#!/scene/&&2&&"},[["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addattr":"href:/scene/&&1&&/&&2&&"},[],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]]],[["length","content"],["length","content",false,[{"name":"timeLength","params":["m"]}]],["id","href"]]]],[["id","href"]]],["div",{"class":"clearfix"},[["span",{"itemprop":"datePublished","content":""},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["sites.publishDate","content",true]]],["span",{"class":"related-rate","itemprop":"ratingCount>\n\t\t\t\t&&0&&\n\t\t\t\t<if notEmpty=","$[_ratings|lt:0]\"":"","addclass":"related-bad"},[],[["_ratings","itemprop",false,[{"name":"shift","params":[]}]]]]]]]]]);
fox.registerTemplate("sitepage_scene_currentrelatedvideo_container", [["h2",{"class":"related-title text-color-3"},[["textNode",{"text":"Related Videos"}]]],["div",{"class":"related-videos"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_scene_video", [["div",{"class":"mobile-switcher"}],["div",{"class":"player-block player ac-p-player","id":"flash-player"}]]);
fox.registerTemplate("sitepage_scene_content_backlink", [["if",{"notempty":""},[["div",{"class":"link content-actions text-color-3"},[["a",{"href":"","target":"_blank","rel":"nofollow"},[["i",{"class":"icon icon-au_join_right_arw"}],["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]]],[["url","href",true]]]]]],[["url","notempty",true]]]]);
fox.registerTemplate("sitepage_scene_playerblock", [["div",{"class":"pad-lr pad-tb","itemscope":"","itemtype":"http://schema.org/VideoObject"},[["div",{"class":"title-with-filter content-info"},[["div",{"class":"title-block clearfix"},[["h2",{"class":"left global-title text-color-2"},[["span",{},[],[["title","__text",true]]]]]]],["div",{"class":"right added"},[["span",{},[["textNode",{"text":"Added:"}]]],["textNode",{"text":" "}],["span",{"class":"text-color-3 date","itemprop":"datePublished","content":""},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["sites.publishDate","content",true]]]]]]],["div",{"class":"cast content-info","id":"model-backlinks"}],["div",{"class":"content-description"},[["if",{"notempty":""},[["h3",{"class":"full-desc"},[["textNode",{"text":" "}],["span",{},[],[["description","__text",true]]],["textNode",{"text":" "}],["a",{"class":"desc-toggle show-more"},[["span",{},[["textNode",{"text":"less"}]]],["textNode",{"text":" "}],["i",{"class":"root-ico_tags_arr arr"}]]]]],["h3",{"class":"short-desc"},[["textNode",{"text":" "}],["span",{},[],[["description","__text",true,[{"name":"truncate","params":["320","..."]}]]]],["textNode",{"text":" "}],["a",{"class":"desc-toggle show-more"},[["span",{},[["textNode",{"text":"more"}]]],["textNode",{"text":" "}],["i",{"class":"root-ico_tags_arr arr"}]]]]],["else",{},[["h3",{},[["span",{},[],[["description","__text",true]]]]]]]],[["description","notempty",true,[{"name":"count","params":[]},{"name":"gt","params":["320"]}]]]]]],["div",{"class":"player-block-wrapper"}],["div",{"class":"content-links"},[["div",{"class":"content-backlink item"}],["if",{"notempty":""},[["div",{"class":"item"},[["div",{"class":"link faq-link content-actions"},[["a",{"href":"/","target":"_blank"},[["span",{"class":"icon icon-au_question-mark_24"}],["textNode",{"text":" Virtual reality FAQ"}]]]]]]]],[["vr","notempty",true]]]]],["if",{"notempty":""},[["h4",{"class":"tags content-info"},[["span",{"class":"label"},[["textNode",{"text":"Tags:&nbsp;"}]]],["foreach",{"from":"","item":"item"},[["span",{},[["a",{"href":"/videos/tags=&&0&&","class":"item"},[["span",{},[],[["item.alias","__text",true]]]],[["item.alias","href"]]],["textNode",{"text":" &nbsp; "}],["if",{"empty":""},[["span",{"class":"coma"},[["textNode",{"text":", "}]]]],[["item._last","empty",true]]]]]],[["tags","from",true]]]]]],[["tags","notempty",true,[{"name":"notEmptyDl","params":[]}]]]],["import",{"name":"content_actions"}],["if",{"notempty":""},[["div",{"id":"comment-form","class":"comments-block reviews","data-target-id":""},[],[["id","data-target-id",true]]]],[["member","notempty",true,[{"name":"hasAccess","params":["member"]}]]]],["div",{"id":"last_added_videos"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_sponsor", [["div",{"class":"sponsor-page clearfix pad-t"}],["section",{"id":"newsletter-container"}],["section",{"id":"#liveshow-container","class":"next-liveshow bg-color-2 text-color-1","itemscope":"","itemtype":"http://schema.org/Event"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_terms", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"TermsTitle","data-fox-context":"terms"},[["textNode",{"text":"Website Terms-of-Use Agreement "}]]]]],["div",{"data-fox-alias":"termsText","class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_tips", [["div",{"class":"pad-tb pad-lr"},[["div",{"class":"tips-page clearfix pad-t","itemscope":"","itemtype":"http://schema.org/TipAction"},[["div",{"class":"tips-promo"},[["div",{"class":"global-title"},[["span",{"class":"icon icon-au_heart text-color-4 heart-1"}],["h2",{"data-fox-alias":"autTipsTextTitle"},[["textNode",{"text":"Show Me Your Love"}]]]]],["div",{"class":"global-title mobile"},[["p",{},[["textNode",{"text":"Tip Me"}]]]]],["div",{"class":"img-block"},[["span",{"class":"icon heart-color icon-au_heart text-color-4 heart-2"}],["div",{"data-fox-alias":"autTipsPhoto","data-fox-editor-type":"image"},[["img",{"itemprop":"image","src":"" + __webpack_require__(78) + "","alt":"tip me &&0&&"},[],[["screenName","alt",false,[],"env"]]]]],["span",{"class":"icon heart-color icon-au_heart text-color-4 heart-3"}]]],["h3",{"data-fox-alias":"autTipsMainText","class":"tips-txt","itemprop":"recipient"},[["p",{"class":"p1"},[["textNode",{"text":" I love shooting for my fans and I'm happy to be able to provide great content for my website for all you to enjoy. My lovely admirers have been asking for a way to send me gifts and tips! Everyone knows that an artist loves when his or her work is appreciated. And now I have a great new way for you to show me just how much you like my art! "}]]],["p",{"class":"p2"},[["strong",{},[["textNode",{"text":"Every fan who sends me a gift will receive a personalized love letter directly from me! Just use this form to show me your love... don’t be shy."}]]]]]]]]],["div",{"class":"tips-block"}]]]]],["div",{"id":"newsletter-container"}]]);
fox.registerTemplate("sitepage_tips_form", [["form",{"class":"tips-form","id":"tips-form","action":"#","method":"post"},[["div",{"class":"global-title tips-title text-color-1 bg-color-2"},[["span",{"class":"icon-au_m_tips"}],["p",{"data-fox-alias":"autTipsOptionsTitle"},[["textNode",{"text":"Go On And Spoil Me:"}]]]]],["div",{"class":"tips-list-container"}],["if",{"empty":""},[["div",{"class":"msg-block"},[["div",{"class":"row"},[["div",{"class":"common-input type-2"},[["input",{"type":"text","name":"login","class":"","placeholder":"Enter your nickname"}],["div",{"class":"border"}]]],["label",{"class":"err-msg"},[["textNode",{"text":"Nickname is a required field"}]]]]],["div",{"class":"row"},[["div",{"class":"common-input type-2"},[["input",{"type":"text","name":"email","class":"","placeholder":"Enter your email"}],["div",{"class":"border"}]]],["label",{"class":"err-msg"},[["textNode",{"text":"Email is a required field"}]]]]]]]],[["id","empty",true,[],"member"]]],["div",{"class":"write-comment msg-block row"},[["div",{"class":"common-input txtarea"},[["textarea",{"placeholder":"Start typing your message...","name":"tipsMessage"}],["div",{"class":"border"}]]]]],["div",{"class":"common-btn bg-color-2 text-color-1 join-submit"},[["p",{"style":"cursor: pointer;","id":"tipsSubmit","data-fox-alias":"autPayBtnText","class":"placeholder-text tips-title-color"},[["textNode",{"text":"Spoil Me"}]]]]]]],["div",{"id":"errors","class":"errors"}],["div",{"style":"display: none;","id":"biller-form-container"}]]);
fox.registerTemplate("sitepage_tips_form_item", [["h4",{"class":"item item-&&0&&"},[["if",{"notempty":""},[["div",{"class":"radio","itemprop":"actionStatus"},[["input",{"type":"radio","name":"tips","class":"fleft","id":"tip_&&0&&","value":"","checked":""},[],[["_iteration","id"],["id","value",true]]],["textNode",{"text":" "}],["span",{"class":"dot bg-color-6"}]]],["else",{},[["div",{"class":"radio"},[["input",{"type":"radio","name":"tips","class":"fleft","id":"tip_&&0&&","value":"","data-amount":""},[],[["_iteration","id"],["id","value",true],["amount","data-amount",true]]],["textNode",{"text":" "}],["span",{"class":"dot bg-color-6"}]]]]]],[["isDefault","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":"","addattr":"custom-price"},[],[["type","notempty",true,[{"name":"eq","params":["1"]}]]]],["label",{"data-amount":"","data-id":""},[["if",{"notempty":"","addattr":"for:tip_&&1&&","value":""},[],[["type","notempty",true,[{"name":"eq","params":["0"]}]],["_iteration","addattr"],["id","value",true]]],["span",{"class":"icon-au_m_tips ico text-color-4"}],["textNode",{"text":" "}],["span",{"class":"price text-color-4","itemprop":"price"},[["if",{"notempty":""},[["textNode",{"text":" $"}],["span",{},[],[["amount","__text",true]]],["textNode",{"text":" "}],["else",{"addclass":"custom-price"},[["div",{"class":"common-input type-2"},[["input",{"type":"text","name":"custom_price","alias":""},[],[["id","alias",true]]],["div",{"class":"border"}]]],["span",{"class":"err-msg text-color-4"},[["textNode",{"text":"Please enter an amount between 2 and 99999"}]]]]]],[["type","notempty",true,[{"name":"eq","params":["0"]}]]]]]],["p",{"class":"tip-option-title"},[["span",{},[],[["title","__text",true]]]]]],[["amount","data-amount",true],["id","data-id",true]]]],[["_iteration","class"]]]]);
fox.registerTemplate("sitepage_tips_form_billing", [["div",{},[["form",{"id":"biller-form","action":"","method":""},[],[["billerUrl","action",true],["formMethod","method",true]]]]]]);
fox.registerTemplate("sitepage_tips_form_billing_row", [["input",{"type":"hidden","value":"","name":""},[],[["val","value",true],["key","name",true]]]]);
fox.registerTemplate("sitepage_tips_form_error_row", [["div",{},[["span",{},[],[["message","__text",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_login", [["form",{"id":"login_form","class":"auth-form","autocomplete":"off"},[["if",{"notempty":""},[["div",{"class":"success-registration-message"},[["p",{},[["textNode",{"text":"Your account was successfully created!"}]]],["p",{},[["textNode",{"text":"Your password was e-mailed to you from "}],["a",{"href":"mailto:support@modelcentro.com"},[["textNode",{"text":"support@modelcentro.com"}]]],["textNode",{"text":"."}]]]]]],[["successfulRegistration","notempty",true]]],["div",{"class":"global-title"},[["div",{"data-fox-alias":"loginWelcomeText"},[["textNode",{"text":"Log in"}]]]]],["div",{"id":"message","class":"login-form-error-message error"}],["div",{"class":"login-form-error-message default"},[["div",{"class":"default-message"},[["p",{},[["textNode",{"text":"Sign in failed, your account is inactive."}]]],["p",{},[["textNode",{"text":"This could happen because either your membership has expired or there was a problem processing your payment."}]]],["p",{},[["textNode",{"text":"Please contact "}],["a",{"id":"_reportProblem"},[["textNode",{"text":"customer support"}]]],["textNode",{"text":" for more information."}]]]]]]],["div",{"class":"row"},[["div",{"class":"common-input icon login"},[["i",{"class":"ico icon-au_login text-color-2"}],["textNode",{"text":" "}],["input",{"type":"text","name":"le","class":"text-color-2","autocomplete":"off"}],["div",{"class":"border"}]]],["div",{"class":"error-message"}]]],["div",{"class":"row"},[["div",{"class":"common-input icon pass"},[["i",{"class":"ico icon-au_password text-color-2"}],["textNode",{"text":" "}],["input",{"type":"password","name":"password","class":"text-color-2"}],["div",{"class":"border"},[["i",{"class":"ico icon-au_password text-color-2"}]]]]],["div",{"class":"error-message"}]]],["div",{"class":"row"},[["a",{"class":"forgot text-color-3","href":"/password-recovery"},[["textNode",{"text":"Forgot password?"}]]]]],["div",{"class":"row capcha","id":"captchaBlock","style":"display: none"},[["span",{"class":"reload-captcha icon-au_site-captcha_update text-color-3","id":"reload_captcha"}],["div",{"class":"common-input icon captcha"},[["input",{"type":"text","name":"captcha"}],["div",{"class":"border"},[["div",{"id":"captcha","class":"ico"}]]]]],["div",{"class":"error-message"}]]],["div",{"class":"row btns clearfix"},[["a",{"href":"","class":"common-btn reg text-color-3 border-color-3"},[["textNode",{"text":"register"}]],[["siteProps.ubs.joinUrl","href",true,[],"env"]]],["div",{"class":"common-btn login text-color-1 border-color-3 bg-color-2 no-hover"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["div",{"data-fox-alias":"loginSubmitText"},[["textNode",{"text":"login"}]]],["input",{"type":"submit","name":"submit","value":"submit"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_notifications_manager", [["div",{"class":"user-notitfications border-color-3-trans-20"},[["div",{"class":"global-title"},[["textNode",{"text":"Notify me when:"}]]],["if",{"empty":""},[["div",{"class":"email-verification-notice"},[["p",{},[["textNode",{"text":"Please verify your email address if you would like to receive updates via email"}]]]]]],[["emailVefied","empty",true]]],["div",{"id":"email-notitfications-list"},[["div",{"class":"user-notifications-wrapper pad-b border-color-3-trans-20"},[["div",{"class":"row"},[["label",{"for":"publishVideoEmail"},[["if",{"empty":""},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"publishVideoEmail","$state":"checked_disabled"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"publishVideoEmail","$state":"disabled"}]]]],[["publishVideoEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["else",{},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"publishVideoEmail","$state":"checked"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"publishVideoEmail"}]]]],[["publishVideoEmail","notempty",true,[{"name":"eq","params":["1"]}]]]]]]],[["emailVefied","empty",true]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" publishes a new video"}]]]]]]],["div",{"class":"row"},[["label",{"for":"publishPhotosetEmail"},[["if",{"empty":""},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"publishPhotosetEmail","$state":"checked_disabled"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"publishPhotosetEmail","$state":"disabled"}]]]],[["publishPhotosetEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["else",{},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"publishPhotosetEmail","$state":"checked"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"publishPhotosetEmail"}]]]],[["publishPhotosetEmail","notempty",true,[{"name":"eq","params":["1"]}]]]]]]],[["emailVefied","empty",true]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" publishes a new photoset"}]]]]]]],["div",{"class":"row"},[["label",{"for":"startLiveshowEmail"},[["if",{"empty":""},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"startLiveshowEmail","$state":"checked_disabled"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"startLiveshowEmail","$state":"disabled"}]]]],[["startLiveshowEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["else",{},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"startLiveshowEmail","$state":"checked"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"startLiveshowEmail"}]]]],[["startLiveshowEmail","notempty",true,[{"name":"eq","params":["1"]}]]]]]]],[["emailVefied","empty",true]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" starts a live show"}]]]]]]],["div",{"class":"row"},[["label",{"for":"publishBlogPostEmail"},[["if",{"empty":""},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"publishBlogPostEmail","$state":"checked_disabled"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"publishBlogPostEmail","$state":"disabled"}]]]],[["publishBlogPostEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["else",{},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"publishBlogPostEmail","$state":"checked"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"publishBlogPostEmail"}]]]],[["publishBlogPostEmail","notempty",true,[{"name":"eq","params":["1"]}]]]]]]],[["emailVefied","empty",true]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" publishes a new blog post"}]]]]]]],["div",{"class":"row"},[["label",{"for":"sentModelMessageByEmail"},[["if",{"empty":""},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"sentModelMessageByEmail","$state":"checked_disabled"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"sentModelMessageByEmail","$state":"disabled"}]]]],[["sentModelMessageByEmail","notempty",true,[{"name":"eq","params":["1"]}]]]],["else",{},[["if",{"notempty":""},[["import",{"name":"user_notifications_manager_input","$name":"sentModelMessageByEmail","$state":"checked_disabled"}],["else",{},[["import",{"name":"user_notifications_manager_input","$name":"sentModelMessageByEmail","$state":"disabled"}]]]],[["sentModelMessageByEmail","notempty",true,[{"name":"eq","params":["1"]}]]]]]]],[["emailVefied","empty",true]]],["span",{"class":"label"},[["span",{},[],[["screenName","__text",true,[],"env"]]],["textNode",{"text":" sent a new Private message"}]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_passwordrecovery_email", [["div",{"class":"auth-form"},[["div",{"data-fox-alias":"loginWelcomeText","class":"global-title"},[["textNode",{"text":"Password Recovery"}]]],["div",{"class":"messages errors-block error common-error-text-color","style":"display: block","id":"recovery-message"}],["form",{"id":"email-form","class":"form_block","style":"display: block","autocomplete":"off"},[["div",{"class":"row"},[["p",{"class":"text-color-2"},[["textNode",{"text":"Please enter email that you used to log on to the site."}]]]]],["div",{"class":"row"},[["div",{"class":"common-input email"},[["input",{"id":"forgot-input","class":"text-color-2","type":"text","name":"email","value":""}],["div",{"class":"border"}]]],["div",{"class":"error-message"}]]],["div",{"class":"row btns clearfix"},[["button",{"type":"submit","class":"common-btn login text-color-1 border-color-3 bg-color-2 loader","id":"submit-btn"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["textNode",{"text":" submit "}]]]]]]]]]]);
fox.registerTemplate("user_passwordrecovery_confirmation", [["div",{"class":"auth-form"},[["div",{"data-fox-alias":"loginWelcomeText","class":"global-title"},[["textNode",{"text":"Password Recovery"}]]],["div",{"class":"messages errors-block error common-error-text-color","style":"display: block","id":"recovery-message"}],["if",{"empty":""},[["form",{"id":"confirmation-form","name":"confirmation_form","class":"form_block","style":"display: block","autocomplete":"off"},[["div",{"class":"row"},[["p",{},[["textNode",{"text":"Please enter your new password and confirm new password."}]]]]],["div",{"class":"row"},[["label",{},[["textNode",{"text":"New password:"}]]],["div",{"class":"mc-common-input email"},[["input",{"class":"text-color-2","type":"password","name":"password","placeholder":""}],["div",{"class":"border"}]]],["div",{"class":"err-msg"}]]],["div",{"class":"row"},[["label",{},[["textNode",{"text":"Confirm password:"}]]],["div",{"class":"mc-common-input email"},[["input",{"class":"text-color-2","type":"password","name":"confirm","placeholder":""}],["div",{"class":"border"}]]],["div",{"class":"err-msg"}]]],["div",{"class":"row btns clearfix"},[["button",{"class":"common-btn login text-color-1 border-color-3 bg-color-2 loader","id":"submit-btn"},[["span",{"class":"small-loader type-1 trans-anim-all-3s"}],["textNode",{"text":" submit "}]]]]]]],["else",{},[["p",{},[["textNode",{"text":"The password reset request has expired, please click "}],["a",{"href":"/login"},[["textNode",{"text":"here"}]]],["textNode",{"text":" to make another request."}]]]]]],[["isError","empty",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_personal_data", [["div",{"class":"user-notitfications border-color-3-trans-20"},[["div",{"class":"global-title"},[["textNode",{"text":"Personal Data Processing"}]]],["div",{},[["import",{"name":"user_personal_data_rows"}],["div",{"class":"user-communication"},[["div",{"class":"global-title"},[["textNode",{"text":"Communication"}]]],["import",{"name":"user_communications_rows"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_profile", [["div",{"class":"user-notitfications border-color-3-trans-20"},[["div",{"class":"global-title"},[["textNode",{"text":"Member profile"}]]],["div",{"class":"user-profile-table"},[["table",{},[["tr",{},[["td",{},[["strong",{},[["textNode",{"text":"Username"}]]]]],["td",{},[["span",{},[],[["login","__text",true]]]]]]],["tr",{},[["td",{},[["strong",{},[["textNode",{"text":"Email"}]]]]],["td",{},[["span",{},[],[["email","__text",true]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_videos", [["div",{"class":"content-block pad-lr pad-tb","id":"last_added_videos"}],["div",{"class":"clear"}],["div",{"id":"newsletter-container"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("item_scene", [["div",{"class":"bg-color-3 text-color-1 item scene","itemscope":"","itemtype":"http://schema.org/VideoObject"},[["meta",{"itemprop":"description","content":""},[],[["title","content",true]]],["meta",{"itemprop":"uploadDate","content":""},[],[["sites.publishDate","content",true]]],["a",{"href":"","class":"img"},[["span",{"class":"play bg-color bg-color-2-trans-70"},[["i",{"class":"icon-au_play text-color-1"}]]],["meta",{"itemprop":"thumbnailURL","content":""},[],[["_resources.primary.url","content",true]]],["img",{"itemprop":"image","data-src":"","alt":"","class":"lazyload"},[],[["_resources.primary.url","data-src",true],["_resources.primary.altTag","alt",true]]],["if",{"notempty":""},[["span",{"class":"vr-label bg-color-2 text-color-1"},[["i",{"class":"icon-au_vr-video_15"}]]]],[["type","notempty",true,[{"name":"eq","params":["4"]}]]]],["if",{"notempty":""},[["video",{"class":"hov-video","playsinline":"","autoplay":"autoplay","loop":"loop","data-src":""},[],[["_resources.hoverPreview","data-src",true]]],["else",{},[["div",{"class":"baseline"},[["foreach",{"from":"","item":"thumb"},[["img",{"class":"loadImg _hidden","data-img":""},[],[["thumb.url","data-img",true]]]],[["_resources.base","from",true]]]]]]]],[["_resources.hoverPreview","notempty",true]]]],[["generatedContentLink","href",true]]],["div",{"class":"over-timeline"},[["div",{"class":"progressbar"},[["div",{"class":"filling"}]]]]],["div",{"class":"info"},[["a",{"href":"","class":"title text-color-1","itemprop":"name"},[["span",{},[],[["title","__text",true]]]],[["generatedContentLink","href",true]]],["div",{"class":"data"},[["div",{"class":"total"},[["if",{"notempty":""},[["span",{"class":"length","itemprop":"duration","content":""},[["textNode",{"text":"Length: "}],["span",{},[],[["length","__text",true,[{"name":"timeLength","params":["h m s"]}]]]],["textNode",{"text":" sec"}]],[["length","content",true,[{"name":"timeLength","params":["h m s"]}]]]],["else",{},[["span",{"class":"length","itemprop":"duration","content":""},[["textNode",{"text":"Length: "}],["span",{},[],[["length","__text",true]]],["textNode",{"text":" sec"}]],[["length","content",true]]]]]],[["length","notempty",true,[{"name":"gt","params":["60"]}]]]]]],["div",{"class":"added","itemprop":"datePublished","content":""},[["span",{},[],[["sites.publishDate","__text",true,[{"name":"dateAgo","params":[]}]]]]],[["sites.publishDate","content",true]]],["div",{"class":"socials"},[["span",{"class":"likes"},[["span",{},[],[["_socialParams.likes","__text",true]]],["i",{"class":"ico icon-au_like"}]]],["textNode",{"text":" "}],["span",{"class":"sep bg-color-1-trans-30"}],["textNode",{"text":" "}],["span",{"class":"comments"},[["span",{},[],[["_socialParams.totalComments","__text",true]]],["i",{"class":"ico icon-au_comments"}]]]]]]]]],["span",{"itemprop":"author","style":"display:none","itemscope":"","itemtype":"http://schema.org/Person"},[["meta",{"itemprop":"name","content":""},[],[["screenName","content",true,[],"env"]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("social_comments_addform", [["if",{"notempty":""},[["form",{"class":"add-review border-color-3-trans-20","action":"#","method":"post"},[["div",{"class":"write-comment"},[["div",{"class":"common-input txtarea"},[["textarea",{"name":"comment","placeholder":"Write a comment ..."}],["div",{"class":"border"}]]],["input",{"id":"addpost-button","class":"common-btn text-color-1 border-color-3 bg-color-2 post-comment","type":"submit","name":"submit","value":"Post"}]]]]]],[["id","notempty",true,[],"member"]]]]);
fox.registerTemplate("social_comment", [["li",{"class":"item item-comment"},[["div",{"class":"onepost"},[["if",{"notempty":""},[["div",{},[["span",{},[],[["comment","__text",true,[{"name":"truncate","params":["320","..."]}]]]],["textNode",{"text":" "}],["a",{"class":"toggle-comment pointer"},[["textNode",{"text":"more"}]]]]],["div",{"style":"display: none;"},[["span",{},[],[["comment","__text",true]]],["textNode",{"text":" "}],["a",{"class":"toggle-comment pointer"},[["textNode",{"text":"less"}]]]]],["else",{},[["span",{},[["span",{},[],[["comment","__text",true]]]]]]]],[["comment","notempty",true,[{"name":"count","params":[]},{"name":"gt","params":["320"]}]]]],["div",{"class":"post-info"},[["span",{"class":"post-user border-color-3-trans-20"},[["span",{},[],[["name","__text",true]]]]],["textNode",{"text":" "}],["span",{"class":"post-date border-color-3-trans-20"},[["span",{},[],[["date","__text",true,[{"name":"dateFormat","params":["%d %b %Y at %I"]}]]]],["textNode",{"text":":"}],["span",{},[],[["date","__text",true,[{"name":"dateFormat","params":["%M %P"]}]]]]]]]]]]]],["if",{"notempty":""},[["li",{"class":"reply-wrapper"},[["foreach",{"from":"","item":"child"},[["if",{"notempty":""},[["li",{"class":"item item-comment border-color-7"},[["div",{"class":"dotted"}],["div",{"class":"onepost"},[["if",{"notempty":""},[["div",{},[["span",{},[],[["child.comment","__text",true,[{"name":"truncate","params":["320","..."]}]]]],["textNode",{"text":" "}],["a",{"class":"toggle-comment pointer text-color-4"},[["textNode",{"text":"more"}]]]]],["div",{"style":"display: none;"},[["span",{},[],[["child.comment","__text",true]]],["textNode",{"text":" "}],["a",{"class":"toggle-comment pointer text-color-4"},[["textNode",{"text":"less"}]]]]],["else",{},[["span",{},[["span",{},[],[["child.comment","__text",true]]]]]]]],[["child.comment","notempty",true,[{"name":"count","params":[]},{"name":"gt","params":["320"]}]]]],["div",{"class":"post-info text-color-7"},[["span",{"class":"post-user border-color-3-trans-20"},[["span",{},[],[["child.name","__text",true]]]]],["textNode",{"text":" "}],["span",{"class":"post-date"},[["span",{},[],[["child.date","__text",true,[{"name":"dateFormat","params":["%d %b %Y at %I"]}]]]],["textNode",{"text":":"}],["span",{},[],[["date","__text",true,[{"name":"dateFormat","params":["%M %P"]}]]]]]]]]]]]]],[["child.deleted","notempty",true,[{"name":"eq","params":["0"]}]]]]],[["children","from",true]]]]]],[["children","notempty",true,[{"name":"notEmpty","params":[]}]]]]]);
fox.registerTemplate("social_comments_grid", [["ul",{"class":"reviews-list"}],["div",{"id":"comments-pager"}]]);
fox.registerTemplate("social_comments_block", [["a",{"class":"title-block clearfix reviews-actions"},[["h2",{"class":"left global-title toggleForm text-color-2","data-target-id":""},[["if",{"notempty":""},[["textNode",{"text":" Add a comment "}],["else",{},[["textNode",{"text":"Comments "}],["span",{"class":"count"},[["span",{},[],[["total","__text",true]]]]]]]],[["total","notempty",true,[{"name":"eq","params":["0"]}]]]]],[["targetId","data-target-id",true]]],["if",{"empty":"","addattr":"href:&&1&&"},[],[["id","empty",true,[],"member"],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]]]],["div",{"class":"reviews-actions-block"},[["if",{"notempty":"","addclass":"show-reviews"},[],[["show","notempty",true]]],["div",{"class":"_reviews"}],["div",{"class":"addreview-container","data-target-id":""},[],[["targetId","data-target-id",true]]]]]]);
fox.registerTemplate("social_comments_block_111", [["div",{"class":"reviews-actions"},[["a",{"class":"link toggleForm","data-target-id":""},[["if",{"notempty":""},[["textNode",{"text":" Add a comment "}],["else",{},[["textNode",{"text":"Comments "}],["span",{},[],[["total","__text",true]]],["textNode",{"text":" "}],["span",{"class":"count"},[["span",{},[],[["total","__text",true]]]]]]]],[["total","notempty",true,[{"name":"eq","params":["0"]}]]]],["if",{"empty":"","addattr":"href:&&1&&"},[],[["id","empty",true,[],"member"],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]]],[["targetId","data-target-id",true]]]]],["div",{"class":"reviews-actions-block"},[["if",{"notempty":"","addclass":"show-reviews"},[],[["show","notempty",true]]],["div",{"class":"_reviews"}],["div",{"class":"addreview-container","data-target-id":""},[],[["targetId","data-target-id",true]]]]]]);
fox.registerTemplate("social_comment_scene", [["div",{"class":"reviews-actions-block reviews-actions","data-target-id":""},[["h2",{"class":"left global-title text-color-2"},[["if",{"notempty":""},[["textNode",{"text":" Add a comment "}],["else",{},[["textNode",{"text":"Comments"}],["span",{"class":"count"},[["span",{},[],[["total","__text",true]]]]]]]],[["total","notempty",true,[{"name":"eq","params":["0"]}]]]]]],["div",{"class":"_reviews"}],["div",{"class":"addreview-container","data-target-id":""},[],[["targetId","data-target-id",true]]]],[["targetId","data-target-id",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_gallery_addto_favorite", [["a",{"class":"fav-link bookmark pointer","data-target-id":""},[["if",{"notempty":"","addclass":"active"},[],[["isFavorite","notempty",true]]],["if",{"empty":"","addattr":"href:&&1&&"},[],[["id","empty",true,[],"member"],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["i",{"class":"icon-au_favorites"}],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"ADD TO FAVORITES"}]]]],[["targetId","data-target-id",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("social_rating_blog", [["span",{},[["a",{"title":"I like this post!","class":"rate","data-value":"5"},[["if",{"notempty":"","addattr":"href:&&1&&"},[["else",{"addattr":"data-target-id:&&0&&"},[],[["targetId","__internal"]]]],[["member","notempty",true,[{"name":"hasAccess","params":["guest"]}]],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["i",{"class":"icon-like"}]]],["textNode",{"text":" "}],["span",{},[["span",{},[],[["total","__text",true]]]]],["textNode",{"text":" "}],["a",{"title":"Dislike this post!","class":"rate","data-value":"0"},[["if",{"notempty":"","addattr":"href:&&1&&"},[["else",{"addattr":"data-target-id:&&0&&"},[],[["targetId","__internal"]]]],[["member","notempty",true,[{"name":"hasAccess","params":["guest"]}]],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["i",{"class":"icon-dislike"}]]]]],["textNode",{"text":"&nbsp; "}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("twitter_grid", [["div",{"class":"twit-wrapper pad-lr pad-b"},[["div",{"class":"global-title text-color-2"},[["textNode",{"text":"My Twitter"}]]],["ul",{"id":"twits","class":"twits-list"}],["div",{"class":"view"}],["div",{"class":"clear"}]]]]);
fox.registerTemplate("twitter_list", [["li",{},[["span",{"class":"name"},[["a",{"href":"","target":"_blank","rel":"nofollow"},[["span",{},[],[["authorName","__text",true]]]],[["connectId.pageUrl","href",true]]],["textNode",{"text":": "}]]],["textNode",{"text":" "}],["span",{},[["span",{},[],[["postText","__text",true,[{"name":"html","params":[]},{"name":"nofollow","params":[]}]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./layout/join.js": 1252,
	"./member.js": 1253,
	"./model/browser.js": 1254,
	"./site/menu.js": 1255,
	"./sitepage/2257.js": 1256,
	"./sitepage/404.js": 1257,
	"./sitepage/about.js": 1258,
	"./sitepage/account.js": 1259,
	"./sitepage/favorites.js": 1260,
	"./sitepage/gallery.js": 1261,
	"./sitepage/liveshow.js": 1262,
	"./sitepage/login.js": 1263,
	"./sitepage/photosets.js": 1264,
	"./sitepage/privacy.js": 1265,
	"./sitepage/scene.js": 1266,
	"./sitepage/settings.js": 1267,
	"./sitepage/terms.js": 1268,
	"./sitepage/videos.js": 1269,
	"./user/favoriteamc.js": 1270,
	"./user/forgotpassword.js": 1271
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1251;

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Home */

(function(fox) {
	'use strict';
	fox.registerWidget('Layout_Join', {
	
	}, 'Site_Layout');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** member Widget */

/** Layout Member */

(function(fox) {

	fox.registerWidget('Member', {

		//Widget config
		configure: function(options) {
			this.callParent('configure', arguments);
		},

		rendering: function() {
			if (fox.isEmpty(fox.site.member)) {
				return this.createFragment();
			}
			return this.callParent('rendering', arguments);
		}
	});

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	
	fox.registerWidget('Model_Browser', {

		configure: function(options) {
			options.dataLayer || (options.dataLayer = {});
			options.dlClass = 'Model';
			this.callParent('configure', arguments);
		},

		init: function() {
			this.callParent('init', arguments);
			return this;
		}
	}, 'Grid');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Menu Node Widget */

(function(fox) {

	var _options = {
			alias: {
				mandatory: true
			},
			tpl: [{
				row: {
					'default': 'p{$[title]}'
				}
			}]
		};

	fox.registerWidget('Site_Menu', {

		//Widget config
		configure: function(options) {
			this.prepareOptions(options, _options);
			options.dataLayer || (options.dataLayer = this.initDl(options.alias));
			this.callParent('configure', arguments);
		},

		// initDl: function(alias) {
		// 	var dl = fox.createDataLayer().setClass('Site_Menu').setFields(['id', 'title', 'alias', 'link']);
		// 	if (!fox.isEmpty(fox.site.member)) {
		// 		return dl.addFilter(['treeId.alias'], [alias]).addFilter(['access'], [[1,3]]).addSorting('position');
		// 	} else {
		// 		return dl.addFilter(['treeId.alias'], [alias]).addFilter(['access'], [[2,3]]).addSorting('position');
		// 	}

		// },

		// running: function() {
		// 	this.dl.load();
		// },

		render: function() {
			return;
		}

	}, 'Grid_List');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_2257', {

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) {
	fox.registerWidget('SitePage_404', {

		// running: function() {
		// 	// this.handleEvent(, 'addedToDom', fox.bind(function() {
		// 		$('p.p3').text('The requested URL ' + location.hash + ' was not found on this server.');	
		// 	// }, this));
		// }
	
	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) { fox.registerWidget('SitePage_About', {}, 'Site_Page'); })(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_Account', {
		configure: function(options) {
			this.prepareOptions(options, {
				
			});
			this.callParent('configure', arguments);
		},
	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Favorities */

(function(fox) {
	
	fox.registerWidget('SitePage_Favorites', {

		//init: function() {
			// this.currentId = fox.Navigator.get(1);
			// this.userId = fox.site.member.getObjectValue('id');
			
			// this.favoriteDl = fox.createDataLayer()
			// 	.setClass('Content_Favorite')
			// 	.addFields(['id', 'contentId'])
			// 	.addFilter(['userId'], [this.userId])
			// 	.addMetaField('resources', {primary: 'primary..w282i', photoSet: 'primary..w135i',  photoSetCount: 'sources..w140i'})
			// 	.addMetaField('contents')
			// 	.setLimit(25);

			// this.embedWidget('favorites', 'Grid', {
			// 	container: '#favorites', 
			// 	dataLayer: this.favoriteDl,
			// 	preset: 'favorites',
			// 	autoRender: true,
			// 	externalLoad: true,
			// 	list: {
			// 		tpl: {
			// 			row: fox.getTemplate('sitepage_favorites_row'),
			// 		},
			// 		handlers: {
			// 			showCross: {
			// 				target: '.favitem',
			// 				event: 'mouseover',
			// 				callback: fox.bind(this.showCross, this)
			// 			},
			// 			hideCross: {
			// 				target: '.favitem',
			// 				event: 'mouseout',
			// 				callback: fox.bind(this.hideCross, this)
			// 			},
			// 			remove:{
			// 				target: '.remove',
			// 				event: 'click',
			// 				callback: fox.bind(this.remove, this)
			// 			}

			// 		},
			// 		hooks: {
			// 			onAddedToDom: fox.bind(function(obj) {
			// 				this.imageLoaded();
			// 			}, this),
			// 		}
			// 	},
				/*pager: {
					container: '#join_continue',
					zenTemplate: '',
					tpl: {
						container: fox.getTemplate('pagerLogged')
					},
					currentPageClass: 'cp',
					page: '',
					pagesCount: 3,
					handlers: {
						setPage: {
							target: '.pager-click'
						}
					},
					navigatorPrefix: 'fovorite_page'
				}*/
			// });
			
		// 	return this.callParent('init', arguments);
		// },

		// running: function() {
		// 	this.handleEvent(fox.Navigator, 'modified_0', fox.bind(this.runFavorites, this), true);
		// },
		
		// runFavorites: function() {
		// 	this.favoriteDl.load();
		// },

		// imageLoaded: function() {
		// 	var self = this;
		// 	var favicons = fox.dom.select('.favitem', this.element);
			
		// 	$(favicons).each(function(i, el) {
		// 		var elt = $(el).find('img')[0];
		// 		elt.onload = function(){
		// 			self.initFavorites();
		// 		}
		// 	});
		// },

		// initFavorites: function(elt) {
		// 	setTimeout(function() { 
		// 		$('#favorites').masonry({
		// 			// options
		// 			itemSelector : '.favitem',
		// 			columnWidth: function( containerWidth ) {
		// 				return containerWidth / 6;
		// 			},
		// 			isAnimated: true,
		// 			animationOptions: {
		// 				duration: 750,
		// 				easing: 'linear',
		// 				queue: false
		// 			}
		// 		});
		// 	}, 200)
		// },

		// showCross: function(elt){
		//  	$(elt).find('.remove').show();
		// },

		// hideCross: function(elt){
		//  	$(elt).find('.remove').hide();
		// },

		// remove: function(elt){
		// 	this.favoriteElt = $(elt).parent();
		// 	if (elt.id) {
		// 		var data = {
		// 			'contentId': elt.id
		// 		};

		// 		var api = new fox.Api(null, this._wom).method('favorite.toggle');
		// 		this.handleEvent(api, ['success'], fox.bind(this.response, this));
		// 		api.send(data);
		// 	}
		// },

		// response: function(data) {
		// 	if (data.answer.response.success) {
		// 		var response = data.answer.response.success;
		// 		if (!response.is) {
		// 			this.favoriteElt.remove();
		// 			$('#favorites').masonry('reload')
		// 		}	
		// 	}	
		// }
		// activate: function() {
		// 	this.callParent('activate', arguments);
		// 	this.requireEmbeddedWidget('favorites').dl.load()
		// }
	}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Gallery */

(function(fox) { fox.registerWidget('SitePage_Gallery', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('SitePage_Liveshow', {}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) { fox.registerWidget('SitePage_Login', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page photosets */

(function(fox) {

	fox.registerWidget('SitePage_Photosets', {}, 'Site_Page');
	
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_Privacy', {

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/**SitePage Scene */

(function(fox) { fox.registerWidget('SitePage_Scene', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('SitePage_Settings', {}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_Terms', {

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) { fox.registerWidget('SitePage_Videos', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	
	fox.registerWidget('User_FavoriteAmc', {
		redrawFavorites: function(data)
		{
			this.isFavorite = data.response.success.isFavorite;

			if (this.isFavorite == 1) {
				fox.dom.selectFirst(this.options.showTarget, this.element).classList.add(this.options.showActive);
			} else {
				fox.dom.selectFirst(this.options.showTarget, this.element).classList.remove(this.options.showActive);
			}
		}
		
	}, 'User_Favorite');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	
	fox.registerWidget('User_ForgotPassword', {

		configure: function(options) {
			options.formElement = '#forgot_form';
			options.dataLayer || (options.dataLayer = {});
			options.dlClass = 'User_ForgotPassword';
			this.callParent('configure', arguments);
		},

		rendering: function() {
			this.addHandler('formSubmit', this.options.formElement, 'submit', fox.bind(this.submit, this));
		},

		submit: function(){
			
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports = function (getSchemeUrl) {
	'use strict';

	function createLink (url) {
		var link = document.createElement('link');
		link.rel = 'stylesheet';
		link.type = 'text/css';
		link.href = url;
		link.setAttribute('colorscheme', 'colorscheme');

		return link;
	}

	return function (colorscheme) {
		var head = document.getElementsByTagName('head')[0];
		var currentColorscheme = head.querySelector('[colorscheme]');
		var colorschemeUrl = getSchemeUrl(colorscheme);

		if (currentColorscheme) {
			if (currentColorscheme.href === colorschemeUrl) return false;
			
			if (currentColorscheme.nextSibling) {
				currentColorscheme.parentNode.insertBefore(createLink(colorschemeUrl), currentColorscheme.nextSibling);
				
				setTimeout(function () {
					currentColorscheme.parentNode.removeChild(currentColorscheme);
				}, 10);
			} else {
				currentColorscheme.parentNode.replaceChild(createLink(colorschemeUrl), currentColorscheme);
			}
		} else {
			head.appendChild(createLink(colorschemeUrl));
		}
	}
};

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./_black_green.styl": 1274,
	"./_black_grey.styl": 1275,
	"./_black_red.styl": 1276,
	"./_blue.styl": 1277,
	"./_default.styl": 1278,
	"./_grey_light.styl": 1279,
	"./_light_black.styl": 1280,
	"./_pink_light.styl": 1281,
	"./_purple_dark.styl": 1282
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1273;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/colorscheme/_black_green.1dChW4F.css";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/colorscheme/_black_grey.25p51lf.css";

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/colorscheme/_black_red.3M-CQL_.css";

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/colorscheme/_blue.1UJRs6I.css";

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/colorscheme/_default.2uP0Qfz.css";

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/colorscheme/_grey_light.3PMG1YI.css";

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/colorscheme/_light_black.2488z9E.css";

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/colorscheme/_pink_light.2A42BJC.css";

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/colorscheme/_purple_dark.3Chx0zf.css";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// pk.0.js